/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "2b37b4ce7557b845e34d"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/ 	
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/ 	
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	module.exports = global["Player"] = __webpack_require__(2);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _componentsApp = __webpack_require__(188);
	
	var _componentsApp2 = _interopRequireDefault(_componentsApp);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _componentsBrand_play = __webpack_require__(189);
	
	var _componentsBrand_play2 = _interopRequireDefault(_componentsBrand_play);
	
	__webpack_require__(299);
	__webpack_require__(316);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	
	var body = document.querySelector('body');
	
	if ((0, _utilsUtil.isMobile)() || (0, _utilsUtil.isIpad)()) {
	  body.classList.add('is-mobile');
	} else {
	  body.classList.add('is-desktop');
	}
	var cpData = JSON.parse(document.querySelector('[data-cp]').getAttribute('data-cp'));
	var lastScn = undefined;
	
	$.ajax({
	  type: "GET",
	  contentType: "application/jsonp",
	  url: '//api' + (0, _utilsUtil.envCheck)() + '.medscape.com/cp/ipplastvisit/user/' + Number(window.s_registered_user_id) / 27.0 + '/activities/' + cpData.activityId,
	  dataType: "jsonp",
	  timeout: 1000,
	  success: function success(data) {
	    if (typeof data.activities[0].scene != 'undefined') {
	      lastScn = Number(data.activities[0].scene.name.split('scn')[1]);
	    }
	    if (bpInstance.rememberMe && cpData && !bpInstance.tacticIndex) {
	      if (typeof (0, _utilsUtil.getParams)().startVideo == 'undefined' && lastScn > 0) {
	        if (lastScn < bpInstance.videos.length) {
	          window.bpInstance.initialIndex = lastScn;
	        }
	      }
	    }
	  },
	  error: function error(err) {
	    console.log(err);
	  },
	  complete: function complete() {
	    (0, _reactDom.render)(_react2['default'].createElement(_componentsBrand_play2['default'], { descriptorJSON: window.bpInstance }), document.getElementById('jsx_video_player'));
	    $(window).trigger('video_player:rendered');
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, $, module, jQuery) {(function(e,t){function H(e){var t=e.length,n=w.type(e);if(w.isWindow(e)){return false}if(e.nodeType===1&&t){return true}return n==="array"||n!=="function"&&(t===0||typeof t==="number"&&t>0&&t-1 in e)}function j(e){var t=B[e]={};w.each(e.match(S)||[],function(e,n){t[n]=true});return t}function q(e,n,r,i){if(!w.acceptData(e)){return}var s,o,u=w.expando,a=e.nodeType,f=a?w.cache:e,l=a?e[u]:e[u]&&u;if((!l||!f[l]||!i&&!f[l].data)&&r===t&&typeof n==="string"){return}if(!l){if(a){l=e[u]=c.pop()||w.guid++}else{l=u}}if(!f[l]){f[l]=a?{}:{toJSON:w.noop}}if(typeof n==="object"||typeof n==="function"){if(i){f[l]=w.extend(f[l],n)}else{f[l].data=w.extend(f[l].data,n)}}o=f[l];if(!i){if(!o.data){o.data={}}o=o.data}if(r!==t){o[w.camelCase(n)]=r}if(typeof n==="string"){s=o[n];if(s==null){s=o[w.camelCase(n)]}}else{s=o}return s}function R(e,t,n){if(!w.acceptData(e)){return}var r,i,s=e.nodeType,o=s?w.cache:e,u=s?e[w.expando]:w.expando;if(!o[u]){return}if(t){r=n?o[u]:o[u].data;if(r){if(!w.isArray(t)){if(t in r){t=[t]}else{t=w.camelCase(t);if(t in r){t=[t]}else{t=t.split(" ")}}}else{t=t.concat(w.map(t,w.camelCase))}i=t.length;while(i--){delete r[t[i]]}if(n?!z(r):!w.isEmptyObject(r)){return}}}if(!n){delete o[u].data;if(!z(o[u])){return}}if(s){w.cleanData([e],true)}else if(w.support.deleteExpando||o!=o.window){delete o[u]}else{o[u]=null}}function U(e,n,r){if(r===t&&e.nodeType===1){var i="data-"+n.replace(I,"-$1").toLowerCase();r=e.getAttribute(i);if(typeof r==="string"){try{r=r==="true"?true:r==="false"?false:r==="null"?null:+r+""===r?+r:F.test(r)?w.parseJSON(r):r}catch(s){}w.data(e,n,r)}else{r=t}}return r}function z(e){var t;for(t in e){if(t==="data"&&w.isEmptyObject(e[t])){continue}if(t!=="toJSON"){return false}}return true}function it(){return true}function st(){return false}function ot(){try{return o.activeElement}catch(e){}}function ct(e,t){do{e=e[t]}while(e&&e.nodeType!==1);return e}function ht(e,t,n){if(w.isFunction(t)){return w.grep(e,function(e,r){return!!t.call(e,r,e)!==n})}if(t.nodeType){return w.grep(e,function(e){return e===t!==n})}if(typeof t==="string"){if(ut.test(t)){return w.filter(t,e,n)}t=w.filter(t,e)}return w.grep(e,function(e){return w.inArray(e,t)>=0!==n})}function pt(e){var t=dt.split("|"),n=e.createDocumentFragment();if(n.createElement){while(t.length){n.createElement(t.pop())}}return n}function Mt(e,t){return w.nodeName(e,"table")&&w.nodeName(t.nodeType===1?t:t.firstChild,"tr")?e.getElementsByTagName("tbody")[0]||e.appendChild(e.ownerDocument.createElement("tbody")):e}function _t(e){e.type=(w.find.attr(e,"type")!==null)+"/"+e.type;return e}function Dt(e){var t=Ct.exec(e.type);if(t){e.type=t[1]}else{e.removeAttribute("type")}return e}function Pt(e,t){var n,r=0;for(;(n=e[r])!=null;r++){w._data(n,"globalEval",!t||w._data(t[r],"globalEval"))}}function Ht(e,t){if(t.nodeType!==1||!w.hasData(e)){return}var n,r,i,s=w._data(e),o=w._data(t,s),u=s.events;if(u){delete o.handle;o.events={};for(n in u){for(r=0,i=u[n].length;r<i;r++){w.event.add(t,n,u[n][r])}}}if(o.data){o.data=w.extend({},o.data)}}function Bt(e,t){var n,r,i;if(t.nodeType!==1){return}n=t.nodeName.toLowerCase();if(!w.support.noCloneEvent&&t[w.expando]){i=w._data(t);for(r in i.events){w.removeEvent(t,r,i.handle)}t.removeAttribute(w.expando)}if(n==="script"&&t.text!==e.text){_t(t).text=e.text;Dt(t)}else if(n==="object"){if(t.parentNode){t.outerHTML=e.outerHTML}if(w.support.html5Clone&&e.innerHTML&&!w.trim(t.innerHTML)){t.innerHTML=e.innerHTML}}else if(n==="input"&&xt.test(e.type)){t.defaultChecked=t.checked=e.checked;if(t.value!==e.value){t.value=e.value}}else if(n==="option"){t.defaultSelected=t.selected=e.defaultSelected}else if(n==="input"||n==="textarea"){t.defaultValue=e.defaultValue}}function jt(e,n){var r,s,o=0,u=typeof e.getElementsByTagName!==i?e.getElementsByTagName(n||"*"):typeof e.querySelectorAll!==i?e.querySelectorAll(n||"*"):t;if(!u){for(u=[],r=e.childNodes||e;(s=r[o])!=null;o++){if(!n||w.nodeName(s,n)){u.push(s)}else{w.merge(u,jt(s,n))}}}return n===t||n&&w.nodeName(e,n)?w.merge([e],u):u}function Ft(e){if(xt.test(e.type)){e.defaultChecked=e.checked}}function tn(e,t){if(t in e){return t}var n=t.charAt(0).toUpperCase()+t.slice(1),r=t,i=en.length;while(i--){t=en[i]+n;if(t in e){return t}}return r}function nn(e,t){e=t||e;return w.css(e,"display")==="none"||!w.contains(e.ownerDocument,e)}function rn(e,t){var n,r,i,s=[],o=0,u=e.length;for(;o<u;o++){r=e[o];if(!r.style){continue}s[o]=w._data(r,"olddisplay");n=r.style.display;if(t){if(!s[o]&&n==="none"){r.style.display=""}if(r.style.display===""&&nn(r)){s[o]=w._data(r,"olddisplay",an(r.nodeName))}}else{if(!s[o]){i=nn(r);if(n&&n!=="none"||!i){w._data(r,"olddisplay",i?n:w.css(r,"display"))}}}}for(o=0;o<u;o++){r=e[o];if(!r.style){continue}if(!t||r.style.display==="none"||r.style.display===""){r.style.display=t?s[o]||"":"none"}}return e}function sn(e,t,n){var r=$t.exec(t);return r?Math.max(0,r[1]-(n||0))+(r[2]||"px"):t}function on(e,t,n,r,i){var s=n===(r?"border":"content")?4:t==="width"?1:0,o=0;for(;s<4;s+=2){if(n==="margin"){o+=w.css(e,n+Zt[s],true,i)}if(r){if(n==="content"){o-=w.css(e,"padding"+Zt[s],true,i)}if(n!=="margin"){o-=w.css(e,"border"+Zt[s]+"Width",true,i)}}else{o+=w.css(e,"padding"+Zt[s],true,i);if(n!=="padding"){o+=w.css(e,"border"+Zt[s]+"Width",true,i)}}}return o}function un(e,t,n){var r=true,i=t==="width"?e.offsetWidth:e.offsetHeight,s=qt(e),o=w.support.boxSizing&&w.css(e,"boxSizing",false,s)==="border-box";if(i<=0||i==null){i=Rt(e,t,s);if(i<0||i==null){i=e.style[t]}if(Jt.test(i)){return i}r=o&&(w.support.boxSizingReliable||i===e.style[t]);i=parseFloat(i)||0}return i+on(e,t,n||(o?"border":"content"),r,s)+"px"}function an(e){var t=o,n=Qt[e];if(!n){n=fn(e,t);if(n==="none"||!n){It=(It||w("<iframe frameborder='0' width='0' height='0'/>").css("cssText","display:block !important")).appendTo(t.documentElement);t=(It[0].contentWindow||It[0].contentDocument).document;t.write("<!doctype html><html><body>");t.close();n=fn(e,t);It.detach()}Qt[e]=n}return n}function fn(e,t){var n=w(t.createElement(e)).appendTo(t.body),r=w.css(n[0],"display");n.remove();return r}function vn(e,t,n,r){var i;if(w.isArray(t)){w.each(t,function(t,i){if(n||cn.test(e)){r(e,i)}else{vn(e+"["+(typeof i==="object"?t:"")+"]",i,n,r)}})}else if(!n&&w.type(t)==="object"){for(i in t){vn(e+"["+i+"]",t[i],n,r)}}else{r(e,t)}}function _n(e){return function(t,n){if(typeof t!=="string"){n=t;t="*"}var r,i=0,s=t.toLowerCase().match(S)||[];if(w.isFunction(n)){while(r=s[i++]){if(r[0]==="+"){r=r.slice(1)||"*";(e[r]=e[r]||[]).unshift(n)}else{(e[r]=e[r]||[]).push(n)}}}}}function Dn(e,t,n,r){function o(u){var a;i[u]=true;w.each(e[u]||[],function(e,u){var f=u(t,n,r);if(typeof f==="string"&&!s&&!i[f]){t.dataTypes.unshift(f);o(f);return false}else if(s){return!(a=f)}});return a}var i={},s=e===An;return o(t.dataTypes[0])||!i["*"]&&o("*")}function Pn(e,n){var r,i,s=w.ajaxSettings.flatOptions||{};for(i in n){if(n[i]!==t){(s[i]?e:r||(r={}))[i]=n[i]}}if(r){w.extend(true,e,r)}return e}function Hn(e,n,r){var i,s,o,u,a=e.contents,f=e.dataTypes;while(f[0]==="*"){f.shift();if(s===t){s=e.mimeType||n.getResponseHeader("Content-Type")}}if(s){for(u in a){if(a[u]&&a[u].test(s)){f.unshift(u);break}}}if(f[0]in r){o=f[0]}else{for(u in r){if(!f[0]||e.converters[u+" "+f[0]]){o=u;break}if(!i){i=u}}o=o||i}if(o){if(o!==f[0]){f.unshift(o)}return r[o]}}function Bn(e,t,n,r){var i,s,o,u,a,f={},l=e.dataTypes.slice();if(l[1]){for(o in e.converters){f[o.toLowerCase()]=e.converters[o]}}s=l.shift();while(s){if(e.responseFields[s]){n[e.responseFields[s]]=t}if(!a&&r&&e.dataFilter){t=e.dataFilter(t,e.dataType)}a=s;s=l.shift();if(s){if(s==="*"){s=a}else if(a!=="*"&&a!==s){o=f[a+" "+s]||f["* "+s];if(!o){for(i in f){u=i.split(" ");if(u[1]===s){o=f[a+" "+u[0]]||f["* "+u[0]];if(o){if(o===true){o=f[i]}else if(f[i]!==true){s=u[0];l.unshift(u[1])}break}}}}if(o!==true){if(o&&e["throws"]){t=o(t)}else{try{t=o(t)}catch(c){return{state:"parsererror",error:o?c:"No conversion from "+a+" to "+s}}}}}}}return{state:"success",data:t}}function zn(){try{return new e.XMLHttpRequest}catch(t){}}function Wn(){try{return new e.ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}function Yn(){setTimeout(function(){Xn=t});return Xn=w.now()}function Zn(e,t,n){var r,i=(Gn[t]||[]).concat(Gn["*"]),s=0,o=i.length;for(;s<o;s++){if(r=i[s].call(n,t,e)){return r}}}function er(e,t,n){var r,i,s=0,o=Qn.length,u=w.Deferred().always(function(){delete a.elem}),a=function(){if(i){return false}var t=Xn||Yn(),n=Math.max(0,f.startTime+f.duration-t),r=n/f.duration||0,s=1-r,o=0,a=f.tweens.length;for(;o<a;o++){f.tweens[o].run(s)}u.notifyWith(e,[f,s,n]);if(s<1&&a){return n}else{u.resolveWith(e,[f]);return false}},f=u.promise({elem:e,props:w.extend({},t),opts:w.extend(true,{specialEasing:{}},n),originalProperties:t,originalOptions:n,startTime:Xn||Yn(),duration:n.duration,tweens:[],createTween:function(t,n){var r=w.Tween(e,f.opts,t,n,f.opts.specialEasing[t]||f.opts.easing);f.tweens.push(r);return r},stop:function(t){var n=0,r=t?f.tweens.length:0;if(i){return this}i=true;for(;n<r;n++){f.tweens[n].run(1)}if(t){u.resolveWith(e,[f,t])}else{u.rejectWith(e,[f,t])}return this}}),l=f.props;tr(l,f.opts.specialEasing);for(;s<o;s++){r=Qn[s].call(f,e,l,f.opts);if(r){return r}}w.map(l,Zn,f);if(w.isFunction(f.opts.start)){f.opts.start.call(e,f)}w.fx.timer(w.extend(a,{elem:e,anim:f,queue:f.opts.queue}));return f.progress(f.opts.progress).done(f.opts.done,f.opts.complete).fail(f.opts.fail).always(f.opts.always)}function tr(e,t){var n,r,i,s,o;for(n in e){r=w.camelCase(n);i=t[r];s=e[n];if(w.isArray(s)){i=s[1];s=e[n]=s[0]}if(n!==r){e[r]=s;delete e[n]}o=w.cssHooks[r];if(o&&"expand"in o){s=o.expand(s);delete e[r];for(n in s){if(!(n in e)){e[n]=s[n];t[n]=i}}}else{t[r]=i}}}function nr(e,t,n){var r,i,s,o,u,a,f=this,l={},c=e.style,h=e.nodeType&&nn(e),p=w._data(e,"fxshow");if(!n.queue){u=w._queueHooks(e,"fx");if(u.unqueued==null){u.unqueued=0;a=u.empty.fire;u.empty.fire=function(){if(!u.unqueued){a()}}}u.unqueued++;f.always(function(){f.always(function(){u.unqueued--;if(!w.queue(e,"fx").length){u.empty.fire()}})})}if(e.nodeType===1&&("height"in t||"width"in t)){n.overflow=[c.overflow,c.overflowX,c.overflowY];if(w.css(e,"display")==="inline"&&w.css(e,"float")==="none"){if(!w.support.inlineBlockNeedsLayout||an(e.nodeName)==="inline"){c.display="inline-block"}else{c.zoom=1}}}if(n.overflow){c.overflow="hidden";if(!w.support.shrinkWrapBlocks){f.always(function(){c.overflow=n.overflow[0];c.overflowX=n.overflow[1];c.overflowY=n.overflow[2]})}}for(r in t){i=t[r];if($n.exec(i)){delete t[r];s=s||i==="toggle";if(i===(h?"hide":"show")){continue}l[r]=p&&p[r]||w.style(e,r)}}if(!w.isEmptyObject(l)){if(p){if("hidden"in p){h=p.hidden}}else{p=w._data(e,"fxshow",{})}if(s){p.hidden=!h}if(h){w(e).show()}else{f.done(function(){w(e).hide()})}f.done(function(){var t;w._removeData(e,"fxshow");for(t in l){w.style(e,t,l[t])}});for(r in l){o=Zn(h?p[r]:0,r,f);if(!(r in p)){p[r]=o.start;if(h){o.end=o.start;o.start=r==="width"||r==="height"?1:0}}}}}function rr(e,t,n,r,i){return new rr.prototype.init(e,t,n,r,i)}function ir(e,t){var n,r={height:e},i=0;t=t?1:0;for(;i<4;i+=2-t){n=Zt[i];r["margin"+n]=r["padding"+n]=e}if(t){r.opacity=r.width=e}return r}function sr(e){return w.isWindow(e)?e:e.nodeType===9?e.defaultView||e.parentWindow:false}var n,r,i=typeof t,s=e.location,o=e.document,u=o.documentElement,a=__webpack_provided_window_dot_jQuery,f=e.$,l={},c=[],h="1.10.2",p=c.concat,d=c.push,v=c.slice,m=c.indexOf,g=l.toString,y=l.hasOwnProperty,b=h.trim,w=function(e,t){return new w.fn.init(e,t,r)},E=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,S=/\S+/g,x=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,T=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,N=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,C=/^[\],:{}\s]*$/,k=/(?:^|:|,)(?:\s*\[)+/g,L=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,A=/"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,O=/^-ms-/,M=/-([\da-z])/gi,_=function(e,t){return t.toUpperCase()},D=function(e){if(o.addEventListener||e.type==="load"||o.readyState==="complete"){P();w.ready()}},P=function(){if(o.addEventListener){o.removeEventListener("DOMContentLoaded",D,false);e.removeEventListener("load",D,false)}else{o.detachEvent("onreadystatechange",D);e.detachEvent("onload",D)}};w.fn=w.prototype={jquery:h,constructor:w,init:function(e,n,r){var i,s;if(!e){return this}if(typeof e==="string"){if(e.charAt(0)==="<"&&e.charAt(e.length-1)===">"&&e.length>=3){i=[null,e,null]}else{i=T.exec(e)}if(i&&(i[1]||!n)){if(i[1]){n=n instanceof w?n[0]:n;w.merge(this,w.parseHTML(i[1],n&&n.nodeType?n.ownerDocument||n:o,true));if(N.test(i[1])&&w.isPlainObject(n)){for(i in n){if(w.isFunction(this[i])){this[i](n[i])}else{this.attr(i,n[i])}}}return this}else{s=o.getElementById(i[2]);if(s&&s.parentNode){if(s.id!==i[2]){return r.find(e)}this.length=1;this[0]=s}this.context=o;this.selector=e;return this}}else if(!n||n.jquery){return(n||r).find(e)}else{return this.constructor(n).find(e)}}else if(e.nodeType){this.context=this[0]=e;this.length=1;return this}else if(w.isFunction(e)){return r.ready(e)}if(e.selector!==t){this.selector=e.selector;this.context=e.context}return w.makeArray(e,this)},selector:"",length:0,toArray:function(){return v.call(this)},get:function(e){return e==null?this.toArray():e<0?this[this.length+e]:this[e]},pushStack:function(e){var t=w.merge(this.constructor(),e);t.prevObject=this;t.context=this.context;return t},each:function(e,t){return w.each(this,e,t)},ready:function(e){w.ready.promise().done(e);return this},slice:function(){return this.pushStack(v.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},map:function(e){return this.pushStack(w.map(this,function(t,n){return e.call(t,n,t)}))},end:function(){return this.prevObject||this.constructor(null)},push:d,sort:[].sort,splice:[].splice};w.fn.init.prototype=w.fn;w.extend=w.fn.extend=function(){var e,n,r,i,s,o,u=arguments[0]||{},a=1,f=arguments.length,l=false;if(typeof u==="boolean"){l=u;u=arguments[1]||{};a=2}if(typeof u!=="object"&&!w.isFunction(u)){u={}}if(f===a){u=this;--a}for(;a<f;a++){if((s=arguments[a])!=null){for(i in s){e=u[i];r=s[i];if(u===r){continue}if(l&&r&&(w.isPlainObject(r)||(n=w.isArray(r)))){if(n){n=false;o=e&&w.isArray(e)?e:[]}else{o=e&&w.isPlainObject(e)?e:{}}u[i]=w.extend(l,o,r)}else if(r!==t){u[i]=r}}}}return u};w.extend({expando:"jQuery"+(h+Math.random()).replace(/\D/g,""),noConflict:function(t){if(e.$===w){e.$=f}if(t&&__webpack_provided_window_dot_jQuery===w){__webpack_provided_window_dot_jQuery=a}return w},isReady:false,readyWait:1,holdReady:function(e){if(e){w.readyWait++}else{w.ready(true)}},ready:function(e){if(e===true?--w.readyWait:w.isReady){return}if(!o.body){return setTimeout(w.ready)}w.isReady=true;if(e!==true&&--w.readyWait>0){return}n.resolveWith(o,[w]);if(w.fn.trigger){w(o).trigger("ready").off("ready")}},isFunction:function(e){return w.type(e)==="function"},isArray:Array.isArray||function(e){return w.type(e)==="array"},isWindow:function(e){return e!=null&&e==e.window},isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},type:function(e){if(e==null){return String(e)}return typeof e==="object"||typeof e==="function"?l[g.call(e)]||"object":typeof e},isPlainObject:function(e){var n;if(!e||w.type(e)!=="object"||e.nodeType||w.isWindow(e)){return false}try{if(e.constructor&&!y.call(e,"constructor")&&!y.call(e.constructor.prototype,"isPrototypeOf")){return false}}catch(r){return false}if(w.support.ownLast){for(n in e){return y.call(e,n)}}for(n in e){}return n===t||y.call(e,n)},isEmptyObject:function(e){var t;for(t in e){return false}return true},error:function(e){throw new Error(e)},parseHTML:function(e,t,n){if(!e||typeof e!=="string"){return null}if(typeof t==="boolean"){n=t;t=false}t=t||o;var r=N.exec(e),i=!n&&[];if(r){return[t.createElement(r[1])]}r=w.buildFragment([e],t,i);if(i){w(i).remove()}return w.merge([],r.childNodes)},parseJSON:function(t){if(e.JSON&&e.JSON.parse){return e.JSON.parse(t)}if(t===null){return t}if(typeof t==="string"){t=w.trim(t);if(t){if(C.test(t.replace(L,"@").replace(A,"]").replace(k,""))){return(new Function("return "+t))()}}}w.error("Invalid JSON: "+t)},parseXML:function(n){var r,i;if(!n||typeof n!=="string"){return null}try{if(e.DOMParser){i=new DOMParser;r=i.parseFromString(n,"text/xml")}else{r=new ActiveXObject("Microsoft.XMLDOM");r.async="false";r.loadXML(n)}}catch(s){r=t}if(!r||!r.documentElement||r.getElementsByTagName("parsererror").length){w.error("Invalid XML: "+n)}return r},noop:function(){},globalEval:function(t){if(t&&w.trim(t)){(e.execScript||function(t){e["eval"].call(e,t)})(t)}},camelCase:function(e){return e.replace(O,"ms-").replace(M,_)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,t,n){var r,i=0,s=e.length,o=H(e);if(n){if(o){for(;i<s;i++){r=t.apply(e[i],n);if(r===false){break}}}else{for(i in e){r=t.apply(e[i],n);if(r===false){break}}}}else{if(o){for(;i<s;i++){r=t.call(e[i],i,e[i]);if(r===false){break}}}else{for(i in e){r=t.call(e[i],i,e[i]);if(r===false){break}}}}return e},trim:b&&!b.call("﻿ ")?function(e){return e==null?"":b.call(e)}:function(e){return e==null?"":(e+"").replace(x,"")},makeArray:function(e,t){var n=t||[];if(e!=null){if(H(Object(e))){w.merge(n,typeof e==="string"?[e]:e)}else{d.call(n,e)}}return n},inArray:function(e,t,n){var r;if(t){if(m){return m.call(t,e,n)}r=t.length;n=n?n<0?Math.max(0,r+n):n:0;for(;n<r;n++){if(n in t&&t[n]===e){return n}}}return-1},merge:function(e,n){var r=n.length,i=e.length,s=0;if(typeof r==="number"){for(;s<r;s++){e[i++]=n[s]}}else{while(n[s]!==t){e[i++]=n[s++]}}e.length=i;return e},grep:function(e,t,n){var r,i=[],s=0,o=e.length;n=!!n;for(;s<o;s++){r=!!t(e[s],s);if(n!==r){i.push(e[s])}}return i},map:function(e,t,n){var r,i=0,s=e.length,o=H(e),u=[];if(o){for(;i<s;i++){r=t(e[i],i,n);if(r!=null){u[u.length]=r}}}else{for(i in e){r=t(e[i],i,n);if(r!=null){u[u.length]=r}}}return p.apply([],u)},guid:1,proxy:function(e,n){var r,i,s;if(typeof n==="string"){s=e[n];n=e;e=s}if(!w.isFunction(e)){return t}r=v.call(arguments,2);i=function(){return e.apply(n||this,r.concat(v.call(arguments)))};i.guid=e.guid=e.guid||w.guid++;return i},access:function(e,n,r,i,s,o,u){var a=0,f=e.length,l=r==null;if(w.type(r)==="object"){s=true;for(a in r){w.access(e,n,a,r[a],true,o,u)}}else if(i!==t){s=true;if(!w.isFunction(i)){u=true}if(l){if(u){n.call(e,i);n=null}else{l=n;n=function(e,t,n){return l.call(w(e),n)}}}if(n){for(;a<f;a++){n(e[a],r,u?i:i.call(e[a],a,n(e[a],r)))}}}return s?e:l?n.call(e):f?n(e[0],r):o},now:function(){return(new Date).getTime()},swap:function(e,t,n,r){var i,s,o={};for(s in t){o[s]=e.style[s];e.style[s]=t[s]}i=n.apply(e,r||[]);for(s in t){e.style[s]=o[s]}return i}});w.ready.promise=function(t){if(!n){n=w.Deferred();if(o.readyState==="complete"){setTimeout(w.ready)}else if(o.addEventListener){o.addEventListener("DOMContentLoaded",D,false);e.addEventListener("load",D,false)}else{o.attachEvent("onreadystatechange",D);e.attachEvent("onload",D);var r=false;try{r=e.frameElement==null&&o.documentElement}catch(i){}if(r&&r.doScroll){(function s(){if(!w.isReady){try{r.doScroll("left")}catch(e){return setTimeout(s,50)}P();w.ready()}})()}}}return n.promise(t)};w.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(e,t){l["[object "+t+"]"]=t.toLowerCase()});r=w(o);(function(e,t){function ot(e,t,n,i){var s,o,u,a,f,l,p,m,g,w;if((t?t.ownerDocument||t:E)!==h){c(t)}t=t||h;n=n||[];if(!e||typeof e!=="string"){return n}if((a=t.nodeType)!==1&&a!==9){return[]}if(d&&!i){if(s=Z.exec(e)){if(u=s[1]){if(a===9){o=t.getElementById(u);if(o&&o.parentNode){if(o.id===u){n.push(o);return n}}else{return n}}else{if(t.ownerDocument&&(o=t.ownerDocument.getElementById(u))&&y(t,o)&&o.id===u){n.push(o);return n}}}else if(s[2]){H.apply(n,t.getElementsByTagName(e));return n}else if((u=s[3])&&r.getElementsByClassName&&t.getElementsByClassName){H.apply(n,t.getElementsByClassName(u));return n}}if(r.qsa&&(!v||!v.test(e))){m=p=b;g=t;w=a===9&&e;if(a===1&&t.nodeName.toLowerCase()!=="object"){l=mt(e);if(p=t.getAttribute("id")){m=p.replace(nt,"\\$&")}else{t.setAttribute("id",m)}m="[id='"+m+"'] ";f=l.length;while(f--){l[f]=m+gt(l[f])}g=$.test(e)&&t.parentNode||t;w=l.join(",")}if(w){try{H.apply(n,g.querySelectorAll(w));return n}catch(S){}finally{if(!p){t.removeAttribute("id")}}}}}return Nt(e.replace(W,"$1"),t,n,i)}function ut(){function t(n,r){if(e.push(n+=" ")>s.cacheLength){delete t[e.shift()]}return t[n]=r}var e=[];return t}function at(e){e[b]=true;return e}function ft(e){var t=h.createElement("div");try{return!!e(t)}catch(n){return false}finally{if(t.parentNode){t.parentNode.removeChild(t)}t=null}}function lt(e,t){var n=e.split("|"),r=e.length;while(r--){s.attrHandle[n[r]]=t}}function ct(e,t){var n=t&&e,r=n&&e.nodeType===1&&t.nodeType===1&&(~t.sourceIndex||O)-(~e.sourceIndex||O);if(r){return r}if(n){while(n=n.nextSibling){if(n===t){return-1}}}return e?1:-1}function ht(e){return function(t){var n=t.nodeName.toLowerCase();return n==="input"&&t.type===e}}function pt(e){return function(t){var n=t.nodeName.toLowerCase();return(n==="input"||n==="button")&&t.type===e}}function dt(e){return at(function(t){t=+t;return at(function(n,r){var i,s=e([],n.length,t),o=s.length;while(o--){if(n[i=s[o]]){n[i]=!(r[i]=n[i])}}})})}function vt(){}function mt(e,t){var n,r,i,o,u,a,f,l=N[e+" "];if(l){return t?0:l.slice(0)}u=e;a=[];f=s.preFilter;while(u){if(!n||(r=X.exec(u))){if(r){u=u.slice(r[0].length)||u}a.push(i=[])}n=false;if(r=V.exec(u)){n=r.shift();i.push({value:n,type:r[0].replace(W," ")});u=u.slice(n.length)}for(o in s.filter){if((r=G[o].exec(u))&&(!f[o]||(r=f[o](r)))){n=r.shift();i.push({value:n,type:o,matches:r});u=u.slice(n.length)}}if(!n){break}}return t?u.length:u?ot.error(e):N(e,a).slice(0)}function gt(e){var t=0,n=e.length,r="";for(;t<n;t++){r+=e[t].value}return r}function yt(e,t,n){var r=t.dir,s=n&&r==="parentNode",o=x++;return t.first?function(t,n,i){while(t=t[r]){if(t.nodeType===1||s){return e(t,n,i)}}}:function(t,n,u){var a,f,l,c=S+" "+o;if(u){while(t=t[r]){if(t.nodeType===1||s){if(e(t,n,u)){return true}}}}else{while(t=t[r]){if(t.nodeType===1||s){l=t[b]||(t[b]={});if((f=l[r])&&f[0]===c){if((a=f[1])===true||a===i){return a===true}}else{f=l[r]=[c];f[1]=e(t,n,u)||i;if(f[1]===true){return true}}}}}}}function bt(e){return e.length>1?function(t,n,r){var i=e.length;while(i--){if(!e[i](t,n,r)){return false}}return true}:e[0]}function wt(e,t,n,r,i){var s,o=[],u=0,a=e.length,f=t!=null;for(;u<a;u++){if(s=e[u]){if(!n||n(s,r,i)){o.push(s);if(f){t.push(u)}}}}return o}function Et(e,t,n,r,i,s){if(r&&!r[b]){r=Et(r)}if(i&&!i[b]){i=Et(i,s)}return at(function(s,o,u,a){var f,l,c,h=[],p=[],d=o.length,v=s||Tt(t||"*",u.nodeType?[u]:u,[]),m=e&&(s||!t)?wt(v,h,e,u,a):v,g=n?i||(s?e:d||r)?[]:o:m;if(n){n(m,g,u,a)}if(r){f=wt(g,p);r(f,[],u,a);l=f.length;while(l--){if(c=f[l]){g[p[l]]=!(m[p[l]]=c)}}}if(s){if(i||e){if(i){f=[];l=g.length;while(l--){if(c=g[l]){f.push(m[l]=c)}}i(null,g=[],f,a)}l=g.length;while(l--){if((c=g[l])&&(f=i?j.call(s,c):h[l])>-1){s[f]=!(o[f]=c)}}}}else{g=wt(g===o?g.splice(d,g.length):g);if(i){i(null,o,g,a)}else{H.apply(o,g)}}})}function St(e){var t,n,r,i=e.length,o=s.relative[e[0].type],u=o||s.relative[" "],a=o?1:0,l=yt(function(e){return e===t},u,true),c=yt(function(e){return j.call(t,e)>-1},u,true),h=[function(e,n,r){return!o&&(r||n!==f)||((t=n).nodeType?l(e,n,r):c(e,n,r))}];for(;a<i;a++){if(n=s.relative[e[a].type]){h=[yt(bt(h),n)]}else{n=s.filter[e[a].type].apply(null,e[a].matches);if(n[b]){r=++a;for(;r<i;r++){if(s.relative[e[r].type]){break}}return Et(a>1&&bt(h),a>1&&gt(e.slice(0,a-1).concat({value:e[a-2].type===" "?"*":""})).replace(W,"$1"),n,a<r&&St(e.slice(a,r)),r<i&&St(e=e.slice(r)),r<i&&gt(e))}h.push(n)}}return bt(h)}function xt(e,t){var n=0,r=t.length>0,o=e.length>0,u=function(u,a,l,c,p){var d,v,m,g=[],y=0,b="0",w=u&&[],E=p!=null,x=f,T=u||o&&s.find["TAG"]("*",p&&a.parentNode||a),N=S+=x==null?1:Math.random()||.1;if(E){f=a!==h&&a;i=n}for(;(d=T[b])!=null;b++){if(o&&d){v=0;while(m=e[v++]){if(m(d,a,l)){c.push(d);break}}if(E){S=N;i=++n}}if(r){if(d=!m&&d){y--}if(u){w.push(d)}}}y+=b;if(r&&b!==y){v=0;while(m=t[v++]){m(w,g,a,l)}if(u){if(y>0){while(b--){if(!(w[b]||g[b])){g[b]=D.call(c)}}}g=wt(g)}H.apply(c,g);if(E&&!u&&g.length>0&&y+t.length>1){ot.uniqueSort(c)}}if(E){S=N;f=x}return w};return r?at(u):u}function Tt(e,t,n){var r=0,i=t.length;for(;r<i;r++){ot(e,t[r],n)}return n}function Nt(e,t,n,i){var o,u,f,l,c,h=mt(e);if(!i){if(h.length===1){u=h[0]=h[0].slice(0);if(u.length>2&&(f=u[0]).type==="ID"&&r.getById&&t.nodeType===9&&d&&s.relative[u[1].type]){t=(s.find["ID"](f.matches[0].replace(rt,it),t)||[])[0];if(!t){return n}e=e.slice(u.shift().value.length)}o=G["needsContext"].test(e)?0:u.length;while(o--){f=u[o];if(s.relative[l=f.type]){break}if(c=s.find[l]){if(i=c(f.matches[0].replace(rt,it),$.test(u[0].type)&&t.parentNode||t)){u.splice(o,1);e=i.length&&gt(u);if(!e){H.apply(n,i);return n}break}}}}}a(e,h)(i,t,!d,n,$.test(e));return n}var n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b="sizzle"+ -(new Date),E=e.document,S=0,x=0,T=ut(),N=ut(),C=ut(),k=false,L=function(e,t){if(e===t){k=true;return 0}return 0},A=typeof t,O=1<<31,M={}.hasOwnProperty,_=[],D=_.pop,P=_.push,H=_.push,B=_.slice,j=_.indexOf||function(e){var t=0,n=this.length;for(;t<n;t++){if(this[t]===e){return t}}return-1},F="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",I="[\\x20\\t\\r\\n\\f]",q="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",R=q.replace("w","w#"),U="\\["+I+"*("+q+")"+I+"*(?:([*^$|!~]?=)"+I+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+R+")|)|)"+I+"*\\]",z=":("+q+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+U.replace(3,8)+")*)|.*)\\)|)",W=new RegExp("^"+I+"+|((?:^|[^\\\\])(?:\\\\.)*)"+I+"+$","g"),X=new RegExp("^"+I+"*,"+I+"*"),V=new RegExp("^"+I+"*([>+~]|"+I+")"+I+"*"),$=new RegExp(I+"*[+~]"),J=new RegExp("="+I+"*([^\\]'\"]*)"+I+"*\\]","g"),K=new RegExp(z),Q=new RegExp("^"+R+"$"),G={ID:new RegExp("^#("+q+")"),CLASS:new RegExp("^\\.("+q+")"),TAG:new RegExp("^("+q.replace("w","w*")+")"),ATTR:new RegExp("^"+U),PSEUDO:new RegExp("^"+z),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+I+"*(even|odd|(([+-]|)(\\d*)n|)"+I+"*(?:([+-]|)"+I+"*(\\d+)|))"+I+"*\\)|)","i"),bool:new RegExp("^(?:"+F+")$","i"),needsContext:new RegExp("^"+I+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+I+"*((?:-\\d)?\\d*)"+I+"*\\)|)(?=[^-]|$)","i")},Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,et=/^(?:input|select|textarea|button)$/i,tt=/^h\d$/i,nt=/'|\\/g,rt=new RegExp("\\\\([\\da-f]{1,6}"+I+"?|("+I+")|.)","ig"),it=function(e,t,n){var r="0x"+t-65536;return r!==r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,r&1023|56320)};try{H.apply(_=B.call(E.childNodes),E.childNodes);_[E.childNodes.length].nodeType}catch(st){H={apply:_.length?function(e,t){P.apply(e,B.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]){}e.length=n-1}}}u=ot.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return t?t.nodeName!=="HTML":false};r=ot.support={};c=ot.setDocument=function(e){var t=e?e.ownerDocument||e:E,n=t.defaultView;if(t===h||t.nodeType!==9||!t.documentElement){return h}h=t;p=t.documentElement;d=!u(t);if(n&&n.attachEvent&&n!==n.top){n.attachEvent("onbeforeunload",function(){c()})}r.attributes=ft(function(e){e.className="i";return!e.getAttribute("className")});r.getElementsByTagName=ft(function(e){e.appendChild(t.createComment(""));return!e.getElementsByTagName("*").length});r.getElementsByClassName=ft(function(e){e.innerHTML="<div class='a'></div><div class='a i'></div>";e.firstChild.className="i";return e.getElementsByClassName("i").length===2});r.getById=ft(function(e){p.appendChild(e).id=b;return!t.getElementsByName||!t.getElementsByName(b).length});if(r.getById){s.find["ID"]=function(e,t){if(typeof t.getElementById!==A&&d){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}};s.filter["ID"]=function(e){var t=e.replace(rt,it);return function(e){return e.getAttribute("id")===t}}}else{delete s.find["ID"];s.filter["ID"]=function(e){var t=e.replace(rt,it);return function(e){var n=typeof e.getAttributeNode!==A&&e.getAttributeNode("id");return n&&n.value===t}}}s.find["TAG"]=r.getElementsByTagName?function(e,t){if(typeof t.getElementsByTagName!==A){return t.getElementsByTagName(e)}}:function(e,t){var n,r=[],i=0,s=t.getElementsByTagName(e);if(e==="*"){while(n=s[i++]){if(n.nodeType===1){r.push(n)}}return r}return s};s.find["CLASS"]=r.getElementsByClassName&&function(e,t){if(typeof t.getElementsByClassName!==A&&d){return t.getElementsByClassName(e)}};m=[];v=[];if(r.qsa=Y.test(t.querySelectorAll)){ft(function(e){e.innerHTML="<select><option selected=''></option></select>";if(!e.querySelectorAll("[selected]").length){v.push("\\["+I+"*(?:value|"+F+")")}if(!e.querySelectorAll(":checked").length){v.push(":checked")}});ft(function(e){var n=t.createElement("input");n.setAttribute("type","hidden");e.appendChild(n).setAttribute("t","");if(e.querySelectorAll("[t^='']").length){v.push("[*^$]="+I+"*(?:''|\"\")")}if(!e.querySelectorAll(":enabled").length){v.push(":enabled",":disabled")}e.querySelectorAll("*,:x");v.push(",.*:")})}if(r.matchesSelector=Y.test(g=p.webkitMatchesSelector||p.mozMatchesSelector||p.oMatchesSelector||p.msMatchesSelector)){ft(function(e){r.disconnectedMatch=g.call(e,"div");g.call(e,"[s!='']:x");m.push("!=",z)})}v=v.length&&new RegExp(v.join("|"));m=m.length&&new RegExp(m.join("|"));y=Y.test(p.contains)||p.compareDocumentPosition?function(e,t){var n=e.nodeType===9?e.documentElement:e,r=t&&t.parentNode;return e===r||!!(r&&r.nodeType===1&&(n.contains?n.contains(r):e.compareDocumentPosition&&e.compareDocumentPosition(r)&16))}:function(e,t){if(t){while(t=t.parentNode){if(t===e){return true}}}return false};L=p.compareDocumentPosition?function(e,n){if(e===n){k=true;return 0}var i=n.compareDocumentPosition&&e.compareDocumentPosition&&e.compareDocumentPosition(n);if(i){if(i&1||!r.sortDetached&&n.compareDocumentPosition(e)===i){if(e===t||y(E,e)){return-1}if(n===t||y(E,n)){return 1}return l?j.call(l,e)-j.call(l,n):0}return i&4?-1:1}return e.compareDocumentPosition?-1:1}:function(e,n){var r,i=0,s=e.parentNode,o=n.parentNode,u=[e],a=[n];if(e===n){k=true;return 0}else if(!s||!o){return e===t?-1:n===t?1:s?-1:o?1:l?j.call(l,e)-j.call(l,n):0}else if(s===o){return ct(e,n)}r=e;while(r=r.parentNode){u.unshift(r)}r=n;while(r=r.parentNode){a.unshift(r)}while(u[i]===a[i]){i++}return i?ct(u[i],a[i]):u[i]===E?-1:a[i]===E?1:0};return t};ot.matches=function(e,t){return ot(e,null,null,t)};ot.matchesSelector=function(e,t){if((e.ownerDocument||e)!==h){c(e)}t=t.replace(J,"='$1']");if(r.matchesSelector&&d&&(!m||!m.test(t))&&(!v||!v.test(t))){try{var n=g.call(e,t);if(n||r.disconnectedMatch||e.document&&e.document.nodeType!==11){return n}}catch(i){}}return ot(t,h,null,[e]).length>0};ot.contains=function(e,t){if((e.ownerDocument||e)!==h){c(e)}return y(e,t)};ot.attr=function(e,n){if((e.ownerDocument||e)!==h){c(e)}var i=s.attrHandle[n.toLowerCase()],o=i&&M.call(s.attrHandle,n.toLowerCase())?i(e,n,!d):t;return o===t?r.attributes||!d?e.getAttribute(n):(o=e.getAttributeNode(n))&&o.specified?o.value:null:o};ot.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)};ot.uniqueSort=function(e){var t,n=[],i=0,s=0;k=!r.detectDuplicates;l=!r.sortStable&&e.slice(0);e.sort(L);if(k){while(t=e[s++]){if(t===e[s]){i=n.push(s)}}while(i--){e.splice(n[i],1)}}return e};o=ot.getText=function(e){var t,n="",r=0,i=e.nodeType;if(!i){for(;t=e[r];r++){n+=o(t)}}else if(i===1||i===9||i===11){if(typeof e.textContent==="string"){return e.textContent}else{for(e=e.firstChild;e;e=e.nextSibling){n+=o(e)}}}else if(i===3||i===4){return e.nodeValue}return n};s=ot.selectors={cacheLength:50,createPseudo:at,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:true}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:true},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){e[1]=e[1].replace(rt,it);e[3]=(e[4]||e[5]||"").replace(rt,it);if(e[2]==="~="){e[3]=" "+e[3]+" "}return e.slice(0,4)},CHILD:function(e){e[1]=e[1].toLowerCase();if(e[1].slice(0,3)==="nth"){if(!e[3]){ot.error(e[0])}e[4]=+(e[4]?e[5]+(e[6]||1):2*(e[3]==="even"||e[3]==="odd"));e[5]=+(e[7]+e[8]||e[3]==="odd")}else if(e[3]){ot.error(e[0])}return e},PSEUDO:function(e){var n,r=!e[5]&&e[2];if(G["CHILD"].test(e[0])){return null}if(e[3]&&e[4]!==t){e[2]=e[4]}else if(r&&K.test(r)&&(n=mt(r,true))&&(n=r.indexOf(")",r.length-n)-r.length)){e[0]=e[0].slice(0,n);e[2]=r.slice(0,n)}return e.slice(0,3)}},filter:{TAG:function(e){var t=e.replace(rt,it).toLowerCase();return e==="*"?function(){return true}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=T[e+" "];return t||(t=new RegExp("(^|"+I+")"+e+"("+I+"|$)"))&&T(e,function(e){return t.test(typeof e.className==="string"&&e.className||typeof e.getAttribute!==A&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=ot.attr(r,e);if(i==null){return t==="!="}if(!t){return true}i+="";return t==="="?i===n:t==="!="?i!==n:t==="^="?n&&i.indexOf(n)===0:t==="*="?n&&i.indexOf(n)>-1:t==="$="?n&&i.slice(-n.length)===n:t==="~="?(" "+i+" ").indexOf(n)>-1:t==="|="?i===n||i.slice(0,n.length+1)===n+"-":false}},CHILD:function(e,t,n,r,i){var s=e.slice(0,3)!=="nth",o=e.slice(-4)!=="last",u=t==="of-type";return r===1&&i===0?function(e){return!!e.parentNode}:function(t,n,a){var f,l,c,h,p,d,v=s!==o?"nextSibling":"previousSibling",m=t.parentNode,g=u&&t.nodeName.toLowerCase(),y=!a&&!u;if(m){if(s){while(v){c=t;while(c=c[v]){if(u?c.nodeName.toLowerCase()===g:c.nodeType===1){return false}}d=v=e==="only"&&!d&&"nextSibling"}return true}d=[o?m.firstChild:m.lastChild];if(o&&y){l=m[b]||(m[b]={});f=l[e]||[];p=f[0]===S&&f[1];h=f[0]===S&&f[2];c=p&&m.childNodes[p];while(c=++p&&c&&c[v]||(h=p=0)||d.pop()){if(c.nodeType===1&&++h&&c===t){l[e]=[S,p,h];break}}}else if(y&&(f=(t[b]||(t[b]={}))[e])&&f[0]===S){h=f[1]}else{while(c=++p&&c&&c[v]||(h=p=0)||d.pop()){if((u?c.nodeName.toLowerCase()===g:c.nodeType===1)&&++h){if(y){(c[b]||(c[b]={}))[e]=[S,h]}if(c===t){break}}}}h-=i;return h===r||h%r===0&&h/r>=0}}},PSEUDO:function(e,t){var n,r=s.pseudos[e]||s.setFilters[e.toLowerCase()]||ot.error("unsupported pseudo: "+e);if(r[b]){return r(t)}if(r.length>1){n=[e,e,"",t];return s.setFilters.hasOwnProperty(e.toLowerCase())?at(function(e,n){var i,s=r(e,t),o=s.length;while(o--){i=j.call(e,s[o]);e[i]=!(n[i]=s[o])}}):function(e){return r(e,0,n)}}return r}},pseudos:{not:at(function(e){var t=[],n=[],r=a(e.replace(W,"$1"));return r[b]?at(function(e,t,n,i){var s,o=r(e,null,i,[]),u=e.length;while(u--){if(s=o[u]){e[u]=!(t[u]=s)}}}):function(e,i,s){t[0]=e;r(t,null,s,n);return!n.pop()}}),has:at(function(e){return function(t){return ot(e,t).length>0}}),contains:at(function(e){return function(t){return(t.textContent||t.innerText||o(t)).indexOf(e)>-1}}),lang:at(function(e){if(!Q.test(e||"")){ot.error("unsupported lang: "+e)}e=e.replace(rt,it).toLowerCase();return function(t){var n;do{if(n=d?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang")){n=n.toLowerCase();return n===e||n.indexOf(e+"-")===0}}while((t=t.parentNode)&&t.nodeType===1);return false}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===p},focus:function(e){return e===h.activeElement&&(!h.hasFocus||h.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:function(e){return e.disabled===false},disabled:function(e){return e.disabled===true},checked:function(e){var t=e.nodeName.toLowerCase();return t==="input"&&!!e.checked||t==="option"&&!!e.selected},selected:function(e){if(e.parentNode){e.parentNode.selectedIndex}return e.selected===true},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling){if(e.nodeName>"@"||e.nodeType===3||e.nodeType===4){return false}}return true},parent:function(e){return!s.pseudos["empty"](e)},header:function(e){return tt.test(e.nodeName)},input:function(e){return et.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return t==="input"&&e.type==="button"||t==="button"},text:function(e){var t;return e.nodeName.toLowerCase()==="input"&&e.type==="text"&&((t=e.getAttribute("type"))==null||t.toLowerCase()===e.type)},first:dt(function(){return[0]}),last:dt(function(e,t){return[t-1]}),eq:dt(function(e,t,n){return[n<0?n+t:n]}),even:dt(function(e,t){var n=0;for(;n<t;n+=2){e.push(n)}return e}),odd:dt(function(e,t){var n=1;for(;n<t;n+=2){e.push(n)}return e}),lt:dt(function(e,t,n){var r=n<0?n+t:n;for(;--r>=0;){e.push(r)}return e}),gt:dt(function(e,t,n){var r=n<0?n+t:n;for(;++r<t;){e.push(r)}return e})}};s.pseudos["nth"]=s.pseudos["eq"];for(n in{radio:true,checkbox:true,file:true,password:true,image:true}){s.pseudos[n]=ht(n)}for(n in{submit:true,reset:true}){s.pseudos[n]=pt(n)}vt.prototype=s.filters=s.pseudos;s.setFilters=new vt;a=ot.compile=function(e,t){var n,r=[],i=[],s=C[e+" "];if(!s){if(!t){t=mt(e)}n=t.length;while(n--){s=St(t[n]);if(s[b]){r.push(s)}else{i.push(s)}}s=C(e,xt(i,r))}return s};r.sortStable=b.split("").sort(L).join("")===b;r.detectDuplicates=k;c();r.sortDetached=ft(function(e){return e.compareDocumentPosition(h.createElement("div"))&1});if(!ft(function(e){e.innerHTML="<a href='#'></a>";return e.firstChild.getAttribute("href")==="#"})){lt("type|href|height|width",function(e,t,n){if(!n){return e.getAttribute(t,t.toLowerCase()==="type"?1:2)}})}if(!r.attributes||!ft(function(e){e.innerHTML="<input/>";e.firstChild.setAttribute("value","");return e.firstChild.getAttribute("value")===""})){lt("value",function(e,t,n){if(!n&&e.nodeName.toLowerCase()==="input"){return e.defaultValue}})}if(!ft(function(e){return e.getAttribute("disabled")==null})){lt(F,function(e,t,n){var r;if(!n){return(r=e.getAttributeNode(t))&&r.specified?r.value:e[t]===true?t.toLowerCase():null}})}w.find=ot;w.expr=ot.selectors;w.expr[":"]=w.expr.pseudos;w.unique=ot.uniqueSort;w.text=ot.getText;w.isXMLDoc=ot.isXML;w.contains=ot.contains})(e);var B={};w.Callbacks=function(e){e=typeof e==="string"?B[e]||j(e):w.extend({},e);var n,r,i,s,o,u,a=[],f=!e.once&&[],l=function(t){r=e.memory&&t;i=true;o=u||0;u=0;s=a.length;n=true;for(;a&&o<s;o++){if(a[o].apply(t[0],t[1])===false&&e.stopOnFalse){r=false;break}}n=false;if(a){if(f){if(f.length){l(f.shift())}}else if(r){a=[]}else{c.disable()}}},c={add:function(){if(a){var t=a.length;(function i(t){w.each(t,function(t,n){var r=w.type(n);if(r==="function"){if(!e.unique||!c.has(n)){a.push(n)}}else if(n&&n.length&&r!=="string"){i(n)}})})(arguments);if(n){s=a.length}else if(r){u=t;l(r)}}return this},remove:function(){if(a){w.each(arguments,function(e,t){var r;while((r=w.inArray(t,a,r))>-1){a.splice(r,1);if(n){if(r<=s){s--}if(r<=o){o--}}}})}return this},has:function(e){return e?w.inArray(e,a)>-1:!!(a&&a.length)},empty:function(){a=[];s=0;return this},disable:function(){a=f=r=t;return this},disabled:function(){return!a},lock:function(){f=t;if(!r){c.disable()}return this},locked:function(){return!f},fireWith:function(e,t){if(a&&(!i||f)){t=t||[];t=[e,t.slice?t.slice():t];if(n){f.push(t)}else{l(t)}}return this},fire:function(){c.fireWith(this,arguments);return this},fired:function(){return!!i}};return c};w.extend({Deferred:function(e){var t=[["resolve","done",w.Callbacks("once memory"),"resolved"],["reject","fail",w.Callbacks("once memory"),"rejected"],["notify","progress",w.Callbacks("memory")]],n="pending",r={state:function(){return n},always:function(){i.done(arguments).fail(arguments);return this},then:function(){var e=arguments;return w.Deferred(function(n){w.each(t,function(t,s){var o=s[0],u=w.isFunction(e[t])&&e[t];i[s[1]](function(){var e=u&&u.apply(this,arguments);if(e&&w.isFunction(e.promise)){e.promise().done(n.resolve).fail(n.reject).progress(n.notify)}else{n[o+"With"](this===r?n.promise():this,u?[e]:arguments)}})});e=null}).promise()},promise:function(e){return e!=null?w.extend(e,r):r}},i={};r.pipe=r.then;w.each(t,function(e,s){var o=s[2],u=s[3];r[s[1]]=o.add;if(u){o.add(function(){n=u},t[e^1][2].disable,t[2][2].lock)}i[s[0]]=function(){i[s[0]+"With"](this===i?r:this,arguments);return this};i[s[0]+"With"]=o.fireWith});r.promise(i);if(e){e.call(i,i)}return i},when:function(e){var t=0,n=v.call(arguments),r=n.length,i=r!==1||e&&w.isFunction(e.promise)?r:0,s=i===1?e:w.Deferred(),o=function(e,t,n){return function(r){t[e]=this;n[e]=arguments.length>1?v.call(arguments):r;if(n===u){s.notifyWith(t,n)}else if(!--i){s.resolveWith(t,n)}}},u,a,f;if(r>1){u=new Array(r);a=new Array(r);f=new Array(r);for(;t<r;t++){if(n[t]&&w.isFunction(n[t].promise)){n[t].promise().done(o(t,f,n)).fail(s.reject).progress(o(t,a,u))}else{--i}}}if(!i){s.resolveWith(f,n)}return s.promise()}});w.support=function(t){var n,r,s,u,a,f,l,c,h,p=o.createElement("div");p.setAttribute("className","t");p.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";n=p.getElementsByTagName("*")||[];r=p.getElementsByTagName("a")[0];if(!r||!r.style||!n.length){return t}u=o.createElement("select");f=u.appendChild(o.createElement("option"));s=p.getElementsByTagName("input")[0];r.style.cssText="top:1px;float:left;opacity:.5";t.getSetAttribute=p.className!=="t";t.leadingWhitespace=p.firstChild.nodeType===3;t.tbody=!p.getElementsByTagName("tbody").length;t.htmlSerialize=!!p.getElementsByTagName("link").length;t.style=/top/.test(r.getAttribute("style"));t.hrefNormalized=r.getAttribute("href")==="/a";t.opacity=/^0.5/.test(r.style.opacity);t.cssFloat=!!r.style.cssFloat;t.checkOn=!!s.value;t.optSelected=f.selected;t.enctype=!!o.createElement("form").enctype;t.html5Clone=o.createElement("nav").cloneNode(true).outerHTML!=="<:nav></:nav>";t.inlineBlockNeedsLayout=false;t.shrinkWrapBlocks=false;t.pixelPosition=false;t.deleteExpando=true;t.noCloneEvent=true;t.reliableMarginRight=true;t.boxSizingReliable=true;s.checked=true;t.noCloneChecked=s.cloneNode(true).checked;u.disabled=true;t.optDisabled=!f.disabled;try{delete p.test}catch(d){t.deleteExpando=false}s=o.createElement("input");s.setAttribute("value","");t.input=s.getAttribute("value")==="";s.value="t";s.setAttribute("type","radio");t.radioValue=s.value==="t";s.setAttribute("checked","t");s.setAttribute("name","t");a=o.createDocumentFragment();a.appendChild(s);t.appendChecked=s.checked;t.checkClone=a.cloneNode(true).cloneNode(true).lastChild.checked;if(p.attachEvent){p.attachEvent("onclick",function(){t.noCloneEvent=false});p.cloneNode(true).click()}for(h in{submit:true,change:true,focusin:true}){p.setAttribute(l="on"+h,"t");t[h+"Bubbles"]=l in e||p.attributes[l].expando===false}p.style.backgroundClip="content-box";p.cloneNode(true).style.backgroundClip="";t.clearCloneStyle=p.style.backgroundClip==="content-box";for(h in w(t)){break}t.ownLast=h!=="0";w(function(){var n,r,s,u="padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",a=o.getElementsByTagName("body")[0];if(!a){return}n=o.createElement("div");n.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px";a.appendChild(n).appendChild(p);p.innerHTML="<table><tr><td></td><td>t</td></tr></table>";s=p.getElementsByTagName("td");s[0].style.cssText="padding:0;margin:0;border:0;display:none";c=s[0].offsetHeight===0;s[0].style.display="";s[1].style.display="none";t.reliableHiddenOffsets=c&&s[0].offsetHeight===0;p.innerHTML="";p.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;";w.swap(a,a.style.zoom!=null?{zoom:1}:{},function(){t.boxSizing=p.offsetWidth===4});if(e.getComputedStyle){t.pixelPosition=(e.getComputedStyle(p,null)||{}).top!=="1%";t.boxSizingReliable=(e.getComputedStyle(p,null)||{width:"4px"}).width==="4px";r=p.appendChild(o.createElement("div"));r.style.cssText=p.style.cssText=u;r.style.marginRight=r.style.width="0";p.style.width="1px";t.reliableMarginRight=!parseFloat((e.getComputedStyle(r,null)||{}).marginRight)}if(typeof p.style.zoom!==i){p.innerHTML="";p.style.cssText=u+"width:1px;padding:1px;display:inline;zoom:1";t.inlineBlockNeedsLayout=p.offsetWidth===3;p.style.display="block";p.innerHTML="<div></div>";p.firstChild.style.width="5px";t.shrinkWrapBlocks=p.offsetWidth!==3;if(t.inlineBlockNeedsLayout){a.style.zoom=1}}a.removeChild(n);n=p=s=r=null});n=u=a=f=r=s=null;return t}({});var F=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,I=/([A-Z])/g;w.extend({cache:{},noData:{applet:true,embed:true,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(e){e=e.nodeType?w.cache[e[w.expando]]:e[w.expando];return!!e&&!z(e)},data:function(e,t,n){return q(e,t,n)},removeData:function(e,t){return R(e,t)},_data:function(e,t,n){return q(e,t,n,true)},_removeData:function(e,t){return R(e,t,true)},acceptData:function(e){if(e.nodeType&&e.nodeType!==1&&e.nodeType!==9){return false}var t=e.nodeName&&w.noData[e.nodeName.toLowerCase()];return!t||t!==true&&e.getAttribute("classid")===t}});w.fn.extend({data:function(e,n){var r,i,s=null,o=0,u=this[0];if(e===t){if(this.length){s=w.data(u);if(u.nodeType===1&&!w._data(u,"parsedAttrs")){r=u.attributes;for(;o<r.length;o++){i=r[o].name;if(i.indexOf("data-")===0){i=w.camelCase(i.slice(5));U(u,i,s[i])}}w._data(u,"parsedAttrs",true)}}return s}if(typeof e==="object"){return this.each(function(){w.data(this,e)})}return arguments.length>1?this.each(function(){w.data(this,e,n)}):u?U(u,e,w.data(u,e)):null},removeData:function(e){return this.each(function(){w.removeData(this,e)})}});w.extend({queue:function(e,t,n){var r;if(e){t=(t||"fx")+"queue";r=w._data(e,t);if(n){if(!r||w.isArray(n)){r=w._data(e,t,w.makeArray(n))}else{r.push(n)}}return r||[]}},dequeue:function(e,t){t=t||"fx";var n=w.queue(e,t),r=n.length,i=n.shift(),s=w._queueHooks(e,t),o=function(){w.dequeue(e,t)};if(i==="inprogress"){i=n.shift();r--}if(i){if(t==="fx"){n.unshift("inprogress")}delete s.stop;i.call(e,o,s)}if(!r&&s){s.empty.fire()}},_queueHooks:function(e,t){var n=t+"queueHooks";return w._data(e,n)||w._data(e,n,{empty:w.Callbacks("once memory").add(function(){w._removeData(e,t+"queue");w._removeData(e,n)})})}});w.fn.extend({queue:function(e,n){var r=2;if(typeof e!=="string"){n=e;e="fx";r--}if(arguments.length<r){return w.queue(this[0],e)}return n===t?this:this.each(function(){var t=w.queue(this,e,n);w._queueHooks(this,e);if(e==="fx"&&t[0]!=="inprogress"){w.dequeue(this,e)}})},dequeue:function(e){return this.each(function(){w.dequeue(this,e)})},delay:function(e,t){e=w.fx?w.fx.speeds[e]||e:e;t=t||"fx";return this.queue(t,function(t,n){var r=setTimeout(t,e);n.stop=function(){clearTimeout(r)}})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,n){var r,i=1,s=w.Deferred(),o=this,u=this.length,a=function(){if(!--i){s.resolveWith(o,[o])}};if(typeof e!=="string"){n=e;e=t}e=e||"fx";while(u--){r=w._data(o[u],e+"queueHooks");if(r&&r.empty){i++;r.empty.add(a)}}a();return s.promise(n)}});var W,X,V=/[\t\r\n\f]/g,$=/\r/g,J=/^(?:input|select|textarea|button|object)$/i,K=/^(?:a|area)$/i,Q=/^(?:checked|selected)$/i,G=w.support.getSetAttribute,Y=w.support.input;w.fn.extend({attr:function(e,t){return w.access(this,w.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){w.removeAttr(this,e)})},prop:function(e,t){return w.access(this,w.prop,e,t,arguments.length>1)},removeProp:function(e){e=w.propFix[e]||e;return this.each(function(){try{this[e]=t;delete this[e]}catch(n){}})},addClass:function(e){var t,n,r,i,s,o=0,u=this.length,a=typeof e==="string"&&e;if(w.isFunction(e)){return this.each(function(t){w(this).addClass(e.call(this,t,this.className))})}if(a){t=(e||"").match(S)||[];for(;o<u;o++){n=this[o];r=n.nodeType===1&&(n.className?(" "+n.className+" ").replace(V," "):" ");if(r){s=0;while(i=t[s++]){if(r.indexOf(" "+i+" ")<0){r+=i+" "}}n.className=w.trim(r)}}}return this},removeClass:function(e){var t,n,r,i,s,o=0,u=this.length,a=arguments.length===0||typeof e==="string"&&e;if(w.isFunction(e)){return this.each(function(t){w(this).removeClass(e.call(this,t,this.className))})}if(a){t=(e||"").match(S)||[];for(;o<u;o++){n=this[o];r=n.nodeType===1&&(n.className?(" "+n.className+" ").replace(V," "):"");if(r){s=0;while(i=t[s++]){while(r.indexOf(" "+i+" ")>=0){r=r.replace(" "+i+" "," ")}}n.className=e?w.trim(r):""}}}return this},toggleClass:function(e,t){var n=typeof e;if(typeof t==="boolean"&&n==="string"){return t?this.addClass(e):this.removeClass(e)}if(w.isFunction(e)){return this.each(function(n){w(this).toggleClass(e.call(this,n,this.className,t),t)})}return this.each(function(){if(n==="string"){var t,r=0,s=w(this),o=e.match(S)||[];while(t=o[r++]){if(s.hasClass(t)){s.removeClass(t)}else{s.addClass(t)}}}else if(n===i||n==="boolean"){if(this.className){w._data(this,"__className__",this.className)}this.className=this.className||e===false?"":w._data(this,"__className__")||""}})},hasClass:function(e){var t=" "+e+" ",n=0,r=this.length;for(;n<r;n++){if(this[n].nodeType===1&&(" "+this[n].className+" ").replace(V," ").indexOf(t)>=0){return true}}return false},val:function(e){var n,r,i,s=this[0];if(!arguments.length){if(s){r=w.valHooks[s.type]||w.valHooks[s.nodeName.toLowerCase()];if(r&&"get"in r&&(n=r.get(s,"value"))!==t){return n}n=s.value;return typeof n==="string"?n.replace($,""):n==null?"":n}return}i=w.isFunction(e);return this.each(function(n){var s;if(this.nodeType!==1){return}if(i){s=e.call(this,n,w(this).val())}else{s=e}if(s==null){s=""}else if(typeof s==="number"){s+=""}else if(w.isArray(s)){s=w.map(s,function(e){return e==null?"":e+""})}r=w.valHooks[this.type]||w.valHooks[this.nodeName.toLowerCase()];if(!r||!("set"in r)||r.set(this,s,"value")===t){this.value=s}})}});w.extend({valHooks:{option:{get:function(e){var t=w.find.attr(e,"value");return t!=null?t:e.text}},select:{get:function(e){var t,n,r=e.options,i=e.selectedIndex,s=e.type==="select-one"||i<0,o=s?null:[],u=s?i+1:r.length,a=i<0?u:s?i:0;for(;a<u;a++){n=r[a];if((n.selected||a===i)&&(w.support.optDisabled?!n.disabled:n.getAttribute("disabled")===null)&&(!n.parentNode.disabled||!w.nodeName(n.parentNode,"optgroup"))){t=w(n).val();if(s){return t}o.push(t)}}return o},set:function(e,t){var n,r,i=e.options,s=w.makeArray(t),o=i.length;while(o--){r=i[o];if(r.selected=w.inArray(w(r).val(),s)>=0){n=true}}if(!n){e.selectedIndex=-1}return s}}},attr:function(e,n,r){var s,o,u=e.nodeType;if(!e||u===3||u===8||u===2){return}if(typeof e.getAttribute===i){return w.prop(e,n,r)}if(u!==1||!w.isXMLDoc(e)){n=n.toLowerCase();s=w.attrHooks[n]||(w.expr.match.bool.test(n)?X:W)}if(r!==t){if(r===null){w.removeAttr(e,n)}else if(s&&"set"in s&&(o=s.set(e,r,n))!==t){return o}else{e.setAttribute(n,r+"");return r}}else if(s&&"get"in s&&(o=s.get(e,n))!==null){return o}else{o=w.find.attr(e,n);return o==null?t:o}},removeAttr:function(e,t){var n,r,i=0,s=t&&t.match(S);if(s&&e.nodeType===1){while(n=s[i++]){r=w.propFix[n]||n;if(w.expr.match.bool.test(n)){if(Y&&G||!Q.test(n)){e[r]=false}else{e[w.camelCase("default-"+n)]=e[r]=false}}else{w.attr(e,n,"")}e.removeAttribute(G?n:r)}}},attrHooks:{type:{set:function(e,t){if(!w.support.radioValue&&t==="radio"&&w.nodeName(e,"input")){var n=e.value;e.setAttribute("type",t);if(n){e.value=n}return t}}}},propFix:{"for":"htmlFor","class":"className"},prop:function(e,n,r){var i,s,o,u=e.nodeType;if(!e||u===3||u===8||u===2){return}o=u!==1||!w.isXMLDoc(e);if(o){n=w.propFix[n]||n;s=w.propHooks[n]}if(r!==t){return s&&"set"in s&&(i=s.set(e,r,n))!==t?i:e[n]=r}else{return s&&"get"in s&&(i=s.get(e,n))!==null?i:e[n]}},propHooks:{tabIndex:{get:function(e){var t=w.find.attr(e,"tabindex");return t?parseInt(t,10):J.test(e.nodeName)||K.test(e.nodeName)&&e.href?0:-1}}}});X={set:function(e,t,n){if(t===false){w.removeAttr(e,n)}else if(Y&&G||!Q.test(n)){e.setAttribute(!G&&w.propFix[n]||n,n)}else{e[w.camelCase("default-"+n)]=e[n]=true}return n}};w.each(w.expr.match.bool.source.match(/\w+/g),function(e,n){var r=w.expr.attrHandle[n]||w.find.attr;w.expr.attrHandle[n]=Y&&G||!Q.test(n)?function(e,n,i){var s=w.expr.attrHandle[n],o=i?t:(w.expr.attrHandle[n]=t)!=r(e,n,i)?n.toLowerCase():null;w.expr.attrHandle[n]=s;return o}:function(e,n,r){return r?t:e[w.camelCase("default-"+n)]?n.toLowerCase():null}});if(!Y||!G){w.attrHooks.value={set:function(e,t,n){if(w.nodeName(e,"input")){e.defaultValue=t}else{return W&&W.set(e,t,n)}}}}if(!G){W={set:function(e,n,r){var i=e.getAttributeNode(r);if(!i){e.setAttributeNode(i=e.ownerDocument.createAttribute(r))}i.value=n+="";return r==="value"||n===e.getAttribute(r)?n:t}};w.expr.attrHandle.id=w.expr.attrHandle.name=w.expr.attrHandle.coords=function(e,n,r){var i;return r?t:(i=e.getAttributeNode(n))&&i.value!==""?i.value:null};w.valHooks.button={get:function(e,n){var r=e.getAttributeNode(n);return r&&r.specified?r.value:t},set:W.set};w.attrHooks.contenteditable={set:function(e,t,n){W.set(e,t===""?false:t,n)}};w.each(["width","height"],function(e,t){w.attrHooks[t]={set:function(e,n){if(n===""){e.setAttribute(t,"auto");return n}}}})}if(!w.support.hrefNormalized){w.each(["href","src"],function(e,t){w.propHooks[t]={get:function(e){return e.getAttribute(t,4)}}})}if(!w.support.style){w.attrHooks.style={get:function(e){return e.style.cssText||t},set:function(e,t){return e.style.cssText=t+""}}}if(!w.support.optSelected){w.propHooks.selected={get:function(e){var t=e.parentNode;if(t){t.selectedIndex;if(t.parentNode){t.parentNode.selectedIndex}}return null}}}w.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){w.propFix[this.toLowerCase()]=this});if(!w.support.enctype){w.propFix.enctype="encoding"}w.each(["radio","checkbox"],function(){w.valHooks[this]={set:function(e,t){if(w.isArray(t)){return e.checked=w.inArray(w(e).val(),t)>=0}}};if(!w.support.checkOn){w.valHooks[this].get=function(e){return e.getAttribute("value")===null?"on":e.value}}});var Z=/^(?:input|select|textarea)$/i,et=/^key/,tt=/^(?:mouse|contextmenu)|click/,nt=/^(?:focusinfocus|focusoutblur)$/,rt=/^([^.]*)(?:\.(.+)|)$/;w.event={global:{},add:function(e,n,r,s,o){var u,a,f,l,c,h,p,d,v,m,g,y=w._data(e);if(!y){return}if(r.handler){l=r;r=l.handler;o=l.selector}if(!r.guid){r.guid=w.guid++}if(!(a=y.events)){a=y.events={}}if(!(h=y.handle)){h=y.handle=function(e){return typeof w!==i&&(!e||w.event.triggered!==e.type)?w.event.dispatch.apply(h.elem,arguments):t};h.elem=e}n=(n||"").match(S)||[""];f=n.length;while(f--){u=rt.exec(n[f])||[];v=g=u[1];m=(u[2]||"").split(".").sort();if(!v){continue}c=w.event.special[v]||{};v=(o?c.delegateType:c.bindType)||v;c=w.event.special[v]||{};p=w.extend({type:v,origType:g,data:s,handler:r,guid:r.guid,selector:o,needsContext:o&&w.expr.match.needsContext.test(o),namespace:m.join(".")},l);if(!(d=a[v])){d=a[v]=[];d.delegateCount=0;if(!c.setup||c.setup.call(e,s,m,h)===false){if(e.addEventListener){e.addEventListener(v,h,false)}else if(e.attachEvent){e.attachEvent("on"+v,h)}}}if(c.add){c.add.call(e,p);if(!p.handler.guid){p.handler.guid=r.guid}}if(o){d.splice(d.delegateCount++,0,p)}else{d.push(p)}w.event.global[v]=true}e=null},remove:function(e,t,n,r,i){var s,o,u,a,f,l,c,h,p,d,v,m=w.hasData(e)&&w._data(e);if(!m||!(l=m.events)){return}t=(t||"").match(S)||[""];f=t.length;while(f--){u=rt.exec(t[f])||[];p=v=u[1];d=(u[2]||"").split(".").sort();if(!p){for(p in l){w.event.remove(e,p+t[f],n,r,true)}continue}c=w.event.special[p]||{};p=(r?c.delegateType:c.bindType)||p;h=l[p]||[];u=u[2]&&new RegExp("(^|\\.)"+d.join("\\.(?:.*\\.|)")+"(\\.|$)");a=s=h.length;while(s--){o=h[s];if((i||v===o.origType)&&(!n||n.guid===o.guid)&&(!u||u.test(o.namespace))&&(!r||r===o.selector||r==="**"&&o.selector)){h.splice(s,1);if(o.selector){h.delegateCount--}if(c.remove){c.remove.call(e,o)}}}if(a&&!h.length){if(!c.teardown||c.teardown.call(e,d,m.handle)===false){w.removeEvent(e,p,m.handle)}delete l[p]}}if(w.isEmptyObject(l)){delete m.handle;w._removeData(e,"events")}},trigger:function(n,r,i,s){var u,a,f,l,c,h,p,d=[i||o],v=y.call(n,"type")?n.type:n,m=y.call(n,"namespace")?n.namespace.split("."):[];f=h=i=i||o;if(i.nodeType===3||i.nodeType===8){return}if(nt.test(v+w.event.triggered)){return}if(v.indexOf(".")>=0){m=v.split(".");v=m.shift();m.sort()}a=v.indexOf(":")<0&&"on"+v;n=n[w.expando]?n:new w.Event(v,typeof n==="object"&&n);n.isTrigger=s?2:3;n.namespace=m.join(".");n.namespace_re=n.namespace?new RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null;n.result=t;if(!n.target){n.target=i}r=r==null?[n]:w.makeArray(r,[n]);c=w.event.special[v]||{};if(!s&&c.trigger&&c.trigger.apply(i,r)===false){return}if(!s&&!c.noBubble&&!w.isWindow(i)){l=c.delegateType||v;if(!nt.test(l+v)){f=f.parentNode}for(;f;f=f.parentNode){d.push(f);h=f}if(h===(i.ownerDocument||o)){d.push(h.defaultView||h.parentWindow||e)}}p=0;while((f=d[p++])&&!n.isPropagationStopped()){n.type=p>1?l:c.bindType||v;u=(w._data(f,"events")||{})[n.type]&&w._data(f,"handle");if(u){u.apply(f,r)}u=a&&f[a];if(u&&w.acceptData(f)&&u.apply&&u.apply(f,r)===false){n.preventDefault()}}n.type=v;if(!s&&!n.isDefaultPrevented()){if((!c._default||c._default.apply(d.pop(),r)===false)&&w.acceptData(i)){if(a&&i[v]&&!w.isWindow(i)){h=i[a];if(h){i[a]=null}w.event.triggered=v;try{i[v]()}catch(g){}w.event.triggered=t;if(h){i[a]=h}}}}return n.result},dispatch:function(e){e=w.event.fix(e);var n,r,i,s,o,u=[],a=v.call(arguments),f=(w._data(this,"events")||{})[e.type]||[],l=w.event.special[e.type]||{};a[0]=e;e.delegateTarget=this;if(l.preDispatch&&l.preDispatch.call(this,e)===false){return}u=w.event.handlers.call(this,e,f);n=0;while((s=u[n++])&&!e.isPropagationStopped()){e.currentTarget=s.elem;o=0;while((i=s.handlers[o++])&&!e.isImmediatePropagationStopped()){if(!e.namespace_re||e.namespace_re.test(i.namespace)){e.handleObj=i;e.data=i.data;r=((w.event.special[i.origType]||{}).handle||i.handler).apply(s.elem,a);if(r!==t){if((e.result=r)===false){e.preventDefault();e.stopPropagation()}}}}}if(l.postDispatch){l.postDispatch.call(this,e)}return e.result},handlers:function(e,n){var r,i,s,o,u=[],a=n.delegateCount,f=e.target;if(a&&f.nodeType&&(!e.button||e.type!=="click")){for(;f!=this;f=f.parentNode||this){if(f.nodeType===1&&(f.disabled!==true||e.type!=="click")){s=[];for(o=0;o<a;o++){i=n[o];r=i.selector+" ";if(s[r]===t){s[r]=i.needsContext?w(r,this).index(f)>=0:w.find(r,this,null,[f]).length}if(s[r]){s.push(i)}}if(s.length){u.push({elem:f,handlers:s})}}}}if(a<n.length){u.push({elem:this,handlers:n.slice(a)})}return u},fix:function(e){if(e[w.expando]){return e}var t,n,r,i=e.type,s=e,u=this.fixHooks[i];if(!u){this.fixHooks[i]=u=tt.test(i)?this.mouseHooks:et.test(i)?this.keyHooks:{}}r=u.props?this.props.concat(u.props):this.props;e=new w.Event(s);t=r.length;while(t--){n=r[t];e[n]=s[n]}if(!e.target){e.target=s.srcElement||o}if(e.target.nodeType===3){e.target=e.target.parentNode}e.metaKey=!!e.metaKey;return u.filter?u.filter(e,s):e},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(e,t){if(e.which==null){e.which=t.charCode!=null?t.charCode:t.keyCode}return e}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(e,n){var r,i,s,u=n.button,a=n.fromElement;if(e.pageX==null&&n.clientX!=null){i=e.target.ownerDocument||o;s=i.documentElement;r=i.body;e.pageX=n.clientX+(s&&s.scrollLeft||r&&r.scrollLeft||0)-(s&&s.clientLeft||r&&r.clientLeft||0);e.pageY=n.clientY+(s&&s.scrollTop||r&&r.scrollTop||0)-(s&&s.clientTop||r&&r.clientTop||0)}if(!e.relatedTarget&&a){e.relatedTarget=a===e.target?n.toElement:a}if(!e.which&&u!==t){e.which=u&1?1:u&2?3:u&4?2:0}return e}},special:{load:{noBubble:true},focus:{trigger:function(){if(this!==ot()&&this.focus){try{this.focus();return false}catch(e){}}},delegateType:"focusin"},blur:{trigger:function(){if(this===ot()&&this.blur){this.blur();return false}},delegateType:"focusout"},click:{trigger:function(){if(w.nodeName(this,"input")&&this.type==="checkbox"&&this.click){this.click();return false}},_default:function(e){return w.nodeName(e.target,"a")}},beforeunload:{postDispatch:function(e){if(e.result!==t){e.originalEvent.returnValue=e.result}}}},simulate:function(e,t,n,r){var i=w.extend(new w.Event,n,{type:e,isSimulated:true,originalEvent:{}});if(r){w.event.trigger(i,null,t)}else{w.event.dispatch.call(t,i)}if(i.isDefaultPrevented()){n.preventDefault()}}};w.removeEvent=o.removeEventListener?function(e,t,n){if(e.removeEventListener){e.removeEventListener(t,n,false)}}:function(e,t,n){var r="on"+t;if(e.detachEvent){if(typeof e[r]===i){e[r]=null}e.detachEvent(r,n)}};w.Event=function(e,t){if(!(this instanceof w.Event)){return new w.Event(e,t)}if(e&&e.type){this.originalEvent=e;this.type=e.type;this.isDefaultPrevented=e.defaultPrevented||e.returnValue===false||e.getPreventDefault&&e.getPreventDefault()?it:st}else{this.type=e}if(t){w.extend(this,t)}this.timeStamp=e&&e.timeStamp||w.now();this[w.expando]=true};w.Event.prototype={isDefaultPrevented:st,isPropagationStopped:st,isImmediatePropagationStopped:st,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=it;if(!e){return}if(e.preventDefault){e.preventDefault()}else{e.returnValue=false}},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=it;if(!e){return}if(e.stopPropagation){e.stopPropagation()}e.cancelBubble=true},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=it;this.stopPropagation()}};w.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(e,t){w.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,s=e.handleObj;if(!i||i!==r&&!w.contains(r,i)){e.type=s.origType;n=s.handler.apply(this,arguments);e.type=t}return n}}});if(!w.support.submitBubbles){w.event.special.submit={setup:function(){if(w.nodeName(this,"form")){return false}w.event.add(this,"click._submit keypress._submit",function(e){var n=e.target,r=w.nodeName(n,"input")||w.nodeName(n,"button")?n.form:t;if(r&&!w._data(r,"submitBubbles")){w.event.add(r,"submit._submit",function(e){e._submit_bubble=true});w._data(r,"submitBubbles",true)}})},postDispatch:function(e){if(e._submit_bubble){delete e._submit_bubble;if(this.parentNode&&!e.isTrigger){w.event.simulate("submit",this.parentNode,e,true)}}},teardown:function(){if(w.nodeName(this,"form")){return false}w.event.remove(this,"._submit")}}}if(!w.support.changeBubbles){w.event.special.change={setup:function(){if(Z.test(this.nodeName)){if(this.type==="checkbox"||this.type==="radio"){w.event.add(this,"propertychange._change",function(e){if(e.originalEvent.propertyName==="checked"){this._just_changed=true}});w.event.add(this,"click._change",function(e){if(this._just_changed&&!e.isTrigger){this._just_changed=false}w.event.simulate("change",this,e,true)})}return false}w.event.add(this,"beforeactivate._change",function(e){var t=e.target;if(Z.test(t.nodeName)&&!w._data(t,"changeBubbles")){w.event.add(t,"change._change",function(e){if(this.parentNode&&!e.isSimulated&&!e.isTrigger){w.event.simulate("change",this.parentNode,e,true)}});w._data(t,"changeBubbles",true)}})},handle:function(e){var t=e.target;if(this!==t||e.isSimulated||e.isTrigger||t.type!=="radio"&&t.type!=="checkbox"){return e.handleObj.handler.apply(this,arguments)}},teardown:function(){w.event.remove(this,"._change");return!Z.test(this.nodeName)}}}if(!w.support.focusinBubbles){w.each({focus:"focusin",blur:"focusout"},function(e,t){var n=0,r=function(e){w.event.simulate(t,e.target,w.event.fix(e),true)};w.event.special[t]={setup:function(){if(n++===0){o.addEventListener(e,r,true)}},teardown:function(){if(--n===0){o.removeEventListener(e,r,true)}}}})}w.fn.extend({on:function(e,n,r,i,s){var o,u;if(typeof e==="object"){if(typeof n!=="string"){r=r||n;n=t}for(o in e){this.on(o,n,r,e[o],s)}return this}if(r==null&&i==null){i=n;r=n=t}else if(i==null){if(typeof n==="string"){i=r;r=t}else{i=r;r=n;n=t}}if(i===false){i=st}else if(!i){return this}if(s===1){u=i;i=function(e){w().off(e);return u.apply(this,arguments)};i.guid=u.guid||(u.guid=w.guid++)}return this.each(function(){w.event.add(this,e,i,r,n)})},one:function(e,t,n,r){return this.on(e,t,n,r,1)},off:function(e,n,r){var i,s;if(e&&e.preventDefault&&e.handleObj){i=e.handleObj;w(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler);return this}if(typeof e==="object"){for(s in e){this.off(s,n,e[s])}return this}if(n===false||typeof n==="function"){r=n;n=t}if(r===false){r=st}return this.each(function(){w.event.remove(this,e,r,n)})},trigger:function(e,t){return this.each(function(){w.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n){return w.event.trigger(e,t,n,true)}}});var ut=/^.[^:#\[\.,]*$/,at=/^(?:parents|prev(?:Until|All))/,ft=w.expr.match.needsContext,lt={children:true,contents:true,next:true,prev:true};w.fn.extend({find:function(e){var t,n=[],r=this,i=r.length;if(typeof e!=="string"){return this.pushStack(w(e).filter(function(){for(t=0;t<i;t++){if(w.contains(r[t],this)){return true}}}))}for(t=0;t<i;t++){w.find(e,r[t],n)}n=this.pushStack(i>1?w.unique(n):n);n.selector=this.selector?this.selector+" "+e:e;return n},has:function(e){var t,n=w(e,this),r=n.length;return this.filter(function(){for(t=0;t<r;t++){if(w.contains(this,n[t])){return true}}})},not:function(e){return this.pushStack(ht(this,e||[],true))},filter:function(e){return this.pushStack(ht(this,e||[],false))},is:function(e){return!!ht(this,typeof e==="string"&&ft.test(e)?w(e):e||[],false).length},closest:function(e,t){var n,r=0,i=this.length,s=[],o=ft.test(e)||typeof e!=="string"?w(e,t||this.context):0;for(;r<i;r++){for(n=this[r];n&&n!==t;n=n.parentNode){if(n.nodeType<11&&(o?o.index(n)>-1:n.nodeType===1&&w.find.matchesSelector(n,e))){n=s.push(n);break}}}return this.pushStack(s.length>1?w.unique(s):s)},index:function(e){if(!e){return this[0]&&this[0].parentNode?this.first().prevAll().length:-1}if(typeof e==="string"){return w.inArray(this[0],w(e))}return w.inArray(e.jquery?e[0]:e,this)},add:function(e,t){var n=typeof e==="string"?w(e,t):w.makeArray(e&&e.nodeType?[e]:e),r=w.merge(this.get(),n);return this.pushStack(w.unique(r))},addBack:function(e){return this.add(e==null?this.prevObject:this.prevObject.filter(e))}});w.each({parent:function(e){var t=e.parentNode;return t&&t.nodeType!==11?t:null},parents:function(e){return w.dir(e,"parentNode")},parentsUntil:function(e,t,n){return w.dir(e,"parentNode",n)},next:function(e){return ct(e,"nextSibling")},prev:function(e){return ct(e,"previousSibling")},nextAll:function(e){return w.dir(e,"nextSibling")},prevAll:function(e){return w.dir(e,"previousSibling")},nextUntil:function(e,t,n){return w.dir(e,"nextSibling",n)},prevUntil:function(e,t,n){return w.dir(e,"previousSibling",n)},siblings:function(e){return w.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return w.sibling(e.firstChild)},contents:function(e){return w.nodeName(e,"iframe")?e.contentDocument||e.contentWindow.document:w.merge([],e.childNodes)}},function(e,t){w.fn[e]=function(n,r){var i=w.map(this,t,n);if(e.slice(-5)!=="Until"){r=n}if(r&&typeof r==="string"){i=w.filter(r,i)}if(this.length>1){if(!lt[e]){i=w.unique(i)}if(at.test(e)){i=i.reverse()}}return this.pushStack(i)}});w.extend({filter:function(e,t,n){var r=t[0];if(n){e=":not("+e+")"}return t.length===1&&r.nodeType===1?w.find.matchesSelector(r,e)?[r]:[]:w.find.matches(e,w.grep(t,function(e){return e.nodeType===1}))},dir:function(e,n,r){var i=[],s=e[n];while(s&&s.nodeType!==9&&(r===t||s.nodeType!==1||!w(s).is(r))){if(s.nodeType===1){i.push(s)}s=s[n]}return i},sibling:function(e,t){var n=[];for(;e;e=e.nextSibling){if(e.nodeType===1&&e!==t){n.push(e)}}return n}});var dt="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|"+"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",vt=/ jQuery\d+="(?:null|\d+)"/g,mt=new RegExp("<(?:"+dt+")[\\s/>]","i"),gt=/^\s+/,yt=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,bt=/<([\w:]+)/,wt=/<tbody/i,Et=/<|&#?\w+;/,St=/<(?:script|style|link)/i,xt=/^(?:checkbox|radio)$/i,Tt=/checked\s*(?:[^=]|=\s*.checked.)/i,Nt=/^$|\/(?:java|ecma)script/i,Ct=/^true\/(.*)/,kt=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,Lt={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:w.support.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},At=pt(o),Ot=At.appendChild(o.createElement("div"));Lt.optgroup=Lt.option;Lt.tbody=Lt.tfoot=Lt.colgroup=Lt.caption=Lt.thead;Lt.th=Lt.td;w.fn.extend({text:function(e){return w.access(this,function(e){return e===t?w.text(this):this.empty().append((this[0]&&this[0].ownerDocument||o).createTextNode(e))},null,e,arguments.length)},append:function(){return this.domManip(arguments,function(e){if(this.nodeType===1||this.nodeType===11||this.nodeType===9){var t=Mt(this,e);t.appendChild(e)}})},prepend:function(){return this.domManip(arguments,function(e){if(this.nodeType===1||this.nodeType===11||this.nodeType===9){var t=Mt(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return this.domManip(arguments,function(e){if(this.parentNode){this.parentNode.insertBefore(e,this)}})},after:function(){return this.domManip(arguments,function(e){if(this.parentNode){this.parentNode.insertBefore(e,this.nextSibling)}})},remove:function(e,t){var n,r=e?w.filter(e,this):this,i=0;for(;(n=r[i])!=null;i++){if(!t&&n.nodeType===1){w.cleanData(jt(n))}if(n.parentNode){if(t&&w.contains(n.ownerDocument,n)){Pt(jt(n,"script"))}n.parentNode.removeChild(n)}}return this},empty:function(){var e,t=0;for(;(e=this[t])!=null;t++){if(e.nodeType===1){w.cleanData(jt(e,false))}while(e.firstChild){e.removeChild(e.firstChild)}if(e.options&&w.nodeName(e,"select")){e.options.length=0}}return this},clone:function(e,t){e=e==null?false:e;t=t==null?e:t;return this.map(function(){return w.clone(this,e,t)})},html:function(e){return w.access(this,function(e){var n=this[0]||{},r=0,i=this.length;if(e===t){return n.nodeType===1?n.innerHTML.replace(vt,""):t}if(typeof e==="string"&&!St.test(e)&&(w.support.htmlSerialize||!mt.test(e))&&(w.support.leadingWhitespace||!gt.test(e))&&!Lt[(bt.exec(e)||["",""])[1].toLowerCase()]){e=e.replace(yt,"<$1></$2>");try{for(;r<i;r++){n=this[r]||{};if(n.nodeType===1){w.cleanData(jt(n,false));n.innerHTML=e}}n=0}catch(s){}}if(n){this.empty().append(e)}},null,e,arguments.length)},replaceWith:function(){var e=w.map(this,function(e){return[e.nextSibling,e.parentNode]}),t=0;this.domManip(arguments,function(n){var r=e[t++],i=e[t++];if(i){if(r&&r.parentNode!==i){r=this.nextSibling}w(this).remove();i.insertBefore(n,r)}},true);return t?this:this.remove()},detach:function(e){return this.remove(e,true)},domManip:function(e,t,n){e=p.apply([],e);var r,i,s,o,u,a,f=0,l=this.length,c=this,h=l-1,d=e[0],v=w.isFunction(d);if(v||!(l<=1||typeof d!=="string"||w.support.checkClone||!Tt.test(d))){return this.each(function(r){var i=c.eq(r);if(v){e[0]=d.call(this,r,i.html())}i.domManip(e,t,n)})}if(l){a=w.buildFragment(e,this[0].ownerDocument,false,!n&&this);r=a.firstChild;if(a.childNodes.length===1){a=r}if(r){o=w.map(jt(a,"script"),_t);s=o.length;for(;f<l;f++){i=a;if(f!==h){i=w.clone(i,true,true);if(s){w.merge(o,jt(i,"script"))}}t.call(this[f],i,f)}if(s){u=o[o.length-1].ownerDocument;w.map(o,Dt);for(f=0;f<s;f++){i=o[f];if(Nt.test(i.type||"")&&!w._data(i,"globalEval")&&w.contains(u,i)){if(i.src){w._evalUrl(i.src)}else{w.globalEval((i.text||i.textContent||i.innerHTML||"").replace(kt,""))}}}}a=r=null}}return this}});w.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){w.fn[e]=function(e){var n,r=0,i=[],s=w(e),o=s.length-1;for(;r<=o;r++){n=r===o?this:this.clone(true);w(s[r])[t](n);d.apply(i,n.get())}return this.pushStack(i)}});w.extend({clone:function(e,t,n){var r,i,s,o,u,a=w.contains(e.ownerDocument,e);if(w.support.html5Clone||w.isXMLDoc(e)||!mt.test("<"+e.nodeName+">")){s=e.cloneNode(true)}else{Ot.innerHTML=e.outerHTML;Ot.removeChild(s=Ot.firstChild)}if((!w.support.noCloneEvent||!w.support.noCloneChecked)&&(e.nodeType===1||e.nodeType===11)&&!w.isXMLDoc(e)){r=jt(s);u=jt(e);for(o=0;(i=u[o])!=null;++o){if(r[o]){Bt(i,r[o])}}}if(t){if(n){u=u||jt(e);r=r||jt(s);for(o=0;(i=u[o])!=null;o++){Ht(i,r[o])}}else{Ht(e,s)}}r=jt(s,"script");if(r.length>0){Pt(r,!a&&jt(e,"script"))}r=u=i=null;return s},buildFragment:function(e,t,n,r){var i,s,o,u,a,f,l,c=e.length,h=pt(t),p=[],d=0;for(;d<c;d++){s=e[d];if(s||s===0){if(w.type(s)==="object"){w.merge(p,s.nodeType?[s]:s)}else if(!Et.test(s)){p.push(t.createTextNode(s))}else{u=u||h.appendChild(t.createElement("div"));a=(bt.exec(s)||["",""])[1].toLowerCase();l=Lt[a]||Lt._default;u.innerHTML=l[1]+s.replace(yt,"<$1></$2>")+l[2];i=l[0];while(i--){u=u.lastChild}if(!w.support.leadingWhitespace&&gt.test(s)){p.push(t.createTextNode(gt.exec(s)[0]))}if(!w.support.tbody){s=a==="table"&&!wt.test(s)?u.firstChild:l[1]==="<table>"&&!wt.test(s)?u:0;i=s&&s.childNodes.length;while(i--){if(w.nodeName(f=s.childNodes[i],"tbody")&&!f.childNodes.length){s.removeChild(f)}}}w.merge(p,u.childNodes);u.textContent="";while(u.firstChild){u.removeChild(u.firstChild)}u=h.lastChild}}}if(u){h.removeChild(u)}if(!w.support.appendChecked){w.grep(jt(p,"input"),Ft)}d=0;while(s=p[d++]){if(r&&w.inArray(s,r)!==-1){continue}o=w.contains(s.ownerDocument,s);u=jt(h.appendChild(s),"script");if(o){Pt(u)}if(n){i=0;while(s=u[i++]){if(Nt.test(s.type||"")){n.push(s)}}}}u=null;return h},cleanData:function(e,t){var n,r,s,o,u=0,a=w.expando,f=w.cache,l=w.support.deleteExpando,h=w.event.special;for(;(n=e[u])!=null;u++){if(t||w.acceptData(n)){s=n[a];o=s&&f[s];if(o){if(o.events){for(r in o.events){if(h[r]){w.event.remove(n,r)}else{w.removeEvent(n,r,o.handle)}}}if(f[s]){delete f[s];if(l){delete n[a]}else if(typeof n.removeAttribute!==i){n.removeAttribute(a)}else{n[a]=null}c.push(s)}}}}},_evalUrl:function(e){return w.ajax({url:e,type:"GET",dataType:"script",async:false,global:false,"throws":true})}});w.fn.extend({wrapAll:function(e){if(w.isFunction(e)){return this.each(function(t){w(this).wrapAll(e.call(this,t))})}if(this[0]){var t=w(e,this[0].ownerDocument).eq(0).clone(true);if(this[0].parentNode){t.insertBefore(this[0])}t.map(function(){var e=this;while(e.firstChild&&e.firstChild.nodeType===1){e=e.firstChild}return e}).append(this)}return this},wrapInner:function(e){if(w.isFunction(e)){return this.each(function(t){w(this).wrapInner(e.call(this,t))})}return this.each(function(){var t=w(this),n=t.contents();if(n.length){n.wrapAll(e)}else{t.append(e)}})},wrap:function(e){var t=w.isFunction(e);return this.each(function(n){w(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(){return this.parent().each(function(){if(!w.nodeName(this,"body")){w(this).replaceWith(this.childNodes)}}).end()}});var It,qt,Rt,Ut=/alpha\([^)]*\)/i,zt=/opacity\s*=\s*([^)]*)/,Wt=/^(top|right|bottom|left)$/,Xt=/^(none|table(?!-c[ea]).+)/,Vt=/^margin/,$t=new RegExp("^("+E+")(.*)$","i"),Jt=new RegExp("^("+E+")(?!px)[a-z%]+$","i"),Kt=new RegExp("^([+-])=("+E+")","i"),Qt={BODY:"block"},Gt={position:"absolute",visibility:"hidden",display:"block"},Yt={letterSpacing:0,fontWeight:400},Zt=["Top","Right","Bottom","Left"],en=["Webkit","O","Moz","ms"];w.fn.extend({css:function(e,n){return w.access(this,function(e,n,r){var i,s,o={},u=0;if(w.isArray(n)){s=qt(e);i=n.length;for(;u<i;u++){o[n[u]]=w.css(e,n[u],false,s)}return o}return r!==t?w.style(e,n,r):w.css(e,n)},e,n,arguments.length>1)},show:function(){return rn(this,true)},hide:function(){return rn(this)},toggle:function(e){if(typeof e==="boolean"){return e?this.show():this.hide()}return this.each(function(){if(nn(this)){w(this).show()}else{w(this).hide()}})}});w.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Rt(e,"opacity");return n===""?"1":n}}}},cssNumber:{columnCount:true,fillOpacity:true,fontWeight:true,lineHeight:true,opacity:true,order:true,orphans:true,widows:true,zIndex:true,zoom:true},cssProps:{"float":w.support.cssFloat?"cssFloat":"styleFloat"},style:function(e,n,r,i){if(!e||e.nodeType===3||e.nodeType===8||!e.style){return}var s,o,u,a=w.camelCase(n),f=e.style;n=w.cssProps[a]||(w.cssProps[a]=tn(f,a));u=w.cssHooks[n]||w.cssHooks[a];if(r!==t){o=typeof r;if(o==="string"&&(s=Kt.exec(r))){r=(s[1]+1)*s[2]+parseFloat(w.css(e,n));o="number"}if(r==null||o==="number"&&isNaN(r)){return}if(o==="number"&&!w.cssNumber[a]){r+="px"}if(!w.support.clearCloneStyle&&r===""&&n.indexOf("background")===0){f[n]="inherit"}if(!u||!("set"in u)||(r=u.set(e,r,i))!==t){try{f[n]=r}catch(l){}}}else{if(u&&"get"in u&&(s=u.get(e,false,i))!==t){return s}return f[n]}},css:function(e,n,r,i){var s,o,u,a=w.camelCase(n);n=w.cssProps[a]||(w.cssProps[a]=tn(e.style,a));u=w.cssHooks[n]||w.cssHooks[a];if(u&&"get"in u){o=u.get(e,true,r)}if(o===t){o=Rt(e,n,i)}if(o==="normal"&&n in Yt){o=Yt[n]}if(r===""||r){s=parseFloat(o);return r===true||w.isNumeric(s)?s||0:o}return o}});if(e.getComputedStyle){qt=function(t){return e.getComputedStyle(t,null)};Rt=function(e,n,r){var i,s,o,u=r||qt(e),a=u?u.getPropertyValue(n)||u[n]:t,f=e.style;if(u){if(a===""&&!w.contains(e.ownerDocument,e)){a=w.style(e,n)}if(Jt.test(a)&&Vt.test(n)){i=f.width;s=f.minWidth;o=f.maxWidth;f.minWidth=f.maxWidth=f.width=a;a=u.width;f.width=i;f.minWidth=s;f.maxWidth=o}}return a}}else if(o.documentElement.currentStyle){qt=function(e){return e.currentStyle};Rt=function(e,n,r){var i,s,o,u=r||qt(e),a=u?u[n]:t,f=e.style;if(a==null&&f&&f[n]){a=f[n]}if(Jt.test(a)&&!Wt.test(n)){i=f.left;s=e.runtimeStyle;o=s&&s.left;if(o){s.left=e.currentStyle.left}f.left=n==="fontSize"?"1em":a;a=f.pixelLeft+"px";f.left=i;if(o){s.left=o}}return a===""?"auto":a}}w.each(["height","width"],function(e,t){w.cssHooks[t]={get:function(e,n,r){if(n){return e.offsetWidth===0&&Xt.test(w.css(e,"display"))?w.swap(e,Gt,function(){return un(e,t,r)}):un(e,t,r)}},set:function(e,n,r){var i=r&&qt(e);return sn(e,n,r?on(e,t,r,w.support.boxSizing&&w.css(e,"boxSizing",false,i)==="border-box",i):0)}}});if(!w.support.opacity){w.cssHooks.opacity={get:function(e,t){return zt.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":t?"1":""},set:function(e,t){var n=e.style,r=e.currentStyle,i=w.isNumeric(t)?"alpha(opacity="+t*100+")":"",s=r&&r.filter||n.filter||"";n.zoom=1;if((t>=1||t==="")&&w.trim(s.replace(Ut,""))===""&&n.removeAttribute){n.removeAttribute("filter");if(t===""||r&&!r.filter){return}}n.filter=Ut.test(s)?s.replace(Ut,i):s+" "+i}}}w(function(){if(!w.support.reliableMarginRight){w.cssHooks.marginRight={get:function(e,t){if(t){return w.swap(e,{display:"inline-block"},Rt,[e,"marginRight"])}}}}if(!w.support.pixelPosition&&w.fn.position){w.each(["top","left"],function(e,t){w.cssHooks[t]={get:function(e,n){if(n){n=Rt(e,t);return Jt.test(n)?w(e).position()[t]+"px":n}}}})}});if(w.expr&&w.expr.filters){w.expr.filters.hidden=function(e){return e.offsetWidth<=0&&e.offsetHeight<=0||!w.support.reliableHiddenOffsets&&(e.style&&e.style.display||w.css(e,"display"))==="none"};w.expr.filters.visible=function(e){return!w.expr.filters.hidden(e)}}w.each({margin:"",padding:"",border:"Width"},function(e,t){w.cssHooks[e+t]={expand:function(n){var r=0,i={},s=typeof n==="string"?n.split(" "):[n];for(;r<4;r++){i[e+Zt[r]+t]=s[r]||s[r-2]||s[0]}return i}};if(!Vt.test(e)){w.cssHooks[e+t].set=sn}});var ln=/%20/g,cn=/\[\]$/,hn=/\r?\n/g,pn=/^(?:submit|button|image|reset|file)$/i,dn=/^(?:input|select|textarea|keygen)/i;w.fn.extend({serialize:function(){return w.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=w.prop(this,"elements");return e?w.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!w(this).is(":disabled")&&dn.test(this.nodeName)&&!pn.test(e)&&(this.checked||!xt.test(e))}).map(function(e,t){var n=w(this).val();return n==null?null:w.isArray(n)?w.map(n,function(e){return{name:t.name,value:e.replace(hn,"\r\n")}}):{name:t.name,value:n.replace(hn,"\r\n")}}).get()}});w.param=function(e,n){var r,i=[],s=function(e,t){t=w.isFunction(t)?t():t==null?"":t;i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(t)};if(n===t){n=w.ajaxSettings&&w.ajaxSettings.traditional}if(w.isArray(e)||e.jquery&&!w.isPlainObject(e)){w.each(e,function(){s(this.name,this.value)})}else{for(r in e){vn(r,e[r],n,s)}}return i.join("&").replace(ln,"+")};w.each(("blur focus focusin focusout load resize scroll unload click dblclick "+"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave "+"change select submit keydown keypress keyup error contextmenu").split(" "),function(e,t){w.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}});w.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)},bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return arguments.length===1?this.off(e,"**"):this.off(t,e||"**",n)}});var mn,gn,yn=w.now(),bn=/\?/,wn=/#.*$/,En=/([?&])_=[^&]*/,Sn=/^(.*?):[ \t]*([^\r\n]*)\r?$/mg,xn=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Tn=/^(?:GET|HEAD)$/,Nn=/^\/\//,Cn=/^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,kn=w.fn.load,Ln={},An={},On="*/".concat("*");try{gn=s.href}catch(Mn){gn=o.createElement("a");gn.href="";gn=gn.href}mn=Cn.exec(gn.toLowerCase())||[];w.fn.load=function(e,n,r){if(typeof e!=="string"&&kn){return kn.apply(this,arguments)}var i,s,o,u=this,a=e.indexOf(" ");if(a>=0){i=e.slice(a,e.length);e=e.slice(0,a)}if(w.isFunction(n)){r=n;n=t}else if(n&&typeof n==="object"){o="POST"}if(u.length>0){w.ajax({url:e,type:o,dataType:"html",data:n}).done(function(e){s=arguments;u.html(i?w("<div>").append(w.parseHTML(e)).find(i):e)}).complete(r&&function(e,t){u.each(r,s||[e.responseText,t,e])})}return this};w.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){w.fn[t]=function(e){return this.on(t,e)}});w.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:gn,type:"GET",isLocal:xn.test(mn[1]),global:true,processData:true,async:true,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":On,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":true,"text json":w.parseJSON,"text xml":w.parseXML},flatOptions:{url:true,context:true}},ajaxSetup:function(e,t){return t?Pn(Pn(e,w.ajaxSettings),t):Pn(w.ajaxSettings,e)},ajaxPrefilter:_n(Ln),ajaxTransport:_n(An),ajax:function(e,n){function N(e,n,r,i){var l,g,y,E,S,T=n;if(b===2){return}b=2;if(u){clearTimeout(u)}f=t;o=i||"";x.readyState=e>0?4:0;l=e>=200&&e<300||e===304;if(r){E=Hn(c,x,r)}E=Bn(c,E,x,l);if(l){if(c.ifModified){S=x.getResponseHeader("Last-Modified");if(S){w.lastModified[s]=S}S=x.getResponseHeader("etag");if(S){w.etag[s]=S}}if(e===204||c.type==="HEAD"){T="nocontent"}else if(e===304){T="notmodified"}else{T=E.state;g=E.data;y=E.error;l=!y}}else{y=T;if(e||!T){T="error";if(e<0){e=0}}}x.status=e;x.statusText=(n||T)+"";if(l){d.resolveWith(h,[g,T,x])}else{d.rejectWith(h,[x,T,y])}x.statusCode(m);m=t;if(a){p.trigger(l?"ajaxSuccess":"ajaxError",[x,c,l?g:y])}v.fireWith(h,[x,T]);if(a){p.trigger("ajaxComplete",[x,c]);if(!--w.active){w.event.trigger("ajaxStop")}}}if(typeof e==="object"){n=e;e=t}n=n||{};var r,i,s,o,u,a,f,l,c=w.ajaxSetup({},n),h=c.context||c,p=c.context&&(h.nodeType||h.jquery)?w(h):w.event,d=w.Deferred(),v=w.Callbacks("once memory"),m=c.statusCode||{},g={},y={},b=0,E="canceled",x={readyState:0,getResponseHeader:function(e){var t;if(b===2){if(!l){l={};while(t=Sn.exec(o)){l[t[1].toLowerCase()]=t[2]}}t=l[e.toLowerCase()]}return t==null?null:t},getAllResponseHeaders:function(){return b===2?o:null},setRequestHeader:function(e,t){var n=e.toLowerCase();if(!b){e=y[n]=y[n]||e;g[e]=t}return this},overrideMimeType:function(e){if(!b){c.mimeType=e}return this},statusCode:function(e){var t;if(e){if(b<2){for(t in e){m[t]=[m[t],e[t]]}}else{x.always(e[x.status])}}return this},abort:function(e){var t=e||E;if(f){f.abort(t)}N(0,t);return this}};d.promise(x).complete=v.add;x.success=x.done;x.error=x.fail;c.url=((e||c.url||gn)+"").replace(wn,"").replace(Nn,mn[1]+"//");c.type=n.method||n.type||c.method||c.type;c.dataTypes=w.trim(c.dataType||"*").toLowerCase().match(S)||[""];if(c.crossDomain==null){r=Cn.exec(c.url.toLowerCase());c.crossDomain=!!(r&&(r[1]!==mn[1]||r[2]!==mn[2]||(r[3]||(r[1]==="http:"?"80":"443"))!==(mn[3]||(mn[1]==="http:"?"80":"443"))))}if(c.data&&c.processData&&typeof c.data!=="string"){c.data=w.param(c.data,c.traditional)}Dn(Ln,c,n,x);if(b===2){return x}a=c.global;if(a&&w.active++===0){w.event.trigger("ajaxStart")}c.type=c.type.toUpperCase();c.hasContent=!Tn.test(c.type);s=c.url;if(!c.hasContent){if(c.data){s=c.url+=(bn.test(s)?"&":"?")+c.data;delete c.data}if(c.cache===false){c.url=En.test(s)?s.replace(En,"$1_="+yn++):s+(bn.test(s)?"&":"?")+"_="+yn++}}if(c.ifModified){if(w.lastModified[s]){x.setRequestHeader("If-Modified-Since",w.lastModified[s])}if(w.etag[s]){x.setRequestHeader("If-None-Match",w.etag[s])}}if(c.data&&c.hasContent&&c.contentType!==false||n.contentType){x.setRequestHeader("Content-Type",c.contentType)}x.setRequestHeader("Accept",c.dataTypes[0]&&c.accepts[c.dataTypes[0]]?c.accepts[c.dataTypes[0]]+(c.dataTypes[0]!=="*"?", "+On+"; q=0.01":""):c.accepts["*"]);for(i in c.headers){x.setRequestHeader(i,c.headers[i])}if(c.beforeSend&&(c.beforeSend.call(h,x,c)===false||b===2)){return x.abort()}E="abort";for(i in{success:1,error:1,complete:1}){x[i](c[i])}f=Dn(An,c,n,x);if(!f){N(-1,"No Transport")}else{x.readyState=1;if(a){p.trigger("ajaxSend",[x,c])}if(c.async&&c.timeout>0){u=setTimeout(function(){x.abort("timeout")},c.timeout)}try{b=1;f.send(g,N)}catch(T){if(b<2){N(-1,T)}else{throw T}}}return x},getJSON:function(e,t,n){return w.get(e,t,n,"json")},getScript:function(e,n){return w.get(e,t,n,"script")}});w.each(["get","post"],function(e,n){w[n]=function(e,r,i,s){if(w.isFunction(r)){s=s||i;i=r;r=t}return w.ajax({url:e,type:n,dataType:s,data:r,success:i})}});w.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(e){w.globalEval(e);return e}}});w.ajaxPrefilter("script",function(e){if(e.cache===t){e.cache=false}if(e.crossDomain){e.type="GET";e.global=false}});w.ajaxTransport("script",function(e){if(e.crossDomain){var n,r=o.head||w("head")[0]||o.documentElement;return{send:function(t,i){n=o.createElement("script");n.async=true;if(e.scriptCharset){n.charset=e.scriptCharset}n.src=e.url;n.onload=n.onreadystatechange=function(e,t){if(t||!n.readyState||/loaded|complete/.test(n.readyState)){n.onload=n.onreadystatechange=null;if(n.parentNode){n.parentNode.removeChild(n)}n=null;if(!t){i(200,"success")}}};r.insertBefore(n,r.firstChild)},abort:function(){if(n){n.onload(t,true)}}}}});var jn=[],Fn=/(=)\?(?=&|$)|\?\?/;w.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=jn.pop()||w.expando+"_"+yn++;this[e]=true;return e}});w.ajaxPrefilter("json jsonp",function(n,r,i){var s,o,u,a=n.jsonp!==false&&(Fn.test(n.url)?"url":typeof n.data==="string"&&!(n.contentType||"").indexOf("application/x-www-form-urlencoded")&&Fn.test(n.data)&&"data");if(a||n.dataTypes[0]==="jsonp"){s=n.jsonpCallback=w.isFunction(n.jsonpCallback)?n.jsonpCallback():n.jsonpCallback;if(a){n[a]=n[a].replace(Fn,"$1"+s)}else if(n.jsonp!==false){n.url+=(bn.test(n.url)?"&":"?")+n.jsonp+"="+s}n.converters["script json"]=function(){if(!u){w.error(s+" was not called")}return u[0]};n.dataTypes[0]="json";o=e[s];e[s]=function(){u=arguments};i.always(function(){e[s]=o;if(n[s]){n.jsonpCallback=r.jsonpCallback;jn.push(s)}if(u&&w.isFunction(o)){o(u[0])}u=o=t});return"script"}});var In,qn,Rn=0,Un=e.ActiveXObject&&function(){var e;for(e in In){In[e](t,true)}};w.ajaxSettings.xhr=e.ActiveXObject?function(){return!this.isLocal&&zn()||Wn()}:zn;qn=w.ajaxSettings.xhr();w.support.cors=!!qn&&"withCredentials"in qn;qn=w.support.ajax=!!qn;if(qn){w.ajaxTransport(function(n){if(!n.crossDomain||w.support.cors){var r;return{send:function(i,s){var o,u,a=n.xhr();if(n.username){a.open(n.type,n.url,n.async,n.username,n.password)}else{a.open(n.type,n.url,n.async)}if(n.xhrFields){for(u in n.xhrFields){a[u]=n.xhrFields[u]}}if(n.mimeType&&a.overrideMimeType){a.overrideMimeType(n.mimeType)}if(!n.crossDomain&&!i["X-Requested-With"]){i["X-Requested-With"]="XMLHttpRequest"}try{for(u in i){a.setRequestHeader(u,i[u])}}catch(f){}a.send(n.hasContent&&n.data||null);r=function(e,i){var u,f,l,c;try{if(r&&(i||a.readyState===4)){r=t;if(o){a.onreadystatechange=w.noop;if(Un){delete In[o]}}if(i){if(a.readyState!==4){a.abort()}}else{c={};u=a.status;f=a.getAllResponseHeaders();if(typeof a.responseText==="string"){c.text=a.responseText}try{l=a.statusText}catch(h){l=""}if(!u&&n.isLocal&&!n.crossDomain){u=c.text?200:404}else if(u===1223){u=204}}}}catch(p){if(!i){s(-1,p)}}if(c){s(u,l,c,f)}};if(!n.async){r()}else if(a.readyState===4){setTimeout(r)}else{o=++Rn;if(Un){if(!In){In={};w(e).unload(Un)}In[o]=r}a.onreadystatechange=r}},abort:function(){if(r){r(t,true)}}}}})}var Xn,Vn,$n=/^(?:toggle|show|hide)$/,Jn=new RegExp("^(?:([+-])=|)("+E+")([a-z%]*)$","i"),Kn=/queueHooks$/,Qn=[nr],Gn={"*":[function(e,t){var n=this.createTween(e,t),r=n.cur(),i=Jn.exec(t),s=i&&i[3]||(w.cssNumber[e]?"":"px"),o=(w.cssNumber[e]||s!=="px"&&+r)&&Jn.exec(w.css(n.elem,e)),u=1,a=20;if(o&&o[3]!==s){s=s||o[3];i=i||[];o=+r||1;do{u=u||".5";o=o/u;w.style(n.elem,e,o+s)}while(u!==(u=n.cur()/r)&&u!==1&&--a)}if(i){o=n.start=+o||+r||0;n.unit=s;n.end=i[1]?o+(i[1]+1)*i[2]:+i[2]}return n}]};w.Animation=w.extend(er,{tweener:function(e,t){if(w.isFunction(e)){t=e;e=["*"]}else{e=e.split(" ")}var n,r=0,i=e.length;for(;r<i;r++){n=e[r];Gn[n]=Gn[n]||[];Gn[n].unshift(t)}},prefilter:function(e,t){if(t){Qn.unshift(e)}else{Qn.push(e)}}});w.Tween=rr;rr.prototype={constructor:rr,init:function(e,t,n,r,i,s){this.elem=e;this.prop=n;this.easing=i||"swing";this.options=t;this.start=this.now=this.cur();this.end=r;this.unit=s||(w.cssNumber[n]?"":"px")},cur:function(){var e=rr.propHooks[this.prop];return e&&e.get?e.get(this):rr.propHooks._default.get(this)},run:function(e){var t,n=rr.propHooks[this.prop];if(this.options.duration){this.pos=t=w.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration)}else{this.pos=t=e}this.now=(this.end-this.start)*t+this.start;if(this.options.step){this.options.step.call(this.elem,this.now,this)}if(n&&n.set){n.set(this)}else{rr.propHooks._default.set(this)}return this}};rr.prototype.init.prototype=rr.prototype;rr.propHooks={_default:{get:function(e){var t;if(e.elem[e.prop]!=null&&(!e.elem.style||e.elem.style[e.prop]==null)){return e.elem[e.prop]}t=w.css(e.elem,e.prop,"");return!t||t==="auto"?0:t},set:function(e){if(w.fx.step[e.prop]){w.fx.step[e.prop](e)}else if(e.elem.style&&(e.elem.style[w.cssProps[e.prop]]!=null||w.cssHooks[e.prop])){w.style(e.elem,e.prop,e.now+e.unit)}else{e.elem[e.prop]=e.now}}}};rr.propHooks.scrollTop=rr.propHooks.scrollLeft={set:function(e){if(e.elem.nodeType&&e.elem.parentNode){e.elem[e.prop]=e.now}}};w.each(["toggle","show","hide"],function(e,t){var n=w.fn[t];w.fn[t]=function(e,r,i){return e==null||typeof e==="boolean"?n.apply(this,arguments):this.animate(ir(t,true),e,r,i)}});w.fn.extend({fadeTo:function(e,t,n,r){return this.filter(nn).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=w.isEmptyObject(e),s=w.speed(t,n,r),o=function(){var t=er(this,w.extend({},e),s);if(i||w._data(this,"finish")){t.stop(true)}};o.finish=o;return i||s.queue===false?this.each(o):this.queue(s.queue,o)},stop:function(e,n,r){var i=function(e){var t=e.stop;delete e.stop;t(r)};if(typeof e!=="string"){r=n;n=e;e=t}if(n&&e!==false){this.queue(e||"fx",[])}return this.each(function(){var t=true,n=e!=null&&e+"queueHooks",s=w.timers,o=w._data(this);if(n){if(o[n]&&o[n].stop){i(o[n])}}else{for(n in o){if(o[n]&&o[n].stop&&Kn.test(n)){i(o[n])}}}for(n=s.length;n--;){if(s[n].elem===this&&(e==null||s[n].queue===e)){s[n].anim.stop(r);t=false;s.splice(n,1)}}if(t||!r){w.dequeue(this,e)}})},finish:function(e){if(e!==false){e=e||"fx"}return this.each(function(){var t,n=w._data(this),r=n[e+"queue"],i=n[e+"queueHooks"],s=w.timers,o=r?r.length:0;n.finish=true;w.queue(this,e,[]);if(i&&i.stop){i.stop.call(this,true)}for(t=s.length;t--;){if(s[t].elem===this&&s[t].queue===e){s[t].anim.stop(true);s.splice(t,1)}}for(t=0;t<o;t++){if(r[t]&&r[t].finish){r[t].finish.call(this)}}delete n.finish})}});w.each({slideDown:ir("show"),slideUp:ir("hide"),slideToggle:ir("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){w.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}});w.speed=function(e,t,n){var r=e&&typeof e==="object"?w.extend({},e):{complete:n||!n&&t||w.isFunction(e)&&e,duration:e,easing:n&&t||t&&!w.isFunction(t)&&t};r.duration=w.fx.off?0:typeof r.duration==="number"?r.duration:r.duration in w.fx.speeds?w.fx.speeds[r.duration]:w.fx.speeds._default;if(r.queue==null||r.queue===true){r.queue="fx"}r.old=r.complete;r.complete=function(){if(w.isFunction(r.old)){r.old.call(this)}if(r.queue){w.dequeue(this,r.queue)}};return r};w.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}};w.timers=[];w.fx=rr.prototype.init;w.fx.tick=function(){var e,n=w.timers,r=0;Xn=w.now();for(;r<n.length;r++){e=n[r];if(!e()&&n[r]===e){n.splice(r--,1)}}if(!n.length){w.fx.stop()}Xn=t};w.fx.timer=function(e){if(e()&&w.timers.push(e)){w.fx.start()}};w.fx.interval=13;w.fx.start=function(){if(!Vn){Vn=setInterval(w.fx.tick,w.fx.interval)}};w.fx.stop=function(){clearInterval(Vn);Vn=null};w.fx.speeds={slow:600,fast:200,_default:400};w.fx.step={};if(w.expr&&w.expr.filters){w.expr.filters.animated=function(e){return w.grep(w.timers,function(t){return e===t.elem}).length}}w.fn.offset=function(e){if(arguments.length){return e===t?this:this.each(function(t){w.offset.setOffset(this,e,t)})}var n,r,s={top:0,left:0},o=this[0],u=o&&o.ownerDocument;if(!u){return}n=u.documentElement;if(!w.contains(n,o)){return s}if(typeof o.getBoundingClientRect!==i){s=o.getBoundingClientRect()}r=sr(u);return{top:s.top+(r.pageYOffset||n.scrollTop)-(n.clientTop||0),left:s.left+(r.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}};w.offset={setOffset:function(e,t,n){var r=w.css(e,"position");if(r==="static"){e.style.position="relative"}var i=w(e),s=i.offset(),o=w.css(e,"top"),u=w.css(e,"left"),a=(r==="absolute"||r==="fixed")&&w.inArray("auto",[o,u])>-1,f={},l={},c,h;if(a){l=i.position();c=l.top;h=l.left}else{c=parseFloat(o)||0;h=parseFloat(u)||0}if(w.isFunction(t)){t=t.call(e,n,s)}if(t.top!=null){f.top=t.top-s.top+c}if(t.left!=null){f.left=t.left-s.left+h}if("using"in t){t.using.call(e,f)}else{i.css(f)}}};w.fn.extend({position:function(){if(!this[0]){return}var e,t,n={top:0,left:0},r=this[0];if(w.css(r,"position")==="fixed"){t=r.getBoundingClientRect()}else{e=this.offsetParent();t=this.offset();if(!w.nodeName(e[0],"html")){n=e.offset()}n.top+=w.css(e[0],"borderTopWidth",true);n.left+=w.css(e[0],"borderLeftWidth",true)}return{top:t.top-n.top-w.css(r,"marginTop",true),left:t.left-n.left-w.css(r,"marginLeft",true)}},offsetParent:function(){return this.map(function(){var e=this.offsetParent||u;while(e&&!w.nodeName(e,"html")&&w.css(e,"position")==="static"){e=e.offsetParent}return e||u})}});w.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,n){var r=/Y/.test(n);w.fn[e]=function(i){return w.access(this,function(e,i,s){var o=sr(e);if(s===t){return o?n in o?o[n]:o.document.documentElement[i]:e[i]}if(o){o.scrollTo(!r?s:w(o).scrollLeft(),r?s:w(o).scrollTop())}else{e[i]=s}},e,i,arguments.length,null)}});w.each({Height:"height",Width:"width"},function(e,n){w.each({padding:"inner"+e,content:n,"":"outer"+e},function(r,i){w.fn[i]=function(i,s){var o=arguments.length&&(r||typeof i!=="boolean"),u=r||(i===true||s===true?"margin":"border");return w.access(this,function(n,r,i){var s;if(w.isWindow(n)){return n.document.documentElement["client"+e]}if(n.nodeType===9){s=n.documentElement;return Math.max(n.body["scroll"+e],s["scroll"+e],n.body["offset"+e],s["offset"+e],s["client"+e])}return i===t?w.css(n,r,u):w.style(n,r,i,u)},n,o?i:t,o,null)}})});w.fn.size=function(){return this.length};w.fn.andSelf=w.fn.addBack;if(typeof module==="object"&&module&&typeof module.exports==="object"){module.exports=w}else{__webpack_provided_window_dot_jQuery=e.$=w;if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return w}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}}})(window);(function(e){e.cookie=function(t,n,r){if(arguments.length>1&&(!/Object/.test(Object.prototype.toString.call(n))||n===null||n===undefined)){r=e.extend({},r);if(n===null||n===undefined){r.expires=-1}if(typeof r.expires==="number"){var i=r.expires,s=r.expires=new Date;s.setDate(s.getDate()+i)}n=String(n);return document.cookie=[encodeURIComponent(t),"=",r.raw?n:encodeURIComponent(n),r.expires?"; expires="+r.expires.toUTCString():"",r.path?"; path="+r.path:"",r.domain?"; domain="+r.domain:"",r.secure?"; secure":""].join("")}r=n||{};var o=r.raw?function(e){return e}:decodeURIComponent;var u=document.cookie.split("; ");for(var a=0,f;f=u[a]&&u[a].split("=");a++){if(o(f[0])===t){return o(f[1]||"")}}return null}})(jQuery)
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(3), __webpack_require__(4)(module), __webpack_require__(3)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactBaseClasses = __webpack_require__(8);
	var ReactChildren = __webpack_require__(17);
	var ReactDOMFactories = __webpack_require__(25);
	var ReactElement = __webpack_require__(19);
	var ReactPropTypes = __webpack_require__(32);
	var ReactVersion = __webpack_require__(37);
	
	var createReactClass = __webpack_require__(38);
	var onlyChild = __webpack_require__(40);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (true) {
	  var lowPriorityWarning = __webpack_require__(16);
	  var canDefineProperty = __webpack_require__(13);
	  var ReactElementValidator = __webpack_require__(26);
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (true) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (true) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(7);
	
	var ReactNoopUpdateQueue = __webpack_require__(10);
	
	var canDefineProperty = __webpack_require__(13);
	var emptyObject = __webpack_require__(14);
	var invariant = __webpack_require__(15);
	var lowPriorityWarning = __webpack_require__(16);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  true ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (true) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (true) {
	    var constructor = publicInstance.constructor;
	     true ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (true) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (true) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (true) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (true) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (true) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(18);
	var ReactElement = __webpack_require__(19);
	
	var emptyFunction = __webpack_require__(12);
	var traverseAllChildren = __webpack_require__(22);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 18 */
[322, 9],
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var warning = __webpack_require__(11);
	var canDefineProperty = __webpack_require__(13);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(21);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (true) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (true) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       true ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       true ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (true) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (true) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (true) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var REACT_ELEMENT_TYPE = __webpack_require__(21);
	
	var getIteratorFn = __webpack_require__(23);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(24);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (true) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	           true ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (true) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  true ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(19);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (true) {
	  var ReactElementValidator = __webpack_require__(26);
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactComponentTreeHook = __webpack_require__(27);
	var ReactElement = __webpack_require__(19);
	
	var checkReactTypeSpec = __webpack_require__(28);
	
	var canDefineProperty = __webpack_require__(13);
	var getIteratorFn = __webpack_require__(23);
	var warning = __webpack_require__(11);
	var lowPriorityWarning = __webpack_require__(16);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getSourceInfoErrorAddendum(elementProps) {
	  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
	    var source = elementProps.__source;
	    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	    var lineNumber = source.lineNumber;
	    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	function getCurrentComponentErrorInfo(parentType) {
	  var info = getDeclarationErrorAddendum();
	
	  if (!info) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      info = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	  return info;
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
	  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
	  if (memoizer[currentComponentErrorInfo]) {
	    return;
	  }
	  memoizer[currentComponentErrorInfo] = true;
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwner = '';
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	   true ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     true ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    if (!validType) {
	      if (typeof type !== 'function' && typeof type !== 'string') {
	        var info = '';
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	
	        var sourceInfo = getSourceInfoErrorAddendum(props);
	        if (sourceInfo) {
	          info += sourceInfo;
	        } else {
	          info += getDeclarationErrorAddendum();
	        }
	
	        info += ReactComponentTreeHook.getCurrentStackAddendum();
	
	        var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
	        ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
	         true ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
	        ReactComponentTreeHook.popNonStandardWarningStack();
	      }
	    }
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (true) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	};
	
	module.exports = ReactElementValidator;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   true ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  true ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  true ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  true ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  true ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  true ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  true ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypeLocationNames = __webpack_require__(30);
	var ReactPropTypesSecret = __webpack_require__(31);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"development atom"}) && ("development atom") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(27);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  true ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       true ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (true) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = __webpack_require__(27);
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         true ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (true) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(19),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(33);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(34);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var assign = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(35);
	var checkPropTypes = __webpack_require__(36);
	
	var printWarning = function() {};
	
	if (true) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (true) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (("development atom") !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       true ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       true ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (true) {
	  var ReactPropTypesSecret = __webpack_require__(35);
	  var loggedTypeFailures = {};
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (true) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          )
	
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(8),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(19),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(10);
	var factory = __webpack_require__(39);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyObject = __webpack_require__(14);
	var _invariant = __webpack_require__(15);
	
	if (true) {
	  var warning = __webpack_require__(11);
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (true) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (true) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (true) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (true) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (true) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (true) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (true) {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (true) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (true) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (true) {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (true) {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (true) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (true) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (true) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (true) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (true) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactElement = __webpack_require__(19);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  true ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(42);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactDefaultInjection = __webpack_require__(47);
	var ReactMount = __webpack_require__(176);
	var ReactReconciler = __webpack_require__(68);
	var ReactUpdates = __webpack_require__(65);
	var ReactVersion = __webpack_require__(181);
	
	var findDOMNode = __webpack_require__(182);
	var getHostComponentFromComposite = __webpack_require__(183);
	var renderSubtreeIntoContainer = __webpack_require__(184);
	var warning = __webpack_require__(11);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (true) {
	  var ExecutionEnvironment = __webpack_require__(57);
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	     true ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	     true ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	         true ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (true) {
	  var ReactInstrumentation = __webpack_require__(71);
	  var ReactDOMUnknownPropertyHook = __webpack_require__(185);
	  var ReactDOMNullInputValuePropHook = __webpack_require__(186);
	  var ReactDOMInvalidARIAHook = __webpack_require__(187);
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentFlags = __webpack_require__(46);
	
	var invariant = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  true ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  true ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 44 */
9,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  true ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  true ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (true) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (true) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  true ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(48);
	var BeforeInputEventPlugin = __webpack_require__(49);
	var ChangeEventPlugin = __webpack_require__(64);
	var DefaultEventPluginOrder = __webpack_require__(82);
	var EnterLeaveEventPlugin = __webpack_require__(83);
	var HTMLDOMPropertyConfig = __webpack_require__(88);
	var ReactComponentBrowserEnvironment = __webpack_require__(89);
	var ReactDOMComponent = __webpack_require__(102);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactDOMEmptyComponent = __webpack_require__(147);
	var ReactDOMTreeTraversal = __webpack_require__(148);
	var ReactDOMTextComponent = __webpack_require__(149);
	var ReactDefaultBatchingStrategy = __webpack_require__(150);
	var ReactEventListener = __webpack_require__(151);
	var ReactInjection = __webpack_require__(154);
	var ReactReconcileTransaction = __webpack_require__(155);
	var SVGDOMPropertyConfig = __webpack_require__(163);
	var SelectEventPlugin = __webpack_require__(164);
	var SimpleEventPlugin = __webpack_require__(165);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(50);
	var ExecutionEnvironment = __webpack_require__(57);
	var FallbackCompositionState = __webpack_require__(58);
	var SyntheticCompositionEvent = __webpack_require__(61);
	var SyntheticInputEvent = __webpack_require__(63);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(51);
	var EventPluginUtils = __webpack_require__(53);
	
	var accumulateInto = __webpack_require__(55);
	var forEachAccumulated = __webpack_require__(56);
	var warning = __webpack_require__(11);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (true) {
	     true ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var EventPluginRegistry = __webpack_require__(52);
	var EventPluginUtils = __webpack_require__(53);
	var ReactErrorUtils = __webpack_require__(54);
	
	var accumulateInto = __webpack_require__(55);
	var forEachAccumulated = __webpack_require__(56);
	var invariant = __webpack_require__(15);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  true ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  true ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  true ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  true ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  true ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  true ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (true) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  true ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  true ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (true) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactErrorUtils = __webpack_require__(54);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (true) {
	       true ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (true) {
	       true ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (true) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	     true ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (true) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (true) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (true) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  true ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (true) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  true ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(59);
	
	var getTextContentAccessor = __webpack_require__(60);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 59 */
[322, 44],
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(59);
	
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(11);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (true) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (true) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (true) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (true) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (true) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	               true ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     true ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(51);
	var EventPropagators = __webpack_require__(50);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(65);
	var SyntheticEvent = __webpack_require__(62);
	
	var inputValueTracking = __webpack_require__(78);
	var getEventTarget = __webpack_require__(79);
	var isEventSupported = __webpack_require__(80);
	var isTextInputElement = __webpack_require__(81);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(66);
	var PooledClass = __webpack_require__(59);
	var ReactFeatureFlags = __webpack_require__(67);
	var ReactReconciler = __webpack_require__(68);
	var Transaction = __webpack_require__(77);
	
	var invariant = __webpack_require__(15);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  true ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  true ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  true ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  true ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  true ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  true ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(59);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  true ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(69);
	var ReactInstrumentation = __webpack_require__(71);
	
	var warning = __webpack_require__(11);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       true ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (true) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(70);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  true ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  true ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (true) {
	  var ReactDebugTool = __webpack_require__(72);
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactInvalidSetStateWarningHook = __webpack_require__(73);
	var ReactHostOperationHistoryHook = __webpack_require__(74);
	var ReactComponentTreeHook = __webpack_require__(27);
	var ExecutionEnvironment = __webpack_require__(57);
	
	var performanceNow = __webpack_require__(75);
	var warning = __webpack_require__(11);
	
	var hooks = [];
	var didHookThrowForEvent = {};
	
	function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
	  try {
	    fn.call(context, arg1, arg2, arg3, arg4, arg5);
	  } catch (e) {
	     true ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
	    didHookThrowForEvent[event] = true;
	  }
	}
	
	function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
	  for (var i = 0; i < hooks.length; i++) {
	    var hook = hooks[i];
	    var fn = hook[event];
	    if (fn) {
	      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
	    }
	  }
	}
	
	var isProfiling = false;
	var flushHistory = [];
	var lifeCycleTimerStack = [];
	var currentFlushNesting = 0;
	var currentFlushMeasurements = [];
	var currentFlushStartTime = 0;
	var currentTimerDebugID = null;
	var currentTimerStartTime = 0;
	var currentTimerNestedFlushDuration = 0;
	var currentTimerType = null;
	
	var lifeCycleTimerHasWarned = false;
	
	function clearHistory() {
	  ReactComponentTreeHook.purgeUnmountedComponents();
	  ReactHostOperationHistoryHook.clearHistory();
	}
	
	function getTreeSnapshot(registeredIDs) {
	  return registeredIDs.reduce(function (tree, id) {
	    var ownerID = ReactComponentTreeHook.getOwnerID(id);
	    var parentID = ReactComponentTreeHook.getParentID(id);
	    tree[id] = {
	      displayName: ReactComponentTreeHook.getDisplayName(id),
	      text: ReactComponentTreeHook.getText(id),
	      updateCount: ReactComponentTreeHook.getUpdateCount(id),
	      childIDs: ReactComponentTreeHook.getChildIDs(id),
	      // Text nodes don't have owners but this is close enough.
	      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
	      parentID: parentID
	    };
	    return tree;
	  }, {});
	}
	
	function resetMeasurements() {
	  var previousStartTime = currentFlushStartTime;
	  var previousMeasurements = currentFlushMeasurements;
	  var previousOperations = ReactHostOperationHistoryHook.getHistory();
	
	  if (currentFlushNesting === 0) {
	    currentFlushStartTime = 0;
	    currentFlushMeasurements = [];
	    clearHistory();
	    return;
	  }
	
	  if (previousMeasurements.length || previousOperations.length) {
	    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
	    flushHistory.push({
	      duration: performanceNow() - previousStartTime,
	      measurements: previousMeasurements || [],
	      operations: previousOperations || [],
	      treeSnapshot: getTreeSnapshot(registeredIDs)
	    });
	  }
	
	  clearHistory();
	  currentFlushStartTime = performanceNow();
	  currentFlushMeasurements = [];
	}
	
	function checkDebugID(debugID) {
	  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (allowRoot && debugID === 0) {
	    return;
	  }
	  if (!debugID) {
	     true ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
	  }
	}
	
	function beginLifeCycleTimer(debugID, timerType) {
	  if (currentFlushNesting === 0) {
	    return;
	  }
	  if (currentTimerType && !lifeCycleTimerHasWarned) {
	     true ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	    lifeCycleTimerHasWarned = true;
	  }
	  currentTimerStartTime = performanceNow();
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = debugID;
	  currentTimerType = timerType;
	}
	
	function endLifeCycleTimer(debugID, timerType) {
	  if (currentFlushNesting === 0) {
	    return;
	  }
	  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
	     true ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
	    lifeCycleTimerHasWarned = true;
	  }
	  if (isProfiling) {
	    currentFlushMeasurements.push({
	      timerType: timerType,
	      instanceID: debugID,
	      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
	    });
	  }
	  currentTimerStartTime = 0;
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = null;
	  currentTimerType = null;
	}
	
	function pauseCurrentLifeCycleTimer() {
	  var currentTimer = {
	    startTime: currentTimerStartTime,
	    nestedFlushStartTime: performanceNow(),
	    debugID: currentTimerDebugID,
	    timerType: currentTimerType
	  };
	  lifeCycleTimerStack.push(currentTimer);
	  currentTimerStartTime = 0;
	  currentTimerNestedFlushDuration = 0;
	  currentTimerDebugID = null;
	  currentTimerType = null;
	}
	
	function resumeCurrentLifeCycleTimer() {
	  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
	      startTime = _lifeCycleTimerStack$.startTime,
	      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
	      debugID = _lifeCycleTimerStack$.debugID,
	      timerType = _lifeCycleTimerStack$.timerType;
	
	  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
	  currentTimerStartTime = startTime;
	  currentTimerNestedFlushDuration += nestedFlushDuration;
	  currentTimerDebugID = debugID;
	  currentTimerType = timerType;
	}
	
	var lastMarkTimeStamp = 0;
	var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
	
	function shouldMark(debugID) {
	  if (!isProfiling || !canUsePerformanceMeasure) {
	    return false;
	  }
	  var element = ReactComponentTreeHook.getElement(debugID);
	  if (element == null || typeof element !== 'object') {
	    return false;
	  }
	  var isHostElement = typeof element.type === 'string';
	  if (isHostElement) {
	    return false;
	  }
	  return true;
	}
	
	function markBegin(debugID, markType) {
	  if (!shouldMark(debugID)) {
	    return;
	  }
	
	  var markName = debugID + '::' + markType;
	  lastMarkTimeStamp = performanceNow();
	  performance.mark(markName);
	}
	
	function markEnd(debugID, markType) {
	  if (!shouldMark(debugID)) {
	    return;
	  }
	
	  var markName = debugID + '::' + markType;
	  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';
	
	  // Chrome has an issue of dropping markers recorded too fast:
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
	  // To work around this, we will not report very small measurements.
	  // I determined the magic number by tweaking it back and forth.
	  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
	  // When the bug is fixed, we can `measure()` unconditionally if we want to.
	  var timeStamp = performanceNow();
	  if (timeStamp - lastMarkTimeStamp > 0.1) {
	    var measurementName = displayName + ' [' + markType + ']';
	    performance.measure(measurementName, markName);
	  }
	
	  performance.clearMarks(markName);
	  if (measurementName) {
	    performance.clearMeasures(measurementName);
	  }
	}
	
	var ReactDebugTool = {
	  addHook: function (hook) {
	    hooks.push(hook);
	  },
	  removeHook: function (hook) {
	    for (var i = 0; i < hooks.length; i++) {
	      if (hooks[i] === hook) {
	        hooks.splice(i, 1);
	        i--;
	      }
	    }
	  },
	  isProfiling: function () {
	    return isProfiling;
	  },
	  beginProfiling: function () {
	    if (isProfiling) {
	      return;
	    }
	
	    isProfiling = true;
	    flushHistory.length = 0;
	    resetMeasurements();
	    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
	  },
	  endProfiling: function () {
	    if (!isProfiling) {
	      return;
	    }
	
	    isProfiling = false;
	    resetMeasurements();
	    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
	  },
	  getFlushHistory: function () {
	    return flushHistory;
	  },
	  onBeginFlush: function () {
	    currentFlushNesting++;
	    resetMeasurements();
	    pauseCurrentLifeCycleTimer();
	    emitEvent('onBeginFlush');
	  },
	  onEndFlush: function () {
	    resetMeasurements();
	    currentFlushNesting--;
	    resumeCurrentLifeCycleTimer();
	    emitEvent('onEndFlush');
	  },
	  onBeginLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
	    markBegin(debugID, timerType);
	    beginLifeCycleTimer(debugID, timerType);
	  },
	  onEndLifeCycleTimer: function (debugID, timerType) {
	    checkDebugID(debugID);
	    endLifeCycleTimer(debugID, timerType);
	    markEnd(debugID, timerType);
	    emitEvent('onEndLifeCycleTimer', debugID, timerType);
	  },
	  onBeginProcessingChildContext: function () {
	    emitEvent('onBeginProcessingChildContext');
	  },
	  onEndProcessingChildContext: function () {
	    emitEvent('onEndProcessingChildContext');
	  },
	  onHostOperation: function (operation) {
	    checkDebugID(operation.instanceID);
	    emitEvent('onHostOperation', operation);
	  },
	  onSetState: function () {
	    emitEvent('onSetState');
	  },
	  onSetChildren: function (debugID, childDebugIDs) {
	    checkDebugID(debugID);
	    childDebugIDs.forEach(checkDebugID);
	    emitEvent('onSetChildren', debugID, childDebugIDs);
	  },
	  onBeforeMountComponent: function (debugID, element, parentDebugID) {
	    checkDebugID(debugID);
	    checkDebugID(parentDebugID, true);
	    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
	    markBegin(debugID, 'mount');
	  },
	  onMountComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'mount');
	    emitEvent('onMountComponent', debugID);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    checkDebugID(debugID);
	    emitEvent('onBeforeUpdateComponent', debugID, element);
	    markBegin(debugID, 'update');
	  },
	  onUpdateComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'update');
	    emitEvent('onUpdateComponent', debugID);
	  },
	  onBeforeUnmountComponent: function (debugID) {
	    checkDebugID(debugID);
	    emitEvent('onBeforeUnmountComponent', debugID);
	    markBegin(debugID, 'unmount');
	  },
	  onUnmountComponent: function (debugID) {
	    checkDebugID(debugID);
	    markEnd(debugID, 'unmount');
	    emitEvent('onUnmountComponent', debugID);
	  },
	  onTestEvent: function () {
	    emitEvent('onTestEvent');
	  }
	};
	
	// TODO remove these when RN/www gets updated
	ReactDebugTool.addDevtool = ReactDebugTool.addHook;
	ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;
	
	ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
	ReactDebugTool.addHook(ReactComponentTreeHook);
	var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	if (/[?&]react_perf\b/.test(url)) {
	  ReactDebugTool.beginProfiling();
	}
	
	module.exports = ReactDebugTool;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var warning = __webpack_require__(11);
	
	if (true) {
	  var processingChildContext = false;
	
	  var warnInvalidSetState = function () {
	     true ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
	  };
	}
	
	var ReactInvalidSetStateWarningHook = {
	  onBeginProcessingChildContext: function () {
	    processingChildContext = true;
	  },
	  onEndProcessingChildContext: function () {
	    processingChildContext = false;
	  },
	  onSetState: function () {
	    warnInvalidSetState();
	  }
	};
	
	module.exports = ReactInvalidSetStateWarningHook;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var history = [];
	
	var ReactHostOperationHistoryHook = {
	  onHostOperation: function (operation) {
	    history.push(operation);
	  },
	  clearHistory: function () {
	    if (ReactHostOperationHistoryHook._preventClearing) {
	      // Should only be used for tests.
	      return;
	    }
	
	    history = [];
	  },
	  getHistory: function () {
	    return history;
	  }
	};
	
	module.exports = ReactHostOperationHistoryHook;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var performance = __webpack_require__(76);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function performanceNow() {
	    return performance.now();
	  };
	} else {
	  performanceNow = function performanceNow() {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  true ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  true ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(43);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(43);
	var SyntheticMouseEvent = __webpack_require__(84);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(85);
	var ViewportMetrics = __webpack_require__(86);
	
	var getEventModifierState = __webpack_require__(87);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	var getEventTarget = __webpack_require__(79);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(90);
	var ReactDOMIDOperations = __webpack_require__(101);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(91);
	var Danger = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactInstrumentation = __webpack_require__(71);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(94);
	var setInnerHTML = __webpack_require__(93);
	var setTextContent = __webpack_require__(95);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (true) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (true) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (true) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (true) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (true) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (true) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (true) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (true) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(92);
	var setInnerHTML = __webpack_require__(93);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(94);
	var setTextContent = __webpack_require__(95);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	var DOMNamespaces = __webpack_require__(92);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(94);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	var escapeTextContentForBrowser = __webpack_require__(96);
	var setInnerHTML = __webpack_require__(93);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var DOMLazyTree = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(57);
	
	var createNodesFromMarkup = __webpack_require__(98);
	var emptyFunction = __webpack_require__(12);
	var invariant = __webpack_require__(15);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  true ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var createArrayFromMixed = __webpack_require__(99);
	var getMarkupWrap = __webpack_require__(100);
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  true ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  true ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  true ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  true ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  true ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  true ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  true ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(43);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(103);
	var CSSPropertyOperations = __webpack_require__(105);
	var DOMLazyTree = __webpack_require__(91);
	var DOMNamespaces = __webpack_require__(92);
	var DOMProperty = __webpack_require__(45);
	var DOMPropertyOperations = __webpack_require__(113);
	var EventPluginHub = __webpack_require__(51);
	var EventPluginRegistry = __webpack_require__(52);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactDOMComponentFlags = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactDOMInput = __webpack_require__(118);
	var ReactDOMOption = __webpack_require__(121);
	var ReactDOMSelect = __webpack_require__(122);
	var ReactDOMTextarea = __webpack_require__(123);
	var ReactInstrumentation = __webpack_require__(71);
	var ReactMultiChild = __webpack_require__(124);
	var ReactServerRenderingTransaction = __webpack_require__(143);
	
	var emptyFunction = __webpack_require__(12);
	var escapeTextContentForBrowser = __webpack_require__(96);
	var invariant = __webpack_require__(15);
	var isEventSupported = __webpack_require__(80);
	var shallowEqual = __webpack_require__(133);
	var inputValueTracking = __webpack_require__(78);
	var validateDOMNesting = __webpack_require__(146);
	var warning = __webpack_require__(11);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   true ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  true ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  true ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  true ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (true) {
	     true ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	     true ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	     true ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  true ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (true) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	     true ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (true) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  true ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  true ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  true ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (true) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (true) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (true) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (true) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (true) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (true) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (true) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (true) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (true) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (true) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  true ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (true) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(43);
	
	var focusNode = __webpack_require__(104);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(71);
	
	var camelizeStyleName = __webpack_require__(107);
	var dangerousStyleValue = __webpack_require__(109);
	var hyphenateStyleName = __webpack_require__(110);
	var memoizeStringOnly = __webpack_require__(112);
	var warning = __webpack_require__(11);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (true) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	     true ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	     true ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	     true ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	     true ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (true) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (true) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (true) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(108);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var warning = __webpack_require__(11);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (true) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	           true ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(111);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactInstrumentation = __webpack_require__(71);
	
	var quoteAttributeValueForBrowser = __webpack_require__(114);
	var warning = __webpack_require__(11);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   true ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (true) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (true) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (true) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (true) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(96);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(52);
	var ReactEventEmitterMixin = __webpack_require__(116);
	var ViewportMetrics = __webpack_require__(86);
	
	var getVendorPrefixedEventName = __webpack_require__(117);
	var isEventSupported = __webpack_require__(80);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(51);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var DOMPropertyOperations = __webpack_require__(113);
	var LinkedValueUtils = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (true) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	         true ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	         true ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	         true ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	         true ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (true) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	         true ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	         true ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  true ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactPropTypesSecret = __webpack_require__(120);
	var propTypesFactory = __webpack_require__(33);
	
	var React = __webpack_require__(6);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  true ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  true ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  true ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         true ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 120 */
31,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(6);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactDOMSelect = __webpack_require__(122);
	
	var warning = __webpack_require__(11);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       true ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (true) {
	       true ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(65);
	
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     true ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       true ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       true ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (true) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       true ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  true ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (true) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	         true ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	         true ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (true) {
	           true ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  true ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  true ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactComponentEnvironment = __webpack_require__(125);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(68);
	var ReactChildReconciler = __webpack_require__(127);
	
	var emptyFunction = __webpack_require__(12);
	var flattenChildren = __webpack_require__(142);
	var invariant = __webpack_require__(15);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (true) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (true) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (true) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (true) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (true) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  true ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  true ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (true) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  true ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(68);
	
	var instantiateReactComponent = __webpack_require__(128);
	var KeyEscapeUtils = __webpack_require__(138);
	var shouldUpdateReactComponent = __webpack_require__(134);
	var traverseAllChildren = __webpack_require__(139);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"development atom"}) && ("development atom") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(27);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (true) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = __webpack_require__(27);
	    }
	    if (!keyUnique) {
	       true ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (true) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(129);
	var ReactEmptyComponent = __webpack_require__(135);
	var ReactHostComponent = __webpack_require__(136);
	
	var getNextDebugID = __webpack_require__(137);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (true) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  true ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  true ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (true) {
	     true ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (true) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (true) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var React = __webpack_require__(6);
	var ReactComponentEnvironment = __webpack_require__(125);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactErrorUtils = __webpack_require__(54);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(71);
	var ReactNodeTypes = __webpack_require__(130);
	var ReactReconciler = __webpack_require__(68);
	
	if (true) {
	  var checkReactTypeSpec = __webpack_require__(131);
	}
	
	var emptyObject = __webpack_require__(14);
	var invariant = __webpack_require__(15);
	var shallowEqual = __webpack_require__(133);
	var shouldUpdateReactComponent = __webpack_require__(134);
	var warning = __webpack_require__(11);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (true) {
	     true ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	     true ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (true) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  true ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (true) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	         true ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	       true ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (true) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	       true ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	       true ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	       true ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	       true ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	       true ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	       true ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	       true ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  true ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (true) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (("development atom") !== 'production' && !doConstruct) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (true) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (true) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (true) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (true) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (true) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (true) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (true) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (true) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  true ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (true) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  true ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (true) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  true ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (true) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (true) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (true) {
	       true ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (true) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (true) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (true) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (true) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (true) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (true) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (true) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  true ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  true ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (true) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	       true ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var React = __webpack_require__(6);
	
	var invariant = __webpack_require__(15);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  true ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactPropTypeLocationNames = __webpack_require__(132);
	var ReactPropTypesSecret = __webpack_require__(120);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"development atom"}) && ("development atom") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(27);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  true ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       true ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (true) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = __webpack_require__(27);
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         true ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 132 */
30,
/* 133 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  true ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 138 */
24,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var REACT_ELEMENT_TYPE = __webpack_require__(140);
	
	var getIteratorFn = __webpack_require__(141);
	var invariant = __webpack_require__(15);
	var KeyEscapeUtils = __webpack_require__(138);
	var warning = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (true) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	           true ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (true) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  true ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 140 */
21,
/* 141 */
23,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(138);
	var traverseAllChildren = __webpack_require__(139);
	var warning = __webpack_require__(11);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"development atom"}) && ("development atom") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(27);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (true) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = __webpack_require__(27);
	      }
	      if (!keyUnique) {
	         true ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (true) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(59);
	var Transaction = __webpack_require__(77);
	var ReactInstrumentation = __webpack_require__(71);
	var ReactServerUpdateQueue = __webpack_require__(144);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (true) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(145);
	
	var warning = __webpack_require__(11);
	
	function warnNoop(publicInstance, callerName) {
	  if (true) {
	    var constructor = publicInstance.constructor;
	     true ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(71);
	var ReactUpdates = __webpack_require__(65);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (true) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	       true ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (true) {
	     true ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (true) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	         true ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (true) {
	      ReactInstrumentation.debugTool.onSetState();
	       true ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  true ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(11);
	
	var validateDOMNesting = emptyFunction;
	
	if (true) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	       true ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	         true ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	         true ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(43);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  true ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  true ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  true ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  true ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(90);
	var DOMLazyTree = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(43);
	
	var escapeTextContentForBrowser = __webpack_require__(96);
	var invariant = __webpack_require__(15);
	var validateDOMNesting = __webpack_require__(146);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (true) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  true ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(65);
	var Transaction = __webpack_require__(77);
	
	var emptyFunction = __webpack_require__(12);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(152);
	var ExecutionEnvironment = __webpack_require__(57);
	var PooledClass = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(65);
	
	var getEventTarget = __webpack_require__(79);
	var getUnboundedScrollPosition = __webpack_require__(153);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (true) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(51);
	var EventPluginUtils = __webpack_require__(53);
	var ReactComponentEnvironment = __webpack_require__(125);
	var ReactEmptyComponent = __webpack_require__(135);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactHostComponent = __webpack_require__(136);
	var ReactUpdates = __webpack_require__(65);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(66);
	var PooledClass = __webpack_require__(59);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactInputSelection = __webpack_require__(156);
	var ReactInstrumentation = __webpack_require__(71);
	var Transaction = __webpack_require__(77);
	var ReactUpdateQueue = __webpack_require__(145);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (true) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(157);
	
	var containsNode = __webpack_require__(159);
	var focusNode = __webpack_require__(104);
	var getActiveElement = __webpack_require__(162);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var getNodeForCharacterOffset = __webpack_require__(158);
	var getTextContentAccessor = __webpack_require__(60);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(160);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(161);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(50);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactInputSelection = __webpack_require__(156);
	var SyntheticEvent = __webpack_require__(62);
	
	var getActiveElement = __webpack_require__(162);
	var isTextInputElement = __webpack_require__(81);
	var shallowEqual = __webpack_require__(133);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var EventListener = __webpack_require__(152);
	var EventPropagators = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(43);
	var SyntheticAnimationEvent = __webpack_require__(166);
	var SyntheticClipboardEvent = __webpack_require__(167);
	var SyntheticEvent = __webpack_require__(62);
	var SyntheticFocusEvent = __webpack_require__(168);
	var SyntheticKeyboardEvent = __webpack_require__(169);
	var SyntheticMouseEvent = __webpack_require__(84);
	var SyntheticDragEvent = __webpack_require__(172);
	var SyntheticTouchEvent = __webpack_require__(173);
	var SyntheticTransitionEvent = __webpack_require__(174);
	var SyntheticUIEvent = __webpack_require__(85);
	var SyntheticWheelEvent = __webpack_require__(175);
	
	var emptyFunction = __webpack_require__(12);
	var getEventCharCode = __webpack_require__(170);
	var invariant = __webpack_require__(15);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  true ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(85);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(85);
	
	var getEventCharCode = __webpack_require__(170);
	var getEventKey = __webpack_require__(171);
	var getEventModifierState = __webpack_require__(87);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(170);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(84);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(85);
	
	var getEventModifierState = __webpack_require__(87);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(62);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(84);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var DOMLazyTree = __webpack_require__(91);
	var DOMProperty = __webpack_require__(45);
	var React = __webpack_require__(6);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactDOMContainerInfo = __webpack_require__(177);
	var ReactDOMFeatureFlags = __webpack_require__(178);
	var ReactFeatureFlags = __webpack_require__(67);
	var ReactInstanceMap = __webpack_require__(126);
	var ReactInstrumentation = __webpack_require__(71);
	var ReactMarkupChecksum = __webpack_require__(179);
	var ReactReconciler = __webpack_require__(68);
	var ReactUpdateQueue = __webpack_require__(145);
	var ReactUpdates = __webpack_require__(65);
	
	var emptyObject = __webpack_require__(14);
	var instantiateReactComponent = __webpack_require__(128);
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(93);
	var shouldUpdateReactComponent = __webpack_require__(134);
	var warning = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (true) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (true) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (true) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     true ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  true ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  true ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  true ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     true ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (true) {
	       true ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	             true ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     true ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  true ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (true) {
	       true ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (true) {
	         true ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  true ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (true) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  true ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (true) {
	           true ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  true ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (true) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(146);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (true) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(180);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 181 */
37,
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(44);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(43);
	var ReactInstanceMap = __webpack_require__(126);
	
	var getHostComponentFromComposite = __webpack_require__(183);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(11);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (true) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	       true ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  true ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  true ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(130);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(176);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginRegistry = __webpack_require__(52);
	var ReactComponentTreeHook = __webpack_require__(27);
	
	var warning = __webpack_require__(11);
	
	if (true) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true,
	
	    autoFocus: true,
	    defaultValue: true,
	    valueLink: true,
	    defaultChecked: true,
	    checkedLink: true,
	    innerHTML: true,
	    suppressContentEditableWarning: true,
	    onFocusIn: true,
	    onFocusOut: true
	  };
	  var warnedProperties = {};
	
	  var validateProperty = function (tagName, name, debugID) {
	    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
	      return true;
	    }
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return true;
	    }
	    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
	      return true;
	    }
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
	    if (standardName != null) {
	       true ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else if (registrationName != null) {
	       true ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      return true;
	    } else {
	      // We were unable to guess which prop the user intended.
	      // It is likely that the user was just blindly spreading/forwarding props
	      // Components should be careful to only render valid props/attributes.
	      // Warning will be invoked in warnUnknownProperties to allow grouping.
	      return false;
	    }
	  };
	}
	
	var warnUnknownProperties = function (debugID, element) {
	  var unknownProps = [];
	  for (var key in element.props) {
	    var isValid = validateProperty(element.type, key, debugID);
	    if (!isValid) {
	      unknownProps.push(key);
	    }
	  }
	
	  var unknownPropString = unknownProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (unknownProps.length === 1) {
	     true ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  } else if (unknownProps.length > 1) {
	     true ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  }
	};
	
	function handleElement(debugID, element) {
	  if (element == null || typeof element.type !== 'string') {
	    return;
	  }
	  if (element.type.indexOf('-') >= 0 || element.props.is) {
	    return;
	  }
	  warnUnknownProperties(debugID, element);
	}
	
	var ReactDOMUnknownPropertyHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMUnknownPropertyHook;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactComponentTreeHook = __webpack_require__(27);
	
	var warning = __webpack_require__(11);
	
	var didWarnValueNull = false;
	
	function handleElement(debugID, element) {
	  if (element == null) {
	    return;
	  }
	  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
	    return;
	  }
	  if (element.props != null && element.props.value === null && !didWarnValueNull) {
	     true ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
	    didWarnValueNull = true;
	  }
	}
	
	var ReactDOMNullInputValuePropHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    handleElement(debugID, element);
	  }
	};
	
	module.exports = ReactDOMNullInputValuePropHook;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactComponentTreeHook = __webpack_require__(27);
	
	var warning = __webpack_require__(11);
	
	var warnedProperties = {};
	var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	
	function validateProperty(tagName, name, debugID) {
	  if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	    return true;
	  }
	
	  if (rARIA.test(name)) {
	    var lowerCasedName = name.toLowerCase();
	    var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // If this is an aria-* attribute, but is not listed in the known DOM
	    // DOM properties, then it is an invalid aria-* attribute.
	    if (standardName == null) {
	      warnedProperties[name] = true;
	      return false;
	    }
	    // aria-* attributes should be lowercase; suggest the lowercase version.
	    if (name !== standardName) {
	       true ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	      warnedProperties[name] = true;
	      return true;
	    }
	  }
	
	  return true;
	}
	
	function warnInvalidARIAProps(debugID, element) {
	  var invalidProps = [];
	
	  for (var key in element.props) {
	    var isValid = validateProperty(element.type, key, debugID);
	    if (!isValid) {
	      invalidProps.push(key);
	    }
	  }
	
	  var unknownPropString = invalidProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (invalidProps.length === 1) {
	     true ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  } else if (invalidProps.length > 1) {
	     true ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	  }
	}
	
	function handleElement(debugID, element) {
	  if (element == null || typeof element.type !== 'string') {
	    return;
	  }
	  if (element.type.indexOf('-') >= 0 || element.props.is) {
	    return;
	  }
	
	  warnInvalidARIAProps(debugID, element);
	}
	
	var ReactDOMInvalidARIAHook = {
	  onBeforeMountComponent: function (debugID, element) {
	    if (true) {
	      handleElement(debugID, element);
	    }
	  },
	  onBeforeUpdateComponent: function (debugID, element) {
	    if (true) {
	      handleElement(debugID, element);
	    }
	  }
	};
	
	module.exports = ReactDOMInvalidARIAHook;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsBrand_play = __webpack_require__(189);
	
	var _componentsBrand_play2 = _interopRequireDefault(_componentsBrand_play);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'App',
	
	  render: function render() {
	    return _react2['default'].createElement(_componentsBrand_play2['default'], { descriptorJSON: window.bpInstance });
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, $) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	var _storesDescriptor_store = __webpack_require__(238);
	
	var _storesDescriptor_store2 = _interopRequireDefault(_storesDescriptor_store);
	
	var _componentsStandalone_player = __webpack_require__(248);
	
	var _componentsStandalone_player2 = _interopRequireDefault(_componentsStandalone_player);
	
	var _componentsBrand_playChapters = __webpack_require__(275);
	
	var _componentsBrand_playChapters2 = _interopRequireDefault(_componentsBrand_playChapters);
	
	var _componentsQnaQna_standalone_presenter = __webpack_require__(283);
	
	var _componentsQnaQna_standalone_presenter2 = _interopRequireDefault(_componentsQnaQna_standalone_presenter);
	
	__webpack_require__(297);
	/* conditionally load template based on className in <body>, use utility functions (isMobile etc.)
	 *require('templates_mv_isi');
	 * templates_mv_isi:  __dirname + '/assets/css/template_mv-isi.scss',
	 * templates_mv:      __dirname + '/assets/css/template_mv-no-isi.scss',
	 * templates_sv_isi:  __dirname + '/assets/css/template_sv-isi.scss',
	 * templates_sv:      __dirname + '/assets/css/template_sv-no-isi.scss'
	 */
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.BrandPlay',
	  propTypes: {
	    descriptorURL: _react.PropTypes.string,
	    descriptorJSON: _react.PropTypes.object
	  },
	  polling: true,
	  mixins: [_reflux2['default'].connect(_storesVideo_store2['default'])],
	  getInitialState: function getInitialState() {
	    return {
	      showMore: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    $('.episode-title').remove();
	    $('#notes, .magnify').on('click', function () {
	      _storesVideo_store2['default'].mediaApi.pause();
	    });
	    $(window).on('player:pause', function () {
	      _storesVideo_store2['default'].mediaApi.pause();
	    }).on('player:play', function () {
	      _storesVideo_store2['default'].mediaApi.play();
	    });
	    var selectedVideo = undefined,
	        selectedVideoCSS = undefined,
	        chapterMenu = $('.chapter-link-in-menu');
	
	    $('[data-video]').on('click', function () {
	      selectedVideo = $(this).data('video') - 1;
	      selectedVideoCSS = '#chapter-' + $(this).data('video');
	      _actionsVideo_actions2['default'].selectVideo(_storesDescriptor_store2['default'].state.videos[selectedVideo], selectedVideo);
	      $('.chapter-link-in-menu').removeClass('now_playing_color');
	      $(selectedVideoCSS).addClass('now_playing_color');
	    });
	
	    $(window).on('hashchange', function () {
	      try {
	        var index = 0,
	            video = Number(window.location.hash.substr(1)),
	            _selectedVideoCSS = "#chapter-" + video;
	        if (video) {
	          if (video < 1 && video > bpInstance.videos.length) {} else {
	            index = video - 1;
	          }
	        }
	        _actionsVideo_actions2['default'].selectVideo(_storesDescriptor_store2['default'].state.videos[index], index);
	        _storesVideo_store2['default'].mediaApi.play();
	        if (chapterMenu.length > 0) {
	          chapterMenu.removeClass('now_playing_color');
	          $(_selectedVideoCSS).addClass('now_playing_color');
	        }
	      } catch (err) {
	        console.log(err.message);
	      }
	    });
	    //setTimeout(() => { addLinkTrackVars('contextData.wb.spcrtid'); }, 1000);
	  },
	  interstitial: function interstitial(videoIndex) {
	    var videos = _storesDescriptor_store2['default'].state.videos,
	        isAuto = _import2['default'].get(this.state.descriptor, 'defaultVideoOptions.shouldAutoplay');
	    if (isAuto && videos[next]) {
	      _actionsVideo_actions2['default'].selectVideo(videos[next], next);
	    }
	  },
	  showMore: function showMore() {
	    this.setState({
	      showMore: true
	    });
	  },
	  replayVideo: function replayVideo() {
	    $('.video-player-standalone').show();
	    _storesVideo_store2['default'].mediaApi.replay();
	  },
	  nextVideo: function nextVideo(videoIndex) {
	    var videos = _storesDescriptor_store2['default'].state.videos;
	    var next = _storesVideo_store2['default'].getIndex() + 1;
	
	    $('.video-player-standalone').show();
	
	    if (next < videos.length) {
	      _actionsVideo_actions2['default'].selectVideo(videos[next], next);
	    } else {
	      _actionsVideo_actions2['default'].selectVideo(videos[0], 0);
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (typeof this.state.video != 'undefined') {
	      if (typeof this.state.video.isEnded != 'undefined') {
	        if (this.state.video.isEnded && $('.qna-radio-form').length === 0) {
	          this.polling = true;
	        } else {
	          if (this.state.video.index !== nextState.video.index) {
	            this.polling = true;
	          } else {
	            this.polling = false;
	          }
	        }
	      }
	    }
	  },
	  render: function render() {
	    var title = undefined,
	        headerURL = undefined,
	        isiLinks = undefined,
	        chapters = undefined,
	        videoIndex = undefined,
	        viewed = undefined,
	        page = undefined,
	        ended = undefined,
	        qnaFlg = undefined;
	    var hasMobileStyle = (0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)();
	    var useMobileMenu = (0, _utilsUtil.isMobile)() ? bpInstance.mobileMenu ? true : false : false;
	    if (useMobileMenu) $('body').addClass('has-mobile-menu');
	    if ((0, _import.get)(this, 'state.video.meta', false)) {
	      headerURL = _storesDescriptor_store2['default'].state.headerURL;
	      isiLinks = _storesDescriptor_store2['default'].state.isiLinks;
	      chapters = _storesDescriptor_store2['default'].state.videos;
	      title = this.state.video.meta.title;
	      videoIndex = this.state.video.index;
	      viewed = this.state.video.viewed;
	      page = this.props.descriptorJSON.videos[videoIndex].page;
	      ended = this.state.video.isEnded;
	      qnaFlg = this.props.descriptorJSON.videos[videoIndex].qna;
	    }
	    var showMore = null;
	    if (hasMobileStyle && !this.state.showMore) {
	      showMore = _react2['default'].createElement(
	        'div',
	        { onClick: this.showMore, className: 'show-more' },
	        'SHOW MORE',
	        _react2['default'].createElement('div', { className: 'show-more-border' })
	      );
	    }
	    var qid = this.props.descriptorJSON.qid;
	    if (!($(".cme-chart").length > 0) && this.polling) {
	      this.component = _react2['default'].createElement(new _componentsQnaQna_standalone_presenter2['default'](qid, page), { qid: qid, page: page });
	    }
	    var qnaElement = undefined;
	    if (!_storesVideo_store2['default'].state.isPlaying && ended && qnaFlg) {
	      qnaElement = _react2['default'].createElement(
	        'div',
	        { className: 'qna-container' },
	        this.component,
	        _react2['default'].createElement(
	          'div',
	          { className: 'video-qna' },
	          _react2['default'].createElement(
	            'button',
	            { className: 'qna-button replay-video', onClick: this.replayVideo },
	            'Replay Video'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { className: 'qna-button next-video', onClick: this.nextVideo },
	            'Next Video'
	          )
	        )
	      );
	    } else {
	      qnaElement = '';
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'brand-play' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'brand-play-player' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'brand-play-poll-wrapper' },
	          _react2['default'].createElement(_componentsStandalone_player2['default'], {
	            id: 'brand-player',
	            onVideoEnd: this.interstitial,
	            videoIndex: videoIndex,
	            descriptorURL: this.props.descriptorURL,
	            descriptorJSON: this.props.descriptorJSON
	          }),
	          qnaElement
	        ),
	        _react2['default'].createElement(_componentsBrand_playChapters2['default'], {
	          chapters: chapters,
	          index: parseInt(videoIndex, 10),
	          headerURL: headerURL,
	          title: title,
	          isiLinks: isiLinks,
	          hasMobileStyle: hasMobileStyle,
	          showMore: this.state.showMore,
	          viewed: viewed,
	          useMobileMenu: useMobileMenu
	        }),
	        showMore
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "brand_play.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), __webpack_require__(3)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(191);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var makePatchReactClass = __webpack_require__(192);
	
	/**
	 * Returns a function that, when invoked, patches a React class with a new
	 * version of itself. To patch different classes, pass different IDs.
	 */
	module.exports = function makeMakeHot(getRootInstances, React) {
	  if (typeof getRootInstances !== 'function') {
	    throw new Error('Expected getRootInstances to be a function.');
	  }
	
	  var patchers = {};
	
	  return function makeHot(NextClass, persistentId) {
	    persistentId = persistentId || NextClass.displayName || NextClass.name;
	
	    if (!persistentId) {
	      console.error(
	        'Hot reload is disabled for one of your types. To enable it, pass a ' +
	        'string uniquely identifying this class within this current module ' +
	        'as a second parameter to makeHot.'
	      );
	      return NextClass;
	    }
	
	    if (!patchers[persistentId]) {
	      patchers[persistentId] = makePatchReactClass(getRootInstances, React);
	    }
	
	    var patchReactClass = patchers[persistentId];
	    return patchReactClass(NextClass);
	  };
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var makeAssimilatePrototype = __webpack_require__(193),
	    requestForceUpdateAll = __webpack_require__(194);
	
	function hasNonStubTypeProperty(ReactClass) {
	  if (!ReactClass.hasOwnProperty('type')) {
	    return false;
	  }
	
	  var descriptor = Object.getOwnPropertyDescriptor(ReactClass, 'type');
	  if (typeof descriptor.get === 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	function getPrototype(ReactClass) {
	  var prototype = ReactClass.prototype,
	      seemsLegit = prototype && typeof prototype.render === 'function';
	
	  if (!seemsLegit && hasNonStubTypeProperty(ReactClass)) {
	    prototype = ReactClass.type.prototype;
	  }
	
	  return prototype;
	}
	
	/**
	 * Returns a function that will patch React class with new versions of itself
	 * on subsequent invocations. Both legacy and ES6 style classes are supported.
	 */
	module.exports = function makePatchReactClass(getRootInstances, React) {
	  var assimilatePrototype = makeAssimilatePrototype(),
	      FirstClass = null;
	
	  return function patchReactClass(NextClass) {
	    var nextPrototype = getPrototype(NextClass);
	    assimilatePrototype(nextPrototype);
	
	    if (FirstClass) {
	      requestForceUpdateAll(getRootInstances, React);
	    }
	
	    return FirstClass || (FirstClass = NextClass);
	  };
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Returns a function that establishes the first prototype passed to it
	 * as the "source of truth" and patches its methods on subsequent invocations,
	 * also patching current and previous prototypes to forward calls to it.
	 */
	module.exports = function makeAssimilatePrototype() {
	  var storedPrototype,
	      knownPrototypes = [];
	
	  function wrapMethod(key) {
	    return function () {
	      if (storedPrototype[key]) {
	        return storedPrototype[key].apply(this, arguments);
	      }
	    };
	  }
	
	  function patchProperty(proto, key) {
	    proto[key] = storedPrototype[key];
	
	    if (typeof proto[key] !== 'function' ||
	      key === 'type' ||
	      key === 'constructor') {
	      return;
	    }
	
	    proto[key] = wrapMethod(key);
	
	    if (storedPrototype[key].isReactClassApproved) {
	      proto[key].isReactClassApproved = storedPrototype[key].isReactClassApproved;
	    }
	
	    if (proto.__reactAutoBindMap && proto.__reactAutoBindMap[key]) {
	      proto.__reactAutoBindMap[key] = proto[key];
	    }
	  }
	
	  function updateStoredPrototype(freshPrototype) {
	    storedPrototype = {};
	
	    Object.getOwnPropertyNames(freshPrototype).forEach(function (key) {
	      storedPrototype[key] = freshPrototype[key];
	    });
	  }
	
	  function reconcileWithStoredPrototypes(freshPrototype) {
	    knownPrototypes.push(freshPrototype);
	    knownPrototypes.forEach(function (proto) {
	      Object.getOwnPropertyNames(storedPrototype).forEach(function (key) {
	        patchProperty(proto, key);
	      });
	    });
	  }
	
	  return function assimilatePrototype(freshPrototype) {
	    if (Object.prototype.hasOwnProperty.call(freshPrototype, '__isAssimilatedByReactHotAPI')) {
	      return;
	    }
	
	    updateStoredPrototype(freshPrototype);
	    reconcileWithStoredPrototypes(freshPrototype);
	    freshPrototype.__isAssimilatedByReactHotAPI = true;
	  };
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var deepForceUpdate = __webpack_require__(195);
	
	var isRequestPending = false;
	
	module.exports = function requestForceUpdateAll(getRootInstances, React) {
	  if (isRequestPending) {
	    return;
	  }
	
	  /**
	   * Forces deep re-render of all mounted React components.
	   * Hats off to Omar Skalli (@Chetane) for suggesting this approach:
	   * https://gist.github.com/Chetane/9a230a9fdcdca21a4e29
	   */
	  function forceUpdateAll() {
	    isRequestPending = false;
	
	    var rootInstances = getRootInstances(),
	        rootInstance;
	
	    for (var key in rootInstances) {
	      if (rootInstances.hasOwnProperty(key)) {
	        rootInstance = rootInstances[key];
	
	        // `|| rootInstance` for React 0.12 and earlier
	        rootInstance = rootInstance._reactInternalInstance || rootInstance;
	        deepForceUpdate(rootInstance, React);
	      }
	    }
	  }
	
	  setTimeout(forceUpdateAll);
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bindAutoBindMethods = __webpack_require__(196);
	var traverseRenderedChildren = __webpack_require__(197);
	
	function setPendingForceUpdate(internalInstance) {
	  if (internalInstance._pendingForceUpdate === false) {
	    internalInstance._pendingForceUpdate = true;
	  }
	}
	
	function forceUpdateIfPending(internalInstance, React) {
	  if (internalInstance._pendingForceUpdate === true) {
	    // `|| internalInstance` for React 0.12 and earlier
	    var instance = internalInstance._instance || internalInstance;
	
	    if (instance.forceUpdate) {
	      instance.forceUpdate();
	    } else if (React && React.Component) {
	      React.Component.prototype.forceUpdate.call(instance);
	    }
	  }
	}
	
	/**
	 * Updates a React component recursively, so even if children define funky
	 * `shouldComponentUpdate`, they are forced to re-render.
	 * Makes sure that any newly added methods are properly auto-bound.
	 */
	function deepForceUpdate(internalInstance, React) {
	  traverseRenderedChildren(internalInstance, bindAutoBindMethods);
	  traverseRenderedChildren(internalInstance, setPendingForceUpdate);
	  traverseRenderedChildren(internalInstance, forceUpdateIfPending, React);
	}
	
	module.exports = deepForceUpdate;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	
	  boundMethod.__reactBoundContext = component;
	  boundMethod.__reactBoundMethod = method;
	  boundMethod.__reactBoundArguments = null;
	
	  var componentName = component.constructor.displayName,
	      _bind = boundMethod.bind;
	
	  boundMethod.bind = function (newThis) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    if (newThis !== component && newThis !== null) {
	      console.warn(
	        'bind(): React component methods may only be bound to the ' +
	        'component instance. See ' + componentName
	      );
	    } else if (!args.length) {
	      console.warn(
	        'bind(): You are binding a component method to the component. ' +
	        'React does this for you automatically in a high-performance ' +
	        'way, so you can safely remove this call. See ' + componentName
	      );
	      return boundMethod;
	    }
	
	    var reboundMethod = _bind.apply(boundMethod, arguments);
	    reboundMethod.__reactBoundContext = component;
	    reboundMethod.__reactBoundMethod = method;
	    reboundMethod.__reactBoundArguments = args;
	
	    return reboundMethod;
	  };
	
	  return boundMethod;
	}
	
	/**
	 * Performs auto-binding similar to how React does it.
	 * Skips already auto-bound methods.
	 * Based on https://github.com/facebook/react/blob/b264372e2b3ad0b0c0c0cc95a2f383e4a1325c3d/src/classic/class/ReactClass.js#L639-L705
	 */
	module.exports = function bindAutoBindMethods(internalInstance) {
	  var component = typeof internalInstance.getPublicInstance === 'function' ?
	    internalInstance.getPublicInstance() :
	    internalInstance;
	
	  if (!component) {
	    // React 0.14 stateless component has no instance
	    return;
	  }
	
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (!component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      continue;
	    }
	
	    // Skip already bound methods
	    if (component.hasOwnProperty(autoBindKey) &&
	        component[autoBindKey].__reactBoundContext === component) {
	      continue;
	    }
	
	    var method = component.__reactAutoBindMap[autoBindKey];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	function traverseRenderedChildren(internalInstance, callback, argument) {
	  callback(internalInstance, argument);
	
	  if (internalInstance._renderedComponent) {
	    traverseRenderedChildren(
	      internalInstance._renderedComponent,
	      callback,
	      argument
	    );
	  } else {
	    for (var key in internalInstance._renderedChildren) {
	      traverseRenderedChildren(
	        internalInstance._renderedChildren[key],
	        callback,
	        argument
	      );
	    }
	  }
	}
	
	module.exports = traverseRenderedChildren;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getRootInstancesFromReactMount = __webpack_require__(199);
	
	var injectedProvider = null,
	    didWarn = false;
	
	function warnOnce() {
	  if (!didWarn) {
	    console.warn(
	      'It appears that React Hot Loader isn\'t configured correctly. ' +
	      'If you\'re using NPM, make sure your dependencies don\'t drag duplicate React distributions into their node_modules and that require("react") corresponds to the React instance you render your app with.',
	      'If you\'re using a precompiled version of React, see https://github.com/gaearon/react-hot-loader/tree/master/docs#usage-with-external-react for integration instructions.'
	    );
	  }
	
	  didWarn = true;
	}
	
	var RootInstanceProvider = {
	  injection: {
	    injectProvider: function (provider) {
	      injectedProvider = provider;
	    }
	  },
	
	  getRootInstances: function (ReactMount) {
	    if (injectedProvider) {
	      return injectedProvider.getRootInstances();
	    }
	
	    var instances = ReactMount && getRootInstancesFromReactMount(ReactMount) || [];
	    if (!Object.keys(instances).length) {
	      warnOnce();
	    }
	
	    return instances;
	  }
	};
	
	module.exports = RootInstanceProvider;

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	function getRootInstancesFromReactMount(ReactMount) {
	  return ReactMount._instancesByReactRootID || ReactMount._instancesByContainerID || [];
	}
	
	module.exports = getRootInstancesFromReactMount;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.9.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash compat -o ./lodash.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.9.0';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_DROP_WHILE_FLAG = 0,
	      LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [special characters](http://www.regular-expressions.info/characters.html#special).
	   * In addition to special characters the forward slash is escaped to allow for
	   * easier `eval` use and `Function` compilation.
	   */
	  var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to detect and test for whitespace. */
	  var whitespace = (
	    // Basic whitespace characters.
	    ' \t\x0b\f\xa0\ufeff' +
	
	    // Line terminators.
	    '\n\r\u2028\u2029' +
	
	    // Unicode category "Zs" space separators.
	    '\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000'
	  );
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'document',
	    'isFinite', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    'window'
	  ];
	
	  /** Used to fix the JScript `[[DontEnum]]` bug. */
	  var shadowProps = [
	    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	    'toLocaleString', 'toString', 'valueOf'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used as an internal `_.debounce` options object by `_.throttle`. */
	  var debounceOptions = {
	    'leading': false,
	    'maxWait': 0,
	    'trailing': false
	  };
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    if (typeof value == 'string') {
	      return value;
	    }
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare to `other`.
	   * @param {Object} other The object to compare to `object`.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of each element
	   * in a collection and stable sort them in the following order:
	   *
	   * If `orders` is unspecified, sort in ascending order for all properties.
	   * Otherwise, for each property, sort in ascending order if its corresponding value in
	   * orders is true, and descending order if false.
	   *
	   * @private
	   * @param {Object} object The object to compare to `other`.
	   * @param {Object} other The object to compare to `object`.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        return result * (orders[index] ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled
	   * string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  var isHostObject = (function() {
	    try {
	      Object({ 'toString': 0 } + '');
	    } catch(e) {
	      return function() { return false; };
	    }
	    return function(value) {
	      // IE < 9 presents many host objects as `Object` objects that can coerce
	      // to strings despite having improperly defined `toString` methods.
	      return typeof value.toString != 'function' && typeof (value + '') == 'string';
	    };
	  }());
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        errorProto = Error.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to detect DOM support. */
	    var document = (document = context.window) ? document.document : null;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = context._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      escapeRegExp(fnToString.call(hasOwnProperty))
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = getNative(context, 'ArrayBuffer'),
	        bufferSlice = getNative(ArrayBuffer && new ArrayBuffer(0), 'slice'),
	        ceil = Math.ceil,
	        clearTimeout = context.clearTimeout,
	        floor = Math.floor,
	        getPrototypeOf = getNative(Object, 'getPrototypeOf'),
	        push = arrayProto.push,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = getNative(context, 'Uint8Array'),
	        WeakMap = getNative(context, 'WeakMap');
	
	    /** Used to clone array buffers. */
	    var Float64Array = (function() {
	      // Safari 5 errors when using an array buffer to initialize a typed array
	      // where the array buffer's `byteLength` is not a multiple of the typed
	      // array's `BYTES_PER_ELEMENT`.
	      try {
	        var func = getNative(context, 'Float64Array'),
	            result = new func(new ArrayBuffer(10), 0, 1) && func;
	      } catch(e) {}
	      return result || null;
	    }());
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCreate = getNative(Object, 'create'),
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeNumIsFinite = getNative(Number, 'isFinite'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /** Used as the size, in bytes, of each `Float64Array` element. */
	    var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;
	
	    /**
	     * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to lookup a type array constructors by `toStringTag`. */
	    var ctorByTag = {};
	    ctorByTag[float32Tag] = context.Float32Array;
	    ctorByTag[float64Tag] = context.Float64Array;
	    ctorByTag[int8Tag] = context.Int8Array;
	    ctorByTag[int16Tag] = context.Int16Array;
	    ctorByTag[int32Tag] = context.Int32Array;
	    ctorByTag[uint8Tag] = context.Uint8Array;
	    ctorByTag[uint8ClampedTag] = context.Uint8ClampedArray;
	    ctorByTag[uint16Tag] = context.Uint16Array;
	    ctorByTag[uint32Tag] = context.Uint32Array;
	
	    /** Used to avoid iterating over non-enumerable properties in IE < 9. */
	    var nonEnumProps = {};
	    nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
	    nonEnumProps[boolTag] = nonEnumProps[stringTag] = { 'constructor': true, 'toString': true, 'valueOf': true };
	    nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = { 'constructor': true, 'toString': true };
	    nonEnumProps[objectTag] = { 'constructor': true };
	
	    arrayEach(shadowProps, function(key) {
	      for (var tag in nonEnumProps) {
	        if (hasOwnProperty.call(nonEnumProps, tag)) {
	          var props = nonEnumProps[tag];
	          props[key] = hasOwnProperty.call(props, key);
	        }
	      }
	    });
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that return a boolean or single value will
	     * automatically end the chain returning the unwrapped value. Explicit chaining
	     * may be enabled using `_.chain`. The execution of chained methods is lazy,
	     * that is, execution is deferred until `_#value` is implicitly or explicitly
	     * called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization that merges iteratees to avoid creating intermediate
	     * arrays and reduce the number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defer`, `delay`,
	     * `difference`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `fill`,
	     * `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`, `forEach`,
	     * `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `functions`,
	     * `groupBy`, `indexBy`, `initial`, `intersection`, `invert`, `invoke`, `keys`,
	     * `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `method`, `methodOf`, `mixin`, `negate`, `omit`, `once`,
	     * `pairs`, `partial`, `partialRight`, `partition`, `pick`, `plant`, `pluck`,
	     * `property`, `propertyOf`, `pull`, `pullAt`, `push`, `range`, `rearg`,
	     * `reject`, `remove`, `rest`, `restParam`, `reverse`, `set`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `sortByAll`, `sortByOrder`, `splice`, `spread`,
	     * `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`, `throttle`,
	     * `thru`, `times`, `toArray`, `toPlainObject`, `transform`, `union`, `uniq`,
	     * `unshift`, `unzip`, `unzipWith`, `values`, `valuesIn`, `where`, `without`,
	     * `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `clone`, `cloneDeep`, `deburr`,
	     * `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
	     * `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`, `get`,
	     * `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`, `inRange`, `isArguments`,
	     * `isArray`, `isBoolean`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isError`,
	     * `isFinite` `isFunction`, `isMatch`, `isNative`, `isNaN`, `isNull`, `isNumber`,
	     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`,
	     * `isTypedArray`, `join`, `kebabCase`, `last`, `lastIndexOf`, `lt`, `lte`,
	     * `max`, `min`, `noConflict`, `noop`, `now`, `pad`, `padLeft`, `padRight`,
	     * `parseInt`, `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`,
	     * `runInContext`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
	     * `sortedLastIndex`, `startCase`, `startsWith`, `sum`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    (function(x) {
	      var Ctor = function() { this.x = x; },
	          object = { '0': x, 'length': x },
	          props = [];
	
	      Ctor.prototype = { 'valueOf': x, 'y': x };
	      for (var key in new Ctor) { props.push(key); }
	
	      /**
	       * Detect if the `toStringTag` of `arguments` objects is resolvable
	       * (all but Firefox < 4, IE < 9).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.argsTag = objToString.call(arguments) == argsTag;
	
	      /**
	       * Detect if `name` or `message` properties of `Error.prototype` are
	       * enumerable by default (IE < 9, Safari < 5.1).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') ||
	        propertyIsEnumerable.call(errorProto, 'name');
	
	      /**
	       * Detect if `prototype` properties are enumerable by default.
	       *
	       * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	       * (if the prototype or a property on the prototype has been set)
	       * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
	       * property to `true`.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
	
	      /**
	       * Detect if the `toStringTag` of DOM nodes is resolvable (all but IE < 9).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.nodeTag = objToString.call(document) != objectTag;
	
	      /**
	       * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
	       *
	       * In IE < 9 an object's own properties, shadowing non-enumerable ones,
	       * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.nonEnumShadows = !/valueOf/.test(props);
	
	      /**
	       * Detect if own properties are iterated after inherited properties (IE < 9).
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.ownLast = props[0] != 'x';
	
	      /**
	       * Detect if `Array#shift` and `Array#splice` augment array-like objects
	       * correctly.
	       *
	       * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
	       * `shift()` and `splice()` functions that fail to remove the last element,
	       * `value[0]`, of array-like objects even though the "length" property is
	       * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
	       * while `splice()` is buggy regardless of mode in IE < 9.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
	
	      /**
	       * Detect lack of support for accessing string characters by index.
	       *
	       * IE < 8 can't access characters by index. IE 8 can only access characters
	       * by index on string literals, not string objects.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      support.unindexedChars = ('x'[0] + Object('x')[0]) != 'xx';
	
	      /**
	       * Detect if the DOM is supported.
	       *
	       * @memberOf _.support
	       * @type boolean
	       */
	      try {
	        support.dom = document.createDocumentFragment().nodeType === 11;
	      } catch(e) {
	        support.dom = false;
	      }
	    }(1, 0));
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = null;
	      this.__dir__ = 1;
	      this.__dropCount__ = 0;
	      this.__filtered__ = false;
	      this.__iteratees__ = null;
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = null;
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var actions = this.__actions__,
	          iteratees = this.__iteratees__,
	          views = this.__views__,
	          result = new LazyWrapper(this.__wrapped__);
	
	      result.__actions__ = actions ? arrayCopy(actions) : null;
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = iteratees ? arrayCopy(iteratees) : null;
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = views ? arrayCopy(views) : null;
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value();
	      if (!isArray(array)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var dir = this.__dir__,
	          isRight = dir < 0,
	          view = getView(0, array.length, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          takeCount = nativeMin(length, this.__takeCount__),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees ? iteratees.length : 0,
	          resIndex = 0,
	          result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type;
	
	          if (type == LAZY_DROP_WHILE_FLAG) {
	            if (data.done && (isRight ? (index > data.index) : (index < data.index))) {
	              data.count = 0;
	              data.done = false;
	            }
	            data.index = index;
	            if (!data.done) {
	              var limit = data.limit;
	              if (!(data.done = limit > -1 ? (data.count++ >= limit) : !iteratee(value))) {
	                continue outer;
	              }
	            }
	          } else {
	            var computed = iteratee(value);
	            if (type == LAZY_MAP_FLAG) {
	              value = computed;
	            } else if (!computed) {
	              if (type == LAZY_FILTER_FLAG) {
	                continue outer;
	              } else {
	                break outer;
	              }
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays whichs invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for iteratees.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +array[length] || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = null;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= 200) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            value = baseFlatten(value, isDeep, isStrict);
	          }
	          var valIndex = -1,
	              valLength = value.length;
	
	          while (++valIndex < valLength) {
	            result[++resIndex] = value[valIndex];
	          }
	        } else if (!isStrict) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      object = toObject(object);
	      if (pathKey !== undefined && pathKey in object) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = toObject(object)[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObject(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          object = toObject(object);
	          return object[key] === value && (value !== undefined || (key in object));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not which does
	     * not clone `value`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merging properties.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? null : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merging properties.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : toObject(object)[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + floor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= 200,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var args = [result],
	            action = actions[index];
	
	        push.apply(args, action.args);
	        result = action.func.apply(action.thisArg, args);
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = floor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      return bufferSlice.call(buffer, 0);
	    }
	    if (!bufferSlice) {
	      // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
	      bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
	        var byteLength = buffer.byteLength,
	            floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
	            offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
	            result = new ArrayBuffer(byteLength);
	
	        if (floatLength) {
	          var view = new Float64Array(result, 0, floatLength);
	          view.set(new Float64Array(buffer, 0, floatLength));
	        }
	        if (byteLength != offset) {
	          view = new Uint8Array(result, offset);
	          view.set(new Uint8Array(buffer, offset));
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(argsLength + leftLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a function that aggregates a collection, creating an accumulator
	     * object composed from the results of running each element in the collection
	     * through an iteratee.
	     *
	     * **Note:** This function is used to create `_.countBy`, `_.groupBy`, `_.indexBy`,
	     * and `_.partition`.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that assigns properties of source object(s) to a given
	     * destination object.
	     *
	     * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
	      return new SetCache(values);
	    };
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = null;
	        }
	        var result = createWrapper(func, flag, null, null, null, null, null, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = null;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([]);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : null;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments;
	          if (wrapper && args.length == 1 && isArray(args[0])) {
	            return wrapper.plant(args[0]).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : args[0];
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, null, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? null : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : null,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : null,
	                newHoldersRight = isCurry ? null : argsHolders,
	                newPartials = isCurry ? args : null,
	                newPartialsRight = isCurry ? null : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, ceil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(argsLength + leftLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = null;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = null;
	      }
	      var data = isBindKey ? null : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} value The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} [transforms] The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms ? transforms.length : 0;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          // Safari 5 mobile incorrectly has `Object` as the constructor of typed arrays.
	          if (Ctor instanceof Ctor) {
	            Ctor = ctorByTag[tag];
	          }
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = typeof value == 'number' ? value : parseFloat(value);
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      return !!funcName && func === lodash[funcName] && funcName in LazyWrapper.prototype;
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `_.isPlainObject` which checks if `value`
	     * is an object created by the `Object` constructor or has a `[[Prototype]]`
	     * of `null`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     */
	    function shimIsPlainObject(value) {
	      var Ctor,
	          support = lodash.support;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isHostObject(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') &&
	            (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) ||
	          (!support.argsTag && isArguments(value))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      if (support.ownLast) {
	        baseForIn(value, function(subValue, key, object) {
	          result = hasOwnProperty.call(object, key);
	          return false;
	        });
	        return result !== false;
	      }
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object) || isString(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      if (lodash.support.unindexedChars && isString(value)) {
	        return value.split('');
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      if (lodash.support.unindexedChars && isString(value)) {
	        var index = -1,
	            length = value.length,
	            result = Object(value);
	
	        while (++index < length) {
	          result[index] = value.charAt(index);
	        }
	        return result;
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(+size || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(ceil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array excluding all values of the provided arrays using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value),
	            other = array[index];
	
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values in all provided arrays using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, of the provided arrays using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? null : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? baseDifference(result, array).concat(baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapper = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapper = wrapper.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapper.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapper = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapper = wrapper.plant(other);
	     *
	     * otherWrapper.value();
	     * // => [9, 16]
	     *
	     * wrapper.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        if (this.__actions__.length) {
	          value = new LazyWrapper(this);
	        }
	        return new LodashWrapper(value.reverse(), this.__chain__);
	      }
	      return this.thru(function(value) {
	        return value.reverse();
	      });
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      if (isArrayLike(collection)) {
	        collection = toIterable(collection);
	      }
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = null;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (!length) {
	        return false;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex < length && collection.indexOf(target, fromIndex) > -1)
	        : (getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : null);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `includes`, `merge`, `sortByAll`, and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var result = shuffle(collection);
	      result.length = nativeMin(n < 0 ? 0 : (+n || 0), result.length);
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      collection = toIterable(collection);
	
	      var index = -1,
	          length = collection.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var rand = baseRandom(0, index);
	        if (index != rand) {
	          result[index] = result[rand];
	        }
	        result[rand] = collection[index];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = null;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = null;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. A truthy value in `orders` will
	     * sort the corresponding property name in ascending order while a falsey
	     * value will sort it in descending order.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], [true, false]), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = null;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = null;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, null, null, null, null, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = null;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          if (maxTimeoutId) {
	            clearTimeout(maxTimeoutId);
	          }
	          var isCalled = trailingCall;
	          maxTimeoutId = timeoutId = trailingCall = undefined;
	          if (isCalled) {
	            lastCalled = now();
	            result = func.apply(thisArg, args);
	            if (!timeoutId && !maxTimeoutId) {
	              args = thisArg = null;
	            }
	          }
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (trailing || (maxWait !== wait)) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = null;
	          }
	        }
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = null;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, null, null, null, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      debounceOptions.leading = leading;
	      debounceOptions.maxWait = +wait;
	      debounceOptions.trailing = trailing;
	      return debounce(func, wait, debounceOptions);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, null, [value], []);
	    }
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) && objToString.call(value) == argsTag;
	    }
	    // Fallback for environments without a `toStringTag` for `arguments` objects.
	    if (!support.argsTag) {
	      isArguments = function(value) {
	        return isObjectLike(value) && isArrayLike(value) &&
	          hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	      };
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) &&
	        (lodash.support.nodeTag ? (objToString.call(value).indexOf('Element') > -1) : isHostObject(value));
	    }
	    // Fallback for environments without DOM support.
	    if (!support.dom) {
	      isElement = function(value) {
	        return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	      };
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    var isFinite = nativeNumIsFinite || function(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    };
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return objToString.call(value) == funcTag;
	    };
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (objToString.call(value) == funcTag) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
	      if (!(value && objToString.call(value) == objectTag) || (!lodash.support.argsTag && isArguments(value))) {
	        return false;
	      }
	      var valueOf = getNative(value, 'valueOf'),
	          objProto = valueOf && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
	
	      return objProto
	        ? (value == objProto || getPrototypeOf(value) == objProto)
	        : shimIsPlainObject(value);
	    };
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return (lodash.support.unindexedChars && isString(value))
	        ? value.split('')
	        : arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = null;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = restParam(function(args) {
	      var object = args[0];
	      if (object == null) {
	        return object;
	      }
	      args.push(assignDefaults);
	      return assign.apply(undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object) || isString(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = null;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? null : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object == 'function' ? lodash.support.enumPrototypes : isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length,
	          support = lodash.support;
	
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object) || isString(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          proto = (isFunction(Ctor) && Ctor.prototype) || objectProto,
	          isProto = proto === object,
	          result = Array(length),
	          skipIndexes = length > 0,
	          skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error),
	          skipProto = support.enumPrototypes && isFunction(object);
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      // lodash skips the `constructor` property when it infers it is iterating
	      // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
	      // attribute of an existing property and the `constructor` property of a
	      // prototype defaults to non-enumerable.
	      for (var key in object) {
	        if (!(skipProto && key == 'prototype') &&
	            !(skipErrorProps && (key == 'message' || key == 'name')) &&
	            !(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      if (support.nonEnumShadows && object !== objectProto) {
	        var tag = object === stringProto ? stringTag : (object === errorProto ? errorTag : objToString.call(object)),
	            nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
	
	        if (tag == objectTag) {
	          proto = objectProto;
	        }
	        length = shadowProps.length;
	        while (length--) {
	          key = shadowProps[length];
	          var nonEnum = nonEnums[key];
	          if (!(isProto && nonEnum) &&
	              (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) {
	            result.push(key);
	          }
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : toObject(object)[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : toObject(object)[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          endIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == endIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : null);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (typeof end === 'undefined') {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = null;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = floor(mid),
	          rightLength = ceil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard && isIterateeCall(string, radix, guard)) {
	        radix = 0;
	      }
	      return nativeParseInt(string, radix);
	    }
	    // Fallback for environments with pre-ES5 implementations.
	    if (nativeParseInt(whitespace + '08') != 8) {
	      parseInt = function(string, radix, guard) {
	        // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	        // Chrome fails to trim leading <BOM> whitespace characters.
	        // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	        if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	          radix = 0;
	        } else if (radix) {
	          radix = +radix;
	        }
	        string = trim(string);
	        return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	      };
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = floor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = null;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = null;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = null;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = null;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function which performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function which compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function which invokes the method at `path` on a given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function which invokes
	     * the method at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : null,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : null;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              var args = [this.value()];
	              push.apply(args, arguments);
	              return func.apply(object, args);
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      context._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function which returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function which returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function which returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = null;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(ceil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = floor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, -Infinity);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, Infinity);
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = null;
	      }
	      var callback = getCallback(),
	          noIteratee = iteratee == null;
	
	      if (!(noIteratee && callback === baseCallback)) {
	        noIteratee = false;
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return noIteratee
	        ? arraySum(isArray(collection) ? collection : toIterable(collection))
	        : baseSum(collection, iteratee);
	    }
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['dropWhile', 'filter', 'map', 'takeWhile'], function(methodName, type) {
	      var isFilter = type != LAZY_MAP_FLAG,
	          isDropWhile = type == LAZY_DROP_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var filtered = this.__filtered__,
	            result = (filtered && isDropWhile) ? new LazyWrapper(this) : this.clone(),
	            iteratees = result.__iteratees__ || (result.__iteratees__ = []);
	
	        iteratees.push({
	          'done': false,
	          'count': 0,
	          'index': 0,
	          'iteratee': getCallback(iteratee, thisArg, 1),
	          'limit': -1,
	          'type': type
	        });
	
	        result.__filtered__ = filtered || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      var whileName = methodName + 'While';
	
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__,
	            result = (filtered && !index) ? this.dropWhile() : this.clone();
	
	        n = n == null ? 1 : nativeMax(floor(n) || 0, 0);
	        if (filtered) {
	          if (index) {
	            result.__takeCount__ = nativeMin(result.__takeCount__, n);
	          } else {
	            last(result.__iteratees__).limit = n;
	          }
	        } else {
	          var views = result.__views__ || (result.__views__ = []);
	          views.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	
	      LazyWrapper.prototype[methodName + 'RightWhile'] = function(predicate, thisArg) {
	        return this.reverse()[whileName](predicate, thisArg).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (start < 0) {
	        result = this.takeRight(-start);
	      } else if (start) {
	        result = this.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.drop(0);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (!lodashFunc) {
	        return;
	      }
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // avoid lazy use if the iteratee has a "length" value other than `1`
	          isLazy = useLazy = false;
	        }
	        var onlyLazy = isLazy && !isHybrid;
	        if (retUnwrapped && !chainAll) {
	          return onlyLazy
	            ? func.call(value)
	            : lodashFunc.call(lodash, this.value());
	        }
	        var interceptor = function(value) {
	          var otherArgs = [value];
	          push.apply(otherArgs, args);
	          return lodashFunc.apply(lodash, otherArgs);
	        };
	        if (useLazy) {
	          var wrapper = onlyLazy ? value : new LazyWrapper(this),
	              result = func.apply(wrapper, args);
	
	          if (!retUnwrapped && (isHybrid || result.__actions__)) {
	            var actions = result.__actions__ || (result.__actions__ = []);
	            actions.push({ 'func': thru, 'args': [interceptor], 'thisArg': lodash });
	          }
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['concat', 'join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var protoFunc = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          fixObjects = !support.spliceObjects && /^(?:pop|shift|splice)$/.test(methodName),
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      // Avoid array-like object bugs with `Array#shift` and `Array#splice` in
	      // IE < 9, Firefox < 10, and RingoJS.
	      var func = !fixObjects ? protoFunc : function() {
	        var result = protoFunc.apply(this, arguments);
	        if (this.length === 0) {
	          delete this[0];
	        }
	        return result;
	      };
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(null, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': null }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), (function() { return this; }())))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var Util = {
	  /** Convert a float data type to a ratio.
	   *
	   * @params {number} x: The float number that will be converted to a fraction
	   */
	  floatToRatio: function floatToRatio(x) {
	    var tolerance = 1.0E-6;
	    var h1 = 1;
	    var h2 = 0;
	    var k1 = 0;
	    var k2 = 1;
	    var b = x;
	    do {
	      var a = Math.floor(b);
	      var aux = h1;
	      h1 = a * h1 + h2;
	      h2 = aux;
	      aux = k1;
	      k1 = a * k1 + k2;
	      k2 = aux;
	      b = 1 / (b - a);
	    } while (Math.abs(x - h1 / k1) > x * tolerance);
	
	    return h1 + '/' + k1;
	  },
	  queryParams: function queryParams(source) {
	    var array = [];
	    for (var key in source) {
	      array.push(encodeURIComponent(key) + '=' + encodeURIComponent(source[key]));
	    }
	    return array.join('&');
	  },
	
	  toArray: function toArray(obj) {
	    return _import2['default'].isArray(obj) ? obj : [obj];
	  },
	  /**
	   * Load a CSS  file
	   * @param {String} nameOfDoc : Name of a file you want the url for, minus the suffix (.js, .css, etc)
	   * @param {String} contentToCut: The beginning of the part of the url you'd like to truncate
	   * @param {String} appendContent: The string you'd like to append to the end of your URL
	   */
	  loadCss: function loadCss(nameOfDoc, contentToCut, appendContent) {
	    var url = Util._urlFinder(nameOfDoc, contentToCut, appendContent);
	    var link = document.createElement('link');
	    link.type = 'text/css';
	    link.rel = 'stylesheet';
	    link.href = url;
	    document.getElementsByTagName('head')[0].appendChild(link);
	  },
	  /**
	   * Find the url of the current file, typically called by
	   *
	   * @param {string} nameOfDoc : name of the file you want
	   * the url for, minus the suffix (.js, .css, etc)
	   *
	   * @param {string} contentToCut: the beginning of the part
	   * of the url you'd like to truncate
	   *
	   * @param {string} appendContent: the string you'd like to append to the end of your URL
	   */
	  _urlFinder: function _urlFinder(nameOfDoc, contentToCut, appendContent) {
	    var currentUrl = undefined;
	
	    var scriptElements = document.getElementsByTagName('script');
	    var i = undefined,
	        element = undefined,
	        myfile = undefined;
	
	    for (i = 0; element = scriptElements[i]; i++) {
	      myfile = element.src;
	
	      if (myfile.indexOf(nameOfDoc) >= 0) {
	        currentUrl = myfile.substring(0, myfile.indexOf(nameOfDoc));
	      }
	    }
	
	    // Cut off end of URL and add relative path to css file needed
	    var url = currentUrl.substr(0, currentUrl.indexOf(contentToCut)) + appendContent;
	
	    return url;
	  },
	
	  mixin: function mixin() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _import2['default'].extend.apply(null, args.map(_import2['default'].clone));
	  },
	
	  forceRepaint: function forceRepaint(node) {
	    node.style.display = 'none';
	    Util.nextTick(function () {
	      return node.style.display = '';
	    });
	  },
	
	  /* Returns true if the current device is mobile, else returns false */
	  isMobile: function isMobile() {
	    return (/android|webos|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase())
	    );
	  },
	
	  isTouchDevice: function isTouchDevice() {
	    return 'ontouchstart' in window || 'onmsgesturechange' in window;
	  },
	
	  /** Returns the current environment the code is running on */
	  environment: function environment() {
	    // All the code below determines the environment and builds the proper string
	    var environments = ['proddev', 'staging', 'qa00', 'qa01', 'qa02'];
	    var currentEnv = '';
	
	    // Determine environment
	    _jquery2['default'].each(environments, function (index, value) {
	      if (_jquery2['default'].inArray(value, window.location.host.split('.')) === 1) {
	        currentEnv = value;
	      }
	    });
	
	    return currentEnv;
	  },
	
	  /**
	   * Parse query params into an object
	   */
	
	  getParams: function getParams(qs_) {
	    var qs = qs_ || window.location.search.substring(1);
	    if (!qs) return {};
	
	    return _import2['default'].chain(qs.split('&')).map(function (seg) {
	      return _import2['default'].map(seg.split('='), decodeURIComponent);
	    }).zipObject().value();
	  },
	
	  urlToJSONP: function urlToJSONP(dataUrl) {
	    var _dataUrl$split = dataUrl.split('?');
	
	    var _dataUrl$split2 = _slicedToArray(_dataUrl$split, 2);
	
	    var url = _dataUrl$split2[0];
	    var query = _dataUrl$split2[1];
	
	    if (query) {
	      url += '?' + query + '&';
	    } else {
	      url += '?';
	    }
	    url += 'callback=?';
	    return url;
	  },
	
	  /**
	   * Alternate Environment Checking Function, Handles all
	   * combination of qa/staging/proddev and inserts a period, for
	   * direct use in URLs */
	  envCheck: function envCheck() {
	    var env = '';
	    if (window.location.href.indexOf('.staging.') !== -1) {
	      if (window.location.href.match(/\.qa\d\d/) !== null) {
	        env = '.staging' + window.location.href.match(/\.qa\d\d/)[0];
	      } else {
	        env = '.staging';
	      }
	    } else if (window.location.href.indexOf('.proddev.') !== -1) {
	      env = '.proddev';
	    } else if (window.location.href.match(/\.qa\d\d/) !== null) {
	      env = env + window.location.href.match(/\.qa\d\d/)[0];
	    }
	    return env;
	  },
	
	  /**
	   * returns the default image server for but also takes an override for when
	   * you're testing locally but you want to override and point at a remote.
	   */
	  imageServer: function imageServer(env) {
	    var sub = env ? env : Util.envCheck();
	    var prodEnv = ['www.medscape.com', 'www.medscape.org', 'reference.medscape.com', 'education.webmd.com'];
	    var isProd = prodEnv.some(function (envUrl) {
	      return window.location.host.indexOf(envUrl) !== -1;
	    });
	    if (isProd) {
	      return '//img.medscapestatic.com';
	    }
	    if (env === 'override') {
	      return '';
	    } else if (sub === '' && Util.isLocal()) {
	      return '//img.staging.medscapestatic.com';
	    } else {
	      return '//img' + sub + '.medscapestatic.com';
	    }
	  },
	
	  isLocal: function isLocal() {
	    return document.location.hostname === "localhost";
	  },
	
	  /** Returns true if the current device is Retina display */
	  isRetina: function isRetina() {
	    return window.devicePixelRatio > 1;
	  },
	
	  /** Returns true if the current device is ipad */
	  isIpad: function isIpad() {
	    return navigator.userAgent.match(/iPad/i) !== null;
	  },
	  isIphone: function isIphone() {
	    return navigator.userAgent.match(/iPhone/i) !== null;
	  },
	  isIOS: function isIOS(version) {
	    var isIOS = Util.isIpad() || navigator.userAgent.match(/iPhone/i);
	    if (version) {
	      isIOS = isIOS && navigator.userAgent.match(new RegExp('OS ' + version));
	    }
	    return isIOS;
	  },
	  isSafari: function isSafari() {
	    return Util.isIOS() && navigator.userAgent.indexOf('Safari') > -1;
	  },
	  isApp: function isApp() {
	    return !!navigator.userAgent.toLowerCase().match('medscape');
	  },
	  nextTick: function nextTick(f) {
	    setTimeout(f, 0);
	  },
	  removeElementById: function removeElementById(id) {
	    var elem = document.getElementById(id);
	    elem.parentNode.removeChild(elem);
	  },
	  getXhr: function getXhr(url) {
	    var Promise = __webpack_require__(202);
	    return new Promise(function (resolve, reject) {
	      var req = new XMLHttpRequest();
	      req.open('GET', url);
	      req.onload = function () {
	        if (req.status === 200) {
	          resolve(req.response);
	        } else {
	          reject(Error(req.statusText));
	        }
	      };
	      req.onerror = function () {
	        reject(Error('Network Error'));
	      };
	      req.send();
	    });
	  },
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	    while (node !== null) {
	      if (node === parent) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  },
	  setCookie: function setCookie(a, b, c) {
	    var e = '';
	    if (c) {
	      var d = new Date();
	      d.setTime(d.getTime() + c * 24 * 60 * 60 * 1e3);
	      e = '; expires=' + d.toGMTString();
	    }
	    document.cookie = a + '=' + b + e + '; path=/';
	  },
	  deleteCookie: function deleteCookie(a) {
	    Util.setCookie(a, '', -1);
	  },
	  getCookie: function getCookie(a) {
	    var b = a + '=';
	    var c = document.cookie.split(';');
	    for (var d = 0; d < c.length; d++) {
	      var e = c[d];
	      while (e.charAt(0) === ' ') e = e.substring(1, e.length);
	      if (e.indexOf(b) === 0) {
	        return e.substring(b.length, e.length);
	      }
	    }
	    return null;
	  }
	};
	
	exports['default'] = Util;
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! Native Promise Only
	    v0.8.1 (c) Kyle Simpson
	    MIT License: http://getify.mit-license.org
	*/
	
	(function UMD(name,context,definition){
		// special form of UMD for polyfilling across evironments
		context[name] = context[name] || definition();
		if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
		else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = function $AMD$(){ return context[name]; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
	})("Promise",typeof global != "undefined" ? global : this,function DEF(){
		/*jshint validthis:true */
		"use strict";
	
		var builtInProp, cycle, scheduling_queue,
			ToString = Object.prototype.toString,
			timer = (typeof setImmediate != "undefined") ?
				function timer(fn) { return setImmediate(fn); } :
				setTimeout
		;
	
		// dammit, IE8.
		try {
			Object.defineProperty({},"x",{});
			builtInProp = function builtInProp(obj,name,val,config) {
				return Object.defineProperty(obj,name,{
					value: val,
					writable: true,
					configurable: config !== false
				});
			};
		}
		catch (err) {
			builtInProp = function builtInProp(obj,name,val) {
				obj[name] = val;
				return obj;
			};
		}
	
		// Note: using a queue instead of array for efficiency
		scheduling_queue = (function Queue() {
			var first, last, item;
	
			function Item(fn,self) {
				this.fn = fn;
				this.self = self;
				this.next = void 0;
			}
	
			return {
				add: function add(fn,self) {
					item = new Item(fn,self);
					if (last) {
						last.next = item;
					}
					else {
						first = item;
					}
					last = item;
					item = void 0;
				},
				drain: function drain() {
					var f = first;
					first = last = cycle = void 0;
	
					while (f) {
						f.fn.call(f.self);
						f = f.next;
					}
				}
			};
		})();
	
		function schedule(fn,self) {
			scheduling_queue.add(fn,self);
			if (!cycle) {
				cycle = timer(scheduling_queue.drain);
			}
		}
	
		// promise duck typing
		function isThenable(o) {
			var _then, o_type = typeof o;
	
			if (o != null &&
				(
					o_type == "object" || o_type == "function"
				)
			) {
				_then = o.then;
			}
			return typeof _then == "function" ? _then : false;
		}
	
		function notify() {
			for (var i=0; i<this.chain.length; i++) {
				notifyIsolated(
					this,
					(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
					this.chain[i]
				);
			}
			this.chain.length = 0;
		}
	
		// NOTE: This is a separate function to isolate
		// the `try..catch` so that other code can be
		// optimized better
		function notifyIsolated(self,cb,chain) {
			var ret, _then;
			try {
				if (cb === false) {
					chain.reject(self.msg);
				}
				else {
					if (cb === true) {
						ret = self.msg;
					}
					else {
						ret = cb.call(void 0,self.msg);
					}
	
					if (ret === chain.promise) {
						chain.reject(TypeError("Promise-chain cycle"));
					}
					else if (_then = isThenable(ret)) {
						_then.call(ret,chain.resolve,chain.reject);
					}
					else {
						chain.resolve(ret);
					}
				}
			}
			catch (err) {
				chain.reject(err);
			}
		}
	
		function resolve(msg) {
			var _then, self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			try {
				if (_then = isThenable(msg)) {
					schedule(function(){
						var def_wrapper = new MakeDefWrapper(self);
						try {
							_then.call(msg,
								function $resolve$(){ resolve.apply(def_wrapper,arguments); },
								function $reject$(){ reject.apply(def_wrapper,arguments); }
							);
						}
						catch (err) {
							reject.call(def_wrapper,err);
						}
					})
				}
				else {
					self.msg = msg;
					self.state = 1;
					if (self.chain.length > 0) {
						schedule(notify,self);
					}
				}
			}
			catch (err) {
				reject.call(new MakeDefWrapper(self),err);
			}
		}
	
		function reject(msg) {
			var self = this;
	
			// already triggered?
			if (self.triggered) { return; }
	
			self.triggered = true;
	
			// unwrap
			if (self.def) {
				self = self.def;
			}
	
			self.msg = msg;
			self.state = 2;
			if (self.chain.length > 0) {
				schedule(notify,self);
			}
		}
	
		function iteratePromises(Constructor,arr,resolver,rejecter) {
			for (var idx=0; idx<arr.length; idx++) {
				(function IIFE(idx){
					Constructor.resolve(arr[idx])
					.then(
						function $resolver$(msg){
							resolver(idx,msg);
						},
						rejecter
					);
				})(idx);
			}
		}
	
		function MakeDefWrapper(self) {
			this.def = self;
			this.triggered = false;
		}
	
		function MakeDef(self) {
			this.promise = self;
			this.state = 0;
			this.triggered = false;
			this.chain = [];
			this.msg = void 0;
		}
	
		function Promise(executor) {
			if (typeof executor != "function") {
				throw TypeError("Not a function");
			}
	
			if (this.__NPO__ !== 0) {
				throw TypeError("Not a promise");
			}
	
			// instance shadowing the inherited "brand"
			// to signal an already "initialized" promise
			this.__NPO__ = 1;
	
			var def = new MakeDef(this);
	
			this["then"] = function then(success,failure) {
				var o = {
					success: typeof success == "function" ? success : true,
					failure: typeof failure == "function" ? failure : false
				};
				// Note: `then(..)` itself can be borrowed to be used against
				// a different promise constructor for making the chained promise,
				// by substituting a different `this` binding.
				o.promise = new this.constructor(function extractChain(resolve,reject) {
					if (typeof resolve != "function" || typeof reject != "function") {
						throw TypeError("Not a function");
					}
	
					o.resolve = resolve;
					o.reject = reject;
				});
				def.chain.push(o);
	
				if (def.state !== 0) {
					schedule(notify,def);
				}
	
				return o.promise;
			};
			this["catch"] = function $catch$(failure) {
				return this.then(void 0,failure);
			};
	
			try {
				executor.call(
					void 0,
					function publicResolve(msg){
						resolve.call(def,msg);
					},
					function publicReject(msg) {
						reject.call(def,msg);
					}
				);
			}
			catch (err) {
				reject.call(def,err);
			}
		}
	
		var PromisePrototype = builtInProp({},"constructor",Promise,
			/*configurable=*/false
		);
	
		// Note: Android 4 cannot use `Object.defineProperty(..)` here
		Promise.prototype = PromisePrototype;
	
		// built-in "brand" to signal an "uninitialized" promise
		builtInProp(PromisePrototype,"__NPO__",0,
			/*configurable=*/false
		);
	
		builtInProp(Promise,"resolve",function Promise$resolve(msg) {
			var Constructor = this;
	
			// spec mandated checks
			// note: best "isPromise" check that's practical for now
			if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
				return msg;
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				resolve(msg);
			});
		});
	
		builtInProp(Promise,"reject",function Promise$reject(msg) {
			return new this(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				reject(msg);
			});
		});
	
		builtInProp(Promise,"all",function Promise$all(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
			if (arr.length === 0) {
				return Constructor.resolve([]);
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				var len = arr.length, msgs = Array(len), count = 0;
	
				iteratePromises(Constructor,arr,function resolver(idx,msg) {
					msgs[idx] = msg;
					if (++count === len) {
						resolve(msgs);
					}
				},reject);
			});
		});
	
		builtInProp(Promise,"race",function Promise$race(arr) {
			var Constructor = this;
	
			// spec mandated checks
			if (ToString.call(arr) != "[object Array]") {
				return Constructor.reject(TypeError("Not an array"));
			}
	
			return new Constructor(function executor(resolve,reject){
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}
	
				iteratePromises(Constructor,arr,function resolver(idx,msg){
					resolve(msg);
				},reject);
			});
		});
	
		return Promise;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(203).setImmediate))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(204);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(29)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(206);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	exports.ActionMethods = __webpack_require__(207);
	
	exports.ListenerMethods = __webpack_require__(208);
	
	exports.PublisherMethods = __webpack_require__(216);
	
	exports.StoreMethods = __webpack_require__(217);
	
	exports.createAction = __webpack_require__(218);
	
	exports.createStore = __webpack_require__(212);
	
	exports.connect = __webpack_require__(219);
	
	exports.connectFilter = __webpack_require__(220);
	
	exports.ListenerMixin = __webpack_require__(221);
	
	exports.listenTo = __webpack_require__(222);
	
	exports.listenToMany = __webpack_require__(223);
	
	
	var maker = __webpack_require__(211).staticJoinCreator;
	
	exports.joinTrailing = exports.all = maker("last"); // Reflux.all alias for backward compatibility
	
	exports.joinLeading = maker("first");
	
	exports.joinStrict = maker("strict");
	
	exports.joinConcat = maker("all");
	
	var _ = __webpack_require__(209);
	
	exports.EventEmitter = _.EventEmitter;
	
	exports.Promise = _.Promise;
	
	/**
	 * Convenience function for creating a set of actions
	 *
	 * @param definitions the definitions for the actions to be created
	 * @returns an object with actions of corresponding action names
	 */
	exports.createActions = function(definitions) {
	    var actions = {};
	    for (var k in definitions){
	        if (definitions.hasOwnProperty(k)) {
	            var val = definitions[k],
	                actionName = _.isObject(val) ? k : val;
	
	            actions[actionName] = exports.createAction(val);
	        }
	    }
	    return actions;
	};
	
	/**
	 * Sets the eventmitter that Reflux uses
	 */
	exports.setEventEmitter = function(ctx) {
	    var _ = __webpack_require__(209);
	    exports.EventEmitter = _.EventEmitter = ctx;
	};
	
	
	/**
	 * Sets the Promise library that Reflux uses
	 */
	exports.setPromise = function(ctx) {
	    var _ = __webpack_require__(209);
	    exports.Promise = _.Promise = ctx;
	};
	
	
	/**
	 * Sets the Promise factory that creates new promises
	 * @param {Function} factory has the signature `function(resolver) { return [new Promise]; }`
	 */
	exports.setPromiseFactory = function(factory) {
	    var _ = __webpack_require__(209);
	    _.createPromise = factory;
	};
	
	
	/**
	 * Sets the method used for deferring actions and stores
	 */
	exports.nextTick = function(nextTick) {
	    var _ = __webpack_require__(209);
	    _.nextTick = nextTick;
	};
	
	/**
	 * Provides the set of created actions and stores for introspection
	 */
	exports.__keep = __webpack_require__(213);
	
	/**
	 * Warn if Function.prototype.bind not available
	 */
	if (!Function.prototype.bind) {
	  console.error(
	    'Function.prototype.bind not available. ' +
	    'ES5 shim required. ' +
	    'https://github.com/spoike/refluxjs#es5'
	  );
	}


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/**
	 * A module of methods that you want to include in all actions.
	 * This module is consumed by `createAction`.
	 */
	module.exports = {
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209),
	    maker = __webpack_require__(211).instanceJoinCreator;
	
	/**
	 * Extract child listenables from a parent from their
	 * children property and return them in a keyed Object
	 *
	 * @param {Object} listenable The parent listenable
	 */
	var mapChildListenables = function(listenable) {
	    var i = 0, children = {}, childName;
	    for (;i < (listenable.children||[]).length; ++i) {
	        childName = listenable.children[i];
	        if(listenable[childName]){
	            children[childName] = listenable[childName];
	        }
	    }
	    return children;
	};
	
	/**
	 * Make a flat dictionary of all listenables including their
	 * possible children (recursively), concatenating names in camelCase.
	 *
	 * @param {Object} listenables The top-level listenables
	 */
	var flattenListenables = function(listenables) {
	    var flattened = {};
	    for(var key in listenables){
	        var listenable = listenables[key];
	        var childMap = mapChildListenables(listenable);
	
	        // recursively flatten children
	        var children = flattenListenables(childMap);
	
	        // add the primary listenable and chilren
	        flattened[key] = listenable;
	        for(var childKey in children){
	            var childListenable = children[childKey];
	            flattened[key + _.capitalize(childKey)] = childListenable;
	        }
	    }
	
	    return flattened;
	};
	
	/**
	 * A module of methods related to listening.
	 */
	module.exports = {
	
	    /**
	     * An internal utility function used by `validateListening`
	     *
	     * @param {Action|Store} listenable The listenable we want to search for
	     * @returns {Boolean} The result of a recursive search among `this.subscriptions`
	     */
	    hasListener: function(listenable) {
	        var i = 0, j, listener, listenables;
	        for (;i < (this.subscriptions||[]).length; ++i) {
	            listenables = [].concat(this.subscriptions[i].listenable);
	            for (j = 0; j < listenables.length; j++){
	                listener = listenables[j];
	                if (listener === listenable || listener.hasListener && listener.hasListener(listenable)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	
	    /**
	     * A convenience method that listens to all listenables in the given object.
	     *
	     * @param {Object} listenables An object of listenables. Keys will be used as callback method names.
	     */
	    listenToMany: function(listenables){
	        var allListenables = flattenListenables(listenables);
	        for(var key in allListenables){
	            var cbname = _.callbackName(key),
	                localname = this[cbname] ? cbname : this[key] ? key : undefined;
	            if (localname){
	                this.listenTo(allListenables[key],localname,this[cbname+"Default"]||this[localname+"Default"]||localname);
	            }
	        }
	    },
	
	    /**
	     * Checks if the current context can listen to the supplied listenable
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @returns {String|Undefined} An error message, or undefined if there was no problem.
	     */
	    validateListening: function(listenable){
	        if (listenable === this) {
	            return "Listener is not able to listen to itself";
	        }
	        if (!_.isFunction(listenable.listen)) {
	            return listenable + " is missing a listen method";
	        }
	        if (listenable.hasListener && listenable.hasListener(this)) {
	            return "Listener cannot listen to this listenable because of circular loop";
	        }
	    },
	
	    /**
	     * Sets up a subscription to the given listenable for the context object
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @param {Function|String} callback The callback to register as event handler
	     * @param {Function|String} defaultCallback The callback to register as default handler
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is the object being listened to
	     */
	    listenTo: function(listenable, callback, defaultCallback) {
	        var desub, unsubscriber, subscriptionobj, subs = this.subscriptions = this.subscriptions || [];
	        _.throwIf(this.validateListening(listenable));
	        this.fetchInitialState(listenable, defaultCallback);
	        desub = listenable.listen(this[callback]||callback, this);
	        unsubscriber = function() {
	            var index = subs.indexOf(subscriptionobj);
	            _.throwIf(index === -1,'Tried to remove listen already gone from subscriptions list!');
	            subs.splice(index, 1);
	            desub();
	        };
	        subscriptionobj = {
	            stop: unsubscriber,
	            listenable: listenable
	        };
	        subs.push(subscriptionobj);
	        return subscriptionobj;
	    },
	
	    /**
	     * Stops listening to a single listenable
	     *
	     * @param {Action|Store} listenable The action or store we no longer want to listen to
	     * @returns {Boolean} True if a subscription was found and removed, otherwise false.
	     */
	    stopListeningTo: function(listenable){
	        var sub, i = 0, subs = this.subscriptions || [];
	        for(;i < subs.length; i++){
	            sub = subs[i];
	            if (sub.listenable === listenable){
	                sub.stop();
	                _.throwIf(subs.indexOf(sub)!==-1,'Failed to remove listen from subscriptions list!');
	                return true;
	            }
	        }
	        return false;
	    },
	
	    /**
	     * Stops all subscriptions and empties subscriptions array
	     */
	    stopListeningToAll: function(){
	        var remaining, subs = this.subscriptions || [];
	        while((remaining=subs.length)){
	            subs[0].stop();
	            _.throwIf(subs.length!==remaining-1,'Failed to remove listen from subscriptions list!');
	        }
	    },
	
	    /**
	     * Used in `listenTo`. Fetches initial data from a publisher if it has a `getInitialState` method.
	     * @param {Action|Store} listenable The publisher we want to get initial state from
	     * @param {Function|String} defaultCallback The method to receive the data
	     */
	    fetchInitialState: function (listenable, defaultCallback) {
	        defaultCallback = (defaultCallback && this[defaultCallback]) || defaultCallback;
	        var me = this;
	        if (_.isFunction(defaultCallback) && _.isFunction(listenable.getInitialState)) {
	            var data = listenable.getInitialState();
	            if (data && _.isFunction(data.then)) {
	                data.then(function() {
	                    defaultCallback.apply(me, arguments);
	                });
	            } else {
	                defaultCallback.call(this, data);
	            }
	        }
	    },
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the last emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinTrailing: maker("last"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the first emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinLeading: maker("first"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with all emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinConcat: maker("all"),
	
	    /**
	     * The callback will be called once all listenables have triggered.
	     * If a callback triggers twice before that happens, an error is thrown.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinStrict: maker("strict")
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * isObject, extend, isFunction, isArguments are taken from undescore/lodash in
	 * order to remove the dependency
	 */
	var isObject = exports.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	};
	
	exports.extend = function(obj) {
	    if (!isObject(obj)) {
	        return obj;
	    }
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	        source = arguments[i];
	        for (prop in source) {
	            if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	                var propertyDescriptor = Object.getOwnPropertyDescriptor(source, prop);
	                Object.defineProperty(obj, prop, propertyDescriptor);
	            } else {
	                obj[prop] = source[prop];
	            }
	        }
	    }
	    return obj;
	};
	
	exports.isFunction = function(value) {
	    return typeof value === 'function';
	};
	
	exports.EventEmitter = __webpack_require__(210);
	
	exports.nextTick = function(callback) {
	    setTimeout(callback, 0);
	};
	
	exports.capitalize = function(string){
	    return string.charAt(0).toUpperCase()+string.slice(1);
	};
	
	exports.callbackName = function(string){
	    return "on"+exports.capitalize(string);
	};
	
	exports.object = function(keys,vals){
	    var o={}, i=0;
	    for(;i<keys.length;i++){
	        o[keys[i]] = vals[i];
	    }
	    return o;
	};
	
	exports.Promise = __webpack_require__(202);
	
	exports.createPromise = function(resolver) {
	    return new exports.Promise(resolver);
	};
	
	exports.isArguments = function(value) {
	    return typeof value === 'object' && ('callee' in value) && typeof value.length === 'number';
	};
	
	exports.throwIf = function(val,msg){
	    if (val){
	        throw Error(msg||val);
	    }
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Internal module used to create static and instance join methods
	 */
	
	var slice = Array.prototype.slice,
	    _ = __webpack_require__(209),
	    createStore = __webpack_require__(212),
	    strategyMethodNames = {
	        strict: "joinStrict",
	        first: "joinLeading",
	        last: "joinTrailing",
	        all: "joinConcat"
	    };
	
	/**
	 * Used in `index.js` to create the static join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} A static function which returns a store with a join listen on the given listenables using the given strategy
	 */
	exports.staticJoinCreator = function(strategy){
	    return function(/* listenables... */) {
	        var listenables = slice.call(arguments);
	        return createStore({
	            init: function(){
	                this[strategyMethodNames[strategy]].apply(this,listenables.concat("triggerAsync"));
	            }
	        });
	    };
	};
	
	/**
	 * Used in `ListenerMethods.js` to create the instance join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} An instance method which sets up a join listen on the given listenables using the given strategy
	 */
	exports.instanceJoinCreator = function(strategy){
	    return function(/* listenables..., callback*/){
	        _.throwIf(arguments.length < 3,'Cannot create a join with less than 2 listenables!');
	        var listenables = slice.call(arguments),
	            callback = listenables.pop(),
	            numberOfListenables = listenables.length,
	            join = {
	                numberOfListenables: numberOfListenables,
	                callback: this[callback]||callback,
	                listener: this,
	                strategy: strategy
	            }, i, cancels = [], subobj;
	        for (i = 0; i < numberOfListenables; i++) {
	            _.throwIf(this.validateListening(listenables[i]));
	        }
	        for (i = 0; i < numberOfListenables; i++) {
	            cancels.push(listenables[i].listen(newListener(i,join),this));
	        }
	        reset(join);
	        subobj = {listenable: listenables};
	        subobj.stop = makeStopper(subobj,cancels,this);
	        this.subscriptions = (this.subscriptions || []).concat(subobj);
	        return subobj;
	    };
	};
	
	// ---- internal join functions ----
	
	function makeStopper(subobj,cancels,context){
	    return function() {
	        var i, subs = context.subscriptions,
	            index = (subs ? subs.indexOf(subobj) : -1);
	        _.throwIf(index === -1,'Tried to remove join already gone from subscriptions list!');
	        for(i=0;i < cancels.length; i++){
	            cancels[i]();
	        }
	        subs.splice(index, 1);
	    };
	}
	
	function reset(join) {
	    join.listenablesEmitted = new Array(join.numberOfListenables);
	    join.args = new Array(join.numberOfListenables);
	}
	
	function newListener(i,join) {
	    return function() {
	        var callargs = slice.call(arguments);
	        if (join.listenablesEmitted[i]){
	            switch(join.strategy){
	                case "strict": throw new Error("Strict join failed because listener triggered twice.");
	                case "last": join.args[i] = callargs; break;
	                case "all": join.args[i].push(callargs);
	            }
	        } else {
	            join.listenablesEmitted[i] = true;
	            join.args[i] = (join.strategy==="all"?[callargs]:callargs);
	        }
	        emitIfAllListenablesEmitted(join);
	    };
	}
	
	function emitIfAllListenablesEmitted(join) {
	    for (var i = 0; i < join.numberOfListenables; i++) {
	        if (!join.listenablesEmitted[i]) {
	            return;
	        }
	    }
	    join.callback.apply(join.listener,join.args);
	    reset(join);
	}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209),
	    Reflux = __webpack_require__(206),
	    Keep = __webpack_require__(213),
	    mixer = __webpack_require__(214),
	    allowed = {preEmit:1,shouldEmit:1},
	    bindMethods = __webpack_require__(215);
	
	/**
	 * Creates an event emitting Data Store. It is mixed in with functions
	 * from the `ListenerMethods` and `PublisherMethods` mixins. `preEmit`
	 * and `shouldEmit` may be overridden in the definition object.
	 *
	 * @param {Object} definition The data store object definition
	 * @returns {Store} A data store instance
	 */
	module.exports = function(definition) {
	
	    definition = definition || {};
	
	    for(var a in Reflux.StoreMethods){
	        if (!allowed[a] && (Reflux.PublisherMethods[a] || Reflux.ListenerMethods[a])){
	            throw new Error("Cannot override API method " + a +
	                " in Reflux.StoreMethods. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead."
	            );
	        }
	    }
	
	    for(var d in definition){
	        if (!allowed[d] && (Reflux.PublisherMethods[d] || Reflux.ListenerMethods[d])){
	            throw new Error("Cannot override API method " + d +
	                " in store creation. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead."
	            );
	        }
	    }
	
	    definition = mixer(definition);
	
	    function Store() {
	        var i=0, arr;
	        this.subscriptions = [];
	        this.emitter = new _.EventEmitter();
	        this.eventLabel = "change";
	        bindMethods(this, definition);
	        if (this.init && _.isFunction(this.init)) {
	            this.init();
	        }
	        if (this.listenables){
	            arr = [].concat(this.listenables);
	            for(;i < arr.length;i++){
	                this.listenToMany(arr[i]);
	            }
	        }
	    }
	
	    _.extend(Store.prototype, Reflux.ListenerMethods, Reflux.PublisherMethods, Reflux.StoreMethods, definition);
	
	    var store = new Store();
	    Keep.createdStores.push(store);
	
	    return store;
	};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	exports.createdStores = [];
	
	exports.createdActions = [];
	
	exports.reset = function() {
	    while(exports.createdStores.length) {
	        exports.createdStores.pop();
	    }
	    while(exports.createdActions.length) {
	        exports.createdActions.pop();
	    }
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209);
	
	module.exports = function mix(def) {
	    var composed = {
	        init: [],
	        preEmit: [],
	        shouldEmit: []
	    };
	
	    var updated = (function mixDef(mixin) {
	        var mixed = {};
	        if (mixin.mixins) {
	            mixin.mixins.forEach(function (subMixin) {
	                _.extend(mixed, mixDef(subMixin));
	            });
	        }
	        _.extend(mixed, mixin);
	        Object.keys(composed).forEach(function (composable) {
	            if (mixin.hasOwnProperty(composable)) {
	                composed[composable].push(mixin[composable]);
	            }
	        });
	        return mixed;
	    }(def));
	
	    if (composed.init.length > 1) {
	        updated.init = function () {
	            var args = arguments;
	            composed.init.forEach(function (init) {
	                init.apply(this, args);
	            }, this);
	        };
	    }
	    if (composed.preEmit.length > 1) {
	        updated.preEmit = function () {
	            return composed.preEmit.reduce(function (args, preEmit) {
	                var newValue = preEmit.apply(this, args);
	                return newValue === undefined ? args : [newValue];
	            }.bind(this), arguments);
	        };
	    }
	    if (composed.shouldEmit.length > 1) {
	        updated.shouldEmit = function () {
	            var args = arguments;
	            return !composed.shouldEmit.some(function (shouldEmit) {
	                return !shouldEmit.apply(this, args);
	            }, this);
	        };
	    }
	    Object.keys(composed).forEach(function (composable) {
	        if (composed[composable].length === 1) {
	            updated[composable] = composed[composable][0];
	        }
	    });
	
	    return updated;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = function(store, definition) {
	  for (var name in definition) {
	    if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	        var propertyDescriptor = Object.getOwnPropertyDescriptor(definition, name);
	
	        if (!propertyDescriptor.value || typeof propertyDescriptor.value !== 'function' || !definition.hasOwnProperty(name)) {
	            continue;
	        }
	
	        store[name] = definition[name].bind(store);
	    } else {
	        var property = definition[name];
	
	        if (typeof property !== 'function' || !definition.hasOwnProperty(name)) {
	            continue;
	        }
	
	        store[name] = property.bind(store);
	    }
	  }
	
	  return store;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209);
	
	/**
	 * A module of methods for object that you want to be able to listen to.
	 * This module is consumed by `createStore` and `createAction`
	 */
	module.exports = {
	
	    /**
	     * Hook used by the publisher that is invoked before emitting
	     * and before `shouldEmit`. The arguments are the ones that the action
	     * is invoked with. If this function returns something other than
	     * undefined, that will be passed on as arguments for shouldEmit and
	     * emission.
	     */
	    preEmit: function() {},
	
	    /**
	     * Hook used by the publisher after `preEmit` to determine if the
	     * event should be emitted with given arguments. This may be overridden
	     * in your application, default implementation always returns true.
	     *
	     * @returns {Boolean} true if event should be emitted
	     */
	    shouldEmit: function() { return true; },
	
	    /**
	     * Subscribes the given callback for action triggered
	     *
	     * @param {Function} callback The callback to register as event handler
	     * @param {Mixed} [optional] bindContext The context to bind the callback with
	     * @returns {Function} Callback that unsubscribes the registered event handler
	     */
	    listen: function(callback, bindContext) {
	        bindContext = bindContext || this;
	        var eventHandler = function(args) {
	            if (aborted){
	                return;
	            }
	            callback.apply(bindContext, args);
	        }, me = this, aborted = false;
	        this.emitter.addListener(this.eventLabel, eventHandler);
	        return function() {
	            aborted = true;
	            me.emitter.removeListener(me.eventLabel, eventHandler);
	        };
	    },
	
	    /**
	     * Attach handlers to promise that trigger the completed and failed
	     * child publishers, if available.
	     *
	     * @param {Object} The promise to attach to
	     */
	    promise: function(promise) {
	        var me = this;
	
	        var canHandlePromise =
	            this.children.indexOf('completed') >= 0 &&
	            this.children.indexOf('failed') >= 0;
	
	        if (!canHandlePromise){
	            throw new Error('Publisher must have "completed" and "failed" child publishers');
	        }
	
	        promise.then(function(response) {
	            return me.completed(response);
	        }, function(error) {
	            return me.failed(error);
	        });
	    },
	
	    /**
	     * Subscribes the given callback for action triggered, which should
	     * return a promise that in turn is passed to `this.promise`
	     *
	     * @param {Function} callback The callback to register as event handler
	     */
	    listenAndPromise: function(callback, bindContext) {
	        var me = this;
	        bindContext = bindContext || this;
	        this.willCallPromise = (this.willCallPromise || 0) + 1;
	
	        var removeListen = this.listen(function() {
	
	            if (!callback) {
	                throw new Error('Expected a function returning a promise but got ' + callback);
	            }
	
	            var args = arguments,
	                promise = callback.apply(bindContext, args);
	            return me.promise.call(me, promise);
	        }, bindContext);
	
	        return function () {
	          me.willCallPromise--;
	          removeListen.call(me);
	        };
	
	    },
	
	    /**
	     * Publishes an event using `this.emitter` (if `shouldEmit` agrees)
	     */
	    trigger: function() {
	        var args = arguments,
	            pre = this.preEmit.apply(this, args);
	        args = pre === undefined ? args : _.isArguments(pre) ? pre : [].concat(pre);
	        if (this.shouldEmit.apply(this, args)) {
	            this.emitter.emit(this.eventLabel, args);
	        }
	    },
	
	    /**
	     * Tries to publish the event on the next tick
	     */
	    triggerAsync: function(){
	        var args = arguments,me = this;
	        _.nextTick(function() {
	            me.trigger.apply(me, args);
	        });
	    },
	
	    /**
	     * Returns a Promise for the triggered action
	     *
	     * @return {Promise}
	     *   Resolved by completed child action.
	     *   Rejected by failed child action.
	     *   If listenAndPromise'd, then promise associated to this trigger.
	     *   Otherwise, the promise is for next child action completion.
	     */
	    triggerPromise: function(){
	        var me = this;
	        var args = arguments;
	
	        var canHandlePromise =
	            this.children.indexOf('completed') >= 0 &&
	            this.children.indexOf('failed') >= 0;
	
	        var promise = _.createPromise(function(resolve, reject) {
	            // If `listenAndPromise` is listening
	            // patch `promise` w/ context-loaded resolve/reject
	            if (me.willCallPromise) {
	                _.nextTick(function() {
	                    var old_promise_method = me.promise;
	                    me.promise = function (promise) {
	                        promise.then(resolve, reject);
	                        // Back to your regularly schedule programming.
	                        me.promise = old_promise_method;
	                        return me.promise.apply(me, arguments);
	                    };
	                    me.trigger.apply(me, args);
	                });
	                return;
	            }
	
	            if (canHandlePromise) {
	                var removeSuccess = me.completed.listen(function(args) {
	                    removeSuccess();
	                    removeFailed();
	                    resolve(args);
	                });
	
	                var removeFailed = me.failed.listen(function(args) {
	                    removeSuccess();
	                    removeFailed();
	                    reject(args);
	                });
	            }
	
	            me.triggerAsync.apply(me, args);
	
	            if (!canHandlePromise) {
	                resolve();
	            }
	        });
	
	        return promise;
	    }
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	/**
	 * A module of methods that you want to include in all stores.
	 * This module is consumed by `createStore`.
	 */
	module.exports = {
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209),
	    Reflux = __webpack_require__(206),
	    Keep = __webpack_require__(213),
	    allowed = {preEmit:1,shouldEmit:1};
	
	/**
	 * Creates an action functor object. It is mixed in with functions
	 * from the `PublisherMethods` mixin. `preEmit` and `shouldEmit` may
	 * be overridden in the definition object.
	 *
	 * @param {Object} definition The action object definition
	 */
	var createAction = function(definition) {
	
	    definition = definition || {};
	    if (!_.isObject(definition)){
	        definition = {actionName: definition};
	    }
	
	    for(var a in Reflux.ActionMethods){
	        if (!allowed[a] && Reflux.PublisherMethods[a]) {
	            throw new Error("Cannot override API method " + a +
	                " in Reflux.ActionMethods. Use another method name or override it on Reflux.PublisherMethods instead."
	            );
	        }
	    }
	
	    for(var d in definition){
	        if (!allowed[d] && Reflux.PublisherMethods[d]) {
	            throw new Error("Cannot override API method " + d +
	                " in action creation. Use another method name or override it on Reflux.PublisherMethods instead."
	            );
	        }
	    }
	
	    definition.children = definition.children || [];
	    if (definition.asyncResult){
	        definition.children = definition.children.concat(["completed","failed"]);
	    }
	
	    var i = 0, childActions = {};
	    for (; i < definition.children.length; i++) {
	        var name = definition.children[i];
	        childActions[name] = createAction(name);
	    }
	
	    var context = _.extend({
	        eventLabel: "action",
	        emitter: new _.EventEmitter(),
	        _isAction: true
	    }, Reflux.PublisherMethods, Reflux.ActionMethods, definition);
	
	    var functor = function() {
	        return functor[functor.sync?"trigger":"triggerPromise"].apply(functor, arguments);
	    };
	
	    _.extend(functor,childActions,context);
	
	    Keep.createdActions.push(functor);
	
	    return functor;
	
	};
	
	module.exports = createAction;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(206),
	    _ = __webpack_require__(209);
	
	module.exports = function(listenable,key){
	    return {
	        getInitialState: function(){
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (key === undefined) {
	                return listenable.getInitialState();
	            } else {
	                return _.object([key],[listenable.getInitialState()]);
	            }
	        },
	        componentDidMount: function(){
	            _.extend(this,Reflux.ListenerMethods);
	            var me = this, cb = (key === undefined ? this.setState : function(v){me.setState(_.object([key],[v]));});
	            this.listenTo(listenable,cb);
	        },
	        componentWillUnmount: Reflux.ListenerMixin.componentWillUnmount
	    };
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(206),
	  _ = __webpack_require__(209);
	
	module.exports = function(listenable, key, filterFunc) {
	    filterFunc = _.isFunction(key) ? key : filterFunc;
	    return {
	        getInitialState: function() {
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (_.isFunction(key)) {
	                return filterFunc.call(this, listenable.getInitialState());
	            } else {
	                // Filter initial payload from store.
	                var result = filterFunc.call(this, listenable.getInitialState());
	                if (result) {
	                  return _.object([key], [result]);
	                } else {
	                  return {};
	                }
	            }
	        },
	        componentDidMount: function() {
	            _.extend(this, Reflux.ListenerMethods);
	            var me = this;
	            var cb = function(value) {
	                if (_.isFunction(key)) {
	                    me.setState(filterFunc.call(me, value));
	                } else {
	                    var result = filterFunc.call(me, value);
	                    me.setState(_.object([key], [result]));
	                }
	            };
	
	            this.listenTo(listenable, cb);
	        },
	        componentWillUnmount: Reflux.ListenerMixin.componentWillUnmount
	    };
	};
	


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(209),
	    ListenerMethods = __webpack_require__(208);
	
	/**
	 * A module meant to be consumed as a mixin by a React component. Supplies the methods from
	 * `ListenerMethods` mixin and takes care of teardown of subscriptions.
	 * Note that if you're using the `connect` mixin you don't need this mixin, as connect will
	 * import everything this mixin contains!
	 */
	module.exports = _.extend({
	
	    /**
	     * Cleans up all listener previously registered.
	     */
	    componentWillUnmount: ListenerMethods.stopListeningToAll
	
	}, ListenerMethods);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(206);
	
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `ListenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method.
	 *
	 * @param {Action|Store} listenable An Action or Store that should be
	 *  listened to.
	 * @param {Function|String} callback The callback to register as event handler
	 * @param {Function|String} defaultCallback The callback to register as default handler
	 * @returns {Object} An object to be used as a mixin, which sets up the listener for the given listenable.
	 */
	module.exports = function(listenable,callback,initial){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in Reflux.ListenerMethods){
	                if (this[m] !== Reflux.ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenTo!";
	                    }
	                    this[m] = Reflux.ListenerMethods[m];
	                }
	            }
	            this.listenTo(listenable,callback,initial);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: Reflux.ListenerMethods.stopListeningToAll
	    };
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(206);
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `listenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method. This version is used
	 * to automatically set up a `listenToMany` call.
	 *
	 * @param {Object} listenables An object of listenables
	 * @returns {Object} An object to be used as a mixin, which sets up the listeners for the given listenables.
	 */
	module.exports = function(listenables){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in Reflux.ListenerMethods){
	                if (this[m] !== Reflux.ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenToMany!";
	                    }
	                    this[m] = Reflux.ListenerMethods[m];
	                }
	            }
	            this.listenToMany(listenables);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: Reflux.ListenerMethods.stopListeningToAll
	    };
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var Actions = _reflux2['default'].createActions(['load', 'enable', 'disable', 'selectVideo', 'start', 'end', 'toggle', 'replay', 'pause', 'subtitle', 'setVolume', 'setCurrentTime', 'mute', 'unmute', 'fullScreen', 'stopAutoplay', 'setClosedCaptioning', 'selectLanguage', 'exitFullScreen', 'deleteQna']);
	
	exports['default'] = Actions;
	module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {/* global define BASE_PLUGIN_URL BASE_AMP_URL $ */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _videoVideoApi = __webpack_require__(226);
	
	var _videoVideoApi2 = _interopRequireDefault(_videoVideoApi);
	
	var _videoConfig = __webpack_require__(230);
	
	var _videoConfig2 = _interopRequireDefault(_videoConfig);
	
	var _mixinsMedia_store = __webpack_require__(232);
	
	var _mixinsMedia_store2 = _interopRequireDefault(_mixinsMedia_store);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _storesDescriptor_store = __webpack_require__(238);
	
	var _storesDescriptor_store2 = _interopRequireDefault(_storesDescriptor_store);
	
	var _storesRoadblock_store = __webpack_require__(245);
	
	var _storesRoadblock_store2 = _interopRequireDefault(_storesRoadblock_store);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _descriptorEvent_compiler = __webpack_require__(247);
	
	var _descriptorEvent_compiler2 = _interopRequireDefault(_descriptorEvent_compiler);
	
	exports['default'] = _reflux2['default'].createStore({
	  listenables: _actionsVideo_actions2['default'],
	  mixins: [_mixinsStore_state2['default'], _mixinsMedia_store2['default'], _mixinsHas_pretty_time2['default']],
	  stateNamespace: 'video',
	  queued: [],
	  cors_flag: true,
	  mediaApi: null,
	  getInitialState: function getInitialState() {
	    return {
	      isVideo: true
	    };
	  },
	  onLoad: function onLoad(elementId, video) {
	    var _this = this;
	
	    var descriptor = _storesDescriptor_store2['default'].getDescriptor(),
	        index = descriptor.initialIndex,
	        ampPath = '/amp-premier/',
	        pluginPath = ampPath + 'plugins/',
	        ampURL = (0, _utilsUtil.isLocal)() ? ampPath : '//img' + (0, _utilsUtil.envCheck)() + '.medscape.com/pi/core' + ampPath,
	        pluginURL = (0, _utilsUtil.isLocal)() ? pluginPath : '//img' + (0, _utilsUtil.envCheck)() + '.medscape.com/pi/core' + pluginPath,
	        watermark = descriptor.watermark ? descriptor.watermark : '',
	        config = (0, _import.extend)((0, _videoConfig2['default'])(pluginURL, ampURL), {
	      media: video,
	      debug: false,
	      autoplay: video.autoplay,
	      controls: {
	        'native': (0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)(),
	        mode: (0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)() ? 'auto' : 'none'
	      },
	      branding: {
	        id: 'logo',
	        logo: watermark
	      },
	      playoverlay: { enabled: true },
	      captioning: { enabled: true },
	      webmd: {
	        chapterData: descriptor.videos[descriptor.initialIndex || 0].chapters
	      },
	      mode: 'html'
	    });
	    config.flash = config.flash || {};
	    config.flash.params = { wmmode: 'transparent' };
	    if (this.mediaApi) {
	      this.removeMediaEvents();
	      this.mediaApi.destroy();
	    }
	    this.mediaApi = new _videoVideoApi2['default'](elementId, config);
	    this.mediaApi.init(function () {
	      // autoplay if configed or if the starting video is not the
	      // first in the chapter list.
	      _this.mediaApi._v.setAutoplay(config.autoplay && !_this.state.stopAutoplay);
	      _this.addMediaEvents();
	      if ((0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)()) {
	        var ccFileName = _storesDescriptor_store2['default'].getCCInfo()[_storesDescriptor_store2['default'].getCCDefaultLang()];
	        if (typeof ccFileName !== 'undefined') {
	          _this.mediaApi._v.getMediaElement().addTextTrack('subtitles', 'en', 'en');
	        }
	      }
	    });
	    this.mediaApi.ready(this.onReady.bind(this));
	    this.eventCompiler = new _descriptorEvent_compiler2['default']((0, _import.get)(video, 'events', []), '').compile();
	    this.isBuffering = false;
	    this.bufferDelay = 400;
	    this.bufferTimeout = null;
	    var videoWithEvents = (0, _import.assign)(video, this.eventCompiler.getEvents());
	    this.setState({
	      meta: videoWithEvents,
	      index: index,
	      event: 'loading',
	      isLoading: false,
	      viewed: {},
	      playerType: this.mediaApi._v.getPlayerType()
	    });
	    // const videoElement = this.mediaApi._v.getMediaElement();
	    this.videoPosterClass = 'akamai-poster';
	    this.posterImgClass = 'akamai-poster-image';
	    // DEBUG REMOVEME
	    window.mediaApi = this.mediaApi;
	  },
	  getPosterElement: function getPosterElement(ele) {
	    var _this2 = this;
	
	    var backgroundPath = this.mediaApi._config.media.poster;
	    var akamaiSelector = '.akamai-media-element';
	    if (!$('.' + this.videoPosterClass)[0]) {
	      // build poster element for mobile based on desktop markup.
	      if ((0, _utilsUtil.isMobile)() && $(akamaiSelector).length > 0) {
	        this.posterElement = $('<div class="' + this.videoPosterClass + ' akamai-layer" id="mobile-poster-content"><div class="akamai-poster-content">\n                <img src="' + backgroundPath + '" class="' + this.posterImgClass + '"></div>\n           </div>').insertAfter($('.akamai-video'));
	        $('#mobile-poster-content').bind('touchstart', function (e) {
	          if (_this2.mediaApi._v.paused === true) {
	            _this2.mediaApi.play();
	          }
	        });
	      } else {
	        window.requestAnimationFrame(this.getPosterElement.bind(null, ele));
	      }
	    } else {
	      this.videoElement = ele;
	      this.posterElement = $('.' + this.videoPosterClass);
	      this.currentIndex = this.state.index;
	    }
	  },
	  updatePosterElement: function updatePosterElement(imagePath) {
	    $('.' + this.posterImgClass).attr('src', imagePath);
	  },
	  exitFullScreenMobile: function exitFullScreenMobile() {
	    if (!(0, _utilsUtil.isIpad)() && (0, _utilsUtil.isMobile)()) {
	      this.mediaApi.exitFullScreen();
	    }
	  },
	  loadMobileCC: function loadMobileCC() {
	    if ((0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)() && this.ccLoaded !== true) {
	      var ccFileName = _storesDescriptor_store2['default'].getCCInfo()[_storesDescriptor_store2['default'].getCCDefaultLang()];
	      if (typeof ccFileName !== 'undefined') {
	        var trackUrl = ((0, _utilsUtil.imageServer)((0, _utilsUtil.envCheck)()) + '/' + _storesDescriptor_store2['default'].getCCFileRoot().replace(/^en\//, '') + ccFileName).replace('.xml', '.vtt'),
	            videoElement = this.mediaApi._v.getMediaElement(),
	            track = document.createElement('track');
	
	        videoElement.setAttribute('crossorigin', 'anonymous');
	        this.ccLoaded = true;
	        track.kind = 'captions';
	        track.srclang = 'en';
	        track.src = trackUrl;
	        track.id = 'captions';
	        if (document.getElementById('captions') === null) {
	          videoElement.appendChild(track);
	        }
	        videoElement.mode = 'hidden';
	        videoElement.textTracks[0].mode = 'hidden';
	      }
	    }
	  },
	  // webkit only event
	  onWebkitendfullscreen: function onWebkitendfullscreen(videoElement) {
	    if ((0, _utilsUtil.isMobile)() && !(0, _utilsUtil.isIpad)()) {
	      if (!$(videoElement).attr('controls')) {
	        $(videoElement).attr('controls', 'controls');
	      }
	    }
	  },
	  onReady: function onReady() {
	    var _this3 = this;
	
	    this._setupFullScreenIdleDetection();
	    var meta = _storesDescriptor_store2['default'].getVideo(this.state.index);
	    this._isReady = true;
	    this.setState({
	      index: this.state.index,
	      api: this.mediaApi,
	      event: 'ready',
	      isLoading: false,
	      isBuffering: false,
	      isPlaying: false,
	      currentTime: this.mediaApi.getCurrentTime(),
	      duration: meta.duration || this.mediaApi.getDuration() || 0,
	      meta: meta,
	      isCaptioningOn: meta.hasCcAutoDisplay,
	      ccLang: meta.ccDefaultLang,
	      playerType: this.mediaApi._v.getPlayerType()
	    });
	
	    this.dequeue();
	    // moved from the end of the onLoad event
	    var videoElement = this.mediaApi._v.getMediaElement();
	    if ((0, _import.get)(akamai, 'amp.AMP.players.html.prototype.presentationModeChanged', null) !== null) {
	      akamai.amp.AMP.players.html.prototype.presentationModeChanged = function () {};
	    }
	    videoElement.addEventListener('timeupdate', function () {
	      var roadBlockedTime = _storesRoadblock_store2['default'].getRoadBlockedTime();
	      if (videoElement.currentTime > roadBlockedTime) {
	        videoElement.currentTime = roadBlockedTime;
	        for (var i = 0; i < videoElement.buffered.length; i++) {
	          if (videoElement.buffered.start(i) <= roadBlockedTime && roadBlockedTime <= videoElement.buffered.end(i)) {
	            window.trackingEnabled = false;
	            _this3.onPause();
	            _this3.exitFullScreenMobile();
	          }
	        }
	      }
	    });
	    videoElement.addEventListener('webkitendfullscreen', this.onWebkitendfullscreen.bind(null, videoElement));
	    this.getPosterElement(videoElement);
	  },
	  onStopAutoplay: function onStopAutoplay() {
	    this.setState({
	      stopAutoplay: true
	    });
	  },
	  onSelectVideo: function onSelectVideo(video, index) {
	    if (!video.autoplay) this.posterElement.hide();
	    if ((0, _utilsUtil.isMobile)()) this.updatePosterElement(video.poster);
	    this.firstPause = false;
	    this.eventCompiler = new _descriptorEvent_compiler2['default']((0, _import.get)(video, 'events', []), '').compile();
	    var videoWithEvents = (0, _import.assign)(video, this.eventCompiler.getEvents());
	    $('#captions').remove();
	    this.ccLoaded = false;
	    $('video').removeAttr('crossorigin');
	    if (!this._isReady) {
	      this.enqueue('onSelectVideo', video, index);
	      return;
	    }
	    this.mediaApi.setMedia(video);
	    this.setState({
	      index: index,
	      meta: videoWithEvents,
	      isPlaying: true,
	      isLoading: false,
	      isEnded: false,
	      event: 'videoSelected'
	    });
	  },
	  setVideoTime: (0, _import.throttle)(function (newTime, mediaApi) {
	    mediaApi.setCurrentTime(newTime);
	  }, 500, {
	    'leading': true,
	    'trailing': false
	  }),
	  onSetCurrentTime: function onSetCurrentTime(time) {
	    if ((0, _utilsUtil.isIpad)() && !this.state.hasStarted) {
	      this.mediaApi.play();
	    }
	    var roadBlockedTime = _storesRoadblock_store2['default'].getRoadBlockedTime(),
	        meta = _storesDescriptor_store2['default'].getVideo(this.state.index);
	    var newTime = time > roadBlockedTime ? roadBlockedTime : time;
	    newTime = time > this.state.duration ? this.state.duration - 1 : newTime;
	    this.clearQueue('onSetCurrentTime');
	    this.setVideoTime.call(this, newTime, this.mediaApi);
	    if (!this.state.isPlaying) {
	      this.enqueue('onSetCurrentTime', newTime);
	      this.setState({
	        event: 'settingTime',
	        pushedTime: newTime,
	        currentTime: newTime,
	        isLoading: true,
	        duration: meta.duration
	      });
	      return;
	    }
	    // on the first load of a video, the duration isn't set and
	    // setting the current time doesn't work until the player has
	    // started. Because Akamai makes shitty, fragile APIs. This also
	    // has the effect of setting the time optimistically. `pushedTime`
	    // is cleared by the progress event.
	    this.setState({
	      event: 'settingTime',
	      pushedTime: newTime,
	      currentTime: newTime,
	      isLoading: true,
	      duration: this.mediaApi.getDuration()
	    });
	  },
	  onBuffering: function onBuffering() {
	    var _this4 = this;
	
	    if (this.isBuffering) return;
	    this.isBuffering = true;
	    this.bufferTimeout = setTimeout(function () {
	      _this4.isBuffering = false;
	      clearTimeout(_this4.bufferTimeout);
	    }, this.bufferDelay);
	  },
	  onDeleteQna: function onDeleteQna(qaidFormPage) {
	    var newQnas = this.state.meta.qna.filter(function (qna) {
	      return qna.qaidFormPage !== qaidFormPage;
	    }),
	        newMeta = JSON.parse(JSON.stringify(this.state.meta));
	    newMeta.qna = newQnas;
	    this.setState({
	      meta: newMeta
	    });
	  },
	  onProgress: function onProgress() {
	    var bufferredEnd = null;
	    if (this.mediaApi._v.getMediaElement().readyState === 4 && this.mediaApi._v.getMediaElement().buffered.length !== 0) {
	      var buffered = this.mediaApi._v.getMediaElement().buffered.length - 1;
	      bufferredEnd = this.mediaApi._v.getMediaElement().buffered.end(buffered);
	    }
	    this.setState({
	      event: 'progress',
	      isBuffering: false,
	      isLoading: false,
	      hasStarted: true,
	      // WARNING: this is commented out because the video api sends a
	      // bogus 'progress' event after the video has been paused.
	      // Don't set isPlaying to true inside this setState call.
	      // isPlaying:   true, <---- don't do this.
	      // Hopefully that will save you some debugging time in the future.
	      pushedTime: null,
	      currentTime: this.mediaApi.getCurrentTime(),
	      duration: this.mediaApi.getDuration(),
	      roadblockedTime: _storesRoadblock_store2['default'].getRoadBlockedTime(),
	      bufferredEnd: bufferredEnd
	    });
	  },
	  onSetVolume: function onSetVolume(volume) {
	    this.mediaApi._v.setVolume(volume);
	  },
	  onVolumeChanged: function onVolumeChanged() {
	    this.setState({
	      event: 'volumeChanged',
	      currentVolume: this.mediaApi.getVolume()
	    });
	  },
	  onMute: function onMute() {
	    this.mediaApi.mute();
	  },
	  onUnmute: function onUnmute() {
	    //this.onSetVolume(volume);
	    this.mediaApi.unmute();
	  },
	  onSetClosedCaptioning: function onSetClosedCaptioning(turnOn) {
	    // fire global event for tracking
	    $(window).trigger('onSetCaption', { on: turnOn });
	    if (turnOn) {
	      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
	      this.mediaApi.turnClosedCaptionOn();
	    } else {
	      this.mediaApi.setCaptionLanguage('', false);
	      this.mediaApi.turnClosedCaptionOff();
	    }
	    this.setState({
	      isCaptioningOn: turnOn
	    });
	  },
	  onSelectLanguage: function onSelectLanguage(lang) {
	    if (lang !== '') {
	      this.mediaApi.setCaptionLanguage(lang, true);
	      this.setState({
	        ccLang: lang,
	        isOpen: false
	      });
	    } else {
	      this.setState({
	        ccLang: lang,
	        isOpen: false
	      });
	    }
	  },
	  onEnd: function onEnd() {},
	  onEnded: function onEnded() {
	    this.mediaApi.end();
	    this.state.viewed[this.state.index] = true;
	    this.setState({
	      isPlaying: false,
	      isEnded: true,
	      event: 'ended'
	    });
	    var nextVideo = _storesDescriptor_store2['default'].getVideo(this.state.index + 1);
	    if (typeof nextVideo !== 'undefined' && nextVideo.autoplay === true) {
	      nextVideo.muted = false;
	      this.onSelectVideo(nextVideo, this.state.index + 1);
	    }
	    if ((0, _utilsUtil.isMobile)()) {
	      if ($('.qna-container').length > 0) {
	        $('.video-player-standalone').hide();
	        $('.qna-container').addClass('bp_video_scroll');
	      }
	    }
	  },
	  onReplay: function onReplay() {
	    window.trackingEnabled = false;
	    this.mediaApi.replay();
	    // the duration gets wiped after the video ends so we have to go back to the config.
	    this.setState({
	      isPlaying: true,
	      duration: this.getDuration(true),
	      hasStarted: true, // always true after the first start
	      isEnded: false,
	      canPlay: false
	    });
	  },
	  onStart: function onStart() {
	    this.mediaApi.play();
	    this.loadMobileCC();
	    if (!this._isReady) {
	      this.enqueue('onStart');
	      return;
	    }
	    this.setState({
	      event: 'start',
	      isPlaying: true,
	      hasStarted: true, // always true after the first start
	      isLoading: true,
	      isEnded: false,
	      canPlay: false
	    });
	  },
	  onStarted: function onStarted() {
	    if (this.posterElement.css('display') === 'block') this.posterElement.hide();
	    this.dequeue();
	    this.loadMobileCC();
	    this.setState({
	      isPlaying: true,
	      isLoading: false,
	      isEnded: false,
	      event: 'play',
	      hasStarted: true,
	      currentVolume: this.mediaApi.getVolume()
	    });
	    if (this.state.isCaptioningOn) {
	      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
	      this.mediaApi.turnClosedCaptionOn();
	    }
	  },
	  onToggle: function onToggle() {
	    if (this.isPlaying()) {
	      this.onPause();
	    } else {
	      this.onStart();
	    }
	  },
	  getIndex: function getIndex() {
	    return this.state.index;
	  },
	  /* accessors */
	  isPlaying: function isPlaying() {
	    return this.state.isPlaying;
	  },
	  getCurrentTime: function getCurrentTime() {
	    if (!this._isReady) return 0;
	    return this.mediaApi.getCurrentTime();
	  },
	  getDuration: function getDuration() {
	    return this.mediaApi.getDuration();
	  },
	  getTitle: function getTitle() {
	    return _storesDescriptor_store2['default'].getTitle(this.state.index);
	  },
	  getVersion: function getVersion() {
	    return 'Medscape/AMP';
	  }
	});
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(227), __webpack_require__(224)], __WEBPACK_AMD_DEFINE_RESULT__ = function (AkamaiCore, VideoActions) {
		//Note: we define a class definition here. Consuming code must use new keyword before using it.
		/**
	 *	constructor
	 *	@param id 	the element id of the element which you want the video to be in
	 *	@param 	config 	configuration override.
	 *	@param 	cb 	callback
	 *
	 */
		function WebmdVideo(id, config, cb) {
			var self = this,
			    isMobile = self.isMobile();
			this._v;
			this._t = null;
			this._id = id;
			this._isLoaded = false;
			this._isMuted = false;
			this._cbs = [];
			this.adPlaying = false;
			this.setEvents = {};
	
			this._config = $.extend({
				autoplay: false,
				muted: true,
				playsInline: true,
				controls: {
					mode: isMobile ? 'auto' : 'none',
					native: isMobile ? true : false
				},
				hls: {
					quality: {
						startLevel: 0
					},
					data: {
						enableWorker: true,
						enableSoftwareAES: true,
						debug: false
					}
				},
				captioning: {
					enabled: true
				},
				mode: 'auto'
			}, config);
			//config.ima.adTagUrl = config.ima.adTagUrl.replace('&impl=', '&ciu_szs=300x50,320x50,1x1,300x51,300x250,300x253,320x51&impl=');
			//console.log(config.ima.adTagUrl)
			/*
	  this._config.mode = "auto";
	  	this._config.media.source = [
	  						{ "src": "//webmd-a.akamaihd.net/webmd-test/delivery/7b/00/7b00ace6-04ae-4048-93c2-9e219ae8dff1/120689-Module%204-1.18.13_1000k.mp4",  "type": "video\/mp4"}
	  					];
	  	this._config.media.track = [
	  					{
	  						kind : "captions",
	  						type : "application/ttml+xml",
	  						srclang : "en",
	  						src : "//projects.mediadev.edgesuite.net/customers/akamai/mdt-html5-core/webmd/0.20.0.0001/samples/captioning.xml"
	  					}
	  	];
	  /*
	  this._config.ima = {
	  				enabled: true,
	  				resources: [
	  					{
	  						src: "//imasdk.googleapis.com/js/sdkloader/ima3.js",
	  						type: "text/javascript"
	  					}
	  				],
	  				version: 3,
	  				adTagUrl: "//pubads.g.doubleclick.net/gampad/ads?sz=640x360&iu=/6062/iab_vast_samples/skippable&ciu_szs=300x250,728x90&impl=s&gdfp_req=1&env=vp&output=xml_vast2&unviewed_position_start=1&url=" + window.location.href + "&correlator=" + new Date().toString(),
	  				disableCompanionAds: "false",
	  				companions: [
	  					{
	  						id: "companion-container",
	  						width: 728,
	  						height: 90
	  					}
	  				]
	  			};
	  */
	
			//this.init(cb);
		}
	
		/**
	 *	the init method. Initializes the video, the elements around it with flash config data.
	 *	@param 	cb 	callback.
	 */
		WebmdVideo.prototype.init = function (cb) {
			var self = this,
			    isFF = !(window.mozInnerScreenX == null),
			    isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./),
			    imgSvrPath = window.image_server_url || '//img.preview.webmd.com/dtmcms/preview',
			    basePluginUrl = window.location.host.indexOf('localhost') > -1 ? '/resources/plugins/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
			    baseSkinUrl = window.location.host.indexOf('localhost') > -1 ? '/amp/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
			    coreConfig = self._config;
			coreConfig.flash.vars.auto_play_override = self._config.autoplay || false;
	
			//NOTE: this is still temporary, the default plugin and skin url will be hard coded in the wxml file
			while (coreConfig.flash.xml.indexOf('{basePluginUrl}') !== -1) {
				coreConfig.flash.xml = coreConfig.flash.xml.replace('{basePluginUrl}', basePluginUrl);
			}
			while (coreConfig.flash.xml.indexOf('{baseSkinUrl}') !== -1) {
				coreConfig.flash.xml = coreConfig.flash.xml.replace('{baseSkinUrl}', baseSkinUrl);
			}
	
			coreConfig = $.extend(true, coreConfig, self._config);
	
			//this part is for testing, it will be removed
	
			/* if(window.location.host.indexOf("localhost") <= -1) {
	     coreConfig['flash']['swf'] = imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/AkamaiPremierPlayer.swf';
	     coreConfig['flash']['debug'] = imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/AkamaiPremierPlayer-debug.swf';
	     } */
	
			if (isFF === true || isIE === true) {
				coreConfig['flash']['params'] = { 'wmode': 'transparent' };
			}
	
			self._v = akamai.amp.AMP.create(self._id, coreConfig, function () {
				if (cb) cb();
				self._cbs.forEach(function (cb) {
					cb();
				});
				self._isLoaded = true;
			});
		};
	
		/**
	 *	lets the programmer know when the video is ready to interact with.
	 *
	 *	@param 	cb 	callback
	 */
		WebmdVideo.prototype.ready = function (cb) {
			var self = this;
	
			if (self._isLoaded) {
				cb();
				return;
			}
	
			this._cbs.push(cb);
		};
	
		/**
	 *	Pauses the video.
	 *
	 */
		WebmdVideo.prototype.pause = function () {
			this._v.pause();
		};
	
		/**
	 *	removes the video from the system and stops all activities related to it.
	 *
	 */
		WebmdVideo.prototype.destroy = function () {
			document.getElementById(this._id).innerHTML = '';
	
			if (this._v != null) {
				this._v.destroy();
			}
	
			this._v = null;
		};
	
		/**
	 *	Plays the video.
	 *
	 */
		WebmdVideo.prototype.play = function () {
			this._v.play();
		};
	
		/**
	 *	restarts the video.
	 *
	 */
		WebmdVideo.prototype.replay = function () {
			this._v.replay();
		};
	
		/**
	 *	Sets the video volume to the volume inserted
	 *
	 *	@param 	v 	float 	the volume the video will be set to, either 1-100 or 0-1.
	 */
		WebmdVideo.prototype.setVolume = function (v) {
			if (v > 1) {
				v = parseFloat(v) / 100;
			}
	
			this._v.setVolume(v);
		};
	
		/**
	 *	Sets the video time to the time inserted (in seconds).
	 *
	 *	@param 	t 	int 	the time that the video will be seeked to in seconds.
	 */
		WebmdVideo.prototype.setCurrentTime = function (t) {
	
			this._v.setCurrentTime(t);
		};
	
		/**
	 *	Used to load dynamic videos on the fly.
	 *
	 *	@param 	Object 	json	akamai media config override (contains video source and meta data)
	 */
		WebmdVideo.prototype.setMedia = function (json) {
			this._v.setMedia(json);
		};
	
		/**
	 *	Sets the closed captions to on or off depending on the parameter.
	 *
	 *	@param 	b 	boolean	Determines whether or not the closed captions will be turned on.
	 */
		WebmdVideo.prototype.setClosedCaption = function (b) {
			if (typeof this._v.captioning !== 'undefined') {
				this._v.captioning.setHidden(b);
			} else {
				console.log('error', 'The closed captioning feature is disabled, please enable it before turning it on!');
			}
		};
	
		/**
	 *	Turns closed captions on.
	 *
	 */
		WebmdVideo.prototype.turnClosedCaptionOn = function () {
	
			this.setClosedCaption(false);
		};
	
		/**
	 *	Turns closed captions off.
	 *
	 */
		WebmdVideo.prototype.turnClosedCaptionOff = function () {
			this.setClosedCaption(true);
		};
	
		/**
	 *	Enters full screen mode.
	 *
	 */
		WebmdVideo.prototype.enterFullScreen = function () {
	
			this._v.enterFullScreen();
		};
	
		/**
	 *	Exits full screen mode.
	 *
	 */
		WebmdVideo.prototype.exitFullScreen = function () {
	
			this._v.exitFullScreen();
		};
	
		/**
	 *	Mutes the video.
	 *
	 */
		WebmdVideo.prototype.mute = function () {
			this.setMuted(true);
		};
	
		/**
	 *	Unmutes the video.
	 *
	 */
		WebmdVideo.prototype.unmute = function () {
			this.setMuted(false);
		};
	
		/**
	 *	Mutes or unmutes the video depending on the parameter.
	 *
	 *	@param 	bool 	determines whether the video will be muted or not.
	 */
		WebmdVideo.prototype.setMuted = function (bool) {
			this._v.setMuted(bool);
		};
	
		/**
	  *	Sets the caption language based on the languages assigned in the config.
	  *
	  *	@param 	string 	lan 	The language that the caption will be set to (ie: en, de, jp)
	  *	@param 	boolean 	captionOn 	flag whether to turn on captions as soon as it is set or not
	  *
	  *	@return 	boolean
	  */
		WebmdVideo.prototype.setCaptionLanguage = function (lan, captionOn) {
			var config = this.getConfig();
			if (typeof config.media === 'undefined') {
				//TODO throw error
				console.log('error', 'There is no media definition in your config');
				return;
			}
	
			if (typeof config.media.track === 'undefined') {
				//TODO throw error
				return;
			}
	
			for (var i in config.media.track) {
				if (typeof config.media.track[i] !== 'undefined' && config.media.track[i].srclang == lan) {
					this._v.captioning.selectTrackByLanguage(lan);
	
					if (captionOn) {
						this.turnClosedCaptionOn();
					}
	
					return true;
				}
			}
	
			//TODO throw error
			console.log('error', 'Could not find the language ' + lan + ' in your media track definition');
			return false;
		};
	
		/**
	 *	Ends the video.
	 *
	 */
		WebmdVideo.prototype.end = function () {
	
			this._v.end();
		};
	
		/**
	 *	Returns a boolean of the state of the captions (on or off).
	 *
	 *	@return	bool 	whether or the not the captioning is on or off.
	 */
		WebmdVideo.prototype.getClosedCaption = function () {
			return this._v !== null ? !this._v.captioning.getHidden() : null;
		};
	
		/**
	 *	returns the current volume of the video playing.
	 *
	 *	@return	float 	the current volume of the video as a decimal from 0 to 1.
	 */
		WebmdVideo.prototype.getVolume = function () {
			return this._v !== null ? this._v.getVolume() : 0;
		};
	
		/**
	 *	return shte current time the video is playing at.
	 *
	 *	@return	int 	the current time the video is playing at in seconds.
	 */
		WebmdVideo.prototype.getCurrentTime = function () {
			/*
	  if(this.isMobile()) {
	  	try {
	  		return document.getElementById(this._id).getElementsByTagName('video')[0].currentTime;
	  	} catch (e) {
	  		return 0;
	  	}
	  	}
	  */
			return this._v !== null ? this._v.getCurrentTime() : 0;
		};
	
		/**
	 *	returns the duration of the current video
	 *
	 *	@return	int 	duration of the video
	 */
		WebmdVideo.prototype.getDuration = function () {
			/*
	  if(this.isMobile()) {
	  	try {
	  		return document.getElementById(this._id).getElementsByTagName('video')[0].duration;
	  	} catch (e) {
	  		return 0;
	  	}
	  }
	  */
			return this._v !== null ? this._v.getDuration() : 0;
		};
	
		/**
	 *	returns the current video media information (source and meta data).
	 *
	 *	@return	Object 	Akamai media object (has video sources as well as meta data)
	 */
		WebmdVideo.prototype.getMedia = function () {
			return this._v !== null ? this._v.getMedia() : 0;
		};
	
		/**
	 *	returns the user defined config data
	 *
	 *	@return 	Object 	The user defined configuration
	 */
		WebmdVideo.prototype.getConfig = function () {
			return this._config;
		};
	
		/**
	 *	Returns the id of the video.
	 *
	 *	@param 	cb 	callback {before|after}
	 */
		WebmdVideo.prototype.getId = function () {
			return this._id;
		};
	
		/**
	 *	Returns whether the browser is mobile/tablet or desktop
	 *
	 *	@return 	boolean 	Whether or not the browser is mobile/tablet.
	 */
		WebmdVideo.prototype.isMobile = function () {
			//this line did not work for iPad and the chrome simulation mode
			//return window.matchMedia("only screen and (max-width: 760px)").matches||false;
	
			return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
			);
		};
	
		/**
	 *	Returns whether the browser is an ipad
	 *
	 *	@return 	boolean 	Whether or not the browser is an ipad.
	 */
		WebmdVideo.prototype.isIpad = function () {
			return (/iPad/i.test(navigator.userAgent)
			);
		};
	
		/**
	  *	Returns whether the browser is a smart phone
	  *
	  *	@return 	boolean 	Whether or not the browser is a smart phone.
	  */
		WebmdVideo.prototype.isSmartPhone = function () {
			/*
	   detection just for phones (excluding tablets).  The following logic is based on the following:
	   (1) //googlewebmastercentral.blogspot.com/2011/03/mo-better-to-also-detect-mobile-user.html
	   (2) wku's tests with real devices:  (a) both iphone and ipad contains the word 'Mobile' (b) android tablet does not contain the word 'Mobile'
	   */
	
			var userAgentStr = navigator.userAgent,
			    isAndroidPhone,
			    isOtherPhones;
	
			isAndroidPhone = userAgentStr.indexOf('Android') > -1 && userAgentStr.indexOf('Mobile') > -1;
			isOtherPhones = /iPhone|iPod|BlackBerry|IEMobile/i.test(userAgentStr);
	
			return isAndroidPhone === true || isOtherPhones === true;
		};
	
		WebmdVideo.prototype.isAutoplay = function () {
			if (this.getConfig().autoplay || this.getConfig().media.autoplay) {
				return true;
			}
	
			return false;
		};
	
		WebmdVideo.prototype.getTitle = function () {
			return this.getConfig().title || null;
		};
	
		/**
	 *	Creates a listener for the akamai video events
	 *
	 *	@param 	e 	string 	the name of the event
	 *	@param 	f 	function 	the callback that will be run when the event is invoked.
	 *
	 */
		WebmdVideo.prototype.addEventListener = function (e, f) {
			var self = this,
			    $v = $(self._v),
			    eventName = e.toString().split('.')[0];
	
			if (this.isMobile()) {
				/*
	   $v = $(document.getElementById(self._id).getElementsByTagName('video')[0]);
	   	if($v.length < 1) {
	   		setTimeout(function(){
	   		self.addEventListener(e,f);
	   	}, 100);
	   		return;
	   }
	   */
			}
	
			if (typeof this.setEvents[eventName] === 'undefined') {
				this.setEvents[eventName] = true;
	
				switch (eventName) {
					case 'volumechange':
					case 'mute':
					case 'unmute':
						$v.on('volumechange', function (e) {
							if (typeof e.detail === 'undefined' && typeof e.originalEvent.detail !== 'undefined') {
								e.detail = e.originalEvent.detail;
							}
							$(document.getElementById(self._id)).trigger('volumechange', { detail: e });
						});
	
						this.setEvents['volumechange'] = true;
						this.setEvents['mute'] = true;
						this.setEvents['unmute'] = true;
	
						break;
	
					case 'play':
						if (self.isMobile()) {
							$v = $(self._v.getMediaElement());
							self._v.getMediaElement().addEventListener('playing', function () {
								var $video;
								$('.akamai-play.akamai-overlay').addClass('hide-playlist');
								$(document.getElementById(self._id)).trigger('play', { detail: e });
								if (self.adPlaying) {
									$(document.getElementById(self._id)).trigger('ad-play', { detail: e });
								}
							});
						} else {
							$v.on('playing', function (e) {
								var $video;
								$(document.getElementById(self._id)).trigger('play', { detail: e });
	
								if (self.adPlaying) {
									$(document.getElementById(self._id)).trigger('ad-play', { detail: e });
								}
							});
						}
						break;
	
					case 'pause':
						if (self.isMobile()) {
							$v = $(self._v.getMediaElement());
	
							self._v.getMediaElement().addEventListener('pause', function () {
								$('.akamai-play.akamai-overlay').removeClass('hide-playlist');
								VideoActions.pause();
								if (self.adPlaying) {
									$(document.getElementById(self._id)).trigger('ad-pause', { detail: e });
								}
							});
						} else {
							$v.on('pause', function (e) {
								VideoActions.pause();
								if (self.adPlaying) {
									$(document.getElementById(self._id)).trigger('ad-pause', { detail: e });
								}
							});
						}
						break;
	
					case 'ended':
						$v.on('ended', function (e) {
							$(document.getElementById(self._id)).trigger('ended', { detail: e });
							/*
	      the next line is the workaround provided by Hudi in his email dated 3/26/2015 7:37pm titled: 'Re: [Amp-premier-impl] Akamai/WebMD Weekly Status'
	      the reason we need it is that, recent workaround for autoplay stopped the replay method from functioning when the autoplay is set to false.
	       */
							self._v.setAutoplay(true);
						});
						break;
	
					case 'visibilitychange':
					case 'closedcaption-off':
					case 'closedcaption-on':
						if (typeof self._v.captioning !== 'undefined') {
							$(self._v.captioning).on('visibilitychange', function (e) {
								$(document.getElementById(self._id)).trigger('visibilitychange', { detail: e });
	
								if (!e.originalEvent.detail) {
									$(document.getElementById(self._id)).trigger('closedcaption-off', { detail: e });
								} else {
									$(document.getElementById(self._id)).trigger('closedcaption-on', { detail: e });
								}
							});
						}
	
						this.setEvents['visibilitychange'] = true;
						this.setEvents['closedcaption-off'] = true;
						this.setEvents['closedcaption-on'] = true;
	
						break;
	
					case 'ad-started':
						self.ready(function () {
							if (typeof self._v.ads !== 'undefined') {
								$(self._v.ads).on('started', function (e) {
									var $video;
	
									if (self.isMobile()) {
										$video = $(document.getElementById(self._id)).find('video');
	
										if ($video.length > 0) {
											$video.get(0).controls = false;
										}
									}
									self.adPlaying = true;
									$(document.getElementById(self._id)).trigger('ad-started', { detail: e });
								});
							}
						});
						break;
	
					case 'ad-ended':
						self.ready(function () {
							if (typeof self._v.ads !== 'undefined') {
								$(self._v.ads).on('breakend', function (e) {
									var $video;
	
									if (self.isMobile()) {
										$video = $(document.getElementById(self._id)).find('video');
	
										if ($video.length > 0) {
											$video.get(0).controls = true;
										}
									}
									self.adPlaying = false;
									$(document.getElementById(self._id)).trigger('ad-ended', { detail: e });
								});
							}
						});
						break;
	
					case 'ad-error':
						self.ready(function () {
							if (typeof self._v.ads !== 'undefined') {
								$(self._v.ads).on('error', function (e) {
									$(document.getElementById(self._id)).trigger('ad-error', { detail: e });
								});
							}
						});
						break;
	
					case 'companion':
						self.ready(function () {
							if (typeof self._v.ads !== 'undefined') {
								$(self._v.ads).on('companion', function (e) {
									$(document.getElementById(self._id)).trigger('ad-companion', { detail: e });
								});
							}
						});
						break;
	
					case 'offline':
						$(window).on('offline', function (e) {
							$(document.getElementById(self._id)).trigger('offline', { detail: e });
						});
						break;
	
					default:
						$v.on(eventName, function (e) {
							$(document.getElementById(self._id)).trigger(eventName, { detail: e });
						});
						break;
	
				}
			}
	
			$(document.getElementById(this._id)).on(e, f);
		};
	
		/**
	 *	Triggers an event for the akamai video events
	 *
	 *	@param 	e 	string 	the name of the event
	 *
	 */
		WebmdVideo.prototype.triggerEvent = function (e) {
			$(document.getElementById(this._id)).trigger(e);
		};
	
		/**
	 *	Removes a listener for the akamai video events
	 *
	 *	@param 	e 	string 	the name of the event
	 *
	 */
		WebmdVideo.prototype.removeEventListener = function (e) {
			$(document.getElementById(this._id)).off(e);
		};
	
		return WebmdVideo;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(228)(__webpack_require__(229))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript === "function")
			execScript(src);
		else
			eval.call(null, src);
	}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = "(function(n){function i(a,d){this.setNotifyMethod(a);this.setNotifyContext(d)}function j(a,d,b){this.name=a;this.body=d;this.type=b}function k(){}function m(){}function l(){this.subCommands=[];this.initializeMacroCommand()}function g(a,d){this.mediatorName=a||this.constructor.NAME;this.viewComponent=d}function h(a,d){this.proxyName=a||this.constructor.NAME;null!=d&&this.setData(d)}function b(a){if(null!=b.instanceMap[a])throw Error(b.MULTITON_MSG);this.initializeNotifier(a);b.instanceMap[a]=this;\nthis.initializeFacade()}function c(a){if(null!=c.instanceMap[a])throw Error(c.MULTITON_MSG);this.multitonKey=a;c.instanceMap[this.multitonKey]=this;this.mediatorMap=[];this.observerMap=[];this.initializeView()}function e(a){if(e.instanceMap[a])throw Error(e.MULTITON_MSG);this.multitonKey=a;e.instanceMap[a]=this;this.proxyMap=[];this.initializeModel()}function f(a){if(null!=f.instanceMap[a])throw Error(f.MULTITON_MSG);this.multitonKey=a;f.instanceMap[this.multitonKey]=this;this.commandMap=[];this.initializeController()}\nfunction p(a,d,b){for(var a=a.split(\".\"),b=b||o.global,c,e,f=0,g=a.length;f<g;f++)c=b,e=a[f],b=null==b[e]?b[e]={}:b[e];return null==d?b:c[e]=d}null==n&&(n=window);if(!n.puremvc){i.prototype.setNotifyMethod=function(a){this.notify=a};i.prototype.setNotifyContext=function(a){this.context=a};i.prototype.getNotifyMethod=function(){return this.notify};i.prototype.getNotifyContext=function(){return this.context};i.prototype.notifyObserver=function(a){this.getNotifyMethod().call(this.getNotifyContext(),\na)};i.prototype.compareNotifyContext=function(a){return a===this.context};i.prototype.notify=null;i.prototype.context=null;j.prototype.getName=function(){return this.name};j.prototype.setBody=function(a){this.body=a};j.prototype.getBody=function(){return this.body};j.prototype.setType=function(a){this.type=a};j.prototype.getType=function(){return this.type};j.prototype.toString=function(){var a=\"Notification Name: \"+this.getName(),a=a+(\"\\nBody:\"+(null==this.body?\"null\":this.body.toString()));return a+=\n\"\\nType:\"+(null==this.type?\"null\":this.type)};j.prototype.name=null;j.prototype.type=null;j.prototype.body=null;k.prototype.sendNotification=function(a,d,b){var c=this.getFacade();c&&c.sendNotification(a,d,b)};k.prototype.initializeNotifier=function(a){this.multitonKey=\"\"+a;this.facade=this.getFacade()};k.prototype.getFacade=function(){if(null==this.multitonKey)throw Error(k.MULTITON_MSG);return b.getInstance(this.multitonKey)};k.prototype.multitonKey=null;k.MULTITON_MSG=\"multitonKey for this Notifier not yet initialized!\";\nm.prototype=new k;m.prototype.constructor=m;m.prototype.execute=function(){};l.prototype=new k;l.prototype.constructor=l;l.prototype.subCommands=null;l.prototype.initializeMacroCommand=function(){};l.prototype.addSubCommand=function(a){this.subCommands.push(a)};l.prototype.execute=function(a){for(;0<this.subCommands.length;){var d=new (this.subCommands.shift());d.initializeNotifier(this.multitonKey);d.execute(a)}};g.NAME=\"Mediator\";g.prototype=new k;g.prototype.constructor=g;g.prototype.getMediatorName=\nfunction(){return this.mediatorName};g.prototype.setViewComponent=function(a){this.viewComponent=a};g.prototype.getViewComponent=function(){return this.viewComponent};g.prototype.listNotificationInterests=function(){return[]};g.prototype.handleNotification=function(){};g.prototype.onRegister=function(){};g.prototype.onRemove=function(){};g.prototype.mediatorName=null;g.prototype.viewComponent=null;h.NAME=\"Proxy\";h.prototype=new k;h.prototype.constructor=h;h.prototype.getProxyName=function(){return this.proxyName};\nh.prototype.setData=function(a){this.data=a};h.prototype.getData=function(){return this.data};h.prototype.onRegister=function(){};h.prototype.onRemove=function(){};h.prototype.proxyName=null;h.prototype.data=null;b.prototype.initializeFacade=function(){this.initializeModel();this.initializeController();this.initializeView()};b.getInstance=function(a){if(null==a)return null;null==b.instanceMap[a]&&(b.instanceMap[a]=new b(a));return b.instanceMap[a]};b.prototype.initializeController=function(){if(null==\nthis.controller)this.controller=f.getInstance(this.multitonKey)};b.prototype.initializeModel=function(){if(null==this.model)this.model=e.getInstance(this.multitonKey)};b.prototype.initializeView=function(){if(null==this.view)this.view=c.getInstance(this.multitonKey)};b.prototype.registerCommand=function(a,d){this.controller.registerCommand(a,d)};b.prototype.removeCommand=function(a){this.controller.removeCommand(a)};b.prototype.hasCommand=function(a){return this.controller.hasCommand(a)};b.prototype.registerProxy=\nfunction(a){this.model.registerProxy(a)};b.prototype.retrieveProxy=function(a){return this.model.retrieveProxy(a)};b.prototype.removeProxy=function(a){var d=null;null!=this.model&&(d=this.model.removeProxy(a));return d};b.prototype.hasProxy=function(a){return this.model.hasProxy(a)};b.prototype.registerMediator=function(a){null!=this.view&&this.view.registerMediator(a)};b.prototype.retrieveMediator=function(a){return this.view.retrieveMediator(a)};b.prototype.removeMediator=function(a){var d=null;\nnull!=this.view&&(d=this.view.removeMediator(a));return d};b.prototype.hasMediator=function(a){return this.view.hasMediator(a)};b.prototype.sendNotification=function(a,d,b){this.notifyObservers(new j(a,d,b))};b.prototype.notifyObservers=function(a){null!=this.view&&this.view.notifyObservers(a)};b.prototype.initializeNotifier=function(a){this.multitonKey=a};b.hasCore=function(a){return null!=b.instanceMap[a]};b.removeCore=function(a){null!=b.instanceMap[a]&&(e.removeModel(a),c.removeView(a),f.removeController(a),\ndelete b.instanceMap[a])};b.prototype.controller=null;b.prototype.model=null;b.prototype.view=null;b.prototype.multitonKey=null;b.instanceMap=[];b.MULTITON_MSG=\"Facade instance for this Multiton key already constructed!\";c.prototype.initializeView=function(){};c.getInstance=function(a){if(null==a)return null;null==c.instanceMap[a]&&(c.instanceMap[a]=new c(a));return c.instanceMap[a]};c.prototype.registerObserver=function(a,d){null!=this.observerMap[a]?this.observerMap[a].push(d):this.observerMap[a]=\n[d]};c.prototype.notifyObservers=function(a){if(null!=this.observerMap[a.getName()]){for(var d=this.observerMap[a.getName()],b=[],c,e=0;e<d.length;e++)c=d[e],b.push(c);for(e=0;e<b.length;e++)c=b[e],c.notifyObserver(a)}};c.prototype.removeObserver=function(a,d){for(var b=this.observerMap[a],c=0;c<b.length;c++)if(!0==b[c].compareNotifyContext(d)){b.splice(c,1);break}0==b.length&&delete this.observerMap[a]};c.prototype.registerMediator=function(a){if(null==this.mediatorMap[a.getMediatorName()]){a.initializeNotifier(this.multitonKey);\nthis.mediatorMap[a.getMediatorName()]=a;var d=a.listNotificationInterests();if(0<d.length)for(var b=new i(a.handleNotification,a),c=0;c<d.length;c++)this.registerObserver(d[c],b);a.onRegister()}};c.prototype.retrieveMediator=function(a){return this.mediatorMap[a]};c.prototype.removeMediator=function(a){var d=this.mediatorMap[a];if(d){for(var b=d.listNotificationInterests(),c=0;c<b.length;c++)this.removeObserver(b[c],d);delete this.mediatorMap[a];d.onRemove()}return d};c.prototype.hasMediator=function(a){return null!=\nthis.mediatorMap[a]};c.removeView=function(a){delete c.instanceMap[a]};c.prototype.mediatorMap=null;c.prototype.observerMap=null;c.instanceMap=[];c.prototype.multitonKey=null;c.MULTITON_MSG=\"View instance for this Multiton key already constructed!\";e.prototype.initializeModel=function(){};e.getInstance=function(a){if(null==a)return null;null==e.instanceMap[a]&&(e.instanceMap[a]=new e(a));return e.instanceMap[a]};e.prototype.registerProxy=function(a){a.initializeNotifier(this.multitonKey);this.proxyMap[a.getProxyName()]=\na;a.onRegister()};e.prototype.retrieveProxy=function(a){return this.proxyMap[a]};e.prototype.hasProxy=function(a){return null!=this.proxyMap[a]};e.prototype.removeProxy=function(a){var b=this.proxyMap[a];b&&(this.proxyMap[a]=null,b.onRemove());return b};e.removeModel=function(a){delete e.instanceMap[a]};e.prototype.proxyMap=null;e.instanceMap=[];e.MULTITON_MSG=\"Model instance for this Multiton key already constructed!\";f.prototype.initializeController=function(){this.view=c.getInstance(this.multitonKey)};\nf.getInstance=function(a){if(null==a)return null;null==this.instanceMap[a]&&(this.instanceMap[a]=new this(a));return this.instanceMap[a]};f.prototype.executeCommand=function(a){var b=this.commandMap[a.getName()];null!=b&&(b=new b,b.initializeNotifier(this.multitonKey),b.execute(a))};f.prototype.registerCommand=function(a,b){null==this.commandMap[a]&&this.view.registerObserver(a,new i(this.executeCommand,this));this.commandMap[a]=b};f.prototype.hasCommand=function(a){return null!=this.commandMap[a]};\nf.prototype.removeCommand=function(a){this.hasCommand(a)&&(this.view.removeObserver(a,this),this.commandMap[a]=null)};f.removeController=function(a){delete this.instanceMap[a]};f.prototype.view=null;f.prototype.commandMap=null;f.prototype.multitonKey=null;f.instanceMap=[];f.MULTITON_MSG=\"controller key for this Multiton key already constructed\";var o={global:function(){return this}(),extend:function(a,b){if(\"function\"!==typeof a)throw new TypeError(\"#extend- child should be Function\");if(\"function\"!==\ntypeof b)throw new TypeError(\"#extend- parent should be Function\");if(b!==a){var c=new Function;c.prototype=b.prototype;a.prototype=new c;return a.prototype.constructor=a}},decorate:function(a,b){for(var c in b)a[c]=b[c];return a}};n.puremvc={View:c,Model:e,Controller:f,SimpleCommand:m,MacroCommand:l,Facade:b,Mediator:g,Observer:i,Notification:j,Notifier:k,Proxy:h,define:function(a,b,c){a||(a={});var e=a.name,f=a.parent,g=\"function\"===typeof f,h=a.scope||null;if(\"parent\"in a&&!g)throw new TypeError(\"Class parent must be Function\");\nif(a.hasOwnProperty(\"constructor\")){if(a=a.constructor,\"function\"!==typeof a)throw new TypeError(\"Class constructor must be Function\");}else a=g?function(){f.apply(this,arguments)}:new Function;g&&o.extend(a,f);if(b)g=a.prototype,o.decorate(g,b),g.constructor=a;c&&o.decorate(a,c);if(e){if(\"string\"!==typeof e)throw new TypeError(\"Class name must be primitive string\");p(e,a,h)}return a},declare:p}}})(this);\ntry{var ce=new window.CustomEvent(\"test\");ce.preventDefault();if(!0!==ce.defaultPrevented)throw Error(\"Could not prevent default\");}catch(e){var CustomEvent=function(d,a){var b,c;a=a||{bubbles:!1,cancelable:!1,detail:void 0};b=document.createEvent(\"CustomEvent\");b.initCustomEvent(d,a.bubbles,a.cancelable,a.detail);c=b.preventDefault;b.preventDefault=function(){c.call(this);try{Object.defineProperty(this,\"defaultPrevented\",{get:function(){return!0}})}catch(f){this.defaultPrevented=!0}};return b};CustomEvent.prototype=\nwindow.Event.prototype;window.CustomEvent=CustomEvent};\n!function(e){var r=e.babelHelpers={};r.typeof=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":typeof e},r.jsx=function(){var e=\"function\"==typeof Symbol&&Symbol.for&&Symbol.for(\"react.element\")||60103;return function(r,t,n,o){var i=r&&r.defaultProps,u=arguments.length-3;if(t||0===u||(t={}),t&&i)for(var a in i)void 0===t[a]&&(t[a]=i[a]);else t||(t=i||{});if(1===u)t.children=o;else if(u>1){for(var f=Array(u),l=0;l<u;l++)f[l]=arguments[l+3];t.children=f}return{$$typeof:e,type:r,key:void 0===n?null:\"\"+n,ref:null,props:t,_owner:null}}}(),r.asyncIterator=function(e){if(\"function\"==typeof Symbol){if(Symbol.asyncIterator){var r=e[Symbol.asyncIterator];if(null!=r)return r.call(e)}if(Symbol.iterator)return e[Symbol.iterator]()}throw new TypeError(\"Object is not async iterable\")},r.asyncGenerator=function(){function e(e){this.value=e}function r(r){function t(e,r){return new Promise(function(t,o){var a={key:e,arg:r,resolve:t,reject:o,next:null};u?u=u.next=a:(i=u=a,n(e,r))})}function n(t,i){try{var u=r[t](i),a=u.value;a instanceof e?Promise.resolve(a.value).then(function(e){n(\"next\",e)},function(e){n(\"throw\",e)}):o(u.done?\"return\":\"normal\",u.value)}catch(e){o(\"throw\",e)}}function o(e,r){switch(e){case\"return\":i.resolve({value:r,done:!0});break;case\"throw\":i.reject(r);break;default:i.resolve({value:r,done:!1})}i=i.next,i?n(i.key,i.arg):u=null}var i,u;this._invoke=t,\"function\"!=typeof r.return&&(this.return=void 0)}return\"function\"==typeof Symbol&&Symbol.asyncIterator&&(r.prototype[Symbol.asyncIterator]=function(){return this}),r.prototype.next=function(e){return this._invoke(\"next\",e)},r.prototype.throw=function(e){return this._invoke(\"throw\",e)},r.prototype.return=function(e){return this._invoke(\"return\",e)},{wrap:function(e){return function(){return new r(e.apply(this,arguments))}},await:function(r){return new e(r)}}}(),r.asyncGeneratorDelegate=function(e,r){function t(t,n){return o=!0,n=new Promise(function(r){r(e[t](n))}),{done:!1,value:r(n)}}var n={},o=!1;return\"function\"==typeof Symbol&&Symbol.iterator&&(n[Symbol.iterator]=function(){return this}),n.next=function(e){return o?(o=!1,e):t(\"next\",e)},\"function\"==typeof e.throw&&(n.throw=function(e){if(o)throw o=!1,e;return t(\"throw\",e)}),\"function\"==typeof e.return&&(n.return=function(e){return t(\"return\",e)}),n},r.asyncToGenerator=function(e){return function(){var r=e.apply(this,arguments);return new Promise(function(e,t){function n(o,i){try{var u=r[o](i),a=u.value}catch(e){return void t(e)}return u.done?void e(a):Promise.resolve(a).then(function(e){n(\"next\",e)},function(e){n(\"throw\",e)})}return n(\"next\")})}},r.classCallCheck=function(e,r){if(!(e instanceof r))throw new TypeError(\"Cannot call a class as a function\")},r.createClass=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,\"value\"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),r.defineEnumerableProperties=function(e,r){for(var t in r){var n=r[t];n.configurable=n.enumerable=!0,\"value\"in n&&(n.writable=!0),Object.defineProperty(e,t,n)}return e},r.defaults=function(e,r){for(var t=Object.getOwnPropertyNames(r),n=0;n<t.length;n++){var o=t[n],i=Object.getOwnPropertyDescriptor(r,o);i&&i.configurable&&void 0===e[o]&&Object.defineProperty(e,o,i)}return e},r.defineProperty=function(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e},r.extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},r.get=function e(r,t,n){null===r&&(r=Function.prototype);var o=Object.getOwnPropertyDescriptor(r,t);if(void 0===o){var i=Object.getPrototypeOf(r);return null===i?void 0:e(i,t,n)}if(\"value\"in o)return o.value;var u=o.get;if(void 0!==u)return u.call(n)},r.inherits=function(e,r){if(\"function\"!=typeof r&&null!==r)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)},r.instanceof=function(e,r){return null!=r&&\"undefined\"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r},r.interopRequireDefault=function(e){return e&&e.__esModule?e:{default:e}},r.interopRequireWildcard=function(e){if(e&&e.__esModule)return e;var r={};if(null!=e)for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=e[t]);return r.default=e,r},r.newArrowCheck=function(e,r){if(e!==r)throw new TypeError(\"Cannot instantiate an arrow function\")},r.objectDestructuringEmpty=function(e){if(null==e)throw new TypeError(\"Cannot destructure undefined\")},r.objectWithoutProperties=function(e,r){var t={};for(var n in e)r.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t},r.possibleConstructorReturn=function(e,r){if(!e)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!r||\"object\"!=typeof r&&\"function\"!=typeof r?e:r},r.selfGlobal=\"undefined\"==typeof e?self:e,r.set=function e(r,t,n,o){var i=Object.getOwnPropertyDescriptor(r,t);if(void 0===i){var u=Object.getPrototypeOf(r);null!==u&&e(u,t,n,o)}else if(\"value\"in i&&i.writable)i.value=n;else{var a=i.set;void 0!==a&&a.call(o,n)}return n},r.slicedToArray=function(){function e(e,r){var t=[],n=!0,o=!1,i=void 0;try{for(var u,a=e[Symbol.iterator]();!(n=(u=a.next()).done)&&(t.push(u.value),!r||t.length!==r);n=!0);}catch(e){o=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(o)throw i}}return t}return function(r,t){if(Array.isArray(r))return r;if(Symbol.iterator in Object(r))return e(r,t);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),r.slicedToArrayLoose=function(e,r){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e)){for(var t,n=[],o=e[Symbol.iterator]();!(t=o.next()).done&&(n.push(t.value),!r||n.length!==r););return n}throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")},r.taggedTemplateLiteral=function(e,r){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))},r.taggedTemplateLiteralLoose=function(e,r){return e.raw=r,e},r.temporalRef=function(e,r,t){if(e===t)throw new ReferenceError(r+\" is not defined - temporal dead zone\");return e},r.temporalUndefined={},r.toArray=function(e){return Array.isArray(e)?e:Array.from(e)},r.toConsumableArray=function(e){if(Array.isArray(e)){for(var r=0,t=Array(e.length);r<e.length;r++)t[r]=e[r];return t}return Array.from(e)}}(\"undefined\"==typeof global?self:global);\n/*! DOMTokenlist shim | Copyright 2016 Jonathan Wilsson and Bogdan Chadkin. */\n\"undefined\"!=typeof window&&function(e){\"use strict\";if(e.DOMTokenList){var t=document.createElement(\"a\").classList,n=DOMTokenList.prototype,i=n.add,o=n.remove,r=n.toggle;t.add(\"c1\",\"c2\");var s=function(e){return function(){var t,n=arguments;for(t=0;t<n.length;t+=1)e.call(this,n[t])}};t.contains(\"c2\")||(n.add=s(i),n.remove=s(o)),t.toggle(\"c1\",!0)||(n.toggle=function(e,t){return void 0===t?r.call(this,e):((t?i:o).call(this,e),!!t)})}}(window),\"undefined\"!=typeof window&&function(e){\"use strict\";var t=[],n=function(e,n){var i;if(t.indexOf)return t.indexOf.call(e,n);for(i=0;i<e.length;i++)if(e[i]===n)return i;return-1},i=function(e){var t=/[\\u0009\\u000A\\u000C\\u000D\\u0020]/;if(\"\"===e||t.test(e))throw new Error(\"Token must not be empty or contain whitespace.\")},o=function(e,t){var n,i=this,o=[];if(e&&t&&(i.element=e,i.prop=t,e[t]))for(o=e[t].replace(/^\\s+|\\s+$/g,\"\").split(/\\s+/),n=0;n<o.length;n++)i[n]=o[n];i.length=o.length};o.prototype={add:function(){var e,n=this,o=arguments;for(e=0;e<o.length;e++)i(o[e]),n.contains(o[e])||t.push.call(n,o[e]);n.element&&(n.element[n.prop]=n)},contains:function(e){return i(e),-1!==n(this,e)},item:function(e){return this[e]||null},remove:function(){var e,o,r=arguments,s=this;for(o=0;o<r.length;o++)i(r[o]),e=n(s,r[o]),-1!==e&&t.splice.call(s,e,1);s.element&&(s.element[s.prop]=s)},toggle:function(e,t){var n=this;return n.contains(e)?t?!0:(n.remove(e),!1):t===!1?!1:(n.add(e),!0)},toString:function(){return t.join.call(this,\" \")}},e.DOMTokenList=o}(window),\"undefined\"!=typeof window&&function(){\"use strict\";\"classList\"in document.createElement(\"a\")||Object.defineProperty(Element.prototype,\"classList\",{get:function(){return new DOMTokenList(this,\"className\")}})}(),\"undefined\"!=typeof window&&function(){\"use strict\";if(!(\"relList\"in document.createElement(\"a\"))){var e,t=[HTMLAnchorElement,HTMLAreaElement,HTMLLinkElement],n=function(){return new DOMTokenList(this,\"rel\")};for(e=0;e<t.length;e++)Object.defineProperty(t[e].prototype,\"relList\",{get:n})}}(),\"undefined\"!=typeof window&&function(){\"use strict\";if(\"undefined\"!=typeof SVGElement){var e=document.createElementNS(\"http://www.w3.org/2000/svg\",\"svg\");\"classList\"in e&&!window.QUnit||Object.defineProperty(SVGElement.prototype,\"classList\",{get:function(){return\"string\"==typeof this.className?new DOMTokenList(this,\"className\"):\"string\"==typeof this.className.baseVal?new DOMTokenList(this.className,\"baseVal\"):void 0}})}}();\n\n\"function\"!=typeof Object.assign&&(Object.assign=function(c){if(null==c)throw new TypeError(\"Cannot convert undefined or null to object\");c=Object(c);for(var e=1;e<arguments.length;e++){var b=arguments[e];if(null!=b)for(var d in b)Object.prototype.hasOwnProperty.call(b,d)&&(c[d]=b[d])}return c});\nArray.prototype.findIndex||Object.defineProperty(Array.prototype,\"findIndex\",{value:function(c,e){if(null==this)throw new TypeError('\"this\" is null or not defined');var b=Object(this),d=b.length>>>0;if(\"function\"!==typeof c)throw new TypeError(\"predicate must be a function\");for(var a=0;a<d;){if(c.call(e,b[a],a,b))return a;a++}return-1}});\nArray.prototype.includes||Object.defineProperty(Array.prototype,\"includes\",{value:function(c,e){if(null==this)throw new TypeError('\"this\" is null or not defined');var b=Object(this),d=b.length>>>0;if(0===d)return!1;var a=e|0;for(a=Math.max(0<=a?a:d-Math.abs(a),0);a<d;){var f=b[a],g=c;if(f===g||\"number\"===typeof f&&\"number\"===typeof g&&isNaN(f)&&isNaN(g))return!0;a++}return!1}});\n\n/*!\n * Bowser - a browser detector\n * https://github.com/ded/bowser\n * MIT License | (c) Dustin Diaz 2015\n */\n!function(e,t,n){typeof module!=\"undefined\"&&module.exports?module.exports=n():typeof define==\"function\"&&define.amd?define(t,n):e[t]=n()}(this,\"bowser\",function(){function t(t){function n(e){var n=t.match(e);return n&&n.length>1&&n[1]||\"\"}function r(e){var n=t.match(e);return n&&n.length>1&&n[2]||\"\"}function N(e){switch(e){case\"NT\":return\"NT\";case\"XP\":return\"XP\";case\"NT 5.0\":return\"2000\";case\"NT 5.1\":return\"XP\";case\"NT 5.2\":return\"2003\";case\"NT 6.0\":return\"Vista\";case\"NT 6.1\":return\"7\";case\"NT 6.2\":return\"8\";case\"NT 6.3\":return\"8.1\";case\"NT 10.0\":return\"10\";default:return undefined}}var i=n(/(ipod|iphone|ipad)/i).toLowerCase(),s=/like android/i.test(t),o=!s&&/android/i.test(t),u=/nexus\\s*[0-6]\\s*/i.test(t),a=!u&&/nexus\\s*[0-9]+/i.test(t),f=/CrOS/.test(t),l=/silk/i.test(t),c=/sailfish/i.test(t),h=/tizen/i.test(t),p=/(web|hpw)os/i.test(t),d=/windows phone/i.test(t),v=/SamsungBrowser/i.test(t),m=!d&&/windows/i.test(t),g=!i&&!l&&/macintosh/i.test(t),y=!o&&!c&&!h&&!p&&/linux/i.test(t),b=r(/edg([ea]|ios)\\/(\\d+(\\.\\d+)?)/i),w=n(/version\\/(\\d+(\\.\\d+)?)/i),E=/tablet/i.test(t)&&!/tablet pc/i.test(t),S=!E&&/[^-]mobi/i.test(t),x=/xbox/i.test(t),T;/opera/i.test(t)?T={name:\"Opera\",opera:e,version:w||n(/(?:opera|opr|opios)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/opr\\/|opios/i.test(t)?T={name:\"Opera\",opera:e,version:n(/(?:opr|opios)[\\s\\/](\\d+(\\.\\d+)?)/i)||w}:/SamsungBrowser/i.test(t)?T={name:\"Samsung Internet for Android\",samsungBrowser:e,version:w||n(/(?:SamsungBrowser)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/coast/i.test(t)?T={name:\"Opera Coast\",coast:e,version:w||n(/(?:coast)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/yabrowser/i.test(t)?T={name:\"Yandex Browser\",yandexbrowser:e,version:w||n(/(?:yabrowser)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/ucbrowser/i.test(t)?T={name:\"UC Browser\",ucbrowser:e,version:n(/(?:ucbrowser)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/mxios/i.test(t)?T={name:\"Maxthon\",maxthon:e,version:n(/(?:mxios)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/epiphany/i.test(t)?T={name:\"Epiphany\",epiphany:e,version:n(/(?:epiphany)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/puffin/i.test(t)?T={name:\"Puffin\",puffin:e,version:n(/(?:puffin)[\\s\\/](\\d+(?:\\.\\d+)?)/i)}:/sleipnir/i.test(t)?T={name:\"Sleipnir\",sleipnir:e,version:n(/(?:sleipnir)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/k-meleon/i.test(t)?T={name:\"K-Meleon\",kMeleon:e,version:n(/(?:k-meleon)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:d?(T={name:\"Windows Phone\",osname:\"Windows Phone\",windowsphone:e},b?(T.msedge=e,T.version=b):(T.msie=e,T.version=n(/iemobile\\/(\\d+(\\.\\d+)?)/i))):/msie|trident/i.test(t)?T={name:\"Internet Explorer\",msie:e,version:n(/(?:msie |rv:)(\\d+(\\.\\d+)?)/i)}:f?T={name:\"Chrome\",osname:\"Chrome OS\",chromeos:e,chromeBook:e,chrome:e,version:n(/(?:chrome|crios|crmo)\\/(\\d+(\\.\\d+)?)/i)}:/edg([ea]|ios)/i.test(t)?T={name:\"Microsoft Edge\",msedge:e,version:b}:/vivaldi/i.test(t)?T={name:\"Vivaldi\",vivaldi:e,version:n(/vivaldi\\/(\\d+(\\.\\d+)?)/i)||w}:c?T={name:\"Sailfish\",osname:\"Sailfish OS\",sailfish:e,version:n(/sailfish\\s?browser\\/(\\d+(\\.\\d+)?)/i)}:/seamonkey\\//i.test(t)?T={name:\"SeaMonkey\",seamonkey:e,version:n(/seamonkey\\/(\\d+(\\.\\d+)?)/i)}:/firefox|iceweasel|fxios/i.test(t)?(T={name:\"Firefox\",firefox:e,version:n(/(?:firefox|iceweasel|fxios)[ \\/](\\d+(\\.\\d+)?)/i)},/\\((mobile|tablet);[^\\)]*rv:[\\d\\.]+\\)/i.test(t)&&(T.firefoxos=e,T.osname=\"Firefox OS\")):l?T={name:\"Amazon Silk\",silk:e,version:n(/silk\\/(\\d+(\\.\\d+)?)/i)}:/phantom/i.test(t)?T={name:\"PhantomJS\",phantom:e,version:n(/phantomjs\\/(\\d+(\\.\\d+)?)/i)}:/slimerjs/i.test(t)?T={name:\"SlimerJS\",slimer:e,version:n(/slimerjs\\/(\\d+(\\.\\d+)?)/i)}:/blackberry|\\bbb\\d+/i.test(t)||/rim\\stablet/i.test(t)?T={name:\"BlackBerry\",osname:\"BlackBerry OS\",blackberry:e,version:w||n(/blackberry[\\d]+\\/(\\d+(\\.\\d+)?)/i)}:p?(T={name:\"WebOS\",osname:\"WebOS\",webos:e,version:w||n(/w(?:eb)?osbrowser\\/(\\d+(\\.\\d+)?)/i)},/touchpad\\//i.test(t)&&(T.touchpad=e)):/bada/i.test(t)?T={name:\"Bada\",osname:\"Bada\",bada:e,version:n(/dolfin\\/(\\d+(\\.\\d+)?)/i)}:h?T={name:\"Tizen\",osname:\"Tizen\",tizen:e,version:n(/(?:tizen\\s?)?browser\\/(\\d+(\\.\\d+)?)/i)||w}:/qupzilla/i.test(t)?T={name:\"QupZilla\",qupzilla:e,version:n(/(?:qupzilla)[\\s\\/](\\d+(?:\\.\\d+)+)/i)||w}:/chromium/i.test(t)?T={name:\"Chromium\",chromium:e,version:n(/(?:chromium)[\\s\\/](\\d+(?:\\.\\d+)?)/i)||w}:/chrome|crios|crmo/i.test(t)?T={name:\"Chrome\",chrome:e,version:n(/(?:chrome|crios|crmo)\\/(\\d+(\\.\\d+)?)/i)}:o?T={name:\"Android\",version:w}:/safari|applewebkit/i.test(t)?(T={name:\"Safari\",safari:e},w&&(T.version=w)):i?(T={name:i==\"iphone\"?\"iPhone\":i==\"ipad\"?\"iPad\":\"iPod\"},w&&(T.version=w)):/googlebot/i.test(t)?T={name:\"Googlebot\",googlebot:e,version:n(/googlebot\\/(\\d+(\\.\\d+))/i)||w}:T={name:n(/^(.*)\\/(.*) /),version:r(/^(.*)\\/(.*) /)},!T.msedge&&/(apple)?webkit/i.test(t)?(/(apple)?webkit\\/537\\.36/i.test(t)?(T.name=T.name||\"Blink\",T.blink=e):(T.name=T.name||\"Webkit\",T.webkit=e),!T.version&&w&&(T.version=w)):!T.opera&&/gecko\\//i.test(t)&&(T.name=T.name||\"Gecko\",T.gecko=e,T.version=T.version||n(/gecko\\/(\\d+(\\.\\d+)?)/i)),!T.windowsphone&&(o||T.silk)?(T.android=e,T.osname=\"Android\"):!T.windowsphone&&i?(T[i]=e,T.ios=e,T.osname=\"iOS\"):g?(T.mac=e,T.osname=\"macOS\"):x?(T.xbox=e,T.osname=\"Xbox\"):m?(T.windows=e,T.osname=\"Windows\"):y&&(T.linux=e,T.osname=\"Linux\");var C=\"\";T.windows?C=N(n(/Windows ((NT|XP)( \\d\\d?.\\d)?)/i)):T.windowsphone?C=n(/windows phone (?:os)?\\s?(\\d+(\\.\\d+)*)/i):T.mac?(C=n(/Mac OS X (\\d+([_\\.\\s]\\d+)*)/i),C=C.replace(/[_\\s]/g,\".\")):i?(C=n(/os (\\d+([_\\s]\\d+)*) like mac os x/i),C=C.replace(/[_\\s]/g,\".\")):o?C=n(/android[ \\/-](\\d+(\\.\\d+)*)/i):T.webos?C=n(/(?:web|hpw)os\\/(\\d+(\\.\\d+)*)/i):T.blackberry?C=n(/rim\\stablet\\sos\\s(\\d+(\\.\\d+)*)/i):T.bada?C=n(/bada\\/(\\d+(\\.\\d+)*)/i):T.tizen&&(C=n(/tizen[\\/\\s](\\d+(\\.\\d+)*)/i)),C&&(T.osversion=C);var k=!T.windows&&C.split(\".\")[0];if(E||a||i==\"ipad\"||o&&(k==3||k>=4&&!S)||T.silk)T.tablet=e;else if(S||i==\"iphone\"||i==\"ipod\"||o||u||T.blackberry||T.webos||T.bada)T.mobile=e;return T.msedge||T.msie&&T.version>=10||T.yandexbrowser&&T.version>=15||T.vivaldi&&T.version>=1||T.chrome&&T.version>=20||T.samsungBrowser&&T.version>=4||T.firefox&&T.version>=20||T.safari&&T.version>=6||T.opera&&T.version>=10||T.ios&&T.osversion&&T.osversion.split(\".\")[0]>=6||T.blackberry&&T.version>=10.1||T.chromium&&T.version>=20?T.a=e:T.msie&&T.version<10||T.chrome&&T.version<20||T.firefox&&T.version<20||T.safari&&T.version<6||T.opera&&T.version<10||T.ios&&T.osversion&&T.osversion.split(\".\")[0]<6||T.chromium&&T.version<20?T.c=e:T.x=e,T}function r(e){return e.split(\".\").length}function i(e,t){var n=[],r;if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r++)n.push(t(e[r]));return n}function s(e){var t=Math.max(r(e[0]),r(e[1])),n=i(e,function(e){var n=t-r(e);return e+=(new Array(n+1)).join(\".0\"),i(e.split(\".\"),function(e){return(new Array(20-e.length)).join(\"0\")+e}).reverse()});while(--t>=0){if(n[0][t]>n[1][t])return 1;if(n[0][t]!==n[1][t])return-1;if(t===0)return 0}}function o(e,r,i){var o=n;typeof r==\"string\"&&(i=r,r=void 0),r===void 0&&(r=!1),i&&(o=t(i));var u=\"\"+o.version;for(var a in e)if(e.hasOwnProperty(a)&&o[a]){if(typeof e[a]!=\"string\")throw new Error(\"Browser version in the minVersion map should be a string: \"+a+\": \"+String(e));return s([u,e[a]])<0}return r}function u(e,t,n){return!o(e,t,n)}var e=!0,n=t(typeof navigator!=\"undefined\"?navigator.userAgent||\"\":\"\");return n.test=function(e){for(var t=0;t<e.length;++t){var r=e[t];if(typeof r==\"string\"&&r in n)return!0}return!1},n.isUnsupportedBrowser=o,n.compareVersions=s,n.check=u,n._detect=t,n.detect=t,n})\n!function(t,e){if(!t.ES6Promise){t.ES6Promise=e();t.ES6Promise.polyfill()}}(this,function(){\"use strict\";function t(t){return\"function\"==typeof t||\"object\"==typeof t&&null!==t}function e(t){return\"function\"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return\"undefined\"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode(\"\");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=t(\"vertx\");return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&\"object\"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError(\"You cannot resolve a promise with itself\")}function d(){return new TypeError(\"A promises callback cannot return that same promise.\")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},\"Settle: \"+(t._label||\" unknown promise\"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?j(t,it.error):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),P(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(P,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(P,t)}function P(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function T(){this.error=null}function M(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=M(r,o),s===st?(a=!0,u=s.error,s=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error(\"Array Methods must be provided an Array\")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError(\"You must pass an array to race.\"))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError(\"You must pass a resolver function as the first argument to the promise constructor\")}function N(){throw new TypeError(\"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.\")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&(\"function\"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if(\"undefined\"!=typeof global)t=global;else if(\"undefined\"!=typeof self)t=self;else try{t=Function(\"return this\")()}catch(e){throw new Error(\"polyfill failed because global object is unavailable in this environment\")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if(\"[object Promise]\"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return\"[object Array]\"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q=\"undefined\"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X=\"undefined\"==typeof self&&\"undefined\"!=typeof process&&\"[object process]\"==={}.toString.call(process),Z=\"undefined\"!=typeof Uint8ClampedArray&&\"undefined\"!=typeof importScripts&&\"undefined\"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&\"function\"==typeof require?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new T,st=new T,ut=0;return Y.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===nt&&n<t;n++)this._eachEntry(e[n],n)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if(\"function\"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,\"catch\":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U});\n\n(function() {\nvar  global, version, _ref;\n\n\n  function AkamaiSDKManager() {\n    var legacyCheck, sdk, versions,\n      _this = this;\n    sdk = null;\n    this.getSDK = function() {\n      return sdk;\n    };\n    this.setSDK = function(newSDK) {\n      var key, value;\n      sdk = newSDK;\n      legacyCheck();\n      for (key in sdk) {\n        value = sdk[key];\n        window[key] = value;\n      }\n      return sdk;\n    };\n    this.saveSDK = function(version, object) {\n      var key, value, _ref;\n      if (!(object != null) || !(version != null) || version === \"\") {\n        return;\n      }\n      if (!(object.main != null)) {\n        for (key in object) {\n          value = object[key];\n          if (!((value != null ? value.VERSION : void 0) === version)) {\n            continue;\n          }\n          object.main = value;\n          break;\n        }\n      }\n      if ((_ref = object.version) == null) {\n        object.version = version;\n      }\n      versions.push(object);\n      this[version] = object;\n      return object;\n    };\n    versions = [];\n    this.getVersions = function() {\n      return versions.slice();\n    };\n    this.getVersion = function(version) {\n      return this[version];\n    };\n    this.setVersion = function(version) {\n      sdk = this.getVersion(version);\n      if (!(sdk != null)) {\n        return null;\n      }\n      this.setSDK(sdk);\n      return sdk;\n    };\n    this.revert = function() {\n      return this.setSDK(versions[0]);\n    };\n    this.noConflict = function() {\n      var current;\n      current = this.getSDK();\n      this.revert();\n      return current;\n    };\n    this.create = (function() {\n      var Creator;\n      Creator = function(cls, args) {\n        this.prototype = cls.prototype;\n        return cls.apply(this, args);\n      };\n      return function(args) {\n        return new Creator(sdk.main, arguments);\n      };\n    })();\n    legacyCheck = function() {\n      var key, obj, value, _ref, _ref1;\n      if ((_ref = window.com) != null ? (_ref1 = _ref.akamai) != null ? _ref1.amp : void 0 : void 0) {\n        for (key in window) {\n          value = window[key];\n          if ((value === window.AMP || value === window.AMPremier) && ((value != null ? value.VERSION : void 0) != null) && value.VERSION !== \"\" && value.VERSION !== (sdk != null ? sdk.version : void 0) && (!(_this[value.VERSION] != null))) {\n            obj = {};\n            obj.main = value;\n            obj.com = window.com;\n            if (window.AMP) {\n              obj.AMP = window.AMP;\n            }\n            if (window.AMPPremier) {\n              obj.AMPremier = window.AMPPremier;\n            }\n            if (window.Utils) {\n              obj.Utils = window.Utils;\n            }\n            if (window.QueryString) {\n              obj.QueryString = window.QueryString;\n            }\n            if (window.QueryParams) {\n              obj.QueryParams = window.QueryParams;\n            }\n            _this.saveSDK(value.VERSION, obj);\n            break;\n          }\n        }\n      }\n    };\n    legacyCheck();\n  }\n\n\nif ((_ref = window.AKAMAI_MEDIA_PLAYER) == null) {\n  window.AKAMAI_MEDIA_PLAYER = new AkamaiSDKManager();\n}\nversion = \"AMP - Premier : WebMD v2.99.6\";\nif (!(window.AKAMAI_MEDIA_PLAYER[version] != null)) {\n  global = window.AKAMAI_MEDIA_PLAYER[version] = {};\n  /* Start JS Lib\n  */\n  function __hasProp(prop) {\n\treturn {}[\"hasOwnProperty\"](prop);\n}\n\nfunction __extends(child, parent) {\n\tfor (var key in parent) {\n\t\tif (__hasProp[\"call\"](parent, key))\n\t\t\tchild[key] = parent[key];\n\t}\n\tfunction ctor() {\n\t\tthis.constructor = child;\n\t}\n\n\tctor.prototype = parent.prototype;\n\tchild.prototype = new ctor;\n\tchild.__super__ = parent.prototype;\n\treturn child;\n}\n\nfunction __indexOf(item) {\n\tfor (var i = 0, l = this.length; i < l; i++) {\n\t\tif ( i in this && this[i] === item)\n\t\t\treturn i;\n\t}\n\treturn -1;\n}\n\nfunction __bind(fn, me) {\n\treturn function() {\n\t\treturn fn[\"apply\"](me, arguments);\n\t};\n}\n\nfunction QueryString() {}\n\nQueryString.construct = function() {\n  var key, value, vars;\n  vars = this.decode(window.location.search);\n  QueryString.typed = {};\n  for (key in vars) {\n    value = vars[key];\n    QueryString[key] = value;\n    QueryString.typed[key] = this.parse(value);\n  }\n  return true;\n};\n\nQueryString.encode = function(obj, prefix) {\n  var k, p, str, v;\n  str = [];\n  for (p in obj) {\n    v = obj[p];\n    if (!(v != null)) {\n      continue;\n    }\n    k = (prefix ? prefix + \"[\" + p + \"]\" : p);\n    str.push((typeof v === \"object\" ? this.encode(v, k) : k + \"=\" + encodeURIComponent(v)));\n  }\n  return str.join(\"&\");\n};\n\nQueryString.decode = function(uri) {\n  var results,\n    _this = this;\n  if (uri != null) {\n    results = {};\n    uri = uri.replace(/^[^?]*\\?/, \"\");\n    uri.replace(new RegExp(\"([^?=&]+)(=([^&]*))?\", \"g\"), function($0, $1, $2, $3) {\n      var key, obj, value;\n      key = decodeURIComponent($1);\n      value = decodeURIComponent($3);\n      if (/~/.test(value)) {\n        value = _this.decodeObject(value);\n      }\n      if (/\\[/.test(key)) {\n        obj = key.match(/[^\\[]+/)[0];\n        key = key.match(/\\[([A-Za-z]+)\\]/)[1];\n        if (results[obj] == null) {\n          results[obj] = {};\n        }\n        results[obj][key] = value;\n        return;\n      }\n      results[key] = value;\n    });\n  }\n  return results;\n};\n\nQueryString.decodeObject = function(uri) {\n  var results,\n    _this = this;\n  if (uri != null) {\n    results = {};\n    uri.replace(/([^:~]+)(:([^~]*))?/g, function($0, $1, $2, $3) {\n      results[decodeURIComponent($1)] = _this.parse(decodeURIComponent($3));\n    });\n  }\n  return results;\n};\n\nQueryString.parse = function(value) {\n  var temp;\n  if (typeof value === \"object\") {\n    return value;\n  }\n  if (value === \"undefined\") {\n    return true;\n  }\n  temp = value.toLowerCase();\n  if (temp === \"true\" || temp === \"false\") {\n    return temp === \"true\";\n  }\n  if (temp === \"null\") {\n    return null;\n  }\n  temp = parseFloat(value);\n  if (!isNaN(temp)) {\n    return temp;\n  }\n  try {\n    temp = JSON.parse(value);\n    return temp;\n  } catch (error) {\n    return value;\n  }\n};\n\nQueryString.constructed = QueryString.construct();\n\n/**\n * The Config class\n *\n * @param Object} overrides\n *    Config overrides\n *\n * @constructor\n*/\nfunction Config(overrides) {\n  var config, key, react, value;\n  if (overrides == null) {\n    overrides = {};\n  }\n  if (!(akamai.amp.AMP.plugins.controls != null)) {\n    react = {\n      plugins: {\n        react: {\n          resources: [\n            {\n              src: \"${paths.plugins}react/libs/react.min.js\",\n              debug: \"${paths.plugins}react/libs/react.js\",\n              type: \"text/javascript\"\n            }, {\n              src: \"${paths.plugins}react/React.min.css\",\n              debug: \"${paths.plugins}react/React.css\",\n              type: \"text/css\"\n            }, {\n              src: \"${paths.plugins}react/React.min.js\",\n              debug: \"${paths.plugins}react/React.js\",\n              type: \"text/javascript\"\n            }\n          ],\n          autoHide: 3\n        }\n      }\n    };\n    overrides = Utils.override(react, overrides);\n  }\n  config = Utils.override(Config.defaults, overrides);\n  if (/amp\\-debug\\=true/.test(location.search.toLowerCase()) === true) {\n    config.debug = true;\n  }\n  if (typeof QueryString.amp === \"object\") {\n    config = Utils.override(config, QueryString.amp);\n  }\n  config.mode = Utils.getPlaybackMode(config.mode);\n  if (Utils.getIEVersion() === 9) {\n    config.plugins.react = null;\n    config.flash.view = Utils.override(config.flash.view, Config.flashView);\n  }\n  config.version = AMP.getVersion();\n  for (key in config) {\n    value = config[key];\n    this[key] = value;\n  }\n}\n\nConfig.create = function(overrides) {\n  return new Config(overrides);\n};\n\nConfig.defaults = {\n  paths: {\n    base: \"../\",\n    root: \"../\",\n    player: \"../amp.premier/\",\n    plugins: \"../akamai/amp/\",\n    resources: \"../resources/\"\n  },\n  resources: [\n    {\n      src: '#{paths.player}amp.premier.css',\n      type: \"text/css\",\n      async: true\n    }\n  ],\n  rules: {\n    android_4_gets_m3u8: {\n      regexp: \"Android 4\"\n    }\n  },\n  attributes: {},\n  settings: {},\n  autoplay: true,\n  loop: false,\n  playsinline: null,\n  muted: null,\n  target: \"_blank\",\n  domain: \"akamai.com\",\n  fullscreen: {},\n  contextmenu: {},\n  captioning: {},\n  controls: {},\n  playoverlay: {},\n  hls: {\n    resources: [\n      {\n        type: \"text/javascript\",\n        src: '#{paths.resources}js/hls.min.js',\n        debug: '#{paths.resources}js/hls.js'\n      }\n    ],\n    quality: {\n      startLevel: -1\n    },\n    data: {\n      enableWorker: true\n    }\n  },\n  dash: {\n    resources: [\n      {\n        type: \"text/javascript\",\n        src: \"//cdn.dashjs.org/v2.6.8/dash.all.min.js\",\n        debug: \"//cdn.dashjs.org/v2.6.8/dash.all.debug.js\"\n      }\n    ],\n    buffer: 1\n  },\n  flash: {\n    swf: '#{paths.player}AkamaiPremierPlayer.swf',\n    debug: '#{paths.player}AkamaiPremierPlayer-debug.swf',\n    expressInstallSWF: '#{paths.player}playerProductInstall.swf',\n    \"static\": {\n      enabled: false,\n      swf: '#{paths.player}AkamaiPremierPlayer-static.swf',\n      debug: '#{paths.player}AkamaiPremierPlayer-static-debug.swf'\n    },\n    vars: {\n      core_player_name: \"amp.premier\",\n      mbr_starting_index: 2,\n      use_last_known_bitrate: false,\n      use_netsession_client: false,\n      netsession_install_prompt_frequency_secs: -1,\n      ad_server_timeout: 20,\n      ad_control_enabled: true,\n      dvr_enabled: 1,\n      branding_preload: \"none\",\n      hds_live_low_latency: true,\n      fullscreen_enabled: true,\n      show_feature_bar: false,\n      suppress_events: \"mediaPlayerViewInitialized\",\n      hds_fragment_retry_data_gap_threshold: 20\n    },\n    view: {\n      attributes: {\n        skin: '#{paths.player}amp.chromeless.assets.swf'\n      },\n      elements: {\n        controls: {},\n        adOptions: {\n          attributes: {\n            style: \"backgroundColor: 'rgba(0, 0, 0, 0)'\"\n          },\n          elements: {\n            adChoices: null,\n            adCountdown: null,\n            adCount: null\n          }\n        },\n        endSlate: {\n          attributes: {\n            enabled: false,\n            hideElements: \"brandingLogo|viewAll\"\n          }\n        },\n        loadingView: {\n          attributes: {\n            enabled: false,\n            style: \"backgroundColor: 'rgba(0, 0, 0, 0)'; color: 'rgba(0, 0, 0, 0)'\",\n            radius: 0\n          }\n        }\n      }\n    }\n  },\n  locales: {\n    en: {\n      MSG_TIME_SEPARATOR: \" / \",\n      MSG_EMAIL_TO: \"To\",\n      MSG_EMAIL_FROM: \"From\",\n      MSG_EMAIL_VIDEO: \"Email this video\",\n      MSG_EMAIL_MESSAGE_DEFAULT: \"Check out this video from xxx\",\n      MSG_EMAIL_MESSAGE: \"Message\",\n      MSG_EMAIL_ADDRESS_INVALID: \"Invalid Email Address\",\n      MSG_EMAIL_MESSAGE_INVALID: \"Please limit your message to 500 characters or less.\",\n      MSG_EMAIL_CHARACTERS_REMAINING_TEXT: \" characters left\",\n      MSG_EMAIL_SEND_FAILURE: \"Message could not be sent.\",\n      MSG_EMAIL_SEND_SUCCESS_MESSAGE: \"Your email has been sent!\",\n      MSG_SHARE_VIDEO_TEXT: \"Share this video...\",\n      MSG_POST_TEXT: \"Post\",\n      MSG_EMBED_TEXT: \"Embed\",\n      MSG_LINK_TEXT: \"Link\",\n      MSG_SHARE_CONNECT_FAILURE: \"Unable to connect. Please try again.\",\n      MSG_SHARE_CONTENT_DISABLED: \"Share and embed are disabled.\",\n      MSG_VERSION_TEXT: \"Version\",\n      MSG_BUFFERING_TEXT: \"buffering\",\n      MSG_CUSTOMIZE_CLIP_POINTS: \"Customize the start and end point of the video.\",\n      MSG_PAUSE: \"Pause\",\n      MSG_PLAY: \"Play\",\n      MSG_REWIND: \"Rewind\",\n      MSG_PLAYBACK_RATE: \"Playback Rate\",\n      MSG_FULLSCREEN: \"Fullscreen\",\n      MSG_ENTER_FULLSCREEN: \"Enter Fullscreen\",\n      MSG_EXIT_FULLSCREEN: \"Exit Fullscreen\",\n      MSG_MUTE: \"Mute\",\n      MSG_UNMUTE: \"Unmute\",\n      MSG_JUMP_BACK: \"Jump Back\",\n      MSG_JUMP_AHEAD: \"Jump Ahead\",\n      MSG_VOLUME: \"Volume\",\n      MSG_REPLAY: \"Replay\",\n      MSG_SETTINGS: \"Settings\",\n      MSG_SHARE: \"Share\",\n      MSG_CLOSED_CAPTIONING: \"Closed Captioning\",\n      MSG_SLIDER: \"Slider\",\n      MSG_SEEK: \"Seek\",\n      MSG_OF: \"of\",\n      MSG_AD: \"Ad\",\n      MSG_PREVIEW: \"Preview\",\n      MSG_CURRENT: \"Current\",\n      MSG_SEEK_TO: \"Seek to\",\n      MSG_LIVE: \"LIVE\",\n      MSG_ERROR: \"Error\",\n      MSG_ERROR_ABORTED: \"Media Aborted\",\n      MSG_ERROR_DECODE: \"Decode Error\",\n      MSG_ERROR_NETWORK: \"Network Error\",\n      MSG_ERROR_SRC: \"Source not supported\",\n      MSG_ERROR_DEFAULT: \"An error has occurred\",\n      MSG_STREAM_NOT_FOUND: \"Stream not found\",\n      MSG_CURRENT_WORKING_BANDWIDTH: \"Current working bandwidth\",\n      MSG_CURRENT_BITRATE_PLAYING: \"Current bitrate playing\",\n      MSG_MAX_BITRATE_AVAILABLE: \"Max bitrate available\",\n      MSG_NOT_AVAILABLE: \"Not Available\",\n      MSG_GO_LIVE: \"GO LIVE\",\n      MSG_NEXT_VIDEO: \"Video starts in: \",\n      MSG_RECOMMENDED: \"Recommended\",\n      MSG_VIEW_ALL: \"View all \",\n      MSG_VIDEO: \" videos\",\n      MSG_CC: \"CC\",\n      MSG_CC_TITLE: \"Caption\",\n      MSG_CC_LANGUAGE: \"Track :\",\n      MSG_CC_PRESETS: \"Presets :\",\n      MSG_CC_FONT: \"Font :\",\n      MSG_CC_EDGE: \"Edge :\",\n      MSG_CC_SIZE: \"Size :\",\n      MSG_CC_SCROLL: \"Scroll :\",\n      MSG_CC_COLOR: \"Color :\",\n      MSG_CC_BACKGROUND: \"Background :\",\n      MSG_CC_WINDOW: \"Window :\",\n      MSG_CC_OPACITY: \"Opacity :\",\n      MSG_CC_SHOW_ADVANCED: \"Show Advanced Settings\",\n      MSG_CC_HIDE_ADVANCED: \"Hide Advanced Settings\",\n      MSG_NEXT_AD: \"Next ad starts in: \",\n      MSG_CC_RESET: \"Default\",\n      MSG_CC_CANCEL: \"Cancel\",\n      MSG_CC_APPLY: \"Apply\",\n      MSG_CC_PREVIEW_TEXT: \"Lorem ipsum dolor sit amet..\",\n      MSG_EN: \"English\",\n      MSG_ENG: \"English\",\n      MSG_ES: \"Spanish\",\n      MSG_SPA: \"Spanish\",\n      MSG_DE: \"German\",\n      MSG_DEU: \"German\",\n      MSG_GER: \"German\",\n      MSG_FR: \"French\",\n      MSG_FRE: \"French\",\n      MSG_FRA: \"French\",\n      MSG_IT: \"Italian\",\n      MSG_ITA: \"Italian\",\n      MSG_RU: \"Russian\",\n      MSG_RUS: \"Russian\",\n      MSG_ZH: \"Chinese\",\n      MSG_ZHO: \"Chinese\",\n      MSG_CHI: \"Chinese\",\n      MSG_JA: \"Japanese\",\n      MSG_JPN: \"Japanese\",\n      MSG_KO: \"Korean\",\n      MSG_KOR: \"Korean\",\n      MSG_CHROMECAST_MESSAGE: \"Video playing on ${device}\",\n      MSG_RETRY_MESSAGE: \"Content not yet available, retrying in\",\n      MSG_SECONDS: \"seconds\",\n      MSG_RETRY_FAILED: \"Retry failed\",\n      MSG_RECOMMENDATIONS_TITLE: \"Recommended\",\n      MSG_VIEWER_ID: \"Viewer ID: \",\n      MSG_SIGN_IN: \"Sign In\",\n      MSG_PREVIEW_INFO: \"Free Preview\",\n      MSG_PREVIEW_EXPIRES: \"Expires in\",\n      MSG_UNKNOWN: \"Unknown\"\n    },\n    es: '#{paths.player}es.json',\n    fr: '#{paths.player}fr.json'\n  }\n};\n\nConfig.flashView = {\n  attributes: {\n    skin: '#{paths.player}premier.assets.swf'\n  },\n  elements: {\n    infoOverlay: {\n      attributes: {\n        style: \"top: 0px;\"\n      }\n    },\n    adOptions: {\n      attributes: {\n        style: \"backgroundColor: 'rgba(0, 0, 0, 1)'\"\n      },\n      elements: {\n        adChoices: {\n          attributes: {\n            target: \"http://www.akamai.com/\"\n          }\n        },\n        adCountdown: {},\n        adCount: {}\n      }\n    },\n    endSlate: {\n      attributes: {\n        enabled: true,\n        hideElements: \"brandingLogo|viewAll\"\n      }\n    },\n    replayView: {},\n    bufferingView: {},\n    controls: {\n      attributes: {\n        height: \"28\",\n        itemMargin: \"5\",\n        scrubPosition: \"inline\"\n      },\n      elements: {\n        replayBtn: {},\n        playPauseBtn: {},\n        streamTimeIndicator: {\n          attributes: {\n            exclude: \"live\"\n          },\n          elements: {\n            streamTime: {},\n            streamDuration: {}\n          }\n        },\n        rewindBtn: {},\n        scrubBar: {\n          attributes: {\n            style: \"height: 18px;\"\n          }\n        },\n        progressBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #FF0000, #1B1B1B);\"\n          }\n        },\n        loadedBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #00FF00, #1B1B1B);\"\n          }\n        },\n        liveIndicator: {},\n        timeLocationIndicator: {},\n        goLiveBtn: {},\n        statsBtn: {},\n        volumeBar: {\n          attributes: {\n            color: \"#CA2127\"\n          }\n        },\n        volumeBtn: {},\n        fullscreenBtn: {}\n      }\n    }\n  }\n};\n\n/**\n * Creates a new instance of MediaProxy. Used to track player configuration settings.\n *\n * @param {Object} data The config object.\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ModuleProxy(data, name) {\n  this.config = data;\n  ModuleProxy.__super__.constructor.call(this, name);\n}\n\n\n__extends(ModuleProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nModuleProxy.NAME = \"ModuleProxy\";\n\n/** @private\n*/\nModuleProxy.prototype.defaults = null;\n\nModuleProxy.prototype.config = null;\n\n/** @override\n*/\nModuleProxy.prototype.initializeNotifier = function(key) {\n  ModuleProxy.__super__.initializeNotifier.call(this, key);\n  this.createData();\n};\n\n/**\n*/\nModuleProxy.prototype.createData = function() {\n  this.setData(this.config);\n};\n\n/**\n*/\nModuleProxy.prototype.getDefaults = function() {\n  return this.defaults || {};\n};\n\n/**\n * Sets the data for this proxy.\n *\n * @param {Object} value\n *    The new data for this proxy\n * @override\n*/\nModuleProxy.prototype.setData = function(data) {\n  var dflt, key, obj, value, _ref;\n  if (data == null) {\n    data = {};\n  }\n  obj = {};\n  _ref = this.getDefaults();\n  for (key in _ref) {\n    dflt = _ref[key];\n    value = key in data ? data[key] : dflt;\n    obj[key] = value;\n  }\n  ModuleProxy.__super__.setData.call(this, obj);\n  return data;\n};\n\n/**\n*/\nModuleProxy.prototype.destroy = function() {};\n\n/**\n * The Module class.\n *\n * @param {Object}  config        The configuration object\n * @param {Object}  viewComponent The player's container element\n * @constructor\n * @private\n * @extends {puremvc.Facade}\n*/\nfunction Module(viewComponent) {\n  this.viewComponent = viewComponent;\n  this.performance = {\n    init: Date.now()\n  };\n  Module.__super__.constructor.call(this, this.getModuleName() + \"-\" + Utils.createUID());\n  this.dispatcher = new EventDispatcher(this);\n  this.transformer = new Transformer();\n  this.logger = Logger.instance;\n  this.moduleMap = {};\n}\n\n\n__extends(Module, puremvc.Facade);\n\n\nModule.prototype.logger = null;\n\nModule.prototype.config = null;\n\nModule.prototype.moduleName = null;\n\nModule.prototype.moduleMap = null;\n\nModule.prototype.viewComponent = null;\n\nModule.prototype.dispatcher = null;\n\nModule.prototype.oninitialized = null;\n\nModule.prototype.onerror = null;\n\nModule.prototype.parentModule = null;\n\nModule.prototype.performance = null;\n\nModule.prototype.transformer = null;\n\n/**\n * Initialization function.\n *\n * @param {Object}  config  The plugin's configuration object.\n*/\nModule.prototype.initialize = function(config, parentModule) {\n  this.config = config;\n  this.parentModule = parentModule;\n  this.loadModuleResources().then(this.resourcesLoaded.bind(this))[\"catch\"](this.resourcesError.bind(this));\n};\n\n/**\n*/\nModule.prototype.loadModuleResources = function(resources) {\n  if (resources == null) {\n    resources = this.config.resources;\n  }\n  if (!(resources != null ? resources.length : void 0) > 0) {\n    return Promise.resolve();\n  }\n  return AMP.addResources(this.evaluatePaths(resources));\n};\n\n/**\n*/\nModule.prototype.evaluatePaths = function(path) {\n  var paths, _ref, _ref1;\n  if (!(path != null)) {\n    return;\n  }\n  paths = this.config.paths || ((_ref = this.parentModule) != null ? (_ref1 = _ref.config) != null ? _ref1.paths : void 0 : void 0);\n  if (paths != null) {\n    path = DataBinding.evaluateBindings(path, {\n      paths: paths\n    });\n  }\n  return path;\n};\n\n/**\n * The resources failed to load.\n *\n * @private\n*/\nModule.prototype.resourcesError = function(error) {\n  if (typeof this.onerror === \"function\") {\n    this.onerror(this);\n  }\n};\n\n/**\n * The resources have finished loaded, load the extensions.\n *\n * @private\n*/\nModule.prototype.resourcesLoaded = function() {\n  this.createFramework();\n  if (typeof this.oninitialized === \"function\") {\n    this.oninitialized(this);\n  }\n};\n\n/**\n * Framework based initialization function for defining default\n * mvc classes. Meant to be overwritten by base classes.\n*/\nModule.prototype.createFramework = function() {\n  this.createModel();\n  this.createController();\n  this.createView();\n};\n\n/**\n*/\nModule.prototype.createModel = function() {\n  this.registerProxy(new ModuleProxy(this.config));\n};\n\n/**\n*/\nModule.prototype.createView = function() {};\n\n/**\n*/\nModule.prototype.createController = function() {\n  this.registerCommand(Notifications.DISPATCH_EVENT, DispatchEventCommand);\n};\n\n/**\n*/\nModule.prototype.getModuleName = function() {\n  return this.moduleName;\n};\n\n/**\n * @return {Object} The configuration object.\n * @expose\n*/\nModule.prototype.getConfig = function() {\n  return this.config;\n};\n\n/**\n*/\nModule.prototype.hasModule = function(moduleName) {\n  return this.moduleMap[moduleName] != null;\n};\n\n/**\n*/\nModule.prototype.getModules = function() {\n  var key, modules, value, _ref;\n  modules = {};\n  _ref = this.moduleMap;\n  for (key in _ref) {\n    value = _ref[key];\n    modules[key] = value.module;\n  }\n  return modules;\n};\n\n/**\n*/\nModule.prototype.registerModule = function(module) {\n  var adaptor, moduleName;\n  moduleName = module.getModuleName();\n  if (!(module != null) || (this.moduleMap[moduleName] != null)) {\n    return;\n  }\n  adaptor = new ModuleAdapter(module);\n  this.moduleMap[moduleName] = adaptor;\n  this.registerMediator(adaptor);\n  module.onRegister();\n};\n\n/**\n*/\nModule.prototype.retrieveModule = function(moduleName) {\n  return this.moduleMap[moduleName].module;\n};\n\n/**\n*/\nModule.prototype.removeModule = function(moduleName) {\n  var adaptor, module;\n  adaptor = this.moduleMap[moduleName];\n  if (!(adaptor != null)) {\n    return;\n  }\n  delete this.moduleMap[moduleName];\n  this.removeMediator(moduleName);\n  module = adaptor.module;\n  module.onRemove.call(module);\n  return module;\n};\n\n/** List INotification interests.\n*/\nModule.prototype.listNotificationInterests = function() {\n  return [];\n};\n\n/** List Notification publications\n*/\nModule.prototype.listNotificationPublications = function() {\n  return [];\n};\n\n/** Get the IMediator's view component.\n*/\nModule.prototype.getViewComponent = function() {\n  return this.viewComponent;\n};\n\n/** Set the IMediator's view component.\n*/\nModule.prototype.setViewComponent = function(viewComponent) {\n  this.viewComponent = viewComponent;\n  return viewComponent;\n};\n\n/** Called by the parent module when the Module is registered\n*/\nModule.prototype.onRegister = function() {};\n\n/** Called by the parent module when the Module is removed\n*/\nModule.prototype.onRemove = function() {};\n\n/** Destroys the module\n*/\nModule.prototype.destroy = function() {\n  var key, value, _ref, _ref1;\n  if (this.getModules() != null) {\n    _ref = this.getModules();\n    for (key in _ref) {\n      value = _ref[key];\n      this.removeModule(key);\n      value.destroy();\n    }\n  }\n  if ((_ref1 = this.retrieveProxy(ModuleProxy.NAME)) != null) {\n    if (typeof _ref1.destroy === \"function\") {\n      _ref1.destroy();\n    }\n  }\n  puremvc.Facade.removeCore(this.multitonKey);\n  if (this.viewComponent != null) {\n    this.viewComponent.innerHTML = \"\";\n    this.viewComponent.className = \"\";\n  }\n  for (key in this) {\n    try {\n      this[key] = null;\n    } catch (error) {\n\n    }\n    delete this[key];\n  }\n};\n\n/**\n * Adds a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @expose\n*/\nModule.prototype.addEventListener = function(type, func) {\n  this.dispatcher.addEventListener(type, func);\n};\n\n/**\n * Adds a listener for a given event type and removes it after it has been triggered once.\n*/\nModule.prototype.once = function(type, func) {\n  this.dispatcher.once(type, func);\n};\n\n/**\n*/\nModule.prototype.logEvent = function(event) {\n  var prefix;\n  if (/(timeupdate|progress|fragmentloaded|fragmentloadstart)/.test(event.type) === true) {\n    return;\n  }\n  prefix = this.getModuleName().toUpperCase();\n  if (event.dispatcher) {\n    prefix += \" \" + event.dispatcher;\n  }\n  this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n};\n\n/**\n * Dispathes and event, triggering all event listener of the event's type.\n *\n * @param {!IEvent} event The event to dispatch.\n * @expose\n*/\nModule.prototype.dispatchEvent = function(event) {\n  this.logEvent(event);\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!String} type    The type of event to dispatch.\n * @param {Object=} detail  Data to pass along with the event.\n*/\nModule.prototype.dispatch = function(type, detail) {\n  this.dispatchEvent(new Event(type, detail));\n};\n\n/**\n * Removes a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @return {?Function} the handler that was removed if any\n * @expose\n*/\nModule.prototype.removeEventListener = function(type, func) {\n  this.dispatcher.removeEventListener(type, func);\n};\n\n/**\n * Adds a transform for a given type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n*/\nModule.prototype.addTransform = function(type, transform) {\n  return this.transformer.addTransform(type, transform);\n};\n\n/**\n * Sorts the transform list by priority. Higher priority Transforms\n * are executed first.\n *\n * @param {!String} type The transform type\n * @param {Function=} sort An optional sort function\n * @returns {Array.<Function|akamai.amp.Transform>} The sorted list of transforms\n*/\nModule.prototype.sortTransforms = function(type, sort) {\n  return this.transformer.sortTransforms(type, sort);\n};\n\n/**\n * Performs a transform for a given type\n *\n * @param {!String} type The transform type\n * @param {!Object} value The value to be transformed\n*/\nModule.prototype.transform = function(type, value) {\n  return this.transformer.transform(type, value);\n};\n\n/**\n * Removes a transform for a given type.\n *\n * @param {!string}  type  A string representing the transform's type.\n * @param {!Function} transform  A function or Transform object to call when the type is triggered.\n * @return {?Function} the transform that was removed if any\n*/\nModule.prototype.removeTransform = function(type, transform) {\n  return this.transformer.removeTransform(type, transform);\n};\n\n/**\n * Creates a new EventDispatcher\n *\n * @constructor\n * @private\n * @implements {IEventDispatcher}\n*/\nfunction EventDispatcher(_target) {\n  this._target = _target != null ? _target : this;\n  this._listenerMap = {};\n}\n\n/**\n * Adds a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @param {boolean=} capture\n*/\nEventDispatcher.prototype.addEventListener = function(type, func, capture) {\n  if (!(func != null) || !(type != null)) {\n    return;\n  }\n  if (!(this._listenerMap[type] != null)) {\n    this._listenerMap[type] = [];\n  }\n  if (this._listenerMap[type].indexOf(func) !== -1) {\n    return;\n  }\n  this._listenerMap[type].push(func);\n};\n\n/**\n * Adds a listener for a given event type and removes it after it has been triggered once.\n*/\nEventDispatcher.prototype.once = function(type, func) {\n  func.once = true;\n  this.addEventListener(type, func);\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!IEvent} event The event to dispatch.\n*/\nEventDispatcher.prototype.dispatchEvent = function(event) {\n  var index, listener, listeners, _i, _len, _ref;\n  listeners = this._listenerMap[event.type];\n  listener = this._target[\"on\" + event.type];\n  event.target = this._target;\n  if (listener != null) {\n    listener.apply(this._target, [event]);\n  }\n  if (!(listeners != null)) {\n    return;\n  }\n  _ref = listeners.slice();\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    listener = _ref[index];\n    listener.apply(this._target, [event]);\n    if (listener.once === true) {\n      listeners.splice(index, 1);\n    }\n  }\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!String} type    The type of event to dispatch.\n * @param {Object=} detail  Data to pass along with the event.\n*/\nEventDispatcher.prototype.dispatch = function(type, detail) {\n  this.dispatchEvent(new Event(type, detail));\n};\n\n/**\n * Removes a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @return {?Function} the handler that was removed if any\n * @param {boolean=} capture\n*/\nEventDispatcher.prototype.removeEventListener = function(type, func, capture) {\n  var index, listeners;\n  if (!(func != null) || !(type != null)) {\n    return;\n  }\n  listeners = this._listenerMap[type];\n  if (!(listeners != null)) {\n    return;\n  }\n  index = listeners != null ? listeners.indexOf(func) : void 0;\n  if (index === -1) {\n    return;\n  }\n  return listeners.splice(index, 1);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction TrackList(list) {\n  this.list = list != null ? list : [];\n  TrackList.__super__.constructor.call(this);\n  this.dispatcher = new EventDispatcher(this);\n  this.handlers = {\n    change: this.changeHandler.bind(this)\n  };\n}\n\n\n__extends(TrackList, Array);\n\n\nTrackList.prototype.onchange = null;\n\n/**\n*/\nTrackList.prototype.changeHandler = function(event) {\n  this.dispatchEvent(event);\n};\n\n/**\n*/\nTrackList.prototype.addEventListener = function(type, func, capture) {\n  this.dispatcher.addEventListener(type, func, capture);\n};\n\n/**\n*/\nTrackList.prototype.dispatchEvent = function(event) {\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n*/\nTrackList.prototype.removeEventListener = function(type, func, capture) {\n  return this.dispatcher.removeEventListener(type, func, capture);\n};\n\n/**\n * @param {string} key\n *     The key\n *\n * @param {Object} value\n *     The value\n*/\nTrackList.prototype.add = function(track, dispatch) {\n  if (dispatch == null) {\n    dispatch = true;\n  }\n  this.push(track);\n  track.addEventListener(\"change\", this.handlers.change);\n  if (dispatch === true) {\n    this.dispatchEvent({\n      type: \"addtrack\"\n    });\n  }\n};\n\n/**\n * @param {string} key\n *     The module's key\n *\n * @return {Object}\n *     The item.\n*/\nTrackList.prototype.remove = function(track, dispatch) {\n  var index;\n  if (dispatch == null) {\n    dispatch = true;\n  }\n  index = this.indexOf(track);\n  if (index === -1) {\n    return;\n  }\n  this.splice(index, 1);\n  track.removeEventListener(\"change\", this.handlers.change);\n  if (dispatch === true) {\n    this.dispatchEvent({\n      type: \"removetrack\"\n    });\n  }\n  return track;\n};\n\nTrackList.prototype.clear = function() {\n  var index, _i, _len;\n  if (this.length === 0) {\n    return;\n  }\n  for (_i = 0, _len = this.length; _i < _len; _i++) {\n    index = this[_i];\n    this.remove(this[this.length - 1], false);\n  }\n  this.dispatchEvent({\n    type: \"removetrack\"\n  });\n};\n\nTrackList.prototype.getTrackById = function(id) {\n  var track, _i, _len;\n  for (_i = 0, _len = this.length; _i < _len; _i++) {\n    track = this[_i];\n    if (track.id === id) {\n      return track;\n    }\n  }\n};\n\n/**\n * The InstallPlayer class.\n *\n * @constructor\n * @private\n * @param {Object} viewComponent\n*/\nfunction InstallPlayer(viewComponent) {\n  var anchor, div, img, message;\n  viewComponent.className = Namespace.PREFIX + \"player\";\n  div = UI.create(\"install-flash\", viewComponent);\n  message = UI.create(null, div, \"p\", \"To view this page ensure that Adobe Flash Player version 10.2.0 or greater is installed.\");\n  anchor = UI.create(null, div, \"a\");\n  anchor.href = 'http://www.adobe.com/go/getflashplayer';\n  img = UI.create(null, anchor, \"img\");\n  img.src = \"//www.adobe.com/images/shared/download_buttons/get_flash_player.gif\";\n  img.alt = \"Get Adobe Flash player\";\n}\n\nInstallPlayer.prototype.initialize = function() {};\n\n/**\n*/\nInstallPlayer.prototype.getModules = function() {\n  return [];\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction Manager() {\n  this.map = {};\n}\n\n/**\n * @type {Object.<string, Object>}\n * @private\n*/\nManager.prototype.map = null;\n\n/**\n * @param {string} key\n *     The key\n *\n * @param {Object} value\n *     The value\n*/\nManager.prototype.add = function(key, value) {\n  this.map[key] = value;\n};\n\n/**\n * @param {string} key\n *     The module's key\n *\n * @return {Object}\n *     The item at the given key.\n*/\nManager.prototype.item = function(key) {\n  return this.map[key];\n};\n\n/**\n * @param {string} key\n *     The module's key\n *\n * @return {Object}\n *     The item.\n*/\nManager.prototype.remove = function(key) {\n  var item;\n  item = this.map[key];\n  if (item != null) {\n    this.map[key] = null;\n    delete this.map[key];\n  }\n  return item;\n};\n\nfunction URL() {}\n\n/**\n * The URL to send the request to.\n *\n * @type {String}\n*/\nURL.prototype.url = null;\n\n/**\n * The HTTP method to use, such as \"GET\", \"POST\", \"PUT\", \"DELETE\", etc.\n * Ignored for non-HTTP(S) URLs.\n *\n * @type {String}\n*/\nURL.prototype.method = null;\n\n/**\n * A Boolean that indicates whether or not cross-site Access-Control\n * requests should be made using credentials such as cookies or authorization\n * headers.\n *\n * @type {Boolean}\n*/\nURL.prototype.withCredentials = null;\n\n/**\n * A key value map of http headers to include in the reques\n *\n * @type {Object}\n*/\nURL.prototype.headers = null;\n\n/**\n * Data to send with a POST request\n *\n * @type {Object}\n*/\nURL.prototype.data = null;\n\nfunction Authorization(key, token, expiration) {\n  this.key = key;\n  this.token = token;\n  this.expiration = expiration;\n}\n\nAuthorization.prototype.key = null;\n\nAuthorization.prototype.token = null;\n\nAuthorization.prototype.expiration = null;\n\n/**\n * @constructor\n * @extends {Manager}\n*/\nfunction ResourceManager() {\n  ResourceManager.__super__.constructor.call(this);\n}\n\n\n__extends(ResourceManager, Manager);\n\n\nResourceManager.prototype.js = function(src, resource) {\n  return Utils.loadScript(src, document.body);\n};\n\nResourceManager.prototype.css = function(src, resource) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    try {\n      Utils.loadStyleSheet(src);\n    } catch (error) {\n      reject();\n    }\n    resolve(resource);\n  });\n};\n\nResourceManager.prototype.json = function(src, resource) {\n  var _this = this;\n  return Utils.requestJson(resource.src).then(function(data) {\n    resource.data = data;\n    return resource;\n  });\n};\n\n/**\n * @override\n*/\nResourceManager.prototype.require = function(id) {\n  var item,\n    _this = this;\n  item = this.item(id);\n  if (!(item != null)) {\n    if (typeof id === \"string\") {\n      return this.add({\n        src: id\n      });\n    } else if (id.src != null) {\n      return this.add(id);\n    } else {\n      return Promise.resolve(id);\n    }\n  } else if (typeof item === \"function\") {\n    Manager.prototype.add.call(this, id, null);\n    return Promise.resolve().then(function() {\n      return item();\n    });\n  } else if (typeof item.then === \"function\") {\n    return item;\n  } else {\n    return Promise.resolve(item);\n  }\n};\n\n/**\n * @override\n*/\nResourceManager.prototype.add = function(resource) {\n  var id, item, promise, src, type,\n    _this = this;\n  if (resource.enabled === false) {\n    return Promise.resolve();\n  }\n  src = Logger.instance.enabled && (resource.debug != null) ? resource.debug : resource.src;\n  id = resource.id || src;\n  if (resource.defer === true) {\n    resource.defer = false;\n    ResourceManager.__super__.add.call(this, id, this.add.bind(this, resource));\n    return Promise.resolve();\n  }\n  item = this.item(id);\n  if (item != null) {\n    if (typeof item.then === \"function\") {\n      return item;\n    } else {\n      return Promise.resolve(item);\n    }\n  }\n  type = resource.type || Utils.getMimeType(src);\n  if (type === Utils.mimeTypes.js || /javascript/.test(type)) {\n    promise = this.js(src, resource);\n  } else if (type === Utils.mimeTypes.css) {\n    promise = this.css(src, resource);\n  } else if (type === Utils.mimeTypes.json || /json/.test(type)) {\n    promise = this.json(src, resource);\n  } else if (type !== Utils.mimeTypes.swf) {\n    promise = Utils.request(src);\n  }\n  if (!(promise != null)) {\n    return Promise.resolve();\n  }\n  promise = promise.then(function(resource) {\n    Manager.prototype.add.call(_this, id, resource);\n    return resource;\n  });\n  ResourceManager.__super__.add.call(this, id, promise);\n  return promise;\n};\n\n/**\n * @param {Array.<akamai.amp.Resource>} resource\n *    The resource\n *\n * @param {Function} callback\n*/\nResourceManager.prototype.addResources = function(resources) {\n  var asyncs, promise, promises, resource, _i, _len,\n    _this = this;\n  if (!(resources != null ? resources.length : void 0) > 0) {\n    return Promise.resolve();\n  }\n  promises = [];\n  asyncs = [];\n  for (_i = 0, _len = resources.length; _i < _len; _i++) {\n    resource = resources[_i];\n    if (resource instanceof Array) {\n      promises.push(this.addResources.bind(this, resource));\n    } else if (resource.async === true) {\n      asyncs.push(this.add(resource));\n    } else {\n      promises.push(this.add.bind(this, resource));\n    }\n  }\n  if (asyncs.length > 0) {\n    promise = Promise.all(asyncs);\n  } else {\n    promise = Promise.resolve();\n  }\n  return promise.then(function() {\n    return Utils.chain(promises);\n  });\n};\n\n/**\n * The PluginsInitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PluginsInitializedCommand() {\n  PluginsInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginsInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPluginsInitializedCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.READY, this.facade.config);\n};\n\n/**\n * The PlayerCommand class. Base class for commands that need access\n * to the application state or the media\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PlayerCommand() {\n  PlayerCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayerCommand, puremvc.SimpleCommand);\n\n\nPlayerCommand.prototype.applicationState = null;\n\nPlayerCommand.prototype.media = null;\n\nPlayerCommand.prototype.player = null;\n\nPlayerCommand.prototype.playback = null;\n\nPlayerCommand.prototype.config = null;\n\nPlayerCommand.prototype.logger = null;\n\nPlayerCommand.prototype.bindings = null;\n\nPlayerCommand.prototype.params = null;\n\nPlayerCommand.prototype.playerCore = null;\n\nPlayerCommand.prototype.security = null;\n\nPlayerCommand.prototype.tracks = null;\n\n/** @override\n*/\nPlayerCommand.prototype.initializeNotifier = function(key) {\n  var _ref;\n  PlayerCommand.__super__.initializeNotifier.call(this, key);\n  this.player = this.facade.player || this.facade;\n  this.applicationState = this.player.appState;\n  this.media = this.player.mediaProxy;\n  this.config = this.player.configuration;\n  this.logger = this.player.logger;\n  this.bindings = this.player.bindings;\n  this.params = this.player.params;\n  this.playerCore = this.player.playerCore;\n  this.security = this.player.security;\n  this.tracks = this.player.tracks;\n  this.playback = ((_ref = this.player.playerCore) != null ? _ref.getActivePlaybackCore() : void 0) || this.player.playback;\n};\n\n/**\n * The TogglePlayPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction TogglePlayPauseCommand() {\n  TogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TogglePlayPauseCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTogglePlayPauseCommand.prototype.execute = function(notification) {\n  var note;\n  if (this.applicationState.getSeeking()) {\n    return;\n  }\n  switch (this.applicationState.getPlayState()) {\n    case PlayState.ENDED:\n      note = Notifications.REPLAY;\n      break;\n    case PlayState.PAUSED:\n    case PlayState.READY:\n      note = Notifications.PLAY;\n      break;\n    case PlayState.PLAYING:\n      note = Notifications.PAUSE;\n  }\n  if (this.applicationState.getWaiting()) {\n    if (this.facade.getMediaElement().paused === true) {\n      note = Notifications.PLAY;\n    }\n  }\n  this.sendNotification(note, true);\n};\n\n/**\n * The ToggleFullScreenCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleFullScreenCommand() {\n  ToggleFullScreenCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleFullScreenCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nToggleFullScreenCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.applicationState.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, state);\n};\n\n/**\n * The PlayerCommand class. Base class for commands that need access\n * to the application state or the media\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PlayerEventCommand() {\n  PlayerEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayerEventCommand, PlayerCommand);\n\n\n/**\n *\n*/\nPlayerEventCommand.prototype.dispatchEvent = function(type, detail) {\n  var event;\n  if (typeof type !== \"string\") {\n    detail = type.getBody() != null ? type.getBody() : {};\n    type = type.getName();\n  }\n  event = new Event(type.toLowerCase(), detail);\n  this.sendNotification(Notifications.DISPATCH_EVENT, event);\n};\n\n/**\n *\n*/\nPlayerEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var callback;\n    callback = function() {\n      try {\n        _this.dispatchEvent(type, detail);\n        resolve();\n      } catch (error) {\n        _this.facade.logger.error(error);\n        reject(error);\n      }\n    };\n    return setTimeout(callback, 0);\n  });\n};\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlayerEventCommand.prototype.execute = function(notification) {\n  this.dispatchEvent(notification);\n};\n\n/**\n * The PlayCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction PlayingCommand() {\n  PlayingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlayingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getIsUserActive() === true) {\n    return;\n  }\n  if (this.facade.getMediaElement().currentTime === 0 && this.media.started === false && this.applicationState.getSeeking() === false) {\n    this.media.started = true;\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);\n  }\n  if (this.applicationState.getPlayState() === PlayState.PLAYING) {\n    PlayingCommand.__super__.execute.call(this, notification);\n  } else {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FullscreenMode = {\n  /**\n   *\n  */\n\n  EXTERNAL: \"external\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ControlsMode = {\n  /**\n   * Constant representing auto controls mode\n  */\n\n  AUTO: \"auto\",\n  /**\n   * Constant representing the persistent controls mode\n  */\n\n  PERSISTENT: \"persistent\",\n  /**\n   * Constant representing none controls mode\n  */\n\n  NONE: \"none\"\n};\n\n/**\n * The PauseCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PauseCommand() {\n  PauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PauseCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPauseCommand.prototype.execute = function(notification) {\n  this.playback.pause();\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  PauseCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeAutoplayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeAutoplayCommand() {\n  ChangeAutoplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeAutoplayCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeAutoplayCommand.prototype.execute = function(notification) {\n  this.config.setAutoplay(notification.getBody());\n};\n\n/**\n * The ChangeLoopCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeLoopCommand() {\n  ChangeLoopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeLoopCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeLoopCommand.prototype.execute = function(notification) {\n  this.config.setLoop(notification.getBody());\n};\n\n/**\n * The ChangeVolumeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeVolumeCommand() {\n  ChangeVolumeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeVolumeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeVolumeCommand.prototype.execute = function(notification) {\n  var volume;\n  volume = Utils.clamp(notification.getBody(), 0, 1);\n  if (this.playback.getVolume() !== volume) {\n    this.playback.setVolume(volume);\n  }\n};\n\n/**\n * The MediaValidatedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaValidatedCommand() {\n  MediaValidatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaValidatedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaValidatedCommand.prototype.execute = function(notification) {\n  var canAutoPlay, container, media, mediaElement, muted, playsinline, unmute,\n    _this = this;\n  media = notification.getBody();\n  mediaElement = this.facade.getMediaElement();\n  this.sendNotification(Notifications.MEDIA_CHANGE, media);\n  if (this.applicationState.getPlaybackTarget() !== \"amp\") {\n    return;\n  }\n  canAutoPlay = this.applicationState.getLocked() === false && this.facade.getAutoplay() === true;\n  playsinline = this.config.getPlaysInline();\n  if ((playsinline != null)) {\n    mediaElement.playsInline = playsinline;\n  }\n  muted = this.config.getMuted();\n  if (muted != null) {\n    this.playback.setMuted(muted);\n  }\n  if (canAutoPlay && muted) {\n    container = this.facade.getContainer();\n    unmute = function() {\n      _this.config.setMuted(false);\n      _this.facade.setMuted(false);\n      container.removeEventListener(\"click\", unmute);\n    };\n    container.addEventListener(\"click\", unmute);\n  }\n  if (canAutoPlay) {\n    setTimeout(this.sendNotification.bind(this, Notifications.PLAY, true), 0);\n  }\n};\n\n/**\n * The SeekCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekCommand() {\n  SeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSeekCommand.prototype.execute = function(notification) {\n  var time,\n    _this = this;\n  time = notification.getBody();\n  this.facade.transform(TransformType.SEEK, time).then(function(time) {\n    var video;\n    if (time === 0 && _this.media.getType() === Utils.mimeTypes.m3u8) {\n      time = 0.25;\n    }\n    if (time === _this.playback.getCurrentTime()) {\n      return;\n    }\n    if (_this.playback.getStarted() === true) {\n      _this.sendNotification(Notifications.WAITING);\n    }\n    _this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: time,\n      duration: _this.playback.getDuration()\n    });\n    _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    video = _this.facade.getMediaElement();\n    _this.playback.setCurrentTime(time);\n    if (_this.playback.getStarted() !== true) {\n      _this.sendNotification(Notifications.TIME_CHANGE, time);\n    }\n  });\n};\n\n/**\n * The SeekingCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekingCommand() {\n  SeekingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSeekingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getSeeking() === true) {\n    this.applicationState.setSeekRequested(true);\n    return;\n  }\n  if (this.applicationState.getEnded()) {\n    this.applicationState.setEnded(false);\n  }\n  if (this.facade.getMediaElement().currentTime === 0) {\n    this.media.started = false;\n  }\n  this.applicationState.setSeeking(true);\n  SeekingCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The SeekedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekedCommand() {\n  SeekedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSeekedCommand.prototype.execute = function(notification) {\n  var _this = this;\n  if (this.applicationState.getIsUserActive() === true) {\n    setTimeout(this.sendNotification.bind(this, notification.getName(), notification.getBody()), 100);\n    return;\n  }\n  setTimeout(function() {\n    var state;\n    _this.applicationState.setSeeking(false);\n    _this.dispatchEvent(notification);\n    _this.applicationState.setSeekRequested(false);\n    _this.sendNotification(UserNotifications.SEEKED, notification.getBody());\n    if (_this.applicationState.getPlayState() === PlayState.READY) {\n      return;\n    }\n    if (_this.applicationState.displayState === \"full-screen\" && _this.applicationState.device === \"ipad\" && _this.facade.retrieveProxy(PlaybackProxy.NAME).getPaused() !== _this.facade.getMediaElement().paused) {\n      state = _this.facade.getMediaElement().paused === true ? PlayState.PAUSED : PlayState.PLAYING;\n    }\n    if ((state != null) && state !== \"undefined\") {\n      _this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n    }\n  }, 1);\n};\n\n/**\n * The ReplayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ReplayCommand() {\n  ReplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ReplayCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nReplayCommand.prototype.execute = function(notification) {\n  if (typeof this.playback.replay === \"function\") {\n    this.playback.replay();\n    return;\n  }\n  this.sendNotification(Notifications.SET_MEDIA, this.media.getData());\n};\n\n/**\n * The EndCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction EndCommand() {\n  EndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EndCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nEndCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getEnded()) {\n    return;\n  }\n  this.playback.setEnabled(false);\n  this.playback.pause();\n  this.playback.seek(this.playback.getDuration()).then(this.sendNotification.bind(this, Notifications.ENDED));\n};\n\n/**\n * The EndedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction EndedCommand() {\n  EndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EndedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nEndedCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getEnded()) {\n    return;\n  }\n  this.applicationState.setEnded(true);\n  EndedCommand.__super__.execute.call(this, notification);\n  if (this.config.getLoop() === true) {\n    this.sendNotification(Notifications.REPLAY);\n  } else if (this.applicationState.getHasPostContent() === false) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n  }\n};\n\n/**\n * The StartCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction StartCommand() {\n  StartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(StartCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  this.sendNotification(Notifications.DISPLAY_TIME, {\n    currentTime: 0,\n    duration: this.media.getDuration()\n  });\n  this.sendNotification(Notifications.STARTED, notification.getBody());\n};\n\n/**\n * The IsUserActiveCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction IsUserActiveCommand() {\n  IsUserActiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IsUserActiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIsUserActiveCommand.prototype.execute = function(notification) {\n  this.applicationState.setIsUserActive(notification.getBody());\n};\n\n/**\n * The WaitingCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction WaitingCommand() {\n  WaitingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(WaitingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nWaitingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getWaiting()) {\n    return;\n  }\n  this.applicationState.setWaiting(true);\n  WaitingCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeMutedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeMutedCommand() {\n  ChangeMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeMutedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeMutedCommand.prototype.execute = function(notification) {\n  this.playback.setMuted(notification.getBody());\n};\n\n/**\n * The AuthorizedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction AuthorizedCommand() {\n  AuthorizedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AuthorizedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAuthorizedCommand.prototype.execute = function(notification) {\n  if (this.security.getSession() != null) {\n    return;\n  }\n  this.security.setSession(Utils.createUID());\n  this.sendNotification(Notifications.MEDIA_VALIDATED, this.media.getData());\n  AuthorizedCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The InitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction InitializedCommand() {\n  InitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(InitializedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nInitializedCommand.prototype.execute = function(notification) {\n  this.playback.initialized = true;\n};\n\n/**\n * The RegisterPlaybackCoreCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction RegisterPlaybackCoreCommand() {\n  RegisterPlaybackCoreCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RegisterPlaybackCoreCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nRegisterPlaybackCoreCommand.prototype.execute = function(notification) {\n  this.playerCore.registerPlaybackCore(notification.getBody());\n};\n\n/**\n * The RecordContentChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction RecordContentChangeCommand() {\n  RecordContentChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecordContentChangeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nRecordContentChangeCommand.prototype.execute = function(notification) {\n  var content;\n  content = notification.getBody();\n  this.sendNotification(Notifications.CHANGE_CONTENT, {\n    from: this.media.getData(),\n    to: content\n  });\n  this.media.updateData(content);\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n  this.sendNotification(Notifications.CHANGE_CONTENT, this.media.getData());\n};\n\n/**\n * The TimeupdateCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimeUpdateCommand() {\n  TimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimeUpdateCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimeUpdateCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.DISPLAY_TIME, {\n    currentTime: this.applicationState.getCurrentTime(),\n    duration: this.applicationState.getDuration()\n  });\n  TimeUpdateCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ToggleMutedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleMutedCommand() {\n  ToggleMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleMutedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nToggleMutedCommand.prototype.execute = function(notification) {\n  this.playback.setMuted(!this.playback.getMuted());\n};\n\n/**\n * The PlayRequestCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlayRequestCommand() {\n  PlayRequestCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayRequestCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlayRequestCommand.prototype.execute = function(notification) {\n  if (this.media.started === true) {\n    return;\n  }\n  this.media.started = true;\n  PlayRequestCommand.__super__.execute.call(this, notification);\n  this.sendNotification(Notifications.WAITING);\n  this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);\n};\n\n/**\n * The EnableVideoEventsCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction EnableVideoEventsCommand() {\n  EnableVideoEventsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EnableVideoEventsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nEnableVideoEventsCommand.prototype.execute = function(notification) {\n  var event, events, video, _i, _len;\n  video = this.player.getMediaElement();\n  events = notification.getBody();\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    video.addEventListener(event, this.playback.handlers[event]);\n  }\n};\n\n/**\n * The DisableVideoEventsCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DisableVideoEventsCommand() {\n  DisableVideoEventsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DisableVideoEventsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nDisableVideoEventsCommand.prototype.execute = function(notification) {\n  var event, events, video, _i, _len;\n  video = this.player.getMediaElement();\n  events = notification.getBody();\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    video.removeEventListener(event, this.playback.handlers[event]);\n  }\n};\n\n/**\n * The PauseCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction VolumeChangeCommand() {\n  VolumeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(VolumeChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nVolumeChangeCommand.prototype.execute = function(notification) {\n  this.applicationState.setVolume(notification.getBody());\n  VolumeChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The HasPostContentCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction HasPostContentCommand() {\n  HasPostContentCommand.__super__.constructor.call(this);\n}\n\n\n__extends(HasPostContentCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nHasPostContentCommand.prototype.execute = function(notification) {\n  this.applicationState.setHasPostContent(notification.getBody());\n};\n\n/**\n * The EndedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction MediaSequenceEndedCommand() {\n  MediaSequenceEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaSequenceEndedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaSequenceEndedCommand.prototype.execute = function(notification) {\n  if (this.config.getLoop() === true) {\n    MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n    this.sendNotification(Notifications.REPLAY);\n  } else {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ENDED);\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n  }\n};\n\n/**\n * The LockCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction LockCommand() {\n  LockCommand.__super__.constructor.call(this);\n}\n\n\n__extends(LockCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nLockCommand.prototype.execute = function(notification) {\n  var locked, note;\n  locked = notification.getBody();\n  note = locked ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, \"locked\");\n  this.applicationState.setLocked(locked);\n};\n\n/**\n * The SeekCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction GoLiveCommand() {\n  GoLiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(GoLiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nGoLiveCommand.prototype.execute = function(notification) {\n  var _base;\n  if (typeof (_base = this.playback).goLive === \"function\") {\n    _base.goLive();\n  }\n};\n\n/**\n * The TimeChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimeChangeCommand() {\n  TimeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimeChangeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimeChangeCommand.prototype.execute = function(notification) {\n  var time,\n    _this = this;\n  time = notification.getBody();\n  if (time.currentTime != null) {\n    this.facade.transform(TransformType.TIME, time.currentTime).then(function(time) {\n      return _this.applicationState.setCurrentTime(time);\n    });\n  }\n  if (time.duration != null) {\n    this.facade.transform(TransformType.TIME, time.duration).then(function(time) {\n      return _this.applicationState.setDuration(time);\n    });\n  }\n};\n\n/**\n * The TimedMetadataCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimedMetadataCommand() {\n  TimedMetadataCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimedMetadataCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimedMetadataCommand.prototype.execute = function(notification) {\n  var body, detail, type, value;\n  type = notification.getName();\n  body = notification.getBody();\n  detail = {\n    startTime: body.startTime,\n    endTime: body.endTime,\n    type: body.type,\n    track: body.track,\n    value: {\n      key: body.value.key,\n      data: body.value.data,\n      info: body.value.info\n    }\n  };\n  value = detail.value;\n  try {\n    if (!(value.info != null)) {\n      if (typeof value.data === \"string\") {\n        value.info = value.data;\n      } else if (value.data instanceof ArrayBuffer) {\n        value.info = Utils.arrayBufferToString(value.data);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.log(\"[AMP ERROR]: Could not parse timed metadata\");\n  }\n  notification.body = detail;\n  TimedMetadataCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeActiveStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeActiveStateCommand() {\n  ChangeActiveStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeActiveStateCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeActiveStateCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.config.getControls().mode !== ControlsMode.PERSISTENT ? notification.getBody() : ActiveState.ACTIVE;\n  this.applicationState.setActiveState(state);\n};\n\n/**\n * The ChangeDisplayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction ChangeDisplayStateCommand() {\n  ChangeDisplayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeDisplayStateCommand, PlayerEventCommand);\n\n\nChangeDisplayStateCommand.interval = null;\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeDisplayStateCommand.prototype.execute = function(notification) {\n  var core, fullscreen, state, view,\n    _this = this;\n  state = notification.getBody();\n  if (state === this.applicationState.getDisplayState()) {\n    return;\n  }\n  this.applicationState.setDisplayState(state);\n  if (this.config.getFullscreen().mode === FullscreenMode.EXTERNAL) {\n    this.sendNotifications(state);\n    return;\n  }\n  core = this.facade.getMediaElement();\n  view = this.facade.getViewComponent();\n  fullscreen = Utils.getFullScreenApi(view, core);\n  if (state === DisplayState.FULL_SCREEN) {\n    if (fullscreen.event != null) {\n      if (view.mozRequestFullScreen != null) {\n        document[fullscreen.event] = function(event) {\n          if (!document.mozFullScreen) {\n            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          }\n        };\n      } else {\n        view[fullscreen.event] = function(event) {\n          if (!(document[fullscreen.element] != null)) {\n            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          }\n        };\n      }\n    } else {\n      clearInterval(ChangeDisplayStateCommand.interval);\n      ChangeDisplayStateCommand.interval = setInterval(function() {\n        if (core.webkitDisplayingFullscreen !== true) {\n          _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          clearInterval(ChangeDisplayStateCommand.interval);\n        }\n      }, 100);\n    }\n    if (fullscreen.error != null) {\n      document.addEventListener(fullscreen.error, this.facade.logger.error.bind(this.facade.logger));\n    }\n    fullscreen.enter();\n  } else if (state === DisplayState.NORMAL) {\n    if (fullscreen != null) {\n      if (typeof fullscreen.exit === \"function\") {\n        fullscreen.exit();\n      }\n    }\n    core[fullscreen.event] = null;\n    clearInterval(ChangeDisplayStateCommand.interval);\n  }\n  this.sendNotifications(state);\n};\n\nChangeDisplayStateCommand.prototype.sendNotifications = function(state) {\n  setTimeout(this.sendNotification.bind(this, Notifications.FULL_SCREEN_CHANGE, state), 100);\n  this.dispatchEvent(\"fullscreenchange\", state === DisplayState.FULL_SCREEN);\n};\n\n/**\n * The PlayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlayCommand() {\n  PlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlayCommand.prototype.execute = function(notification) {\n  var userInitiated;\n  if (this.applicationState.getLocked() === true) {\n    return;\n  }\n  userInitiated = notification.getBody();\n  if (userInitiated && this.playback.initialized !== true) {\n    this.sendNotification(Notifications.INITIALIZED);\n  }\n  if (this.playback.initialized !== true || (!this.media.getSrc() && !this.media.getSource())) {\n    return;\n  }\n  if (!this.playback.getStarted()) {\n    this.sendNotification(Notifications.START);\n  }\n  this.playback.play();\n  PlayCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ToggleActiveCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleActiveCommand() {\n  ToggleActiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleActiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nToggleActiveCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.applicationState.getActiveState() === ActiveState.ACTIVE ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n};\n\nfunction Track(data) {\n  this.data = data != null ? data : {};\n  Track.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    kind: {\n      get: this.getKind,\n      enumerable: true,\n      configurable: false\n    },\n    label: {\n      get: this.getLabel,\n      enumerable: true,\n      configurable: false\n    },\n    language: {\n      get: this.getLanguage,\n      enumerable: true,\n      configurable: false\n    },\n    id: {\n      get: this.getId,\n      enumerable: true,\n      configurable: false\n    },\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(Track, EventDispatcher);\n\n\nTrack.prototype.getKind = function() {\n  return this.data.kind;\n};\n\nTrack.prototype.getLabel = function() {\n  return this.data.label;\n};\n\nTrack.prototype.getLanguage = function() {\n  return this.data.language;\n};\n\nTrack.prototype.getId = function() {\n  return this.data.id;\n};\n\nTrack.prototype.setEnabled = function(value) {\n  if (value === this.data.enabled) {\n    return;\n  }\n  this.data.enabled = value;\n  this.changeEnabled(value);\n  this.dispatchEvent(\"change\");\n};\n\nTrack.prototype.changeEnabled = function(value) {};\n\nTrack.prototype.getEnabled = function() {\n  return this.data.enabled;\n};\n\nTrack.prototype.flatten = function() {\n  return {\n    kind: this.getKind(),\n    label: this.getLabel(),\n    language: this.getLanguage(),\n    id: this.getId(),\n    enabled: this.getEnabled()\n  };\n};\n\nfunction XMLUtils() {}\n\nXMLUtils.createTextContent = function(xml, text) {\n  var node;\n  node = /[\\&<>]/.test(text) ? xml.createCDATASection(text) : xml.createTextNode(text);\n  return node;\n};\n\nXMLUtils.updateTextContent = function(node, str) {\n  var text;\n  text = XMLUtils.createTextContent(node.ownerDocument, str);\n  node.removeChild(node.childNodes[0]);\n  node.appendChild(text);\n  return node;\n};\n\nXMLUtils.serialize = function(xml) {\n  var serializer;\n  if (!(xml != null)) {\n    return;\n  }\n  if (typeof xml === \"string\") {\n    return xml;\n  }\n  try {\n    serializer = new XMLSerializer();\n    return serializer.serializeToString(xml);\n  } catch (err1) {\n    try {\n      serializer = document.implementation.createLSSerializer();\n      return xmlSerializer.writeToString(xml);\n    } catch (err3) {\n      try {\n        return xml.xml;\n      } catch (err2) {\n\n      }\n    }\n  }\n};\n\nXMLUtils.parse = function(text) {\n  var parser, xmlDoc;\n  if (window.DOMParser) {\n    parser = new DOMParser();\n    xmlDoc = parser.parseFromString(text, \"text/xml\");\n  } else {\n    xmlDoc = new ActiveXObject(\"Microsoft.XMLDOM\");\n    xmlDoc.async = false;\n    xmlDoc.loadXML(text);\n  }\n  return xmlDoc;\n};\n\n/**\n * Creates a new instance of TracksProxy.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction TracksProxy() {\n  TracksProxy.__super__.constructor.call(this, null, {});\n  this.data.audioTracks = new TrackList();\n  this.data.videoTracks = new TrackList();\n  this.data.textTracks = new TrackList();\n}\n\n\n__extends(TracksProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nTracksProxy.NAME = \"TracksProxy\";\n\nTracksProxy.prototype.clear = function() {\n  this.data.audioTracks.clear();\n  this.data.videoTracks.clear();\n  this.data.textTracks.clear();\n};\n\nTracksProxy.prototype.getAudioTracks = function() {\n  return this.data.audioTracks;\n};\n\nTracksProxy.prototype.getVideoTracks = function() {\n  return this.data.videoTracks;\n};\n\nTracksProxy.prototype.getTextTracks = function() {\n  return this.data.textTracks;\n};\n\n/**\n * The base player class.\n *\n * @param {Object} config\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Module}\n*/\nfunction Player(viewComponent) {\n  var _this = this;\n  Player.__super__.constructor.call(this, viewComponent);\n  this.ads = new EventDispatcher();\n  this.ads.enabled = false;\n  this.ads.getEnabled = function() {\n    return false;\n  };\n  this.ads.inprogress = false;\n  this.ads.getInProgress = function() {\n    return false;\n  };\n}\n\n\n__extends(Player, Module);\n\n\nPlayer.prototype.moduleName = \"amp\";\n\nPlayer.prototype.playerType = null;\n\nPlayer.prototype.hidden = false;\n\nPlayer.prototype.l10n = null;\n\nPlayer.prototype.appState = null;\n\nPlayer.prototype.mediaProxy = null;\n\nPlayer.prototype.bindings = null;\n\nPlayer.prototype.configuration = null;\n\nPlayer.prototype.params = null;\n\nPlayer.prototype.security = null;\n\nPlayer.prototype.createModel = function() {\n  this.appState = new ApplicationStateProxy();\n  this.registerProxy(this.appState);\n  this.bindings = new DataBindingProxy();\n  this.registerProxy(this.bindings);\n  this.security = new SecurityProxy();\n  this.registerProxy(this.security);\n  this.mediaProxy = new MediaProxy(this.config);\n  this.registerProxy(this.mediaProxy);\n  this.params = new ParamsProxy(this.config.params);\n  this.registerProxy(this.params);\n  this.configuration = new ConfigurationProxy(this.config);\n  this.registerProxy(this.configuration);\n};\n\n/** @override\n*/\nPlayer.prototype.resourcesLoaded = function() {\n  Player.__super__.resourcesLoaded.call(this);\n  Object.defineProperties(this, {\n    src: {\n      get: this.getSrc,\n      set: this.setSrc,\n      enumerable: true,\n      configurable: false\n    },\n    media: {\n      get: this.getMedia,\n      set: this.setMedia,\n      enumerable: true,\n      configurable: false\n    },\n    currentTime: {\n      get: this.getCurrentTime,\n      set: this.setCurrentTime,\n      enumerable: true,\n      configurable: false\n    },\n    autoplay: {\n      get: this.getAutoplay,\n      set: this.setAutoplay,\n      enumerable: true,\n      configurable: false\n    },\n    duration: {\n      get: this.getDuration,\n      enumerable: true,\n      configurable: false\n    },\n    playState: {\n      get: this.getPlayState,\n      enumerable: true,\n      configurable: false\n    },\n    seeking: {\n      get: this.getSeeking,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    ended: {\n      get: this.getEnded,\n      enumerable: true,\n      configurable: false\n    },\n    volume: {\n      get: this.getVolume,\n      set: this.setVolume,\n      enumerable: true,\n      configurable: false\n    },\n    muted: {\n      get: this.getMuted,\n      set: this.setMuted,\n      enumerable: true,\n      configurable: false\n    },\n    mediaElement: {\n      get: this.getMediaElement,\n      enumerable: true,\n      configurable: false\n    },\n    textTracks: {\n      get: (function() {\n        return this.getMediaElement().textTracks;\n      }),\n      enumerable: true,\n      configurable: false\n    },\n    audioTracks: {\n      get: this.getAudioTracks,\n      enumerable: true,\n      configurable: false\n    },\n    container: {\n      get: this.getContainer,\n      enumerable: true,\n      configurable: false\n    },\n    loop: {\n      get: this.getLoop,\n      set: this.setLoop,\n      enumerable: true,\n      configurable: false\n    },\n    displayState: {\n      get: this.getDisplayState,\n      set: this.setDisplayState,\n      enumerable: true,\n      configurable: false\n    },\n    playbackRate: {\n      get: this.getPlaybackRate,\n      set: this.setPlaybackRate,\n      enumerable: true,\n      configurable: false\n    },\n    language: {\n      get: this.getLanguage,\n      set: this.setLanguage,\n      enumerable: true,\n      configurable: false\n    },\n    localization: {\n      get: (function() {\n        return this.retrieveProxy(LocalizationProxy.NAME);\n      }),\n      enumerable: true,\n      configurable: false\n    },\n    version: {\n      get: this.getVersion,\n      enumerable: true,\n      configurable: false\n    },\n    error: {\n      get: this.getError,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    waiting: {\n      get: this.getWaiting,\n      set: this.setWaiting,\n      enumerable: true,\n      configurable: false\n    },\n    busy: {\n      get: this.getBusy,\n      set: this.setBusy,\n      enumerable: true,\n      configurable: false\n    },\n    cues: {\n      get: this.getCues,\n      set: this.setCues,\n      enumerable: true,\n      configurable: false\n    },\n    quality: {\n      get: this.getQuality,\n      set: this.setQuality,\n      enumerable: true,\n      configurable: false\n    },\n    qualityMode: {\n      get: this.getQualityMode,\n      set: this.setQualityMode,\n      enumerable: true,\n      configurable: false\n    },\n    qualityLevels: {\n      get: this.getQualityLevels,\n      enumerable: true,\n      configurable: false\n    },\n    debug: {\n      get: this.getDebug,\n      enumerable: true,\n      configurable: false\n    },\n    settings: {\n      get: this.getSettings,\n      enumerable: true,\n      configurable: false\n    },\n    mode: {\n      get: this.getMode,\n      enumerable: true,\n      configurable: false\n    },\n    buffering: {\n      get: this.getBuffering,\n      enumerable: true,\n      configurable: false\n    },\n    width: {\n      get: this.getWidth,\n      enumerable: true,\n      configurable: false\n    },\n    height: {\n      get: this.getHeight,\n      enumerable: true,\n      configurable: false\n    },\n    videoWidth: {\n      get: this.getVideoWidth,\n      enumerable: true,\n      configurable: false\n    },\n    videoHeight: {\n      get: this.getVideoHeight,\n      enumerable: true,\n      configurable: false\n    },\n    defaultMediaTransform: {\n      get: this.mediaProxy.transform,\n      enumerable: true,\n      configurable: false\n    },\n    absoluteCurrentTime: {\n      get: this.getAbsoluteCurrentTime,\n      set: this.setAbsoluteCurrentTime,\n      enumerable: true,\n      configurable: false\n    },\n    absoluteDuration: {\n      get: this.getAbsoluteDuration,\n      enumerable: true,\n      configurable: false\n    },\n    playbackTarget: {\n      get: this.getPlaybackTarget,\n      set: this.setPlaybackTarget,\n      enumerable: true,\n      configurable: false\n    }\n  });\n};\n\n/** @override\n*/\nPlayer.prototype.createView = function() {\n  this._settings = new SettingsMediator();\n  this.registerMediator(this._settings);\n};\n\n/** @override\n*/\nPlayer.prototype.createController = function() {\n  Player.__super__.createController.call(this);\n  this.registerCommand(Notifications.CHANGE_SETTINGS, ChangeSettingsCommand);\n  this.registerCommand(Notifications.SETTINGS_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.CUES_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.DESTROY, PlayerEventCommand);\n};\n\n/** @override\n*/\nPlayer.prototype.setViewComponent = function(viewComponent) {\n  viewComponent[\"amp\"] = this;\n  return Player.__super__.setViewComponent.call(this, viewComponent);\n};\n\n/**\n*/\nPlayer.prototype.getPlayerType = function() {\n  return this.playerType;\n};\n\n/**\n*/\nPlayer.prototype.getVersion = function() {\n  return AMP.getVersion();\n};\n\n/**\n*/\nPlayer.prototype.getDebug = function() {\n  return this.config.debug;\n};\n\n/**\n*/\nPlayer.prototype.getMode = function() {\n  return this.config.mode;\n};\n\n/**\n*/\nPlayer.prototype.createPlugins = function() {\n  this.sendNotification(PluginNotifications.REGISTER_PLUGINS, this.config);\n};\n\n/**\n*/\nPlayer.prototype.createMediaElement = function() {\n  return null;\n};\n\n/** @override\n*/\nPlayer.prototype.createFramework = function() {\n  Player.__super__.createFramework.call(this);\n  this.setMediaElement(this.createMediaElement());\n  this.createPlugins();\n};\n\n/**\n*/\nPlayer.prototype.getLanguage = function() {\n  return this.retrieveProxy(LocalizationProxy.NAME).getLanguage();\n};\n\n/**\n*/\nPlayer.prototype.setLanguage = function(value) {\n  this.retrieveProxy(LocalizationProxy.NAME).setLanguage(value);\n  return value;\n};\n\n/**\n*/\nPlayer.prototype.getLocalizedString = function(value, context) {\n  try {\n    return this.retrieveProxy(LocalizationProxy.NAME).getString(value, context);\n  } catch (error) {\n    return value;\n  }\n};\n\n/**\n * @return {HTMLObject|HTMLMediaElement} The media playback DOM element.\n*/\nPlayer.prototype.getMediaElement = function() {\n  return this.appState.getMediaElement();\n};\n\n/**\n*/\nPlayer.prototype.setMediaElement = function(value) {\n  this.appState.setMediaElement(value);\n  if (!(value.once != null)) {\n    value.once = function(type, listener) {\n      var handler, id;\n      id = Utils.createUID();\n      handler = function(id, type, listener, event) {\n        this.removeEventListener(type, this[id]);\n        delete this[id];\n        listener(event);\n      };\n      this[id] = handler.bind(this, id, type, listener);\n      this.addEventListener(type, this[id]);\n    };\n    value.once = value.once.bind(value);\n  }\n  value.amp = this;\n  return value;\n};\n\n/**\n * @return {HTMLElement} The container div.\n*/\nPlayer.prototype.getContainer = function() {\n  return this.getViewComponent();\n};\n\n/**\n * @return {HTMLElement} The container div.\n*/\nPlayer.prototype.getAudioTracks = function() {};\n\n/**\n * @param   {Object}  binding\n *    A data bound object to evaluate.\n *\n * @param   {?Object}  context\n *    Context object to pass to the bindings\n *\n * @return {Object}\n *    The evaluated result\n*/\nPlayer.prototype.evaluateBindings = function(binding, context) {\n  return DataBinding.evaluateBindings(binding, Utils.override(this.bindings.data, context));\n};\n\n/**\n * Determines if the core can play a given mimeType.\n *\n * @param   {string}  type\n *    The mimetype to check.\n *\n * @return  {string}  \"\"\n *    if the core can't play the mimeType\n*/\nPlayer.prototype.canPlayType = function(type) {};\n\n/**\n * Loads the video.\n*/\nPlayer.prototype.load = function() {};\n\n/**\n * Plays the currently loaded video.\n*/\nPlayer.prototype.play = function() {};\n\n/**\n * Plays the currently loaded video from its start time.\n*/\nPlayer.prototype.replay = function() {};\n\n/**\n * Pauses the currently loaded video.\n*/\nPlayer.prototype.pause = function() {};\n\n/**\n * Ends video playback.\n*/\nPlayer.prototype.end = function() {};\n\n/**\n * Sets user params.\n *\n * @param {Object} value The user params object.\n*/\nPlayer.prototype.setParams = function(value) {};\n\n/**\n * Gets user params.\n *\n * @return {Object} The user params object.\n*/\nPlayer.prototype.getParams = function() {};\n\n/**\n * Sets auto play flag.\n *\n * @param {boolean} value The autoplay flash.\n*/\nPlayer.prototype.setAutoplay = function(value) {};\n\n/**\n * Gets auto play flag.\n *\n * @return {boolean} The autoplay flash.\n*/\nPlayer.prototype.getAutoplay = function() {};\n\n/**\n * Sets player's loop flag.\n *\n * @param {boolean} value The loop flag.\n*/\nPlayer.prototype.setLoop = function(value) {};\n\n/**\n * Gets player's loop flag.\n *\n * @return {boolean} The loop flag.\n*/\nPlayer.prototype.getLoop = function() {};\n\n/**\n * Sets player's muted value.\n *\n * @param {boolean} value The muted value.\n*/\nPlayer.prototype.setMuted = function(value) {};\n\n/**\n * Gets player's muted value.\n *\n * @return {boolean} The muted value.\n*/\nPlayer.prototype.getMuted = function() {};\n\n/**\n * Mutes the player.\n*/\nPlayer.prototype.mute = function() {\n  return this.setMuted(true);\n};\n\n/**\n * Unmutes the player.\n*/\nPlayer.prototype.unmute = function() {\n  return this.setMuted(false);\n};\n\n/**\n * Sets the media object.\n *\n * @param {Object} value The media object for the video to play.\n*/\nPlayer.prototype.setMedia = function(value) {};\n\n/**\n * Gets the media object.\n *\n * @return {Object} The media object for the video to play.\n*/\nPlayer.prototype.getMedia = function() {};\n\n/**\n * Sets the current time of the video.\n *\n * @param {number} value The desired time to seek to.\n*/\nPlayer.prototype.setCurrentTime = function(value) {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current playhead time.\n*/\nPlayer.prototype.getCurrentTime = function() {};\n\n/**\n * Sets the current time of the video.\n *\n * @param {number} value The desired time to seek to.\n*/\nPlayer.prototype.setAbsoluteCurrentTime = function(value) {\n  return this.setCurrentTime(value);\n};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current playhead time.\n*/\nPlayer.prototype.getAbsoluteCurrentTime = function() {\n  return this.getCurrentTime();\n};\n\n/**\n * Gets the current time of the video as a UTC timestamp.\n *\n * @return {number} The current playhead time as a UTC timestamp.\n*/\nPlayer.prototype.getCurrentTimeUTC = function() {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current time of the video.\n*/\nPlayer.prototype.getDuration = function() {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current time of the video.\n*/\nPlayer.prototype.getAbsoluteDuration = function() {\n  return this.getDuration();\n};\n\n/**\n * Sets the source url of video.\n *\n * @param {string} value The source url of the video to play.\n*/\nPlayer.prototype.setSrc = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {string} The source url of the video to play.\n*/\nPlayer.prototype.getSrc = function() {};\n\n/**\n * Sets the source url of video.\n *\n * @param {Array.<Object>} value An array of source objects to choose from.\n*/\nPlayer.prototype.setSource = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {Array.<Object>} An array of source objects to choose from.\n*/\nPlayer.prototype.getSource = function() {};\n\n/**\n * Sets the source url of video.\n *\n * @param {number} value The source url of the video to play.\n*/\nPlayer.prototype.setVolume = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {number} The volume a number between 0 and 1.\n*/\nPlayer.prototype.getVolume = function() {};\n\n/**\n * The seeking flag.\n *\n * @return {boolean} The seeking flag.\n*/\nPlayer.prototype.getSeeking = function() {};\n\n/**\n * The paused flag.\n *\n * @return {boolean} The paused flag.\n*/\nPlayer.prototype.getPaused = function() {};\n\n/**\n * The ended flag.\n *\n * @return {boolean} The ended flag.\n*/\nPlayer.prototype.getEnded = function() {};\n\n/**\n * The buffering flag.\n *\n * @return {boolean} The buffering flag.\n*/\nPlayer.prototype.getBuffering = function() {\n  return this.appState.getBuffering();\n};\n\n/**\n * Sets the player's display state.\n *\n * @param {DisplayState} value\n *    The display state.\n*/\nPlayer.prototype.setDisplayState = function(value) {};\n\n/**\n * Returns the player's display state.\n *\n * @return {DisplayState}\n *    The display state.\n*/\nPlayer.prototype.getDisplayState = function() {};\n\n/**\n * Returns the player's waiting state.\n *\n * @return {boolean}\n *    The waiting state.\n*/\nPlayer.prototype.getWaiting = function() {\n  return this.appState.getWaiting();\n};\n\n/**\n * Sets the player's waiting state.\n *\n * @param {boolean} value\n *    The waiting state.\n*/\nPlayer.prototype.setWaiting = function(value) {\n  return this.appState.setWaiting(value);\n};\n\n/**\n * Returns the player's busy state.\n *\n * @return {boolean}\n *    The busy state.\n*/\nPlayer.prototype.getBusy = function() {\n  return this.appState.getBusy();\n};\n\n/**\n * Sets the player's busy state.\n *\n * @param {boolean} value\n *    The busy state.\n*/\nPlayer.prototype.setBusy = function(value) {\n  return this.appState.setBusy(value);\n};\n\n/**\n * Returns the player error.\n *\n * @return {Error}\n *    The Error\n*/\nPlayer.prototype.getError = function() {};\n\n/**\n * Enters the player into full screen mode.\n*/\nPlayer.prototype.enterFullScreen = function() {};\n\n/**\n * Exits the player out of full screen mode.\n*/\nPlayer.prototype.exitFullScreen = function() {};\n\n/**\n * Show the player\n*/\nPlayer.prototype.setHidden = function(value) {\n  var style;\n  if (value === this.appState.getHidden()) {\n    return;\n  }\n  this.appState.setHidden(value);\n  style = this.viewComponent.style;\n  if (value === true) {\n    this.hiddenData = {\n      width: style.width,\n      height: style.height,\n      paused: this.getPaused()\n    };\n    style.width = style.height = \"0px\";\n    if (this.hiddenData.paused === false) {\n      this.pause();\n    }\n  } else {\n    style.width = this.hiddenData.width;\n    style.height = this.hiddenData.height;\n    if (this.hiddenData.paused === false) {\n      this.play();\n    }\n    this.hiddenData = null;\n  }\n};\n\n/**\n * Hide the player\n*/\nPlayer.prototype.getHidden = function() {\n  return this.appState.getHidden();\n};\n\n/**\n * The player's width\n*/\nPlayer.prototype.getWidth = function() {\n  var _ref;\n  return (_ref = this.getViewComponent()) != null ? _ref.offsetWidth : void 0;\n};\n\n/**\n * The player's height\n*/\nPlayer.prototype.getHeight = function() {\n  var _ref;\n  return (_ref = this.getViewComponent()) != null ? _ref.offsetWidth : void 0;\n};\n\n/**\n * The media's source width\n*/\nPlayer.prototype.getVideoWidth = function() {\n  var _ref;\n  return (_ref = this.getMediaElement()) != null ? _ref.videoWidth : void 0;\n};\n\n/**\n * The media's source height\n*/\nPlayer.prototype.getVideoHeight = function() {\n  var _ref;\n  return (_ref = this.getMediaElement()) != null ? _ref.videoHeight : void 0;\n};\n\n/**\n * Records a content change\n *\n * @param {Object} content\n *    An object representing the new content\n*/\nPlayer.prototype.recordContentChange = function(content) {};\n\n/**\n * Sets the rate of playback.\n*/\nPlayer.prototype.setPlaybackRate = function() {};\n\n/**\n * Gets the rate of playback.\n*/\nPlayer.prototype.getPlaybackRate = function() {};\n\n/**\n * Sets the list of cues.\n*/\nPlayer.prototype.setCues = function(value) {\n  this.mediaProxy.setCues(value);\n  return value;\n};\n\n/**\n * Gets the list of cues.\n*/\nPlayer.prototype.getCues = function() {\n  return this.mediaProxy.getCues();\n};\n\n/**\n *\n*/\nPlayer.prototype.setQuality = function(value) {};\n\n/**\n *\n*/\nPlayer.prototype.getQuality = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getQualityLevels = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getQualityMode = function() {};\n\n/**\n *\n*/\nPlayer.prototype.setQualityMode = function(value) {};\n\n/**\n * Gets the play state.\n*/\nPlayer.prototype.getPlaystate = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getPlaybackTarget = function() {\n  return this.appState.getPlaybackTarget();\n};\n\n/**\n *\n*/\nPlayer.prototype.setPlaybackTarget = function(value) {\n  this.appState.setPlaybackTarget(value);\n};\n\n/**\n * Gets the list of media transforms\n*/\nPlayer.prototype.getMediaTransforms = function() {\n  return this.mediaProxy.getTransforms();\n};\n\n/**\n * Authorizes a protected stream\n*/\nPlayer.prototype.authorize = function(authorization) {\n  this.security.authorize(authorization);\n};\n\n/**\n * Force the player into live mode during DVR playback\n*/\nPlayer.prototype.goLive = function() {};\n\n/**\n *\n*/\nPlayer.prototype.appendChild = function(element) {\n  this.mediator.addLayer(element);\n};\n\n/**\n *\n*/\nPlayer.prototype.removeChild = function(element) {\n  this.mediator.removeLayer(element);\n};\n\n/**\n *\n*/\nPlayer.prototype.getSettings = function() {\n  var _ref;\n  return ((_ref = this._settings) != null ? _ref.getSettings() : void 0) || {\n    change: function() {}\n  };\n};\n\n/**\n * @override\n*/\nPlayer.prototype.destroy = function() {\n  this.sendNotification(Notifications.DESTROY);\n  Player.__super__.destroy.call(this);\n};\n\n/**\n * The HTMLPlayer class.\n *\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Player}\n*/\nfunction HTMLPlayer(viewComponent) {\n  HTMLPlayer.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(HTMLPlayer, Player);\n\n\nHTMLPlayer.prototype.playerType = \"html\";\n\nHTMLPlayer.prototype.playerCore = null;\n\nHTMLPlayer.prototype.tracks = null;\n\nHTMLPlayer.prototype.mediator = null;\n\n/** @override\n*/\nHTMLPlayer.prototype.createMediaElement = function() {\n  var viewComponent;\n  this.mediator = new MediaElementMediator(\"html5\", \"video\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n  viewComponent = this.mediator.getViewComponent();\n  if (viewComponent.dataset == null) {\n    viewComponent.dataset = {};\n  }\n  return viewComponent;\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createModel = function() {\n  var playbackProxy;\n  HTMLPlayer.__super__.createModel.call(this);\n  this.registerProxy(new LocalizationProxy(this.config));\n  playbackProxy = new PlaybackCoreProxy();\n  this.registerProxy(playbackProxy);\n  this.playerCore = new PlayerProxy(playbackProxy, this.config.getPlaybackOrder);\n  this.registerProxy(this.playerCore);\n  this.tracks = new TracksProxy();\n  this.registerProxy(this.tracks);\n  this.appState.setRenderMode(RenderMode.HTML);\n  this.bindings.initialize();\n  this.fps = Utils.override(FPS, this.config.fps);\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createView = function() {\n  HTMLPlayer.__super__.createView.call(this);\n  this.mediator = new PlayerMediator(\"html5\", this.getViewComponent());\n  this.registerMediator(this.mediator);\n  this.registerMediator(new PluginAdapter());\n  this.registerMediator(new VideoLayerMediator());\n  this.registerMediator(new OverlayLayerMediator());\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createController = function() {\n  HTMLPlayer.__super__.createController.call(this);\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n  this.registerCommand(Notifications.PLAY, PlayCommand);\n  this.registerCommand(Notifications.PLAYING, PlayingCommand);\n  this.registerCommand(Notifications.PAUSE, PauseCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.TOGGLE_FULL_SCREEN, ToggleFullScreenCommand);\n  this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);\n  this.registerCommand(Notifications.TOGGLE_ACTIVE, ToggleActiveCommand);\n  this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, ChangeActiveStateCommand);\n  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(Notifications.START, StartCommand);\n  this.registerCommand(Notifications.TIME_CHANGE, TimeChangeCommand);\n  this.registerCommand(Notifications.SEEK, SeekCommand);\n  this.registerCommand(Notifications.SEEKING, SeekingCommand);\n  this.registerCommand(Notifications.SEEKED, SeekedCommand);\n  this.registerCommand(Notifications.CHANGE_VOLUME, ChangeVolumeCommand);\n  this.registerCommand(Notifications.CHANGE_MUTED, ChangeMutedCommand);\n  this.registerCommand(Notifications.CHANGE_AUTOPLAY, ChangeAutoplayCommand);\n  this.registerCommand(Notifications.CHANGE_LOOP, ChangeLoopCommand);\n  this.registerCommand(Notifications.END, EndCommand);\n  this.registerCommand(Notifications.ENDED, EndedCommand);\n  this.registerCommand(Notifications.REPLAY, ReplayCommand);\n  this.registerCommand(Notifications.ERROR, ErrorCommand);\n  this.registerCommand(Notifications.READY, ReadyCommand);\n  this.registerCommand(Notifications.WAITING, WaitingCommand);\n  this.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n  this.registerCommand(Notifications.IS_USER_ACTIVE, IsUserActiveCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZED, AuthorizedCommand);\n  this.registerCommand(Notifications.INITIALIZED, InitializedCommand);\n  this.registerCommand(Notifications.REGISTER_PLAYBACK_CORE, RegisterPlaybackCoreCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, SeekCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n  this.registerCommand(Notifications.RECORD_CONTENT_CHANGE, RecordContentChangeCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, TimeUpdateCommand);\n  this.registerCommand(Notifications.TOGGLE_MUTED, ToggleMutedCommand);\n  this.registerCommand(Notifications.VOLUME_CHANGE, VolumeChangeCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, PlayRequestCommand);\n  this.registerCommand(Notifications.HAS_POST_CONTENT, HasPostContentCommand);\n  this.registerCommand(Notifications.LOCK, LockCommand);\n  this.registerCommand(UserNotifications.GO_LIVE, GoLiveCommand);\n  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);\n  this.registerCommand(Notifications.TIMED_METADATA, TimedMetadataCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.PROGRESS, PlayerEventCommand);\n  this.registerCommand(Notifications.CAN_PLAY, PlayerEventCommand);\n  this.registerCommand(Notifications.CAN_PLAY_THROUGH, PlayerEventCommand);\n  this.registerCommand(Notifications.LOAD_START, PlayerEventCommand);\n  this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.LOADED_METADATA, PlayerEventCommand);\n  this.registerCommand(Notifications.DURATION_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIUM_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.TEMPORAL_TYPE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.LANGUAGE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_AVAILABILITY_CHANGE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHENTICATION_FAILED, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_EXPIRED, PlayerEventCommand);\n  this.registerCommand(Notifications.FAIL_OVER_ATTEMPT, PlayerEventCommand);\n  this.registerCommand(Notifications.IS_LIVE, PlayerEventCommand);\n  this.registerCommand(Notifications.PAUSED, PlayerEventCommand);\n  this.registerCommand(Notifications.STALLED, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_SWITCHED, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGING, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_LEVELS_LOADED, PlayerEventCommand);\n  this.registerCommand(Notifications.MUTE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.RESUME, PlayerEventCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOAD_START, PlayerEventCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOADED, PlayerEventCommand);\n  this.registerCommand(Notifications.AUTOPLAY_BLOCKED, PlayerEventCommand);\n  this.registerCommand(Notifications.AUDIO_TRACK_SWITCH, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, MediaSequenceEndedCommand);\n  this.registerCommand(Notifications.ENABLE_VIDEO_EVENTS, EnableVideoEventsCommand);\n  this.registerCommand(Notifications.DISABLE_VIDEO_EVENTS, DisableVideoEventsCommand);\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.setMediaElement = function(value) {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement != null) {\n    mediaElement.removeEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n  }\n  value.addEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n  HTMLPlayer.__super__.setMediaElement.call(this, value);\n  return value;\n};\n\n/**\n * HACK: Fix for iOS 10 manipulating controls property incorrectly after leaving fullscreen\n*/\nHTMLPlayer.prototype.presentationModeChanged = function(event) {\n  /*\n  if (\"inline\" === event.target.webkitPresentationMode) {\n    event.target.controls = false;\n  }\n  */\n};\n\nHTMLPlayer.prototype.recordContentChange = function(content) {\n  this.sendNotification(Notifications.RECORD_CONTENT_CHANGE, content);\n};\n\nHTMLPlayer.prototype.canPlayType = function(type) {\n  return this.retrieveProxy(PlaybackProxy.NAME).canPlayType(type);\n};\n\nHTMLPlayer.prototype.getAudioTracks = function() {\n  return this.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n};\n\nHTMLPlayer.prototype.load = function() {\n  this.sendNotification(Notifications.LOAD);\n};\n\nHTMLPlayer.prototype.play = function() {\n  this.sendNotification(Notifications.PLAY, true);\n};\n\nHTMLPlayer.prototype.replay = function() {\n  this.sendNotification(Notifications.REPLAY);\n};\n\nHTMLPlayer.prototype.pause = function() {\n  this.sendNotification(Notifications.PAUSE);\n};\n\nHTMLPlayer.prototype.end = function() {\n  this.sendNotification(Notifications.END);\n};\n\nHTMLPlayer.prototype.setParams = function(value) {\n  this.sendNotification(Notifications.CHANGE_PARAMS, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getParams = function() {\n  return this.params.getData();\n};\n\nHTMLPlayer.prototype.setAutoplay = function(value) {\n  this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getAutoplay = function() {\n  var autoPlay, playbackProxy, _ref;\n  playbackProxy = this.retrieveProxy(PlaybackProxy.NAME);\n  autoPlay = ((Utils.isAutoplaySupported() && this.configuration.getMuted()) || playbackProxy.initialized) && (this.configuration.getAutoplay() || ((_ref = this.getMedia()) != null ? _ref.autoplay : void 0) === true);\n  return autoPlay;\n};\n\nHTMLPlayer.prototype.setLoop = function(value) {\n  this.sendNotification(Notifications.CHANGE_LOOP, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getLoop = function() {\n  return this.configuration.getLoop();\n};\n\nHTMLPlayer.prototype.setMuted = function(value) {\n  this.sendNotification(Notifications.CHANGE_MUTED, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getMuted = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getMuted();\n};\n\nHTMLPlayer.prototype.setMedia = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getMedia = function() {\n  return this.mediaProxy.getData();\n};\n\nHTMLPlayer.prototype.setCurrentTime = function(value) {\n  this.sendNotification(Notifications.SEEK, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getCurrentTime = function() {\n  return this.appState.getCurrentTime();\n};\n\nHTMLPlayer.prototype.setAbsoluteCurrentTime = function(value) {\n  this.sendNotification(Notifications.SEEK, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getAbsoluteCurrentTime = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getCurrentTime();\n};\n\nHTMLPlayer.prototype.getDuration = function() {\n  return this.appState.getDuration();\n};\n\nHTMLPlayer.prototype.getAbsoluteDuration = function() {\n  return this.mediaProxy.getDuration();\n};\n\nHTMLPlayer.prototype.setSrc = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    src: value\n  });\n  return value;\n};\n\nHTMLPlayer.prototype.getSrc = function() {\n  return this.mediaProxy.getSrc();\n};\n\nHTMLPlayer.prototype.setSource = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    source: value\n  });\n  return value;\n};\n\nHTMLPlayer.prototype.getSource = function() {\n  return this.mediaProxy.getSource();\n};\n\nHTMLPlayer.prototype.setVolume = function(value) {\n  this.sendNotification(Notifications.CHANGE_VOLUME, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getVolume = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getVolume();\n};\n\nHTMLPlayer.prototype.getSeeking = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getSeeking();\n};\n\nHTMLPlayer.prototype.getPaused = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getPaused();\n};\n\nHTMLPlayer.prototype.getEnded = function() {\n  return this.appState.getEnded();\n};\n\nHTMLPlayer.prototype.getError = function() {\n  return this.getMediaElement().error;\n};\n\nHTMLPlayer.prototype.setDisplayState = function(value) {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);\n};\n\nHTMLPlayer.prototype.getDisplayState = function(value) {\n  return this.appState.getDisplayState();\n};\n\nHTMLPlayer.prototype.enterFullScreen = function() {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.FULL_SCREEN);\n};\n\nHTMLPlayer.prototype.exitFullScreen = function() {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n};\n\nHTMLPlayer.prototype.setPlaybackRate = function(value) {\n  var _ref;\n  if (((_ref = this.ads) != null ? _ref.inProgress : void 0) === true || value === this.getMediaElement().playbackRate) {\n    return;\n  }\n  this.appState.setPlaybackRate(value);\n  this.getMediaElement().playbackRate = value;\n  this.dispatchEvent(new Event(Events.PLAYBACK_RATE_CHANGE, value));\n};\n\nHTMLPlayer.prototype.getPlaybackRate = function() {\n  return this.getMediaElement().playbackRate;\n};\n\nHTMLPlayer.prototype.getQualityLevels = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQualityLevels();\n};\n\nHTMLPlayer.prototype.setQuality = function(value) {\n  return this.retrieveProxy(PlaybackProxy.NAME).setQuality(value);\n};\n\nHTMLPlayer.prototype.getQuality = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQuality();\n};\n\nHTMLPlayer.prototype.getQualityMode = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQualityMode();\n};\n\nHTMLPlayer.prototype.setQualityMode = function(value) {\n  return this.retrieveProxy(PlaybackProxy.NAME).setQualityMode(value);\n};\n\n/**\n * Gets the play state.\n*/\nHTMLPlayer.prototype.getPlayState = function() {\n  return this.appState.getPlayState();\n};\n\n/**\n * Force the player into live mode during DVR playback\n*/\nHTMLPlayer.prototype.goLive = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).goLive();\n};\n\n/**\n * @override\n*/\nHTMLPlayer.prototype.destroy = function() {\n  var _ref, _ref1;\n  if ((_ref = this.retrieveProxy(PlayerProxy.NAME)) != null) {\n    if ((_ref1 = _ref.activePlaybackCore) != null) {\n      if (typeof _ref1.destroy === \"function\") {\n        _ref1.destroy();\n      }\n    }\n  }\n  HTMLPlayer.__super__.destroy.call(this);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FlashNotifications = {\n  READY: \"jsApiReady\",\n  RESET: \"mediaPlayerReset\",\n  LOADING: \"mediaPlayerLoading\",\n  PLAYER_ERROR: \"mediaPlayerError\",\n  MEDIA_ERROR: \"mediaError\",\n  ERROR_STREAM_NOT_FOUND: \"mediaPlayerErrorStreamNotFound\",\n  CAPABILITY_CHANGE: \"mediaPlayerCapabilityChange\",\n  PLAYBACK_OPEN: \"mediaPlayerPlaybackOpen\",\n  PLAYBACK_CLOSE: \"mediaPlayerPlaybackClose\",\n  PLAYING: \"mediaPlayerPlaying\",\n  ENDED: \"mediaPlayerPlaybackClose\",\n  MEDIA_SEQUENCE_ENDED: \"mediaPlayerPlaybackSequenceComplete\",\n  PAUSED: \"mediaPlayerPaused\",\n  BUFFERING: \"mediaPlayerBuffering\",\n  DURATION_CHANGE: \"mediaPlayerDurationChange\",\n  TIME_UPDATE: \"mediaPlayerPlayheadUpdate\",\n  SEEKING_CHANGE: \"mediaPlayerSeekingChange\",\n  ERROR: \"error\",\n  VOLUME_CHANGE: \"mediaPlayerVolumeChanged\",\n  PLAY_STATE_CHANGE: \"mediaPlayerPlayStateChange\",\n  STATE_CHANGE: \"mediaPlayerStateChange\",\n  CAPTION_DATA_CHANGE: \"mediaPlayerCaptiondataChange\",\n  FAIL_OVER_ATTEMPT: \"mediaPlayerFailoverAttempt\",\n  ELEMENT_EVENT: \"mediaPlayerElementEvent\",\n  PLAY: \"mediaPlayerResumeOrPausePlayback\",\n  BUFFERING_CHANGE: \"mediaPlayerBufferingChanged\",\n  APPLICATION_STATE_CHANGE: \"mediaPlayerApplicationStateChange\",\n  INITIALIZED: \"mediaPlayerInitialized\",\n  FULLSCREEN_CHANGE: \"mediaPlayerFullscreenChange\",\n  AUTHORIZE: \"mediaPlayerAuthenticate\",\n  CAPTIONING_REQUEST: \"mediaPlayerCaptioningRequest\",\n  CAPTION_LANG_CHANGE: \"mediaPlayerCaptionLangChange\",\n  RECOMMENDATIONS_LOADED: \"mediaPlayerRecommendationsLoaded\",\n  RECOMMENDATION_SELECTED: \"mediaPlayerRecommendationSelected\",\n  SHARE: \"mediaPlayerShare\",\n  SHARE_REQUEST: \"mediaPlayerShareRequest\",\n  AUTO_ADVANCE: \"mediaPlayerAutoAdvance\",\n  CREATE_FLASH_VARS: \"createFlashVars\",\n  CREATE_XML: \"createXML\",\n  FLASH_CREATED: \"flashCreated\",\n  PLAY_REQUEST: \"mediaPlayerPlaybackSequenceInitiated\",\n  LOAD_FEED: \"mediaPlayerDataFeedRequested\",\n  FEED_UPDATED: \"mediaPlayerDataFeedUpdated\",\n  FEED_LOADED: \"mediaPlayerFeedLoaded\",\n  TIMED_METADATA: \"mediaPlayerSendCuePoint\",\n  MEDIA_PLAYER_ID3_UPDATED: \"mediaPlayerID3Updated\"\n};\n\n/**\n * PlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction PlaybackProxy() {\n  PlaybackProxy.__super__.constructor.call(this, PlaybackProxy.NAME);\n  this.data = {\n    core: null,\n    muted: false,\n    started: false,\n    volume: 1,\n    currentTime: 0,\n    duration: 0,\n    src: null,\n    ended: false,\n    paused: false,\n    seeking: false,\n    loading: false,\n    waiting: false,\n    keyErrored: false\n  };\n  if (Utils.getDevice() === \"desktop\") {\n    this.initialized = true;\n  }\n  this.handlers = {\n    \"timeupdate\": this.ontimeupdate.bind(this),\n    \"durationchange\": this.ondurationchange.bind(this),\n    \"play\": this.onplay.bind(this),\n    \"playing\": this.onplaying.bind(this),\n    \"pause\": this.onpause.bind(this),\n    \"loadeddata\": this.onloadeddata.bind(this),\n    \"waiting\": this.onwaiting.bind(this),\n    \"seeking\": this.onseeking.bind(this),\n    \"seeked\": this.onseeked.bind(this),\n    \"ended\": this.onended.bind(this),\n    \"progress\": this.onprogress.bind(this),\n    \"error\": this.onerror.bind(this),\n    \"loadstart\": this.onloadstart.bind(this),\n    \"canplay\": this.oncanplay.bind(this),\n    \"canplaythrough\": this.oncanplaythrough.bind(this),\n    \"loadedmetadata\": this.onloadedmetadata.bind(this),\n    \"stalled\": this.onstalled.bind(this)\n  };\n  this.resume = {\n    event: Utils.getIEVersion() === -1 || Utils.getIEVersion() === 11 ? \"loadedmetadata\" : \"canplaythrough\",\n    listener: this.resumestart.bind(this)\n  };\n  this.textTrackHandlers = {\n    \"addtrack\": this.onaddtrack.bind(this)\n  };\n  this.onneedkey = this.onneedkey.bind(this);\n}\n\n\n__extends(PlaybackProxy, puremvc.Proxy);\n\n\n/**\n * The name of the this Proxy.\n *\n * @static\n * @type {string}\n*/\nPlaybackProxy.NAME = \"PlaybackProxy\";\n\n/** @private\n*/\nPlaybackProxy.prototype.data = null;\n\nPlaybackProxy.prototype.initialized = false;\n\nPlaybackProxy.prototype.enabled = null;\n\nPlaybackProxy.prototype.handlers = null;\n\nPlaybackProxy.prototype.resume = null;\n\nPlaybackProxy.prototype.playWhenLoaded = false;\n\nPlaybackProxy.prototype.metadataloaded = false;\n\nPlaybackProxy.prototype.activeCuesIndex = 0;\n\nPlaybackProxy.prototype.id3CueType = null;\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nPlaybackProxy.prototype.setEnabled = function(value) {\n  if (value === this.enabled) {\n    return;\n  }\n  this.enabled = value;\n  if (this.enabled === true) {\n    this.load();\n  } else {\n    this.applyHandlers(false);\n  }\n  return value;\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.applyHandlers = function(enabled) {\n  var action, handler, type, video, _ref;\n  if (enabled == null) {\n    enabled = true;\n  }\n  video = this.getMediaElement();\n  action = enabled ? \"addEventListener\" : \"removeEventListener\";\n  _ref = this.handlers;\n  for (type in _ref) {\n    handler = _ref[type];\n    video[action](type, handler);\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.resumestart = function(event) {\n  var video,\n    _this = this;\n  video = this.getMediaElement();\n  this.handlers.durationchange(event);\n  if (this.data.currentTime > 0 && this.data.ended !== true) {\n    setTimeout(function() {\n      _this.seek(_this.data.currentTime).then(_this.resumecomplete.bind(_this));\n    }, 50);\n  } else {\n    this.resumecomplete();\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.resumecomplete = function() {\n  this.data.loading = false;\n  this.applyHandlers(true);\n  if (this.playWhenLoaded === true) {\n    setTimeout(this.play.bind(this), 1);\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.onaddtrack = function(event) {\n  var track,\n    _this = this;\n  track = event.track;\n  if (track.kind !== \"metadata\") {\n    return;\n  }\n  track.mode = \"hidden\";\n  track.addEventListener(\"cuechange\", function(event) {\n    var cue, previousCue, _i, _len, _ref;\n    _ref = event.target.activeCues;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      cue = _ref[_i];\n      if (!(previousCue !== cue)) {\n        continue;\n      }\n      _this.sendNotification(Notifications.TIMED_METADATA, cue);\n      previousCue = cue;\n    }\n  });\n};\n\nPlaybackProxy.prototype.ontimeupdate = function(event) {\n  var currentTime, _ref;\n  currentTime = event.target.currentTime;\n  if (((_ref = this.facade.ads) != null ? _ref.inProgress : void 0) === true) {\n    return;\n  }\n  this.data.currentTime = currentTime;\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: currentTime\n  });\n};\n\nPlaybackProxy.prototype.ondurationchange = function(event) {\n  var duration;\n  duration = event.target.duration;\n  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {\n    return;\n  }\n  this.data.duration = duration;\n  if (/Android [4-7]/.test(navigator.userAgent) && this.getMediaElement().src.indexOf(\".m3u8\") !== -1 && duration === Infinity) {\n    return;\n  }\n  this.sendNotification(Notifications.CHANGE_DURATION, duration);\n};\n\nPlaybackProxy.prototype.onplay = function(event) {\n  this.data.paused = false;\n};\n\nPlaybackProxy.prototype.onplaying = function(event) {\n  this.data.paused = false;\n  this.data.seeking = false;\n  this.data.waiting = false;\n  this.sendNotification(Notifications.PLAYING);\n};\n\nPlaybackProxy.prototype.onpause = function(event) {\n  if (this.getMediaElement().ended === true || this.facade.playState === PlayState.READY) {\n    return;\n  }\n  if (this.data.waiting === true && this.playbackCoreName === \"hls\") {\n    return;\n  }\n  this.data.paused = true;\n  if (event.target.readyState > 0) {\n    this.sendNotification(Notifications.PAUSED);\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n  }\n};\n\nPlaybackProxy.prototype.onloadeddata = function(event) {\n  this.sendNotification(Notifications.LOADED_DATA);\n};\n\nPlaybackProxy.prototype.onwaiting = function(event) {\n  var video;\n  this.data.waiting = true;\n  this.sendNotification(Notifications.WAITING);\n  video = this.getMediaElement();\n  if (video.seeking === false && video.readyState === 2 && video.networkState === 2) {\n    video.once(\"playing\", this.sendNotification.bind(this, Notifications.BUFFERING_CHANGE, false));\n    this.sendNotification(Notifications.BUFFERING_CHANGE, true);\n  }\n};\n\nPlaybackProxy.prototype.onstalled = function(event) {\n  this.sendNotification(Notifications.STALLED);\n};\n\nPlaybackProxy.prototype.onseeking = function(event) {\n  var currentTime;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n  currentTime = event.target.currentTime;\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: currentTime\n  });\n  this.data.seeking = true;\n  this.sendNotification(Notifications.SEEKING);\n};\n\nPlaybackProxy.prototype.onseeked = function(event) {\n  this.data.seeking = false;\n  this.sendNotification(Notifications.SEEKED, event.target.currentTime);\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nPlaybackProxy.prototype.onended = function(event) {\n  this.data.ended = true;\n  this.sendNotification(Notifications.ENDED);\n};\n\nPlaybackProxy.prototype.onprogress = function(event) {\n  var buffered, video;\n  try {\n    video = this.getMediaElement();\n    buffered = video.buffered;\n    this.sendNotification(Notifications.PROGRESS, buffered.end(buffered.length - 1) / video.duration);\n  } catch (error) {\n\n  }\n};\n\nPlaybackProxy.prototype.onerror = function(event) {\n  this.sendNotification(Notifications.ERROR, this.getMediaElement().error);\n};\n\nPlaybackProxy.prototype.onloadstart = function(event) {\n  this.sendNotification(Notifications.LOAD_START);\n};\n\nPlaybackProxy.prototype.oncanplay = function(event) {\n  this.sendNotification(Notifications.CAN_PLAY);\n};\n\nPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  this.createTracks();\n  this.sendNotification(Notifications.CAN_PLAY_THROUGH);\n  this.sendNotification(Notifications.PROGRESS, this.getDuration());\n};\n\nPlaybackProxy.prototype.onloadedmetadata = function(event) {\n  this.metadataloaded = true;\n  this.sendNotification(Notifications.ENABLE_FULL_SCREEN);\n  this.sendNotification(Notifications.LOADED_METADATA);\n};\n\nPlaybackProxy.prototype.applyTextTrackHandlers = function(data) {\n  var action, _ref;\n  action = data === true ? \"addEventListener\" : \"removeEventListener\";\n  if ((_ref = this.getMediaElement().textTracks) != null) {\n    _ref[action](\"addtrack\", this.textTrackHandlers.addtrack);\n  }\n};\n\n/** @override\n*/\nPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, index, item, track, tracks, _i, _len;\n  audio = this.getMediaElement().audioTracks;\n  tracks = this.facade.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n  changeEnabled = function(track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(track) {\n      return track.data.enabled = false;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    return this.facade.tracks.getAudioTracks()[track.id].data.enabled = true;\n  };\n  if (audio != null) {\n    count = audio.length || 0;\n    for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n      item = audio[index];\n      if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n        continue;\n      }\n      track = new Track(item);\n      track.changeEnabled = changeEnabled.bind(this, track);\n      tracks.add(track, index + 1 === count);\n    }\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.reset = function() {\n  this.data.currentTime = 0;\n  this.data.duration = 0;\n  this.data.src = null;\n  this.data.ended = false;\n  this.data.paused = false;\n  this.data.seeking = false;\n  this.data.started = false;\n  this.data.loading = false;\n  this.applyTextTrackHandlers(false);\n};\n\n/**\n * @return {boolean}\n*/\nPlaybackProxy.prototype.getStarted = function() {\n  return this.data.started;\n};\n\n/**\n * The playback core\n *\n * @param {HTMLVideoElement} value\n *    The new playback core\n * @returns {HTMLVideoElement}\n *    The playback core\n * @type {HTMLVideoElement}\n *\n * @private\n*/\nPlaybackProxy.prototype.getMediaElement = function() {\n  return this.facade.getMediaElement();\n};\n\n/**\n *\n*/\nPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return medium === \"video\";\n};\n\n/**\n *\n*/\nPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return temporalType !== \"dvr\";\n};\n\n/**\n * Determines if the core can play a given mimeType.\n *\n * @return {String} \"\" if the core can't play the mimeType\n*/\nPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  var canPlay;\n  canPlay = document.createElement(\"video\").canPlayType(mimeType) || \"\";\n  if ((/Android (4\\.[1-9]|[5-6])/.test(navigator.userAgent) || /Silk\\/3/.test(navigator.userAgent)) && mimeType === Utils.mimeTypes.m3u8) {\n    canPlay = \"maybe\";\n  }\n  if (canPlay === \"probably\" && /video\\/f4m|x-flv/.test(mimeType) && /UCBrowser/.test(navigator.userAgent)) {\n    canPlay = \"\";\n  }\n  return canPlay;\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nPlaybackProxy.prototype.getPaused = function() {\n  return this.data.paused;\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nPlaybackProxy.prototype.getSeeking = function() {\n  return this.data.seeking;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.data.currentTime;\n};\n\nPlaybackProxy.prototype.setCurrentTime = function(value) {\n  if (value === this.data.currentTime) {\n    return;\n  }\n  this.data.currentTime = value;\n  if (this.getStarted()) {\n    this.seek(value);\n  }\n  return value;\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.seek = function(time) {\n  var _this = this;\n  if (time == null) {\n    time = this.data.currentTime;\n  }\n  return new Promise(function(resolve, reject) {\n    var interval, seeked, ua, video;\n    try {\n      video = _this.getMediaElement();\n      seeked = function() {\n        setTimeout(resolve, 10, time);\n      };\n      video.once(\"seeked\", seeked);\n      video.currentTime = time;\n      ua = navigator.userAgent;\n      if (/Android.*Chrome/.test(ua)) {\n        interval = setInterval(function() {\n          if (Math.round(video.currentTime) === Math.round(time)) {\n            clearInterval(interval);\n            video.dispatchEvent(new CustomEvent(\"seeked\"));\n          }\n        }, 10);\n      }\n    } catch (error) {\n      reject(error);\n    }\n  });\n};\n\n/**\n*/\nPlaybackProxy.prototype.goLive = function() {\n  var mediaElement, time;\n  mediaElement = this.getMediaElement();\n  time = mediaElement.duration === Infinity ? mediaElement.seekable.end(0) : mediaElement.duration;\n  mediaElement.currentTime = time;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getVolume = function() {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement.muted === true) {\n    return 0;\n  } else {\n    return mediaElement.volume;\n  }\n};\n\nPlaybackProxy.prototype.setVolume = function(value) {\n  if (this.getMuted() && value > 0) {\n    this.setMuted(false, false);\n  } else if (!this.getMuted() && value === 0) {\n    this.setMuted(true, false);\n  }\n  this.sendNotification(Notifications.VOLUME_CHANGE, this.getMediaElement().volume = value);\n  return value;\n};\n\n/**\n*/\nPlaybackProxy.prototype.getMuted = function() {\n  return this.data.muted;\n};\n\nPlaybackProxy.prototype.setMuted = function(value, changeVolume) {\n  var volume;\n  if (changeVolume == null) {\n    changeVolume = true;\n  }\n  if (this.data.muted === value) {\n    return;\n  }\n  this.data.muted = value;\n  if (this.data.muted === true) {\n    this.data.volume = this.getVolume();\n    volume = 0;\n  } else {\n    volume = this.data.volume;\n  }\n  this.getMediaElement().muted = value;\n  if (changeVolume === true) {\n    this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n    this.sendNotification(Notifications.VOLUME_CHANGE, volume);\n  }\n  this.sendNotification(Notifications.MUTE_CHANGE, this.data.muted);\n  return value;\n};\n\n/**\n * The duration of the video in seconds.\n *\n * @returns {Number}\n *    The duration of the video\n * @type {Number}\n*/\nPlaybackProxy.prototype.getDuration = function() {\n  return this.data.duration;\n};\n\n/**\n * Instructs the core to play.\n*/\nPlaybackProxy.prototype.play = function() {\n  var promise,\n    _this = this;\n  if (this.data.started !== true) {\n    this.data.started = true;\n    this.setEnabled(true);\n    this.playWhenLoaded = true;\n    if (this.metadataloaded === false) {\n      return;\n    }\n  } else if (this.data.loading === true) {\n    this.playWhenLoaded = true;\n    return;\n  }\n  if (this.getPaused()) {\n    this.sendNotification(Notifications.RESUME);\n  }\n  promise = this.getMediaElement().play();\n  if ((promise != null ? promise[\"catch\"] : void 0) != null) {\n    promise[\"catch\"](function(error) {\n      return _this.sendNotification(Notifications.AUTOPLAY_BLOCKED);\n    });\n  }\n};\n\n/**\n * Instructs the core to pause.\n*/\nPlaybackProxy.prototype.pause = function() {\n  this.data.paused = true;\n  this.getMediaElement().pause();\n};\n\nPlaybackProxy.prototype.getSrc = function() {\n  return this.facade.mediaProxy.getSrc();\n};\n\n/**\n * Instructs the core to load.\n*/\nPlaybackProxy.prototype.load = function() {\n  var element;\n  this.sendNotification(Notifications.WAITING);\n  this.data.loading = true;\n  this.playWhenLoaded = false;\n  this.metadataloaded = false;\n  element = this.getMediaElement();\n  element.once(this.resume.event, this.resume.listener);\n  element.addEventListener(\"loadedmetadata\", this.handlers.loadedmetadata);\n  element.addEventListener(\"durationchange\", this.handlers.durationchange);\n  element.addEventListener(\"canplaythrough\", this.handlers.canplaythrough);\n  element.addEventListener(\"webkitneedkey\", this.onneedkey);\n  element.addEventListener(\"error\", this.handlers.error);\n  this.applyTextTrackHandlers(true);\n  this.applySrc();\n};\n\nPlaybackProxy.prototype.applySrc = function() {\n  var element, muted, src, _ref;\n  src = this.getSrc();\n  if (!(src != null) || src === \"\") {\n    this.sendNotification(Notifications.ERROR, \"The value of src is not supported: \" + value);\n  }\n  element = this.getMediaElement();\n  element.src = src;\n  muted = element.muted;\n  if (muted === true) {\n    this.data.muted = true;\n  }\n  if (Utils.isIPad() && ((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 8) {\n    setTimeout(element.load.bind(element), 100);\n  } else {\n    element.load();\n  }\n};\n\nPlaybackProxy.prototype.setQuality = function(value) {};\n\nPlaybackProxy.prototype.getQuality = function() {};\n\nPlaybackProxy.prototype.getQualityLevels = function() {\n  return [];\n};\n\nPlaybackProxy.prototype.getQualityMode = function() {};\n\nPlaybackProxy.prototype.setQualityMode = function(value) {};\n\nPlaybackProxy.prototype.destroy = function() {\n  var element, key, value, _ref, _ref1;\n  element = this.getMediaElement();\n  _ref = this.handlers;\n  for (key in _ref) {\n    value = _ref[key];\n    element.removeEventListener(key, value);\n  }\n  element.removeEventListener(this.resume.event, this.resume.listener);\n  element.removeEventListener(\"webkitneedkey\", this.onneedkey);\n  if ((_ref1 = element.textTracks) != null) {\n    _ref1.removeEventListener(\"addtrack\", this.textTrackHandlers.addtrack);\n  }\n};\n\n/**\n  The EME specification (https://dvcs.w3.org/hg/html-media/raw-file/tip/encrypted-media/encrypted-media.html)\n  is supported starting OSX 10.10 and greater.\n*/\nPlaybackProxy.prototype.onneedkey = function(event) {\n  var contentId, disallowRetries, fps, initData, keySystem, keys, serverUrl, video, _ref,\n    _this = this;\n  video = event.target;\n  keySystem = Utils.getKeySystem();\n  keys = this.facade.mediaProxy.getKeys()[keySystem];\n  fps = this.facade.fps;\n  disallowRetries = (((_ref = this.facade.config.fps) != null ? _ref.allowKeyErrorRetries : void 0) != null) && this.facade.config.fps.allowKeyErrorRetries === false;\n  if (!(keys != null) || keySystem !== \"com.apple.fps.1_0\") {\n    return;\n  }\n  if (this.keyErrored && disallowRetries) {\n    this.getMediaElement().removeEventListener(\"webkitneedkey\", this.onneedkey);\n    return;\n  }\n  initData = event.initData;\n  contentId = fps.extractContentId(initData, keys);\n  serverUrl = fps.extractServerUrl(initData, keys);\n  fps.requestCertificate(keys).then(function(cert) {\n    return fps.concatInitDataIdAndCertificate(initData, contentId, cert);\n  }).then(function(initData) {\n    var session;\n    if (!WebKitMediaKeys.isTypeSupported(keySystem, \"video/mp4\")) {\n      throw \"Key System not supported\";\n    }\n    if (!(video.webkitKeys != null)) {\n      video.webkitSetMediaKeys(new WebKitMediaKeys(keySystem));\n    }\n    if (!(video.webkitKeys != null)) {\n      throw \"Could not create MediaKeys\";\n    }\n    session = video.webkitKeys.createSession(\"video/mp4\", initData);\n    if (!(session != null)) {\n      throw \"Could not create key session\";\n    }\n    session.addEventListener(\"webkitkeymessage\", function(event) {\n      fps.requestLicense(event.message, contentId, serverUrl, keys).then(function(key) {\n        session.update(key);\n      })[\"catch\"](function(error) {\n        session.close();\n        _this.keyErrored = true;\n        _this.facade.logger.error(\"[AMP DRM] A key request error was encountered.\", error);\n      });\n    });\n    session.addEventListener(\"webkitkeyadded\", function(event) {\n      _this.facade.logger.log(\"[AMP DRM] Decryption key was added to session.\");\n    });\n    session.addEventListener(\"webkitkeyerror\", function(event) {\n      _this.sendNotification(Notifications.ERROR, {\n        message: \"A decryption key error was encountered for key system \" + keySystem,\n        detail: event\n      });\n      session.close();\n      _this.keyErrored = true;\n      _this.facade.logger.log(\"[AMP DRM] A decryption key error was encountered.\", event);\n    });\n  })[\"catch\"](function(error) {\n    _this.facade.logger.error(error);\n  });\n};\n\n/**\n * The FlashPluginsInitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FlashPluginsInitializedCommand() {\n  FlashPluginsInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashPluginsInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFlashPluginsInitializedCommand.prototype.execute = function(notification) {\n  setTimeout(this.facade.pluginsinitialized.bind(this.facade), 0);\n};\n\n/**\n * The FlashStartCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction FlashStartCommand() {\n  FlashStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashStartCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFlashStartCommand.prototype.execute = function(notification) {\n  this.player.started = true;\n  this.sendNotification(Notifications.STARTED, notification.getBody());\n  this.sendNotification(Notifications.PLAY, notification.getBody());\n};\n\n/**\n * The WaitingCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction BufferingChangeCommand() {\n  BufferingChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(BufferingChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nBufferingChangeCommand.prototype.execute = function(notification) {\n  var buffering;\n  buffering = notification.getBody();\n  if (this.applicationState.getBuffering() === buffering) {\n    return;\n  }\n  this.applicationState.setBuffering(buffering);\n  BufferingChangeCommand.__super__.execute.call(this, notification);\n};\n\nfunction LocalizationWrapper(player, config) {\n  this.player = player;\n  this.config = config;\n  LocalizationWrapper.__super__.constructor.call(this, this.constructor.NAME);\n  this.proxy = new LocalizationProxy(this.config);\n  this.player.registerProxy(this.proxy);\n}\n\n\n__extends(LocalizationWrapper, puremvc.Mediator);\n\n\nLocalizationWrapper.prototype.player = null;\n\nLocalizationWrapper.prototype.config = null;\n\nLocalizationWrapper.prototype.proxy = null;\n\nLocalizationWrapper.NAME = \"LocalizationWrapper\";\n\n/**\n*/\nLocalizationWrapper.prototype.getString = function(key, context) {\n  return this.proxy.getString(key, context);\n};\n\n/** @override\n*/\nLocalizationWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n};\n\n/**\n*/\nLocalizationWrapper.prototype.handleNotification = function(notification) {\n  var application, body, config, element, flashvars, key, lang, locale, locales, name, prop, text, value, xml, _ref;\n  LocalizationWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      config = body.config;\n      flashvars.locale_setting = this.proxy.getLocaleId();\n      break;\n    case FlashNotifications.CREATE_XML:\n      xml = body.xml;\n      application = xml.firstChild;\n      locales = xml.getElementsByTagName(\"locales\")[0];\n      if (!(locales != null)) {\n        locales = xml.createElement(\"locales\");\n        application.appendChild(locales);\n      }\n      _ref = this.proxy.getLocales();\n      for (lang in _ref) {\n        locale = _ref[lang];\n        element = xml.createElement(\"locale\");\n        element.setAttribute(\"id\", lang);\n        locales.appendChild(element);\n        for (key in locale) {\n          value = locale[key];\n          prop = xml.createElement(\"property\");\n          prop.setAttribute(\"key\", key);\n          text = XMLUtils.createTextContent(xml, value);\n          prop.appendChild(text);\n          element.appendChild(prop);\n        }\n      }\n  }\n};\n\n/**\n * The ModuleMediator class.\n *\n * @param {string} name\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {puremvc.Mediator}\n*/\nfunction ModuleMediator(viewComponent) {\n  if (this.cssPrefix == null) {\n    this.cssPrefix = Namespace.PREFIX;\n  }\n  ModuleMediator.__super__.constructor.call(this, this.mediatorName, viewComponent);\n}\n\n\n__extends(ModuleMediator, puremvc.Mediator);\n\n\nModuleMediator.prototype.config = null;\n\nModuleMediator.prototype.cssPrefix = null;\n\nModuleMediator.prototype.classList = null;\n\n/** @override\n*/\nModuleMediator.prototype.initializeNotifier = function(key) {\n  var base;\n  ModuleMediator.__super__.initializeNotifier.call(this, key);\n  base = this.facade.player || this.facade;\n  this.config = base.retrieveProxy(ModuleProxy.NAME);\n  this.classList = this.classList = new ClassList(this.viewComponent);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction LocalizedMediator(viewComponent) {\n  LocalizedMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(LocalizedMediator, ModuleMediator);\n\n\nLocalizedMediator.prototype.localizationManager = null;\n\n/** @override\n*/\nLocalizedMediator.prototype.initializeNotifier = function(key) {\n  var target;\n  LocalizedMediator.__super__.initializeNotifier.call(this, key);\n  target = this.facade.player || this.facade;\n  this.localizationManager = target.retrieveProxy(LocalizationProxy.NAME);\n};\n\n/**\n * @constructor\n * @extends {LocalizedMediator}\n * @private\n*/\nfunction ComponentMediator(componentName, componentType, parent, element) {\n  this.componentName = componentName != null ? componentName : this.componentName;\n  this.componentType = componentType != null ? componentType : this.componentType;\n  this.parent = parent;\n  this.element = element;\n  if (this.mediatorName == null) {\n    this.mediatorName = this.createMediatorName();\n  }\n  ComponentMediator.__super__.constructor.call(this, this.viewComponent);\n}\n\n\n__extends(ComponentMediator, LocalizedMediator);\n\n\nComponentMediator.prototype.componentName = null;\n\nComponentMediator.prototype.componentType = null;\n\nComponentMediator.prototype.parent = null;\n\nComponentMediator.prototype.element = null;\n\nComponentMediator.prototype.classList = null;\n\nComponentMediator.prototype.state = null;\n\nComponentMediator.prototype.disabled = false;\n\n/**\n*/\nComponentMediator.prototype.onRegister = function() {\n  this.viewComponent = this.createViewComponent(this.parent, this.element);\n  this.classList = this.viewComponent._classList;\n  UI.bindEvents(this.viewComponent, this);\n};\n\n/**\n*/\nComponentMediator.prototype.createViewComponent = function(parent, element) {\n  var type;\n  type = this.getTypeList();\n  return UI.create(type, parent, element);\n};\n\n/**\n*/\nComponentMediator.prototype.createMediatorName = function() {\n  var type;\n  type = this.getTypeList();\n  type.push(\"mediator\");\n  type.push(Utils.createUID());\n  return type.join(\"-\");\n};\n\n/**\n*/\nComponentMediator.prototype.getTypeList = function() {\n  var type;\n  type = [];\n  if (this.componentName != null) {\n    type.push(this.componentName);\n  }\n  if (this.componentType != null) {\n    type = type.concat(this.componentType);\n  }\n  return type;\n};\n\n/**\n*/\nComponentMediator.prototype.create = function(type, parent, element, text) {\n  if (parent == null) {\n    parent = this;\n  }\n  if (parent === false) {\n    parent = null;\n  }\n  return UI.create(type, parent, element, text);\n};\n\n/**\n*/\nComponentMediator.prototype.createText = function(type, text, parent, element) {\n  if (parent == null) {\n    parent = this;\n  }\n  return UI.create(type, parent, element, text);\n};\n\n/**\n*/\nComponentMediator.prototype.setState = function(value) {\n  if (value === this.state) {\n    return;\n  }\n  if (this.state != null) {\n    this.classList.remove(this.state);\n  }\n  this.state = value;\n  if (this.state != null) {\n    this.classList.add(this.state);\n  }\n  return value;\n};\n\n/**\n*/\nComponentMediator.prototype.getState = function() {\n  return this.state;\n};\n\n/**\n*/\nComponentMediator.prototype.setDisabled = function(value) {\n  if (value === this.disabled) {\n    return;\n  }\n  this.disabled = value;\n  if (this.disabled) {\n    this.classList.add(\"disabled\");\n  } else {\n    this.classList.remove(\"disabled\");\n  }\n  return value;\n};\n\n/**\n*/\nComponentMediator.prototype.getDisabled = function() {\n  return this.disabled;\n};\n\n/**\n * @constructor\n * @private\n * @extends {ComponentMediator}\n*/\nfunction MediaElementMediator(componentName, viewComponent) {\n  this.mediatorName = \"\" + this.componentType + \"-mediator\";\n  MediaElementMediator.__super__.constructor.call(this, componentName, null, null, viewComponent);\n}\n\n\n__extends(MediaElementMediator, ComponentMediator);\n\n\nMediaElementMediator.prototype.componentType = \"media-element\";\n\nMediaElementMediator.prototype.created = false;\n\nMediaElementMediator.prototype.onRegister = function() {\n  if (this.created !== true) {\n    this.created = true;\n    MediaElementMediator.__super__.onRegister.call(this);\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction LayerMediator() {\n  LayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(LayerMediator, ComponentMediator);\n\n\nLayerMediator.prototype.componentType = \"layer\";\n\n/**\n * Registers the layer\n *\n * @override\n*/\nLayerMediator.prototype.onRegister = function() {\n  LayerMediator.__super__.onRegister.call(this);\n  this.registerLayer();\n};\n\n/**\n * Removes the layer\n *\n * @override\n*/\nLayerMediator.prototype.onRemove = function() {\n  LayerMediator.__super__.onRemove.call(this);\n  this.removeLayer();\n};\n\n/**\n *\n*/\nLayerMediator.prototype.registerLayer = function() {\n  this.sendNotification(Notifications.ADD_LAYER, this.viewComponent);\n};\n\n/**\n *\n*/\nLayerMediator.prototype.removeLayer = function() {\n  this.sendNotification(Notifications.REMOVE_LAYER, this.viewComponent);\n};\n\n/**\n * @constructor\n * @extends {LayerMediator}\n * @private\n*/\nfunction VideoLayerMediator() {\n  VideoLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(VideoLayerMediator, LayerMediator);\n\n\nVideoLayerMediator.prototype.componentName = \"video\";\n\n/** @override\n*/\nVideoLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYBACK_CORE_CHANGE];\n};\n\nVideoLayerMediator.prototype.mediator = null;\n\nVideoLayerMediator.prototype.mediaElement = null;\n\n/** @override\n*/\nVideoLayerMediator.prototype.handleNotification = function(notification) {\n  var body, isMediator, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAYBACK_CORE_CHANGE:\n      if (this.mediaElement != null) {\n        this.viewComponent.removeChild(this.mediaElement);\n      }\n      if (this.mediator != null) {\n        this.facade.removeMediator(this.mediator.getMediatorName());\n      }\n      isMediator = (body != null ? body.getViewComponent : void 0) != null;\n      if (isMediator) {\n        this.facade.registerMediator(body);\n        this.mediator = body;\n        this.mediaElement = this.mediator.getViewComponent();\n      } else {\n        this.mediator = null;\n        this.mediaElement = body;\n      }\n      if (this.mediaElement != null) {\n        this.facade.setMediaElement(this.mediaElement);\n        this.viewComponent.appendChild(this.mediaElement);\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n * @extends {ModuleMediator}\n*/\nfunction PlayerMediator(componentName, viewComponent) {\n  this.componentName = componentName;\n  this.layers = [];\n  PlayerMediator.__super__.constructor.call(this, null, null, null, viewComponent);\n}\n\n\n__extends(PlayerMediator, ComponentMediator);\n\n\nPlayerMediator.prototype.componentType = \"player\";\n\nPlayerMediator.prototype.core = null;\n\nPlayerMediator.prototype.medium = null;\n\nPlayerMediator.prototype.layers = null;\n\nPlayerMediator.prototype.ready = false;\n\n/** @override\n*/\nPlayerMediator.prototype.onRegister = function() {\n  var device;\n  PlayerMediator.__super__.onRegister.call(this);\n  device = Utils.getDevice();\n  if ((device != null)) {\n    this.classList.add(device);\n  }\n  if (Utils.isTouchDevice()) {\n    this.classList.add(\"touch\");\n  }\n};\n\n/** @override\n*/\nPlayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.DISPLAY_STATE_CHANGE, Notifications.ACTIVE_STATE_CHANGE, Notifications.PLAY_STATE_CHANGE, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.MEDIUM_CHANGE, Notifications.DURATION_CHANGE, Notifications.TEMPORAL_TYPE_CHANGE, Notifications.IS_LIVE, Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.READY];\n};\n\n/** @override\n*/\nPlayerMediator.prototype.handleNotification = function(notification) {\n  var body, name, previous, state, states, value;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.ACTIVE_STATE_CHANGE:\n    case Notifications.PLAY_STATE_CHANGE:\n    case Notifications.DISPLAY_STATE_CHANGE:\n    case Notifications.MEDIUM_CHANGE:\n      states = body;\n      value = states.value;\n      previous = states.previous;\n      if ((previous != null) && this.classList.contains(previous)) {\n        this.classList.remove(previous);\n      }\n      if (value != null) {\n        this.classList.add(value);\n      }\n      break;\n    case Notifications.ADD_APPLICATION_STATE:\n      state = body;\n      this.classList.add(state);\n      break;\n    case Notifications.REMOVE_APPLICATION_STATE:\n      state = body;\n      this.classList.remove(state);\n      break;\n    case Notifications.TEMPORAL_TYPE_CHANGE:\n      if (body.previous) {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, body.previous);\n      }\n      if (body.value) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, body.value);\n      }\n      break;\n    case Notifications.IS_LIVE:\n      if (body === true) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"is-live\");\n      } else {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"is-live\");\n      }\n      break;\n    case Notifications.DURATION_CHANGE:\n      if (body > 3600) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"long-form\");\n      } else {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"long-form\");\n      }\n      break;\n    case Notifications.ADD_LAYER:\n      this.addLayer(body);\n      break;\n    case Notifications.REMOVE_LAYER:\n      this.removeLayer(body);\n      break;\n    case Notifications.READY:\n      this.initialize();\n      this.viewCreated();\n  }\n};\n\n/**\n*/\nPlayerMediator.prototype.initialize = function() {\n  var layer, _i, _len, _ref;\n  this.ready = true;\n  _ref = this.layers;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    layer = _ref[_i];\n    if (!this.viewComponent.contains(layer)) {\n      this.viewComponent.appendChild(layer);\n    }\n  }\n};\n\nPlayerMediator.prototype.viewCreated = function() {\n  this.sendNotification(Notifications.VIEW_CREATED);\n};\n\n/**\n*/\nPlayerMediator.prototype.addLayer = function(layer) {\n  this.layers.push(layer);\n  if (this.ready) {\n    this.viewComponent.appendChild(layer);\n  }\n};\n\n/**\n*/\nPlayerMediator.prototype.removeLayer = function(layer) {\n  var index;\n  if (this.viewComponent.contains(layer)) {\n    this.viewComponent.removeChild(layer);\n  }\n  index = this.layers.indexOf(layer);\n  if (index >= 0) {\n    this.layers.splice(index, 1);\n  }\n};\n\n/**\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {PlayerMeditator}\n*/\nfunction FlashPlayerMediator(viewComponent) {\n  FlashPlayerMediator.__super__.constructor.call(this, this.type, viewComponent);\n}\n\n\n__extends(FlashPlayerMediator, PlayerMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {String}\n*/\nFlashPlayerMediator.NAME = \"FlashPlayerMediator\";\n\nFlashPlayerMediator.prototype.type = \"flash\";\n\n/** @override\n*/\nFlashPlayerMediator.prototype.listNotificationInterests = function() {\n  return FlashPlayerMediator.__super__.listNotificationInterests.call(this).concat([PluginNotifications.PLUGINS_INITIALIZED]);\n};\n\n/** @override\n*/\nFlashPlayerMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      this.viewCreated();\n      return;\n    case PluginNotifications.PLUGINS_INITIALIZED:\n      this.initialize();\n      return;\n  }\n  FlashPlayerMediator.__super__.handleNotification.call(this, notification);\n};\n\n/**\n * The RegisterPlaybackCoreCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlaybackTargetChangeCommand() {\n  PlaybackTargetChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlaybackTargetChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlaybackTargetChangeCommand.prototype.execute = function(notification) {\n  var note, target;\n  target = notification.getBody().value;\n  if (target === \"amp\") {\n    note = Notifications.REMOVE_APPLICATION_STATE;\n  } else {\n    note = Notifications.ADD_APPLICATION_STATE;\n  }\n  this.sendNotification(note, \"remote-playback\");\n  PlaybackTargetChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The FlashAuthorizedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FlashAuthorizedCommand() {\n  FlashAuthorizedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashAuthorizedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFlashAuthorizedCommand.prototype.execute = function(notification) {\n  var media;\n  FlashAuthorizedCommand.__super__.execute.call(this, notification);\n  media = Utils.clone(this.media.getData());\n  media.src = this.media.getSrc();\n  this.facade.getMediaElement().authenticationComplete({\n    media: media\n  });\n};\n\n/**\n * PlaybackCoreProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackProxy}\n*/\nfunction PlaybackCoreProxy(supportedTypes, config) {\n  this.supportedTypes = supportedTypes != null ? supportedTypes : this.supportedTypes;\n  this.config = config;\n  PlaybackCoreProxy.__super__.constructor.call(this);\n  this.temporalTypes = [\"vod\", \"live\", \"ondemand\"];\n}\n\n\n__extends(PlaybackCoreProxy, PlaybackProxy);\n\n\nPlaybackCoreProxy.prototype.temporalTypes = null;\n\nPlaybackCoreProxy.prototype.supportedTypes = null;\n\nPlaybackCoreProxy.prototype.playbackCoreName = \"default\";\n\nPlaybackCoreProxy.prototype.config = null;\n\n/**\n*/\nPlaybackCoreProxy.prototype.onRegister = function() {\n  this.mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getUseMAE = function() {\n  var maeConfig;\n  maeConfig = this.config.mae;\n  return (maeConfig != null) && maeConfig.enabled !== false;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getPlaybackCoreName = function() {\n  return this.playbackCoreName;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getSupportedTypes = function() {\n  return this.supportedTypes || [];\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.setSupportedTypes = function(types) {\n  this.supportedTypes = types;\n  return types;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getTemporalTypes = function() {\n  return this.temporalTypes || [];\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.setTemporalTypes = function(types) {\n  this.temporalTypes = types;\n  return types;\n};\n\n/** @override\n*/\nPlaybackCoreProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return this.getTemporalTypes().indexOf(temporalType) !== -1;\n};\n\n/** @override\n*/\nPlaybackCoreProxy.prototype.canPlayType = function(mimeType) {\n  if (this.supportedTypes != null) {\n    if (this.getSupportedTypes().indexOf(mimeType) !== -1) {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  } else {\n    return PlaybackCoreProxy.__super__.canPlayType.call(this, mimeType);\n  }\n};\n\n/**\n * ChromeCastPlaybackProxy constructor.\n *\n * @constructor\n * @extends {PlaybackCoreProxy}\n * @private\n*/\nfunction FlashPlaybackProxy(player) {\n  this.player = player;\n  FlashPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(FlashPlaybackProxy, PlaybackCoreProxy);\n\n\n/**\n * The name of the this Proxy.\n *\n * @static\n * @type {string}\n*/\nFlashPlaybackProxy.NAME = PlaybackProxy.NAME;\n\nFlashPlaybackProxy.prototype.player = null;\n\nFlashPlaybackProxy.prototype.initialized = true;\n\nFlashPlaybackProxy.prototype.playbackCoreName = \"flash\";\n\nFlashPlaybackProxy.prototype.supportedTypes = [\"video/mp4\", \"video/x-flv\", \"video/f4m\", \"application/smil\", \"application/smil+xml\"];\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getPaused = function() {\n  return this.player.getPaused();\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getEnded = function() {\n  return this.player.getEnded();\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getSeeking = function() {\n  return this.player.getSeeking();\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.player.getCurrentTime();\n};\n\nFlashPlaybackProxy.prototype.setCurrentTime = function(value) {\n  this.player.setCurrentTime(value);\n  return value;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getSrc = function() {\n  return this.player.getSrc();\n};\n\nFlashPlaybackProxy.prototype.setSrc = function(value) {\n  this.player.setSrc(value);\n  return value;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getVolume = function() {\n  return this.player.getVolume();\n};\n\nFlashPlaybackProxy.prototype.setVolume = function(value) {\n  this.player.setVolume(value);\n  return value;\n};\n\n/**\n*/\nFlashPlaybackProxy.prototype.getMuted = function() {\n  return this.player.getMuted();\n};\n\nFlashPlaybackProxy.prototype.setMuted = function(value) {\n  this.player.setMuted(value);\n  return value;\n};\n\n/**\n * The duration of the video in seconds.\n *\n * @returns {Number}\n *    The duration of the video\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getDuration = function(value) {\n  return this.player.getDuration();\n};\n\n/**\n * Instructs the core to play.\n*/\nFlashPlaybackProxy.prototype.play = function() {\n  this.player.play();\n};\n\n/**\n * Instructs the core to pause.\n*/\nFlashPlaybackProxy.prototype.pause = function() {\n  this.player.pause();\n};\n\n/**\n * Instructs the core to load.\n*/\nFlashPlaybackProxy.prototype.load = function() {\n  this.player.load();\n};\n\n/**\n * The FlashPlayer class\n *\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Player}\n*/\nfunction FlashPlayer(viewComponent) {\n  var _this = this;\n  this.flashObjectID += Date.now();\n  this.plugins = {};\n  this._displayState = DisplayState.NORMAL;\n  this.debug = /debug\\=true/.test(location.search);\n  FlashPlayer.__super__.constructor.call(this, viewComponent);\n  this.addEventListener(\"mediachange\", function(event) {\n    var item, mediaElement, textTracks, track, tracks, _i, _len;\n    tracks = event.detail.track;\n    mediaElement = _this.getMediaElement();\n    textTracks = mediaElement.textTracks = [];\n    if (!(tracks != null)) {\n      return;\n    }\n    for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n      track = tracks[_i];\n      item = {\n        kind: track.kind,\n        label: track.label,\n        language: track.srclang,\n        _mode: track.mode\n      };\n      Object.defineProperty(item, \"mode\", {\n        get: function() {\n          return this._mode;\n        },\n        set: function(value) {\n          var visible;\n          this._mode = value;\n          visible = value === \"showing\";\n          if (visible) {\n            mediaElement.setTrackByLanguage(this.language);\n          }\n          mediaElement.setPlayerProperty(\"captionDisplay\", {\n            visible: visible\n          });\n        },\n        enumerable: true,\n        configurable: false\n      });\n      textTracks.push(item);\n    }\n  });\n}\n\n\n__extends(FlashPlayer, Player);\n\n\n/**\n * @override\n*/\nFlashPlayer.prototype.initialize = function(config, parentModule) {\n  var _ref, _ref1;\n  this.config = config;\n  this.parentModule = parentModule;\n  this.createDefaults();\n  this.logEvents = ((_ref = this.config.flash) != null ? _ref.logEvents : void 0) === true || ((_ref1 = QueryString[\"amp-flash-log\"]) != null ? _ref1.toLowerCase() : void 0) === \"true\";\n  FlashPlayer.__super__.initialize.call(this, this.config, this.parentModule);\n};\n\n/**\n*/\nFlashPlayer.prototype.loadModuleResources = function(resources) {\n  var _this = this;\n  return FlashPlayer.__super__.loadModuleResources.call(this, resources).then(function() {\n    var key, locales, promises, update, value;\n    locales = _this.config.locales;\n    promises = [];\n    update = function(key, resource) {\n      locales[key] = resource.data;\n    };\n    for (key in locales) {\n      value = locales[key];\n      if (typeof value === \"string\") {\n        promises.push(AMP.addResource({\n          src: _this.evaluatePaths(value),\n          type: Utils.mimeTypes.json\n        }).then(update.bind(_this, key))[\"catch\"](function(error) {\n          return Promise.resolve();\n        }));\n      }\n    }\n    return Promise.all(promises);\n  });\n};\n\n/** @override\n*/\nFlashPlayer.prototype.pluginsinitialized = function() {\n  var attributes, expressInstallSWF, flash, params, swf, swfs, version, xml, _ref;\n  flash = this.config.flash || {};\n  swfs = ((_ref = flash[\"static\"]) != null ? _ref.enabled : void 0) === true ? flash[\"static\"] : flash;\n  swf = this.debug && (swfs.debug != null) ? swfs.debug : swfs.swf || \"amp.swf\";\n  version = flash.version || \"10.1\";\n  expressInstallSWF = this.evaluatePaths(flash.expressInstallSWF) || \"playerProductInstall.swf\";\n  params = this.createParams(flash);\n  attributes = this.createAttributes(flash);\n  this.flashvars = this.createFlashVars(flash);\n  if (!(this.flashvars.settings_url != null)) {\n    xml = this.createXML(this.config);\n    if (xml != null) {\n      this.flashvars.settings_xml = xml;\n    }\n  }\n  attributes.data = this.evaluatePaths(swf);\n  this.createdHandler(Utils.createFlashObject({\n    params: params,\n    attributes: attributes,\n    vars: this.flashvars\n  }, this.getMediaElement().parentNode));\n};\n\nFlashPlayer.prototype.playerType = \"flash\";\n\nFlashPlayer.prototype.flashObjectID = \"flashObject\";\n\nFlashPlayer.prototype.loaded = false;\n\nFlashPlayer.prototype.flashvars = null;\n\nFlashPlayer.prototype._paused = false;\n\nFlashPlayer.prototype._ended = false;\n\nFlashPlayer.prototype._muted = false;\n\nFlashPlayer.prototype.plugins = null;\n\nFlashPlayer.prototype.debug = false;\n\nFlashPlayer.prototype.started = false;\n\nFlashPlayer.prototype._displayState = null;\n\nFlashPlayer.prototype.logEvents = false;\n\nFlashPlayer.prototype._loop = false;\n\nFlashPlayer.prototype.playback = null;\n\nFlashPlayer.prototype.flashPlugins = [\n  {\n    id: \"AkamaiAdvancedStreamingPlugin\",\n    src: \"//sslplayers-vh.akamaihd.net/flash/plugins/osmf/advanced-streaming-plugin/v3.10/osmf2.0/AkamaiAdvancedStreamingPlugin.swf\",\n    absolute: true,\n    host: \"osmf\",\n    main: \"com.akamai.osmf.AkamaiAdvancedStreamingPluginInfo\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"ErrorMessagingPlugin\",\n    src: '#{paths.resources}plugins/ErrorMessagingPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ErrorMessagingPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"VideoMetricsViewPlugin\",\n    src: '#{paths.resources}plugins/VideoMetricsViewPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"VideoMetricsViewPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"VideoStatsInfoOverlayPlugin\",\n    src: '#{paths.resources}plugins/VideoStatsInfoOverlayPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"VideoStatsInfoOverlayPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nFlashPlayer.prototype.flashView = null;\n\n/** @override\n*/\nFlashPlayer.prototype.createModel = function() {\n  FlashPlayer.__super__.createModel.call(this);\n  this.playback = new FlashPlaybackProxy(this);\n  this.registerProxy(this.playback);\n  this.appState.setRenderMode(RenderMode.FLASH);\n  this.bindings.initialize();\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createView = function() {\n  FlashPlayer.__super__.createView.call(this);\n  this.mediator = new FlashPlayerMediator(this.getViewComponent());\n  this.registerMediator(this.mediator);\n  this.registerMediator(new VideoLayerMediator());\n  this.registerMediator(new OverlayLayerMediator());\n  this.registerMediator(new LocalizationWrapper(this, this.config));\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createController = function() {\n  var _ref,\n    _this = this;\n  FlashPlayer.__super__.createController.call(this);\n  if (((_ref = this.config.plugins) != null ? _ref.react : void 0) != null) {\n    this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);\n    this.getDisplayState = function() {\n      return _this.appState.getDisplayState();\n    };\n    this.setDisplayState = function(value) {\n      return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);\n    };\n  }\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, FlashPluginsInitializedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZED, FlashAuthorizedCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.START, FlashStartCommand);\n  this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAY, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, PlayerEventCommand);\n  this.registerCommand(FlashNotifications.FLASH_CREATED, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);\n  this.registerCommand(FlashNotifications.CREATE_XML, PlayerEventCommand);\n  this.registerCommand(FlashNotifications.CREATE_FLASH_VARS, PlayerEventCommand);\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createMediaElement = function() {\n  var video, viewComponent;\n  video = new MediaElementMediator(\"flash\", \"div\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, video);\n  viewComponent = video.getViewComponent();\n  viewComponent.id = viewComponent.name = this.flashObjectID;\n  return viewComponent;\n};\n\n/**\n*/\nFlashPlayer.prototype.createDefaults = function() {\n  var plugin, resources, swf, _i, _len, _ref, _ref1, _ref2;\n  if (!((_ref = this.flashPlugins) != null ? _ref.length : void 0) > 0) {\n    return;\n  }\n  resources = this.config.resources || [];\n  if (((_ref1 = this.config.flash) != null ? _ref1.resources : void 0) != null) {\n    resources = resources.concat(this.config.flash.resources);\n  }\n  swf = Utils.mimeTypes.swf;\n  _ref2 = this.flashPlugins;\n  for (_i = 0, _len = _ref2.length; _i < _len; _i++) {\n    plugin = _ref2[_i];\n    if ((plugin != null) && resources.filter(function(resource) {\n      return resource.id === plugin.id;\n    }).length === 0) {\n      if (plugin.type == null) {\n        plugin.type = swf;\n      }\n      resources.push(plugin);\n    }\n  }\n  this.config.resources = resources;\n};\n\n/**\n*/\nFlashPlayer.prototype.createParams = function(flash) {\n  var params;\n  params = {\n    allowFullScreen: true,\n    allowScriptAccess: \"always\",\n    wmode: \"direct\",\n    bgColor: \"#000000\"\n  };\n  if (flash.params != null) {\n    if (flash.params.allowFullScreen != null) {\n      params.allowFullScreen = flash.params.allowFullScreen;\n    }\n    if (flash.params.allowScriptAccess != null) {\n      params.allowScriptAccess = flash.params.allowScriptAccess;\n    }\n    if (flash.params.wmode != null) {\n      params.wmode = flash.params.wmode;\n    }\n    if (flash.params.bgColor != null) {\n      params.bgColor = flash.params.bgColor;\n    }\n  }\n  if (params.wmode === \"direct\" && /MSIE/.test(navigator.userAgent)) {\n    params.wmode = \"transparent\";\n  }\n  return params;\n};\n\n/** @override\n*/\nFlashPlayer.prototype.getModules = function() {\n  return this.plugins;\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createPlugins = function() {\n  var def, feature, init, key, plugin, plugins, promises, register, type, _ref,\n    _this = this;\n  type = this.getPlayerType();\n  _ref = AMP.plugins;\n  for (key in _ref) {\n    register = _ref[key];\n    if (!((key in this.config) && (this.config[key] != null) && !(this.config[key].enabled === false))) {\n      continue;\n    }\n    def = register[type];\n    if (!(def != null)) {\n      this.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n      continue;\n    }\n    try {\n      plugin = this[key] = this.plugins[key] = new def(this, this.config[key]);\n      this.registerMediator(this.plugins[key]);\n      feature = typeof plugin.getFeatureName === \"function\" ? plugin.getFeatureName() : void 0;\n      if (feature != null) {\n        this[feature] = plugin;\n      }\n      if (plugin.flashView != null) {\n        this.flashView = Utils.override(this.flashView, plugin.flashView);\n      }\n      this.logger.debug(\"[AMP] Plugin registered: \" + key);\n    } catch (error) {\n      this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n      continue;\n    }\n  }\n  plugins = this.config.plugins || {};\n  promises = [];\n  for (key in plugins) {\n    init = plugins[key];\n    if (!((init != null) && init.enabled !== false)) {\n      continue;\n    }\n    plugin = function(player, config, key) {\n      return _this.loadResources(config.resources).then(function() {\n        def = AMP.plugins[key][type];\n        if (!(def != null)) {\n          throw new Error(\"[AMP] Plugin could not be found: \" + key);\n        }\n        return def(player, config, key).then(function(result) {\n          _this.logger.debug(\"[AMP] Plugin registered: \" + key);\n          return {\n            key: key,\n            value: result\n          };\n        });\n      })[\"catch\"](function(error) {\n        return _this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n      });\n    };\n    promises.push(plugin.bind(null, this, init, key));\n  }\n  promises = promises.map(function(item) {\n    return item();\n  });\n  Promise.all(promises).then(function(plugins) {\n    var plugin, _i, _len;\n    if (_this.config.flash.view != null) {\n      _this.flashView = Utils.override(_this.flashView, _this.config.flash.view);\n    }\n    for (_i = 0, _len = plugins.length; _i < _len; _i++) {\n      plugin = plugins[_i];\n      if (!(plugin != null)) {\n        continue;\n      }\n      _this[plugin.key] = plugin.value;\n      _this.plugins[plugin.key] = plugin.value;\n    }\n    return _this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, _this.plugins);\n  })[\"catch\"](function(error) {\n    return _this.logger.error(error);\n  });\n};\n\n/**\n*/\nFlashPlayer.prototype.createAttributes = function(flash) {\n  var attributes;\n  attributes = {\n    id: this.flashObjectID,\n    name: this.flashObjectID\n  };\n  if (flash.attributes != null) {\n    if (flash.attributes.id != null) {\n      attributes.id = flash.attributes.id;\n    }\n    if (flash.attributes.name != null) {\n      attributes.name = flash.attributes.name;\n    }\n  }\n  return attributes;\n};\n\n/**\n*/\nFlashPlayer.prototype.createFlashJSON = function(config, spacer) {\n  var prepJSON, prepValue;\n  if (config == null) {\n    config = this.config;\n  }\n  config = JSON.stringify(config);\n  config = this.evaluatePaths(config);\n  config = JSON.parse(config);\n  prepValue = function(config, key, value) {\n    switch (typeof value) {\n      case \"string\":\n        config[key] = escape(value);\n        break;\n      case \"object\":\n        prepJSON(value);\n    }\n  };\n  prepJSON = function(config) {\n    var key, value, _i, _len;\n    if (config instanceof Array) {\n      for (key = _i = 0, _len = config.length; _i < _len; key = ++_i) {\n        value = config[key];\n        prepValue(config, key, value);\n      }\n    } else if (typeof config === \"object\") {\n      for (key in config) {\n        value = config[key];\n        prepValue(config, key, value);\n      }\n    }\n  };\n  prepJSON(config);\n  return encodeURIComponent(JSON.stringify(config, null, spacer));\n};\n\n/**\n*/\nFlashPlayer.prototype.createFlashVars = function(flash) {\n  var flashvars, loadingViewString, prop, settings, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;\n  flashvars = {};\n  settings = Object.assign({}, this.config, this.config.plugins);\n  delete settings.plugins;\n  settings.flash = null;\n  delete settings.flash;\n  settings.locales = null;\n  delete settings.locales;\n  settings.params = null;\n  delete settings.params;\n  settings.rules = null;\n  delete settings.rules;\n  flashvars.settings_json = this.createFlashJSON(settings);\n  if (this.config.autoplay != null) {\n    flashvars.auto_play = this.config.autoplay;\n  }\n  if ((this.config.rules != null)) {\n    Utils.mergeRules(this.config.rules);\n  }\n  flashvars.hinting_rules = escape(JSON.stringify(Utils.rules));\n  if (this.config.volume != null) {\n    flashvars.volume = Utils.clamp(this.config.volume, 0, 1);\n  }\n  if ((this.config.target != null)) {\n    flashvars.external_target = this.config.target;\n  }\n  if ((this.config.name != null)) {\n    flashvars.core_player_name = this.config.name;\n  }\n  if ((this.config.domain != null)) {\n    flashvars.embed_domain = flashvars.domain = this.config.domain;\n  }\n  this._loop = flashvars.auto_replay = this.config.loop === true;\n  if (this.config.fullscreen != null) {\n    flashvars.fullscreen_enabled = this.config.fullscreen.enabled !== false && this.config.fullscreen.mode !== FullscreenMode.EXTERNAL;\n  }\n  if (this.config.titlebar != null) {\n    flashvars.titlebar_enabled = this.config.titlebar.enabled !== false;\n  }\n  if (this.config.params != null) {\n    flashvars.params = escape(JSON.stringify(this.config.params));\n  }\n  if (this.config.version != null) {\n    flashvars.context_menu_label = this.config.version;\n  }\n  if (((_ref = this.config.controls) != null ? _ref.displaySceneMarkers : void 0) != null) {\n    flashvars.displaySceneMarkers = this.config.controls.displaySceneMarkers;\n  }\n  if (this.config.media != null) {\n    this.mediaProxy.setData(this.config.media);\n    if (this.config.media.src != null) {\n      this.setSrc(this.config.media.src);\n      flashvars.video_url = escape(this.config.media.src);\n    }\n    if ((this.config.media.source != null) && this.config.media.source.length > 0) {\n      this.setSource(this.config.media.source);\n      flashvars.video_url = escape(this.mediaProxy.getSrc());\n    }\n    if (this.config.media.medium != null) {\n      this.setMedium(this.config.media.medium);\n      flashvars.medium = this.config.media.medium;\n    }\n    if (this.config.media.title != null) {\n      flashvars.title = encodeURIComponent(this.config.media.title);\n    }\n    if (this.config.media.poster != null) {\n      flashvars.poster = escape(this.config.media.poster);\n    }\n    if (this.config.media.temporalType != null) {\n      flashvars.temporalType = this.config.media.temporalType;\n    }\n  }\n  if (this.getMedium() === \"audio\") {\n    flashvars.controls = true;\n    flashvars.auto_hide = -1;\n  }\n  if (((_ref1 = this.config.ima) != null ? (_ref2 = _ref1.overlay) != null ? _ref2.delay : void 0 : void 0) != null) {\n    flashvars.overlay_ad_delay = this.config.ima.overlay.delay;\n  }\n  if ((this.config.ticker != null) && this.config.ticker.enabled !== false) {\n    if (this.config.ticker.url != null) {\n      flashvars.ticker_text_url = this.config.ticker.url;\n    }\n    if (this.config.ticker.interval != null) {\n      flashvars.ticker_polling_interval = this.config.ticker.interval;\n    }\n    if (this.config.ticker.speed != null) {\n      flashvars.ticker_speed = this.config.ticker.speed;\n    }\n  }\n  flashvars.show_play_button_overlay = false;\n  flashvars.auto_play_list = false;\n  flashvars.next_video_timer = 0;\n  if (flashvars.context_menu_mode == null) {\n    flashvars.context_menu_mode = this.debug === true ? \"long\" : \"short\";\n  }\n  if (((_ref3 = this.config.flash) != null ? (_ref4 = _ref3.view) != null ? (_ref5 = _ref4.elements) != null ? (_ref6 = _ref5.loadingView) != null ? _ref6.attributes : void 0 : void 0 : void 0 : void 0) != null) {\n    loadingViewString = \"\";\n    for (prop in this.config.flash.view.elements.loadingView.attributes) {\n      loadingViewString += prop + \":\" + this.config.flash.view.elements.loadingView.attributes[prop] + \" \";\n    }\n    flashvars.loadingView = loadingViewString;\n  }\n  this.sendNotification(FlashNotifications.CREATE_FLASH_VARS, {\n    flashvars: flashvars,\n    config: this.config\n  });\n  flashvars = Utils.override(flashvars, flash.vars);\n  return flashvars;\n};\n\n/**\n*/\nFlashPlayer.prototype.createXML = function(config) {\n  var app, element, elements, isStatic, key, mode, node, parent, parseResources, parseView, plugin, plugins, str, swf, value, viewXML, xml, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n  if (!((config != null ? (_ref = config.flash) != null ? _ref.xml : void 0 : void 0) != null)) {\n    if (config.flash == null) {\n      config.flash = {};\n    }\n    config.flash.xml = \"<application></application>\";\n  }\n  xml = XMLUtils.parse(config.flash.xml);\n  if (xml.childNodes.length > 1) {\n    xml.removeChild(xml.firstChild);\n  }\n  this.sendNotification(FlashNotifications.CREATE_XML, {\n    config: config,\n    xml: xml\n  });\n  parseResources = function(config) {\n    var key, plugins, resource, resources, value, _i, _len, _ref1;\n    resources = config.resources;\n    plugins = [];\n    if ((resources instanceof Array) && ((resources != null ? resources.length : void 0) > 0)) {\n      for (_i = 0, _len = resources.length; _i < _len; _i++) {\n        resource = resources[_i];\n        if (!(resource.type === swf)) {\n          continue;\n        }\n        resource = Utils.clone(resource);\n        if (isStatic === true) {\n          if ((resource.main != null) && resource.main !== \"\") {\n            resource.src = resource.main;\n            resource.type = \"static\";\n          } else {\n            resource.type = \"dynamic\";\n          }\n        } else {\n          if ((resource.src != null) && resource.src !== \"\") {\n            resource.type = \"dynamic\";\n          } else {\n            resource.src = resource.main;\n            resource.type = \"static\";\n          }\n        }\n        delete resource.main;\n        plugins.push(resource);\n      }\n    }\n    for (key in config) {\n      value = config[key];\n      if (key !== \"flash\" && ((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {\n        plugins = plugins.concat(parseResources(value));\n      }\n    }\n    _ref1 = config.plugins;\n    for (key in _ref1) {\n      value = _ref1[key];\n      if (((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {\n        plugins = plugins.concat(parseResources(value));\n      }\n    }\n    return plugins;\n  };\n  swf = Utils.mimeTypes.swf;\n  plugins = parseResources(this.config);\n  isStatic = ((_ref1 = config.flash[\"static\"]) != null ? _ref1.enabled : void 0) === true;\n  if ((plugins != null ? plugins.length : void 0) > 0) {\n    parent = xml.getElementsByTagName(\"plugins\");\n    if (parent.length < 1) {\n      parent = xml.createElement(\"plugins\");\n      xml.firstChild.appendChild(parent);\n    } else {\n      parent = parent[0];\n    }\n    for (_i = 0, _len = plugins.length; _i < _len; _i++) {\n      plugin = plugins[_i];\n      if (!(plugin.enabled !== false)) {\n        continue;\n      }\n      node = xml.createElement(\"plugin\");\n      for (key in plugin) {\n        value = plugin[key];\n        if (key !== \"loaded\") {\n          if (key !== \"src\") {\n            node.setAttribute(key, \"\" + value);\n          } else {\n            if (key === \"id\" && value === \"AkamaiAdvancedStreamingPlugin\" && this.debug === true) {\n              value = value.replace(\"AkamaiAdvancedStreamingPlugin.swf\", \"AkamaiAdvancedStreamingPlugin-logging.swf\");\n            }\n            node.appendChild(XMLUtils.createTextContent(xml, value));\n          }\n        }\n      }\n      parent.appendChild(node);\n    }\n  }\n  parseView = function(view, node) {\n    var element, key, value, _ref2, _ref3, _ref4;\n    if (view.attributes != null) {\n      _ref2 = view.attributes;\n      for (key in _ref2) {\n        value = _ref2[key];\n        node.setAttribute(key, \"\" + value);\n      }\n    }\n    if (view.elements != null) {\n      _ref3 = view.elements;\n      for (key in _ref3) {\n        value = _ref3[key];\n        if (!(value != null)) {\n          continue;\n        }\n        element = xml.createElement(\"element\");\n        element.setAttribute(\"id\", key);\n        if (element.id === \"state\") {\n          continue;\n        }\n        parseView(value, element);\n        node.appendChild(element);\n      }\n    }\n    if (view.state != null) {\n      element = xml.createElement(\"state\");\n      if (view.state.attributes) {\n        _ref4 = view.state.attributes;\n        for (key in _ref4) {\n          value = _ref4[key];\n          if (value != null) {\n            element.setAttribute(key, \"\" + value);\n          }\n        }\n      }\n      node.appendChild(element);\n    }\n    return node;\n  };\n  viewXML = xml.getElementsByTagName(\"view\")[0];\n  if (!(viewXML != null)) {\n    viewXML = xml.createElement(\"view\");\n    xml.firstChild.appendChild(viewXML);\n  }\n  parseView(this.flashView, viewXML);\n  mode = (_ref2 = this.config.fullscreen) != null ? _ref2.mode : void 0;\n  if (mode != null) {\n    elements = xml.getElementsByTagName(\"element\");\n    for (_j = 0, _len1 = elements.length; _j < _len1; _j++) {\n      element = elements[_j];\n      if (element.getAttribute(\"id\") === \"fullscreenBtn\") {\n        element.setAttribute(\"action\", \"external\");\n      }\n    }\n  }\n  str = XMLUtils.serialize(xml);\n  app = str.match(/<application>[\\w\\W\\s\\S\\d\\D]*<\\/application>/)[0] || str;\n  app = app.replace(/[\\n\\r\\t]/g, \"\");\n  app = this.evaluatePaths(app);\n  return encodeURIComponent(app);\n};\n\n/**\n*/\nFlashPlayer.prototype.createdHandler = function(obj) {\n  var id, mediaElement,\n    _this = this;\n  id = this.getMediaElement().id;\n  mediaElement = document.getElementById(id);\n  this.setMediaElement(mediaElement);\n  mediaElement.className = Namespace.PREFIX + MediaElementMediator.prototype.componentType;\n  mediaElement.eventHandler = function(eventName, body) {\n    return _this.eventHandler(eventName, body);\n  };\n  this.sendNotification(FlashNotifications.FLASH_CREATED);\n  if (this.getMedium() != null) {\n    this.setMedium(this.getMedium());\n  }\n};\n\n/**\n*/\nFlashPlayer.prototype.eventHandler = function(eventName, body) {\n  var error, event, helper, media, state, type, update, _ref, _ref1, _ref2, _ref3,\n    _this = this;\n  if (this.logEvents && !this.excludedFlashEvents.test(eventName)) {\n    this.logger.log(\"[AMP FLASH EVENT] \" + eventName, body);\n  }\n  try {\n    switch (eventName) {\n      case FlashNotifications.INITIALIZED:\n        type = state = \"ready\";\n        break;\n      case FlashNotifications.RESET:\n        if (!(body != null)) {\n          state = \"ready\";\n        }\n        this.started = false;\n        break;\n      case FlashNotifications.LOADING:\n        type = \"loadstart\";\n        break;\n      case FlashNotifications.PLAYER_ERROR:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.MEDIA_ERROR:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.FEED_LOADED:\n        body = JSON.parse(body);\n        helper = new MRSSHelper();\n        media = (_ref = helper.createFeed(body)) != null ? (_ref1 = _ref.item) != null ? _ref1[0] : void 0 : void 0;\n        if (media != null) {\n          this.mediaProxy.setData(media);\n        }\n        break;\n      case FlashNotifications.FEED_UPDATED:\n        type = \"mediachange\";\n        body = this.getMedia();\n        update = true;\n        break;\n      case FlashNotifications.ERROR_STREAM_NOT_FOUND:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.CAPABILITY_CHANGE:\n        event = body.type;\n        if (event === \"canPlayChange\" && body.enabled === true) {\n          type = \"canplay\";\n          this.loaded = true;\n        } else if (event === \"canSeekChange\" && body.enabled === true) {\n          type = \"canplaythrough\";\n        } else if (event === \"temporalChange\" && body.enabled === true) {\n          type = \"loadedmetadata\";\n          if (!this.started) {\n            this.sendNotification(Notifications.START, body);\n          }\n        }\n        break;\n      case FlashNotifications.PLAYING:\n        if (!this.started) {\n          this.sendNotification(Notifications.START, body);\n        }\n        type = state = \"playing\";\n        this._ended = false;\n        this._paused = false;\n        if (this.appState.getSeeking() === true) {\n          this.appState.setSeeking(false);\n          this.sendNotification(Notifications.SEEKED);\n          this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"seeked\"));\n        }\n        break;\n      case FlashNotifications.ELEMENT_EVENT:\n        if (body.element === \"fullscreenBtn\" && body.type === \"click\" && ((_ref2 = this.config) != null ? (_ref3 = _ref2.fullscreen) != null ? _ref3.mode : void 0 : void 0) === FullscreenMode.EXTERNAL) {\n          state = this.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n          this.setDisplayState(state);\n        }\n        break;\n      case FlashNotifications.PLAY_REQUEST:\n        this.sendNotification(Notifications.PLAY_REQUEST);\n        this.setPlayState(\"playing\");\n        type = Notifications.MEDIA_SEQUENCE_STARTED;\n        this.loaded = true;\n        this._ended = false;\n        break;\n      case FlashNotifications.PLAY:\n        if (this.getPlayState() !== \"paused\" && this.started) {\n          this.sendNotification(Notifications.PLAY, body);\n        }\n        break;\n      case FlashNotifications.ENDED:\n        type = Notifications.ENDED;\n        break;\n      case FlashNotifications.MEDIA_SEQUENCE_ENDED:\n        type = Notifications.MEDIA_SEQUENCE_ENDED;\n        state = Notifications.ENDED;\n        this._ended = true;\n        break;\n      case FlashNotifications.PAUSED:\n        type = \"pause\";\n        state = \"paused\";\n        this._paused = true;\n        break;\n      case FlashNotifications.BUFFERING:\n        if (this.className !== \"ended\") {\n          type = state = \"waiting\";\n        }\n        break;\n      case FlashNotifications.BUFFERING_CHANGE:\n        this.sendNotification(Notifications.BUFFERING_CHANGE, body);\n        return;\n      case FlashNotifications.DURATION_CHANGE:\n        if (!isNaN(body.time)) {\n          if (body.time === 0) {\n            this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);\n          }\n          type = \"durationchange\";\n          body = body.time;\n          setTimeout(function() {\n            _this.setCues(_this.getCues().slice());\n          }, 0);\n        }\n        break;\n      case FlashNotifications.VOLUME_CHANGE:\n        type = \"volumechange\";\n        body = body.volume;\n        break;\n      case FlashNotifications.TIME_UPDATE:\n        type = \"timeupdate\";\n        body = body.currentTime;\n        break;\n      case FlashNotifications.SEEKING_CHANGE:\n        if (this.appState.getSeeking() === false && body.seeking === false) {\n          return;\n        }\n        type = body.seeking ? \"seeking\" : \"seeked\";\n        this.appState.setSeeking(body.seeking);\n        if (body.seeking) {\n          state = \"seeking\";\n        }\n        break;\n      case FlashNotifications.FULLSCREEN_CHANGE:\n        type = \"fullscreenchange\";\n        body = body.displayState === \"fullScreen\";\n        this.applyDisplayState(body ? DisplayState.FULL_SCREEN : DisplayState.NORMAL);\n        break;\n      case FlashNotifications.FAIL_OVER_ATTEMPT:\n        type = \"failoverattempt\";\n        body = body;\n        break;\n      case FlashNotifications.ERROR:\n        eventName = null;\n        break;\n      case FlashNotifications.AUTHORIZE:\n        type = SecurityNotifications.AUTHORIZE;\n        break;\n      case FlashNotifications.TIMED_METADATA:\n        type = Notifications.TIMED_METADATA;\n        body = {\n          startTime: body.time,\n          endTime: body.time,\n          data: body\n        };\n        break;\n      case FlashNotifications.MEDIA_PLAYER_ID3_UPDATED:\n        type = Notifications.TIMED_METADATA;\n        body = {\n          startTime: body.time,\n          endTime: body.time,\n          data: window.atob(body)\n        };\n    }\n    if ((eventName != null) && eventName !== type) {\n      event = new Event(eventName, body);\n      event.dispatcher = \"FLASH\";\n      this.sendNotification(Notifications.DISPATCH_EVENT, event);\n      this.sendNotification(eventName, body);\n    }\n    if (type != null) {\n      if (type === \"error\") {\n        error = body.error || body;\n        this.logError(\"Flash Error\", error);\n      }\n      this.sendNotification(type, body);\n      this.sendNotification(Notifications.DISPATCH_EVENT, new Event(type, body));\n    }\n    if (update != null) {\n      this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n    }\n    if (state != null) {\n      this.setPlayState(state);\n    }\n  } catch (error) {\n    this.logError(\"Event Error: \" + eventName, error);\n  }\n};\n\nFlashPlayer.prototype.logError = function(msg, error) {\n  this.logger.error(\"[AMP FLASH ERROR]\", msg, error);\n};\n\n/**\n*/\nFlashPlayer.prototype.excludedFlashEvents = /(mediaPlayerPlayheadUpdate|mediaPlayerElementEvent|adComponentPlaybackProgress)/;\n\nFlashPlayer.prototype.logFlashEvents = false;\n\nFlashPlayer.prototype.logEvent = function(event) {\n  if ((event.dispatcher === \"FLASH\" && this.logFlashEvents === false) || this.excludedFlashEvents.test(event.type) === true) {\n    return;\n  }\n  FlashPlayer.__super__.logEvent.call(this, event);\n};\n\n/**\n * Sets the player's play state and adds CSS class to player div\n*/\nFlashPlayer.prototype.setPlayState = function(state) {\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n  return state;\n};\n\nFlashPlayer.prototype.getPlayState = function() {\n  return this.appState.getPlayState();\n};\n\n/**\n * Initializes the player to a given set of parameters\n*/\nFlashPlayer.prototype.setMedia = function(value) {\n  var _this = this;\n  if (this.getPlayState() != null) {\n    this.setPlayState(\"ready\");\n  }\n  value = this.mediaProxy.transform(value);\n  this.transform(TransformType.MEDIA, value).then(function(result) {\n    value = result;\n    _this.mediaProxy.setData(value);\n    if (value.src != null) {\n      _this.setSrc(value.src);\n    }\n    if ((value.source != null) && value.source.length > 0) {\n      _this.setSource(value.source);\n    }\n    _this.sendNotification(Notifications.MEDIA_CHANGE, value);\n    return _this.load(_this.mediaProxy.getData());\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.getMedia = function() {\n  return this.mediaProxy.getData();\n};\n\n/**\n * Loads the video.\n *\n*/\nFlashPlayer.prototype.load = function() {\n  var data, key, media, value;\n  media = this.mediaProxy.getData();\n  this.security.setMedia(media);\n  if (this.security.getAuthorized()) {\n    this.loaded = true;\n    data = Utils.clone(media);\n    if (data.autoplay == null) {\n      data.autoplay = this.config.autoplay;\n    }\n    for (key in data) {\n      value = data[key];\n      if (value === void 0) {\n        delete data[key];\n      }\n    }\n    this.getMediaElement().loadURL(this.mediaProxy.getSrc(), data);\n  } else {\n    this.sendNotification(SecurityNotifications.AUTHORIZE, {\n      media: media\n    });\n  }\n};\n\n/**\n * Plays the currently loaded video.\n *\n*/\nFlashPlayer.prototype.play = function() {\n  if (!this.loaded) {\n    this.load();\n  }\n  this.getMediaElement().unpause();\n};\n\n/**\n*/\nFlashPlayer.prototype.setMuted = function(value) {\n  this._muted = value;\n  try {\n    if (value === true) {\n      this.getMediaElement().mute();\n    } else {\n      this.getMediaElement().unmute();\n    }\n  } catch (error) {\n    this.logError(\"Flash muted error\", error);\n  }\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.getMuted = function() {\n  return this._muted;\n};\n\n/**\n*/\nFlashPlayer.prototype.getLoop = function() {\n  return this._loop;\n};\n\n/**\n * The source url of video.\n *\n * @param {String} value The source url of the video to play.\n*/\nFlashPlayer.prototype.getSrc = function(value) {\n  return this.getMediaElement().getURL();\n};\n\nFlashPlayer.prototype.setSrc = function(value) {\n  this.mediaProxy.setSrc(value);\n  this.loaded = false;\n  this.setMedium(Utils.getMimeType(value));\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.setAutoplay = function(value) {\n  this.getMediaElement().setPlayerProperty(\"autoplay\", value);\n  return value;\n};\n\nFlashPlayer.prototype.getAutoplay = function() {\n  return this.getMediaElement().getPlayerProperty(\"autoplay\");\n};\n\n/**\n * The url to the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nFlashPlayer.prototype.getMedium = function() {\n  return this.mediaProxy.getData().medium;\n};\n\nFlashPlayer.prototype.setMedium = function(value) {\n  var media, previous;\n  media = this.mediaProxy.getData();\n  if (value === media.medium) {\n    return;\n  }\n  if (media.medium != null) {\n    previous = \"medium-\" + media.medium;\n  }\n  media.medium = /audio/.test(value) ? \"audio\" : \"video\";\n  this.sendNotification(Notifications.MEDIUM_CHANGE, {\n    value: \"medium-\" + media.medium,\n    previous: previous\n  });\n  return value;\n};\n\n/**\n * Sets the source url of video.\n *\n * @param {String} value The source url of the video to play.\n*/\nFlashPlayer.prototype.setSource = function(value) {\n  var item, media,\n    _this = this;\n  if (!(value != null) || value.length < 1) {\n    return;\n  }\n  media = this.mediaProxy.getData();\n  media.source = value;\n  this.loaded = false;\n  item = Utils.selectSource(value, function(type) {\n    return _this.canPlayType(type);\n  });\n  if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n    this.setSrc(item.src);\n    if (typeof type !== \"undefined\" && type !== null) {\n      this.setMedium(type);\n    }\n  } else {\n    throw new Error(\"No valid source could be found\");\n  }\n  return value;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getSource = function() {\n  return this.mediaProxy.getData().source;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getSeeking = function() {\n  return this.appState.getSeeking();\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getPaused = function() {\n  return this._paused;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getEnded = function() {\n  return this._ended;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashXML = function() {\n  var doc, xml;\n  xml = decodeURIComponent(this.flashvars.settings_xml);\n  doc = XMLUtils.parse(xml);\n  try {\n    doc.toString = function() {\n      return xml;\n    };\n  } catch (error) {\n\n  }\n  return doc;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashVars = function() {\n  return this.flashvars;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashJSON = function() {\n  return JSON.parse(decodeURIComponent(this.flashvars.settings_json));\n};\n\nFlashPlayer.prototype.canPlayType = function(mimeType) {\n  if (__indexOf.call(Utils.flashTypes, mimeType) >= 0) {\n    return \"maybe\";\n  } else {\n    return \"\";\n  }\n};\n\nFlashPlayer.prototype.replay = function() {\n  this.getMediaElement().replay();\n};\n\nFlashPlayer.prototype.pause = function() {\n  this.getMediaElement().pause();\n};\n\nFlashPlayer.prototype.end = function() {\n  this.getMediaElement().stopPlayer();\n};\n\nFlashPlayer.prototype.getCurrentTime = function() {\n  var _base;\n  return typeof (_base = this.getMediaElement()).getCurrentTime === \"function\" ? _base.getCurrentTime() : void 0;\n};\n\nFlashPlayer.prototype.setCurrentTime = function(value) {\n  this.getMediaElement().jumpToTime(value);\n  return value;\n};\n\nFlashPlayer.prototype.getParams = function() {\n  return this.getMediaElement().getParams();\n};\n\nFlashPlayer.prototype.setParams = function(value) {\n  this.getMediaElement().setParams(value);\n  return value;\n};\n\nFlashPlayer.prototype.getVolume = function() {\n  var _ref;\n  return ((_ref = this.getMediaElement()) != null ? typeof _ref.getVolume === \"function\" ? _ref.getVolume() : void 0 : void 0) || 0;\n};\n\nFlashPlayer.prototype.setVolume = function(value, scope) {\n  this.getMediaElement().setVolume(value, scope || \"\");\n  return value;\n};\n\nFlashPlayer.prototype.getDuration = function() {\n  var _base;\n  return typeof (_base = this.getMediaElement()).getDuration === \"function\" ? _base.getDuration() : void 0;\n};\n\nFlashPlayer.prototype.getDisplayState = function() {\n  return this._displayState;\n};\n\nFlashPlayer.prototype.setDisplayState = function(value) {\n  var _ref;\n  if (value === this._displayState) {\n    return;\n  }\n  this.applyDisplayState(value);\n  if (((_ref = this.config.fullscreen) != null ? _ref.mode : void 0) === FullscreenMode.EXTERNAL) {\n    return;\n  }\n  if (this._displayState === DisplayState.FULL_SCREEN) {\n    this.getMediaElement().enterFullScreen();\n  } else {\n    this.getMediaElement().exitFullScreen();\n  }\n  return value;\n};\n\nFlashPlayer.prototype.applyDisplayState = function(value) {\n  var states;\n  if (value === this._displayState) {\n    return;\n  }\n  states = {\n    value: value,\n    previous: this._displayState\n  };\n  this._displayState = value;\n  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, states);\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"fullscreenchange\", this._displayState === DisplayState.FULL_SCREEN));\n};\n\nFlashPlayer.prototype.enterFullScreen = function() {\n  this.setDisplayState(DisplayState.FULL_SCREEN);\n};\n\nFlashPlayer.prototype.exitFullScreen = function() {\n  this.setDisplayState(DisplayState.NORMAL);\n};\n\nFlashPlayer.prototype.recordContentChange = function(content) {\n  this.getMediaElement().recordContentChange(content);\n};\n\nFlashPlayer.prototype.setQuality = function(value) {\n  return this.getMediaElement().setQuality(value);\n};\n\nFlashPlayer.prototype.getQuality = function() {\n  var quality;\n  try {\n    quality = this.getMediaElement().getQuality();\n  } catch (error) {\n\n  }\n  return quality;\n};\n\nFlashPlayer.prototype.getQualityLevels = function() {\n  var levels, _base;\n  try {\n    levels = (typeof (_base = this.getMediaElement()).getQualityLevels === \"function\" ? _base.getQualityLevels() : void 0) || [];\n  } catch (error) {\n    levels = [];\n  }\n  return levels;\n};\n\n/**\n * The ModuleAdapter class.\n *\n * @param {Module} module\n * @constructor\n * @private\n * @extends {puremvc.Mediator}\n*/\nfunction ModuleAdapter(module) {\n  this.module = module;\n  ModuleAdapter.__super__.constructor.call(this, module.getModuleName(), this);\n}\n\n\n__extends(ModuleAdapter, puremvc.Mediator);\n\n\nModuleAdapter.prototype.module = null;\n\nModuleAdapter.prototype.mediator = null;\n\nModuleAdapter.prototype.initializeNotifier = function(key) {\n  var publications,\n    _this = this;\n  ModuleAdapter.__super__.initializeNotifier.call(this, key);\n  publications = this.module.listNotificationPublications();\n  if (publications != null) {\n    this.mediator = new puremvc.Mediator(this.facade.getModuleName());\n    this.mediator.listNotificationInterests = function() {\n      return publications;\n    };\n    this.mediator.handleNotification = function(notification) {\n      _this.facade.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n    };\n  }\n};\n\nModuleAdapter.prototype.onRegister = function() {\n  if (this.mediator != null) {\n    this.module.registerMediator(this.mediator);\n  }\n};\n\nModuleAdapter.prototype.onRemove = function() {\n  if (this.mediator != null) {\n    this.module.removeMediator(this.mediator);\n  }\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n *\n*/\nModuleAdapter.prototype.listNotificationInterests = function() {\n  return this.module.listNotificationInterests();\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n * @param note An INotification\n *\n*/\nModuleAdapter.prototype.handleNotification = function(notification) {\n  this.module.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n};\n\nEvents = {\n  LOADED_METADATA: \"loadedmetadata\",\n  READY: \"ready\",\n  ERROR: \"error\",\n  ENDED: \"ended\",\n  STARTED: \"started\",\n  DURATION_CHANGE: \"durationchange\",\n  SEEKING: \"seeking\",\n  SEEKED: \"seeked\",\n  TIME_UPDATE: \"timeupdate\",\n  LOAD_START: \"loadstart\",\n  LOADED_DATA: \"loadeddata\",\n  CAN_PLAY: \"canplay\",\n  CAN_PLAY_THROUGH: \"canplaythrough\",\n  PROGRESS: \"progress\",\n  MEDIA_CHANGE: \"mediachange\",\n  WAITING: \"waiting\",\n  BUFFERING_CHANGE: \"bufferingchange\",\n  STALLED: \"stalled\",\n  PLAY: \"play\",\n  PLAYING: \"playing\",\n  PAUSE: \"pause\",\n  PAUSED: \"paused\",\n  PLAY_REQUEST: \"playrequest\",\n  MEDIUM_CHANGE: \"mediumchange\",\n  TEMPORAL_TYPE_CHANGE: \"temporaltypechange\",\n  VOLUME_CHANGE: \"volumechange\",\n  FAIL_OVER_ATTEMPT: \"failoverattempt\",\n  PLAYBACK_TARGET_CHANGE: \"playbacktargetchange\",\n  PLAYBACK_TARGET_AVAILABILITY_CHANGE: \"playbacktargetavailabilitychange\",\n  RECORD_CONTENT_CHANGE: \"recordcontentchange\",\n  IS_LIVE: \"islive\",\n  CONTENT_CHANGED: \"contentchanged\",\n  PLAYBACK_RATE_CHANGE: \"playbackratechange\",\n  SETTINGS_CHANGE: \"settingschange\",\n  QUALITY_CHANGE: \"qualitychange\",\n  QUALITY_CHANGING: \"qualitychanging\",\n  QUALITY_SWITCHED: \"qualityswitched\",\n  QUALITY_MODE_CHANGE: \"qualitymodechange\",\n  QUALITY_LEVELS_LOADED: \"qualitylevelsloaded\",\n  MEDIA_SEQUENCE_STARTED: \"mediasequencestarted\",\n  MEDIA_SEQUENCE_ENDED: \"mediasequenceended\",\n  MEDIA_SEQUENCE_ABORTED: \"mediasequenceaborted\",\n  AUTOPLAY_BLOCKED: \"autoplayblocked\",\n  LANGUAGE_CHANGE: \"languagechange\",\n  TIMED_METADATA: \"timedmetadata\",\n  CUES_CHANGE: \"cueschange\",\n  VIEW_CREATED: \"viewcreated\",\n  MUTE_CHANGE: \"mutechange\",\n  RESUME: \"resume\",\n  PLAY_STATE_CHANGE: \"playstatechange\",\n  FULL_SCREEN_CHANGE: \"fullscreenchange\",\n  BUSY: \"busy\",\n  DESTROY: \"destroy\",\n  init: function() {\n    var key, value;\n    this.values = [];\n    for (key in this) {\n      value = this[key];\n      if (key !== \"values\" && key !== \"init\") {\n        this.values.push(value);\n      }\n    }\n  }\n};\nEvents.init();\n\n/**\n * Creates a new Transformer\n *\n * @constructor\n * @private\n*/\nfunction Transformer(_target) {\n  this._target = _target != null ? _target : this;\n  this._transformMap = {};\n}\n\n/**\n * Adds a transform for a given type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} transform  A function to call when the event is triggered.\n*/\nTransformer.prototype.addTransform = function(type, transform) {\n  var _base;\n  if (!(transform != null) || !(type != null)) {\n    return;\n  }\n  if ((_base = this._transformMap)[type] == null) {\n    _base[type] = [];\n  }\n  if (this._transformMap[type].indexOf(transform) !== -1) {\n    return;\n  }\n  this._transformMap[type].push(transform);\n  this.sortTransforms(type);\n};\n\n/**\n * Sorts the transform list by priority. Higher priority Transforms\n * are executed first.\n *\n * @param {!String} type The transform type\n * @param {Function=} func An optional sort function\n * @returns {Array.<Function|akamai.amp.Transform>} The sorted list\n*/\nTransformer.prototype.sortTransforms = function(type, func) {\n  var _this = this;\n  if (func == null) {\n    func = function(a, b) {\n      var aP, bP;\n      aP = a.priority || 0;\n      bP = b.priority || 0;\n      return bP - aP;\n    };\n  }\n  return this._transformMap[type].sort(func);\n};\n\n/**\n * Performs a transform for a given type\n *\n * @param {!String} type The transform type\n * @param {!Object} value The value to be transformed\n*/\nTransformer.prototype.transform = function(type, value) {\n  var transforms;\n  transforms = this._transformMap[type];\n  if (!(transforms != null)) {\n    return Promise.resolve(value);\n  }\n  return Utils.transform(value, transforms);\n};\n\n/**\n * Removes a transform for a given type.\n *\n * @param {!string}  type  A string representing the transform's type.\n * @param {!Function} transform  A function or Transform object to call when the type is triggered.\n * @return {?Function} the transform that was removed if any\n*/\nTransformer.prototype.removeTransform = function(type, transform) {\n  var index, transforms;\n  if (!(transform != null) || !(type != null)) {\n    return;\n  }\n  transforms = this._transformMap[type];\n  if (!(transforms != null)) {\n    return;\n  }\n  index = transforms.indexOf(transform);\n  if (index === -1) {\n    return;\n  }\n  return transforms.splice(index, 1);\n};\n\n/**\n * @constructor\n*/\nfunction DataBinding() {}\n\n/**\n * @private\n * @type {RegExp}\n * @const\n*/\nDataBinding.SINGLE = /^\\s*[#\\$]{([^\\$#{}]+)}\\s*$/;\n\n/**\n * @private\n * @type {RegExp}\n * @const\n*/\nDataBinding.TOKEN = /[#\\$]{([^\\$#}]*)}/g;\n\n/**\n * Evaluate a data bound string.\n *\n * @param {string} binding\n *   The data bound string.\n *\n * @param {?Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nDataBinding[\"eval\"] = function(binding, context) {\n  var _this = this;\n  if (!(binding != null)) {\n    return binding;\n  }\n  if (this.SINGLE.test(binding)) {\n    try {\n      return this.exec(binding.replace(this.SINGLE, \"$1\"), context);\n    } catch (error) {\n      return binding;\n    }\n  }\n  return binding.replace(this.TOKEN, function(match, token, offset, string) {\n    try {\n      return _this.exec(token, context);\n    } catch (error) {\n      return match;\n    }\n  });\n};\n\n/**\n * Execute a data bound string.\n *\n * @param {string} binding\n *   The data bound string.\n *\n * @param {?Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nDataBinding.exec = function(binding, context) {\n  return (new Function(\"with (this) { return \" + binding + \" }\")).bind(context)();\n};\n\n/**\n * Evaluate a data bound object.\n *\n * @param {Object} binding\n *   The data bound object.\n *\n * @param {Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {Object}\n *   The evaluated result\n*/\nDataBinding.evaluateBindings = function(value, context, clone) {\n  var key,\n    _this = this;\n  if (clone == null) {\n    clone = true;\n  }\n  if (!(value != null)) {\n    return;\n  }\n  if (typeof value === \"object\") {\n    clone = clone === true ? JSON.parse(JSON.stringify(value)) : value;\n    if (value instanceof Array) {\n      return clone.map(function(item) {\n        return _this.evaluateBindings(item, context, false);\n      });\n    } else {\n      value = {};\n      for (key in clone) {\n        value[key] = this.evaluateBindings(clone[key], context, false);\n      }\n      return value;\n    }\n  } else if (typeof value === \"string\") {\n    return this[\"eval\"](value, context);\n  } else {\n    return value;\n  }\n};\n\n/**\n * The EndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DispatchEventCommand() {\n  DispatchEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DispatchEventCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nDispatchEventCommand.prototype.execute = function(notification) {\n  var event;\n  event = notification.getBody();\n  event.player = this.facade.player || this.facade;\n  this.facade.dispatchEvent(event);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar Notifications = {\n  STARTUP: \"startup\",\n  LOAD: \"load\",\n  PAUSE_REQUEST: \"pauserequest\",\n  TOGGLE_PLAY_PAUSE: \"togglePlayPause\",\n  CHANGE_PLAY_STATE: \"chageplaystate\",\n  MEDIA_ELEMENT_CHANGE: \"mediaelementchange\",\n  HIDDEN_CHANGE: \"hiddenchange\",\n  TOGGLE_FULL_SCREEN: \"toggleFullScreen\",\n  CHANGE_DISPLAY_STATE: \"chageDisplayState\",\n  DISPLAY_STATE_CHANGE: \"displayStateChange\",\n  DISABLE_FULL_SCREEN: \"disableFullScreen\",\n  ENABLE_FULL_SCREEN: \"enableFullScreen\",\n  TOGGLE_ACTIVE: \"toggleActive\",\n  CHANGE_ACTIVE_STATE: \"changeactivestate\",\n  ACTIVE_STATE_CHANGE: \"activestatechange\",\n  CHANGE_MEDIA: \"changeMedia\",\n  SET_MEDIA: \"setmedia\",\n  MEDIA_VALIDATED: \"mediavalidated\",\n  CHANGE_SETTINGS: \"changesettings\",\n  UPDATE_DATA_BINDINGS: \"updatedatabindings\",\n  CHANGE_VOLUME: \"changevolume\",\n  CHANGE_MUTED: \"changemuted\",\n  TOGGLE_MUTED: \"togglemuted\",\n  CHANGE_TIME: \"changetime\",\n  TIME_CHANGE: \"timechange\",\n  SEEK: \"seek\",\n  CHANGE_DURATION: \"changeduration\",\n  CHANGE_AUTOPLAY: \"changeAutoplay\",\n  AUTOPLAY_CHANGE: \"autoplaychange\",\n  CHANGE_LOOP: \"changeLoop\",\n  PLAYBACK_CORE_CHANGE: \"playbackCoreChange\",\n  START: \"start\",\n  END: \"end\",\n  REPLAY: \"replay\",\n  REGISTER_PLUGIN: \"registerPlugin\",\n  REGISTER_PLUGINS: \"registerPlugins\",\n  PLUGIN_REGISTERED: \"pluginRegistered\",\n  ADD_LAYER: \"addLayer\",\n  REMOVE_LAYER: \"removeLayer\",\n  ADD_OVERLAY: \"addOverlay\",\n  REMOVE_OVERLAY: \"removeOverlay\",\n  ADD_CONTROL: \"addControl\",\n  REMOVE_CONTROL: \"removeControl\",\n  ADD_CONTROL_STATE: \"addControlState\",\n  REMOVE_CONTROL_STATE: \"removeControlState\",\n  ADD_APPLICATION_STATE: \"addApplicationState\",\n  REMOVE_APPLICATION_STATE: \"removeApplicationState\",\n  DISPATCH_EVENT: \"dispatchEvent\",\n  CHANGE_PARAMS: \"changeParams\",\n  INITIALIZED: \"initialized\",\n  REGISTER_PLAYBACK_CORE: \"registerPlaybackCore\",\n  REMOVE_PLAYBACK_CORE: \"removePlaybackCore\",\n  DISPLAY_TIME: \"displaytime\",\n  IS_USER_ACTIVE: \"isUserActive\",\n  CHANGE_PLAYBACK_TARGET: \"changeplaybacktarget\",\n  LOCK: \"lock\",\n  FRAGMENT_LOAD_START: \"fragmentloadstart\",\n  FRAGMENT_LOADED: \"fragmentloaded\",\n  CHANGE_CONTENT: \"changecontent\",\n  ENABLE_VIDEO_EVENTS: \"enablevideoevents\",\n  DISABLE_VIDEO_EVENTS: \"disablevideoevents\",\n  HAS_POST_CONTENT: \"haspostcontent\",\n  AUDIO_TRACK_SWITCH: \"audiotrackswitch\",\n  init: function() {\n    var key, value;\n    for (key in Events) {\n      value = Events[key];\n      if (key !== \"values\" && key !== \"init\") {\n        this[key] = value;\n      }\n    }\n  }\n};\nNotifications.init();\n\nfunction Utilization() {}\n\nUtilization.track = function(event, data) {\n  var params, url, _ref,\n    _this = this;\n  url = \"//amp.akamaized.net/amp.gif\";\n  params = {\n    os: bowser.osname,\n    osver: bowser.osversion,\n    browser: bowser.name,\n    browserver: bowser.version,\n    prod: AMP.VERSION.replace(/^AMP/, \"\").replace(/\\sv?[0-9\\.]+$/, \"\"),\n    prodver: (_ref = AMP.VERSION.match(/[0-9\\.]+/)) != null ? _ref[0] : void 0,\n    platform: \"web\",\n    url: location.href,\n    event: event,\n    data: data\n  };\n  return Utils.request(\"\" + url + \"?\" + (QueryString.encode(params)))[\"catch\"](function(error) {\n    return Logger.instance.log(error);\n  });\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar DisplayState = {\n  /**\n   * Constant representing the normal display state\n  */\n\n  NORMAL: \"normal\",\n  /**\n   * Constant representing the full screen display state\n  */\n\n  FULL_SCREEN: \"full-screen\"\n};\n\n/**\n * The DataBoundConfigurationProxy class.\n *\n * @constructor\n * @private\n * @extends {ModuleProxy}\n * @param {Object} data\n*/\nfunction DataBoundConfigurationProxy(data) {\n  DataBoundConfigurationProxy.__super__.constructor.call(this, data);\n  this.value = {};\n}\n\n\n__extends(DataBoundConfigurationProxy, ModuleProxy);\n\n\n/** @static\n*/\nDataBoundConfigurationProxy.NAME = ModuleProxy.NAME;\n\nDataBoundConfigurationProxy.prototype.bindings = null;\n\nDataBoundConfigurationProxy.prototype.configurationName = null;\n\nDataBoundConfigurationProxy.prototype.contextName = null;\n\nDataBoundConfigurationProxy.prototype.contextData = null;\n\nDataBoundConfigurationProxy.prototype.value = null;\n\nDataBoundConfigurationProxy.prototype.getConfigurationName = function() {\n  return this.configurationName;\n};\n\nDataBoundConfigurationProxy.prototype.getConfigurationData = function() {\n  return this.value || {};\n};\n\nDataBoundConfigurationProxy.prototype.getContextName = function() {\n  return this.contextName;\n};\n\nDataBoundConfigurationProxy.prototype.getContextData = function() {\n  return this.contextData;\n};\n\nDataBoundConfigurationProxy.prototype.onRegister = function() {\n  var base;\n  base = this.facade.player || this.facade;\n  if (!(this.getConfigurationName() != null)) {\n    this.configurationName = this.facade.moduleName;\n  }\n  this.bindings = base.retrieveProxy(DataBindingProxy.NAME);\n  this.bindings.registerConfiguration(this);\n  if (!(this.getContextName() != null)) {\n    return;\n  }\n  this.bindings.registerContext(this);\n  this.value = DataBinding.evaluateBindings(this.data, this.bindings.getData());\n};\n\nDataBoundConfigurationProxy.prototype.setData = function(data) {\n  var key, value, _ref;\n  if (data == null) {\n    data = {};\n  }\n  this.data = {};\n  _ref = this.getDefaults();\n  for (key in _ref) {\n    value = _ref[key];\n    this.data[key] = key in data ? data[key] : value;\n  }\n  return this.data;\n};\n\nDataBoundConfigurationProxy.prototype.getValue = function(key) {\n  this.bindings.update();\n  this.value[key] = DataBinding.evaluateBindings(this.data[key], this.bindings.getData());\n  return this.value[key];\n};\n\nDataBoundConfigurationProxy.prototype.compile = function(context, suppressErrors) {\n  if (suppressErrors == null) {\n    suppressErrors = false;\n  }\n  if (!(context != null)) {\n    context = this.bindings.getData();\n  }\n  if ((this.contextName != null) && (this.contextData != null)) {\n    context = Utils.clone(context);\n    context[this.contextName] = this.contextData;\n  }\n  this.value = DataBinding.evaluateBindings(this.data, this.bindings.getData());\n  return this.value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar SecurityNotifications = {\n  AUTHORIZATION_FAILED: \"authorizationfailed\",\n  AUTHORIZE: \"authorize\",\n  AUTHORIZED: \"authorized\",\n  AUTHENTICATION_FAILED: \"authenticationfailed\",\n  AUTHENTICATE: \"authenticate\",\n  AUTHENTICATED: \"authenticated\",\n  AUTHORIZATION_EXPIRED: \"authorizationexpired\"\n};\n\n/**\n * Binds an event(s) to a handler function.\n *\n * @param {IEventDispatcher}    target  The event target\n * @param {string|Array|number} type    The event to listen for\n * @param {Function}            handler The handler function to call when the event is dispatched.\n * @constructor\n * @private\n*/\nfunction EventHandler(target, type, handler) {\n  var _ref;\n  this.target = target;\n  this.type = type;\n  this.handler = handler;\n  this.trigger = __bind(this.trigger, this);\n\n  EventHandler.instances.push(this);\n  this.types = [];\n  if (_ref = this.type, __indexOf.call(EventHandler.EVENTS, _ref) >= 0) {\n    if (Utils.isTouchDevice()) {\n      this.types.push(EventHandler.TOUCH_EVENTS[this.type]);\n      if (this.type === EventHandler.TOUCH_EVENTS[1]) {\n        this.types.push(EventHandler.TOUCH_EVENTS[4]);\n      }\n    } else {\n      this.types.push(EventHandler.MOUSE_EVENTS[this.type]);\n    }\n  } else if (this.type instanceof Array) {\n    this.types = this.type;\n  } else {\n    this.types.push(this.type);\n  }\n  this.bind();\n}\n\n/**\n * Represents the press user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.PRESS = 0;\n\n/**\n * Represents the release user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.RELEASE = 1;\n\n/**\n * Represents the move user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.MOVE = 2;\n\n/**\n * Represents the click user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.CLICK = 3;\n\n/**\n * Represents the right click (contextMenu) user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.CONTEXTMENU = 4;\n\n/**\n * Represents the mouse over user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.HOVER = 5;\n\n/**\n * Represents the mouse out user interaction\n *\n * @type {number}\n * @static\n * @const\n*/\nEventHandler.HOVEROUT = 6;\n\n/**\n * The list of user interactions\n *\n * @type {Array.<number>}\n * @static\n * @const\n*/\nEventHandler.EVENTS = [EventHandler.PRESS, EventHandler.RELEASE, EventHandler.MOVE, EventHandler.CLICK, EventHandler.CONTEXTMENU, EventHandler.HOVER, EventHandler.HOVEROUT];\n\n/**\n * The list of mouse interactions\n *\n * @type {Array.<string>}\n * @static\n * @const\n*/\nEventHandler.MOUSE_EVENTS = [\"mousedown\", \"mouseup\", \"mousemove\", \"click\", \"contextmenu\", \"mouseover\", \"mouseout\"];\n\n/**\n * The list of touch interactions\n *\n * @type {Array.<string>}\n * @static\n * @const\n*/\nEventHandler.TOUCH_EVENTS = [\"touchstart\", \"touchend\", \"touchmove\", \"click\", \"touchcancel\"];\n\n/**\n * An array of EventHandler instances.\n *\n * @type {Array.<EventHandler>}\n * @static\n*/\nEventHandler.instances = [];\n\n/**\n * Creates an EventHandler with the parameters provided.\n *\n * @param {IEventDispatcher}    target  The event target\n * @param {string|Array|number} type    The event to listen for\n * @param {Function}            handler The handler function to call when the event is dispatched.\n * @static\n * @return {EventHandler} the new EventHandler\n*/\nEventHandler.create = function(target, type, handler) {\n  return new EventHandler(target, type, handler);\n};\n\n/**\n * Binds all EventHandlers of the provided target.\n *\n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.bind = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!(instance.target === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.bind();\n  }\n};\n\n/**\n * Unbinds all EventHandlers of the provided target.\n *\n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.unbind = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!(instance.target === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.unbind();\n  }\n};\n\n/**\n * Clear all EventHandlers of the provided target.\n *\n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.clear = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!((instance != null ? instance.target : void 0) === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.clear();\n    EventHandler.instances.splice(i, 1);\n  }\n};\n\n/**\n * The system event types for this EventTarget\n *\n * @type {Array.<string>}\n*/\nEventHandler.prototype.types = null;\n\n/**\n * Binds the target to the event\n*/\nEventHandler.prototype.bind = function() {\n  var type, _i, _len, _ref;\n  _ref = this.types;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    type = _ref[_i];\n    if (this.target.addEventListener != null) {\n      this.target.addEventListener(type, this.trigger, false);\n    } else if (this.target.attachEvent != null) {\n      this.target.attachEvent(\"on\" + type, this.trigger);\n    }\n  }\n};\n\n/**\n * Unbinds the target from the event\n*/\nEventHandler.prototype.unbind = function() {\n  var type, _i, _len, _ref;\n  _ref = this.types;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    type = _ref[_i];\n    if (this.target.removeEventListener != null) {\n      this.target.removeEventListener(type, this.trigger);\n    } else if (this.target.attachEvent != null) {\n      this.target.removeEvent(\"on\" + type, this.trigger);\n    }\n  }\n};\n\n/**\n * Clears the EventHandler\n*/\nEventHandler.prototype.clear = function() {\n  this.unbind();\n  this.target = null;\n  this.handler = null;\n  this.type = null;\n  this.types = null;\n};\n\n/**\n * Triggers the event handler\n*/\nEventHandler.prototype.trigger = function(event) {\n  this.handler(event);\n};\n\n/**\n * Used to track player configuration settings\n*/\n/**\n * Creates a new instance of MediaProxy.\n *\n * @constructor\n * @private\n*/\nfunction ConfigurationProxy(config) {\n  this.defaults = Config.defaults;\n  ConfigurationProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ConfigurationProxy, ModuleProxy);\n\n\n/** @static\n*/\nConfigurationProxy.NAME = ModuleProxy.NAME;\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.getContextName = function() {\n  return \"paths\";\n};\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.getContextData = function() {\n  return this.getPaths();\n};\n\n/**\n*/\nConfigurationProxy.prototype.onRegister = function() {\n  this.facade.retrieveProxy(DataBindingProxy.NAME).registerContext(this);\n};\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.setData = function(value) {\n  if (value.rules != null) {\n    Utils.mergeRules(value.rules);\n  }\n  ConfigurationProxy.__super__.setData.call(this, value);\n  return value;\n};\n\n/**\n * Plays iniline\n*/\nConfigurationProxy.prototype.getPlaysInline = function() {\n  return this.data.playsinline;\n};\n\n/**\n * Plays iniline\n*/\nConfigurationProxy.prototype.getMuted = function() {\n  return this.data.muted;\n};\n\nConfigurationProxy.prototype.setMuted = function(value) {\n  this.data.muted = value;\n  return value;\n};\n\n/**\n * Auto play.\n*/\nConfigurationProxy.prototype.getAutoplay = function() {\n  return this.data.autoplay;\n};\n\nConfigurationProxy.prototype.setAutoplay = function(value) {\n  this.data.autoplay = value;\n  return value;\n};\n\n/**\n * Auto play.\n*/\nConfigurationProxy.prototype.getLoop = function() {\n  return this.data.loop;\n};\n\nConfigurationProxy.prototype.setLoop = function(value) {\n  this.data.loop = value;\n  return value;\n};\n\n/**\n * End Slate.\n*/\nConfigurationProxy.prototype.getSettings = function() {\n  return this.data.settings;\n};\n\nConfigurationProxy.prototype.setSettings = function(value) {\n  this.data.settings = value;\n  return value;\n};\n\n/**\n * Domain\n*/\nConfigurationProxy.prototype.getDomain = function() {\n  return this.data.domain;\n};\n\nConfigurationProxy.prototype.setDomain = function(value) {\n  this.data.domain = value;\n  return value;\n};\n\n/**\n * Target.\n*/\nConfigurationProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nConfigurationProxy.prototype.setTarget = function(value) {\n  this.data.target = value;\n  return value;\n};\n\n/**\n * The player name.\n*/\nConfigurationProxy.prototype.getName = function() {\n  return this.data.name;\n};\n\nConfigurationProxy.prototype.setName = function(value) {\n  this.data.name = value;\n  return value;\n};\n\n/**\n * The player paths.\n*/\nConfigurationProxy.prototype.getPaths = function() {\n  return this.data.paths;\n};\n\nConfigurationProxy.prototype.setPaths = function(value) {\n  this.data.paths = value;\n  return value;\n};\n\n/**\n * The player version.\n*/\nConfigurationProxy.prototype.getVersion = function() {\n  return this.data.version;\n};\n\n/**\n * Controls\n*/\nConfigurationProxy.prototype.getControls = function() {\n  return this.data.controls;\n};\n\nConfigurationProxy.prototype.setControls = function(value) {\n  this.data.controls = value;\n  return value;\n};\n\n/**\n * Fullscreen configuration\n*/\nConfigurationProxy.prototype.getFullscreen = function() {\n  return this.data.fullscreen || {};\n};\n\nConfigurationProxy.prototype.setFullscreen = function(value) {\n  this.data.fullscreen = value;\n  return value;\n};\n\n/**\n * @constructor\n * @private\n * @extends {ModuleMediator}\n*/\nfunction SettingsMediator() {\n  SettingsMediator.__super__.constructor.call(this, this.NAME);\n  this.namespace = SettingsMediator.NAMESPACE;\n  this.defaults = {\n    volume: 1,\n    captions: {\n      visible: false,\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"small\",\n      scroll: \"popout\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0,0,0,0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    }\n  };\n}\n\n\n__extends(SettingsMediator, puremvc.Mediator);\n\n\nSettingsMediator.NAME = \"SettingsMediator\";\n\nSettingsMediator.NAMESPACE = \"akamai_amp\";\n\nSettingsMediator.GET = function() {\n  var settings;\n  settings = localStorage.getItem(SettingsMediator.NAMESPACE);\n  try {\n    settings = JSON.parse(settings);\n  } catch (error) {\n    settings = {};\n  }\n  return settings || {};\n};\n\n/** @override\n*/\nSettingsMediator.prototype.onRegister = function() {\n  var config, data, settings;\n  config = this.facade.retrieveProxy(ModuleProxy.NAME).getSettings() || {};\n  if (config.namespace != null) {\n    this.namespace = config.namespace;\n  }\n  this.settings = Utils.override(config.defaults, this.defaults);\n  try {\n    data = localStorage.getItem(this.namespace);\n    if (data != null) {\n      settings = JSON.parse(data);\n    }\n  } catch (_error) {}\n  this.save(settings);\n};\n\n/** @override\n*/\nSettingsMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.VOLUME_CHANGE, Notifications.CHANGE_AUTOPLAY];\n};\n\n/** @override\n*/\nSettingsMediator.prototype.handleNotification = function(notification) {\n  var body, name, value;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      value = this.settings.volume;\n      if (value != null) {\n        this.sendNotification(Notifications.CHANGE_VOLUME, value);\n      }\n      value = this.settings.autoplay;\n      if (value != null) {\n        this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);\n      }\n      break;\n    case Notifications.CHANGE_AUTOPLAY:\n      if (this.settings.autoplay === body) {\n        return;\n      }\n      this.change({\n        autoplay: body\n      });\n      break;\n    case Notifications.VOLUME_CHANGE:\n      if (this.settings.volume === body) {\n        return;\n      }\n      this.change({\n        volume: body\n      });\n  }\n};\n\n/**\n*/\nSettingsMediator.prototype.change = function(settings) {\n  var captions, changes, edgeColor, edgeType, fontFamily;\n  if (!(settings != null) || typeof settings !== \"object\" || settings instanceof Array) {\n    return;\n  }\n  changes = Utils.diff(this.settings, settings);\n  if (!(changes != null)) {\n    return;\n  }\n  captions = changes.captions;\n  if (captions != null) {\n    edgeColor = captions.edgeColor || \"\";\n    if (edgeColor === \"none\") {\n      captions.edgeColor = \"rgba(0,0,0,0)\";\n    }\n    edgeType = captions.edgeType;\n    if (edgeType != null) {\n      switch (edgeType.toLowerCase()) {\n        case \"none\":\n          edgeType = \"text-shadow: 0px 0px 0px\";\n          break;\n        case \"depressed\":\n          edgeType = \"text-shadow: 0px 1px 0px\";\n          break;\n        case \"left drop shadow\":\n          edgeType = \"text-shadow: -3px 3px 2px\";\n          break;\n        case \"raised\":\n          edgeType = \"text-shadow: 0px 1px 1px\";\n          break;\n        case \"right drop shadow\":\n          edgeType = \"text-shadow: 3px 3px 2px\";\n          break;\n        case \"uniform\":\n          edgeType = \"text-shadow: 0px 0px 4px\";\n      }\n      captions.edgeType = edgeType;\n    }\n    if (captions.fontSize != null) {\n      captions.size = captions.fontSize;\n      delete captions.fontSize;\n    }\n    fontFamily = captions.fontFamily;\n    if (fontFamily != null) {\n      if (this.fontFamily == null) {\n        this.fontFamily = {\n          \"Monospaced Serif\": \"Courier New, Courier, Nimbus Mono L, Cutive Mono, monospace\",\n          \"Proportional Serif\": \"Times New Roman, Times, Georgia, Cambria, PT Serif Caption, serif\",\n          \"Monospaced Sans-Serif\": \"Deja Vu Sans Mono, Lucida Console, Monaco, Consolas, PT Mono, monospace\",\n          \"Proportional Sans-Serif\": \"Roboto, Arial Unicode Ms, Arial, Helvetica, Verdana, PT Sans Caption, sans-serif\",\n          \"Casual\": \"Comic Sans MS, Impact, Handlee, fantasy\",\n          \"Cursive\": \"Monotype Corsiva, URW Chancery L, Apple Chancery, Dancing Script, cursive\",\n          \"Small Capitals\": \"Arial Unicode Ms, Arial, Helvetica, Verdana, Marcellus SC, sans-serif; font-variant: small-caps\"\n        };\n      }\n      if (typeof fontFamily === \"object\") {\n        this.fontFamily = Utils.override(this.fontFamily, fontFamily);\n      } else if (typeof fontFamily === \"string\") {\n        if (Object.keys(this.fontFamily).indexOf(fontFamily) !== -1) {\n          captions.fontFamily = this.fontFamily[fontFamily];\n        }\n      }\n    }\n  }\n  this.save(changes);\n  this.sendNotification(Notifications.SETTINGS_CHANGE, changes);\n};\n\n/**\n*/\nSettingsMediator.prototype.getSettings = function() {\n  return Object.freeze(Object.assign({\n    defaults: Object.assign({}, this.defaults),\n    change: this.change.bind(this)\n  }, this.settings));\n};\n\n/**\n*/\nSettingsMediator.prototype.save = function(settings) {\n  this.settings = Utils.override(this.settings, settings);\n  try {\n    localStorage.setItem(this.namespace, JSON.stringify(this.settings));\n  } catch (_error) {}\n};\n\n/**\n * The ChangeAutoplayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeSettingsCommand() {\n  ChangeSettingsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeSettingsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeSettingsCommand.prototype.execute = function(notification) {\n  var _ref;\n  if ((_ref = this.facade.retrieveMediator(SettingsMediator.NAME)) != null) {\n    _ref.change(notification.getBody());\n  }\n};\n\n/**\n * AudioPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction AudioPlaybackProxy() {\n  AudioPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(AudioPlaybackProxy, PlaybackCoreProxy);\n\n\nAudioPlaybackProxy.prototype.playbackCoreName = \"audio\";\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.onRegister = function() {\n  var mediaElement;\n  mediaElement = new MediaElementMediator(\"html5\", \"audio\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, mediaElement);\n};\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.onRemove = function() {\n  this.facade.createMediaElement();\n};\n\n/**\n *\n*/\nAudioPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return medium === \"audio\";\n};\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  if (/audio/.test(mimeType)) {\n    return \"maybe\";\n  } else if (/mpegURL/.test(mimeType) && (Utils.isIOS() || Utils.getSafariVersion() !== -1)) {\n    return \"maybe\";\n  }\n  return \"\";\n};\n\nfunction FPS() {}\n\nFPS.extractContentId = function(initData, keys) {\n  var link;\n  link = document.createElement('a');\n  link.href = Utils.arrayToString(initData);\n  return link.hostname;\n};\n\nFPS.extractServerUrl = function(initData, keys) {\n  return keys.serverURL || keys.serverUrl;\n};\n\nFPS.requestCertificate = function(keys) {\n  var request;\n  request = {\n    url: keys.cert,\n    responseType: \"arraybuffer\",\n    headers: {\n      \"Pragma\": \"Cache-Control: no-cache\",\n      \"Cache-Control\": \"max-age=0\"\n    }\n  };\n  return Utils.request(request).then(function(xhr) {\n    return new Uint8Array(xhr.response);\n  });\n};\n\nFPS.concatInitDataIdAndCertificate = function(initData, id, cert) {\n  var buffer, certArray, dataView, idArray, initDataArray, offset;\n  if (typeof id === \"string\") {\n    id = Utils.stringToArray(id);\n  }\n  offset = 0;\n  buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);\n  dataView = new DataView(buffer);\n  initDataArray = new Uint8Array(buffer, offset, initData.byteLength);\n  initDataArray.set(initData);\n  offset += initData.byteLength;\n  dataView.setUint32(offset, id.byteLength, true);\n  offset += 4;\n  idArray = new Uint16Array(buffer, offset, id.length);\n  idArray.set(id);\n  offset += idArray.byteLength;\n  dataView.setUint32(offset, cert.byteLength, true);\n  offset += 4;\n  certArray = new Uint8Array(buffer, offset, cert.byteLength);\n  certArray.set(cert);\n  return new Uint8Array(buffer, 0, buffer.byteLength);\n};\n\nFPS.requestLicense = function(message, contentId, serverUrl, keys) {\n  var key, request, value, _ref,\n    _this = this;\n  request = {\n    url: serverUrl,\n    method: \"POST\",\n    responseType: \"text\",\n    headers: {\n      \"Content-type\": \"application/x-www-form-urlencoded\"\n    },\n    data: \"spc=\" + (Utils.base64EncodeUint8Array(message)) + \"&assetId=\" + (encodeURIComponent(contentId))\n  };\n  if (keys.httpRequestHeaders != null) {\n    _ref = keys.httpRequestHeaders;\n    for (key in _ref) {\n      value = _ref[key];\n      request.headers[key] = value;\n    }\n  }\n  if (typeof keys.withCredentials === \"boolean\") {\n    request.withCredentials = keys.withCredentials;\n  }\n  return Utils.request(request).then(function(xhr) {\n    var keyText;\n    keyText = xhr.responseText.trim();\n    if (keyText.substr(0, 5) === \"<ckc>\" && keyText.substr(-6) === \"</ckc>\") {\n      keyText = keyText.slice(5, -6);\n    }\n    return Utils.base64DecodeUint8Array(keyText);\n  })[\"catch\"](function(error) {\n    throw \"The license request failed.\";\n  });\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ParamsProxy(data) {\n  ParamsProxy.__super__.constructor.call(this, data);\n}\n\n\n__extends(ParamsProxy, DataBoundConfigurationProxy);\n\n\n/** @static\n*/\nParamsProxy.NAME = \"ParamsProxy\";\n\nParamsProxy.prototype.defaults = {};\n\nParamsProxy.prototype.configurationName = \"params\";\n\n/** @override\n*/\nParamsProxy.prototype.setData = function(data) {\n  var key, value;\n  this.data = {};\n  for (key in data) {\n    value = data[key];\n    this.data[key] = data[key];\n  }\n  return this.data;\n};\n\n/**\n * DVRPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction DVRPlaybackProxy() {\n  DVRPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(DVRPlaybackProxy, PlaybackCoreProxy);\n\n\nDVRPlaybackProxy.prototype.playbackCoreName = \"dvr\";\n\nDVRPlaybackProxy.prototype.interval = null;\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.ondurationchange = function(event) {\n  this.updateDuration();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.ontimeupdate = function(event) {\n  this.updateCurrentTime();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onplay = function(event) {\n  this.stopTimer();\n  DVRPlaybackProxy.__super__.onplay.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onplaying = function(event) {\n  this.stopTimer();\n  DVRPlaybackProxy.__super__.onplaying.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onpause = function(event) {\n  this.startTimer();\n  DVRPlaybackProxy.__super__.onpause.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return temporalType === \"dvr\";\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getDuration = function() {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement.duration === Infinity) {\n    this.updateDuration();\n  }\n  return this.data.duration;\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getStartTime = function() {\n  return this.getMediaElement().seekable.start(0);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getFragmentDuration = function() {\n  return 10;\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getLiveTime = function() {\n  return this.getDuration() - this.getFragmentDuration();\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.isLive = function() {\n  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.seek = function(value) {\n  var _this = this;\n  return DVRPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {\n    _this.sendNotification(Notifications.IS_LIVE, _this.isLive());\n  });\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.updateCurrentTime = function() {\n  var currentTime, seekable;\n  seekable = this.getMediaElement().seekable;\n  if (seekable.length === 0) {\n    return;\n  }\n  currentTime = this.getMediaElement().currentTime;\n  this.data.currentTime = currentTime - seekable.start(0);\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: this.data.currentTime\n  });\n  this.mediaProxy.setIsLive(this.isLive());\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.updateDuration = function() {\n  var seekable;\n  seekable = this.getMediaElement().seekable;\n  if (seekable.length === 0) {\n    return;\n  }\n  this.data.duration = seekable.end(0) - seekable.start(0);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.startTimer = function() {\n  this.interval = setInterval(this.updateCurrentTime.bind(this), 1000);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.stopTimer = function() {\n  if (this.interval != null) {\n    clearInterval(this.interval);\n    this.interval = null;\n    this.updateCurrentTime();\n  }\n};\n\n/**\n * Creates a new instance of Context.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n * @implements {IDataBindingContext}\n*/\nfunction DataBindingContext() {\n  DataBindingContext.__super__.constructor.call(this);\n  if (this.contextName == null) {\n    this.contextName = this.constructor.NAME;\n  }\n}\n\n\n__extends(DataBindingContext, puremvc.Proxy);\n\n\nDataBindingContext.prototype.contextName = null;\n\nDataBindingContext.prototype.contextData = null;\n\n/**\n*/\nDataBindingContext.prototype.onRegister = function() {\n  var base, bindings;\n  if (!(this.getContextName() != null)) {\n    return;\n  }\n  base = this.facade.player || this.facade;\n  bindings = base.retrieveProxy(DataBindingProxy.NAME);\n  bindings.registerContext(this);\n};\n\n/**\n*/\nDataBindingContext.prototype.getContextName = function() {\n  return this.contextName;\n};\n\n/**\n*/\nDataBindingContext.prototype.getContextData = function() {\n  return this.contextData;\n};\n\n/**\n * Creates a new instance of PlayerProxy.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction PlayerProxy(defaultPlaybackCore, getPlaybackOrder) {\n  var _this = this;\n  this.defaultPlaybackCore = defaultPlaybackCore;\n  this.getPlaybackOrder = getPlaybackOrder;\n  PlayerProxy.__super__.constructor.call(this);\n  this.playbackCoreMap = [];\n  if (this.getPlaybackOrder == null) {\n    this.getPlaybackOrder = function(order) {\n      if (/Edge|Android/.test(navigator.userAgent)) {\n        return [\"audio\", \"hls\", \"dash\", \"dvr\", \"default\"];\n      }\n    };\n  }\n}\n\n\n__extends(PlayerProxy, DataBindingContext);\n\n\n/** @static\n*/\nPlayerProxy.NAME = \"PlayerProxy\";\n\nPlayerProxy.prototype.contextName = \"player\";\n\nPlayerProxy.prototype.getPlaybackOrder = null;\n\nPlayerProxy.prototype.playbackCoreMap = null;\n\nPlayerProxy.prototype.defaultPlaybackCore = null;\n\nPlayerProxy.prototype.activePlaybackCore = null;\n\n/**\n*/\nPlayerProxy.prototype.onRegister = function() {\n  PlayerProxy.__super__.onRegister.call(this);\n  this.registerPlaybackCore(new DVRPlaybackProxy());\n  this.registerPlaybackCore(this.defaultPlaybackCore);\n  this.registerPlaybackCore(new AudioPlaybackProxy());\n  this.activePlaybackCore = this.defaultPlaybackCore;\n};\n\nPlayerProxy.prototype.ready = function() {\n  var order,\n    _this = this;\n  order = typeof this.getPlaybackOrder === \"function\" ? this.getPlaybackOrder(this.playbackCoreMap.map(function(core) {\n    return core.getPlaybackCoreName();\n  })) : void 0;\n  if (!(order != null)) {\n    return;\n  }\n  this.playbackCoreMap = this.playbackCoreMap.sort(function(a, b) {\n    a = order.indexOf(a.getPlaybackCoreName());\n    b = order.indexOf(b.getPlaybackCoreName());\n    if (a === b) {\n      return 0;\n    }\n    if (a === -1 && b !== -1) {\n      return 1;\n    }\n    if (a !== -1 && b === -1) {\n      return -1;\n    }\n    return a - b;\n  });\n};\n\n/**\n*/\nPlayerProxy.prototype.getActivePlaybackCore = function() {\n  return this.activePlaybackCore;\n};\n\n/**\n*/\nPlayerProxy.prototype.registerPlaybackCore = function(core) {\n  var name,\n    _this = this;\n  name = core.getPlaybackCoreName();\n  if (!(core != null) || this.playbackCoreMap.some(function(item) {\n    return item.getPlaybackCoreName() === name;\n  })) {\n    return;\n  }\n  this.playbackCoreMap.push(core);\n};\n\n/**\n*/\nPlayerProxy.prototype.retrievePlaybackCore = function(name) {\n  var core, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    if (core.getPlaybackCoreName() === name) {\n      return core;\n    }\n  }\n};\n\n/**\n*/\nPlayerProxy.prototype.removePlaybackCore = function(name) {\n  var core, index;\n  core = this.retrievePlaybackCore(name);\n  if (!(core != null)) {\n    return null;\n  }\n  index = this.playbackCoreMap.indexOf(core);\n  this.playbackCoreMap.splice(index, 1);\n  return core;\n};\n\n/**\n*/\nPlayerProxy.prototype.setPlaybackCore = function(media) {\n  var core, error, playbackCore, playbackProxy, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    if (core.canPlayMedium(media.medium) === true && core.canPlayTemporalType(media.temporalType) === true && core.canPlayType(media.type) !== \"\") {\n      playbackCore = core;\n      break;\n    }\n  }\n  if (!(playbackCore != null)) {\n    error = new Error();\n    error.code = MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED;\n    throw error;\n  }\n  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  if (playbackProxy !== playbackCore) {\n    if (typeof playbackProxy.destroy === \"function\") {\n      playbackProxy.destroy();\n    }\n    this.facade.removeProxy(PlaybackProxy.NAME);\n    this.facade.registerProxy(playbackCore);\n    playbackCore.setData(playbackProxy.getData());\n  }\n  this.activePlaybackCore = playbackCore;\n  return media;\n};\n\n/**\n*/\nPlayerProxy.prototype.canPlayType = function(type) {\n  var canPlay, core, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    canPlay = core.canPlayType(type);\n    if (canPlay !== \"\") {\n      return canPlay;\n    }\n  }\n  return \"\";\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nPlayerProxy.prototype.getContextData = function() {\n  var configProxy, element, mediaProxy, playbackProxy;\n  configProxy = this.facade.retrieveProxy(ConfigurationProxy.NAME);\n  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n  element = this.facade.getViewComponent();\n  return {\n    width: element.offsetWidth,\n    height: element.offsetHeight,\n    mode: \"html5\",\n    autoplay: configProxy.getAutoplay(),\n    domain: configProxy.getDomain(),\n    name: configProxy.getName(),\n    currentTime: playbackProxy.getCurrentTime(),\n    duration: playbackProxy.getDuration(),\n    version: configProxy.getVersion(),\n    timecode: {\n      duration: Utils.formatTimecode(mediaProxy.getDuration()),\n      currentTime: Utils.formatTimecode(playbackProxy.getCurrentTime())\n    }\n  };\n};\n\n/**\n * Creates a new instance of MediaProxy. Used to track metadata associated with the video such as src, title and duration.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction MediaProxy(config) {\n  this.data = {\n    metadata: {}\n  };\n  MediaProxy.__super__.constructor.call(this);\n  this.transform = this.transform.bind(this);\n}\n\n\n__extends(MediaProxy, DataBindingContext);\n\n\n/** @static\n*/\nMediaProxy.NAME = \"MediaProxy\";\n\nMediaProxy.prototype.contextName = \"media\";\n\n/** @private\n*/\nMediaProxy.prototype.data = null;\n\nMediaProxy.prototype.value = null;\n\nMediaProxy.prototype.started = false;\n\nMediaProxy.prototype.authorized = true;\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nMediaProxy.prototype.getContextData = function() {\n  return this.data;\n};\n\n/**\n * Sets the data for this proxy.\n *\n * @param {Object} value\n *    The new data for this proxy\n * @override\n*/\nMediaProxy.prototype.getData = function() {\n  var data;\n  data = Utils.clone(MediaProxy.__super__.getData.call(this));\n  if (!(data.authorization != null)) {\n    data.authorization = Utils.clone(this.facade.security.data);\n  }\n  return data;\n};\n\n/**\n * Sets the data for this proxy.\n *\n * @param {Object} value\n *    The new data for this proxy\n * @override\n*/\nMediaProxy.prototype.setData = function(value) {\n  if (this.data && this.facade.getCurrentTime() < this.facade.getDuration()) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);\n  }\n  this.started = false;\n  this.setAutoplay(value.autoplay);\n  this.setType(value.type);\n  this.setIsLive(value.isLive);\n  this.setTemporalType(value.temporalType);\n  if (value.source != null) {\n    this.setSource(value.source);\n  }\n  if (value.src != null) {\n    this.setSrc(value.src);\n  }\n  this.setTitle(value.title);\n  this.setDuration(value.duration);\n  this.setPoster(value.poster);\n  this.setGUID(value.guid);\n  this.setLink(value.link);\n  this.setEmbed(value.embed);\n  this.setWidth(value.width);\n  this.setHeight(value.height);\n  this.setCategory(value.category);\n  this.setStartTime(value.startTime);\n  this.setDescription(value.description);\n  this.setStatus(value.status);\n  this.setCategory(value.category);\n  this.setMetadata(value.metadata);\n  this.setAuthorization(value.authorization);\n  this.setMedium(value.medium);\n  this.setPubDate(value.pubDate);\n  this.setTrack(value.track);\n  this.setScenes(value.scenes);\n  this.setKeys(value.keys);\n  this.setCues(value.cues);\n  this.setRestriction(value.restriction);\n  return this.data;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.transform = function(media) {\n  var index, item, playerProxy, scene, time, _i, _len, _ref, _ref1,\n    _this = this;\n  if (!(media.src != null) && ((_ref = media.source) != null ? _ref.length : void 0) > 0) {\n    playerProxy = this.facade.retrieveProxy(PlayerProxy.NAME) || this.facade;\n    if (playerProxy != null) {\n      item = Utils.selectSource(media.source, function(type) {\n        return playerProxy.canPlayType(type);\n      });\n    }\n    if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n      media.src = item.src;\n      media.type = item.type;\n    }\n  }\n  if (media.type == null) {\n    media.type = Utils.getMimeType(media.src);\n  }\n  if (!(media.medium != null)) {\n    media.medium = /audio/.test(media.type) ? \"audio\" : \"video\";\n  }\n  if (media.temporalType == null) {\n    media.temporalType = \"vod\";\n  }\n  media.isLive = media.temporalType === \"live\" || media.temporalType === \"dvr\";\n  if (media.scenes != null) {\n    _ref1 = media.scenes;\n    for (index = _i = 0, _len = _ref1.length; _i < _len; index = ++_i) {\n      scene = _ref1[index];\n      scene.start = isNaN(time = Utils.flattenTimecode(scene.sceneStartTime)) ? 0 : time;\n      scene.end = isNaN(time = Utils.flattenTimecode(scene.sceneEndTime)) ? 0 : time;\n      scene.title = scene.sceneTitle || \"\";\n      scene.description = scene.sceneDescription || \"\";\n      scene.position = index + 1;\n    }\n  }\n  if (media.startTime == null) {\n    media.startTime = 0;\n  }\n  if (media.status == null) {\n    media.status = {};\n  }\n  if (media.metadata == null) {\n    media.metadata = {};\n  }\n  media.originalSrc = media.src;\n  return media;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.updateData = function(data) {\n  var key, value;\n  for (key in data) {\n    value = data[key];\n    if (key in this.data) {\n      this.data[key] = value;\n    }\n  }\n};\n\n/**\n * The global unique identifier for this to the video.\n *\n * @param {String} value\n *    The new guid of the video\n * @returns {String}\n *    The guid of the video\n * @type {String}\n*/\nMediaProxy.prototype.getGUID = function() {\n  return this.data.guid;\n};\n\nMediaProxy.prototype.setGUID = function(value) {\n  return this.data.guid = value;\n};\n\nMediaProxy.prototype.getLink = function() {\n  return this.data.link;\n};\n\nMediaProxy.prototype.setLink = function(value) {\n  return this.data.link = value;\n};\n\nMediaProxy.prototype.getStartTime = function() {\n  return this.data.startTime;\n};\n\nMediaProxy.prototype.setStartTime = function(value) {\n  return this.data.startTime = value;\n};\n\nMediaProxy.prototype.getEmbed = function() {\n  return this.data.embed;\n};\n\nMediaProxy.prototype.setEmbed = function(value) {\n  return this.data.embed = value;\n};\n\nMediaProxy.prototype.getAutoplay = function() {\n  return this.data.autoplay;\n};\n\nMediaProxy.prototype.setAutoplay = function(value) {\n  return this.data.autoplay = value;\n};\n\nMediaProxy.prototype.getPubDate = function() {\n  return this.data.pubDate;\n};\n\nMediaProxy.prototype.setPubDate = function(value) {\n  return this.data.pubDate = value;\n};\n\nMediaProxy.prototype.getCategory = function() {\n  return this.data.category;\n};\n\nMediaProxy.prototype.setCategory = function(value) {\n  return this.data.category = value;\n};\n\nMediaProxy.prototype.getStatus = function() {\n  return this.data.status;\n};\n\nMediaProxy.prototype.setStatus = function(value) {\n  if (value == null) {\n    value = {};\n  }\n  return this.data.status = value;\n};\n\n/**\n * The url to the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nMediaProxy.prototype.getSrc = function() {\n  return this.facade.security.createURL(this.data.src);\n};\n\nMediaProxy.prototype.setSrc = function(value) {\n  return this.data.src = value;\n};\n\n/**\n * The mimeType of the video.\n*/\nMediaProxy.prototype.getType = function() {\n  return this.data.type;\n};\n\nMediaProxy.prototype.setType = function(value) {\n  return this.data.type = value;\n};\n\n/**\n * The medium the video. ie audio, video, executable\n*/\nMediaProxy.prototype.getMedium = function() {\n  return this.data.medium;\n};\n\nMediaProxy.prototype.setMedium = function(value) {\n  if (value === this.data.medium) {\n    return;\n  }\n  this.data.medium = value;\n  return this.facade.retrieveProxy(ApplicationStateProxy.NAME).setMedium(value);\n};\n\n/**\n * Additional information about the vieo\n*/\nMediaProxy.prototype.getMetadata = function() {\n  return this.data.metadata;\n};\n\nMediaProxy.prototype.setMetadata = function(value) {\n  return this.data.metadata = value;\n};\n\n/**\n * The source object of the video.\n*/\nMediaProxy.prototype.getSource = function() {\n  return this.data.source;\n};\n\nMediaProxy.prototype.setSource = function(value) {\n  return this.data.source = value;\n};\n\n/**\n * The source object of the video.\n*/\nMediaProxy.prototype.getTrack = function() {\n  return this.data.track;\n};\n\nMediaProxy.prototype.setTrack = function(value) {\n  return this.data.track = value;\n};\n\n/**\n * The title of the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nMediaProxy.prototype.getTitle = function() {\n  return this.data.title;\n};\n\nMediaProxy.prototype.setTitle = function(value) {\n  return this.data.title = value;\n};\n\n/**\n * The native width of the video.\n*/\nMediaProxy.prototype.getWidth = function() {\n  return this.data.width;\n};\n\nMediaProxy.prototype.setWidth = function(value) {\n  return this.data.width = value;\n};\n\n/**\n * The native width of the video.\n*/\nMediaProxy.prototype.getHeight = function() {\n  return this.data.height;\n};\n\nMediaProxy.prototype.setHeight = function(value) {\n  return this.data.height = value;\n};\n\n/**\n * The description of the video.\n *\n * @param {String} value\n *    The new description of the video\n * @returns {Boolean}\n *    The description of the video\n * @type {String}\n*/\nMediaProxy.prototype.getDescription = function() {\n  return this.data.description;\n};\n\nMediaProxy.prototype.setDescription = function(value) {\n  return this.data.description = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getCategory = function() {\n  return this.data.category;\n};\n\nMediaProxy.prototype.setCategory = function(value) {\n  return this.data.category = value;\n};\n\n/**\n * The duration of the video. This property is used in situations where the\n * duration cannot be determined from the video (i.e. before metadata is loaded)\n *\n * @param {Number} value\n *    The new duration of the video\n * @returns {Number}\n *    The duration of the video\n * @type {Number}\n*/\nMediaProxy.prototype.getDuration = function(value) {\n  return this.data.duration;\n};\n\nMediaProxy.prototype.setDuration = function(value) {\n  var ua;\n  if (value === 0 || this.data.temporalType === \"live\") {\n    return;\n  }\n  ua = navigator.userAgent;\n  if (value === 1 && (/Android/.test(ua) && !/Android.*Chrome/.test(ua))) {\n    return;\n  }\n  if (value !== this.data.duration) {\n    this.data.duration = value;\n    this.sendNotification(Notifications.TIME_CHANGE, {\n      duration: value\n    });\n  }\n  if (value === Infinity) {\n    this.setTemporalType(\"live\");\n  }\n  return value;\n};\n\n/**\n * The poster image for the video.\n *\n * @param {String} value\n *    The url of the new poster image\n * @returns {String}\n *    The url of the poster image\n * @type {String}\n*/\nMediaProxy.prototype.getPoster = function(value) {\n  return this.data.poster;\n};\n\nMediaProxy.prototype.setPoster = function(value) {\n  this.data.poster = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getIsLive = function() {\n  return this.data.isLive;\n};\n\nMediaProxy.prototype.setIsLive = function(value) {\n  if (value === this.data.isLive) {\n    return;\n  }\n  this.data.isLive = value;\n  this.sendNotification(Notifications.IS_LIVE, value);\n  return value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getTemporalType = function() {\n  return this.data.temporalType || \"vod\";\n};\n\nMediaProxy.prototype.setTemporalType = function(value) {\n  var previous;\n  if (value === this.data.temporalType) {\n    return;\n  }\n  previous = this.data.temporalType;\n  this.data.temporalType = value;\n  this.sendNotification(Notifications.TEMPORAL_TYPE_CHANGE, {\n    previous: previous,\n    value: value\n  });\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getScenes = function() {\n  return this.data.scenes;\n};\n\nMediaProxy.prototype.setScenes = function(value) {\n  return this.data.scenes = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getCues = function() {\n  return this.data.cues;\n};\n\nMediaProxy.prototype.setCues = function(value) {\n  if (value == null) {\n    value = [];\n  }\n  if (this.data.cues === value) {\n    return;\n  }\n  this.data.cues = value;\n  this.sendNotification(Notifications.CUES_CHANGE, value);\n  return value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getScene = function(currentTime) {\n  var index, scene, _i, _len, _ref;\n  if (!(this.data.scenes != null)) {\n    return;\n  }\n  _ref = this.data.scenes;\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    scene = _ref[index];\n    if ((scene.start <= currentTime && currentTime < scene.end)) {\n      return scene;\n    }\n  }\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getKeys = function() {\n  return this.data.keys;\n};\n\nMediaProxy.prototype.setKeys = function(value) {\n  this.data.keys = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getAuthorization = function() {\n  return this.data.authorization;\n};\n\nMediaProxy.prototype.setAuthorization = function(value) {\n  this.data.authorization = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getRestriction = function() {\n  return this.data.restriction;\n};\n\nMediaProxy.prototype.setRestriction = function(value) {\n  if (value == null) {\n    value = [];\n  }\n  this.data.restriction = value;\n};\n\n/**\n * Creates a new instance of SecurityProxy.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction SecurityProxy() {\n  SecurityProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n  this.setupHDN1();\n  Object.defineProperties(this, {\n    authorized: {\n      get: this.getAuthorized,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(SecurityProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nSecurityProxy.NAME = \"SecurityProxy\";\n\nSecurityProxy.prototype.authorized = true;\n\nSecurityProxy.prototype.timeout = null;\n\n/**\n*/\nSecurityProxy.prototype.setupHDN1 = function() {\n  var _this = this;\n  return window.retrieveToken = function(guid, url) {\n    var token;\n    try {\n      _this.facade.logger.debug(\"[AMP AUTH] HDN1: Token Requested\", guid, url);\n      token = _this.getToken();\n      if (token != null) {\n        _this.facade.getMediaElement().tokenRetrievalSuccess(\"&primaryToken=\" + token);\n      } else {\n        _this.sendNotification(SecurityNotifications.AUTHORIZE);\n      }\n    } catch (error) {\n      _this.facade.logger.error(\"[AMP AUTH ERROR]: Token Retrival Error\", error);\n    }\n    return true;\n  };\n};\n\n/**\n*/\nSecurityProxy.prototype.setMedia = function(media) {\n  var authorized;\n  this.setSession(null);\n  authorized = media.status.state !== \"blocked\" && media.restriction.length === 0;\n  this.setAuthorized(authorized);\n  this.setAuthorization(media.authorization);\n};\n\n/**\n*/\nSecurityProxy.prototype.authorize = function(authorization) {\n  this.setAuthorization(authorization);\n  this.sendNotification(SecurityNotifications.AUTHORIZED, authorization);\n};\n\n/**\n*/\nSecurityProxy.prototype.getAuthorization = function() {\n  return this.data;\n};\n\nSecurityProxy.prototype.setAuthorization = function(value) {\n  if ((value != null ? value.token : void 0) != null) {\n    this.setAuthorized(true);\n  }\n  this.data = value || {};\n  if (this.data.expiration != null) {\n    this.setExpiration(this.data.expiration);\n  }\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getKey = function() {\n  return this.data.key;\n};\n\nSecurityProxy.prototype.setKey = function(value) {\n  this.data.key = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getToken = function() {\n  return this.data.token;\n};\n\nSecurityProxy.prototype.setToken = function(value) {\n  this.data.token = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getExpiration = function() {\n  return this.data.expiration;\n};\n\nSecurityProxy.prototype.setExpiration = function(value) {\n  this.data.expiration = value;\n  if (this.data.expiration > Date.now()) {\n    this.startTimeout();\n  }\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.startTimeout = function() {\n  var _this = this;\n  Utils.getUTC().then(function(time) {\n    var timeout;\n    timeout = function() {\n      _this.sendNotification(SecurityNotifications.AUTHORIZATION_EXPIRED);\n      _this.sendNotification(SecurityNotifications.AUTHORIZE, {\n        media: _this.facade.getMedia()\n      });\n    };\n    return _this.timeout = setTimeout(timeout, _this.getExpiration() - time);\n  });\n};\n\n/**\n*/\nSecurityProxy.prototype.stopTimeout = function() {\n  clearTimeout(this.timeout);\n};\n\n/**\n*/\nSecurityProxy.prototype.getSecret = function() {\n  var secret;\n  if (!(this.data.token != null)) {\n    return null;\n  }\n  secret = \"\";\n  if (this.data.token != null) {\n    secret = \"\" + this.data.token;\n  }\n  if (this.data.key != null) {\n    secret = \"\" + this.data.key + \"=\" + secret;\n  }\n  return secret;\n};\n\n/**\n*/\nSecurityProxy.prototype.createURL = function(url) {\n  var secret;\n  secret = this.getSecret();\n  if (secret != null) {\n    url += !/\\?/.test(url) ? \"?\" : \"&\";\n    url += secret;\n  }\n  return url;\n};\n\n/**\n*/\nSecurityProxy.prototype.getAuthorized = function() {\n  return this._authorized;\n};\n\nSecurityProxy.prototype.setAuthorized = function(value) {\n  this.stopTimeout();\n  this._authorized = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getSession = function() {\n  return this.session;\n};\n\nSecurityProxy.prototype.setSession = function(value) {\n  this.session = value;\n  return value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PlayState = {\n  /**\n   * Constant representing the playing play state\n  */\n\n  READY: \"ready\",\n  /**\n   * Constant representing the playing play state\n  */\n\n  PLAYING: \"playing\",\n  /**\n   * Constant representing the paused play state\n  */\n\n  PAUSED: \"paused\",\n  /**\n   * Constant representing the ended play state\n  */\n\n  ENDED: \"ended\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  LOADING: \"loading\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  WAITING: \"waiting\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  ERROR: \"error\"\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction DataBindingProxy() {\n  DataBindingProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n  this.data = {};\n  this.contextMap = {};\n  this.configurationMap = {};\n}\n\n\n__extends(DataBindingProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nDataBindingProxy.NAME = \"DataBindingProxy\";\n\nDataBindingProxy.prototype.contextMap = null;\n\nDataBindingProxy.prototype.configurationMap = null;\n\nDataBindingProxy.prototype.paramsProxy = null;\n\n/**\n*/\nDataBindingProxy.prototype.initialize = function() {\n  this.paramsProxy = this.facade.retrieveProxy(ParamsProxy.NAME);\n  this.update();\n};\n\n/**\n*/\nDataBindingProxy.prototype.registerContext = function(context) {\n  if (!(context != null)) {\n    return;\n  }\n  this.contextMap[context.getContextName()] = context;\n};\n\n/**\n*/\nDataBindingProxy.prototype.retrieveContext = function(name) {\n  return this.contextMap[name];\n};\n\n/**\n*/\nDataBindingProxy.prototype.removeContext = function(name) {\n  var context;\n  context = this.contextMap[name];\n  delete this.contextMap[name];\n  return context;\n};\n\n/**\n*/\nDataBindingProxy.prototype.registerConfiguration = function(config) {\n  if (!(config != null)) {\n    return;\n  }\n  this.configurationMap[config.getConfigurationName()] = config;\n  config.compile(this.context, true);\n};\n\n/**\n*/\nDataBindingProxy.prototype.retrieveConfiguration = function(name) {\n  return this.configurationMap[name];\n};\n\n/**\n*/\nDataBindingProxy.prototype.removeConfiguration = function(name) {\n  var config;\n  config = this.configurationMap[name];\n  delete this.configurationMap[name];\n  return config;\n};\n\n/**\n*/\nDataBindingProxy.prototype.update = function(contexts) {\n  var context, key, name, value, _ref, _ref1;\n  this.data.now = Date.now();\n  _ref = this.contextMap;\n  for (name in _ref) {\n    context = _ref[name];\n    if ((contexts != null ? typeof contexts.indexOf === \"function\" ? contexts.indexOf(name) : void 0 : void 0) === -1) {\n      continue;\n    }\n    this.data[name] = context.getContextData();\n  }\n  this.paramsProxy.compile(this.data);\n  _ref1 = this.paramsProxy.value;\n  for (key in _ref1) {\n    value = _ref1[key];\n    this.data[key] = value;\n  }\n  return this.data;\n};\n\n/**\n*/\nDataBindingProxy.prototype.compile = function(contexts, suppressErrors) {\n  var config, context, name, paramsName, _ref;\n  if (suppressErrors == null) {\n    suppressErrors = false;\n  }\n  this.update(contexts);\n  context = this.data;\n  paramsName = this.paramsProxy.getConfigurationName();\n  _ref = this.configurationMap;\n  for (name in _ref) {\n    config = _ref[name];\n    if (name !== paramsName) {\n      config.compile(context, suppressErrors);\n    }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar RenderMode = {\n  /**\n   * Constant representing the flash renderer.\n  */\n\n  FLASH: \"flash\",\n  /**\n   * Constant representing the html renderer.\n  */\n\n  HTML: \"html\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ActiveState = {\n  /**\n   * Constant representing the active state (controls on).\n  */\n\n  ACTIVE: \"active\",\n  /**\n   * Constant representing the inactive state (controls off).\n  */\n\n  INACTIVE: \"inactive\"\n};\n\n/**\n * @enum {string}\n * @const\n*/\n\nvar TransformType = {\n  /**\n   *\n  */\n\n  TIME: \"time\",\n  /**\n   *\n  */\n\n  SEEK: \"seek\",\n  /**\n   *\n  */\n\n  MEDIA: \"media\",\n  /**\n   *\n  */\n\n  AD_REQUEST: \"adrequest\",\n  /**\n   *\n  */\n\n  PLAY_STATE: \"playstate\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PluginNotifications = {\n  REGISTER_PLUGINS: \"registerPlugins\",\n  PLUGIN_REGISTERED: \"pluginRegistered\",\n  PLUGINS_INITIALIZED: \"pluginsinitialized\"\n};\n\n/**\n * Used to track the various states of the player like full screen mode and active state (controls visible).\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ApplicationStateProxy() {\n  ApplicationStateProxy.__super__.constructor.call(this);\n  this.device = Utils.getDevice();\n  this.time = {};\n}\n\n\n__extends(ApplicationStateProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nApplicationStateProxy.NAME = \"ApplicationStateProxy\";\n\n/** @private\n*/\nApplicationStateProxy.prototype.displayState = DisplayState.NORMAL;\n\nApplicationStateProxy.prototype.playState = null;\n\nApplicationStateProxy.prototype.renderMode = null;\n\nApplicationStateProxy.prototype.activeState = null;\n\nApplicationStateProxy.prototype.seeking = false;\n\nApplicationStateProxy.prototype.seekrequested = false;\n\nApplicationStateProxy.prototype.waiting = false;\n\nApplicationStateProxy.prototype.busy = false;\n\nApplicationStateProxy.prototype.isUserActive = false;\n\nApplicationStateProxy.prototype.device = null;\n\nApplicationStateProxy.prototype.volume = 1;\n\nApplicationStateProxy.prototype.playbackTarget = \"amp\";\n\nApplicationStateProxy.prototype.hasPostContent = false;\n\nApplicationStateProxy.prototype.locked = false;\n\nApplicationStateProxy.prototype.mediaElement = null;\n\nApplicationStateProxy.prototype.hidden = false;\n\nApplicationStateProxy.prototype.ended = false;\n\nApplicationStateProxy.prototype.buffering = false;\n\nApplicationStateProxy.prototype.time = null;\n\nApplicationStateProxy.prototype.playbackRate = 1;\n\n/**\n * Flag indicating whether or not the media will have additional\n * content playback after the media playback is complete\n *\n * @param {Boolean} value\n *    The post content flag\n * @returns {Boolean}\n *    The post content flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getHasPostContent = function() {\n  return this.hasPostContent;\n};\n\nApplicationStateProxy.prototype.setHasPostContent = function(value) {\n  this.hasPostContent = value;\n};\n\n/**\n * Flag indicating whether or not the media playback is complete\n *\n * @param {Boolean} value\n *    The ended flag\n * @returns {Boolean}\n *    The ended flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getEnded = function() {\n  return this.ended;\n};\n\nApplicationStateProxy.prototype.setEnded = function(value) {\n  this.ended = value;\n  if (this.ended === true && this.seeking === true) {\n    this.seeking = false;\n  }\n};\n\n/**\n * The player's display state. Valid options are:\n *\n * ApplicationStateProxy.FULL_SCREEN\n * ApplicationStateProxy.NORMAL\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getDisplayState = function() {\n  return this.displayState;\n};\n\nApplicationStateProxy.prototype.setDisplayState = function(value) {\n  var previous;\n  if (value === this.displayState) {\n    return;\n  }\n  previous = this.displayState;\n  this.displayState = value;\n  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, {\n    previous: previous,\n    value: this.displayState\n  });\n};\n\n/**\n * The player's display state. Valid options are:\n *\n * ApplicationStateProxy.FULL_SCREEN\n * ApplicationStateProxy.NORMAL\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getPlayState = function() {\n  return this.playState;\n};\n\nApplicationStateProxy.prototype.setPlayState = function(value) {\n  var previous,\n    _this = this;\n  if (this.getWaiting() === true) {\n    this.setWaiting(false);\n  }\n  if (value === this.playState) {\n    return;\n  }\n  previous = this.playState;\n  this.playState = value;\n  this.facade.transform(TransformType.PLAY_STATE, this.playState).then(function(result) {\n    _this.sendNotification(Notifications.PLAY_STATE_CHANGE, {\n      previous: previous,\n      value: _this.playState\n    });\n    switch (value) {\n      case PlayState.PLAYING:\n        return _this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"playing\"));\n    }\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n};\n\n/**\n * The player's device.\n *\n *\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getDevice = function() {\n  return this.device;\n};\n\n/**\n * Indicates whether or not the player is seeking\n *\n * @param {Boolean} value\n *    The seeking flag\n * @returns {Boolean}\n *    The seeking flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getSeeking = function() {\n  return this.seeking;\n};\n\nApplicationStateProxy.prototype.setSeeking = function(value) {\n  if (value === this.seeking) {\n    return;\n  }\n  this.seeking = value;\n  if (this.seeking === false && this.playState === PlayState.PAUSED && this.getWaiting() === true) {\n    this.setWaiting(false);\n  }\n};\n\n/**\n * Indicates whether or not a seek has been requested.\n * This is only set when a seek is requested while\n * a previously requested seek is in progress\n *\n * @param {Boolean} value\n *    The seekrequested flag\n * @returns {Boolean}\n *    The seekrequested flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getSeekRequested = function() {\n  return this.seekrequested;\n};\n\nApplicationStateProxy.prototype.setSeekRequested = function(value) {\n  if (value === this.seekrequested) {\n    return;\n  }\n  this.seekrequested = value;\n};\n\n/**\n * Indicates whether or not the player is waiting\n *\n * @param {Boolean} value\n *    The waiting flag\n * @returns {Boolean}\n *    The waiting flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getWaiting = function() {\n  return this.waiting;\n};\n\nApplicationStateProxy.prototype.setWaiting = function(value) {\n  var handler, mediaElement, note,\n    _this = this;\n  if (value === this.waiting) {\n    return;\n  }\n  this.waiting = value;\n  note = this.waiting === true ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, PlayState.WAITING);\n  if (this.waiting === true) {\n    mediaElement = this.facade.getMediaElement();\n    handler = function(event) {\n      _this.facade.removeEventListener(\"playing\", handler);\n      _this.facade.removeEventListener(\"canplaythrough\", handler);\n      _this.facade.removeEventListener(\"ended\", handler);\n      _this.setWaiting(false);\n    };\n    this.facade.addEventListener(\"playing\", handler);\n    this.facade.addEventListener(\"canplaythrough\", handler);\n    this.facade.addEventListener(\"ended\", handler);\n  }\n};\n\n/**\n * Indicates whether or not the player is busy\n *\n * @param {Boolean} value\n *    The busy flag\n * @returns {Boolean}\n *    The busy flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getBusy = function() {\n  return this.busy;\n};\n\nApplicationStateProxy.prototype.setBusy = function(value) {\n  if (value === this.busy) {\n    return;\n  }\n  this.busy = value;\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"busy\", value));\n};\n\n/**\n * Indicates whether or not the player is locked.\n * A lock player will not autoplay even if configured\n * to do so.\n *\n * @param {Boolean} value\n *    The locked flag\n * @returns {Boolean}\n *    The locked flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getLocked = function() {\n  return this.locked;\n};\n\nApplicationStateProxy.prototype.setLocked = function(value) {\n  this.locked = value;\n};\n\n/**\n * Indicates whether or not the player is buffering.\n *\n * @param {Boolean} value\n *    The buffering flag\n * @returns {Boolean}\n *    The buffering flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getBuffering = function() {\n  return this.buffering;\n};\n\nApplicationStateProxy.prototype.setBuffering = function(value) {\n  this.buffering = value;\n};\n\n/**\n * Indicates whether or not the user is currently interacting with the player\n *\n * @param {Boolean} value\n *\n * @returns {Boolean}\n *\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getIsUserActive = function() {\n  return this.isUserActive;\n};\n\nApplicationStateProxy.prototype.setIsUserActive = function(value) {\n  if (value !== this.isUserActive) {\n    this.isUserActive = value;\n  }\n};\n\n/**\n * The core type used for rendering the video.\n *\n * @param {String} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getRenderMode = function() {\n  return this.renderMode;\n};\n\nApplicationStateProxy.prototype.setRenderMode = function(value) {\n  if (value !== this.renderMode) {\n    this.renderMode = value;\n  }\n};\n\n/**\n * The medium the player is currently playing. Valid options are:\n *\n * \"audio\"\n * \"video\"\n *\n * @param {String} value\n *    The new medium\n *\n * @returns {String}\n *    The current medium\n *\n * @type {String}\n*/\nApplicationStateProxy.prototype.getMedium = function() {\n  return this.medium;\n};\n\nApplicationStateProxy.prototype.setMedium = function(value) {\n  var previous;\n  if (value === this.medium) {\n    return;\n  }\n  previous = this.medium != null ? \"medium-\" + this.medium : this.medium;\n  this.medium = value;\n  this.sendNotification(Notifications.MEDIUM_CHANGE, {\n    previous: previous,\n    value: \"medium-\" + this.medium\n  });\n};\n\n/**\n * The player's volume as a value between 0 and 1.\n *\n * @param {Number} value\n *    The new volume\n *\n * @returns {Number}\n *    The current volume\n *\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getVolume = function() {\n  return this.volume;\n};\n\nApplicationStateProxy.prototype.setVolume = function(value) {\n  if (value === this.volume) {\n    return;\n  }\n  return this.volume = value;\n};\n\n/**\n * The playback target. i.e. \"amp\", \"chromecast\", \"airplay\"\n *\n * @param {Number} value\n *    The new volume\n *\n * @returns {Number}\n *    The current volume\n *\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getPlaybackTarget = function() {\n  return this.playbackTarget;\n};\n\nApplicationStateProxy.prototype.setPlaybackTarget = function(value) {\n  var previous;\n  if (value === this.playbackTarget) {\n    return;\n  }\n  previous = this.playbackTarget;\n  this.playbackTarget = value;\n  if (value !== \"amp\") {\n    if (this.getPlayState() !== PlayState.PAUSED) {\n      this.facade.pause();\n    }\n  } else {\n    if (this.getPlayState() === PlayState.PLAYING) {\n      this.facade.play();\n    }\n  }\n  this.sendNotification(Notifications.PLAYBACK_TARGET_CHANGE, {\n    previous: previous,\n    value: this.playbackTarget\n  });\n};\n\n/**\n * The active state of the player. Used to display controls.\n *\n * @param {Boolean} value\n *    The new active state of the video\n * @returns {Boolean}\n *    The active state of the video\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getActiveState = function() {\n  return this.activeState;\n};\n\nApplicationStateProxy.prototype.setActiveState = function(value) {\n  var previous;\n  if (value === this.activeState) {\n    return;\n  }\n  previous = this.activeState;\n  this.activeState = value;\n  this.sendNotification(Notifications.ACTIVE_STATE_CHANGE, {\n    previous: previous,\n    value: this.activeState\n  });\n};\n\n/**\n * The player's media element\n *\n * @param {HTMLElement} value\n *    The new media element\n * @returns {HTMLElement}\n *    The media element\n * @type {HTMLElement}\n*/\nApplicationStateProxy.prototype.getMediaElement = function() {\n  return this.mediaElement;\n};\n\nApplicationStateProxy.prototype.setMediaElement = function(value) {\n  var previous;\n  if (value === this.mediaElement) {\n    return;\n  }\n  previous = this.mediaElement;\n  this.mediaElement = value;\n  this.sendNotification(Notifications.MEDIA_ELEMENT_CHANGE, {\n    previous: previous,\n    value: this.mediaElement\n  });\n};\n\n/**\n * The player's hidden state\n *\n * @param {Boolean} value\n *    The new hidden state\n * @returns {Boolean}\n *    The hidden state\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nApplicationStateProxy.prototype.setHidden = function(value) {\n  var previous;\n  if (value === this.hidden) {\n    return;\n  }\n  previous = this.hidden;\n  this.hidden = value;\n  this.sendNotification(Notifications.HIDDEN_CHANGE, {\n    previous: previous,\n    value: this.hidden\n  });\n};\n\n/**\n * The media's current time\n *\n * @param {Number} value\n *    The new current time\n * @returns {Number}\n *    The current time\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getCurrentTime = function() {\n  return this.time.currentTime;\n};\n\nApplicationStateProxy.prototype.setCurrentTime = function(value) {\n  if (value === this.time.currentTime || value < 0) {\n    return;\n  }\n  this.time.currentTime = value;\n  this.sendNotification(Notifications.TIME_UPDATE, value);\n};\n\n/**\n * The media's duration\n *\n * @param {Number} value\n *    The new duration\n * @returns {Number}\n *    The duration\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getDuration = function() {\n  return this.time.duration;\n};\n\nApplicationStateProxy.prototype.setDuration = function(value) {\n  if (value === this.time.duration) {\n    return;\n  }\n  this.time.duration = value;\n  this.sendNotification(Notifications.DURATION_CHANGE, value);\n};\n\n/**\n * The playback rate\n *\n * @param {Number} value\n *     The new playback rate\n * @returns {Number}\n *     The playback rate\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getPlaybackRate = function() {\n  return this.playbackRate;\n};\n\nApplicationStateProxy.prototype.setPlaybackRate = function(value) {\n  if (value === this.playbackRate) {\n    return;\n  }\n  this.playbackRate = value;\n};\n\n/**\n * The ExternalMediaProxy class.\n *\n * @constructor\n * @private\n * @extends {MediaProxy}\n*/\nfunction ExternalMediaProxy() {\n  ExternalMediaProxy.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalMediaProxy, MediaProxy);\n\n\n/** @static\n*/\nExternalMediaProxy.NAME = \"MediaProxy\";\n\n/**\n * The source object of the video.\n*/\nExternalMediaProxy.prototype.setSource = function(value) {\n  if (!(value != null) || value.length < 1) {\n    return;\n  }\n  value = value.filter(function(item) {\n    return item.type === \"external\";\n  });\n  return ExternalMediaProxy.__super__.setSource.call(this, value);\n};\n\n/**\n * The ExternalPlaybackProxy class.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ExternalPlaybackProxy() {\n  ExternalPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalPlaybackProxy, puremvc.Proxy);\n\n\n/**\n * The name of the this Proxy.\n *\n * @static\n * @type {string}\n*/\nExternalPlaybackProxy.NAME = \"PlaybackProxy\";\n\n/** @private\n*/\nExternalPlaybackProxy.prototype.src = null;\n\n/**\n*/\nExternalPlaybackProxy.prototype.getPlaybackCoreName = function() {\n  return \"external\";\n};\n\n/**\n * Determines if the core can play a given mimeType.\n *\n * @return {String} \"\" if the core can't play the mimeType\n*/\nExternalPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  return mimeType === \"external\";\n};\n\n/**\n *\n*/\nExternalPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return true;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nExternalPlaybackProxy.prototype.getSrc = function() {\n  return this.facade.mediaProxy.getSrc();\n};\n\n/**\n * Instructs the core to play.\n*/\nExternalPlaybackProxy.prototype.play = function() {\n  window.open(this.getSrc(), \"_blank\");\n};\n\nExternalPlaybackProxy.prototype.load = function() {};\n\nExternalPlaybackProxy.prototype.setVolume = function() {};\n\nExternalPlaybackProxy.prototype.pause = function() {};\n\nExternalPlaybackProxy.prototype.setEnabled = function() {};\n\nExternalPlaybackProxy.prototype.getCurrentTime = function() {\n  return 0;\n};\n\nExternalPlaybackProxy.prototype.setCurrentTime = function(value) {};\n\nExternalPlaybackProxy.prototype.getDuration = function() {\n  return 0;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar UserNotifications = {\n  TOGGLE_PLAY_PAUSE: \"usertogglePlayPause\",\n  PLAY: \"userplay\",\n  PAUSE: \"userpause\",\n  SEEK: \"userseek\",\n  SEEKED: \"userseeked\",\n  GO_LIVE: \"usergolive\"\n};\n\n/**\n * The PluginProxy class.\n *\n * @param {Object} config\n * @constructor\n * @private\n * @extends {DataBoundConfigurationProxy}\n*/\nfunction PluginProxy(config) {\n  PluginProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(PluginProxy, DataBoundConfigurationProxy);\n\n\n/** @static\n*/\nPluginProxy.NAME = ModuleProxy.NAME;\n\nPluginProxy.prototype.enabled = true;\n\nPluginProxy.prototype.plugin = null;\n\nPluginProxy.prototype.appState = null;\n\n/**\n*/\nPluginProxy.prototype.getDefaults = function() {\n  var defaults;\n  defaults = PluginProxy.__super__.getDefaults.call(this);\n  if (!(defaults.debug != null)) {\n    defaults.debug = null;\n  }\n  return defaults;\n};\n\n/** @override\n*/\nPluginProxy.prototype.initializeNotifier = function(key) {\n  PluginProxy.__super__.initializeNotifier.call(this, key);\n  this.appState = this.facade.player.appState;\n};\n\n/**\n*/\nPluginProxy.prototype.getMediaElement = function() {\n  return this.facade.player.getMediaElement();\n};\n\n/**\n*/\nPluginProxy.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  return value;\n};\n\nPluginProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\n/**\n*/\nPluginProxy.prototype.getDebug = function() {\n  if (this.value.debug != null) {\n    return this.value.debug;\n  } else {\n    return this.facade.player.getConfig().debug === true;\n  }\n};\n\n/**\n*/\nPluginProxy.prototype.createPlugin = function() {};\n\n/**\n*/\nPluginProxy.prototype.initialize = function() {\n  this.plugin = this.createPlugin();\n};\n\n/**\n*/\nPluginProxy.prototype.error = function(err) {\n  this.facade.logger.error(\"[AMP \" + (this.facade.getModuleName().toUpperCase()) + \" Error]\", err);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar Namespace = {\n  PREFIX: \"akamai-\"\n};\n\n/**\n * The Plugin class. Acts as a base for plugins.\n *\n * @constructor\n * @private\n * @extends {Module}\n*/\nfunction Plugin() {\n  Plugin.__super__.constructor.call(this);\n}\n\n\n__extends(Plugin, Module);\n\n\nPlugin.prototype.player = null;\n\nPlugin.prototype.proxy = null;\n\n/**\n * @override\n*/\nPlugin.prototype.initialize = function(config, player) {\n  this.player = player;\n  this.logger = this.player.logger;\n  Plugin.__super__.initialize.call(this, config, player);\n};\n\n/**\n*/\nPlugin.prototype.isAvailable = function() {\n  return true;\n};\n\n/**\n*/\nPlugin.prototype.loadModuleResources = function() {\n  if (!this.isAvailable()) {\n    return Promise.resolve();\n  }\n  return Plugin.__super__.loadModuleResources.call(this);\n};\n\n/**\n * @override\n*/\nPlugin.prototype.resourcesLoaded = function() {\n  if (typeof this.oninitialized === \"function\") {\n    this.oninitialized(this);\n  }\n};\n\n/** @override\n*/\nPlugin.prototype.onRegister = function() {\n  var _ref;\n  if (this.isAvailable()) {\n    this.createFramework();\n    if ((_ref = this.retrieveProxy(PluginProxy.NAME)) != null) {\n      if (typeof _ref.initialize === \"function\") {\n        _ref.initialize();\n      }\n    }\n  }\n  this.performance.ready = Date.now();\n  this.sendNotification(PluginNotifications.PLUGIN_REGISTERED, this);\n};\n\n/** @override\n*/\nPlugin.prototype.logEvent = function(event) {\n  var prefix;\n  if (/(timeupdate|timeremaining)/.test(event.type) === true) {\n    return;\n  }\n  prefix = this.player.getModuleName().toUpperCase() + \" \" + this.getModuleName().toUpperCase();\n  if (event.dispatcher != null) {\n    prefix += \" \" + event.dispatcher;\n  }\n  this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n};\n\n/** @override\n*/\nPlugin.prototype.listNotificationPublications = function() {\n  var key, notes, value;\n  notes = [Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.IS_USER_ACTIVE, Notifications.PLAYBACK_CORE_CHANGE];\n  return notes.concat((function() {\n    var _results;\n    _results = [];\n    for (key in PluginNotifications) {\n      value = PluginNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * The ChangePlayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangePlayStateCommand() {\n  ChangePlayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangePlayStateCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangePlayStateCommand.prototype.execute = function(notification) {\n  this.applicationState.setPlayState(notification.getBody());\n};\n\n/**\n * The ChangeMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeMediaCommand() {\n  ChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeMediaCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeMediaCommand.prototype.execute = function(notification) {\n  var media;\n  try {\n    media = this.media.setData(notification.getBody());\n  } catch (error) {\n    this.sendNotification(Notifications.ERROR, error.message);\n    return;\n  }\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n  media = this.media.getData();\n  this.security.setMedia(media);\n  if (this.security.getAuthorized()) {\n    this.sendNotification(SecurityNotifications.AUTHORIZED, this.security.getAuthorization());\n  } else {\n    this.sendNotification(SecurityNotifications.AUTHORIZE, {\n      media: media\n    });\n  }\n};\n\n/**\n * The SetMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction SetMediaCommand() {\n  SetMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SetMediaCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSetMediaCommand.prototype.execute = function(notification) {\n  var media, _ref,\n    _this = this;\n  media = notification.getBody();\n  this.applicationState.setBuffering(false);\n  this.applicationState.setEnded(false);\n  this.playback.setEnabled(false);\n  this.playback.pause();\n  if ((_ref = this.tracks) != null) {\n    _ref.clear();\n  }\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  media = this.media.transform(media);\n  this.facade.transform(TransformType.MEDIA, media).then(function(result) {\n    return _this.sendNotification(Notifications.CHANGE_MEDIA, result);\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n};\n\n/**\n * The MediaChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction MediaChangeCommand() {\n  MediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaChangeCommand.prototype.execute = function(notification) {\n  var media, playback;\n  media = notification.getBody();\n  this.playerCore.setPlaybackCore(media);\n  playback = this.playerCore.getActivePlaybackCore() || this.player.playback;\n  playback.reset();\n  playback.setCurrentTime(media.startTime || 0);\n  MediaChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeDurationCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeDurationCommand() {\n  ChangeDurationCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeDurationCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeDurationCommand.prototype.execute = function(notification) {\n  var duration;\n  duration = notification.getBody();\n  if (this.media.getDuration() === duration) {\n    return;\n  }\n  this.media.setDuration(duration);\n};\n\n/**\n * The ErrorCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction ErrorCommand() {\n  ErrorCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ErrorCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nErrorCommand.prototype.execute = function(notification) {\n  var core, error;\n  this.playback.destroy();\n  core = this.playback.getMediaElement();\n  EventHandler.clear(core);\n  error = notification.getBody();\n  this.logger.error(\"[AMP ERROR]\", error);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ERROR);\n  this.facade.error = error;\n  ErrorCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ReadyCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ReadyCommand() {\n  ReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ReadyCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nReadyCommand.prototype.execute = function(notification) {\n  var volume, _ref,\n    _this = this;\n  volume = (_ref = this.facade.config) != null ? _ref.volume : void 0;\n  if (volume != null) {\n    this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n  }\n  this.playerCore.ready();\n  if (this.facade.config.autoplay === true) {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoplay\");\n  }\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  this.facade.performance.ready = Date.now();\n  Utilization.track(\"ready\", this.facade.performance.ready - this.facade.performance.init);\n  this.dispatchEventAfterCommand(notification).then(function() {\n    var media, _ref1;\n    media = (_ref1 = _this.facade.config) != null ? _ref1.media : void 0;\n    if (media != null) {\n      return _this.sendNotification(Notifications.SET_MEDIA, media);\n    }\n  });\n};\n\n/**\n * The UpdateDataBindingsCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction UpdateDataBindingsCommand() {\n  UpdateDataBindingsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(UpdateDataBindingsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nUpdateDataBindingsCommand.prototype.execute = function(notification) {\n  var body;\n  body = notification.getBody() || {};\n  this.bindings.compile(body.contexts, body.suppressErrors);\n};\n\n/**\n * The ChangeParamsCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeParamsCommand() {\n  ChangeParamsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeParamsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeParamsCommand.prototype.execute = function(notification) {\n  this.params.setData(notification.getBody());\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n    suppressErrors: true\n  });\n};\n\n/**\n * The OverlayLayerMediator class.\n *\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction OverlayLayerMediator() {\n  OverlayLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(OverlayLayerMediator, LayerMediator);\n\n\nOverlayLayerMediator.prototype.componentName = \"overlays\";\n\nOverlayLayerMediator.NAME = \"OverlayLayerMediator\";\n\n/**\n*/\nOverlayLayerMediator.prototype.createMediatorName = function() {\n  return OverlayLayerMediator.NAME;\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n *\n * @override\n*/\nOverlayLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY];\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n *\n * @param note An INotification\n * @override\n*/\nOverlayLayerMediator.prototype.handleNotification = function(notification) {\n  var name, overlay;\n  name = notification.getName();\n  overlay = notification.getBody();\n  switch (name) {\n    case Notifications.ADD_OVERLAY:\n      this.viewComponent.appendChild(overlay);\n      break;\n    case Notifications.REMOVE_OVERLAY:\n      this.viewComponent.removeChild(overlay);\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction PluginAdapter() {\n  this.plugins = [];\n  this.registered = 0;\n  PluginAdapter.__super__.constructor.call(this, this.constructor.NAME, {});\n}\n\n\n__extends(PluginAdapter, puremvc.Mediator);\n\n\nPluginAdapter.NAME = \"PluginAdapter\";\n\nPluginAdapter.prototype.plugins = null;\n\nPluginAdapter.prototype.registered = null;\n\n/**\n * Registers the appropriate pipes and listeners when\n * this class is registered\n *\n * @override\n*/\nPluginAdapter.prototype.onRegister = function() {\n  return PluginAdapter.__super__.onRegister.call(this);\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n *\n * @override\n*/\nPluginAdapter.prototype.listNotificationInterests = function() {\n  return [PluginNotifications.REGISTER_PLUGINS, PluginNotifications.PLUGIN_REGISTERED];\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n *\n * @param note An INotification\n * @override\n*/\nPluginAdapter.prototype.handleNotification = function(notification) {\n  var body, config, def, init, initialize, key, name, plugin, plugins, type, value, _ref,\n    _this = this;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case PluginNotifications.REGISTER_PLUGINS:\n      type = this.facade.getPlayerType();\n      config = body;\n      _ref = AMP.plugins;\n      for (key in _ref) {\n        value = _ref[key];\n        if (!(key in config)) {\n          continue;\n        }\n        init = config[key];\n        if (!(init != null) || init.enabled === false) {\n          continue;\n        }\n        def = value[type];\n        if (!(def != null)) {\n          this.facade.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n          continue;\n        }\n        try {\n          plugin = new def();\n          plugin.oninitialized = this.onplugininitialized.bind(this, key);\n          plugin.onerror = this.onpluginerror.bind(this, key);\n          initialize = plugin.initialize.bind(plugin, init, this.facade);\n          this.plugins.push(initialize);\n        } catch (error) {\n          this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n          continue;\n        }\n      }\n      plugins = config.plugins || {};\n      for (key in plugins) {\n        init = plugins[key];\n        if (!((init != null) && init.enabled !== false)) {\n          continue;\n        }\n        initialize = function(player, config, key, resolve, reject) {\n          return _this.facade.loadResources(config.resources).then(function() {\n            def = AMP.plugins[key][type];\n            if (!(def != null)) {\n              reject(\"[AMP] Plugin could not be found: \" + key);\n            }\n            return def(player, config, key);\n          }).then(resolve)[\"catch\"](reject);\n        };\n        this.plugins.push(initialize.bind(null, this.facade, init, key, this.onpluginregistered.bind(this, key), this.onpluginerror.bind(this, key)));\n      }\n      this.plugins.forEach(function(item) {\n        return item();\n      });\n      break;\n    case PluginNotifications.PLUGIN_REGISTERED:\n      this.onpluginregistered(body.getModuleName(), body);\n  }\n};\n\nPluginAdapter.prototype.initializedCheck = function() {\n  if (this.registered === this.plugins.length) {\n    this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, this.plugins);\n  }\n};\n\nPluginAdapter.prototype.onplugininitialized = function(key, plugin) {\n  plugin.oninitialized = null;\n  plugin.onerror = null;\n  this.facade.registerModule(plugin);\n};\n\nPluginAdapter.prototype.onpluginerror = function(key, error) {\n  this.registered++;\n  this.facade.logger.error(\"[AMP] Plugin could not be registered: \" + key);\n  this.facade.logger.error(error);\n  this.initializedCheck();\n};\n\nPluginAdapter.prototype.onpluginregistered = function(key, plugin) {\n  var feature;\n  this.registered++;\n  this.facade.logger.debug(\"[AMP] Plugin registered: \" + key);\n  this.facade[key] = plugin;\n  feature = (typeof plugin.getFeatureName === \"function\" ? plugin.getFeatureName() : void 0) || plugin.feature;\n  if (feature != null) {\n    this.facade[feature] = plugin;\n  }\n  this.initializedCheck();\n};\n\n/**\n * The ClassList class.\n *\n * @param {!DOMElement}  element\n *    The DOM Element\n *\n * @constructor\n*/\nfunction ClassList(element) {\n  this.element = element;\n}\n\nClassList.prototype.element = null;\n\nClassList.prototype.prefix = Namespace.PREFIX;\n\n/**\n*/\nClassList.prototype.contains = function(className) {\n  return this.constructor.contains(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.add = function(className) {\n  this.constructor.add(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.remove = function(className) {\n  this.constructor.remove(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.toggle = function(className) {\n  return this.constructor.contains(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.contains = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.contains : void 0) != null) {\n    return element.classList.contains(css);\n  } else {\n    return element.className.indexOf(css) !== -1;\n  }\n};\n\n/**\n*/\nClassList.add = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.add : void 0) != null) {\n    element.classList.add(css);\n  } else {\n    if (!this.contains(className, element)) {\n      if (element.className !== \"\") {\n        element.className += \" \" + css;\n      } else {\n        element.className = css;\n      }\n    }\n  }\n};\n\n/**\n*/\nClassList.remove = function(className, element, prefix) {\n  var css, regexp, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.remove : void 0) != null) {\n    element.classList.remove(css);\n  } else {\n    if (this.contains(className, element)) {\n      regexp = new RegExp(\" ?\" + css);\n      element.className = element.className.replace(regexp, \"\");\n    }\n  }\n};\n\n/**\n*/\nClassList.toggle = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.toggle : void 0) != null) {\n    element.classList.toggle(this.prefix + className);\n  } else {\n    if (this.contains(className, element)) {\n      this.remome(className, element);\n    } else {\n      this.add(className, element);\n    }\n  }\n};\n\n/**\n * The LocalizationProxy class. Used to track player localization settings.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n * @param {Object}  init  The configuration object.\n*/\nfunction LocalizationProxy(init) {\n  var key, lang;\n  LocalizationProxy.__super__.constructor.call(this);\n  this.data = {\n    language: navigator.language || navigator.browserLanguage,\n    locales: Config.defaults.locales\n  };\n  if (init != null) {\n    if (init.language != null) {\n      this.data.language = init.language;\n    }\n    if (init.locales != null) {\n      for (lang in init.locales) {\n        if (this.data.locales[lang] != null) {\n          for (key in init.locales[lang]) {\n            this.data.locales[lang][key] = init.locales[lang][key];\n          }\n        } else {\n          this.data.locales[lang] = init.locales[lang];\n        }\n      }\n    }\n  }\n}\n\n\n__extends(LocalizationProxy, DataBindingContext);\n\n\n/** @static\n*/\nLocalizationProxy.NAME = \"LocalizationProxy\";\n\nLocalizationProxy.prototype.contextName = \"l10n\";\n\nLocalizationProxy.prototype.locale = null;\n\nLocalizationProxy.prototype.localeId = null;\n\n/** @override\n*/\nLocalizationProxy.prototype.onRegister = function() {\n  LocalizationProxy.__super__.onRegister.call(this);\n  this.setLocale(this.data.language);\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nLocalizationProxy.prototype.getContextData = function() {\n  return this.locale;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getLanguage = function() {\n  return this.data.language;\n};\n\nLocalizationProxy.prototype.setLanguage = function(value) {\n  var _this = this;\n  this.setLocale(value).then(function() {\n    _this.data.language = value;\n    _this.sendNotification(Notifications.LANGUAGE_CHANGE, value);\n  });\n  return value;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.setLocale = function(value) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var complete, locale, localeId;\n    complete = function() {\n      _this.localeId = localeId;\n      _this.locale = _this.facade.l10n = _this.data.locales[localeId];\n      resolve();\n    };\n    localeId = value;\n    locale = _this.data.locales[localeId];\n    if (!(locale != null)) {\n      localeId = value.substring(0, 2);\n      locale = _this.data.locales[localeId];\n    }\n    if (typeof locale === \"string\") {\n      return AMP.addResource({\n        src: _this.facade.evaluatePaths(locale),\n        type: Utils.mimeTypes.json\n      }).then(function(resource) {\n        _this.data.locales[localeId] = resource.data;\n        return complete();\n      });\n    } else {\n      return complete();\n    }\n  });\n};\n\nLocalizationProxy.prototype.getLocaleId = function() {\n  return this.localeId;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getLocales = function() {\n  return this.data.locales;\n};\n\nLocalizationProxy.prototype.setLocales = function(value) {\n  this.data.locales = value;\n  return value;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getString = function(key, context) {\n  var locale, str;\n  try {\n    locale = this.locale || this.data.locales.en;\n    str = locale[key] || key;\n    if (context != null) {\n      str = DataBinding.evaluateBindings(str, context);\n    }\n    return str;\n  } catch (error) {\n    return \"\";\n  }\n};\n\n/**\n * Retrieves the full language name in the player's current language setting.\n *\n * @param   {string}  lang  The language code.\n * @return  {string}        The full name of the language according to the player's current language setting.\n*/\nLocalizationProxy.prototype.getLanguageString = function(lang) {\n  var key, str;\n  if (typeof lang !== \"string\" || !(lang != null) || lang === \"\") {\n    return \"\";\n  }\n  key = \"MSG_\" + (lang.toUpperCase());\n  str = this.getString(key);\n  if (str === \"\") {\n    lang = lang.split(\"-\").shift();\n    key = \"MSG_\" + (lang.toUpperCase());\n    str = this.getString(key);\n  }\n  return str;\n};\n\nfunction UI() {}\n\n/**\n * Creates an HTML element.\n *\n * @param   {?(string|Array.<string>)}  type\n * @param   {?DOMElement}  parent\n * @param   {?string|DOMElement}  element\n * @param   {?string} text\n * @return  {DOMElement}\n*/\nUI.create = function(type, parent, element, text) {\n  var classList, item, viewComponent, _i, _len;\n  if (element == null) {\n    element = \"div\";\n  }\n  if (typeof element === \"string\") {\n    element = document.createElement(element);\n  }\n  classList = new ClassList(element);\n  if (type != null) {\n    if (typeof type === \"string\") {\n      type = [type];\n    }\n    for (_i = 0, _len = type.length; _i < _len; _i++) {\n      item = type[_i];\n      classList.add(item);\n    }\n  }\n  element._classList = classList;\n  if (text != null) {\n    if (element.innerText != null) {\n      element.innerText = text;\n    } else {\n      element.textContent = text;\n    }\n  }\n  if (parent != null) {\n    if (parent.getViewComponent != null) {\n      viewComponent = parent.getViewComponent();\n    }\n    if (viewComponent != null) {\n      parent = viewComponent;\n    }\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n * Binds a mediators event handlers to an element.\n *\n * @param {!DOMElement} element\n * @param {!mediator} mediator\n*/\nUI.bindEvents = function(element, handlers, exceptions) {\n  var key, value;\n  if (exceptions == null) {\n    exceptions = [\"onRemove\", \"onRegister\"];\n  }\n  for (key in handlers) {\n    value = handlers[key];\n    if (!(__indexOf.call(exceptions, key) >= 0) && /^on/.test(key) && ((value != null ? value.bind : void 0) != null)) {\n      element[key] = value.bind(handlers);\n    }\n  }\n};\n\n/**\n * The ExternalPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction ExternalPlayCommand() {\n  ExternalPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalPlayCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nExternalPlayCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  this.playback.play();\n  ExternalPlayCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ExternalPlayer class.\n *\n * @constructor\n * @private\n * @extends {Player}\n * @param {Object} config\n * @param {Object} viewComponent\n * @param {EventDispatcher} dispatcher\n*/\nfunction ExternalPlayer(config, viewComponent, dispatcher) {\n  ExternalPlayer.__super__.constructor.call(this, config, viewComponent, dispatcher);\n}\n\n\n__extends(ExternalPlayer, Player);\n\n\nExternalPlayer.prototype.playerType = \"external\";\n\n/** @override\n*/\nExternalPlayer.prototype.createModel = function() {\n  var playbackProxy;\n  ExternalPlayer.__super__.createModel.call(this);\n  this.registerProxy(new LocalizationProxy(this.config));\n  playbackProxy = new ExternalPlaybackProxy();\n  this.registerProxy(playbackProxy);\n  this.playerCore = new PlayerProxy(playbackProxy);\n  this.registerProxy(this.playerCore);\n  this.bindings.initialize();\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createView = function() {\n  var overlay,\n    _this = this;\n  this.registerMediator(new PlayerMediator(\"external\", this.getViewComponent()));\n  this.registerMediator(new PluginAdapter());\n  overlay = new OverlayLayerMediator();\n  this.registerMediator(overlay);\n  EventHandler.create(overlay.viewComponent, EventHandler.CLICK, function() {\n    return _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n  });\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createController = function() {\n  ExternalPlayer.__super__.createController.call(this);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ExternalPlayCommand);\n  this.registerCommand(Notifications.PLAY, ExternalPlayCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n  this.registerCommand(Notifications.ERROR, ErrorCommand);\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n  this.registerCommand(Notifications.READY, ReadyCommand);\n  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createMediaElement = function() {\n  return document.createElement(\"div\");\n};\n\nExternalPlayer.prototype.canPlayType = function(mimeType) {\n  return \"maybe\";\n};\n\nExternalPlayer.prototype.play = function() {\n  this.sendNotification(Notifications.PLAY);\n};\n\nExternalPlayer.prototype.setParams = function(value) {\n  this.sendNotification(Notifications.CHANGE_PARAMS, value);\n  return value;\n};\n\nExternalPlayer.prototype.getParams = function() {\n  return this.retrieveProxy(ParamsProxy.NAME).getData();\n};\n\nExternalPlayer.prototype.setAutoplay = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getAutoplay = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setLoop = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getLoop = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setMuted = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getMuted = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setMedia = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, value);\n  return value;\n};\n\nExternalPlayer.prototype.getMedia = function(value) {\n  var _ref;\n  return (_ref = this.retrieveProxy(MediaProxy.NAME)) != null ? _ref.getData() : void 0;\n};\n\nExternalPlayer.prototype.setCurrentTime = function(value) {\n  return 0;\n};\n\nExternalPlayer.prototype.getCurrentTime = function(value) {\n  return 0;\n};\n\nExternalPlayer.prototype.getDuration = function(value) {\n  return this.retrieveProxy(MediaProxy.NAME).getDuration();\n};\n\nExternalPlayer.prototype.setSrc = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    src: value\n  });\n  return value;\n};\n\nExternalPlayer.prototype.getSrc = function(value) {\n  return this.retrieveProxy(MediaProxy.NAME).getSrc();\n};\n\nExternalPlayer.prototype.setSource = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    source: value\n  });\n  return value;\n};\n\nExternalPlayer.prototype.getSource = function() {\n  return this.retrieveProxy(MediaProxy.NAME).getSource();\n};\n\nExternalPlayer.prototype.setVolume = function(value) {\n  return value;\n};\n\nExternalPlayer.prototype.getVolume = function(value) {\n  return 1;\n};\n\nExternalPlayer.prototype.getSeeking = function() {\n  return false;\n};\n\nExternalPlayer.prototype.getPaused = function() {\n  return false;\n};\n\nExternalPlayer.prototype.getEnded = function() {\n  return false;\n};\n\n/**\n * Event constructor.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {Object=} detail  Data to pass along with the event.\n * @constructor\n * @private\n*/\nfunction Event(type, detail) {\n  this.type = type;\n  if (detail != null) {\n    this.detail = this.data = detail;\n  }\n}\n\n/**\n * The event's type.\n *\n * @type {string}\n*/\nEvent.prototype.type = null;\n\n/**\n * The event's target\n *\n * @type {Object}\n*/\nEvent.prototype.target = null;\n\n/**\n * Collection of event specific details.\n *\n * @type {Object}\n*/\nEvent.prototype.detail = null;\n\nfunction Logger(enabled) {\n  this.enabled = enabled;\n  if (!this.enabled) {\n    this.log = this.trace = this.debug = this.info = this.warn = this.error = this.fatal = function() {};\n  }\n}\n\nLogger.prototype.log = function() {\n  try {\n    if (arguments.length > 1 && (arguments[1] != null)) {\n      console.log.apply(console, arguments);\n    } else {\n      console.log(arguments[0]);\n    }\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.trace = function() {\n  try {\n    console.trace.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.debug = function() {\n  try {\n    console.log.apply(console, arguments);\n  } catch (error) {\n    this.log.apply(this, arguments);\n  }\n};\n\nLogger.prototype.info = function() {\n  try {\n    console.info.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.warn = function() {\n  try {\n    console.warn.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.error = function() {\n  try {\n    console.error.apply(console, arguments);\n  } catch (error) {\n    this.log.apply(this, arguments);\n  }\n};\n\nLogger.prototype.fatal = function() {\n  try {\n    console.fatal.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\n/**\n * Poller class\n *\n * @constructor\n * @private\n * @extends {EventDispatcher}\n * @param {string} url\n * @param {number} interval\n * @param {string} type\n * @param {Object} headers\n*/\nfunction Poller(url, interval, type, headers) {\n  this.url = url;\n  this.interval = interval != null ? interval : 10000;\n  this.type = type != null ? type : null;\n  this.headers = headers != null ? headers : null;\n  Poller.__super__.constructor.call(this);\n}\n\n\n__extends(Poller, EventDispatcher);\n\n\nPoller.prototype.timeout = null;\n\nPoller.prototype.interval = null;\n\nPoller.prototype.url = null;\n\nPoller.prototype.lastModified = null;\n\nPoller.prototype.contentLenght = null;\n\nPoller.prototype.data = null;\n\nPoller.prototype.text = null;\n\nPoller.prototype.type = null;\n\nPoller.prototype.headers = null;\n\nPoller.prototype.useHeadRequest = true;\n\nPoller.prototype.xhr = null;\n\n/**\n*/\nPoller.prototype.start = function() {\n  if ((this.url != null) && this.url !== \"\") {\n    this.poll();\n  }\n};\n\n/**\n*/\nPoller.prototype.poll = function() {\n  var xhr,\n    _this = this;\n  xhr = Utils.getXHR();\n  if (!this.useHeadRequest) {\n    this.updateData();\n  } else {\n    xhr.onload = function(event) {\n      var contentLength, lastModified;\n      if (xhr.status === 304) {\n        _this.invoke();\n        return;\n      }\n      lastModified = xhr.getResponseHeader(\"Last-Modified\");\n      contentLength = xhr.getResponseHeader(\"Content-Length\");\n      if ((!(lastModified != null) && !(contentLength != null)) || ((lastModified != null) && lastModified !== _this.lastModified) || ((contentLength != null) && contentLength !== _this.contentLength)) {\n        _this.lastModified = lastModified;\n        _this.contentLength = contentLength;\n        _this.updateData();\n      } else {\n        _this.invoke();\n      }\n    };\n    xhr.onerror = function(event) {\n      _this.error(event);\n    };\n    xhr.open(\"HEAD\", Utils.cacheBust(this.url), false);\n    this.applyHeaders();\n    if (this.lastModified != null) {\n      xhr.setRequestHeader(\"If-Modified-Since\", this.lastModified);\n    }\n    xhr.send();\n  }\n};\n\n/**\n*/\nPoller.prototype.applyHeaders = function() {\n  if (!(this.headers != null)) {\n    return;\n  }\n  this.xhr.setRequestHeaders(this.headers);\n};\n\n/**\n*/\nPoller.prototype.updateData = function() {\n  var xhr,\n    _this = this;\n  xhr = Utils.getXHR();\n  xhr.open(\"GET\", Utils.cacheBust(this.url), true);\n  xhr.onload = function(event) {\n    var text;\n    text = xhr.responseText;\n    _this.setText(text);\n    _this.invoke();\n  };\n  xhr.onerror = function(event) {\n    _this.error(event);\n  };\n  this.applyHeaders();\n  return xhr.send();\n};\n\n/**\n*/\nPoller.prototype.setText = function(value) {\n  var data;\n  if (value !== this.text) {\n    this.text = value;\n    data = this.text;\n    if (this.type === Utils.mimeTypes.json) {\n      try {\n        data = this.xhr.response;\n      } catch (error) {\n        data = this.text;\n      }\n    }\n    this.setData(data);\n  }\n  return value;\n};\n\n/**\n*/\nPoller.prototype.setData = function(value) {\n  if (value !== this.data) {\n    this.data = value;\n    this.dispatchEvent(new Event(\"datachange\", this.data));\n  }\n  return value;\n};\n\n/**\n*/\nPoller.prototype.error = function(error) {\n  Logger.error(event);\n  this.stop();\n};\n\n/**\n*/\nPoller.prototype.invoke = function() {\n  var _this = this;\n  this.stop();\n  this.timeout = setTimeout(function() {\n    _this.poll();\n  }, this.interval);\n};\n\n/**\n*/\nPoller.prototype.stop = function() {\n  clearTimeout(this.timeout);\n};\n\nfunction IdleUtil(element, timeout) {\n  this.element = element;\n  this.timeout = timeout;\n  IdleUtil.__super__.constructor.call(this);\n  this.resetHandler = this.reset.bind(this);\n}\n\n\n__extends(IdleUtil, EventDispatcher);\n\n\nIdleUtil.prototype.events = [\"mousemove\", \"mousedown\", \"keypress\", \"DOMMouseScroll\", \"mousewheel\", \"touchmove\", \"MSPointerMove\"];\n\nIdleUtil.prototype.resetHandler = null;\n\nIdleUtil.prototype.element = null;\n\nIdleUtil.prototype.timeout = null;\n\nIdleUtil.prototype.active = true;\n\nIdleUtil.prototype.timeoutId = null;\n\nIdleUtil.prototype.applyListeners = function(action) {\n  var event, _i, _len, _ref;\n  if (action == null) {\n    action = \"add\";\n  }\n  _ref = this.events;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    event = _ref[_i];\n    this.element[\"\" + action + \"EventListener\"](event, this.resetHandler);\n  }\n};\n\nIdleUtil.prototype.start = function(timeout) {\n  if (timeout != null) {\n    this.timeout = timeout;\n  }\n  this.stop();\n  this.applyListeners(\"add\");\n  this.timeoutId = setTimeout(this.setActive.bind(this, false), this.timeout);\n};\n\nIdleUtil.prototype.stop = function() {\n  this.applyListeners(\"remove\");\n  clearTimeout(this.timeoutId);\n};\n\nIdleUtil.prototype.reset = function() {\n  this.setActive(true);\n  this.start();\n};\n\nIdleUtil.prototype.setActive = function(value) {\n  if (value === this.active) {\n    return;\n  }\n  this.active = value;\n  this.dispatchEvent(new Event(\"activechange\", {\n    active: this.active\n  }));\n  return value;\n};\n\nIdleUtil.prototype.getActive = function() {\n  return this.active;\n};\n\nfunction FeedVO() {\n  this.item = [];\n  this.metadata = {};\n}\n\nFeedVO.prototype.title = null;\n\nFeedVO.prototype.link = null;\n\nFeedVO.prototype.description = null;\n\nFeedVO.prototype.category = null;\n\nFeedVO.prototype.pubDate = null;\n\nFeedVO.prototype.language = null;\n\nFeedVO.prototype.ttl = null;\n\nFeedVO.prototype.item = null;\n\nFeedVO.prototype.metadata = null;\n\nfunction Resource() {\n  this.metadata = {};\n}\n\n/**\n * The resource url.\n *\n * @type {String}\n*/\nResource.prototype.src = null;\n\n/**\n * The resource url to use in debug mode.\n *\n * @type {String}\n*/\nResource.prototype.debug = null;\n\n/**\n * The mime type.\n *\n * @type {String}\n*/\nResource.prototype.type = null;\n\n/**\n * @type {Object}\n*/\nResource.prototype.metadata = null;\n\n/**\n * @enum {string}\n * @const\n*/\n\nvar PlaybackMode = {\n  /**\n   *\n  */\n\n  AUTO: \"auto\",\n  /**\n   *\n  */\n\n  HTML: \"html\",\n  /**\n   *\n  */\n\n  FLASH: \"flash\",\n  /**\n   *\n  */\n\n  EXTERNAL: \"external\",\n  /**\n   *\n  */\n\n  NONE: \"none\",\n  /**\n   *\n  */\n\n  HTML_AUTO: \"html-auto\"\n};\n\nfunction MediaVO() {\n  return MediaVO.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(MediaVO, Resource);\n\n\nMediaVO.prototype.source = null;\n\nMediaVO.prototype.title = null;\n\nMediaVO.prototype.description = null;\n\nMediaVO.prototype.link = null;\n\nMediaVO.prototype.guid = null;\n\nMediaVO.prototype.pubDate = null;\n\nMediaVO.prototype.poster = null;\n\nMediaVO.prototype.thumbnail = null;\n\nMediaVO.prototype.embed = null;\n\nMediaVO.prototype.category = null;\n\nMediaVO.prototype.type = null;\n\nMediaVO.prototype.medium = null;\n\nMediaVO.prototype.duration = null;\n\nMediaVO.prototype.track = null;\n\nMediaVO.prototype.metadata = null;\n\nMediaVO.prototype.scenes = null;\n\nMediaVO.prototype.startTime = null;\n\nfunction ID3() {}\n\n/**\n*/\nID3.getID3 = function(id3Data) {\n  var frame, frameData, offset;\n  offset = 10;\n  frameData = this.getFrameData(id3Data.subarray(offset));\n  frame = this.decodeFrame(frameData);\n  return frame;\n};\n\n/**\n*/\nID3.getFrameData = function(data) {\n  var offset, size, type;\n  type = String.fromCharCode(data[0], data[1], data[2], data[3]);\n  size = this.readSize(data, 4);\n  offset = 10;\n  return {\n    type: type,\n    size: size,\n    data: data.subarray(offset, offset + size)\n  };\n};\n\n/**\n*/\nID3.readSize = function(data, offset) {\n  var size;\n  size = 0;\n  size = (data[offset] & 0x7f) << 21;\n  size |= (data[offset + 1] & 0x7f) << 14;\n  size |= (data[offset + 2] & 0x7f) << 7;\n  size |= data[offset + 3] & 0x7f;\n  return size;\n};\n\n/**\n*/\nID3.decodeFrame = function(frame) {\n  if (frame.type === 'PRIV') {\n    return this.decodePrivFrame(frame);\n  } else if (frame.type[0] === 'T') {\n    return this.decodeTextFrame(frame);\n  } else if (frame.type[0] === 'W') {\n    return this.decodeURLFrame(frame);\n  } else {\n    return this.decodeTextFrame(frame);\n  }\n};\n\n/**\n*/\nID3.decodePrivFrame = function(frame) {\n  var owner, privateData;\n  if (frame.size < 2) {\n    return;\n  }\n  owner = this.utf8ArrayToStr(frame.data, true);\n  privateData = new Uint8Array(frame.data.subarray(owner.length + 1));\n  return {\n    key: frame.type,\n    info: owner,\n    data: privateData.buffer\n  };\n};\n\n/**\n*/\nID3.decodeTextFrame = function(frame) {\n  var description, index, text, value;\n  if (frame.size < 2) {\n    return;\n  }\n  if (frame.type === 'TXXX') {\n    index = 1;\n    description = this.utf8ArrayToStr(frame.data.subarray(index));\n    index += description.length + 1;\n    value = this.utf8ArrayToStr(frame.data.subarray(index));\n    return {\n      key: frame.type,\n      info: description,\n      data: value\n    };\n  } else {\n    text = this.utf8ArrayToStr(frame.data.subarray(1));\n    return {\n      key: frame.type,\n      info: text,\n      data: text\n    };\n  }\n};\n\n/**\n*/\nID3.decodeURLFrame = function(frame) {\n  var description, index, url, value;\n  if (frame.type === 'WXXX') {\n    if (frame.size < 2) {\n      return;\n    }\n    index = 1;\n    description = this.utf8ArrayToStr(frame.data.subarray(index));\n    index += description.length + 1;\n    value = this.utf8ArrayToStr(frame.data.subarray(index));\n    return {\n      key: frame.type,\n      info: description,\n      data: value\n    };\n  } else {\n    url = this.utf8ArrayToStr(frame.data);\n    return {\n      key: frame.type,\n      info: url,\n      data: url\n    };\n  }\n};\n\n/**\n*/\nID3.utf8ArrayToStr = function(array, exitOnNull) {\n  var c, char2, char3, i, len, out;\n  if (exitOnNull == null) {\n    exitOnNull = false;\n  }\n  len = array.length;\n  out = '';\n  i = 0;\n  while (i < len) {\n    c = array[i++];\n    if (c === 0x00 && exitOnNull) {\n      return out;\n    } else if (c === 0x00 || c === 0x03) {\n      continue;\n    }\n    switch (c >> 4) {\n      case 0:\n      case 1:\n      case 2:\n      case 3:\n      case 4:\n      case 5:\n      case 6:\n      case 7:\n        out += String.fromCharCode(c);\n        break;\n      case 12:\n      case 13:\n        char2 = array[i++];\n        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));\n        break;\n      case 14:\n        char2 = array[i++];\n        char3 = array[i++];\n        out += String.fromCharCode(((c & 0x0F) << 12) | ((char2 & 0x3F) << 6) | ((char3 & 0x3F) << 0));\n    }\n  }\n  return out;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction MRSSHelper() {}\n\n/**\n*/\nMRSSHelper.prototype.getFeed = function(url) {\n  return Utils.getFeed(url);\n};\n\n/**\n*/\nMRSSHelper.prototype.getMediaNode = function(item, name, checkItem) {\n  var base, mediaContent, mediaName, node;\n  if (checkItem == null) {\n    checkItem = true;\n  }\n  mediaName = \"media-\" + name;\n  base = item['media-group'] || item;\n  mediaContent = base['media-content'];\n  if ((mediaContent != null) && (mediaContent[mediaName] != null)) {\n    node = mediaContent[mediaName];\n  } else if (base[mediaName] != null) {\n    node = base[mediaName];\n  } else if (item[mediaName] != null) {\n    node = item[mediaName];\n  } else if ((item[name] != null) && checkItem) {\n    node = item[name];\n  }\n  return node;\n};\n\nMRSSHelper.prototype.createEmbed = function(item) {\n  var embed, embedVO, param, _i, _len, _ref;\n  try {\n    embed = this.getMediaNode(item, \"embed\");\n    if (!(embed != null)) {\n      return embedVO;\n    }\n    embedVO = {};\n    embedVO.url = embed[\"@attributes\"].url;\n    embedVO.width = embed[\"@attributes\"].width;\n    embedVO.height = embed[\"@attributes\"].height;\n    embedVO.params = {};\n    if (!(embed[\"media-param\"] instanceof Array)) {\n      embed[\"media-param\"] = [embed[\"media-param\"]];\n    }\n    _ref = embed[\"media-param\"];\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      param = _ref[_i];\n      embedVO.params[param[\"@attributes\"].name] = param[\"#text\"];\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] embed parse error: \" + error.message, error);\n  }\n  return embedVO;\n};\n\n/**\n*/\nMRSSHelper.prototype.createFeed = function(json) {\n  var channel, feedVO, item, items, key, mediaVO, value, _i, _len;\n  try {\n    channel = json.channel;\n    feedVO = new FeedVO();\n    if (channel != null) {\n      feedVO.title = channel.title;\n      feedVO.description = channel.description;\n      feedVO.language = channel.language;\n      feedVO.category = channel.category;\n      feedVO.pubDate = new Date(Date.parse(channel.pubDate));\n      feedVO.ttl = channel.ttl;\n      items = channel.item instanceof Array ? channel.item : [channel.item];\n      for (_i = 0, _len = items.length; _i < _len; _i++) {\n        item = items[_i];\n        mediaVO = this.createMedia(item);\n        feedVO.item.push(mediaVO);\n      }\n      for (key in channel) {\n        value = channel[key];\n        if (!(key in feedVO)) {\n          feedVO.metadata[key] = value;\n        }\n      }\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] feed parse error: \" + error.message, error);\n  }\n  return feedVO;\n};\n\n/**\n*/\nMRSSHelper.prototype.createMedia = function(item) {\n  var atts, category, content, key, label, mediaContent, mediaVO, node, restriction, source, track, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2;\n  try {\n    mediaVO = new MediaVO();\n    mediaContent = this.getMediaNode(item, 'content');\n    if (mediaContent instanceof Array) {\n      mediaVO.source = [];\n      for (_i = 0, _len = mediaContent.length; _i < _len; _i++) {\n        content = mediaContent[_i];\n        source = {\n          src: content['@attributes'].url,\n          type: content['@attributes'].type\n        };\n        category = content[\"media-category\"];\n        if (category != null) {\n          atts = category[\"@attributes\"];\n          if (atts.schema === \"http://mrss.akamai.com/user_agent_hint\") {\n            label = atts.label || category[\"#text\"];\n            if ((label != null) && label !== \"\") {\n              if (source.rules == null) {\n                source.rules = [];\n              }\n              source.rules.push(label);\n            }\n          }\n        }\n        mediaVO.source.push(source);\n        mediaVO.medium = content['@attributes'].medium;\n        mediaVO.duration = parseFloat(content['@attributes'].duration);\n      }\n    } else {\n      mediaVO.type = mediaContent['@attributes'].type;\n      mediaVO.src = mediaContent['@attributes'].url;\n      mediaVO.medium = mediaContent['@attributes'].medium;\n      mediaVO.duration = parseFloat(mediaContent['@attributes'].duration);\n    }\n    mediaVO.guid = item.guid;\n    mediaVO.title = this.getMediaNode(item, \"title\");\n    mediaVO.link = item.link;\n    mediaVO.description = this.getMediaNode(item, \"description\");\n    mediaVO.pubDate = new Date(Date.parse(item.pubDate));\n    mediaVO.thumbnail = mediaVO.poster = (_ref = this.getMediaNode(item, 'thumbnail')) != null ? (_ref1 = _ref['@attributes']) != null ? _ref1.url : void 0 : void 0;\n    mediaVO.embed = this.createEmbed(item);\n    mediaVO.scenes = (_ref2 = this.getMediaNode(item, \"scenes\")) != null ? _ref2['media-scene'] : void 0;\n    node = this.getMediaNode(item, \"status\", false);\n    if (node != null) {\n      mediaVO.status = {\n        state: node['@attributes'].state,\n        reason: node['@attributes'].reason\n      };\n    }\n    node = this.getMediaNode(item, \"restriction\", false);\n    if (node != null) {\n      if (!(node instanceof Array)) {\n        node = [node];\n      }\n      mediaVO.restriction = [];\n      for (_j = 0, _len1 = node.length; _j < _len1; _j++) {\n        restriction = node[_j];\n        mediaVO.restriction.push({\n          relationship: restriction[\"@attributes\"].relationship,\n          type: restriction[\"@attributes\"].type,\n          value: restriction[\"#text\"].split(\" \")\n        });\n      }\n    }\n    mediaVO.category = item.category;\n    if (!(mediaVO.category instanceof Array)) {\n      mediaVO.category = [mediaVO.category];\n    }\n    node = this.getMediaNode(item, \"category\", false);\n    if (node != null) {\n      for (_k = 0, _len2 = node.length; _k < _len2; _k++) {\n        category = node[_k];\n        if ((category[\"#text\"] != null) && category[\"#text\"] !== \"\") {\n          mediaVO.category.push(category[\"#text\"]);\n        }\n      }\n    }\n    if (mediaVO.category != null) {\n      mediaVO.category.sort(function(a, b) {\n        a = a.toLowerCase();\n        b = b.toLowerCase();\n        if (a > b) {\n          return 1;\n        } else if (a < b) {\n          return -1;\n        } else {\n          return 0;\n        }\n      });\n    }\n    node = this.getMediaNode(item, \"subTitle\");\n    if (node != null) {\n      if (mediaVO.track == null) {\n        mediaVO.track = [];\n      }\n      if (!(node instanceof Array)) {\n        node = [node];\n      }\n      for (_l = 0, _len3 = node.length; _l < _len3; _l++) {\n        track = node[_l];\n        if (track[\"@attributes\"] != null) {\n          mediaVO.track.push({\n            src: track[\"@attributes\"].href,\n            type: track[\"@attributes\"].type,\n            kind: \"captions\",\n            srclang: track[\"@attributes\"].lang || \"en\"\n          });\n        }\n      }\n    }\n    category = item.category;\n    if (!(category instanceof Array)) {\n      category = [category];\n    }\n    mediaVO.isLive = item.temporalType === \"live\" || ((category != null) && category.join(\",\").indexOf(\"live_stream\") !== -1);\n    mediaVO.temporalType = mediaVO.isLive ? \"live\" : item.temporalType || \"vod\";\n    for (key in item) {\n      value = item[key];\n      if (!(key in mediaVO)) {\n        mediaVO.metadata[key] = value;\n      }\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] media parse error: \" + error.message, error);\n  }\n  return mediaVO;\n};\n\nfunction Cookies() {}\n\nCookies.setCookie = function(name, value, days, path, domain) {\n  var expires;\n  value = escape(value);\n  if (days != null) {\n    expires = new Date();\n    expires.setDate(expires.getDate() + days);\n    value += \"; expires=\" + expires.toUTCString();\n  }\n  if (domain != null) {\n    value += \"; domain=\" + domain;\n  }\n  if (path != null) {\n    value += \"; path=\" + path;\n  }\n  return document.cookie = name + \"=\" + value;\n};\n\nCookies.getCookie = function(name) {\n  var cookie, cookies, index, key, value, _i, _len;\n  cookies = document.cookie.split(\";\");\n  for (_i = 0, _len = cookies.length; _i < _len; _i++) {\n    cookie = cookies[_i];\n    index = cookie.indexOf(\"=\");\n    key = cookie.substr(0, index).replace(/^\\s+|\\s+$/g, \"\");\n    value = unescape(cookie.substr(index + 1));\n    if (key === name) {\n      return value;\n    }\n  }\n};\n\nCookies.deleteCookie = function(name) {\n  return this.setCookie(name, \"\", -1);\n};\n\n/**\n * @constructor\n * @private\n * @extends {EventDispatcher}\n*/\nfunction XHR() {\n  XHR.__super__.constructor.call(this);\n}\n\n\n__extends(XHR, EventDispatcher);\n\n\nXHR.prototype.xhr = null;\n\nXHR.prototype.headers = null;\n\nXHR.prototype.response = null;\n\nXHR.prototype.responseXML = null;\n\nXHR.prototype.responseText = null;\n\nXHR.prototype.responseType = null;\n\nXHR.prototype.withCredentials = false;\n\nXHR.prototype.readyState = 0;\n\nXHR.prototype.status = null;\n\nXHR.prototype.open = function(method, url) {\n  var xdr, xhr,\n    _this = this;\n  try {\n    xhr = new XMLHttpRequest();\n  } catch (error) {\n    xhr = new window.ActiveXObject(\"Microsoft.XMLHTTP\");\n  }\n  if (XHR.isCORS(url)) {\n    if (Object.prototype.hasOwnProperty.call(xhr, \"withCredentials\")) {\n      try {\n        xhr.withCredentials = this.withCredentials;\n      } catch (error) {\n        Logger.warn(\"[AMP XHR WARNING]\", \"withCredentials not properly supported in this browser.\", error);\n      }\n    } else if (typeof XDomainRequest !== \"undefined\") {\n      xdr = true;\n      xhr = new XDomainRequest();\n    }\n  }\n  if (xhr != null) {\n    if (xdr) {\n      xhr.onprogress = function() {};\n      xhr.ontimeout = function() {};\n      xhr.onerror = function() {};\n      xhr.onload = function(event) {\n        if (typeof xhr.onreadystatechange === 'function') {\n          xhr.readyState = 4;\n          xhr.status = 200;\n          if (xhr.contentType.match(/\\/xml/)) {\n            xhr.responseXML = new ActiveXObject('Microsoft.XMLDOM');\n            xhr.responseXML.async = false;\n            xhr.responseXML.loadXML(xhr.responseText);\n          }\n          xhr.onreadystatechange.call(xhr, event, false);\n        }\n      };\n    }\n    xhr.onreadystatechange = function(event) {\n      var _ref, _ref1;\n      _this.readyState = xhr.readyState;\n      _this.dispatchEvent(new Event(\"readystatechange\", xhr));\n      if (xhr.readyState === 4) {\n        _this.status = xhr.status;\n        if ((199 < (_ref = _this.status) && _ref < 400) || _this.status === 0) {\n          if (xhr.responseText == null) {\n            xhr.responseText = xhr.text;\n          }\n          _this.responseText = xhr.responseText;\n          if ((xhr.responseXML != null) && ((_ref1 = xhr.responseXML.childNodes) != null ? _ref1.length : void 0) > 0) {\n            _this.response = _this.responseXML = xhr.responseXML;\n            _this.responseType = \"document\";\n          } else {\n            try {\n              _this.response = JSON.parse(xhr.responseText);\n              _this.responseType = \"json\";\n            } catch (error) {\n              _this.response = xhr.responseText;\n              _this.responseType = \"text\";\n            }\n          }\n          _this.dispatchEvent(new Event(\"load\", _this));\n        } else {\n          if (_this.status !== 0) {\n            _this.dispatchEvent(new Event(\"error\", _this));\n          }\n        }\n      }\n    };\n    try {\n      if (typeof xhr.onerror !== \"undefined\") {\n        xhr.onerror = function(event) {\n          _this.dispatchEvent(new Event(\"error\", _this));\n        };\n      }\n    } catch (error) {\n\n    }\n    xhr.open(method, url);\n  }\n  this.xhr = xhr;\n};\n\nXHR.prototype.send = function(data) {\n  var key, value, _ref,\n    _this = this;\n  if (this.headers != null) {\n    _ref = this.headers;\n    for (key in _ref) {\n      value = _ref[key];\n      if ((key != null) && (value != null)) {\n        this.xhr.setRequestHeader(key, value);\n      }\n    }\n  }\n  setTimeout(function() {\n    _this.xhr.send(data);\n  }, 0);\n};\n\nXHR.prototype.setRequestHeader = function(key, value) {\n  if (!(key != null) || !(value != null)) {\n    return;\n  }\n  if (this.headers == null) {\n    this.headers = {};\n  }\n  this.headers[key] = value;\n};\n\nXHR.prototype.setRequestHeaders = function(headers) {\n  this.headers = headers;\n  return headers;\n};\n\nXHR.prototype.getResponseHeader = function(name) {\n  var _ref;\n  return (_ref = this.xhr) != null ? typeof _ref.getResponseHeader === \"function\" ? _ref.getResponseHeader(name) : void 0 : void 0;\n};\n\nXHR.prototype.getAllResponseHeaders = function() {\n  var _ref;\n  return (_ref = this.xhr) != null ? typeof _ref.getAllResponseHeaders === \"function\" ? _ref.getAllResponseHeaders() : void 0 : void 0;\n};\n\nXHR.isCORS = function(url) {\n  var hostname, parser, port, protocol;\n  parser = document.createElement('a');\n  parser.href = url;\n  hostname = parser.hostname !== \"\" ? parser.hostname : location.hostname;\n  port = parser.port !== \"0\" ? parser.port : location.port;\n  protocol = parser.protocol !== \":\" ? parser.protocol : location.protocol;\n  return location.protocol !== protocol || location.hostname !== hostname || location.port !== port && !(location.port === \"\" && port === \"80\");\n};\n\n/**\n * Constructs a new Timer object with the specified delay and repeatCount states.\n*/\nfunction Timer(delay, repeatCount) {\n  var _this = this;\n  this.delay = delay;\n  this.repeatCount = repeatCount != null ? repeatCount : 0;\n  Timer.__super__.constructor.call(this);\n  this._running = false;\n  this._currentCount = 0;\n  this._timeout = null;\n  this._startTime = null;\n  this._currentTime = 0;\n  this.tick = this.tick.bind(this);\n  this.next = setTimeout.bind(null, this.tick, this.delay);\n  Object.defineProperties(this, {\n    currentCount: {\n      get: function() {\n        return _this._currentCount;\n      },\n      enumerable: true,\n      configurable: false\n    },\n    running: {\n      get: function() {\n        return _this._running;\n      },\n      enumerable: true,\n      configurable: false\n    },\n    time: {\n      get: function() {\n        return _this._currentTime + (Date.now() - _this._startTime);\n      },\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(Timer, EventDispatcher);\n\n\n/**\n * Stops the timer, if it is running, and sets the currentCount property back to 0, like the reset button of a stopwatch.\n*/\nTimer.prototype.reset = function() {\n  this.stop();\n  this._currentCount = 0;\n  this._currentTime = 0;\n  this._startTime = null;\n};\n\n/**\n * Starts the timer, if it is not already running.\n*/\nTimer.prototype.start = function() {\n  var delay;\n  if (this._running === true) {\n    return;\n  }\n  delay = this.delay - (this._currentTime - (this.delay * this._currentCount));\n  this._running = true;\n  this._timeout = setTimeout(this.tick, delay);\n};\n\n/**\n * Stops the timer.\n*/\nTimer.prototype.stop = function() {\n  if (this._running === false) {\n    return;\n  }\n  clearTimeout(this._timeout);\n  this._currentTime += Date.now() - this._startTime;\n  this._timeout = null;\n  this._running = false;\n};\n\n/**\n *\n*/\nTimer.prototype.tick = function() {\n  var complete;\n  clearTimeout(this._timeout);\n  complete = this.repeatCount !== 0 && this._currentCount >= this.repeatCount;\n  this._currentCount++;\n  this._currentTime += this.delay;\n  this._startTime = Date.now();\n  if (complete === false) {\n    this._timeout = this.next();\n  }\n  this.dispatchEvent(new Event(\"timer\", this));\n  if (complete === true) {\n    this.stop();\n    this.dispatchEvent(new Event(\"complete\", this));\n  }\n};\n\nfunction Utils() {}\n\nUtils.blankImage = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjI2QkJDQTBCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjI2QkJDQTFCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODg4NjdFQkIzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODg4NjdFQ0IzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pu0++ecAAAAGUExURf///wAAAFXC034AAAABdFJOUwBA5thmAAAADElEQVR42mJgAAgwAAACAAFPbVnhAAAAAElFTkSuQmCC\";\n\nUtils.mimeTypes = {\n  mp4: \"video/mp4\",\n  flv: \"video/x-flv\",\n  f4m: \"video/f4m\",\n  smil: \"application/smil\",\n  smilxml: \"application/smil+xml\",\n  m3u8: \"application/x-mpegURL\",\n  mp3: \"audio/mpeg\",\n  json: \"application/json\",\n  txt: \"text/plain\",\n  xml: \"application/xml\",\n  ogv: \"video/ogg\",\n  webm: \"video/webm\",\n  mpd: \"application/dash+xml\",\n  ism: \"application/vnd.ms-sstr+xml\",\n  js: \"text/javascript\",\n  css: \"text/css\",\n  swf: \"application/x-shockwave-flash\",\n  vtt: \"text/vtt\",\n  ttml: \"application/ttml+xml\",\n  srt: \"application/x-subrip\",\n  cea608: \"text/cea-608\",\n  cea708: \"text/cea-708\"\n};\n\nUtils.flashTypes = [Utils.mimeTypes.mp4, Utils.mimeTypes.flv, Utils.mimeTypes.f4m, Utils.mimeTypes.smil, Utils.mimeTypes.smilxml];\n\nUtils.rules = {\n  flashTablets: {\n    label: \"Android 2 & 3 or Kindle Fire 1\",\n    regexp: \"Android [23]|Silk\\/1\"\n  },\n  html5Phones: {\n    label: \"iPhone\",\n    regexp: \"iPhone\"\n  },\n  html5Tablets: {\n    label: \"HTML5 Tablets\",\n    regexp: \"iPad|Android [4-9]|Silk\\/2\"\n  },\n  desktop: {\n    label: \"Desktop\",\n    regexp: \"^((?!iPad|iPhone|Android|BlackBerry|PlayBook|Silk).)*$\"\n  }\n};\n\nUtils.getPlaybackMode = function(mode) {\n  var key, valid, value, _ref;\n  if (mode == null) {\n    mode = ((_ref = QueryString[\"amp-mode\"]) != null ? _ref.toLowerCase() : void 0) || PlaybackMode.HTML_AUTO;\n  }\n  valid = false;\n  for (key in PlaybackMode) {\n    value = PlaybackMode[key];\n    if (value === mode) {\n      valid = true;\n      break;\n    }\n  }\n  if (!valid) {\n    mode = PlaybackMode.AUTO;\n  }\n  if (mode === PlaybackMode.HTML_AUTO) {\n    mode = this.isHTMLFirst() ? PlaybackMode.HTML : PlaybackMode.AUTO;\n  }\n  if (mode !== PlaybackMode.AUTO) {\n    if (mode === PlaybackMode.FLASH && (!this.hasFlash() || typeof FlashPlayer === \"undefined\")) {\n      if (this.supportsHTML5Video()) {\n        mode = PlaybackMode.HTML;\n      } else {\n        mode = PlaybackMode.NONE;\n      }\n    }\n    return mode;\n  }\n  if (!this.hasFlash()) {\n    mode = this.supportsHTML5Video() ? PlaybackMode.HTML : PlaybackMode.NONE;\n  }\n  if (mode === PlaybackMode.AUTO) {\n    mode = this.isHTML5() ? PlaybackMode.HTML : PlaybackMode.FLASH;\n  }\n  return mode;\n};\n\nUtils.getIEVersion = function() {\n  var re, rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (navigator.appName === 'Microsoft Internet Explorer') {\n    re = new RegExp(\"MSIE ([0-9]{1,}[\\.0-9]{0,})\");\n  } else if (navigator.appName === 'Netscape') {\n    re = new RegExp(\"Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})\");\n  } else if (/Edge\\/[0-9\\.]+$/.test(ua)) {\n    re = /Edge\\/([0-9\\.]+)/;\n  }\n  if ((re != null ? re.exec(ua) : void 0) != null) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.getFFVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Firefox\\/([0-9\\.]+)$/.exec(ua)) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.getSafariVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Safari\\/[0-9\\.]+$/.test(ua) && (/Version\\/([0-9]+\\.[0-9]+) Safari/.exec(ua) != null)) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.isChrome = function() {\n  return /Chrom(e|ium)/.test(navigator.userAgent);\n};\n\nUtils.getChromeVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Chrome( Mobile)?\\/([0-9\\.]+)/.test(ua)) {\n    rv = parseFloat(ua.match(/Chrome( Mobile)?\\/([0-9\\.]+)/)[2].split(\".\").slice(0, 2).join(\".\"));\n  }\n  return rv;\n};\n\nUtils.isHTMLFirst = function() {\n  return window.MediaSource != null;\n};\n\nUtils.mergeRules = function(rules) {\n  var id, rule, _results;\n  _results = [];\n  for (id in rules) {\n    rule = rules[id];\n    _results.push(Utils.rules[id] = rule);\n  }\n  return _results;\n};\n\nUtils.checkRules = function(rules) {\n  var id, regExp, rule, _i, _len;\n  if ((rules != null) && rules.length > 0) {\n    for (_i = 0, _len = rules.length; _i < _len; _i++) {\n      id = rules[_i];\n      if (!(rule = Utils.rules[id])) {\n        continue;\n      }\n      regExp = new RegExp(rule.regexp);\n      if (regExp.test(navigator.userAgent)) {\n        return true;\n      }\n    }\n  }\n  return false;\n};\n\nUtils.selectSource = function(sources, canPlayType) {\n  var item, _i, _j, _len, _len1;\n  for (_i = 0, _len = sources.length; _i < _len; _i++) {\n    item = sources[_i];\n    if (Utils.checkRules(item.rules)) {\n      return item;\n    }\n  }\n  for (_j = 0, _len1 = sources.length; _j < _len1; _j++) {\n    item = sources[_j];\n    if (canPlayType(item.type || Utils.getMimeType(item.src)) !== \"\") {\n      return item;\n    }\n  }\n  return null;\n};\n\nUtils.getSourceByType = function(media, type) {\n  var source, sources, _i, _len;\n  sources = media.source != null ? media.source.slice() : [];\n  if (!(media.type != null)) {\n    media.type = Utils.getMimeType(media.src);\n  }\n  sources.unshift(media);\n  for (_i = 0, _len = sources.length; _i < _len; _i++) {\n    source = sources[_i];\n    if (source.type === type) {\n      return source;\n    }\n  }\n  return null;\n};\n\nUtils.getMimeType = function(file) {\n  return this.mimeTypes[Utils.getFileExtension(file)];\n};\n\nUtils.selectTrack = function(tracks, kind) {\n  var item, track, _i, _len;\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    item = tracks[_i];\n    if (!(item.kind === kind)) {\n      continue;\n    }\n    track = item;\n    break;\n  }\n  return track;\n};\n\nUtils.isIPhone = function() {\n  return /iPhone/.test(navigator.platform) || /iPhone/.test(navigator.userAgent);\n};\n\nUtils.isIPad = function() {\n  return /iPad/.test(navigator.platform) || /iPad/.test(navigator.userAgent);\n};\n\nUtils.isAndroid = function() {\n  return /Android [4-9]/.test(navigator.userAgent);\n};\n\nUtils.isKindleFireHD = function() {\n  return /Silk\\/2/.test(navigator.userAgent);\n};\n\nUtils.isKindleFire = function() {\n  return /Silk\\/1/.test(navigator.userAgent);\n};\n\nUtils.isBlackBerry = function() {\n  return /BlackBerry;|PlayBook|BB10/.test(navigator.userAgent);\n};\n\nUtils.isFirefoxOS = function() {\n  return /\\(Mobile;.*Firefox\\//.test(navigator.userAgent);\n};\n\nUtils.supportsHTML5Video = function() {\n  var video;\n  video = document.createElement(\"video\");\n  return video.canPlayType != null;\n};\n\nUtils.isHTML5 = function() {\n  return this.isIOS() || this.isAndroid() || this.isKindleFireHD() || this.isBlackBerry() || this.isFirefoxOS();\n};\n\nUtils.isIOS = function() {\n  var iOSRegEx, isIOS;\n  iOSRegEx = /iP(hone|od|ad)/i;\n  return isIOS = iOSRegEx.test(navigator.platform) || iOSRegEx.test(navigator.userAgent);\n};\n\nUtils.getIOSversion = function() {\n  var ver;\n  if (this.isIOS()) {\n    ver = navigator.appVersion.match(/OS (\\d+)_(\\d+)_?(\\d+)?/);\n    return [parseInt(ver[1], 10), parseInt(ver[2], 10), parseInt(ver[3] || 0, 10)];\n  }\n};\n\nUtils.hasFlash = function() {\n  var hasFlash;\n  try {\n    hasFlash = Boolean(new ActiveXObject(\"ShockwaveFlash.ShockwaveFlash\"));\n  } catch (error) {\n    hasFlash = \"undefined\" !== typeof navigator.mimeTypes[\"application/x-shockwave-flash\"];\n  }\n  return hasFlash;\n};\n\nUtils.isFullscreenDevice = function() {\n  return this.isKindleFireHD() || this.isIPhone();\n};\n\nUtils.getDevice = function() {\n  var device;\n  device = \"desktop\";\n  if (this.isIPhone()) {\n    device = \"iphone\";\n  } else if (this.isIPad()) {\n    device = \"ipad\";\n  } else if (/Android/.test(navigator.userAgent)) {\n    device = \"android\";\n  } else if (this.isKindleFireHD()) {\n    device = \"kindlefirehd\";\n  } else if (this.isKindleFire()) {\n    device = \"kindlefire\";\n  }\n  return device;\n};\n\nUtils.xmlToJson = function(xml) {\n  var attribute, child, element, index, nodeName, obj, _i, _j, _len, _len1, _ref, _ref1;\n  obj = {};\n  if (xml.nodeType === 9) {\n    xml = xml.firstChild;\n  }\n  if (xml.nodeType === 1) {\n    if (xml.attributes.length > 0) {\n      obj[\"@attributes\"] = {};\n      _ref = xml.attributes;\n      for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n        attribute = _ref[index];\n        obj[\"@attributes\"][attribute.nodeName] = attribute.nodeValue;\n      }\n    }\n  } else if (xml.nodeType === 3 || xml.nodeType === 4) {\n    obj = xml.nodeValue;\n  }\n  if (xml.hasChildNodes()) {\n    _ref1 = xml.childNodes;\n    for (index = _j = 0, _len1 = _ref1.length; _j < _len1; index = ++_j) {\n      child = _ref1[index];\n      if (child.nodeType === 3 && !/\\S/.test(child.nodeValue)) {\n        continue;\n      }\n      nodeName = child.nodeName.replace(/:/, \"-\");\n      element = this.xmlToJson(child);\n      if (!(element[\"@attributes\"] != null) && (element[\"#text\"] != null)) {\n        element = element[\"#text\"];\n      }\n      if (!(obj[nodeName] != null)) {\n        obj[nodeName] = element;\n      } else {\n        if (!(obj[nodeName] instanceof Array)) {\n          obj[nodeName] = [obj[nodeName]];\n        }\n        obj[nodeName].push(element);\n      }\n    }\n  }\n  return obj;\n};\n\n/**\n * Returns a platform specific XHR object.\n *\n * @static\n*/\nUtils.getXHR = function() {\n  return new XHR();\n};\n\n/**\n * Retrieves a remote text file\n *\n * @static\n*/\nUtils.getUTC = function() {\n  var _this = this;\n  return this.request(\"//time.akamai.com\").then(function(xhr) {\n    return parseInt(xhr.responseText) * 1000;\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.request = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return new Promise(function(resolve, reject) {\n    var key, value, xhr, _ref;\n    if (typeof options === \"string\") {\n      options = {\n        url: options\n      };\n    }\n    if (!(options.method != null)) {\n      options.method = \"GET\";\n    }\n    xhr = new XMLHttpRequest();\n    xhr.open(options.method, options.url);\n    xhr.onload = function() {\n      return resolve(xhr);\n    };\n    xhr.onerror = function(event) {\n      return reject(event);\n    };\n    xhr.withCredentials = options.withCredentials;\n    if (options.responseType != null) {\n      try {\n        xhr.responseType = options.responseType;\n      } catch (error) {\n\n      }\n    }\n    if (options.headers != null) {\n      _ref = options.headers;\n      for (key in _ref) {\n        value = _ref[key];\n        if ((key != null) && (value != null)) {\n          xhr.setRequestHeader(key, value);\n        }\n      }\n    }\n    return xhr.send(options.data || options.body);\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.requestText = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return this.request(options).then(function(xhr) {\n    return xhr.responseText;\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.requestJson = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return this.requestText(options).then(function(text) {\n    return JSON.parse(text);\n  });\n};\n\n/**\n * Attaches a JavaScript file to the head of the document.\n *\n * @static\n*/\nUtils.loadScript = function(src, parent) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var head, script;\n    head = parent || document.getElementsByTagName(\"head\")[0];\n    script = document.createElement(\"script\");\n    script.type = 'text/javascript';\n    if (script.addEventListener) {\n      script.onload = function() {\n        resolve(script);\n      };\n      script.onerror = function(event) {\n        reject(event);\n      };\n    } else if (script.readyState) {\n      script.onreadystatechange = function(event) {\n        if (this.readyState === 'loaded' || this.readyState === 'complete') {\n          this.onreadystatechange = null;\n          resolve(script);\n        }\n      };\n    }\n    script.src = src;\n    head.appendChild(script);\n  });\n};\n\n/**\n * Attaches a CSS file to the head of the document.\n *\n * @static\n*/\nUtils.loadStyleSheet = function(href) {\n  var head, link;\n  head = document.getElementsByTagName(\"head\")[0];\n  link = document.createElement(\"link\");\n  link.rel = \"stylesheet\";\n  link.type = \"text/css\";\n  link.href = href;\n  return head.appendChild(link);\n};\n\nUtils.getFileExtension = function(url) {\n  if (url == null) {\n    url = \"\";\n  }\n  return url.replace(/\\?.*/, \"\").replace(/\\#.*/, \"\").split('.').pop();\n};\n\nUtils.getResponseHeader = function(url, header, client) {\n  var xhr;\n  if (client == null) {\n    client = {};\n  }\n  xhr = Utils.getXHR();\n  if (client.onerror != null) {\n    xhr.onerror = client.onerror;\n  }\n  xhr.open(\"HEAD\", url, false);\n  xhr.send();\n  return xhr.getResponseHeader(header);\n};\n\nUtils.getResponseHeaders = function(url, headers, client) {\n  var header, results, xhr, _i, _len;\n  if (client == null) {\n    client = {};\n  }\n  xhr = Utils.getXHR();\n  if (client.onerror != null) {\n    xhr.onerror = client.onerror;\n  }\n  xhr.open(\"HEAD\", url, false);\n  xhr.send();\n  results = {};\n  if (!(headers != null)) {\n    return xhr.getAllResponseHeaders();\n  }\n  for (_i = 0, _len = headers.length; _i < _len; _i++) {\n    header = headers[_i];\n    results[header] = xhr.getResponseHeader(header);\n  }\n  return results;\n};\n\n/**\n * Determines if the device supports touch events\n *\n * @static\n*/\nUtils.isTouch = null;\n\n/**\n * Determines if the device supports touch events\n *\n * @static\n*/\nUtils.isTouchDevice = function() {\n  if (!(this.isTouch != null)) {\n    try {\n      document.createEvent(\"TouchEvent\");\n      this.isTouch = true;\n    } catch (error) {\n      this.isTouch = false;\n    }\n  }\n  return this.isTouch;\n};\n\n/**\n * Forces a number between a min and a max\n *\n * @static\n*/\nUtils.clamp = function(value, min, max) {\n  if (value < min) {\n    value = min;\n  }\n  if (value > max) {\n    value = max;\n  }\n  return value;\n};\n\n/**\n * Beacons a url via an img tag\n *\n * @static\n*/\nUtils.beacon = function(url, beaconId) {\n  var beaconImg;\n  if (beaconId == null) {\n    beaconId = \"beaconId\";\n  }\n  beaconImg = document.getElementById(beaconId);\n  if (!(beaconImg != null)) {\n    beaconImg = document.createElement(\"img\");\n    beaconImg.setAttribute(\"id\", beaconId);\n    beaconImg.setAttribute(\"height\", 0);\n    beaconImg.setAttribute(\"width\", 0);\n    document.body.appendChild(beaconImg);\n    beaconImg.style.display = \"none\";\n  }\n  beaconImg.setAttribute(\"src\", url);\n  return beaconImg;\n};\n\n/**\n * Calculates offset Left and Top\n *\n * @static\n*/\nUtils.getElementOffset = function(element, root) {\n  var height, left, scrollLeft, scrollTop, top, width;\n  if (root == null) {\n    root = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;\n  }\n  left = 0;\n  top = 0;\n  width = element.offsetWidth;\n  height = element.offsetHeight;\n  while (element && element !== root) {\n    if (element.tagName === \"BODY\") {\n      scrollLeft = element.scrollLeft || document.documentElement.scrollLeft;\n      scrollTop = element.scrollTop || document.documentElement.scrollTop;\n      left += element.offsetLeft - scrollLeft + element.clientLeft;\n      top += element.offsetTop - scrollTop + element.clientTop;\n    } else {\n      left += element.offsetLeft - element.scrollLeft + element.clientLeft;\n      top += element.offsetTop - element.scrollTop + element.clientTop;\n    }\n    element = element.offsetParent;\n  }\n  return {\n    left: left,\n    top: top,\n    width: width,\n    height: height\n  };\n};\n\n/**\n * Override the properties of a base object with the values\n * of an override object.\n *\n * @param {Object} base     The base object.\n * @param {Object} overrides  key/value overrides\n * @return {Object}\n * @static\n*/\nUtils.override = function(base, overrides, clone) {\n  var key, value;\n  if (clone == null) {\n    clone = true;\n  }\n  if (!(base != null)) {\n    return overrides;\n  }\n  if (!(overrides != null)) {\n    return base;\n  }\n  if (clone === true) {\n    base = Utils.clone(base);\n    overrides = Utils.clone(overrides);\n  }\n  for (key in overrides) {\n    value = overrides[key];\n    if (typeof base[key] === \"object\" && typeof value === \"object\" && (value != null)) {\n      if (base[key] == null) {\n        base[key] = value instanceof Array ? [] : {};\n      }\n      base[key] = Utils.override(base[key], value, false);\n    } else {\n      base[key] = value;\n    }\n  }\n  return base;\n};\n\n/**\n * Diffs two objects.\n *\n * @param {Object} oldObj The old object.\n * @param {Object} newObj The new object.\n * @return {Object?}\n * @static\n*/\nUtils.diff = function(oldObj, newObj) {\n  var changes, diff, key, old, value;\n  if (!(newObj != null)) {\n    return null;\n  }\n  if (!(oldObj != null) && (newObj != null)) {\n    return newObj;\n  }\n  changes = {};\n  for (key in newObj) {\n    value = newObj[key];\n    if ((old = oldObj[key]) !== value) {\n      if (!(old != null)) {\n        changes[key] = value;\n      } else {\n        switch (typeof value) {\n          case \"string\":\n          case \"number\":\n          case \"boolean\":\n          case \"function\":\n            changes[key] = value;\n            break;\n          case \"object\":\n            if (value instanceof Array) {\n              if (old.length !== value.length) {\n                changes[key] = value;\n              }\n            } else {\n              diff = this.diff(old, value);\n              if (diff != null) {\n                changes[key] = diff;\n              }\n            }\n        }\n      }\n    }\n  }\n  if (Object.keys(changes).length === 0) {\n    return null;\n  }\n  return changes;\n};\n\n/**\n * Clones an object.\n *\n * @param {Object} obj The object to be cloned.\n * @return {Object}\n * @static\n*/\nUtils.clone = function(obj, deepCopy) {\n  var clone, item, k, key, v, value, _i, _len;\n  if (deepCopy == null) {\n    deepCopy = true;\n  }\n  if (!(obj != null)) {\n    return obj;\n  }\n  if (typeof obj !== \"object\") {\n    clone = obj;\n  } else {\n    if (obj instanceof Array) {\n      clone = [];\n    } else {\n      clone = {};\n    }\n    for (key in obj) {\n      value = obj[key];\n      if (typeof value === \"object\" && value !== null && deepCopy === true) {\n        if (value instanceof Array) {\n          clone[key] = [];\n          for (_i = 0, _len = value.length; _i < _len; _i++) {\n            item = value[_i];\n            clone[key].push(this.clone(item));\n          }\n        } else {\n          clone[key] = {};\n          for (k in value) {\n            v = value[k];\n            clone[key][k] = this.clone(v);\n          }\n        }\n      } else {\n        clone[key] = value;\n      }\n    }\n  }\n  return clone;\n};\n\n/**\n * Takes a time in seconds and converts it to timecode.\n *\n * @param   {Number}  time  The time in seconds to be formatted.\n * @return  {String}  A SMTP formatted string.\n*/\nUtils.formatTimecode = function(time, duration) {\n  var strTime;\n  time = parseInt(time);\n  if (isNaN(time)) {\n    return \"00:00\";\n  }\n  strTime = Utils.formatZeroFill(time % 60);\n  time = parseInt(time / 60);\n  strTime = Utils.formatZeroFill(time % 60) + \":\" + strTime;\n  time = parseInt(time / 60);\n  if (time > 0) {\n    strTime = Utils.formatZeroFill(time) + \":\" + strTime;\n  }\n  if (duration >= 3600 && strTime.length === 5) {\n    strTime = \"00:\" + strTime;\n  }\n  return strTime;\n};\n\n/**\n * Converts a time in seconds to a string and adds a zero in front of any number lower than 10.\n *\n * @param Number time The number to be zero filled.\n*/\nUtils.formatZeroFill = function(time) {\n  var str;\n  str = time.toString();\n  if (time < 10) {\n    str = \"0\" + str;\n  }\n  return str;\n};\n\n/**\n * Converts timecode to seconds.\n *\n * @param   {string}  timeCode        A SMTP formatted string.\n * @param   {number}  [framerate=30]  The frame rate. Used to calculate milliseconds.\n * @return  {number}                  The number of seconds represented by the time code\n*/\nUtils.flattenTimecode = function(timeCode, framerate) {\n  var ms, parts, pieces, time;\n  if (framerate == null) {\n    framerate = 30;\n  }\n  if (!(timeCode != null) || timeCode === \"\") {\n    return NaN;\n  }\n  pieces = timeCode.split(\":\");\n  ms = 0;\n  if (pieces.length === 4) {\n    ms = parseInt(pieces.pop()) / framerate;\n  } else if (pieces.length === 3) {\n    pieces[2] = pieces[2].replace(\",\", \".\");\n    if (pieces[2].indexOf(\".\") !== -1) {\n      parts = pieces[2].split(\".\");\n    }\n    if ((parts != null ? parts.length : void 0) > 1) {\n      pieces[2] = parts[0];\n      ms = parseInt(parts[1]) / 1000;\n    }\n  }\n  time = parseInt(pieces.pop());\n  while (pieces.length > 0) {\n    time += Math.pow(60, pieces.length) * parseInt(pieces.shift());\n  }\n  return time + ms;\n};\n\n/**\n * Adds a cache busting query string parameter to a url.\n *\n * @param String url The url.\n * @param String key The name of the query string variable\n * @param Object value The value of the query string variable\n*/\nUtils.cacheBust = function(url, key, value) {\n  var op;\n  if (key == null) {\n    key = \"cacheBust\";\n  }\n  if (value == null) {\n    value = Date.now();\n  }\n  op = url.indexOf('?') === -1 ? \"?\" : \"&\";\n  return url + op + key + \"=\" + value;\n};\n\n/**\n * Converts a camel case string in to a CSS proptery name.\n*/\nUtils.formatStyleName = function(styleName) {\n  return styleName.replace(/([A-Z])/, \"-$1\").toLowerCase();\n};\n\n/**\n * Trims whitespace from the beginning and end of a string\n*/\nUtils.trim = function(str) {\n  var trim;\n  trim = str.replace(/^\\s*(.*)/, \"$1\");\n  return trim.replace(/(.*)\\s*$/, \"$1\");\n};\n\n/**\n*/\nUtils.getFeed = function(url) {\n  var _this = this;\n  return this.request(url).then(function(xhr) {\n    if (xhr.responseType === \"document\" || /^</.test(xhr.responseText)) {\n      return Utils.xmlToJson(xhr.responseXML);\n    } else {\n      return JSON.parse(xhr.responseText);\n    }\n  });\n};\n\n/**\n*/\nUtils.getSource = function(url, onload, onerror) {\n  var feedloadedHandler, mode;\n  mode = Utils.getPlaybackMode();\n  feedloadedHandler = function(feed) {\n    var canPlayType, helper, source, _ref;\n    helper = new MRSSHelper();\n    feed = helper.createFeed(feed);\n    if ((feed != null ? (_ref = feed.item) != null ? _ref.length : void 0 : void 0) > 0) {\n      canPlayType = function(type) {\n        if ((mode === \"flash\" && Utils.flashTypes.indexOf(type) !== -1) || (mode === \"html\" && Utils.flashTypes.indexOf(type) === -1)) {\n          return \"maybe\";\n        } else {\n          return \"\";\n        }\n      };\n      source = Utils.selectSource(feed.item[0].source, canPlayType);\n    }\n    if (typeof onload === \"function\") {\n      onload(source);\n    }\n  };\n  Utils.getFeed(url).then(feedloadedHandler)[\"catch\"](onerror);\n};\n\n/**\n*/\nUtils.trackMouse = function() {\n  try {\n    if (document.addEventListener != null) {\n      document.addEventListener(\"mousemove\", this.mouseTracker);\n    } else if (document.attachEvent != null) {\n      document.attachEvent(\"mousemove\", this.mouseTracker);\n    }\n  } catch (error) {\n\n  }\n};\n\nUtils.clientX = 0;\n\nUtils.clientY = 0;\n\nUtils.pageX = 0;\n\nUtils.pageY = 0;\n\n/**\n*/\nUtils.mouseTracker = function(event) {\n  Utils.clientX = event.clientX;\n  Utils.clientY = event.clientY;\n  Utils.pageX = event.pageX;\n  Utils.pageY = event.pageY;\n};\n\n/**\n*/\nUtils.isMouseOverElement = function(element) {\n  var isOver;\n  isOver = false;\n  if (!(element != null)) {\n    return isOver;\n  }\n  try {\n    isOver = element.contains(document.elementFromPoint(Utils.clientX, Utils.clientY));\n  } catch (error) {\n    isOver = false;\n  }\n  return isOver;\n};\n\nUtils.trackMouse();\n\n/** Function to get Outer Dimensions\n*/\nUtils.getActualSize = function(element, margin) {\n  var height, style, width;\n  if (margin == null) {\n    margin = true;\n  }\n  width = element.offsetWidth;\n  height = element.offsetHeight;\n  if (margin === true) {\n    style = getComputedStyle(element);\n    width += parseInt(style.marginLeft) + parseInt(style.marginRight);\n    height += parseInt(style.marginTop) + parseInt(style.marginBottom);\n  }\n  return {\n    \"width\": width,\n    \"height\": height\n  };\n};\n\nUtils.isVolumeSettable = function() {\n  var noVolume, ua;\n  ua = navigator.userAgent.toLowerCase();\n  noVolume = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(ua);\n  if (noVolume != null) {\n    if (noVolume[0] === \"android\" && /Firefox/.test(ua)) {\n      return true;\n    } else {\n      return false;\n    }\n  }\n  return true;\n};\n\n/**\n * Creates a flash object tag.\n *\n * @param {string} swf\n *    The number to be zero filled.\n *\n * @param {Object} flashvars\n *\n * @return {HTMLObjectElement}\n *    The flash object tag.\n *\n * @static\n*/\nUtils.createFlashObject = function(flash, parent) {\n  var atts, id, innerHTML, key, params, value, vars, _ref, _ref1;\n  if (!(flash != null)) {\n    return;\n  }\n  params = {\n    allowFullScreen: true,\n    allowScriptAccess: \"always\",\n    wmode: \"direct\",\n    bgColor: \"#000000\"\n  };\n  Utils.override(params, flash.params, false);\n  if (flash.vars != null) {\n    vars = [];\n    _ref = flash.vars;\n    for (key in _ref) {\n      value = _ref[key];\n      vars.push(\"\" + key + \"=\" + value);\n    }\n    params.flashvars = vars.join(\"&\");\n  }\n  id = ((_ref1 = flash.attributes) != null ? _ref1.id : void 0) || this.createUID();\n  atts = {\n    id: id,\n    name: id,\n    width: \"100%\",\n    height: \"100%\",\n    type: \"application/x-shockwave-flash\"\n  };\n  Utils.override(atts, flash.attributes, false);\n  if (this.getIEVersion() !== -1) {\n    if (params.wmode === \"direct\") {\n      params.wmode = \"transparent\";\n    }\n  }\n  innerHTML = \"<object \";\n  for (key in atts) {\n    value = atts[key];\n    innerHTML += \"\" + key + \"=\\\"\" + value + \"\\\" \";\n  }\n  innerHTML += \">\\n\";\n  for (key in params) {\n    value = params[key];\n    innerHTML += \"<param name=\\\"\" + key + \"\\\" value=\\\"\" + value + \"\\\" />\\n\";\n  }\n  innerHTML += \"</object>\";\n  parent.innerHTML = innerHTML;\n};\n\n/**\n * Creates a unique id.\n *\n * @param   {number=}   len\n *    The number of characters in the uid\n *\n * @param   {number=}   base\n *    The base to use for representing a numeric value.\n *\n * @return  {string}\n *    The unique id.\n*/\nUtils.createUID = function(len, base) {\n  var i, randomRangeInt, uid, _i, _ref,\n    _this = this;\n  if (len == null) {\n    len = 16;\n  }\n  if (base == null) {\n    base = 32;\n  }\n  randomRangeInt = function(min, max) {\n    return Math.floor(Math.random() * (max - min + 1)) + min;\n  };\n  uid = \"\";\n  for (i = _i = 0, _ref = len - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    uid += randomRangeInt(0, base - 1).toString(base).toUpperCase();\n  }\n  if (this.uids[uid] === true) {\n    return this.createUID(len, base);\n  }\n  this.uids[uid] = true;\n  return uid;\n};\n\nUtils.uids = {};\n\n/**\n * Chains an array of promises sequentially\n *\n * @param   {Array}   promises\n *    The list of promises\n *\n * @param   {Object}   data\n *    Data to be passes from promise to promise\n *\n * @return  {Promise}\n *    The promise chain\n*/\nUtils.chain = function(promises, data) {\n  var chain, promise, _i, _len;\n  chain = Promise.resolve(data);\n  for (_i = 0, _len = promises.length; _i < _len; _i++) {\n    promise = promises[_i];\n    chain = chain.then(promise);\n  }\n  return chain;\n};\n\n/**\n * Asynchronously transform an object using an array of functions\n *\n * @param   {Object}   value\n *    Data to be passes from promise to promise\n *\n * @param   {Array.<Function|Transform>}   transforms\n *    The list of transforms\n *\n * @return  {Promise.<Object>}\n *    The transformed object\n*/\nUtils.transform = function(value, transforms) {\n  var exec, index, len, next;\n  if (!(transforms != null) || transforms.length === 0) {\n    return Promise.resolve(value);\n  }\n  transforms = transforms.map(function(item) {\n    if (typeof item.transform === \"function\") {\n      return item.transform;\n    } else {\n      return item;\n    }\n  });\n  index = 0;\n  len = transforms.length - 1;\n  next = function(value) {\n    index++;\n    return exec(value);\n  };\n  exec = function(value) {\n    var transform;\n    transform = transforms[index];\n    if (typeof transform !== \"function\") {\n      throw new Error(\"Transform must be a valid function\");\n    }\n    return Promise.resolve(transform(value, next)).then(function(result) {\n      if (index < len) {\n        return next(result);\n      } else {\n        return result;\n      }\n    });\n  };\n  return exec(value);\n};\n\n/**\n * Converts an array buffer to UTF-8 string.\n *\n * @param   {ArrayBuffer}   arrayBuffer\n *    The ArrayBuffer\n *\n * @return  {String}\n *    The UTF-8 string\n*/\nUtils.arrayBufferToString = function(arrayBuffer) {\n  return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));\n};\n\n/**\n * Parses a JSON Web Token\n *\n * @param {String} jwt\n *\n * @return {Object}\n *    The parsed JSON Web Token as an object\n*/\nUtils.parseJWT = function(jwt) {\n  var parts;\n  parts = jwt.split(\".\");\n  return {\n    header: JSON.parse(atob(parts[0])),\n    payload: JSON.parse(atob(parts[1])),\n    signature: parts[2]\n  };\n};\n\n/**\n *\n*/\nUtils.getFullScreenApi = function(container, video) {\n  var fullscreen;\n  fullscreen = {};\n  if (container.webkitRequestFullScreen != null) {\n    fullscreen.enter = container.webkitRequestFullScreen.bind(container);\n    fullscreen.exit = document.webkitExitFullscreen != null ? document.webkitExitFullscreen.bind(document) : document.webkitCancelFullScreen.bind(document);\n    fullscreen.event = \"onwebkitfullscreenchange\";\n    fullscreen.element = \"webkitFullscreenElement\";\n    fullscreen.error = \"webkitfullscreenerror\";\n  } else if (container.requestFullscreen != null) {\n    fullscreen.enter = container.requestFullscreen.bind(container);\n    fullscreen.exit = document.exitFullscreen != null ? document.exitFullscreen.bind(document) : document.cancelFullscreen.bind(document);\n    fullscreen.event = \"onfullscreenchange\";\n    fullscreen.element = \"fullscreenElement\";\n    fullscreen.error = \"fullscreenerror\";\n  } else if (container.mozRequestFullScreen != null) {\n    fullscreen.enter = container.mozRequestFullScreen.bind(container);\n    fullscreen.exit = document.mozCancelFullScreen.bind(document);\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n    fullscreen.error = \"mozfullscreenerror\";\n  } else if (container.msRequestFullscreen != null) {\n    fullscreen.enter = container.msRequestFullscreen.bind(container);\n    fullscreen.exit = document.msExitFullscreen.bind(document);\n    fullscreen.event = \"MSFullscreenChange\";\n    fullscreen.element = \"msFullscreenElement\";\n    fullscreen.error = \"MSFullscreenError\";\n  } else if (video.webkitEnterFullscreen != null) {\n    fullscreen.enter = video.webkitEnterFullscreen.bind(video);\n    fullscreen.exit = video.webkitExitFullscreen.bind(video);\n    fullscreen.event = null;\n    fullscreen.error = null;\n  }\n  return fullscreen;\n};\n\n/**\n*/\nUtils.stringToArray = function(string) {\n  var array, buffer, i, _i, _ref;\n  buffer = new ArrayBuffer(string.length * 2);\n  array = new Uint16Array(buffer);\n  for (i = _i = 0, _ref = string.length - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    array[i] = string.charCodeAt(i);\n  }\n  return array;\n};\n\n/**\n*/\nUtils.arrayToString = function(array) {\n  return String.fromCharCode.apply(null, new Uint16Array(array.buffer));\n};\n\n/**\n*/\nUtils.base64DecodeUint8Array = function(input) {\n  var array, i, raw, rawLength, _i, _ref;\n  raw = window.atob(input);\n  rawLength = raw.length;\n  array = new Uint8Array(new ArrayBuffer(rawLength));\n  for (i = _i = 0, _ref = rawLength - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    array[i] = raw.charCodeAt(i);\n  }\n  return array;\n};\n\n/**\n*/\nUtils.base64EncodeUint8Array = function(input) {\n  var keyStr = \"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\";\n    var output = \"\";\n    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;\n    var i = 0;\n\n    while (i < input.length) {\n      chr1 = input[i++];\n      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index\n      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here\n\n      enc1 = chr1 >> 2;\n      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);\n      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);\n      enc4 = chr3 & 63;\n\n      if (isNaN(chr2)) {\n        enc3 = enc4 = 64;\n      } else if (isNaN(chr3)) {\n        enc4 = 64;\n      }\n      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);\n    };\n  return output;\n};\n\n/**\n*/\nUtils.getKeySystem = function() {\n  var ua;\n  ua = navigator.userAgent;\n  if (/Edge/.test(ua) || /Trident/.test(ua)) {\n    return \"com.microsoft.playready\";\n  } else if (/Chrome/.test(ua) || /Firefox/.test(ua)) {\n    return \"com.widevine.alpha\";\n  } else {\n    return \"com.apple.fps.1_0\";\n  }\n};\n\n/**\n*/\nUtils.isAutoplaySupported = function() {\n  var supported;\n  supported = true;\n  if (this.isIOS()) {\n    if (this.getSafariVersion() !== -1) {\n      supported = this.getIOSversion()[0] >= 10;\n    } else if (this.isChrome()) {\n      supported = this.getChromeVersion() >= 53;\n    }\n  }\n  if (this.isChrome() && this.isAndroid()) {\n    supported = this.getChromeVersion() >= 53;\n  }\n  return supported;\n};\n\n/**\n*/\nUtils.fieldIsUnique = function(items, field, compare) {\n  var index, isUnique, item, _i, _len;\n  isUnique = true;\n  for (index = _i = 0, _len = items.length; _i < _len; index = ++_i) {\n    item = items[index];\n    if (item !== null && item !== void 0 && item[field] !== null && item[field] !== void 0 && item[field].toString().toLowerCase() === compare.toString().toLowerCase()) {\n      isUnique = false;\n      break;\n    }\n  }\n  return isUnique;\n};\n\n/**\n*/\nUtils.toCamelCase = function(str) {\n  return str.replace(/-([a-z])/g, function(g) {\n    return g[1].toUpperCase();\n  });\n};\n\n/**\n*/\nUtils.toHyphenated = function(str) {\n  return str.replace(/([A-Z])/g, function(g) {\n    return \"-\" + g[0].toLowerCase();\n  });\n};\n\n/**\n * Creates an HTML element.\n *\n * @param   {?(string|Array.<string>)}  classes\n * @param   {?DOMElement}  parent\n * @param   {?string} text\n * @param   {?string|DOMElement}  element\n * @return  {DOMElement}\n*/\nUtils.createElement = function(classes, parent, text, element) {\n  var classList, item, _i, _len;\n  if (element == null) {\n    element = \"div\";\n  }\n  if (typeof element === \"string\") {\n    element = document.createElement(element);\n  }\n  classList = element.classList;\n  if (classes != null) {\n    if (typeof classes === \"string\") {\n      classes = [classes];\n    }\n    for (_i = 0, _len = classes.length; _i < _len; _i++) {\n      item = classes[_i];\n      classList.add(item);\n    }\n  }\n  if (text != null) {\n    element.textContent = text;\n  }\n  if (parent != null) {\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n * The AMPConfig class\n *\n * @constructor\n * @private\n * @extends {EventDispatcher}\n*/\nfunction AMPConfig() {\n  AMPConfig.__super__.constructor.call(this, this, false);\n}\n\n\n__extends(AMPConfig, EventDispatcher);\n\n\nAMPConfig.UNINITIALIZED = 0;\n\nAMPConfig.LOADING = 1;\n\nAMPConfig.LOADED = 2;\n\n/**\n * Converst XML to a native JS object\n *\n * @param   {Element} xml   The XML to convert\n * @return  {Object}\n * @static\n*/\nAMPConfig.parseModule = function(xml) {\n  var child, childNodes, count, i, k, node, obj, _i, _len;\n  obj = {};\n  i = 0;\n  childNodes = xml.childNodes;\n  count = childNodes.length;\n  k = 0;\n  node = null;\n  child = null;\n  for (_i = 0, _len = childNodes.length; _i < _len; _i++) {\n    node = childNodes[_i];\n    if ((node != null ? node.nodeType : void 0) === 1) {\n      obj[node.nodeName] = this.parseItem(node);\n    }\n  }\n  return obj;\n};\n\nAMPConfig.parseItem = function(node) {\n  var child, children, type, value, _i, _len;\n  type = (\"\" + (node.getAttribute('type'))).toLowerCase();\n  value = node.textContent || node.text || node.innerText;\n  if (type !== \"object\" && type !== \"array\" && /#\\{.*\\}/.test(value)) {\n    return value;\n  }\n  switch (type) {\n    case \"object\":\n      value = this.parseModule(node);\n      break;\n    case \"array\":\n      value = [];\n      children = node.childNodes;\n      for (_i = 0, _len = children.length; _i < _len; _i++) {\n        child = children[_i];\n        if (child.nodeType !== 1) {\n          continue;\n        }\n        value.push(this.parseItem(child));\n      }\n      break;\n    case \"boolean\":\n      value = value.toLowerCase() === \"true\";\n      break;\n    case \"number\":\n      value = parseFloat(value);\n  }\n  return value;\n};\n\nAMPConfig.prototype.url = null;\n\nAMPConfig.prototype.data = null;\n\nAMPConfig.prototype.xml = null;\n\nAMPConfig.prototype.readyState = AMPConfig.UNINITIALIZED;\n\nAMPConfig.prototype.loaded = false;\n\nAMPConfig.prototype.flash = {\n  PlaybackMetricsPlugin: {\n    src: '#{paths.resources}plugins/PlaybackMetricsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"PlaybackMetricsPlugin\"\n  },\n  SubclipMonitorPlugin: {\n    src: '#{paths.resources}plugins/SubclipMonitorPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"SubclipMonitorPlugin\"\n  },\n  NetSessionClientPlugin: {\n    src: '#{paths.resources}plugins/NetSessionClientPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NetSessionClientPlugin\"\n  }\n};\n\n/**\n*/\nAMPConfig.prototype.loadURL = function(url, withCredentials) {\n  var _this = this;\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  this.url = url;\n  this.setReadyState(AMPConfig.LOADING);\n  Utils.request({\n    url: url,\n    withCredentials: withCredentials\n  }).then(function(xhr) {\n    var data, firstChild;\n    if (xhr.responseType === \"document\") {\n      _this.xml = xhr.responseXML;\n      firstChild = _this.xml.firstChild.nodeType !== 7 ? _this.xml.firstChild : _this.xml.childNodes[1];\n      data = AMPConfig.parseModule(firstChild);\n    } else {\n      data = xhr.response;\n      if (typeof data === \"string\") {\n        data = JSON.parse(data);\n      }\n    }\n    _this.loadData(data);\n  })[\"catch\"](function() {\n    _this.dispatchEvent(new Event(\"error\", event));\n    Logger.error(event);\n  });\n};\n\n/**\n*/\nAMPConfig.prototype.loadData = function(data) {\n  Config.defaults = data;\n  this.setReadyState(AMPConfig.LOADED);\n};\n\n/**\n*/\nAMPConfig.prototype.load = function(resource, withCredentials) {\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  switch (typeof resource) {\n    case \"object\":\n      this.loadData(resource);\n      break;\n    case \"string\":\n      this.loadURL(resource, withCredentials);\n      break;\n    default:\n      throw new Error(\"[AMP ERROR] Invalid default configuration resource\");\n  }\n};\n\n/**\n*/\nAMPConfig.prototype.setReadyState = function(state) {\n  this.readyState = state;\n  this.dispatchEvent(new Event(\"readystatechange\", state));\n  if (state === AMPConfig.LOADED && !this.loaded) {\n    this.loaded = true;\n    this.dispatchEvent(new Event(\"load\", this.data));\n  }\n};\n\n/**\n * The CaptionCue class.\n *\n * @constructor\n * @private\n * @param {number} startTime  The start time of the cue in seconds\n * @param {number} endTime    The end time of the cue in seconds\n * @param {number} text       The text of the cue\n*/\nfunction CaptionCue(startTime, endTime, id) {\n  this.startTime = startTime;\n  this.endTime = endTime;\n  this.id = id;\n}\n\nCaptionCue.prototype.id = null;\n\nCaptionCue.prototype.startTime = null;\n\nCaptionCue.prototype.endTime = null;\n\nCaptionCue.prototype.text = null;\n\nCaptionCue.prototype.html = null;\n\nCaptionCue.prototype.align = null;\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FeatureNotifications = {\n  REGISTER_FEATURE: \"registerfeature\"\n};\n\nfunction SRTParser() {}\n\n/**\n * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n *\n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {String}        txt   The text of the srt file\n * @return  {CaptionTrack}        The populated caption track\n*/\nSRTParser.prototype.parse = function(track, txt) {\n  var caption, captions, cue, end, index, parts, start, text, times, _i, _len;\n  txt = txt.replace(/\\r/g, '');\n  captions = txt.split(\"\\n\\n\");\n  for (_i = 0, _len = captions.length; _i < _len; _i++) {\n    caption = captions[_i];\n    parts = caption.split(\"\\n\");\n    try {\n      index = parts[0];\n      times = parts[1].match(/([0-9:\\,]+)\\s*-->\\s*([0-9:\\,]+)/).slice(1);\n      start = Utils.flattenTimecode(times[0]);\n      end = Utils.flattenTimecode(times[1]);\n      text = parts.slice(2);\n    } catch (err) {\n      Logger.instance.warn(\"SRT Parsing Warning\");\n    }\n    cue = new CaptionCue(start, end, \"cue_\" + index);\n    cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n    cue.text = text.join(\"\\n\");\n    track.cues.push(cue);\n  }\n  return track;\n};\n\nfunction WebVTTParser() {}\n\n/**\n * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n *\n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {String}        txt   The text of the srt file\n * @return  {CaptionTrack}        The populated caption track\n*/\nWebVTTParser.prototype.parse = function(track, txt) {\n  var caption, captions, cue, end, index, parts, settings, start, text, times, _i, _len;\n  txt = txt.replace(/\\r/g, '');\n  captions = txt.split(\"\\n\\n\");\n  index = 0;\n  if (/^WEBVTT/.test(captions[0])) {\n    captions.shift();\n  }\n  for (_i = 0, _len = captions.length; _i < _len; _i++) {\n    caption = captions[_i];\n    if (!(caption !== \"\")) {\n      continue;\n    }\n    parts = caption.trim().split(\"\\n\");\n    try {\n      index = /^[0-9]+$/.test(parts[0]) ? parts.shift() : ++index;\n      times = parts[0].match(/([0-9:\\.]+)\\s*-->\\s*([0-9:\\.]+)([^\\n]*)/).slice(1);\n      settings = times[2];\n      start = Utils.flattenTimecode(times[0]);\n      end = Utils.flattenTimecode(times[1]);\n      text = parts.slice(1);\n      cue = new CaptionCue(start, end, \"cue_\" + index);\n      cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n      cue.text = text.join(\"\\n\");\n      if (settings != null) {\n        settings.replace(/\\s*([A-Za-z]+)\\s*:\\s*([\\w\\-\\%]+)/g, function(match, $1, $2) {\n          cue[$1] = $2;\n          return \"\";\n        });\n      }\n      track.cues.push(cue);\n    } catch (err) {\n      Logger.instance.error(\"WebVTT Parse Error\");\n    }\n  }\n  return track;\n};\n\nfunction SMPTETTParser() {}\n\n/**\n * Parses a SMPTETT file into CaptionCue objects and attaches them to a given track.\n *\n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {XMLDocument}   xml   The SMPTETT xml document\n * @return  {CaptionTrack}        The populated caption track\n*/\nSMPTETTParser.prototype.parse = function(track, xml) {\n  var captions, lang, styledElements, styles, tt,\n    _this = this;\n  if (typeof xml === \"string\") {\n    xml = XMLUtils.parse(xml);\n  }\n  styles = Array.prototype.slice.call(xml.querySelectorAll(\"styling style\"));\n  styles.forEach(function(item, index, list) {\n    var attributes, id, style;\n    style = \"\";\n    id = item.getAttribute(\"id\") || item.getAttribute(\"xml:id\");\n    attributes = Array.prototype.slice.call(item.attributes);\n    attributes.forEach(function(item, index, array) {\n      if (item.prefix === \"tts\") {\n        return style += Utils.formatStyleName(item.localName) + \":\" + item.nodeValue + \";\";\n      }\n    });\n    track.styles[id] = style;\n  });\n  styledElements = Array.prototype.slice.call(xml.querySelectorAll(\"body [style]\"));\n  styledElements.forEach(function(item, index, array) {\n    var id;\n    id = item.getAttribute(\"style\");\n    item.setAttribute(\"style\", track.styles[id]);\n  });\n  tt = xml.querySelector(\"tt\");\n  lang = tt.getAttribute(\"lang\") || tt.getAttribute(\"xml:lang\");\n  if (track.language === void 0 || track.language === null) {\n    track.language = lang;\n  }\n  captions = Array.prototype.slice.call(xml.querySelectorAll(\"body p[begin]\"));\n  captions.forEach(function(item, index, array) {\n    var align, cue, end, start, text;\n    start = item.getAttribute(\"begin\");\n    item.removeAttribute(\"begin\");\n    if (item.getAttribute(\"end\") != null) {\n      end = item.getAttribute(\"end\");\n      item.removeAttribute(\"end\");\n    } else if (captions[index + 1] != null) {\n      end = captions[index + 1].getAttribute(\"begin\");\n    }\n    cue = new CaptionCue(Utils.flattenTimecode(start), Utils.flattenTimecode(end), \"cue_\" + index);\n    align = item.getAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n    if (align != null) {\n      cue.align = align === \"center\" ? \"middle\" : align;\n      item.removeAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n    }\n    text = XMLUtils.serialize(item);\n    text = text.replace(/\\s*xmlns=\"[^\"]*\"/, \"\");\n    cue.html = text;\n    text = text.replace(/^<p[^>]*>/, \"\");\n    text = text.replace(/<\\/p>$/, \"\");\n    text = text.replace(/<br\\/>/, \"\\n\");\n    text = text.replace(/<span style=\"([^\"]*)\"/, \"<c.$1\");\n    text = text.replace(/<\\/span>/, \"</c>\");\n    cue.text = text;\n    track.cues.push(cue);\n  });\n  return track;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction LiveCaptionProxy() {\n  var com,\n    _this = this;\n  this.captions = [];\n  this.head = document.getElementsByTagName(\"head\")[0];\n  com = window.com || {};\n  com.akamai = com.akamai || {};\n  com.akamai.amp = com.akamai.amp || {};\n  com.akamai.amp.plugins = com.akamai.amp.plugins || {};\n  com.akamai.amp.plugins.subply = com.akamai.amp.plugins.subply || {};\n  com.akamai.amp.plugins.subply.response = function(json) {\n    _this.parse(json);\n    _this.poll();\n  };\n  if (!(window.com != null)) {\n    window.com = com;\n  }\n  LiveCaptionProxy.__super__.constructor.call(this, this.constructor.NAME);\n}\n\n\n__extends(LiveCaptionProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nLiveCaptionProxy.NAME = \"LiveCaptionProxy\";\n\nLiveCaptionProxy.prototype.data = {\n  base: \"http://test.plymedia.com.s3.amazonaws.com/online/Akamai_\",\n  interval: 1000\n};\n\nLiveCaptionProxy.prototype.caption = null;\n\nLiveCaptionProxy.prototype.head = null;\n\nLiveCaptionProxy.prototype.script = null;\n\nLiveCaptionProxy.prototype.timeout = null;\n\n/**\n *\n*/\nLiveCaptionProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nLiveCaptionProxy.prototype.setURL = function(value) {\n  this.data.url = value;\n  return value;\n};\n\nLiveCaptionProxy.prototype.start = function() {\n  this.send();\n};\n\nLiveCaptionProxy.prototype.poll = function() {\n  var timeout,\n    _this = this;\n  timeout = setTimeout(function() {\n    _this.send();\n  }, this.data.interval || 1000);\n};\n\nLiveCaptionProxy.prototype.send = function() {\n  var _this = this;\n  if (this.script != null) {\n    this.head.removeChild(this.script);\n  }\n  this.script = Utils.loadScript(this.data.base + this.data.url + \".js?nocache=\" + Date.now()).then(function(script) {\n    return _this.script = script;\n  })[\"catch\"](function(error) {\n    return _this.facade.logger.error(\"[AMP CAPTIONING ERROR]\", error);\n  });\n};\n\nLiveCaptionProxy.prototype.stop = function() {\n  clearTimeout(timeout);\n};\n\n/**\n *\n*/\nLiveCaptionProxy.prototype.parse = function(response) {\n  var html, text, _i, _len, _ref;\n  if (response.Stream !== this.data.url) {\n    return;\n  }\n  if ((this.caption != null) && this.caption.id >= response.Ticks) {\n    return;\n  }\n  this.caption = new CaptionCue(Utils.flattenTimecode(response.From), Utils.flattenTimecode(response.To), response.Ticks);\n  this.caption.text = response.Text;\n  html = \"\";\n  _ref = response.Text.split(\"\\n\");\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    text = _ref[_i];\n    if (html !== \"\") {\n      html += \"<br />\";\n    }\n    html += \"<span>\" + text + \"</span>\";\n  }\n  this.caption.html = \"<p>\" + html + \"</p>\";\n  this.sendNotification(CaptioningNotifications.CUE_CHANGE, [this.caption]);\n  return this.caption;\n};\n\n/**\n * @constructor\n*/\nfunction AMP() {}\n\n/**\n * Create a player based on the configuration object and container.\n *\n * @param {string|HTMLElement} container\n *    The id of the div the player will be attached to.\n *\n * @param {?(Object|string)} config\n *    The configuration override object.\n *\n * @param {?Function} onready\n *    Optional ready handler.\n *\n * @return {Player}\n *\n*/\nAMP.create = function(container, config, onready) {\n  var element, initTime, player, version;\n  initTime = Date.now();\n  if (typeof container === \"string\") {\n    element = document.getElementById(container);\n    if (!(element != null)) {\n      element = document.querySelector(container);\n    }\n  } else {\n    element = container;\n  }\n  if (!(element != null)) {\n    throw new Error(\"[AMP ERROR] Invalid container. Could not find DOM element: \" + container);\n  }\n  config = config instanceof Config ? config : Config.create(config);\n  Logger.instance = new Logger(config.debug);\n  version = this.getVersion();\n  if (element.dataset == null) {\n    element.dataset = {};\n  }\n  element.dataset[\"amp.version\"] = version;\n  Logger.instance.log(\"[AMP] \" + version);\n  player = this.createPlayer(config, element);\n  player.initTime = player.performance.init = initTime;\n  element.amp = player;\n  player.request = this.request.bind(this);\n  player.require = this.require.bind(this);\n  player.loadResources = player.loadModuleResources.bind(player);\n  player.onready = onready;\n  player.initialize(config);\n  Utilization.track(\"create\");\n  return player;\n};\n\n/**\n *\n*/\nAMP.createPlayer = function(config, container) {\n  var player;\n  player = this.players[config.mode];\n  if (player != null) {\n    player = new player(container);\n  }\n  return player;\n};\n\n/**\n * Returns the version string for this player library.\n *\n * @return {string} The version string.\n*/\nAMP.getVersion = function() {\n  return this.VERSION;\n};\n\n/**\n * The player version string\n *\n * @type {string}\n * @private\n * @static\n*/\nAMP.VERSION = \"AMP - Premier : WebMD v2.99.6\";\n\n/**\n * @private\n*/\nAMP.defaults = new AMPConfig();\n\n/**\n * @private\n*/\nAMP.plugins = [];\n\n/**\n * @private\n*/\nAMP.players = {};\n\n/**\n * Loads a default configuration object from a url.\n *\n * @param {string} url\n *    A url to a configuration json file to use at the defaults object.\n *\n * @param {?Function} loaded\n *    Callback function triggered when the file has been loaded and\n *    sucessfully parsed.\n *\n * @param {?Function} error\n *    Callback function triggered when the file has failed to load\n *    or cannot be parsed.\n *\n * @param {boolean} [withCredentials=false]\n *    Whether or not to use credntials when making XMLHttpRequest.\n *\n * @static\n*/\nAMP.loadDefaults = function(url, loaded, error, withCredentials) {\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  if (loaded != null) {\n    this.defaults.addEventListener(\"load\", loaded);\n  }\n  if (error != null) {\n    this.defaults.addEventListener(\"error\", error);\n  }\n  this.defaults.load(url, withCredentials);\n};\n\n/**\n * Returns the playback mode best suited for the current environment.\n *\n * @return {PlaybackMode}\n *    The playback mode.\n *\n * @static\n*/\nAMP.getPlaybackMode = function() {\n  return Utils.getPlaybackMode();\n};\n\n/**\n * @private\n * @static\n*/\nAMP.registerPlayer = function(mode, player) {\n  this.players[mode] = player;\n};\n\n/**\n * Registers a plugin factory function. This function is\n * called when akamai.amp.AMP.create is called and the\n * config object contains the plugin key.\n *\n * @param {String} key\n *    The plugin key. Used to configure the plugin.\n *\n * @param {String|Array.<String>} mode\n *    The player mode(s) in which the plugin can be used.\n *\n * @param {Function} factory\n *\n * @static\n*/\nAMP.registerPlugin = function(id, mode, plugin) {\n  var item, _base, _i, _len, _ref;\n  if ((_base = this.plugins)[id] == null) {\n    _base[id] = {};\n  }\n  if (typeof mode === \"function\") {\n    _ref = [plugin, mode], mode = _ref[0], plugin = _ref[1];\n  }\n  if (typeof mode === \"string\") {\n    mode = [mode];\n  }\n  if (!(mode != null)) {\n    mode = [\"html\", \"flash\"];\n  }\n  for (_i = 0, _len = mode.length; _i < _len; _i++) {\n    item = mode[_i];\n    this.plugins[id][item] = plugin;\n  }\n};\n\n/**\n * @type {akamai.amp.ResourceManager}\n * @private\n*/\nAMP.resourceManager = null;\n\n/**\n * Short cut getter for the global renderer manager\n *\n * @return {akamai.amp.ResourceManager}\n *\n * @static\n * @private\n*/\nAMP.getResourceManager = function() {\n  if (!(this.resourceManager != null)) {\n    this.resourceManager = new ResourceManager();\n  }\n  return this.resourceManager;\n};\n\n/**\n * @param {akamai.amp.Resource} resource\n *    The resource definition\n *\n * @param {Function} callback\n *\n * @static\n * @private\n*/\nAMP.addResource = function(resource) {\n  return this.getResourceManager().add(resource);\n};\n\n/**\n * @param {Array.<akamai.amp.Resource>} resources\n *    The list of resources\n *\n * @param {Function} callback\n *\n * @static\n * @private\n*/\nAMP.addResources = function(resources) {\n  return this.getResourceManager().addResources(resources);\n};\n\n/**\n * Request a http resource.\n *\n * @param {String|Object} options\n *    A url string or an object containing the following properties:\n *\n * @return {Promise.<XHR>}\n *     Promise which resolves to a XHR object\n *\n * @static\n*/\nAMP.request = function(options) {\n  return Utils.request(options);\n};\n\n/**\n * Request a http json resource.\n *\n * @param {String|Object} options\n *    A url string or an object containing the following properties:\n *\n * @return {Promise.<Object>}\n *     Promise which resolves to a js object\n *\n * @static\n*/\nAMP.requestJson = function(options) {\n  return Utils.requestJson(options);\n};\n\n/**\n * Loads resource from url or cache\n *\n * @param {String} id\n *    A url or id of the resource\n *\n * @return {Promise.<Object>}\n *     Promise which resolves to an object\n *\n * @static\n*/\nAMP.require = function(id) {\n  return this.resourceManager.require(id);\n};\n\n/**\n * @param {!string} key\n *     The resource's key\n *\n * @return {akamai.amp.Resource}\n *     The resource definition\n *\n * @static\n * @private\n*/\nAMP.getResource = function(key) {\n  return this.getResourceManager().item(key);\n};\n\n/**\n * @param {!string} key\n *     The resource's key\n *\n * @return {Function}\n *     The resource's constructor\n *\n * @static\n * @private\n*/\nAMP.removeResource = function(key) {\n  return this.getResourceManager().remove(key);\n};\n\n/**\n * Evaluate a data bound object.\n *\n * @param {Object} binding\n *   The data bound object.\n *\n * @param {Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nAMP.evaluateBindings = function(value, context) {\n  return DataBinding.evaluateBindings(value, context);\n};\n\n\nAMP.registerPlayer(\"html\", HTMLPlayer);\nAMP.registerPlayer(\"flash\", FlashPlayer);\nAMP.registerPlayer(\"none\", InstallPlayer);\nAMP.registerPlayer(\"external\", ExternalPlayer);\n\n/**\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction PluginCommand() {\n  PluginCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginCommand, PlayerCommand);\n\n\nPluginCommand.prototype.plugin = null;\n\nPluginCommand.prototype.proxy = null;\n\n/** @override\n*/\nPluginCommand.prototype.initializeNotifier = function(key) {\n  PluginCommand.__super__.initializeNotifier.call(this, key);\n  this.proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.plugin = this.facade;\n};\n\n/**\n * The CaptioningChangeMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction CaptioningChangeMediaCommand() {\n  CaptioningChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningChangeMediaCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningChangeMediaCommand.prototype.execute = function(notification) {\n  var media, track;\n  media = notification.getBody();\n  track = notification.getBody().track;\n  this.proxy.setTracks(track);\n  if (!(track != null)) {\n    this.sendNotification(CaptioningNotifications.ENABLED, false);\n    return;\n  }\n  this.proxy.selectRenderer(media);\n  this.sendNotification(CaptioningNotifications.ENABLED, true);\n};\n\n/**\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction PluginEventCommand() {\n  PluginEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginEventCommand, PluginCommand);\n\n\n/**\n *\n*/\nPluginEventCommand.prototype.dispatchEvent = function(type, detail) {\n  var event, name, _base;\n  if (typeof type !== \"string\") {\n    detail = type.getBody();\n    if (!(detail != null)) {\n      detail = {};\n    }\n    type = type.getName();\n  }\n  name = typeof (_base = this.plugin).getFeatureName === \"function\" ? _base.getFeatureName() : void 0;\n  if ((name != null) && name !== \"auth\") {\n    type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n  }\n  name = this.plugin.getModuleName();\n  type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n  event = new Event(type, detail);\n  this.sendNotification(Notifications.DISPATCH_EVENT, event);\n};\n\n/**\n *\n*/\nPluginEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n  setTimeout(this.dispatchEvent.bind(this, type, detail), 0);\n};\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPluginEventCommand.prototype.execute = function(notification) {\n  this.dispatchEvent(notification);\n};\n\n/**\n * The CaptioningEnabledCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction CaptioningEnabledCommand() {\n  CaptioningEnabledCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningEnabledCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningEnabledCommand.prototype.execute = function(notification) {\n  this.proxy.setEnabled(notification.getBody());\n  CaptioningEnabledCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar UserSettingsNotifications = {\n  SETTING_CHANGE: \"settingchange\",\n  UPDATE_SETTINGS: \"updatesettings\"\n};\n\n/**\n * The ChangeVisibilityCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction CaptioningVisibilityChangeCommand() {\n  CaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningVisibilityChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n  var hidden;\n  hidden = !notification.getBody();\n  if (hidden === this.proxy.getHidden()) {\n    return;\n  }\n  this.proxy.setHidden(hidden);\n  CaptioningVisibilityChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The CaptioningTimeUpdateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction CaptioningTimeUpdateCommand() {\n  CaptioningTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningTimeUpdateCommand.prototype.execute = function(notification) {\n  var active, changed, cue, cues, index, time, track, _i, _len;\n  time = notification.getBody();\n  track = this.proxy.getTrack();\n  if (!(track != null)) {\n    return;\n  }\n  active = track.activeCues;\n  cues = track.cues;\n  changed = false;\n  for (_i = 0, _len = cues.length; _i < _len; _i++) {\n    cue = cues[_i];\n    if (time >= cue.startTime && time < cue.endTime) {\n      if (!(__indexOf.call(active, cue) >= 0)) {\n        active.push(cue);\n        changed = true;\n      }\n    } else {\n      index = active.indexOf(cue);\n      if (index !== -1) {\n        active.splice(index, 1);\n        changed = true;\n      }\n    }\n  }\n  if (changed === true) {\n    this.sendNotification(CaptioningNotifications.CUE_CHANGE, active);\n  }\n};\n\n/**\n * The CaptioningStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction CaptioningStartedCommand() {\n  CaptioningStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningStartedCommand.prototype.execute = function(notification) {\n  var proxy, track, _ref;\n  proxy = this.facade.retrieveProxy(CaptioningProxy.NAME);\n  track = proxy.getTrack();\n  if (!(track != null) && ((_ref = proxy.getTracks()) != null ? _ref.length : void 0) > 0) {\n    track = proxy.autoSelectTrack();\n  }\n  if ((track != null ? track.isLive : void 0) === true) {\n    this.facade.removeCommand(Notifications.TIME_UPDATE);\n    proxy = this.facade.retrieveProxy(LiveCaptionProxy.NAME);\n    if (!(proxy != null)) {\n      proxy = new LiveCaptionProxy();\n      this.facade.registerProxy(proxy);\n    }\n    proxy.setURL(track.src);\n    proxy.start();\n  }\n};\n\n/**\n * @private\n*/\n\nCaptionParsers = {\n  \"application/ttml+xml\": new SMPTETTParser(),\n  \"application/x-subrip\": new SRTParser(),\n  \"text/vtt\": new WebVTTParser(),\n  undefined: new SMPTETTParser()\n};\n\n/**\n * @param {FlashPlayer} player\n * @param {Object} config\n * @constructor\n * @private\n * @extends {puremvc.Mediator}\n*/\nfunction PluginWrapper(player, config) {\n  this.player = player;\n  this.config = config;\n  PluginWrapper.__super__.constructor.call(this);\n  this.dispatcher = new EventDispatcher(this);\n  this.createDefaults();\n}\n\n\n__extends(PluginWrapper, puremvc.Mediator);\n\n\nPluginWrapper.NAME = \"PluginWrapper\";\n\nPluginWrapper.prototype.player = null;\n\nPluginWrapper.prototype.config = null;\n\nPluginWrapper.prototype.dispatcher = null;\n\nPluginWrapper.prototype.flashPlugins = null;\n\nPluginWrapper.prototype.createFlashVars = null;\n\nPluginWrapper.prototype.createXML = null;\n\nPluginWrapper.prototype.createDefaults = function() {\n  this.player.createDefaults.call(this);\n};\n\n/**\n*/\nPluginWrapper.prototype.addEventListener = function(type, func) {\n  this.dispatcher.addEventListener(type, func);\n};\n\nPluginWrapper.prototype.logEvent = function(event) {};\n\n/**\n*/\nPluginWrapper.prototype.dispatchEvent = function(event) {\n  if (event.type !== \"timeupdate\" && event.type !== \"timeremaining\") {\n    this.player.logger.log(\"[AMP \" + (this.constructor.NAME.replace('Wrapper', '').toUpperCase()) + \" EVENT] \" + event.type, event);\n  }\n  event.player = this.player;\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n*/\nPluginWrapper.prototype.removeEventListener = function(type, func) {\n  this.dispatcher.removeEventListener(type, func);\n};\n\n/**\n*/\nPluginWrapper.prototype.createElement = function(xml, id, parent) {\n  var element;\n  element = xml.createElement(\"element\");\n  element.setAttribute(\"id\", id);\n  if (!(parent != null)) {\n    parent = this.getControls(xml).controls;\n  }\n  if (parent != null) {\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n*/\nPluginWrapper.prototype.createProperty = function(xml, key, value, parent) {\n  var property, text, val;\n  property = xml.createElement(\"property\");\n  property.setAttribute(\"key\", key);\n  if (parent != null) {\n    parent.appendChild(property);\n  }\n  if (value != null) {\n    if (typeof value === \"object\" && !(value instanceof Array)) {\n      for (key in value) {\n        val = value[key];\n        this.createProperty(xml, key, val, property);\n      }\n    } else {\n      text = XMLUtils.createTextContent(xml, value.toString());\n      property.appendChild(text);\n    }\n  }\n  return property;\n};\n\n/** @override\n*/\nPluginWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n};\n\n/**\n*/\nPluginWrapper.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      if (typeof this.createFlashVars === \"function\") {\n        this.createFlashVars(body.flashvars);\n      }\n      break;\n    case FlashNotifications.CREATE_XML:\n      if (typeof this.createXML === \"function\") {\n        this.createXML(body.xml);\n      }\n  }\n};\n\n/**\n*/\nPluginWrapper.prototype.destroy = function() {};\n\n/**\n * The CaptionTrack class.\n *\n * @constructor\n * @private\n * @param {?Object} track A generic track object.\n*/\nfunction CaptionTrack(track, onload) {\n  var _this = this;\n  CaptionTrack.__super__.constructor.call(this, {\n    kind: track.kind,\n    label: track.label || this.srclang || this.kind,\n    language: track.srclang\n  });\n  this.src = track.src;\n  this.type = track.type;\n  this.cues = track.cues || [];\n  this.styles = track.styles || {};\n  this.activeCues = [];\n  this.isLive = /live-subply/.test(this.type);\n  if ((this.src != null) && this.src !== \"\" && !this.isLive) {\n    Utils.request(this.src).then(function(xhr) {\n      try {\n        CaptionParsers[_this.type].parse(_this, xhr.response);\n      } catch (error) {\n        Logger.instance.error(\"Could not parse caption track: \" + _this.src);\n        return;\n      }\n      if (typeof onload === \"function\") {\n        onload();\n      }\n    })[\"catch\"](function(error) {\n      Logger.instance.error(\"Could not load caption track: \" + _this.src);\n    });\n  } else {\n    setTimeout(onload, 1);\n  }\n}\n\n\n__extends(CaptionTrack, Track);\n\n\nCaptionTrack.prototype.src = null;\n\nCaptionTrack.prototype.cues = null;\n\nCaptionTrack.prototype.activeCues = null;\n\nCaptionTrack.prototype.type = null;\n\nCaptionTrack.prototype.styles = null;\n\nCaptionTrack.prototype.isLive = false;\n\n/**\n * @constructor\n * @private\n*/\nfunction OverlayMediator() {\n  OverlayMediator.__super__.constructor.call(this, null, null, null, null);\n}\n\n\n__extends(OverlayMediator, ComponentMediator);\n\n\nOverlayMediator.prototype.componentType = \"overlay\";\n\n/**\n * Registers the overlay.\n *\n * @override\n*/\nOverlayMediator.prototype.onRegister = function() {\n  OverlayMediator.__super__.onRegister.call(this);\n  this.registerOverlay();\n};\n\n/**\n * Removes the overlay.\n *\n * @override\n*/\nOverlayMediator.prototype.onRemove = function() {\n  OverlayMediator.__super__.onRemove.call(this);\n  this.removeOverlay();\n};\n\n/**\n *\n*/\nOverlayMediator.prototype.registerOverlay = function() {\n  this.sendNotification(Notifications.ADD_OVERLAY, this.viewComponent);\n};\n\n/**\n *\n*/\nOverlayMediator.prototype.removeOverlay = function() {\n  this.sendNotification(Notifications.REMOVE_OVERLAY, this.viewComponent);\n};\n\n/**\n * The CaptioningProxy class\n *\n * @constructor\n * @private\n * @extends {PluginProxy}\n * @param   {Object}  config  The configuration object.\n*/\nfunction CaptioningProxy(config) {\n  this.activeCaptions = [];\n  this.providers = {};\n  this.tracks = [];\n  this.rendererMap = [];\n  this.track = {};\n  CaptioningProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(CaptioningProxy, PluginProxy);\n\n\n/** @static\n*/\nCaptioningProxy.NAME = ModuleProxy.NAME;\n\nCaptioningProxy.TEXT_TRACK_RENDERER = \"caption-text\";\n\nCaptioningProxy.prototype.defaults = {\n  useNative: false,\n  crossorigin: null\n};\n\nCaptioningProxy.prototype.enabled = false;\n\nCaptioningProxy.prototype.hidden = true;\n\nCaptioningProxy.prototype.tracks = null;\n\nCaptioningProxy.prototype.track = null;\n\nCaptioningProxy.prototype.activeCaptions = null;\n\nCaptioningProxy.prototype.captions = null;\n\nCaptioningProxy.prototype.loaded = true;\n\nCaptioningProxy.prototype.rendererMap = null;\n\n/**\n *\n*/\nCaptioningProxy.prototype.getUseNative = function() {\n  return this.getValue(\"useNative\");\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getCrossOrigin = function() {\n  return this.getValue(\"crossorigin\");\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getTracks = function() {\n  return this.tracks;\n};\n\nCaptioningProxy.prototype.setTracks = function(value) {\n  var count, item, loaded, track, trackLoaded, _i, _len,\n    _this = this;\n  this.tracks = [];\n  this.track = null;\n  if (!(value != null)) {\n    return;\n  }\n  count = value.length;\n  loaded = 0;\n  trackLoaded = function() {\n    loaded++;\n    if (loaded === count) {\n      _this.sendNotification(CaptioningNotifications.TRACKS_LOADED, _this.tracks);\n      _this.autoSelectTrack();\n    }\n  };\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    item = value[_i];\n    track = new CaptionTrack(item, trackLoaded);\n    this.tracks.push(track);\n  }\n  return value;\n};\n\n/**\n*/\nCaptioningProxy.prototype.registerRenderer = function(value) {\n  if (!(value != null)) {\n    return;\n  }\n  value.proxy = this;\n  this.rendererMap.push(value);\n};\n\n/**\n*/\nCaptioningProxy.prototype.retrieveRenderer = function(name) {\n  var value, _i, _len, _ref;\n  _ref = this.rendererMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    value = _ref[_i];\n    if (value.getRendererName() === name) {\n      return value;\n    }\n  }\n};\n\n/**\n*/\nCaptioningProxy.prototype.removeRenderer = function(name) {\n  var index, value;\n  value = this.retrieveRenderer(name);\n  value.proxy = null;\n  if (!(value != null)) {\n    return null;\n  }\n  index = this.rendererMap.indexOf(value);\n  this.rendererMap.splice(index, 1);\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getRenderer = function() {\n  return this.renderer;\n};\n\nCaptioningProxy.prototype.setRenderer = function(value) {\n  if (value === this.renderer) {\n    return value;\n  }\n  if (this.renderer != null) {\n    this.facade.removeMediator(CaptioningProxy.TEXT_TRACK_RENDERER);\n  }\n  this.renderer = value;\n  if (this.renderer != null) {\n    this.facade.registerMediator(this.renderer);\n  }\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectRenderer = function(media) {\n  var item, renderer, track, tracks, _i, _j, _len, _len1, _ref;\n  renderer = null;\n  tracks = media.track;\n  if (!(tracks != null)) {\n    return;\n  }\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    _ref = this.rendererMap;\n    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n      item = _ref[_j];\n      if (!(item.canUseResource(track) === true)) {\n        continue;\n      }\n      renderer = item;\n      break;\n    }\n    if (renderer != null) {\n      break;\n    }\n  }\n  this.setRenderer(renderer);\n  return renderer;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getTrack = function() {\n  return this.track;\n};\n\nCaptioningProxy.prototype.setTrack = function(value) {\n  this.track = value;\n  this.captions = this.track.cues;\n  this.activeCaptions = [];\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: {\n      track: this.track.flatten()\n    }\n  });\n  this.sendNotification(CaptioningNotifications.TRACK_SELECTED, this.track);\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectTrackByIndex = function(index) {\n  var track;\n  if ((0 <= index && index < this.tracks.length)) {\n    track = this.tracks[index];\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectTrackByLanguage = function(lang) {\n  var item, track, _i, _len, _ref;\n  _ref = this.tracks;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    item = _ref[_i];\n    if (!(item.language === lang)) {\n      continue;\n    }\n    track = item;\n    break;\n  }\n  if (track != null) {\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nCaptioningProxy.prototype.setHidden = function(value) {\n  this.hidden = value;\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nCaptioningProxy.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.autoSelectTrack = function() {\n  var lang, track, _ref;\n  lang = (_ref = this.facade.player.retrieveProxy(LocalizationProxy.NAME)) != null ? _ref.getLanguage() : void 0;\n  if (lang != null) {\n    lang = lang.split(\"-\").shift();\n    track = this.selectTrackByLanguage(lang);\n  }\n  if (!(track != null)) {\n    track = this.tracks[0];\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/**\n * PluginMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction PluginComponentMediator(componentName, componentType, parent, element) {\n  PluginComponentMediator.__super__.constructor.call(this, componentName, componentType, parent, element);\n}\n\n\n__extends(PluginComponentMediator, ComponentMediator);\n\n\n/** @override\n*/\nPluginComponentMediator.prototype.initializeNotifier = function(key) {\n  PluginComponentMediator.__super__.initializeNotifier.call(this, key);\n  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningNativeMediator(viewComponent) {\n  CaptioningNativeMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptioningNativeMediator, LocalizedMediator);\n\n\nCaptioningNativeMediator.prototype.video = null;\n\nCaptioningNativeMediator.prototype.index = -1;\n\nCaptioningNativeMediator.prototype.plugin = null;\n\nCaptioningNativeMediator.prototype.parallelement = null;\n\nCaptioningNativeMediator.prototype.paralleltimer = null;\n\nCaptioningNativeMediator.prototype.paddingvalue = 6;\n\nCaptioningNativeMediator.prototype.cueChangeListener = null;\n\nCaptioningNativeMediator.prototype.lineheight = 34;\n\nCaptioningNativeMediator.prototype.playerDefaultHeight = 648;\n\nCaptioningNativeMediator.NAME = CaptioningProxy.TEXT_TRACK_RENDERER;\n\n/**\n*/\nCaptioningNativeMediator.prototype.getRendererName = function() {\n  return \"native\";\n};\n\n/**\n*/\nCaptioningNativeMediator.prototype.canUseResource = function(resource) {\n  var hasNative, type, types, useNative;\n  if (!(resource != null)) {\n    return false;\n  }\n  hasNative = document.createElement(\"video\").textTracks != null;\n  if (!hasNative) {\n    return false;\n  }\n  types = [Utils.mimeTypes.vtt, Utils.mimeTypes.cea608, Utils.mimeTypes.cea708];\n  type = resource.type;\n  if (type === types[1] || type === types[2]) {\n    return true;\n  }\n  useNative = /iphone|ipad/.test(Utils.getDevice()) || this.proxy.getUseNative();\n  if (!useNative) {\n    return false;\n  }\n  return types.indexOf(resource.type) !== -1;\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.onRegister = function() {\n  this.plugin = this.facade.retrieveProxy(CaptioningProxy.NAME);\n  this.cueChangeListener = this.cueChange.bind(this);\n  if (Utils.getSafariVersion() < 0) {\n    this.facade.player.getMediaElement().textTracks.addEventListener(\"addtrack\", this.updateTrack.bind(this));\n  }\n  this.facade.player.getMediaElement().textTracks.addEventListener(\"cuechange\", this.cueChangeListener);\n  if ((this.plugin != null) && (this.plugin.config != null) && !this.plugin.config.hasOwnProperty('useparallelrendering')) {\n    this.plugin.config.useparallelrendering = false;\n  }\n};\n\n/** @override\n*/\nCaptioningNativeMediator.prototype.onRemove = function() {\n  if ((this.viewComponent != null) && (this.parallelelment != null)) {\n    this.viewComponent.removeChild(this.parallelement);\n    this.facade.player.getMediaElement().textTracks.removeEventListener(\"addtrack\", this.updateTrack);\n    this.facade.player.getMediaElement().textTracks.removeEventListener(\"cuechange\", this.cueChangeListener);\n  }\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.TRACKS_LOADED, Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, AdNotifications.BREAK_START];\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.handleNotification = function(notification) {\n  var body, crossorigin, element, track, video, _i, _len, _ref;\n  body = notification.getBody();\n  switch (notification.getName()) {\n    case CaptioningNotifications.TRACKS_LOADED:\n      this.tracks = body;\n      break;\n    case CaptioningNotifications.TRACK_SELECTED:\n      if (this.facade.player.getMediaElement().textTracks.length) {\n        track = this.facade.player.getMediaElement().textTracks[this.index];\n      }\n      if (track != null) {\n        track.mode = \"hidden\";\n      }\n      this.index = this.plugin.getTracks().indexOf(body);\n      this.lang = body.language;\n      this.updateTrack();\n      break;\n    case CaptioningNotifications.VISIBILITY_CHANGE:\n    case Notifications.CAN_PLAY_THROUGH:\n      this.updateTrack();\n      break;\n    case AdNotifications.BREAK_START:\n      this.clearCaption();\n      break;\n    case Notifications.LOADED_METADATA:\n      if (!(this.tracks != null)) {\n        return;\n      }\n      video = this.facade.player.getMediaElement();\n      crossorigin = this.plugin.getCrossOrigin();\n      if (crossorigin != null) {\n        video.setAttribute(\"crossorigin\", crossorigin);\n      }\n      _ref = this.tracks;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        track = _ref[_i];\n        if (!(track.type === Utils.mimeTypes.vtt)) {\n          continue;\n        }\n        element = document.createElement(\"track\");\n        element.src = track.src;\n        if (track.kind != null) {\n          element.kind = track.kind;\n        }\n        if (track.language != null) {\n          element.srclang = track.language;\n        }\n        if (track.label != null) {\n          element.label = track.label;\n        }\n        element[\"default\"] = \"default\" in track;\n        video.appendChild(element);\n      }\n      this.tracks = null;\n  }\n};\n\nCaptioningNativeMediator.prototype.updateTrack = function(event) {\n  var config, etrack, i, track, _i, _len, _ref, _ref1, _ref2;\n  config = this.plugin.config;\n  _ref = this.facade.player.getMediaElement().textTracks;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    track = _ref[i];\n    if (!(/subtitles|captions/.test(track.kind) && (track.language === this.lang || !track.language.length))) {\n      continue;\n    }\n    if (!(track != null)) {\n      return;\n    }\n    this.index = i;\n    if (this.getTracksByKind(track.kind).length > 1) {\n      this.suppressDupeTracks(track.kind, [1]);\n      if (i === 1) {\n        track.mode = this.plugin.getHidden() ? \"hidden\" : \"showing\";\n      }\n    }\n    if (track.kind === \"subtitles\") {\n      track.mode = \"hidden\";\n    } else {\n      if (config.useparallelrendering === false) {\n        track.mode = this.plugin.getHidden() ? \"hidden\" : \"showing\";\n      }\n    }\n  }\n  if (event) {\n    if (((_ref1 = event.track) != null ? _ref1.kind : void 0) === \"metadata\") {\n      return;\n    }\n  }\n  if (this.plugin.getHidden()) {\n    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {\n      if ((this.parallelement != null)) {\n        this.parallelement.style.display = \"none\";\n      }\n    } else {\n      this.clearCaption();\n    }\n  } else {\n    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {\n      if ((this.parallelement != null)) {\n        this.parallelement.style.display = \"inline\";\n      }\n    }\n  }\n  if ((_ref2 = this.plugin) != null ? _ref2.config.useparallelrendering : void 0) {\n    etrack = null;\n    if (!this.parallelement) {\n      this.createParallelement();\n    }\n    if (event) {\n      etrack = event.track;\n    }\n    if (etrack && etrack.language !== null && etrack.language !== this.lang) {\n      return;\n    }\n    this.useParallelRendering(this.plugin.config.useparallelrendering, etrack);\n  }\n};\n\nCaptioningNativeMediator.prototype.createParallelement = function() {\n  if (this.parallelement) {\n    return;\n  }\n  this.parallelement = document.createElement(\"div\");\n  this.parallelement.className = \"akamai-caption-container\";\n  this.viewComponent.appendChild(this.parallelement);\n  return this.parallelement;\n};\n\nCaptioningNativeMediator.prototype.useParallelRendering = function(value, track) {\n  var _ref, _ref1;\n  if ((_ref = this.plugin) != null) {\n    _ref.config.useparallelrendering = value;\n  }\n  if (!track && ((_ref1 = this.facade.player.getMediaElement().textTracks) != null ? _ref1.length : void 0)) {\n    track = this.facade.player.getMediaElement().textTracks[this.index];\n  }\n  if (track) {\n    if (value === true) {\n      if (track.hasCueChangeListener === false || typeof track.hasCueChangeListener === 'undefined') {\n        track.hasCueChangeListener = true;\n        return track.addEventListener(\"cuechange\", this.cueChangeListener);\n      }\n    } else {\n      track.hasCueChangeListener = false;\n      return track.removeEventListener(\"cuechange\", this.cueChangeListener);\n    }\n  }\n};\n\nCaptioningNativeMediator.prototype.cueChange = function(event) {\n  var capText, captionTextContainerArray, computedFontSize, cssLh, currentHeight, delay, diff, endtime, i, isPriority, maxCueBottom, percentChanged, shouldScaleFont, starttime, stl, temp, xPos, yPos;\n  isPriority = this.proxy.track ? this.proxy.track.kind === event.target.kind : true;\n  if (this.plugin.getHidden() || !isPriority) {\n    return;\n  }\n  maxCueBottom = 0;\n  shouldScaleFont = false;\n  if (this.paralleltimer) {\n    clearTimeout(this.paralleltimer);\n    this.paralleltimer = null;\n  }\n  if (this.parallelement) {\n    this.parallelement.innerHTML = \"\";\n  }\n  captionTextContainerArray = [];\n  i = 0;\n  while (i < event.target.activeCues.length) {\n    if ((new RegExp(\"^\\{\\\".*}$\")).test(event.target.activeCues[i].text)) {\n      return;\n    }\n    this.parallelement.style.display = \"inline\";\n    captionTextContainerArray[i] = document.createElement('div');\n    captionTextContainerArray[i].className = 'akamai-caption-text';\n    this.viewComponent.getElementsByClassName('akamai-caption-container')[0].appendChild(captionTextContainerArray[i]);\n    capText = document.createElement('p');\n    captionTextContainerArray[i].appendChild(capText);\n    cssLh = window.getComputedStyle(capText).lineHeight.replace(\"px\", \"\");\n    if (cssLh) {\n      this.lineheight = cssLh;\n    }\n    xPos = void 0;\n    if (navigator.userAgent.indexOf('Firefox') !== -1) {\n      xPos = event.target.activeCues[i].position - 50 + '%';\n    } else {\n      xPos = event.target.activeCues[i].position + '%';\n    }\n    yPos = void 0;\n    currentHeight = this.facade.player.getMediaElement().getBoundingClientRect().height;\n    percentChanged = currentHeight / this.playerDefaultHeight * 100;\n    stl = event.target.activeCues[i].snapToLines;\n    if (stl !== null && (event.target.activeCues[i].snapToLines === true || typeof stl === 'undefined')) {\n      yPos = event.target.activeCues[i].line * (this.lineheight / 100 * percentChanged);\n    } else {\n      yPos = currentHeight / 100 * event.target.activeCues[i].line * 10;\n    }\n    if (i > 0 && yPos) {\n      diff = this.viewComponent.getElementsByClassName('akamai-caption-container')[0].childNodes[0].offsetHeight - (this.lineheight / 100 * percentChanged);\n      yPos = yPos + diff * i;\n    }\n    yPos = yPos + 'px';\n    captionTextContainerArray[i].style.left = xPos;\n    captionTextContainerArray[i].style.top = yPos;\n    captionTextContainerArray[i].style.textAlign = 'left';\n    captionTextContainerArray[i].style.position = 'absolute';\n    captionTextContainerArray[i].style.bottom = 'auto';\n    captionTextContainerArray[i].style.display = 'inline';\n    captionTextContainerArray[i].style.padding = this.paddingvalue + 'px';\n    captionTextContainerArray[i].style.width = 'auto';\n    captionTextContainerArray[i].style['min-height'] = '0px';\n    capText.innerHTML = event.target.activeCues[i].text;\n    capText.style.margin = '0px';\n    capText.style.display = 'block';\n    capText.style.lineHeight = \"normal\";\n    computedFontSize = null;\n    try {\n      temp = document.createElement('span');\n      temp.style.fontSize = JSON.parse(localStorage.getItem(\"akamai-captioningDefault\")).size;\n      captionTextContainerArray[i].appendChild(temp);\n      computedFontSize = window.getComputedStyle(temp).fontSize.replace(\"px\", \"\");\n      temp = null;\n    } catch (_error) {}\n    if (computedFontSize) {\n      if (shouldScaleFont) {\n        computedFontSize = computedFontSize / 100 * percentChanged;\n        capText.style.fontSize = computedFontSize + \"px\";\n      }\n      maxCueBottom = Math.max(maxCueBottom, (Number(yPos.replace(\"px\", \"\")) || 0) + captionTextContainerArray[i].getBoundingClientRect().height);\n    }\n    if (i === event.target.activeCues.length - 1) {\n      endtime = event.target.activeCues[i].endTime ? event.target.activeCues[i].endTime : 0;\n      starttime = event.target.activeCues[i].startTime ? event.target.activeCues[i].startTime : 0;\n      delay = (endtime - starttime) * 1000;\n      if (delay > 500) {\n        this.paralleltimer = setTimeout(this.clearCaption.bind(this), delay);\n      }\n    }\n    i++;\n  }\n  if (maxCueBottom > currentHeight) {\n    maxCueBottom = maxCueBottom - currentHeight;\n    i = 0;\n    while (i < captionTextContainerArray.length) {\n      captionTextContainerArray[i].style.top = (Number(captionTextContainerArray[i].style.top.replace(\"px\", \"\")) - maxCueBottom) + \"px\";\n      i++;\n    }\n  }\n};\n\nCaptioningNativeMediator.prototype.clearCaption = function() {\n  if (this.paralleltimer) {\n    clearTimeout(this.paralleltimer);\n    this.paralleltimer = null;\n  }\n  if (this.parallelement) {\n    this.parallelement.innerHTML = \"\";\n  }\n};\n\nCaptioningNativeMediator.prototype.getTracksByKind = function(kind) {\n  var stracks, track, tracks, _i, _len;\n  tracks = this.facade.player.getMediaElement().textTracks;\n  stracks = [];\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    if (track.kind === kind && track.language === \"en\") {\n      stracks.push(track);\n    }\n  }\n  return stracks;\n};\n\nCaptioningNativeMediator.prototype.suppressDupeTracks = function(kind, exclude) {\n  var i, track, _i, _len, _ref;\n  _ref = this.getTracksByKind(kind);\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    track = _ref[i];\n    if (track.kind === kind && track.language === \"en\") {\n      if ((exclude != null) && (new RegExp(i)).test(exclude)) {\n        continue;\n      }\n      track.mode = \"hidden\";\n    }\n  }\n  return i > 0;\n};\n\n/**\n * The CaptioningHTMLMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningHTMLMediator(viewComponent) {\n  CaptioningHTMLMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n}\n\n\n__extends(CaptioningHTMLMediator, PluginComponentMediator);\n\n\nCaptioningHTMLMediator.prototype.componentName = CaptioningProxy.TEXT_TRACK_RENDERER;\n\nCaptioningHTMLMediator.prototype.captionText = null;\n\n/**\n*/\nCaptioningHTMLMediator.prototype.getRendererName = function() {\n  return \"html\";\n};\n\n/** @override\n*/\nCaptioningHTMLMediator.prototype.onRemove = function() {\n  if (this.viewComponent !== null) {\n    while (this.viewComponent.firstChild) {\n      this.viewComponent.removeChild(this.viewComponent.firstChild);\n    }\n  }\n};\n\n/**\n*/\nCaptioningHTMLMediator.prototype.canUseResource = function(resource) {\n  var types;\n  if (!(resource != null)) {\n    return false;\n  }\n  types = [Utils.mimeTypes.srt, Utils.mimeTypes.ttml, Utils.mimeTypes.vtt];\n  return types.indexOf(resource.type) !== -1;\n};\n\n/* Get Caption Container Display Height\n*/\nCaptioningHTMLMediator.prototype.getCaptionDisplayHeight = function() {\n  var height, i, length;\n  height = 0;\n  i = length = this.viewComponent.childNodes.length;\n  while (i) {\n    --i;\n    if (length === 3 && i === 0) {\n      break;\n    }\n    height += Utils.getActualSize(this.viewComponent.childNodes[i]).height;\n  }\n  return height + \"px\";\n};\n\n/* Scroll Captions\n*/\nCaptioningHTMLMediator.prototype.scrollCaptions = function(scrollHeight, scrollTop, steps) {\n  var scroll, stepSize,\n    _this = this;\n  if (scrollHeight == null) {\n    scrollHeight = this.viewComponent.scrollHeight;\n  }\n  if (scrollTop == null) {\n    scrollTop = this.viewComponent.scrollTop;\n  }\n  if (steps == null) {\n    steps = 20;\n  }\n  stepSize = (scrollHeight - scrollTop) / steps;\n  scroll = function() {\n    var _results;\n    if (scrollTop < scrollHeight) {\n      _this.viewComponent.scrollTop = scrollTop += stepSize;\n      return setTimeout(scroll, 20);\n    } else {\n      _results = [];\n      while (_this.viewComponent.childNodes.length > 2) {\n        _results.push(_this.viewComponent.removeChild(_this.viewComponent.firstChild));\n      }\n      return _results;\n    }\n  };\n  scroll();\n};\n\n/**\n * @override\n*/\nCaptioningHTMLMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.CUE_CHANGE, Notifications.CHANGE_MEDIA];\n};\n\n/**\n * @override\n*/\nCaptioningHTMLMediator.prototype.handleNotification = function(notification) {\n  var body, captions, child, childNode, cue, i, name, settings, temp, _i, _j, _k, _len, _len1, _len2, _ref, _ref1;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.CHANGE_MEDIA:\n      this.viewComponent.innerHTML = \"\";\n      break;\n    case CaptioningNotifications.CUE_CHANGE:\n      settings = this.facade.player.settings.captions || {};\n      captions = \"\";\n      settings.scroll = settings.scroll.toLowerCase().replace('-', '');\n      for (_i = 0, _len = body.length; _i < _len; _i++) {\n        cue = body[_i];\n        _ref = this.viewComponent.children;\n        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n          child = _ref[_j];\n          if ((new RegExp(cue.html)).test(child.outerHTML) && settings.scroll === \"popout\") {\n            continue;\n          }\n        }\n        captions += cue.html;\n      }\n      if (settings.scroll === \"painton\") {\n        this.classList.add(\"captioning-typed\");\n      } else {\n        this.classList.remove(\"captioning-typed\");\n      }\n      switch (settings.scroll) {\n        case \"popout\":\n          this.viewComponent.innerHTML = captions;\n          break;\n        case \"rollon\":\n        case \"painton\":\n          temp = document.createElement(\"div\");\n          temp.innerHTML = captions;\n          _ref1 = temp.childNodes;\n          for (i = _k = 0, _len2 = _ref1.length; _k < _len2; i = ++_k) {\n            childNode = _ref1[i];\n            if (this.viewComponent.children.length && (new RegExp(childNode.innerText)).test(this.viewComponent.lastChild.innerText)) {\n              continue;\n            }\n            this.viewComponent.appendChild(childNode);\n          }\n          this.viewComponent.style.maxHeight = this.getCaptionDisplayHeight();\n          this.scrollCaptions();\n      }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar CaptioningNotifications = {\n  VISIBILITY_CHANGE: \"captioningvisibilitychange\",\n  ENABLED: \"captioningenabled\",\n  TRACKS_LOADED: \"captioningtracksloaded\",\n  TRACK_SELECTED: \"captioningtrackselected\",\n  CUE_CHANGE: \"captioningcuechange\",\n  SETTINGS_VISIBILITY_CHANGE: \"captioningsettingsvisibility\",\n  TOGGLE_SETTINGS_VISIBILITY: \"togglesettingsvisibility\",\n  SETTINGS_CHANGE: \"captioningsettingschange\"\n};\n\nfunction LocalizationConstants() {}\n\nLocalizationConstants.MSG_LIVE = \"MSG_LIVE\";\n\nLocalizationConstants.MSG_REPLAY = \"MSG_REPLAY\";\n\nLocalizationConstants.MSG_BUFFERING = \"MSG_BUFFERING_TEXT\";\n\nLocalizationConstants.MSG_CC = \"MSG_CC\";\n\nLocalizationConstants.MSG_CC_TITLE = \"MSG_CC_TITLE\";\n\nLocalizationConstants.MSG_CC_LANGUAGE = \"MSG_CC_LANGUAGE\";\n\nLocalizationConstants.MSG_CC_PRESETS = \"MSG_CC_PRESETS\";\n\nLocalizationConstants.MSG_CC_FONT = \"MSG_CC_FONT\";\n\nLocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\nLocalizationConstants.MSG_CC_SIZE = \"MSG_CC_SIZE\";\n\nLocalizationConstants.MSG_CC_SCROLL = \"MSG_CC_SCROLL\";\n\nLocalizationConstants.MSG_CC_COLOR = \"MSG_CC_COLOR\";\n\nLocalizationConstants.MSG_CC_BACKGROUND = \"MSG_CC_BACKGROUND\";\n\nLocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\nLocalizationConstants.MSG_CC_WINDOW = \"MSG_CC_WINDOW\";\n\nLocalizationConstants.MSG_CC_OPACITY = \"MSG_CC_OPACITY\";\n\nLocalizationConstants.MSG_CC_SHOW_ADVANCED = \"MSG_CC_SHOW_ADVANCED\";\n\nLocalizationConstants.MSG_CC_HIDE_ADVANCED = \"MSG_CC_HIDE_ADVANCED\";\n\nLocalizationConstants.MSG_CC_RESET = \"MSG_CC_RESET\";\n\nLocalizationConstants.MSG_CC_CANCEL = \"MSG_CC_CANCEL\";\n\nLocalizationConstants.MSG_CC_APPLY = \"MSG_CC_APPLY\";\n\nLocalizationConstants.MSG_CC_PREVIEW_TEXT = \"MSG_CC_PREVIEW_TEXT\";\n\nLocalizationConstants.MSG_SECONDS = \"MSG_SECONDS\";\n\nLocalizationConstants.MSG_RECOMMENDATIONS_TITLE = \"MSG_RECOMMENDATIONS_TITLE\";\n\nLocalizationConstants.MSG_NEXT_VIDEO = \"MSG_NEXT_VIDEO\";\n\nLocalizationConstants.MSG_NEXT_AD = \"MSG_NEXT_AD\";\n\nLocalizationConstants.MSG_TIME_SEPARATOR = \"MSG_TIME_SEPARATOR\";\n\nLocalizationConstants.MSG_VIEW_ALL = \"MSG_VIEW_ALL\";\n\nLocalizationConstants.MSG_VIDEO = \"MSG_VIDEO\";\n\n/**\n * PluginMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction PluginMediator() {\n  PluginMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PluginMediator, OverlayMediator);\n\n\n/** @override\n*/\nPluginMediator.prototype.initializeNotifier = function(key) {\n  PluginMediator.__super__.initializeNotifier.call(this, key);\n  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n};\n\n/** @override\n*/\nPluginMediator.prototype.onRegister = function() {\n  PluginMediator.__super__.onRegister.call(this);\n  this.facade.viewComponent = this.viewComponent;\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningMediator(viewComponent) {\n  CaptioningMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptioningMediator, PluginMediator);\n\n\nCaptioningMediator.prototype.componentName = \"captioning\";\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.onRegister = function() {\n  CaptioningMediator.__super__.onRegister.call(this);\n  this.captioningStyle = this.create(null, document.getElementsByTagName(\"head\")[0], \"style\");\n  this.captioningStyle.type = \"text/css\";\n  this.applyStyles();\n};\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.ENABLED, CaptioningNotifications.TRACK_SELECTED, Notifications.SETTINGS_CHANGE];\n};\n\n/** @override\n*/\nCaptioningMediator.prototype.onRemove = function() {\n  var parent;\n  if (this.captioningStyle) {\n    parent = document.getElementsByTagName(\"head\")[0];\n    parent.removeChild(this.captioningStyle);\n  }\n};\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.handleNotification = function(notification) {\n  var body, note, state;\n  body = notification.getBody();\n  note = body ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  switch (notification.getName()) {\n    case CaptioningNotifications.TRACK_SELECTED:\n      state = \"cc-embedded\";\n      note = body.type === \"embedded\" ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n      break;\n    case CaptioningNotifications.VISIBILITY_CHANGE:\n      state = \"cc-active\";\n      break;\n    case CaptioningNotifications.ENABLED:\n      note = body ? Notifications.ADD_CONTROL_STATE : Notifications.REMOVE_CONTROL_STATE;\n      state = \"cc-enabled\";\n      if (!body) {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"cc-active\");\n      }\n      break;\n    case Notifications.SETTINGS_CHANGE:\n      if (body.captions != null) {\n        this.applyStyles();\n      }\n  }\n  this.sendNotification(note, state);\n};\n\nCaptioningMediator.prototype.applyStyles = function() {\n  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, styles, windowColor, windowColorValue;\n  styles = this.facade.settings;\n  if (styles.visible != null) {\n    this.facade.hidden = !styles.visible;\n  }\n  fontFamily = \"font-family: \" + styles.fontFamily + \" !important;\";\n  edgeType = \"\" + styles.edgeType + \" \" + styles.edgeColor + \" !important;\";\n  fontSize = \"font-size: \" + styles.size + \" !important;\";\n  color = \"color: \" + styles.fontColor + \" !important;\";\n  backgroundColor = \"background-color: \" + styles.backgroundColor + \" !important;\";\n  windowColor = \"background-color: \" + styles.windowColor + \" !important;\";\n  containerStyle = \"line-height:2.2em;\";\n  windowColorValue = windowColor.match(/rgba\\([^)]+\\)/g);\n  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {\n    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\\)/, '$1')) === 0 ? \"\" : containerStyle;\n  }\n  id = this.facade.player.viewComponent.id;\n  this.captioningStyle.innerHTML = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + '#' + id + ' video::-webkit-media-text-track-display { ' + windowColor + ' } #' + id + ' video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } #' + id + ' video::-webkit-media-text-track-display { ' + windowColor + ' } #' + id + ' video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } #' + id + ' video::-webkit-media-text-track-container {' + containerStyle + '} #' + id + ' video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';\n};\n\n/**\n * The CaptioningWrapper class.\n *\n * @constructor\n * @private\n * @extends {PluginWrapper}\n * @param {FlashPlayer}     player  The FlashPlayer\n * @param {Object}          config  The plugin config\n*/\nfunction CaptioningWrapper(player, config) {\n  CaptioningWrapper.__super__.constructor.call(this, player, config);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    visible: {\n      get: this.getVisible,\n      set: this.setVisible,\n      enumerable: true,\n      configurable: false\n    },\n    tracks: {\n      get: this.getTracks,\n      enumerable: true,\n      configurable: false\n    },\n    track: {\n      get: this.getTrack,\n      set: this.setTrack,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(CaptioningWrapper, PluginWrapper);\n\n\nCaptioningWrapper.NAME = \"CaptioningWrapper\";\n\nCaptioningWrapper.prototype.flashPlugins = [\n  {\n    id: \"AdobeCaptionPlugin\",\n    src: '#{paths.resources}plugins/AdobeCaptionPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdobeCaptionPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"AMPCaptionPlugin\",\n    src: '#{paths.resources}plugins/AMPCaptionPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AMPCaptionPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"CaptionSettingsPlugin\",\n    src: '#{paths.resources}plugins/CaptionSettingsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"CaptionSettingsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nCaptioningWrapper.prototype.flashView = {\n  elements: {\n    captionDisplay: {\n      attributes: {\n        defaultMessage: \"Sorry! No captions available for this stream\",\n        initState: \"cookie\",\n        position: \"relative\",\n        settingsEnabled: \"true\",\n        style: \"bottom: 0px; windowColor :0x000000; windowOpacity: 0; font: Monospaced Serif; fontColor: 0xffffff; fontOpacity: 1; fontBGColor: 0x000000; fontBGOpacity: 0; edgeType: none; edgeColor: 0x000000; edgeOpacity: 1; scroll: Pop-Out; fontSize: 12;\"\n      }\n    },\n    controls: {\n      elements: {\n        captionBtn: {}\n      }\n    }\n  }\n};\n\nCaptioningWrapper.prototype._hidden = true;\n\n/** @override\n*/\nCaptioningWrapper.prototype.createXML = function(xml) {\n  var application, player, subply, _ref;\n  subply = (_ref = this.config.flash) != null ? _ref.subply : void 0;\n  if (subply != null) {\n    try {\n      if (subply.timeMethod != null) {\n        player = xml.getElementsByTagName(\"player\")[0];\n        player.setAttribute(\"subply_time_method\", subply.timeMethod);\n      }\n      if (subply.plugin != null) {\n        application = xml.firstChild;\n        subply = xml.getElementsByTagName(\"subply\")[0];\n        if (!(subply != null)) {\n          subply = xml.createElement(\"subply\");\n          application.appendChild(subply);\n        }\n        this.createProperty(xml, \"SUBPLY_URL\", this.config.flash.subply.plugin, subply);\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP CAPTIONING ERROR]\", error);\n    }\n  }\n};\n\n/** @override\n*/\nCaptioningWrapper.prototype.createFlashVars = function(flashvars) {\n  var captionLangArr, captionUrlArr, config, track, _i, _len, _ref, _ref1;\n  config = this.player.config;\n  if (((_ref = config.media) != null ? _ref.track : void 0) != null) {\n    track = Utils.selectTrack(config.media.track, \"captions\");\n    if ((track.src != null) && track.src !== \"\") {\n      flashvars.caption_url = track.src;\n    }\n    if (config.media.track.length > 0) {\n      captionUrlArr = [];\n      captionLangArr = [];\n      _ref1 = config.media.track;\n      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {\n        track = _ref1[_i];\n        captionUrlArr.push(track.src);\n        captionLangArr.push(track.srclang);\n      }\n      flashvars.caption_url = captionUrlArr.join(\",\");\n      flashvars.caption_language = captionLangArr.join(\",\");\n    }\n    flashvars.caption_type = track.type != null ? encodeURIComponent(track.type) : \"application/ttml+xml\";\n  }\n  if (flashvars.caption_language == null) {\n    flashvars.caption_language = \"en-us\";\n  }\n};\n\n/** @override\n*/\nCaptioningWrapper.prototype.listNotificationInterests = function() {\n  return CaptioningWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIA_CHANGE, FlashNotifications.CAPTIONING_REQUEST, FlashNotifications.CAPTION_LANG_CHANGE, FlashNotifications.INITIALIZED]);\n};\n\n/**\n*/\nCaptioningWrapper.prototype.handleNotification = function(notification) {\n  var body, media, name, track, type,\n    _this = this;\n  CaptioningWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CAPTION_LANG_CHANGE:\n      type = \"\";\n      break;\n    case FlashNotifications.CAPTIONING_REQUEST:\n      type = \"visibilitychange\";\n      body = body.enabled;\n      this.hidden = !body;\n      break;\n    case Notifications.MEDIA_CHANGE:\n      media = body;\n      if (media.track != null) {\n        this._tracks = media.track.map(function(track) {\n          return Object.assign({\n            language: track.srclang\n          }, track);\n        });\n        track = Utils.selectTrack(this._tracks, \"captions\");\n        if (!(track != null)) {\n          return;\n        }\n        if ((track.src != null) && track.src !== \"\") {\n          media.captioningUrl = track.src;\n        }\n        if (track.type != null) {\n          media.captioningType = track.type || \"application/ttml+xml\";\n        }\n        this._track = track;\n      }\n      break;\n    case FlashNotifications.INITIALIZED:\n      this.hidden = !this.player.getMediaElement().getPlayerProperty(\"isCaptionVisible\");\n  }\n  if ((type != null) && type !== \"\") {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n*/\nCaptioningWrapper.prototype.getHidden = function() {\n  return this._hidden;\n};\n\nCaptioningWrapper.prototype.setHidden = function(value) {\n  this._hidden = value;\n  this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n    visible: !value\n  });\n  return value;\n};\n\n/**\n*/\nCaptioningWrapper.prototype.getVisible = function() {\n  return !this._hidden;\n};\n\nCaptioningWrapper.prototype.setVisible = function(value) {\n  this.setHidden(!value);\n  return value;\n};\n\n/**\n * Returns an array of caption tracks\n *\n * @return {Array.<CaptionTrack>} The list of text tracks.\n * @expose\n*/\nCaptioningWrapper.prototype.getTracks = function() {\n  return this._tracks || [];\n};\n\n/**\n * Returns the currently selected track.\n *\n * @return {CaptionTrack} The currently selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.getTrack = function() {\n  return this._track;\n};\n\n/**\n * Selects a caption track by its index in the getTracks array.\n *\n * @param {number}        index   The index to select\n * @return {CaptionTrack}         The selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.selectTrackByIndex = function(index) {};\n\n/**\n * Selects a caption track by it's language property.\n *\n * @param {string}        lang  The language to select\n * @return {CaptionTrack}       The selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.selectTrackByLanguage = function(lang) {\n  this.facade.getMediaElement().setTrackByLanguage(lang);\n};\n\n/**\n * Sets a caption Settings Object (styles)\n *\n * @param {Object}  object  The caption settings object.\n * @expose\n*/\nCaptioningWrapper.prototype.changeSettings = function(object) {\n  if (((object != null ? object.fontFamily : void 0) != null) && typeof object.fontFamily === \"object\") {\n    return this.facade.getMediaElement().setPlayerProperty(\"captionSettingsUI\", object);\n  }\n  if ((object != null ? object.visible : void 0) != null) {\n    this.hidden = !object.visible;\n  }\n  this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n    visible: !this.hidden,\n    style: this.parseObject(object)\n  });\n};\n\n/**\n * Parse Object\n *\n*/\nCaptioningWrapper.prototype.parseObject = function(object) {\n  var flashObject, keyString, prop, _ref;\n  flashObject = {};\n  try {\n    for (prop in object) {\n      switch (prop) {\n        case \"fontFamily\":\n          flashObject['font'] = object[prop];\n          break;\n        case \"fontColor\":\n        case \"backgroundColor\":\n        case \"edgeColor\":\n        case \"windowColor\":\n          keyString = prop === \"fontColor\" ? \"font\" : prop === \"backgroundColor\" ? \"fontBG\" : prop === \"edgeColor\" ? \"edge\" : \"window\";\n          if (((_ref = object[prop]) != null ? _ref.indexOf('rgba') : void 0) !== -1) {\n            flashObject[keyString + 'Color'] = this.parseRGBA(object[prop]);\n            flashObject[keyString + 'Opacity'] = object[prop].replace(/^.*,(.+)\\)/, '$1');\n          }\n          break;\n        default:\n          flashObject[prop] = object[prop];\n      }\n    }\n    delete flashObject['visible'];\n  } catch (error) {\n    this.facade.logger.error('Captioning Settings Parse Error', error);\n  }\n  return flashObject;\n};\n\nCaptioningWrapper.prototype.parseRGBA = function(rgb) {\n  rgb = rgb.match(/^rgba?[\\s+]?\\([\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?/i);\n  if (rgb && rgb.length === 4) {\n    return \"0x\" + (\"0\" + parseInt(rgb[1], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[2], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[3], 10).toString(16)).slice(-2);\n  }\n  return \"\";\n};\n\n\nAMP.registerPlugin(\"captioning\", \"flash\", CaptioningWrapper);\n\n/**\n * The Feature class. Acts as a base for features.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @param {Object}  config  The plugin's configuration object.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction Feature() {\n  Feature.__super__.constructor.call(this);\n}\n\n\n__extends(Feature, Plugin);\n\n\nFeature.NAME = \"Feature\";\n\nFeature.prototype.featureName = null;\n\n/**\n*/\nFeature.prototype.getFeatureName = function() {\n  return this.featureName;\n};\n\n/**\n*/\nFeature.prototype.registerFeature = function() {\n  if (this.getFeatureName() != null) {\n    this.player.sendNotification(FeatureNotifications.REGISTER_FEATURE, this);\n  }\n};\n\n/** @override\n*/\nFeature.prototype.onRegister = function() {\n  this.registerFeature();\n  Feature.__super__.onRegister.call(this);\n};\n\n/** @override\n*/\nFeature.prototype.listNotificationPublications = function() {\n  return Feature.__super__.listNotificationPublications.call(this).concat([FeatureNotifications.REGISTER_FEATURE]);\n};\n\n/**\n * @constructor\n * @private\n * @extends {contextMenuMediator}\n*/\nfunction contextMenuMediator() {\n  contextMenuMediator.__super__.constructor.call(this);\n}\n\n\n__extends(contextMenuMediator, OverlayMediator);\n\n\ncontextMenuMediator.prototype.componentName = \"context-menu\";\n\ncontextMenuMediator.prototype.contextMenu = null;\n\n/**\n * @override\n*/\ncontextMenuMediator.prototype.onRegister = function() {\n  var _this = this;\n  contextMenuMediator.__super__.onRegister.call(this);\n  EventHandler.create(this.facade.player.viewComponent, EventHandler.CONTEXTMENU, function(event) {\n    event.preventDefault();\n    _this.contextMenuHandler(event);\n    return false;\n  });\n};\n\n/** Context Menu Click Handler\n*/\ncontextMenuMediator.prototype.contextMenuHandler = function(event) {\n  var id, item,\n    _this = this;\n  if (this.contextMenu) {\n    this.removeContextMenu();\n  }\n  this.contextMenu = UI.create(\"context-menu\", document.body, \"ul\");\n  UI.create(\"context-item\", this.contextMenu, \"li\", this.facade.player.getVersion());\n  if (typeof akamaiGetViewerId !== \"undefined\" && akamaiGetViewerId !== null) {\n    id = akamaiGetViewerId();\n    item = UI.create(\"context-item\", this.contextMenu, \"li\", \"\" + (this.localizationManager.getString(\"MSG_VIEWER_ID\") || \"Viewer ID: \"));\n    UI.create(\"selectable\", item, \"span\", \"\" + (id != null ? id : \"N/A\"));\n  }\n  this.contextMenu.style.top = event.pageY + \"px\";\n  this.contextMenu.style.left = event.pageX + \"px\";\n  EventHandler.create(document.body, EventHandler.CLICK, function(event) {\n    if (/selectable/.test(event.target.className)) {\n      return false;\n    }\n    _this.removeContextMenu(event);\n    return false;\n  });\n};\n\n/** Remove ContextMenu Handler and DOM Object\n*/\ncontextMenuMediator.prototype.removeContextMenu = function(event) {\n  try {\n    EventHandler.clear(document.body, EventHandler.CLICK);\n    document.body.removeChild(this.contextMenu);\n    this.contextMenu = null;\n  } catch (_error) {}\n};\n\n/**\n * The IOSCursorMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction IOSCursorMediator() {\n  IOSCursorMediator.__super__.constructor.call(this, this.NAME);\n}\n\n\n__extends(IOSCursorMediator, OverlayMediator);\n\n\nIOSCursorMediator.NAME = \"IOSCursorMediator\";\n\nIOSCursorMediator.prototype.componentName = \"ioscursor\";\n\nIOSCursorMediator.prototype.container = null;\n\nIOSCursorMediator.prototype.onRegister = function() {\n  IOSCursorMediator.__super__.onRegister.call(this);\n  this.container = this.create(\"ioscursor-container\");\n};\n\n/**\n * @override\n*/\nIOSCursorMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n/**\n * @override\n*/\nIOSCursorMediator.prototype.handleNotification = function(notification) {\n  var _this = this;\n  switch (notification.getName()) {\n    case Notifications.READY:\n      if (!Utils.isIOS()) {\n        ClassList.add(\"hidden\", this.container, Namespace.PREFIX);\n      } else if (Utils.isIOS()) {\n        EventHandler.create(this.container, EventHandler.CLICK, function() {\n          return _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n        });\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction TitleBarMediator() {\n  TitleBarMediator.__super__.constructor.call(this);\n}\n\n\n__extends(TitleBarMediator, OverlayMediator);\n\n\nTitleBarMediator.prototype.componentName = \"title-bar\";\n\nTitleBarMediator.prototype.title = null;\n\nTitleBarMediator.prototype.description = null;\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.onRegister = function() {\n  TitleBarMediator.__super__.onRegister.call(this);\n  this.title = this.create(\"title-text\");\n  this.description = this.create(\"description-text\");\n};\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA];\n};\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.handleNotification = function(notification) {\n  var metadata, title;\n  switch (notification.getName()) {\n    case Notifications.CHANGE_MEDIA:\n      metadata = notification.getBody();\n      title = this.facade.player.evaluateBindings(metadata.title);\n      if (!(title != null) || title === \"\" || title === \"undefined\") {\n        this.classList.add(\"hidden\");\n      } else {\n        this.title.innerHTML = title;\n        this.description.innerHTML = metadata.description ? metadata.description : \"\";\n        this.classList.remove(\"hidden\");\n      }\n  }\n};\n\n/**\n * The ControlsWrapper class.\n *\n * @constructor\n * @private\n * @extends {PluginWrapper}\n * @param   {FlashPlayer}   player  The FlashPlayer\n * @param   {Object}        config  The plugin config\n*/\nfunction ControlsWrapper(player, config) {\n  ControlsWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(ControlsWrapper, PluginWrapper);\n\n\nControlsWrapper.NAME = \"ControlsWrapper\";\n\nControlsWrapper.prototype.mode = \"auto\";\n\nControlsWrapper.prototype.autoHide = 5;\n\nControlsWrapper.prototype.flashView = {\n  elements: {\n    controls: {\n      attributes: {\n        height: \"28\",\n        itemMargin: \"5\",\n        scrubPosition: \"inline\"\n      },\n      elements: {\n        replayBtn: {},\n        playPauseBtn: {},\n        streamTimeIndicator: {\n          attributes: {\n            exclude: \"live\"\n          },\n          elements: {\n            streamTime: {},\n            streamDuration: {}\n          }\n        },\n        rewindBtn: {},\n        scrubBar: {\n          attributes: {\n            style: \"height: 18px;\"\n          }\n        },\n        progressBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #FF0000, #1B1B1B);\"\n          }\n        },\n        loadedBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #00FF00, #1B1B1B);\"\n          }\n        },\n        liveIndicator: {},\n        timeLocationIndicator: {},\n        goLiveBtn: {},\n        statsBtn: {},\n        volumeBar: {\n          attributes: {\n            color: \"#CA2127\"\n          }\n        },\n        volumeBtn: {},\n        fullscreenBtn: {}\n      }\n    }\n  }\n};\n\n/** @override\n*/\nControlsWrapper.prototype.listNotificationInterests = function() {\n  return ControlsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIUM_CHANGE]);\n};\n\n/**\n*/\nControlsWrapper.prototype.handleNotification = function(notification) {\n  var body, mode, name;\n  ControlsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIUM_CHANGE:\n      mode = /audio/.test(body) ? \"persistent\" : this.mode;\n      this.setMode(mode);\n  }\n};\n\n/** @override\n*/\nControlsWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.mode != null) {\n    this.mode = flashvars.controls_mode = this.config.mode;\n  }\n  if ((this.config.admode != null) && this.config.admode !== this.config.mode) {\n    flashvars.ads_auto_fit = true;\n  }\n  flashvars.show_play_button_overlay = this.config.playoverlay != null ? this.config.playoverlay : true;\n  return flashvars;\n};\n\nControlsWrapper.prototype.createXML = function(xml) {\n  var controls, _ref, _ref1;\n  controls = (_ref = this.player.flashView) != null ? (_ref1 = _ref.elements) != null ? _ref1.controls : void 0 : void 0;\n  if (!(controls != null)) {\n    return;\n  }\n  if (controls.attributes[\"autoHideDelay\"] != null) {\n    this.autoHide = controls.attributes[\"autoHideDelay\"];\n  } else {\n    if (this.config.autoHide != null) {\n      this.autoHide = this.config.autoHide;\n      controls.attributes[\"autoHideDelay\"] = this.config.autoHide;\n    }\n  }\n  return xml;\n};\n\n/**\n*/\nControlsWrapper.prototype.getMode = function() {\n  return this.mode;\n};\n\nControlsWrapper.prototype.setMode = function(value) {\n  if (value === this.mode) {\n    return;\n  }\n  try {\n    this.mode = value;\n    this.player.mediaElement.setPlayerProperty(\"controlsMode\", value);\n  } catch (error) {\n    this.facade.logger.error(\"[AMP CONTROLS ERROR]\", error);\n  }\n  return value;\n};\n\nControlsWrapper.prototype.getAutoHide = function() {\n  return this.autoHide;\n};\n\n/**\n * The ControlsPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsPlayCommand() {\n  ControlsPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsPlayCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.start();\n};\n\n/**\n * The ControlsPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsPauseCommand() {\n  ControlsPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPauseCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsPauseCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.stop();\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsActiveStateChangeCommand() {\n  ControlsActiveStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsActiveStateChangeCommand.prototype.execute = function(notification) {\n  var app, body, controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  app = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n  body = notification.getBody();\n  if (body.value === ActiveState.ACTIVE && app.getPlayState() !== PlayState.READY && Utils.getDevice() !== \"desktop\") {\n    controls.start();\n  }\n};\n\n/**\n * The ControlsAdBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsAdBreakStartCommand() {\n  ControlsAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsAdBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsAdBreakStartCommand.prototype.execute = function(notification) {\n  if (this.plugin.config[\"native\"] === true) {\n    this.player.getMediaElement().controls = false;\n  } else {\n    this.proxy.adBreakStart();\n  }\n};\n\n/**\n * The ControlsAdBreakEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsAdBreakEndCommand() {\n  ControlsAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsAdBreakEndCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsAdBreakEndCommand.prototype.execute = function(notification) {\n  if (this.plugin.config[\"native\"] === true) {\n    this.player.getMediaElement().controls = true;\n  } else {\n    this.proxy.adBreakEnd();\n  }\n};\n\n/**\n * The ControlsMediaValidatedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsMediaValidatedCommand() {\n  ControlsMediaValidatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsMediaValidatedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsMediaValidatedCommand.prototype.execute = function(notification) {\n  var element, media, src;\n  media = notification.getBody();\n  src = media.poster;\n  element = this.facade.player.getMediaElement();\n  if ((src != null) && src !== \"\") {\n    element.poster = src;\n  }\n  element.src = media.src;\n  if (this.facade.player.getAutoplay() !== true) {\n    this.facade.applyClickHandler();\n  }\n};\n\n/**\n * The ControlsStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsStartedCommand() {\n  ControlsStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsStartedCommand.prototype.execute = function(notification) {\n  this.facade.applyClickHandler(false);\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsStartCommand() {\n  ControlsStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsStartCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.start();\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsDisplayStateChangeCommand() {\n  ControlsDisplayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsDisplayStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsDisplayStateChangeCommand.prototype.execute = function(notification) {\n  var controls, state;\n  state = notification.getBody().value;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  if (state === DisplayState.FULL_SCREEN) {\n    window.addEventListener(\"keypress\", controls.keypress);\n  } else if (state === DisplayState.NORMAL) {\n    window.removeEventListener(\"keypress\", controls.keypress);\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ControlsProxy(config) {\n  ControlsProxy.__super__.constructor.call(this, config);\n  this.keypress = this.keypress.bind(this);\n}\n\n\n__extends(ControlsProxy, ModuleProxy);\n\n\nControlsProxy.NAME = ModuleProxy.NAME;\n\nControlsProxy.prototype.defaults = {\n  mode: \"auto\",\n  autoHide: 3,\n  admode: null\n};\n\nControlsProxy.prototype.timeout = null;\n\nControlsProxy.prototype.appState = null;\n\nControlsProxy.prototype.controls = null;\n\nControlsProxy.prototype.interactiveElement = null;\n\nControlsProxy.prototype.idleUtil = null;\n\nControlsProxy.prototype.initializeNotifier = function(key) {\n  ControlsProxy.__super__.initializeNotifier.call(this, key);\n  this.appState = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n  this.controls = this.facade.retrieveMediator(ApplicationStateProxy.NAME);\n};\n\nControlsProxy.prototype.onRegister = function() {\n  var _this = this;\n  ControlsProxy.__super__.onRegister.call(this);\n  if (this.config.mode != null) {\n    this.changeMode(this.config.mode);\n  }\n  this.interactiveElement = this.facade.player.getContainer();\n  if (Utils.getDevice() === \"desktop\") {\n    this.facade.registerMediator(new IOSCursorMediator);\n    EventHandler.create(this.interactiveElement, \"mouseenter\", function() {\n      _this.stop();\n      if (_this.appState.activeState !== ActiveState.ACTIVE) {\n        _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n      }\n    });\n    EventHandler.create(this.interactiveElement, \"mouseleave\", function() {\n      _this.start();\n    });\n    this.idleUtil = new IdleUtil(this.facade.player.getViewComponent(), this.data.autoHide * 1000);\n    this.idleUtil.addEventListener(\"activechange\", function(event) {\n      var state;\n      state = event.detail.active !== true ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n      _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n    });\n    this.idleUtil.start();\n    EventHandler.create(this.facade.player.getMediaElement(), \"click\", function() {\n      _this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n    });\n  } else {\n    if (Utils.isIOS()) {\n      this.facade.registerMediator(new IOSCursorMediator);\n    }\n    EventHandler.create(this.interactiveElement, EventHandler.CLICK, function() {\n      _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n    });\n  }\n};\n\nControlsProxy.prototype.setMode = function(value) {\n  if (this.data.mode === value) {\n    return value;\n  }\n  this.changeMode(value);\n  return value;\n};\n\nControlsProxy.prototype.changeMode = function(value) {\n  if (this.data.mode === \"auto\") {\n    this.stop();\n  }\n  this.facade.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"controls-\" + this.data.mode);\n  this.data.mode = value;\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-\" + this.data.mode);\n};\n\nControlsProxy.prototype.getMode = function() {\n  return this.data.mode;\n};\n\nControlsProxy.prototype.setAutoHide = function(value) {\n  this.data.autoHide = value;\n  return value;\n};\n\nControlsProxy.prototype.getAutoHide = function() {\n  return this.data.autoHide;\n};\n\nControlsProxy.prototype.adBreakStart = function() {\n  if (this.data.admode != null) {\n    this.config.mode = this.getMode();\n    this.setMode(this.data.admode);\n  }\n};\n\nControlsProxy.prototype.adBreakEnd = function() {\n  if (this.data.admode != null) {\n    this.setMode(this.config.mode);\n  }\n};\n\nControlsProxy.prototype.start = function() {\n  this.stop();\n  if (this.data.mode !== \"auto\") {\n    return;\n  }\n  this.timeout = setTimeout(this.hide.bind(this), this.data.autoHide * 1000);\n};\n\nControlsProxy.prototype.keypress = function(event) {\n  switch (event.keyCode || event.which || event.charCode) {\n    case 27:\n      break;\n    case 32:\n      if (!this.facade.player.getEnded()) {\n        if (this.facade.player.getPaused()) {\n          this.facade.player.play();\n        } else {\n          this.facade.player.pause();\n        }\n      }\n  }\n};\n\nControlsProxy.prototype.stop = function() {\n  clearTimeout(this.timeout);\n  this.timeout = null;\n};\n\nControlsProxy.prototype.hide = function() {\n  if (this.data.mode !== \"auto\") {\n    return;\n  }\n  if ((this.appState.getIsUserActive() === true || Utils.isMouseOverElement(this.facade.viewComponent)) && this.appState.getDisplayState() !== DisplayState.FULL_SCREEN) {\n    this.start();\n    return;\n  }\n  this.facade.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.INACTIVE);\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction ReplayOverlayMediator() {\n  ReplayOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ReplayOverlayMediator, OverlayMediator);\n\n\nReplayOverlayMediator.prototype.componentName = \"replay\";\n\nReplayOverlayMediator.prototype.replay = null;\n\nReplayOverlayMediator.prototype.icon = null;\n\nReplayOverlayMediator.prototype.label = null;\n\n/**\n * @override\n*/\nReplayOverlayMediator.prototype.onRegister = function() {\n  ReplayOverlayMediator.__super__.onRegister.call(this);\n  this.replay = this.create(\"replay-button\");\n  this.replay.onclick = this.onclick.bind(this);\n  this.icon = this.create(\"replay-icon\", this.replay);\n  this.label = this.createText(\"replay-label\", this.localizationManager.getString(LocalizationConstants.MSG_REPLAY), this.replay);\n};\n\n/**\n*/\nReplayOverlayMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.REPLAY);\n  return false;\n};\n\n/**\n * ErrorLayerMediator class.\n *\n * @constructor\n * @extends {LayerMediator}\n * @private\n*/\nfunction ErrorLayerMediator() {\n  ErrorLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ErrorLayerMediator, LayerMediator);\n\n\nErrorLayerMediator.prototype.message = null;\n\nErrorLayerMediator.prototype.componentName = \"error\";\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.onRegister = function() {\n  ErrorLayerMediator.__super__.onRegister.call(this);\n  this.message = this.create(\"error-message\");\n};\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ERROR];\n};\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.handleNotification = function(notification) {\n  var error, msg;\n  switch (notification.getName()) {\n    case Notifications.ERROR:\n      error = notification.getBody();\n      msg = /^(Error: )/.test(error.toString()) ? \"\" : \"Error: \";\n      switch (error.code) {\n        case MediaError.MEDIA_ERR_ABORTED:\n          msg += \"Media was aborted.\";\n          break;\n        case MediaError.MEDIA_ERR_DECODE:\n          msg += \"Decode Error.\";\n          break;\n        case MediaError.MEDIA_ERR_NETWORK:\n          msg += \"Network Error.\";\n          break;\n        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:\n          msg += \"Source not supported.\";\n          break;\n        default:\n          msg += error;\n      }\n      this.message.textContent = msg;\n  }\n};\n\n/**\n * @constructor\n * @extends {OverlayMediator}\n * @private\n*/\nfunction LoadingOverlayMediator() {\n  LoadingOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(LoadingOverlayMediator, OverlayMediator);\n\n\nLoadingOverlayMediator.prototype.componentName = \"loading\";\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction WaitingOverlayMediator() {\n  WaitingOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(WaitingOverlayMediator, OverlayMediator);\n\n\nWaitingOverlayMediator.prototype.componentName = \"waiting\";\n\nWaitingOverlayMediator.prototype.bar = null;\n\nWaitingOverlayMediator.prototype.text = null;\n\nWaitingOverlayMediator.prototype.onRegister = function() {\n  WaitingOverlayMediator.__super__.onRegister.call(this);\n  this.bar = this.create(\"waiting-bar\");\n  this.text = this.createText(\"waiting-text\", this.localizationManager.getString(LocalizationConstants.MSG_BUFFERING));\n};\n\n/**\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction PosterMediator() {\n  PosterMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PosterMediator, OverlayMediator);\n\n\nPosterMediator.prototype.componentName = \"poster\";\n\nPosterMediator.prototype.poster = null;\n\nPosterMediator.prototype.clickHandler = null;\n\n/**\n * @override\n*/\nPosterMediator.prototype.onRegister = function() {\n  PosterMediator.__super__.onRegister.call(this);\n  this.poster = this.create(\"poster-content\");\n  this.poster.onclick = this.onclick.bind(this);\n};\n\n/**\n*/\nPosterMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n  return false;\n};\n\n/**\n * @override\n*/\nPosterMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.SET_MEDIA];\n};\n\n/**\n * @override\n*/\nPosterMediator.prototype.handleNotification = function(notification) {\n  var html, src;\n  switch (notification.getName()) {\n    case Notifications.SET_MEDIA:\n      src = notification.getBody().poster;\n      html = (src != null) && src !== \"\" ? \"<img src=\\\"\" + src + \"\\\" class=\\\"\" + this.cssPrefix + \"poster-image\\\" />\" : \"\";\n      this.poster.innerHTML = html;\n  }\n};\n\n/**\n*/\n/**\n * @constructor\n * @private\n*/\nfunction EndSlateMediator() {\n  EndSlateMediator.__super__.constructor.call(this);\n}\n\n\n__extends(EndSlateMediator, OverlayMediator);\n\n\nEndSlateMediator.prototype.componentName = \"end-slate\";\n\n/**\n * @override\n*/\nEndSlateMediator.prototype.onRegister = function() {\n  if (this.facade.config.endslate != null) {\n    EndSlateMediator.__super__.onRegister.call(this);\n  }\n};\n\nEndSlateMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\nEndSlateMediator.prototype.handleNotification = function(notification) {\n  var endslate, html, media, src, viewComponent;\n  switch (notification.getName()) {\n    case Notifications.MEDIA_CHANGE:\n      media = notification.getBody();\n      endslate = this.facade.config.endslate;\n      viewComponent = this.getViewComponent();\n      html = \"\";\n      if (endslate != null) {\n        src = endslate.usePoster === true ? media.poster : endslate.url;\n        if ((src != null) && src !== \"\") {\n          html = \"<img src=\\\"\" + src + \"\\\" class=\\\"end-slate-image\\\" />\";\n        }\n      }\n      if (viewComponent != null) {\n        viewComponent.innerHTML = html;\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ButtonMediator(labelText, parent, element, componentName, onclick) {\n  this.labelText = labelText;\n  this.onclick = onclick != null ? onclick : this.onclick;\n  ButtonMediator.__super__.constructor.call(this, componentName, null, parent, element);\n}\n\n\n__extends(ButtonMediator, ComponentMediator);\n\n\nButtonMediator.prototype.componentType = \"button\";\n\nButtonMediator.prototype.icon = null;\n\nButtonMediator.prototype.label = null;\n\nButtonMediator.prototype.onclick = null;\n\nButtonMediator.prototype.labelText = null;\n\nButtonMediator.prototype.onRegister = function() {\n  ButtonMediator.__super__.onRegister.call(this);\n  this.icon = this.create(\"icon\");\n  this.createLabel(this.labelText);\n};\n\nButtonMediator.prototype.createLabel = function(label) {\n  if (label != null) {\n    this.label = this.createText(\"label\", label);\n  }\n};\n\nButtonMediator.prototype.setLabel = function(value) {\n  if (!(this.label != null)) {\n    this.createLabel(value);\n  } else {\n    this.label.textContent = value;\n  }\n  return value;\n};\n\nButtonMediator.prototype.getLabel = function() {\n  var _ref;\n  return (_ref = this.label) != null ? _ref.textContent : void 0;\n};\n\n/**\n * The LogoMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction LogoMediator(parent) {\n  LogoMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(LogoMediator, ComponentMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {string}\n*/\nLogoMediator.prototype.componentName = \"logo\";\n\nLogoMediator.prototype.url = null;\n\n/**\n * @override\n*/\nLogoMediator.prototype.onRegister = function() {\n  LogoMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n};\n\nLogoMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"controlsLogoClicked\"));\n  return false;\n};\n\n/**\n * The FullScreenMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction FullScreenMediator(parent) {\n  FullScreenMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(FullScreenMediator, ButtonMediator);\n\n\nFullScreenMediator.prototype.componentName = \"full-screen\";\n\nFullScreenMediator.prototype.onRegister = function() {\n  FullScreenMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n};\n\nFullScreenMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.TOGGLE_FULL_SCREEN);\n  return false;\n};\n\n/**\n * @override\n*/\nFullScreenMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN];\n};\n\n/**\n * @override\n*/\nFullScreenMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.DISABLE_FULL_SCREEN:\n      this.setDisabled(true);\n      break;\n    case Notifications.ENABLE_FULL_SCREEN:\n      this.setDisabled(false);\n  }\n};\n\n/**\n * The VolumeMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction SliderMediator(parent, direction) {\n  this.direction = direction != null ? direction : this.direction;\n  SliderMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(SliderMediator, ComponentMediator);\n\n\nSliderMediator.prototype.componentType = \"slider\";\n\nSliderMediator.prototype.trackView = null;\n\nSliderMediator.prototype.handleView = null;\n\nSliderMediator.prototype.valueView = null;\n\nSliderMediator.prototype.startCapView = null;\n\nSliderMediator.prototype.endCapView = null;\n\nSliderMediator.prototype.clickView = null;\n\nSliderMediator.prototype.min = 0;\n\nSliderMediator.prototype.max = 1;\n\nSliderMediator.prototype.value = 0;\n\nSliderMediator.prototype.draggable = false;\n\nSliderMediator.prototype.dragging = false;\n\nSliderMediator.prototype.draggingInterval = null;\n\nSliderMediator.prototype.draggingDelay = 250;\n\nSliderMediator.prototype.direction = \"vertical\";\n\nSliderMediator.prototype.pressHandler = null;\n\nSliderMediator.prototype.releaseHandler = null;\n\nSliderMediator.prototype.moveHandler = null;\n\nSliderMediator.prototype.clickHandler = null;\n\n/**\n * @override\n*/\nSliderMediator.prototype.onRegister = function() {\n  SliderMediator.__super__.onRegister.call(this);\n  this.startCapView = this.create(\"start-cap\");\n  this.endCapView = this.create(\"end-cap\");\n  this.trackView = this.create(\"track\");\n  this.valueView = this.create(\"value\", this.trackView);\n  this.clickView = this.create(\"click\", this.trackView);\n  this.handleView = this.create(\"handle\", this.trackView);\n  this.pressHandler = EventHandler.create(this.handleView, EventHandler.PRESS, this.handlePressHandler.bind(this));\n  this.releaseHandler = EventHandler.create(window, EventHandler.RELEASE, this.handleReleaseHandler.bind(this));\n  this.releaseHandler.unbind();\n  this.moveHandler = EventHandler.create(window, EventHandler.MOVE, this.updateHandler.bind(this, this.draggable));\n  this.moveHandler.unbind();\n  this.clickHandler = EventHandler.create(this.clickView, EventHandler.CLICK, this.updateHandler.bind(this, true));\n};\n\n/** sets the value\n*/\nSliderMediator.prototype.setDirection = function(value) {\n  this.direction = value;\n  return value;\n};\n\nSliderMediator.prototype.getDirection = function() {\n  return this.direction;\n};\n\n/** sets the value\n*/\nSliderMediator.prototype.setValue = function(value) {\n  this.updateValue(value);\n  this.valueChanged();\n  return value;\n};\n\nSliderMediator.prototype.getValue = function() {\n  return this.value;\n};\n\nSliderMediator.prototype.setDragging = function(value) {\n  if (value === this.dragging) {\n    return;\n  }\n  this.dragging = value;\n  this.sendNotification(Notifications.IS_USER_ACTIVE, this.dragging);\n  if (this.dragging === true) {\n    this.draggingInterval = setInterval(this.valueChanged.bind(this), this.draggingDelay);\n  } else {\n    clearInterval(this.draggingInterval);\n    this.valueChanged();\n  }\n  return this.dragging;\n};\n\nSliderMediator.prototype.getDragging = function() {\n  return this.dragging;\n};\n\nSliderMediator.prototype.setDraggable = function(value) {\n  if (value === this.draggable) {\n    return;\n  }\n  this.draggable = value;\n  return value;\n};\n\nSliderMediator.prototype.getDraggable = function() {\n  return this.draggable;\n};\n\n/** updates the view\n*/\nSliderMediator.prototype.updateValue = function(value, force) {\n  var handle;\n  if (force == null) {\n    force = false;\n  }\n  if (value === this.value && force === false) {\n    return;\n  }\n  this.value = Utils.clamp(value, this.min, this.max);\n  if (this.direction === \"vertical\") {\n    value = \"height\";\n    handle = \"bottom\";\n  } else {\n    value = \"width\";\n    handle = \"left\";\n  }\n  this.valueView.style[value] = this.handleView.style[handle] = \"\" + (this.value * 100) + \"%\";\n};\n\n/** calculates the value based on mouse/touch point\n*/\nSliderMediator.prototype.calculateValue = function(event) {\n  var offset, pos, value;\n  pos = {\n    x: (event.pageX - (window.scrollX || window.pageXOffset)) || (event.targetTouches[0].pageX - window.scrollX),\n    y: (event.pageY - (window.scrollY || window.pageYOffset)) || (event.targetTouches[0].pageY - window.scrollY)\n  };\n  offset = Utils.getElementOffset(this.viewComponent);\n  if (this.getDirection() === \"vertical\") {\n    value = 1 - ((pos.y - offset.top) / offset.height);\n  } else {\n    value = (pos.x - offset.left) / offset.width;\n  }\n  return Utils.clamp(value, 0, 1);\n};\n\nSliderMediator.prototype.blockEvent = function(event) {\n  if (!(event != null)) {\n    return;\n  }\n  event.stopImmediatePropagation();\n  event.preventDefault();\n};\n\nSliderMediator.prototype.handlePressHandler = function(event) {\n  this.moveHandler.bind();\n  this.releaseHandler.bind();\n  this.clickHandler.unbind();\n  this.setDragging(true);\n  this.blockEvent(event);\n  return false;\n};\n\nSliderMediator.prototype.handleReleaseHandler = function(event) {\n  this.moveHandler.unbind();\n  this.releaseHandler.unbind();\n  this.clickHandler.bind();\n  this.setDragging(false);\n  this.blockEvent(event);\n  return false;\n};\n\nSliderMediator.prototype.updateHandler = function(setValue, event) {\n  var value;\n  this.blockEvent(event);\n  value = /click/.test(event.type) && this.classList.contains('scrubbing') ? this.getValue() : this.calculateValue(event);\n  if (setValue === true) {\n    this.setValue(value);\n  } else {\n    this.updateValue(value);\n  }\n  return false;\n};\n\nSliderMediator.prototype.valueChanged = function() {};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PanelNotifications = {\n  ADD_PANEL: \"addPanel\",\n  REMOVE_PANEL: \"removePanel\",\n  OPEN_PANEL: \"openPanel\",\n  CLOSE_PANEL: \"closePanel\",\n  TOGGLE_PANEL: \"togglePanel\",\n  CLOSE_ALL_PANELS: \"closeAllPanels\"\n};\n\n/**\n * The TimeDisplayMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction TimeDisplayMediator(parent) {\n  TimeDisplayMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(TimeDisplayMediator, ComponentMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {string}\n*/\nTimeDisplayMediator.prototype.componentName = \"time-display\";\n\nTimeDisplayMediator.prototype.duration = null;\n\nTimeDisplayMediator.prototype.currentTimeDisplay = null;\n\nTimeDisplayMediator.prototype.separatorDisplay = null;\n\nTimeDisplayMediator.prototype.durationDisplay = null;\n\nTimeDisplayMediator.prototype.liveDisplay = null;\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.onRegister = function() {\n  TimeDisplayMediator.__super__.onRegister.call(this);\n  this.liveDisplay = this.createText(\"live-display\", this.localizationManager.getString(LocalizationConstants.MSG_LIVE));\n  this.currentTimeDisplay = this.createText(\"current-time-display\", \"00:00\", this, \"span\");\n  this.separatorDisplay = this.createText(\"separator-display\", this.localizationManager.getString(LocalizationConstants.MSG_TIME_SEPARATOR), this, \"span\");\n  this.durationDisplay = this.createText(\"duration-display\", \"00:00\", this, \"span\");\n};\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAY, Notifications.DURATION_CHANGE, Notifications.ENDED, Notifications.DISPLAY_TIME];\n};\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAY:\n      this.updateDuration();\n      break;\n    case Notifications.DURATION_CHANGE:\n      this.updateCurrentTime();\n      this.updateDuration(body);\n      break;\n    case Notifications.ENDED:\n      this.updateCurrentTime(this.duration);\n      this.updateDuration();\n      break;\n    case Notifications.DISPLAY_TIME:\n      this.updateCurrentTime(body.currentTime, body.duration);\n      this.updateDuration(body.duration);\n  }\n};\n\nTimeDisplayMediator.prototype.updateCurrentTime = function(currentTime, duration) {\n  if (currentTime != null) {\n    this.currentTime = currentTime;\n  }\n  if (duration != null) {\n    this.duration = duration;\n  }\n  this.currentTimeDisplay.textContent = Utils.formatTimecode(this.currentTime, this.duration);\n};\n\nTimeDisplayMediator.prototype.updateDuration = function(duration) {\n  if (duration != null) {\n    this.duration = duration;\n  }\n  this.durationDisplay.textContent = Utils.formatTimecode(this.duration);\n};\n\n/**\n * The PlayPauseMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction GoLiveMediator(parent) {\n  GoLiveMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(GoLiveMediator, ButtonMediator);\n\n\nGoLiveMediator.prototype.componentName = \"go-live\";\n\nGoLiveMediator.prototype.onRegister = function() {\n  GoLiveMediator.__super__.onRegister.call(this);\n  this.createLabel(this.localizationManager.getString(\"MSG_LIVE\"));\n};\n\n/**\n * @override\n*/\nGoLiveMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.IS_LIVE];\n};\n\n/**\n * @override\n*/\nGoLiveMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.IS_LIVE:\n      this.setLabel(body === true ? this.localizationManager.getString(\"MSG_LIVE\") : this.localizationManager.getString(\"MSG_GO_LIVE\"));\n  }\n};\n\n/**\n*/\nGoLiveMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.GO_LIVE);\n  return false;\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction AdMediator() {\n  AdMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AdMediator, OverlayMediator);\n\n\nAdMediator.prototype.duration = null;\n\nAdMediator.prototype.currentTime = null;\n\nAdMediator.prototype.container = null;\n\nAdMediator.prototype.banner = null;\n\nAdMediator.prototype.text = null;\n\nAdMediator.prototype.adText = null;\n\nAdMediator.prototype.bg = null;\n\nAdMediator.prototype.totalAds = null;\n\nAdMediator.prototype.adPosition = null;\n\nAdMediator.prototype.adContainerRequired = true;\n\nAdMediator.prototype.componentName = \"ads\";\n\n/**\n * @override\n*/\nAdMediator.prototype.onRegister = function() {\n  AdMediator.__super__.onRegister.call(this);\n  if (this.adContainerRequired) {\n    this.container = this.create(\"ad-container\");\n  }\n  this.banner = this.create(\"ad-banner\");\n  this.bg = this.create(\"ad-text-bg\", this.banner);\n  this.adText = this.create(\"ad-text-title\", this.banner);\n  this.text = this.create(\"ad-text\", this.banner);\n  if (this.adContainerRequired) {\n    this.viewComponent.container = this.container;\n  }\n  this.sendNotification(AdNotifications.AD_CONTAINER_CREATED, this.viewComponent);\n};\n\n/**\n * @override\n*/\nAdMediator.prototype.listNotificationInterests = function() {\n  return [AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED];\n};\n\n/**\n * @override\n*/\nAdMediator.prototype.handleNotification = function(notification) {\n  var adVO, msg, time;\n  switch (notification.getName()) {\n    case AdNotifications.BREAK_END:\n      this.text.textContent = \"\";\n      this.adText.textContent = \"\";\n      break;\n    case AdNotifications.AD_TIME_REMAINING:\n      time = Math.round(notification.getBody());\n      if ((this.totalAds != null) && this.totalAds > 0 && (this.adPosition != null) && this.adPosition !== this.totalAds) {\n        msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_AD)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n      } else {\n        msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_VIDEO)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n      }\n      this.text.textContent = msg;\n      break;\n    case AdNotifications.AD_STARTED:\n      adVO = notification.getBody();\n      this.totalAds = adVO.totalAds;\n      this.adPosition = adVO.position;\n      msg = \"Ad \" + adVO.position + \" of \" + adVO.totalAds;\n      if ((adVO.position != null) && (adVO.totalAds != null) && adVO.totalAds >= 1) {\n        this.adText.textContent = msg;\n      }\n  }\n};\n\n/**\n * The PanelControlMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PanelControlMediator(componentName) {\n  PanelControlMediator.__super__.constructor.call(this, null, null, null, componentName, onclick);\n}\n\n\n__extends(PanelControlMediator, ButtonMediator);\n\n\nPanelControlMediator.prototype.panel = null;\n\nPanelControlMediator.prototype.timeout = null;\n\nPanelControlMediator.prototype.closePanelDelayed = null;\n\n/**\n * @override\n*/\nPanelControlMediator.prototype.onRegister = function() {\n  this.closePanelDelayed = this.delayedClosePanel.bind(this);\n  if (Utils.getDevice() === \"desktop\") {\n    this.onmouseleave = this.closePanelDelayed;\n    this.onmouseenter = this.openPanel;\n    this.onclick = this.clickHandler;\n  } else {\n    this.onclick = this.togglePanel;\n  }\n  PanelControlMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"\" + this.componentName + \"-enabled\");\n  this.sendNotification(Notifications.ADD_CONTROL, this.viewComponent);\n};\n\nPanelControlMediator.prototype.openPanel = function() {\n  clearTimeout(this.timeout);\n  this.sendNotification(PanelNotifications.OPEN_PANEL, this.panel);\n  this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n};\n\nPanelControlMediator.prototype.closePanel = function() {\n  if (Utils.isMouseOverElement(this.panel.viewComponent) || Utils.isMouseOverElement(this.viewComponent) || this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getIsUserActive()) {\n    return;\n  }\n  this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n};\n\nPanelControlMediator.prototype.delayedClosePanel = function() {\n  this.timeout = setTimeout(this.closePanel.bind(this), 350);\n};\n\nPanelControlMediator.prototype.togglePanel = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(PanelNotifications.TOGGLE_PANEL, this.panel);\n};\n\nPanelControlMediator.prototype.clickPanel = function() {};\n\n/**\n * The PlayPauseMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PanelMediator(componentName) {\n  PanelMediator.__super__.constructor.call(this, componentName, null, null, null);\n}\n\n\n__extends(PanelMediator, ComponentMediator);\n\n\nPanelMediator.prototype.componentType = \"panel\";\n\nPanelMediator.prototype.control = null;\n\n/**\n * @override\n*/\nPanelMediator.prototype.onRegister = function() {\n  PanelMediator.__super__.onRegister.call(this);\n  this.sendNotification(PanelNotifications.ADD_PANEL, this);\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptionsMediator(viewComponent) {\n  CaptionsMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptionsMediator, PluginMediator);\n\n\nCaptionsMediator.prototype.componentName = \"captioning\";\n\nCaptionsMediator.prototype.captionButton = null;\n\n/**\n * @override\n*/\nCaptionsMediator.prototype.onRegister = function() {\n  var button;\n  this.captioning = this.facade.player.captioning;\n  button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent, null, \"caption\", this.onclick.bind(this));\n  this.facade.registerMediator(button);\n  this.captionButton = button.getViewComponent();\n  this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n  CaptionsMediator.__super__.onRegister.call(this);\n};\n\n/**\n*/\nCaptionsMediator.prototype.onclick = function(event) {\n  var _ref;\n  event.stopImmediatePropagation();\n  if (((_ref = this.captioning.getTrack()) != null ? _ref.type : void 0) === \"embedded\") {\n    this.captioning.setHidden(!this.captioning.getHidden());\n  } else if (event.currentTarget === this.captionButton) {\n    this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, this.captioning.getHidden());\n  }\n  return false;\n};\n\n/**\n * The CaptioningSettingsMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptionsSettingsMediator(viewComponent) {\n  this.list = {\n    font: null,\n    language: null,\n    edge: null,\n    size: null,\n    scroll: null\n  };\n  this.picker = {\n    color: null,\n    background: null,\n    edge: null,\n    window: null\n  };\n  this.toggle = {\n    ON: null,\n    OFF: null,\n    disabled: false\n  };\n  this.captioningObject = {\n    \"default\": {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"small\",\n      scroll: \"popout\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    },\n    appliedStyleText: \"\",\n    selected: {\n      fontFamily: null,\n      size: null,\n      fontColor: null,\n      edgeType: null,\n      edgeColor: null,\n      backgroundColor: null,\n      windowColor: null\n    },\n    preset1: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset2: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,0,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset3: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,1)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset4: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,0,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 1)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    },\n    instance: null\n  };\n  CaptionsSettingsMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n}\n\n\n__extends(CaptionsSettingsMediator, PluginComponentMediator);\n\n\nCaptionsSettingsMediator.prototype.componentName = \"captioning-settings\";\n\nCaptionsSettingsMediator.prototype.settingsUiVisible = false;\n\nCaptionsSettingsMediator.prototype.captionningStyle = null;\n\nCaptionsSettingsMediator.prototype.swatchColorCurr = null;\n\nCaptionsSettingsMediator.prototype.swatchOpacityCurr = null;\n\nCaptionsSettingsMediator.prototype.colorPicker = null;\n\nCaptionsSettingsMediator.prototype.colorPickerOpacity = null;\n\nCaptionsSettingsMediator.prototype.advancedSettingContainer = null;\n\nCaptionsSettingsMediator.prototype.scroll = {\n  type: \"popout\",\n  typeSpeed: 5,\n  lines: 2,\n  scrollTimer: [],\n  speed: 10,\n  popout: null,\n  rollup: null,\n  painton: null\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.onRegister = function() {\n  var applyButton, cancelButton, captionContainer, captionLabel, clonedSwatch, color, colorArray, isDefault, preset1, preset2, preset3, preset4, previewContainer, previewPara, resetButton, swatch, titleBar, titleText, toggleAdvancedButton, _i, _len,\n    _this = this;\n  CaptionsSettingsMediator.__super__.onRegister.call(this);\n  this.captioning = this.facade.player.captioning;\n  titleBar = this.create(\"captioning-titlebar\");\n  titleText = this.create(\"captioning-title\", titleBar, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_TITLE));\n  this.toggle.OFF = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"OFF\");\n  this.toggle.ON = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"ON\");\n  EventHandler.create(this.toggle.ON, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    if (!_this.toggle.disabled) {\n      _this.toggleButtonHandler(true);\n    }\n    return false;\n  });\n  if (!this.toggle.disabled) {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n  }\n  EventHandler.create(this.toggle.OFF, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    if (!_this.toggle.disabled) {\n      _this.toggleButtonHandler(false);\n    }\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\");\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_LANGUAGE));\n  this.list.language = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.languageListPopulate();\n  EventHandler.create(this.list.language, \"change\", function(event) {\n    var langIsSelected;\n    event.stopImmediatePropagation();\n    langIsSelected = event.target.selectedValue !== \"None\";\n    _this.captioining.setHidden(!langIsSelected);\n    if (langIsSelected) {\n      _this.captioning.setTrack(_this.captioning.selectTrackByIndex(event.target.selectedIndex));\n    }\n    return false;\n  });\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PRESETS));\n  preset1 = this.create([\"captioning-preset\", \"captioning-preset1\"], captionContainer, null, \"Aa\");\n  preset2 = this.create([\"captioning-preset\", \"captioning-preset2\"], captionContainer, null, \"Aa\");\n  preset3 = this.create([\"captioning-preset\", \"captioning-preset3\"], captionContainer, null, \"Aa\");\n  preset4 = this.create([\"captioning-preset\", \"captioning-preset4\"], captionContainer, null, \"Aa\");\n  EventHandler.create(preset1, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset1);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset2, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset2);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset3, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset3);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset4, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset4);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  this.advancedSettingContainer = this.create(\"captioning-advanced-container\");\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_FONT));\n  this.list.font = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.font, \"option\", \"Monospaced Serif\").value = \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\";\n  this.create(null, this.list.font, \"option\", \"Proportional Serif\").value = \"'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif\";\n  this.create(null, this.list.font, \"option\", \"Monospaced Sans-Serif\").value = \"'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace\";\n  this.create(null, this.list.font, \"option\", \"Proportional Sans-Serif\").value = \"Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif\";\n  this.create(null, this.list.font, \"option\", \"Casual\").value = \"'Comic Sans MS', Impact, Handlee, fantasy\";\n  this.create(null, this.list.font, \"option\", \"Cursive\").value = \"'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive\";\n  this.create(null, this.list.font, \"option\", \"Small Capitals\").value = \"'Arial Unicode Ms', Arial, Helvetica, Verdana, 'Marcellus SC', sans-serif; font-variant: small-caps\";\n  EventHandler.create(this.list.font, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.fontFamily = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  captionContainer.appendChild(this.list.font);\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n  this.list.edge = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.edge, \"option\", \"None\").value = \"text-shadow: 0px 0px 0px\";\n  this.create(null, this.list.edge, \"option\", \"Depressed\").value = \"text-shadow: 0px 1px 0px\";\n  this.create(null, this.list.edge, \"option\", \"Left Drop Shadow\").value = \"text-shadow: -3px 3px 2px\";\n  this.create(null, this.list.edge, \"option\", \"Raised\").value = \"text-shadow: 0px 1px 1px\";\n  this.create(null, this.list.edge, \"option\", \"Right Drop Shadow\").value = \"text-shadow: 3px 3px 2px\";\n  this.create(null, this.list.edge, \"option\", \"Uniform\").value = \"text-shadow: 0px 0px 4px\";\n  EventHandler.create(this.list.edge, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.edgeType = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SIZE));\n  this.list.size = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.size, \"option\", \"Extra Small\").value = \"x-small\";\n  this.create(null, this.list.size, \"option\", \"Small\").value = \"small\";\n  this.create(null, this.list.size, \"option\", \"Medium\").value = \"medium\";\n  this.create(null, this.list.size, \"option\", \"Large\").value = \"large\";\n  this.create(null, this.list.size, \"option\", \"Extra Large\").value = \"x-large\";\n  this.list.size.selectedIndex = 1;\n  EventHandler.create(this.list.size, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.size = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SCROLL));\n  this.list.scroll = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.scroll, \"option\", \"Pop-Out\").value = \"popout\";\n  this.create(null, this.list.scroll, \"option\", \"Roll-On\").value = \"rollon\";\n  this.create(null, this.list.scroll, \"option\", \"Paint-On\").value = \"painton\";\n  EventHandler.create(this.list.scroll, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.scroll = _this.scroll.type = event.target.value;\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_COLOR));\n  this.picker.color = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n  EventHandler.create(this.picker.color, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"152px\";\n      _this.colorPicker.name = \"fontColor\";\n      _this.captioningObject.instance = _this.picker.color;\n      if (_this.picker.color.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.color.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_BACKGROUND));\n  this.picker.background = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n  EventHandler.create(this.picker.background, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"264px\";\n      _this.colorPicker.name = \"backgroundColor\";\n      _this.captioningObject.instance = _this.picker.background;\n      if (_this.picker.background.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.background.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n  this.picker.edge = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n  EventHandler.create(this.picker.edge, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"212px\";\n      _this.colorPicker.name = \"edgeColor\";\n      _this.captioningObject.instance = _this.picker.edge;\n      if (_this.picker.edge.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.edge.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_WINDOW));\n  this.picker.window = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n  EventHandler.create(this.picker.window, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"300px\";\n      _this.colorPicker.name = \"windowColor\";\n      _this.captioningObject.instance = _this.picker.window;\n      if (_this.picker.window.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.window.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  previewContainer = this.create([\"caption-text\", \"caption-text-preview\"]);\n  previewPara = this.create(null, previewContainer, \"p\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PREVIEW_TEXT));\n  captionContainer = this.create(\"captioning-footer-container\");\n  applyButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_APPLY));\n  cancelButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_CANCEL));\n  resetButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_RESET));\n  if (this.captioning.getViewComponent().clientWidth >= 0) {\n    toggleAdvancedButton = this.create(\"captioning-advanced-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED));\n    EventHandler.create(toggleAdvancedButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (_this.advancedSettingContainer.style.display === \"block\") {\n        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED);\n        _this.advancedSettingContainer.style.display = \"none\";\n        _this.colorPicker.style.display = \"none\";\n      } else {\n        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_HIDE_ADVANCED);\n        _this.advancedSettingContainer.style.display = \"block\";\n      }\n      return false;\n    });\n  }\n  EventHandler.create(applyButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n    _this.applyCaptioningStyle(false, true);\n    _this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, _this.captioningObject.selected);\n    return false;\n  });\n  EventHandler.create(cancelButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n    return false;\n  });\n  EventHandler.create(resetButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.colorPicker.style.display = \"none\";\n    _this.applyCaptioningStyle(true);\n    return false;\n  });\n  this.captionningStyle = this.create(null, document.getElementsByTagName('head')[0], \"style\");\n  this.captionningStyle.type = 'text/css';\n  colorArray = [\"#000000\", \"#660000\", \"#990000\", \"#ff0000\", \"#000066\", \"#660066\", \"#990066\", \"#ff0066\", \"#006600\", \"#666600\", \"#996600\", \"#ff6600\", \"#006666\", \"#666666\", \"#996666\", \"#ff6666\", \"#009900\", \"#669966\", \"#999900\", \"#ff9900\", \"#009966\", \"#669966\", \"#999966\", \"#ff9966\", \"#00ff00\", \"#66ff00\", \"#99ff00\", \"#ffff00\", \"#00ff66\", \"#66ff66\", \"#99ff66\", \"#ffff66\", \"#000099\", \"#660099\", \"#990099\", \"#ff0099\", \"#0000ff\", \"#6600ff\", \"#9900ff\", \"#ff00ff\", \"#006699\", \"#666699\", \"#996699\", \"#ff6699\", \"#0066ff\", \"#6666ff\", \"#9966ff\", \"#ff66ff\", \"#009999\", \"#669999\", \"#999999\", \"#ff9999\", \"#0099ff\", \"#6699ff\", \"#9999ff\", \"#ff99ff\", \"#0099ff\", \"#66ff99\", \"#99ff99\", \"#ffff99\", \"#00ffff\", \"#66ffff\", \"#99ffff\", \"#ffffff\"];\n  this.colorPicker = this.create(\"colorpicker-palette\", this.viewComponent.parentElement);\n  swatch = this.create(\"colorpicker-swatch\", false, null, \"&nbsp;\");\n  for (_i = 0, _len = colorArray.length; _i < _len; _i++) {\n    color = colorArray[_i];\n    swatch.style.backgroundColor = color;\n    clonedSwatch = swatch.cloneNode();\n    EventHandler.create(clonedSwatch, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (_this.swatchColorCurr !== null) {\n        _this.swatchColorCurr.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.swatchColorCurr = event.target;\n      _this.swatchColorCurr.style.borderColor = \"rgba(255, 50, 50, 1)\";\n      _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(event.target.style.backgroundColor);\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    this.colorPicker.appendChild(clonedSwatch);\n  }\n  this.create(\"opacity-label\", this.colorPicker, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_OPACITY));\n  this.colorPickerOpacity = this.create(\"colorpicker-slider\", this.colorPicker, \"input\");\n  this.colorPickerOpacity.type = \"range\";\n  this.colorPickerOpacity.min = 0;\n  this.colorPickerOpacity.max = 1;\n  this.colorPickerOpacity.step = .1;\n  this.colorPickerOpacity.value = 1;\n  EventHandler.create(this.colorPickerOpacity, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(_this.captioningObject.instance.style.backgroundColor);\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  this.swatchOpacityCurr = this.colorPickerOpacity;\n  try {\n    if (localStorage.getItem(Namespace.PREFIX + \"captioningDefault\") != null) {\n      this.captioningObject.selected = JSON.parse(localStorage.getItem(Namespace.PREFIX + \"captioningDefault\"));\n      this.applyCaptioningStyle(false, !this.captioning.getHidden());\n    } else {\n      isDefault = !((this.captioning.config.style != null) || this.captioning.config.style !== \"undefined\");\n      if (!isDefault) {\n        this.captioningObject.selected = this.cloneObject(this.captioning.config.style);\n      }\n      this.applyCaptioningStyle(isDefault);\n    }\n  } catch (_error) {}\n  this.setSettings(Object.keys(this.captioningObject.selected).length > 0 ? this.captioningObject.selected : this.captioningObject[\"default\"]);\n  this.toggleButtonHandler(!this.captioning.getHidden(), false);\n};\n\nCaptionsSettingsMediator.prototype.toRGBA = function(colorCode) {\n  var rbga, rgb;\n  rgb = colorCode.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',');\n  rbga = 'rgba(' + rgb[0] + \",\" + rgb[1] + \",\" + rgb[2] + \",\" + this.swatchOpacityCurr.value + ')';\n  return rbga;\n};\n\nCaptionsSettingsMediator.prototype.onScrollListChange = function(value) {\n  var _ref;\n  if (value != null) {\n    this.captioningObject.selected.scroll = this.scroll.type = value;\n  }\n  this.setSettings({\n    scroll: this.scroll.type\n  });\n  try {\n    if (((_ref = this.captioning.proxy.renderer) != null ? _ref.viewComponent : void 0) != null) {\n      if (this.scroll.type === \"painton\") {\n        ClassList.add(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n      } else {\n        ClassList.remove(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"AMP Captioning Error\", error);\n  }\n};\n\nCaptionsSettingsMediator.prototype.languageListPopulate = function() {\n  var language, track, tracks, _i, _len, _ref;\n  tracks = this.captioning.getTracks();\n  if (!(tracks != null)) {\n    return;\n  }\n  this.list.language.innerHTML = \"\";\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    language = track.language;\n    language = this.facade.player.retrieveProxy(LocalizationProxy.NAME).getLanguageString(language);\n    if ((language != null) && language !== \"\") {\n      this.create(null, this.list.language, \"option\", language).value = track.language;\n    }\n  }\n  this.toggle.disabled = this.list.language.childElementCount === 0;\n  if (this.toggle.disabled) {\n    this.create(null, this.list.language, \"option\", \"None\");\n  }\n  this.list.language.value = (_ref = this.captioning.getTrack()) != null ? _ref.language : void 0;\n};\n\nCaptionsSettingsMediator.prototype.colorPickerHandler = function(unbind) {\n  var _this = this;\n  if (unbind == null) {\n    unbind = false;\n  }\n  if (unbind) {\n    return EventHandler.unbind(document, EventHandler.CLICK);\n  }\n  EventHandler.create(document, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler(true);\n    if (event.target.className !== \"akamai-colorpicker-palette\" && event.target.className !== \"akamai-opacity-label\" && event.target.className !== \"akamai-colorpicker-slider\" && _this.colorPicker.style.display !== \"none\") {\n      _this.colorPicker.style.display = \"none\";\n    }\n    return false;\n  });\n};\n\nCaptionsSettingsMediator.prototype.cloneObject = function(clone) {\n  var cloned, key;\n  cloned = {};\n  for (key in clone) {\n    cloned[key] = clone[key];\n  }\n  return cloned;\n};\n\nCaptionsSettingsMediator.prototype.applyCaptioningStyle = function(isDefault, isApply, settingsDefault) {\n  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, windowColor, windowColorValue;\n  if (isDefault == null) {\n    isDefault = false;\n  }\n  if (isApply == null) {\n    isApply = false;\n  }\n  if (settingsDefault == null) {\n    settingsDefault = false;\n  }\n  if (isDefault) {\n    this.captioningObject.selected = this.cloneObject(this.captioningObject[\"default\"]);\n    this.list.font.value = this.captioningObject[\"default\"].fontFamily;\n    this.list.edge.value = this.captioningObject[\"default\"].edgeType != null ? this.captioningObject[\"default\"].edgeType : \"text-shadow: 0px 0px 0px\";\n    this.list.size.value = this.captioningObject[\"default\"].size;\n    this.list.scroll.value = this.captioningObject[\"default\"].scroll;\n    this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n    this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n    this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n    this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n  } else {\n    if ((this.captioningObject.selected.fontFamily != null) && !settingsDefault) {\n      this.list.font.value = this.captioningObject.selected.fontFamily;\n    }\n    this.list.edge.value = this.captioningObject.selected.edgeType != null ? this.captioningObject.selected.edgeType : \"text-shadow: 0px 0px 0px\";\n    if (this.captioningObject.selected.size != null) {\n      this.list.size.value = this.captioningObject.selected.size;\n    }\n    if (this.captioningObject.selected.scroll != null) {\n      this.list.scroll.value = this.captioningObject.selected.scroll;\n    } else {\n      this.captioningObject.selected.scroll = this.list.scroll.value;\n    }\n    this.picker.color.style.backgroundColor = this.captioningObject.selected.fontColor;\n    if (this.captioningObject.selected.backgroundColor != null) {\n      this.picker.background.style.backgroundColor = this.captioningObject.selected.backgroundColor;\n    }\n    if (this.captioningObject.selected.edgeColor != null) {\n      this.picker.edge.style.backgroundColor = this.captioningObject.selected.edgeColor;\n    }\n    if (this.captioningObject.selected.windowColor != null) {\n      this.picker.window.style.backgroundColor = this.captioningObject.selected.windowColor;\n    }\n  }\n  fontFamily = \"font-family: \" + (isDefault ? this.captioningObject[\"default\"].fontFamily : settingsDefault ? this.captioningObject.selected.fontFamily : this.list.font.value) + \" !important;\";\n  edgeType = (isDefault ? this.captioningObject[\"default\"].edgeType + this.captioningObject[\"default\"].edgeColor : this.list.edge.value + \" \" + this.picker.edge.style.backgroundColor) + \" !important;\";\n  fontSize = \"font-size: \" + (isDefault ? this.captioningObject[\"default\"].size : this.list.size.value) + \" !important;\";\n  color = \"color: \" + (isDefault ? this.captioningObject[\"default\"].fontColor : this.picker.color.style.backgroundColor) + \" !important;\";\n  backgroundColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].backgroundColor : this.picker.background.style.backgroundColor) + \" !important;\";\n  windowColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].windowColor : this.picker.window.style.backgroundColor) + \" !important;\";\n  containerStyle = \"line-height:2.2em;\";\n  windowColorValue = windowColor.match(/rgba\\([^)]+\\)/g);\n  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {\n    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\\)/, '$1')) === 0 ? \"\" : containerStyle;\n  }\n  if (isApply) {\n    this.onScrollListChange();\n    id = this.facade.player.viewComponent.id;\n    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + 'video::-webkit-media-text-track-display { ' + windowColor + ' } video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-display { ' + windowColor + ' } video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-container {' + containerStyle + '} video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';\n    try {\n      if (isDefault === false && !settingsDefault) {\n        localStorage.setItem(Namespace.PREFIX + \"captioningDefault\", JSON.stringify(this.captioningObject.selected));\n      }\n    } catch (localStorageError) {\n      this.facade.logger.error(\"LocalStorage Not Supported on this Browser\", localStorageError);\n    }\n  } else {\n    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText + '#' + id + ' .akamai-caption-text.akamai-caption-text-preview { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text.akamai-caption-text-preview p { ' + color + backgroundColor + ' }';\n  }\n};\n\nCaptionsSettingsMediator.prototype.toggleButtonHandler = function(isON, isTargetButton) {\n  if (isON == null) {\n    isON = false;\n  }\n  if (isTargetButton == null) {\n    isTargetButton = true;\n  }\n  if (isON) {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n    ClassList.remove(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n  } else {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n    ClassList.remove(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n  }\n  if (isTargetButton) {\n    this.captioning.setHidden(!isON);\n  }\n  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n    captioning: {\n      hidden: !isON\n    }\n  });\n};\n\nCaptionsSettingsMediator.prototype.setSettings = function(value) {\n  this.settings = value;\n  this.facade.player.settings.change({\n    captions: value\n  });\n  return value;\n};\n\nCaptionsSettingsMediator.prototype.getSettings = function() {\n  return this.settings;\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY, CaptioningNotifications.SETTINGS_CHANGE];\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.handleNotification = function(notification) {\n  var body, fName, fValue, i, isDefault, k, listString, name, note, option, state, v, _i, _len, _ref;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE:\n    case CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY:\n      if (this.settingsUiVisible) {\n        this.colorPicker.style.display = \"none\";\n      }\n      this.settingsUiVisible = !this.settingsUiVisible;\n      if (this.settingsUiVisible && this.list.language.length === 1) {\n        this.languageListPopulate();\n      }\n      note = this.settingsUiVisible ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n      state = \"cc-setting-active\";\n      this.toggleButtonHandler(!this.captioning.getHidden(), false);\n      this.list.language.value = this.captioning.getTrack().language;\n      this.onScrollListChange(this.captioningObject.selected.scroll);\n      this.sendNotification(note, state);\n      break;\n    case CaptioningNotifications.SETTINGS_CHANGE:\n      isDefault = false;\n      for (k in body) {\n        v = body[k];\n        switch (k) {\n          case \"fontFamily\":\n          case \"fontSize\":\n          case \"scroll\":\n          case \"edgeType\":\n            listString = k === \"fontFamily\" ? \"font\" : k === \"fontSize\" ? \"size\" : k === \"edgeType\" ? \"edge\" : \"scroll\";\n            _ref = this.list[listString].options;\n            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n              option = _ref[i];\n              if (k === \"fontFamily\" && typeof v === \"object\") {\n                for (fName in v) {\n                  fValue = v[fName];\n                  if (fName === \"default\") {\n                    this.captioningObject.selected.fontFamily = fValue;\n                    isDefault = true;\n                  }\n                  if ((new RegExp(fName, \"i\")).test(option.label)) {\n                    if (!(new RegExp(\"^\" + fValue)).test(option.value)) {\n                      option.value = fValue + \",\" + option.value;\n                    }\n                    if (option.selected) {\n                      this.captioningObject.selected.fontFamily = option.value;\n                    }\n                  }\n                }\n              } else if ((new RegExp(\"^\" + v + \"$\", \"i\")).test(option.label)) {\n                this.list[listString].selectedIndex = i;\n                if (k === \"fontSize\") {\n                  k = \"size\";\n                }\n                this.captioningObject.selected[k] = option.value;\n                if (k === \"scroll\") {\n                  this.scroll.type = this.captioningObject.selected.scroll = option.value;\n                  this.setSettings({\n                    scroll: this.scroll.type\n                  });\n                  try {\n                    if (option.value === \"painton\") {\n                      ClassList.add(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n                    } else {\n                      ClassList.remove(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n                    }\n                  } catch (error) {\n                    this.facade.logger.error(\"AMP Captioning Error\", error);\n                  }\n                }\n              }\n            }\n            break;\n          case \"backgroundColor\":\n          case \"edgeColor\":\n          case \"fontColor\":\n          case \"windowColor\":\n            this.captioningObject.selected[k] = v;\n        }\n      }\n      this.applyCaptioningStyle(false, true, isDefault);\n      if ((body.visible != null) && body.visible !== !this.captioning.getHidden()) {\n        this.captioning.setHidden(!body.visible);\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction PlayOverlayMediator() {\n  PlayOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PlayOverlayMediator, OverlayMediator);\n\n\nPlayOverlayMediator.prototype.componentName = \"play\";\n\nPlayOverlayMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n  return false;\n};\n\nfunction VolumePanelControlMediator(componentName) {\n  VolumePanelControlMediator.__super__.constructor.call(this, componentName);\n}\n\n\n__extends(VolumePanelControlMediator, PanelControlMediator);\n\n\nVolumePanelControlMediator.prototype.clickHandler = function() {\n  this.sendNotification(Notifications.TOGGLE_MUTED);\n};\n\n/**\n * The VolumeMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction VolumeMediator(parent, direction) {\n  VolumeMediator.__super__.constructor.call(this, parent, direction);\n}\n\n\n__extends(VolumeMediator, SliderMediator);\n\n\nVolumeMediator.prototype.componentName = \"volume\";\n\nVolumeMediator.prototype.draggable = true;\n\n/**\n * @override\n*/\nVolumeMediator.prototype.valueChanged = function() {\n  this.sendNotification(Notifications.CHANGE_VOLUME, this.value);\n  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n    volume: this.value\n  });\n};\n\n/**\n * @override\n*/\nVolumeMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.VOLUME_CHANGE, Notifications.READY];\n};\n\n/**\n * @override\n*/\nVolumeMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case Notifications.READY:\n      this.updateValue(this.facade.player.getVolume(), true);\n      break;\n    case Notifications.VOLUME_CHANGE:\n      this.updateValue(notification.getBody());\n  }\n};\n\n/**\n * The ControlPanelMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction ControlPanelMediator() {\n  ControlPanelMediator.__super__.constructor.call(this);\n  this.controls = {};\n}\n\n\n__extends(ControlPanelMediator, PluginMediator);\n\n\nControlPanelMediator.prototype.panel = null;\n\nControlPanelMediator.prototype.control = null;\n\nControlPanelMediator.prototype.separator = null;\n\nControlPanelMediator.prototype.controls = null;\n\nControlPanelMediator.prototype.labels = null;\n\nControlPanelMediator.prototype.closed = true;\n\nControlPanelMediator.prototype.panelClass = PanelMediator;\n\nControlPanelMediator.prototype.controlClass = PanelControlMediator;\n\n/**\n * @override\n*/\nControlPanelMediator.prototype.onRegister = function() {\n  this.panel = this.createPanel(this.componentName);\n  this.control = this.createControl(this.componentName);\n  this.separator = this.createSeparator(this.componentName);\n  this.panel.control = this.control;\n  this.control.panel = this.panel;\n  if (this.labels == null) {\n    this.labels = {};\n  }\n  this.createPanelControls(this.componentName);\n};\n\nControlPanelMediator.prototype.createControl = function(name) {\n  var control;\n  control = new this.controlClass(name);\n  this.facade.registerMediator(control);\n  return control;\n};\n\nControlPanelMediator.prototype.createPanel = function(name) {\n  var panel;\n  panel = new this.panelClass(name);\n  this.facade.registerMediator(panel);\n  return panel;\n};\n\nControlPanelMediator.prototype.createSeparator = function(name) {\n  return this.create([\"separator\", \"icon\"], this.panel);\n};\n\nControlPanelMediator.prototype.createPanelControls = function(name) {\n  var data, key, value, _base, _ref;\n  data = (typeof (_base = this.plugin).getConfigurationData === \"function\" ? _base.getConfigurationData() : void 0) || this.facade.getConfig()[this.componentName];\n  for (key in data) {\n    value = data[key];\n    if (value === true) {\n      this.controls[key] = this.addPanelControl(new ButtonMediator(this.localizationManager.getString(this.labels[key]), null, null, key, (_ref = this.panelButtonClickHandler) != null ? typeof _ref.bind === \"function\" ? _ref.bind(this, key) : void 0 : void 0));\n    }\n  }\n};\n\nControlPanelMediator.prototype.addPanelControl = function(control) {\n  this.facade.registerMediator(control);\n  this.panel.getViewComponent().appendChild(control.getViewComponent());\n  return control;\n};\n\n/**\n*/\nControlPanelMediator.prototype.panelButtonClickHandler = function() {\n  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n};\n\n/**\n * The VolumePanelMediator class.\n *\n * @constructor\n * @private\n * @extends {ControlPanelMediator}\n*/\nfunction VolumePanelMediator() {\n  VolumePanelMediator.__super__.constructor.call(this);\n}\n\n\n__extends(VolumePanelMediator, ControlPanelMediator);\n\n\nVolumePanelMediator.prototype.componentName = \"volume\";\n\nVolumePanelMediator.prototype.slider = null;\n\nVolumePanelMediator.prototype.level = null;\n\nVolumePanelMediator.prototype.controlClass = VolumePanelControlMediator;\n\n/**\n*/\nVolumePanelMediator.prototype.onRegister = function() {\n  var _ref;\n  VolumePanelMediator.__super__.onRegister.call(this);\n  this.slider = new VolumeMediator(this.panel, (_ref = this.facade.getConfig().volume) != null ? _ref.direction : void 0);\n  this.facade.registerMediator(this.slider);\n};\n\nVolumePanelMediator.prototype.updateVolumeButton = function(percent) {\n  var level;\n  level = Math.ceil(percent * 10);\n  if (level === this.level) {\n    return;\n  }\n  if (this.level != null) {\n    this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"volume-\" + this.level);\n  }\n  this.level = level;\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"volume-\" + this.level);\n};\n\n/**\n * @override\n*/\nVolumePanelMediator.prototype.listNotificationInterests = function() {\n  return VolumePanelMediator.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.VOLUME_CHANGE]);\n};\n\n/**\n * @override\n*/\nVolumePanelMediator.prototype.handleNotification = function(notification) {\n  VolumePanelMediator.__super__.handleNotification.call(this, notification);\n  switch (notification.getName()) {\n    case Notifications.VOLUME_CHANGE:\n      this.updateVolumeButton(notification.body);\n  }\n};\n\n/**\n * The PanelsMediator class.\n *\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction PanelsMediator(parent) {\n  this.panels = [];\n  this.closeHandler = this.mouseupHandler.bind(this);\n  PanelsMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(PanelsMediator, ComponentMediator);\n\n\nPanelsMediator.prototype.componentName = \"panels\";\n\nPanelsMediator.prototype.activePanel = null;\n\nPanelsMediator.prototype.panels = null;\n\nPanelsMediator.prototype.closeHandler = null;\n\n/**\n * @override\n*/\nPanelsMediator.prototype.listNotificationInterests = function() {\n  var key, value;\n  return ((function() {\n    var _results;\n    _results = [];\n    for (key in PanelNotifications) {\n      value = PanelNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([]);\n};\n\n/**\n * @override\n*/\nPanelsMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case PanelNotifications.ADD_PANEL:\n      this.addPanel(body);\n      break;\n    case PanelNotifications.REMOVE_PANEL:\n      this.removePanel(body);\n      break;\n    case PanelNotifications.OPEN_PANEL:\n      this.openPanel(body);\n      break;\n    case PanelNotifications.CLOSE_PANEL:\n      this.closePanel(body);\n      break;\n    case PanelNotifications.CLOSE_ALL_PANELS:\n      this.closeAllPanels(body);\n      break;\n    case PanelNotifications.TOGGLE_PANEL:\n      this.togglePanel(body);\n  }\n};\n\nPanelsMediator.prototype.addPanel = function(panel) {\n  this.panels.push(panel);\n  this.viewComponent.appendChild(panel.getViewComponent());\n};\n\nPanelsMediator.prototype.removePanel = function(panel) {\n  this.panels.splice(this.panels.indexOf(panel), 1);\n  this.viewComponent.removeChild(panel.getViewComponent());\n};\n\nPanelsMediator.prototype.openPanel = function(panel) {\n  if (panel === this.activePanel || !(panel != null)) {\n    return;\n  }\n  this.closeAllPanels();\n  this.activePanel = panel;\n  this.activePanel.classList.add(\"active\");\n  if (Utils.getDevice() !== \"desktop\") {\n    this.sendNotification(Notifications.IS_USER_ACTIVE, true);\n  }\n  document.addEventListener(\"mouseup\", this.closeHandler);\n};\n\nPanelsMediator.prototype.closePanel = function(panel) {\n  panel.classList.remove(\"active\");\n  if (this.activePanel != null) {\n    this.activePanel = null;\n    if (Utils.getDevice() !== \"desktop\") {\n      this.sendNotification(Notifications.IS_USER_ACTIVE, false);\n    }\n    document.removeEventListener(\"mouseup\", this.closeHandler);\n  }\n};\n\nPanelsMediator.prototype.togglePanel = function(panel) {\n  if (panel === this.activePanel) {\n    this.closePanel(panel);\n  } else {\n    this.openPanel(panel);\n  }\n};\n\nPanelsMediator.prototype.closeAllPanels = function() {\n  var panel, _i, _len, _ref;\n  _ref = this.panels;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    panel = _ref[_i];\n    this.closePanel(panel);\n  }\n};\n\nPanelsMediator.prototype.mouseupHandler = function(event) {\n  var button, element, panel;\n  element = document.elementFromPoint(event.clientX, event.clientY);\n  panel = this.activePanel.getViewComponent();\n  button = this.activePanel.control.getViewComponent();\n  if (element !== panel && panel.contains(element) === false && element !== button && button.contains(element) === false) {\n    this.closeAllPanels();\n  }\n};\n\n/**\n * The ProgressMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction ProgressMediator(parent) {\n  ProgressMediator.__super__.constructor.call(this, parent, \"horizontal\");\n}\n\n\n__extends(ProgressMediator, SliderMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {string}\n*/\nProgressMediator.prototype.componentName = \"progress\";\n\nProgressMediator.prototype.bufferValue = null;\n\nProgressMediator.prototype.scrubTime = null;\n\nProgressMediator.prototype.scrubTimeSeparator = null;\n\nProgressMediator.prototype.cuePoints = null;\n\nProgressMediator.prototype.cues = null;\n\nProgressMediator.prototype.duration = 0;\n\nProgressMediator.prototype.isLive = false;\n\nProgressMediator.prototype.seeking = false;\n\nProgressMediator.prototype.previewData = {\n  src: null,\n  previewWidth: null,\n  previewHeight: null,\n  imgWidth: null,\n  imgHeight: null,\n  count: null\n};\n\nProgressMediator.prototype.hoverHandler = null;\n\nProgressMediator.prototype.mouseoutHandler = null;\n\nProgressMediator.prototype.mouseMoveHandler = null;\n\nProgressMediator.prototype.previewMoveHandler = null;\n\n/**\n * @override\n*/\nProgressMediator.prototype.onRegister = function() {\n  ProgressMediator.__super__.onRegister.call(this);\n  this.bufferValue = this.create(\"buffer-value\", false);\n  this.trackView.insertBefore(this.bufferValue, this.trackView.lastChild);\n  this.cuePoints = this.create(\"cue-points\", this.trackView);\n  this.scrubTimeSeparator = this.create(\"scrub-time-separator\");\n  this.scrubTime = this.create(\"scrub-time\");\n  this.thumbPreview = this.create(\"thumb-preview\", this.trackView);\n  this.previewMoveHandler = EventHandler.create(this.clickView, EventHandler.MOVE, this.updatePreviewHandler.bind(this));\n  this.previewMoveHandler.unbind();\n  this.hoverHandler = EventHandler.create(this.clickView, EventHandler.HOVER, this.handlehoverHandler.bind(this));\n  this.mouseoutHandler = EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.handlemouseoutHandler.bind(this));\n  this.mouseoutHandler.unbind();\n  EventHandler.create(this.clickView, EventHandler.HOVER, this.mouseOverHandler.bind(this));\n  EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.mouseOutHandler.bind(this));\n  this.mouseMoveBinding = EventHandler.create(document, EventHandler.MOVE, this.mouseMoveHandler.bind(this));\n  this.mouseMoveBinding.unbind();\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ENDED, Notifications.MEDIA_CHANGE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.CUES_CHANGE, Notifications.DISPLAY_TIME, AdNotifications.BREAK_START];\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.handleNotification = function(notification) {\n  var body, name, value;\n  ProgressMediator.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      this.isLive = body.temporalType === \"live\";\n      this.updateValue(0);\n      this.bufferValue.style.width = \"0%\";\n      this.updatePreview(body.metadata);\n      break;\n    case Notifications.PROGRESS:\n      value = Utils.clamp(body / this.duration * 100, 0, 100);\n      this.bufferValue.style.width = value + \"%\";\n      break;\n    case Notifications.DURATION_CHANGE:\n      this.duration = body;\n      this.updateCuePoints();\n      break;\n    case Notifications.ENDED:\n      this.updateValue(1.0);\n      break;\n    case Notifications.CUES_CHANGE:\n      this.cues = body;\n      this.updateCuePoints();\n      break;\n    case Notifications.DISPLAY_TIME:\n      if (this.dragging === false) {\n        this.updateValue(body.currentTime / body.duration, body.duration);\n      }\n      if (body.duration !== this.duration) {\n        this.duration = body.duration;\n      }\n      break;\n    case AdNotifications.BREAK_START:\n      if (this.getDragging()) {\n        this.handleReleaseHandler();\n      }\n  }\n};\n\nProgressMediator.prototype.updateCuePoints = function() {\n  var cue, cuePoint, _i, _len, _ref;\n  if (!(this.cues != null)) {\n    return;\n  }\n  if (this.facade.config.displaySceneMarkers === false) {\n    return;\n  }\n  this.removeCuePoints();\n  _ref = this.cues;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    cue = _ref[_i];\n    if (!(cue.startTime !== 0 && cue.startTime !== -1)) {\n      continue;\n    }\n    cuePoint = this.create(\"cue-point\", this.cuePoints);\n    cuePoint.style.left = (cue.startTime / this.duration * 100) + \"%\";\n  }\n};\n\nProgressMediator.prototype.preloadPreviewImages = function(metadata) {\n  var i, image;\n  i = 1;\n  while (i < metadata.previewThumbnailCount) {\n    image = new Image;\n    image.src = metadata.previewThumbnailSrc + \"out\" + i + \".png\";\n    i++;\n  }\n};\n\nProgressMediator.prototype.updatePreview = function(metadata) {\n  this.preloadPreviewImages(metadata);\n  this.previewData.src = metadata.previewThumbnailSrc;\n  this.previewData.previewHeight = metadata.previewThumbnailHeight;\n  this.previewData.previewWidth = metadata.previewThumbnailWidth;\n  this.previewData.count = metadata.previewThumbnailCount;\n  if (this.previewData.src === void 0) {\n    this.hoverHandler.unbind();\n  }\n};\n\nProgressMediator.prototype.handlehoverHandler = function(event) {\n  this.previewMoveHandler.bind();\n  this.mouseoutHandler.bind();\n  this.hoverHandler.unbind();\n  this.updatePreviewHandler(event);\n  event.stopImmediatePropagation();\n  return false;\n};\n\nProgressMediator.prototype.handlemouseoutHandler = function(event) {\n  this.previewMoveHandler.unbind();\n  this.mouseoutHandler.unbind();\n  this.hoverHandler.bind();\n  event.stopImmediatePropagation();\n  return false;\n};\n\nProgressMediator.prototype.mouseOverHandler = function(event) {\n  this.mouseOver = true;\n  this.classList.add(\"active\");\n  this.mouseMoveBinding.bind();\n};\n\nProgressMediator.prototype.mouseOutHandler = function(event) {\n  this.mouseOver = false;\n  if (this.getDragging() === true) {\n    return;\n  }\n  this.classList.remove(\"active\");\n  this.mouseMoveBinding.unbind();\n};\n\nProgressMediator.prototype.mouseMoveHandler = function(event) {\n  var value;\n  value = this.calculateValue(event);\n  this.scrubTime.textContent = Utils.formatTimecode(Math.round(value * this.duration));\n  this.scrubTime.style.left = this.scrubTimeSeparator.style.left = \"\" + ((value * 100).toFixed(2)) + \"%\";\n};\n\nProgressMediator.prototype.updatePreviewHandler = function(event) {\n  var thumbPreviewPos, value;\n  value = this.calculateValue(event);\n  this.previewInterval = this.duration / this.previewData.count;\n  this.previewImgIndex = Math.floor(value * this.duration / this.previewInterval);\n  if (this.previewData.src) {\n    this.thumbPreview.style.backgroundImage = \"url(\" + this.previewData.src + \"out\" + (this.previewImgIndex + 1) + \".png)\";\n  }\n  this.thumbPreview.style.width = this.previewData.previewWidth + \"px\";\n  this.thumbPreview.style.height = this.previewData.previewHeight + \"px\";\n  thumbPreviewPos = Utils.clamp(((value * 100) - 10).toFixed(2), 1, 80);\n  this.thumbPreview.style.left = \"\" + thumbPreviewPos + \"%\";\n};\n\nProgressMediator.prototype.removeCuePoints = function() {\n  if (!(this.cuePoints != null)) {\n    return;\n  }\n  this.cuePoints.innerHTML = \"\";\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.valueChanged = function() {\n  this.sendNotification(UserNotifications.SEEK, this.value * this.facade.player.retrieveProxy(PlaybackProxy.NAME).getDuration());\n};\n\n/** updates the view\n*/\nProgressMediator.prototype.updateValue = function(value) {\n  if (value === this.value) {\n    return;\n  }\n  if (this.isLive === true) {\n    value = 1;\n  }\n  if (isNaN(value) === true) {\n    value = 0;\n  }\n  ProgressMediator.__super__.updateValue.call(this, value);\n  if (this.getDragging() && this.value >= this.max) {\n    this.handleReleaseHandler();\n    this.sendNotification(Notifications.END);\n  }\n};\n\nProgressMediator.prototype.updateHandler = function(setValue, event) {\n  ProgressMediator.__super__.updateHandler.call(this, setValue, event);\n  this.mouseMoveHandler(event);\n};\n\nProgressMediator.prototype.handlePressHandler = function(event) {\n  ProgressMediator.__super__.handlePressHandler.call(this, event);\n  this.classList.add(\"scrubbing\");\n};\n\nProgressMediator.prototype.handleReleaseHandler = function(event) {\n  var self;\n  ProgressMediator.__super__.handleReleaseHandler.call(this, event);\n  self = this;\n  setTimeout(function() {\n    return self.classList.remove(\"scrubbing\");\n  }, 500);\n  if (this.mouseOver === false) {\n    this.mouseOutHandler();\n  }\n};\n\n/**\n * The PlayPauseMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PlayPauseMediator(parent) {\n  PlayPauseMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(PlayPauseMediator, ButtonMediator);\n\n\nPlayPauseMediator.prototype.componentName = \"play-pause\";\n\nPlayPauseMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n  return false;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AdNotifications = {\n  BREAK_START: \"adsbreakstart\",\n  BREAK_END: \"adsbreakend\",\n  BREAK_SKIPPED: \"adsbreakskipped\",\n  AD_CONTAINER_CREATED: \"adscontainercreated\",\n  AD_LOADED: \"adsloaded\",\n  AD_MANAGER_LOADED: \"adsmanagerloaded\",\n  AD_STARTED: \"adsstarted\",\n  AD_TIME_UPDATE: \"adstimeupdate\",\n  AD_TIME_REMAINING: \"adstimeremaining\",\n  AD_DURATION_CHANGE: \"adsdurationchange\",\n  AD_ENDED: \"adsended\",\n  AD_ERROR: \"adserror\",\n  AD_PLAY: \"adsplay\",\n  AD_PAUSE: \"adspause\",\n  AD_PAUSED: \"adspaused\",\n  AD_RESUME: \"adsresume\",\n  AD_CLICKED: \"adclicked\",\n  AD_COMPANION: \"adscompanion\",\n  FIRST_QUARTILE: \"adsfirstquartile\",\n  MIDPOINT: \"adsmidpoint\",\n  THIRD_QUARTILE: \"adsthirdquartile\",\n  COMPLETE: \"adscomplete\",\n  LOG: \"adslog\",\n  REQUEST: \"adsrequest\",\n  REQUEST_COMPLETE: \"adsrequestcomplete\",\n  RESPONSE: \"adsresponse\",\n  SKIPPED: \"adsskipped\",\n  IMPRESSION: \"adsimpression\"\n};\n\n/**\n * The ControlsMediator class.\n *\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction ControlsMediator(overlays) {\n  this.overlays = overlays != null ? overlays : true;\n  ControlsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsMediator, LayerMediator);\n\n\nControlsMediator.prototype.componentName = \"controls\";\n\nControlsMediator.prototype.activeControlPanel = null;\n\nControlsMediator.prototype.controlBar = null;\n\nControlsMediator.prototype.panels = null;\n\n/**\n * @override\n*/\nControlsMediator.prototype.onRegister = function() {\n  var separator, titlebar;\n  this.facade.registerMediator(new ErrorLayerMediator());\n  if (this.facade.player.config.debug !== true) {\n    if (this.facade.player.config.contextmenu && this.facade.player.config.contextmenu.enabled !== false) {\n      this.facade.registerMediator(new contextMenuMediator());\n    }\n  }\n  ControlsMediator.__super__.onRegister.call(this);\n  this.facade.viewComponent = this.viewComponent;\n  if (this.overlays !== false) {\n    this.facade.registerMediator(new PosterMediator());\n    this.facade.registerMediator(new LoadingOverlayMediator());\n    this.facade.registerMediator(new WaitingOverlayMediator());\n    this.facade.registerMediator(new ReplayOverlayMediator());\n    this.facade.registerMediator(new EndSlateMediator());\n    titlebar = this.facade.config.titlebar || this.facade.player.config.titlebar || {};\n    if (titlebar.enabled !== false) {\n      this.facade.registerMediator(new TitleBarMediator());\n    }\n  }\n  this.controlBar = this.create(\"control-bar\");\n  this.facade.registerMediator(new PanelsMediator(this.viewComponent));\n  this.facade.registerMediator(new PlayPauseMediator(this.controlBar));\n  this.facade.registerMediator(new TimeDisplayMediator(this.controlBar));\n  this.facade.registerMediator(new ProgressMediator(this.controlBar));\n  if (this.facade.config.logo != null) {\n    this.facade.registerMediator(new LogoMediator(this.controlBar));\n  }\n  this.facade.registerMediator(new GoLiveMediator(this.controlBar));\n  if (this.overlays !== false && (this.facade.player.captioning != null)) {\n    this.facade.registerMediator(new CaptionsMediator());\n    this.facade.registerMediator(new CaptionsSettingsMediator(this.viewComponent));\n  }\n  this.facade.registerMediator(new VolumePanelMediator());\n  if (this.overlays !== false) {\n    this.facade.ads = new AdMediator();\n    this.facade.registerMediator(this.facade.ads);\n    this.facade.registerMediator(new PlayOverlayMediator());\n  }\n  separator = this.create(\"separator\", this.controlBar);\n};\n\n/**\n * @override\n*/\nControlsMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.SET_MEDIA, AdNotifications.BREAK_START, AdNotifications.BREAK_END];\n};\n\n/**\n * @override\n*/\nControlsMediator.prototype.handleNotification = function(notification) {\n  var body, name, _ref;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      if (((_ref = body.fullscreen) != null ? _ref.enabled : void 0) !== false) {\n        this.facade.registerMediator(new FullScreenMediator(this.controlBar));\n      }\n      break;\n    case Notifications.SET_MEDIA:\n    case AdNotifications.BREAK_END:\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case AdNotifications.BREAK_START:\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case Notifications.ADD_CONTROL_STATE:\n      this.classList.add(body);\n      break;\n    case Notifications.REMOVE_CONTROL_STATE:\n      this.classList.remove(body);\n      break;\n    case Notifications.ADD_CONTROL:\n      this.controlBar.appendChild(body);\n      break;\n    case Notifications.REMOVE_CONTROL:\n      if (this.controlBar.contains(body)) {\n        this.controlBar.removeChild(body);\n      }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar MediaAnalyticsNotifications = {\n  SET_DIMENSIONS: \"mediaanalytics:setDimensions\"\n};\n\n/**\n * The CaptioningPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction CaptioningPlugin() {\n  CaptioningPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    visible: {\n      get: this.getVisible,\n      set: this.setVisible,\n      enumerable: true,\n      configurable: false\n    },\n    tracks: {\n      get: this.getTracks,\n      enumerable: true,\n      configurable: false\n    },\n    track: {\n      get: this.getTrack,\n      set: this.setTrack,\n      enumerable: true,\n      configurable: false\n    },\n    settings: {\n      get: this.getSettings,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(CaptioningPlugin, Feature);\n\n\nCaptioningPlugin.prototype.featureName = \"captioning\";\n\nCaptioningPlugin.prototype.moduleName = \"captioning\";\n\nCaptioningPlugin.prototype.mediatorname = \"\";\n\n/** @override\n*/\nCaptioningPlugin.prototype.createController = function() {\n  CaptioningPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.CHANGE_MEDIA, CaptioningChangeMediaCommand);\n  this.registerCommand(Notifications.STARTED, CaptioningStartedCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, CaptioningTimeUpdateCommand);\n  this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, CaptioningVisibilityChangeCommand);\n  this.registerCommand(CaptioningNotifications.ENABLED, CaptioningEnabledCommand);\n  this.registerCommand(CaptioningNotifications.TRACK_SELECTED, PluginEventCommand);\n  this.registerCommand(CaptioningNotifications.TRACKS_LOADED, PluginEventCommand);\n  this.registerCommand(CaptioningNotifications.CUE_CHANGE, PluginEventCommand);\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.createModel = function() {\n  this.proxy = new CaptioningProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.createView = function() {\n  var mediator, viewComponent;\n  mediator = new CaptioningMediator();\n  this.registerMediator(mediator);\n  this.mediatorname = mediator.getMediatorName();\n  viewComponent = mediator.viewComponent;\n  this.proxy.registerRenderer(new CaptioningNativeMediator(viewComponent));\n  this.proxy.registerRenderer(new CaptioningHTMLMediator(viewComponent));\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.destroy = function() {\n  var name, renderer;\n  while (this.proxy.rendererMap.length >= 1) {\n    renderer = this.proxy.rendererMap[0];\n    name = renderer.getMediatorName();\n    this.removeMediator(name);\n    this.proxy.removeRenderer(renderer.getRendererName());\n  }\n  this.removeMediator(this.mediatorname);\n};\n\n/**\n*/\nCaptioningPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, Notifications.CHANGE_MEDIA, Notifications.STARTED, Notifications.TIME_UPDATE, Notifications.SETTINGS_CHANGE, CaptioningNotifications.TRACK_SELECTED];\n};\n\n/**\n*/\nCaptioningPlugin.prototype.listNotificationPublications = function() {\n  return CaptioningPlugin.__super__.listNotificationPublications.call(this).concat([CaptioningNotifications.CUE_CHANGE, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_SETTINGS, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE]);\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getEnabled = function() {\n  return this.proxy.getEnabled();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setEnabled = function(value) {\n  this.sendNotification(CaptioningNotifications.ENABLED, value);\n  return value;\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getHidden = function() {\n  return this.proxy.getHidden();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setHidden = function(value) {\n  this.setVisible(!value);\n  return value;\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getVisible = function() {\n  return !this.proxy.getHidden();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setVisible = function(value) {\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: {\n      visible: value\n    }\n  });\n  this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, value);\n  return value;\n};\n\n/**\n * Returns an array of caption tracks\n *\n * @return {Array.<CaptionTrack>} The list of text tracks.\n * @expose\n*/\nCaptioningPlugin.prototype.getTracks = function() {\n  return this.proxy.getTracks();\n};\n\n/**\n * Returns the currently selected track.\n *\n * @return {CaptionTrack} The currently selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.getTrack = function() {\n  return this.proxy.getTrack();\n};\n\n/**\n * Selects a caption track\n *\n * @param {CaptionTrack} value The caption track to select\n * @expose\n*/\nCaptioningPlugin.prototype.setTrack = function(value) {\n  this.proxy.setTrack(value);\n  return value;\n};\n\n/**\n * Selects a caption track by its index in the getTracks array.\n *\n * @param {number}        index   The index to select\n * @return {CaptionTrack}         The selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.selectTrackByIndex = function(index) {\n  return this.proxy.selectTrackByIndex(index);\n};\n\n/**\n * Selects a caption track by it's language property.\n *\n * @param {string}        lang  The language to select\n * @return {CaptionTrack}       The selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.selectTrackByLanguage = function(lang) {\n  return this.proxy.selectTrackByLanguage(lang);\n};\n\n/**\n * Sets a caption Settings Object (styles)\n *\n * @param {Object}  object  The caption settings object.\n * @expose\n*/\nCaptioningPlugin.prototype.changeSettings = function(object) {\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: object\n  });\n  this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, object);\n  return object;\n};\n\n/**\n * Return the captions settings object\n *\n * @return {Object}       The captions settings object.\n * @expose\n*/\nCaptioningPlugin.prototype.getSettings = function() {\n  return this.player.settings.captions;\n};\n\n/**\n * Allows parallel rendering to be toggled\n *\n * @param {value}  number  The value to use.\n * @expose\n*/\nCaptioningPlugin.prototype.useParallelRendering = function(value) {\n  var renderer;\n  renderer = this.proxy.getRenderer();\n  if (renderer) {\n    renderer.useParallelRendering(value);\n  }\n  return value;\n};\n\n\nAMP.registerPlugin(\"captioning\", \"html\", CaptioningPlugin);\n\n/**\n * @constructor\n * @private\n*/\nfunction MediaAnalyticsProxy(config) {\n  MediaAnalyticsProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(MediaAnalyticsProxy, PluginProxy);\n\n\n/** @static\n*/\nMediaAnalyticsProxy.NAME = ModuleProxy.NAME;\n\nMediaAnalyticsProxy.prototype.defaults = {\n  config: null,\n  dimensions: null,\n  iplookup: true\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.ready = function() {\n  try {\n    if (this.getDebug() === true) {\n      window.AkamaiAnalytics_debug = 1;\n    }\n    window.akamaiSetVideoObject(this.facade.player.getMediaElement());\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set video tag\", error);\n  }\n  if (this.value.iplookup === false && typeof akamaiDisableServerIpLookup === \"function\") {\n    akamaiDisableServerIpLookup();\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.setDimensions = function(value) {\n  var dimensions, key, val;\n  dimensions = this.data.dimensions;\n  for (key in value) {\n    val = value[key];\n    if (val != null) {\n      dimensions[key] = val;\n    }\n  }\n  this.applyDimensions(dimensions);\n  return value;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.applyDimensions = function(dimensions) {\n  var key, value;\n  if (!(window.setAkamaiMediaAnalyticsData != null)) {\n    return;\n  }\n  try {\n    for (key in dimensions) {\n      value = dimensions[key];\n      setAkamaiMediaAnalyticsData(key, value);\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set dimensions:\", error);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.setMedia = function(media) {\n  var dimensions, viewerId, _ref;\n  if (typeof akamaiSetStreamURL === \"function\") {\n    akamaiSetStreamURL(media.src, false);\n  }\n  viewerId = this.value.viewerId || this.value.viewerID || this.value[\"std:viewerId\"];\n  if (viewerId != null) {\n    akamaiSetViewerId(viewerId);\n  }\n  if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n    dimensions = Utils.override(this.value.dimensions, media.mediaanalytics.dimensions);\n  } else {\n    dimensions = this.value.dimensions;\n  }\n  akamaiHandleStreamSwitch();\n  this.applyDimensions(dimensions);\n  return media;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.udpateMedia = function(media) {\n  if (typeof akamaiHandleTitleSwitch === \"function\") {\n    akamaiHandleTitleSwitch(media);\n  }\n  return media;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.fragmentLoadStart = function(bitrate) {\n  if (typeof fragmentDownloadStarted === \"function\") {\n    fragmentDownloadStarted(bitrate);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.fragmentLoaded = function(bitrate) {\n  if (typeof fragmentDownloadCompleted === \"function\") {\n    fragmentDownloadCompleted(bitrate);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.bitrateSwitch = function(data) {\n  if (typeof akamaiHandleBitRateSwitch === \"function\") {\n    akamaiHandleBitRateSwitch(data.bitrate);\n  }\n};\n\n/**\n * The MediaAnalyticsReadyCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsReadyCommand() {\n  MediaAnalyticsReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsReadyCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsReadyCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(MediaAnalyticsProxy.NAME).ready();\n};\n\n/**\n * The MediaAnalyticsChangeMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsChangeMediaCommand() {\n  MediaAnalyticsChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsChangeMediaCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsChangeMediaCommand.prototype.execute = function(notification) {\n  this.proxy.setMedia(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsAdBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdBreakStartCommand() {\n  MediaAnalyticsAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdBreakStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdBreakStartCommand.prototype.execute = function(notification) {\n  this.facade.player.getMediaElement().dataset.isad = true;\n};\n\n/**\n * The MediaAnalyticsAdBreakEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdBreakEndCommand() {\n  MediaAnalyticsAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdBreakEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdBreakEndCommand.prototype.execute = function(notification) {\n  this.facade.player.getMediaElement().dataset.isad = false;\n};\n\n/**\n * The MediaAnalyticsAdLoadedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdLoadedCommand() {\n  MediaAnalyticsAdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdLoadedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdLoadedCommand.prototype.execute = function(notification) {\n  var adObject, adVO;\n  try {\n    adVO = notification.getBody();\n    adObject = {\n      adDuration: adVO.duration,\n      adPartnerId: adVO.partner,\n      adTitle: adVO.title,\n      adId: adVO.id\n    };\n    if (typeof akamaiHandleAdLoaded === \"function\") {\n      akamaiHandleAdLoaded(adObject);\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n};\n\n/**\n * The MediaAnalyticsAdStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdStartCommand() {\n  MediaAnalyticsAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdStartCommand.prototype.execute = function(notification) {\n  try {\n    if (typeof akamaiHandleAdStarted === \"function\") {\n      akamaiHandleAdStarted();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n};\n\n/**\n * The MediaAnalyticsTimeUpdateCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdTimeUpdateCommand() {\n  MediaAnalyticsAdTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdTimeUpdateCommand.prototype.execute = function(notification) {\n  var core, percent;\n  core = notification.getBody();\n  percent = Math.round(core.currentTime / core.duration * 100);\n  try {\n    if (percent >= 25 && this.proxy.percent < 25) {\n      this.facade.logger.debug(\"MediaAnalytics: First Quartile\");\n      if (typeof akamaiHandleAdFirstQuartile === \"function\") {\n        akamaiHandleAdFirstQuartile();\n      }\n    } else if (percent >= 50 && this.proxy.percent < 50) {\n      this.facade.logger.debug(\"MediaAnalytics: Second Quartile\");\n      if (typeof akamaiHandleAdMidpoint === \"function\") {\n        akamaiHandleAdMidpoint();\n      }\n    } else if (percent >= 75 && this.proxy.percent < 75) {\n      this.facade.logger.debug(\"MediaAnalytics: Third Quartile\");\n      if (typeof akamaiHandleAdThirdQuartile === \"function\") {\n        akamaiHandleAdThirdQuartile();\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n  this.proxy.percent = percent;\n};\n\n/**\n * The MediaAnalyticsAdEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdEndCommand() {\n  MediaAnalyticsAdEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsAdEndCommand.prototype.execute = function(notification) {\n  try {\n    if (typeof akamaiHandleAdCompleted === \"function\") {\n      akamaiHandleAdCompleted();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n  this.facade.player.getMediaElement().dataset.isad = true;\n};\n\n/**\n * The MediaAnalyticsSetDimensionsCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsSetDimensionsCommand() {\n  MediaAnalyticsSetDimensionsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsSetDimensionsCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsSetDimensionsCommand.prototype.execute = function(notification) {\n  var dimensions;\n  dimensions = notification.getBody();\n  this.proxy.setDimensions(dimensions);\n};\n\n/**\n * The MediaAnalyticsContentChangedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsContentChangedCommand() {\n  MediaAnalyticsContentChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsContentChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsContentChangedCommand.prototype.execute = function(notification) {\n  this.proxy.updatedMedia(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsFragmentLoadStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsFragmentLoadStartCommand() {\n  MediaAnalyticsFragmentLoadStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsFragmentLoadStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsFragmentLoadStartCommand.prototype.execute = function(notification) {\n  this.proxy.fragmentLoadStart(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsFragmentLoadedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsFragmentLoadedCommand() {\n  MediaAnalyticsFragmentLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsFragmentLoadedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsFragmentLoadedCommand.prototype.execute = function(notification) {\n  this.proxy.fragmentLoaded(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsBitrateSwitchCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsBitrateSwitchCommand() {\n  MediaAnalyticsBitrateSwitchCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsBitrateSwitchCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaAnalyticsBitrateSwitchCommand.prototype.execute = function(notification) {\n  this.proxy.bitrateSwitch(notification.getBody());\n};\n\nfunction MediaAnalyticsWrapper(player, config) {\n  MediaAnalyticsWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(MediaAnalyticsWrapper, PluginWrapper);\n\n\nMediaAnalyticsWrapper.NAME = \"MediaAnalyticsWrapper\";\n\nMediaAnalyticsWrapper.prototype.flashPlugins = [\n  {\n    id: \"OSMFCSMALoader\",\n    host: \"osmf\",\n    main: \"com.akamai.playeranalytics.osmf.OSMFCSMALoaderInfo\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nMediaAnalyticsWrapper.prototype.listNotificationInterests = function() {\n  return MediaAnalyticsWrapper.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, MediaAnalyticsNotifications.SET_DIMENSIONS]);\n};\n\nMediaAnalyticsWrapper.prototype.createFlashVars = function(flashvars) {\n  var dimensions, key, value, _ref, _ref1;\n  dimensions = (_ref = this.player.config) != null ? (_ref1 = _ref.media) != null ? _ref1.mediaanalytics : void 0 : void 0;\n  if (dimensions != null) {\n    for (key in dimensions) {\n      value = dimensions[key];\n      flashvars[\"report_\" + key] = value;\n    }\n  }\n  return flashvars;\n};\n\nMediaAnalyticsWrapper.prototype.createXML = function(xml) {\n  var application, dimensions, element, key, metrics, path, value, vendor, _ref, _ref1;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"akamai\");\n  metrics.appendChild(vendor);\n  if (this.config.config != null) {\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", \"MEDIA_ANALYTICS_BEACON\");\n    element.appendChild(XMLUtils.createTextContent(xml, this.config.config));\n    vendor.appendChild(element);\n    path = ((_ref = this.config.plugin) != null ? _ref.swf : void 0) || \"http://79423.analytics.edgesuite.net/csma/plugin/csma.swf\";\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", \"MEDIA_ANALYTICS_PLUGIN_PATH\");\n    element.appendChild(XMLUtils.createTextContent(xml, path));\n    vendor.appendChild(element);\n  }\n  if (this.config.dimensions != null) {\n    dimensions = xml.createElement(\"property\");\n    dimensions.setAttribute(\"key\", \"dimensions\");\n    vendor.appendChild(dimensions);\n    _ref1 = this.config.dimensions;\n    for (key in _ref1) {\n      value = _ref1[key];\n      element = xml.createElement(\"property\");\n      element.setAttribute(\"key\", key);\n      element.appendChild(XMLUtils.createTextContent(xml, value));\n      dimensions.appendChild(element);\n    }\n  }\n  return xml;\n};\n\nMediaAnalyticsWrapper.prototype.handleNotification = function(notification) {\n  var body, key, media, name, value, _ref, _ref1;\n  MediaAnalyticsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      media = body;\n      if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n        media.dimensions = [];\n        _ref1 = media.mediaanalytics.dimensions;\n        for (key in _ref1) {\n          value = _ref1[key];\n          media.dimensions.push({\n            key: key,\n            value: value\n          });\n        }\n      }\n      break;\n    case MediaAnalyticsNotifications.SET_DIMENSIONS:\n      this.setDimensions(body);\n  }\n};\n\n/**\n*/\nMediaAnalyticsWrapper.prototype.setDimensions = function(value) {\n  this.player.mediaElement.setPlayerProperty(\"maDimensions\", value);\n  return value;\n};\n\n/**\n * The ControlsPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ControlsPlugin() {\n  ControlsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPlugin, Feature);\n\n\nControlsPlugin.prototype.moduleName = \"controls\";\n\nControlsPlugin.prototype.featureName = \"ui\";\n\n/** @override\n*/\nControlsPlugin.prototype.createFramework = function() {\n  this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n  if (this.config[\"native\"] !== true) {\n    ControlsPlugin.__super__.createFramework.call(this);\n    return;\n  }\n  this.player.getMediaElement().controls = true;\n  this.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-native\");\n  this.registerCommand(Notifications.MEDIA_VALIDATED, ControlsMediaValidatedCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, ControlsStartedCommand);\n  this.createView = function() {};\n};\n\n/**\n*/\nControlsPlugin.prototype.applyClickHandler = function(apply) {\n  if (apply == null) {\n    apply = true;\n  }\n  this.player.getMediaElement().onclick = apply ? this.clickHandler.bind(this) : null;\n  this.player.getMediaElement().onplay = apply ? this.clickHandler.bind(this) : null;\n};\n\n/**\n*/\nControlsPlugin.prototype.clickHandler = function(event) {\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createController = function() {\n  ControlsPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.START, ControlsStartCommand);\n  this.registerCommand(Notifications.PLAY, ControlsPlayCommand);\n  this.registerCommand(Notifications.PAUSE, ControlsPauseCommand);\n  this.registerCommand(Notifications.ACTIVE_STATE_CHANGE, ControlsActiveStateChangeCommand);\n  this.registerCommand(Notifications.DISPLAY_STATE_CHANGE, ControlsDisplayStateChangeCommand);\n  this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createModel = function() {\n  this.proxy = new ControlsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createView = function() {\n  this.registerMediator(new ControlsMediator());\n};\n\n/**\n*/\nControlsPlugin.prototype.listNotificationInterests = function() {\n  var key, value;\n  return ((function() {\n    var _results;\n    _results = [];\n    for (key in PanelNotifications) {\n      value = PanelNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([Notifications.CHANGE_MEDIA, Notifications.MEDIA_CHANGE, Notifications.TIME_UPDATE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.ENDED, Notifications.CUES_CHANGE, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN, Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.ACTIVE_STATE_CHANGE, Notifications.START, Notifications.PLAY, Notifications.PAUSE, Notifications.ERROR, AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED, Notifications.SET_MEDIA, Notifications.DISPLAY_TIME, Notifications.MEDIA_VALIDATED, Notifications.STARTED, Notifications.PLAY_REQUEST, Notifications.IS_LIVE, Notifications.VOLUME_CHANGE, Notifications.DISPLAY_STATE_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY]);\n};\n\n/**\n*/\nControlsPlugin.prototype.listNotificationPublications = function() {\n  return ControlsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_ACTIVE_STATE, Notifications.TOGGLE_FULL_SCREEN, UserNotifications.SEEK, Notifications.TOGGLE_ACTIVE, UserNotifications.TOGGLE_PLAY_PAUSE, UserNotifications.GO_LIVE, Notifications.END, Notifications.REPLAY, AdNotifications.AD_CONTAINER_CREATED, Notifications.CHANGE_VOLUME, Notifications.TOGGLE_MUTED, UserSettingsNotifications.UPDATE_SETTINGS]);\n};\n\n/**\n * @param {string} value The contorls mode.\n * @expose\n*/\nControlsPlugin.prototype.setMode = function(value) {\n  this.proxy.setMode(value);\n  return value;\n};\n\n/**\n * @return {string} The controls mode.\n * @expose\n*/\nControlsPlugin.prototype.getMode = function() {\n  return this.proxy.getMode();\n};\n\n/**\n * @param {boolean} value The autohide flag.\n * @expose\n*/\nControlsPlugin.prototype.setAutoHide = function(value) {\n  this.proxy.setAutoHide(value);\n  return value;\n};\n\n/**\n * @return {boolean} The autohide flag.\n * @expose\n*/\nControlsPlugin.prototype.getAutoHide = function() {\n  return this.proxy.getAutoHide();\n};\n\n\nAMP.registerPlugin(\"controls\", \"html\", ControlsPlugin);\nAMP.registerPlugin(\"controls\", \"flash\", ControlsWrapper);\nAMP.registerPlugin(\"controls\", \"external\", ControlsPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar EventManagementNotifications = {\n  EVENT_STATE_CHANGED: \"eventStateChanged\"\n};\n\nfunction EventManagementWrapper() {\n  return EventManagementWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(EventManagementWrapper, PluginWrapper);\n\n\nEventManagementWrapper.NAME = \"EventManagementWrapper\";\n\n/** @override\n*/\nEventManagementWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.enabled != null) {\n    flashvars.eventmanagementstates_enabled = this.config.enabled;\n  }\n  if (this.config.url != null) {\n    flashvars.eventmanagementstates_status_url = this.config.url;\n  }\n  if (this.config.interval != null) {\n    flashvars.eventmanagementstates_status_interval = this.config.interval;\n  }\n  return flashvars;\n};\n\n/** @override\n*/\nEventManagementWrapper.prototype.createXML = function(xml) {\n  var application, eventmanagementstates, node, property, state, states, _i, _len, _ref;\n  application = xml.firstChild;\n  eventmanagementstates = xml.getElementsByTagName(\"eventmanagementstates\");\n  if (!(eventmanagementstates != null) || eventmanagementstates.length === 0) {\n    eventmanagementstates = xml.createElement(\"eventmanagementstates\");\n    application.appendChild(eventmanagementstates);\n  } else {\n    eventmanagementstates = eventmanagementstates[0];\n  }\n  states = xml.createElement(\"states\");\n  eventmanagementstates.appendChild(states);\n  _ref = this.config.states;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    state = _ref[_i];\n    node = xml.createElement(\"state\");\n    states.appendChild(node);\n    property = xml.createElement(\"property\");\n    property.setAttribute(\"key\", \"ID\");\n    property.appendChild(XMLUtils.createTextContent(xml, state.id));\n    node.appendChild(property);\n    property = xml.createElement(\"property\");\n    property.setAttribute(\"key\", \"POSTER_SRC\");\n    property.appendChild(XMLUtils.createTextContent(xml, state.poster));\n    node.appendChild(property);\n    if (state.url != null) {\n      property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", \"URL\");\n      property.appendChild(XMLUtils.createTextContent(xml, state.url));\n      node.appendChild(property);\n    }\n  }\n  return xml;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction EventManagementProxy(config) {\n  var _this = this;\n  EventManagementProxy.__super__.constructor.call(this, config);\n  this.poller = new Poller();\n  this.poller.ondatachange = function(event) {\n    var id, state, _i, _len, _ref;\n    id = event.detail;\n    if (id === \"on\") {\n      state = EventManagementProxy.ON;\n    } else {\n      _ref = _this.data.states;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        state = _ref[_i];\n        if (state.id === id) {\n          break;\n        }\n      }\n    }\n    if (state != null) {\n      return _this.setState(state);\n    }\n  };\n}\n\n\n__extends(EventManagementProxy, ModuleProxy);\n\n\nEventManagementProxy.NAME = ModuleProxy.NAME;\n\nEventManagementProxy.ON = {\n  id: \"on\"\n};\n\nEventManagementProxy.prototype.defaults = {\n  url: null,\n  interval: null,\n  states: null,\n  enabled: false\n};\n\nEventManagementProxy.prototype.poller = null;\n\nEventManagementProxy.prototype.state = null;\n\nEventManagementProxy.prototype.initialize = function() {\n  if (this.data.enabled === true) {\n    this.setURL(this.data.url);\n    this.setInterval(this.data.interval);\n    this.poller.start();\n  }\n};\n\nEventManagementProxy.prototype.setURL = function(value) {\n  this.data.url = this.poller.url = value;\n  return value;\n};\n\nEventManagementProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\n/**\n *\n*/\nEventManagementProxy.prototype.getInterval = function() {\n  return this.data.interval;\n};\n\nEventManagementProxy.prototype.setInterval = function(value) {\n  this.data.interval = this.poller.interval = value * 1000;\n  return value;\n};\n\nEventManagementProxy.prototype.setState = function(value) {\n  this.state = value;\n  this.sendNotification(EventManagementNotifications.EVENT_STATE_CHANGED, value);\n  return value;\n};\n\nEventManagementProxy.prototype.getState = function() {\n  return this.state;\n};\n\n/**\n * The EventManagementMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction EventManagementMediator() {\n  EventManagementMediator.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementMediator, OverlayMediator);\n\n\nEventManagementMediator.prototype.componentName = \"event-management\";\n\nEventManagementMediator.prototype.poster = null;\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.onRegister = function() {\n  EventManagementMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.poster = this.create(\"event-poster\", false, \"img\");\n};\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.listNotificationInterests = function() {\n  return [EventManagementNotifications.EVENT_STATE_CHANGED];\n};\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.handleNotification = function(notification) {\n  var state;\n  switch (notification.getName()) {\n    case EventManagementNotifications.EVENT_STATE_CHANGED:\n      state = notification.getBody();\n      if (state.id !== \"on\") {\n        if (state.poster != null) {\n          this.poster.src = state.poster;\n          this.viewComponent.appendChild(this.poster);\n        }\n        this.classList.remove(\"hidden\");\n        this.sendNotification(Notifications.PAUSE);\n        this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n      } else {\n        if (this.viewComponent.contains(this.poster)) {\n          this.viewComponent.removeChild(this.poster);\n        }\n        this.classList.add(\"hidden\");\n      }\n  }\n};\n\n/**\n * The EventManagementStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction EventManagementStateChangeCommand() {\n  EventManagementStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementStateChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nEventManagementStateChangeCommand.prototype.execute = function(notification) {\n  var locked;\n  locked = notification.getBody().id !== EventManagementProxy.ON.id;\n  this.sendNotification(Notifications.LOCK, locked);\n  EventManagementStateChangeCommand.__super__.execute.call(this, notification);\n  if (locked === false && this.facade.player.getAutoplay() === true) {\n    this.sendNotification(Notifications.PLAY);\n  }\n};\n\n/**\n * The MediaAnalyticsPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction MediaAnalyticsPlugin() {\n  MediaAnalyticsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsPlugin, Plugin);\n\n\nMediaAnalyticsPlugin.prototype.moduleName = \"mediaanalytics\";\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.initialize = function(config, player) {\n  window.AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = config.config;\n  MediaAnalyticsPlugin.__super__.initialize.call(this, config, player);\n};\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.createModel = function() {\n  this.proxy = new MediaAnalyticsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.createController = function() {\n  MediaAnalyticsPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.READY, MediaAnalyticsReadyCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaAnalyticsChangeMediaCommand);\n  this.registerCommand(AdNotifications.BREAK_START, MediaAnalyticsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, MediaAnalyticsAdBreakEndCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, MediaAnalyticsAdLoadedCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, MediaAnalyticsAdStartCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, MediaAnalyticsAdTimeUpdateCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, MediaAnalyticsAdEndCommand);\n  this.registerCommand(MediaAnalyticsNotifications.SET_DIMENSIONS, MediaAnalyticsSetDimensionsCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, MediaAnalyticsContentChangedCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOAD_START, MediaAnalyticsFragmentLoadStartCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOADED, MediaAnalyticsFragmentLoadedCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGE, MediaAnalyticsBitrateSwitchCommand);\n};\n\n/**\n*/\nMediaAnalyticsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.MEDIA_CHANGE, AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_TIME_UPDATE, AdNotifications.AD_ENDED, MediaAnalyticsNotifications.SET_DIMENSIONS, Notifications.CONTENT_CHANGED, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED, Notifications.QUALITY_CHANGE];\n};\n\n/**\n * Sets the media analytics dimensions.\n *\n * @param {Object} value The hash representing dimensions.\n * @expose\n*/\nMediaAnalyticsPlugin.prototype.setDimensions = function(value) {\n  this.retrieveProxy(MediaAnalyticsProxy.NAME).setDimensions(value);\n  return value;\n};\n\n\nAMP.registerPlugin(\"mediaanalytics\", \"html\", MediaAnalyticsPlugin);\nAMP.registerPlugin(\"mediaanalytics\", \"flash\", MediaAnalyticsWrapper);\n\nfunction BrandingWrapper() {\n  return BrandingWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(BrandingWrapper, PluginWrapper);\n\n\nBrandingWrapper.NAME = \"BrandingWrapper\";\n\nBrandingWrapper.prototype.flashView = {\n  elements: {\n    logoOverlay: {\n      attributes: {\n        style: \"width: 150px; height: 53px; right: 15px; top: 15px; opacity: 0.5;\"\n      }\n    }\n  }\n};\n\nBrandingWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.id != null) {\n    flashvars.branding = this.config.id;\n  }\n  return flashvars;\n};\n\nBrandingWrapper.prototype.createXML = function(xml) {\n  var backgroundImage, style, view, _ref, _ref1, _ref2;\n  view = this.player.flashView;\n  if ((((_ref = this.config) != null ? _ref.logo : void 0) != null) && (view != null)) {\n    backgroundImage = \"background-image: url('\" + this.config.logo + \"');\";\n    style = ((_ref1 = view.elements.logoOverlay) != null ? (_ref2 = _ref1.attributes) != null ? _ref2.style : void 0 : void 0) || \"\";\n    if (style.indexOf(\"background-image:\") !== -1) {\n      style = style.replace(/background-image: [A-Za-z0-9_\\-\\.\\/\\\\;\\(\\)\"'#{}]+/, backgroundImage);\n    } else {\n      style = backgroundImage + style;\n    }\n    view.elements.logoOverlay.attributes.style = style;\n  }\n  return xml;\n};\n\n/**\n * The AdChoicesMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction BrandingMediator() {\n  BrandingMediator.__super__.constructor.call(this);\n}\n\n\n__extends(BrandingMediator, OverlayMediator);\n\n\nBrandingMediator.prototype.componentName = \"branding\";\n\nBrandingMediator.prototype.logo = null;\n\nBrandingMediator.prototype.text = null;\n\nBrandingMediator.prototype.container = null;\n\nBrandingMediator.prototype.onRegister = function() {\n  BrandingMediator.__super__.onRegister.call(this);\n  this.container = this.create(\"branding-container\");\n  this.logo = this.create([\"branding-image\", \"hidden\"], this.container, \"img\");\n  this.text = this.create(\"branding-text\", this.container);\n};\n\n/**\n * @override\n*/\nBrandingMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n/**\n * @override\n*/\nBrandingMediator.prototype.handleNotification = function(notification) {\n  var branding, href,\n    _this = this;\n  switch (notification.getName()) {\n    case Notifications.READY:\n      branding = notification.getBody().branding;\n      if (!(branding != null)) {\n        return;\n      }\n      if (branding.logo != null) {\n        this.logo.src = this.facade.evaluatePaths(branding.logo);\n        this.logo.onerror = function() {\n          return ClassList.add(\"hidden\", _this.logo, Namespace.PREFIX);\n        };\n        ClassList.remove(\"hidden\", this.logo, Namespace.PREFIX);\n      } else {\n        ClassList.add(\"hidden\", this.logo, Namespace.PREFIX);\n      }\n      href = this.config.getDomain();\n      if ((href != null) && href.indexOf(\"http\") !== 0) {\n        href = location.protocol + \"//\" + href;\n        this.text.innerHTML = \"<span>\" + (this.localizationManager.getString(LocalizationConstants.MSG_VIEW_ALL)) + \"<a href=\\\"\" + href + \"\\\" target=\\\"\" + (this.config.getTarget()) + \"\\\">\" + (this.config.getDomain()) + \"</a> \" + (this.localizationManager.getString(LocalizationConstants.MSG_VIDEO)) + \".\";\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction BrandingProxy(config) {\n  BrandingProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(BrandingProxy, ModuleProxy);\n\n\n/** @static\n*/\nBrandingProxy.NAME = ModuleProxy.NAME;\n\nBrandingProxy.prototype.defaults = {\n  id: null,\n  title: null,\n  link: null,\n  logo: null,\n  target: null\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getID = function() {\n  return this.data.id;\n};\n\nBrandingProxy.prototype.setID = function(value) {\n  return this.data.id = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nBrandingProxy.prototype.setTarget = function(value) {\n  return this.data.target = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getTitle = function() {\n  return this.data.title;\n};\n\nBrandingProxy.prototype.setTitle = function(value) {\n  return this.data.title = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getLink = function() {\n  return this.data.link;\n};\n\nBrandingProxy.prototype.setLink = function(value) {\n  return this.data.link = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getLogo = function() {\n  return this.data.logo;\n};\n\nBrandingProxy.prototype.setLogo = function(value) {\n  return this.data.logo = value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FeedNotifications = {\n  LOAD_FEED: \"loadfeed\",\n  FEED_CHANGED: \"feedchanged\",\n  FEED_LOADED: \"feedloaded\",\n  FEED_ERROR: \"feederror\"\n};\n\n/**\n * The EventManagementPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @extends {Plugin}\n * @private\n*/\nfunction EventManagementPlugin() {\n  EventManagementPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementPlugin, Plugin);\n\n\nEventManagementPlugin.prototype.moduleName = \"eventmanagement\";\n\n/** @override\n*/\nEventManagementPlugin.prototype.createModel = function() {\n  this.registerProxy(new EventManagementProxy(this.config));\n};\n\n/** @override\n*/\nEventManagementPlugin.prototype.createController = function() {\n  EventManagementPlugin.__super__.createController.call(this);\n  this.registerCommand(EventManagementNotifications.EVENT_STATE_CHANGED, EventManagementStateChangeCommand);\n};\n\nEventManagementPlugin.prototype.createView = function() {\n  this.registerMediator(new EventManagementMediator());\n};\n\n/** @override\n*/\nEventManagementPlugin.prototype.listNotificationPublications = function() {\n  return EventManagementPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_DISPLAY_STATE, Notifications.PLAY, Notifications.PAUSE, Notifications.LOCK, EventManagementNotifications.EVENT_STATE_CHANGED]);\n};\n\n\nAMP.registerPlugin(\"eventmanagement\", \"html\", EventManagementPlugin);\nAMP.registerPlugin(\"eventmanagement\", \"flash\", EventManagementWrapper);\n\n/**\n * The FeedProxy class.\n *\n * @constructor\n * @private\n * @extends {ModuleProxy}\n * @param {Object} config The configuration object.\n*/\nfunction FeedProxy(config) {\n  FeedProxy.__super__.constructor.call(this, config);\n  this.helper = new MRSSHelper();\n}\n\n\n__extends(FeedProxy, ModuleProxy);\n\n\nFeedProxy.NAME = ModuleProxy.NAME;\n\nFeedProxy.prototype.defaults = {\n  url: null,\n  data: null\n};\n\nFeedProxy.prototype.feed = null;\n\nFeedProxy.prototype.helper = null;\n\nFeedProxy.prototype.setURL = function(value) {\n  var _this = this;\n  this.data.url = this.facade.evaluatePaths(value);\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"request\", this.data.url));\n  this.helper.getFeed(this.data.url).then(function(feed) {\n    _this.sendNotification(FeedNotifications.FEED_LOADED, feed);\n    _this.sendNotification(FeedNotifications.CHANGE_FEED, feed);\n  })[\"catch\"](function(error) {\n    _this.sendNotification(FeedNotifications.FEED_ERROR, {\n      error: error,\n      url: value\n    });\n    Logger.instance.error(\"[AMP Feed Load Error]\", _this.data.url, error);\n  });\n  return value;\n};\n\nFeedProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nFeedProxy.prototype.setFeedData = function(value) {\n  this.data.data = value;\n  this.feed = this.helper.createFeed(value);\n  this.sendNotification(FeedNotifications.FEED_CHANGED, this.feed);\n  return value;\n};\n\nFeedProxy.prototype.getFeedData = function() {\n  return this.data.data;\n};\n\nFeedProxy.prototype.invoke = function() {\n  var func;\n  if ((this.data.url != null) && this.data.url !== \"\") {\n    func = this.sendNotification.bind(this, FeedNotifications.LOAD_FEED, this.data.url);\n  } else if (this.data.data != null) {\n    func = this.sendNotification.bind(this, FeedNotifications.CHANGE_FEED, this.data.data);\n  }\n  if (func != null) {\n    setTimeout(func, 1);\n  }\n};\n\n/**\n * The LoadFeedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction LoadFeedCommand() {\n  LoadFeedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(LoadFeedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nLoadFeedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.setURL(notification.getBody());\n};\n\n/**\n * The ChangeFeedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ChangeFeedCommand() {\n  ChangeFeedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeFeedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeFeedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.setFeedData(notification.getBody());\n};\n\n/**\n * The FeedChangedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction FeedChangedCommand() {\n  FeedChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FeedChangedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFeedChangedCommand.prototype.execute = function(notification) {\n  var feed, mediaVO;\n  FeedChangedCommand.__super__.execute.call(this, notification);\n  this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  feed = notification.getBody();\n  mediaVO = feed.item[0];\n  this.player.sendNotification(Notifications.SET_MEDIA, mediaVO);\n};\n\n/**\n * The FeedInitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FeedInitializedCommand() {\n  FeedInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FeedInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFeedInitializedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.invoke();\n};\n\nfunction FeedWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  FeedWrapper.__super__.constructor.call(this, player, config);\n  if (config.url != null) {\n    this.url = config.url;\n  }\n  if (config.data != null) {\n    this.data = config.data;\n  }\n  this.player.load = function() {};\n}\n\n\n__extends(FeedWrapper, PluginWrapper);\n\n\nFeedWrapper.NAME = \"FeedWrapper\";\n\nFeedWrapper.prototype.url = null;\n\nFeedWrapper.prototype.data = null;\n\nFeedWrapper.prototype.updateData = true;\n\n/** @override\n*/\nFeedWrapper.prototype.createFlashVars = function(flashvars) {\n  if ((this.url != null) && this.url !== \"\") {\n    flashvars.data_feed_url = escape(this.facade.evaluatePaths(this.url));\n  }\n};\n\n/** @override\n*/\nFeedWrapper.prototype.listNotificationInterests = function() {\n  return FeedWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.READY, FlashNotifications.FEED_LOADED, FlashNotifications.LOAD_FEED]);\n};\n\n/**\n*/\nFeedWrapper.prototype.handleNotification = function(notification) {\n  var body, name, type,\n    _this = this;\n  FeedWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.FEED_LOADED:\n      this.data = body;\n      this.sendNotification(FeedNotifications.FEED_CHANGED, this.data);\n      break;\n    case FlashNotifications.LOAD_FEED:\n      type = \"request\";\n      break;\n    case FlashNotifications.READY:\n      if (this.data != null) {\n        setTimeout(function() {\n          _this.setData(_this.data);\n        }, 25);\n      } else if ((this.url != null) && this.url !== \"\") {\n        this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n      }\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n*/\nFeedWrapper.prototype.setURL = function(value) {\n  if ((value != null) && value !== \"\") {\n    this.url = value;\n    this.player.mediaElement.playFile(this.url, this.player.getAutoplay());\n    this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n  }\n  return value;\n};\n\nFeedWrapper.prototype.getURL = function() {\n  return this.url;\n};\n\n/**\n*/\nFeedWrapper.prototype.setData = function(value) {\n  this.data = value;\n  this.updateData = false;\n  this.player.mediaElement.playFile(this.data, this.player.getAutoplay());\n  return value;\n};\n\nFeedWrapper.prototype.getData = function() {\n  return this.data;\n};\n\n/**\n * The BrandingPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction BrandingPlugin() {\n  BrandingPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(BrandingPlugin, Plugin);\n\n\nBrandingPlugin.NAME = \"BrandingPlugin\";\n\nBrandingPlugin.prototype.moduleName = \"branding\";\n\n/** @override\n*/\nBrandingPlugin.prototype.createModel = function() {\n  this.registerProxy(new BrandingProxy(this.config));\n};\n\nBrandingPlugin.prototype.createView = function() {\n  this.registerMediator(new BrandingMediator());\n};\n\n/** @override\n*/\nBrandingPlugin.prototype.onRegister = function() {\n  if (this.config.id != null) {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"branding-\" + this.config.id);\n  }\n  BrandingPlugin.__super__.onRegister.call(this);\n};\n\n/**\n*/\nBrandingPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n\nAMP.registerPlugin(\"branding\", \"html\", BrandingPlugin);\nAMP.registerPlugin(\"branding\", \"flash\", BrandingWrapper);\nAMP.registerPlugin(\"branding\", \"external\", BrandingPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AutoAdvanceNotifications = {\n  TIME_UPDATE: \"autoadvancetimeupdate\",\n  START: \"autoadvancestart\",\n  STOP: \"autoadvancestop\",\n  ADVANCE: \"autoadvanceadvance\"\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AutoAdvanceWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  AutoAdvanceWrapper.__super__.constructor.call(this, player, config);\n  if (config.interval != null) {\n    this.interval = config.interval;\n  }\n  if (config.handler != null) {\n    this.handler = config.handler;\n  }\n}\n\n\n__extends(AutoAdvanceWrapper, PluginWrapper);\n\n\nAutoAdvanceWrapper.NAME = \"AutoAdvanceWrapper\";\n\nAutoAdvanceWrapper.prototype.interval = null;\n\nAutoAdvanceWrapper.prototype.handler = null;\n\nAutoAdvanceWrapper.prototype.getInterval = function() {\n  return this.interval;\n};\n\nAutoAdvanceWrapper.prototype.setInterval = function(value) {\n  return this.interval = value;\n};\n\nAutoAdvanceWrapper.prototype.getHandler = function() {\n  return this.handler;\n};\n\nAutoAdvanceWrapper.prototype.setHandler = function(value) {\n  return this.handler = value;\n};\n\n/** @override\n*/\nAutoAdvanceWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.AUTO_ADVANCE];\n};\n\n/**\n*/\nAutoAdvanceWrapper.prototype.handleNotification = function(notification) {\n  var body, flashvars, name, type, _base;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      if (this.interval != null) {\n        flashvars.next_video_timer = this.interval;\n        flashvars.auto_play_list = true;\n      }\n      break;\n    case FlashNotifications.AUTO_ADVANCE:\n      if (typeof (_base = this.config).handler === \"function\") {\n        _base.handler();\n      }\n      type = \"advance\";\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type));\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AutoAdvanceProxy(config) {\n  AutoAdvanceProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AutoAdvanceProxy, ModuleProxy);\n\n\n/** @static\n*/\nAutoAdvanceProxy.NAME = ModuleProxy.NAME;\n\nAutoAdvanceProxy.prototype.defaults = {\n  interval: 15,\n  handler: null\n};\n\nAutoAdvanceProxy.prototype.currentTime = 0;\n\nAutoAdvanceProxy.prototype.timeout = null;\n\nAutoAdvanceProxy.prototype.start = function() {\n  var _this = this;\n  this.currentTime = this.data.interval;\n  this.timeout = setInterval(function() {\n    _this.updateTime();\n  }, 1000);\n  this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n};\n\nAutoAdvanceProxy.prototype.stop = function() {\n  clearInterval(this.timeout);\n};\n\nAutoAdvanceProxy.prototype.updateTime = function() {\n  this.currentTime--;\n  this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n  if (this.currentTime <= 0) {\n    this.stop();\n    this.sendNotification(AutoAdvanceNotifications.ADVANCE, this.data.handler);\n  }\n};\n\n/**\n * The AutoAdvanceStartCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AutoAdvanceStartCommand() {\n  AutoAdvanceStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAutoAdvanceStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoadvance-mode\");\n  this.proxy.start();\n  AutoAdvanceStartCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AutoAdvanceAdvanceCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AutoAdvanceAdvanceCommand() {\n  AutoAdvanceAdvanceCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceAdvanceCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAutoAdvanceAdvanceCommand.prototype.execute = function(notification) {\n  var handler;\n  handler = notification.getBody();\n  if ((handler != null)) {\n    if (typeof handler === \"string\") {\n      eval(\"\" + handler + \"()\");\n    } else if (typeof handler === \"function\") {\n      handler();\n    }\n  }\n  this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"autoadvance-mode\");\n  AutoAdvanceAdvanceCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AutoAdvanceEndedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AutoAdvanceEndedCommand() {\n  AutoAdvanceEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAutoAdvanceEndedCommand.prototype.execute = function(notification) {\n  if (this.proxy.getData().interval != null) {\n    this.sendNotification(AutoAdvanceNotifications.START, notification.getBody());\n  }\n};\n\n/**\n * The AutoAdvanceStopCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AutoAdvanceStopCommand() {\n  AutoAdvanceStopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceStopCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAutoAdvanceStopCommand.prototype.execute = function(notification) {\n  this.proxy.stop();\n};\n\n/**\n * The AutoAdvanceMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction AutoAdvanceMediator() {\n  AutoAdvanceMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceMediator, OverlayMediator);\n\n\nAutoAdvanceMediator.prototype.componentName = \"autoadvance\";\n\nAutoAdvanceMediator.prototype.text = null;\n\nAutoAdvanceMediator.prototype.onRegister = function() {\n  AutoAdvanceMediator.__super__.onRegister.call(this);\n  this.text = this.create(\"autoadvance-text\");\n};\n\n/**\n * @override\n*/\nAutoAdvanceMediator.prototype.listNotificationInterests = function() {\n  return [AutoAdvanceNotifications.TIME_UPDATE];\n};\n\n/**\n * @override\n*/\nAutoAdvanceMediator.prototype.handleNotification = function(notification) {\n  var time;\n  switch (notification.getName()) {\n    case AutoAdvanceNotifications.TIME_UPDATE:\n      time = notification.getBody();\n      this.text.textContent = \"\" + (this.localizationManager.getString('MSG_NEXT_VIDEO')) + \" \" + time + \" \" + (this.localizationManager.getString('MSG_SECONDS'));\n  }\n};\n\n/**\n * The FeedPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction FeedPlugin() {\n  FeedPlugin.__super__.constructor.call(this);\n  try {\n    Object.defineProperties(this, {\n      url: {\n        get: this.getURL,\n        set: this.setURL,\n        enumerable: true,\n        configurable: false\n      },\n      data: {\n        get: this.getData,\n        set: this.setData,\n        enumerable: true,\n        configurable: false\n      }\n    });\n  } catch (error) {\n    console.error(error);\n  }\n}\n\n\n__extends(FeedPlugin, Plugin);\n\n\nFeedPlugin.prototype.moduleName = \"feed\";\n\n/** @override\n*/\nFeedPlugin.prototype.createModel = function() {\n  this.proxy = new FeedProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.createController = function() {\n  FeedPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.READY, FeedInitializedCommand);\n  this.registerCommand(FeedNotifications.LOAD_FEED, LoadFeedCommand);\n  this.registerCommand(FeedNotifications.CHANGE_FEED, ChangeFeedCommand);\n  this.registerCommand(FeedNotifications.FEED_CHANGED, FeedChangedCommand);\n  this.registerCommand(FeedNotifications.FEED_LOADED, PluginEventCommand);\n  this.registerCommand(FeedNotifications.FEED_ERROR, PluginEventCommand);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.listNotificationInterests = function() {\n  return FeedPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.READY]);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return FeedPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in FeedNotifications) {\n      value = FeedNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * @param {string} value The url of the feed.\n * @expose\n*/\nFeedPlugin.prototype.setURL = function(value) {\n  this.sendNotification(FeedNotifications.LOAD_FEED, value);\n  return value;\n};\n\n/**\n * @return {string} The url of the feed.\n * @expose\n*/\nFeedPlugin.prototype.getURL = function() {\n  return this.proxy.getURL();\n};\n\n/**\n * @param {Object} value The MRSS feed object\n * @expose\n*/\nFeedPlugin.prototype.setData = function(value) {\n  this.sendNotification(FeedNotifications.CHANGE_FEED, value);\n  return value;\n};\n\n/**\n * @return {Object} The MRSS feed object.\n * @expose\n*/\nFeedPlugin.prototype.getData = function() {\n  return this.proxy.getFeedData();\n};\n\n\nAMP.registerPlugin(\"feed\", \"html\", FeedPlugin);\nAMP.registerPlugin(\"feed\", \"flash\", FeedWrapper);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar RecommendationsNotifications = {\n  RECOMMENDATIONS_LOADED: \"recommendationsloaded\",\n  RECOMMENDATION_SELECTED: \"recommendationsselected\"\n};\n\nfunction RecommendationVO(guid, link, title, description, thumbnail, duration, pubDate, target, metadata) {\n  this.guid = guid;\n  this.link = link;\n  this.title = title;\n  this.description = description;\n  this.thumbnail = thumbnail;\n  this.duration = duration;\n  this.pubDate = pubDate;\n  this.target = target;\n  this.metadata = metadata != null ? metadata : {};\n}\n\nRecommendationVO.prototype.guid = null;\n\nRecommendationVO.prototype.link = null;\n\nRecommendationVO.prototype.title = null;\n\nRecommendationVO.prototype.description = null;\n\nRecommendationVO.prototype.thumbnail = null;\n\nRecommendationVO.prototype.duration = null;\n\nRecommendationVO.prototype.pubDate = null;\n\nRecommendationVO.prototype.target = null;\n\nRecommendationVO.prototype.metadata = null;\n\n/**\n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction RecommendationsWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  RecommendationsWrapper.__super__.constructor.call(this, player, config);\n  if (config.url != null) {\n    this.url = config.url;\n  }\n  if (config.target != null) {\n    this.target = config.target;\n  }\n}\n\n\n__extends(RecommendationsWrapper, PluginWrapper);\n\n\nRecommendationsWrapper.NAME = \"RecommendationsWrapper\";\n\nRecommendationsWrapper.prototype.flashPlugins = [\n  {\n    id: \"RecommendationsPlugin\",\n    src: '#{paths.resources}plugins/RecommendationsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"RecommendationsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nRecommendationsWrapper.prototype.flashView = {\n  elements: {\n    recommendationSlate: {\n      attributes: {\n        items: \"5\",\n        viewMode: \"grid\"\n      }\n    }\n  }\n};\n\nRecommendationsWrapper.prototype.url = null;\n\nRecommendationsWrapper.prototype.target = null;\n\nRecommendationsWrapper.prototype.recommendations = null;\n\n/**\n*/\nRecommendationsWrapper.prototype.getFeatureName = function() {\n  return \"recommendations\";\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getData = function() {\n  return this.recommendations;\n};\n\nRecommendationsWrapper.prototype.setData = function(value) {\n  return this.recommendations = value;\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getTarget = function() {\n  var _ref, _ref1;\n  return this.target || ((_ref = this.player) != null ? (_ref1 = _ref.config) != null ? _ref1.target : void 0 : void 0);\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getURL = function() {\n  return this.url;\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.createFlashVars = function(flashvars) {\n  flashvars.recommendations_partner = \"mrss\";\n  if (this.config.target != null) {\n    flashvars.external_target = this.config.target;\n  }\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.createXML = function(xml) {\n  var application, recommendations, vendor;\n  application = xml.firstChild;\n  recommendations = xml.getElementsByTagName(\"recommendations\")[0];\n  if (!(recommendations != null)) {\n    recommendations = xml.createElement(\"recommendations\");\n    application.appendChild(recommendations);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"mrss\");\n  recommendations.appendChild(vendor);\n  this.createProperty(xml, \"RECOMMENDATIONS_MRSS_URL\", this.url, vendor);\n};\n\n/** @override\n*/\nRecommendationsWrapper.prototype.listNotificationInterests = function() {\n  return RecommendationsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.RECOMMENDATION_SELECTED, FlashNotifications.RECOMMENDATIONS_LOADED]);\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.handleNotification = function(notification) {\n  var body, name, type;\n  RecommendationsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.RECOMMENDATIONS_LOADED:\n      type = \"loaded\";\n      this.recommendations = body;\n      break;\n    case FlashNotifications.RECOMMENDATION_SELECTED:\n      type = \"selected\";\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n * The RecommendationsSelectedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction RecommendationSelectedCommand() {\n  RecommendationSelectedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationSelectedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nRecommendationSelectedCommand.prototype.execute = function(notification) {\n  var rec;\n  RecommendationSelectedCommand.__super__.execute.call(this, notification);\n  rec = notification.getBody();\n  if (rec.target !== \"none\" && rec.target !== \"player\") {\n    window.open(rec.link, rec.target);\n  }\n};\n\n/**\n * The RecommendationsPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction RecommendationsPlayCommand() {\n  RecommendationsPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nRecommendationsPlayCommand.prototype.execute = function(notification) {\n  this.proxy.invoke();\n};\n\n/**\n * The RecommendationsPlayStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction RecommendationsPlayStateChangeCommand() {\n  RecommendationsPlayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlayStateChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nRecommendationsPlayStateChangeCommand.prototype.execute = function(notification) {\n  var recommendations, states;\n  recommendations = this.proxy.getRecommendations();\n  states = notification.getBody();\n  if (states.value === PlayState.ENDED) {\n    if ((recommendations != null ? recommendations.length : void 0) > 0) {\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"recommendations-mode\");\n    }\n  } else if (states.previous === PlayState.ENDED) {\n    if ((recommendations != null ? recommendations.length : void 0) > 0) {\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"recommendations-mode\");\n    }\n  }\n};\n\n/**\n * Proxy for recommendations feature\n *\n * @constructor\n * @private\n*/\nfunction RecommendationsProxy(config) {\n  RecommendationsProxy.__super__.constructor.call(this, config);\n  this.helper = new MRSSHelper();\n}\n\n\n__extends(RecommendationsProxy, PluginProxy);\n\n\n/** @static\n*/\nRecommendationsProxy.NAME = ModuleProxy.NAME;\n\nRecommendationsProxy.prototype.defaults = {\n  url: null,\n  target: \"_blank\"\n};\n\nRecommendationsProxy.prototype.loaded = true;\n\nRecommendationsProxy.prototype.recommendations = null;\n\nRecommendationsProxy.prototype.helper = null;\n\n/** Getter/Setter for RecommendationVO.\n*/\nRecommendationsProxy.prototype.getRecommendations = function() {\n  return this.recommendations;\n};\n\nRecommendationsProxy.prototype.setRecommendations = function(value) {\n  this.recommendations = value;\n  this.sendNotification(RecommendationsNotifications.RECOMMENDATIONS_LOADED, this.recommendations);\n  return value;\n};\n\nRecommendationsProxy.prototype.getURL = function() {\n  return this.getConfigurationData().url;\n};\n\nRecommendationsProxy.prototype.setURL = function(value) {\n  this.data.url = value;\n  this.invoke();\n  return value;\n};\n\nRecommendationsProxy.prototype.getTarget = function() {\n  return this.getConfigurationData().target || this.facade.player.retrieveProxy(ConfigurationProxy.NAME).getTarget();\n};\n\nRecommendationsProxy.prototype.setTarget = function(value) {\n  this.data.target = value;\n  return value;\n};\n\n/**\n *\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nRecommendationsProxy.prototype.invoke = function() {\n  var url;\n  url = this.getURL();\n  if (!(url != null) || url === \"\") {\n    this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error: No url provided\");\n    return;\n  }\n  Utils.getFeed(url).then(this.onload.bind(this))[\"catch\"](this.onerror.bind(this));\n};\n\nRecommendationsProxy.prototype.onload = function(json) {\n  var recs;\n  recs = this.createRecommendations(json);\n  this.setRecommendations(recs);\n};\n\nRecommendationsProxy.prototype.onerror = function(error) {\n  this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error:\", error);\n};\n\n/**\n*/\nRecommendationsProxy.prototype.createRecommendations = function(feed) {\n  var item, rec, recs, _i, _len, _ref;\n  feed = this.helper.createFeed(feed);\n  recs = [];\n  _ref = feed.item;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    item = _ref[_i];\n    rec = new RecommendationVO(item.guid, item.link, item.title, item.description, item.thumbnail, item.duration, item.pubDate, this.getTarget(), item);\n    recs.push(rec);\n  }\n  return recs;\n};\n\n/**\n * The RecommendationsMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction RecommendationsMediator() {\n  RecommendationsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsMediator, OverlayMediator);\n\n\nRecommendationsMediator.prototype.componentName = \"recommendations\";\n\nRecommendationsMediator.prototype.listArea = null;\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.onRegister = function() {\n  var label;\n  RecommendationsMediator.__super__.onRegister.call(this);\n  label = this.createText(\"recommendations-label\", \"Recommended\");\n  this.listArea = this.create(\"recommendations-list-area\");\n};\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n};\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len;\n  switch (notification.getName()) {\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.listArea.innerHTML = \"\";\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec);\n        }\n      }\n  }\n};\n\nRecommendationsMediator.prototype.addElement = function(recommendation) {\n  var listItem,\n    _this = this;\n  listItem = this.create(\"recommendation\", this.listArea);\n  if (listItem.dataset == null) {\n    listItem.dataset = {};\n  }\n  listItem.dataset.link = recommendation.link;\n  listItem.dataset.target = recommendation.target;\n  listItem.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendation-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendation-text'>\" + recommendation.description + \"</span>\";\n  listItem.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  };\n};\n\n/**\n * The AutoadvancePlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AutoAdvancePlugin() {\n  AutoAdvancePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvancePlugin, Plugin);\n\n\nAutoAdvancePlugin.NAME = \"AutoAdvancePlugin\";\n\nAutoAdvancePlugin.prototype.moduleName = \"autoadvance\";\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createController = function() {\n  AutoAdvancePlugin.__super__.createController.call(this);\n  this.registerCommand(AutoAdvanceNotifications.START, AutoAdvanceStartCommand);\n  this.registerCommand(AutoAdvanceNotifications.ADVANCE, AutoAdvanceAdvanceCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, AutoAdvanceEndedCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.PLAY, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.PLAYING, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.REPLAY, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.SEEK, AutoAdvanceStopCommand);\n  this.registerCommand(UserNotifications.SEEK, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, PluginEventCommand);\n  this.registerCommand(Notifications.STOP, PluginEventCommand);\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createModel = function() {\n  this.registerProxy(new AutoAdvanceProxy(this.config));\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createView = function() {\n  this.registerMediator(new AutoAdvanceMediator());\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.SEEK, UserNotifications.SEEK];\n};\n\n/**\n*/\nAutoAdvancePlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return AutoAdvancePlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in AutoAdvanceNotifications) {\n      value = AutoAdvanceNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n\nAMP.registerPlugin(\"autoadvance\", \"html\", AutoAdvancePlugin);\nAMP.registerPlugin(\"autoadvance\", \"flash\", AutoAdvanceWrapper);\n\n/**\n * The AdChoicesMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction RecommendationsGridMediator() {\n  RecommendationsGridMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsGridMediator, OverlayMediator);\n\n\nRecommendationsGridMediator.prototype.componentName = \"recommendations-grid\";\n\nRecommendationsGridMediator.prototype.grid = null;\n\nRecommendationsGridMediator.prototype.onRegister = function() {\n  var label;\n  RecommendationsGridMediator.__super__.onRegister.call(this);\n  label = this.createText(\"recommendations-grid-label\", this.localizationManager.getString(LocalizationConstants.MSG_RECOMMENDATIONS_TITLE));\n  this.grid = this.create(\"recommendations-grid-table-grid\", this, \"table\");\n};\n\n/**\n * @override\n*/\nRecommendationsGridMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n};\n\n/**\n * @override\n*/\nRecommendationsGridMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len;\n  switch (notification.getName()) {\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.grid.innerHTML = \"\";\n      this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n      this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec, _i);\n        }\n      }\n  }\n};\n\nRecommendationsGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n  var gridRowIndex, td,\n    _this = this;\n  gridRowIndex = (recommendedIndex % 4) < 2 ? 0 : 1;\n  td = this.create(\"recommendations-grid-item\", this.grid.childNodes[gridRowIndex], \"td\");\n  if (td.dataset == null) {\n    td.dataset = {};\n  }\n  td.dataset.link = recommendation.link;\n  td.dataset.target = this.config.getTarget();\n  td.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendations-grid-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendations-grid-text'>\" + recommendation.description + \"</span>\";\n  td.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  };\n};\n\n/**\n * The RecommendationsFluidGridMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction RecommendationsFluidGridMediator() {\n  RecommendationsFluidGridMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsFluidGridMediator, OverlayMediator);\n\n\nRecommendationsFluidGridMediator.prototype.componentName = \"recommendations-fluid-grid\";\n\nRecommendationsFluidGridMediator.prototype.grid = null;\n\nRecommendationsFluidGridMediator.prototype.timeout = null;\n\nRecommendationsFluidGridMediator.prototype.gridBounds = {\n  width: 0,\n  height: 0\n};\n\nRecommendationsFluidGridMediator.prototype.onRegister = function() {\n  RecommendationsFluidGridMediator.__super__.onRegister.call(this);\n  this.grid = this.viewComponent;\n  window.addEventListener(\"orientationchange\", this.delayedResizeGridHanlder.bind(this));\n};\n\n/**\n * @override\n*/\nRecommendationsFluidGridMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED, Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY];\n};\n\nRecommendationsFluidGridMediator.prototype.delayedResizeGridHanlder = function(event) {\n  try {\n    clearTimeout(this.timeout);\n  } catch (_error) {}\n  this.timeout = setTimeout(this.resizeGridHandler.bind(this, true), 100);\n};\n\nRecommendationsFluidGridMediator.prototype.resizeGridHandler = function(isOrientation) {\n  var currentGridBounds, item, _i, _j, _len, _len1, _ref, _ref1;\n  if (isOrientation == null) {\n    isOrientation = false;\n  }\n  currentGridBounds = this.grid.getBoundingClientRect();\n  if (this.gridBounds.width !== currentGridBounds.width || this.gridBounds.height !== currentGridBounds.height || isOrientation) {\n    this.grid.setAttribute(\"style\", \"align-content:flex-start; -webkit-align-content:flex-start; -ms-flex-align: flex-start;opacity:0;\");\n    this.gridBounds = currentGridBounds;\n    _ref = this.grid.childNodes;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      item = _ref[_i];\n      item.style.display = \"block\";\n    }\n    _ref1 = this.grid.childNodes;\n    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n      item = _ref1[_j];\n      if (item.getBoundingClientRect().bottom > this.gridBounds.bottom) {\n        item.style.display = \"none\";\n      }\n    }\n    this.grid.setAttribute(\"style\", \"align-content:center; -webkit-align-content:center; -ms-flex-align: center;opacity:1;\");\n  }\n};\n\n/**\n * @override\n*/\nRecommendationsFluidGridMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len,\n    _this = this;\n  switch (notification.getName()) {\n    case Notifications.CHANGE_MEDIA:\n    case Notifications.PLAY:\n    case Notifications.PLAYING:\n    case Notifications.REPLAY:\n      try {\n        clearInterval(this.timeout);\n      } catch (_error) {}\n      break;\n    case Notifications.ENDED:\n      this.timeout = setInterval(function() {\n        _this.resizeGridHandler();\n      }, 500);\n      break;\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.grid.innerHTML = \"\";\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec, _i);\n        }\n      }\n  }\n};\n\nRecommendationsFluidGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n  var tile, _ref, _ref1,\n    _this = this;\n  tile = this.create(\"recommendations-fluid-grid-tile\", this.grid);\n  tile.style.backgroundImage = \"url(\" + recommendation.thumbnail + \")\";\n  if (((_ref = this.facade.getConfig().responsive) != null ? _ref.rows : void 0) != null) {\n    tile.style.height = \"calc(\" + 100 / this.facade.getConfig().responsive.rows + \"%)\";\n  }\n  if (((_ref1 = this.facade.getConfig().responsive) != null ? _ref1.column : void 0) != null) {\n    tile.style.width = \"calc(\" + 100 / this.facade.getConfig().responsive.columns + \"%)\";\n  }\n  tile.dataset.link = recommendation.link;\n  tile.dataset.target = this.facade.getConfig().target;\n  EventHandler.create(tile, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  });\n  this.create(\"recommendations-fluid-grid-tile-caption\", tile, \"span\", recommendation.description);\n};\n\n/**\n * The RecommendationsPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction RecommendationsPlugin() {\n  RecommendationsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlugin, Feature);\n\n\nRecommendationsPlugin.prototype.featureName = \"recommendations\";\n\nRecommendationsPlugin.prototype.moduleName = \"recommendations\";\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createController = function() {\n  RecommendationsPlugin.__super__.createController.call(this);\n  this.registerCommand(RecommendationsNotifications.RECOMMENDATION_SELECTED, RecommendationSelectedCommand);\n  this.registerCommand(Notifications.START, RecommendationsPlayCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, RecommendationsPlayStateChangeCommand);\n  this.registerCommand(RecommendationsNotifications.RECOMMENDATIONS_LOADED, PluginEventCommand);\n};\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createModel = function() {\n  this.proxy = new RecommendationsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createView = function() {\n  this.registerMediator(new RecommendationsMediator());\n};\n\n/**\n*/\nRecommendationsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.START, Notifications.PLAY_STATE_CHANGE];\n};\n\n/**\n*/\nRecommendationsPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return RecommendationsPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in RecommendationsNotifications) {\n      value = RecommendationsNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * @param {string} value The url of the feed.\n * @expose\n*/\nRecommendationsPlugin.prototype.setURL = function(value) {\n  this.proxy.set(value);\n};\n\n/**\n * @return {string} The url of the feed.\n * @expose\n*/\nRecommendationsPlugin.prototype.getURL = function() {\n  return this.proxy.getURL();\n};\n\n/**\n * @return {Object} The MRSS feed object.\n * @expose\n*/\nRecommendationsPlugin.prototype.getData = function() {\n  return this.proxy.getData();\n};\n\n/**\n * @param {Object} value The MRSS feed object\n * @expose\n*/\nRecommendationsPlugin.prototype.setData = function(value) {\n  this.proxy.setData(value);\n};\n\n/**\n * @return {string} The window target for recommendations.\n * @expose\n*/\nRecommendationsPlugin.prototype.getTarget = function() {\n  return this.proxy.getTarget();\n};\n\n/**\n * @param {string} value The window target for recommendations.\n * @expose\n*/\nRecommendationsPlugin.prototype.setTarget = function(value) {\n  this.proxy.setTarget(value);\n};\n\n\nAMP.registerPlugin(\"recommendations\", \"html\", RecommendationsPlugin);\nAMP.registerPlugin(\"recommendations\", \"flash\", RecommendationsWrapper);\n\n/**\n * @constructor\n * @private\n*/\nfunction NielsenProxy(config) {\n  NielsenProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(NielsenProxy, DataBoundConfigurationProxy);\n\n\nNielsenProxy.prototype.configurationName = \"nielsen\";\n\n/** @static\n*/\nNielsenProxy.NAME = ModuleProxy.NAME;\n\nNielsenProxy.cg = \"OnDemand\";\n\nNielsenProxy.url = \"//secure-us.imrworldwide.com/cgi-bin/m\";\n\nNielsenProxy.prototype.defaults = {\n  url: null,\n  data: {\n    ci: null,\n    c6: null,\n    cg: null,\n    tl: null\n  },\n  events: null\n};\n\nNielsenProxy.prototype.getTitle = function() {\n  return this.title;\n};\n\nNielsenProxy.prototype.setTitle = function(value) {\n  return this.title = value;\n};\n\n/**\n*/\nNielsenProxy.prototype.start = function() {\n  var url;\n  url = this.constructURL(\"video\", \"started\");\n  Utils.beacon(url, \"nielsenBeacon\");\n};\n\nNielsenProxy.prototype.end = function() {\n  var url;\n  url = this.constructURL(\"video\", \"ended\");\n  Utils.beacon(url, \"nielsenBeacon\");\n};\n\nNielsenProxy.prototype.constructURL = function(target, type) {\n  var c6, cg, ci, event, events, item, tl, url, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;\n  url = this.url || NielsenProxy.url;\n  events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n  if (events != null) {\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      item = events[_i];\n      if (item.type === type) {\n        event = item;\n      }\n    }\n  }\n  ci = (event != null ? (_ref1 = event.data) != null ? _ref1.ci : void 0 : void 0) || this.value.data.ci;\n  c6 = (event != null ? (_ref2 = event.data) != null ? _ref2.c6 : void 0 : void 0) || this.value.data.c6;\n  cg = (event != null ? (_ref3 = event.data) != null ? _ref3.cg : void 0 : void 0) || this.value.data.cg || NielsenProxy.cg;\n  tl = (event != null ? (_ref4 = event.data) != null ? _ref4.tl : void 0 : void 0) || this.value.data.tl;\n  return \"\" + url + \"?ci=\" + ci + \"&c6=\" + c6 + \"&cc=1&tl=\" + tl + \"&cg=\" + cg + \"&rnd=\" + (Date.now());\n};\n\nfunction NielsenWrapper() {\n  return NielsenWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(NielsenWrapper, PluginWrapper);\n\n\nNielsenWrapper.NAME = \"NielsenWrapper\";\n\nNielsenWrapper.prototype.flashPlugins = [\n  {\n    id: \"NielsenPlugin\",\n    src: '#{paths.resources}plugins/NielsenPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NielsenPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nNielsenWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, prop, props, text, txtTest, type, urlElement, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3;\n  if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"nielsen\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"ci\",\n      key: \"NIELSEN_CI\"\n    }, {\n      value: \"cg\",\n      key: \"NIELSEN_CG\"\n    }, {\n      value: \"tl\",\n      key: \"NIELSEN_TL\"\n    }, {\n      value: \"c6\",\n      key: \"NIELSEN_C6\"\n    }\n  ];\n  if (this.config.url != null) {\n    urlElement = xml.createElement(\"property\");\n    urlElement.setAttribute(\"key\", \"serviceURL\");\n    txtTest = XMLUtils.createTextContent(xml, this.config.url.toString());\n    urlElement.appendChild(txtTest);\n    vendor.appendChild(urlElement);\n  }\n  _ref1 = this.config.events;\n  for (type in _ref1) {\n    events = _ref1[type];\n    if ((events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n          prop = props[_j];\n          text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * The NielsenEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsenEndCommand() {\n  NielsenEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsenEndCommand.prototype.execute = function(notification) {\n  var nielsen;\n  nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n  nielsen.end();\n};\n\n/**\n * The NielsenStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsenStartCommand() {\n  NielsenStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsenStartCommand.prototype.execute = function(notification) {\n  var nielsen;\n  nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n  nielsen.start();\n};\n\n/**\n * The RecommendationsGridPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {RecommendationsPlugin}\n*/\nfunction RecommendationsGridPlugin() {\n  RecommendationsGridPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsGridPlugin, RecommendationsPlugin);\n\n\nRecommendationsGridPlugin.prototype.moduleName = \"recommendationsgrid\";\n\n/** @override\n*/\nRecommendationsGridPlugin.prototype.createView = function() {\n  if (this.config.view === \"tile\") {\n    this.registerMediator(new RecommendationsFluidGridMediator());\n  } else {\n    this.registerMediator(new RecommendationsGridMediator());\n  }\n};\n\n/**\n*/\nRecommendationsGridPlugin.prototype.listNotificationInterests = function() {\n  return RecommendationsGridPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY]);\n};\n\n\nAMP.registerPlugin(\"recommendationsgrid\", \"html\", RecommendationsGridPlugin);\nAMP.registerPlugin(\"recommendationsgrid\", \"flash\", RecommendationsWrapper);\n\nfunction NielsensdkWrapper() {\n  return NielsensdkWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(NielsensdkWrapper, PluginWrapper);\n\n\nNielsensdkWrapper.NAME = \"NielsensdkWrapper\";\n\nNielsensdkWrapper.prototype.flashPlugins = [\n  {\n    id: \"NielsenSDKPlugin\",\n    src: '#{paths.resources}plugins/NielsenSDKPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NielsenSDKPlugin\"\n  }\n];\n\n/** @override\n*/\nNielsensdkWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, pluginProp, pluginProps, prop, props, text, type, vendor, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _ref3;\n  if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"nielsenSDK\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      resume: \"videoResume\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"censusCategory\",\n      key: \"NIELSEN_CENSUS_CATEGORY\"\n    }, {\n      value: \"category\",\n      key: \"NIELSEN_CATEGORY\"\n    }, {\n      value: \"episodeTitle\",\n      key: \"NIELSEN_EPISODE_TITLE\"\n    }, {\n      value: \"videoType\",\n      key: \"NIELSEN_VIDEO_TYPE\"\n    }, {\n      value: \"length\",\n      key: \"NIELSEN_LENGTH\"\n    }, {\n      value: \"assetId\",\n      key: \"NIELSEN_ASSET_ID\"\n    }, {\n      value: \"dprFlag\",\n      key: \"NIELSEN_DPR_FLAG\"\n    }\n  ];\n  pluginProps = [\n    {\n      value: \"apid\",\n      key: \"NIELSEN_APID\"\n    }, {\n      value: \"sfcode\",\n      key: \"NIELSEN_SF_CODE\"\n    }, {\n      value: \"apn\",\n      key: \"NIELSEN_APN\"\n    }, {\n      value: \"fbTag\",\n      key: \"NIELSEN_FBTAG\"\n    }\n  ];\n  for (_i = 0, _len = pluginProps.length; _i < _len; _i++) {\n    pluginProp = pluginProps[_i];\n    if (this.config.data[pluginProp.value] != null) {\n      this.createProperty(xml, pluginProp.key, this.config.data[pluginProp.value], vendor);\n    }\n  }\n  _ref1 = this.config.events;\n  for (type in _ref1) {\n    events = _ref1[type];\n    if ((events != null) && events.length > 0) {\n      for (_j = 0, _len1 = events.length; _j < _len1; _j++) {\n        event = events[_j];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n          prop = props[_k];\n          text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction NielsensdkProxy(config) {\n  NielsensdkProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(NielsensdkProxy, PluginProxy);\n\n\n/** @static\n*/\nNielsensdkProxy.NAME = ModuleProxy.NAME;\n\nNielsensdkProxy.prototype.defaults = {\n  data: null,\n  events: null,\n  plugin: {\n    js: \"http://secure-us.imrworldwide.com/novms/js/2/ggcmb400.js\"\n  }\n};\n\nNielsensdkProxy.prototype.nielsensdkSDK = null;\n\nNielsensdkProxy.prototype.cur_position = 0;\n\nNielsensdkProxy.prototype.timer = null;\n\nNielsensdkProxy.prototype.queryInterval = 2;\n\nNielsensdkProxy.prototype.isLive = null;\n\n/** Overrides\n*/\nNielsensdkProxy.prototype.initialize = function() {\n  NielsensdkProxy.__super__.initialize.call(this);\n  this.nielsensdkSDK = new NOLCMB.ggInitialize(this.value.data);\n};\n\n/** Populate Nielsen VO\n*/\nNielsensdkProxy.prototype.generateNielsenVO = function(adVO, eventName) {\n  var event, events, key, media, type, vo, _i, _len, _ref;\n  if (adVO == null) {\n    adVO = null;\n  }\n  if (eventName == null) {\n    eventName = null;\n  }\n  vo = new Object();\n  media = this.facade.player.getMedia();\n  this.isLive = media.isLive;\n  vo.assetid = media.guid;\n  vo.category = media.category;\n  vo.censuscategory = media.category;\n  vo.dprflag = \"true\";\n  vo.episodetitle = media.title ? media.title : episode_url;\n  vo.length = adVO != null ? adVO.duration : String(media.duration.toFixed(1)) === \"NaN\" ? 86400 : String(media.duration.toFixed(1));\n  vo.videotype = adVO != null ? adVO.type : \"content\";\n  _ref = this.value.events;\n  for (type in _ref) {\n    events = _ref[type];\n    if ((eventName != null) && (events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        if ((event != null ? event.type : void 0) === eventName) {\n          for (key in event.data) {\n            vo[key.toLowerCase()] = event.data[key];\n          }\n        }\n      }\n    }\n  }\n  return vo;\n};\n\n/** MetaData Loaded\n*/\nNielsensdkProxy.prototype.metaLoad = function() {\n  this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : loadMetadata\");\n};\n\nNielsensdkProxy.prototype.adStart = function(adVO) {\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO());\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : stop\");\n  }\n  this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO));\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad Start\");\n};\n\nNielsensdkProxy.prototype.adEnd = function(adVO) {\n  this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO(adVO));\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad End\");\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Resume\");\n  }\n};\n\n/** Media Started\n*/\nNielsensdkProxy.prototype.start = function(adVO) {\n  if (adVO == null) {\n    adVO = null;\n  }\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO, 'resume'));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Resume\");\n  } else {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(null, 'started'));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Play\");\n  }\n};\n\n/** Media Ended\n*/\nNielsensdkProxy.prototype.end = function() {\n  var currentTime;\n  currentTime = this.facade.player.getCurrentTime().toFixed(1);\n  this.nielsensdkSDK.ggPM(\"57\", currentTime);\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Ended\");\n  this.cur_position = 0;\n};\n\n/** Time update\n*/\nNielsensdkProxy.prototype.timeupdate = function() {\n  if (this.isLive) {\n    this.nielsensdkSDK.ggPM(\"49\", Math.floor(Date.now() / 1000));\n    this.facade.logger.log(\"[AMP nielsensdk Event] : timeupdate Live\");\n  } else {\n    this.cur_position = this.facade.player.getCurrentTime().toFixed(1);\n    if (Math.abs(this.timer - this.cur_position) > this.queryInterval) {\n      this.timer = this.cur_position;\n      this.nielsensdkSDK.ggPM(\"49\", this.cur_position);\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : timeupdate\", this.cur_position);\n    }\n  }\n};\n\n/**\n * The NielsensdkStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkStartCommand() {\n  NielsensdkStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkStartCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.start();\n};\n\n/**\n * The NielsensdkAdStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkAdStartCommand() {\n  NielsensdkAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkAdStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkAdStartCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.adStart(notification.body);\n};\n\n/**\n * The NielsensdkAdEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkAdEndCommand() {\n  NielsensdkAdEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkAdEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkAdEndCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.adEnd(notification.body);\n};\n\n/**\n * The NielsensdkEndCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkEndCommand() {\n  NielsensdkEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkEndCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.end();\n};\n\n/**\n * The NielsensdkMetaloadCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkMetaloadCommand() {\n  NielsensdkMetaloadCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkMetaloadCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkMetaloadCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.metaLoad();\n};\n\n/**\n * The NielsensdkTimeupdateCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkTimeupdateCommand() {\n  NielsensdkTimeupdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkTimeupdateCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nNielsensdkTimeupdateCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.timeupdate();\n};\n\n/**\n * The NielsenPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction NielsenPlugin() {\n  NielsenPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenPlugin, Plugin);\n\n\nNielsenPlugin.prototype.moduleName = \"nielsen\";\n\n/** @override\n*/\nNielsenPlugin.prototype.createController = function() {\n  var event, events, _i, _len, _ref, _ref1;\n  NielsenPlugin.__super__.createController.call(this);\n  events = (_ref = this.config) != null ? (_ref1 = _ref.events) != null ? _ref1.video : void 0 : void 0;\n  if (!(events != null)) {\n    return;\n  }\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    if (event.type === \"started\") {\n      this.registerCommand(Notifications.STARTED, NielsenStartCommand);\n      this.registerCommand(Notifications.CONTENT_CHANGED, NielsenStartCommand);\n    }\n    if (event.type === \"ended\") {\n      this.registerCommand(Notifications.ENDED, NielsenEndCommand);\n      this.registerCommand(Notifications.CHANGE_CONTENT, NielsenEndCommand);\n    }\n  }\n};\n\n/** @override\n*/\nNielsenPlugin.prototype.createModel = function() {\n  this.registerProxy(new NielsenProxy(this.config));\n};\n\n/** @override\n*/\nNielsenPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.STARTED, Notifications.ENDED, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT];\n};\n\n\nAMP.registerPlugin(\"nielsen\", \"html\", NielsenPlugin);\nAMP.registerPlugin(\"nielsen\", \"flash\", NielsenWrapper);\n\nfunction ComscoreStreamsenseWrapper() {\n  return ComscoreStreamsenseWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(ComscoreStreamsenseWrapper, PluginWrapper);\n\n\nComscoreStreamsenseWrapper.NAME = \"ComscoreStreamsenseWrapper\";\n\nComscoreStreamsenseWrapper.prototype.flashPlugins = [\n  {\n    id: \"ComscoreStreamSensePlugin\",\n    src: '#{paths.resources}plugins/ComscoreStreamSensePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ComscoreStreamSensePlugin\"\n  }\n];\n\n/** @override\n*/\nComscoreStreamsenseWrapper.prototype.createXML = function(xml) {\n  var application, metrics, prop, props, vendor, _i, _len;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"comscoreStreamSense\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.data.clientId,\n      key: \"C2\"\n    }, {\n      value: this.config.data.publisherSecret,\n      key: \"PUBLISHER_SECRET\"\n    }, {\n      value: this.config.data.appVersion,\n      key: \"APP_VERSION\"\n    }, {\n      value: this.config.data.metadata,\n      key: \"metadata\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  return xml;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ComscoreStreamsenseProxy(config) {\n  ComscoreStreamsenseProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ComscoreStreamsenseProxy, PluginProxy);\n\n\n/** @static\n*/\nComscoreStreamsenseProxy.NAME = ModuleProxy.NAME;\n\nComscoreStreamsenseProxy.prototype.defaults = {\n  plugin: {\n    js: null\n  },\n  data: {\n    clientId: null,\n    publisherSecret: null,\n    appVersion: null,\n    metadata: null\n  }\n};\n\nComscoreStreamsenseProxy.prototype.myStreamingTag = null;\n\nComscoreStreamsenseProxy.prototype.sdk = null;\n\n/** Overrides\n*/\nComscoreStreamsenseProxy.prototype.getScript = function() {\n  return this.config.plugin.js;\n};\n\n/** Overrides\n*/\nComscoreStreamsenseProxy.prototype.initialize = function() {\n  ComscoreStreamsenseProxy.__super__.initialize.call(this);\n  this.sdk = akamai[\"amp\"].ns_;\n  if ((this.sdk != null) && this.myStreamingTag === null) {\n    this.myStreamingTag = new this.sdk.StreamingTag({\n      customerC2: this.value.data.clientId\n    });\n  }\n};\n\nComscoreStreamsenseProxy.prototype.mediaChange = function() {\n  if (this.myStreamingTag != null) {\n    this.myStreamingTag.stop();\n  }\n  this.myStreamingTag = null;\n  this.myStreamingTag = new this.sdk.StreamingTag({\n    customerC2: this.value.data.clientId\n  });\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Media Change, StreamTag ReInitialize\");\n};\n\nComscoreStreamsenseProxy.prototype.adStart = function(adVO) {\n  if (adVO == null) {\n    adVO = null;\n  }\n  this.myStreamingTag.playVideoAdvertisement(this.getMetaData(true));\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Ad Start\");\n};\n\n/** Media Started\n*/\nComscoreStreamsenseProxy.prototype.start = function(adVO) {\n  var _ref;\n  if (adVO == null) {\n    adVO = null;\n  }\n  if ((_ref = this.facade.player.ads) != null ? _ref.getInProgress() : void 0) {\n    return;\n  }\n  this.myStreamingTag.playVideoContentPart(this.getMetaData());\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Content Play\");\n};\n\n/** Media Stop\n*/\nComscoreStreamsenseProxy.prototype.stop = function() {\n  this.myStreamingTag.stop();\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Stop\");\n};\n\n/** Media Ended\n*/\nComscoreStreamsenseProxy.prototype.ended = function() {\n  this.myStreamingTag.stop();\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : End\");\n  this.myStreamingTag = null;\n  this.myStreamingTag = new this.sdk.StreamingTag({\n    customerC2: this.value.data.clientId\n  });\n};\n\n/** Get MetaData\n*/\nComscoreStreamsenseProxy.prototype.getMetaData = function(ads) {\n  var key, metadata, object, value;\n  if (ads == null) {\n    ads = false;\n  }\n  metadata = {};\n  object = ads ? this.value.data.metadata.ads : this.value.data.metadata.video;\n  for (key in object) {\n    value = object[key];\n    if (value !== \"null\") {\n      metadata[key] = value;\n    }\n  }\n  return metadata;\n};\n\n/**\n * The ComscoreStreamsenseStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseStartedCommand() {\n  ComscoreStreamsenseStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseStartedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.start(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseAdStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseAdStartedCommand() {\n  ComscoreStreamsenseAdStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseAdStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseAdStartedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.adStart(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseStopCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseStopCommand() {\n  ComscoreStreamsenseStopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseStopCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseStopCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.stop(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseAdErrorCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseAdErrorCommand() {\n  ComscoreStreamsenseAdErrorCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseAdErrorCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseAdErrorCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.adStart(notification.body);\n  comscoreProxy.stop(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseChangeMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseChangeMediaCommand() {\n  ComscoreStreamsenseChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseChangeMediaCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseChangeMediaCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.mediaChange();\n};\n\n/**\n * The ComscoreStreamsenseEndedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseEndedCommand() {\n  ComscoreStreamsenseEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseEndedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStreamsenseEndedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.ended();\n};\n\n/**\n * The NielsenPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction NielsensdkPlugin() {\n  NielsensdkPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkPlugin, Plugin);\n\n\nNielsensdkPlugin.prototype.moduleName = \"nielsensdk\";\n\n/** @override\n*/\nNielsensdkPlugin.prototype.createModel = function() {\n  this.registerProxy(new NielsensdkProxy(this.config));\n};\n\n/** @override\n*/\nNielsensdkPlugin.prototype.createController = function() {\n  NielsensdkPlugin.__super__.createController.call(this);\n  this.registerCommand(AdNotifications.BREAK_END, NielsensdkAdEndCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, NielsensdkAdStartCommand);\n  this.registerCommand(Notifications.STARTED, NielsensdkStartCommand);\n  this.registerCommand(Notifications.ENDED, NielsensdkEndCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, NielsensdkTimeupdateCommand);\n  this.registerCommand(AdNotifications.AD_TIME_REMAINING, NielsensdkTimeupdateCommand);\n};\n\n/** @override\n*/\nNielsensdkPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_STARTED, AdNotifications.BREAK_END, Notifications.STARTED, Notifications.ENDED, Notifications.LOADED_METADATA, Notifications.TIME_UPDATE, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT, AdNotifications.AD_TIME_REMAINING];\n};\n\n\nAMP.registerPlugin(\"nielsensdk\", \"html\", NielsensdkPlugin);\nAMP.registerPlugin(\"nielsensdk\", \"flash\", NielsensdkWrapper);\n\n/**\n * @constructor\n * @private\n*/\nfunction ComscoreProxy(config) {\n  ComscoreProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ComscoreProxy, DataBoundConfigurationProxy);\n\n\nComscoreProxy.prototype.configurationName = \"comscore\";\n\n/** @static\n*/\nComscoreProxy.NAME = ModuleProxy.NAME;\n\nComscoreProxy.prototype.defaults = {\n  url: \"//b.scorecardresearch.com/b\",\n  events: {\n    ads: null,\n    video: null\n  },\n  data: {\n    c1: null,\n    c2: null,\n    c3: null,\n    c4: null,\n    c5: null,\n    c6: null,\n    c7: null,\n    c8: null,\n    c9: null,\n    c10: null,\n    c14: null\n  }\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.adStart = function() {\n  var url;\n  url = this.constructURL(\"ads\", \"started\");\n  Utils.beacon(url);\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.videoStart = function() {\n  var url;\n  url = this.constructURL(\"video\", \"started\");\n  Utils.beacon(url);\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.constructURL = function(target, type) {\n  var data, event, events, item, key, query, url, value, _i, _len, _ref, _ref1, _ref2;\n  data = {};\n  events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n  if (events != null) {\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      item = events[_i];\n      if (item.type === type) {\n        event = item;\n      }\n    }\n  }\n  _ref1 = this.value.data;\n  for (key in _ref1) {\n    value = _ref1[key];\n    data[key] = (event != null ? (_ref2 = event.data) != null ? _ref2[key] : void 0 : void 0) || value;\n  }\n  if (data.c7 == null) {\n    data.c7 = document.location.href.substr(0, 512);\n  }\n  if (data.c8 == null) {\n    data.c8 = document.referrer.substr(0, 512);\n  }\n  if (data.c9 == null) {\n    data.c9 = document.title;\n  }\n  if (data.cv == null) {\n    data.cv = \"2.0\";\n  }\n  data.rn = Date.now();\n  url = this.value.url;\n  query = [];\n  for (key in data) {\n    value = data[key];\n    if ((value != null) && value !== \"\") {\n      query.push(key + \"=\" + escape(value));\n    }\n  }\n  if (query.length > 0) {\n    url += \"?\" + query.join(\"&\");\n  }\n  return url.substr(0, 2080);\n};\n\nfunction ComscoreWrapper() {\n  return ComscoreWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(ComscoreWrapper, PluginWrapper);\n\n\nComscoreWrapper.NAME = \"ComscoreWrapper\";\n\nComscoreWrapper.prototype.flashPlugins = [\n  {\n    id: \"ComscorePlugin\",\n    src: '#{paths.resources}plugins/ComscorePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ComscorePlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nComscoreWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, prop, props, text, type, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"comscore\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"c1\",\n      key: \"COMSCORE_CSC1\"\n    }, {\n      value: \"c2\",\n      key: \"COMSCORE_CSC2\"\n    }, {\n      value: \"c3\",\n      key: \"COMSCORE_CSC3\"\n    }, {\n      value: \"c4\",\n      key: \"COMSCORE_CSC4\"\n    }, {\n      value: \"c5\",\n      key: \"COMSCORE_CSC5\"\n    }, {\n      value: \"c6\",\n      key: \"COMSCORE_CSC6\"\n    }, {\n      value: \"c7\",\n      key: \"COMSCORE_CSC7\"\n    }, {\n      value: \"c8\",\n      key: \"COMSCORE_CSC8\"\n    }, {\n      value: \"c9\",\n      key: \"COMSCORE_CSC9\"\n    }, {\n      value: \"c10\",\n      key: \"COMSCORE_CSC10\"\n    }, {\n      value: \"c11\",\n      key: \"COMSCORE_CSC14\"\n    }\n  ];\n  _ref = this.config.events;\n  for (type in _ref) {\n    events = _ref[type];\n    if ((events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        element = xml.createElement(\"property\");\n        element.setAttribute(\"key\", \"COMSCORE_CSURL\");\n        text = XMLUtils.createTextContent(xml, this.config.url);\n        element.appendChild(text);\n        node.appendChild(element);\n        for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n          prop = props[_j];\n          text = ((_ref1 = event.data) != null ? _ref1[prop.value] : void 0) || ((_ref2 = this.config.data) != null ? _ref2[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * The ComscoreAdStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreAdStartCommand() {\n  ComscoreAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreAdStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreAdStartCommand.prototype.execute = function(notification) {\n  var comscore;\n  comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n  comscore.adStart();\n};\n\n/**\n * The ComscoreStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStartCommand() {\n  ComscoreStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nComscoreStartCommand.prototype.execute = function(notification) {\n  var comscore;\n  comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n  comscore.videoStart();\n};\n\n/**\n * The ComscoreStreamsensePlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ComscoreStreamsensePlugin() {\n  ComscoreStreamsensePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsensePlugin, Plugin);\n\n\nComscoreStreamsensePlugin.prototype.moduleName = \"comscorestreamsense\";\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.createModel = function() {\n  this.registerProxy(new ComscoreStreamsenseProxy(this.config));\n};\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.createController = function() {\n  ComscoreStreamsensePlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.MEDIA_CHANGE, ComscoreStreamsenseChangeMediaCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, ComscoreStreamsenseAdStartedCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(AdNotifications.SKIPPED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(AdNotifications.AD_ERROR, ComscoreStreamsenseAdErrorCommand);\n  this.registerCommand(Notifications.PLAYING, ComscoreStreamsenseStartedCommand);\n  this.registerCommand(Notifications.PAUSED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(Notifications.ENDED, ComscoreStreamsenseEndedCommand);\n};\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE, AdNotifications.AD_STARTED, AdNotifications.AD_ENDED, AdNotifications.AD_ERROR, AdNotifications.SKIPPED, Notifications.ENDED, Notifications.PAUSED, Notifications.PLAYING];\n};\n\n\nAMP.registerPlugin(\"comscorestreamsense\", \"html\", ComscoreStreamsensePlugin);\nAMP.registerPlugin(\"comscorestreamsense\", \"flash\", ComscoreStreamsenseWrapper);\n\n/**\n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction OmnitureWrapper(player, config) {\n  if (config.heartbeat.enabled === true || config.useJS === true) {\n    this.createXML = function() {};\n    this.flashPlugins = [];\n    this.plugin = new OmniturePlugin();\n    this.plugin.oninitialized = player.registerModule.bind(player, this.plugin);\n    this.plugin.initialize(config, player);\n  }\n  OmnitureWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(OmnitureWrapper, PluginWrapper);\n\n\nOmnitureWrapper.NAME = \"OmnitureWrapper\";\n\nOmnitureWrapper.prototype.flashPlugins = [\n  {\n    id: \"OmniturePlugin\",\n    src: '#{paths.resources}plugins/OmniturePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"OmniturePlugin\"\n  }\n];\n\n/** @override\n*/\nOmnitureWrapper.prototype.createXML = function(xml) {\n  var application, contextData, contextDataMapping, event, events, intervalProp, intervalReached, intervals, key, linkTracking, linkTrackingData, media, metrics, milestone, milestones, prop, property, props, trackMilestone, trackMilestones, type, value, vendor, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _len5, _len6, _m, _n, _o, _ref, _ref1, _ref2;\n  if (this.config.useJS === true) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"omniture\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.channel,\n      key: \"OMNITURE_CHANNEL\"\n    }, {\n      value: this.config.account,\n      key: \"OMNITURE_ACCOUNT\"\n    }, {\n      value: this.config.debugTracking,\n      key: \"OMNITURE_DEBUG_TRACKING\"\n    }, {\n      value: this.config.trackLocal,\n      key: \"OMNITURE_TRACK_LOCAL\"\n    }, {\n      value: this.config.visitorNamespace,\n      key: \"OMNITURE_VISITOR_NAMESPACE\"\n    }, {\n      value: this.config.trackingServer,\n      key: \"OMNITURE_TRACKING_SERVER\"\n    }, {\n      value: this.config.trackingServerSecure,\n      key: \"OMNITURE_TRACKING_SERVER_SECURE\"\n    }, {\n      value: this.config.currencyCode,\n      key: \"OMNITURE_CURRENCY_CODE\"\n    }, {\n      value: this.config.trackWhilePlaying,\n      key: \"OMNITURE_TRACK_WHILE_PLAYING\"\n    }, {\n      value: this.config.trackMediaMethods,\n      key: \"OMNITURE_TRACK_MEDIA_METHODS\"\n    }, {\n      value: this.config.mediaName,\n      key: \"OMNITURE_MEDIA_NAME\"\n    }, {\n      value: this.config.playerName,\n      key: \"OMNITURE_PLAYER_NAME\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  media = this.config.Media;\n  if (media != null) {\n    props = [\n      {\n        value: media.autoTrack,\n        key: \"OMNITURE_AUTO_TRACK\"\n      }, {\n        value: media.segmentByMilestones,\n        key: \"OMNITURE_SEGMENT_MILESTONES\"\n      }, {\n        value: media.trackVars,\n        key: \"OMNITURE_TRACKVARS\"\n      }, {\n        value: media.trackEvents,\n        key: \"OMNITURE_TRACKEVENTS\"\n      }, {\n        value: media.trackUsingContextData,\n        key: \"OMNITURE_TRACK_CONTEXT_DATA\"\n      }, {\n        value: media.trackSecondIntervals,\n        key: \"OMNITURE_TRACKSECOND_INTERVALS\"\n      }\n    ];\n    for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n      prop = props[_j];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    if (media.trackMilestones != null) {\n      trackMilestones = this.createProperty(xml, \"OMNITURE_TRACK_MILESTONES\", null, vendor);\n      milestones = media.trackMilestones;\n      for (_k = 0, _len2 = milestones.length; _k < _len2; _k++) {\n        milestone = milestones[_k];\n        trackMilestone = this.createProperty(xml, milestone.percent, null, trackMilestones);\n        for (key in milestone) {\n          value = milestone[key];\n          if (key !== \"percent\") {\n            this.createProperty(xml, key, value, trackMilestone);\n          }\n        }\n      }\n    }\n    contextDataMapping = media.contextDataMapping;\n    if (contextDataMapping != null) {\n      contextData = this.createProperty(xml, \"OMNITURE_CONTEXT_DATA\", null, vendor);\n      for (key in contextDataMapping) {\n        value = contextDataMapping[key];\n        if (typeof value === \"string\") {\n          this.createProperty(xml, key, value, contextData);\n        }\n        if (value instanceof Array) {\n          property = this.createProperty(xml, key, null, contextData);\n          for (_l = 0, _len3 = value.length; _l < _len3; _l++) {\n            milestone = value[_l];\n            this.createProperty(xml, milestone.percent, milestone.events, property);\n          }\n        }\n      }\n    }\n  }\n  linkTracking = this.config.customLinkTracking;\n  if (linkTracking != null) {\n    linkTrackingData = this.createProperty(xml, \"OMNITURE_CUSTOM_LINK_TRACKING\", null, vendor);\n    for (key in linkTracking) {\n      if (key === \"intervalReached\") {\n        intervalReached = this.createProperty(xml, key, null, linkTrackingData);\n        _ref = linkTracking[key];\n        for (_m = 0, _len4 = _ref.length; _m < _len4; _m++) {\n          intervals = _ref[_m];\n          intervalProp = this.createProperty(xml, intervals.interval, null, intervalReached);\n          for (key in intervals) {\n            if (key !== \"interval\") {\n              this.createProperty(xml, key, intervals[key], intervalProp);\n            }\n          }\n        }\n      } else {\n        this.createProperty(xml, key, linkTracking[key], linkTrackingData);\n      }\n    }\n  }\n  events = (_ref1 = this.config.events) != null ? _ref1.video : void 0;\n  if (events != null) {\n    for (_n = 0, _len5 = events.length; _n < _len5; _n++) {\n      event = events[_n];\n      switch (event.type) {\n        case \"started\":\n          type = \"videoStart\";\n          break;\n        case \"ended\":\n          type = \"videoComplete\";\n          break;\n        case \"play\":\n          type = \"videoResume\";\n          break;\n        case \"pause\":\n          type = \"videoPause\";\n          break;\n        default:\n          type = event.type;\n      }\n      this.createProperty(xml, type, event.data, vendor);\n    }\n  }\n  events = (_ref2 = this.config.events) != null ? _ref2.ads : void 0;\n  if (events != null) {\n    for (_o = 0, _len6 = events.length; _o < _len6; _o++) {\n      event = events[_o];\n      type = event.type === \"started\" ? 'adStart' : event.type === \"ended\" ? 'adComplete' : event.type;\n      this.createProperty(xml, type, event.data, vendor);\n    }\n  }\n};\n\n/**\n * The OmnitureProxy class.\n *\n * @param {Object} config\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction OmnitureProxy(config) {\n  OmnitureProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(OmnitureProxy, PluginProxy);\n\n\n/** @static\n*/\nOmnitureProxy.NAME = ModuleProxy.NAME;\n\nOmnitureProxy.prototype.defaults = {\n  main: \"s\",\n  heartbeat: null,\n  account: null,\n  playerName: null,\n  mediaName: null,\n  trackingServer: null,\n  visitorNamespace: null,\n  visitor: null,\n  visitorID: null,\n  pageName: null\n};\n\nOmnitureProxy.prototype.media = null;\n\nOmnitureProxy.prototype.started = false;\n\nOmnitureProxy.prototype.ad = null;\n\nOmnitureProxy.prototype.adCurrentTime = null;\n\nOmnitureProxy.prototype.adStarted = false;\n\nOmnitureProxy.prototype.adsEnabled = false;\n\nOmnitureProxy.prototype.getMediaName = function() {\n  return this.getConfigurationData().mediaName || this.media.getTitle();\n};\n\nOmnitureProxy.prototype.getPlayerName = function() {\n  var _ref;\n  return this.getConfigurationData().playerName || ((_ref = this.facade.player.retrieveProxy(ConfigurationProxy.NAME)) != null ? _ref.getName() : void 0) || this.facade.player.config.name || \"amp\";\n};\n\nOmnitureProxy.prototype.getPlaybackCore = function() {\n  var _ref;\n  return ((_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME)) != null ? _ref.getActivePlaybackCore() : void 0) || this.facade.player.playback;\n};\n\n/**\n*/\nOmnitureProxy.prototype.initialize = function() {\n  var _ref, _ref1;\n  OmnitureProxy.__super__.initialize.call(this);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n  this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n  if (this.plugin != null) {\n    try {\n      if (!(this.plugin.Media != null)) {\n        this.plugin.loadModule(\"Media\");\n      }\n    } catch (error) {\n      this.error(\"initialize\", error);\n    }\n    if (!(((_ref1 = this.plugin.Media) != null ? _ref1.openAd : void 0) != null)) {\n      this.adStart = this.adEnded = this.adPlay = this.adPause = this.adCurrentTime = function() {};\n    }\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.createPlugin = function() {\n  return window[this.getConfigurationData().main];\n};\n\n/**\n*/\nOmnitureProxy.prototype.mediaChange = function() {\n  var _ref;\n  this.started = false;\n  this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n};\n\n/**\n*/\nOmnitureProxy.prototype.start = function() {\n  if (this.started === true) {\n    return;\n  }\n  try {\n    this.started = true;\n    this.plugin.Media.open(this.getMediaName(), this.media.getDuration(), this.getPlayerName());\n  } catch (error) {\n    this.error(error);\n  }\n  if (this.adsEnabled !== true) {\n    this.play();\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.play = function() {\n  if (this.started !== true) {\n    this.start();\n    return;\n  }\n  if (this.adStarted === true) {\n    return;\n  }\n  try {\n    this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime() || 0);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.pause = function() {\n  if (this.adStarted === true) {\n    return;\n  }\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.seeking = function() {\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.seeked = function() {\n  try {\n    this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.ended = function() {\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n    this.plugin.Media.close(this.getMediaName());\n    this.started = false;\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/** Pluging.\n*/\nOmnitureProxy.prototype.getAd = function() {\n  return this.ad;\n};\n\nOmnitureProxy.prototype.setAd = function(value) {\n  this.adStarted = false;\n  this.adCurrentTime = 0;\n  return this.ad = value;\n};\n\n/**\n*/\nOmnitureProxy.prototype.adStart = function() {\n  try {\n    this.adStarted = true;\n    this.plugin.Media.openAd(this.ad.title, this.ad.duration, this.getPlayerName(), this.getMediaName(), this.ad.type, this.ad.position, this.ad.cpm);\n    this.adPlay();\n  } catch (error) {\n    this.error(\"ad start\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adPlay = function() {\n  if (this.adStarted !== true) {\n    this.adStart();\n  }\n  try {\n    this.plugin.Media.play(this.ad.title, this.adCurrentTime || 0);\n  } catch (error) {\n    this.error(\"ad play\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adPause = function() {\n  try {\n    this.plugin.Media.stop(this.ad.title, this.adCurrentTime);\n  } catch (error) {\n    this.error(\"ad pause\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adCurrentTime = function(value) {\n  this.adCurrentTime = value;\n};\n\n/**\n*/\nOmnitureProxy.prototype.adEnded = function() {\n  if (this.adStarted === false) {\n    return;\n  }\n  try {\n    this.adStarted = false;\n    this.plugin.Media.stop(this.ad.title, this.ad.duration);\n    this.plugin.Media.close(this.ad.title);\n  } catch (error) {\n    this.error(\"ad end\", error);\n  }\n  this.play();\n};\n\n/**\n * The HeartbeatProxy class.\n *\n * @param {Object} config\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction HeartbeatProxy(config) {\n  HeartbeatProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(HeartbeatProxy, OmnitureProxy);\n\n\n/** @static\n*/\nHeartbeatProxy.NAME = ModuleProxy.NAME;\n\nHeartbeatProxy.prototype.aaPlugin = null;\n\nHeartbeatProxy.prototype.playerPlugin = null;\n\nHeartbeatProxy.prototype.heartbeat = null;\n\nHeartbeatProxy.prototype.resumed = false;\n\nHeartbeatProxy.prototype.liveLinear = null;\n\n/**\n*/\nHeartbeatProxy.prototype.initialize = function() {\n  var ahPlugin, appMeasurement, config, delegate, pluginConfig, plugins, visitor,\n    _this = this;\n  HeartbeatProxy.__super__.initialize.call(this);\n  config = this.getConfigurationData();\n  if (config.heartbeat.liveLinear != null) {\n    this.calculateLiveLinear();\n  }\n  if (typeof Visitor !== \"undefined\" && Visitor !== null) {\n    visitor = new Visitor(config.visitor.marketingCloudOrgId);\n    visitor.trackingServer = config.visitor.trackingServer;\n  }\n  appMeasurement = new AppMeasurement();\n  appMeasurement.account = config.account;\n  appMeasurement.trackingServer = config.trackingServer;\n  appMeasurement.visitor = visitor;\n  appMeasurement.pageName = config.pageName;\n  appMeasurement.charSet = \"UTF-8\";\n  appMeasurement.visitorID = config.visitorID;\n  delegate = this.createDelegate();\n  this.playerPlugin = new ADB.va.plugins.videoplayer.VideoPlayerPlugin(delegate);\n  pluginConfig = new ADB.va.plugins.videoplayer.VideoPlayerPluginConfig();\n  pluginConfig.debugLogging = this.getDebug();\n  this.playerPlugin.configure(pluginConfig);\n  delegate = new ADB.va.plugins.aa.AdobeAnalyticsPluginDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"AdobeAnalyticsPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  this.aaPlugin = new ADB.va.plugins.aa.AdobeAnalyticsPlugin(appMeasurement, delegate);\n  pluginConfig = new ADB.va.plugins.aa.AdobeAnalyticsPluginConfig();\n  pluginConfig.channel = config.heartbeat.channel;\n  pluginConfig.debugLogging = this.getDebug();\n  this.aaPlugin.configure(pluginConfig);\n  delegate = new ADB.va.plugins.ah.AdobeHeartbeatPluginDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"AdobeHeartbeatPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  ahPlugin = new ADB.va.plugins.ah.AdobeHeartbeatPlugin(delegate);\n  pluginConfig = new ADB.va.plugins.ah.AdobeHeartbeatPluginConfig(config.heartbeat.trackingServer, config.heartbeat.publisher);\n  pluginConfig.ovp = config.heartbeat.ovp;\n  pluginConfig.sdk = config.heartbeat.sdk;\n  pluginConfig.ssl = config.heartbeat.ssl === true;\n  pluginConfig.debugLogging = this.getDebug();\n  ahPlugin.configure(pluginConfig);\n  plugins = [this.playerPlugin, this.aaPlugin, ahPlugin];\n  delegate = new ADB.va.HeartbeatDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"Heartbeat error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  this.heartbeat = new ADB.va.Heartbeat(delegate, plugins);\n  pluginConfig = new ADB.va.HeartbeatConfig();\n  pluginConfig.debugLogging = this.getDebug();\n  this.heartbeat.configure(pluginConfig);\n};\n\n/**\n*/\nHeartbeatProxy.prototype.calculateLiveLinear = function() {\n  var liveLinear, start,\n    _this = this;\n  if (this.liveLinear == null) {\n    this.liveLinear = {};\n  }\n  if (this.liveLinear.updating === true) {\n    return;\n  }\n  this.liveLinear.updating = true;\n  liveLinear = {\n    updating: false\n  };\n  start = Date.now();\n  Utils.getUTC().then(function(utc) {\n    var date, day, end, timezone;\n    end = Date.now();\n    date = new Date(utc);\n    day = date.toJSON().replace(/([^T]+T).+/, \"$1\");\n    timezone = _this.getConfigurationData().heartbeat.liveLinear.timezone || \"Z\";\n    liveLinear.utc = utc;\n    date = new Date(start + ((end - start) / 2));\n    liveLinear.client = date.getTime();\n    liveLinear.offset = liveLinear.client - utc;\n    date = new Date(day + \"00:00:00.000\" + timezone);\n    liveLinear.start = date.getTime();\n    date = new Date(day + \"23:59:59.999\" + timezone);\n    liveLinear.end = date.getTime();\n    liveLinear.duration = Math.round((liveLinear.end - liveLinear.start) / 1000);\n    return _this.liveLinear = liveLinear;\n  });\n  return;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.calculateLiveLinearTime = function() {\n  var now, time;\n  now = Date.now() - this.liveLinear.offset;\n  time = Math.round((now - this.liveLinear.start) / 1000);\n  if (time > this.liveLinear.duration) {\n    time = time - this.liveLinear.duration;\n    this.calculateLiveLinear();\n  }\n  return time;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.createDelegate = function() {\n  var delegate,\n    _this = this;\n  delegate = new ADB.va.plugins.videoplayer.VideoPlayerPluginDelegate();\n  delegate.getVideoInfo = function() {\n    var config, playbackCore, time, videoInfo;\n    playbackCore = _this.getPlaybackCore();\n    videoInfo = new ADB.va.plugins.videoplayer.VideoInfo();\n    videoInfo.id = _this.media.getGUID() || _this.media.getTitle();\n    videoInfo.playerName = _this.getPlayerName();\n    videoInfo.name = _this.getMediaName();\n    videoInfo.resumed = _this.resumed;\n    config = _this.getConfigurationData().heartbeat;\n    if (config.liveLinear.enabled === true) {\n      videoInfo.length = _this.liveLinear.duration;\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n      videoInfo.playhead = _this.calculateLiveLinearTime();\n    } else if (_this.media.getTemporalType() === \"live\") {\n      videoInfo.length = -1;\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n      videoInfo.playhead = 0;\n    } else {\n      videoInfo.length = _this.media.getDuration();\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_VOD;\n      time = playbackCore != null ? typeof playbackCore.getCurrentTime === \"function\" ? playbackCore.getCurrentTime() : void 0 : void 0;\n      videoInfo.playhead = !(time != null) || isNaN(time) ? 0 : time;\n    }\n    return videoInfo;\n  };\n  delegate.getAdInfo = function() {\n    var adInfo, duration;\n    adInfo = new ADB.va.plugins.videoplayer.AdInfo();\n    if (!(_this.ad != null)) {\n      return null;\n    }\n    adInfo.id = _this.ad.id;\n    duration = _this.ad.duration;\n    adInfo.length = isNaN(duration) || duration === 0 ? -1 : duration;\n    adInfo.position = _this.ad.position;\n    adInfo.name = _this.ad.title;\n    return adInfo;\n  };\n  delegate.getAdBreakInfo = function() {\n    var adBreakInfo;\n    adBreakInfo = new ADB.va.plugins.videoplayer.AdBreakInfo();\n    if (!(_this.ad != null)) {\n      return null;\n    }\n    adBreakInfo.name = _this.ad.type;\n    adBreakInfo.position = _this.ad.position;\n    adBreakInfo.playerName = _this.getPlayerName();\n    adBreakInfo.startTime = _this.getPlaybackCore().getCurrentTime();\n    return adBreakInfo;\n  };\n  delegate.getChapterInfo = function() {\n    var chapterInfo, currentScene;\n    currentScene = _this.media.getScene(_this.getPlaybackCore().getCurrentTime());\n    if (!(currentScene != null)) {\n      return null;\n    }\n    chapterInfo = new ADB.va.plugins.videoplayer.ChapterInfo();\n    chapterInfo.name = currentScene.title;\n    chapterInfo.length = currentScene.end - currentScene.start;\n    chapterInfo.position = currentScene.position;\n    chapterInfo.startTime = currentScene.start;\n    return chapterInfo;\n  };\n  delegate.onError = function(error) {\n    _this.facade.logger.error(\"Heartbeat Error:\", error);\n  };\n  delegate.getQoSInfo = function() {\n    var qosInfo;\n    qosInfo = new ADB.va.plugins.videoplayer.QoSInfo();\n    return null;\n  };\n  return delegate;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.mediaChange = function() {\n  var metadata, _ref;\n  HeartbeatProxy.__super__.mediaChange.call(this);\n  this.resumed = false;\n  metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.video : void 0;\n  if (metadata != null) {\n    this.aaPlugin.setVideoMetadata(metadata);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.start = function() {\n  if (this.started === true) {\n    return;\n  }\n  try {\n    this.playerPlugin.trackVideoLoad();\n    this.started = true;\n  } catch (error) {\n    this.error(error);\n  }\n  this.play();\n};\n\n/**\n*/\nHeartbeatProxy.prototype.play = function() {\n  if (this.started !== true) {\n    this.start();\n  }\n  try {\n    this.playerPlugin.trackPlay();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.pause = function() {\n  try {\n    this.playerPlugin.trackPause();\n    this.resumed = true;\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.seeking = function() {\n  try {\n    this.playerPlugin.trackSeekStart();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.seeked = function() {\n  try {\n    this.playerPlugin.trackSeekComplete();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.ended = function() {\n  try {\n    this.playerPlugin.trackComplete();\n    this.playerPlugin.trackVideoUnload();\n    this.started = false;\n    this.aaPlugin.setVideoMetadata(null);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.adStart = function() {\n  var metadata, _ref;\n  if (this.started !== true) {\n    metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.ad : void 0;\n    if (metadata != null) {\n      this.aaPlugin.setAdMetadata(metadata);\n    }\n    this.start();\n    setTimeout(this.adStart.bind(this), 0);\n    return;\n  }\n  try {\n    this.playerPlugin.trackAdStart();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.adEnded = function() {\n  try {\n    this.playerPlugin.trackAdComplete();\n    this.aaPlugin.setAdMetadata(null);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\nHeartbeatProxy.prototype.adPlay = function() {};\n\nHeartbeatProxy.prototype.adPause = function() {};\n\n/**\n * The OmnitureStartCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureStartCommand() {\n  OmnitureStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureStartCommand.prototype.execute = function(notification) {\n  this.proxy.start();\n};\n\n/**\n * The OmniturePlayCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmniturePlayCommand() {\n  OmniturePlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmniturePlayCommand.prototype.execute = function(notification) {\n  this.proxy.play();\n};\n\n/**\n * The OmniturePauseCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmniturePauseCommand() {\n  OmniturePauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmniturePauseCommand.prototype.execute = function(notification) {\n  this.proxy.pause();\n};\n\n/**\n * The OmnitureSeekingCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureSeekingCommand() {\n  OmnitureSeekingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureSeekingCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureSeekingCommand.prototype.execute = function(notification) {\n  this.proxy.seeking();\n};\n\n/**\n * The OmnitureSeekedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureSeekedCommand() {\n  OmnitureSeekedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureSeekedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureSeekedCommand.prototype.execute = function(notification) {\n  this.proxy.seeked();\n};\n\n/**\n * The OmnitureEndedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureEndedCommand() {\n  OmnitureEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureEndedCommand.prototype.execute = function(notification) {\n  this.proxy.ended();\n};\n\n/**\n * The OmnitureChangeMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureContentChangedCommand() {\n  OmnitureContentChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureContentChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureContentChangedCommand.prototype.execute = function(notification) {\n  this.proxy.setMedia(notification.getBody());\n  this.proxy.start();\n};\n\n/**\n * The OmnitureAdLoadedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdLoadedCommand() {\n  OmnitureAdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdLoadedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdLoadedCommand.prototype.execute = function(notification) {\n  this.proxy.setAd(notification.getBody());\n};\n\n/**\n * The OmnitureAdStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdStartedCommand() {\n  OmnitureAdStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdStartedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdStartedCommand.prototype.execute = function(notification) {\n  this.proxy.adStart();\n};\n\n/**\n * The OmnitureAdPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdPlayCommand() {\n  OmnitureAdPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdPlayCommand.prototype.execute = function(notification) {\n  this.proxy.adPlay();\n};\n\n/**\n * The OmnitureAdPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdPauseCommand() {\n  OmnitureAdPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdPauseCommand.prototype.execute = function(notification) {\n  this.proxy.adPause();\n};\n\n/**\n * The OmnitureAdBreakEndCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdBreakEndCommand() {\n  OmnitureAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdBreakEndCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdBreakEndCommand.prototype.execute = function(notification) {\n  this.proxy.adEnded();\n  this.proxy.setAd(null);\n};\n\n/**\n * The OmnitureAdTimeRemainingCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdTimeUpdateCommand() {\n  OmnitureAdTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureAdTimeUpdateCommand.prototype.execute = function(notification) {\n  this.proxy.adCurrentTime(notification.getBody());\n};\n\n/**\n * The OmnitureMediaChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureMediaChangeCommand() {\n  OmnitureMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nOmnitureMediaChangeCommand.prototype.execute = function(notification) {\n  this.proxy.mediaChange();\n};\n\n/**\n * The ComscorePlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ComscorePlugin() {\n  ComscorePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ComscorePlugin, Plugin);\n\n\nComscorePlugin.prototype.moduleName = \"comscore\";\n\n/** @override\n*/\nComscorePlugin.prototype.createController = function() {\n  ComscorePlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.STARTED, ComscoreStartCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, ComscoreStartCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, ComscoreAdStartCommand);\n};\n\n/** @override\n*/\nComscorePlugin.prototype.createModel = function() {\n  this.registerProxy(new ComscoreProxy(this.config));\n};\n\n/** @override\n*/\nComscorePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.STARTED, AdNotifications.AD_STARTED, Notifications.CONTENT_CHANGED];\n};\n\n\nAMP.registerPlugin(\"comscore\", \"html\", ComscorePlugin);\nAMP.registerPlugin(\"comscore\", \"flash\", ComscoreWrapper);\n\n/**\n * @constructor\n * @private\n*/\nfunction InfoWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  InfoWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(InfoWrapper, PluginWrapper);\n\n\nInfoWrapper.NAME = \"InfoWrapper\";\n\n/** @override\n*/\nInfoWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML, FlashNotifications.SHARE, FlashNotifications.SHARE_REQUEST];\n};\n\n/**\n*/\nInfoWrapper.prototype.handleNotification = function(notification) {\n  var application, body, data, element, elements, flashvars, info, name, property, provider, text, type, view, xml, _i, _len;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      break;\n    case FlashNotifications.CREATE_XML:\n      xml = body.xml;\n      application = xml.firstChild;\n      view = xml.getElementsByTagName(\"view\")[0];\n      elements = xml.getElementsByTagName(\"element\");\n      for (_i = 0, _len = elements.length; _i < _len; _i++) {\n        element = elements[_i];\n        if (!(element.getAttribute(\"id\") === \"infoOverlayAdvanced\")) {\n          continue;\n        }\n        info = element;\n        break;\n      }\n      if (!(view != null)) {\n        return;\n      }\n      if (!(info != null)) {\n        info = xml.createElement(\"element\");\n        info.setAttribute(\"id\", \"infoOverlayAdvanced\");\n        info.setAttribute(\"displayStates\", \"preplay,paused,ns,fs,mouseover\");\n        view.insertBefore(info, view.childNodes[0]);\n      }\n      data = xml.createElement(\"data\");\n      info.appendChild(data);\n      if (this.config.title != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"title\");\n        text = XMLUtils.createTextContent(xml, this.config.title);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.description != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"description\");\n        text = XMLUtils.createTextContent(xml, this.config.description);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.more != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"more\");\n        text = XMLUtils.createTextContent(xml, this.config.more);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.less != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"less\");\n        text = XMLUtils.createTextContent(xml, this.config.less);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.provider != null) {\n        provider = xml.createElement(\"property\");\n        provider.setAttribute(\"key\", \"provider\");\n        data.appendChild(provider);\n        if (this.config.provider.name != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"name\");\n          text = XMLUtils.createTextContent(xml, this.config.provider.name);\n          property.appendChild(text);\n          provider.appendChild(property);\n        }\n        if (this.config.provider.image != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"image\");\n          text = XMLUtils.createTextContent(xml, this.config.provider.image);\n          property.appendChild(text);\n          provider.appendChild(property);\n        }\n      }\n      break;\n    case FlashNotifications.SHARE:\n    case FlashNotifications.SHARE_REQUEST:\n      type = \"share\";\n  }\n  if (type != null) {\n    return this.dispatchEvent(new Event(type, body));\n  }\n};\n\n\nAMP.registerPlugin(\"info\", \"flash\", InfoWrapper);\n\n/**\n * The InfoMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction InfoMediator() {\n  InfoMediator.__super__.constructor.call(this);\n}\n\n\n__extends(InfoMediator, PluginMediator);\n\n\nInfoMediator.prototype.componentName = \"info\";\n\nInfoMediator.prototype.title = null;\n\nInfoMediator.prototype.shortDescription = null;\n\nInfoMediator.prototype.icon = null;\n\nInfoMediator.prototype.provider = null;\n\n/**\n * @override\n*/\nInfoMediator.prototype.onRegister = function() {\n  InfoMediator.__super__.onRegister.call(this);\n  this.title = this.create(\"info-title\");\n  this.provider = this.create(\"info-provider\");\n  this.shortDescription = this.create(\"info-short-description\");\n  this.icon = this.create(\"info-icon\", this, \"img\");\n  this.dataChangedHandler();\n};\n\n/**\n * @override\n*/\nInfoMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\n/**\n * @override\n*/\nInfoMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      this.dataChangedHandler();\n  }\n};\n\nInfoMediator.prototype.moreClicked = function(event) {\n  return this.classList.add(\"open\");\n};\n\nInfoMediator.prototype.closeClicked = function(event) {\n  return this.classList.remove(\"open\");\n};\n\nInfoMediator.prototype.dataChangedHandler = function() {\n  var styles, _ref;\n  if (this.plugin.value.title != null) {\n    this.title.textContent = this.plugin.value.title;\n  }\n  if (((_ref = this.plugin.value.provider) != null ? _ref.image : void 0) != null) {\n    this.icon.src = this.plugin.value.provider.image;\n  }\n  styles = getComputedStyle(this.title);\n  if (this.title.clientHeight > parseInt(styles.lineHeight)) {\n    this.classList.add(\"info-small\");\n    this.shortDescription.innerHTML = this.provider.innerHTML = \"\";\n    return;\n  } else {\n    this.classList.remove(\"info-small\");\n  }\n  this.truncateDescription(this.plugin.value.description, this.plugin.value.more);\n  this.provider.textContent = this.plugin.value.provider.name != null ? \"\" + this.plugin.value.provider.name : \"\";\n};\n\nInfoMediator.prototype.truncateDescription = function(desc) {\n  var character, ellp, index, text, tf, _i, _len;\n  ellp = \"...\";\n  text = \"\";\n  tf = this.shortDescription;\n  tf.textContent = \"\";\n  if (!(desc != null)) {\n    return;\n  }\n  for (index = _i = 0, _len = desc.length; _i < _len; index = ++_i) {\n    character = desc[index];\n    tf.textContent = text + character + ellp;\n    if (tf.scrollHeight > tf.clientHeight) {\n      tf.textContent = text + ellp;\n      break;\n    } else {\n      text += character;\n    }\n  }\n};\n\n/**\n * The InfoProxy class.\n *\n * @constructor\n * @private\n * @extends {DataBoundConfigurationProxy}\n * @param {Object} data\n*/\nfunction InfoProxy(data) {\n  InfoProxy.__super__.constructor.call(this, data);\n}\n\n\n__extends(InfoProxy, DataBoundConfigurationProxy);\n\n\nInfoProxy.prototype.configurationName = \"info\";\n\n/** @static\n*/\nInfoProxy.NAME = ModuleProxy.NAME;\n\nInfoProxy.prototype.defaults = {\n  title: '#{media.title}',\n  description: '#{media.description}',\n  provider: {},\n  more: \"read more\",\n  less: \"less\"\n};\n\n/**\n * The AdContentStartedCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentStartedCommand() {\n  AdContentStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentStartedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdContentStartedCommand.prototype.execute = function(notification) {\n  this.proxy.contentStarted();\n};\n\n/**\n * The AdContentEndedCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentEndedCommand() {\n  AdContentEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdContentEndedCommand.prototype.execute = function(notification) {\n  this.proxy.contentEnded();\n};\n\n/**\n * The AdMediaChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdMediaChangeCommand() {\n  AdMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdMediaChangeCommand.prototype.execute = function(notification) {\n  if (this.proxy.getEnabled() === false) {\n    return;\n  }\n  this.proxy.mediaChanging = true;\n  this.proxy.engage(notification.getBody());\n};\n\n/**\n * The AdLoadedCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdLoadedCommand() {\n  AdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdLoadedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdLoadedCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n    contexts: [this.proxy.getContextName()]\n  });\n  AdLoadedCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AdBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdBreakStartCommand() {\n  AdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdBreakStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdBreakStartCommand.prototype.execute = function(notification) {\n  AdBreakStartCommand.__super__.execute.call(this, notification);\n  this.proxy.breakStart();\n};\n\n/**\n * The AdBreakEndCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdBreakEndCommand() {\n  AdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdBreakEndCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdBreakEndCommand.prototype.execute = function(notification) {\n  var rate, _ref;\n  AdBreakEndCommand.__super__.execute.call(this, notification);\n  this.proxy.breakEnd();\n  if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === \"ima\") {\n    rate = this.applicationState.getPlaybackRate();\n    this.facade.player.setPlaybackRate(rate);\n  }\n  if (this.applicationState.getEnded() && this.applicationState.getHasPostContent() === true) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n  }\n};\n\n/**\n * The AdSeekCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdSeekCommand() {\n  AdSeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdSeekCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdSeekCommand.prototype.execute = function(notification) {\n  this.proxy.contentSeek(notification.getBody());\n};\n\n/**\n * The AdPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContainerCreatedCommand() {\n  AdContainerCreatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContainerCreatedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdContainerCreatedCommand.prototype.execute = function(notification) {\n  this.proxy.container = notification.getBody();\n  AdContainerCreatedCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AdReplayCommand class.\n *\n * Added to address ad replay workflow FLASHPLR\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdReplayCommand() {\n  AdReplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdReplayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdReplayCommand.prototype.execute = function(notification) {\n  if (typeof this.proxy.replay === \"function\" && this.facade.player.getAutoplay() === false) {\n    this.proxy.replay();\n  }\n};\n\n/**\n * @constructor\n*/\nfunction AdVO(id, title, duration, position, type, partner, advertiser, companions, request, metadata, totalAds, time) {\n  this.id = id;\n  this.title = title;\n  this.duration = duration;\n  this.position = position;\n  this.type = type;\n  this.partner = partner;\n  this.advertiser = advertiser;\n  this.companions = companions;\n  this.request = request;\n  this.metadata = metadata;\n  this.totalAds = totalAds;\n  this.time = time;\n}\n\nAdVO.prototype.id = null;\n\nAdVO.prototype.title = null;\n\nAdVO.prototype.duration = NaN;\n\nAdVO.prototype.position = NaN;\n\nAdVO.prototype.totalAds = NaN;\n\nAdVO.prototype.type = null;\n\nAdVO.prototype.partner = null;\n\nAdVO.prototype.advertiser = null;\n\nAdVO.prototype.companions = null;\n\nAdVO.prototype.metadata = null;\n\nAdVO.prototype.request = null;\n\nAdVO.prototype.error = null;\n\nAdVO.prototype.time = null;\n\n/**\n * Create an AdRequest object.\n *\n * @constructor\n * @param {Object} request The partner specific ad request object\n * @param {string} partner The partner identifier. i.e. \"ima\" or \"freewheel\"\n * @param {Object} config The plugin's configuration object\n * @param {Object} params Additional parameters to send with the ad request\n*/\nfunction AdRequest(request, partner, config, params) {\n  var key, value;\n  this.request = request;\n  this.partner = partner;\n  this.config = config;\n  if (params != null) {\n    for (key in params) {\n      value = params[key];\n      this[key] = value;\n    }\n  }\n}\n\n/**\n * Create an AdRequest object.\n *\n * @param {Object} request The partner specific ad request object\n * @param {string} partner The partner identifier. i.e. \"ima\" or \"freewheel\"\n * @param {Object} config The plugin's configuration object\n * @param {Object} params Additional parameters to send with the ad request\n * @returns {AdRequest}\n*/\nAdRequest.create = function(request, partner, config, params) {\n  return new AdRequest(request, partner, config, params);\n};\n\nAdRequest.prototype.request = null;\n\nAdRequest.prototype.partner = null;\n\nAdRequest.prototype.config = null;\n\n/**\n * The AdStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction AdStartCommand() {\n  AdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  if (this.playback.initialized === false) {\n    this.player.sendNotification(Notifications.INITIALIZED);\n  }\n  this.proxy.start();\n  AdStartCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AdPlayCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPlayCommand() {\n  AdPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdPlayCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getLocked() === true) {\n    return;\n  }\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  if (this.proxy.getStarted() === false) {\n    this.sendNotification(Notifications.START, true);\n    return;\n  }\n  this.proxy.play();\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n};\n\n/**\n * The AdPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPauseCommand() {\n  AdPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdPauseCommand.prototype.execute = function(notification) {\n  var duration, time, transform,\n    _this = this;\n  time = this.proxy.adVO.time;\n  duration = this.proxy.adVO.duration;\n  if (time === \"undefined\" || !time || time === duration) {\n    transform = {\n      transform: function(state) {\n        if (state === Notifications.PLAYING) {\n          setTimeout(function() {\n            _this.player.removeTransform(TransformType.PLAY_STATE, transform);\n            return _this.player.sendNotification(Notifications.PAUSE);\n          }, 300);\n          return state;\n        }\n      },\n      priority: 2\n    };\n    this.player.addTransform(TransformType.PLAY_STATE, transform);\n    return;\n  }\n  this.proxy.pause();\n  this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n};\n\n/**\n * The AdTogglePlayPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdTogglePlayPauseCommand() {\n  AdTogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdTogglePlayPauseCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdTogglePlayPauseCommand.prototype.execute = function(notification) {\n  var note;\n  if (this.proxy.getPaused() || this.proxy.getStarted() === false) {\n    note = Notifications.PLAY;\n  } else {\n    note = Notifications.PAUSE;\n  }\n  this.sendNotification(note, true);\n};\n\n/**\n * The AdVolumeChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdVolumeChangeCommand() {\n  AdVolumeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdVolumeChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdVolumeChangeCommand.prototype.execute = function(notification) {\n  this.proxy.setVolume(notification.getBody());\n  AdVolumeChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AdPlayStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPlayStateChangeCommand() {\n  AdPlayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPlayStateChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdPlayStateChangeCommand.prototype.execute = function(notification) {\n  if (notification.getBody().value === \"playing\") {\n    this.dispatchEvent(\"playing\", this.proxy.adVO);\n  }\n};\n\n/**\n * The OmniturePlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction OmniturePlugin() {\n  OmniturePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePlugin, Plugin);\n\n\nOmniturePlugin.prototype.moduleName = \"omniture\";\n\n/** @override\n*/\nOmniturePlugin.prototype.createController = function() {\n  this.registerCommand(Notifications.MEDIA_CHANGE, OmnitureMediaChangeCommand);\n  this.registerCommand(Notifications.ENDED, OmnitureEndedCommand);\n  this.registerCommand(Notifications.STARTED, OmnitureStartCommand);\n  this.registerCommand(Notifications.PLAY, OmniturePlayCommand);\n  this.registerCommand(Notifications.PAUSE, OmniturePauseCommand);\n  this.registerCommand(Notifications.SEEKING, OmnitureSeekingCommand);\n  this.registerCommand(Notifications.SEEKED, OmnitureSeekedCommand);\n  this.registerCommand(Notifications.CHANGE_CONTENT, OmnitureEndedCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, OmnitureContentChangedCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, OmnitureAdLoadedCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, OmnitureAdStartedCommand);\n  this.registerCommand(AdNotifications.AD_PLAY, OmnitureAdPlayCommand);\n  this.registerCommand(AdNotifications.AD_PAUSE, OmnitureAdPauseCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, OmnitureAdTimeUpdateCommand);\n  this.registerCommand(AdNotifications.BREAK_END, OmnitureAdBreakEndCommand);\n};\n\n/** @override\n*/\nOmniturePlugin.prototype.createModel = function() {\n  var _ref;\n  if (((_ref = this.config.heartbeat) != null ? _ref.enabled : void 0) === true) {\n    this.registerProxy(new HeartbeatProxy(this.config));\n  } else {\n    this.registerProxy(new OmnitureProxy(this.config));\n  }\n};\n\n/**\n*/\nOmniturePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA, Notifications.MEDIA_CHANGE, Notifications.CHANGE_CONTENT, Notifications.CONTENT_CHANGED, Notifications.TIME_UPDATE, Notifications.ENDED, Notifications.STARTED, Notifications.PLAY, Notifications.PAUSE, Notifications.SEEKING, Notifications.SEEKED, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_PLAY, AdNotifications.AD_PAUSE, AdNotifications.AD_TIME_REMAINING, AdNotifications.BREAK_START, AdNotifications.BREAK_END];\n};\n\n\nAMP.registerPlugin(\"omniture\", \"html\", OmniturePlugin);\nAMP.registerPlugin(\"omniture\", \"flash\", OmnitureWrapper);\n\n/**\n * The AdProxy class.\n *\n * @constructor\n * @private\n * @extends {PluginProxy}\n * @param {Object} config\n * @implements {IDataBindingContext}\n*/\nfunction AdProxy(config) {\n  AdProxy.__super__.constructor.call(this, config);\n  this.pods = [];\n}\n\n\n__extends(AdProxy, PluginProxy);\n\n\n/** @static\n*/\nAdProxy.NAME = PluginProxy.NAME;\n\nAdProxy.prototype.inProgress = false;\n\nAdProxy.prototype.paused = false;\n\nAdProxy.prototype.started = false;\n\nAdProxy.prototype.adVO = null;\n\nAdProxy.prototype.contextName = \"ad\";\n\nAdProxy.prototype.container = null;\n\nAdProxy.prototype.partner = null;\n\nAdProxy.prototype.pods = null;\n\nAdProxy.prototype.mediaChanging = false;\n\nAdProxy.prototype.createDefaultAdVO = function() {\n  return new AdVO(null, null, null, null, null, this.partner, null, null, null, null, null);\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n*/\nAdProxy.prototype.getContextData = function() {\n  return this.adVO || {};\n};\n\n/**\n*/\nAdProxy.prototype.setCompanions = function(value) {\n  this.adVO.companions = value;\n  this.sendNotification(AdNotifications.AD_COMPANION, this.adVO);\n  return value;\n};\n\nAdProxy.prototype.getCompanions = function() {\n  var _ref;\n  return (_ref = this.adVO) != null ? _ref.companions : void 0;\n};\n\n/**\n*/\nAdProxy.prototype.getInProgress = function() {\n  return this.inProgress;\n};\n\nAdProxy.prototype.setInProgress = function(value) {\n  this.inProgress = value;\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.getStarted = function() {\n  return this.started;\n};\n\n/**\n*/\nAdProxy.prototype.setStarted = function(value) {\n  this.started = value;\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.getPaused = function() {\n  return this.paused;\n};\n\nAdProxy.prototype.setPaused = function(value) {\n  this.paused = value;\n  return value;\n};\n\nAdProxy.prototype.setCues = function(value) {\n  var cue, cues, _i, _len;\n  cues = [];\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    cue = value[_i];\n    cues.push({\n      startTime: cue,\n      endTime: cue\n    });\n  }\n  this.facade.player.mediaProxy.setCues(cues);\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.play = function() {\n  this.setPaused(false);\n  this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.pause = function() {\n  this.setPaused(true);\n  this.sendNotification(AdNotifications.AD_PAUSE, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.breakStart = function() {\n  this.setInProgress(true);\n};\n\n/**\n*/\nAdProxy.prototype.breakEnd = function() {\n  this.setInProgress(false);\n  this.reset();\n};\n\n/**\n*/\nAdProxy.prototype.error = function(err, breakEnd) {\n  var msg;\n  if (breakEnd == null) {\n    breakEnd = true;\n  }\n  msg = (typeof err.getMessage === \"function\" ? err.getMessage() : void 0) || err.message;\n  this.facade.logger.error(\"[AMP AD ERROR]\", \"\" + msg + \" Skipping ad content.\", err);\n  if (this.adVO == null) {\n    this.adVO = {};\n  }\n  this.adVO.error = err;\n  this.sendNotification(AdNotifications.AD_ERROR, this.adVO);\n  if (breakEnd === true) {\n    this.endBreak();\n  }\n};\n\n/**\n*/\nAdProxy.prototype.engage = function(media) {\n  if (this.getEnabled() === false) {\n    return;\n  }\n  this.setStarted(false);\n  if (this.getInProgress()) {\n    this.reset();\n    this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n  }\n  this.engageAds();\n};\n\n/**\n*/\nAdProxy.prototype.engageAds = function() {\n  this.facade.player.removeCommand(Notifications.START);\n  this.facade.player.removeCommand(Notifications.PLAY);\n  this.facade.player.removeCommand(Notifications.PAUSE);\n  this.facade.player.removeCommand(Notifications.ENDED);\n  this.facade.player.removeCommand(UserNotifications.PLAY);\n  this.facade.player.removeCommand(UserNotifications.PAUSE);\n  this.facade.player.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n  if (this.facade.isFullscreenDevice()) {\n    this.facade.player.removeCommand(Notifications.CHANGE_DURATION);\n  }\n  this.facade.removeCommand(Notifications.STARTED);\n  this.facade.removeCommand(Notifications.ENDED);\n  this.facade.registerCommand(Notifications.START, AdStartCommand);\n  this.facade.registerCommand(Notifications.PLAY, AdPlayCommand);\n  this.facade.registerCommand(Notifications.PAUSE, AdPauseCommand);\n  this.facade.registerCommand(UserNotifications.PLAY, AdPlayCommand);\n  this.facade.registerCommand(UserNotifications.PAUSE, AdPauseCommand);\n  this.facade.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, AdTogglePlayPauseCommand);\n  this.facade.registerCommand(Notifications.VOLUME_CHANGE, AdVolumeChangeCommand);\n  this.facade.registerCommand(Notifications.PLAY_STATE_CHANGE, AdPlayStateChangeCommand);\n};\n\n/**\n*/\nAdProxy.prototype.reset = function() {\n  this.facade.removeCommand(Notifications.START);\n  this.facade.removeCommand(Notifications.PLAY);\n  this.facade.removeCommand(Notifications.PAUSE);\n  this.facade.removeCommand(UserNotifications.PLAY);\n  this.facade.removeCommand(UserNotifications.PAUSE);\n  this.facade.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n  this.facade.removeCommand(Notifications.VOLUME_CHANGE);\n  this.facade.removeCommand(Notifications.PLAY_STATE_CHANGE);\n  this.facade.player.registerCommand(Notifications.START, StartCommand);\n  this.facade.player.registerCommand(Notifications.PLAY, PlayCommand);\n  this.facade.player.registerCommand(Notifications.PAUSE, PauseCommand);\n  this.facade.player.registerCommand(Notifications.ENDED, EndedCommand);\n  this.facade.player.registerCommand(UserNotifications.PLAY, PlayCommand);\n  this.facade.player.registerCommand(UserNotifications.PAUSE, PauseCommand);\n  this.facade.player.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n  if (this.facade.isFullscreenDevice()) {\n    this.facade.player.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n  }\n  this.facade.registerCommand(Notifications.STARTED, AdContentStartedCommand);\n  this.facade.registerCommand(Notifications.ENDED, AdContentEndedCommand);\n};\n\n/**\n*/\nAdProxy.prototype.processAdRequest = function(value) {\n  var _this = this;\n  return this.facade.player.transform(TransformType.AD_REQUEST, value).then(function(result) {\n    return _this.facade.transform(TransformType.AD_REQUEST, result);\n  });\n};\n\n/**\n*/\nAdProxy.prototype.requestAd = function() {\n  this.sendNotification(AdNotifications.REQUEST, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.getPodById = function(id) {\n  var pod, _i, _len, _ref;\n  _ref = this.pods;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    pod = _ref[_i];\n    if (pod.id === id) {\n      return pod;\n    }\n  }\n};\n\n/**\n*/\nAdProxy.prototype.setPodLocks = function(pods) {\n  var pod, _i, _len, _ref;\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if ((_ref = this.getPodById(pod.id)) != null) {\n      _ref.locked = pod.locked;\n    }\n  }\n};\n\n/**\n*/\nAdProxy.prototype.resize = function(state) {};\n\n/**\n*/\nAdProxy.prototype.startBreak = function(adVO) {\n  if (adVO != null) {\n    this.adVO = adVO;\n  }\n  this.setStarted(true);\n  this.sendNotification(AdNotifications.BREAK_START, this.adVO);\n  if (this.getEnabled() === false) {\n    this.endBreak();\n    return false;\n  }\n  return true;\n};\n\n/**\n*/\nAdProxy.prototype.endBreak = function() {\n  this.sendNotification(AdNotifications.BREAK_END, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.start = function() {\n  this.mediaChanging = false;\n  this.startBreak();\n};\n\n/**\n*/\nAdProxy.prototype.contentPlay = function() {\n  this.facade.player.sendNotification(Notifications.PLAY, true);\n};\n\n/**\n*/\nAdProxy.prototype.contentPause = function() {\n  var video,\n    _this = this;\n  video = this.facade.player.mediaElement;\n  if (video.seeking === true) {\n    video.once(\"seeked\", function() {\n      video.pause();\n    });\n  } else {\n    video.pause();\n  }\n};\n\n/**\n*/\nAdProxy.prototype.contentStarted = function() {};\n\n/**\n*/\nAdProxy.prototype.contentSeek = function(time) {};\n\n/**\n*/\nAdProxy.prototype.contentEnded = function() {};\n\n/**\n*/\nAdProxy.prototype.setVolume = function(value) {};\n\n/**\n*/\nAdProxy.prototype.getVolume = function() {};\n\n/**\n*/\nAdProxy.prototype.terminateAd = function() {};\n\n/**\n*/\nAdProxy.prototype.terminateAllAds = function() {};\n\n/**\n * The InfoPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction InfoPlugin() {\n  InfoPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(InfoPlugin, Plugin);\n\n\nInfoPlugin.prototype.moduleName = \"info\";\n\n/** @override\n*/\nInfoPlugin.prototype.createModel = function() {\n  this.registerProxy(new InfoProxy(this.config));\n};\n\n/** @override\n*/\n/** @override\n*/\nInfoPlugin.prototype.createView = function() {\n  this.registerMediator(new InfoMediator());\n};\n\n/** @override\n*/\nInfoPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\n\nAMP.registerPlugin(\"info\", \"html\", InfoPlugin);\nAMP.registerPlugin(\"info\", \"external\", InfoPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FlashAdNotifications = {\n  BREAK_START: \"adComponentBreakInitiated\",\n  BREAK_END: \"adComponentBreakComplete\",\n  BREAK_SKIPPED: \"adComponentBreakSkipped\",\n  AD_LOADED: \"adComponentLoaded\",\n  AD_STARTED: \"adComponentAdBegin\",\n  AD_TIME_UPDATE: \"adComponentPlaybackProgress\",\n  AD_TIME_REMAINING: \"adComponentTimeElapsed\",\n  AD_DURATION_CHANGE: \"addurationchange\",\n  AD_ENDED: \"adComponentImpressionEnd\",\n  COMPLETE: \"adComponentAdComplete\",\n  AD_ERROR: \"adComponentInitFailed\",\n  AD_PLAY: \"adComponentPlaybackResumed\",\n  AD_PAUSE: \"adComponentPlaybackPaused\",\n  AD_LOG: \"adComponentLog\",\n  AD_COMPANION: \"adComponentCompanion\",\n  AD_PLAYBACK_FAILED: \"adComponentPlaybackFailed\",\n  AD_PLAYBACK_TERMINATED: \"adComponentPlaybackTerminated\",\n  AD_MEDIA_LOADED: \"adComponentMediaLoaded\",\n  AD_CLICKED: \"adComponentClicked\",\n  AD_FIRST_QUARTILE: \"adComponentFirstQuartile\",\n  AD_MIDPOINT: \"adComponentMidpoint\",\n  AD_THIRD_QUARTILE: \"adComponentThirdQuartile\",\n  AD_REQUEST: \"adComponentAdsRequest\",\n  AD_REQUEST_COMPLETE: \"adComponentAdsRequestComplete\",\n  AD_SKIPPED: \"adComponentAdSkipped\",\n  AD_IMPRESSION: \"adComponentImpression\"\n};\n\n/**\n * Used to trigger overlay ads for Google IMA\n *\n * @constructor\n * @private\n*/\nfunction IMAOverlayProxy(config) {\n  IMAOverlayProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(IMAOverlayProxy, DataBoundConfigurationProxy);\n\n\nIMAOverlayProxy.prototype.configurationName = \"imaoverlay\";\n\n/** @static\n*/\nIMAOverlayProxy.NAME = \"IMAOveralyProxy\";\n\nIMAOverlayProxy.prototype.defaults = {\n  adTagUrl: null,\n  duration: 15,\n  interval: 30,\n  delay: 30\n};\n\nIMAOverlayProxy.prototype.durationTimer = null;\n\nIMAOverlayProxy.prototype.intervalTimer = null;\n\nIMAOverlayProxy.prototype.delayTimer = null;\n\n/** Stops polling and clears the ad\n*/\nIMAOverlayProxy.prototype.stop = function() {\n  clearTimeout(this.durationTimer);\n  clearTimeout(this.delayTimer);\n  clearTimeout(this.intervalTimer);\n};\n\n/** Starts polling and load the first ad\n*/\nIMAOverlayProxy.prototype.play = function() {\n  var _this = this;\n  this.stop();\n  this.delayTimer = setTimeout(function() {\n    return _this.requestAd();\n  }, this.value.delay * 1000);\n};\n\n/** Retrieves an ad image from VAST XML\n*/\nIMAOverlayProxy.prototype.requestAd = function() {\n  var adTagUrl;\n  adTagUrl = this.getValue(\"adTagUrl\");\n  if (adTagUrl != null) {\n    adTagUrl = adTagUrl.replace(\"[timestamp]\", new Date().getTime());\n    adTagUrl = adTagUrl.replace(\"__random-number__\", new Date().getTime());\n  }\n  Utils.request({\n    url: adTagUrl,\n    withCredentials: true\n  }).then(this.vastLoadHandler.bind(this))[\"catch\"](this.error.bind(this));\n};\n\nIMAOverlayProxy.prototype.vastLoadHandler = function(xhr) {\n  var ad, clickThroughHref, creativeView, img, impression, xml;\n  xml = xhr.target.responseXML;\n  if (xml != null) {\n    try {\n      ad = xml.querySelector(\"NonLinear\");\n      if (ad != null) {\n        impression = xml.querySelector(\"Impression\") != null ? xml.querySelector(\"Impression\").textContent : \"\";\n        creativeView = xml.querySelector(\"Tracking[event=creativeView]\") != null ? xml.querySelector(\"Tracking[event=creativeView]\").textContent : \"\";\n        clickThroughHref = ad.querySelector(\"NonLinearClickThrough\") != null ? ad.querySelector(\"NonLinearClickThrough\").textContent : \"\";\n        img = {\n          src: ad.querySelector(\"StaticResource\").textContent,\n          width: ad.getAttribute(\"width\"),\n          height: ad.getAttribute(\"height\"),\n          tracking: [impression, creativeView],\n          href: clickThroughHref\n        };\n        this.displayAd(img);\n      } else {\n        this.error(\"No overlay was returned\");\n      }\n    } catch (error) {\n      this.error(error);\n    }\n  }\n};\n\nIMAOverlayProxy.prototype.error = function(error) {\n  this.facade.logger.error(\"[AMP IMA OVERLAY ERROR]\", error);\n  this.stop();\n};\n\n/** Notifies the application that a new overlay is ready to display\n*/\nIMAOverlayProxy.prototype.displayAd = function(ad) {\n  var _this = this;\n  this.sendNotification(IMANotifications.ADD_OVERLAY, ad);\n  this.durationTimer = setTimeout(function() {\n    _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n    return _this.intervalTimer = setTimeout(function() {\n      return _this.requestAd();\n    }, _this.value.interval * 1000);\n  }, this.value.duration * 1000);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar IMANotifications = {\n  INITIALIZED: \"ima/initialize\",\n  ADD_OVERLAY: \"ima/addOverlay\",\n  REMOVE_OVERLAY: \"ima/removeOverlay\"\n};\n\n/**\n * The IMAProxy class.\n *\n * @constructor\n * @private\n * @extends {AdProxy}\n * @param {Object} config\n*/\nfunction IMAProxy(config) {\n  IMAProxy.__super__.constructor.call(this, config);\n  this.intervals = [];\n  this.loadedmetadata = this.onLoadedMetadata.bind(this);\n  this.adVO = this.createDefaultAdVO();\n}\n\n\n__extends(IMAProxy, AdProxy);\n\n\n/** @static\n*/\nIMAProxy.NAME = AdProxy.NAME;\n\nIMAProxy.prototype.defaults = {\n  adTagUrl: null,\n  overlay: null,\n  width: null,\n  height: null,\n  maxBitrate: -1,\n  ppid: null,\n  companions: null,\n  logEventsEnabled: false\n};\n\nIMAProxy.prototype.partner = \"ima\";\n\nIMAProxy.prototype.key = \"ima\";\n\nIMAProxy.prototype.intervals = null;\n\nIMAProxy.prototype.adDisplayContainer = null;\n\nIMAProxy.prototype.adDisplayContainerInitialized = false;\n\nIMAProxy.prototype.adsLoader = null;\n\nIMAProxy.prototype.adsRenderingSettings = null;\n\nIMAProxy.prototype.adsManagerLoaded = false;\n\nIMAProxy.prototype.adsManager = null;\n\nIMAProxy.prototype.cuepoints = null;\n\nIMAProxy.prototype.adLoaded = false;\n\nIMAProxy.prototype.playWhenLoaded = false;\n\nIMAProxy.prototype.contentHasEnded = false;\n\nIMAProxy.prototype.adTagUrl = null;\n\nIMAProxy.prototype.viewMode = null;\n\nIMAProxy.prototype.playbackCore = null;\n\nIMAProxy.prototype.loadedmetadata = null;\n\n/**\n*/\nIMAProxy.prototype.setEnabled = function(value) {\n  var _ref;\n  IMAProxy.__super__.setEnabled.call(this, value);\n  if (value === false) {\n    if ((_ref = this.adsManager) != null) {\n      if (typeof _ref.destroy === \"function\") {\n        _ref.destroy();\n      }\n    }\n    if (this.getInProgress()) {\n      this.contentPlay();\n    }\n  }\n  return value;\n};\n\n/** @override\n*/\nIMAProxy.prototype.onLoadedMetadata = function(event) {\n  if (this.canPlay() && this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/** @override\n*/\nIMAProxy.prototype.initialize = function() {};\n\n/** @override\n*/\nIMAProxy.prototype.ready = function() {\n  var isAndroidChrome, mode, userAgentMatch, _ref;\n  this.viewMode = google.ima.ViewMode.NORMAL;\n  window.addEventListener(\"resize\", this.resize.bind(this));\n  if (this.config.vpaidAllowed != null) {\n    google.ima.settings.setVpaidAllowed(this.config.vpaidAllowed);\n  }\n  if ((this.config.vpaidMode != null) && ((mode = google.ima.ImaSdkSettings.VpaidMode[this.config.vpaidMode.toUpperCase()]) != null)) {\n    google.ima.settings.setVpaidMode(mode);\n  }\n  if (this.config.disableFlashAds != null) {\n    google.ima.settings.setDisableFlashAds(this.config.disableFlashAds);\n  }\n  this.adDisplayContainer = this.createPlugin();\n  this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);\n  userAgentMatch = navigator.userAgent.match(/Chrom(e|ium)\\/([0-9]+)\\./);\n  isAndroidChrome = userAgentMatch ? parseInt(userAgentMatch[2], 10) > 52 : false;\n  if ((((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) >= 10 || isAndroidChrome) && this.facade.player.getConfig().playsinline !== false) {\n    google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);\n  }\n  this.adsRenderingSettings = new google.ima.AdsRenderingSettings();\n  this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);\n  this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);\n};\n\n/** @override\n*/\nIMAProxy.prototype.createPlugin = function() {\n  return new google.ima.AdDisplayContainer(this.getContainer());\n};\n\n/** @override\n*/\nIMAProxy.prototype.engage = function(override) {\n  var _ref, _ref1;\n  if (override == null) {\n    override = true;\n  }\n  if (this.getEnabled() === false) {\n    return;\n  }\n  IMAProxy.__super__.engage.call(this);\n  if (this.adsManagerLoaded === true && this.contentHasEnded === false || this.contentHasEnded === true && ((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n    if ((_ref1 = this.adsManager) != null) {\n      if (typeof _ref1.destroy === \"function\") {\n        _ref1.destroy();\n      }\n    }\n  }\n  this.adsManagerLoaded = false;\n  this.contentHasEnded = false;\n  this.adsManagerLoaded = false;\n  this.playWhenLoaded = false;\n};\n\n/**\n*/\nIMAProxy.prototype.setVolume = function(value) {\n  var _ref;\n  if ((_ref = this.adsManager) != null) {\n    _ref.setVolume(value);\n  }\n  return value;\n};\n\n/**\n*/\nIMAProxy.prototype.getVolume = function() {\n  var _ref;\n  return (_ref = this.adsManager) != null ? _ref.getVolume() : void 0;\n};\n\n/** @override\n*/\nIMAProxy.prototype.requestAd = function() {\n  var adsRequest, dimensions, height, settings, width, _ref, _ref1,\n    _this = this;\n  IMAProxy.__super__.requestAd.call(this);\n  dimensions = this.getDimensions();\n  width = dimensions.clientWidth;\n  height = dimensions.clientHeight;\n  adsRequest = new google.ima.AdsRequest();\n  this.adTagUrl = this.getValue(\"adTagUrl\");\n  if (typeof this.adTagUrl === \"object\") {\n    this.adTagUrl = this.buildAdTagUrl(this.adTagUrl);\n  }\n  adsRequest.adTagUrl = this.adTagUrl;\n  if (!(adsRequest.adsResponse != null) && !(adsRequest.adTagUrl != null)) {\n    this.onAdError(\"No valid adTagUrl or adsResponse provided.\");\n    return;\n  }\n  adsRequest.linearAdSlotWidth = width;\n  adsRequest.linearAdSlotHeight = height;\n  adsRequest.nonLinearAdSlotWidth = ((_ref = this.value.overlay) != null ? _ref.width : void 0) || width;\n  adsRequest.nonLinearAdSlotHeight = ((_ref1 = this.value.overlay) != null ? _ref1.height : void 0) || height;\n  settings = this.adsLoader.getSettings();\n  if (this.config.ppid != null) {\n    settings.setPpid(this.getValue(\"ppid\"));\n  }\n  Promise.resolve(AdRequest.create(adsRequest, \"ima\", this.getData(), {\n    loader: this.adsLoader\n  })).then(function(ad) {\n    var adsResponse;\n    adsResponse = _this.getValue(\"adsResponse\");\n    if ((adsResponse != null) && adsResponse !== \"\") {\n      return Utils.requestText(adsResponse).then(function(text) {\n        ad.request.adsResponse = text;\n        return ad;\n      });\n    } else {\n      return ad;\n    }\n  }).then(this.processAdRequest.bind(this)).then(function(result) {\n    return _this.adsLoader.requestAds(result.request);\n  });\n};\n\n/** @override\n*/\nIMAProxy.prototype.requestOverlay = function() {\n  var adsRequest, overlay;\n  overlay = this.value.overlay;\n  if (!(overlay != null)) {\n    return;\n  }\n  adsRequest = new google.ima.AdsRequest();\n  adsRequest.adTagUrl = overlay.adTagUrl;\n  adsRequest.nonLinearAdSlotWidth = overlay.width || 300;\n  adsRequest.nonLinearAdSlotHeight = overlay.height || 50;\n  this.adsLoader.requestAds(adsRequest);\n};\n\n/** @override\n*/\nIMAProxy.prototype.start = function(load) {\n  var video;\n  if (load == null) {\n    load = true;\n  }\n  if (load === true) {\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    video = this.getMediaElement();\n    video.once(\"loadedmetadata\", this.loadedmetadata);\n    this.playbackCore.setEnabled(false);\n    if (this.facade.isFullscreenDevice()) {\n      this.playbackCore.load();\n    } else {\n      video.load();\n    }\n  } else {\n    this.engage();\n  }\n  if (IMAProxy.__super__.start.call(this) === false) {\n    return false;\n  }\n  this.isLiveMidroll = (load === false) && (this.facade.player.retrieveProxy(MediaProxy.NAME).getTemporalType() === \"live\");\n  if (this.adDisplayContainerInitialized !== true) {\n    this.adDisplayContainer.initialize();\n    this.adDisplayContainerInitialized = true;\n  }\n  if (this.canPlay() === true && load === true) {\n    this.startAd();\n  } else {\n    this.playWhenLoaded = true;\n    this.requestAd();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.canPlay = function() {\n  return this.adsManagerLoaded === true;\n};\n\n/**\n*/\nIMAProxy.prototype.startAd = function() {\n  this.playWhenLoaded = false;\n  try {\n    if (this.viewMode == null) {\n      this.viewMode = google.ima.ViewMode.NORMAL;\n    }\n    this.adsManager.init(this.facade.player.getViewComponent().clientWidth, this.facade.player.getViewComponent().clientHeight, this.viewMode);\n    this.adsManager.start();\n  } catch (adError) {\n    this.error(adError);\n  }\n};\n\nIMAProxy.prototype.resize = function(state, dimensions) {\n  var _ref;\n  if (dimensions == null) {\n    dimensions = this.getDimensions();\n  }\n  if ((this.dimensions != null) && this.dimensions.width === dimensions.width && this.dimensions.height === dimensions.height) {\n    return;\n  }\n  this.dimensions = dimensions;\n  if (state != null) {\n    this.viewMode = state === DisplayState.FULL_SCREEN ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL;\n  }\n  if ((_ref = this.adsManager) != null) {\n    _ref.resize(this.dimensions.width, this.dimensions.height, this.viewMode);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.onAdsManagerLoaded = function(adsManagerLoadedEvent) {\n  var adEventHandler, _ref;\n  this.adsRenderingSettings.bitrate = this.getValue(\"maxBitrate\");\n  this.adsRenderingSettings.autoAlign = true;\n  this.adsRenderingSettings.useStyledNonLinearAds = true;\n  if ((_ref = this.adsManager) != null) {\n    if (typeof _ref.destroy === \"function\") {\n      _ref.destroy();\n    }\n  }\n  this.adsManager = adsManagerLoadedEvent.getAdsManager(this.facade.player.mediaElement, this.adsRenderingSettings);\n  this.sendNotification(AdNotifications.AD_MANAGER_LOADED, {\n    \"adManager\": this.adsManager,\n    \"viewMode\": google.ima.ViewMode.NORMAL,\n    \"adContainer\": this.getContainer()\n  });\n  this.adsManagerLoaded = true;\n  this.cuePoints = this.adsManager.getCuePoints();\n  this.setCues(this.cuePoints);\n  if (this.cuePoints.indexOf(-1) !== -1) {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n  }\n  adEventHandler = this.onAdEvent.bind(this);\n  this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.contentPause.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.contentPlay.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this.onAdResumed.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this.onAdPaused.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, this.onAdClick.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.IMPRESSION, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, adEventHandler);\n  this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n    pods: this.cuePoints\n  });\n  this.sendNotification(AdNotifications.RESPONSE, {\n    pods: this.cuePoints,\n    response: adsManagerLoadedEvent,\n    adsManager: this.adsManager\n  });\n  if (this.canPlay() && this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.onAdClick = function(adEvent) {\n  if ((adEvent != null ? adEvent.getAd().isLinear() : void 0) === false) {\n    this.facade.player.sendNotification(Notifications.PAUSE);\n    return;\n  }\n  if (!this.getPaused()) {\n    this.pause();\n  }\n  this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdPaused = function(adEvent) {\n  this.setPaused(true);\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n  this.facade.player.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  this.facade.player.sendNotification(AdNotifications.AD_PAUSED, this.adVO);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdResumed = function(adEvent) {\n  this.setPaused(false);\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdEvent = function(adEvent) {\n  var ad, companion, companions, config, pos, type, _i, _len, _ref, _ref1;\n  ad = adEvent.getAd();\n  if (this.adVO != null) {\n    if (ad != null) {\n      ad.wrapperAdIds = typeof ad.getWrapperAdIds === \"function\" ? ad.getWrapperAdIds() : void 0;\n      ad.wrapperAdSystems = typeof ad.getWrapperAdSystems === \"function\" ? ad.getWrapperAdSystems() : void 0;\n    }\n    this.adVO.metadata = ad;\n  }\n  switch (adEvent.type) {\n    case google.ima.AdEvent.Type.IMPRESSION:\n      this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.LOADED:\n      if (ad.isLinear()) {\n        this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-overlaymode\");\n        pos = ad.getAdPodInfo().getPodIndex();\n        type = pos === 0 ? \"preroll\" : pos === -1 ? \"postroll\" : \"midroll\";\n        this.adVO = new AdVO(ad.getAdId(), ad.getAdId(), ad.getDuration(), pos, type, \"ima\", null, null, this.adTagUrl, ad, ad.getAdPodInfo().getTotalAds(), ad.getDuration() - this.adsManager.getRemainingTime());\n        if (!this.getInProgress() && type === \"midroll\" || type === \"postroll\") {\n          this.startBreak();\n          this.engageAds();\n        }\n        this.resize();\n        this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n        this.sendNotification(AdNotifications.AD_DURATION_CHANGE, this.adVO);\n        this.setVolume(this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getVolume());\n      } else {\n        this.facade.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlaymode\");\n        this.contentPlay();\n      }\n      break;\n    case google.ima.AdEvent.Type.STARTED:\n      if (ad.isLinear()) {\n        this.adVO.position = ad.getAdPodInfo().getAdPosition();\n        this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n        this.intervals.push(setInterval(this.onAdTimeUpdate.bind(this), 67));\n        this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n        this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n      }\n      try {\n        companions = [];\n        config = (typeof this.getConfigurationData === \"function\" ? (_ref = this.getConfigurationData()) != null ? _ref.companions : void 0 : void 0) || [];\n        for (_i = 0, _len = config.length; _i < _len; _i++) {\n          companion = config[_i];\n          companions = companions.concat(ad.getCompanionAds(companion.width, companion.height));\n        }\n        if ((companions != null ? companions.length : void 0) > 0) {\n          this.setCompanions(companions);\n        }\n      } catch (error) {\n        this.facade.logger.error(\"[AMP IMA ERROR]\", \"Could not retrieve companion ads:\", error);\n      }\n      break;\n    case google.ima.AdEvent.Type.COMPLETE:\n      if (ad.isLinear()) {\n        this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n      }\n      break;\n    case google.ima.AdEvent.Type.FIRST_QUARTILE:\n      this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.MIDPOINT:\n      this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.THIRD_QUARTILE:\n      this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.LOG:\n      if (this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getEnded() === true && (((_ref1 = adEvent.getAdData()) != null ? _ref1.adError : void 0) != null)) {\n        this.forceBreakEnd = true;\n      }\n      if (this.getValue(\"logEventsEnabled\") === true) {\n        this.sendNotification(AdNotifications.LOG, this.adVO);\n      }\n      break;\n    case google.ima.AdEvent.Type.SKIPPED:\n      this.sendNotification(AdNotifications.SKIPPED, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:\n      if (this.getInProgress() === true || this.forceBreakEnd === true) {\n        this.forceBreakEnd = false;\n        this.endBreak();\n      }\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.getContainer = function() {\n  var _ref, _ref1;\n  return ((_ref = this.facade.player.ui) != null ? (_ref1 = _ref.ads) != null ? _ref1.container : void 0 : void 0) || this.facade.player.container;\n};\n\n/**\n*/\nIMAProxy.prototype.getDimensions = function() {\n  var container;\n  container = this.getContainer();\n  return {\n    width: container.clientWidth,\n    height: container.clientHeight\n  };\n};\n\n/**\n*/\nIMAProxy.prototype.onAdTimeUpdate = function(adEvent) {\n  var remaining, time;\n  this.resize();\n  remaining = Utils.clamp(this.adsManager.getRemainingTime(), 0, this.adVO.duration);\n  time = this.adVO.duration - remaining;\n  this.adVO.time = time;\n  this.sendNotification(AdNotifications.AD_TIME_UPDATE, time);\n  this.sendNotification(AdNotifications.AD_TIME_REMAINING, remaining);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdError = function(adErrorEvent) {\n  var error;\n  error = (adErrorEvent != null ? typeof adErrorEvent.getError === \"function\" ? adErrorEvent.getError() : void 0 : void 0) || adErrorEvent;\n  this.error(error);\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.play = function() {\n  var _ref;\n  IMAProxy.__super__.play.call(this);\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.resume();\n    }\n    this.sendNotification(AdNotifications.AD_RESUME);\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"resume\", error);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.pause = function() {\n  IMAProxy.__super__.pause.call(this);\n  if (this.adsManager != null) {\n    try {\n      this.adsManager.pause();\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"pause\", error);\n    }\n  } else {\n    this.playWhenLoaded = false;\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.clearIntervals = function() {\n  var interval, _i, _len, _ref;\n  _ref = this.intervals;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    interval = _ref[_i];\n    clearInterval(this.intervals.pop());\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.breakEnd = function() {\n  var overlayProxy;\n  this.clearIntervals();\n  IMAProxy.__super__.breakEnd.call(this);\n  overlayProxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n  if (overlayProxy != null) {\n    overlayProxy.play();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.setCompanions = function(value) {\n  var companion, companions, _i, _len, _ref;\n  companions = [];\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    companion = value[_i];\n    companions.push({\n      data: companion.getContent(),\n      type: (_ref = companion.getContentType()) != null ? _ref.toLowerCase() : void 0,\n      width: companion.getWidth(),\n      height: companion.getHeight(),\n      metadata: companion\n    });\n  }\n  IMAProxy.__super__.setCompanions.call(this, companions);\n  return value;\n};\n\n/**\n*/\nIMAProxy.prototype.contentPause = function() {\n  var events,\n    _this = this;\n  events = [\"pause\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"];\n  if (this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getSeeking() === false) {\n    events.push(\"seeked\");\n  } else {\n    this.getMediaElement().once(\"seeked\", function() {\n      _this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"seeked\"]);\n    });\n  }\n  this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, events);\n  if (this.isLiveMidroll === true) {\n    this.getMediaElement().volume = 0;\n    return;\n  }\n  IMAProxy.__super__.contentPause.call(this);\n};\n\n/**\n*/\nIMAProxy.prototype.contentPlay = function() {\n  var _ref, _ref1;\n  if (this.getInProgress() === true) {\n    this.endBreak();\n  }\n  this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"pause\", \"seeked\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"]);\n  if (((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n    return;\n  }\n  if (this.isLiveMidroll === true) {\n    this.getMediaElement().volume = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getVolume();\n    if (Utils.getDevice() === \"ipad\") {\n      this.getMediaElement().load();\n    } else {\n      return;\n    }\n  }\n  IMAProxy.__super__.contentPlay.call(this);\n  if (((_ref1 = this.adVO) != null ? _ref1.type : void 0) === \"midroll\" && Utils.getDevice() === \"desktop\") {\n    this.facade.player.setCurrentTime(Math.floor(this.facade.player.getCurrentTime()));\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.contentEnded = function() {\n  var _ref;\n  this.contentHasEnded = true;\n  try {\n    if ((_ref = this.adsLoader) != null) {\n      if (typeof _ref.contentComplete === \"function\") {\n        _ref.contentComplete();\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"contentComplete\", error);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.terminateAd = function() {\n  var _ref;\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.stop();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAd\", error);\n  }\n  if (this.adVO.type === \"postrol\") {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  }\n  this.endBreak();\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.terminateAllAds = function() {\n  var _ref;\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.destroy();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAllAds\", error);\n  }\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.endBreak();\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.destroy = function() {\n  var _ref;\n  this.clearIntervals();\n  if ((_ref = this.adsManager) != null) {\n    if (typeof _ref.destroy === \"function\") {\n      _ref.destroy();\n    }\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.buildAdTagUrl = function(adTagObj) {\n  var adTagUrl;\n  adTagUrl = adTagObj.base || \"//pubads.g.doubleclick.net/gampad/ads\";\n  adTagUrl += \"?\" + this.encodeAdTagParams(adTagObj.params);\n  return adTagUrl;\n};\n\n/**\n*/\nIMAProxy.prototype.encodeAdTagParams = function(params) {\n  var adTagParams, key, value;\n  adTagParams = [];\n  for (key in params) {\n    value = params[key];\n    if (typeof value === \"object\") {\n      value = encodeURIComponent(this.encodeAdTagParams(value));\n    }\n    adTagParams.push(\"\" + key + \"=\" + value);\n  }\n  return adTagParams.join(\"&\");\n};\n\n/**\n * The IMAAddOverlayCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAAddOverlayCommand() {\n  IMAAddOverlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAAddOverlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIMAAddOverlayCommand.prototype.execute = function(notification) {\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlay-mode\");\n};\n\n/**\n * The IMARemoveOverlayCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMARemoveOverlayCommand() {\n  IMARemoveOverlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMARemoveOverlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIMARemoveOverlayCommand.prototype.execute = function(notification) {\n  var proxy;\n  proxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n  proxy.stop();\n  this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-overlay-mode\");\n};\n\n/**\n * The IMAOverlayMediator class.\n *\n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction IMAOverlayMediator() {\n  IMAOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(IMAOverlayMediator, OverlayMediator);\n\n\nIMAOverlayMediator.prototype.componentName = \"ad-overlay\";\n\nIMAOverlayMediator.prototype.anchor = null;\n\nIMAOverlayMediator.prototype.image = null;\n\nIMAOverlayMediator.prototype.tracker = null;\n\nIMAOverlayMediator.prototype.tracker2 = null;\n\nIMAOverlayMediator.prototype.closeButton = null;\n\nIMAOverlayMediator.prototype.closeText = null;\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.onRegister = function() {\n  var _this = this;\n  IMAOverlayMediator.__super__.onRegister.call(this);\n  this.anchor = this.create(\"ad-overlay-anchor\");\n  this.anchor.target = \"_blank\";\n  this.image = this.create(\"ad-overlay-img\", this.anchor, \"img\");\n  this.tracker = this.create();\n  this.tracker.width = 0;\n  this.tracker.height = 0;\n  this.tracker2 = this.create(null, this, \"img\");\n  this.tracker2.width = 0;\n  this.tracker2.height = 0;\n  this.closeButton = this.create(\"ad-close-button\", this.anchor);\n  this.closeButton.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n    return false;\n  };\n  this.closeText = this.createText(\"ad-close-text\", \"x\", this.closeButton);\n};\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.listNotificationInterests = function() {\n  return [IMANotifications.ADD_OVERLAY, IMANotifications.REMOVE_OVERLAY];\n};\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.handleNotification = function(notification) {\n  var ad;\n  switch (notification.getName()) {\n    case IMANotifications.ADD_OVERLAY:\n      ad = notification.getBody();\n      this.image.src = ad.src;\n      this.anchor.href = ad.href;\n      this.tracker.src = ad.tracking[0];\n      this.tracker2.src = ad.tracking[1];\n  }\n};\n\n/**\n * The IMAReadyCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAReadyCommand() {\n  IMAReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAReadyCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIMAReadyCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).ready();\n};\n\n/**\n * The IMADisplayStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMADisplayStateChangeCommand() {\n  IMADisplayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMADisplayStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIMADisplayStateChangeCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n};\n\n/**\n * The IMAActiveStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAActiveStateChangeCommand() {\n  IMAActiveStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nIMAActiveStateChangeCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n};\n\n/**\n * The IMAFullscreenProxy class.\n *\n * @constructor\n * @private\n * @extends {IMAProxy}\n * @param   {Object}    config  The configuration object.\n*/\nfunction IMAFullscreenProxy(config) {\n  IMAFullscreenProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(IMAFullscreenProxy, IMAProxy);\n\n\n/** @static\n*/\nIMAFullscreenProxy.NAME = IMAProxy.NAME;\n\n/**\n*/\nIMAFullscreenProxy.prototype.createPlugin = function() {\n  var container, _ref, _ref1;\n  container = this.facade.player.ui.ads.container;\n  if (Utils.isIPhone() && (((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 10)) {\n    return new google.ima.AdDisplayContainer(container, this.facade.player.getMediaElement(), container);\n  }\n  if (((_ref1 = Utils.getIOSversion()) != null ? _ref1[0] : void 0) >= 10) {\n    this.facade.player.getMediaElement().playsInline = this.facade.player.getConfig().playsinline != null ? this.facade.player.getConfig().playsinline : true;\n  }\n  return new google.ima.AdDisplayContainer(container, this.facade.player.getMediaElement());\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.engage = function(media) {\n  IMAFullscreenProxy.__super__.engage.call(this, media);\n  this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.reset = function(media) {\n  IMAFullscreenProxy.__super__.reset.call(this, media);\n  this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.breakStart = function() {\n  this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  this.playbackCore.setEnabled(false);\n  this.setInProgress(true);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.breakEnd = function() {\n  IMAFullscreenProxy.__super__.breakEnd.call(this);\n  this.playbackCore.setEnabled(true);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AdWrapper(player, init) {\n  AdWrapper.__super__.constructor.call(this, player, init);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    inProgress: {\n      get: this.getInProgress,\n      enumerable: true,\n      configurable: false\n    },\n    started: {\n      get: this.getStarted,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    companions: {\n      get: this.getCompanions,\n      enumerable: true,\n      configurable: false\n    },\n    currentAd: {\n      get: this.getCurrentAd,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(AdWrapper, PluginWrapper);\n\n\nAdWrapper.NAME = \"AdWrapper\";\n\nAdWrapper.prototype.enabled = true;\n\nAdWrapper.prototype.paused = false;\n\nAdWrapper.prototype.started = false;\n\nAdWrapper.prototype.adVO = null;\n\nAdWrapper.prototype.partner = null;\n\n/**\n*/\nAdWrapper.prototype.getFeatureName = function() {\n  return \"ads\";\n};\n\nAdWrapper.prototype.getInProgress = function() {\n  return this.player.mediaElement.getPlayerProperty(\"adInProgress\");\n};\n\nAdWrapper.prototype.getStarted = function() {\n  return this.started;\n};\n\nAdWrapper.prototype.getPaused = function() {\n  return this.paused;\n};\n\nAdWrapper.prototype.getCompanions = function() {\n  var _ref;\n  return (_ref = this.adVO) != null ? _ref.companions : void 0;\n};\n\nAdWrapper.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  this.player.mediaElement.setPlayerProperty(\"adsEnabled\", value);\n  return value;\n};\n\nAdWrapper.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nAdWrapper.prototype.getCurrentAd = function() {\n  return this.adVO;\n};\n\nAdWrapper.prototype.enable = function() {\n  this.setEnabled(true);\n};\n\nAdWrapper.prototype.disable = function() {\n  this.setEnabled(false);\n};\n\n/**\n*/\nAdWrapper.prototype.createFlashVars = function(flashvars) {\n  flashvars.core_ads_enabled = true;\n  return flashvars;\n};\n\n/**\n*/\nAdWrapper.prototype.listNotificationInterests = function() {\n  var key, value;\n  return AdWrapper.__super__.listNotificationInterests.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in FlashAdNotifications) {\n      value = FlashAdNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/** @override\n*/\nAdWrapper.prototype.handleNotification = function(notification) {\n  var body, cuepoints, cues, event, name, pods, remaining, scene, target, type, _i, _len, _ref,\n    _this = this;\n  AdWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  this.adVO = this.createAdVO(body);\n  target = this;\n  switch (name) {\n    case FlashAdNotifications.BREAK_START:\n      type = AdNotifications.BREAK_START;\n      this.facade.setPlayState(\"playing\");\n      if (((_ref = body.cuePoints) != null ? _ref.length : void 0) > 0) {\n        cuepoints = body.cuePoints.map(function(cue) {\n          var start;\n          start = !isNaN(cue.sceneStartSeconds) ? cue.sceneStartSeconds : cue.sceneEndSeconds;\n          return {\n            startTime: start,\n            endTime: cue.sceneEndSeconds\n          };\n        });\n        this.facade.setCues(cuepoints);\n      }\n      break;\n    case FlashAdNotifications.BREAK_END:\n      type = AdNotifications.BREAK_END;\n      break;\n    case FlashAdNotifications.BREAK_SKIPPED:\n      type = AdNotifications.BREAK_SKIPPED;\n      break;\n    case FlashAdNotifications.AD_MEDIA_LOADED:\n      type = AdNotifications.AD_LOADED;\n      this.start = false;\n      target.dispatchEvent(new Event(AdNotifications.AD_DURATION_CHANGE.replace(/^ads/, \"\"), this.adVO));\n      break;\n    case FlashAdNotifications.AD_STARTED:\n      type = AdNotifications.AD_STARTED;\n      this.started = true;\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.AD_TIME_UPDATE:\n      type = AdNotifications.AD_TIME_UPDATE;\n      remaining = body.duration - body.currentTime;\n      target.dispatchEvent(new Event(AdNotifications.AD_TIME_REMAINING.replace(/^ads/, \"\"), remaining));\n      body = body.currentTime;\n      break;\n    case FlashAdNotifications.AD_TIME_REMAINING:\n      type = AdNotifications.AD_TIME_REMAINING;\n      body = body.timeElapsed;\n      break;\n    case FlashAdNotifications.AD_ERROR:\n    case FlashAdNotifications.AD_PLAYBACK_FAILED:\n      type = AdNotifications.AD_ERROR;\n      this.start = false;\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.COMPLETE:\n      type = AdNotifications.COMPLETE;\n      break;\n    case FlashAdNotifications.AD_ENDED:\n    case FlashAdNotifications.AD_PLAYBACK_TERMINATED:\n      type = AdNotifications.AD_ENDED;\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.AD_CLICKED:\n      type = AdNotifications.AD_CLICKED;\n      break;\n    case FlashAdNotifications.AD_COMPANION:\n      type = AdNotifications.AD_COMPANION;\n      if ((this.adVO != null) && (body != null)) {\n        this.adVO.companions = body;\n      }\n      break;\n    case FlashAdNotifications.AD_PAUSE:\n      type = AdNotifications.AD_PAUSE;\n      target = this.player;\n      this.paused = true;\n      this.player.setPlayState(\"paused\");\n      break;\n    case FlashAdNotifications.AD_PLAY:\n      type = AdNotifications.AD_PLAY;\n      this.paused = false;\n      this.player.setPlayState(\"playing\");\n      break;\n    case FlashAdNotifications.AD_LOG:\n      type = AdNotifications.AD_LOG;\n      break;\n    case FlashAdNotifications.AD_FIRST_QUARTILE:\n      type = AdNotifications.FIRST_QUARTILE;\n      break;\n    case FlashAdNotifications.AD_MIDPOINT:\n      type = AdNotifications.MIDPOINT;\n      break;\n    case FlashAdNotifications.AD_THIRD_QUARTILE:\n      type = AdNotifications.THIRD_QUARTILE;\n      break;\n    case FlashAdNotifications.AD_REQUEST:\n      type = AdNotifications.REQUEST;\n      break;\n    case FlashAdNotifications.AD_REQUEST_COMPLETE:\n      type = AdNotifications.REQUEST_COMPLETE;\n      pods = [];\n      cues = body.cuePoints || [];\n      for (_i = 0, _len = cues.length; _i < _len; _i++) {\n        scene = cues[_i];\n        pods.push(new AdVO(scene.sceneId, scene.sceneTitle, scene.sceneDuration, scene.scenePodIndex, scene.scenePodPosition, this.partner, null, null, null, {}, scene.sceneSubCount, scene.sceneEndSeconds));\n      }\n      this.adVO = {\n        pods: pods\n      };\n      event = new Event(\"response\", this.adVO);\n      event.player = this.player;\n      target.dispatchEvent(event);\n      break;\n    case FlashAdNotifications.AD_SKIPPED:\n      type = AdNotifications.SKIPPED;\n      break;\n    case FlashAdNotifications.AD_IMPRESSION:\n      type = AdNotifications.IMPRESSION;\n  }\n  if (type != null) {\n    this.sendNotification(type, this.adVO);\n    if (type === AdNotifications.AD_TIME_REMAINING || type === AdNotifications.AD_TIME_UPDATE) {\n      event = new Event(type.replace(/^ads/, \"\"), body);\n    } else {\n      event = new Event(type.replace(/^ads/, \"\"), this.adVO);\n    }\n    event.player = this.player;\n    target.dispatchEvent(event);\n  }\n};\n\n/**\n*/\nAdWrapper.prototype.createAdVO = function(ad) {\n  if (!(ad != null)) {\n    return null;\n  }\n  return new AdVO(ad.id, ad.title, ad.duration, ad.adIndex, ad.podPosition, ad.adPlatform, null, null, ad.requestURL, ad.metadata, ad.totalAds, ad.currentTime);\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.setPodLocks = function(pods) {\n  var pod, scenes, _i, _len;\n  scenes = [];\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    scenes.push({\n      sceneId: pod.id,\n      sceneLocked: pod.locked,\n      sceneTitle: pod.title,\n      sceneStartSeconds: pod.time,\n      sceneEndSeconds: pod.duration + pod.time,\n      scenePodIndex: pod.position,\n      scenePodPosition: pod.type\n    });\n  }\n  this.player.mediaElement.setAdPodLocks(scenes);\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.terminateAd = function() {\n  this.player.mediaElement.terminateAd();\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.terminateAllAds = function() {\n  this.player.mediaElement.terminateAllAds();\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.requestAd = function() {\n  this.player.mediaElement.triggerAd();\n};\n\nfunction IMAWrapper() {\n  return IMAWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(IMAWrapper, AdWrapper);\n\n\nIMAWrapper.NAME = \"IMAWrapper\";\n\nIMAWrapper.prototype.partner = \"ima\";\n\nIMAWrapper.prototype.flashPlugins = [\n  {\n    id: \"GoogleIMAPlugin\",\n    src: '#{paths.resources}plugins/GoogleIMAPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"GoogleIMAPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"IMAOverlayAdPlugin\",\n    src: '#{paths.resources}plugins/IMAOverlayAdPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"IMAOverlayAdPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"AdOptionsPlugin\",\n    src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdOptionsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/**\n*/\nIMAWrapper.prototype.createXML = function(xml) {\n  var admedia, application, companion, companions, ids, overlay, prop, props, vendor, _i, _j, _k, _len, _len1, _len2, _ref;\n  application = xml.firstChild;\n  admedia = xml.getElementsByTagName(\"admedia\")[0];\n  if (!(admedia != null)) {\n    admedia = xml.createElement(\"admedia\");\n    application.appendChild(admedia);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"dfp\");\n  admedia.appendChild(vendor);\n  props = [\n    {\n      value: this.config.adTagUrl,\n      key: \"DFP_AD_TAG_URL\"\n    }, {\n      value: this.config.maxBitrate,\n      key: \"DFP_MAX_BITRATE\"\n    }, {\n      value: this.config.sceneMarkers,\n      key: \"displaySceneMarkers\"\n    }, {\n      value: this.config.ppid,\n      key: \"DFP_PPID\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  if (this.config.position != null) {\n    vendor.setAttribute(\"position\", this.config.position);\n  }\n  if (this.config.params != null) {\n    if (this.config.params.adTag != null) {\n      this.createProperty(xml, \"DFP_AD_TAG_PARAMS\", this.config.params.adTag, vendor);\n    }\n    if (this.config.params.manual != null) {\n      this.createProperty(xml, \"DFP_MANUAL_PARAMS\", this.config.params.manual, vendor);\n    }\n  }\n  if (this.config.companions != null) {\n    companions = [];\n    ids = [];\n    _ref = this.config.companions;\n    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n      companion = _ref[_j];\n      companions.push(companion.width + \"x\" + companion.height);\n      ids.push(companion.id);\n    }\n    this.createProperty(xml, \"DFP_SIZE\", companions.join(\",\"), vendor);\n    this.createProperty(xml, \"COMPANION_ID\", ids.join(\",\"), vendor);\n  }\n  if (this.config.disableCompanionAds != null) {\n    this.createProperty(xml, \"disableCompanionAds\", this.config.disableCompanionAds, vendor);\n  }\n  if (this.config.overlay != null) {\n    if (this.config.overlay.enabled === true) {\n      overlay = xml.createElement(\"overlay\");\n      admedia.appendChild(overlay);\n    }\n    props = [\n      {\n        value: \"dfp\",\n        key: \"OVERLAY_AD_PARTNER\"\n      }, {\n        value: this.config.overlay.adTagUrl,\n        key: \"OVERLAY_AD_BASE_URL\"\n      }, {\n        value: this.config.overlay.delay,\n        key: \"OVERLAY_AD_DELAY\"\n      }, {\n        value: this.config.overlay.interval,\n        key: \"OVERLAY_AD_INTERVAL\"\n      }, {\n        value: this.config.overlay.duration,\n        key: \"OVERLAY_AD_DURATION\"\n      }, {\n        value: \"\" + this.config.overlay.width + \"x\" + this.config.overlay.height,\n        key: \"OVERLAY_AD_SIZE\"\n      }\n    ];\n    for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n      prop = props[_k];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, overlay);\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar StatsNotifications = {\n  VISIBILITY_CHANGE: \"statsvisibilitychange\",\n  BITRATES_UPDATE: \"bitratesUpdate\"\n};\n\n/**\n * The AdPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction AdPlugin() {\n  AdPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    inProgress: {\n      get: this.getInProgress,\n      enumerable: true,\n      configurable: false\n    },\n    started: {\n      get: this.getStarted,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    companions: {\n      get: this.getCompanions,\n      enumerable: true,\n      configurable: false\n    },\n    currentAd: {\n      get: this.getCurrentAd,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(AdPlugin, Feature);\n\n\nAdPlugin.NAME = \"AdPlugin\";\n\nAdPlugin.prototype.container = null;\n\nAdPlugin.prototype.featureName = \"ads\";\n\n/** @override\n*/\nAdPlugin.prototype.createModel = function() {\n  this.proxy = this.isFullscreenDevice() ? this.createFullscreenProxy() : this.createProxy();\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nAdPlugin.prototype.createController = function() {\n  AdPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.MEDIA_CHANGE, AdMediaChangeCommand);\n  this.registerCommand(AdNotifications.BREAK_START, AdBreakStartCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, AdLoadedCommand);\n  this.registerCommand(AdNotifications.BREAK_END, AdBreakEndCommand);\n  this.registerCommand(UserNotifications.SEEKED, AdSeekCommand);\n  this.registerCommand(AdNotifications.AD_CONTAINER_CREATED, AdContainerCreatedCommand);\n  this.registerCommand(Notifications.REPLAY, AdReplayCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, PluginEventCommand);\n  this.registerCommand(AdNotifications.SKIPPED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_MANAGER_LOADED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_TIME_REMAINING, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_DURATION_CHANGE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_ERROR, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_COMPANION, PluginEventCommand);\n  this.registerCommand(AdNotifications.FIRST_QUARTILE, PluginEventCommand);\n  this.registerCommand(AdNotifications.MIDPOINT, PluginEventCommand);\n  this.registerCommand(AdNotifications.THIRD_QUARTILE, PluginEventCommand);\n  this.registerCommand(AdNotifications.COMPLETE, PluginEventCommand);\n  this.registerCommand(AdNotifications.LOG, PluginEventCommand);\n  this.registerCommand(AdNotifications.REQUEST, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_RESUME, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PLAY, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PAUSE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PAUSED, PluginEventCommand);\n  this.registerCommand(AdNotifications.IMPRESSION, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_CLICKED, PluginEventCommand);\n  this.registerCommand(AdNotifications.REQUEST_COMPLETE, PluginEventCommand);\n  this.registerCommand(AdNotifications.RESPONSE, PluginEventCommand);\n  this.registerCommand(AdNotifications.BREAK_SKIPPED, PluginEventCommand);\n};\n\nAdPlugin.prototype.isFullscreenDevice = function() {\n  return Utils.isFullscreenDevice();\n};\n\nAdPlugin.prototype.createProxy = function() {};\n\nAdPlugin.prototype.createFullscreenProxy = function() {};\n\n/**\n*/\nAdPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE, Notifications.REPLAY, Notifications.PLAY, Notifications.PAUSE, Notifications.PAUSED, Notifications.START, Notifications.STARTED, Notifications.ENDED, Notifications.READY, Notifications.VOLUME_CHANGE, Notifications.FULL_SCREEN_CHANGE, Notifications.CHANGE_ACTIVE_STATE, Notifications.PLAY_STATE_CHANGE, UserNotifications.PLAY, UserNotifications.PAUSE, UserNotifications.SEEKED, UserNotifications.TOGGLE_PLAY_PAUSE];\n};\n\n/**\n*/\nAdPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return AdPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in AdNotifications) {\n      value = AdNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([Notifications.PLAY_REQUEST, Notifications.UPDATE_DATA_BINDINGS, Notifications.DISPLAY_TIME, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_VIDEO_EVENTS, Notifications.DISABLE_VIDEO_EVENTS, Notifications.HAS_POST_CONTENT, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.CHANGE_PLAY_STATE, Notifications.AUTOPLAY_BLOCKED]);\n};\n\n/**\n * @param {boolean} value The enabled flag.\n * @expose\n*/\nAdPlugin.prototype.setEnabled = function(value) {\n  this.proxy.setEnabled(value);\n};\n\n/**\n * @return {boolean} The enabled flag.\n * @expose\n*/\nAdPlugin.prototype.getEnabled = function() {\n  return this.proxy.getEnabled();\n};\n\n/**\n * @return {boolean} The in progress flag.\n * @expose\n*/\nAdPlugin.prototype.getInProgress = function() {\n  return this.proxy.getInProgress();\n};\n\n/**\n * @return {boolean} The started flag.\n * @expose\n*/\nAdPlugin.prototype.getStarted = function() {\n  return this.proxy.getStarted();\n};\n\n/**\n * @return {boolean} The paused flag.\n * @expose\n*/\nAdPlugin.prototype.getPaused = function() {\n  return this.proxy.getPaused();\n};\n\n/**\n * @return {Array.<Object>} The list of companion ads.\n * @expose\n*/\nAdPlugin.prototype.getCompanions = function() {\n  return this.proxy.getCompanions();\n};\n\n/**\n * @return {Array.<Object>} The list of companion ads.\n * @expose\n*/\nAdPlugin.prototype.getCurrentAd = function() {\n  return this.proxy.adVO;\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.setPodLocks = function(pods) {\n  this.proxy.setPodLocks(pods);\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.resize = function(state) {\n  this.proxy.resize(state);\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.terminateAd = function() {\n  this.proxy.terminateAd();\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.terminateAllAds = function() {\n  this.proxy.terminateAllAds();\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.requestAd = function() {\n  this.proxy.start(false);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction StatsProxy(config) {\n  StatsProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(StatsProxy, ModuleProxy);\n\n\n/** @static\n*/\nStatsProxy.NAME = ModuleProxy.NAME;\n\nStatsProxy.prototype.defaults = {\n  url: null\n};\n\nStatsProxy.prototype.hidden = true;\n\nStatsProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nStatsProxy.prototype.setURL = function(value) {\n  return this.data.url = value;\n};\n\nStatsProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nStatsProxy.prototype.setHidden = function(value) {\n  return this.hidden = value;\n};\n\nStatsProxy.prototype.invoke = function() {\n  var _this = this;\n  if (this.data.url != null) {\n    return Utils.request(this.data.url).then(function(xhr) {\n      return _this.sendNotification(StatsNotifications.BITRATES_UPDATE, xhr.response);\n    })[\"catch\"](function(error) {\n      return _this.sendNotification(StatsNotifications.BITRATES_UPDATE, null);\n    });\n  }\n};\n\n/**\n * The StatsVisibilityChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction StatsVisibilityChangeCommand() {\n  StatsVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(StatsVisibilityChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nStatsVisibilityChangeCommand.prototype.execute = function(notification) {\n  var statsProxy;\n  statsProxy = this.facade.retrieveProxy(StatsProxy.NAME);\n  statsProxy.setHidden(notification.getBody());\n  statsProxy.setURL(\"\" + (this.facade.player.getSrc()));\n  if (notification.getBody() === false) {\n    statsProxy.invoke();\n  }\n};\n\n/**\n * The StatsMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction StatsMediator() {\n  StatsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(StatsMediator, PluginMediator);\n\n\n/**\n * Stats Mediator\n *\n * @static\n * @type {string}\n*/\nStatsMediator.prototype.componentName = \"stats\";\n\nStatsMediator.prototype.container = null;\n\nStatsMediator.prototype.statsText = null;\n\nStatsMediator.prototype.statsButton = null;\n\nStatsMediator.prototype.bitrateText = null;\n\nStatsMediator.prototype.bitrateArr = null;\n\n/**\n * @override\n*/\nStatsMediator.prototype.onRegister = function() {\n  var _this = this;\n  StatsMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"stats-enabled\");\n  this.classList.add(\"hidden\");\n  this.statsFormat = this.create(\"stats-text\");\n  this.statsQuality = this.create(\"stats-text\");\n  this.statsBitRate = this.create(\"stats-text\");\n  this.statsPlayBack = this.create(\"stats-text\");\n  this.statsAnalytics = this.create(\"stats-text\");\n  this.statsButton = this.create(\"stats-button\", false);\n  EventHandler.create(this.statsButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, !_this.facade.getHidden());\n    return false;\n  });\n  this.sendNotification(Notifications.ADD_CONTROL, this.statsButton);\n};\n\n/**\n * @override\n*/\nStatsMediator.prototype.listNotificationInterests = function() {\n  return [StatsNotifications.VISIBILITY_CHANGE, Notifications.PLAYING, Notifications.TIME_UPDATE];\n};\n\n/**\n * @override\n*/\nStatsMediator.prototype.handleNotification = function(notification) {\n  var body, levels, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case StatsNotifications.VISIBILITY_CHANGE:\n      if (this.plugin.getHidden()) {\n        this.classList.add(\"hidden\");\n      } else {\n        this.classList.remove(\"hidden\");\n        this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Loading...</p>\";\n        this.renderStats();\n      }\n      break;\n    case Notifications.TIME_UPDATE:\n      this.renderQuality();\n      break;\n    case Notifications.PLAYING:\n      levels = this.facade.player.getQualityLevels();\n      if ((levels != null ? levels.length : void 0) > 0) {\n        this.constructBitrateText(levels);\n      } else {\n        this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Not Available</p>\";\n      }\n  }\n};\n\n/*  Render Stats UI\n*/\nStatsMediator.prototype.renderQuality = function() {\n  var quality;\n  quality = this.facade.player.getQuality();\n  if (this.quality === quality) {\n    return;\n  }\n  this.statsQuality.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Quality</b></p><p>\" + this.createBitrateText(this.facade.player.getQualityLevels()[quality], quality) + \"</p>\";\n};\n\n/*  Render Stats UI\n*/\nStatsMediator.prototype.renderStats = function() {\n  var analyticsVal, device, formatVal, isDash, playbackVal, player, urlVal, _ref;\n  try {\n    player = this.facade.player;\n    formatVal = player.getMedia() === void 0 ? \"Not Available\" : player.getMedia().type;\n    urlVal = player.getSrc() === \"\" || player.getSrc() === null ? \"Not Available\" : player.getSrc();\n    device = Utils.getDevice();\n    if (device == null) {\n      device = \"\";\n    }\n    playbackVal = this.facade.player.getConfig().mode !== \"\" && this.facade.player.getConfig().mode !== null && this.facade.player.getConfig().mode.indexOf(\"html\") !== -1 ? this.facade.player.getVersion() + \", HTML5 Video: \" + device : \"Not Available\";\n    isDash = (_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore()) != null ? _ref.proxyName.indexOf(\"dash\") : void 0;\n    if (isDash > -1) {\n      playbackVal += \", dash.js\";\n    }\n    analyticsVal = this.facade.player.getConfig().mediaanalytics === void 0 || this.facade.player.getConfig().mediaanalytics.config === \"\" || this.facade.player.getConfig().mediaanalytics.config === null ? \"Not Available\" : this.facade.player.getConfig().mediaanalytics.config;\n    this.statsFormat.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Stream</b></p><p>Format: \" + formatVal + \"</p><p>URL: \" + urlVal + \"</p>\";\n    this.statsPlayBack.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Playback</b></p>\" + playbackVal;\n    this.statsAnalytics.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Analytics</b></p>\" + analyticsVal;\n  } catch (error) {\n    this.facade.logger.error(\"[AMP Stats Render Error]:\", error);\n  }\n};\n\n/*  Format Bitrate HTML Text\n*/\nStatsMediator.prototype.constructBitrateText = function(bitrateArr) {\n  var index, item, _i, _len, _ref;\n  this.bitrateArr = bitrateArr;\n  this.bitrateText = '';\n  this.bitrateArr.sort(function(a, b) {\n    var aBitrate, bBitrate;\n    aBitrate = parseInt(a.bitrate);\n    bBitrate = parseInt(b.bitrate);\n    if (aBitrate < bBitrate) {\n      return -1;\n    } else if (aBitrate > bBitrate) {\n      return 1;\n    } else {\n      return 0;\n    }\n  });\n  _ref = this.bitrateArr;\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    item = _ref[index];\n    this.bitrateText += this.createBitrateText(item, index);\n  }\n  if (this.bitrateText === \"\") {\n    this.bitrateText = \"<p>Not Available</p>\";\n  }\n  this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p>\" + this.bitrateText;\n};\n\n/**\n*/\nStatsMediator.prototype.createBitrateText = function(item, index) {\n  return \"<p>\" + (index + 1) + \". \" + ((item.bitrate / 1000).toFixed(0)) + \" kbps \" + item.width + \"x\" + item.height + \"</p>\";\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AISNotifications = {\n  START_AUTHENTICATION: \"aisauthenticationstarted\",\n  AUTHENTICATED: \"aisauthenticated\",\n  AUTHENTICATING: \"aisauthenticating\",\n  AUTHENTICATION_COMPLETE: \"aisauthenticationcomplete\",\n  CHOOSE_AUTH_PROVIDER: \"aischooseprovider\",\n  CHOOSE_PLAY_OPTIONS: \"aischooseplayoptions\",\n  LAUNCH_IDP_LOGIN: \"aislaunchidplogin\",\n  PREVIEW: \"aispreview\",\n  PREVIEW_TIME_REMAINING: \"aispreviewtimeremaining\"\n};\n\n/**\n * The AISLaunchIDPLoginCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISLaunchIDPLoginCommand() {\n  AISLaunchIDPLoginCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISLaunchIDPLoginCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISLaunchIDPLoginCommand.prototype.execute = function(notification) {\n  AISLaunchIDPLoginCommand.__super__.execute.call(this, notification);\n  this.proxy.launchIDPLogin(notification.getBody());\n};\n\n/**\n * The AISChooserMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction AISChooserMediator(parent) {\n  AISChooserMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISChooserMediator, ComponentMediator);\n\n\nAISChooserMediator.prototype.componentName = \"ais-chooser\";\n\nAISChooserMediator.prototype.menu = null;\n\nAISChooserMediator.prototype.label = null;\n\nAISChooserMediator.prototype.grid = null;\n\nAISChooserMediator.prototype.select = null;\n\nAISChooserMediator.prototype.login = null;\n\nAISChooserMediator.prototype.title = null;\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISChooserMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.title = this.createText(\"ais-chooser-title\", \"Choose your provider\");\n  this.grid = this.create(\"ais-chooser-grid\");\n  this.menu = this.create(\"ais-chooser-menu\");\n  this.label = this.createText(\"ais-chooser-label\", \"Providers: \", this.menu);\n  this.select = this.create(\"ais-chooser-select\", this.menu, \"select\");\n  this.login = this.create(\"ais-chooser-login\", false, \"input\");\n  this.login.type = \"button\";\n  this.login.value = \"Login\";\n  EventHandler.create(this.login, EventHandler.CLICK, function(event) {\n    var idpID;\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    idpID = _this.select.options[_this.select.selectedIndex].value;\n    _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n    return false;\n  });\n  this.menu.appendChild(this.login);\n};\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.CHOOSE_AUTH_PROVIDER, AISNotifications.AUTHENTICATING];\n};\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.handleNotification = function(notification) {\n  var baseURL, div, featuredGroup, footprints, group, groups, idp, idps, img, index, key, logos, member, option, options, proxy, resp, span, src, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1,\n    _this = this;\n  switch (notification.getName()) {\n    case AISNotifications.CHOOSE_AUTH_PROVIDER:\n      resp = notification.getBody();\n      idps = resp.possible_idps;\n      footprints = resp.footprints || [];\n      groups = resp.grouped_idps || [];\n      proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n      logos = proxy.value.logos;\n      baseURL = logos != null ? logos.base : void 0;\n      this.grid.innerHTML = \"\";\n      if ((groups != null) && ((logos != null ? logos.group : void 0) != null)) {\n        for (_i = 0, _len = groups.length; _i < _len; _i++) {\n          group = groups[_i];\n          if (!(group.name === logos.group)) {\n            continue;\n          }\n          featuredGroup = group;\n          break;\n        }\n        if (featuredGroup != null) {\n          _ref = featuredGroup.members;\n          for (index = _j = 0, _len1 = _ref.length; _j < _len1; index = ++_j) {\n            member = _ref[index];\n            idp = idps[member];\n            div = this.create([\"ais-chooser-grid-item\", \"ais-chooser-grid-index-\" + (index + 1)], this.grid);\n            if (div.dataset == null) {\n              div.dataset = {};\n            }\n            div.dataset.key = member;\n            div.onclick = function(event) {\n              var idpID, target;\n              if (typeof event.stopImmediatePropagation === \"function\") {\n                event.stopImmediatePropagation();\n              }\n              target = (event.currentTarget != null) ? event.currentTarget : event.srcElement;\n              idpID = target.dataset.key;\n              _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n              return false;\n            };\n            if (((_ref1 = idps[member].logos) != null ? _ref1[logos.key] : void 0) != null) {\n              img = this.create(\"ais-chooser-grid-cell-img\", div, \"img\");\n              img.alt = idp.display_name;\n              src = idp.logos[logos.key];\n              if (src.indexOf(\"http\") === -1) {\n                src = baseURL + src;\n              }\n              img.src = src;\n              if (img.dataset == null) {\n                img.dataset = {};\n              }\n              img.dataset.key = member;\n              span = this.create(\"ais-chooser-grid-cell-label\", div, \"span\");\n              span.innerHTML = idp.display_name;\n            } else {\n              div.innerHTML = idp.display_name;\n            }\n          }\n        }\n      }\n      if (this.grid.innerHTML !== \"\") {\n        this.classList.add(\"ais-chooser-featured\");\n        this.label.textContent = \"Other \";\n      }\n      options = this.select.options;\n      for (index = _k = 0, _len2 = options.length; _k < _len2; index = ++_k) {\n        option = options[index];\n        this.select.options.remove(index);\n      }\n      if (footprints.length > 0) {\n        for (_l = 0, _len3 = footprints.length; _l < _len3; _l++) {\n          key = footprints[_l];\n          options[options.length] = new Option(\"\" + idps[key].display_name, \"\" + key);\n        }\n      }\n      for (key in idps) {\n        value = idps[key];\n        options[options.length] = new Option(\"\" + value.display_name, \"\" + key);\n      }\n      this.classList.remove(\"hidden\");\n      break;\n    case AISNotifications.AUTHENTICATING:\n      this.classList.add(\"hidden\");\n  }\n};\n\n/**\n * The AISPlayMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction AISPlayMediator(parent) {\n  AISPlayMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISPlayMediator, ComponentMediator);\n\n\nAISPlayMediator.prototype.componentName = \"ais-play\";\n\nAISPlayMediator.prototype.menu = null;\n\nAISPlayMediator.prototype.restart = null;\n\nAISPlayMediator.prototype.resume = null;\n\nAISPlayMediator.prototype.resumeTime = null;\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISPlayMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.menu = this.create(\"ais-play-menu\");\n  this.restart = this.create(\"ais-play-restart\", this.menu);\n  this.restart.type = \"button\";\n  this.restart.textContent = \"Restart\";\n  this.restart.onclick = function(event) {\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    _this.play();\n    return false;\n  };\n  this.resume = this.create(\"ais-play-resume\", this.menu);\n  this.resume.type = \"button\";\n  this.resume.value = \"Resume\";\n  this.restart.onclick = function(event) {\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    _this.play(_this.resumeTime);\n    return false;\n  };\n};\n\nAISPlayMediator.prototype.play = function(time) {\n  var proxy;\n  proxy = this.facade.retrieveProxy(AISProxy.NAME);\n  proxy.play(time);\n};\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.CHOOSE_PLAY_OPTIONS];\n};\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case AISNotifications.CHOOSE_PLAY_OPTIONS:\n      this.resumeTime = notification.getBody();\n      this.classList.remove(\"hidden\");\n  }\n};\n\n/**\n * The AISAuthenticateMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISAuthorizeCommand() {\n  AISAuthorizeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizeCommand.prototype.execute = function(notification) {\n  if (this.proxy.isRestricted(this.media.getData())) {\n    this.proxy.authorize();\n  }\n};\n\n/**\n * The AISAuthenticationFailedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthenticationFailedCommand() {\n  AISAuthenticationFailedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthenticationFailedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthenticationFailedCommand.prototype.execute = function(notification) {\n  AISAuthenticationFailedCommand.__super__.execute.call(this, notification);\n  if (this.proxy.isPreviewAvailable()) {\n    this.proxy.preview();\n  } else {\n    this.proxy.choose();\n  }\n};\n\n/**\n * The AISAuthorizationFailedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthorizationFailedCommand() {\n  AISAuthorizationFailedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizationFailedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizationFailedCommand.prototype.execute = function(notification) {\n  AISAuthorizationFailedCommand.__super__.execute.call(this, notification);\n  if (this.proxy.isPreviewAvailable()) {\n    this.proxy.preview();\n  }\n};\n\n/**\n * The AISAuthorizationExpiredCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthorizationExpiredCommand() {\n  AISAuthorizationExpiredCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizationExpiredCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizationExpiredCommand.prototype.execute = function(notification) {\n  AISAuthorizationExpiredCommand.__super__.execute.call(this, notification);\n  this.sendNotification(Notifications.PAUSE);\n  this.proxy.authorize();\n};\n\n/**\n * The AISChangePlayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISChangePlayStateCommand() {\n  AISChangePlayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISChangePlayStateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISChangePlayStateCommand.prototype.execute = function(notification) {\n  var state;\n  state = notification.getBody().value;\n  if (state === PlayState.PLAYING) {\n    this.proxy.playing();\n  } else if (state === PlayState.PAUSED) {\n    this.proxy.pause();\n  }\n};\n\n/**\n * The AISAuthenticatingMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction AISAuthenticatingMediator(parent) {\n  AISAuthenticatingMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISAuthenticatingMediator, ComponentMediator);\n\n\nAISAuthenticatingMediator.prototype.componentName = \"ais-authenticating\";\n\nAISAuthenticatingMediator.prototype.retry = null;\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.onRegister = function() {\n  AISAuthenticatingMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.retry = this.create(\"ais-authenticating-button\");\n  this.retry.type = \"button\";\n  this.retry.value = \"Back to Providers\";\n  this.retry.onclick = this.onclick.bind(this);\n};\n\n/**\n*/\nAISAuthenticatingMediator.prototype.onclick = function(event) {\n  if (typeof event.stopImmediatePropagation === \"function\") {\n    event.stopImmediatePropagation();\n  }\n  this.classList.add(\"hidden\");\n  this.sendNotification(AISNotifications.START_AUTHENTICATION);\n  return false;\n};\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.AUTHENTICATING];\n};\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case AISNotifications.AUTHENTICATING:\n      if (notification.getBody() === true) {\n        this.classList.remove(\"hidden\");\n      } else {\n        this.classList.add(\"hidden\");\n      }\n  }\n};\n\n/**\n * The AISPlayMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction AISPreviewMediator(parent) {\n  AISPreviewMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISPreviewMediator, ComponentMediator);\n\n\nAISPreviewMediator.prototype.componentName = \"ais-preview\";\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISPreviewMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.info = this.create([\"flex-item\", \"ais-preview-info\"]);\n  this.info.textContent = this.localizationManager.getString(\"MSG_PREVIEW_INFO\");\n  this.spacer = this.create(\"spacer\");\n  this.label = this.create([\"flex-item\", \"ais-preview-label\"]);\n  this.label.textContent = this.localizationManager.getString(\"MSG_PREVIEW_EXPIRES\");\n  this.count = this.create([\"flex-item\", \"ais-preview-count\"]);\n  this.login = this.create([\"flex-item\", \"ais-preview-login\"], this, \"button\");\n  this.login.textContent = this.localizationManager.getString(\"MSG_SIGN_IN\");\n  this.login.onclick = function() {\n    _this.sendNotification(Notifications.PAUSE);\n    _this.facade.retrieveProxy(AISProxy.NAME).authorize(true);\n  };\n};\n\nAISPreviewMediator.prototype.displayTime = function(time, duration) {\n  this.count.textContent = Utils.formatTimecode(time, duration);\n};\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.START_AUTHENTICATION, AISNotifications.PREVIEW, AISNotifications.PREVIEW_TIME_REMAINING];\n};\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.handleNotification = function(notification) {\n  var data;\n  switch (notification.getName()) {\n    case AISNotifications.START_AUTHENTICATION:\n      this.classList.add(\"hidden\");\n      break;\n    case AISNotifications.PREVIEW:\n      this.classList.remove(\"hidden\");\n      break;\n    case AISNotifications.PREVIEW_TIME_REMAINING:\n      data = notification.getBody();\n      this.displayTime(data.time / 1000, data.duration / 1000);\n  }\n};\n\n/**\n * The AISStartAuthenticationCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISStartAuthenticationCommand() {\n  AISStartAuthenticationCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISStartAuthenticationCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISStartAuthenticationCommand.prototype.execute = function(notification) {\n  this.proxy.authenticate();\n  AISStartAuthenticationCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AISMediator() {\n  AISMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AISMediator, OverlayMediator);\n\n\nAISMediator.prototype.componentName = \"ais\";\n\nAISMediator.prototype.chooser = null;\n\nAISMediator.prototype.auth = null;\n\nAISMediator.prototype.play = null;\n\nAISMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  setTimeout(function() {\n    _this.chooser = new AISChooserMediator(_this);\n    _this.facade.registerMediator(_this.chooser);\n    _this.auth = new AISAuthenticatingMediator(_this);\n    _this.facade.registerMediator(_this.auth);\n    _this.play = new AISPlayMediator(_this);\n    _this.facade.registerMediator(_this.play);\n    _this.preview = new AISPreviewMediator(_this);\n    return _this.facade.registerMediator(_this.preview);\n  }, 20);\n};\n\nAISMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.START_AUTHENTICATION, AISNotifications.AUTHENTICATION_COMPLETE, AISNotifications.CHOOSE_PLAY_OPTIONS, AISNotifications.PREVIEW, Notifications.MEDIA_CHANGE];\n};\n\nAISMediator.prototype.handleNotification = function(notification) {\n  var name;\n  name = notification.getName();\n  switch (name) {\n    case AISNotifications.CHOOSE_PLAY_OPTIONS:\n    case AISNotifications.START_AUTHENTICATION:\n    case AISNotifications.PREVIEW:\n      this.classList.remove(\"hidden\");\n      if (name === AISNotifications.PREVIEW) {\n        this.classList.add(\"ais-free-preview\");\n      } else {\n        this.classList.remove(\"ais-free-preview\");\n      }\n      break;\n    case AISNotifications.AUTHENTICATION_COMPLETE:\n    case Notifications.MEDIA_CHANGE:\n      this.classList.add(\"hidden\");\n      this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n  }\n};\n\n/**\n * The AISPlugin class.\n *\n * @param {Module}  app\n *    The parent module of this plugin.\n *\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction AISPlugin() {\n  AISPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AISPlugin, Feature);\n\n\nAISPlugin.NAME = \"AISPlugin\";\n\nAISPlugin.prototype.moduleName = \"ais\";\n\nAISPlugin.prototype.featureName = \"auth\";\n\nAISPlugin.prototype.idps = null;\n\n/** @override\n*/\nAISPlugin.prototype.createController = function() {\n  AISPlugin.__super__.createController.call(this);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, AISAuthorizeCommand);\n  this.registerCommand(AISNotifications.LAUNCH_IDP_LOGIN, AISLaunchIDPLoginCommand);\n  this.registerCommand(AISNotifications.START_AUTHENTICATION, AISStartAuthenticationCommand);\n  this.registerCommand(SecurityNotifications.AUTHENTICATION_FAILED, AISAuthenticationFailedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, AISAuthorizationFailedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_EXPIRED, AISAuthorizationExpiredCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATED, PluginEventCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATING, PluginEventCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATION_COMPLETE, PluginEventCommand);\n  this.registerCommand(AISNotifications.CHOOSE_AUTH_PROVIDER, PluginEventCommand);\n  this.registerCommand(AISNotifications.CHOOSE_PLAY_OPTIONS, PluginEventCommand);\n  this.registerCommand(AISNotifications.PREVIEW, PluginEventCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, AISChangePlayStateCommand);\n};\n\n/** @override\n*/\nAISPlugin.prototype.createModel = function() {\n  this.proxy = new AISProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nAISPlugin.prototype.createView = function() {\n  this.registerMediator(new AISMediator());\n};\n\n/** @override\n*/\nAISPlugin.prototype.createNotificationEvent = function(notificationName, body, type) {\n  var event;\n  event = Module.prototype.createNotificationEvent.call(this, notificationName, body, type);\n  if (!(event != null)) {\n    return;\n  }\n  event.type = event.type.replace(new RegExp(\"^\" + (this.getModuleName())), \"\");\n  return event;\n};\n\n/** @override\n*/\nAISPlugin.prototype.listNotificationInterests = function() {\n  return AISPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, SecurityNotifications.AUTHORIZE, Notifications.PLAY_STATE_CHANGE]);\n};\n\n/**\n*/\nAISPlugin.prototype.listNotificationPublications = function() {\n  return AISPlugin.__super__.listNotificationPublications.call(this).concat([SecurityNotifications.AUTHORIZED, SecurityNotifications.AUTHENTICATION_FAILED, SecurityNotifications.AUTHORIZATION_FAILED, SecurityNotifications.AUTHORIZATION_EXPIRED, Notifications.INITIALIZED, Notifications.PLAY, Notifications.PAUSE, Notifications.SEEK, Notifications.WAITING]);\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.authorize = function(media) {\n  this.proxy.authorize(media);\n  return media;\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.identity = function(force) {\n  return this.proxy.identity(force);\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.logout = function() {\n  this.proxy.logout();\n};\n\n/**\n * @return {Array.<Object>} The list of IDPs.\n * @expose\n*/\nAISPlugin.prototype.getIdps = function() {\n  return this.idps;\n};\n\n\nAMP.registerPlugin(\"ais\", \"html\", AISPlugin);\n\n/**\n * The AISFlashPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AISFlashPlugin() {\n  AISFlashPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AISFlashPlugin, AISPlugin);\n\n\nAISFlashPlugin.NAME = \"AISFlashPlugin\";\n\nAISFlashPlugin.prototype.proxy = null;\n\nAISFlashPlugin.prototype.startTime = null;\n\n/**\n*/\nAISFlashPlugin.prototype.setData = function(data) {\n  var proxy;\n  proxy = this.retrieveProxy(AISProxy.NAME);\n  proxy.data.platformID = data.platformID;\n  proxy.data.resourceID = data.resourceID;\n  proxy.data.contentID = data.contentID;\n};\n\n/**\n*/\nAISFlashPlugin.prototype.authorize = function(media) {\n  this.retrieveProxy(AISProxy.NAME).authorize(media);\n};\n\n/**\n * The AISTimeUpdateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISTimeUpdateCommand() {\n  AISTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISTimeUpdateCommand.prototype.execute = function(notification) {\n  var currentTime;\n  currentTime = Math.floor(notification.getBody());\n  if (currentTime !== 0 && currentTime % 30 === 0 && currentTime !== this.proxy.currentTime) {\n    this.proxy.vcsSet(currentTime);\n  }\n  this.proxy.currentTime = currentTime;\n};\n\n/**\n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction AISWrapper(player, config) {\n  var dispatchEvent, key, value;\n  AISWrapper.__super__.constructor.call(this, player, config);\n  this.plugin = new AISFlashPlugin();\n  dispatchEvent = this.dispatcher.dispatchEvent.bind(this.dispatcher);\n  for (key in AISNotifications) {\n    value = AISNotifications[key];\n    this.plugin.addEventListener(value.replace(/^(ais)/, \"\"), dispatchEvent);\n  }\n  for (key in SecurityNotifications) {\n    value = SecurityNotifications[key];\n    this.plugin.addEventListener(value.replace(/^(auth)/, \"\"), dispatchEvent);\n  }\n  this.plugin.oninitialized = this.player.registerModule.bind(this.player, this.plugin);\n  this.plugin.initialize(config, this.player);\n}\n\n\n__extends(AISWrapper, PluginWrapper);\n\n\nAISWrapper.NAME = \"AISWrapper\";\n\nAISWrapper.prototype.plugin = null;\n\n/**\n*/\nAISWrapper.prototype.getFeatureName = function() {\n  return \"auth\";\n};\n\n/**\n*/\nAISWrapper.prototype.createXML = function(xml) {\n  var application, auth, element, prop, props, text, vendor, _i, _len;\n  application = xml.firstChild;\n  auth = xml.getElementsByTagName(\"authentication\");\n  if (!(auth != null) || auth.length === 0) {\n    auth = xml.createElement(\"authentication\");\n    application.appendChild(auth);\n  } else {\n    auth = auth[0];\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"ais\");\n  auth.appendChild(vendor);\n  props = [\n    {\n      value: this.config.platformID,\n      key: \"platformID\"\n    }, {\n      value: this.config.resourceID,\n      key: \"resourceID\"\n    }, {\n      value: this.config.contentID,\n      key: \"contentID\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (!(prop.value != null)) {\n      continue;\n    }\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", prop.key);\n    text = XMLUtils.createTextContent(xml, prop.value);\n    element.appendChild(text);\n    vendor.appendChild(element);\n  }\n  return xml;\n};\n\n/**\n*/\nAISWrapper.prototype.listNotificationInterests = function() {\n  return AISWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([SecurityNotifications.AUTHORIZE, FlashNotifications.TIME_UPDATE, FlashNotifications.ENDED, FlashNotifications.PAUSED, FlashNotifications.CAPABILITY_CHANGE, FlashNotifications.RESET]);\n};\n\n/**\n*/\nAISWrapper.prototype.handleNotification = function(notification) {\n  var body, mediaProxy, name;\n  AISWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case SecurityNotifications.AUTHORIZE:\n      this.plugin.startTime = null;\n      this.plugin.setData(body);\n      mediaProxy = this.player.retrieveProxy(MediaProxy.NAME);\n      if (!(mediaProxy.getSrc() != null)) {\n        mediaProxy.setSrc(body.media.src);\n      }\n      break;\n    case FlashNotifications.TIME_UPDATE:\n      this.plugin.sendNotification(Notifications.TIME_UPDATE, body);\n      break;\n    case FlashNotifications.ENDED:\n      this.plugin.sendNotification(Notifications.ENDED, body);\n      break;\n    case FlashNotifications.PAUSED:\n      this.plugin.sendNotification(Notifications.PAUSE, body);\n      break;\n    case FlashNotifications.RESET:\n      this.plugin.sendNotification(Notifications.MEDIA_CHANGE, body);\n      break;\n    case FlashNotifications.CAPABILITY_CHANGE:\n      if ((this.plugin.startTime != null) && body.type === \"canSeekChange\" && body.enabled) {\n        this.player.setCurrentTime(this.plugin.startTime);\n      }\n  }\n};\n\n/**\n * @expose\n*/\nAISWrapper.prototype.authorize = function(media) {\n  this.plugin.authorize(media);\n  return media;\n};\n\n/**\n * @expose\n*/\nAISWrapper.prototype.logout = function() {\n  this.plugin.logout();\n};\n\n/**\n * @return {Array.<Object>} The list of IDPs.\n * @expose\n*/\nAISWrapper.prototype.getIdps = function() {\n  return this.plugin.getIdps();\n};\n\n\nAMP.registerPlugin(\"ais\", \"flash\", AISWrapper);\n\n/**\n * The AISEndedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISEndedCommand() {\n  AISEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISEndedCommand.prototype.execute = function(notification) {\n  this.proxy.vcsSet(0);\n};\n\n/**\n * The IMAPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {AdPlugin}\n*/\nfunction IMAPlugin() {\n  IMAPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(IMAPlugin, AdPlugin);\n\n\nIMAPlugin.prototype.moduleName = \"ima\";\n\nIMAPlugin.prototype.createFullscreenProxy = function() {\n  return new IMAFullscreenProxy(this.config);\n};\n\nIMAPlugin.prototype.createProxy = function() {\n  return new IMAProxy(this.config);\n};\n\nIMAPlugin.prototype.isFullscreenDevice = function() {\n  var ua;\n  ua = navigator.userAgent;\n  return this.config.fullscreen === true || Utils.isFullscreenDevice() || /Android 4\\.[0-1]/.test(ua) || /CrKey/.test(ua);\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createModel = function() {\n  IMAPlugin.__super__.createModel.call(this);\n  if (this.config.overlay != null) {\n    this.registerProxy(new IMAOverlayProxy(this.config.overlay));\n  }\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createController = function() {\n  IMAPlugin.__super__.createController.call(this);\n  if (this.config.overlay != null) {\n    this.registerCommand(IMANotifications.ADD_OVERLAY, IMAAddOverlayCommand);\n    this.registerCommand(IMANotifications.REMOVE_OVERLAY, IMARemoveOverlayCommand);\n  }\n  this.registerCommand(Notifications.READY, IMAReadyCommand);\n  this.registerCommand(Notifications.FULL_SCREEN_CHANGE, IMADisplayStateChangeCommand);\n  this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, IMAActiveStateChangeCommand);\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createView = function() {\n  IMAPlugin.__super__.createView.call(this);\n  if (this.config.overlay != null) {\n    this.registerMediator(new IMAOverlayMediator());\n  }\n};\n\n\nAMP.registerPlugin(\"ima\", \"html\", IMAPlugin);\nAMP.registerPlugin(\"ima\", \"flash\", IMAWrapper);\n\n/**\n * The AdContentPausedCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentPausedCommand() {\n  AdContentPausedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentPausedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdContentPausedCommand.prototype.execute = function(notification) {\n  var fw;\n  fw = this.facade.retrieveProxy(AdProxy.NAME);\n  fw.contentPaused();\n};\n\n/**\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction AISProxy(config) {\n  AISProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AISProxy, PluginProxy);\n\n\n/** @static\n*/\nAISProxy.NAME = ModuleProxy.NAME;\n\nAISProxy.prototype.client = null;\n\nAISProxy.prototype.currentTime = null;\n\nAISProxy.prototype.idps = null;\n\nAISProxy.prototype.idp = null;\n\nAISProxy.prototype.token = null;\n\nAISProxy.prototype.authz = null;\n\nAISProxy.prototype.authenticated = null;\n\nAISProxy.prototype.defaults = {\n  platformID: null,\n  resourceID: null,\n  contentID: null,\n  responseTargets: null,\n  query: \"hdnts\",\n  vcs: false,\n  preview: null,\n  uri: \"urn:protected\",\n  logos: {\n    base: null,\n    group: null,\n    key: \"full\"\n  }\n};\n\n/** @override\n*/\nAISProxy.prototype.getScript = function() {\n  return this.value.plugin;\n};\n\n/**\n*/\nAISProxy.prototype.initialize = function() {\n  this.client = window.ais_client;\n  this.client.setLogging(this.facade.logger.enabled);\n  this.client.setPlatformId(this.value.platformID);\n  this.client.setUseCache(false);\n  this.client.assignhandler(\"bounce\", this.bounceHandler.bind(this));\n  this.client.assignhandler(\"chooser\", this.chooserHandler.bind(this));\n  this.client.assignhandler(\"init\", this.initHandler.bind(this));\n  this.client.assignhandler(\"authz_query\", this.authz_queryHandler.bind(this));\n  this.client.assignhandler(\"vcs\", this.vcsHandler.bind(this));\n  window.onunload = function() {};\n};\n\n/**\n*/\nAISProxy.prototype.isRestricted = function(media) {\n  var reason, restrictions, uri,\n    _this = this;\n  reason = media.status.reason;\n  if (reason === \"ais\" || reason === \"token\") {\n    return true;\n  }\n  restrictions = media.restriction.filter(function(restriction) {\n    return restriction.relationship === \"allow\" && restriction.type === \"uri\";\n  });\n  uri = this.value.uri;\n  return restrictions.some(function(restriction) {\n    return restriction.value.indexOf(uri) !== -1;\n  });\n};\n\n/**\n*/\nAISProxy.prototype.waiting = function(value) {\n  var _this = this;\n  setTimeout(function() {\n    _this.facade.player.appState.setWaiting(value);\n  }, 10);\n};\n\n/**\n*/\nAISProxy.prototype.authorize = function(force) {\n  if (force == null) {\n    force = false;\n  }\n  this.authz = null;\n  this.token = null;\n  if (force === true) {\n    this.value.preview = null;\n  }\n  this.disengage();\n  this.waiting(true);\n  this.sendNotification(AISNotifications.START_AUTHENTICATION);\n};\n\n/**\n*/\nAISProxy.prototype.credentials = function(token) {\n  var security;\n  security = this.facade.player.security;\n  security.setAuthorization({\n    key: this.value.query || this.getDefaults().query,\n    token: token\n  });\n  this.token = security.getSecret();\n};\n\n/**\n*/\nAISProxy.prototype.authorized = function(token) {\n  if (token == null) {\n    token = this.token;\n  }\n  this.engage();\n  this.waiting(false);\n  this.sendNotification(AISNotifications.AUTHENTICATION_COMPLETE);\n  this.sendNotification(SecurityNotifications.AUTHORIZED, token);\n};\n\n/**\n*/\nAISProxy.prototype.play = function(time) {\n  this.sendNotification(Notifications.INITIALIZED);\n  this.sendNotification(Notifications.PLAY);\n  if (time != null) {\n    return this.sendNotification(Notifications.SEEK, time);\n  }\n};\n\n/**\n*/\nAISProxy.prototype.engage = function() {\n  this.facade.registerCommand(Notifications.TIME_UPDATE, AISTimeUpdateCommand);\n  this.facade.registerCommand(Notifications.ENDED, AISEndedCommand);\n};\n\n/**\n*/\nAISProxy.prototype.disengage = function() {\n  this.facade.removeCommand(Notifications.TIME_UPDATE);\n  this.facade.removeCommand(Notifications.ENDED);\n};\n\n/**\n*/\nAISProxy.prototype.logout = function() {\n  var height, method, target, width, _ref;\n  this.authenticated = null;\n  method = ((_ref = this.idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n  target = this.getTarget(method);\n  this.setRedirect(method);\n  switch (method) {\n    case \"redirect\":\n      window.open(this.client.logoutFormat(target), \"_top\");\n      break;\n    case \"popup\":\n      width = this.idp.window_display.width || 320;\n      height = this.idp.window_display.height || 240;\n      window.open(this.client.logoutFormat(target), \"ais_popup\", \"width=\" + width + \",height=\" + height);\n  }\n};\n\n/**\n*/\nAISProxy.prototype.isPreviewAvailable = function() {\n  var _ref;\n  return ((_ref = this.value.preview) != null ? _ref.duration : void 0) != null;\n};\n\n/**\n*/\nAISProxy.prototype.preview = function(refreshIdToken) {\n  var count, delay, duration, expired, preflight, remaining, startTime, windowed,\n    _this = this;\n  if (refreshIdToken == null) {\n    refreshIdToken = false;\n  }\n  duration = this.value.preview.duration * 1000;\n  windowed = this.value.preview.type === \"window\";\n  count = \"AIS_preview___\" + this.value.platformID + \"__\" + this.value.resourceID;\n  delay = 100;\n  expired = \"PREVIEW EXPIRED\";\n  if (windowed === false) {\n    startTime = localStorage.getItem(count);\n    if (!(startTime != null)) {\n      startTime = 0;\n      localStorage.setItem(count, 0);\n    }\n    startTime = parseInt(startTime);\n    remaining = duration - startTime;\n  }\n  preflight = function() {\n    return new Promise(function(resolve, reject) {\n      if (windowed === false && remaining <= 0) {\n        reject(expired);\n      } else {\n        resolve();\n      }\n    });\n  };\n  return preflight().then(function() {\n    return _this.requestIdToken(refreshIdToken);\n  }).then(function(tokenId) {\n    return _this.requestCrossToken(tokenId);\n  }).then(function(preview) {\n    _this.credentials(preview.token);\n    _this.authorized(_this.token);\n    if (windowed === true) {\n      startTime = 0;\n      remaining = preview.expires - preview.issued;\n    }\n    if (remaining <= 0) {\n      throw expired;\n    }\n    _this.timer = new Timer(delay, Math.ceil(remaining / delay));\n    _this.timer.addEventListener(\"timer\", function(event) {\n      var currentTime, remainingTime;\n      currentTime = event.target.time;\n      remainingTime = remaining - currentTime;\n      if (windowed === false) {\n        localStorage.setItem(count, startTime + currentTime);\n      }\n      _this.sendNotification(AISNotifications.PREVIEW_TIME_REMAINING, {\n        time: remainingTime,\n        duration: duration\n      });\n      if (remainingTime <= 0) {\n        _this.timer.stop();\n        _this.sendNotification(SecurityNotifications.AUTHORIZATION_EXPIRED);\n      }\n    });\n    _this.sendNotification(AISNotifications.PREVIEW, preview);\n    _this.sendNotification(AISNotifications.PREVIEW_TIME_REMAINING, {\n      time: remaining,\n      duration: duration\n    });\n  })[\"catch\"](function(error) {\n    _this.facade.logger.error(error);\n    _this.authorize(true);\n  }).then(function() {\n    _this.waiting(false);\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestGuardToken = function() {\n  var path,\n    _this = this;\n  path = \"https://idp.securetve.com/rest/security/v2/platforms/\" + this.value.platformID + \"/tokens/guard\";\n  return Utils.requestJson(path).then(function(json) {\n    return json.guard_token;\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestIdToken = function(refreshIdToken) {\n  var paths, token, tokenKey,\n    _this = this;\n  tokenKey = \"AIS_preview___\" + this.value.platformID + \"__response_cache__identity_token\";\n  if (refreshIdToken === true) {\n    localStorage.removeItem(tokenKey);\n  } else {\n    token = localStorage.getItem(tokenKey);\n    if (token != null) {\n      return Promise.resolve(token);\n    }\n  }\n  paths = [\"https://idp.securetve.com/rest/authn/v2/platforms/\" + this.value.platformID + \"/init/fingerprint\", \"https://idp.securetve.com/rest/authn/v2/platforms/\" + this.value.platformID + \"/tokens/id\"];\n  return this.requestGuardToken().then(function(guard) {\n    return Utils.requestJson({\n      url: paths[0],\n      headers: {\n        \"Akamai-Token-Guard\": guard\n      }\n    }).then(function(km) {\n      return akamai.ais.createEncryptedFingerprint(km);\n    }).then(function(fingerprint) {\n      return Utils.requestJson({\n        url: paths[1],\n        headers: {\n          \"Akamai-Token-Guard\": guard,\n          \"Akamai-Authentication\": \"fingerprint/ob \" + fingerprint\n        }\n      });\n    }).then(function(json) {\n      if (json.failure_type != null) {\n        throw json.failure_type;\n      }\n      token = json.identity_token;\n      localStorage.setItem(tokenKey, token);\n      return token;\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestCrossToken = function(tokenId) {\n  var paths,\n    _this = this;\n  paths = [\"https://idp.securetve.com/rest/authz/v2/platforms/\" + this.value.platformID + \"/resources/\" + this.value.resourceID, \"https://idp.securetve.com/rest/authz/v2/platforms/\" + this.value.platformID + \"/tokens/crossover\"];\n  return Utils.requestJson({\n    url: paths[0],\n    headers: {\n      \"Akamai-Token-Id\": tokenId\n    }\n  }).then(function(json) {\n    var error;\n    error = json.failure_type;\n    if (!(error != null)) {\n      return json;\n    }\n    switch (error) {\n      case \"INVALID_ID_TOKEN\":\n        return _this.preview(true);\n      case \"GRANTS_WINDOW_EXPIRED\":\n        return _this.requestGuardToken().then(function(guard) {\n          return Utils.requestJson({\n            url: paths[0],\n            method: \"POST\",\n            headers: {\n              \"Akamai-Token-Guard\": guard,\n              \"Akamai-Token-Id\": tokenId\n            },\n            body: '{\"action\":\"grant_extension\",\"attributes\":{\"duration\":' + _this.value.preview.duration + '}}'\n          });\n        });\n      default:\n        throw JSON.stringify(json, null, \"  \");\n    }\n  }).then(function(json) {\n    var jwt, preview;\n    if (json.failure_type != null) {\n      throw json.failure_type;\n    }\n    jwt = Utils.parseJWT(json.access_token).payload.grants[_this.value.resourceID];\n    preview = {\n      issued: jwt.issued * 1000,\n      expires: jwt.expires * 1000,\n      duration: _this.value.preview.duration\n    };\n    return Utils.requestJson({\n      url: paths[1],\n      headers: {\n        \"Akamai-Token-Access\": json.access_token\n      }\n    }).then(function(json) {\n      preview.token = json.crossover_token;\n      return preview;\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.playing = function() {\n  if (!(this.timer != null) || !(this.value.preview != null) || this.value.preview.type === \"window\") {\n    return;\n  }\n  this.timer.start();\n};\n\n/**\n*/\nAISProxy.prototype.pause = function() {\n  if (!(this.timer != null) || !(this.value.preview != null) || this.value.preview.type === \"window\") {\n    return;\n  }\n  this.timer.stop();\n};\n\n/**\n*/\nAISProxy.prototype.authenticate = function() {\n  if (this.authenticated === null) {\n    this.bounce();\n  } else if (this.authenticated === false) {\n    this.choose();\n  }\n};\n\n/**\n*/\nAISProxy.prototype.bounce = function(resource) {\n  this.client.bounce();\n};\n\n/**\n*/\nAISProxy.prototype.init = function(resource) {\n  this.client.init();\n};\n\n/**\n*/\nAISProxy.prototype.identity = function(force) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    _this.client.identity(force);\n    return _this.client.assignhandler(\"identity\", function(type, resp) {\n      var data;\n      data = resp.identity;\n      resolve(data);\n      return _this.facade.dispatchEvent(new Event(type, data));\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.choose = function() {\n  this.timer = null;\n  this.client.chooser();\n};\n\n/**\n*/\nAISProxy.prototype.resourceAccess = function(resource) {\n  if (resource == null) {\n    resource = this.value.resourceID;\n  }\n  this.client.resourceAccess(resource);\n};\n\n/**\n*/\nAISProxy.prototype.vcsSet = function(time) {\n  time = Utils.formatTimecode(time);\n  this.client.vcsSet(this.value.contentID, time);\n};\n\n/**\n*/\nAISProxy.prototype.bounceHandler = function(type, resp) {\n  this.authenticated = resp.authenticated.toString() === \"true\";\n  if (this.authenticated === false) {\n    this.sendNotification(SecurityNotifications.AUTHENTICATION_FAILED);\n  } else if (this.authenticated === true) {\n    this.init();\n  }\n};\n\n/**\n*/\nAISProxy.prototype.initHandler = function(type, resp) {\n  var key, key2, value, value2, _ref;\n  this.idp = resp.idps;\n  this.facade.idps = {};\n  _ref = resp.idps;\n  for (key in _ref) {\n    value = _ref[key];\n    this.facade.idps.key = key;\n    for (key2 in value) {\n      value2 = value[key2];\n      this.facade.idps[key2] = value2;\n    }\n    break;\n  }\n  for (key in resp) {\n    value = resp[key];\n    if (key !== \"idps\" && (value != null)) {\n      this.facade[key] = value;\n    }\n  }\n  if ((this.value.logos != null) && (this.facade.idps.logos != null)) {\n    this.facade.idps.logo = this.value.logos.base + this.facade.idps.logos[this.value.logos.key];\n  }\n  this.client.assignhandler('logout_result', this.logoutHandler.bind(this));\n  this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n  this.sendNotification(AISNotifications.AUTHENTICATED, this.facade.idps);\n  this.resourceAccess(this.value.resourceID);\n};\n\n/**\n*/\nAISProxy.prototype.chooserHandler = function(type, resp) {\n  this.waiting(false);\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"authenticating\");\n  resp.possible_idps = this.idps = this.sort(resp.possible_idps, \"value\", \"display_name\");\n  this.sendNotification(AISNotifications.CHOOSE_AUTH_PROVIDER, resp);\n};\n\nAISProxy.prototype.launchIDPLogin = function(idp_platform_id) {\n  var height, idp, method, target, width, _ref;\n  this.sendNotification(AISNotifications.AUTHENTICATING, true);\n  idp = this.idps[idp_platform_id];\n  method = ((_ref = idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n  target = this.getTarget(method);\n  this.setRedirect(method);\n  switch (method) {\n    case \"redirect\":\n      window.open(this.client.loginFormat(idp_platform_id, target), \"_top\");\n      break;\n    case \"popup\":\n      method = idp.window_display.method || \"popup\";\n      width = idp.window_display.width || 320;\n      height = idp.window_display.height || 240;\n      window.open(this.client.loginFormat(idp_platform_id, target), \"ais_popup\", \"width=\" + width + \",height=\" + height);\n  }\n};\n\n/**\n*/\n/**\n*/\nAISProxy.prototype.authz_queryHandler = function(type, resp) {\n  var auth, dimensions, resource;\n  auth = resp.authorization.toString() === \"true\";\n  if (auth === false) {\n    this.sendNotification(SecurityNotifications.AUTHORIZATION_FAILED, resp);\n  } else if (auth === true) {\n    this.authz = resp;\n    dimensions = {\n      mvpdName: this.facade.idps.name,\n      viewerId: this.client.aisuid,\n      \"std:viewerId\": this.client.aisuid\n    };\n    this.facade.player.setParams({\n      \"mvpdname\": dimensions.mvpdName\n    });\n    this.facade.player.sendNotification(MediaAnalyticsNotifications.SET_DIMENSIONS, dimensions);\n    this.facade.viewerId = this.client.aisuid;\n    resource = resp.resource;\n    if (resource != null) {\n      this.facade.resource = resource;\n    }\n    this.credentials(resp.security_token);\n    this.sendNotification(AISNotifications.AUTHENTICATING, false);\n    if (this.value.vcs === true && (this.value.contentID != null)) {\n      this.client.vcsGet(this.value.contentID);\n    } else {\n      this.authorized(this.token);\n    }\n  }\n};\n\n/**\n*/\nAISProxy.prototype.logoutHandler = function(type, resp) {\n  top.location.href = top.location.href;\n};\n\n/**\n*/\nAISProxy.prototype.vcsHandler = function(type, resp) {\n  var pos;\n  if (resp.operation === \"get\") {\n    pos = resp.ph_pos;\n    if (pos === \"00:00:00\" || pos === \"00:00\") {\n      this.client.vcsSet(this.value.contentID, pos);\n      this.authorized(this.token);\n    } else {\n      this.sendNotification(AISNotifications.CHOOSE_PLAY_OPTIONS, Utils.flattenTimecode(pos));\n    }\n  }\n};\n\n/**\n*/\nAISProxy.prototype.sort = function(obj, sortType, valueName) {\n  var data, index, item, key, returnObj, value, _i, _len;\n  returnObj = {};\n  data = [];\n  index = 0;\n  for (key in obj) {\n    value = obj[key];\n    data[index] = {\n      key: key,\n      value: value[valueName]\n    };\n    index++;\n  }\n  data.sort(function(a, b) {\n    var valueA, valueB, _ref, _ref1, _ref2, _ref3;\n    valueA = sortType === \"value\" ? (_ref = a.value) != null ? _ref.toLowerCase() : void 0 : (_ref1 = a.key) != null ? _ref1.toLowercase() : void 0;\n    valueB = sortType === \"value\" ? (_ref2 = b.value) != null ? _ref2.toLowerCase() : void 0 : (_ref3 = b.key) != null ? _ref3.toLowercase() : void 0;\n    if (valueA < valueB) {\n      return -1;\n    } else if (valueA > valueB) {\n      return 1;\n    } else {\n      return 0;\n    }\n  });\n  for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {\n    item = data[index];\n    returnObj[item.key] = obj[item.key];\n  }\n  return returnObj;\n};\n\n/**\n*/\nAISProxy.prototype.setRedirect = function(method) {\n  var devToken, domain, loc;\n  try {\n    devToken = /\\/dev\\./;\n    loc = window.top.location.href || window.top.location;\n    domain = devToken.test(loc) ? loc.replace(devToken, \"/\") : null;\n    Cookies.setCookie(this.getTarget(method), loc, 1, \"/\", domain);\n  } catch (error) {\n\n  }\n};\n\n/**\n*/\nAISProxy.prototype.getTarget = function(method) {\n  if (method == null) {\n    method = \"redirect\";\n  }\n  return this.value.responseTargets[method];\n};\n\nfunction FreeWheelWrapper() {\n  return FreeWheelWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(FreeWheelWrapper, AdWrapper);\n\n\nFreeWheelWrapper.NAME = \"FreeWheelWrapper\";\n\nFreeWheelWrapper.prototype.partner = \"freewheel\";\n\nFreeWheelWrapper.prototype.flashPlugins = [\n  {\n    id: \"FreewheelPlugin\",\n    src: '#{paths.resources}plugins/FreewheelPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"FreewheelPlugin\"\n  }, {\n    id: \"AdOptionsPlugin\",\n    src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdOptionsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nFreeWheelWrapper.prototype.createXML = function(xml) {\n  var admedia, application, key, keyValue, prop, props, value, vendor, _i, _len, _ref;\n  application = xml.firstChild;\n  admedia = xml.getElementsByTagName(\"admedia\")[0];\n  if (!(admedia != null)) {\n    admedia = xml.createElement(\"admedia\");\n    application.appendChild(admedia);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"freewheel\");\n  admedia.appendChild(vendor);\n  props = [\n    {\n      value: this.config.plugin.swf,\n      key: \"FREEWHEEL_AD_MANAGER_URL\"\n    }, {\n      value: this.config.serverUrl,\n      key: \"FREEWHEEL_SERVER_URL\"\n    }, {\n      value: this.config.networkId,\n      key: \"FREEWHEEL_NETWORK_ID\"\n    }, {\n      value: this.config.profileId,\n      key: \"FREEWHEEL_PROFILE\"\n    }, {\n      value: this.config.siteSectionId,\n      key: \"FREEWHEEL_SITE_SECTION_ID\"\n    }, {\n      value: this.config.siteSectionFallbackId,\n      key: \"FREEWHEEL_SITE_SECTION_FALLBACK_ID\"\n    }, {\n      value: this.config.prerollSlotId,\n      key: \"FREEWHEEL_PREROLL_SLOT_ID\"\n    }, {\n      value: this.config.midrollSlotId,\n      key: \"FREEWHEEL_MIDROLL_SLOT_ID\"\n    }, {\n      value: this.config.postrollSlotId,\n      key: \"FREEWHEEL_POSTROLL_SLOT_ID\"\n    }, {\n      value: this.config.videoAssetId,\n      key: \"FREEWHEEL_VIDEO_ASSET_ID\"\n    }, {\n      value: this.config.videoAssetFallbackId,\n      key: \"FREEWHEEL_VIDEO_ASSET_FALLBACK_ID\"\n    }, {\n      value: this.config.videoAssetVideoPlayRandom,\n      key: \"FREEWHEEL_VIDEO_ASSET_VIDEO_PLAY_RANDOM\"\n    }, {\n      value: this.config.visitorId,\n      key: \"FREEWHEEL_VISITOR_ID\"\n    }, {\n      value: this.config.keyValuesString,\n      key: \"FREEWHEEL_KEY_VALUES_STRING\"\n    }, {\n      value: this.config,\n      key: \"FREEWHEEL_SITE_SECTION_PAGE_VIEW_RANDOM\"\n    }, {\n      value: \"EXACT\",\n      key: \"FREEWHEEL_VIDEO_ASSET_DURATION_TYPE\"\n    }, {\n      value: this.config.visitorHeader,\n      key: \"FREEWHEEL_VISITOR_HTTP_HEADER_KEY_VALUE\"\n    }, {\n      value: this.config.synchronizeMultipleRequests,\n      key: \"FREEWHEEL_SYNCHRONIZE_MULTIPLE_REQUESTS\"\n    }, {\n      value: this.config.subsessionToken,\n      key: \"FREEWHEEL_SUBSESSION_TOKEN\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  if (this.config.position != null) {\n    vendor.setAttribute(\"position\", this.config.position);\n  }\n  if (this.config.keyValues != null) {\n    keyValue = xml.createElement(\"property\");\n    keyValue.setAttribute(\"key\", \"FREEWHEEL_KEY_VALUE\");\n    _ref = this.config.keyValues;\n    for (key in _ref) {\n      value = _ref[key];\n      if (value != null) {\n        this.createProperty(xml, key, value, keyValue);\n      }\n    }\n    vendor.appendChild(keyValue);\n  }\n};\n\nvar isOverlayDisplayed;\n\n\n\n\n\n/**\n * @constructor\n * @private\n*/\nfunction FreeWheelProxy(config) {\n  this.media = {};\n  this.handlers = {\n    onRequestComplete: this.onRequestComplete.bind(this),\n    onSlotStarted: this.onSlotStarted.bind(this),\n    onSlotEnded: this.onSlotEnded.bind(this),\n    onAdImpression: this.onAdImpression.bind(this),\n    onAdImpressionEnd: this.onAdImpressionEnd.bind(this),\n    onAdClick: this.onAdClick.bind(this),\n    onResume: this.onResume.bind(this),\n    adtimeupdate: this.adTimeupdate.bind(this),\n    timeupdate: this.midrollCheck.bind(this),\n    overlaytimeupdate: this.overlayCheck.bind(this),\n    seekupdate: this.seekingHandler.bind(this),\n    onAdEvent: this.onAdEvent.bind(this)\n  };\n  FreeWheelProxy.__super__.constructor.call(this, config);\n  this.adVO = this.createDefaultAdVO();\n}\n\n\n__extends(FreeWheelProxy, AdProxy);\n\n\n/** @static\n*/\nFreeWheelProxy.NAME = AdProxy.NAME;\n\nFreeWheelProxy.prototype.partner = \"freewheel\";\n\nFreeWheelProxy.prototype.context = null;\n\nFreeWheelProxy.prototype.prerollSlots = null;\n\nFreeWheelProxy.prototype.midrollSlots = null;\n\nFreeWheelProxy.prototype.postrollSlots = null;\n\nFreeWheelProxy.prototype.initialized = false;\n\nFreeWheelProxy.prototype.playWhenLoaded = false;\n\nFreeWheelProxy.prototype.handlers = null;\n\nFreeWheelProxy.prototype.slot = null;\n\nFreeWheelProxy.prototype.playbackCore = null;\n\nFreeWheelProxy.prototype.nextMidroll = null;\n\nFreeWheelProxy.prototype.midrollEngaged = false;\n\nFreeWheelProxy.prototype.overlayEngaged = false;\n\nFreeWheelProxy.prototype.timeout = null;\n\nFreeWheelProxy.prototype.curTime = 0;\n\nFreeWheelProxy.prototype.mediator = null;\n\nFreeWheelProxy.prototype.adPosition = 1;\n\nFreeWheelProxy.prototype.currentAd = null;\n\nisOverlayDisplayed = false;\n\nFreeWheelProxy.prototype.defaults = {\n  networkId: \"96749\",\n  serverUrl: \"http://demo.v.fwmrm.net/ad/g/1\",\n  profileId: \"global-js\",\n  siteSectionId: \"DemoSiteGroup.01\",\n  siteSectionFallbackId: null,\n  siteSectionPageViewRandom: null,\n  videoAssetId: '#{media.guid}',\n  videoAssetFallbackId: null,\n  videoAssetVideoPlayRandom: null,\n  prerollSlotId: null,\n  midrollSlotId: null,\n  postrollSlotId: null,\n  visitorId: null,\n  keyValues: null,\n  keyValuesString: null,\n  renderers: null,\n  synchronizeMultipleRequests: null,\n  subsessionToken: null,\n  creativeParameters: null,\n  parameters: null\n};\n\n/**\n*/\nFreeWheelProxy.prototype.initialize = function() {\n  var debug, level;\n  debug = this.getDebug();\n  switch (true) {\n    case debug === true:\n      level = tv.freewheel.SDK.LOG_LEVEL_INFO;\n      break;\n    case typeof debug === \"number\":\n      level = debug;\n      break;\n    default:\n      level = tv.freewheel.SDK.LOG_LEVEL_QUIET;\n  }\n  tv.freewheel.SDK.setLogLevel(level);\n  this.plugin = this.createPlugin();\n  this.plugin.setNetwork(this.value.networkId);\n  this.plugin.setServer(this.value.serverUrl);\n};\n\nFreeWheelProxy.prototype.createPlugin = function() {\n  return new tv.freewheel.SDK.AdManager();\n};\n\n/**\n*/\nFreeWheelProxy.prototype.engage = function(media) {\n  this.terminateAd(true);\n  this.media = media;\n  FreeWheelProxy.__super__.engage.call(this, media);\n  this.requestAd();\n};\n\n/**\n*/\nFreeWheelProxy.prototype.requestAd = function() {\n  var cues, index, key, keyValue, mediaElement, pair, pairs, parameter, renderer, renderers, scene, time, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2, _ref3,\n    _this = this;\n  this.terminateAllAds(true);\n  this.context = this.plugin.newContext();\n  if (this.value.synchronizeMultipleRequests != null) {\n    this.context.setCapability(\"sync\", this.value.synchronizeMultipleRequests ? tv.freewheel.SDK.CAPABILITY_STATUS_ON : tv.freewheel.SDK.CAPABILITY_STATUS_OFF);\n  }\n  this.context.registerVideoDisplayBase(this.facade.player.viewComponent.id);\n  mediaElement = this.getMediaElement();\n  if (mediaElement.nodeName.toLowerCase() !== \"video\") {\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.facade.player.mediator);\n    this.mediator = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore().mediator;\n  }\n  this.context.setContentVideoElement(this.getMediaElement());\n  this.context.setProfile(this.value.profileId);\n  this.context.setVideoAsset(this.value.videoAssetId, this.media.duration, this.value.networkId, null, null, this.value.videoAssetVideoPlayRandom, null, this.value.videoAssetFallbackId);\n  this.context.setSiteSection(this.value.siteSectionId, this.value.networkId, this.value.siteSectionPageViewRandom, null, this.value.siteSectionFallbackId);\n  if (this.value.subsessionToken != null) {\n    this.context.startSubsession(this.value.subsessionToken);\n  }\n  if (this.value.visitorId != null) {\n    this.context.setVisitor(this.value.visitorId);\n  }\n  if (this.value.keyValues != null) {\n    _ref = this.value.keyValues;\n    for (key in _ref) {\n      value = _ref[key];\n      if (value != null) {\n        this.context.addKeyValue(key, value);\n      }\n    }\n  }\n  if (this.value.keyValuesString != null) {\n    pairs = this.value.keyValuesString.split(\"&\");\n    for (_i = 0, _len = pairs.length; _i < _len; _i++) {\n      pair = pairs[_i];\n      if (!(pair !== \"\")) {\n        continue;\n      }\n      keyValue = pair.split(\"=\");\n      this.context.addKeyValue(keyValue[0], keyValue[1]);\n    }\n  }\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_CLICK, this.handlers.onAdClick);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD, this.handlers.onAdEvent);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_ERROR, this.handlers.onAdEvent);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_DISPLAY_CONTROLS_WHEN_PAUSE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  if (this.value.parameters != null) {\n    _ref1 = this.value.parameters;\n    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n      parameter = _ref1[_j];\n      this.context.setParameter(parameter.key, parameter.value, parameter.level || tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    }\n  }\n  if (this.value.prerollSlotId != null) {\n    this.context.addTemporalSlot(this.value.prerollSlotId, tv.freewheel.SDK.ADUNIT_PREROLL, 0);\n  }\n  if (((_ref2 = this.media.scenes) != null ? _ref2.length : void 0) > 0 && (this.value.midrollSlotId != null)) {\n    cues = [];\n    _ref3 = this.media.scenes;\n    for (index = _k = 0, _len2 = _ref3.length; _k < _len2; index = ++_k) {\n      scene = _ref3[index];\n      if (!(index > 0)) {\n        continue;\n      }\n      time = Utils.flattenTimecode(scene.sceneStartTime);\n      cues.push(time);\n      this.context.addTemporalSlot(this.value.midrollSlotId, tv.freewheel.SDK.ADUNIT_MIDROLL, time);\n    }\n    this.setCues(cues);\n  }\n  if (this.value.postrollSlotId != null) {\n    this.context.addTemporalSlot(this.value.postrollSlotId, tv.freewheel.SDK.ADUNIT_POSTROLL, this.media.duration);\n  }\n  renderers = this.value.renderers;\n  if ((renderers != null ? renderers.length : void 0) > 0) {\n    for (_l = 0, _len3 = renderers.length; _l < _len3; _l++) {\n      renderer = renderers[_l];\n      this.context.addRenderer(renderer.url, renderer.baseUnit, renderer.contentType, renderer.slotType, renderer.soAdUnit, renderer.creativeApi, renderer.parameters);\n    }\n  }\n  this.initialized = false;\n  FreeWheelProxy.__super__.requestAd.call(this);\n  this.processAdRequest(AdRequest.create(this.context, \"freewheel\", this.getData())).then(function(result) {\n    _this.context = result.request;\n    _this.context.submitRequest();\n    try {\n      return _this.facade.player.ui.ads.container.style.pointerEvents = \"none\";\n    } catch (error) {\n\n    }\n  });\n};\n\n/**\n*/\nFreeWheelProxy.prototype.reset = function() {\n  FreeWheelProxy.__super__.reset.call(this);\n  if (this.mediator != null) {\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n    this.mediator = null;\n  }\n  this.facade.registerCommand(Notifications.PAUSED, AdContentPausedCommand);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onRequestComplete = function(event) {\n  var createAdBreakVO, cues, pod, podPosition, slot, slots, _i, _j, _len, _len1, _ref,\n    _this = this;\n  cues = [];\n  this.pods = [];\n  createAdBreakVO = function(slot) {\n    return new AdVO(slot.getCustomId(), slot.getCustomId(), slot.getTotalDuration(), 0, slot.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, slot, slot.getAdCount(), slot.getTimePosition());\n  };\n  if (event.success) {\n    slots = this.context.getTemporalSlots();\n    for (_i = 0, _len = slots.length; _i < _len; _i++) {\n      slot = slots[_i];\n      switch (slot.getTimePositionClass()) {\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n          if (this.value.prerollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            this.prerollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n          if (this.value.midrollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            cues.push(slot.getTimePosition());\n            this.midrollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n          if (this.value.postrollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            this.postrollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:\n          this.pods.push(createAdBreakVO(slot));\n          this.overlaySlotsArray.push(slot);\n      }\n    }\n  }\n  if (cues.length > 0) {\n    this.setCues(cues);\n  }\n  if (this.postrollSlots.length > 0) {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n  }\n  this.initialized = true;\n  this.pods.sort(function(a, b) {\n    return a.time - b.time;\n  });\n  podPosition = -1;\n  _ref = this.pods;\n  for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n    pod = _ref[_j];\n    pod.position = pod.type !== \"overlay\" ? ++podPosition : podPosition;\n  }\n  this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n    pods: this.pods\n  });\n  this.sendNotification(AdNotifications.RESPONSE, {\n    pods: this.pods,\n    response: event,\n    context: this.context\n  });\n  if (this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.breakStart = function() {\n  var video, _ref;\n  if (((_ref = this.adVO) != null ? _ref.type : void 0) !== \"overlay\") {\n    this.disengageOverlayCheck();\n  }\n  FreeWheelProxy.__super__.breakStart.call(this);\n  this.adPosition = 1;\n  this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  this.playbackCore.setEnabled(false);\n  this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n  video = this.getMediaElement();\n  video.addEventListener(\"playing\", this.playbackCore.handlers.playing);\n  video.addEventListener(\"pause\", this.playbackCore.handlers.pause);\n  video.addEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n  video.addEventListener(\"seeking\", this.handlers.seekupdate);\n  this.timeout = setInterval(function() {\n    return this.curTime = video.currentTime;\n  }, 500);\n  if (this.adVO.type === \"midroll\") {\n    this.contentPause();\n  }\n  if (this.facade.player.playbackRate !== 1) {\n    this.playbackRate = this.facade.player.playbackRate;\n    this.facade.player.playbackRate = 1;\n  }\n};\n\n/** Prevent seeking during pre-roll\n*/\nFreeWheelProxy.prototype.seekingHandler = function(event) {\n  if (event.target.currentTime > this.curTime) {\n    event.target.currentTime = this.curTime;\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdImpression = function(event) {\n  var adType, ctrlBrHi, curBtm, metadata, qryString, rendition, _base, _ref, _ref1, _ref2;\n  adType = (_ref = event.adInstance) != null ? typeof _ref.getSlot === \"function\" ? typeof (_base = _ref.getSlot()).getTimePositionClass === \"function\" ? _base.getTimePositionClass() : void 0 : void 0 : void 0;\n  try {\n    if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n      qryString = '[id^=\"_fw_ad_container_iframe_' + this.slot.getCustomId();\n      curBtm = document.getElementById(document.querySelector(qryString).id).style.bottom;\n      ctrlBrHi = window.getComputedStyle(document.getElementsByClassName(\"akamai-control-bar\")[0]).height;\n      if (parseInt(curBtm, 10) < parseInt(ctrlBrHi, 10)) {\n        document.getElementById(document.querySelector(qryString).id).style.bottom = ctrlBrHi;\n      }\n    }\n  } catch (_error) {}\n  if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY || adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    return;\n  }\n  this.currentAd = event.adInstance;\n  this.adVO.position = this.adPosition++;\n  this.adVO.id = this.currentAd.getAdId();\n  if ((this.slot != null) === !null) {\n    metadata = {\n      adtype: this.slot.getType()\n    };\n    this.updateAdMetadata(this.slot, metadata);\n    this.adVO.metadata = metadata;\n  }\n  rendition = (_ref1 = this.currentAd) != null ? _ref1.getActiveCreativeRendition() : void 0;\n  if (rendition != null) {\n    this.adVO.duration = rendition.getDuration();\n    this.adVO.metadata.adwidth = rendition.getWidth();\n    this.adVO.metadata.adheight = rendition.getHeight();\n  } else {\n    this.adVO.duration = (_ref2 = event.adInstance) != null ? _ref2.getDuration() : void 0;\n  }\n  this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n  this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdEvent = function(event) {\n  switch (event.subType) {\n    case tv.freewheel.SDK.EVENT_AD_FIRST_QUARTILE:\n      this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_MIDPOINT:\n      this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_THIRD_QUARTILE:\n      this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_COMPLETE:\n      this.sendNotification(AdNotifications.COMPLETE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_AUTO_PLAY_BLOCKED:\n      this.sendNotification(Notifications.AUTOPLAY_BLOCKED);\n      break;\n    case tv.freewheel.SDK.EVENT_ERROR:\n      this.adVO.error = {};\n      this.adVO.error.errorcode = event.errorCode;\n      this.adVO.error.errorinfo = event.errorInfo;\n      this.adVO.error.errormodule = event.errorModule;\n      this.facade.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"error\", this.adVO));\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdImpressionEnd = function(event) {\n  this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdClick = function(event) {\n  var paused;\n  paused = this.getMediaElement().paused;\n  if (paused === false) {\n    this.pause();\n  }\n  this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onResume = function(event) {\n  this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);\n  this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.adTimeupdate = function(event) {\n  var rendition, time;\n  try {\n    if (this.slot != null) {\n      this.currentAd = this.slot.getCurrentAdInstance();\n      if (this.currentAd != null) {\n        rendition = this.currentAd.getActiveCreativeRendition();\n        if (rendition != null) {\n          this.adVO.duration = rendition.getDuration();\n        } else {\n          this.adVO.duration = this.currentAd.getDuration();\n        }\n        time = this.adVO.duration - this.currentAd.getPlayheadTime();\n        this.adVO.time = time;\n        this.sendNotification(AdNotifications.AD_TIME_UPDATE, this.currentAd.getPlayheadTime());\n        this.sendNotification(AdNotifications.AD_TIME_REMAINING, time);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP FREEWHEEL ERROR]\", error);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onSlotStarted = function(event) {\n  var prevSlot, prevSlotType, slot;\n  prevSlot = this.slot;\n  slot = event.slot;\n  if (slot.getType() !== \"temporal\") {\n    return;\n  }\n  if (prevSlot) {\n    prevSlotType = typeof prevSlot.getTimePositionClass === \"function\" ? prevSlot.getTimePositionClass() : void 0;\n    if ((prevSlotType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) && this.isOverlayDisplayed) {\n      if (typeof prevSlot.stop === \"function\") {\n        prevSlot.stop();\n      }\n    }\n  }\n  this.slot = slot;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onSlotEnded = function(event) {\n  var complete, index, midroll, overlay, pod, slot, slotTimePositionClass;\n  slot = event.slot;\n  complete = event.skipped === true ? this.sendNotification.bind(this, AdNotifications.BREAK_SKIPPED, slot) : this.endBreak.bind(this);\n  if (slot.getType() !== \"temporal\") {\n    return;\n  }\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n  slotTimePositionClass = slot.getTimePositionClass();\n  pod = this.getPodById(slot.getCustomId());\n  pod.locked = true;\n  this.slot = null;\n  switch (slotTimePositionClass) {\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n      if (this.prerollSlots.length) {\n        this.prerollSlots.shift();\n        if (this.prerollSlots.length) {\n          this.playAd(this.prerollSlots[0]);\n        } else {\n          complete();\n        }\n      }\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n      index = this.midrollSlots.indexOf(this.nextMidroll);\n      if (index > -1) {\n        midroll = this.midrollSlots.splice(index, 1);\n      }\n      this.nextMidroll = null;\n      complete();\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:\n      this.isOverlayDisplayed = false;\n      index = this.overlaySlotsArray.indexOf(this.nextOverlay);\n      if (index > -1) {\n        overlay = this.overlaySlotsArray.splice(index, 1);\n      }\n      this.nextOverlay = null;\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n      if (this.postrollSlots.length) {\n        this.postrollSlots.shift();\n        if (this.postrollSlots.length) {\n          this.playAd(this.postrollSlots[0]);\n        } else {\n          complete();\n        }\n      }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.playAd = function(ad) {\n  var activeCreativeRendition, adId, adInstance, adType, metadata, pod, _ref;\n  pod = this.getPodById(ad.getCustomId());\n  if ((pod != null ? pod.locked : void 0) === true) {\n    this.onSlotEnded({\n      slot: pod.metadata,\n      skipped: true\n    });\n    return;\n  }\n  metadata = {\n    adtype: ad.getType()\n  };\n  adInstance = ad != null ? (_ref = ad.getAdInstances()) != null ? _ref[0] : void 0 : void 0;\n  if (adInstance != null) {\n    adId = adInstance.getAdId();\n    metadata.adunit = adInstance.getSoAdUnit();\n    activeCreativeRendition = adInstance.getActiveCreativeRendition();\n    if (activeCreativeRendition != null) {\n      this.updateAdMetadata(ad, metadata);\n    }\n  }\n  if (!(adId != null)) {\n    adId = ad.getCustomId();\n  }\n  this.adVO = new AdVO(adId, ad.getCustomId(), (activeCreativeRendition != null ? activeCreativeRendition.getDuration() : adInstance != null ? adInstance.getDuration() : void 0), this.adPosition, ad.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, metadata, ad.getAdCount());\n  this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n  this.sendNotification(AdNotifications.AD_DURATION_CHANGE, this.adVO);\n  adType = typeof ad.getTimePositionClass === \"function\" ? ad.getTimePositionClass() : void 0;\n  if (adType !== tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n    this.getMediaElement().load();\n  }\n  if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    this.isOverlayDisplayed = true;\n  }\n  ad.play();\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.start = function() {\n  this.mediaChanging = false;\n  if (this.canPlay() === true) {\n    this.startAd();\n  } else {\n    this.playWhenLoaded = true;\n  }\n  return true;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.canPlay = function() {\n  return this.initialized === true;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.startAd = function() {\n  var adLocked, id, slot, _i, _len, _ref, _ref1;\n  this.playWhenLoaded = false;\n  if (this.prerollSlots.length) {\n    adLocked = false;\n    _ref = this.prerollSlots;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      slot = _ref[_i];\n      id = slot.getCustomId();\n      if (((_ref1 = this.getPodById(id)) != null ? _ref1.locked : void 0) === true) {\n        adLocked = true;\n      }\n      if (adLocked) {\n        this.breakEnd();\n      } else {\n        slot = this.prerollSlots[0];\n        this.startBreak(this.getPodById(slot.getCustomId()));\n        this.playAd(slot);\n      }\n    }\n  } else {\n    this.endBreak();\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.play = function() {\n  var _ref;\n  FreeWheelProxy.__super__.play.call(this);\n  this.getMediaElement().play();\n  if ((_ref = this.slot) != null) {\n    _ref.resume();\n  }\n  if (this.terminateAdOnPlay === true) {\n    this.terminateAdOnPlay = false;\n    this.terminateAd();\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.pause = function() {\n  var video, _ref;\n  FreeWheelProxy.__super__.pause.call(this);\n  video = this.getMediaElement();\n  video.pause();\n  if ((_ref = this.slot) != null) {\n    _ref.pause();\n  }\n  setTimeout(function() {\n    return video.controls = false;\n  }, 0);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.breakEnd = function() {\n  var video,\n    _this = this;\n  FreeWheelProxy.__super__.breakEnd.call(this);\n  if (this.playbackCore == null) {\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  }\n  video = this.getMediaElement();\n  video.removeEventListener(\"playing\", this.playbackCore.handlers.playing);\n  video.removeEventListener(\"pause\", this.playbackCore.handlers.pause);\n  video.removeEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n  video.removeEventListener(\"seeking\", this.handlers.seekupdate);\n  clearInterval(this.timeout);\n  if (this.appState.getEnded()) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n  } else if (this.mediaChanging !== true) {\n    this.playbackCore.setEnabled(true);\n    setTimeout(function() {\n      _this.contentPlay();\n      if (_this.playbackRate != null) {\n        _this.facade.player.playbackRate = _this.playbackRate;\n        _this.playbackRate = null;\n      }\n      _this.getMediaElement().addEventListener(\"playing\", _this.handlers.onResume);\n    }, 1);\n    setTimeout(function() {\n      _this.engageMidrollCheck();\n      _this.engageOverlayCheck();\n    }, 500);\n    return;\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentStarted = function() {\n  this.engageMidrollCheck();\n  this.engageOverlayCheck();\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentSeek = function(time) {\n  var nextime;\n  if (this.appState.getSeekRequested() === true) {\n    return;\n  }\n  this.nextMidroll = this.getPreviousMidroll(time);\n  this.nextOverlay = this.getPreviousOverlay(time);\n  if (!(this.nextMidroll != null)) {\n    this.nextMidroll = this.getNextMidroll(time);\n    if (this.nextMidroll != null) {\n      nextime = this.nextMidroll.getTimePosition();\n      if (nextime - time < 1 || time < nextime) {\n        this.nextMidroll = null;\n      }\n    }\n    return;\n  }\n  if (!(this.nextOverlay != null)) {\n    this.nextOverlay = this.getNextOverlay(time);\n    return;\n  }\n  if (!this.midrollEngaged) {\n    this.engageMidrollCheck();\n  }\n  if (!this.overlayEngaged) {\n    this.engageOverlayCheck();\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentEnded = function() {\n  var _ref,\n    _this = this;\n  this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n  if (((_ref = this.postrollSlots) != null ? _ref.length : void 0)) {\n    setTimeout(function() {\n      var slot;\n      slot = _this.postrollSlots[0];\n      _this.startBreak(_this.getPodById(slot.getCustomId()));\n      _this.playAd(slot);\n    }, 0);\n  } else {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.engageMidrollCheck = function() {\n  var _ref;\n  if (((_ref = this.midrollSlots) != null ? _ref.length : void 0) === 0 || this.midrollEngaged === true) {\n    return;\n  }\n  this.midrollEngaged = true;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nFreeWheelProxy.prototype.disengageMidrollCheck = function() {\n  this.midrollEngaged = false;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nFreeWheelProxy.prototype.engageOverlayCheck = function() {\n  var _ref;\n  if (((_ref = this.overlaySlotsArray) != null ? _ref.length : void 0) === 0 || this.overlayEngaged === true) {\n    return;\n  }\n  this.overlayEngaged = true;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.overlaytimeupdate);\n};\n\nFreeWheelProxy.prototype.disengageOverlayCheck = function() {\n  this.overlayEngaged = false;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.overlaytimeupdate);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.midrollCheck = function(event) {\n  var count, cur, next, nextime, pod, time, _base;\n  if (this.getMediaElement().paused) {\n    return;\n  }\n  if (this.appState.getSeeking() === true || this.appState.getSeekRequested() === true) {\n    return;\n  }\n  time = this.playbackCore.getCurrentTime();\n  if (!(this.nextMidroll != null)) {\n    next = this.getNextMidroll(time);\n    cur = this.getPreviousMidroll(time);\n    if ((cur != null) && time >= (cur != null ? cur.getTimePosition() : void 0) && (!(next != null) || ((next != null) && time <= next.getTimePosition()))) {\n      this.nextMidroll = cur;\n    }\n    return;\n  }\n  nextime = this.nextMidroll.getTimePosition();\n  if (time < nextime) {\n    return;\n  }\n  count = typeof (_base = this.nextMidroll).getAdCount === \"function\" ? _base.getAdCount() : void 0;\n  pod = this.getPodById(this.nextMidroll.getCustomId());\n  if (!(count != null) || pod.locked) {\n    return;\n  }\n  if (count === 0) {\n    this.onSlotEnded({\n      slot: this.nextMidroll,\n      skipped: true\n    });\n    return;\n  }\n  this.disengageMidrollCheck();\n  this.disengageOverlayCheck();\n  this.adVO.type = \"midroll\";\n  this.startBreak(this.getPodById(this.nextMidroll.getCustomId()));\n  this.engageAds();\n  this.playAd(this.nextMidroll);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getNextMidroll = function(time) {\n  var midroll, _i, _len, _ref;\n  time = time >= 0 ? time : 0;\n  _ref = this.midrollSlots;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    midroll = _ref[_i];\n    if (time < midroll.getTimePosition()) {\n      return midroll;\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getPreviousMidroll = function(time) {\n  var midroll, pod, pods, _i, _len;\n  pods = this.pods.slice().reverse();\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if (!(pod.type === \"midroll\")) {\n      continue;\n    }\n    midroll = pod.metadata;\n    if (time > midroll.getTimePosition()) {\n      if (pod.locked !== true) {\n        return midroll;\n      } else {\n        return null;\n      }\n    }\n  }\n};\n\nFreeWheelProxy.prototype.overlayCheck = function(event) {\n  var count, _base;\n  if (this.getMediaElement().paused) {\n    return;\n  }\n  if (this.appState.getSeeking() === true || this.appState.getSeekRequested() === true) {\n    return;\n  }\n  if (!(this.nextOverlay != null)) {\n    this.nextOverlay = this.getNextOverlay(this.playbackCore.getCurrentTime());\n    return;\n  }\n  if (this.playbackCore.getCurrentTime() < this.nextOverlay.getTimePosition()) {\n    return;\n  }\n  count = typeof (_base = this.nextOverlay).getAdCount === \"function\" ? _base.getAdCount() : void 0;\n  if (!(count != null)) {\n    return;\n  }\n  if (count === 0) {\n    this.onSlotEnded({\n      slot: this.nextOverlay,\n      skipped: true\n    });\n    return;\n  }\n  this.disengageOverlayCheck();\n  this.adVO.type = \"overlay\";\n  this.playAd(this.nextOverlay);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getNextOverlay = function(time) {\n  var overlay, _i, _len, _ref;\n  time = time >= 0 ? time : 0;\n  _ref = this.overlaySlotsArray;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    overlay = _ref[_i];\n    if (time < overlay.getTimePosition()) {\n      return overlay;\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getPreviousOverlay = function(time) {\n  var overlay, pod, pods, _i, _len;\n  pods = this.pods.slice().reverse();\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if (!(pod.type === \"overlay\")) {\n      continue;\n    }\n    overlay = pod.metadata;\n    if (time > overlay.getTimePosition()) {\n      if (pod.locked !== true) {\n        return overlay;\n      } else {\n        return null;\n      }\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.terminateAd = function(stopactive) {\n  if (stopactive === null) {\n    stopactive = false;\n  }\n  if (this.started === true && this.getMediaElement().paused === true && stopactive === false) {\n    this.terminateAdOnPlay = true;\n    return;\n  }\n  if (this.slot != null) {\n    if (this.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL) {\n      this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n    }\n    if (stopactive === true) {\n      this.slot.stop();\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.terminateAllAds = function(listeners) {\n  if (listeners === true && (this.context != null)) {\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_ERROR, this.handlers.onAdEvent);\n  }\n  this.terminateAd();\n  this.clearSlots();\n  this.disengageMidrollCheck();\n  this.disengageOverlayCheck();\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.isOverlayDisplayed = false;\n  /**\n  */\n};\n\nFreeWheelProxy.prototype.clearSlots = function() {\n  this.prerollSlots = [];\n  this.midrollSlots = [];\n  this.postrollSlots = [];\n  this.overlaySlotsArray = [];\n  this.slot = null;\n  this.nextMidroll = null;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getCreativeParameters = function(instance) {\n  var param, payload, value, _i, _len, _ref;\n  if (this.config.creativeParameters && instance) {\n    value = null;\n    payload = {};\n    _ref = this.config.creativeParameters;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      param = _ref[_i];\n      value = null;\n      try {\n        value = instance.getActiveCreativeRendition().getParameter(param);\n      } catch (error) {\n        this.facade.logger.warn(\"[AMP FREEWHEEL WARNING]\", \"Could not retrieve Freewheel creative parameter: \" + param, error);\n      } finally {\n        if (value) {\n          payload[param] = value;\n        }\n      }\n    }\n  }\n  return payload;\n};\n\nFreeWheelProxy.prototype.contentPaused = function() {\n  if (!this.getInProgress()) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);\n    this.getMediaElement().addEventListener(\"playing\", this.handlers.onResume);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.setVolume = function(value) {\n  var _ref;\n  if ((_ref = this.context) != null) {\n    _ref.setAdVolume(value);\n  }\n  return value;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.destroy = function() {\n  this.terminateAllAds(true);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.updateAdMetadata = function(ad, metadata) {\n  var creativeParameters, id, instance, key, rendition, val, _i, _len, _ref;\n  if ((ad != null) && (metadata != null)) {\n    metadata.time = ad.getTimePosition();\n    instance = ad.getCurrentAdInstance();\n    if (instance != null) {\n      rendition = instance.getActiveCreativeRendition();\n    }\n    if (rendition != null) {\n      for (key in rendition) {\n        val = rendition[key];\n        if (key.indexOf('get') === 0 && typeof val === 'function') {\n          metadata[key.substring(3).toLowerCase()] = val.call(rendition);\n        }\n      }\n      metadata.baseunit = rendition.getBaseUnit();\n      creativeParameters = this.value.creativeParameters;\n      if (creativeParameters != null) {\n        metadata.creativeparameters = {};\n        _ref = ad.getAdInstances();\n        for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n          instance = _ref[_i];\n          id = instance.getAdId();\n          metadata.creativeparameters[id] = this.getCreativeParameters(instance);\n        }\n      }\n    }\n  }\n  return metadata;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.replay = function() {\n  this.playWhenLoaded = true;\n};\n\n/**\n * The StatsPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction StatsPlugin() {\n  StatsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(StatsPlugin, Plugin);\n\n\nStatsPlugin.prototype.moduleName = \"stats\";\n\n/** @override\n*/\nStatsPlugin.prototype.createModel = function() {\n  this.proxy = new StatsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nStatsPlugin.prototype.createController = function() {\n  StatsPlugin.__super__.createController.call(this);\n  this.registerCommand(StatsNotifications.VISIBILITY_CHANGE, StatsVisibilityChangeCommand);\n};\n\n/** @override\n*/\nStatsPlugin.prototype.createView = function() {\n  this.registerMediator(new StatsMediator());\n};\n\n/**\n*/\nStatsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYING, Notifications.TIME_UPDATE];\n};\n\n/** @override\n*/\nStatsPlugin.prototype.listNotificationPublications = function() {\n  return StatsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, StatsNotifications.VISIBILITY_CHANGE]);\n};\n\n/**\n * @return   {boolean}  A boolean indicating whether or not the stats are hidden.\n * @expose\n*/\nStatsPlugin.prototype.getHidden = function() {\n  return this.proxy.getHidden();\n};\n\n/**\n *\n * @param   {boolean} value A boolean indicating whether or not the stats are hidden.\n * @expose\n*/\nStatsPlugin.prototype.setHidden = function(value) {\n  this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, value);\n  return value;\n};\n\n\nAMP.registerPlugin(\"stats\", \"html\", StatsPlugin);\n\n/**\n * The IMAProxy class.\n *\n * @constructor\n * @private\n * @extends {AdProxy}\n * @param {Object} config\n*/\nfunction MOATProxy(config) {\n  MOATProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(MOATProxy, PluginProxy);\n\n\n/** @static\n*/\nMOATProxy.NAME = ModuleProxy.NAME;\n\nMOATProxy.prototype.defaults = {\n  data: {\n    partnerCode: null\n  }\n};\n\n/**\n*/\nMOATProxy.prototype.initSDK = function(adsManagerVO) {\n  var data, _ref;\n  if (typeof initMoatTracking !== \"undefined\" && initMoatTracking !== null) {\n    data = (_ref = this.getConfigurationData()) != null ? _ref.data : void 0;\n    initMoatTracking(adsManagerVO.adManager, {\n      \"partnerCode\": data.partnerCode,\n      \"viewMode\": adsManagerVO.viewMode,\n      \"slicer1\": data.slicer1,\n      \"slicer2\": data.slicer2\n    }, adsManagerVO.adContainer);\n  }\n};\n\nfunction MOATWrapper() {\n  return MOATWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(MOATWrapper, PluginWrapper);\n\n\nMOATWrapper.NAME = \"MOATWrapper\";\n\nMOATWrapper.prototype.flashPlugins = [\n  {\n    id: \"MOATAnalyticsPlugin\",\n    src: '#{paths.resources}plugins/MOATAnalyticsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"MOATAnalyticsPlugin\"\n  }\n];\n\n/** @override\n*/\nMOATWrapper.prototype.createXML = function(xml) {\n  var application, metrics, prop, props, vendor, _i, _len;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"moat\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.data.partnerCode,\n      key: \"partnerCode\"\n    }, {\n      value: this.config.data.slicer1,\n      key: \"slicer1\"\n    }, {\n      value: this.config.data.slicer2,\n      key: \"slicer2\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  return xml;\n};\n\n/**\n * The MOATAdManagerLoadedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MOATAdManagerLoadedCommand() {\n  MOATAdManagerLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MOATAdManagerLoadedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMOATAdManagerLoadedCommand.prototype.execute = function(notification) {\n  var moatProxy;\n  moatProxy = this.facade.retrieveProxy(MOATProxy.NAME);\n  if (notification.getBody()) {\n    moatProxy.initSDK(notification.getBody());\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction FreeWheelPlugin() {\n  FreeWheelPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(FreeWheelPlugin, AdPlugin);\n\n\nFreeWheelPlugin.prototype.moduleName = \"freewheel\";\n\nFreeWheelPlugin.prototype.featureName = \"ads\";\n\n/** @override\n*/\nFreeWheelPlugin.prototype.createProxy = function() {\n  return new FreeWheelProxy(this.config);\n};\n\n/** @override\n*/\nFreeWheelPlugin.prototype.isFullscreenDevice = function() {\n  return false;\n};\n\n\nAMP.registerPlugin(\"freewheel\", \"html\", FreeWheelPlugin);\nAMP.registerPlugin(\"freewheel\", \"flash\", FreeWheelWrapper);\n\n/**\n * DASHPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction DASHPlaybackProxy(data, plugin) {\n  this.plugin = plugin;\n  DASHPlaybackProxy.__super__.constructor.call(this, data.types, data);\n  this.buffer = data.buffer;\n  this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n}\n\n\n__extends(DASHPlaybackProxy, PlaybackCoreProxy);\n\n\nDASHPlaybackProxy.SCTE = \"urn:scte:scte35:2013:xml\";\n\nDASHPlaybackProxy.prototype.playbackCoreName = \"dash\";\n\nDASHPlaybackProxy.prototype.context = null;\n\nDASHPlaybackProxy.prototype.player = null;\n\nDASHPlaybackProxy.prototype.buffer = null;\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.resumecomplete = function() {\n  var track, tracks, _ref;\n  try {\n    tracks = (_ref = this.facade.getMediaElement()) != null ? _ref.textTracks : void 0;\n    if ((tracks != null ? tracks.length : void 0) !== 0) {\n      track = tracks[0];\n      if (track != null) {\n        track.mode = \"hidden\";\n      }\n    }\n  } catch (error) {\n\n  }\n  DASHPlaybackProxy.__super__.resumecomplete.call(this);\n};\n\nDASHPlaybackProxy.prototype.onerror = function() {};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.ontimeupdate = function(event) {\n  DASHPlaybackProxy.__super__.ontimeupdate.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onseeked = function(event) {\n  DASHPlaybackProxy.__super__.onseeked.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onseeking = function(event) {\n  DASHPlaybackProxy.__super__.onseeking.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.ondurationchange = function(event) {\n  DASHPlaybackProxy.__super__.ondurationchange.call(this, {\n    target: {\n      duration: this.getDuration()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onloadedmetadata = function(event) {\n  DASHPlaybackProxy.__super__.onloadedmetadata.call(this, event);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.getDuration());\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  DASHPlaybackProxy.__super__.oncanplaythrough.call(this, event);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.getDuration());\n};\n\n/**\n *\n*/\nDASHPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return DASHPlaybackProxy.__super__.canPlayMedium.call(this, medium) || medium === \"audio\";\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;\n  audio = this.player.getTracksFor(\"audio\");\n  current = this.player.getCurrentTrackFor(\"audio\");\n  tracks = this.facade.tracks.getAudioTracks();\n  count = audio.length;\n  changeEnabled = function(audio, track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(item) {\n      return item.data.enabled = item === track;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    this.player.setCurrentTrack(audio);\n  };\n  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n    item = audio[index];\n    if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n      continue;\n    }\n    track = new Track({\n      kind: item.roles.join(\" \"),\n      label: item.id,\n      language: item.lang,\n      id: item.id,\n      enabled: item === current,\n      data: item\n    });\n    track.changeEnabled = changeEnabled.bind(this, item, track);\n    tracks.add(track, index + 1 === count);\n  }\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.getUseMAE = function() {\n  return DASHPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationDashJsWrapper !== \"undefined\" && MediaAccelerationDashJsWrapper !== null);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.load = function() {\n  var useMAE, _ref;\n  if (!(this.player != null)) {\n    useMAE = ((_ref = this.config.mae) != null ? _ref.enabled : void 0) !== false && (typeof MediaAccelerationDashJsWrapper !== \"undefined\" && MediaAccelerationDashJsWrapper !== null);\n    if (!this.getUseMAE()) {\n      this.player = dashjs.MediaPlayer().create();\n    } else {\n      this.facade.mae = new MediaAccelerationDashJsWrapper(this.config.mae);\n      this.player = this.facade.mae.getPlayer();\n    }\n    this.player.on(\"error\", this.onError.bind(this));\n    this.player.on(\"fragmentLoadingStarted\", this.onFragmentLoadStart.bind(this));\n    this.player.on(\"fragmentLoadingCompleted\", this.onFragmentLoaded.bind(this));\n    this.player.on(\"qualityChangeRequested\", this.onLevelSwitching.bind(this));\n    this.player.on(dashjs.MediaPlayer.events.MANIFEST_LOADED, this.onManifestLoaded.bind(this));\n    this.player.on(dashjs.Protection.events.PROTECTION_CREATED, this.onProtectionCreated.bind(this));\n    this.player.on(DASHPlaybackProxy.SCTE, this.onEmsg.bind(this));\n    this.player.getDebug().setLogToBrowserConsole(this.plugin.proxy.getDebug());\n    this.player.initialize(this.getMediaElement(), null, true);\n    if (this.config.initialBitrate != null) {\n      this.player.setInitialBitrateFor(this.facade.getMedia().medium, this.config.initialBitrate);\n    }\n  }\n  DASHPlaybackProxy.__super__.load.call(this);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.applySrc = function() {\n  var keys;\n  keys = this.facade.getMedia().keys;\n  if (keys != null) {\n    this.player.setProtectionData(keys);\n  }\n  this.player.attachSource(this.getSrc());\n  this.getMediaElement().load();\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.seek = function(value) {\n  return Promise.resolve(this.player.seek(value));\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getCurrentTime = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.time() : void 0) || 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getDuration = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.duration() : void 0) || 0;\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.getStats = function() {\n  return {};\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onFragmentLoadStart = function(event) {\n  var bitrate;\n  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onFragmentLoaded = function(event) {\n  var bitrate;\n  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onLevelSwitching = function(event) {\n  this.sendNotification(Notifications.QUALITY_CHANGING, this.getQualityLevels()[event.newQuality]);\n};\n\nDASHPlaybackProxy.prototype.onManifestLoaded = function(event) {\n  var data;\n  data = event.data;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(dashjs.MediaPlayer.events.MANIFEST_LOADED, data));\n};\n\nDASHPlaybackProxy.prototype.onProtectionCreated = function(event) {\n  var data;\n  data = event.data;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(dashjs.Protection.events.PROTECTION_CREATED, data));\n};\n\nDASHPlaybackProxy.prototype.onEmsg = function(event) {\n  var Cue, cue, data, end, info, start, text;\n  data = event.event;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(event.type, data));\n  Cue = DataCue || VTTCue;\n  start = (data.presentationTime / data.presentationTimeDelta) * 10000;\n  end = start + (data.duration / data.presentationTimeDelta) * 10000;\n  text = String.fromCharCode.apply(null, data.messageData);\n  info = XMLUtils.parse(text);\n  data.text = text;\n  cue = new Cue(start, end, {\n    key: DASHPlaybackProxy.SCTE,\n    data: data,\n    info: info\n  });\n  this.sendNotification(Notifications.TIMED_METADATA, cue);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onError = function(event) {\n  this.facade.logger.error(\"DASH JS Playback Error:\", event);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.setQuality = function(value) {\n  var _ref, _ref1, _ref2;\n  if ((_ref = this.player) != null) {\n    _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value === -1);\n  }\n  if (value === -1) {\n    return;\n  }\n  return (_ref2 = this.player) != null ? _ref2.setQualityFor(\"video\", value) : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQuality = function() {\n  var _ref;\n  return (_ref = this.player) != null ? _ref.getQualityFor(\"video\") : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQualityLevels = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.getBitrateInfoListFor(\"video\") : void 0) || DASHPlaybackProxy.__super__.getQualityLevels.call(this);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQualityMode = function() {\n  var _ref, _ref1;\n  if (((_ref = this.player) != null ? _ref.getAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0) : void 0) === true) {\n    return \"auto\";\n  } else {\n    return \"abr\";\n  }\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.setQualityMode = function(value) {\n  var _ref, _ref1;\n  if (value !== \"auto\") {\n    return value + \" is not a valid key\";\n  }\n  return (_ref = this.player) != null ? _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value) : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.destroy = function() {\n  if (!(this.player != null)) {\n    return;\n  }\n  this.player.reset();\n  DASHPlaybackProxy.__super__.destroy.call(this);\n};\n\n/**\n * The DASHChangeDisplayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DASHChangeDisplayStateCommand() {\n  DASHChangeDisplayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DASHChangeDisplayStateCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nDASHChangeDisplayStateCommand.prototype.execute = function(notification) {\n  var core, fullscreen, playback, proxy, state, target,\n    _this = this;\n  state = notification.getBody();\n  playback = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  core = this.facade.getMediaElement();\n  if (!(core != null) || !core.webkitSupportsFullscreen) {\n    return;\n  }\n  proxy = this.facade.retrieveProxy(ApplicationStateProxy.NAME);\n  proxy.setDisplayState(state);\n  fullscreen = {};\n  target = this.facade.viewComponent;\n  if (target.requestFullscreen != null) {\n    fullscreen.enter = function() {\n      return target.requestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.cancelFullscreen();\n    };\n    fullscreen.event = \"onfullscreenchange\";\n    fullscreen.element = \"fullscreenElement\";\n  } else if (target.webkitRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.webkitRequestFullScreen();\n    };\n    fullscreen.exit = function() {\n      return document.webkitCancelFullScreen();\n    };\n    fullscreen.event = \"onwebkitfullscreenchange\";\n    fullscreen.element = \"webkitFullscreenElement\";\n  } else if (target.mozRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.mozRequestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.mozCancelFullScreen();\n    };\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n  } else if (target.msRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.msRequestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.msCancelFullScreen();\n    };\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n  }\n  if (state === DisplayState.FULL_SCREEN) {\n    fullscreen.enter();\n    if (fullscreen.event != null) {\n      core[fullscreen.event] = function(event) {\n        if (!(document[fullscreen.element] != null)) {\n          return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n        }\n      };\n    }\n  } else if (state === DisplayState.NORMAL) {\n    fullscreen.exit();\n    core[fullscreen.event] = null;\n  }\n  this.facade.dispatchEvent(new Event(\"fullscreenchange\", state === DisplayState.FULL_SCREEN));\n};\n\n/**\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction PlaybackPluginProxy(config) {\n  PlaybackPluginProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(PlaybackPluginProxy, PluginProxy);\n\n\n/** @static\n*/\nPlaybackPluginProxy.NAME = ModuleProxy.NAME;\n\nPlaybackPluginProxy.prototype.playbackProxy = null;\n\nPlaybackPluginProxy.prototype.createPlaybackProxy = function() {};\n\nPlaybackPluginProxy.prototype.initialize = function() {\n  var player;\n  this.playbackProxy = this.createPlaybackProxy();\n  if (!(this.playbackProxy != null)) {\n    return;\n  }\n  this.sendNotification(Notifications.INITIALIZED);\n  player = this.facade.player.retrieveProxy(PlayerProxy.NAME);\n  player.registerPlaybackCore(this.playbackProxy);\n};\n\nPlaybackPluginProxy.prototype.destroy = function() {\n  var _ref;\n  if ((_ref = this.playbackProxy) != null) {\n    _ref.destroy();\n  }\n};\n\n/**\n * The DASHProxy class.\n *\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction DASHProxy(config) {\n  DASHProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(DASHProxy, PlaybackPluginProxy);\n\n\n/** @static\n*/\nDASHProxy.NAME = ModuleProxy.NAME;\n\nDASHProxy.prototype.defaults = {\n  types: [\"application/dash+xml\"],\n  buffer: null,\n  mae: null,\n  initialBitrate: null\n};\n\nDASHProxy.prototype.createPlaybackProxy = function() {\n  var mediaSource;\n  mediaSource = window.MediaSource || window.WebKitMediaSource;\n  if (!(mediaSource != null)) {\n    return;\n  }\n  return new DASHPlaybackProxy(this.getConfigurationData(), this.facade);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ChromeCastConstants = {\n  CHANNEL_ID: \"urn:x-cast:com.akamai.amp.cast\",\n  APPLICATION_ID: \"CC1AD845\",\n  SUPPORTED_TYPES: [Utils.mimeTypes.m3u8, Utils.mimeTypes.mp4, Utils.mimeTypes.mpd, Utils.mimeTypes.ism, Utils.mimeTypes.webm, Utils.mimeTypes.mp3]\n};\n\n/**\n * The MOATPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {AdPlugin}\n*/\nfunction MOATPlugin() {\n  MOATPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(MOATPlugin, Plugin);\n\n\nMOATPlugin.prototype.moduleName = \"moat\";\n\n/** @override\n*/\nMOATPlugin.prototype.createModel = function() {\n  this.proxy = new MOATProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nMOATPlugin.prototype.createController = function() {\n  MOATPlugin.__super__.createController.call(this);\n  return this.registerCommand(AdNotifications.AD_MANAGER_LOADED, MOATAdManagerLoadedCommand);\n};\n\n/** @override\n*/\nMOATPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_MANAGER_LOADED];\n};\n\n\nAMP.registerPlugin(\"moat\", \"html\", MOATPlugin);\nAMP.registerPlugin(\"moat\", \"flash\", MOATWrapper);\n\n/**\n * The ChromeCastLaunchCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastLaunchCommand() {\n  ChromeCastLaunchCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastLaunchCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastLaunchCommand.prototype.execute = function(notification) {\n  this.proxy.launch();\n};\n\n/**\n * The ChromeCastCaptioningVisibilityChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastCaptioningVisibilityChangeCommand() {\n  ChromeCastCaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastCaptioningVisibilityChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n  this.proxy.send({\n    type: \"captioning.visibilitychange\",\n    detail: {\n      visibility: notification.getBody()\n    }\n  });\n};\n\n/**\n * The ChromeCastCaptioningSettingsChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastCaptioningSettingsChangeCommand() {\n  ChromeCastCaptioningSettingsChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastCaptioningSettingsChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastCaptioningSettingsChangeCommand.prototype.execute = function(notification) {\n  this.proxy.send({\n    type: \"captioning.settingschange\",\n    detail: notification.getBody()\n  });\n};\n\n/**\n * The ChromeCastBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastBreakStartCommand() {\n  ChromeCastBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastBreakStartCommand.prototype.execute = function(notification) {\n  var playbackCore;\n  this.facade.logger.debug(\"ChromeCastBreakStartCommand\");\n  playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  if (playbackCore.getPlaybackCoreName() === \"chromecast\") {\n    playbackCore.unload();\n    playbackCore.src = null;\n  }\n};\n\n/**\n * The ChromeCastSeekCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastMediaChangeCommand() {\n  ChromeCastMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastMediaChangeCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getPlaybackTarget() !== \"chromecast\") {\n    return;\n  }\n  this.facade.logger.debug(\"ChromeCastMediaChangeCommand\");\n  this.proxy.loadMedia();\n};\n\n/**\n * The ChromeCastChangeVolumeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastChangeVolumeCommand() {\n  ChromeCastChangeVolumeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastChangeVolumeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastChangeVolumeCommand.prototype.execute = function(notification) {\n  var volume;\n  volume = notification.getBody();\n  this.proxy.setVolume(volume);\n  this.sendNotification(Notifications.VOLUME_CHANGE, volume);\n};\n\n/**\n * The ChromeCastToggleMutedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastToggleMutedCommand() {\n  ChromeCastToggleMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastToggleMutedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastToggleMutedCommand.prototype.execute = function(notification) {\n  this.proxy.toggleMuted();\n};\n\n/**\n * The ChromeCastSenderMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction ChromeCastSenderMediator() {\n  ChromeCastSenderMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastSenderMediator, PluginMediator);\n\n\nChromeCastSenderMediator.prototype.componentName = \"chromecast\";\n\nChromeCastSenderMediator.prototype.controls = null;\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.onRegister = function() {\n  ChromeCastSenderMediator.__super__.onRegister.call(this);\n  this.controls = new ChromeCastControlsMediator(false);\n};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.registerOverlay = function() {};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYBACK_TARGET_CHANGE, Notifications.CHANGE_PLAY_STATE];\n};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.handleNotification = function(notification) {\n  var body, name, target;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAYBACK_TARGET_CHANGE:\n      target = body.value;\n      if (target === \"chromecast\") {\n        this.facade.registerMediator(this.controls);\n      } else {\n        this.facade.removeMediator(this.controls.getMediatorName());\n      }\n      break;\n    case Notifications.CHANGE_PLAY_STATE:\n      this.controls.setState(body);\n  }\n};\n\n/**\n * The ChromeCastSenderMediator class.\n *\n * @constructor\n * @extends {ChromeCastSenderMediator}\n * @private\n*/\nfunction ChromeCastHTMLSenderMediator() {\n  ChromeCastHTMLSenderMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastHTMLSenderMediator, ChromeCastSenderMediator);\n\n\nChromeCastHTMLSenderMediator.prototype.chromeCastButton = null;\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.onRegister = function() {\n  ChromeCastHTMLSenderMediator.__super__.onRegister.call(this);\n  this.chromeCastButton = new ChromeCastButtonMediator();\n  this.facade.registerMediator(this.chromeCastButton);\n};\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.listNotificationInterests = function() {\n  return ChromeCastHTMLSenderMediator.__super__.listNotificationInterests.call(this).concat([ChromeCastNotifications.AVAILABILITY_CHANGE]);\n};\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  ChromeCastHTMLSenderMediator.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case ChromeCastNotifications.AVAILABILITY_CHANGE:\n      if (body === true) {\n        this.sendNotification(Notifications.ADD_CONTROL_STATE, \"chromecast\");\n        this.facade.player.sendNotification(Notifications.ADD_CONTROL, this.chromeCastButton.getViewComponent());\n      } else {\n        this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"chromecast\");\n        this.facade.player.sendNotification(Notifications.REMOVE_CONTROL, this.chromeCastButton.getViewComponent());\n      }\n  }\n};\n\n/**\n * The ChromeCastFeedChangedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastFeedChangedCommand() {\n  ChromeCastFeedChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastFeedChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastFeedChangedCommand.prototype.execute = function(notification) {\n  var _base;\n  if (typeof (_base = this.proxy).setFeed === \"function\") {\n    _base.setFeed(notification.getBody());\n  }\n};\n\n/**\n * The ChromeCastSeekCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastSeekCommand() {\n  ChromeCastSeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastSeekCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastSeekCommand.prototype.execute = function(notification) {\n  this.facade.logger.debug(\"ChromeCastSeekCommand\");\n  this.plugin.setCurrentTime(notification.getBody());\n};\n\n/**\n * The ChromeCastButtonMediator class.\n *\n * @constructor\n * @extends {PluginMediator}\n * @param {Object} parent\n * @private\n*/\nfunction ChromeCastButtonMediator() {\n  ChromeCastButtonMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastButtonMediator, ButtonMediator);\n\n\nChromeCastButtonMediator.prototype.componentName = \"chromecast\";\n\nChromeCastButtonMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(ChromeCastNotifications.LAUNCH);\n  return false;\n};\n\n/**\n * The ChromeCastTogglePlayPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastTogglePlayPauseCommand() {\n  ChromeCastTogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastTogglePlayPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastTogglePlayPauseCommand.prototype.execute = function(notification) {\n  switch (this.applicationState.getPlayState()) {\n    case PlayState.ENDED:\n      this.plugin.setCurrentTime(0);\n      this.plugin.play();\n      break;\n    case PlayState.PAUSED:\n    case PlayState.READY:\n      this.plugin.play();\n      break;\n    case PlayState.PLAYING:\n    case PlayState.WAITING:\n      this.plugin.pause();\n  }\n};\n\n/**\n * The ChromeCastControlsMediator class.\n *\n * @constructor\n * @extends {PluginMediator}\n * @private\n*/\nfunction ChromeCastControlsMediator(playoverlay) {\n  ChromeCastControlsMediator.__super__.constructor.call(this, playoverlay);\n}\n\n\n__extends(ChromeCastControlsMediator, ControlsMediator);\n\n\nChromeCastControlsMediator.prototype.componentName = \"chromecast-controls\";\n\nChromeCastControlsMediator.prototype.message = null;\n\nChromeCastControlsMediator.prototype.messageContainer = null;\n\nChromeCastControlsMediator.prototype.button = null;\n\nChromeCastControlsMediator.prototype.captioningActive = false;\n\n/** @override\n*/\nChromeCastControlsMediator.prototype.onRegister = function() {\n  var button, fullscreen, _ref, _ref1;\n  ChromeCastControlsMediator.__super__.onRegister.call(this);\n  this.messageContainer = this.create(\"chromecast-message-container\");\n  this.message = this.createText(\"chromecast-message\", this.localizationManager.getString(\"MSG_CHROMECAST_MESSAGE\"), this.messageContainer);\n  this.button = new ChromeCastButtonMediator();\n  this.facade.registerMediator(this.button);\n  fullscreen = new FullScreenMediator(this.controlBar);\n  this.facade.registerMediator(fullscreen);\n  fullscreen.setDisabled(true);\n  this.sendNotification(Notifications.ADD_CONTROL, this.button.getViewComponent());\n  if (!this.viewComponent.getElementsByClassName(\"akamai-caption akamai-button\").length && ((_ref = this.facade.player.captioning) != null ? (_ref1 = _ref.config) != null ? _ref1.enabled : void 0 : void 0) === true) {\n    button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent.getElementsByClassName(\"akamai-control-bar\")[0], null, \"caption\", this.captionButtonClick.bind(this));\n    this.facade.registerMediator(button);\n    this.captionButton = button.getViewComponent();\n    this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"cc-enabled\");\n  }\n};\n\nChromeCastControlsMediator.prototype.captionButtonClick = function() {\n  var note;\n  this.captioningActive = !this.captioningActive;\n  try {\n    this.facade.player.parent.chromecast.postMessage({\n      type: \"captioning.visibilitychange\",\n      detail: {\n        visibility: this.captioningActive\n      }\n    });\n  } catch (error) {\n    this.facade.logger.error(\"[AMP Chromecast Captioning Error]\", error);\n  }\n  note = this.captioningActive ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, \"cc-active\");\n};\n\n/**\n * The ChromeCastPlaybackTargetChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastPlaybackTargetChangeCommand() {\n  ChromeCastPlaybackTargetChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastPlaybackTargetChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastPlaybackTargetChangeCommand.prototype.execute = function(notification) {\n  var body, currentTime, duration, target,\n    _this = this;\n  body = notification.getBody();\n  target = body.value;\n  if (target === \"chromecast\") {\n    this.player.pause();\n  } else if (target === \"amp\") {\n    currentTime = this.proxy.getCurrentTime();\n    duration = this.player.getDuration();\n    if (currentTime !== 0 && currentTime !== duration) {\n      this.player.once(\"seeked\", function(event) {\n        setTimeout(_this.sendNotification.bind(_this, Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING), 0);\n      });\n      this.player.setCurrentTime(currentTime);\n    }\n  }\n};\n\n/**\n * The ChromeCastSenderProxy class.\n *\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction ChromeCastSenderProxy(config) {\n  this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;\n  ChromeCastSenderProxy.__super__.constructor.call(this, config.sender);\n}\n\n\n__extends(ChromeCastSenderProxy, PluginProxy);\n\n\n/** @static\n*/\nChromeCastSenderProxy.NAME = ModuleProxy.NAME;\n\nChromeCastSenderProxy.prototype.defaults = {\n  applicationID: ChromeCastConstants.APPLICATION_ID\n};\n\nChromeCastSenderProxy.prototype.session = null;\n\nChromeCastSenderProxy.prototype.media = null;\n\nChromeCastSenderProxy.prototype.messageBus = null;\n\nChromeCastSenderProxy.prototype.feed = null;\n\nChromeCastSenderProxy.prototype.currentTime = null;\n\nChromeCastSenderProxy.prototype.duration = null;\n\nChromeCastSenderProxy.prototype.receiverAvailable = false;\n\nChromeCastSenderProxy.prototype.currentTime = 0;\n\nChromeCastSenderProxy.prototype.duration = 0;\n\nChromeCastSenderProxy.prototype.playerState = null;\n\nChromeCastSenderProxy.prototype.displayTimeTimeout = null;\n\nChromeCastSenderProxy.prototype.volume = 1;\n\nChromeCastSenderProxy.prototype.muted = false;\n\n/** @override\n*/\nChromeCastSenderProxy.prototype.initialize = function() {\n  var _ref,\n    _this = this;\n  if (typeof chrome !== \"undefined\" && chrome !== null ? (_ref = chrome.cast) != null ? _ref.isAvailable : void 0 : void 0) {\n    this.initializeCastApi();\n  } else {\n    window['__onGCastApiAvailable'] = function(loaded, errorInfo) {\n      if (loaded === true) {\n        _this.initializeCastApi();\n      } else {\n        _this.logError(\"cast load error\", errorInfo);\n      }\n    };\n  }\n};\n\nChromeCastSenderProxy.prototype.initializeCastApi = function() {\n  var apiConfig, applicationID, autoJoin, sessionRequest;\n  applicationID = this.getConfigurationData().applicationID;\n  sessionRequest = new chrome.cast.SessionRequest(applicationID);\n  autoJoin = chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED;\n  apiConfig = new chrome.cast.ApiConfig(sessionRequest, this.sessionListener.bind(this), this.receiverListener.bind(this), autoJoin);\n  chrome.cast.initialize(apiConfig, this.onInitSuccess.bind(this), this.onInitError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onInitSuccess = function(event) {\n  this.logEvent(\"init success\", event);\n};\n\nChromeCastSenderProxy.prototype.onInitError = function(event) {\n  this.logError(\"init error\", event);\n};\n\nChromeCastSenderProxy.prototype.receiverListener = function(event) {\n  this.receiverAvailable = event === 'available';\n  this.sendNotification(ChromeCastNotifications.AVAILABILITY_CHANGE, this.receiverAvailable);\n  this.logEvent(\"receiver \" + (this.receiverAvailable ? \"found\" : \"list empty\"));\n};\n\nChromeCastSenderProxy.prototype.sessionListener = function(event) {\n  this.logEvent(\"session listener\", event);\n  if (!(this.session != null)) {\n    this.setSession(event);\n  }\n  if (this.session.media.length !== 0) {\n    this.onMediaDiscovered(this.session.media[0]);\n  } else {\n    this.onRequestSessionSuccess(event);\n  }\n};\n\nChromeCastSenderProxy.prototype.launch = function() {\n  chrome.cast.requestSession(this.onRequestSessionSuccess.bind(this), this.onLaunchError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.send = function(msg) {\n  var _ref;\n  if ((_ref = this.session) != null) {\n    if (typeof _ref.sendMessage === \"function\") {\n      _ref.sendMessage(this.messageBus, msg, this.onMessageSuccess.bind(this), this.onMessageError.bind(this));\n    }\n  }\n};\n\nChromeCastSenderProxy.prototype.onLaunchError = function(event) {\n  this.logError(\"launch error.\", event);\n};\n\nChromeCastSenderProxy.prototype.setSession = function(value) {\n  this.session = value;\n  this.session.addMessageListener(this.messageBus, this.onMessage.bind(this));\n  this.session.addUpdateListener(this.onUpdate.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onRequestSessionSuccess = function(event) {\n  var playbackProxy;\n  this.logEvent(\"request session success.\", event);\n  this.setSession(event);\n  this.session.sendMessage(this.messageBus, {\n    type: \"createPlayer\",\n    config: {\n      debug: this.facade.player.getConfig().debug,\n      params: this.facade.player.getParams()\n    }\n  }, this.onCreateSucess.bind(this), this.onMessageError.bind(this));\n  playbackProxy = this.facade.player.retrieveProxy(PlaybackProxy.NAME);\n  if (this.session.media.length === 0) {\n    this.loadMedia(playbackProxy.getCurrentTime());\n  }\n};\n\nChromeCastSenderProxy.prototype.onUpdate = function(isAlive) {\n  var currentTime;\n  if (!isAlive) {\n    currentTime = this.facade.player.media.isLive === true ? Infinity : this.media.currentTime;\n    this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"amp\");\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.onCreateSucess = function(event) {\n  this.logEvent(\"MPL created\", event);\n  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n};\n\nChromeCastSenderProxy.prototype.onMessageSuccess = function(event) {\n  this.logEvent(\"message sent\", event);\n};\n\nChromeCastSenderProxy.prototype.onMessageError = function(event) {\n  this.logError(\"message error\", event);\n};\n\nChromeCastSenderProxy.prototype.onMessage = function(namespace, message) {\n  var detail, target, type;\n  message = JSON.parse(message);\n  type = message.type;\n  detail = message.detail || {};\n  switch (type) {\n    case \"dispatchevent\":\n      target = detail.target === \"player\" ? this.facade.player : this.facade.player[detail.target];\n      if (target != null) {\n        target.dispatchEvent(detail.event);\n      }\n  }\n  this.sendNotification(Notifications.DISPATCH_EVENT, {\n    type: \"message\",\n    message: message\n  });\n};\n\nChromeCastSenderProxy.prototype.onStop = function(event) {\n  this.logEvent(\"stop\");\n  this.session.stop(this.onStopSuccess.bind(this), this.onStopError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onStopSuccess = function(event) {\n  this.logEvent(\"stop success\", event);\n};\n\nChromeCastSenderProxy.prototype.onStopError = function(event) {\n  this.logError(\"stop error\", event);\n};\n\nChromeCastSenderProxy.prototype.logEvent = function(message, data) {\n  if (message == null) {\n    message = data.type || \"\";\n  }\n  this.facade.logger.log(\"[AMP CHROMECAST] \" + message, data);\n};\n\nChromeCastSenderProxy.prototype.logError = function(message, data) {\n  this.facade.logger.error(\"[AMP CHROMECAST ERROR] \" + message, data);\n};\n\nChromeCastSenderProxy.prototype.loadMedia = function(startTime) {\n  var contentId, media, player, receiverCanPlay, request, source,\n    _this = this;\n  if (startTime == null) {\n    startTime = 0;\n  }\n  player = this.facade.player;\n  media = player.retrieveProxy(MediaProxy.NAME).getData();\n  if (!(media != null)) {\n    return;\n  }\n  if (this.media != null) {\n    source = [].concat(media.source.map(function(item) {\n      return item.src;\n    }), media.src);\n    contentId = this.media.media.contentId;\n    if (source.some(function(src) {\n      return src === contentId;\n    })) {\n      return;\n    }\n  }\n  receiverCanPlay = function(type) {\n    if (ChromeCastConstants.SUPPORTED_TYPES.indexOf(type) > -1) {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  };\n  source = Utils.selectSource(media.source, receiverCanPlay);\n  if (!(source != null)) {\n    return;\n  }\n  request = this.mediaToLoadRequest(media, source, startTime, {\n    media: media\n  });\n  this.session.loadMedia(request, this.onMediaDiscovered.bind(this), this.onMediaError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.mediaToLoadRequest = function(media, source, startTime, customData) {\n  var index, mediaInfo, metadata, request, track, value, _i, _len, _ref, _ref1, _ref2;\n  metadata = new chrome.cast.media.GenericMediaMetadata();\n  metadata.title = media.title;\n  metadata.subtitle = media.description;\n  metadata.image = [new chrome.cast.Image(media.poster)];\n  metadata.releaseDate = (_ref = media.pubDate) != null ? typeof _ref.toISOString === \"function\" ? _ref.toISOString() : void 0 : void 0;\n  mediaInfo = new chrome.cast.media.MediaInfo(source.src, source.type);\n  mediaInfo.duration = media.duration;\n  mediaInfo.customData = customData;\n  mediaInfo.metadata = metadata;\n  if (((_ref1 = media.track) != null ? _ref1.length : void 0) > 0) {\n    mediaInfo.tracks = [];\n    _ref2 = media.track;\n    for (index = _i = 0, _len = _ref2.length; _i < _len; index = ++_i) {\n      value = _ref2[index];\n      track = new chrome.cast.media.Track(index, chrome.cast.media.TrackType.TEXT);\n      track.subtype = chrome.cast.media.TextTrackType.CAPTIONS;\n      track.name = \"Closed Captions\";\n      track.language = value.srclang;\n      track.customData = value;\n      track.trackContentId = value.src;\n      track.trackContentType = value.type;\n      mediaInfo.tracks.push(track);\n    }\n  }\n  request = new chrome.cast.media.LoadRequest(mediaInfo);\n  request.currentTime = startTime;\n  return request;\n};\n\nChromeCastSenderProxy.prototype.onMediaDiscovered = function(media) {\n  if (this.media != null) {\n    this.media.removeUpdateListener(this.mediaStatusUpdate);\n  }\n  this.media = media;\n  this.mediaStatusUpdate = this.onMediaStatusUpdate.bind(this);\n  this.media.addUpdateListener(this.mediaStatusUpdate);\n  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n};\n\nChromeCastSenderProxy.prototype.onMediaStatusUpdate = function(status) {\n  this.logEvent(\"mediastatusupdate\", status);\n  this.updatePlayerState(this.media.playerState);\n  this.updateDisplayTime();\n  if (status === false) {\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.updatePlayerState = function(playerState) {\n  var state;\n  if (playerState === this.playerState) {\n    return;\n  }\n  this.playerState = playerState;\n  switch (this.playerState) {\n    case chrome.cast.media.PlayerState.BUFFERING:\n      state = PlayState.WAITING;\n      break;\n    case chrome.cast.media.PlayerState.PLAYING:\n      state = PlayState.PLAYING;\n      break;\n    case chrome.cast.media.PlayerState.PAUSED:\n      state = PlayState.PAUSED;\n  }\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n  if (this.playerState === chrome.cast.media.PlayerState.PLAYING) {\n    this.startDisplayTimeUpdate();\n  } else {\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.startDisplayTimeUpdate = function() {\n  this.stopDisplayTimeUpdate();\n  this.displayTimeTimeout = setInterval(this.updateDisplayTime.bind(this), 100);\n};\n\nChromeCastSenderProxy.prototype.stopDisplayTimeUpdate = function() {\n  clearInterval(this.displayTimeTimeout);\n  this.displayTimeTimeout = null;\n};\n\nChromeCastSenderProxy.prototype.updateDisplayTime = function() {\n  var currentTime, duration, _ref;\n  currentTime = this.media.getEstimatedTime() || 0;\n  duration = ((_ref = this.media.media) != null ? _ref.duration : void 0) || currentTime;\n  if (duration !== this.duration) {\n    this.duration = duration;\n    this.sendNotification(Notifications.CHANGE_DURATION, this.duration);\n    return;\n  }\n  if (currentTime !== this.currentTime) {\n    this.currentTime = currentTime;\n    this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: this.currentTime,\n      duration: this.duration\n    });\n  }\n};\n\nChromeCastSenderProxy.prototype.onMediaError = function(error) {\n  this.logError(\"media error\", error);\n  this.stopDisplayTimeUpdate();\n};\n\nChromeCastSenderProxy.prototype.play = function() {\n  this.media.play();\n};\n\nChromeCastSenderProxy.prototype.pause = function() {\n  this.media.pause();\n};\n\nChromeCastSenderProxy.prototype.setCurrentTime = function(time) {\n  var request;\n  request = new chrome.cast.media.SeekRequest();\n  request.currentTime = time;\n  this.media.seek(request);\n};\n\nChromeCastSenderProxy.prototype.getCurrentTime = function() {\n  return this.currentTime;\n};\n\nChromeCastSenderProxy.prototype.isReceiverAvailable = function() {\n  return this.receiverAvailable;\n};\n\nChromeCastSenderProxy.prototype.toggleMuted = function() {\n  var request;\n  this.muted = !this.muted;\n  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(null, this.muted));\n  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));\n  this.sendNotification(Notifications.VOLUME_CHANGE, this.muted ? 0 : this.volume);\n};\n\nChromeCastSenderProxy.prototype.getVolume = function() {\n  return this.volume;\n};\n\nChromeCastSenderProxy.prototype.setVolume = function(value, muted) {\n  var request;\n  if (muted == null) {\n    muted = false;\n  }\n  if (value === this.volume && muted !== true) {\n    return;\n  }\n  if (muted === false) {\n    this.volume = value;\n  }\n  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(value, value === 0));\n  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onVolumeSuccess = function() {\n  this.facade.logger.log(\"[AMP Chromecast] Volume success\", this.media.volume);\n};\n\nChromeCastSenderProxy.prototype.onVolumeError = function() {\n  this.facade.logger.log(\"[AMP Chromecast] Volume error\");\n};\n\n/**\n * The ChromeCastPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ChromeCastPlugin() {\n  ChromeCastPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastPlugin, Plugin);\n\n\nChromeCastPlugin.prototype.moduleName = \"chromecast\";\n\n/** @override\n*/\nChromeCastPlugin.prototype.isAvailable = function() {\n  return /Chrome/.test(navigator.userAgent);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createModel = function() {\n  this.proxy = new ChromeCastSenderProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createController = function() {\n  ChromeCastPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n  this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n  this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, ChromeCastCaptioningVisibilityChangeCommand);\n  this.registerCommand(CaptioningNotifications.SETTINGS_CHANGE, ChromeCastCaptioningSettingsChangeCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, ChromeCastMediaChangeCommand);\n  this.registerCommand(Notifications.CHANGE_VOLUME, ChromeCastChangeVolumeCommand);\n  this.registerCommand(Notifications.TOGGLE_MUTED, ChromeCastToggleMutedCommand);\n  this.registerCommand(ChromeCastNotifications.AVAILABILITY_CHANGE, PluginEventCommand);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createView = function() {\n  this.registerMediator(new ChromeCastHTMLSenderMediator());\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE, AdNotifications.BREAK_START, Notifications.PLAYBACK_TARGET_CHANGE, Notifications.MEDIA_CHANGE];\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.listNotificationPublications = function() {\n  return ChromeCastPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.INITIALIZED, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_PLAYBACK_TARGET, Notifications.CHANGE_PLAY_STATE, ChromeCastNotifications.AVAILABILITY_CHANGE, Notifications.CHANGE_PLAY_STATE, Notifications.CHANGE_DURATION, Notifications.DISPLAY_TIME]);\n};\n\n/**\n * @expose\n*/\nChromeCastPlugin.prototype.play = function() {\n  var _base;\n  if (typeof (_base = this.proxy).play === \"function\") {\n    _base.play();\n  }\n};\n\n/**\n * @expose\n*/\nChromeCastPlugin.prototype.pause = function() {\n  var _base;\n  if (typeof (_base = this.proxy).pause === \"function\") {\n    _base.pause();\n  }\n};\n\n/**\n * @param {Number}  value   The time in seconds to seek to.\n * @expose\n*/\nChromeCastPlugin.prototype.setCurrentTime = function(value) {\n  this.proxy.setCurrentTime(value);\n  return value;\n};\n\n/**\n * Returns if The chromecast device's Availability\n * @expose\n*/\nChromeCastPlugin.prototype.isReceiverAvailable = function() {\n  var _ref;\n  return ((_ref = this.proxy) != null ? typeof _ref.isReceiverAvailable === \"function\" ? _ref.isReceiverAvailable() : void 0 : void 0) || false;\n};\n\nChromeCastPlugin.prototype.getMedia = function() {\n  return this.proxy.media;\n};\n\nChromeCastPlugin.prototype.getSession = function() {\n  return this.proxy.session;\n};\n\nChromeCastPlugin.prototype.getMediaManager = function() {\n  return this.proxy.mediaManager;\n};\n\n/**\n * sends a message across the message bus.\n *\n * @param {Object} msg\n * @expose\n*/\nChromeCastPlugin.prototype.postMessage = function(msg) {\n  this.proxy.send(msg);\n};\n\nChromeCastPlugin.prototype.launch = function() {\n  this.proxy.launch();\n};\n\n\nAMP.registerPlugin(\"chromecast\", \"html\", ChromeCastPlugin);\n\n/**\n * The ChromeCastFlashPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @param {Object}  config  The plugin's configuration object.\n * @constructor\n * @extends {ChromeCastPlugin}\n * @private\n*/\nfunction ChromeCastFlashPlugin() {\n  ChromeCastFlashPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastFlashPlugin, ChromeCastPlugin);\n\n\nChromeCastFlashPlugin.NAME = \"ChromeCastFlashPlugin\";\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createModel = function() {\n  this.proxy = new ChromeCastSenderProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createController = function() {\n  ChromeCastFlashPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n  this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n  this.registerCommand(FeedNotifications.FEED_CHANGED, ChromeCastFeedChangedCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createView = function() {\n  this.registerMediator(new ChromeCastSenderMediator());\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.listNotificationInterests = function() {\n  return [FeedNotifications.FEED_CHANGED, Notifications.CHANGE_MEDIA, Notifications.PLAYBACK_TARGET_CHANGE];\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ChromeCastNotifications = {\n  LAUNCH: \"launch\",\n  AVAILABILITY_CHANGE: \"availabilitychange\"\n};\n\n/**\n * @constructor\n * @extends {PluginWrapper}\n * @private\n*/\nfunction ChromeCastWrapper(player, init) {\n  ChromeCastWrapper.__super__.constructor.call(this, player, init);\n  this.plugin = new ChromeCastFlashPlugin();\n  this.plugin.initialize(init, this.player);\n  player.registerModule(this.plugin);\n}\n\n\n__extends(ChromeCastWrapper, PluginWrapper);\n\n\nChromeCastWrapper.NAME = \"ChromeCastWrapper\";\n\nChromeCastWrapper.prototype.buttonId = \"chromecastBtn\";\n\nChromeCastWrapper.prototype.plugin = null;\n\nChromeCastWrapper.prototype.flashView = {\n  elements: {\n    controls: {\n      elements: {\n        chromecastBtn: {}\n      }\n    }\n  }\n};\n\n/**\n*/\nChromeCastWrapper.prototype.listNotificationInterests = function() {\n  return ChromeCastWrapper.__super__.listNotificationInterests.call(this).concat([FlashNotifications.ELEMENT_EVENT, FlashNotifications.LOAD_STATE_READY, FlashNotifications.LOAD_STATE_LOADING, FlashNotifications.APPLICATION_STATE_CHANGE, ChromeCastNotifications.AVAILABILITY_CHANGE]);\n};\n\n/**\n*/\nChromeCastWrapper.prototype.handleNotification = function(notification) {\n  var body, isReceiverAvailable, name, _ref;\n  ChromeCastWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.ELEMENT_EVENT:\n      if (body.type === \"click\" && body.element === this.buttonId) {\n        this.plugin.sendNotification(ChromeCastNotifications.LAUNCH);\n      }\n      break;\n    case ChromeCastNotifications.AVAILABILITY_CHANGE:\n      if (((_ref = this.player.mediaElement) != null ? _ref.setPlayerProperty : void 0) != null) {\n        this.player.mediaElement.setPlayerProperty(this.buttonId, {\n          visible: body\n        });\n      }\n      break;\n    case FlashNotifications.APPLICATION_STATE_CHANGE:\n    case FlashNotifications.LOAD_STATE_READY:\n    case FlashNotifications.LOAD_STATE_LOADING:\n      isReceiverAvailable = this.plugin.isReceiverAvailable();\n      if (isReceiverAvailable) {\n        this.player.mediaElement.setPlayerProperty(this.buttonId, {\n          state: 1\n        });\n      }\n      this.player.mediaElement.setPlayerProperty(this.buttonId, {\n        visible: isReceiverAvailable\n      });\n  }\n};\n\n/**\n * @expose\n*/\nChromeCastWrapper.prototype.play = function() {\n  this.plugin.play();\n};\n\n/**\n * @expose\n*/\nChromeCastWrapper.prototype.pause = function() {\n  this.plugin.pause();\n};\n\n/**\n * @param {Number}  value   The time in seconds to seek to.\n * @expose\n*/\nChromeCastWrapper.prototype.setCurrentTime = function(value) {\n  this.plugin.setCurrentTime(value);\n  return value;\n};\n\n/**\n * Returns if The chromecast device's Availability\n * @expose\n*/\nChromeCastWrapper.prototype.isReceiverAvailable = function() {\n  return this.plugin.isReceiverAvailable();\n};\n\nChromeCastWrapper.prototype.getMedia = function() {\n  return this.plugin.getMedia();\n};\n\nChromeCastWrapper.prototype.getSession = function() {\n  return this.plugin.getSession();\n};\n\nChromeCastWrapper.prototype.getMediaManager = function() {\n  return this.plugin.getMediaManager();\n};\n\nChromeCastWrapper.prototype.getCastReceiverManager = function() {\n  return this.plugin.getCastReceiverManager();\n};\n\nChromeCastWrapper.prototype.getCastMessageBus = function() {\n  return this.plugin.getCastMessageBuses();\n};\n\n/**\n * sends a message across the message bus.\n *\n * @param {Object} msg\n * @expose\n*/\nChromeCastWrapper.prototype.postMessage = function(msg) {\n  this.plugin.postMessage(msg);\n};\n\nChromeCastWrapper.prototype.launch = function() {\n  this.plugin.launch();\n};\n\n\nAMP.registerPlugin(\"chromecast\", \"flash\", ChromeCastWrapper);\n\n/**\n * The PlaylistMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction PlaylistMediator(viewComponent) {\n  PlaylistMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(PlaylistMediator, PluginMediator);\n\n\n/**\n * Stats Mediator\n *\n * @static\n * @type {string}\n*/\nPlaylistMediator.prototype.componentName = \"playlist\";\n\nPlaylistMediator.prototype.playlistButton = null;\n\n/**\n * @override\n*/\nPlaylistMediator.prototype.onRegister = function() {\n  var button;\n  button = new ButtonMediator(null, this.viewComponent, null, \"playlist\", this.playlistOnClick.bind(this));\n  this.facade.registerMediator(button);\n  this.playlistButton = button.getViewComponent();\n  this.sendNotification(Notifications.ADD_CONTROL, this.playlistButton);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"playlist-enabled\");\n  PlaylistMediator.__super__.onRegister.call(this);\n};\n\nPlaylistMediator.prototype.playlistOnClick = function(event) {\n  this.facade.logger.debug('AMP Event: Playlist Clicked');\n};\n\n/**\n * The DASHPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction DASHPlugin() {\n  DASHPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    instance: {\n      get: this.getInstance,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(DASHPlugin, Plugin);\n\n\nDASHPlugin.prototype.moduleName = \"dash\";\n\n/** @override\n*/\nDASHPlugin.prototype.createModel = function() {\n  this.proxy = new DASHProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/**\n * Returns DASH PlaybackProxy\n *\n*/\nDASHPlugin.prototype.getPlaybackProxy = function() {\n  return this.proxy.playbackProxy;\n};\n\n/**\n * Returns instance of DASH player\n *\n*/\nDASHPlugin.prototype.getInstance = function() {\n  return this.getPlaybackProxy().player;\n};\n\nDASHPlugin.prototype.registered = function() {\n  this.player.registerCommand(Notifications.CHANGE_DISPLAY_STATE, DASHChangeDisplayStateCommand);\n  DASHPlugin.__super__.registered.call(this);\n};\n\n/**\n*/\nDASHPlugin.prototype.listNotificationPublications = function() {\n  return DASHPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n};\n\n\nAMP.registerPlugin(\"dash\", \"html\", DASHPlugin);\n\nfunction AdChoicesWrapper() {\n  return AdChoicesWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(AdChoicesWrapper, PluginWrapper);\n\n\nAdChoicesWrapper.NAME = \"AdChoicesWrapper\";\n\nAdChoicesWrapper.prototype.flashView = {\n  elements: {\n    adOptions: {\n      elements: {\n        adChoices: {\n          attributes: {\n            target: \"http://www.akamai.com/\"\n          }\n        }\n      }\n    }\n  }\n};\n\n/**\n * The AdChoicesMediator class.\n *\n * @constructor\n * @extends {ComponentMediator}\n * @private\n*/\nfunction AdChoicesMediator() {\n  AdChoicesMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AdChoicesMediator, ComponentMediator);\n\n\nAdChoicesMediator.prototype.componentName = \"ad-choices\";\n\nAdChoicesMediator.prototype.icon = null;\n\nAdChoicesMediator.prototype.text = null;\n\nAdChoicesMediator.prototype.container = null;\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.onRegister = function() {\n  var data;\n  AdChoicesMediator.__super__.onRegister.call(this);\n  data = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.container = this.create(\"ad-choices-link\", this, \"a\");\n  this.container.target = \"_blank\";\n  this.container.href = data.getTarget();\n  this.text = this.createText(\"ad-choices-text\", \"AdChoices\", this.container);\n  this.icon = this.create(\"ad-choices-icon\", this.container);\n};\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_CONTAINER_CREATED];\n};\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.handleNotification = function(notification) {\n  var container;\n  switch (notification.getName()) {\n    case AdNotifications.AD_CONTAINER_CREATED:\n      container = notification.getBody();\n      if (container != null) {\n        container.appendChild(this.viewComponent);\n      }\n  }\n};\n\n/**\n *\n*/\n/** @constructor\n*/\nfunction AdChoicesProxy(config) {\n  AdChoicesProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AdChoicesProxy, ModuleProxy);\n\n\n/** @static\n*/\nAdChoicesProxy.NAME = ModuleProxy.NAME;\n\nAdChoicesProxy.prototype.defaults = {\n  target: null\n};\n\n/**\n *\n*/\nAdChoicesProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nAdChoicesProxy.prototype.setTarget = function(value) {\n  return this.data.target = value;\n};\n\n/**\n * The PlaylistPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction PlaylistPlugin() {\n  PlaylistPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(PlaylistPlugin, Plugin);\n\n\nPlaylistPlugin.prototype.moduleName = \"playlist\";\n\n/** @override\n*/\nPlaylistPlugin.prototype.createView = function() {\n  this.registerMediator(new PlaylistMediator());\n};\n\n/** @override\n*/\nPlaylistPlugin.prototype.listNotificationPublications = function() {\n  return PlaylistPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE]);\n};\n\n\nAMP.registerPlugin(\"playlist\", \"html\", PlaylistPlugin);\n\n/**\n * HLSPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction HLSPlaybackProxy(config, plugin) {\n  this.plugin = plugin;\n  HLSPlaybackProxy.__super__.constructor.call(this, config.types, config);\n  this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n}\n\n\n__extends(HLSPlaybackProxy, PlaybackCoreProxy);\n\n\nHLSPlaybackProxy.prototype.playbackCoreName = \"hls\";\n\nHLSPlaybackProxy.prototype.player = null;\n\nHLSPlaybackProxy.prototype.hlsConfig = null;\n\nHLSPlaybackProxy.prototype.fragErrorTime = 0;\n\nHLSPlaybackProxy.prototype.timedMedatadata = null;\n\nHLSPlaybackProxy.prototype.currentMedatadata = null;\n\nHLSPlaybackProxy.prototype.id3Track = null;\n\nHLSPlaybackProxy.prototype.manifestParsed = false;\n\nHLSPlaybackProxy.prototype.details = null;\n\nHLSPlaybackProxy.prototype.quality = -1;\n\nHLSPlaybackProxy.prototype.qualityMode = \"auto\";\n\nHLSPlaybackProxy.prototype.userSwitched = false;\n\n/**\n *\n*/\nHLSPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return HLSPlaybackProxy.__super__.canPlayMedium.call(this, medium) || medium === \"audio\";\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.getUseMAE = function() {\n  return HLSPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationHlsJsWrapper !== \"undefined\" && MediaAccelerationHlsJsWrapper !== null);\n};\n\nHLSPlaybackProxy.prototype.getConfig = function() {\n  var config;\n  config = Utils.clone(this.config.data);\n  if (this.config.withCredentials === true) {\n    config.xhrSetup = function(xhr, url) {\n      xhr.withCredentials = true;\n    };\n  }\n  config.debug = this.plugin.proxy.getDebug();\n  if (!this.getUseMAE()) {\n    config.enableSoftwareAES = config.enableSoftwareAES != null ? config.enableSoftwareAES : true;\n  }\n  return config;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.load = function() {\n  var config, key, player, value, _ref, _ref1,\n    _this = this;\n  if (this.player != null) {\n    this.destroy();\n  }\n  this.manifestParsed = false;\n  this.userSwitched = false;\n  this.quality = -1;\n  config = this.getConfig();\n  if (!this.getUseMAE()) {\n    player = new Hls(config);\n  } else {\n    this.facade.mae = new MediaAccelerationHlsJsWrapper(this.config.mae, config);\n    player = this.facade.mae.getPlayer();\n  }\n  player.attachMedia(this.getMediaElement());\n  _ref = Hls.Events;\n  for (key in _ref) {\n    value = _ref[key];\n    player.on(value, function(event, data) {\n      _this.plugin.dispatcher.dispatchEvent(new Event(event, data));\n    });\n  }\n  player.on(Hls.Events.MANIFEST_LOADED, this.onManifestLoaded.bind(this));\n  player.on(Hls.Events.MANIFEST_PARSED, this.onManifestParsed.bind(this));\n  player.on(Hls.Events.ERROR, this.onError.bind(this));\n  player.on(Hls.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata.bind(this));\n  player.on(Hls.Events.LEVEL_LOADED, this.onLevelLoaded.bind(this));\n  player.on(Hls.Events.LEVEL_SWITCHING, this.onLevelSwitching.bind(this));\n  player.on(Hls.Events.LEVEL_SWITCHED, this.onLevelSwitched.bind(this));\n  player.on(Hls.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitch.bind(this));\n  player.on(Hls.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitch.bind(this));\n  player.on(Hls.Events.FRAG_LOADING, this.onFragmentLoadStart.bind(this));\n  player.on(Hls.Events.FRAG_LOADED, this.onFragmentLoaded.bind(this));\n  try {\n    _ref1 = this.config.quality;\n    for (key in _ref1) {\n      value = _ref1[key];\n      player[key] = value;\n    }\n  } catch (_error) {}\n  this.player = player;\n  this.details = null;\n  HLSPlaybackProxy.__super__.load.call(this);\n};\n\nHLSPlaybackProxy.prototype.applySrc = function() {\n  this.currentMedatadata = null;\n  this.player.loadSource(this.getSrc());\n  this.getMediaElement().load();\n};\n\nHLSPlaybackProxy.prototype.onManifestLoaded = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.MANIFEST_LOADED, {\n    event: event,\n    data: data\n  }));\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onManifestParsed = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.MANIFEST_PARSED, {\n    event: event,\n    data: data\n  }));\n  this.manifestParsed = true;\n  this.sendNotification(Notifications.QUALITY_LEVELS_LOADED, data.levels);\n  this.player.loadLevel = -1;\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onLevelLoaded = function(event, data) {\n  var duration;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_LOADED, {\n    event: event,\n    data: data\n  }));\n  this.player.levels[data.level].level = data.level;\n  this.sendNotification(Notifications.QUALITY_CHANGE, this.player.levels[data.level]);\n  this.details = data.details;\n  duration = this.details.totalduration;\n  if (duration !== this.data.duration) {\n    this.data.duration = this.details.totalduration;\n    this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);\n  }\n  if (data.details.live === true && this.facade.mediaProxy.getTemporalType() !== \"dvr\") {\n    this.facade.mediaProxy.setTemporalType(\"live\");\n  }\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onLevelSwitching = function(event, data) {\n  if (this.getQualityMode() === \"manual\") {\n    this.userSwitched = true;\n  }\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_SWITCHING, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.QUALITY_CHANGING, this.player.levels[data.level]);\n};\n\nHLSPlaybackProxy.prototype.onLevelSwitched = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_SWITCHED, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.QUALITY_SWITCHED, this.player.levels[data.level]);\n};\n\nHLSPlaybackProxy.prototype.onAudioTrackSwitch = function(event, data) {\n  var hasswitched;\n  hasswitched = event === Hls.Events.AUDIO_TRACK_SWITCHED;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(event, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.AUDIO_TRACK_SWITCH, {\n    switched: hasswitched\n  });\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onseeking = function(event) {\n  if (this.getQualityMode() === \"manual\" && this.userSwitched) {\n    return;\n  }\n  HLSPlaybackProxy.__super__.onseeking.call(this, event);\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onseeked = function(event) {\n  if (this.getQualityMode() === \"manual\" && this.userSwitched) {\n    this.userSwitched = false;\n    return;\n  }\n  HLSPlaybackProxy.__super__.onseeked.call(this, event);\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onFragParsingMetadata = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_PARSING_METADATA, {\n    event: event,\n    data: data\n  }));\n};\n\nHLSPlaybackProxy.prototype.onFragmentLoadStart = function(event, data) {\n  var bitrate;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADING, {\n    event: event,\n    data: data\n  }));\n  bitrate = this.player.levels[data.frag.level].bitrate;\n  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n};\n\nHLSPlaybackProxy.prototype.onFragmentLoaded = function(event, data) {\n  var bitrate;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADED, {\n    event: event,\n    data: data\n  }));\n  bitrate = this.player.levels[data.frag.level].bitrate;\n  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n};\n\nHLSPlaybackProxy.prototype.ontimeupdate = function(event) {\n  var _ref;\n  if (((_ref = this.facade.ads) != null ? _ref.inProgress : void 0) === true) {\n    return;\n  }\n  this.data.currentTime = this.getCurrentTime();\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: this.data.currentTime\n  });\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.ondurationchange = function(event) {\n  var duration;\n  duration = this.getDetails().totalduration;\n  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {\n    return;\n  }\n  this.data.duration = duration;\n  this.sendNotification(Notifications.CHANGE_DURATION, duration);\n};\n\nHLSPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  this.createTracks();\n  this.sendNotification(Notifications.CAN_PLAY_THROUGH);\n  this.sendNotification(Notifications.PROGRESS, this.getDuration());\n  if (this.qualityMode === \"manual\" && this.player.currentLevel !== this.quality) {\n    this.setQuality(this.quality);\n  }\n};\n\nHLSPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.getMediaElement().currentTime - this.getStartTime();\n};\n\nHLSPlaybackProxy.prototype.getDetails = function() {\n  return this.details || {};\n};\n\nHLSPlaybackProxy.prototype.getFragmentDuration = function() {\n  return this.getDetails().targetduration;\n};\n\nHLSPlaybackProxy.prototype.getUTCStart = function() {\n  return this.getDetails().startSN * 10000;\n};\n\nHLSPlaybackProxy.prototype.getUTCTime = function() {\n  return this.getUTCStart() + (this.getCurrentTime() * 1000);\n};\n\nHLSPlaybackProxy.prototype.getUTCEnd = function() {\n  return this.getDetails().endSN * 10000;\n};\n\nHLSPlaybackProxy.prototype.getStartTime = function() {\n  return this.getMediaElement().duration - this.getDuration();\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.goLive = function() {\n  this.setCurrentTime(this.getLiveTime());\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.getLiveTime = function() {\n  return this.getDuration() - this.getFragmentDuration();\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.isLive = function() {\n  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.seek = function(value) {\n  var _this = this;\n  return HLSPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {\n    if (_this.mediaProxy.getTemporalType() === \"dvr\") {\n      _this.sendNotification(Notifications.IS_LIVE, _this.isLive());\n    }\n  });\n};\n\n/** override\n*/\nHLSPlaybackProxy.prototype.onplaying = function(event) {\n  HLSPlaybackProxy.__super__.onplaying.call(this);\n  this.retried = false;\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onError = function(event, data) {\n  this.userSwitched = false;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"error\", {\n    event: event,\n    data: data\n  }));\n  if (this.config.ignoreErrors === true) {\n    return;\n  }\n  if (this.config.retryOnError === false || this.retried === true) {\n    this.retried = false;\n    this.error(data);\n    return;\n  }\n  if (data.fatal && data.type === Hls.ErrorTypes.MEDIA_ERROR && data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {\n    data.fatal = false;\n  }\n  if (data.fatal) {\n    switch (data.type) {\n      case Hls.ErrorTypes.NETWORK_ERROR:\n        this.retried = true;\n        if (this.manifestParsed) {\n          this.player.startLoad();\n        } else {\n          this.player.loadSource(this.getSrc());\n        }\n        this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n        break;\n      case Hls.ErrorTypes.MEDIA_ERROR:\n        this.retried = true;\n        this.player.recoverMediaError();\n        this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n        break;\n      default:\n        this.facade.logger.error(\"[AMP HLS] Playback Error:\", event);\n        this.error(data);\n    }\n  } else {\n    if (data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {\n      if (this.fragErrorTime === this.getMediaElement().currentTime) {\n        this.getMediaElement().currentTime++;\n        this.facade.logger.error(\"[AMP HLS] Frag Loop Load Error, Seeking to :\", this.getMediaElement().currentTime);\n      } else {\n        this.fragErrorTime = this.getMediaElement().currentTime;\n      }\n    }\n  }\n};\n\nHLSPlaybackProxy.prototype.error = function(data) {\n  switch (data.type) {\n    case Hls.ErrorTypes.NETWORK_ERROR:\n      data.code = MediaError.MEDIA_ERR_NETWORK;\n      break;\n    case Hls.ErrorTypes.MEDIA_ERROR:\n      data.code = MediaError.MEDIA_ERR_DECODE;\n      break;\n    default:\n      data.toString = function() {\n        return data.details;\n      };\n  }\n  this.sendNotification(Notifications.ERROR, data);\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;\n  audio = this.player.audioTracks;\n  current = this.player.audioTrack;\n  tracks = this.facade.tracks.getAudioTracks();\n  count = audio.length;\n  changeEnabled = function(track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(track) {\n      return track.data.enabled = false;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    this.facade.tracks.getAudioTracks()[track.id].data.enabled = true;\n    this.player.audioTrack = track.id;\n  };\n  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n    item = audio[index];\n    if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n      continue;\n    }\n    track = new Track({\n      kind: item.type,\n      label: item.name || item.id,\n      language: item.lang,\n      id: item.id,\n      enabled: item.id === current,\n      data: item\n    });\n    track.changeEnabled = changeEnabled.bind(this, item);\n    tracks.add(track, index + 1 === count);\n  }\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.setQuality = function(value) {\n  var mode, _ref;\n  mode = this.qualityMode;\n  if (value > -1) {\n    mode = \"manual\";\n  } else {\n    mode = \"auto\";\n  }\n  this.setQualityMode(mode);\n  if (value === this.player.currentLevel) {\n    this.onLevelSwitching(\"hlsLevelSwitching\", this.player.levels[value]);\n    this.onLevelSwitched(\"hlsLevelSwitched\", {\n      level: value\n    });\n    return;\n  }\n  if ((_ref = this.player) != null) {\n    _ref.currentLevel = this.quality = value;\n  }\n  return this.quality;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQuality = function() {\n  var level, _ref, _ref1;\n  level = (_ref = this.player) != null ? _ref.currentLevel : void 0;\n  if (level === -1) {\n    level = (_ref1 = this.player) != null ? _ref1.nextLoadLevel : void 0;\n  }\n  return level;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQualityLevels = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.levels : void 0) || HLSPlaybackProxy.__super__.getQualityLevels.call(this);\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQualityMode = function() {\n  return this.qualityMode;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.setQualityMode = function(value) {\n  if (value !== \"auto\" && value !== \"manual\") {\n    value += \" is not a valid key\";\n  } else {\n    this.qualityMode = value;\n  }\n  return value;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.destroy = function() {\n  if (!(this.player != null)) {\n    return;\n  }\n  HLSPlaybackProxy.__super__.destroy.call(this);\n  this.player.destroy();\n  this.player = null;\n};\n\n/**\n * @constructor\n * @extends {PluginWrapper}\n * @private\n*/\nfunction HLSWrapper(player, config) {\n  HLSWrapper.__super__.constructor.call(this, player, config);\n  Utils.flashTypes.push(Utils.mimeTypes.m3u8);\n}\n\n\n__extends(HLSWrapper, PluginWrapper);\n\n\nHLSWrapper.NAME = \"HLSWrapper\";\n\nHLSWrapper.prototype.flashPlugins = [\n  {\n    id: \"flashlsOSMF\",\n    src: '#{paths.resources}plugins/flashlsOSMF.swf',\n    host: \"osmf\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n\nAMP.registerPlugin(\"hls\", \"flash\", HLSWrapper);\n\n/**\n * The HLSAdBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction HLSAdBreakStartCommand() {\n  HLSAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(HLSAdBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nHLSAdBreakStartCommand.prototype.execute = function(notification) {\n  var rate, _ref;\n  if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === \"freewheel\") {\n    rate = this.facade.player.getPlaybackRate();\n    this.proxy.destroy();\n    this.facade.player.setPlaybackRate(rate);\n  }\n};\n\n/**\n * The HLSProxy class.\n *\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction HLSProxy(config) {\n  HLSProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(HLSProxy, PlaybackPluginProxy);\n\n\n/** @static\n*/\nHLSProxy.NAME = ModuleProxy.NAME;\n\nHLSProxy.prototype.defaults = {\n  types: [\"application/x-mpegURL\"],\n  data: {\n    enableWorker: true,\n    enableCEA708Captions: true\n  },\n  mae: null,\n  buffer: null,\n  quality: null,\n  withCredentials: null,\n  retryOnError: true,\n  ignoreErrors: false\n};\n\nHLSProxy.prototype.createPlaybackProxy = function() {\n  var mediaSource;\n  mediaSource = window.MediaSource || window.WebKitMediaSource;\n  if (!(mediaSource != null) || !Hls.isSupported()) {\n    return;\n  }\n  return new HLSPlaybackProxy(this.getConfigurationData(), this.facade);\n};\n\n/**\n * The AdChoicesPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AdChoicesPlugin() {\n  AdChoicesPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AdChoicesPlugin, Plugin);\n\n\nAdChoicesPlugin.prototype.moduleName = \"adchoices\";\n\n/** @override\n*/\nAdChoicesPlugin.prototype.createModel = function() {\n  this.registerProxy(new AdChoicesProxy(this.config));\n};\n\n/** @override\n*/\nAdChoicesPlugin.prototype.createView = function() {\n  this.registerMediator(new AdChoicesMediator());\n};\n\n/**\n * @override\n*/\nAdChoicesPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_CONTAINER_CREATED];\n};\n\n\nAMP.registerPlugin(\"adchoices\", \"html\", AdChoicesPlugin);\nAMP.registerPlugin(\"adchoices\", \"flash\", AdChoicesWrapper);\n\n/**\n * The HLSPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction HLSPlugin() {\n  HLSPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    instance: {\n      get: this.getInstance,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(HLSPlugin, Plugin);\n\n\nHLSPlugin.prototype.moduleName = \"hls\";\n\n/** @override\n*/\nHLSPlugin.prototype.createModel = function() {\n  this.proxy = new HLSProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\nHLSPlugin.prototype.createController = function() {\n  this.registerCommand(AdNotifications.BREAK_START, HLSAdBreakStartCommand);\n  HLSPlugin.__super__.createController.call(this);\n};\n\n/**\n*/\nHLSPlugin.prototype.logEvent = function(event) {\n  if (/(hlsFragLoading|hlsFragLoaded)/.test(event.type) === true) {\n    return;\n  }\n  HLSPlugin.__super__.logEvent.call(this, event);\n};\n\n/**\n * Returns HLS PlaybackProxy\n *\n*/\nHLSPlugin.prototype.getPlaybackProxy = function() {\n  return this.proxy.playbackProxy;\n};\n\n/**\n * Returns instance of HLS player\n *\n*/\nHLSPlugin.prototype.getInstance = function() {\n  return this.getPlaybackProxy().player;\n};\n\n/**\n*/\nHLSPlugin.prototype.listNotificationInterests = function() {\n  return HLSPlugin.__super__.listNotificationInterests.call(this).concat([AdNotifications.BREAK_START]);\n};\n\n/**\n*/\nHLSPlugin.prototype.listNotificationPublications = function() {\n  return HLSPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.TIMED_METADATA, Notifications.QUALITY_LEVELS_LOADED, Notifications.QUALITY_CHANGE, Notifications.QUALITY_CHANGING, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n};\n\n\nAMP.registerPlugin(\"hls\", \"html\", HLSPlugin);\n\n\nvar PromisePlugin = function (_EventDispatcher) {\n  babelHelpers.inherits(PromisePlugin, _EventDispatcher);\n\n  function PromisePlugin(player, config, key) {\n    babelHelpers.classCallCheck(this, PromisePlugin);\n\n    var _this = babelHelpers.possibleConstructorReturn(this, (PromisePlugin.__proto__ || Object.getPrototypeOf(PromisePlugin)).call(this));\n\n    _this.player = player;\n    _this.config = config || {};\n    _this.key = key;\n    _this.logger = new Logger(_this.debug)\n\n    var events = Events.values;\n    var prop = void 0,\n        event = void 0;\n\n    events.forEach(function (event) {\n      prop = _this[\"on\" + event];\n      if (prop == null || typeof prop != \"function\") return;\n\n      prop = _this[\"on\" + event] = prop.bind(_this);\n      _this.player.addEventListener(event, prop);\n    });\n    return _this;\n  }\n\n  babelHelpers.createClass(PromisePlugin, [{\n    key: \"bindHandlers\",\n    value: function bindHandlers(handlers) {\n      var _this2 = this;\n\n      if (handlers instanceof Array == false) handlers = [handlers];\n\n      handlers.forEach(function (func) {\n        _this2[func] = _this2[func].bind(_this2);\n      });\n    }\n  }, {\n    key: \"debug\",\n    get: function get() {\n      return this.config.debug != null ? this.config.debug : this.player.config.debug;\n    }\n  }, {\n    key: \"data\",\n    get: function get() {\n      return this.player.evaluateBindings(this.config);\n    }\n  }], [{\n    key: \"createFactory\",\n    value: function createFactory(def) {\n      return function (player, config, key) {\n        var _this = this;\n\n        return new Promise(function (resolve, reject) {\n          try {\n            var plugin = new _this(player, config, key);\n            resolve(plugin);\n          } catch (error) {\n            reject(error);\n          }\n        });\n      }.bind(def);\n    }\n  }]);\n\n  return PromisePlugin;\n}(EventDispatcher);\n\nvar AdPromisePlugin = function (_PromisePlugin) {\n  babelHelpers.inherits(AdPromisePlugin, _PromisePlugin);\n\n  function AdPromisePlugin(player, config) {\n    babelHelpers.classCallCheck(this, AdPromisePlugin);\n\n    return babelHelpers.possibleConstructorReturn(this, (AdPromisePlugin.__proto__ || Object.getPrototypeOf(AdPromisePlugin)).call(this, player, config));\n  }\n\n  babelHelpers.createClass(AdPromisePlugin, [{\n    key: \"dispatchEvent\",\n    value: function dispatchEvent(event) {\n      this.player.logger.log(\"[AMP AD EVENT] \" + event.type, event);\n      if (typeof this.player.sendNotification === \"function\")\n        this.player.sendNotification(\"ads\" + event.type, event.detail);\n      babelHelpers.get(AdPromisePlugin.prototype.__proto__ || Object.getPrototypeOf(AdPromisePlugin.prototype), \"dispatchEvent\", this).call(this, event);\n    }\n  }]);\n\n  return AdPromisePlugin;\n}(PromisePlugin);\n\nvar FlashPromisePlugin = function (_PromisePlugin) {\n  babelHelpers.inherits(FlashPromisePlugin, _PromisePlugin);\n\n  function FlashPromisePlugin(player, config) {\n    babelHelpers.classCallCheck(this, FlashPromisePlugin);\n\n    var _this = babelHelpers.possibleConstructorReturn(this, (FlashPromisePlugin.__proto__ || Object.getPrototypeOf(FlashPromisePlugin)).call(this, player, config));\n\n    _this.player.createDefaults.call(_this);\n    _this.player.addEventListener(\"createflashvars\", _this.createFlashVars.bind(_this));\n    _this.player.addEventListener(\"createxml\", _this.createXML.bind(_this));\n    return _this;\n  }\n\n  babelHelpers.createClass(FlashPromisePlugin, [{\n    key: \"createFlashVars\",\n    value: function createFlashVars(event) {}\n  }, {\n    key: \"createXML\",\n    value: function createXML(event) {}\n  }, {\n    key: \"createProperty\",\n    value: function createProperty(xml, key, value, parent) {\n      var property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", key);\n\n      if (parent != null) {\n        parent.appendChild(property);\n      }\n\n      if (value != null) {\n        if ((typeof value === \"undefined\" ? \"undefined\" : babelHelpers.typeof(value)) === \"object\" && !(value instanceof Array)) {\n          for (var _key in value) {\n            var val = value[_key];\n            this.createProperty(xml, _key, val, property);\n          }\n        } else {\n          var text = akamai.amp.XMLUtils.createTextContent(xml, value.toString());\n          property.appendChild(text);\n        }\n      }\n      return property;\n    }\n  }, {\n    key: \"flashPlugins\",\n    get: function get() {\n      return [];\n    }\n  }]);\n\n  return FlashPromisePlugin;\n}(PromisePlugin);\n\nglobal[\"akamai\"] = {\n  \"amp\": {\n    \"AMP\": AMP,\n    \"utils\": {\n      \"Timer\": Timer,\n      \"Utils\": Utils,\n      \"QueryString\": QueryString,\n      \"Logger\": Logger.instance,\n      \"MRSSHelper\": MRSSHelper\n    },\n    \"Timer\": Timer,\n    \"Utils\": Utils,\n    \"ID3\": ID3,\n    \"Poller\": Poller,\n    \"Cookies\": Cookies,\n    \"PlayState\": PlayState,\n    \"DisplayState\": DisplayState,\n    \"PlaybackMode\": PlaybackMode,\n    \"QueryString\": QueryString,\n    \"Logger\": Logger,\n    \"Config\": Config,\n    \"XMLUtils\": XMLUtils,\n    \"IdleUtil\": IdleUtil,\n    \"chromecast\": {\n      \"ChromeCastShim\": (typeof ChromeCastShim != \"undefined\") ? ChromeCastShim.getInstance() : null\n    },\n    \"XHR\": XHR,\n    \"Resource\": Resource,\n    \"Media\": MediaVO,\n    \"Authorization\": Authorization,\n    \"Event\": Event,\n    \"Events\": Events,\n    \"EventDispatcher\": EventDispatcher,\n    \"Plugin\": PromisePlugin,\n    \"FlashPlugin\": FlashPromisePlugin,\n    \"AdPlugin\": AdPromisePlugin,\n    \"DataBinding\": DataBinding,\n    \"Logger\": Logger,\n    \"Transformer\": Transformer,\n    \"TransformType\": TransformType\n  }\n};\n\nObject.defineProperties(global[\"akamai\"][\"amp\"], {\n  \"Settings\": {get: SettingsMediator.GET, enumerable: true, configurable: false}\n});\n\nif (typeof AdVO != \"undefined\")\n  global[\"akamai\"][\"amp\"][\"AdVO\"] = AdVO\n\nif (typeof AdNotifications != \"undefined\") {\n  global[\"akamai\"][\"amp\"][\"AdEvents\"] = (function () {\n    var key, value, events = {};\n    events.values = [];\n    for (key in AdNotifications) {\n      value = AdNotifications[key].replace(/^ads/, \"\");\n      events[key.replace(/^AD_/, \"\")] = value;\n      events.values.push(value);\n    }\n    return events;\n  }())\n}\n\n  /* End JS Lib\n  */\n  window[\"AKAMAI_MEDIA_PLAYER\"].saveSDK(version, global);\n}\nwindow.AKAMAI_MEDIA_PLAYER.setVersion(version);\n})();\n"

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var flashConfig = __webpack_require__(231);
	
	exports['default'] = function (pluginUrl, ampURL) {
	  return {
	    media: {
	      muted: true
	    },
	    domain: 'webmd.com',
	    paths: {
	      player: ampURL,
	      resources: ampURL
	    },
	    resources: [],
	    params: {},
	    controls: { mode: 'auto' },
	    fullscreen: {
	      enabled: true,
	      native: true
	    },
	    branding: {
	      id: 'logo',
	      logo: null
	    },
	    playoverlay: { enabled: true },
	    flash: {
	      swf: ampURL + 'AkamaiPremierPlayer.swf',
	      debug: ampURL + 'AkamaiPremierPlayer-debug.swf',
	      vars: {
	        core_ads_enabled: false,
	        auto_play_override: false
	      },
	      xml: flashConfig.replace(/\{baseSkinUrl\}/g, ampURL)
	    },
	    locales: {
	      es: {
	        MSG_RECOMMENDATIONS_TITLE: 'Recomendado',
	        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
	        MSG_RU: 'Ruso',
	        MSG_IT: 'Italiano',
	        MSG_FR: 'Francés',
	        MSG_DE: 'Alemán',
	        MSG_ES: 'Español',
	        MSG_EN: 'Inglés',
	        MSG_CC: 'CC',
	        MSG_VIDEO: ' vídeos',
	        MSG_VIEW_ALL: 'Ver todos ',
	        MSG_RECOMMENDED: 'Recomendado',
	        MSG_NEXT_VIDEO: 'El próximo video comienza en: ',
	        MSG_REPLAY: 'Repetir',
	        MSG_GO_LIVE: 'IR A VIVIR',
	        MSG_NOT_AVAILABLE: 'No está disponible',
	        MSG_MAX_BITRATE_AVAILABLE: 'Tasa de bits máxima disponible',
	        MSG_CURRENT_BITRATE_PLAYING: 'Tasa de bits de reproducción actual',
	        MSG_CURRENT_WORKING_BANDWIDTH: 'Ancho de banda actual de trabajo',
	        MSG_STREAM_NOT_FOUND: 'Stream que no se encuentra',
	        MSG_ERROR_PREFIX: 'Se produjo un error:',
	        MSG_DEFAULT_ERROR_MESSAGE: 'Lo sentimos, no hemos podido jugar los medios de comunicación seleccionados. Por favor, inténtelo de nuevo, o seleccionar los medios de comunicación alternativos.',
	        MSG_LIVE: 'EN VIVO',
	        MSG_SEEK_TO: 'Tratar de',
	        MSG_CURRENT: 'corriente',
	        MSG_PREVIEW: 'vista previa',
	        MSG_PAUSE: 'romper',
	        MSG_CUSTOMIZE_CLIP_POINTS: 'Personalizar el inicio y el punto final del video.',
	        MSG_BUFFERING_TEXT: 'el almacenamiento en búfer',
	        MSG_VERSION_TEXT: 'versión',
	        MSG_SHARE_CONTENT_DISABLED: 'Compartir e incrustar están desactivados.',
	        MSG_SHARE_CONNECT_FAILURE: 'No se puede conectar. Por favor, inténtelo de nuevo.',
	        MSG_LINK_TEXT: 'enlace',
	        MSG_EMBED_TEXT: 'incrustar',
	        MSG_POST_TEXT: 'enviar',
	        MSG_SHARE_VIDEO_TEXT: 'Comparte este vídeo...',
	        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Tu email ha sido enviado!',
	        MSG_EMAIL_SEND_FAILURE: 'El mensaje no pudo ser enviado.',
	        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: 'personajes de la izquierda',
	        MSG_EMAIL_MESSAGE_INVALID: 'Por favor limite su mensaje a 500 caracteres o menos.',
	        MSG_EMAIL_ADDRESS_INVALID: 'Dirección de correo electrónico no válida',
	        MSG_EMAIL_MESSAGE: 'mensaje',
	        MSG_EMAIL_MESSAGE_DEFAULT: 'Echa un vistazo a este video de xxx',
	        MSG_EMAIL_VIDEO: 'Enviar este vídeo',
	        MSG_EMAIL_FROM: 'de',
	        MSG_EMAIL_TO: 'a'
	      },
	      en: {
	        MSG_RECOMMENDATIONS_TITLE: 'Recommended',
	        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
	        MSG_RU: 'Russian',
	        MSG_IT: 'Italian',
	        MSG_FR: 'French',
	        MSG_DE: 'German',
	        MSG_ES: 'Spanish',
	        MSG_EN: 'English',
	        MSG_CC_APPLY: 'Apply',
	        MSG_CC_CANCEL: 'Cancel',
	        MSG_CC_RESET: 'Default',
	        MSG_CC_HIDE_ADVANCED: 'Hide Advanced Settings',
	        MSG_CC_SHOW_ADVANCED: 'Show Advanced Settings',
	        MSG_CC_OPACITY: 'Opacity :',
	        MSG_CC_WINDOW: 'Window :',
	        MSG_CC_BACKGROUND: 'Background :',
	        MSG_CC_COLOR: 'Color :',
	        MSG_CC_SCROLL: 'Scroll :',
	        MSG_CC_SIZE: 'Size :',
	        MSG_CC_EDGE: 'Edge :',
	        MSG_CC_FONT: 'Font :',
	        MSG_CC_PRESETS: 'Presets :',
	        MSG_CC_LANGUAGE: 'Track :',
	        MSG_CC_TITLE: 'Captions',
	        MSG_CC: 'CC',
	        MSG_VIDEO: ' videos',
	        MSG_VIEW_ALL: 'View all ',
	        MSG_RECOMMENDED: 'Recommended',
	        MSG_NEXT_VIDEO: 'Next video starts in: ',
	        MSG_REPLAY: 'Replay',
	        MSG_GO_LIVE: 'GO LIVE',
	        MSG_NOT_AVAILABLE: 'Not Available',
	        MSG_MAX_BITRATE_AVAILABLE: 'Max bitrate available',
	        MSG_CURRENT_BITRATE_PLAYING: 'Current bitrate playing',
	        MSG_CURRENT_WORKING_BANDWIDTH: 'Current working bandwidth',
	        MSG_STREAM_NOT_FOUND: 'Stream not found',
	        MSG_ERROR_PREFIX: 'Error encountered:',
	        MSG_DEFAULT_ERROR_MESSAGE: 'Sorry, we were unable to play the media you selected. Please try again, or select alternate media.',
	        MSG_LIVE: 'LIVE',
	        MSG_SEEK_TO: 'Seek to',
	        MSG_CURRENT: 'Currrent',
	        MSG_PREVIEW: 'Preview',
	        MSG_PAUSE: 'Pause',
	        MSG_CUSTOMIZE_CLIP_POINTS: 'Customize the start and end point of the video.',
	        MSG_BUFFERING_TEXT: 'buffering',
	        MSG_VERSION_TEXT: 'Version',
	        MSG_SHARE_CONTENT_DISABLED: 'Share and embed are disabled.',
	        MSG_SHARE_CONNECT_FAILURE: 'Unable to connect. Please try again.',
	        MSG_LINK_TEXT: 'Link',
	        MSG_EMBED_TEXT: 'Embed',
	        MSG_POST_TEXT: 'Post',
	        MSG_SHARE_VIDEO_TEXT: 'Share this video...',
	        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Your email has been sent!',
	        MSG_EMAIL_SEND_FAILURE: 'Message could not be sent.',
	        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: ' characters left',
	        MSG_EMAIL_MESSAGE_INVALID: 'Please limit your message to 500 characters or less.',
	        MSG_EMAIL_ADDRESS_INVALID: 'Invalid Email Address',
	        MSG_EMAIL_MESSAGE: 'Message',
	        MSG_EMAIL_MESSAGE_DEFAULT: 'Check out this video from xxx',
	        MSG_EMAIL_VIDEO: 'Email this video',
	        MSG_EMAIL_FROM: 'From',
	        MSG_EMAIL_TO: 'To'
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = "<application>\n  <player core_player_name=\"amp-premier-player\"\n          volume=\".75\"\n          mbr_starting_index=\"1\"\n          inpage_bitrate_index_limit=\"3\"\n          use_last_known_bitrate=\"false\"\n          use_netsession_client=\"false\"\n          netsession_install_prompt_frequency_secs=\"-1\"\n          ad_server_timeout=\"20\"\n          ad_control_enabled=\"true\"\n          dvr_enabled=\"1\"\n          branding_preload=\"none\"\n          hds_live_low_latency=\"true\"\n          fullscreen_enabled=\"true\"\n          show_feature_bar=\"false\"\n          suppress_events=\"mediaPlayerViewInitialized\"\n          caption_language=\"en-us\"\n          hds_fragment_retry_data_gap_threshold= \"20\"\n          ads_auto_fit=\"true\"\n          auto_replay=\"false\">\n  </player>\n  <view skin=\"{baseSkinUrl}webmd.assets.swf\">\n    <element id=\"endState\" enabled=\"false\" hideElements=\"viewAll\" />\n    <element id=\"logoOverlay\" style=\"height: 45px; width: 150px; right: 15px; bottom: 15px; opacity: 1.0;\"/>\n    <element id=\"captionDisplay\"\n             initState=\"off\"\n             position=\"relative\"\n             captionWidth=\"90\"\n             enabled=\"true\"\n             settingsEnabled=\"true\"\n             style=\"width: 100%; rightMargin:0; bottom: 0; windowColor:0x000000; windowOpacity:1.0; font: Arial; fontColor:0xffffff; fontBGColor:0x000000; fontBGOpacity:0; edgeType:none; edgeColor:0x000000; edgeOpacity:0; scroll:popOut; textAlign: center; fontSize:12; fontWeight:normal;\"\n             />\n    <element id=\"bufferingView\" mode=\"loader\" tether=\"true\" style=\"fontSize:30px;\" />\n    <element id=\"endSlate\" enabled=\"false\" hideElements=\"brandingLogo|viewAll\" />\n    <element id=\"controls\" height=\"28\" scrubPosition=\"inline\" itemMargin=\"5\" />\n    <element id=\"captionBtn\" />\n    <element id=\"recommendationSlate\" viewMode=\"grid\" items=\"6\" />\n    <element id=\"replayBtn\" />\n    <element id=\"playPauseBtn\" />\n    <element id=\"rewindBtn\" />\n    <element id=\"scrubBar\" style=\"height: 18px;\" />\n    <element id=\"loadedBar\" style=\"background: linear-gradient(90deg, #00FF00, #1B1B1B);\" />\n    <element id=\"playlistBtn\" />\n    <element id=\"timeLocationIndicator\" type=\"arrow\" color=\"#FFFFFF\" />\n    <element id=\"goLiveBtn\" />\n    <element id=\"shareBtn\" />\n    <element id=\"captionBtn\" />\n    <element id=\"statsBtn\" />\n    <element id=\"hdClientBtn\" />\n    <element id=\"chromecastBtn\"/>\n    <element id=\"volumeBar\" color=\"#CA2127\" />\n    <element id=\"volumeBtn\" />\n    <element id=\"fullscreenBtn\" />\n  </view>\n</application>\n"

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(233);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _screenfull = __webpack_require__(234);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _actionsAmpPlayerActions = __webpack_require__(235);
	
	exports['default'] = {
	  // mappings from Video API events to the event handlers in this
	  // store.
	  mediaEvents: {
	    playing: 'onStarted',
	    canplay: 'onCanPlay',
	    pause: 'onPause',
	    ended: 'onEnded',
	    ready: 'onReady', // relying on the video api's custom ready event instead.
	    durationchange: 'onProgress',
	    timeupdate: 'onProgress',
	    seeking: 'onBuffering',
	    volumechange: 'onVolumeChanged',
	    mute: 'onMute',
	    unmute: 'onUnmute',
	    play: 'onPlay'
	  },
	  queued: [],
	  removeMediaEvents: function removeMediaEvents() {
	    var _this = this;
	
	    (0, _lodash.keys)(this.getEventMappings()).forEach(function (event) {
	      _this.mediaApi.removeEventListener(event);
	    });
	  },
	  addMediaEvents: function addMediaEvents() {
	    var _this2 = this;
	
	    (0, _lodash.forEach)(this.getEventMappings(), function (handler, event) {
	      _this2.mediaApi.addEventListener(event, _this2[handler], _this2);
	      // For debugging:
	      //this.mediaApi.addEventListener(event, () => console.log('Media Event>', event));
	    });
	
	    _actionsAmpPlayerActions.AmpPlayerEvents.forEach(function (eventName) {
	      _this2.mediaApi.addEventListener(eventName, function (event) {
	        _actionsAmpPlayerActions.AmpPlayerActions[event.type](_this2.mediaApi);
	      });
	    });
	  },
	  getEventMappings: function getEventMappings() {
	    return (0, _lodash.defaults)(this.extraMediaEvents || {}, this.mediaEvents);
	  },
	  // shared agnostic media events
	  onCanPlay: function onCanPlay() {
	    this.setState({
	      event: 'canplay',
	      canPlay: true,
	      isBuffering: false,
	      isLoading: false
	    });
	  },
	  onEnded: function onEnded() {
	    this.state.viewed[this.state.index] = true;
	    this.setState({
	      isPlaying: false,
	      isEnded: true,
	      event: 'ended'
	    });
	  },
	  onPlay: function onPlay() {
	    if ((0, _utilsUtil.isMobile)()) {
	      if (this.state.isPlaying) this.togglePosterImg('play');
	    } else {
	      if (this.state.isPlaying) this.togglePosterImg('play');
	    }
	  },
	  onPause: function onPause() {
	    // Duplicate pause call fix.
	    if (this.state.isPlaying) {
	      this.togglePosterImg('pause');
	      this.mediaApi.pause();
	      this.setState({
	        isPlaying: false,
	        event: 'paused'
	      });
	    }
	  },
	  onSeeked: function onSeeked() {
	    this.setState({
	      event: 'seeked'
	    });
	  },
	  onMute: function onMute() {
	    this.onSetVolume(0);
	  },
	  onUnmute: function onUnmute(volume) {
	    this.onSetVolume(volume);
	  },
	  onFullScreen: function onFullScreen() {
	    var _this3 = this;
	
	    if ((0, _utilsUtil.isIOS)()) {
	      (0, _jquery2['default'])('#cme-viewport').attr('content', 'minimum-scale=0.75, maximum-scale=0.75');
	    }
	    if (!_screenfull2['default']) {
	      // no support. IE < 11 or whatever the fuck.
	      (0, _jquery2['default'])('body').addClass('fallback-fullscreen');
	    } else if (_screenfull2['default'].raw) {
	      (0, _jquery2['default'])(document).on(_screenfull2['default'].raw.fullscreenchange + '.core-video', function () {
	        if (!_screenfull2['default'].isFullscreen) {
	          _this3.onExitFullScreen();
	        }
	      });
	    } else {
	      (0, _jquery2['default'])(document).on('keyup.fs', function (e) {
	        if ((e.keyCode ? e.keyCode : e.which) === 27) {
	          _this3.onExitFullScreen();
	        }
	      });
	    }
	    this.setState({
	      event: 'fullScreen',
	      isFullScreen: true
	    });
	  },
	  onExitFullScreen: function onExitFullScreen() {
	    if ((0, _utilsUtil.isIOS)()) {
	      (0, _jquery2['default'])('#cme-viewport').attr('content', 'minimum-scale=0.75, maximum-scale=1.6');
	    }
	    if (!_screenfull2['default']) {
	      (0, _jquery2['default'])('body').removeClass('fallback-fullscreen');
	    } else if (_screenfull2['default'].raw) {
	      (0, _jquery2['default'])(document).off(_screenfull2['default'].raw.fullscreenchange + '.core-video');
	    } else {
	      (0, _jquery2['default'])(document).off('keyup.fs');
	    }
	    this.setState({
	      event: 'exitFullScreen',
	      isFullScreen: false
	    });
	  },
	  enqueue: function enqueue(method) {
	    var last = this.queued[this.queued.length - 1];
	    if (last && last[0] === method) {
	      this.queued = (0, _lodash.reject)(this.queued, function (call) {
	        return call[0] !== method;
	      });
	    }
	    this.queued.push([method, [].slice.call(arguments, 1)]);
	  },
	  dequeue: function dequeue() {
	    var _this4 = this;
	
	    this.queued.forEach(function (call) {
	      setTimeout(function () {
	        _this4[call[0]].apply(_this4, call[1]);
	      }, 500);
	    });
	    this.queued = [];
	  },
	  clearQueue: function clearQueue(method) {
	    this.queued = (0, _lodash.reject)(this.queued, function (call) {
	      return call[0] === method;
	    });
	  },
	  onStarted: function onStarted() {},
	  mouseMoveHandler: function mouseMoveHandler(e) {
	    if ((0, _utilsUtil.isDescendant)(document.getElementById('video_player_screen'), e.target)) {
	      this._clearFullScreenIdleDetection();
	      document.removeEventListener('mousemove', this.mouseMoveHandler);
	      this._setupFullScreenIdleDetection();
	    }
	  },
	  _setupFullScreenIdleDetection: function _setupFullScreenIdleDetection() {
	    var _this5 = this;
	
	    this.idleTimeoutId = setTimeout(function () {
	      _this5.setState({ isMouseIdle: true, event: 'mouseMove' });
	    }, 3000);
	    document.addEventListener('mousemove', this.mouseMoveHandler);
	  },
	  _clearFullScreenIdleDetection: function _clearFullScreenIdleDetection() {
	    clearTimeout(this.idleTimeoutId);
	    document.removeEventListener('mousemove', this.mouseMoveHandler);
	    this.setState({ isMouseIdle: false, event: 'mouseMove' });
	  },
	  // shared utility methods
	  isReady: function isReady() {
	    return this._isReady;
	  },
	  isPlayingOrLoading: function isPlayingOrLoading() {
	    console.log('==> isPlayingOrLoading');
	    return !this._isReady || this.state.isPlaying || this.state.isLoading || this.state.isBuffering;
	  },
	  togglePosterImg: function togglePosterImg(p) {
	    if (typeof this.posterElement !== 'undefined') {
	      p === 'pause' ? this.posterElement.show() : this.posterElement.hide();
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)(module)))

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v4.0.1 - 2019-02-18
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				return new Promise(function (resolve) {
					var request = fn.requestFullscreen;
	
					var onFullScreenEntered = function () {
						this.off('change', onFullScreenEntered);
						resolve();
					}.bind(this);
	
					elem = elem || document.documentElement;
	
					// Work around Safari 5.1 bug: reports support for
					// keyboard in fullscreen even though it doesn't.
					// Browser sniffing, since the alternative with
					// setTimeout is even worse.
					if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
						elem[request]();
					} else {
						elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
					}
	
					this.on('change', onFullScreenEntered);
				}.bind(this));
			},
			exit: function () {
				return new Promise(function (resolve) {
					if (!this.isFullscreen) {
						resolve();
						return;
					}
	
					var onFullScreenExit = function () {
						this.off('change', onFullScreenExit);
						resolve();
					}.bind(this);
	
					document[fn.exitFullscreen]();
	
					this.on('change', onFullScreenExit);
				}.bind(this));
			},
			toggle: function (elem) {
				return this.isFullscreen ? this.exit() : this.request(elem);
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	/*
		AMP Player Events
	
		https://community.akamai.com/docs/DOC-5549-amp-api#jive_content_id_Player_Events
	
	*/
	var AmpPlayerEvents = ['activestatechange', 'canplay', 'canplaythrough', 'displaystatechange', 'durationchange', 'ended', 'error', 'initialized', 'loadedmeatadata', 'loadstart', 'mediaPlayerID3Updated', 'mediaPlayeronTextData', 'mediasequenceended', 'mediasequencestarted', 'mediumchange', 'mutechange', 'pause', 'play', 'playbacktargetchange', 'playing', 'playrequest', 'playstatechange', 'progress', 'ready', 'seeked', 'seeking', 'started', 'timedmetadata', 'timeupdate', 'volumechange', 'waiting', 'setMedia' // Switch the video with AMP
	];
	
	var AmpPlayerActions = _reflux2['default'].createActions(AmpPlayerEvents);
	
	exports.AmpPlayerActions = AmpPlayerActions;
	exports.AmpPlayerEvents = AmpPlayerEvents;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports['default'] = {
	  init: function init() {
	    this.state = this._getInitialState();
	  },
	  _getInitialState: function _getInitialState() {
	    if (this.getInitialState) return this.getInitialState();
	    if (this.initialState) return this.initialState;
	    return {};
	  },
	  resetState: function resetState() {
	    this.state = this.getInitialState();
	  },
	  setState: function setState(state) {
	    this.updateState({
	      $merge: state
	    });
	  },
	  updateState: function updateState(query) {
	    var update = __webpack_require__(237);
	    this.state = update(this.state, query);
	    Object.freeze(this.state);
	    if (this.stateNamespace) {
	      this.trigger(_defineProperty({}, this.stateNamespace, this.state));
	    } else {
	      this.trigger(this.state);
	    }
	  },
	  getState: function getState() {
	    return this.state;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	var invariant = __webpack_require__(15);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = '$push';
	var COMMAND_UNSHIFT = '$unshift';
	var COMMAND_SPLICE = '$splice';
	var COMMAND_SET = '$set';
	var COMMAND_MERGE = '$merge';
	var COMMAND_APPLY = '$apply';
	
	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  var specValue = spec[command];
	  invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	      'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  );
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	      'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  );
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    );
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    invariant(
	      mergeObj && typeof mergeObj === 'object',
	      "update(): %s expects a spec of type 'object'; got %s",
	      COMMAND_MERGE,
	      mergeObj
	    );
	    invariant(
	      nextValue && typeof nextValue === 'object',
	      "update(): %s expects a target of type 'object'; got %s",
	      COMMAND_MERGE,
	      nextValue
	    );
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    );
	    invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    );
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	          'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      );
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    );
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsDescriptor_actions = __webpack_require__(239);
	
	var _actionsDescriptor_actions2 = _interopRequireDefault(_actionsDescriptor_actions);
	
	var _descriptorCompiler = __webpack_require__(240);
	
	var _descriptorCompiler2 = _interopRequireDefault(_descriptorCompiler);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _actionsChapter_actions = __webpack_require__(244);
	
	var _actionsChapter_actions2 = _interopRequireDefault(_actionsChapter_actions);
	
	exports['default'] = _reflux2['default'].createStore({
	  mixins: [_mixinsStore_state2['default'], _mixinsHas_pretty_time2['default']],
	  listenables: _actionsDescriptor_actions2['default'],
	  stateNamespace: 'descriptor',
	  defaultVideoOptions: {
	    shouldShowControlsDesktop: true,
	    shouldShowNativeControlsMobile: true,
	    shouldAutoPlay: false,
	    watermark: null
	  },
	  onLoadJSON: function onLoadJSON(descriptor) {
	    this.compile(descriptor);
	  },
	  getTitle: function getTitle(index) {
	    return this.state.videos[index].title;
	  },
	  getDescriptor: function getDescriptor() {
	    return this.state;
	  },
	  isVideo: function isVideo() {
	    return this.state.isVideo;
	  },
	  getInitialIndex: function getInitialIndex() {
	    return this.state.initialIndex;
	  },
	  getVideo: function getVideo(index) {
	    return this.state.videos[index];
	  },
	  getCCFileRoot: function getCCFileRoot() {
	    return this.state.config.ccFileRoot;
	  },
	  hasCCEnabled: function hasCCEnabled(index) {
	    return this.state.videos[index].hasCc;
	  },
	  getCCInfo: function getCCInfo() {
	    return this.state.ccInfo;
	  },
	  getCCArray: function getCCArray(index) {
	    return this.state.videos[index].ccInfo;
	  },
	  getVideos: function getVideos() {
	    return this.state.videos;
	  },
	  getVideoCount: function getVideoCount() {
	    return this.state.videos.length;
	  },
	  getCCDefaultLang: function getCCDefaultLang() {
	    return this.state.config.ccDefaultLang;
	  },
	  compile: function compile(descriptor) {
	    var compiler = new _descriptorCompiler2['default'](descriptor);
	    compiler.compile();
	    this.setState(compiler.getDescriptor());
	    _actionsChapter_actions2['default'].loadLocks(compiler.getDescriptor().lockChildren);
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var Actions = _reflux2['default'].createActions({
	  loadJSON: {}
	});
	
	exports['default'] = Actions;
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _descriptorVideo_compiler = __webpack_require__(241);
	
	var _descriptorVideo_compiler2 = _interopRequireDefault(_descriptorVideo_compiler);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _import = __webpack_require__(200);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var Compiler = function Compiler(descriptor) {
	  this.descriptor = descriptor;
	};
	
	Compiler.prototype = {
	  compile: function compile() {
	    this.sniff();
	    this.mediaCompiler.compile();
	    this.descriptor.videos = this.mediaCompiler.getVideos();
	
	    // If the property "events" exists then the Guided Video feature is active
	    if ((this.descriptor.videos[0].hasOwnProperty('events') || (0, _import.get)(this, 'this.descriptor.videos[1].hasOwnProperty("events")', {})) && this.descriptor.rememberMe === false) {
	      // If the Video Guided feature is active then we disable the startVideo feature
	    } else {
	        if (typeof (0, _utilsUtil.getParams)().startVideo !== 'undefined') {
	          var inIndex = parseInt((0, _utilsUtil.getParams)().startVideo - 1, 10);
	          if (!isNaN(inIndex)) {
	            this.descriptor.initialIndex = inIndex > this.descriptor.videos.length || inIndex < 0 ? 0 : inIndex;
	          }
	        } else if (window.location.hash) {
	          var hashIndex = parseInt(window.location.hash.substr(1) - 1, 10);
	          if (!isNaN(hashIndex)) {
	            this.descriptor.initialIndex = hashIndex > this.descriptor.videos.length || hashIndex < 0 ? 0 : hashIndex;
	          }
	        }
	      }
	
	    // if tacticIndex is not null and is not greater than video length, then initialIndex = tacticIndex
	    if (this.descriptor.tacticIndex && !(this.descriptor.tacticIndex > this.descriptor.videos.length)) {
	      this.descriptor.initialIndex = this.descriptor.tacticIndex;
	    }
	
	    this.descriptor.lockChildren = (0, _import.flatten)(this.descriptor.videos.map(function (inVideo) {
	      if (Array.isArray(inVideo.events)) {
	        var videoLockedChildren = inVideo.events.reduce(function (acc, val) {
	          return acc.concat(val.lockChildren);
	        }, []);
	        return videoLockedChildren;
	      } else {
	        return [];
	      }
	    }));
	
	    var cookieName = 'guidedVideo',
	        lastUnlockedVideo = 1,
	        lockCss = (0, _import.get)(this, 'descriptor.videos[0].events[0].lockDisplay', ''),
	        class_name = '',
	        x = 2;
	
	    // Gray-out or hide all the chapters except the first one
	    if (lockCss === 'hide') {
	      class_name = 'hide-playlist';
	    } else if (lockCss === 'grayout') {
	      class_name = 'gray-out';
	    }
	
	    lastUnlockedVideo = this.getCookie(cookieName);
	    x = Number(lastUnlockedVideo) + 1;
	
	    for (x + 1; x <= (0, _jquery2['default'])('.chapter-link-in-menu').length; x++) {
	      (0, _jquery2['default'])('#chapter-' + x).addClass(class_name);
	    }
	
	    this.descriptor.lockChildren = this.descriptor.lockChildren.filter(function (index) {
	      return index > lastUnlockedVideo;
	    });
	
	    if (!this.descriptor.initialIndex) {
	      this.descriptor.initialIndex = 0;
	    }
	    return this;
	  },
	  sniff: function sniff() {
	    this.mediaCompiler = new _descriptorVideo_compiler2['default'](this.descriptor.videos, this.descriptor.ccInfo);
	    this.descriptor.isVideo = true;
	  },
	  getDescriptor: function getDescriptor() {
	    return this.descriptor;
	  },
	  getCookie: function getCookie(name) {
	    var nameEQ = name + '=',
	        ca = document.cookie.split(';'),
	        i = 0,
	        c = '';
	    for (i; i < ca.length; i++) {
	      var _c = ca[i];
	      while (_c.charAt(0) === ' ') _c = _c.substring(1, _c.length);
	      if (_c.indexOf(nameEQ) === 0) return _c.substring(nameEQ.length, _c.length);
	    }
	    return 1;
	  }
	};
	
	exports['default'] = Compiler;
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _mixinsDescriptor_compiler_methods = __webpack_require__(243);
	
	var _mixinsDescriptor_compiler_methods2 = _interopRequireDefault(_mixinsDescriptor_compiler_methods);
	
	var STREAM_CDN_HOST = '//webmd-vh.akamaihd.net',
	    MP4_CDN_HOST = '//webmd-a.akamaihd.net';
	
	var VideoCompiler = function VideoCompiler(videos, ccInfo) {
	  this.videos = (0, _import.flatten)([videos]);
	  this.isValid = true;
	  this.ccInfo = ccInfo;
	};
	
	VideoCompiler.prototype = (0, _utilsUtil.mixin)(_mixinsHas_pretty_time2['default'], _mixinsDescriptor_compiler_methods2['default'], {
	  compile: function compile() {
	    return this.prefixImageRefs().setDurations().buildSources().setCC();
	  },
	  setCC: function setCC() {
	    var _this = this;
	
	    this.each(function (video) {
	      _this._setClosedCaptioning(video.ccFileRoot, video.ccInfo, video);
	    });
	  },
	  _setClosedCaptioning: function _setClosedCaptioning(prefix, captions, video) {
	    if (prefix && !(0, _import.isEmpty)(captions)) {
	      video.track = (0, _import.reduce)(captions, function (acc, caption, key) {
	        // sloppy data :/
	        if (key !== '') {
	          // ALSO SLOPPY DATA
	          var url = '/' + prefix.replace(/^en\//, '') + '/' + caption;
	          url = url.replace(/\/\//g, '/');
	          url = (0, _utilsUtil.imageServer)((0, _utilsUtil.envCheck)()) + url;
	          return acc.concat({
	            kind: 'captions',
	            type: 'application/ttml+xml',
	            srclang: key.toLowerCase(),
	            src: (0, _utilsUtil.isLocal)() ? '/assets/xml/cc/' + caption : url
	          });
	        } else {
	          return acc;
	        }
	      }, []);
	    }
	  },
	  buildSources: function buildSources(defaultRes) {
	    var res = defaultRes || '750k';
	    this.each(function (video) {
	      if ((0, _import.isArray)(video.source)) return;
	      var fragment = video.source;
	      video.source = [{
	        src: STREAM_CDN_HOST + '/i/delivery' + fragment + '.csmil/master.m3u8',
	        type: 'application/x-mpegURL'
	      }, {
	        src: STREAM_CDN_HOST + '/z/delivery' + fragment + '.csmil/manifest.f4m',
	        type: 'video/f4m'
	      }, {
	        src: MP4_CDN_HOST + '/delivery' + fragment.split(',')[0] + res + '.mp4',
	        type: 'video/mp4'
	      }];
	    });
	    return this;
	  },
	
	  getVideos: function getVideos() {
	    return this.videos;
	  },
	  getVideo: function getVideo(i) {
	    return this.videos[i];
	  },
	  each: function each(f) {
	    if (!this.isValid) {
	      console.warn('attempting to compile a video config that doesn\'t have any video resources.');
	      return;
	    }
	    this.videos.forEach(f);
	  }
	});
	
	exports['default'] = VideoCompiler;
	module.exports = exports['default'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	/**
	 * Utility mixin for dealing with times in the format: HH:MM:SS
	 */
	exports['default'] = {
	  /**
	   * @param {string} prettyTime - Time in the format HH::MM:SS
	   * @returns {number} - Seconds
	   */
	  secondsFromPrettyTime: function secondsFromPrettyTime(prettyTime) {
	    return _import2['default'].reduce(prettyTime.split(':').reverse(), function (state, chunk) {
	      return {
	        seconds: state.seconds + parseInt(chunk, 10) * state.multiplier,
	        multiplier: state.multiplier * 60
	      };
	    }, { seconds: 0, multiplier: 1 }).seconds;
	  },
	  /**
	   * @param {number} seconds
	   * @param {number} [places=3] - The number of places to return. E.g. 3 -> '00:00:00' 2 -> '00:00'
	   */
	  secondsToPrettyTime: function secondsToPrettyTime(seconds, places) {
	    var hours = Math.floor(seconds / 3600),
	        minutes = Math.floor((seconds - hours * 3600) / 60),
	        times = [hours, minutes, Math.floor(seconds - hours * 3600 - minutes * 60)],
	        offset = undefined;
	
	    if (places) {
	      offset = times.length - places;
	    } else {
	      offset = seconds > 60 * 60 ? 0 : 1;
	    }
	
	    return _import2['default'].map(times.slice(offset), function (time) {
	      if (isNaN(time)) {
	        return '00';
	      } else if (time < 10) {
	        return '0' + time;
	      } else {
	        return time.toString();
	      }
	    }).join(':');
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = {
	  setDurations: function setDurations() {
	    var _this = this;
	
	    this.each(function (video) {
	      if (video.duration && typeof video.duration !== 'number') {
	        video.duration = _this.secondsFromPrettyTime(video.duration);
	      }
	    });
	    return this;
	  },
	  /*
	   * This is a temporary measure as the image paths are coming through prefixed with a bloody `en`
	   */
	  prefixImageRefs: function prefixImageRefs() {
	    this.each(function (media) {
	      ['poster', 'bumperImage', 'watermark'].forEach(function (key) {
	        // FIXME: I REALLY dislike shoving the envCheck in here.
	        // This is only for CME and it's so that we can test locally with
	        // remote config json.
	        if (media[key]) {
	          var env = (0, _utilsUtil.isLocal)() ? '.proddev' : (0, _utilsUtil.envCheck)(),
	              posterPath = media.poster,
	              http = 'http';
	          // We check if the poster is relative path or full URL
	          if (posterPath.search(http) === -1) {
	            media[key] = (0, _utilsUtil.imageServer)(env) + '/' + media[key].replace(/^en\//, '') + media.posterFileName;
	          } else {
	            media[key] = '' + media[key].replace(/^en\//, '') + media.posterFileName;
	          }
	        }
	      });
	    });
	    return this;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	exports['default'] = _reflux2['default'].createActions(['removeLocks', 'loadLocks']);
	module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _actionsRoadblock_actions = __webpack_require__(246);
	
	var _actionsRoadblock_actions2 = _interopRequireDefault(_actionsRoadblock_actions);
	
	var _import = __webpack_require__(200);
	
	exports['default'] = _reflux2['default'].createStore({
	  listenables: _actionsRoadblock_actions2['default'],
	  mixins: [_mixinsStore_state2['default'], _mixinsHas_pretty_time2['default']],
	  getInitialState: function getInitialState() {
	    return { roadblocks: [] };
	  },
	  getRoadBlockedTime: function getRoadBlockedTime() {
	    return this.state.minTime;
	  },
	  onClearRoadBlock: function onClearRoadBlock(qaidFormPage) {
	    var filteredRoadblocks = this.state.roadblocks.filter(function (roadblock) {
	      return roadblock.qaidFormPage !== qaidFormPage;
	    });
	    this.setState({
	      roadblocks: filteredRoadblocks,
	      minTime: this.getNewMinTime(filteredRoadblocks)
	    });
	  },
	  getNewMinTime: function getNewMinTime(segments) {
	    var _this = this;
	
	    var roadblocks = segments || this.state.roadblocks,
	        minTime = roadblocks.reduce(function (previousValue, currentValue) {
	      return Math.min(previousValue, _this.secondsFromPrettyTime(currentValue.startTime));
	    }, Number.MAX_VALUE);
	    return minTime;
	  },
	  onSetUpRoadBlocks: function onSetUpRoadBlocks(segments) {
	    if (!(0, _import.isEmpty)(segments)) {
	      var roadblockedSegments = segments.map(function (roadblock) {
	        // eslint-disable-line prefer-const
	        var newRoadblock = {
	          cleared: false,
	          endTime: roadblock.endTime,
	          qaidFormPage: roadblock.qaidFormPage,
	          startTime: roadblock.startTime
	        };
	        return newRoadblock;
	      });
	      this.setState({
	        roadblocks: roadblockedSegments,
	        minTime: this.getNewMinTime(roadblockedSegments)
	      });
	    }
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var RoadBlockActions = _reflux2['default'].createActions(['setUpRoadBlocks', 'getRoadBlocks', 'clearRoadBlock']);
	
	exports['default'] = RoadBlockActions;
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _mixinsDescriptor_compiler_methods = __webpack_require__(243);
	
	var _mixinsDescriptor_compiler_methods2 = _interopRequireDefault(_mixinsDescriptor_compiler_methods);
	
	var EventCompiler = function EventCompiler(events, slideRoot) {
	  this.events = (0, _import.flatten)([events]);
	  this.slideRoot = slideRoot;
	  this.isValid = !!events[0];
	};
	
	EventCompiler.prototype = (0, _utilsUtil.mixin)(_mixinsHas_pretty_time2['default'], _mixinsDescriptor_compiler_methods2['default'], {
	  compile: function compile() {
	    this.buildEvents();
	    return this;
	  },
	  buildEvents: function buildEvents() {
	    var _this = this;
	
	    if (!this.isValid) return this;
	    this.events = this.events.reduce(function (acc, event) {
	      switch (event.type) {
	        case 'unlockVideos':
	          acc.locks.push(event);
	          break;
	        default:
	          console.warn('Unidentified event type: ' + event.type + ' in stream', event);
	      }
	      if (event.chapterTitle) {
	        var lastTitle = (0, _import.last)(acc.chapters) && (0, _import.last)(acc.chapters).title;
	        if (lastTitle !== event.chapterTitle) {
	          acc.chapters.push({
	            title: event.chapterTitle,
	            startTime: event.startTime,
	            // this is for the webmd video lib.
	            startSeconds: _this.secondsFromPrettyTime(event.startTime)
	          });
	        }
	      }
	      return acc;
	    }, { locks: [] });
	
	    return this;
	  },
	
	  getEvents: function getEvents() {
	    return this.isValid ? this.events : {};
	  }
	});
	exports['default'] = EventCompiler;
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, $) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(205);
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _mixinsRenders_video_components = __webpack_require__(250);
	
	var _mixinsRenders_video_components2 = _interopRequireDefault(_mixinsRenders_video_components);
	
	var _mixinsToggles_play = __webpack_require__(254);
	
	var _mixinsToggles_play2 = _interopRequireDefault(_mixinsToggles_play);
	
	var _actionsDescriptor_actions = __webpack_require__(239);
	
	var _actionsDescriptor_actions2 = _interopRequireDefault(_actionsDescriptor_actions);
	
	var _storesDescriptor_store = __webpack_require__(238);
	
	var _storesDescriptor_store2 = _interopRequireDefault(_storesDescriptor_store);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	var _componentsPlayerTap_sound = __webpack_require__(255);
	
	var _componentsPlayerTap_sound2 = _interopRequireDefault(_componentsPlayerTap_sound);
	
	var _componentsPlayerControls = __webpack_require__(257);
	
	var _componentsPlayerControls2 = _interopRequireDefault(_componentsPlayerControls);
	
	var _componentsPlayerScreen = __webpack_require__(269);
	
	var _componentsPlayerScreen2 = _interopRequireDefault(_componentsPlayerScreen);
	
	__webpack_require__(271);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'StandalonePlayer',
	  propTypes: {
	    id: _react.PropTypes.string,
	    descriptorURL: _react.PropTypes.string,
	    descriptorJSON: _react.PropTypes.object,
	    onVideoEnd: _react.PropTypes.func,
	    videoIndex: _react.PropTypes.number,
	    hasCC: _react.PropTypes.bool,
	    mediaApi: _react.PropTypes.object
	  },
	  mixins: [(0, _reflux.connect)(_storesDescriptor_store2['default']), (0, _reflux.connect)(_storesVideo_store2['default']), _mixinsRenders_video_components2['default'], _mixinsToggles_play2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      videoElementId: 'medscape-akamai-video-container'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { video: {} };
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.descriptorJSON) {
	      _actionsDescriptor_actions2['default'].loadJSON(this.props.descriptorJSON);
	    } else {
	      _actionsDescriptor_actions2['default'].load(this.props.descriptorURL);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (this.state.video.currentVolume !== nextState.video.currentVolume) {
	      return true;
	    }
	    var descriptor = this.state.descriptor,
	        video = nextState.video;
	
	    if (video.event === 'ended') {
	      if (this.props.onVideoEnd) this.props.onVideoEnd(video.index);
	    }
	
	    return nextState.descriptor !== descriptor || nextState.video.isFullScreen !== this.state.video.isFullScreen || nextState.video.isLoading !== this.state.video.isLoading || nextState.video.isPlaying !== this.state.video.isPlaying;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if ((0, _utilsUtil.isIpad)() && this.state.video.isFullScreen === false) {
	      $('body').removeClass('body-fs');
	      $('#bp_content').removeClass('body-fs');
	      $('#mobile_ISI').removeClass('mobile_ISI-fs');
	    }
	  },
	  renderControls: function renderControls() {
	    if (!(0, _utilsUtil.isIpad)() && (0, _utilsUtil.isMobile)()) {
	      return null;
	    } else {
	      return _react2['default'].createElement(_componentsPlayerControls2['default'], {
	        playerId: this.props.id,
	        hasCC: this.props.hasCC });
	    }
	  },
	  renderVideo: function renderVideo(descriptor) {
	    var videoIndex = this.state.video.index || this.props.videoIndex || descriptor.initialIndex,
	        video = descriptor.videos[videoIndex],
	        classNames = undefined;
	    var controls = this.renderControls();
	
	    if (typeof video === 'undefined') {
	      console.warn('Warning, no start video at index:' + this.props.videoIndex);
	      videoIndex = 0;
	      video = descriptor.videos[videoIndex];
	    }
	
	    classNames = (0, _classnames2['default'])({
	      'video-player-standalone': true,
	      'is-fullscreen': this.state.video.isFullScreen,
	      'is-playing': this.state.video.isPlaying
	    });
	    var watermark = (0, _import.get)(video, 'options.watermark', null);
	    return _react2['default'].createElement(
	      'div',
	      { className: classNames, id: this.props.id },
	      _react2['default'].createElement(_componentsPlayerScreen2['default'], {
	        onTouchEnd: this.start,
	        isPlaying: this.state.video.isPlaying,
	        shouldShowNativeControls: !controls,
	        watermark: watermark,
	        videoElementId: 'medscape-akamai-video-container',
	        videoIndex: videoIndex,
	        video: video }),
	      controls,
	      _react2['default'].createElement(_componentsPlayerTap_sound2['default'], null)
	    );
	  },
	  render: function render() {
	    var descriptor = this.state.descriptor;
	    if (descriptor) {
	      return this.renderVideo(descriptor);
	    } else {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'video-player-empty-shell' },
	        'loading. . .'
	      );
	    }
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "standalone_player.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), __webpack_require__(3)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = {
	  renderOverlay: function renderOverlay() {
	    var isDesktopOrIOS = !(0, _utilsUtil.isMobile)() || (0, _utilsUtil.isIOS)(),
	        isNotPlaying = !this.state.video.isPlaying;
	    if (isNotPlaying && isDesktopOrIOS) {
	      return _react2['default'].createElement('div', { ref: 'overlay',
	        className: 'video-player-overlay',
	        onClick: this.start,
	        onTouchEnd: this.start });
	    } else {
	      return null;
	    }
	  }
	};
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "renders_video_components.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isReactClassish = __webpack_require__(252),
	    isReactElementish = __webpack_require__(253);
	
	function makeExportsHot(m, React) {
	  if (isReactElementish(m.exports, React)) {
	    // React elements are never valid React classes
	    return false;
	  }
	
	  var freshExports = m.exports,
	      exportsReactClass = isReactClassish(m.exports, React),
	      foundReactClasses = false;
	
	  if (exportsReactClass) {
	    m.exports = m.makeHot(m.exports, '__MODULE_EXPORTS');
	    foundReactClasses = true;
	  }
	
	  for (var key in m.exports) {
	    if (!Object.prototype.hasOwnProperty.call(freshExports, key)) {
	      continue;
	    }
	
	    if (exportsReactClass && key === 'type') {
	      // React 0.12 also puts classes under `type` property for compat.
	      // Skip to avoid updating twice.
	      continue;
	    }
	
	    var value;
	    try {
	      value = freshExports[key];
	    } catch (err) {
	      continue;
	    }
	
	    if (!isReactClassish(value, React)) {
	      continue;
	    }
	
	    if (Object.getOwnPropertyDescriptor(m.exports, key).writable) {
	      m.exports[key] = m.makeHot(value, '__MODULE_EXPORTS_' + key);
	      foundReactClasses = true;
	    } else {
	      console.warn("Can't make class " + key + " hot reloadable due to being read-only. To fix this you can try two solutions. First, you can exclude files or directories (for example, /node_modules/) using 'exclude' option in loader configuration. Second, if you are using Babel, you can enable loose mode for `es6.modules` using the 'loose' option. See: http://babeljs.io/docs/plugins/transform-es2015-modules-commonjs/#options-loose and http://babeljs.io/docs/usage/options/");
	    }
	  }
	
	  return foundReactClasses;
	}
	
	module.exports = makeExportsHot;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	function hasRender(Class) {
	  var prototype = Class.prototype;
	  if (!prototype) {
	    return false;
	  }
	
	  return typeof prototype.render === 'function';
	}
	
	function descendsFromReactComponent(Class, React) {
	  if (!React.Component) {
	    return false;
	  }
	
	  var Base = Object.getPrototypeOf(Class);
	  while (Base) {
	    if (Base === React.Component) {
	      return true;
	    }
	
	    Base = Object.getPrototypeOf(Base);
	  }
	
	  return false;
	}
	
	function isReactClassish(Class, React) {
	  if (typeof Class !== 'function') {
	    return false;
	  }
	
	  // React 0.13
	  if (hasRender(Class) || descendsFromReactComponent(Class, React)) {
	    return true;
	  }
	
	  // React 0.12 and earlier
	  if (Class.type && hasRender(Class.type)) {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isReactClassish;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var isReactClassish = __webpack_require__(252);
	
	function isReactElementish(obj, React) {
	  if (!obj) {
	    return false;
	  }
	
	  return Object.prototype.toString.call(obj.props) === '[object Object]' &&
	         isReactClassish(obj.type, React);
	}
	
	module.exports = isReactElementish;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = {
	  toggle: function toggle(e) {
	    if (_storesVideo_store2['default'].isPlaying()) {
	      this.stop(e);
	    } else {
	      this.start(e);
	    }
	  },
	  stop: function stop(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    _actionsVideo_actions2['default'].pause();
	  },
	  start: function start(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var media = this.state.video || this.state.audio;
	    if (media.event === 'ended') {
	      _actionsVideo_actions2['default'].replay();
	    } else {
	      if ((0, _utilsUtil.isIOS)()) {
	        // KILL ME. This is to get around iOS horseshit.
	        // The indirection of:
	        // VideoActions.start() => VideoStore.onStart() => videoApi.play()
	        // makes it appear that the click event isn't driving the
	        // `play` call, so we have to grab the api and call it
	        // directly here.
	        media.api.play();
	      } else {
	        _actionsVideo_actions2['default'].start();
	      }
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _storesTapForSoundStore = __webpack_require__(256);
	
	var _storesTapForSoundStore2 = _interopRequireDefault(_storesTapForSoundStore);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.TapSound',
	  mixins: [_reflux2['default'].connect(_storesTapForSoundStore2['default'])],
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return nextState.isVisible != this.state.isVisible;
	  },
	  unmute: function unmute(e) {
	    _actionsVideo_actions2['default'].unmute();
	  },
	  render: function render() {
	    if (this.state.isVisible == false) {
	      return null;
	    }
	    var classNames = (0, _classnames2['default'])({
	      'tap-for-sound': true
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'tap-for-sound-layer', onClick: this.unmute },
	      _react2['default'].createElement('span', { className: classNames })
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "tap_sound.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _actionsAmpPlayerActions = __webpack_require__(235);
	
	exports['default'] = _reflux2['default'].createStore({
	  listenables: [],
	  mixins: [_mixinsStore_state2['default']],
	  init: function init() {
	    this.state = this.getInitialState();
	    this.listenTo(_actionsAmpPlayerActions.AmpPlayerActions.volumechange, this.onVideoVolumeChange.bind(this));
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isVisible: true
	    };
	  },
	  onVideoVolumeChange: function onVideoVolumeChange(mediaApi) {
	    if (mediaApi.getVolume() > 0) {
	      this.stopListeningTo(_actionsAmpPlayerActions.AmpPlayerActions.volumechange);
	      this.setState({
	        isVisible: false
	      });
	    }
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(205);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _componentsPlayerProgress_bar = __webpack_require__(258);
	
	var _componentsPlayerProgress_bar2 = _interopRequireDefault(_componentsPlayerProgress_bar);
	
	var _componentsPlayerPlay_button = __webpack_require__(264);
	
	var _componentsPlayerPlay_button2 = _interopRequireDefault(_componentsPlayerPlay_button);
	
	var _componentsPlayerVolume_slider = __webpack_require__(265);
	
	var _componentsPlayerVolume_slider2 = _interopRequireDefault(_componentsPlayerVolume_slider);
	
	var _componentsPlayerCc_button = __webpack_require__(266);
	
	var _componentsPlayerCc_button2 = _interopRequireDefault(_componentsPlayerCc_button);
	
	var _componentsPlayerFullscreen_button = __webpack_require__(268);
	
	var _componentsPlayerFullscreen_button2 = _interopRequireDefault(_componentsPlayerFullscreen_button);
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.Controls',
	  propTypes: {
	    playerId: _react.PropTypes.string.isRequired,
	    ccTracks: _react.PropTypes.array,
	    hasCC: _react.PropTypes.bool,
	    hasPlay: _react.PropTypes.bool,
	    hasScrub: _react.PropTypes.bool,
	    hasLength: _react.PropTypes.bool,
	    hasProgress: _react.PropTypes.bool,
	    hasFS: _react.PropTypes.bool,
	    autoPlayCC: _react.PropTypes.bool,
	    hasCCLangMenu: _react.PropTypes.bool,
	    hasMobileStyle: _react.PropTypes.bool,
	    isVideo: _react.PropTypes.bool
	  },
	  mixins: [(0, _reflux.connect)(_storesVideo_store2['default']), _mixinsHas_pretty_time2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hasCC: true,
	      hasPlay: true,
	      hasScrub: true,
	      hasLength: true,
	      hasFS: true,
	      hasProgress: true,
	      hasVolume: true,
	      autoPlayCC: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  renderTimeTracking: function renderTimeTracking(currentTime, duration, media) {
	    if (!(0, _import.get)(media, 'meta.hasLength', false)) {
	      return null;
	    }
	    if (!currentTime || !duration) {
	      return null;
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'video-player-time-tracking' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-player-elapsed-time' },
	        this.secondsToPrettyTime(currentTime)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-player-progress-divider' },
	        '/'
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'video-player-duration' },
	        this.secondsToPrettyTime(duration)
	      )
	    );
	  },
	  render: function render() {
	    var media = this.state.video || { isBuffering: true };
	    var currentTime = media.currentTime;
	    var classNames = (0, _classnames2['default'])({
	      'video-player-controls': true,
	      'is-playing': media.isPlaying
	    });
	    var _props = this.props;
	    var hasMobileStyle = _props.hasMobileStyle;
	    var hasPlay = _props.hasPlay;
	
	    var playButton = undefined,
	        fsButton = undefined,
	        volume = undefined,
	        captions = undefined,
	        content = undefined;
	    if ((0, _import.get)(media, 'meta.hasCc', false)) {
	      captions = _react2['default'].createElement(_componentsPlayerCc_button2['default'], { tracks: this.props.ccTracks,
	        ccLang: media.ccLang,
	        hasCCLangMenu: this.props.hasCCLangMenu,
	        isCaptioningOn: media.isCaptioningOn });
	    }
	    if (hasPlay && !hasMobileStyle) {
	      playButton = _react2['default'].createElement(_componentsPlayerPlay_button2['default'], { isPlaying: media.isPlaying, isEnded: media.isEnded });
	    }
	
	    if ((0, _import.get)(media, 'meta.hasFs', false) && !hasMobileStyle || hasMobileStyle) {
	      fsButton = _react2['default'].createElement(_componentsPlayerFullscreen_button2['default'], { isFullScreen: media.isFullScreen,
	        hasMobileStyle: this.props.hasMobileStyle,
	        isVideo: this.props.isVideo,
	        screenId: this.props.playerId });
	    }
	    if ((0, _import.get)(media, 'meta.hasVolume', false) && !hasMobileStyle) {
	      if (!(0, _utilsUtil.isIpad)()) {
	        volume = _react2['default'].createElement(_componentsPlayerVolume_slider2['default'], { currentVolume: media.currentVolume });
	      }
	    }
	    var something = (0, _classnames2['default'])({
	      'video-player-controls-wrap': true,
	      'is-idle': media.isMouseIdle
	    });
	    content = _react2['default'].createElement(
	      'div',
	      { className: something },
	      _react2['default'].createElement(_componentsPlayerProgress_bar2['default'], _extends({}, media, {
	        currentTime: currentTime,
	        hasProgress: this.props.hasProgress,
	        hasScrub: (0, _import.get)(media, 'meta.hasScrub', this.props.hasScrub),
	        hasLength: this.props.hasLength })),
	      _react2['default'].createElement(
	        'div',
	        { className: classNames },
	        playButton,
	        this.renderTimeTracking(currentTime, media.duration, media),
	        fsButton,
	        captions,
	        volume
	      )
	    );
	    return content;
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "controls.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _import = __webpack_require__(200);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _actionsCme_tracking_actions = __webpack_require__(259);
	
	var _actionsCme_tracking_actions2 = _interopRequireDefault(_actionsCme_tracking_actions);
	
	var _mixinsHas_slider_events = __webpack_require__(260);
	
	var _mixinsHas_slider_events2 = _interopRequireDefault(_mixinsHas_slider_events);
	
	var _mixinsHas_percentage_width = __webpack_require__(261);
	
	var _mixinsHas_percentage_width2 = _interopRequireDefault(_mixinsHas_percentage_width);
	
	var _mixinsIos_video_set_current_time = __webpack_require__(262);
	
	var _mixinsIos_video_set_current_time2 = _interopRequireDefault(_mixinsIos_video_set_current_time);
	
	var _componentsPlayerDrag_bar = __webpack_require__(263);
	
	var _componentsPlayerDrag_bar2 = _interopRequireDefault(_componentsPlayerDrag_bar);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.ProgressBar',
	  propTypes: {
	    currentTime: _react.PropTypes.number,
	    duration: _react.PropTypes.number,
	    isLoading: _react.PropTypes.bool,
	    isBuffering: _react.PropTypes.bool,
	    hasLength: _react.PropTypes.bool,
	    hasScrub: _react.PropTypes.bool,
	    hasProgress: _react.PropTypes.bool,
	    isFullScreen: _react.PropTypes.bool,
	    bufferredEnd: _react.PropTypes.number,
	    meta: _react.PropTypes.object
	  },
	  mixins: [_mixinsHas_slider_events2['default'], _mixinsHas_percentage_width2['default'], _mixinsIos_video_set_current_time2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hasLength: true,
	      hasScrub: true,
	      hasProgress: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isDragging: false
	    };
	  },
	  componentDidMount: function componentDidMount() {},
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    if (this.props.bufferredEnd !== nextProps.bufferredEnd) {
	      return true;
	    }
	    if (nextProps.event === 'ready') {
	      return true;
	    }
	    if (typeof nextProps.currentTime === 'undefined') {
	      return false;
	    }
	    if (typeof nextProps.duration === 'undefined') {
	      return false;
	    }
	    if (nextProps.isBuffering !== this.props.isBuffering || nextProps.isLoading !== this.props.isLoading) {
	      return true;
	    }
	    var delta = nextProps.currentTime - this.props.currentTime;
	    return nextProps.duration !== this.props.duration || Math.abs(delta) > 0.005;
	  },
	  seek: function seek(e) {
	    if (!this.props.hasScrub) return;
	    var seekTo = this.getSliderValueX(e, this.props.duration, this.props.isFullScreen, document.querySelector('.video-player-controls-wrap'));
	    _actionsCme_tracking_actions2['default'].scrub();
	    this.setCurrentTime(seekTo);
	  },
	  dragStart: function dragStart(e) {
	    if (this.props.hasScrub) {
	      this.refs.dragBar.dragStart(e);
	    }
	  },
	  render: function render() {
	    var duration = this.props.duration,
	        currentTime = this.props.currentTime,
	        style = this.getStyle(currentTime, duration, this.props.isFullScreen),
	        loadedStyle = this.getStyle(this.props.bufferredEnd, duration, this.props.isFullScreen),
	        wrapStyle = (0, _classnames2['default'])({
	      'video-player-progress-bar-wrap': true,
	      'grabbable': this.props.hasScrub,
	      'is-advertisement': (0, _import.get)(this, 'props.meta.isAdvertisement', false)
	    });
	    // NB: the drag bar is just there to make the user feel
	    // good. seek happens when the mouseup bubbles to the outter div
	    var dragBar = undefined;
	    if (this.props.hasProgress) {
	      dragBar = _react2['default'].createElement(_componentsPlayerDrag_bar2['default'], { ref: 'dragBar',
	        className: 'video-player-elapsed-time-indicator',
	        hasScrub: this.props.hasScrub,
	        currentTime: this.props.currentTime,
	        duration: this.props.duration,
	        isFullScreen: this.props.isFullScreen,
	        style: style,
	        isDragging: this.state.isDragging,
	        onDragEnd: this.seek });
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: wrapStyle,
	        onMouseUp: this.seek,
	        onTouchEnd: this.seek,
	        onMouseDown: this.dragStart,
	        onTouchStart: this.dragStart },
	      _react2['default'].createElement('div', { className: 'video-player-loaded-bar', style: loadedStyle }),
	      dragBar
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "progress_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	exports['default'] = _reflux2['default'].createActions(['scrub', 'selectLanguage', 'playlistNavigate', 'chapter', 'slideNavigate', 'slideZoom', 'slideThumb', 'slideSelect', 'closedCaption', 'playList']);
	module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = {
	  /**
	   * For controls that need to be adjusted along a slider. E.g. volume bars, video progress bars
	   *
	   * For instance
	   *   * If you have a slider that is 500 pixels long and it represents the playback time
	   *   * The playback time is 600 seconds
	   *   * The click event was at the 250th pixel
	   *   * The response will be 300 (50% of 600)
	   *
	   * @param {event} mouseEvent - An event from a click having a `.pageX` attribute
	   * @param {number} totalValue - The top end of the range being adjusted for.
	   *
	   * @returns {number} - a number that is N% of the totalValue based
	   * on where the mouse was clicked on the `mouseEvent.currentTarget`
	   */
	  getSliderValueX: function getSliderValueX(mouseEvent, totalValue, isFullScreen, sliderElement) {
	    var pageX = mouseEvent.nativeEvent ? mouseEvent.nativeEvent.pageX : mouseEvent.pageX;
	    if (isFullScreen === true) {
	      var offsetWidth = mouseEvent.currentTarget === document ? document.documentElement.offsetWidth : mouseEvent.currentTarget.offsetWidth,
	          mousePosition = pageX,
	          sliderPercent = mousePosition / offsetWidth;
	      return totalValue * sliderPercent;
	    } else {
	      var percentScrubbed = (pageX - (0, _jquery2['default'])(sliderElement).offset().left) / sliderElement.offsetWidth,
	          seekTo = percentScrubbed * totalValue;
	      return seekTo;
	    }
	  },
	  getSliderValueY: function getSliderValueY(mouseEvent, totalValue) {
	    var pageY = mouseEvent.nativeEvent ? mouseEvent.nativeEvent.pageY : mouseEvent.pageY,
	        mousePosition = pageY - this.findPos(mouseEvent.currentTarget)[1],
	        sliderPercent = mousePosition / mouseEvent.currentTarget.offsetHeight;
	    return totalValue - totalValue * sliderPercent;
	  },
	  findPos: function findPos(obj) {
	    if (obj === document) {
	      return [0, 0];
	    }
	    var curleft = 0;
	    var curtop = 0;
	    var object = obj;
	    if (obj.offsetParent) {
	      do {
	        curleft += object.offsetLeft;
	        curtop += object.offsetTop;
	      } while (object = object.offsetParent);
	      return [curleft, curtop];
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  getStyle: function getStyle(elapsed, total, fullscreen) {
	    var percent = undefined;
	    if (fullscreen === true) {
	      percent = (elapsed / total * 100).toFixed(2);
	    } else {
	      percent = (elapsed / total * 100).toFixed(2);
	    }
	    if (isNaN(percent) || percent < 0) {
	      percent = 0;
	    } else if (percent > 100) {
	      percent = 100;
	    }
	    return {
	      width: percent + '%'
	    };
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	exports['default'] = {
	  setCurrentTime: function setCurrentTime(time) {
	    if (_storesVideo_store2['default'].state.isEnded) {
	      // desktop
	      _actionsVideo_actions2['default'].replay();
	    }
	    _actionsVideo_actions2['default'].setCurrentTime(time);
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	/* eslint "react/no-did-mount-set-state": 0 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mixinsHas_percentage_width = __webpack_require__(261);
	
	var _mixinsHas_percentage_width2 = _interopRequireDefault(_mixinsHas_percentage_width);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.DragBar',
	  propTypes: {
	    onDragStart: _react.PropTypes.func,
	    onDragEnd: _react.PropTypes.func,
	    style: _react.PropTypes.object,
	    hasScrub: _react.PropTypes.bool,
	    currentTime: _react.PropTypes.number,
	    duration: _react.PropTypes.number,
	    isFullScreen: _react.PropTypes.bool
	  },
	  mixins: [_mixinsHas_percentage_width2['default']],
	  getInitialState: function getInitialState() {
	    return {
	      dragX: 0,
	      parentWidth: 1000
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var $parent = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).parent();
	    this.setState({
	      parentWidth: $parent.width()
	    });
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (nextState.dragX === 0 && nextState.isDragging === true) {
	      return false;
	    }
	    if (typeof nextState.dragX === 'undefined') {
	      return false;
	    }
	    if (nextProps.currentTime === 0) {
	      return false;
	    } else {
	      return true;
	    }
	  },
	  onMouseMove: function onMouseMove(e) {
	    var left = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).offset().left;
	    this.setState({
	      dragX: e.pageX - left
	    });
	  },
	  onTouchMove: function onTouchMove(e) {
	    e.preventDefault();
	    var $this = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)),
	        touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
	    this.setState({
	      dragX: touch.pageX - $this.offset().left
	    });
	  },
	  getCursorStyle: function getCursorStyle(elapsed, total) {
	    var num = Math.floor(elapsed / total * 10 - 10);
	    return {
	      'right': num + 1 + 'px'
	    };
	  },
	  dragStart: function dragStart(e) {
	    e.stopPropagation();
	    this.setState({
	      isDragging: true,
	      dragX: 0
	    });
	    (0, _jquery2['default'])(document).on('mousemove.drag', this.onMouseMove);
	    (0, _jquery2['default'])(document).on('mouseup.drag', this.dragEnd);
	    (0, _jquery2['default'])(document).on('touchmove', this.onTouchMove);
	    (0, _jquery2['default'])(document).on('touchend', this.dragEnd);
	    if (this.props.onDragEnd && !(0, _utilsUtil.isDescendant)(document.querySelector('.video-player-progress-bar-wrap'), e.target)) {
	      // this.props.onDragStart(e);
	    }
	  },
	  dragEnd: function dragEnd(e) {
	    if (this.state.isDragging === false) {
	      return;
	    } else {
	      (0, _jquery2['default'])(document).off('mousemove.drag');
	      (0, _jquery2['default'])(document).off('mouseup.drag');
	      (0, _jquery2['default'])(document).off('touchmove');
	      (0, _jquery2['default'])(document).off('touchend');
	      if (this.props.onDragEnd && !(0, _utilsUtil.isDescendant)(document.querySelector('.video-player-progress-bar-wrap'), e.target)) {
	        this.props.onDragEnd(e);
	      }
	    }
	    this.setState({
	      isDragging: false
	    });
	  },
	  killEvent: function killEvent(e) {
	    e.stopPropagation();
	  },
	  render: function render() {
	    var classNames = (0, _classnames2['default'])({
	      'video-player-elapsed-time-indicator': true,
	      'is-dragging': this.state.isDragging
	    }),
	        parentWidth = this.props.isFullScreen ? document.documentElement.offsetWidth : this.state.parentWidth,
	        style = this.state.isDragging ? this.getStyle(this.state.dragX, parentWidth, this.props.isFullScreen) : this.props.style;
	    var cursorStyle = this.getCursorStyle(this.props.currentTime, this.props.duration);
	    if (this.props.hasScrub) {
	      return _react2['default'].createElement(
	        'div',
	        { className: classNames,
	          onMouseDown: this.dragStart,
	          onMouseUp: this.dragEnd,
	          onClick: this.killEvent,
	          onTouchStart: this.dragStart,
	          onTouchEnd: this.dragEnd,
	          onTouchMove: this.touchMove,
	          style: style },
	        _react2['default'].createElement('div', { className: 'draggable',
	          style: cursorStyle })
	      );
	    } else {
	      return _react2['default'].createElement('div', { className: classNames, style: style });
	    }
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "drag_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.PlayButton',
	  propTypes: {
	    isPlaying: _react.PropTypes.bool,
	    isEnded: _react.PropTypes.bool
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.isPlaying !== this.props.isPlaying || nextProps.isEnded !== this.props.isEnded;
	  },
	  toggle: function toggle(e) {
	    e.preventDefault();
	    if (this.props.isPlaying) {
	      _actionsVideo_actions2['default'].pause();
	    } else if (this.props.isEnded) {
	      _actionsVideo_actions2['default'].replay();
	    } else {
	      _actionsVideo_actions2['default'].start();
	    }
	  },
	  render: function render() {
	    var playOrPause = this.props.isPlaying ? 'pause' : 'play';
	    var classNames = (0, _classnames2['default'])({
	      'video-player-play-button': true,
	      'is-playing': this.props.isPlaying
	    });
	    if (this.props.isEnded) {
	      playOrPause = 'replay';
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      { onClick: this.toggle, className: classNames },
	      playOrPause
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "play_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _mixinsHas_slider_events = __webpack_require__(260);
	
	var _mixinsHas_slider_events2 = _interopRequireDefault(_mixinsHas_slider_events);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.VolumeSlider',
	  propTypes: {
	    currentVolume: _react.PropTypes.number,
	    hasMute: _react.PropTypes.bool,
	    isFullScreen: _react.PropTypes.bool
	  },
	  mixins: [_mixinsHas_slider_events2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      currentVolume: 0.75,
	      hasMute: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      lastVolume: 0.75,
	      percentHeight: 75,
	      parentHeight: 70
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (this.state.isActive !== nextState.isActive) {
	      return true;
	    }
	    if (this.state.isDragging === true) {
	      return true;
	    }if (nextProps.currentVolume !== this.props.currentVolume) {
	      return true;
	    } else {
	      return false;
	    }
	    return true;
	  },
	  onMouseMove: function onMouseMove(e) {
	    var $this = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)),
	        percentHeight = this.getStyle($this.offset().top - e.pageY, this.state.parentHeight, this.props.isFullScreen);
	    this.setState({
	      percentHeight: percentHeight
	    });
	  },
	  onTouchMove: function onTouchMove(e) {
	    e.preventDefault();
	    var $this = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)),
	        touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
	        percentHeight = this.getStyle($this.offset().top - touch.pageY, this.state.parentHeight, this.props.isFullScreen);
	    this.setState({
	      percentHeight: percentHeight
	    });
	  },
	  setVolume: function setVolume(e) {
	    e.preventDefault();
	    _actionsVideo_actions2['default'].setVolume(this.getSliderValueY(e, 1));
	  },
	  getCursorStyle: function getCursorStyle(elapsed, total) {
	    var num = Math.floor(elapsed / total * 10 + 20);
	    return {
	      'top': num + 'px'
	    };
	  },
	  getStyle: function getStyle(elapsed, total, fullscreen) {
	    var percent = undefined;
	    if (fullscreen === true) {
	      percent = (elapsed / document.documentElement.offsetHeight * 100).toFixed(2);
	    } else {
	      percent = (elapsed / total * 100).toFixed(2);
	    }
	    if (isNaN(percent) || percent < 0) {
	      percent = 0;
	    } else if (percent > 100) {
	      percent = 100;
	    }
	    return percent;
	  },
	  killEvent: function killEvent(e) {
	    e.stopPropagation();
	  },
	  showVolumeBar: function showVolumeBar() {
	    this.setState({
	      isActive: true
	    });
	  },
	  hideVolumeBar: function hideVolumeBar(e) {
	    var isActive = false;
	    if (e.relatedTarget === document.querySelector('.video-player-progress-bar-wrap') || e.relatedTarget === document.querySelector('.video-player-elapsed-time-indicator') || e.relatedTarget === document.querySelector('.video-player-loaded-bar') || (0, _utilsUtil.isDescendant)(document.querySelector('.video-player-volume-slider'), e.relatedTarget)) {
	      isActive = true;
	    }
	    this.setState({
	      isActive: isActive
	    });
	  },
	  dragStart: function dragStart(e) {
	    e.stopPropagation();
	    this.setState({
	      isDragging: true,
	      dragY: 0
	    });
	    (0, _jquery2['default'])(document).on('mousemove.drag', this.onMouseMove);
	    (0, _jquery2['default'])(document).on('mouseup.drag', this.dragEnd);
	    (0, _jquery2['default'])(document).on('touchmove', this.onTouchMove);
	    (0, _jquery2['default'])(document).on('touchend', this.dragEnd);
	  },
	  dragEnd: function dragEnd(e) {
	    var $this = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)),
	        percentHeight = this.getStyle($this.offset().top - e.pageY, this.state.parentHeight, this.props.isFullScreen);
	    this.setState({
	      percentHeight: percentHeight
	    });
	    if (this.state.isDragging === false) {
	      return;
	    } else {
	      (0, _jquery2['default'])(document).off('mousemove.drag');
	      (0, _jquery2['default'])(document).off('mouseup.drag');
	      (0, _jquery2['default'])(document).on('touchmove');
	      (0, _jquery2['default'])(document).on('touchend');
	      _actionsVideo_actions2['default'].setVolume(percentHeight / 100);
	      this.setState({
	        isDragging: false
	      });
	    }
	  },
	  mute: function mute(e) {
	    e.preventDefault();
	    if (this.props.currentVolume === 0) {
	      _actionsVideo_actions2['default'].unmute(this.state.lastVolume);
	    } else {
	      this.setState({ lastVolume: this.props.currentVolume });
	      _actionsVideo_actions2['default'].mute(0);
	    }
	  },
	  render: function render() {
	    var currentVolume = this.props.currentVolume,
	        volumeButtonClass = (0, _classnames2['default'])({
	      'video-player-volume-muted-button': currentVolume === 0,
	      'video-player-volume-low-button': currentVolume > 0 && currentVolume <= 0.33,
	      'video-player-volume-med-button': currentVolume > 0.33 && currentVolume <= 0.66,
	      'video-player-volume-high-button': currentVolume > 0.66,
	      'video-player-volume-button': true
	    }),
	        mute = this.props.hasMute ? _react2['default'].createElement(
	      'button',
	      { ref: 'muteButton',
	        className: volumeButtonClass,
	        onClick: this.mute },
	      'M'
	    ) : null,
	        classNames = (0, _classnames2['default'])({
	      'video-player-volume-slider': true,
	      'is-muted': this.props.currentVolume === 0,
	      'is-active': this.state.isActive
	    }),
	        grabLine = (0, _classnames2['default'])({
	      grabbable: true,
	      'video-player-volume-line': true
	    }),
	        indicatorCN = (0, _classnames2['default'])({
	      grabbable: true,
	      'video-player-volume-indicator': true
	    }),
	        wrapCN = (0, _classnames2['default'])({
	      grabbable: true,
	      'video-player-volume-boundary-wrap': true
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: classNames, onMouseEnter: this.showVolumeBar, onMouseOut: this.hideVolumeBar },
	      mute,
	      _react2['default'].createElement(
	        'div',
	        { className: wrapCN, onMouseOut: this.hideVolumeBar },
	        _react2['default'].createElement(
	          'div',
	          { className: 'video-player-volume-boundary',
	            onClick: this.killEvent,
	            onMouseDown: this.dragStart,
	            onMouseUp: this.dragEnd,
	            onTouchStart: this.dragStart,
	            onTouchEnd: this.dragEnd,
	            onTouchMove: this.touchMove },
	          _react2['default'].createElement(
	            'div',
	            { className: grabLine },
	            ' '
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: indicatorCN, style: { height: this.state.percentHeight + '%' } },
	            _react2['default'].createElement('div', { className: 'video-player-volume-indicator-icon' })
	          )
	        )
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "volume_slider.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _componentsPlayerCc_list = __webpack_require__(267);
	
	var _componentsPlayerCc_list2 = _interopRequireDefault(_componentsPlayerCc_list);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.CCButton',
	  propTypes: {
	    isCaptioningOn: _react.PropTypes.bool,
	    tracks: _react.PropTypes.array,
	    ccLang: _react.PropTypes.string,
	    hasCCLangMenu: _react.PropTypes.bool
	  },
	  getInitialState: function getInitialState() {
	    return { isOpen: false };
	  },
	  setCCState: function setCCState(state) {
	    this.setState({
	      isOpen: state
	    });
	    _actionsVideo_actions2['default'].setClosedCaptioning(state);
	  },
	  toggle: function toggle() {
	    var isCaptioningOn = this.props.isCaptioningOn;
	    var isOpen = this.state.isOpen;
	
	    if (this.hasMultiple() && this.props.hasCCLangMenu) {
	      this.setState({
	        isOpen: !isOpen
	      });
	    } else {
	      _actionsVideo_actions2['default'].setClosedCaptioning(!isCaptioningOn);
	    }
	  },
	  hasMultiple: function hasMultiple() {
	    var tracks = this.props.tracks;
	
	    return tracks && tracks.length > 1;
	  },
	  render: function render() {
	    var _props = this.props;
	    var isCaptioningOn = _props.isCaptioningOn;
	    var tracks = _props.tracks;
	    var ccLang = _props.ccLang;
	    var isOpen = this.state.isOpen;
	    var classNames = (0, _classnames2['default'])({
	      'video-player-cc-button': true,
	      'is-on': isCaptioningOn,
	      'is-open': isOpen
	    });
	    var list = null;
	    if (isOpen && this.hasMultiple() && this.props.hasCCLangMenu) {
	      list = _react2['default'].createElement(_componentsPlayerCc_list2['default'], { tracks: tracks, ccLang: ccLang, clickHandler: this.setCCState });
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: classNames, onClick: this.toggle, 'data-bptrack': 'true' },
	      isCaptioningOn ? 'CC' : 'CC',
	      list
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "cc_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actionsCme_tracking_actions = __webpack_require__(259);
	
	var _actionsCme_tracking_actions2 = _interopRequireDefault(_actionsCme_tracking_actions);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.CCList',
	  propTypes: {
	    tracks: _react.PropTypes.array.isRequired,
	    clickHandler: _react.PropTypes.func.isRequired,
	    ccLang: _react.PropTypes.string
	  },
	  languages: {
	    en: 'English',
	    es: 'Spanish',
	    sp: 'Spanish',
	    ja: 'Japanese',
	    pt: 'Portuguese',
	    de: 'German',
	    fr: 'French',
	    ko: 'Korean',
	    nl: 'Dutch',
	    ar: 'Arabic',
	    zh: 'Chinese',
	    it: 'Italian',
	    da: 'Danish',
	    ru: 'Cyrillic',
	    pl: 'Polish',
	    cr: 'Character'
	  },
	  selectLanguage: function selectLanguage(lang) {
	    var _this = this;
	
	    return function () {
	      if (lang !== '') {
	        _actionsVideo_actions2['default'].selectLanguage(lang);
	        _this.props.clickHandler(true);
	        (0, _jquery2['default'])('.akamai-captioning').show();
	        _actionsCme_tracking_actions2['default'].selectLanguage(lang);
	      } else {
	        _this.props.clickHandler(false);
	        _actionsVideo_actions2['default'].selectLanguage(lang);
	        (0, _jquery2['default'])('.akamai-captioning').hide();
	      }
	    };
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var items = this.props.tracks.map(function (track, i) {
	      // eslint-disable-line
	      var classNames = (0, _classnames2['default'])({
	        'player-cc-list-item': true,
	        'is-selected': track.srclang === _this2.props.ccLang
	      });
	      var lang = _this2.languages[track.srclang] || track.srclang; // sloppy data
	      return _react2['default'].createElement(
	        'li',
	        { key: i, className: classNames, onClick: _this2.selectLanguage(track.srclang) },
	        lang
	      );
	    });
	    var offClassNames = (0, _classnames2['default'])({
	      'player-cc-list-item': true,
	      'is-selected': this.props.ccLang === ''
	    });
	    items[items.length] = _react2['default'].createElement(
	      'li',
	      { key: 'off_button', className: offClassNames, onClick: this.selectLanguage('') },
	      'Off'
	    );
	    return _react2['default'].createElement(
	      'ul',
	      { className: 'player-cc-list' },
	      items
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "cc_list.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _screenfull = __webpack_require__(234);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	// eslint-disable-line
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.FullscreenButton',
	  propTypes: {
	    isFullScreen: _react.PropTypes.bool,
	    screenId: _react.PropTypes.string,
	    hasMobileStyle: _react.PropTypes.bool,
	    isVideo: _react.PropTypes.bool
	  },
	  mixins: [_react2['default'].PureRenderMixin],
	  fullscreen: function fullscreen(e) {
	    e.preventDefault();
	    if (this.props.isFullScreen) {
	      _actionsVideo_actions2['default'].exitFullScreen();
	      (0, _jquery2['default'])('body').removeClass('body-fs');
	      (0, _jquery2['default'])('#bp_content').removeClass('body-fs');
	      (0, _jquery2['default'])('#mobile_ISI').removeClass('mobile_ISI-fs');
	      if (_screenfull2['default']) _screenfull2['default'].exit();
	    } else {
	      (0, _jquery2['default'])('body').addClass('body-fs');
	      (0, _jquery2['default'])('#bp_content').addClass('body-fs');
	      (0, _jquery2['default'])('#mobile_ISI').addClass('mobile_ISI-fs');
	      if (this.props.hasMobileStyle) {
	        _actionsVideo_actions2['default'].start();
	      }
	      _actionsVideo_actions2['default'].fullScreen();
	      if (_screenfull2['default']) _screenfull2['default'].request(document.getElementById(this.props.screenId));
	    }
	  },
	  render: function render() {
	    var classNames = (0, _classnames2['default'])({
	      'video-player-fullscreen-button': true,
	      'is-fullscreen': this.props.isFullScreen
	    });
	    return _react2['default'].createElement(
	      'button',
	      { className: classNames, onClick: this.fullscreen },
	      'FS'
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "fullscreen_button.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mixinsResizes_images = __webpack_require__(270);
	
	var _mixinsResizes_images2 = _interopRequireDefault(_mixinsResizes_images);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'Player.Screen',
	  propTypes: {
	    videoElementId: _react.PropTypes.string,
	    isPlaying: _react.PropTypes.bool,
	    isEnded: _react.PropTypes.bool,
	    hideControlsMobile: _react.PropTypes.bool,
	    video: _react.PropTypes.object
	  },
	  mixins: [_mixinsResizes_images2['default']],
	  componentDidMount: function componentDidMount() {
	    _actionsVideo_actions2['default'].load(this.props.videoElementId, this.props.video);
	    var node = _reactDom2['default'].findDOMNode(this);
	    var poster = this.props.video.poster;
	
	    var width = node.offsetWidth,
	        height = node.offsetHeight;
	    if ((0, _utilsUtil.isMobile)()) {
	      width *= 2;
	      height *= 2;
	    }
	    node.style.backgroundImage = this.resizeImageTo(poster, width + 'x' + height, 'style');
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if ((0, _utilsUtil.isApp)() || (0, _utilsUtil.isMobile)()) {
	      (0, _jquery2['default'])('video').attr('autoplay', true);
	      (0, _jquery2['default'])('video').attr('playsinline', 'playsinline');
	      (0, _jquery2['default'])('video').attr('webkit-playsinline', 'webkit-playsinline');
	
	      if (this.props.video.autoplay) {
	        (0, _jquery2['default'])('#video_player_screen').removeClass('is-paused');
	        (0, _jquery2['default'])('.video-player-standalone, .video-player-play-button').addClass('is-playing');
	      }
	    }
	
	    if (this.props.hideControlsMobile) {
	      (0, _jquery2['default'])('video').removeAttr('controls');
	    }
	    // Akamai bugged. They probobly wont fix.
	    // Our custom paused/play is more reliable so we use it to fix akamai.
	    //$('#'+this.props.videoElementId).toggleClass('akamai-paused', $('#video_player_screen').hasClass('is-paused'));
	    var videoPlayer = document.getElementById(this.props.videoElementId),
	        videoPlayerScreen = document.getElementById('video_player_screen'),
	        videoPoster = document.querySelector('.akamai-poster');
	    //console.log('video Player paused: '+videoPlayer.paused);
	    //console.log('video PlayerScreen contains(is-paused): '+videoPlayerScreen.classList.contains('is-paused'));
	
	    /*if(videoPlayerScreen.classList.contains('is-paused')){
	      videoPlayer.classList.add('akamai-ready');
	      videoPlayer.classList.add('akamai-paused');
	    } else {videoPlayer.classList.remove('akamai-paused');
	      videoPlayer.classList.remove('akamai-ready');
	    }*/
	  },
	  toggle: function toggle(e) {
	    if (e.target.nodeName === 'OBJECT') return; // ignore events that are bubbling from the flash player
	    // VideoActions.toggle();
	    /*$('.akamai-play.akamai-overlay').addClass('hide-playlist');
	    //console.log('Will check now: ',$('#medscape-akamai-video-container'));
	     if($('#medscape-akamai-video-container').hasClass('akamai-ready')){
	      //console.log('Video paused: ',VideoStore.state.isPlaying);
	    } else if ($('#medscape-akamai-video-container').hasClass('akamai-waiting')){
	      //console.log('Video playing: ',VideoStore.state.isPlaying);
	    } else {
	      //console.log('Video paused and we show icon: ',VideoStore.state.isPlaying);
	    }
	     if(!$('#medscape-akamai-video-container').hasClass('akamai-waiting')){
	      //console.log('Show icon now: ',VideoStore.state.isPlaying);
	    }*/
	  },
	  render: function render() {
	    var _props = this.props;
	    var isPlaying = _props.isPlaying;
	    var isEnded = _props.isEnded;
	    var videoElementId = _props.videoElementId;
	
	    // so that the akamai player works outside of the React render chain
	    var akamaiDiv = "<div class='content' id='" + videoElementId + "'></div>",
	        style = {
	      // backgroundImage: isPlaying? null : `url(${video.poster})`
	    },
	        classes = (0, _classnames2['default'])({
	      'video-player-screen': true,
	      'is-paused': !isPlaying,
	      'is-ended': isEnded
	    });
	    return _react2['default'].createElement('div', { onTouchEnd: this.toggle,
	      onClick: this.toggle,
	      id: 'video_player_screen',
	      className: classes,
	      style: style,
	      dangerouslySetInnerHTML: { __html: akamaiDiv } });
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "screen.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports['default'] = {
	  resizeImageTo: function resizeImageTo(path, ratio, urlType) {
	    var _ratio$split = ratio.split('x');
	
	    var _ratio$split2 = _slicedToArray(_ratio$split, 2);
	
	    var w = _ratio$split2[0];
	    var h = _ratio$split2[1];
	    var url = path + '?interpolation=lanczos-none&resize=' + w + ':' + h;
	    if (urlType === 'style') {
	      return 'url(' + url + ')';
	    } else {
	      return url;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(274)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(272, function() {
				var newContent = __webpack_require__(272);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(273)();
	exports.push([module.id, ".bp .akamai-branding-text,.bp .brand-play .akamai-caption-text p:empty{display:none}.bp .akamai-active .akamai-caption-text,.bp .akamai-cc-active .akamai-caption-text,.bp .akamai-paused .akamai-caption-text{bottom:50px!important}.bp .brand-play .akamai-play.akamai-overlay{right:45%;bottom:45%}.bp .brand-play .akamai-caption-text{background:0 0}.bp .brand-play .akamai-caption-text p{padding:2px 10px;border-radius:3px;background-color:rgba(0,0,0,.6)}.bp .brand-play-wrapper .akamai-play.akamai-overlay{background-repeat:no-repeat;height:18%;width:10%;margin:0;background-position:5% 9%;background-size:100%;background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/play-overlay.svg\")}.bp .brand-play-wrapper .akamai-play.akamai-overlay:hover{background-position:5% 9%}.bp .video-player-screen{position:relative;background-size:100%}.bp .video-player-screen:before{display:block;content:\"\";width:100%;padding-top:56.25%}.bp .video-player-screen>.content{position:absolute;top:0;left:0;right:0;bottom:0}.bp .video-player-screen .akamai-branding-logo{opacity:1}.bp .video-player-screen .akamai-ended .akamai-replay{display:none}.bp object.akamai-media-element,.bp video.akamai-media-element{width:100%}.bp .akamai-controls-native .akamai-branding.akamai-overlay{display:block}.bp .video-player-error,.bp .video-player-screen .akamai-waiting .akamai-loading.akamai-overlay,.bp .video-player-screen .akamai-waiting .akamai-waiting.akamai-overlay{display:none}.bp img.akamai-branding-image{position:absolute;bottom:10px;right:10px;height:10%;opacity:1}.bp .video-player-empty-shell{min-width:100%;height:233px;background:#6a6a6a;color:#FEFEFE;content:\"Loading. . .\";text-align:center;font-family:helvetica,arial,sans-serif;padding-top:200px}.bp .video-player-standalone{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;font-family:Arial,sans-serif;font-size:12px}.bp .video-player-error.is-error{display:block;background:#000;color:#fff}.bp .video-player-playlist .video-player-playlist-index,.bp .video-player-standalone.is-playing .akamai-poster.akamai-layer{display:none}.bp .video-player-progress-bar-wrap{background-color:#d8d8d8;height:4px}.bp .video-player-progress-bar{width:98%;height:4px;padding:0 0 0 1%}.bp .video-player-loaded-bar{background-color:#fff;position:absolute;height:4px}.bp .video-player-playlist{position:absolute;bottom:-50px;width:733px;height:50px}.bp .video-player-playlist.is-open .video-player-playlist-index{list-style:none;position:absolute;top:0;left:0;display:block;z-index:9999999;padding:12px;border:1px solid #333;background:#fff;cursor:pointer}.bp .video-player-overlay{position:absolute;top:0;left:0;width:100%;height:90%;background-position:50% 50%;z-index:10}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.bp .video-player-overlay{background-position:50% 50%;background-size:150px 150px}}.bp .video-player-controls-wrap{position:absolute;width:100%;bottom:0;height:40px;transition:height .3s}.bp .video-player-controls-wrap.is-idle{height:7px;transition:height .3s}.bp .is-idle .video-player-controls{display:none}.bp .video-player-controls{height:36px;width:100%;display:block;color:#ccc;background-color:#000;opacity:.8}.bp .video-player-controls:after{content:\"\";display:table;clear:both}.bp .video-player-controls .button,.bp .video-player-controls button{height:36px;outline:0;border:0;color:#9a9a9a;cursor:pointer;background-color:transparent}.bp .video-player-controls .video-player-play-button{float:left;width:5%;font-size:0;background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/play.svg\");background-repeat:no-repeat;background-position:center}.bp .video-player-controls .video-player-play-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/play-active.svg\")}.bp .video-player-controls .video-player-play-button.is-playing{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/pause.svg\");background-position:center}.bp .video-player-controls .video-player-play-button.is-playing:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/pause-active.svg\")}.bp .tap-for-sound-layer{position:absolute;top:0;bottom:0;left:0;right:0;z-index:200}.bp .tap-for-sound-layer .tap-for-sound{width:160px;height:40px;background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/tap-for-sound.svg\");position:absolute;top:10px;left:10px;display:block}.bp .video-player-load-progress.is-buffering,.bp .video-player-load-progress.is-loading,.bp video-player-controls.is-buffering .video-player-elapsed-time-indicator{background-image:linear-gradient(-45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);animation:move 1s linear infinite}.bp .video-player-volume-indicator,.bp .video-player-volume-line{left:49%;bottom:0;position:absolute}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:192dpi),only screen and (min-resolution:2dppx){.bp .video-player-play-button{background-position:center 7px;background-size:15px 21px}}.bp .video-player-load-progress{position:relative;height:100%;background-color:#d8d8d8}.bp .video-player-load-progress.is-buffering,.bp .video-player-load-progress.is-loading{-ms-box-sizing:border-box;box-sizing:border-box;text-align:center;line-height:3;background-color:#9a9a9a;-ms-background-size:30px 30px;background-size:30px 30px}.bp .draggable{background-color:#007cb0;position:absolute;border-radius:7px;width:10px;height:10px;right:-10px;bottom:-50%;z-index:9999999}.bp .video-player-elapsed-time-indicator{height:4px;background-color:#007cb0;width:0;position:relative}.bp .video-player-duration,.bp .video-player-elapsed-time,.bp .video-player-progress-divider{line-height:14px;height:14px;display:inline-block}.bp video-player-controls.is-buffering .video-player-elapsed-time-indicator{-ms-box-sizing:border-box;box-sizing:border-box;background-color:#e6eef2;overflow:hidden;-ms-background-size:30px 30px;background-size:30px 30px}.bp .video-player-time-tracking{margin:11px 0;width:15%;text-align:center;float:left;overflow:hidden}.bp .video-player-elapsed-time{text-align:right}.bp .video-player-progress-divider{margin:0 3px;text-align:center;color:#9a9a9a}.bp .video-player-duration{text-align:left}.bp .video-player-volume-slider{float:right;width:5%;height:36px;position:relative}.bp .video-player-volume-button{width:100%;float:left;font-size:0;background-position:right 8px}.bp .video-player-volume-high-button,.bp .video-player-volume-low-button,.bp .video-player-volume-med-button,.bp .video-player-volume-muted-button{background-position:center;background-repeat:no-repeat}.bp .video-player-volume-muted-button{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-mute.svg\")}.bp .video-player-volume-muted-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-mute-hover.svg\")}.bp .video-player-volume-low-button{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-low.svg\")}.bp .video-player-volume-low-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-low-hover.svg\")}.bp .video-player-volume-med-button{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-med.svg\")}.bp .video-player-volume-med-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-med-hover.svg\")}.bp .video-player-volume-high-button{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-high.svg\")}.bp .video-player-volume-high-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/volume-high-hover.svg\")}.bp .video-player-cc-chrome{float:left}.bp .video-player-cc-button{cursor:pointer}.bp .video-player-volume-slider.is-muted .video-player-mute-button{text-decoration:line-through;background-position:right 8px;border:1px solid #00f}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min-resolution:192dpi){.bp .video-player-volume-slider .video-player-mute-button,.bp .video-player-volume-slider.is-muted .video-player-mute-button{background-position:right 8px;background-size:22px 19px}}.bp .video-player-volume-boundary-wrap{background-color:#000;bottom:100%;height:100px;position:absolute;width:100%;margin-bottom:4px;display:none}.bp .is-active .video-player-volume-boundary-wrap{display:block}.bp .video-player-volume-boundary{height:70px;margin:15px 0;position:relative}.bp .video-player-volume-line{border-right:3px solid #FFF;height:100%;cursor:grab}.bp .video-player-volume-indicator-icon{width:11px;height:11px;background-color:#007cb0;border-radius:5px;left:-5px;position:absolute}.bp .video-player-cc-button{width:5%;float:right;height:100%;font-family:proxima-nova,sans-serif;font-size:18px;font-weight:lighter;line-height:150%;color:#fff;text-align:center;vertical-align:text-bottom;padding-top:6px}.bp .video-player-cc-button.is-on{text-decoration:underline}.bp .video-player-cc-button:hover{color:#005B81}.bp .video-player-fullscreen-button{float:right;width:5%;font-size:0;background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/enter-full-screen.svg\");background-repeat:no-repeat;background-position:center}.bp .video-player-fullscreen-button:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/enter-full-screen-active.svg\")}.bp .video-player-fullscreen-button.is-fullscreen{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/exit-full-screen.svg\")}.bp .video-player-fullscreen-button.is-fullscreen:hover{background-image:url(\"//img.medscapestatic.com/pi/core/products/brandplay/images/video-player/exit-full-screen-active.svg\")}.bp .video-player-standalone{position:relative;overflow-y:hidden}.bp .video-player-standalone.is-fullscreen{width:100%;max-width:100%;height:100%;background:#000}.bp .video-player-standalone.is-fullscreen .video-player-error,.bp .video-player-standalone.is-fullscreen .video-player-playlist{display:none}.bp .video-player-standalone.is-fullscreen .video-player-screen{transform:translateY(-50%);position:relative;top:50%}.bp .video-player-standalone.is-fullscreen .video-player-controls{bottom:0;left:0;z-index:2;webkit-transition:.5s linear;-moz-transition:.5s linear;-ms-transition:.5s linear;-o-transition:.5s linear}.bp.fallback-fullscreen .video-player-standalone.is-fullscreen{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99}@keyframes move{0%{background-position:0 0}100%{background-position:30px 30px}}.bp .json-editor{padding:1em;margin:1em;border:2px solid #CCC;border-radius:3px}.bp .json-editor.is-saved{border:2px solid #CCC}.bp .json-editor .json-editor-error-message{color:#A00;font-size:18px;font-style:italic}.bp .json-editor .json-editor-text{border:none;outline:0;font-family:Consolas,Monaco,\"Lucida Console\",\"Courier New\",mono-spaced;width:100%;height:600px}.bp .json-editor .json-editor-save-button{margin-top:24px;outline:0;color:#9a9a9a;border:1px solid #222;border-radius:3px;font-size:24px;background:#333}.bp .layout{display:block}.bp .layout .left-side{max-width:770px;width:100%;float:left}.bp .layout .right-side{float:left;width:770px}@media (min-width:1200px){.bp .layout{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.bp .layout .left-side{max-width:770px}.bp .layout .right-side{-ms-flex-positive:2;flex-grow:2;width:auto}}.bp .qna-submit-button{padding:10px 20px;display:block;background:#085a81;color:#fff;cursor:pointer;width:44px;margin:10px auto}.bp .qna-close-button{position:absolute;text-decoration:none;color:#085a81;font-weight:700;cursor:pointer;width:30px;z-index:99999;right:10px;top:10px;display:none}.bp .is-iphone .qna-close-button{display:none}.bp .qna-checkbox-question,.bp .qna-radio-question,.bp .qna-textarea-question{clear:right}.is-mobile .video-player-overlay{background-size:20%}.is-mobile audio::-webkit-media-controls,.is-mobile video::-webkit-media-controls{z-index:100}", ""]);

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _reflux = __webpack_require__(205);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPlayerPlaylist_item = __webpack_require__(276);
	
	var _componentsPlayerPlaylist_item2 = _interopRequireDefault(_componentsPlayerPlaylist_item);
	
	var _mixinsHas_node_height = __webpack_require__(277);
	
	var _mixinsHas_node_height2 = _interopRequireDefault(_mixinsHas_node_height);
	
	var _mixinsUrl_tracking = __webpack_require__(278);
	
	var _mixinsUrl_tracking2 = _interopRequireDefault(_mixinsUrl_tracking);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _storesChapter_store = __webpack_require__(279);
	
	var _storesChapter_store2 = _interopRequireDefault(_storesChapter_store);
	
	var _actionsChapter_actions = __webpack_require__(244);
	
	var _actionsChapter_actions2 = _interopRequireDefault(_actionsChapter_actions);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'BrandPlay.Chapters',
	  propTypes: {
	    viewed: _react.PropTypes.object,
	    index: _react.PropTypes.number,
	    title: _react.PropTypes.string,
	    chapters: _react.PropTypes.array,
	    headerURL: _react.PropTypes.string,
	    children: _react.PropTypes.string,
	    duration: _react.PropTypes.number,
	    hasMobileStyle: _react.PropTypes.bool,
	    useMobileMenu: _react.PropTypes.bool
	  },
	  mixins: [_mixinsHas_node_height2['default'], _mixinsUrl_tracking2['default'], (0, _reflux.connect)(_storesChapter_store2['default'])],
	  getDefaultProps: function getDefaultProps() {
	    var index = 0;
	    if (typeof (0, _utilsUtil.getParams)().startVideo !== 'undefined') {
	      index = (0, _utilsUtil.getParams)().startVideo - 1;
	    }
	    return {
	      chapters: [],
	      viewed: {},
	      index: index,
	      isiLinks: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var index = 0;
	    if (typeof (0, _utilsUtil.getParams)().startVideo !== 'undefined') {
	      index = (0, _utilsUtil.getParams)().startVideo - 1;
	    }
	    return {
	      index: index,
	      viewed: this.props.viewed,
	      enabled: true
	    };
	  },
	  createHtml: function createHtml(html) {
	    var contain = (0, _utilsUtil.isMobile)() ? html : '';
	    return { __html: contain };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var thisLock = (0, _import.get)(this, 'state.videoLocks.lock', null),
	        nextLock = (0, _import.get)(nextState, 'videoLocks.lock', null),
	        thisLocks = (0, _import.get)(this, 'state.videoLocks.lockChildren', []),
	        nextLocks = (0, _import.get)(nextState, 'videoLocks.lockChildren', []);
	    if (thisLock !== nextLock) {
	      var lockChildren = (0, _import.get)(nextState, 'videoLocks.lock.lockChildren', []);
	      if (!(0, _import.isEmpty)(lockChildren)) {
	        _actionsChapter_actions2['default'].removeLocks(lockChildren);
	      }
	      return true;
	    }
	    if (thisLocks !== nextLocks) {
	      return true;
	    }
	    if (this.state.enabled === false) {
	      return false;
	    }
	    if (nextProps.index !== this.props.index) {
	      return true;
	    } else if (nextProps.chapters !== this.props.chapters) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  hasViewed: function hasViewed(index) {
	    return this.props.viewed[index];
	  },
	  enableClick: function enableClick() {
	    this.setState({
	      enabled: true
	    });
	  },
	  disableClick: function disableClick() {
	    this.setState({
	      enabled: false
	    });
	  },
	  menuClose: function menuClose() {
	    (0, _jquery2['default'])(window).trigger('mobmenu:close');
	  },
	  renderChapter: function renderChapter(chapter, i) {
	    var isSelected = parseInt(this.props.index, 10) === parseInt(i, 10),
	        hasViewed = this.hasViewed(i),
	        isLocked = _import2['default'].includes((0, _import.get)(this, 'state.videoLocks.lockChildren', []), i + 1, 0);
	
	    if (this.props.useMobileMenu) {
	      return _react2['default'].createElement(_componentsPlayerPlaylist_item2['default'], {
	        key: i + '-pl',
	        hasViewed: hasViewed,
	        isSelected: isSelected,
	        index: i,
	        isLocked: isLocked,
	        video: chapter,
	        enabled: this.state.enabled,
	        isMobileItem: true
	      });
	    } else {
	      if (this.props.hasMobileStyle) {
	        return _react2['default'].createElement(_componentsPlayerPlaylist_item2['default'], {
	          key: i + '-pl',
	          hasViewed: hasViewed,
	          isSelected: isSelected,
	          index: i,
	          isLocked: isLocked,
	          video: chapter,
	          enabled: this.state.enabled
	        });
	      } else {
	        return _react2['default'].createElement(
	          'div',
	          { key: i + '-pldiv', 'data-chapter': '' + (i + 1) },
	          _react2['default'].createElement(_componentsPlayerPlaylist_item2['default'], {
	            hasViewed: hasViewed,
	            isSelected: isSelected,
	            isLocked: isLocked,
	            index: i,
	            video: chapter,
	            enabled: this.state.enabled
	          })
	        );
	      }
	    }
	  },
	  render: function render() {
	    var chapters = _import2['default'].map(this.props.chapters, this.renderChapter, this);
	    var containerClass = this.props.useMobileMenu ? 'playlistContainer mobile-menu' : 'playlistContainer';
	    var headerImg = _react2['default'].createElement('img', { src: bpInstance.header });
	    var endMatterImg = _react2['default'].createElement('img', { src: bpInstance.endMatter });
	    if (chapters.length === 1) {
	      chapters = [];
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: containerClass },
	      _react2['default'].createElement(
	        'div',
	        { className: 'playlist' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'header' },
	          headerImg
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'episode-title' },
	          'EPISODES (',
	          this.props.chapters.length,
	          ')'
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          chapters
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'endMatter' },
	          endMatterImg
	        )
	      ),
	      _react2['default'].createElement(
	        'a',
	        { className: 'menu-close', onClick: this.menuClose },
	        'Cancel'
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "chapters.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsVideo_actions = __webpack_require__(224);
	
	var _actionsVideo_actions2 = _interopRequireDefault(_actionsVideo_actions);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = _react2['default'].createClass({
	    displayName: 'Player.PlaylistItem',
	    propTypes: {
	        onTouchEnd: _react.PropTypes.func,
	        onClick: _react.PropTypes.func,
	        isSelected: _react.PropTypes.bool,
	        video: _react.PropTypes.object,
	        index: _react.PropTypes.number,
	        hasViewed: _react.PropTypes.bool,
	        duration: _react.PropTypes.number,
	        enabled: _react.PropTypes.bool,
	        isLocked: _react.PropTypes.bool,
	        lockedStyle: _react.PropTypes.string,
	        isMobileItem: _react.PropTypes.bool
	    },
	    isTouchMove: false,
	    touchTimeout: null,
	    selectVideo: function selectVideo(e) {
	        if (this.props.enabled === false) {
	            return;
	        }
	        e.preventDefault();
	        if (!this.props.isSelected) {
	            if (this.props.onClick && !(0, _utilsUtil.isMobile)()) {
	                this.props.onClick(e);
	            } else if ((0, _utilsUtil.isMobile)() && (0, _jquery2['default'])('body').hasClass('has-mobile-menu')) {
	                (0, _jquery2['default'])(window).trigger('mobmenu:close');
	            }
	            _actionsVideo_actions2['default'].selectVideo(this.props.video, this.props.index);
	            _actionsVideo_actions2['default'].start();
	        }
	    },
	    onTouchMove: function onTouchMove(e) {
	        var _this = this;
	
	        if (this.isTouchMove) return;else this.isTouchMove = true;
	        this.touchTimeout = window.setTimeout(function () {
	            _this.isTouchMove = false;
	            window.clearTimeout(_this.touchTimeout);
	        }, 300);
	    },
	    onTouchEnd: function onTouchEnd(e) {
	        if (!this.isTouchMove) {
	            this.selectVideo(e);
	        }
	    },
	    render: function render() {
	        //console.log('grayout: '+this.props.isLocked+'('+this.props.lockedStyle+')');
	        var curVideo = this.props.index + 1,
	            env = (0, _utilsUtil.isLocal)() ? '.proddev' : (0, _utilsUtil.envCheck)(),
	            playBtn = (0, _utilsUtil.imageServer)(env) + '/pi/features/brandplay/play-btn.png';
	
	        var title = _react2['default'].createElement(
	            'div',
	            { className: 'advertisment' },
	            'INFORMATION FROM INDUSTRY'
	        ),
	            content = null,
	            legend = null,
	            classNames = null,
	            posterPlayBTN = _react2['default'].createElement(
	            'div',
	            { className: 'poster-play-btn' },
	            _react2['default'].createElement('img', { src: playBtn })
	        );
	
	        if (this.props.video.hasOwnProperty("events")) {
	            if (this.props.video.events[0].lockDisplay === 'hide') {
	                classNames = (0, _classnames2['default'])({
	                    'video-player-playlist-item': true,
	                    'is-selected': this.props.isSelected,
	                    'has-viewed': this.props.hasViewed,
	                    'hide-playlist': this.props.isLocked,
	                    'mobile-item': this.props.isMobileItem
	                });
	            } else {
	                classNames = (0, _classnames2['default'])({
	                    'video-player-playlist-item': true,
	                    'is-selected': this.props.isSelected,
	                    'has-viewed': this.props.hasViewed,
	                    'gray-out': this.props.isLocked,
	                    'mobile-item': this.props.isMobileItem
	                });
	            }
	        }
	
	        if (!this.props.video.isAdvertisement) {
	            if (this.props.video.label && this.props.video.label !== null) {
	                title = _react2['default'].createElement(
	                    'span',
	                    { className: 'low-light' },
	                    ' ',
	                    this.props.video.label,
	                    ': '
	                );
	            } else {
	                title = _react2['default'].createElement(
	                    'span',
	                    { className: 'low-light' },
	                    ' ',
	                    'CHAPTER ' + curVideo,
	                    ': '
	                );
	            }
	        }
	        if (this.props.isSelected) {
	            if (this.props.video.label && this.props.video.label !== null) {
	                title = _react2['default'].createElement(
	                    'span',
	                    { className: 'low-light' },
	                    ' ',
	                    this.props.video.label,
	                    ': '
	                );
	            } else {
	                title = _react2['default'].createElement(
	                    'span',
	                    { className: 'low-light' },
	                    ' ',
	                    'CHAPTER ' + curVideo,
	                    ': '
	                );
	            }
	        }
	        if (this.props.video.title.length > 45) {
	            content = _react2['default'].createElement(
	                'div',
	                { className: 'video-title' },
	                title,
	                _react2['default'].createElement('span', { className: 'title',
	                    dangerouslySetInnerHTML: { __html: this.props.video.title } })
	            );
	        } else {
	            content = _react2['default'].createElement(
	                'div',
	                { className: 'video-title' },
	                title,
	                _react2['default'].createElement('span', { className: 'title', dangerouslySetInnerHTML: { __html: this.props.video.title } })
	            );
	        }
	
	        var videoTitleClasses = (0, _classnames2['default'])({
	            'video-title': true,
	            'now_playing_color': true
	        }),
	            posterClasses = (0, _classnames2['default'])({
	            'poster-play-btn': true,
	            'hide-poster-play': true
	        });
	
	        if (this.props.hasViewed) {
	            legend = _react2['default'].createElement(
	                'div',
	                { className: 'watched' },
	                'WATCHED'
	            );
	        }
	
	        if (this.props.isSelected) {
	            legend = _react2['default'].createElement(
	                'div',
	                { className: 'now-playing' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'now-playing-txt' },
	                    'NOW PLAYING'
	                )
	            );
	            if (this.props.video.title.length > 45) {
	                content = _react2['default'].createElement(
	                    'div',
	                    { className: videoTitleClasses },
	                    title,
	                    _react2['default'].createElement('span', { className: 'title',
	                        dangerouslySetInnerHTML: { __html: this.props.video.title } })
	                );
	            } else {
	                content = _react2['default'].createElement(
	                    'div',
	                    { className: videoTitleClasses },
	                    title,
	                    _react2['default'].createElement('span', { className: 'title',
	                        dangerouslySetInnerHTML: { __html: this.props.video.title } })
	                );
	            }
	            posterPlayBTN = _react2['default'].createElement(
	                'div',
	                { className: posterClasses },
	                _react2['default'].createElement('img', { src: playBtn })
	            );
	        }
	        var _props$video = this.props.video;
	        var thumbnailFileName = _props$video.thumbnailFileName;
	        var thumbnail = _props$video.thumbnail;
	
	        if (thumbnailFileName.search(thumbnail) === -1) {
	            if (thumbnail.search('//') === -1) {
	                this.props.video.thumbnail = (0, _utilsUtil.imageServer)(env) + '/' + this.props.video.thumbnail.replace(/^en\//, '') + this.props.video.thumbnailFileName;
	            } else {
	                this.props.video.thumbnail = '' + this.props.video.thumbnail.replace(/^en\//, '');
	                if (this.props.video.thumbnail.indexOf(this.props.video.thumbnailFileName) === -1) this.props.video.thumbnail += this.props.video.thumbnailFileName;
	            }
	        }
	        if (this.props.isMobileItem) {
	            return _react2['default'].createElement(
	                'div',
	                { className: classNames, onClick: this.selectVideo, onTouchEnd: this.onTouchEnd, onTouchMove: this.onTouchMove },
	                content
	            );
	        } else {
	            return _react2['default'].createElement(
	                'div',
	                { className: classNames, onClick: this.selectVideo, onTouchEnd: this.onTouchEnd, onTouchMove: this.onTouchMove },
	                content,
	                posterPlayBTN,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'poster' },
	                    _react2['default'].createElement('img', { className: 'posterThumb', src: this.props.video.thumbnail })
	                ),
	                legend
	            );
	        }
	    }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "playlist_item.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	  'use strict';
	  /**
	   * For components that need to get a height minus window offset height
	   */
	  return {
	    getNodeHeight: function getNodeHeight(node) {
	      var height = $(window).height(),
	          top = node.offset().top;
	      return height - top;
	    }
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    track: function track(url) {
	        var medscape = 'medscape.com',
	            internalLink = url.indexOf(medscape);
	        var identifierLink = '',
	            eventLnk = '';
	        if (internalLink > -1) {
	            identifierLink = 'INTLINK_';
	            eventLnk = 'vidvbp-intlink';
	        } else {
	            identifierLink = 'EXTLINK_';
	            eventLnk = 'vidvbp-extlink';
	        }
	        return function () {};
	    }
	};
	module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _actionsChapter_actions = __webpack_require__(244);
	
	var _actionsChapter_actions2 = _interopRequireDefault(_actionsChapter_actions);
	
	var _mixinsSegment_store = __webpack_require__(280);
	
	var _mixinsSegment_store2 = _interopRequireDefault(_mixinsSegment_store);
	
	var _import = __webpack_require__(200);
	
	exports['default'] = _reflux2['default'].createStore({
	  listenables: [_actionsChapter_actions2['default']],
	  mixins: [_mixinsStore_state2['default'], _mixinsSegment_store2['default']],
	  stateNamespace: 'videoLocks',
	  segmentProperty: 'locks',
	  segmentKey: 'lock',
	  onLoadLocks: function onLoadLocks(locks) {
	    //console.log('onLoadLocks: ',locks);
	    this.setState({
	      lockChildren: locks
	    });
	  },
	  onRemoveLocks: function onRemoveLocks(locks) {
	    //console.log('onRemoveLocks: ',locks);
	    var remainingLocks = this.state.lockChildren.filter(function (inLock) {
	      return !(0, _import.includes)(locks, inLock);
	    });
	
	    var cookieName = 'guidedVideo',
	        cookie = 1,
	        lastUnlockedVideo = 1,
	        i = 1;
	
	    this.setState({
	      lockChildren: remainingLocks
	    });
	
	    cookie = this.getCookie(cookieName);
	
	    if (cookie >= 1) {
	      //console.log('cookie > 1');
	      lastUnlockedVideo = locks;
	      this.createCookie(cookieName, lastUnlockedVideo, 2);
	    } else {
	      //console.log('cookie 1 or lower');
	      this.createCookie(cookieName, lastUnlockedVideo, 2);
	    }
	
	    // Code to unlock the top menu playlist for mobile/tablet
	    $(".chapter-link-in-menu").each(function (index) {
	      var chapterId = $(this)[0].id;
	      //console.log('lastUnlockedVideo', lastUnlockedVideo);
	      for (i; i <= lastUnlockedVideo; i++) {
	        $('#chapter-' + i).removeClass('gray-out');
	        $('#chapter-' + i).removeClass('hide-playlist');
	      }
	    });
	  },
	  createCookie: function createCookie(name, value, days) {
	    //console.log('createCookie: '+name+',value: '+value+', days: '+days);
	    var expires = "";
	
	    if (days) {
	      var date = new Date();
	      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	      expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + value + expires + "; path=/";
	  },
	  getCookie: function getCookie(name) {
	    //console.log('getCookie: ',name);
	    var nameEQ = name + "=",
	        ca = document.cookie.split(';'),
	        i = 0,
	        c = '';
	    for (i; i < ca.length; i++) {
	      var _c = ca[i];
	      while (_c.charAt(0) === ' ') _c = _c.substring(1, _c.length);
	      if (_c.indexOf(nameEQ) === 0) return _c.substring(nameEQ.length, _c.length);
	    }
	    return 1;
	  }
	});
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _import = __webpack_require__(200);
	
	var _utilsRange_tree = __webpack_require__(281);
	
	var _utilsRange_tree2 = _interopRequireDefault(_utilsRange_tree);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _storesTick_store = __webpack_require__(282);
	
	var _storesTick_store2 = _interopRequireDefault(_storesTick_store);
	
	/**
	 * Mixin SegmentStore
	 *
	 * Example store definition:
	 *
	 *      mixin: [ SegmentStore ],
	 *      segmentProperty: 'slides',
	 *      segmentKey: 'slide'
	 *
	 *  Example video descriptor:
	 *
	 *      videos: [
	 *       {
	 *         ...
	 *         slides: [ {startTime: "00:00:00", endTime: "00:00:15", name: "Slide 1" }, ...  ]
	 *       }
	 *      ]
	 *
	 * Would trigger `setState({ lastSlide: null, slide: slides[0] })` when video[0] started and
	 * `setState({ lastSlide: slides[0], slide: slides[1] })` on the 15th second.
	 *
	 * SegmentStore allows leaving the `endTime` of a segment
	 * undefined. It will implicitely assume that the `endTime` is the
	 * same as the `startTime` of the next segment or 99:99:99 for the last
	 * segment.
	 *
	 */
	
	exports['default'] = {
	  mixins: [_mixinsHas_pretty_time2['default']],
	  init: function init() {
	    if (typeof this.segmentProperty === 'undefined') {
	      throw new Error('Must define `segmentProperty` in order to mix in SegmentStore, ' + 'this is the attribute of the video config containing the segments ' + 'e.g. `slides`, `chapters`, etc. . .');
	    }
	    if (typeof this.segmentKey === 'undefined') {
	      throw new Error('Must define `segmentKey` in order to mix in SegmentStore, ' + 'this is typically the non-plural of `segmentProperty`, e.g. ' + '`slide`, `chapter`, . . .');
	    }
	    if (typeof this.setState === 'undefined') {
	      throw new Error('Must mix in `StoreState` to use SegmentStore. If you are ' + 'mixing StoreState in already, check the order of the mixin array.');
	    }
	    this.segmentState = {};
	    this.listenTo(_storesTick_store2['default'], this.onTick);
	  },
	  onTick: function onTick(state) {
	    var _this = this;
	
	    var _state$tick = state.tick;
	    var meta = _state$tick.meta;
	    var currentTime = _state$tick.currentTime;
	
	    if (meta !== this.segmentState.meta) {
	      var _ret = (function () {
	        var segments = meta[_this.segmentProperty];
	        if (!segments) return {
	            v: undefined
	          };
	        _this.segmentState.meta = meta;
	        _this.segmentState.map = segments.reduce(function (memo, segment) {
	          var start = _this.secondsFromPrettyTime(segment.startTime),
	              i = memo.length;
	          var end = segment.endTime;
	          if (!end) {
	            end = segments[i + 1] ? segments[i + 1].startTime : '99:99:99';
	          }
	          segment.endTime = end;
	          segment.index = i;
	          end = _this.secondsFromPrettyTime(end);
	          return memo.add(start, end, segment);
	        }, new _utilsRange_tree2['default']());
	        _this.setState(_defineProperty({}, _this.segmentProperty, segments));
	      })();
	
	      if (typeof _ret === 'object') return _ret.v;
	    }
	    if (!this.segmentState.map) return;
	    var currentSegment = this.segmentState.map.inRange(currentTime);
	    if (currentSegment !== this.state[this.segmentKey]) {
	      if (!!currentSegment) {
	        var _setState2;
	
	        var lastSegment = this.segmentState.map.pred(currentTime),
	            nextSegment = this.segmentState.map.succ(currentTime);
	        this.setState((_setState2 = {}, _defineProperty(_setState2, 'last' + (0, _import.capitalize)(this.segmentKey), lastSegment), _defineProperty(_setState2, this.segmentKey, currentSegment), _defineProperty(_setState2, 'next' + (0, _import.capitalize)(this.segmentKey), nextSegment), _setState2));
	      } else if (this.segmentKey === 'question') {
	        var _setState3;
	
	        this.setState((_setState3 = {}, _defineProperty(_setState3, 'last' + (0, _import.capitalize)(this.segmentKey), null), _defineProperty(_setState3, this.segmentKey, null), _defineProperty(_setState3, 'next' + (0, _import.capitalize)(this.segmentKey), null), _setState3));
	      }
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	/*
	
	   Only here to store time boxed segments as range keyed nodes in a
	   small tree. Hence the recursion, which JS doesn't really handle
	   well. You probably don't want to put thousands of items in one, but
	   other than that it should be fine to use without beating up the
	   stack.
	
	   Structurally, this is an AVL balanced binary tree with a guaranteed
	   access time of O(log n)
	
	   See: https://en.wikipedia.org/wiki/AVL_tree for reference.
	
	   Would have just kept this a standard binary tree, but since slides
	   and such tend to be added in ascending timecode order, a naive
	   binary tree degenerates rather quickly into a linked list.
	
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var RangeTree = function RangeTree() {
	  this.root = null;
	  this.length = 0;
	};
	
	function rangeError(existingNode, newNode) {
	  throw new Error('Overlapping ranges: ' + existingNode.rangeStart + '..' + existingNode.rangeEnd + ', ' + newNode.rangeStart + '..' + newNode.rangeEnd);
	}
	
	function isLeft(node) {
	  return node.parent.left === node;
	}
	
	function isRight(node) {
	  return node.parent.right === node;
	}
	
	function search(_x2, _x3) {
	  var _again = true;
	
	  _function: while (_again) {
	    var key = _x2,
	        node = _x3;
	    _again = false;
	
	    if (node === null) {
	      return null;
	    } else if (node.rangeStart <= key && node.rangeEnd > key) {
	      return node.value;
	    } else if (key < node.rangeStart) {
	      _x2 = key;
	      _x3 = node.left;
	      _again = true;
	      continue _function;
	    } else {
	      // key > node.rangeEnd
	      _x2 = key;
	      _x3 = node.right;
	      _again = true;
	      continue _function;
	    }
	  }
	}
	
	// returns node, not value
	function nearest(_x4, _x5) {
	  var _arguments2 = arguments;
	  var _again2 = true;
	
	  _function2: while (_again2) {
	    var key = _x4,
	        node = _x5;
	    _again2 = false;
	    var state = _arguments2.length <= 2 || _arguments2[2] === undefined ? { leftMin: Number.MAX_VALUE, rightMin: Number.MAX_VALUE } : _arguments2[2];
	    var closest = state.closest;
	    var leftMin = state.leftMin;
	    var rightMin = state.rightMin;
	
	    var nextMin = undefined;
	    if (node === null) {
	      return closest;
	    } else if (node.rangeStart <= key && node.rangeEnd > key) {
	      return node;
	    } else if (key < node.rangeStart) {
	      nextMin = Math.abs(key - node.rangeStart);
	      _arguments2 = [_x4 = key, _x5 = node.left, {
	        closest: nextMin < leftMin ? node : closest,
	        leftMin: Math.min(nextMin, leftMin),
	        rightMin: rightMin
	      }];
	      _again2 = true;
	      state = closest = leftMin = rightMin = nextMin = undefined;
	      continue _function2;
	    } else {
	      nextMin = Math.abs(key - node.rangeEnd);
	      _arguments2 = [_x4 = key, _x5 = node.right, {
	        closest: nextMin < rightMin ? node : closest,
	        rightMin: Math.min(nextMin, rightMin),
	        leftMin: leftMin
	      }];
	      _again2 = true;
	      state = closest = leftMin = rightMin = nextMin = undefined;
	      continue _function2;
	    }
	  }
	}
	
	function min(_x6) {
	  var _again3 = true;
	
	  _function3: while (_again3) {
	    var node = _x6;
	    _again3 = false;
	
	    if (node.left) {
	      _x6 = node.left;
	      _again3 = true;
	      continue _function3;
	    } else {
	      return node;
	    }
	  }
	}
	
	function max(_x7) {
	  var _again4 = true;
	
	  _function4: while (_again4) {
	    var node = _x7;
	    _again4 = false;
	
	    if (node.right) {
	      _x7 = node.right;
	      _again4 = true;
	      continue _function4;
	    } else {
	      return node;
	    }
	  }
	}
	
	RangeTree.prototype = {
	  /**
	   * Ranges may not intersect but upper and lower bounds may be equal e.g.
	   *
	   *  * Legal: .add(1,3, val1); .add(3,5, val2)
	   *  * Error: .add(1,3, val1); .add(2,5, val2)
	   *
	   * @param {sortable} rangeStart - The lower bound of the range key
	   * @param {sortable} rangeEnd   - The upper bound of the range key
	   * @param {*} value             - The stored value
	   */
	  add: function add(rangeStart, rangeEnd, value) {
	    var node = {
	      rangeStart: rangeStart,
	      rangeEnd: rangeEnd,
	      value: value,
	      balance: 0,
	      left: null,
	      right: null,
	      parent: null
	    };
	    if (this.root === null) {
	      this.root = node;
	    } else {
	      this.traverse(this.root, node);
	    }
	    this.length++;
	    return this;
	  },
	
	  /**
	   * See the tests
	   *
	   * @param {sortable} key
	   * @returns {*} value
	   */
	  inRange: function inRange(key) {
	    return search(key, this.root);
	  },
	
	  pred: function pred(key) {
	    var node = nearest(key, this.root);
	    if (!node) return null;
	    if (node.left) {
	      return max(node.left).value;
	    } else {
	      var p = node.parent,
	          n = node;
	      while (p && n === p.left) {
	        n = p;
	        p = p.parent;
	      }
	      return p ? p.value : null;
	    }
	  },
	
	  succ: function succ(key) {
	    var node = nearest(key, this.root);
	    if (!node) return null;
	    if (node.right) {
	      return min(node.right).value;
	    } else {
	      var p = node.parent,
	          n = node;
	      while (p && n === p.right) {
	        n = p;
	        p = p.parent;
	      }
	      return p ? p.value : null;
	    }
	  },
	
	  traverse: function traverse(parent, newNode) {
	    if (newNode.rangeStart < parent.rangeStart) {
	      if (newNode.rangeEnd > parent.rangeStart) {
	        rangeError(parent, newNode);
	      }
	
	      if (parent.left === null) {
	        parent.left = newNode;
	        newNode.parent = parent;
	        this.setBalance(newNode);
	      } else {
	        this.traverse(parent.left, newNode);
	      }
	    } else if (newNode.rangeStart >= parent.rangeEnd) {
	      if (parent.right === null) {
	        parent.right = newNode;
	        newNode.parent = parent;
	        this.setBalance(newNode);
	      } else {
	        this.traverse(parent.right, newNode);
	      }
	    } else {
	      rangeError(parent, newNode);
	    }
	  },
	
	  setBalance: function setBalance(node) {
	    if (node.balance > 1 || node.balance < -1) {
	      this.rebalance(node);
	    } else if (node.parent) {
	      if (isLeft(node)) {
	        node.parent.balance++;
	      } else {
	        node.parent.balance--;
	      }
	      if (node.parent.balance !== 0) {
	        this.setBalance(node.parent);
	      }
	    }
	  },
	
	  rebalance: function rebalance(node) {
	    if (node.balance < 0) {
	      if (node.right.balance > 0) {
	        this.rotateRight(node.right);
	        this.rotateLeft(node);
	      } else {
	        this.rotateLeft(node);
	      }
	    } else if (node.balance > 0) {
	      if (node.left.balance < 0) {
	        this.rotateLeft(node.left);
	        this.rotateRight(node);
	      } else {
	        this.rotateRight(node);
	      }
	    }
	  },
	
	  rotateLeft: function rotateLeft(node) {
	    var root = node.right;
	    node.right = root.left;
	    if (root.left) {
	      root.left.parent = node;
	    }
	
	    root.parent = node.parent;
	    if (!root.parent) {
	      this.root = root;
	    } else if (isLeft(node)) {
	      node.parent.left = root;
	    } else {
	      node.parent.right = root;
	    }
	
	    root.left = node;
	    node.parent = root;
	    node.balance += 1 - Math.min(root.balance, 0);
	    root.balance += 1 + Math.max(node.balance, 0);
	  },
	
	  rotateRight: function rotateRight(node) {
	    var root = node.left;
	    node.left = root.right;
	    if (root.right) {
	      root.right.parent = node;
	    }
	
	    root.parent = node.parent;
	    if (!root.parent) {
	      this.root = root;
	    } else if (isRight(node)) {
	      node.parent.right = root;
	    } else {
	      node.parent.left = root;
	    }
	
	    root.right = node;
	    node.parent = root;
	    node.balance += 1 - Math.min(root.balance, 0);
	    root.balance += 1 + Math.max(node.balance, 0);
	  }
	};
	
	exports['default'] = RangeTree;
	module.exports = exports['default'];

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	exports['default'] = _reflux2['default'].createStore({
	  listenables: [],
	  mixins: [_mixinsStore_state2['default']],
	  stateNamespace: 'tick',
	  init: function init() {
	    this.listenTo(_storesVideo_store2['default'], this.onVideoChange.bind(this));
	  },
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  onVideoChange: function onVideoChange(state) {
	    //console.log('state: ',state);
	    var event = state.video.event;
	
	    if (event === 'progress' || event === 'ready' || event === 'settingTime') {
	      this.setState(state.video);
	    }
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _componentsQnaForm = __webpack_require__(284);
	
	var _componentsQnaForm2 = _interopRequireDefault(_componentsQnaForm);
	
	var _actionsQna_standalone_actions = __webpack_require__(293);
	
	var _actionsQna_standalone_actions2 = _interopRequireDefault(_actionsQna_standalone_actions);
	
	var _storesQna_standalone_store = __webpack_require__(294);
	
	var _storesQna_standalone_store2 = _interopRequireDefault(_storesQna_standalone_store);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(205);
	
	var _import = __webpack_require__(200);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _componentsQnaCme_chart = __webpack_require__(296);
	
	var _componentsQnaCme_chart2 = _interopRequireDefault(_componentsQnaCme_chart);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var QNAPresenter = function QNAPresenter() {
	  var itsActions = new _actionsQna_standalone_actions2['default'](),
	      itsStore = new _storesQna_standalone_store2['default'](itsActions);
	  return _react2['default'].createClass({
	    displayName: 'Player.CME',
	    propTypes: {
	      qid: _react.PropTypes.string,
	      page: _react.PropTypes.string
	    },
	    mixins: [(0, _reflux.connect)(itsStore)],
	    componentDidMount: function componentDidMount() {
	      var _props = this.props;
	      var qid = _props.qid;
	      var page = _props.page;
	
	      itsActions.requestQnaXml(qid, page);
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	      // rememebr me feature is on after polling is done
	      if (!this.rememberMeFired) {
	        if ((0, _import.get)(prevState, 'quiz.qid', false) || (0, _import.get)(prevState, 'quiz.isChartVisible', false)) {
	          this.rememberMeFired = true;
	        }
	      }
	    },
	    getSelectedRefValues: function getSelectedRefValues(selectedValues) {
	      this.setState({ selectedValues: selectedValues });
	    },
	    upDateQuestionsForChart: function upDateQuestionsForChart(allQuestions) {
	      var _this = this;
	
	      var chartQuestions = allQuestions.filter(function (question) {
	        return question._showAnsTable === 'true';
	      });
	      chartQuestions.forEach(function (question) {
	        question.isDisabled = true;
	        if (question.displayRule === 'RadioButton' || question.displayRule === 'CheckBox') {
	          question.OriginalTotalResponse = parseInt(question.totalResponse, 10);
	          if (question.responded === 'false') {
	            question.totalResponse++;
	          }
	          var choices = (0, _import.toArray)(question.choice);
	          choices.forEach(function (questionChoice) {
	            if (questionChoice.selected === 'true') {
	              questionChoice.selected = 'selected';
	            }
	            if (!questionChoice.totalResponse || isNaN(parseInt(questionChoice.totalResponse, 10))) {
	              questionChoice.totalResponse = 0;
	            }
	            if (questionChoice.selected === 'selected') {
	              if (_this.state.selectedValues[questionChoice._id] === 'selected') {
	                var newTotalQuestionResponse = Math.round(questionChoice.totalResponse / 100 * question.OriginalTotalResponse);
	                questionChoice.totalResponse = parseInt(newTotalQuestionResponse / question.totalResponse * 100, 10);
	                questionChoice.selected = 'true';
	              } else {
	                var newTotalQuestionResponse = Math.round(questionChoice.totalResponse / 100 * question.OriginalTotalResponse - 1);
	                questionChoice.totalResponse = parseInt(newTotalQuestionResponse / question.totalResponse * 100, 10);
	                questionChoice.selected = 'false';
	              }
	            } else {
	              if (!_this.state.selectedValues[questionChoice._id]) {
	                var newTotalQuestionResponse = Math.round(questionChoice.totalResponse / 100 * question.OriginalTotalResponse);
	                questionChoice.totalResponse = parseInt(newTotalQuestionResponse / question.totalResponse * 100, 10);
	              } else {
	                var newTotalQuestionResponse = Math.round(questionChoice.totalResponse / 100 * question.OriginalTotalResponse + 1);
	                questionChoice.totalResponse = parseInt(newTotalQuestionResponse / question.totalResponse * 100, 10);
	                questionChoice.selected = 'true';
	              }
	            }
	          });
	        }
	      });
	      return chartQuestions;
	    },
	    renderCharts: function renderCharts(questions) {
	      var renderedChart = undefined;
	      var chartLayerClasses = (0, _classnames2['default'])({ 'chart-layer': true, 'is-visible': this.state.quiz.isChartVisible });
	      if (questions.length > 0) {
	        renderedChart = _react2['default'].createElement(
	          'div',
	          { ref: 'qnaScroll', className: chartLayerClasses },
	          _react2['default'].createElement(_componentsQnaCme_chart2['default'], { closeHandler: this.closeLayer, charts: questions })
	        );
	      } else {
	        renderedChart = null;
	      }
	      return renderedChart;
	    },
	    closeHandler: function closeHandler() {
	      itsActions.hideQuestion();
	      this.setState({
	        wasSubmitted: true
	      });
	    },
	    render: function render() {
	      var renderedQuestionPage = _react2['default'].createElement(
	        'div',
	        null,
	        'Loading ...'
	      ),
	          chartLayerClasses = null,
	          questions = [],
	          closeLayer = function closeLayer() {},
	          renderedQuestions = undefined;
	      var questionnaire = (0, _import.get)(this, 'state.quiz.questionnaire', undefined);var _props2 = this.props;
	      var qid = _props2.qid;
	      var page = _props2.page;
	      var isChartVisible = (0, _import.get)(this, 'state.quiz.isChartVisible', false);
	      if (isChartVisible) {
	        if ((0, _jquery2['default'])('[data-qna-message]').length > 0) {
	          (0, _jquery2['default'])('.qna-container').addClass('is-invisible');
	          (0, _jquery2['default'])('#qna-message').addClass('is-visible');
	        } else {
	          (0, _jquery2['default'])('#qna-message').addClass('is-invisible');
	          var chartQuestions = JSON.parse(JSON.stringify(questionnaire.page[0].question));
	          var updatedChartQuestions = chartQuestions.map(function (obj) {
	            obj.isDisabled = true;
	            obj._showAnsTable = 'true';
	            return obj;
	          });
	          if (this.state.wasSubmitted === true) {
	            updatedChartQuestions = this.upDateQuestionsForChart(updatedChartQuestions);
	          }
	          renderedQuestions = this.renderCharts(updatedChartQuestions);
	          renderedQuestionPage = _react2['default'].createElement(
	            'div',
	            { ref: 'qnaScroll', className: chartLayerClasses },
	            _react2['default'].createElement(_componentsQnaCme_chart2['default'], {
	              closeHandler: closeLayer,
	              charts: chartQuestions,
	              chartClassName: 'qna-stand-alone-container'
	            })
	          );
	        }
	      } else {
	        if (questionnaire && questionnaire.page.length > 0) {
	          var itsPage = questionnaire.page.filter(function (inPage) {
	            return inPage._id === page;
	          });
	          renderedQuestionPage = _react2['default'].createElement(_componentsQnaForm2['default'], {
	            questions: itsPage[0].question,
	            getSelectedRefValues: this.getSelectedRefValues,
	            closeHandler: this.closeHandler,
	            qid: qid,
	            page: page
	          });
	        }
	      }
	      return renderedQuestionPage;
	    }
	  });
	};
	exports['default'] = QNAPresenter;
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "qna_standalone_presenter.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actionsQuiz_actions = __webpack_require__(285);
	
	var _actionsQuiz_actions2 = _interopRequireDefault(_actionsQuiz_actions);
	
	var _mixinsRenders_question_components = __webpack_require__(286);
	
	var _mixinsRenders_question_components2 = _interopRequireDefault(_mixinsRenders_question_components);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsUtil = __webpack_require__(201);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'form',
	
	  propTypes: {
	    questions: _react2['default'].PropTypes.array.isRequired,
	    qid: _react2['default'].PropTypes.string.isRequired,
	    page: _react2['default'].PropTypes.string.isRequired,
	    htmlCharting: _react2['default'].PropTypes.bool,
	    closeHandler: _react2['default'].PropTypes.func,
	    getSelectedRefValues: _react2['default'].PropTypes.func,
	    isValid: _react2['default'].PropTypes.bool
	  },
	  mixins: [_mixinsRenders_question_components2['default']],
	  getInitialState: function getInitialState() {
	    return {
	      isValid: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.formChangeHandler();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.formChangeHandler();
	  },
	  getSelectedRefValues: function getSelectedRefValues() {
	    var selectedValues = {}; // eslint-disable-line
	    for (var ref in this.refs) {
	      // eslint-disable-line
	      if (this.refs[ref].state.value) {
	        selectedValues[this.refs[ref].state.value] = 'selected';
	      }
	      if (this.refs[ref].state.values) {
	        for (var i = 0; i < this.refs[ref].state.values.length; i++) {
	          selectedValues[this.refs[ref].state.values[i]] = 'selected';
	        }
	      }
	    }
	    return selectedValues;
	  },
	  submitHandler: function submitHandler(formId, e) {
	    var _props = this.props;
	    var qid = _props.qid;
	    var page = _props.page;
	
	    e.preventDefault();
	    this.formChangeHandler();
	    if (this.state.isValid) {
	      var $form = (0, _jquery2['default'])('#' + formId);
	      _actionsQuiz_actions2['default'].post(decodeURIComponent($form.serialize()), this.props.qid, this.props.page);
	      this.props.getSelectedRefValues(this.getSelectedRefValues());
	      if (this.props.closeHandler) {
	        this.props.closeHandler('isQuestionVisible', true, qid, page);
	      }
	    }
	  },
	  checkValidity: function checkValidity() {
	    var _this = this;
	
	    var valid = true;
	    this.props.questions.forEach(function (question) {
	      if (_this.refs[question._id]) {
	        if (!_this.refs[question._id].validate()) {
	          valid = false;
	        }
	      }
	    });
	    return valid;
	  },
	  formChangeHandler: function formChangeHandler() {
	    var valid = this.checkValidity();
	    (0, _utilsUtil.nextTick)(this.setState({ isValid: valid }));
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var qid = _props2.qid;
	    var page = _props2.page;
	    var isValid = this.state.isValid;
	    var submitButtonClasses = (0, _classnames2['default'])({
	      'disabled': !isValid,
	      'qna-submit-button': true
	    });
	    var requiredMessageClasses = (0, _classnames2['default'])({
	      'qna-required-message': true,
	      'is-visible': !isValid
	    });
	    var questionsComp = this.props.questions.map(this.renderQuestion);
	    return _react2['default'].createElement(
	      'form',
	      { onChange: this.formChangeHandler, onSubmit: this.submitHandler.bind(this, qid + '_form'), className: 'qna-radio-form', id: qid + '_form' },
	      _react2['default'].createElement(
	        'label',
	        { htmlFor: qid + '_form', className: requiredMessageClasses },
	        'All questions required.'
	      ),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'questionnaire_id', id: 'questionnaire_id', value: qid }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'responseType', id: 'responseType', value: 'samepage' }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'nextPageURL', id: 'nextPageURL', value: 'null' }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'questionnaireType', id: 'questionnaireType', value: 'null' }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'form_id', id: 'form_id', value: page }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'formType', id: 'formType', value: 'DEFAULT' }),
	      questionsComp,
	      _react2['default'].createElement(
	        'div',
	        { className: 'button-container' },
	        _react2['default'].createElement(
	          'button',
	          { className: submitButtonClasses,
	            disabled: !this.state.isValid,
	            onClick: this.submitHandler.bind(this, qid + '_form'),
	            id: 'submit-' + qid },
	          'Submit'
	        )
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "form.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsUtil = __webpack_require__(201);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var QuizActions = _reflux2['default'].createActions({
	  cancel: {},
	  close: {},
	  reset: {},
	  hideLayer: {},
	  requestQnaXml: { asyncResult: true, children: ['completed', 'failed'] },
	  showQuestion: {},
	  hideQuestion: {},
	  post: {},
	  completed: {},
	  failed: {},
	  open: {},
	  validate: {},
	  complete: {}
	});
	
	QuizActions.requestQnaXml.shouldEmit = function () {
	  if (QuizActions.ajaxRequest && QuizActions.ajaxRequest.readyState === 1) {
	    return false;
	  }
	  return true;
	};
	QuizActions.requestQnaXml.listen(function (qnas) {
	  var qnaUrl = undefined;
	  var location = window.location.hostname,
	      qid = qnas[0].qaidFormPage.split('/')[0];
	  if (location.match(/www/)) {
	    qnaUrl = '//' + location + '/qnaService?questionnaireID=' + qid;
	  } else if (location.match(/api./)) {
	    qnaUrl = '//www.' + location.replace('api.', '') + '/qnaService?questionnaireID=' + qid;
	  } else if (location.match(/localhost/)) {
	    // for local testing
	    qnaUrl = '//localhost:8080/assets/xml/qna/local.xml';
	  } else {
	    qnaUrl = '//' + location + '/activity/qnaService?questionnaireID=' + qid;
	  }
	  (0, _utilsUtil.getXhr)(qnaUrl).then(this.completed, this.failed);
	});
	QuizActions.post.listen(function (serializedForm) {
	  var postUrl = undefined;
	  var location = window.location.hostname;
	  if (location.match(/www/)) {
	    postUrl = '//' + window.location.hostname + '/qna/AddQAResponsesClassic?';
	  } else {
	    postUrl = '//' + window.location.hostname + '/activity/qna/AddQAResponsesClassic?';
	  }
	  postUrl += serializedForm;
	  (0, _utilsUtil.getXhr)(postUrl).then(this.completed, this.failed);
	});
	exports['default'] = QuizActions;
	module.exports = exports['default'];

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsQnaRadio_question = __webpack_require__(287);
	
	var _componentsQnaRadio_question2 = _interopRequireDefault(_componentsQnaRadio_question);
	
	var _componentsQnaCheckbox_question = __webpack_require__(290);
	
	var _componentsQnaCheckbox_question2 = _interopRequireDefault(_componentsQnaCheckbox_question);
	
	var _componentsQnaTextbox_question = __webpack_require__(291);
	
	var _componentsQnaTextbox_question2 = _interopRequireDefault(_componentsQnaTextbox_question);
	
	var _componentsQnaTextarea_question = __webpack_require__(292);
	
	var _componentsQnaTextarea_question2 = _interopRequireDefault(_componentsQnaTextarea_question);
	
	exports['default'] = {
	  renderQuestion: function renderQuestion(question, i, questionArray) {
	    var QuestionTemplate = undefined,
	        questionPage = i + 1 + ' of  ' + questionArray.length;
	    switch (question.displayRule) {
	      case 'radio':
	      case 'RadioButton':
	        QuestionTemplate = _react2['default'].createElement(_componentsQnaRadio_question2['default'], { key: i,
	          ref: question._id,
	          questionTotalResponse: question.totalResponse,
	          questionIsDisabled: question.isDisabled,
	          questionChoices: question.choice,
	          questionId: question._id,
	          questionPage: questionPage,
	          questionRequired: question._required,
	          questionText: question.questionText,
	          questionShowTable: question._showAnsTable,
	          questionIntro: question.questionIntro });
	        break;
	      case 'checkbox':
	      case 'CheckBox':
	        QuestionTemplate = _react2['default'].createElement(_componentsQnaCheckbox_question2['default'], { key: i,
	          ref: question._id,
	          questionTotalResponse: question.totalResponse,
	          questionIsDisabled: question.isDisabled,
	          questionChoices: question.choice,
	          questionId: question._id,
	          questionPage: questionPage,
	          questionRequired: question._required,
	          questionText: question.questionText,
	          questionShowTable: question._showAnsTable,
	          questionIntro: question.questionIntro });
	        break;
	      /*
	      Not dead code. Drop downs currently do not work because of a bug with the qna tool.
	      When a fix for them is implemented we can uncomment this.
	      case 'dropdown':
	      case 'DropDown':
	        QuestionTemplate = (<DropdownQuestion ref={question._id}
	                                              key={i}
	                                              questionChoices={question.choice}
	                                              questionId={question._id}
	                                              questionPage={questionPage}
	                                              questionRequired={question._required}
	                                              questionText={question.questionText} />);
	        break;
	      */
	      case 'textbox':
	      case 'TextBox':
	        QuestionTemplate = _react2['default'].createElement(_componentsQnaTextbox_question2['default'], { key: i,
	          ref: question._id,
	          questionIsDisabled: question.isDisabled,
	          questionId: question._id,
	          questionPage: questionPage,
	          questionRequired: question._required,
	          questionText: question.questionText });
	        break;
	      case 'textarea':
	      case 'TextArea':
	        QuestionTemplate = _react2['default'].createElement(_componentsQnaTextarea_question2['default'], { key: i,
	          ref: question._id,
	          questionIsDisabled: question.isDisabled,
	          questionId: question._id,
	          questionPage: questionPage,
	          questionRequired: question._required,
	          questionText: question.questionText });
	        break;
	      default:
	        console.warn('Error invalid question type');
	    }
	    return QuestionTemplate;
	  }
	};
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "renders_question_components.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsRenders_perecentage_bar = __webpack_require__(288);
	
	var _mixinsRenders_perecentage_bar2 = _interopRequireDefault(_mixinsRenders_perecentage_bar);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mixinsHas_question_validation = __webpack_require__(289);
	
	var _mixinsHas_question_validation2 = _interopRequireDefault(_mixinsHas_question_validation);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'radio_question',
	
	  propTypes: {
	    questionChoices: _react.PropTypes.array.isRequired,
	    questionId: _react.PropTypes.string.isRequired,
	    questionPage: _react.PropTypes.string,
	    questionRequired: _react.PropTypes.string,
	    questionText: _react.PropTypes.string.isRequired,
	    questionIsDisabled: _react.PropTypes.bool,
	    questionShowTable: _react.PropTypes.string,
	    questionTotalResponse: _react.PropTypes.number,
	    questionIntro: _react.PropTypes.string
	  },
	  mixins: [_mixinsRenders_perecentage_bar2['default'], _mixinsHas_question_validation2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return { isDisabled: false };
	  },
	  getInitialState: function getInitialState() {
	    var _this = this;
	
	    var value = undefined;
	    this.props.questionChoices.forEach(function (questionChoice) {
	      if (questionChoice.selected === 'true' && !_this.props.questionIsDisabled) {
	        value = questionChoice._id;
	      }
	    });
	    return {
	      errors: [''],
	      value: value
	    };
	  },
	  handleChange: function handleChange(event) {
	    this.setState({ value: event.target.value });
	    this.createErrors();
	  },
	  renderRadioQuestions: function renderRadioQuestions() {
	    var _this2 = this;
	
	    var radioQuestions = this.props.questionChoices.map(function (questionChoice, i) {
	      var isChecked = false;
	      var percent = _this2.calcPercent(questionChoice),
	          percentBar = _this2.renderPercentBar(percent),
	          percentNumber = _this2.renderPercentNumber(percent),
	          radioChoiceClasses = (0, _classnames2['default'])({
	        'qna-is-correct': questionChoice.isCorrect === 'true' && _this2.props.questionIsDisabled,
	        'qna-radio-choice': true,
	        'qna-is-highlighted': questionChoice.selected === 'true' && _this2.props.questionIsDisabled || _this2.state.value === questionChoice._id && !_this2.props.questionIsDisabled
	      });
	      if (_this2.props.questionIsDisabled && questionChoice.selected === 'true') {
	        isChecked = true;
	      } else if (_this2.state.value === questionChoice._id && !_this2.props.questionIsDisabled) {
	        isChecked = true;
	      }
	      return _react2['default'].createElement(
	        'li',
	        { className: radioChoiceClasses, key: i },
	        percentBar,
	        _react2['default'].createElement('input', { ref: questionChoice._id,
	          disabled: _this2.props.questionIsDisabled ? 'disabled' : false,
	          checked: isChecked,
	          id: 'option-' + questionChoice._id,
	          name: 'option-' + _this2.props.questionId,
	          onChange: _this2.handleChange,
	          type: 'radio',
	          value: questionChoice._id }),
	        _react2['default'].createElement('label', { htmlFor: 'option-' + questionChoice._id,
	          dangerouslySetInnerHTML: { __html: questionChoice.choiceText } }),
	        percentNumber
	      );
	    });
	    return radioQuestions;
	  },
	  render: function render() {
	    var errorMesseges = this.state.errors.map(function (errorMsg, i) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'error', key: i },
	        errorMsg
	      );
	    }),
	        radioQuestions = this.renderRadioQuestions(this.props.questionChoices),
	        questionExplanation = this.renderQuestionExplanation(this.props.questionChoices[0]);
	    return _react2['default'].createElement(
	      'div',
	      { className: 'qna-radio-question' },
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(
	          'legend',
	          null,
	          this.props.questionPage
	        ),
	        _react2['default'].createElement('p', { className: 'qna-question-introduction',
	          dangerouslySetInnerHTML: { __html: this.props.questionIntro } }),
	        _react2['default'].createElement('div', { className: 'qna-question',
	          dangerouslySetInnerHTML: { __html: this.props.questionText } }),
	        errorMesseges,
	        _react2['default'].createElement(
	          'ul',
	          null,
	          radioQuestions
	        ),
	        _react2['default'].createElement('input', { name: 'question_id', id: 'question_id', type: 'hidden', value: this.props.questionId }),
	        _react2['default'].createElement('input', { name: this.props.questionId, id: this.props.questionId, type: 'hidden', value: 'RadioButton' })
	      ),
	      questionExplanation
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "radio_question.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	exports['default'] = {
	  renderPercentBar: function renderPercentBar(percent) {
	    var percentSpan = null;
	    if (this.props.questionIsDisabled && this.props.questionShowTable === 'true') {
	      var barStyle = {
	        width: percent + '%'
	      };
	      percentSpan = _react2['default'].createElement('span', { className: 'qna-question-percentage-bar', style: barStyle });
	    }
	    return percentSpan;
	  },
	  renderPercentNumber: function renderPercentNumber(percent) {
	    var percentSpan = null;
	    if (this.props.questionIsDisabled && this.props.questionShowTable === 'true') {
	      percentSpan = _react2['default'].createElement(
	        'span',
	        { className: 'qna-question-percentage' },
	        percent,
	        '%'
	      );
	    }
	    return percentSpan;
	  },
	  calcPercent: function calcPercent(questionChoice) {
	    var barPercentWidth = parseInt(questionChoice.totalResponse, 10);
	    if (barPercentWidth < 0 || isNaN(barPercentWidth)) {
	      barPercentWidth = 0;
	    }
	    if (barPercentWidth > 100) {
	      barPercentWidth = 100;
	    }
	    return barPercentWidth;
	  }
	};
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "renders_perecentage_bar.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = {
	  createErrors: function createErrors() {
	    if (this.props.questionRequired === 'true' && (0, _jquery2['default'])(_react2['default'].findDOMNode(this)).find('input:checked').length === 0) {
	      this.setState({ errors: ['Please select an answer.'] });
	      return false;
	    } else {
	      this.setState({ errors: [] });
	      return true;
	    }
	  },
	  validate: function validate() {
	    return this.createErrors();
	  },
	  renderQuestionExplanation: function renderQuestionExplanation(choice) {
	    if (this.props.questionIsDisabled && choice.choiceExplanation.length !== 0) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'qna-question-explanation' },
	        choice.choiceExplanation
	      );
	    } else {
	      return null;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _mixinsRenders_perecentage_bar = __webpack_require__(288);
	
	var _mixinsRenders_perecentage_bar2 = _interopRequireDefault(_mixinsRenders_perecentage_bar);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mixinsHas_question_validation = __webpack_require__(289);
	
	var _mixinsHas_question_validation2 = _interopRequireDefault(_mixinsHas_question_validation);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'checkbox_question',
	
	  propTypes: {
	    questionChoices: _react.PropTypes.array.isRequired,
	    questionId: _react.PropTypes.string.isRequired,
	    questionPage: _react.PropTypes.string,
	    questionRequired: _react.PropTypes.string,
	    questionText: _react.PropTypes.string.isRequired,
	    questionIsDisabled: _react.PropTypes.bool,
	    questionShowTable: _react.PropTypes.string,
	    questionTotalResponse: _react.PropTypes.number,
	    questionIntro: _react.PropTypes.string
	  },
	  mixins: [_mixinsRenders_perecentage_bar2['default'], _mixinsHas_question_validation2['default']],
	  getInitialState: function getInitialState() {
	    var _this = this;
	
	    var values = this.props.questionChoices.map(function (questionChoice) {
	      if (questionChoice.selected === 'true' && !_this.props.questionIsDisabled) {
	        return questionChoice._id;
	      }
	    });
	    return {
	      errors: [''],
	      values: values
	    };
	  },
	  handleChange: function handleChange() {
	    var val = [];
	    this.createErrors();
	    (0, _jquery2['default'])(_react2['default'].findDOMNode(this)).find('input:checked').each(function (i, element) {
	      val.push((0, _jquery2['default'])(element).val());
	    });
	    this.setState({ values: val });
	  },
	  renderCheckboxQuestions: function renderCheckboxQuestions() {
	    var _this2 = this;
	
	    var checkboxQuestions = this.props.questionChoices.map(function (questionChoice, i) {
	      var isChecked = false,
	          percent = _this2.calcPercent(questionChoice),
	          percentBar = _this2.renderPercentBar(percent),
	          percentNumber = _this2.renderPercentNumber(percent),
	          checkboxChoiceClasses = (0, _classnames2['default'])({
	        'qna-is-correct': questionChoice.isCorrect === 'true' && _this2.props.questionIsDisabled,
	        'qna-checkbox-choice': true,
	        'qna-is-highlighted': questionChoice.selected === 'true' && _this2.props.questionIsDisabled || _this2.state.values.indexOf(questionChoice._id) !== -1 && !_this2.props.questionIsDisabled
	      });
	      if (_this2.props.questionIsDisabled && questionChoice.selected === 'true') {
	        isChecked = true;
	      } else if ((0, _import.includes)(_this2.state.values, questionChoice._id) && !_this2.props.questionIsDisabled) {
	        isChecked = true;
	      }
	      return _react2['default'].createElement(
	        'li',
	        { className: checkboxChoiceClasses, key: i },
	        percentBar,
	        _react2['default'].createElement('input', { disabled: _this2.props.questionIsDisabled ? 'disabled' : false,
	          type: 'checkbox',
	          checked: isChecked,
	          onChange: _this2.handleChange,
	          name: 'option-' + _this2.props.questionId,
	          id: 'option-' + questionChoice._id,
	          value: questionChoice._id }),
	        _react2['default'].createElement('label', { htmlFor: 'option-' + questionChoice._id,
	          dangerouslySetInnerHTML: { __html: questionChoice.choiceText } }),
	        percentNumber
	      );
	    });
	    return checkboxQuestions;
	  },
	  render: function render() {
	    var errorMesseges = this.state.errors.map(function (errorMsg, i) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'error', key: i },
	        errorMsg
	      );
	    }),
	        checkboxQuestions = this.renderCheckboxQuestions(this.props.questionChoices),
	        questionExplanation = this.renderQuestionExplanation(this.props.questionChoices[0]);
	    return _react2['default'].createElement(
	      'div',
	      { className: 'qna-checkbox-question' },
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(
	          'legend',
	          null,
	          this.props.questionPage
	        ),
	        _react2['default'].createElement('div', { className: 'qna-question-introduction',
	          dangerouslySetInnerHTML: { __html: this.props.questionIntro } }),
	        _react2['default'].createElement('div', { className: 'qna-question',
	          dangerouslySetInnerHTML: { __html: this.props.questionText } }),
	        errorMesseges,
	        _react2['default'].createElement('input', { name: 'question_id', id: 'question_id', type: 'hidden', value: this.props.questionId }),
	        _react2['default'].createElement('input', { name: this.props.questionId, id: this.props.questionId, type: 'hidden', value: 'CheckBox' }),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          checkboxQuestions
	        )
	      ),
	      questionExplanation
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "checkbox_question.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'textbox_question',
	
	  propTypes: {
	    questionId: _react.PropTypes.string.isRequired,
	    questionPage: _react.PropTypes.string,
	    questionRequired: _react.PropTypes.string,
	    questionText: _react.PropTypes.string.isRequired,
	    questionIsDisabled: _react.PropTypes.bool
	  },
	  getInitialState: function getInitialState() {
	    return {
	      errors: ['']
	    };
	  },
	  validate: function validate() {
	    this.createErrors();
	  },
	  createErrors: function createErrors() {
	    if (this.props.questionRequired === 'true' && (0, _jquery2['default'])(_react2['default'].findDOMNode(this)).find('input').val() === '') {
	      this.setState({ errors: ['Please provide an answer.'] });
	    } else {
	      this.setState({ errors: [] });
	    }
	  },
	  handleChange: function handleChange(event) {
	    this.setState({ value: event.target.value });
	    this.createErrors();
	  },
	  render: function render() {
	    var errorMesseges = this.state.errors.map(function (errorMsg, i) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'error', key: i },
	        errorMsg
	      );
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'qna-textbox-question' },
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(
	          'legend',
	          { htmlFor: this.props.questionId },
	          this.props.questionPage
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'qna-question' },
	          this.props.questionText
	        ),
	        errorMesseges,
	        _react2['default'].createElement('input', { key: 'rkey-' + this.props.questionId,
	          disabled: this.props.questionIsDisabled ? 'disabled' : false,
	          onChange: this.handleChange,
	          className: 'qna-textbox-question',
	          type: 'textbox',
	          name: 'option-' + this.props.questionId,
	          id: this.props.questionId
	        }),
	        _react2['default'].createElement('input', { name: 'question_id', id: 'question_id', type: 'hidden', value: this.props.questionId }),
	        _react2['default'].createElement('input', { name: this.props.questionId, id: this.props.questionId, type: 'hidden', value: 'TextBox' })
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "textbox_question.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'textarea_question',
	
	  propTypes: {
	    questionId: _react.PropTypes.string.isRequired,
	    questionPage: _react.PropTypes.string,
	    questionRequired: _react.PropTypes.string,
	    questionText: _react.PropTypes.string.isRequired,
	    questionIsDisabled: _react.PropTypes.bool
	  },
	  getInitialState: function getInitialState() {
	    return {
	      errors: ['']
	    };
	  },
	  validate: function validate() {
	    this.createErrors();
	  },
	  createErrors: function createErrors() {
	    if (this.props.questionRequired === 'true' && (0, _jquery2['default'])(_react2['default'].findDOMNode(this)).find('input').val() === '') {
	      this.setState({ errors: ['Please provide an answer.'] });
	    } else {
	      this.setState({ errors: [] });
	    }
	  },
	  handleChange: function handleChange(event) {
	    this.setState({ value: event.target.value });
	    this.createErrors();
	  },
	  render: function render() {
	    var errorMesseges = this.state.errors.map(function (errorMsg, i) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'error', key: i },
	        errorMsg
	      );
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'qna-textarea-question' },
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(
	          'legend',
	          { htmlFor: this.props.questionId },
	          this.props.questionPage
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'qna-question' },
	          this.props.questionText
	        ),
	        errorMesseges,
	        _react2['default'].createElement('input', { key: 'rkey-' + this.props.questionId,
	          disabled: this.props.questionIsDisabled ? 'disabled' : false,
	          onChange: this.handleChange,
	          className: 'qna-textarea-question',
	          type: 'textarea',
	          name: 'option-' + this.props.questionId,
	          id: this.props.questionId }),
	        _react2['default'].createElement('input', { name: 'question_id', id: 'question_id', type: 'hidden', value: this.props.questionId }),
	        _react2['default'].createElement('input', { name: this.props.questionId, id: this.props.questionId, type: 'hidden', value: 'TextArea' })
	      )
	    );
	  }
	});
	module.exports = exports['default'];

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "textarea_question.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var QNAActions = function QNAActions() {
	  var QNAActionsI = _reflux2['default'].createActions({
	    cancel: {},
	    close: {},
	    reset: {},
	    hideLayer: {},
	    requestQnaXml: {
	      asyncResult: true,
	      children: ['completed', 'failed']
	    },
	    showQuestion: {},
	    hideQuestion: {},
	    post: {},
	    completed: {},
	    failed: {},
	    open: {},
	    validate: {},
	    complete: {}
	  });
	
	  QNAActionsI.requestQnaXml.shouldEmit = function () {
	    if (QNAActionsI.ajaxRequest && QNAActionsI.ajaxRequest.readyState === 1) {
	      return false;
	    }
	    return true;
	  };
	  QNAActionsI.requestQnaXml.listen(function (qid) {
	    var qnaUrl = undefined;
	    var location = window.location.hostname;
	    if (location.match(/www/)) {
	      qnaUrl = '//' + location + '/qnaService?questionnaireID=' + qid;
	    } else if (location.match(/api./)) {
	      qnaUrl = '//www.' + location.replace('api.', '') + '/qnaService?questionnaireID=' + qid;
	    } else if (location.match(/localhost/)) {
	      // for local testing
	      qnaUrl = '//localhost:8080/assets/xml/qna/local.xml';
	    } else {
	      qnaUrl = '//' + location + '/activity/qnaService?questionnaireID=' + qid;
	    }
	    QNAActionsI.ajaxRequest = _jquery2['default'].ajax({
	      type: 'get',
	      url: qnaUrl,
	      dataType: 'text',
	      statusCode: {
	        404: function _() {
	          console.log('404');
	        }
	      }
	    }).done(this.completed).fail(this.failed);
	  });
	  return QNAActionsI;
	};
	exports['default'] = QNAActions;
	module.exports = exports['default'];

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _x2js = __webpack_require__(295);
	
	var _x2js2 = _interopRequireDefault(_x2js);
	
	var _mixinsStore_state = __webpack_require__(236);
	
	var _mixinsStore_state2 = _interopRequireDefault(_mixinsStore_state);
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	var QNAStore = function QNAStore(QuizActions) {
	  return _reflux2['default'].createStore({
	    mixins: [_mixinsStore_state2['default']],
	    listenables: QuizActions,
	    stateNamespace: 'quiz',
	    onRequestQnaXml: function onRequestQnaXml(qid, page) {
	      this.setState({
	        qid: qid,
	        page: page,
	        requesting: true,
	        isChartVisible: false,
	        isQuestionVisible: false,
	        qna: qid + '/' + page,
	        completedQuestions: []
	      });
	    },
	    onHideLayer: function onHideLayer(propName) {
	      var updatedState = (0, _import.clone)(this.getState(), true);
	      updatedState[propName] = false;
	      this.setState(updatedState);
	    },
	    onReset: function onReset() {
	      this.setState({
	        qid: null,
	        page: null,
	        isQuestionVisible: false,
	        isChartVisible: false
	      });
	    },
	    onHideQuestion: function onHideQuestion(qid, page) {
	      this.setState({
	        qid: qid,
	        page: page,
	        isQuestionVisible: false,
	        isChartVisible: true
	      });
	    },
	    onShowQuestion: function onShowQuestion(qid, page) {
	      if (this.state.completedQuestions.indexOf(page) !== -1) {
	        return false;
	      }
	      if (!this.state.isChartVisible && !this.state.isQuestionVisible) {
	        var currentPage = this.state.questionnaire.page.filter(function (inPage) {
	          return inPage._id === page;
	        });
	        var hasVisibleChart = false;
	        if (!(0, _import.isEmpty)(currentPage)) {
	          hasVisibleChart = currentPage[0].question.some(function (inQuestion) {
	            return inQuestion._showAnsTable === 'true';
	          });
	        }
	        this.setState({
	          qid: qid,
	          page: page,
	          isChartVisible: hasVisibleChart,
	          isQuestionVisible: !(0, _import.isEmpty)(currentPage)
	        });
	      }
	    },
	    getChartVisibility: function getChartVisibility(page) {
	      return page.questions.some(function (question) {
	        return question._showAnsTable === 'true';
	      });
	    },
	    onRequestQnaXmlCompleted: function onRequestQnaXmlCompleted(response) {
	      var _this = this;
	
	      var x2jsParser = new _x2js2['default']();
	      var questionnaire = x2jsParser.parseXmlString(response),
	          updatedState = undefined;
	      questionnaire = x2jsParser.xml2json(questionnaire);
	      updatedState = (0, _import.clone)(this.getState(), true);
	      if (questionnaire.questionnaire.page.length) {} else {
	        questionnaire.questionnaire.page = [questionnaire.questionnaire.page];
	      }
	      questionnaire.questionnaire.page = questionnaire.questionnaire.page.filter(function (inPage) {
	        inPage.question = (0, _utilsUtil.toArray)(inPage.question);
	        return inPage._id === _this.state.page;
	      });
	      updatedState.questionnaire = questionnaire.questionnaire;
	      updatedState.isChartVisible = questionnaire.questionnaire.page[0].question.some(function (elem) {
	        return elem.responded === "true";
	      });
	      this.setState(updatedState);
	    },
	    onClose: function onClose() {
	      this.setState({
	        isChartVisible: false,
	        isQuestionVisible: false,
	        index: null
	      });
	    },
	    onPost: function onPost(postString, qid, page) {
	      var tempCompletedQuestions = [].concat(this.state.completedQuestions, page);
	      this.setState({
	        index: null,
	        completedQuestions: tempCompletedQuestions,
	        isChartVisible: true
	      });
	    }
	  });
	};
	exports['default'] = QNAStore;
	module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = function X2JS(s){var o="1.1.3";s=s||{};g();function g(){if(s.escapeMode===undefined){s.escapeMode=true;}s.attributePrefix=s.attributePrefix||"_";s.arrayAccessForm=s.arrayAccessForm||"none";s.emptyNodeForm=s.emptyNodeForm||"text";if(s.enableToStringFunc===undefined){s.enableToStringFunc=true;}s.arrayAccessFormPaths=s.arrayAccessFormPaths||[];if(s.skipEmptyTextNodesForObj===undefined){s.skipEmptyTextNodesForObj=true;}}var f={ELEMENT_NODE:1,TEXT_NODE:3,CDATA_SECTION_NODE:4,COMMENT_NODE:8,DOCUMENT_NODE:9};function q(u){var v=u.localName;if(v==null){v=u.baseName;}if(v==null||v==""){v=u.nodeName;}return v;}function m(u){return u.prefix;}function n(u){if(typeof(u)=="string"){return u.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;");}else{return u;}}function i(u){return u.replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&#x27;/g,"'").replace(/&#x2F;/g,"/");}function j(y,v,x){switch(s.arrayAccessForm){case"property":if(!(y[v] instanceof Array)){y[v+"_asArray"]=[y[v]];}else{y[v+"_asArray"]=y[v];}break;}if(!(y[v] instanceof Array)&&s.arrayAccessFormPaths.length>0){var u=0;for(;u<s.arrayAccessFormPaths.length;u++){var w=s.arrayAccessFormPaths[u];if(typeof w==="string"){if(w==x){break;}}else{if(w instanceof RegExp){if(w.test(x)){break;}}else{if(typeof w==="function"){if(w(y,v,x)){break;}}}}}if(u!=s.arrayAccessFormPaths.length){y[v]=[y[v]];}}}function t(w,B){if(w.nodeType==f.DOCUMENT_NODE){var C=new Object;var u=w.childNodes;for(var D=0;D<u.length;D++){var v=u.item(D);if(v.nodeType==f.ELEMENT_NODE){var A=q(v);C[A]=t(v,A);}}return C;}else{if(w.nodeType==f.ELEMENT_NODE){var C=new Object;C.__cnt=0;var u=w.childNodes;for(var D=0;D<u.length;D++){var v=u.item(D);var A=q(v);if(v.nodeType!=f.COMMENT_NODE){C.__cnt++;if(C[A]==null){C[A]=t(v,B+"."+A);j(C,A,B+"."+A);}else{if(C[A]!=null){if(!(C[A] instanceof Array)){C[A]=[C[A]];j(C,A,B+"."+A);}}(C[A])[C[A].length]=t(v,B+"."+A);}}}for(var x=0;x<w.attributes.length;x++){var y=w.attributes.item(x);C.__cnt++;C[s.attributePrefix+y.name]=y.value;}var z=m(w);if(z!=null&&z!=""){C.__cnt++;C.__prefix=z;}if(C["#text"]!=null){C.__text=C["#text"];if(C.__text instanceof Array){C.__text=C.__text.join("\n");}if(s.escapeMode){C.__text=i(C.__text);}delete C["#text"];if(s.arrayAccessForm=="property"){delete C["#text_asArray"];}}if(C["#cdata-section"]!=null){C.__cdata=C["#cdata-section"];delete C["#cdata-section"];if(s.arrayAccessForm=="property"){delete C["#cdata-section_asArray"];}}if(C.__cnt==1&&C.__text!=null){C=C.__text;}else{if(C.__cnt==0&&s.emptyNodeForm=="text"){C="";}else{if(C.__cnt>1&&C.__text!=null&&s.skipEmptyTextNodesForObj){if(C.__text.trim()==""){delete C.__text;}}}}delete C.__cnt;if(s.enableToStringFunc&&C.__text!=null||C.__cdata!=null){C.toString=function(){return(this.__text!=null?this.__text:"")+(this.__cdata!=null?this.__cdata:"");};}return C;}else{if(w.nodeType==f.TEXT_NODE||w.nodeType==f.CDATA_SECTION_NODE){return w.nodeValue;}}}}function k(B,y,A,v){var x="<"+((B!=null&&B.__prefix!=null)?(B.__prefix+":"):"")+y;if(A!=null){for(var z=0;z<A.length;z++){var w=A[z];var u=B[w];x+=" "+w.substr(s.attributePrefix.length)+"='"+u+"'";}}if(!v){x+=">";}else{x+="/>";}return x;}function h(v,u){return"</"+(v.__prefix!=null?(v.__prefix+":"):"")+u+">";}function p(v,u){return v.indexOf(u,v.length-u.length)!==-1;}function r(v,u){if((s.arrayAccessForm=="property"&&p(u.toString(),("_asArray")))||u.toString().indexOf(s.attributePrefix)==0||u.toString().indexOf("__")==0||(v[u] instanceof Function)){return true;}else{return false;}}function l(w){var v=0;if(w instanceof Object){for(var u in w){if(r(w,u)){continue;}v++;}}return v;}function a(w){var v=[];if(w instanceof Object){for(var u in w){if(u.toString().indexOf("__")==-1&&u.toString().indexOf(s.attributePrefix)==0){v.push(u);}}}return v;}function e(v){var u="";if(v.__cdata!=null){u+="<![CDATA["+v.__cdata+"]]>";}if(v.__text!=null){if(s.escapeMode){u+=n(v.__text);}else{u+=v.__text;}}return u;}function b(v){var u="";if(v instanceof Object){u+=e(v);}else{if(v!=null){if(s.escapeMode){u+=n(v);}else{u+=v;}}}return u;}function d(w,y,x){var u="";if(w.length==0){u+=k(w,y,x,true);}else{for(var v=0;v<w.length;v++){u+=k(w[v],y,a(w[v]),false);u+=c(w[v]);u+=h(w[v],y);}}return u;}function c(A){var u="";var y=l(A);if(y>0){for(var x in A){if(r(A,x)){continue;}var w=A[x];var z=a(w);if(w==null||w==undefined){u+=k(w,x,z,true);}else{if(w instanceof Object){if(w instanceof Array){u+=d(w,x,z);}else{var v=l(w);if(v>0||w.__text!=null||w.__cdata!=null){u+=k(w,x,z,false);u+=c(w);u+=h(w,x);}else{u+=k(w,x,z,true);}}}else{u+=k(w,x,z,false);u+=b(w);u+=h(w,x);}}}}u+=b(A);return u;}this.parseXmlString=function(u){if(u===undefined){return null;}var v;if(window.DOMParser){var w=new window.DOMParser();v=w.parseFromString(u,"text/xml");}else{if(u.indexOf("<?")==0){u=u.substr(u.indexOf("?>")+2);}v=new ActiveXObject("Microsoft.XMLDOM");v.async="false";v.loadXML(u);}return v;};this.asArray=function(u){if(u instanceof Array){return u;}else{return[u];}};this.xml2json=function(u){return t(u);};this.xml_str2json=function(u){var v=this.parseXmlString(u);return this.xml2json(v);};this.json2xml_str=function(u){return c(u);};this.json2xml=function(v){var u=this.json2xml_str(v);return this.parseXmlString(u);};this.getVersion=function(){return o;};}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* REACT HOT LOADER */ if (true) { (function () { var ReactHotAPI = __webpack_require__(190), RootInstanceProvider = __webpack_require__(198), ReactMount = __webpack_require__(176), React = __webpack_require__(5); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsRenders_question_components = __webpack_require__(286);
	
	var _mixinsRenders_question_components2 = _interopRequireDefault(_mixinsRenders_question_components);
	
	var _classnames = __webpack_require__(249);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'cme_chart',
	
	  propTypes: {
	    charts: _react.PropTypes.array.isRequired,
	    closeHandler: _react.PropTypes.func.isRequired
	  },
	  mixins: [_mixinsRenders_question_components2['default']],
	  close: function close() {
	    this.props.closeHandler('isChartVisible');
	  },
	  render: function render() {
	    var _this = this;
	
	    var hasCorrect = false;
	    var resultsComp = this.props.charts.map(function (question, i, questionArray) {
	      if (!hasCorrect && question.choice.length > 0) {
	        for (var j = 0; j < question.choice.length; j++) {
	          if (question.choice[j].isCorrect === 'true') {
	            hasCorrect = true;
	            break;
	          }
	        }
	      }
	      var renderedQuestion = _this.renderQuestion(question, i, questionArray);
	      return _react2['default'].createElement(
	        'div',
	        { key: i },
	        renderedQuestion
	      );
	    });
	    var qnaCorrectClasse = (0, _classnames2['default'])({
	      'is-visible': hasCorrect,
	      'qna-is-correct': true
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cme-chart' },
	      _react2['default'].createElement(
	        'p',
	        { className: qnaCorrectClasse },
	        'Indicates correct answer.'
	      ),
	      resultsComp
	    );
	  }
	});
	module.exports = exports['default'];
	/*<div className="button-container">
	 <div className="qna-continue-button" onClick={this.close}>Continue</div>
	</div>*/

	/* REACT HOT LOADER */ }).call(this); } finally { if (true) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = __webpack_require__(251); if (makeExportsHot(module, __webpack_require__(5))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "cme_chart.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(298);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(274)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(298, function() {
				var newContent = __webpack_require__(298);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(273)();
	exports.push([module.id, ".bp .akamai-branding-image,.bp .arbitrary-content{display:none}.bp #pageWrapper,body{margin:0 auto;height:100%}@font-face{font-family:proxima_nova_ltlight;src:url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/proximanova-light-webfont.eot\");src:url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/proximanova-light-webfont.eot?#iefix\") format(\"embedded-opentype\"),url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/webfont.woff2\") format(\"woff2\"),url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/proximanova-light-webfont.woff\") format(\"woff\"),url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/proximanova-light-webfont.ttf\") format(\"truetype\"),url(\"//img.medscapestatic.com/medcss/fonts/proximanova/light/proximanova-light-webfont.svg#\") format(\"svg\")}html{height:100%}body{min-height:100%}a{color:#4d4284}.bp .grabbable{cursor:move;cursor:grab;cursor:-webkit-grab}.bp .grabbable:active{cursor:grabbing;cursor:-webkit-grabbing}.bp .akamai-branding-logo{opacity:1;right:0;position:relative;top:0;center:0}.bp #pageWrapper{width:980px;position:relative}.bp #sponsorLine{margin:10px 0}.bp #sponsorLine:after{content:\"\";display:table;clear:both}.bp #returnToMedscapeMobile,.bp .brand-play-isi,.bp .isi-content{display:none}.bp #brandPlay{height:100%;background-color:rgba(0,0,0,.2)}.bp .brand-play-content{text-align:center;height:100%;background:linear-gradient(to bottom,#cdcbdc 0,#efeff4 50%,#efeff4 100%);padding-bottom:15px}.bp .isi-container{padding:10px}.bp .highlight-wrap{background-image:linear-gradient(to bottom,#000,#092734)}.bp .highlight-content{padding:20px 0;margin:0 auto;width:100%}.bp .brand-play-wrapper{width:67%;margin:0 2%;float:left;font-family:proxima_nova_ltlight}.bp .brand-play-wrapper .brand-play{text-align:left}.bp .brand-play-wrapper .brand-play .slick-next{right:-10px}.bp .add{width:23%;float:right}.bp .add img{width:100%}.bp .brand-play-header-image{width:200px}.bp .brand-play-header-isi-link{float:right;font-size:12px}.bp .brand-play-chrome-menu-bar{height:30px}.bp .is-advertisement .draggable,.bp .is-advertisement .video-player-elapsed-time-indicator{background-color:#f69b6f}.bp .advertisment{color:#f69b6f}.bp .brand-play-chrome{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;-ms-flex-direction:column;flex-direction:column}.bp .social-media-wrap{-ms-flex-positive:1;flex-grow:1;min-width:250px;display:-ms-flexbox;display:flex}.bp .brand-play-chrome-title{color:#FFF;font-size:19px;margin:10px 0 0 10px;line-height:20px;-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.bp .brand-play-chrome-title .label{font-size:14px;line-height:2.1;color:#ccc;white-space:nowrap;display:-ms-flexbox;display:flex;margin-right:10px}.bp .comments-wrap,.bp .share-wrap,.bp .transcript-wrap{-ms-flex-positive:0;flex-grow:0;margin:2%;cursor:pointer;color:#aaa;height:15px;background-repeat:no-repeat;background-position:0 3px;padding:0 0 0 17px}.bp .label-advertisment,.bp .label-episode{margin:2% 2% 2% 10px;height:15px;background-repeat:no-repeat;text-align:left}.bp .comments-wrap:hover,.bp .share-wrap:hover,.bp .transcript-wrap:hover{color:#fff}.bp .label-episode{-ms-flex-positive:5;flex-grow:5;padding:0;color:#aaa}.bp .label-advertisment{-ms-flex-positive:5;flex-grow:5;padding:0;font-size:14px;line-height:2.1;color:#f69b6f;display:-ms-flexbox;display:flex}.bp .comments-wrap{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/comments-icon.svg\")}.bp .transcript-wrap{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/transcript-icon.svg\")}.bp .share-wrap{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/share-icon.svg\")}.bp .akamai-branding-container{vertical-align:bottom!important}.bp .video-player-overlay{height:90%;z-index:9}.bp #brandPlay .video-player-controls .video-player-volume-slider{width:13%}.bp video{transform-style:preserve-3}.bp .brand-play-chrome-notes-button{float:right;border:0;padding:0;text-indent:-1000em;overflow:hidden;width:22px;height:26px;background:url(\"//img.proddev.medscapestatic.com/pi/features/brandplay/info_icon@2.png\") top left;background-size:contain}.bp .brand-play-menu-dropdown{display:block;margin-left:22px;margin-right:10px;float:right;position:relative;width:22px;height:26px}.bp .brand-play-menu-dropdown-open{display:block;text-indent:-1000em;overflow:hidden;width:22px;height:26px;background:url(\"//img.proddev.medscapestatic.com/pi/features/brandplay/menu_icon@2.png\") top left;background-size:contain}.bp .brand-play-menu-dropdown-list{top:40px;left:-90px;display:none;visiblity:hidden;opacity:0;transform:scale(.9);transition:transform .2s,opacity .2s,visibility 0s .2s;list-style:none;margin:0;padding:0;position:absolute;width:200px;color:#333;font-size:17px;border-radius:5px;border:1px solid #ccc;box-shadow:0 0 10px 2px rgba(0,0,0,.05)}.bp .brand-play-menu-dropdown-list.is-open{z-index:100;display:block;visibility:visible;opacity:1;transform:scale(1);transition:transform .4s,opacity .4s}.bp .brand-play-menu-dropdown-list li{transition:all .2s ease-out;-webkit-transition:all .2s ease-out;-moz-transition:all .2s ease-out;-ms-transition:all .2s ease-out;color:#333;display:block;padding:10px;font:400 14px arial,sans-serif;background:#FFF;background:rgba(255,255,255,.98);border-bottom:1px solid #f7f7f7;cursor:pointer}.bp .brand-play-menu-dropdown-item.cancel,.bp .overlay{display:none}.bp .brand-play-menu-dropdown-list li a{text-decoration:none;color:#333}.bp .brand-play-menu-dropdown-list li:hover{background-color:#f7f7f7}.bp .brand-play-menu-dropdown-list .brand-play-menu-dropdown-arrow{position:absolute;left:95px;top:-5px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #FFF;box-shadow:0 0 10px 2px rgba(0,0,0,.05)}.bp .video-player-playlist-item img{width:100%;height:100%}.bp .slick-list{width:100%}.bp .video-player-playlist-item{padding:0;position:relative;cursor:pointer;width:94%;margin:0 6% 0 0}.bp .slick-next,.bp .slick-prev{height:28px;width:17px;top:30%;background-repeat:no-repeat}.bp .is-selected .brand-play-chapter-title{color:#999}.bp .has-viewed .brand-play-chapter-thumbnail,.bp .is-selected .brand-play-chapter-thumbnail{opacity:.3;transition:opacity 2s}.bp .episode-title{color:#FFF;font-size:13px;margin:0 0 4px}.bp .slick-prev{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/carousel-left-arrow.svg\");line-height:0;font-size:0;color:inherit}.bp .slick-prev:hover{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/carousel-left-arrow-hover.svg\");background-repeat:no-repeat}.bp .slick-prev:before{content:none}.bp .slick-next{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/carousel-right-arrow.svg\");color:inherit}.bp .slick-next:hover{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/carousel-right-arrow-hover.svg\");background-repeat:no-repeat}.bp .slick-next:before{content:none}.bp .slick-next:focus,.bp .slick-next:hover,.bp .slick-prev:focus,.bp .slick-prev:hover{background:inherit;color:inherit}.bp .overlay-scale{visibility:hidden;opacity:0;transform:scale(.9);transition:transform .2s,opacity .2s,visibility 0s .2s}.bp .overlay-scale.open{visibility:visible;opacity:1;transform:scale(1);transition:transform .4s,opacity .4s;z-index:110}.bp .overlay{position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(255,255,255,.5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);z-index:999999999}.bp .overlay.is-visible{display:block}.bp .overlay .overlay-close{width:40px;height:40px;position:absolute;right:0;top:0;overflow:hidden;border:none;background:url(\"//img.proddev.medscapestatic.com/pi/features/brandplay/x.png\") center center no-repeat;text-indent:200%;color:transparent;outline:0;z-index:100}.bp .overlay_content{padding:5%;background-color:#FFF;width:90%;height:60%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:left;overflow-y:auto}.bp .overlay_content h3{color:#4d4184;font-size:14px;text-transform:uppercase;margin:10px 0}.bp .overlay_content p{font-size:13px;margin:0 0 12px}.bp .overlay_content ul{line-height:15px;list-style-type:none;margin:0;padding:0 0 0 3px;font-size:13px}.bp .overlay_content ul li{margin:0 0 14px;padding:0 0 0 8px;background-image:url(\"//img.proddev.medscapestatic.com/pi/features/brandplay/bullet.png\");background-repeat:no-repeat;background-position:left 5px;background-size:4px 4px}.bp #bioContainer{overflow:auto;-webkit-overflow-scrolling:touch;margin-bottom:15px;padding-bottom:15px;border-bottom:1px solid #CCC}.bp #bioContainer img{width:100px;float:left;margin:0 10px 0 0}.bp #bioContainer h3{margin:0 0 10px}.bp #bioContainer p{font-size:12px;margin:0}.bp .blackBox{border:1px solid #000;padding:10px;margin:0 0 10px}.bp .blackBox p:first-child{margin:0}.bp .blackBox p:last-child{margin-bottom:0}.bp .slider{margin:0 auto;padding:10px;width:100%;color:#333;background:0 0}.bp .now-playing,.bp .watched{font-size:13px;line-height:13px;display:inline-block;opacity:.6;color:#FFF;padding:3px 5px;position:absolute;top:35px;left:0}.bp .now-playing{background-color:rgba(0,90,129,.7)}.bp .watched{background-color:#aaa}.bp .video-title{margin:10px 0 0;color:#fff}.bp .video-title .low-light{color:#aaa}.bp .brand-play-player{width:100%}.bp .hidden{display:none}.bp .share-wrap{position:relative}.bp .share-wrap .share-menu{width:60px;position:absolute;bottom:125%;left:2px;background-color:#FFF;color:transparent}.bp .share-wrap .share-menu .email-button:hover,.bp .share-wrap .share-menu .facebook-button:hover,.bp .share-wrap .share-menu .google-button:hover,.bp .share-wrap .share-menu .linkedIn-button:hover,.bp .share-wrap .share-menu .print-button:hover,.bp .share-wrap .share-menu .twitter-button:hover{background-color:#092734}.bp .share-wrap .share-menu:after{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:rgba(136,183,213,0);border-top-color:#FFF;border-width:10px;margin-left:-10px}.bp .share-wrap .share-menu div{float:left;width:30px;height:30px;opacity:.9;transition:opacity .2s;-webkit-transition:opacity .2s;-moz-transition:opacity .2s;background-repeat:no-repeat;background-position:center}.bp .share-wrap .share-menu .facebook-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/facebook.svg\")}.bp .share-wrap .share-menu .twitter-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/twitter.svg\")}.bp .share-wrap .share-menu .google-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/google-plus.svg\")}.bp .share-wrap .share-menu .linkedIn-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/linkedin.svg\")}.bp .share-wrap .share-menu .email-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/email.svg\")}.bp .share-wrap .share-menu .print-button{background-image:url(\"//img.proddev.medscapestatic.com/pi/core/products/brandplay/images/video-player/print.svg\")}", ""]);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/*!Last Updated: 03.10.2014[01.04.19] by Jonathan Robles*/
	/*!*/
	/*!***********************************************/
	/*!  __  __        _                             */
	/*! |  \/  |___ __| |___ __ __ _ _ __  ___       */
	/*! | |\/| / -_) _` (_-</ _/ _` | '_ \/ -_)      */
	/*! |_|  |_\___\__,_/__/\__\__,_| .__/\___|      */
	/*!                             |_|              */
	/*! required MODULE */
	/*! by Jonathan Robles for WEBMD/Medscape 2013   */
	/*!                                              */
	/*!***********************************************/
	/*!CLX*/
	/*!*/
	/*!*/
	/*!*/
	/*!*/
	/*!*/
	/*!Last Updated: 03.10.2014[01.04.19] by Jonathan Robles*/
	'use strict';
	
	if (typeof window.medscape === 'undefined') {
	    window.medscape = {};
	}
	
	window.medscape.core = {};
	window.medscape.core.isApp = navigator.userAgent.toLowerCase().match('medscape') !== null;
	window.medscape.core.env = "";
	
	if (typeof Object.create !== "function") {
	    Object.create = function (o) {
	        function F() {}
	        F.prototype = o;
	        return new F();
	    };
	}
	
	(function () {
	    var lastTime = 0;
	    var vendors = ["ms", "moz", "webkit", "o"];
	    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
	        window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
	    }
	    if (!window.requestAnimationFrame) {
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function () {
	                callback(currTime + timeToCall);
	            }, timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    }
	    if (!window.cancelAnimationFrame) {
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	    }
	})();
	
	(function () {
	    if (!window.console) {
	        window.console = {};
	    }
	    var m = ["log", "info", "warn", "error", "debug", "trace", "dir", "group", "groupCollapsed", "groupEnd", "time", "timeEnd", "profile", "profileEnd", "dirxml", "assert", "count", "markTimeline", "timeStamp", "clear"];
	    for (var i = 0; i < m.length; i++) {
	        if (!window.console[m[i]]) {
	            window.console[m[i]] = function () {};
	        }
	    }
	})();
	
	window._notify = (function () {
	    var debug = function debug() {};
	    var components = {};
	    var broadcast = function broadcast(event, args, source) {
	        if (!event) {
	            return;
	        }
	        args = args || [];
	        for (var c in components) {
	            if (typeof components[c]["on" + event] == "function") {
	                try {
	                    source = source || components[c];
	                    components[c]["on" + event].apply(source, args);
	                } catch (err) {
	                    debug(["Mediator error.", event, args, source, err].join(" "));
	                }
	            }
	        }
	    };
	    var addComponent = function addComponent(name, component, replaceDuplicate) {
	        if (name in components) {
	            if (replaceDuplicate) {
	                removeComponent(name);
	            } else {
	                throw new Error("The object: " + name + " has already applied listeners");
	            }
	        }
	        components[name] = component;
	    };
	    var removeComponent = function removeComponent(name) {
	        if (name in components) {
	            delete components[name];
	        }
	    };
	    var getComponent = function getComponent(name) {
	        return components[name];
	    };
	    var contains = function contains(name) {
	        return name in components;
	    };
	    return {
	        name: "Mediator",
	        broadcast: broadcast,
	        add: addComponent,
	        rem: removeComponent,
	        get: getComponent,
	        has: contains
	    };
	})();
	
	_notify.add("global", (function () {
	    var tracecount = 0;
	    var alertcount = 0;
	    return {
	        onTrace: function onTrace(o) {
	            tracecount++;
	            var datastring = o.data;
	            if (typeof datastring == "object") {
	                datastring = JSON.stringify(datastring);
	            }
	            var buildstring = "[" + String(tracecount) + "] (" + o.senderID + ":" + o.sendertype + ":" + o.notifyscope + ") > " + datastring;
	            //console.log(buildstring);
	        },
	        onAlert: function onAlert(o) {
	            alertcount++;
	            var datastring = o.data;
	            if (typeof datastring == "object") {
	                datastring = JSON.stringify(datastring);
	            }
	            var buildstring = "[" + String(tracecount) + "] (" + o.senderID + ":" + o.sendertype + ":" + o.notifyscope + ") > " + datastring;
	            alert(buildstring);
	        },
	        onInitialize: function onInitialize(o) {
	            //console.log("Created Instance #" + o.senderID + " type:" + o.sendertype + " by " + o.data.author + " [notifyscope:" + o.notifyscope + "]");
	        },
	        onOrientation: function onOrientation(o) {
	            window._global$.addorientationtohtml(o);
	        }
	    };
	})());
	
	!/* require */(/* limit */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300), __webpack_require__(314), __webpack_require__(3), __webpack_require__(315)]; (function (brandplay, Modernizr, $, _) {
	    !/* require */(/* limit */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (function (brandplay) {
	        var brandplayObject = new brandplay(window.bpInstance.bp);
	        brandplayObject.init();
	    }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}());
	    function CorePlayerBase() {
	        /*if (arguments.callee._singletonInstance) {
	            return arguments.callee._singletonInstance;
	        }
	        arguments.callee._singletonInstance = this;*/
	        var parent = this;
	        var debouncetimeout = 250;
	        this.lastscrollpositionX = 0;
	        this.lastscrollpositionY = 0;
	        this.orientation = "notset";
	        this.windowHeight = undefined;
	        this.windowWidth = undefined;
	        this.documentHeight = undefined;
	        this.documentWidth = undefined;
	        this.screenHeight = undefined;
	        this.screenWidth = undefined;
	        //this.isMobile = Modernizr.mq("only screen and (min-device-width : 320px) and (max-device-width : 480px)");
	        this.isTouch = Modernizr.touch;
	        this.host = location.host;
	        this.addorientationtohtml = function (o) {
	            if (o.data == "portrait") {
	                $("html").addClass("portrait");
	                $("html").removeClass("landscape");
	            } else {
	                $("html").addClass("landscape");
	                $("html").removeClass("portrait");
	            }
	        };
	        this.setOrientation = function () {
	            var candidate = "portrait";
	            this.setWindowHeight();
	            this.setWindowWidth();
	            if (this.windowWidth > this.windowHeight) {
	                candidate = "landscape";
	            }
	            this._isupdated("orientation", candidate, "Orientation");
	        };
	        this.setWindowHeight = function () {
	            this._isupdated("windowHeight", $(window).height(), "WindowHeight");
	        };
	        this.setWindowWidth = function () {
	            this._isupdated("windowWidth", $(window).width(), "WindowWidth");
	        };
	        this.setDocumentHeight = function () {
	            this._isupdated("documentHeight", $(document).height(), "DocumentHeight");
	        };
	        this.setDocumentWidth = function () {
	            this._isupdated("documentWidth", $(document).width(), "DocumentWidth");
	        };
	        this.setScreenHeight = function () {
	            this._isupdated("screenHeight", screen.height, "ScreenHeight");
	        };
	        this.setScreenWidth = function () {
	            this._isupdated("screenWidth", screen.width, "ScreenWidth");
	        };
	        this.setLastScrollposition = function () {
	            var newXval = $(window).scrollLeft();
	            var newYval = $(window).scrollTop();
	            if (newYval > parent.lastscrollpositionY) {
	                $("html").addClass("scrolldown");
	                $("html").removeClass("scrollup");
	            }
	            if (newYval < parent.lastscrollpositionY) {
	                $("html").addClass("scrollup");
	                $("html").removeClass("scrolldown");
	            }
	            if (newXval > parent.lastscrollpositionX) {
	                $("html").addClass("scrollright");
	                $("html").removeClass("scrollleft");
	            }
	            if (newXval < parent.lastscrollpositionX) {
	                $("html").addClass("scrollleft");
	                $("html").removeClass("scrollright");
	            }
	            this._isupdated("lastscrollpositionX", newXval, "LastXscroll");
	            this._isupdated("lastscrollpositionY", newYval, "LastYscroll");
	        };
	        this.jsonpReturn = function (id, type, notifyscope) {
	            return function (data) {
	                _notify.broadcast(type, [{
	                    senderID: id,
	                    sendertype: type,
	                    notifyscope: notifyscope,
	                    data: data
	                }]);
	            };
	        };
	        this._isupdated = function (value, currentVal, notify) {
	            if (parent[value] != currentVal) {
	                var Oldvalue = parent[value];
	                parent[value] = currentVal;
	                if (Oldvalue != undefined) {
	                    this.notify(notify, parent[value]);
	                }
	            }
	        };
	        this.notify = function (type, data) {
	            _notify.broadcast(type, [{
	                senderID: "global",
	                sendertype: "global",
	                notifyscope: "global",
	                data: data
	            }]);
	        };
	        this.getQuery = function (variable) {
	            var query = window.location.search.substring(1);
	            var vars = query.split("&");
	            for (var i = 0; i < vars.length; i++) {
	                var pair = vars[i].split("=");
	                if (pair[0] == variable) {
	                    var returncandidate = pair[1];
	                    if (returncandidate == "true" || returncandidate == "yes" || returncandidate == "y" || returncandidate == "t") {
	                        returncandidate = true;
	                    }
	                    if (returncandidate == "false" || returncandidate == "no" || returncandidate == "n" || returncandidate == "f") {
	                        returncandidate = false;
	                    }
	                    return returncandidate;
	                }
	            }
	            return false;
	        };
	        this.getHash = function (variable) {
	            return window.location.hash;
	        };
	        this.setCookie = function (key, value) {
	            var expires = new Date();
	            expires.setTime(expires.getTime() + 1 * 24 * 60 * 60 * 1e3);
	            document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
	        };
	        this.getCookie = function (key) {
	            var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
	            return keyValue ? keyValue[2] : null;
	        };
	
	        $(window).scroll(_.debounce(function (event) {
	            parent.setLastScrollposition();
	        }, debouncetimeout));
	
	        // $(window).on("resize", _.debounce(function(event) {
	        // parent.setOrientation();
	        // }, debouncetimeout));
	    }
	    window._global$ = new CorePlayerBase();
	    window._global$.setOrientation();
	    window._global$.setDocumentHeight();
	    window._global$.setDocumentWidth();
	    window._global$.setScreenHeight();
	    window._global$.setScreenWidth();
	}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}());

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Brand Play 2 module
	 *
	 * Last Edit:
	 * 07.22.16 by MN and AP => Inegrate new video (MedscapeTV video player) with the
	 * BP1 template and get rid of CorelibBP3/Grunt. Now this script is part of the bundle
	 * 09.15.17 adding MobileMenu module ....
	 */
	
	'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(301), __webpack_require__(302), __webpack_require__(303), __webpack_require__(313)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, parentModel, Util, tracking, MobileMenu) {
	    function thisObject(o) {
	        var defaults = {
	            type: 'module',
	            author: 'EB, MN and AP',
	            trackingBp: '',
	            ippResumeEnable: true,
	            ippResumeShow: true,
	            totalVids: bpInstance.videos.length,
	            specificPercentArray: [25, 50, 75],
	            percentAlreadyTracked: [],
	            stayAliveSeconds: 15,
	            bookmarkedVid: 0,
	            roadblock: '',
	            switchVidNum: 1,
	            switchVidFlag: false,
	            playPauseClickFlag: false,
	            ieScrubFlag: false,
	            ieScrubDebounce: '',
	            chpClickFlag: 0,
	            tempLockVidControls: false,
	            enableHeartbeat: true,
	            bookmarkVidLoadingImage: 'pi/features/brandplay/blackpixel.png',
	            isi: {
	                showOnload: false,
	                container: 'isiContainer'
	            }
	        };
	
	        defaults = $.extend(true, defaults, o);
	        parentModel.call(this, defaults);
	        return this;
	    }
	
	    // Inherit parent methods/variables
	    thisObject.prototype = Object.create(parentModel.prototype);
	    // set status of isi
	    thisObject.prototype.isiStatus = {
	        isOpen: false,
	        setup: false
	    };
	
	    // Listeners
	    thisObject.prototype._startlisteners = function () {
	        this.notify('Trace', '_startlisteners');
	        var parent = this;
	        var self = this;
	        var myID = this._id();
	        var hasStartedParticipation = false;
	    };
	
	    /* Initialize function */
	    thisObject.prototype.init = function () {
	        this.notify('Trace', 'init');
	        this._startlisteners();
	        var self = this;
	
	        window.s_business_reference = 'video-brandplay';
	
	        // Play & pause click flag
	        $('.active-video, .vjs-big-play-button, .vjs-play-control, .vjs-tech, .replayVideoButton, .nextVideoButton, .chapter, .chapter_icon, .chapter_text').on('click', function () {
	            self._var().playPauseClickFlag = true;
	        });
	
	        if ('onhashchange' in window) {
	            // Set flag on hashchange for Mobile App to match web tracking. When users clicks chapter, it should send a 'play' tracking call as opposed to an autoplay.
	            $(window).on('hashchange', function () {
	                self._var().playPauseClickFlag = true;
	            });
	        }
	
	        self.notify('GetTotalVidsOnPage', self._var().totalVids);
	        self.notify('GetPercentages', self._var().specificPercentArray.toString());
	        self.notify('StayAliveSeconds', self._var().stayAliveSeconds);
	
	        $(document).ready(function () {
	            self.$brandPlay = $('#brandPlay');
	            self.$menuDropDown = $('#menuDropdown');
	            self.$chapterMenu = $('#chapter-menu');
	            self.$overlayNew = $('.overlay-new');
	            self.$menu = $('#menu');
	            self.$overlayClose = $('.overlay-close');
	            self.$bpContent = $('#bp_content');
	            self.$pageWrapper = $('#pageWrapper');
	            self.$notes = $('#notes');
	            self.$solidOverlay = $('#solidOverlay');
	            self.$menuArrow = $('.menuArrow');
	            self.$isiContainer = $('#isiContainer');
	            self.$menuBG = $('#menuBG');
	            self.$visPlayControl = $('.vjs-play-control');
	            self.$bpDisclaimer = $('.bp_disclaimer');
	            self.$sponsorLine = $('#sponsorLine');
	
	            var isApp = window.medscape.core.isApp;
	            var menuOpenClsName = 'menu_open';
	
	            // doesn't appear to be returning true for app
	            if (isApp) {
	                // self.$overlayClose.hide();
	                self.isApp = true;
	            }
	
	            // Play & pause click flag
	            $('.active-video, .vjs-big-play-button, .vjs-play-control, .vjs-tech, .replayVideoButton, .nextVideoButton, .chapter, .chapter_icon, .chapter_text').on('click', function () {
	                self._var().playPauseClickFlag = true;
	            });
	
	            if (!self._var().ippResumeEnable) {
	                $('#chapter-1').addClass('playing');
	            }
	
	            self.$menuDropDown.find('.firstLink').hover(function () {
	                self.$menuArrow.addClass('arrowHoverColor');
	            }, function () {
	                self.$menuArrow.removeClass('arrowHoverColor');
	            });
	
	            $(window).on('video_player:rendered', function () {
	                self.playerReady = true;
	            });
	
	            // check the video element exist before binding event handlers
	            function checkVideoElement() {
	                if ($('video').length === 0) {
	                    window.requestAnimationFrame(checkVideoElement);
	                } else {
	                    self.$video = $('video');
	                    addEventBinding();
	                }
	            }
	            window.requestAnimationFrame(checkVideoElement);
	
	            function addEventBinding() {
	                self.$chapterMenu.on('click', function () {
	                    // if desktop
	                    if (!Util.isMobile() && !Util.isIpad()) {
	                        if (!$(this).hasClass(menuOpenClsName)) {
	                            self.$menu.removeClass(menuOpenClsName);
	                            $(this).addClass(menuOpenClsName);
	                            self.$menuDropDown.hide().removeClass('open');
	                            return false;
	                        } else {
	                            self.$menu.removeClass(menuOpenClsName);
	                        }
	                    }
	                });
	
	                if (!Util.isMobile() && !Util.isIpad()) {
	                    self.$menu.on('click', function () {
	                        if (!self.$menu.hasClass(menuOpenClsName)) {
	                            self.$menu.removeClass(menuOpenClsName);
	                            self.$menu.addClass(menuOpenClsName);
	                            self.$menuDropDown.show().addClass('open');
	                            self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_OPEN', 'vidvbp-action_sheet_open', this]);
	                            return false;
	                        } else {
	                            self.$menu.removeClass(menuOpenClsName);
	                            self.$menuDropDown.hide().removeClass('open');
	                            self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', this]);
	                        }
	                    });
	                }
	
	                // The below code dismisses all modal layers when the user clicks outside of a modal layer
	                self.$pageWrapper.on('click', function () {
	                    if (self.$menu.hasClass(menuOpenClsName) || self.$chapterMenu.hasClass(menuOpenClsName)) {
	                        self.$menu.removeClass(menuOpenClsName);
	                        self.$menuDropDown.hide().removeClass('open');
	                        self.$brandPlay.removeClass('lock-isi');
	                        self.$isiContainer.removeClass('lock-isi');
	                        self.$video.removeClass('tempHideVideo');
	                        self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', this]);
	                    }
	                });
	
	                // Notes layer link bind
	                self.$notes.on('click', function () {
	                    self.$brandPlay.removeClass('lock-isi');
	                    self.$isiContainer.removeClass('lock-isi');
	                    self.$menuDropDown.removeClass('open').hide();
	                    if (self.$menu.hasClass(menuOpenClsName)) self.$menu.removeClass(menuOpenClsName);
	
	                    self.$overlayNew.toggleClass('open');
	                    if (self.$visPlayControl.length > 0) {
	                        self.$visPlayControl.removeClass('vjs-playing').addClass('vjs-paused');
	                    }
	                    $('body').addClass('notes-open');
	                    self.notify('TrackBind', ['pamTrack', 'INFO', 'vidvbp-action-info_open', this]);
	                    //keep this at the bottom of the click function.
	                    _notify.broadcast('PauseAllVideoJSVids');
	                    return false;
	                });
	                // X button on notes overlay layer
	                self.$overlayClose.on('click', function () {
	                    self.$overlayNew.removeClass('open');
	                    $('body').removeClass('notes-open');
	                    self.notify('TrackBind', ['pamTrack', 'INFO', 'vidvbp-action-info_close', this]);
	                    return false;
	                });
	
	                // Clicking anywhere other than the notes layer dismisses the notes layer
	                self.$overlayNew.on('click', function (e) {
	                    if (e.target !== this) return;
	                    self.$overlayNew.removeClass('open');
	                });
	
	                // escape key exits the notes layer
	                $(document).keydown(function (e) {
	                    if (e.keyCode === 27) {
	                        self.$overlayNew.removeClass('open');
	                    }
	                });
	
	                if (Util.isMobile() || Util.isIpad()) {
	                    /*
	                     initialize mobile menu,
	                     do not initialize mobile menu when there is an inline playlist underneath video
	                     wait for player to load, event triggered in /brandplay2/modules/video/brand_player.js
	                     */
	                    if (self.playerReady) MobileMenu.init(self);
	                }
	                //END: Link Bindings //
	            }
	
	            // do not show sponsorline when inside an iframe
	            if (window.parent != window.self) {
	                $('body').addClass('inside_iframe');
	            } else {
	                self.$sponsorLine.fadeIn().css('display', 'flex');
	            }
	
	            // Early ie Flag for scrub tracking
	            if (Util.isIE() && Util.ieVer() <= 9) {
	                $('.vjs-progress-control, .vjs-progress-holder, .vjs-slider, .vjs-load-progress, .vjs-play-progress, .vjs-seek-handle').on('mousedown', function () {
	                    if (!self._var().videoplayerObject._var().instances[self._var().videoplayerObject._var().instanceCurrPlaying].paused()) {
	                        self._var().ieScrubFlag = true;
	                    }
	                });
	            }
	
	            function isTrackingReady() {
	                if ($('#menuDropdown').length === 0) {
	                    window.requestAnimationFrame(isTrackingReady);
	                } else {
	                    self.bpTracking();
	                    if (!(Util.isIE() && Util.ieVer() < 9) && self._var().enableHeartbeat) {
	                        self._var().trackingBp.heartbeatTrack(self._var().videoplayerObject);
	                    }
	                    // Setup ISI and bindings
	                    self.setupIsi();
	                }
	            }
	            window.requestAnimationFrame(isTrackingReady);
	        });
	
	        return self;
	    };
	
	    /* Refresh function */
	    thisObject.prototype.refresh = function (initFlag) {
	        var self = this;
	        self.notify('Trace', 'refresh');
	    };
	
	    /* Kill function */
	    thisObject.prototype.kill = function () {
	        this.notify('Trace', 'kill');
	        _notify.rem(this._id());
	    };
	
	    // UNIQUE MODULE METHODS---------------------------------------------------------------------------------------------------------------------------------------------
	
	    /* Setup the chapter list in a menu  */
	    thisObject.prototype.setupChapterListMenu = function () {
	
	        var self = this;
	
	        // Only set this up if it has been specified by the producer
	        if (self._var().mobile.chapterList.showAsMenu) {
	
	            var chapterListMenuButton = $('#chapterListMenuButton');
	
	            // Chapter List Menu button binding
	            chapterListMenuButton.click(function () {
	                // Show the overlay
	                if (self.$overlayNew.hasClass('open')) {
	                    self.$overlayNew.removeClass('open');
	                } else {
	                    self.$overlayNew.addClass('open');
	                }
	            });
	        }
	    };
	
	    /* Setup ISI on load and binding */
	    thisObject.prototype.setupIsi = function () {
	        var self = this,
	            overlay = $('#solidOverlay'),
	            content = $('.' + self._var().isi.container).html(),
	            magnifyElement = $('.magnify'),
	            $body = $('body'),
	            $bpContent = $('#bp_content'),
	            $bpDisclaimer = $('.bp_disclaimer'),
	            $video = $('video');
	
	        function hideOverlay() {
	            overlay.hide();
	            $('video, div').removeClass('tempHideVideo');
	        }
	        function replaceURLslashes(url) {
	            return url.replace(/\/$/, '');
	        }
	        // Actually shows the overlay, and binds the demagnify button
	        function showOverlay(fromIsi) {
	            // Show Overlay
	            overlay.show();
	            // only bind and track links once!
	            if (!thisObject.prototype.isiStatus.setup) {
	                thisObject.prototype.isiStatus.setup = true;
	                // Put content in overly
	                overlay.html(content);
	                // add the tracking events
	                // the click handler is already managed by thisObject.prototype.addTrackHandlers
	                overlay.find('a').each(function (i, e) {
	                    if (thisObject.prototype.checkHref(this.href)) {
	                        if (this.href.match(/\.medscape/g) !== null) {
	                            var inthref = self.removeEnvName(replaceURLslashes(this.href));
	                            self._var().trackingBp.pamHash('INTLINK_' + inthref, 'vidvbp-intlink', this);
	                        } else {
	                            self._var().trackingBp.pamHash('EXTLINK_' + replaceURLslashes(this.href), 'vidvbp-extlink', this);
	                        }
	                    }
	                });
	            }
	        }
	
	        // Clicking magnify will take all html underneath its parent and put it in a solid overlay
	        $body.on('click', '.magnify', function () {
	            if ($body.hasClass('isi-open')) {
	                if (Util.isMobile() === false) {
	                    if (typeof window.hideOverlayTimeout !== 'undefined') {
	                        window.clearTimeout(window.hideOverlayTimeout);
	                        delete window.hideOverlayTimeout;
	                    }
	                }
	                hideOverlay();
	                $bpContent.show();
	                $bpDisclaimer.show();
	                self.notify('TrackBind', ['pamTrack', 'ISI_CLOSE', 'vidvbp-action_isi_close', this]);
	            } else {
	                showOverlay();
	                self.notify('TrackBind', ['pamTrack', 'ISI_OPEN', 'vidvbp-action_isi_open', this]);
	            }
	            $body.toggleClass('isi-open');
	        });
	
	        // If show on load is true, show the overlay on initial load.  Else hide overlay as it is by default on
	        if (self._var().isi.showOnload) {
	            if (Util.isMobile() === false && self._var().isi.showOnDesktop === true || Util.isMobile() === true && self._var().isi.showOnMobile === true) {
	                showOverlay(true);
	                if (typeof self._var().isi.timeOut !== 'undefined') {
	                    var timeoutValue = isNaN(parseInt(self._var().isi.timeOut)) ? 0 : parseInt(self._var().isi.timeOut);
	                    if (timeoutValue > 0) {
	                        window.hideOverlayTimeout = window.setTimeout(hideOverlay, timeoutValue);
	                    }
	                }
	            } else {
	                hideOverlay();
	            }
	        } else {
	            hideOverlay();
	        }
	        // It's hidden on load to prevent it jumping around
	        magnifyElement.show();
	    };
	
	    /* Main method to setup the Question and Answer module, on init*/
	    thisObject.prototype._setupQna = function () {
	        var self = this;
	
	        if (self._var().qna.killswitch === false && $('.question').length !== 0) {
	            //Instantiate object & grab XML
	            var qnaModule = new Qna();
	
	            //Merge settings
	            $.extend(true, qnaModule._var(), self._var().qna);
	
	            //Initialize
	            qnaModule.init();
	        }
	    };
	
	    thisObject.prototype.bpTracking = function () {
	        var self = this;
	
	        ////// TRACKING //////
	        self._var().trackingBp = new tracking({
	            ippEnable: true,
	            appRequestCSD: true,
	            pamProductName: 'brandplay'
	        });
	
	        self._var().trackingBp.init();
	
	        for (x = 1; x <= self._var().totalVids; x++) {
	            self._var().trackingBp.pamHash('ARTICLE-' + x, x, this);
	        }
	
	        //// PAM Tracking for Specific Time on all vids at init
	        for (x = 1; x <= self._var().totalVids; x++) {
	            for (var y = 0; y < self._var().specificPercentArray.length; y++) {
	                self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_' + self._var().specificPercentArray[y] + 'pct', this);
	            }
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_100pct', this);
	        }
	
	        //// PAM Tracking for stayalive ping at init
	        /* for (x=1; x <= self._var().totalVids; x++) {
	         self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_stayalive', this);
	         };	*/
	
	        //// PAM Tracking for video begins playing at init
	        for (x = 1; x <= self._var().totalVids; x++) {
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_start', this);
	        }
	
	        //// PAM Tracking for Player Controls
	        for (x = 1; x <= self._var().totalVids; x++) {
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_play');
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_pause');
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_scrb');
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_vol');
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_bigr');
	            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_smalr');
	        }
	        self._var().trackingBp.pamHash('INFO', 'vidvbp-action-info_open', document.getElementById("notes"));
	        self._var().trackingBp.pamHash('INFO', 'vidvbp-action-info_close', $(".overlay-close")[0]);
	        self._var().trackingBp.pamHash('ACTIONSHEET_OPEN', 'vidvbp-action_sheet_open', document.getElementById("menu"));
	        self._var().trackingBp.pamHash('ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', $('#pageWrapper'));
	        self._var().trackingBp.pamHash('ISI_OPEN', 'vidvbp-action_isi_open', $('.magnify')[0]);
	        self._var().trackingBp.pamHash('ISI_CLOSE', 'vidvbp-action_isi_close', $('.magnify')[0]);
	
	        ////// Tracking the list items of Menu click ///////
	        self.$menuDropDown.find('li').each(function () {
	            $(this).on('click', function () {
	                self.notify('TrackBind', ['pamTrack', 'OPTION' + $(this).index(), 'vidvbp-action_' + $(this).index(), this]);
	            });
	            self._var().trackingBp.pamHash('OPTION' + $(this).index(), 'vidvbp-action_' + $(this).index(), this);
	        });
	        ////// add event handler to all tracking links
	        thisObject.prototype.addTrackHandlers.bind(self, self._var()['trackingBp'])();
	
	        self.notify('TrackBind', ['pamHash', 'CLOSE', 'vidvbp-close', this]);
	
	        ////Allow for data services to pull the PAM table
	        if (window.location.href.match('getHash') !== null) {
	            self._var().trackingBp.getHashTable();
	        }
	    };
	
	    thisObject.prototype.addTrackHandlers = function (trackingBP) {
	        var self = this;
	        var trackCallBack = function trackCallBack(e) {
	            var ele = e.currentTarget;
	            if (thisObject.prototype.checkHref(ele.href)) {
	                // pause video player on isi link click
	                $(window).trigger('player:pause');
	                if (ele.href.match(/\.medscape/g) !== null) {
	                    var inthref = self.removeEnvName(ele.href.replace(/\/$/, ''));
	                    self.notify('TrackBind', ['pamTrack', 'INTLINK_' + inthref, 'vidvbp-intlink', ele]);
	                } else {
	                    self.notify('TrackBind', ['pamTrack', 'EXTLINK_' + ele.href.replace(/\/$/, ''), 'vidvbp-extlink', ele]);
	                }
	            }
	        };
	        var checkIntExtLink = function checkIntExtLink(i, ele) {
	            $(ele).attr('data-bpTrack', true).addClass('bp-track');
	            if (thisObject.prototype.checkHref(ele.href)) {
	                if (ele.href.match(/\.medscape/g) !== null) {
	                    var inthref = self.removeEnvName(ele.href.replace(/\/$/, ''));
	                    trackingBP.pamHash('INTLINK_' + inthref, 'vidvbp-intlink', ele);
	                } else {
	                    trackingBP.pamHash('EXTLINK_' + ele.href.replace(/\/$/, ''), 'vidvbp-extlink', ele);
	                }
	            }
	        };
	        self.$pageWrapper.add('a').filter(function () {
	            return $(this).parents('#menuDropdown').length === 0;
	        }).each(checkIntExtLink).on('click', 'a[data-bpTrack="true"]', trackCallBack);
	
	        ///// patch for the script hack in the jsp, only add handlers if they have not been previously attached
	        if (Util.isMobile() && $('.HackedHeaderWrap a').length === 0) {
	            var $bpContent = $('#bp_content');
	            $bpContent.add('a').filter(function () {
	                return $(this).parents('#menuDropdown').length === 0;
	            }).each(checkIntExtLink).off('click').on('click', '.HackedHeaderWrap a', trackCallBack);
	        }
	    };
	
	    thisObject.prototype.checkHref = function (href) {
	        return typeof href !== 'undefined' && href !== '' && href !== window.location.href.split('#')[0] + '#' && href !== '#';
	    };
	
	    ////// Removes the environment name from the link ///////
	    thisObject.prototype.removeEnvName = function (href) {
	        var regEx = new RegExp(/\.staging|\.proddev|\.qa00|\.qa01|\.qa02/i);
	        return href.replace(regEx, '');
	    };
	
	    thisObject.prototype.getBookmark = function (data) {
	        try {
	            var self = this;
	            if (typeof data.lastscene !== 'undefined') {
	                if (Number(data.lastscene) >= Number(self._var().totalVids)) {
	                    self._var().bookmarkedVid = 1;
	                } else {
	                    self._var().bookmarkedVid = Number(data.lastscene) + 1;
	                }
	                self.notify('PageNamePAM', 'ARTICLE-' + self._var().bookmarkedVid);
	                self.notify('TrackBind', ['omniPageview', self._var().bookmarkedVid, this]);
	                self.notify('BookmarkedVideo', data);
	            } else {
	                self._var().bookmarkedVid = 1;
	                self.notify('PageNamePAM', 'ARTICLE-' + self._var().bookmarkedVid);
	                self.notify('TrackBind', ['omniPageview', self._var().bookmarkedVid, this]);
	                self.notify('BookmarkedVideo', data);
	            }
	        } catch (err) {
	            console.log(err);
	        }
	    };
	    return thisObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/*!Last Updated: 03.10.2014[01.04.54] by Jonathan Robles*/
	/*!*/
	/*!***********************************************/
	/*!  __  __        _                             */
	/*! |  \/  |___ __| |___ __ __ _ _ __  ___       */
	/*! | |\/| / -_) _` (_-</ _/ _` | '_ \/ -_)      */
	/*! |_|  |_\___\__,_/__/\__\__,_| .__/\___|      */
	/*!                             |_|              */
	/*! standardmodule MODULE */
	/*! by Jonathan Robles for WEBMD/Medscape 2013   */
	/*!                                              */
	/*!***********************************************/
	/*!CLX*/
	/*!*/
	/*!*/
	/*!*/
	/*!*/
	/*!*/
	/*!Last Updated: 03.10.2014[01.04.54] by Jonathan Robles*/
	"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var _instanceID = 0;
	    var _nextInstanceID = function _nextInstanceID() {
	        return ++_instanceID;
	    };
	    var settings = [];
	    function _thisObject_(o) {
	        this._instanceID = _nextInstanceID();
	        var _parent = this;
	        settings[this._instanceID] = {
	            type: "Standard Module Definition",
	            author: "Jonathan Robles",
	            notifyscope: "global",
	            target: undefined,
	            file: undefined,
	            usenocache: true,
	            data: undefined,
	            callback: undefined,
	            interval: undefined,
	            init: function init() {
	                _notify.broadcast("Initialize", [{
	                    senderID: _parent._instanceID,
	                    sendertype: this.type,
	                    notifyscope: this.notifyscope,
	                    data: {
	                        author: this.author
	                    }
	                }]);
	            },
	            parent: this
	        };
	        settings[this._instanceID] = $.extend(settings[this._instanceID], o);
	        settings[this._instanceID].init();
	        return this;
	    }
	    _thisObject_.prototype = {
	        _init: function _init() {
	            this._var().init();
	        },
	        _showdata: function _showdata() {
	            return JSON.stringify(settings[this._instanceID]);
	        },
	        _id: function _id() {
	            return this._instanceID;
	        },
	        _var: function _var(o) {
	            if (o != undefined) {
	                settings[this._instanceID] = $.extend(settings[this._instanceID], o);
	            }
	            return settings[this._instanceID];
	        },
	        _nocache: function _nocache(string) {
	            if (typeof string === "string") {
	                if (this._var().usenocache) {
	                    var addOn = "?";
	                    if (string.indexOf("?") != -1) {
	                        addOn = "&";
	                    }
	                    return string + addOn + "nocache=" + Math.floor(Math.random() * 9999);
	                } else {
	                    return string;
	                }
	            } else {
	                this.notify("Alert", "_nocache needs a string!");
	                return;
	            }
	        },
	        notify: function notify(type, data) {
	            _notify.broadcast(type, [{
	                senderID: this._id(),
	                sendertype: this._var().type,
	                notifyscope: this._var().notifyscope,
	                data: data
	            }]);
	        },
	        parent: this
	    };
	    return _thisObject_;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Util module
	 * This module contains commonly used functions.
	 *
	 * Last Edit:
	 * 4/30/15 by ML @ 12:57PM
	 *
	 */
	'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(301)], __WEBPACK_AMD_DEFINE_RESULT__ = function (parentModel) {
	
		function thisObject(o) {
	
			var defaults = {
				type: 'module',
				author: 'Hussein Sharif'
			};
	
			defaults = $.extend(true, defaults, o);
			parentModel.call(this, defaults);
			return this;
		};
	
		// Inherit parent methods/variables
		thisObject.prototype = Object.create(parentModel.prototype);
	
		// Listeners
		thisObject._startlisteners = function () {
	
			this.notify('Trace', '_startlisteners');
			var parent = this;
			var myID = this._id();
	
			_notify.add(this._id(), (function () {
				return {};
			})());
		};
	
		/* Initialize function */
		thisObject.init = function () {
			this.notify('Trace', 'init');
			this._startlisteners();
			return self;
		};
	
		/* Refresh function */
		thisObject.refresh = function (initFlag) {
			var self = this;
			self.notify('Trace', 'refresh');
		};
	
		/* Kill function */
		thisObject.kill = function () {
			this.notify('Trace', 'kill');
			_notify.rem(this._id());
		};
	
		/* Convert a float data type to a ratio. 
	 *
	 * x: The float number that will be converted to a fraction
	 */
		thisObject.floatToRatio = function (x) {
			var tolerance = 1.0E-6;
			var h1 = 1;var h2 = 0;
			var k1 = 0;var k2 = 1;
			var b = x;
			do {
				var a = Math.floor(b);
				var aux = h1;h1 = a * h1 + h2;h2 = aux;
				aux = k1;k1 = a * k1 + k2;k2 = aux;
				b = 1 / (b - a);
			} while (Math.abs(x - h1 / k1) > x * tolerance);
	
			return h1 + "/" + k1;
		};
	
		/* Load a CSS  file
	 *
	 *nameOfDoc : Name of a file you want the url for, minus the suffix (.js, .css, etc)
	 *contentToCut: The beginning of the part of the url you'd like to truncate
	 *appendContent: The string you'd like to append to the end of your URL
	 */
		thisObject.loadCss = function (nameOfDoc, contentToCut, appendContent) {
	
			var url = this._urlFinder(nameOfDoc, contentToCut, appendContent);
	
			var link = document.createElement("link");
			link.type = "text/css";
			link.rel = "stylesheet";
			link.href = url;
			$("head").append(link);
		};
	
		/* Find the url of the current file, typically called by
	 *
	 *nameOfDoc : String, name of the file you want the url for, minus the suffix (.js, .css, etc)
	 *contentToCut: String, the beginning of the part of the url you'd like to truncate
	 *appendContent: String, the string you'd like to append to the end of your URL
	 */
		thisObject._urlFinder = function (nameOfDoc, contentToCut, appendContent) {
	
			var currentUrl;
	
			var scriptElements = document.getElementsByTagName('script');
			var i, element, myfile;
	
			for (i = 0; element = scriptElements[i]; i++) {
	
				myfile = element.src;
	
				if (myfile.indexOf(nameOfDoc) >= 0) {
					currentUrl = myfile.substring(0, myfile.indexOf(nameOfDoc));
				}
			}
	
			// Cut off end of URL and add relative path to css file needed
			var url = currentUrl.substr(0, currentUrl.indexOf(contentToCut)) + appendContent;
	
			return url;
		};
	
		/* Returns true if the current device is mobile, else returns false */
		thisObject.isMobile = function () {
			return (/android|webos|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase())
			);
		};
	
		/* Returns the current environment the code is running on */
		thisObject.environment = function () {
			// All the code below determines the environment and builds the proper string
			var environments = ["proddev", "staging", "qa01", "qa02"];
			var currentEnv = "";
	
			// Determine environment
			$.each(environments, function (index, value) {
				if ($.inArray(value, window.location.host.split(".")) === 1) {
					currentEnv = value;
				}
			});
	
			return currentEnv;
		};
	
		/* Alternate Environment Checking Function, Handles all combination of qa/staging/proddev and inserts a period, for direct use in URLs */
		thisObject.envCheck = function () {
			var env = '';
			if (window.location.href.indexOf(".staging.") != -1) {
				env = ".staging";
			} else if (window.location.href.indexOf(".proddev.") != -1) {
				env = ".proddev";
			}
			if (window.location.href.match(/\.qa\d\d/) != null) {
				env = env + window.location.href.match(/\.qa\d\d/)[0];
			}
			return env;
		};
	
		// Turn Date Object to Full Month / Day string
		thisObject.readableDate = function (utc) {
			var utcDate = new Date(Number(utc)).toDateString();
			var utcDateDay = utcDate.split(' ')[0];
			switch (utcDateDay) {
				case "Sun":
					utcDateDay = "Sunday";break;
				case "Mon":
					utcDateDay = "Monday";break;
				case "Tue":
					utcDateDay = "Tuesday";break;
				case "Wed":
					utcDateDay = "Wednesday";break;
				case "Thu":
					utcDateDay = "Thursday";break;
				case "Fri":
					utcDateDay = "Friday";break;
				case "Sat":
					utcDateDay = "Saturday";break;
			}
			var utcDateMonth = utcDate.split(' ')[1];
			switch (utcDateMonth) {
				case "Jan":
					utcDateMonth = "January";break;
				case "Feb":
					utcDateMonth = "February";break;
				case "Mar":
					utcDateMonth = "March";break;
				case "Apr":
					utcDateMonth = "April";break;
				case "May":
					utcDateMonth = "May";break;
				case "Jun":
					utcDateMonth = "June";break;
				case "Jul":
					utcDateMonth = "July";break;
				case "Aug":
					utcDateMonth = "August";break;
				case "Sep":
					utcDateMonth = "September";break;
				case "Oct":
					utcDateMonth = "October";break;
				case "Nov":
					utcDateMonth = "November";break;
				case "Dec":
					utcDateMonth = "December";break;
			}
			var utcDateStr = utcDate.split(' ')[2];
			if (utcDateStr.length == 2 && utcDateStr[0] == "1") {
				utcDateStr = utcDateStr + "th";
			} else if (utcDateStr[utcDateStr.length - 1].match(/0|4-9/) != null) {
				utcDateStr = utcDateStr + "th";
			} else if (utcDateStr[utcDateStr.length - 1] == "1") {
				utcDateStr = utcDateStr + "st";
			} else if (utcDateStr[utcDateStr.length - 1] == "2") {
				utcDateStr = utcDateStr + "nd";
			} else if (utcDateStr[utcDateStr.length - 1] == "3") {
				utcDateStr = utcDateStr + "rd";
			}
	
			return String(utcDateDay + ', ' + utcDateMonth + ' ' + utcDateStr + ', ' + utcDate.split(' ')[3]);
		};
	
		/* Returns true if the current device is Retina display */
		thisObject.isRetina = function () {
			return window.devicePixelRatio > 1;
		};
	
		/* Returns true if the current device is iPhone */
		thisObject.isIphone = function () {
			return navigator.userAgent.match(/iPhone/i) != null;
		};
	
		/* Returns true if the current device is ipad */
		thisObject.isIpad = function () {
			return navigator.userAgent.match(/iPad/i) != null;
		};
	
		/* Returns iOS version */
		thisObject.iOsVer = function () {
			if (this.isIpad() || this.isIphone()) {
				return Number(navigator.userAgent.match(/OS \d+/)[0].split(' ')[1]);
			} else {
				return 0;
			}
		};
	
		/* Returns true if the current device is IE */
		thisObject.isIE = function () {
			return navigator.userAgent.toLowerCase().match(/msie \d+/) != null || navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/) != null;
		};
	
		/* Returns IE version */
		thisObject.ieVer = function () {
			if (navigator.userAgent.toLowerCase().match(/msie \d+/) != null) {
				return Number(navigator.userAgent.toLowerCase().match(/msie \d+/)[0].split(' ')[1]);
			} else if (navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/) != null) {
				return Number(navigator.userAgent.toLowerCase().match(/trident.*rv:\d+/)[0].split('rv:')[1]);
			} else {
				return 0;
			}
		};
	
		thisObject.isAndroid = function () {
			return navigator.userAgent.match(/android/i) != null;
		};
	
		/* Returns iOS version */
		thisObject.droidVer = function () {
			if (this.isAndroid()) {
				return Number(navigator.userAgent.match(/Android \d\.\d/)[0].substring(8, 11));
			} else {
				return 0;
			}
		};
	
		//-----------------------------------------------------------------------------------------------------------------------------------------------//
	
		return thisObject;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Tracking Module Definition
	 *
	 * Modified Date: 4/28/14 by ML @ 2:19PM
	 *
	 * Communications Platform / VPTrack / Omniture Tracking
	 *
	 */
	
	'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(301), __webpack_require__(304), __webpack_require__(302), __webpack_require__(305), __webpack_require__(312)], __WEBPACK_AMD_DEFINE_RESULT__ = function (parentModel, Json2, Util, md5, Heartbeat) {
		//replace the standardmodule with the module you are extending
		function _thisObject_(o) {
			var defaults = {
				type: 'tracking', //name your module, use this file's exact filename w/o the .js.
				author: 'ML', //your name if you are the original writer
				lasteditby: '',
				omnitureEnable: true,
				cpEnable: true, //enables checking for 'data-cp' tag attribute, to pick up page-level CP vars,
				ippEnable: false, //enables checking for 'data-ipp' tag attribute, to pick up page-level IPP vars
				vptrackEnable: true, //enables initialization of vpTrack iframe on load
				cpObj: {}, //object variable to store page-level CP vars
				ippObj: {}, //object variable to store page-level CP vars
				vpUrl: window.location.href.split('?')[0].split('#')[0].replace(/\/$/, ''), //default vpTrack URL points to window location
				omniPagenameDefault: window.location.href.split('://')[1].split('?')[0].split("#")[0].replace('www.', ''),
				pamProductName: '',
				pamHashArray: [],
				iOsDropOffFlag: false,
				appRequestCSD: false,
				appDropOff: false
			};
			defaults = $.extend(defaults, o);
			parentModel.call(this, defaults);
			return this;
		};
		_thisObject_.prototype = Object.create(parentModel.prototype);
	
		//DEFINE LISTENERS HERE
		_thisObject_.prototype._startlisteners = function () {
			this.notify('Trace', '_startlisteners');
			var self = this;
			var myID = this._id();
			_notify.add(this._id(), (function () {
				return {
					onTrackBind: function onTrackBind(param) {
						var activeFunc = eval('self.' + param.data[0]);
						param.data.shift();
						activeFunc.apply(self, param.data);
					},
					onPageNamePAM: function onPageNamePAM(param) {
						s_md.pageName = document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + self._var().pamProductName + '/' + self._var().ippObj.sfNum + '/' + md5(self._var().ippObj.sfNum + '_' + param.data) + '/';
						self._var().omniPagenameDefault = document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + self._var().pamProductName + '/' + self._var().ippObj.sfNum + '/' + md5(self._var().ippObj.sfNum + '_' + param.data) + '/';
					}
				};
			})());
		};
	
		// MODULE METHODS - you should always have init/refresh/kill defined!
	
		_thisObject_.prototype.init = function () {
			this.notify('Trace', 'init');
			this._startlisteners(); //start this module's listeners
			this.refresh();
			this.getCpObj();
			if (this._var().ippEnable) {
				this.getIppObj();
				if (!window.medscape.core.isApp) {
					this.cp({ 'appname': 'ippevent', 'activityName': 'requestCSD' });
					this.bindDropoff();
				} else {
					if (this._var().appRequestCSD) {
						this.cp({ 'appname': 'ippevent', 'activityName': 'requestCSD' });
					}
					if (this._var().appDropOff) {
						//this.bindDropoff();  remove ipp dropoff tracking for App - PPE45854
					}
				}
			}
			this.vpTrackInit();
			this.getBindings();
		};
	
		_thisObject_.prototype.refresh = function () {
			this.notify('Trace', 'refresh');
		};
	
		_thisObject_.prototype.kill = function () {
			this.notify('Trace', 'kill');
			_notify.rem(this._id()); //kills this module's listeners
		};
	
		// UNIQUE MODULE METHODS
	
		_thisObject_.prototype.getBindings = function () {
			// pick up element function bindings
			try {
				var self = this;
				$('*[data-track]').each(function () {
					if ($.trim($(this).attr('data-track')) != '' && typeof $(this).attr('data-event') == 'undefined') {
						// if data-track not blank and data-event not specified, fire all defined functions contained within attribute
						var funcArr = $(this).attr('data-track').replace(/ /g, '').split(';');
						for (x = 0; x < funcArr.length; x++) {
							try {
								if (typeof eval('self.' + funcArr[x].split('(')[0]) == "function") {
									if (funcArr[x].split('(')[0] == "pamTrack") {
										eval('self.pamHash(' + funcArr[x].split('(')[1].split(')')[0] + ',this)');
									}
									eval('self.' + funcArr[x].split(')')[0] + ',this)');
								}
							} catch (err) {}
						}
					} else if ($.trim($(this).attr('data-track')) != '' && typeof $(this).attr('data-event') != 'undefined') {
						// else if data-event specified, bind function call to events
						var funcArr = $(this).attr('data-track').replace(/ /g, '').split(';');
						for (x = 0; x < funcArr.length; x++) {
							try {
								if (typeof eval('self.' + funcArr[x].split('(')[0]) == "function") {
									var params = funcArr[x].split("('")[1].split("')")[0];
	
									if (funcArr[x].split('(')[0] == "pamTrack") {
										eval('self.pamHash(' + params + ',this)');
									}
									var paramsArr = params.split("','");
									paramsArr.splice(0, 0, funcArr[x].split('(')[0]);
									paramsArr.push(this);
									$(this).on($(this).attr('data-event').replace(",", " "), function () {
										self.notify('TrackBind', paramsArr.slice(0));
									});
								}
							} catch (err) {}
						}
					}
				});
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.cp = function (name, obj) {
			// CP object variable setup function + call fire
			try {
				var self = this;
				if (self._var().cpEnable) {
					var cpObjTemp = {};
					if ($('[data-cp]').length > 1 && typeof obj != 'undefined') {
						try {
							cpObjTemp = JSON.parse($(obj).parents().has('[data-cp]').first().children('[data-cp]:eq(0)').attr('data-cp'));
						} catch (err) {
							self.notify('Trace', '\"data-cp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
						}
					} else {
						cpObjTemp = self._var().cpObj;
					}
					if (typeof name == 'object') {
						$.extend(cpObjTemp, name);
					} else {
						cpObjTemp.activityName = name;
					}
					self.postCp(cpObjTemp);
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.getCpObj = function () {
			// Pick up page-level CP attributes
			if (this._var().cpEnable) {
				if ($('[data-cp]').length > 0) {
					try {
						this._var().cpObj = JSON.parse($('[data-cp]:eq(0)').attr('data-cp'));
					} catch (err) {
						this.notify('Trace', '\"data-cp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
					}
				}
			}
		};
	
		_thisObject_.prototype.getIppObj = function () {
			// Pick up page-level CP attributes
			if (this._var().ippEnable) {
				if ($('[data-ipp]').length > 0) {
					try {
						this._var().ippObj = JSON.parse($('[data-ipp]:eq(0)').attr('data-ipp'));
					} catch (err) {
						this.notify('Trace', '\"data-ipp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
					}
				}
			}
		};
	
		_thisObject_.prototype.trackIpp = function (action) {
			try {
				if (this._var().ippEnable) {
					var self = this;
					if (typeof self._var().ippObj.wpUrl != 'undefined' && typeof self._var().ippObj.parIdE != 'undefined' && typeof self._var().ippObj.activityId != 'undefined') {
						var preload_image = new Image(1, 1);
						if (typeof self._var().ippObj.tacticId != 'undefined') {
							preload_image.src = '//' + self._var().ippObj.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + self._var().ippObj.activityId + '&parId=' + self._var().ippObj.parIdE + '&tacticId=' + self._var().ippObj.tacticId;
						} else {
							preload_image.src = '//' + self._var().ippObj.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + self._var().ippObj.activityId + '&parId=' + self._var().ippObj.parIdE;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.postCp = function (cpdata, callback) {
			// Master CP call function (directly ported from current version used on site, standalone 'cp.js' file)
			try {
				if (typeof cpdata != 'undefined') {
					if (typeof callback == 'object') {
						callback = undefined;
					}
					if (typeof s_registered_user_id != 'undefined' || typeof cpdata.uid != 'undefined') {
						if (typeof cpdata.uid == 'undefined') {
							cpdata.uid = s_registered_user_id;
						}
						if (typeof cpdata.url == 'undefined') {
							cpdata.url = encodeURIComponent(window.location.href.split("?")[0]);
						}
						cpdata.date = new Date().getTime();
						var cpJSON = JSON.stringify(cpdata);
						$.ajax({
							type: "GET",
							contentType: "application/jsonp",
							url: "//api" + Util.envCheck() + ".medscape.com/cp/events.json",
							data: 'event=' + cpJSON,
							dataType: "jsonp",
							timeout: 2000,
							complete: callback
						});
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.vp = function (trackData, trackUrl) {
			// main vpTrack function, sets vpTrack iframe SRC to proper URL
			try {
				var self = this;
				if (typeof trackUrl == 'object') {
					trackUrl = undefined;
				}
				if (self._var().vptrackEnable) {
					var wpCheck = '';
					if (document.domain.match('wp.') != null) {
						wpCheck = 'https://www' + Util.envCheck() + '.medscape.com';
					}
					if (typeof trackUrl != 'undefined') {
						$('iframe[id=xmlFrame]').attr('src', wpCheck + '/public/vptrack.wxml?desturl=' + trackUrl + '%5f' + trackData);
					} else {
						$('iframe[id=xmlFrame]').attr('src', wpCheck + '/public/vptrack.wxml?desturl=' + self._var().vpUrl + '%5f' + trackData);
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.vpTrackInit = function () {
			// check if vpTrack iframe pre-exists on page, creates it if necessary. Sets vpTrack url to 'canonical' URL if present.
			try {
				if (this._var().vptrackEnable) {
					if ($('iframe[id=xmlFrame]').length == 0 && document.domain.match('wp.') == null) {
						$('body').append('<iframe height="0" width="0" name="xmlFrame" id="xmlFrame" src="/public/vptrack_iframe.html" style="display: none;"></iframe>');
					} else if ($('iframe[id=xmlFrame]').length == 0 && document.domain.match('wp.') != null) {
						$('body').append('<iframe height="0" width="0" name="xmlFrame" id="xmlFrame" src="https://www' + Util.envCheck() + '.medscape.com/public/vptrack_iframe.html" style="display: none;"></iframe>');
					}
				}
				if ($('link[rel=canonical]').length > 0 && $.trim($('link[rel=canonical]:eq(0)').attr('href')) != '') {
					this._var().vpUrl = $.trim($('link[rel=canonical]:eq(0)').attr('href'));
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.omni = function (sLink, pName, obj) {
			// Omniture Ad Hoc tracking, for Internal or External-Domain destinations
			try {
				var self = this;
				if (typeof pName == 'object') {
					obj = pName;
					pName = undefined;
				}
				if (self._var().omnitureEnable) {
					if (typeof obj != 'undefined' && typeof obj == 'object') {
	
						if (typeof obj.href != 'undefined') {
							// if referring element link points to external domain, fire external Omniture function
							if (obj.href.match(/:\/\//) != null && obj.href.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain || $.trim(obj.href) == window.location.href.split('#')[0] + "#") {
								self.omniPageLink(sLink, pName);
							} else {
								// else fire internal Omniture function
								self.omniTrack(sLink, pName);
							}
						} else if (typeof obj.action != 'undefined') {
							// if referring element form action points to external domain, fire external Omniture function
							if (obj.action.match(/:\/\//) != null && obj.action.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain || $.trim(obj.action) == window.location.href.split('#')[0] + "#") {
								self.omniPageLink(sLink, pName);
							} else {
								// else fire internal Omniture function
								self.omniTrack(sLink, pName);
							}
						} else {
							self.omniPageLink(sLink, pName);
						}
					} else {
						self.omniPageLink(sLink, pName);
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.omniTrack = function (sLink, pName) {
			// Omniture Ad Hoc tracking, for In-Domain destinations
			try {
				if (this._var().omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdTrack != 'undefined') {
						if (typeof pName != 'undefined') {
							s_md.pageName = pName;
						}
						wmdTrack(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = this._var().omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.omniPageLink = function (sLink, pName) {
			// Omniture Ad Hoc tracking, for External-Domain destinations
			try {
				if (this._var().omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdPageLink != 'undefined') {
						if (typeof pName != 'undefined') {
							s_md.pageName = pName;
						}
						wmdPageLink(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = this._var().omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.omniPageview = function (pCount, pName) {
			// Omniture Page View function
			try {
				if (this._var().omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdPageview != 'undefined') {
						if (typeof pName != 'undefined') {
							wmdPageview(pName, pCount);
						} else {
							wmdPageview("", pCount);
						}
						if (typeof pName != 'undefined') {
							s_md.pageName = this._var().omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.segVarPop = function (obj) {
			try {
				if ($("meta[name=metasegvar]").length > 0) {
					if (segVarParam("artid") != '0') obj.activityId = segVarParam('artid');
					if (segVarParam("ssp") != '0') obj.leadSpec = segVarParam('ssp');
					if (segVarParam("scg") != '0') obj.leadConcept = segVarParam('scg');
					if (segVarParam("cg") != '0') obj.contentGroup = segVarParam('cg');
					if (segVarParam('bc') != '__') {
						var bcTemp = segVarParam('bc');
						bcTemp = bcTemp.substring(1, bcTemp.length - 1);
						bcTemp = bcTemp.split("_");
						obj.blockCode = bcTemp;
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.socialCp = function (platform) {
			try {
				if (this._var().cpEnable) {
					var cpSocData = new Object();
					cpSocData.appname = 'social-functions';
					cpSocData.activityName = encodeURIComponent(platform);
					this.segVarPop(cpSocData);
					this.postCp(cpSocData);
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.cpArticleLoad = function (appname) {
			try {
				if (this._var().cpEnable) {
					var cpArticle = {};
					var testPagination;
					this.segVarPop(cpArticle);
					cpArticle.appname = appname;
					cpArticle.activityName = 'view';
					if (cpArticle.appname === 'viewarticle') {
						testPagination = window.location.pathname.match(/\/viewarticle\/\d+_\d+/);
						if (testPagination !== null) {
							cpArticle.pageN = window.location.pathname.match(/\/viewarticle\/\d+_\d+/)[0].split('_')[1];
						} else {
							cpArticle.pageN = 1;
						}
					}
					this.postCp(cpArticle);
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		//Function to Send Track, or Bind to Elements
		_thisObject_.prototype.pamTrack = function (assetName, moduleStrOrPvNum, element) {
			try {
				var self = this;
				if (typeof element == 'object') {
					if (typeof moduleStrOrPvNum == 'number') {
						this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/', element);
					} else {
						this.omni(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/', element);
					}
				} else {
					if (typeof moduleStrOrPvNum == 'number') {
						this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/');
					} else {
						this.omni(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/');
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.pamHash = function (assetName, moduleStrOrPvNum, element, optNum) {
			try {
				if (typeof element != 'undefined') {
					if (typeof element == 'number') {
						// If Element is undefined, but optNum is, fix parameters
						optNum = element;
						element = undefined;
					}
				}
	
				var itemText = "N/A";
	
				if (typeof element != 'undefined') {
					if (typeof element.tagName != 'undefined') {
						if (element.tagName.toLowerCase() == "a" || element.tagName.toLowerCase() == "li") {
							if (element.tagName.toLowerCase() == "a" || element.tagName.toLowerCase() == "li") {
								itemText = element.innerHTML;
							}
						}
					}
				}
	
				if (typeof optNum == 'number') {
					for (x = 1; x <= optNum; x++) {
						if (typeof moduleStrOrPvNum == 'number') {
							if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName + x) + '</td><td>N/A</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
								this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName + x) + '</td><td>N/A</td><td>' + itemText + '</td></tr>');
							}
						} else {
							if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName + x) + '</td><td>' + moduleStrOrPvNum + x + '</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
								this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName + x) + '</td><td>' + moduleStrOrPvNum + x + '</td><td>' + itemText + '</td></tr>');
							}
						}
					}
				} else {
					if (typeof moduleStrOrPvNum == 'number') {
						if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName) + '</td><td>N/A</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
							this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName) + '</td><td>N/A</td><td>' + itemText + '</td></tr>');
						}
					} else {
						if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName) + '</td><td>' + moduleStrOrPvNum + '</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
							this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum + '_' + assetName) + '</td><td>' + moduleStrOrPvNum + '</td><td>' + itemText + '</td></tr>');
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.pamTrackBind = function (selector, event, assetName, moduleStrOrPvNum) {
			try {
				var self = this;
				$(selector).each(function (idx) {
					$(this).on(event, function () {
						self.notify('TrackBind', ['pamTrack', assetName, moduleStrOrPvNum, this]);
					});
					self.pamHash(assetName, moduleStrOrPvNum, this);
				});
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.getHashTable = function () {
	
			try {
				var self = this;
				var hashWindow = window.open();
				hashWindow.document.write('<table cellpadding="3" border="1" cellspacing="3">');
				hashWindow.document.write('<tr><th>ASSET</th><th>HASH</th><th>MODULE NAME</th><th>LINK TEXT</th></tr>');
				console.log('pamHashArray', this._var().pamHashArray);
				$(this._var().pamHashArray).each(function () {
					hashWindow.document.write(this);
				});
	
				hashWindow.document.write('</table>');
	
				hashWindow.document.close();
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.getRememberMe = function (context, callback) {
			var self = this;
			try {
				if (typeof s_registered_user_id != 'undefined' && typeof self._var().cpObj.activityId != 'undefined') {
					$.ajax({
						type: 'GET',
						contentType: 'application/jsonp',
						url: '//api' + Util.envCheck() + '.medscape.com/cp/ipplastvisit/user/' + Number(s_registered_user_id) / 27 + '/activities/' + self._var().cpObj.activityId,
						dataType: 'jsonp',
						timeout: 1000,
						success: function success(data) {
							if (typeof data.activities[0].scene != 'undefined') {
								data.activities[0].lastscene = Number(data.activities[0].scene.name.split('scn')[1]);
							}
							data = data.activities[0];
							eval('context.' + callback + '(data)');
						},
						complete: function complete(data) {
							if (data.readyState != 4) {
								eval('context.' + callback + '({})');
							}
						}
					});
				} else {
					eval('context.' + callback + '({})');
				}
			} catch (err) {
				console.log(err);
				eval('context.' + callback + '({})');
			}
		};
	
		_thisObject_.prototype.trackDropoff = function () {
			try {
				var self = this;
				self.trackIpp('logBrowserClose');
				var tacticId = "";
				if (typeof self._var().ippObj.tacticId != 'undefined') {
					tacticId = '"tacticId":"' + self._var().ippObj.tacticId + '",';
				}
				if (typeof s_registered_user_id != 'undefined' && typeof self._var().ippObj.activityId != 'undefined' && typeof self._var().ippObj.parId != 'undefined') {
					var preload_image = new Image(1, 1);
					preload_image.src = '//api' + Util.envCheck() + '.medscape.com/cp/events.json?event={' + tacticId + '"activityId":"' + self._var().ippObj.activityId + '","parId":"' + self._var().ippObj.parId + '","appname":"ippevent","activityName":"drop-off","uid":"' + s_registered_user_id + '","url":"' + encodeURIComponent(window.location.href.split("?")[0]) + '","date":' + new Date().getTime() + '}';
				}
				if (navigator.userAgent.toLowerCase().match('chrome') != null) {
					return ' ';
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.setDropoffFlag = function (event) {
			event.data.context._var().iOsDropOffFlag = true;
		};
	
		_thisObject_.prototype.bindDropoff = function (param) {
			try {
				var self = this;
				if (typeof param == 'string') {
					var linkSelector = 'a' + param;
				} else {
					var linkSelector = 'a';
				}
				if (Util.isMobile() || Util.isIpad()) {
					var bindEvent = 'touchend';
				} else {
					var bindEvent = 'click';
				}
				if (navigator.userAgent.toLowerCase().match('iphone') != null || navigator.userAgent.toLowerCase().match('ipad') != null) {
					$(linkSelector).each(function () {
						if (typeof $(this).attr('target') != 'undefined' && $(this).attr('target') == '_blank') {
							if (typeof param == 'string') {
								$(this).off(bindEvent, self.setDropoffFlag);
							}
							$(this).on(bindEvent, { context: self }, self.setDropoffFlag);
						}
					});
					if (typeof param != 'string') {
						$(window).on('pagehide', function () {
							if (self._var().iOsDropOffFlag == false) {
								self.trackDropoff();
							}
						});
						$(window).on('pageshow', function () {
							self._var().iOsDropOffFlag = false;
						});
					}
				} else {
					$(window).on('beforeunload', function () {
						self.trackDropoff();
					});
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		_thisObject_.prototype.heartbeatTrack = function (videoModuleInstance) {
			try {
				if (typeof videoModuleInstance != 'undefined') {
					var hbTemp = new Heartbeat({ vidInstance: videoModuleInstance });
					hbTemp.init();
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		//-------------------------------------------------------------------------//
	
		return _thisObject_;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	/* json2.js by Douglas Crockford, 2012-10-08, Public Domain */
	
	if(typeof JSON!=="object"){JSON={};}(function(){function f(n){return n<10?"0"+n:n;}if(typeof Date.prototype.toJSON!=="function"){Date.prototype.toJSON=function(key){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null;};String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(key){return this.valueOf();};}var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;function quote(string){escapable.lastIndex=0;return escapable.test(string)?'"'+string.replace(escapable,function(a){var c=meta[a];return typeof c==="string"?c:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4);})+'"':'"'+string+'"';}function str(key,holder){var i,k,v,length,mind=gap,partial,value=holder[key];if(value&&typeof value==="object"&&typeof value.toJSON==="function"){value=value.toJSON(key);}if(typeof rep==="function"){value=rep.call(holder,key,value);}switch(typeof value){case"string":return quote(value);case"number":return isFinite(value)?String(value):"null";case"boolean":case"null":return String(value);case"object":if(!value){return"null";}gap+=indent;partial=[];if(Object.prototype.toString.apply(value)==="[object Array]"){length=value.length;for(i=0;i<length;i+=1){partial[i]=str(i,value)||"null";}v=partial.length===0?"[]":gap?"[\n"+gap+partial.join(",\n"+gap)+"\n"+mind+"]":"["+partial.join(",")+"]";gap=mind;return v;}if(rep&&typeof rep==="object"){length=rep.length;for(i=0;i<length;i+=1){if(typeof rep[i]==="string"){k=rep[i];v=str(k,value);if(v){partial.push(quote(k)+(gap?": ":":")+v);}}}}else{for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=str(k,value);if(v){partial.push(quote(k)+(gap?": ":":")+v);}}}}v=partial.length===0?"{}":gap?"{\n"+gap+partial.join(",\n"+gap)+"\n"+mind+"}":"{"+partial.join(",")+"}";gap=mind;return v;}}if(typeof JSON.stringify!=="function"){JSON.stringify=function(value,replacer,space){var i;gap="";indent="";if(typeof space==="number"){for(i=0;i<space;i+=1){indent+=" ";}}else{if(typeof space==="string"){indent=space;}}rep=replacer;if(replacer&&typeof replacer!=="function"&&(typeof replacer!=="object"||typeof replacer.length!=="number")){throw new Error("JSON.stringify");}return str("",{"":value});};}if(typeof JSON.parse!=="function"){JSON.parse=function(text,reviver){var j;function walk(holder,key){var k,v,value=holder[key];if(value&&typeof value==="object"){for(k in value){if(Object.prototype.hasOwnProperty.call(value,k)){v=walk(value,k);if(v!==undefined){value[k]=v;}else{delete value[k];}}}}return reviver.call(holder,key,value);}text=String(text);cx.lastIndex=0;if(cx.test(text)){text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4);});}if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,""))){j=eval("("+text+")");return typeof reviver==="function"?walk({"":j},""):j;}throw new SyntaxError("JSON.parse");};}}());

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {(function(){
	  var crypt = __webpack_require__(310),
	      utf8 = __webpack_require__(311).utf8,
	      bin = __webpack_require__(311).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (typeof Buffer != 'undefined' &&
	        typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if(typeof message == 'undefined')
	      return;
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(306).Buffer))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(307)
	var ieee754 = __webpack_require__(308)
	var isArray = __webpack_require__(309)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {/*
	 * ************************************************************************
	 *
	 *  ADOBE CONFIDENTIAL
	 *  ___________________
	 *
	 *   (c) Copyright 2017 Adobe Systems Incorporated
	 *   All Rights Reserved.
	 *
	 *  NOTICE:  All information contained herein is, and remains
	 *  the property of Adobe Systems Incorporated and its suppliers,
	 *  if any.  The intellectual and technical concepts contained
	 *  herein are proprietary to Adobe Systems Incorporated and its
	 *  suppliers and may be covered by U.S. and Foreign Patents,
	 *  patents in process, and are protected by trade secret or copyright law.
	 *  Dissemination of this information or reproduction of this material
	 *  is strictly forbidden unless prior written permission is obtained
	 *  from Adobe Systems Incorporated.
	 * ************************************************************************
	 */
	
	/*
	 * video heartbeats - 2.0.2 - 2017-04-21
	 * Copyright (c) 2017 Adobe Systems, Inc. All Rights Reserved.
	 */
	
	// Heartbeat core
	!function(a){if("undefined"==typeof b)var b={};if("undefined"==typeof c)var c={};if("undefined"==typeof d)var d={};if(d.radio||(d.radio={}),d.plugin||(d.plugin={}),"undefined"==typeof e)var e={};e.clock||(e.clock={}),function(a){"use strict";function b(a,b){var c=(65535&a)+(65535&b),d=(a>>16)+(b>>16)+(c>>16);return d<<16|65535&c}function c(a,b){return a<<b|a>>>32-b}function d(a,d,e,f,g,h){return b(c(b(b(d,a),b(f,h)),g),e)}function e(a,b,c,e,f,g,h){return d(b&c|~b&e,a,b,f,g,h)}function f(a,b,c,e,f,g,h){return d(b&e|c&~e,a,b,f,g,h)}function g(a,b,c,e,f,g,h){return d(b^c^e,a,b,f,g,h)}function h(a,b,c,e,f,g,h){return d(c^(b|~e),a,b,f,g,h)}function i(a,c){a[c>>5]|=128<<c%32,a[(c+64>>>9<<4)+14]=c;var d,i,j,k,l,m=1732584193,n=-271733879,o=-1732584194,p=271733878;for(d=0;d<a.length;d+=16)i=m,j=n,k=o,l=p,m=e(m,n,o,p,a[d],7,-680876936),p=e(p,m,n,o,a[d+1],12,-389564586),o=e(o,p,m,n,a[d+2],17,606105819),n=e(n,o,p,m,a[d+3],22,-1044525330),m=e(m,n,o,p,a[d+4],7,-176418897),p=e(p,m,n,o,a[d+5],12,1200080426),o=e(o,p,m,n,a[d+6],17,-1473231341),n=e(n,o,p,m,a[d+7],22,-45705983),m=e(m,n,o,p,a[d+8],7,1770035416),p=e(p,m,n,o,a[d+9],12,-1958414417),o=e(o,p,m,n,a[d+10],17,-42063),n=e(n,o,p,m,a[d+11],22,-1990404162),m=e(m,n,o,p,a[d+12],7,1804603682),p=e(p,m,n,o,a[d+13],12,-40341101),o=e(o,p,m,n,a[d+14],17,-1502002290),n=e(n,o,p,m,a[d+15],22,1236535329),m=f(m,n,o,p,a[d+1],5,-165796510),p=f(p,m,n,o,a[d+6],9,-1069501632),o=f(o,p,m,n,a[d+11],14,643717713),n=f(n,o,p,m,a[d],20,-373897302),m=f(m,n,o,p,a[d+5],5,-701558691),p=f(p,m,n,o,a[d+10],9,38016083),o=f(o,p,m,n,a[d+15],14,-660478335),n=f(n,o,p,m,a[d+4],20,-405537848),m=f(m,n,o,p,a[d+9],5,568446438),p=f(p,m,n,o,a[d+14],9,-1019803690),o=f(o,p,m,n,a[d+3],14,-187363961),n=f(n,o,p,m,a[d+8],20,1163531501),m=f(m,n,o,p,a[d+13],5,-1444681467),p=f(p,m,n,o,a[d+2],9,-51403784),o=f(o,p,m,n,a[d+7],14,1735328473),n=f(n,o,p,m,a[d+12],20,-1926607734),m=g(m,n,o,p,a[d+5],4,-378558),p=g(p,m,n,o,a[d+8],11,-2022574463),o=g(o,p,m,n,a[d+11],16,1839030562),n=g(n,o,p,m,a[d+14],23,-35309556),m=g(m,n,o,p,a[d+1],4,-1530992060),p=g(p,m,n,o,a[d+4],11,1272893353),o=g(o,p,m,n,a[d+7],16,-155497632),n=g(n,o,p,m,a[d+10],23,-1094730640),m=g(m,n,o,p,a[d+13],4,681279174),p=g(p,m,n,o,a[d],11,-358537222),o=g(o,p,m,n,a[d+3],16,-722521979),n=g(n,o,p,m,a[d+6],23,76029189),m=g(m,n,o,p,a[d+9],4,-640364487),p=g(p,m,n,o,a[d+12],11,-421815835),o=g(o,p,m,n,a[d+15],16,530742520),n=g(n,o,p,m,a[d+2],23,-995338651),m=h(m,n,o,p,a[d],6,-198630844),p=h(p,m,n,o,a[d+7],10,1126891415),o=h(o,p,m,n,a[d+14],15,-1416354905),n=h(n,o,p,m,a[d+5],21,-57434055),m=h(m,n,o,p,a[d+12],6,1700485571),p=h(p,m,n,o,a[d+3],10,-1894986606),o=h(o,p,m,n,a[d+10],15,-1051523),n=h(n,o,p,m,a[d+1],21,-2054922799),m=h(m,n,o,p,a[d+8],6,1873313359),p=h(p,m,n,o,a[d+15],10,-30611744),o=h(o,p,m,n,a[d+6],15,-1560198380),n=h(n,o,p,m,a[d+13],21,1309151649),m=h(m,n,o,p,a[d+4],6,-145523070),p=h(p,m,n,o,a[d+11],10,-1120210379),o=h(o,p,m,n,a[d+2],15,718787259),n=h(n,o,p,m,a[d+9],21,-343485551),m=b(m,i),n=b(n,j),o=b(o,k),p=b(p,l);return[m,n,o,p]}function j(a){var b,c="";for(b=0;b<32*a.length;b+=8)c+=String.fromCharCode(a[b>>5]>>>b%32&255);return c}function k(a){var b,c=[];for(c[(a.length>>2)-1]=void 0,b=0;b<c.length;b+=1)c[b]=0;for(b=0;b<8*a.length;b+=8)c[b>>5]|=(255&a.charCodeAt(b/8))<<b%32;return c}function l(a){return j(i(k(a),8*a.length))}function m(a,b){var c,d,e=k(a),f=[],g=[];for(f[15]=g[15]=void 0,e.length>16&&(e=i(e,8*a.length)),c=0;c<16;c+=1)f[c]=909522486^e[c],g[c]=1549556828^e[c];return d=i(f.concat(k(b)),512+8*b.length),j(i(g.concat(d),640))}function n(a){var b,c,d="0123456789abcdef",e="";for(c=0;c<a.length;c+=1)b=a.charCodeAt(c),e+=d.charAt(b>>>4&15)+d.charAt(15&b);return e}function o(a){return unescape(encodeURIComponent(a))}function p(a){return l(o(a))}function q(a){return n(p(a))}function r(a,b){return m(o(a),o(b))}function s(a,b){return n(r(a,b))}function t(a,b,c){return b?c?r(b,a):s(b,a):c?p(a):q(a)}a.md5=t}(b),function(a){"use strict";var b={};b.startsWith=function(a,b){return 0==a.indexOf(b)},a.StringUtils=b}(b),function(a){"use strict";var b={};b.clone=function(a){var b={};for(var c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b},b.merge=function(a,c){var d=b.clone(a);for(var e in c)c.hasOwnProperty(e)&&(d[e]=c[e]);return d},a.ObjectUtils=b}(b),function(a){"use strict";function b(a,b,c){this.fn=a,this.ctx=b,this.params=c}b.prototype.run=function(){this.params?this.fn.apply(this.ctx,this.params):this.fn.apply(this.ctx)},a.radio.Command=b}(d),function(a){"use strict";function b(a,b){this._queue=[],this._lastTs=0,this._isSuspended="undefined"!=typeof a&&a,this._delay="undefined"!=typeof b?b:0}b.prototype.addCommand=function(a){this._queue.push(a),this._drain()},b.prototype.cancelAllCommands=function(){this._queue=[]},b.prototype.isEmpty=function(){return 0===this._queue.length},b.prototype.suspend=function(){this._isSuspended=!0},b.prototype.resume=function(){this._isSuspended=!1,this._drain()},b.prototype.flush=function(){this._isSuspended=!1;for(var a=0;a<this._queue.length;a++){var b=this._queue[a];b.run()}this._queue=[]},b.prototype._drain=function(){if(!this._isSuspended&&!this._drainInProgress){this._drainInProgress=!0;var a=this;!function b(){var c=a._queue.shift();c?a._runCommand(c,function(){a._isSuspended||b()}):a._drainInProgress=!1}()}},b.prototype._runCommand=function(a,b){function c(){a.run(),null!=b&&b.call(d)}var d=this;if(0==this._lastTs)c();else{var e=(new Date).getTime(),f=e-this._lastTs;this._lastTs=e,f<this._delay?setTimeout(c,this._delay-f):c()}},a.radio.CommandQueue=b}(d),function(a){"use strict";function b(a,b){if(this._name=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._listeners={},this._requests={},this._commands={},this._isShutDown=!1}function c(a,c){if(a===c)return!0;for(var d=(a||"").split(b.SEPARATOR),e=(c||"").split(b.SEPARATOR),f=!0,g=0;g<d.length;g++)f=f&&(d[g]===b.WILDCARD||d[g]===e[g]);return f}b.WILDCARD="*",b.SEPARATOR=":",b.prototype.toString=function(){return"<channel: "+this._name+">"},b.prototype.shutdown=function(){this._isShutDown||(this._logger.debug(d,"#shutdown > Shutting down"),this.off(),this._requests={},this._commands={},this._isShutDown=!0)},b.prototype.on=function(a,b,c){this._isShutDown||(this._listeners[a]||(this._listeners[a]=[]),this._listeners[a].push({fn:b,ctx:c}))},b.prototype.off=function(a,b,c){if(!this._isShutDown){if(b="function"==typeof b?b:null,!a&&null==b&&!c)return void(this._listeners={});if(a)this._removeListener(a,b,c);else for(a in this._listeners)this._listeners.hasOwnProperty(a)&&this._removeListener(a,b,c)}},b.prototype.trigger=function(a){if(!this._isShutDown)for(var b in this._listeners)if(this._listeners.hasOwnProperty(b)&&c(b,a.name))for(var d=this._listeners[b].slice(0),e=0;e<d.length;e++){var f=d[e];f.fn.call(f.ctx,a)}},b.prototype.comply=function(a,b,c){this._isShutDown||(this._commands[a]={cmd:b,ctx:c})},b.prototype.command=function(a,b){if(!this._isShutDown){var c=this._commands[a];return c?void c.cmd.call(c.ctx,b):void this._logger.warn(d,"#command > No command handler for: "+a)}},b.prototype.reply=function(a,b,c){this._isShutDown||(this._requests[a]={fn:b,ctx:c})},b.prototype.request=function(a){if(!this._isShutDown){var b=this._requests[a];return b?b.fn.call(b.ctx):(this._logger.warn(d,"#request > No request handler for: "+a),null)}},b.prototype._removeListener=function(a,b,c){b="function"==typeof b?b:null;var d=this._listeners[a];if(d){if(!d.length||null==b&&!c)return void delete this._listeners[a];for(var e=0;e<d.length;e++){var f=d[e];null!==b&&b!==f.fn||c&&c!==f.ctx||this._listeners[a].splice(e,1)}}};var d="radio::Channel";a.radio.Channel=b}(d),function(a){"use strict";function b(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._channels={}}var c=a.radio.Channel;b.prototype.channel=function(a){return this._channels[a]||(this._channels[a]=new c(a,this._logger)),this._channels[a]},b.prototype.shutdown=function(){for(var a in this._channels)this._channels.hasOwnProperty(a)&&this._channels[a].shutdown()},a.radio.Radio=b}(d),function(a){"use strict";function b(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a}a.extend=b}(d),function(a){"use strict";function b(){}b.prototype.write=function(a){throw new Error("Implementation error: Method must be overridden.")},a.ILogWriter=b}(d),function(a){"use strict";function b(){}b.prototype.write=function(a){window.console&&window.console.log&&window.console.log(a)},a.LogWriter=b}(d),function(a){"use strict";function b(){}b.prototype.setLogWriter=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getLogWriter=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getEnabled=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.enable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.disable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.debug=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.info=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.warn=function(a,b){throw new Error("Implementation error: Method must be overridden.")},b.prototype.error=function(a,b){throw new Error("Implementation error: Method must be overridden.")},a.ILogger=b}(d),function(a){"use strict";function b(){this._logWriter=new d}function c(a){return a<10?"00"+a:a<100?"0"+a:""+a}var d=a.LogWriter;b.prototype.setLogWriter=function(a){if(!a)throw new Error("Reference to the ILogWriter object cannot be NULL");this._logWriter=a,this._enabled=!1},b.prototype.getLogWriter=function(){return this._logWriter},b.prototype.getEnabled=function(){return this._enabled},b.prototype.enable=function(){this._enabled=!0},b.prototype.disable=function(){this._enabled=!1},b.prototype.debug=function(a,b){this._log(a,f,b)},b.prototype.info=function(a,b){this._log(a,e,b)},b.prototype.warn=function(a,b){this._log(a,g,b)},b.prototype.error=function(a,b){this._log(a,h,b)},b.prototype._log=function(a,b,d){if(b==h||this._enabled){var e="",f=new Date;e+="["+f.toTimeString()+"."+c(f.getMilliseconds())+"] ["+b+"] ",e+="["+a+"] "+d,this._logWriter.write(e)}};var e="INFO",f="DEBUG",g="WARN",h="ERROR";a.Logger=b}(d),function(a){"use strict";function b(a,b){this._pluginName=a,this._eventName=b}var c=a.radio.Channel;b.prototype.getPluginName=function(){return this._pluginName},b.prototype.getEventName=function(){return this._eventName},b.prototype.getName=function(){return this._pluginName+c.SEPARATOR+this._eventName},a.Trigger=b}(d),function(a){"use strict";function b(a,b){this.name=a,this.data=b}b.SUCCESS="success",b.ERROR="error",b.createFromTrigger=function(a){return new b(a.getName())},a.Event=b}(d),function(a){"use strict";function b(){this._events={}}b.prototype.addEventListener=function(a,b,c){a&&b&&(c=c||window,this._events[a]=this._events[a]||[],this._events[a].push({cb:b,ctx:c}))},b.prototype.removeEventListener=function(a,b,c){if(a&&b){c=c||window;var d,e,f=!1;for(e in this._events)if(a===e){f=!0;break}if(f){for(d=this._events[e].length-1;d>=0;d--){var g=this._events[e][d];b===g.cb&&c===g.ctx&&this._events[e].splice(d,1)}this._events[e].length||delete this._events[e]}}},b.prototype.dispatchEvent=function(a){if(a.name){var b,c;for(b in this._events)if(this._events.hasOwnProperty(b)&&a.name===b){var d=this._events[b],e=d.slice(0),f=e.length;for(c=0;c<f;c++)e[c].cb.call(e[c].ctx,a);break}}},b.prototype.removeAllListeners=function(a){if(a){var b,c;for(c in this._events)if(this._events.hasOwnProperty(c)){for(b=this._events[c].length-1;b>=0;b--){var d=this._events[c][b];d.ctx===a&&this._events[c].splice(b,1)}this._events[c].length||delete this._events[c]}}else this._events={}},a.EventDispatcher=b}(d),function(a){"use strict";function b(){}function c(a,b){this.url=a||null,this.method=b,this._xmlhttp=null}function d(){d.__super__.constructor.call(this),this._connection=null}var e=a.Event,f=a.EventDispatcher;b.GET="GET",d.RESPONSE="response",d.INSTANCE="instance",a.extend(d,f),d.prototype.close=function(){this.removeAllListeners(null)},d.prototype.load=function(a){a&&a.method&&a.url&&(a._xmlhttp=this._createCORSRequest(a),a._xmlhttp?a._xmlhttp.send():this._loadImage(a))},d.prototype._createCORSRequest=function(a){var b=null;if("undefined"!=typeof window.XMLHttpRequest){var c=new window.XMLHttpRequest;"withCredentials"in c&&(b=c,b.open(a.method,a.url,!0))}if(null==b&&"undefined"!=typeof window.XDomainRequest&&(b=new window.XDomainRequest,b.open(a.method,a.url)),b){var f={};f[d.INSTANCE]=this;var g=this;b.onload=function(){return b.status&&parseInt(b.status,10)>=400?this.onerror():(f[d.RESPONSE]=b.responseText,void g.dispatchEvent(new e(e.SUCCESS,f)))},b.onerror=function(){g.dispatchEvent(new e(e.ERROR,f))}}return b},d.prototype._loadImage=function(a){this._connection||(this._connection=new Image,this._connection.alt=""),this._connection.src=a.url;var b={};b[d.RESPONSE]="",b[d.INSTANCE]=this,this.dispatchEvent(new e(e.SUCCESS,b))},a.URLRequestMethod=b,a.URLRequest=c,a.URLLoader=d}(d),function(a){"use strict";var b="js",c="2.0.2.123",d="150f2b",e=4,f={};f.getVersion=function(){return b+"-"+c+"-"+d},f.getMajor=function(){return f.getNumberAtPosition(0)},f.getMinor=function(){return f.getNumberAtPosition(1)},f.getMicro=function(){return f.getNumberAtPosition(2)},f.getPatch=function(){return f.getNumberAtPosition(3)},f.getBuild=function(){return d},f.getApiLevel=function(){return e},f.getNumberAtPosition=function(a){return c.split(".")[a]},a.Version=f}(c),function(a){"use strict";function b(a,b){this._message=a,this._details=b}b.prototype.getMessage=function(){return this._message},b.prototype.getDetails=function(){return this._details},a.ErrorInfo=b}(c),function(a){"use strict";function b(){this.debugLogging=!1}a.HeartbeatConfig=b}(c),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.HeartbeatDelegate=b}(c),function(a){"use strict";function b(){}b.prototype.configure=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.bootstrap=function(a){throw new Error("Implementation error: Method must be overridden.")},b.prototype.setup=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.destroy=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.enable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.disable=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getName=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.isInitialized=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.resolveData=function(a){throw new Error("Implementation error: Method must be overridden.")},a.plugin.IPlugin=b}(d),function(a){"use strict";function b(a,b,c,d){this.trigger=a,this.action=c,this.plugin=b,this._paramMappings={},this.mergeParams(d)}var c=a.plugin.ParamMapping;b.prototype.mergeParams=function(a){if(a)for(var b=0;b<a.length;b++){var c=a[b];this._paramMappings[c.getKeyName()]=c}},b.prototype.getParams=function(){var a=[];for(var b in this._paramMappings)this._paramMappings.hasOwnProperty(b)&&a.push(this._paramMappings[b]);return a},b.prototype.addParam=function(a){this._paramMappings[a.getKeyName()]=a},b.prototype.removeParam=function(a,b){var d=new c(a,b);this._paramMappings.hasOwnProperty(d.getKeyName())&&delete this._paramMappings[d.getKeyName()]},a.plugin.Behaviour=b}(d),function(a){"use strict";function b(a,b,d){this._pluginName=a,this._key=b,this._paramName=d||a+c.SEPARATOR+b}var c=a.radio.Channel;b.prototype.getPluginName=function(){return this._pluginName},b.prototype.getKey=function(){return this._key},b.prototype.getKeyName=function(){return this._pluginName+c.SEPARATOR+this._key},b.prototype.getParamName=function(){return this._paramName},a.plugin.ParamMapping=b}(d),function(a){"use strict";function b(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._plugins={},this._behaviours={},this._radio=new d(this._logger),this._dataChannel=this._radio.channel(g),this._ctrlChannel=this._radio.channel(h)}var c=a.Event,d=a.radio.Radio,e=a.radio.Channel,f=a.plugin.Behaviour;b.ERROR="error",b.prototype.addPlugin=function(a){var b=a.getName();this._plugins[b]&&this._logger.warn(i,"#addPlugin > Replacing plugin: "+b),this._plugins[b]=a,a.bootstrap(this)},b.prototype.setupPlugins=function(){for(var a in this._plugins)this._plugins.hasOwnProperty(a)&&this._plugins[a].setup()},b.prototype.pluginExists=function(a){return!!this._plugins[a]},b.prototype.isPluginInitialized=function(a){return this._plugins[a]&&this._plugins[a].isInitialized()},b.prototype.on=function(a,b,c,d){this._dataChannel.on(a+e.SEPARATOR+b,c,d)},b.prototype.off=function(a,b,c,d){var f=a&&b?a+e.SEPARATOR+b:null;this._dataChannel.off(f,c,d)},b.prototype.trigger=function(a){var b=a.name,c=this._behaviours[b];if(c){var d,e,f,g,h,i={},j={};for(d=0;d<c.length;d++)if(f=c[d],g=f.getParams())for(e=0;e<g.length;e++)h=g[e],i[h.getPluginName()]=i[h.getPluginName()]||[],h.key in i[h.getPluginName()]||i[h.getPluginName()].push(h.getKey());for(var k in i)i.hasOwnProperty(k)&&(j[k]=this.request(k,i[k]));for(d=0;d<c.length;d++){f=c[d];var l={_behaviour:f,_eventData:a.data||{}};if(g=f.getParams()){for(e=0;e<g.length;e++)h=g[e],l[h.getParamName()]=j[h.getPluginName()]?j[h.getPluginName()][h.getKey()]:null;this.command(f.plugin.getName(),f.action,l)}}}this._dataChannel.trigger(a)},b.prototype.request=function(a,b){var c=this._plugins[a];return c&&b&&0!=b.length?c.resolveData(b):null},b.prototype.raise=function(a){this._errorInfo=a;var d=new c(b.ERROR,a);this._ctrlChannel.trigger(d)},b.prototype.getErrorInfo=function(){return this._errorInfo},b.prototype.destroy=function(){this._radio.shutdown();for(var a in this._plugins)this._plugins.hasOwnProperty(a)&&this._plugins[a].destroy()},b.prototype.comply=function(a,b,c){this._dataChannel.comply(a.getName()+e.SEPARATOR+b,c,a)},b.prototype.command=function(a,b,c){this._dataChannel.command(a+e.SEPARATOR+b,c)},b.prototype.registerBehaviour=function(a,b,c,d){var e=a.getName(),g=new f(a,b,c,d);this._behaviours[e]=this._behaviours[e]||[],this._behaviours[e].push(g)};var g="data_channel",h="ctrl_channel",i="plugin::PluginManager";a.plugin.PluginManager=b}(d),function(a,b){"use strict";function c(a){this._name=a,this._isInitialized=!1,this._isDestroyed=!1,this._isEnabled=!0,this._dataResolver={},this._logTag="plugin::"+this.getName(),this._logger=new d}var d=a.Logger,e=a.Trigger,f=a.Event,g=b.ErrorInfo;c.INITIALIZED="initialized",c.prototype.configure=function(a){},c.prototype.bootstrap=function(a){this._pluginManager=a,this._isDestroyed&&this._pluginManager.raise(new g("Invalid state.","Plugin already destroyed."))},c.prototype.setup=function(){this._trigger(c.INITIALIZED),this._isInitialized=!0},c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._teardown())},c.prototype.enable=function(){this._isEnabled=!0,this._enabled()},c.prototype.disable=function(){this._isEnabled=!1,this._disabled()},c.prototype.getName=function(){return this._name},c.prototype.getLogger=function(){return this._logger},c.prototype.isInitialized=function(){return this._isInitialized},c.prototype.resolveData=function(a){if(!this._isEnabled||!this._isInitialized)return this._logger.warn(this._logTag,"Unable to retrieve plugin data. Plugin: "+this._name+". Enabled: "+this._isEnabled+". Initialized: "+this._isInitialized+"."),null;if("function"==typeof this._dataResolver)return this._dataResolver.call(this,a);var b=null;if(a)for(var c=0;c<a.length;c++){var d=a[c];this._dataResolver.hasOwnProperty(d)&&(b=b||{},"function"==typeof this._dataResolver[d]?b[d]=this._dataResolver[d].call(this):b[d]=this._dataResolver[d])}return b},c.prototype.toString=function(){return"<plugin: "+this._name+">"},c.prototype._enabled=function(){},c.prototype._disabled=function(){},c.prototype._teardown=function(){},c.prototype._canProcess=function(){return this._isEnabled?!this._isDestroyed||(this._logger.error(this._logTag,"Plugin destroyed."),!1):(this._logger.error(this._logTag,"Plugin disabled."),!1)},c.prototype._trigger=function(a,b){var c=f.createFromTrigger(new e(this.getName(),a));c.data=b,this._pluginManager.trigger(c)},a.plugin.BasePlugin=c}(d,c),function(a){"use strict";function b(a,b,c){this.name=a,this.interval=b,this.isActive=!1,this.repeatCount="undefined"!=typeof c?c:e,this._nextTickTimestamp=0,this.reset()}function c(a,b){if(!a)throw new Error("Reference to the ClockService object cannot be NULL");if(this._service=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._isDestroyed=!1,this._timers={};var c=this;this._clock=window.setInterval(function(){c._onTick()},1e3*f)}b.prototype.reset=function(){this.tick=0,this._createdTimestamp=(new Date).getTime(),this._updateNextTickTimestamp()},b.prototype.shouldTick=function(){var a=(new Date).getTime();return a>this._nextTickTimestamp-f/2&&(this.tick++,this._updateNextTickTimestamp(),!0)},b.prototype._updateNextTickTimestamp=function(){this._nextTickTimestamp=this._createdTimestamp+1e3*this.interval*(this.tick+1)},c.prototype.createTimer=function(a,c,d){this._timers[a]=new b(a,c,d)},c.prototype.destroyTimer=function(a){delete this._timers[a]},c.prototype.resumeTimer=function(a,b){b="undefined"!=typeof b&&b,this._logger.debug(d,"#resumeTimer(name="+a+", reset="+b+")");var c=this._timers[a];c&&(c.isActive=!0,b&&c.reset())},c.prototype.pauseTimer=function(a,b){b="undefined"!=typeof b&&b,this._logger.debug(d,"#pauseTimer(name="+a+", reset="+b+")");var c=this._timers[a];c&&(c.isActive=!1,b&&c.reset())},c.prototype.isTimerPaused=function(a){var b=this._timers[a];return!!b&&!b.isActive},c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._timers={},window.clearInterval(this._clock))},c.prototype._onTick=function(){for(var a in this._timers)if(this._timers.hasOwnProperty(a)){var b=this._timers[a];b.isActive&&b.shouldTick()&&(b.interval>1&&this._logger.debug(d,"#_onTick() > "+b.name+"("+b.tick+" | "+b.repeatCount+")"),0!=b.repeatCount?(this._service.onTick(b.name,b.interval,b.tick),b.repeatCount!=e&&b.repeatCount--):this.destroyTimer(b.name))}};var d="service.clock::TimerManager",e=-1,f=.25;a.clock.TimerDescriptor=b,a.clock.TimerManager=c}(e),function(a,b,c){"use strict";function d(a){if(d.__super__.constructor.call(this,h),!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a,this._timerManager=new e(this,this._logger),this._setupDataResolver()}var e=c.clock.TimerManager,f=b.StringUtils,g=a.plugin.BasePlugin;a.extend(d,g),d.prototype.bootstrap=function(a){d.__super__.bootstrap.call(this,a),this._pluginManager.comply(this,i,this._cmdCreate),this._pluginManager.comply(this,k,this._cmdResume),this._pluginManager.comply(this,j,this._cmdPause),this._pluginManager.comply(this,l,this._cmdDestroy)},d.prototype._teardown=function(){this._timerManager.destroy()},d.prototype._cmdCreate=function(a){var b=a[o]||s;this._timerManager.createTimer(a[m],a[n],b)},d.prototype._cmdPause=function(a){this._timerManager.pauseTimer(a[m],!!a[q])},d.prototype._cmdResume=function(a){this._timerManager.resumeTimer(a[m],!!a[q])},d.prototype._cmdDestroy=function(a){this._timerManager.destroyTimer(a[m])},d.prototype.onTick=function(a,b,c){a+=".tick";var d={};d[m]=a,d[n]=b,d[p]=c,this._trigger(a,d)},d.prototype._setupDataResolver=function(){var a={},b=this._timerManager;a[r]=function(a){return b.isTimerPaused(a)},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];if(c=c||{},f.startsWith(e,r)){var g=e.split(r+".");g.length>0&&(c[e]=a[r].call(this,g[1]))}}return c}};var h="service.clock",i="create",j="pause",k="resume",l="destroy",m="name",n="interval",o="repeat_count",p="tick",q="reset",r="is_paused",s=-1;c.clock.ClockService=d}(d,b,e),function(a,b,c){"use strict";function d(a,b){if(this._logger=new e,this._pluginManager=new f(this._logger),this._pluginManager.addPlugin(new g(this._logger)),b)for(var c=0;c<b.length;c++)this._pluginManager.addPlugin(b[c]);this._pluginManager.setupPlugins(),this._isDestroyed=!1}var e=a.Logger,f=a.plugin.PluginManager,g=b.clock.ClockService;d.prototype.configure=function(a){if(!a)throw new Error("Configuration object cannot be NULL.");a.debugLogging?this._logger.enable():this._logger.disable(),this._isDestroyed&&this._logger.error(h,"Instance is destroyed.")},d.prototype.destroy=function(){this._isDestroyed||(this._pluginManager.destroy(),this._isDestroyed=!0)};var h="Heartbeat";c.Heartbeat=d}(d,e,c),a.ADB||(a.ADB={}),a.ADB.core||(a.ADB.core=d),a.ADB.va||(a.ADB.va=c),a.ADB.va.utils||(a.ADB.va.utils=b),a.ADB.va.plugins||(a.ADB.va.plugins={})}(this);
	
	// VideoPlayerPlugin
	!function(a){if("undefined"==typeof b)var b={};!function(a){"use strict";var b={};b.ASSET_TYPE_VOD="vod",b.ASSET_TYPE_LIVE="live",b.ASSET_TYPE_LINEAR="linear",a.AssetType=b}(b),function(a){"use strict";function b(){this.playerName=null,this.name=null,this.position=null,this.startTime=null}b.prototype.toString=function(){return"playerName="+this.playerName+", name="+this.name+", position="+this.position+", startTime="+this.startTime},a.AdBreakInfo=b}(b),function(a){"use strict";function b(){this.id=null,this.name=null,this.length=null,this.position=null}b.prototype.toString=function(){return"id="+this.id+", name="+this.name+", length="+this.length+", position="+this.position},a.AdInfo=b}(b),function(a){"use strict";function b(){this.name=null,this.length=null,this.position=null,this.startTime=null}b.prototype.toString=function(){return"name="+this.name+", length="+this.length+", position="+this.position+", startTime="+this.startTime},a.ChapterInfo=b}(b),function(a){"use strict";function b(){this.bitrate=null,this.fps=null,this.droppedFrames=null,this.startupTime=null}b.prototype.toString=function(){return"bitrate="+this.bitrate+", fps="+this.fps+", droppedFrames="+this.droppedFrames+", startupTime="+this.startupTime},a.QoSInfo=b}(b),function(a){"use strict";function b(){this.playerName=null,this.id=null,this.name=null,this.length=null,this.playhead=null,this.streamType=null,this.resumed=!1}b.prototype.toString=function(){return"playerName="+this.playerName+", id="+this.id+", name="+this.name+", length="+this.length+", playhead="+this.playhead+", streamType="+this.streamType+", resumed="+this.resumed},a.VideoInfo=b}(b),function(a){"use strict";function b(){this.debugLogging=!1}a.VideoPlayerPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.getVideoInfo=function(){throw new Error("Implementation error: Method must be overridden.")},b.prototype.getAdBreakInfo=function(){return null},b.prototype.getAdInfo=function(){return null},b.prototype.getChapterInfo=function(){return null},b.prototype.getQoSInfo=function(){return null},a.VideoPlayerPluginDelegate=b}(b),function(a,b){"use strict";function c(a){if(c.__super__.constructor.call(this,h),!a)throw new Error("PlayerPlugin delegate cannot be NULL.");this._delegate=a,this._isTrackingSessionActive=!1,this._isTrackingSessionStarted=!1,this._isTrackingAd=!1,this._playheadTimer=null,this._previousPlayhead=-1,this._stalledPlayheadCount=0,this._playheadStalled=!1,this._videoIdle=!1,this._setupDataResolver()}var d=a.plugin.ParamMapping,e=a.Trigger,f=a.plugin.BasePlugin,g=b.VideoPlayerPluginConfig;a.extend(c,f),c.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof g))throw new Error("Expected config data to be instance of VideoPlayerPluginConfig.");a.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure(debugLogging="+a.debugLogging+")")},c.prototype.bootstrap=function(a){c.__super__.bootstrap.call(this,a),this._registerCommands(),this._registerBehaviours()},c.prototype._cmdVideoIdleStart=function(a){this._logger.info(this._logTag,"#_cmdVideoIdleStart()"),this._videoIdle=!0},c.prototype._cmdVideoIdleResume=function(a){this._logger.info(this._logTag,"#_cmdVideoIdleResume()"),this._videoIdle&&(this._trigger(o),this._trigger(p),a.isInChapter&&this._trigger(A),a.isInAd&&(this._trigger(u),this._isTrackingAd=!0)),this._videoIdle=!1},c.prototype.trackSessionStart=function(){if(this._logger.info(this._logTag,"#trackSessionStart()"),this._canProcess()){if(!this._isTrackingSessionActive)return void this._logger.warn(this._logTag,"#trackSessionStart() > No active tracking session.");if(this._isTrackingSessionStarted)return void this._logger.info(this._logTag,"#trackSessionStart() > Tracking session already started.");this._trigger(o),this._isTrackingSessionStarted=!0;var a=this._dataResolver(["video.resumed"]);a.hasOwnProperty("video.resumed")&&a["video.resumed"]&&this._trigger(p)}},c.prototype.trackVideoLoad=function(){this._logger.info(this._logTag,"#trackVideoLoad()"),this._canProcess()&&(this._trigger(m),this._isTrackingSessionActive=!0,this._isTrackingSessionStarted=!1)},c.prototype.trackVideoUnload=function(){if(this._logger.info(this._logTag,"#trackVideoUnload()"),this._canProcess()){if(!this._isTrackingSessionActive)return void this._logger.warn(this._logTag,"#trackVideoUnload() > No active tracking session.");this._stopPlayheadTimer(),this._trigger(n),this._isTrackingSessionActive=!1,this._isTrackingSessionStarted=!1,this._videoIdle=!1}},c.prototype.trackPlay=function(){this._logger.info(this._logTag,"#trackPlay()"),this._canProcess()&&this._startSessionIfNeeded("trackPlay")&&(this._trigger(s),this._startPlayheadTimer())},c.prototype.trackPause=function(){if(this._logger.info(this._logTag,"#trackPause()"),this._canProcess()&&this._startSessionIfNeeded("trackPause")){this._stopPlayheadTimer();var a={};a[H]=!1,this._trigger(t,a)}},c.prototype.trackBufferStart=function(){this._logger.info(this._logTag,"#trackBufferStart()"),this._canProcess()&&this._startSessionIfNeeded("trackBufferStart")&&(this._stopPlayheadTimer(),this._trigger(w))},c.prototype.trackBufferComplete=function(){this._logger.info(this._logTag,"#trackBufferComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackBufferComplete")&&(this._trigger(x),this._startPlayheadTimer())},c.prototype.trackSeekStart=function(){this._logger.info(this._logTag,"#trackSeekStart()"),this._canProcess()&&this._startSessionIfNeeded("trackSeekStart")&&(this._stopPlayheadTimer(),this._trigger(y))},c.prototype.trackSeekComplete=function(){if(this._logger.info(this._logTag,"#trackSeekComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackSeekComplete")){this._trigger(z),this._startPlayheadTimer();var a=this._dataResolver(["ad.isInAd"]);this._isTrackingAd=a.hasOwnProperty("ad.isInAd")&&a["ad.isInAd"]}},c.prototype.trackComplete=function(a){if(this._logger.info(this._logTag,"#trackComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackComplete")){var b={};b[G]=a,this._stopPlayheadTimer(),this._trigger(q,b)}},c.prototype.trackTimedMetadata=function(a){this._logger.info(this._logTag,"#trackComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackTimedMetadata")&&this._trigger(r,a)},c.prototype.trackChapterStart=function(){this._logger.info(this._logTag,"#trackChapterStart()"),this._canProcess()&&this._startSessionIfNeeded("#trackChapterStart")&&this._trigger(A)},c.prototype.trackChapterComplete=function(){this._logger.info(this._logTag,"trackChapterComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackChapterComplete")&&this._trigger(B)},c.prototype.trackAdStart=function(){this._logger.info(this._logTag,"#trackAdStart()"),this._canProcess()&&this._startSessionIfNeeded("trackAdStart")&&(this._trigger(u),this._isTrackingAd=!0)},c.prototype.trackAdComplete=function(){this._logger.info(this._logTag,"#trackAdComplete()"),this._canProcess()&&this._startSessionIfNeeded("trackAdComplete")&&(this._trigger(v),this._isTrackingAd=!1)},c.prototype.trackBitrateChange=function(){this._logger.info(this._logTag,"#trackBitrateChange()"),this._canProcess()&&this._startSessionIfNeeded("trackBitrateChange")&&this._trigger(C)},c.prototype.trackVideoPlayerError=function(a){if(this._logger.info(this._logTag,"#trackVideoPlayerError(errorId="+a+")"),this._startSessionIfNeeded("trackVideoPlayerError")){var b={};b[I]=l,b[J]=a,this._trigger(D,b)}},c.prototype.trackApplicationError=function(a){if(this._logger.info(this._logTag,"#trackApplicationError(errorId="+a+")"),this._startSessionIfNeeded("trackApplicationError")){var b={};b[I]=k,b[J]=a,this._trigger(D,b)}},c.prototype._registerCommands=function(){this._pluginManager.comply(this,"handleVideoIdleStart",this._cmdVideoIdleStart),this._pluginManager.comply(this,"handleVideoIdleResume",this._cmdVideoIdleResume)},c.prototype._registerBehaviours=function(){this._pluginManager.registerBehaviour(new e(j,E),this,"handleVideoIdleStart"),this._pluginManager.registerBehaviour(new e(j,F),this,"handleVideoIdleResume",[new d(i,"ad.isInAd","isInAd"),new d(i,"chapter.isInChapter","isInChapter")])},c.prototype._setupDataResolver=function(){function a(){return g.video?g.video:(g.video=h._delegate.getVideoInfo(),h._logger.info(h._logTag,"Data from delegate > VideoInfo: "+g.video),g.video)}function b(){return g.ad?g.ad:(g.ad=h._delegate.getAdInfo(),h._logger.info(h._logTag,"Data from delegate > AdInfo: "+g.ad),g.ad)}function c(){return g.pod?g.pod:(g.pod=h._delegate.getAdBreakInfo(),h._logger.info(h._logTag,"Data from delegate > AdBreakInfo: "+g.pod),g.pod)}function d(){return g.chapter?g.chapter:(g.chapter=h._delegate.getChapterInfo(),h._logger.info(h._logTag,"Data from delegate > ChapterInfo: "+g.chapter),g.chapter)}function e(){return g.qos?g.qos:(g.qos=h._delegate.getQoSInfo(),h._logger.info(h._logTag,"Data from delegate > QoSInfo: "+g.qos),g.qos)}var f={},g={},h=this;f["video.id"]=function(){var b=a(),c=b?b.id:null;return h._logger.debug(h._logTag,"Resolving video.id: "+c),c},f["video.name"]=function(){var b=a(),c=b?b.name:null;return h._logger.debug(h._logTag,"Resolving video.name: "+c),c},f["video.length"]=function(){var b=a(),c=b?b.length:NaN;return h._logger.debug(h._logTag,"Resolving video.length: "+c),c},f["video.playerName"]=function(){var b=a(),c=b?b.playerName:null;return h._logger.debug(h._logTag,"Resolving video.playerName: "+c),c},f["video.streamType"]=function(){var b=a(),c=b?b.streamType:null;return h._logger.debug(h._logTag,"Resolving video.streamType: "+c),c},f["video.playhead"]=function(){var b=a(),c=b?b.playhead:NaN;return h._logger.debug(h._logTag,"Resolving video.playhead: "+c),c},f["video.resumed"]=function(){var b=a(),c=!!b&&b.resumed;return h._logger.debug(h._logTag,"Resolving video.resumed: "+c),c},f["video.playheadStalled"]=function(){return this._playheadStalled},f["pod.name"]=function(){var a=c(),b=a?a.name:null;return h._logger.debug(h._logTag,"Resolving pod.name: "+b),b},f["pod.playerName"]=function(){var a=c(),b=a?a.playerName:null;return h._logger.debug(h._logTag,"Resolving pod.playerName: "+b),b},f["pod.position"]=function(){var a=c(),b=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving pod.position: "+b),b},f["pod.startTime"]=function(){var a=c(),b=a?a.startTime:NaN;return h._logger.debug(h._logTag,"Resolving pod.startTime: "+b),b},f["ad.isInAd"]=function(){var a=b(),c=null!=a;return h._logger.debug(h._logTag,"Resolving ad.isInAd: "+c),c},f["ad.isInAdBreak"]=function(){var a=c(),b=null!=a;return h._logger.debug(h._logTag,"Resolving ad.isInAdBreak: "+b),b},f["ad.id"]=function(){var a=b(),c=a?a.id:null;return h._logger.debug(h._logTag,"Resolving ad.id: "+c),c},f["ad.name"]=function(){var a=b(),c=a?a.name:null;return h._logger.debug(h._logTag,"Resolving ad.name: "+c),c},f["ad.length"]=function(){var a=b(),c=a?a.length:NaN;return h._logger.debug(h._logTag,"Resolving ad.length: "+c),c},f["ad.position"]=function(){var a=b(),c=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving ad.position: "+c),c},f["chapter.isInChapter"]=function(){var a=d(),b=null!=a;return h._logger.debug(h._logTag,"Resolving chapter.isInChapter: "+b),b},f["chapter.name"]=function(){var a=d(),b=a?a.name:null;return h._logger.debug(h._logTag,"Resolving chapter.name: "+b),b},f["chapter.length"]=function(){var a=d(),b=a?a.length:NaN;return h._logger.debug(h._logTag,"Resolving chapter.length: "+b),b},f["chapter.position"]=function(){var a=d(),b=a?a.position:NaN;return h._logger.debug(h._logTag,"Resolving chapter.position: "+b),b},f["chapter.startTime"]=function(){var a=d(),b=a?a.startTime:NaN;return h._logger.debug(h._logTag,"Resolving chapter.startTime: "+b),b},f["qos.bitrate"]=function(){var a=e(),b=a?a.bitrate:NaN;return h._logger.debug(h._logTag,"Resolving qos.bitrate: "+b),b},f["qos.fps"]=function(){var a=e(),b=a?a.fps:NaN;return h._logger.debug(h._logTag,"Resolving qos.fps: "+b),b},f["qos.droppedFrames"]=function(){var a=e(),b=a?a.droppedFrames:NaN;return h._logger.debug(h._logTag,"Resolving qos.droppedFrames: "+b),b},f["qos.startupTime"]=function(){var a=e(),b=a?1e3*a.startupTime:NaN;return h._logger.debug(h._logTag,"Resolving qos.startupTime: "+b),b},this._dataResolver=function(a){if(!a||0==a.length)return null;g={};for(var b=null,c=0;c<a.length;c++){var d=a[c];b=b||{},b[d]=f.hasOwnProperty(d)?f[d].call(this):null}return b}},c.prototype._trackPlayheadStall=function(){this._canProcess()&&(this._playheadStalled||(this._logger.info(this._logTag,"#_trackPlayheadStall()"),this._stalledPlayheadCount=0,this._playheadStalled=!0,this._trigger(t)))},c.prototype._trackExitStall=function(){this._canProcess()&&(this._stalledPlayheadCount=0,this._playheadStalled&&(this._logger.info(this._logTag,"#_trackExitStall()"),this._playheadStalled=!1,this._trigger(s)))},c.prototype._startPlayheadTimer=function(){var a=this;this._playheadTimer||(this._playheadTimer=setInterval(function(){if(a._canProcess()){var b=a._dataResolver(["ad.isInAd","video.playhead"]);if(a._isTrackingAd)a._playheadStalled&&a._trackExitStall(),b.hasOwnProperty("ad.isInAd")&&!b["ad.isInAd"]&&(a._isTrackingAd=!1);else{var c=b["video.playhead"];c!=a._previousPlayhead?a._trackExitStall():a._previousPlayhead>=0&&c==a._previousPlayhead&&(a._stalledPlayheadCount++,a._stalledPlayheadCount==L&&a._trackPlayheadStall()),a._previousPlayhead=c}}},K))},c.prototype._stopPlayheadTimer=function(){this._playheadTimer&&(clearInterval(this._playheadTimer),this._playheadTimer=null),this._trackExitStall()},c.prototype._startSessionIfNeeded=function(a){return this._isTrackingSessionActive?(this._isTrackingSessionStarted||(this._logger.info(this._logTag,"#"+a+"() > Tracking session auto-start."),this.trackSessionStart()),!0):(this._logger.warn(this._logTag,"#"+a+"() > No active tracking session."),!1)};var h="player",i=h,j="adobe-heartbeat",k="sourceErrorExternal",l="sourceErrorSDK",m="video_load",n="video_unload",o="video_start",p="video_resume",q="video_complete",r="timed_metadata",s="play",t="pause",u="ad_start",v="ad_complete",w="buffer_start",x="buffer_complete",y="seek_start",z="seek_complete",A="chapter_start",B="chapter_complete",C="bitrate_change",D="track_error",E="video_idle_start",F="video_idle_resume",G="callback",H="filter_report",I="source",J="error_id",K=1001,L=2;b.VideoPlayerPlugin=c}(a.ADB.core,b),a.ADB.va.plugins.videoplayer||(a.ADB.va.plugins.videoplayer=b)}(this);
	
	// AdobeHeartbeatPlugin
	!function(a){if("undefined"==typeof b)var b={};b.clock||(b.clock={}),b.context||(b.context={}),b.filter||(b.filter={}),b.model||(b.model={}),b.network||(b.network={}),function(a,b){"use strict";function c(a,b,c,d,e){if(!b)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=b,!a)throw new Error("Reference to the pluginManager object cannot be NULL");if(this._pluginManager=a,!e)throw new Error("Reference to the logger object cannot be NULL");this._logTag="ah::Timer."+c,this._logger=e,this._isDestroyed=!1,this._createTimer(c,d),this._installHandlers()}var d=a.Event;c.KEY_NAME="name",c.KEY_INTERVAL="interval",c.KEY_RESET="reset",c.prototype.resume=function(a){this._logger.debug(this._logTag,"Starting timer: "+this._name);var b={};b[c.KEY_NAME]=e+"."+this._name,b[c.KEY_RESET]=a,this._pluginManager.command(f,i,b)},c.prototype.pause=function(a){this._logger.debug(this._logTag,"Stopping timer: "+this._name);var b={};b[c.KEY_NAME]=e+"."+this._name,b[c.KEY_RESET]=a,this._pluginManager.command(f,h,b)},c.prototype.destroy=function(){if(!this._isDestroyed){this._isDestroyed=!0,this._uninstallHandlers();var a={};a[c.KEY_NAME]=e+"."+this._name,this._pluginManager.command(f,j,a)}},c.prototype.setInterval=function(a){var b=k+"."+e+"."+this._name,c=this._pluginManager.request(f,[b])[b];this.pause(!0),this._createTimer(this._name,a),c||this.resume(!0)},c.prototype._cmdResume=function(a){var b=!1;null!=a&&a.hasOwnProperty(c.KEY_RESET)&&(b=a[c.KEY_RESET]),this.resume(b)},c.prototype._cmdPause=function(a){var b=!1;null!=a&&a.hasOwnProperty(c.KEY_RESET)&&(b=a[c.KEY_RESET]),this.pause(b)},c.prototype._onTick=function(a,b){this._channel.trigger(new d("clock:"+this._name+".tick",b))},c.prototype._installHandlers=function(){this._channel.comply("clock:"+this._name+".resume",this._cmdResume,this),this._channel.comply("clock:"+this._name+".pause",this._cmdPause,this),this._pluginManager.on(f,e+"."+this._name+".tick",this._onTick,this)},c.prototype._uninstallHandlers=function(){this._channel.off(null,null,this),this._pluginManager.off(null,null,null,this)},c.prototype._createTimer=function(a,b){this._name=a,this._interval=b;var d={};d[c.KEY_NAME]=e+"."+this._name,d[c.KEY_INTERVAL]=this._interval,this._pluginManager.command(f,g,d)};var e="heartbeat",f="service.clock",g="create",h="pause",i="resume",j="destroy",k="is_paused";b.clock.Timer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,f,h,d)}var d=a.Event,e=b.clock.Timer;a.extend(c,e),c.prototype._onCheckStatusComplete=function(a){var b=a.data[l];if(this._logger.debug(this._logTag,"#_onCheckStatusComplete(interval="+b+")"),b){if(b==this._interval)return void this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval value not changed.");b>g?(this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Interval value too large: "+b),this.setInterval(g)):(this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval changed to: "+b),this.setInterval(b))}else this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Invalid interval value."),this.setInterval(h)},c.prototype._getSettings=function(a){this._logger.debug(this._logTag,"#_getSettings()"),this._channel.trigger(new d(i))},c.prototype._installHandlers=function(){c.__super__._installHandlers.call(this),this._channel.on(j,this._getSettings,this),this._channel.on(k,this._onCheckStatusComplete,this),this._channel.reply(l,function(){return this._interval},this)};var f="check_status",g=600,h=60,i="clock:check_status.tick",j="clock:check_status.get_settings",k="net:check_status_complete",l="check_status_interval";b.clock.CheckStatusTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,e,f,d)}var d=b.clock.Timer;a.extend(c,d),c.prototype._onCheckStatusComplete=function(a){var b=a.data[g];if(this._logger.debug(this._logTag,"#_onCheckStatusComplete(interval="+b+")"),b){if(b==this._interval)return void this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval value not changed.");this._logger.debug(this._logTag,"#_onCheckStatusComplete() > Interval changed to: "+b),this.setInterval(b)}else this._logger.warn(this._logTag,"#_onCheckStatusComplete() > Invalid interval value."),this.setInterval(f)},c.prototype._installHandlers=function(){c.__super__._installHandlers.call(this),this._channel.on(h,this._onCheckStatusComplete,this),this._channel.reply(g,function(){return this._interval},this)};var e="reporting",f=10,g="reporting_interval",h="net:check_status_complete";b.clock.ReportingTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,e,f,d)}var d=b.clock.Timer;a.extend(c,d);var e="idle",f=1800;b.clock.IdleTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,d){c.__super__.constructor.call(this,a,b,e,f,d)}var d=b.clock.Timer;a.extend(c,d);var e="flush_filter",f=.25;b.clock.FlushFilterTimer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,c){if(!a)throw new Error("Reference to the pluginManager object cannot be NULL");if(!b)throw new Error("Reference to the channel object cannot be NULL");if(!c)throw new Error("Reference to the logger object cannot be NULL");this._isDestroyed=!1,this._reportingTimer=new f(a,b,c),this._checkStatusTimer=new d(a,b,c),this._flushFilterTimer=new e(a,b,c),this._idleTimer=new g(a,b,c)}var d=b.clock.CheckStatusTimer,e=b.clock.FlushFilterTimer,f=b.clock.ReportingTimer,g=b.clock.IdleTimer;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._reportingTimer.destroy(),this._checkStatusTimer.destroy(),this._flushFilterTimer.destroy(),this._idleTimer.destroy())},b.clock.Clock=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){this.value=a,this.hint=b}function d(a){this.realm=a,this.data={}}c.HINT_SHORT="short",d.prototype.setField=function(a,b,d){this.data[a]=new c(b,d)},d.prototype._createAccessor=function(a,b,c){var d=this;return function(){return arguments.length&&(d[a]=arguments[0],d.setField(b,arguments[0],c)),d[a]}},b.model.Dao=d,b.model.DaoField=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"asset"),this.adId=this._createAccessor("_adId","ad_id",null),this.sid=this._createAccessor("_sid","ad_sid",null),this.resolver=this._createAccessor("_resolver","resolver",null),this.podId=this._createAccessor("_podId","pod_id",null),this.podPosition=this._createAccessor("_podPosition","pod_position",null),this.podOffset=this._createAccessor("_podOffset","pod_offset",null),this.podName=this._createAccessor("_podName","pod_name",null),this.adLength=this._createAccessor("_adLength","ad_length",null),this.adName=this._createAccessor("_adName","ad_name",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.adId(a.adId()),this.sid(a.sid()),this.resolver(a.resolver()),this.podId(a.podId()),this.podPosition(a.podPosition()),this.podOffset(a.podOffset()),this.podName(a.podName()),this.adLength(a.adLength()),this.adName(a.adName())}else this.adId(""),this.sid(""),this.resolver(""),this.podId(""),this.podPosition(""),this.podOffset(0),this.podName(""),this.adLength(0),this.adName("")}var d=b.model.Dao;a.extend(c,d),b.model.AdDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"sc"),this.reportSuiteId=this._createAccessor("_reportSuiteId","rsid",null),this.trackingServer=this._createAccessor("_trackingServer","tracking_server",null),this.ssl=this._createAccessor("_ssl","ssl",e.HINT_SHORT),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.reportSuiteId(a.reportSuiteId()),this.trackingServer(a.trackingServer()),this.ssl(a.ssl())}else this.reportSuiteId(""),this.trackingServer(""),this.ssl(0)}var d=b.model.Dao,e=b.model.DaoField;a.extend(c,d),b.model.AdobeAnalyticsDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.id=this._createAccessor("_id","chapter_id",null),this.sid=this._createAccessor("_sid","chapter_sid",null),this.name=this._createAccessor("_name","chapter_name",null),this.position=this._createAccessor("_position","chapter_pos",null),this.length=this._createAccessor("_length","chapter_length",null),this.offset=this._createAccessor("_offset","chapter_offset",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.id(a.id()),this.sid(a.sid()),this.name(a.name()),this.position(a.position()),this.length(a.length()),this.offset(a.offset())}else this.id(""),this.sid(""),this.name(""),this.position(0),this.length(0),this.offset(0)}var d=b.model.Dao;a.extend(c,d),b.model.ChapterDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"asset"),this.type=this._createAccessor("_type","type",null),this.videoId=this._createAccessor("_videoId","video_id",null),this.publisher=this._createAccessor("_publisher","publisher",null),this.adData=this._createAccessor("_adData","ad_data",null),this.chapterData=this._createAccessor("_chapterData","chapter_data",null),this.length=this._createAccessor("_length","length",null),this.name=this._createAccessor("_name","name",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type()),this.name(a.name()),this.videoId(a.videoId()),this.publisher(a.publisher()),this.length(a.length());var b=a.adData()?new e(a.adData()):null;this.adData(b);var d=a.chapterData()?new f(a.chapterData()):null;this.chapterData(d)}else this.type(""),this.name(""),this.videoId(""),this.publisher(""),this.length(0),this.adData(null),this.chapterData(null)}var d=b.model.Dao,e=b.model.AdDao,f=b.model.ChapterDao;a.extend(c,d),c.TYPE_AD="ad",c.TYPE_MAIN_CONTENT="main",b.model.AssetDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"event"),this.type=this._createAccessor("_type","type",null),this.duration=this._createAccessor("_duration","duration",null),this.playhead=this._createAccessor("_playhead","playhead",null),this.id=this._createAccessor("_id","id",null),this.source=this._createAccessor("_source","source",null),this.ts=this._createAccessor("_ts","ts",null),this.prevTs=this._createAccessor("_prevTs","prev_ts",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type()),this.duration(a.duration()),this.playhead(a.playhead()),this.id(a.id()),this.source(a.source()),this.ts(a.ts()),this.prevTs(a.prevTs())}else this.type(""),this.duration(0),this.playhead(0),this.id(""),this.source(""),this.ts(0),this.prevTs(-1)}var d=b.model.Dao;a.extend(c,d),c.EVENT_TYPE_AA_START="aa_start",c.EVENT_TYPE_AA_AD_START="aa_ad_start",c.EVENT_TYPE_START="start",c.EVENT_TYPE_RESUME="resume",c.EVENT_TYPE_CHAPTER_START="chapter_start",c.EVENT_TYPE_CHAPTER_COMPLETE="chapter_complete",c.EVENT_TYPE_PLAY="play",c.EVENT_TYPE_PAUSE="pause",c.EVENT_TYPE_STALL="stall",c.EVENT_TYPE_BUFFER="buffer",c.EVENT_TYPE_BITRATE_CHANGE="bitrate_change",c.EVENT_TYPE_ERROR="error",c.EVENT_TYPE_COMPLETE="complete",b.model.EventDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.bitrate=this._createAccessor("_bitrate","bitrate",null),this.fps=this._createAccessor("_fps","fps",null),this.droppedFrames=this._createAccessor("_droppedFrames","dropped_frames",null),this.startupTime=this._createAccessor("_startup_time","startup_time",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.bitrate(a.bitrate()),this.fps(a.fps()),this.droppedFrames(a.droppedFrames()),this.startupTime(a.startupTime()),this.isStartupTimeOverridden=a.isStartupTimeOverridden}else this.bitrate(0),this.fps(0),this.droppedFrames(0),this.startupTime(0),this.isStartupTimeOverridden=!1}var d=b.model.Dao;a.extend(c,d),b.model.QoSDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"sp"),this.ovp=this._createAccessor("_ovp","ovp",null),this.sdk=this._createAccessor("_sdk","sdk",null),this.channel=this._createAccessor("_channel","channel",null),this.playerName=this._createAccessor("_playerName","player_name",null),this.libVersion=this._createAccessor("_libVersion","hb_version",null),this.apiLevel=this._createAccessor("_apiLevel","hb_api_lvl",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.ovp(a.ovp()),this.sdk(a.sdk()),this.channel(a.channel()),this.playerName(a.playerName()),this.libVersion(a.libVersion()),this.apiLevel(a.apiLevel())}else this.ovp(e),this.sdk(e),this.channel(e),this.playerName(""),this.libVersion(""),this.apiLevel(0)}var d=b.model.Dao;a.extend(c,d);var e="unknown";b.model.ServiceProviderDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"event"),this.sessionId=this._createAccessor("_sessionId","sid",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.sessionId(a.sessionId())}else this.sessionId(null)}var d=b.model.Dao;a.extend(c,d),b.model.SessionDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"stream"),this.type=this._createAccessor("_type","type",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.type(a.type())}else this.type(null)}var d=b.model.Dao;a.extend(c,d),b.model.StreamDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"user"),this.analyticsVisitorId=this._createAccessor("_analyticsVisitorId","aid",null),this.marketingCloudVisitorId=this._createAccessor("_marketingCloudVisitorId","mid",null),this.visitorId=this._createAccessor("_visitorId","id",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.analyticsVisitorId(a.analyticsVisitorId()),this.marketingCloudVisitorId(a.marketingCloudVisitorId()),this.visitorId(a.visitorId())}else this.analyticsVisitorId(null),this.marketingCloudVisitorId(null),this.visitorId(null)}var d=b.model.Dao;a.extend(c,d),b.model.UserDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(){if(c.__super__.constructor.call(this,"aam"),this.audienceManagerBlob=this._createAccessor("_audienceManagerBlob","blob",null),this.audienceManagerLocationHint=this._createAccessor("_audienceManagerLocationHint","loc_hint",null),arguments.length&&arguments[0]instanceof c){var a=arguments[0];this.audienceManagerBlob(a.audienceManagerBlob()),this.audienceManagerLocationHint(a.audienceManagerLocationHint())}else this.audienceManagerBlob(null),this.audienceManagerLocationHint(null)}var d=b.model.Dao;a.extend(c,d),b.model.AudienceManagerDao=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b,c,i,j){this.eventData=new e,this.eventData.type(b),this.eventData.duration(0),this.eventData.ts((new Date).getTime()),this.eventData.playhead(c),this.assetData=new f(a._assetData),this.streamData=new g(a._streamData),this.qosData=new h(a._qosData),this.cuserData=d.clone(a._cuserData),this.meta=i,this.callback=j,this.filterReport=!0}var d=a.ObjectUtils,e=b.model.EventDao,f=b.model.AssetDao,g=b.model.StreamDao,h=b.model.QoSDao;b.model.TrackItem=c}(a.ADB.va.utils,b),function(a,b){"use strict";function c(a,b,c,i,j,k){this.adobeAnalyticsData=a,this.userData=b,this.aamData=c,this.serviceProviderData=i,this.sessionData=j,this.eventData=new e(k.eventData),this.assetData=new f(k.assetData),this.streamData=new g(k.streamData),this.qosData=new h(k.qosData),this.cuserData=d.clone(k.cuserData),this.meta=d.clone(k.meta),this.callback=k.callback,this.filterReport=k.filterReport}var d=a.ObjectUtils,e=b.model.EventDao,f=b.model.AssetDao,g=b.model.StreamDao,h=b.model.QoSDao;b.model.CUserDao;b.model.Report=c}(a.ADB.va.utils,b),function(a){"use strict";function b(){}b.prototype.serializeReport=function(a){},b.prototype.serializeDao=function(a){},b.prototype.serializeMap=function(a){},b.prototype.serializeNumber=function(a,b,c,d){},b.prototype.serializeString=function(a,b,c,d){},a.model.ISerializer=b}(b),function(a,b){"use strict";function c(a){if(!a)throw new Error("Reference to the logger object cannot be NULL");this._logger=a}var d=b.model.Dao,e=b.model.DaoField,f=b.model.ISerializer;a.extend(c,f),c.prototype.serializeReport=function(a){var b=[];return b.push(this.serializeDao(a.adobeAnalyticsData)),b.push(this.serializeDao(a.userData)),b.push(this.serializeDao(a.aamData)),b.push(this.serializeMap(a.cuserData,"cuser")),b.push(this.serializeDao(a.serviceProviderData)),b.push(this.serializeDao(a.sessionData)),b.push(this.serializeDao(a.eventData)),b.push(this.serializeDao(a.assetData)),b.push(this.serializeDao(a.streamData)),b.push(this.serializeDao(a.qosData)),b.push(this.serializeMap(a.meta,"meta")),{serializedOutput:b.filter(function(a){return!!a}).join("&"),callback:a.callback}},c.prototype.serializeDao=function(a){var b=this._processDao(a);return b.filter(function(a){return!!a}).join("&")},c.prototype.serializeMap=function(a,b){var c=[],d=b?b:"meta";for(var e in a)a.hasOwnProperty(e)&&a[e]&&c.push("s:"+d+":"+e+"="+window.encodeURIComponent(a[e]));return c.join("&")},c.prototype.serializeNumber=function(a,b,c,d){var f=h;return null==b||isNaN(b)?null:(d===e.HINT_SHORT&&(f=i),f+":"+c+":"+a+"="+Math.floor(b))},c.prototype.serializeString=function(a,b,c,d){return b?j+":"+c+":"+a+"="+window.encodeURIComponent(b):null},c.prototype._processDao=function(a){var b=[];for(var c in a.data)if(a.data.hasOwnProperty(c)){var e=a.data[c],f=e.value,h=e.hint,i=null,j=a.realm;if(null==f)continue;"number"==typeof f?i=this.serializeNumber(c,f,j,h):"string"==typeof f?i=this.serializeString(c,f,j,h):f instanceof d?i=this.serializeDao(f):this._logger.warn(g,"#_processDao() > Unable to serialize DAO. Field: "+c+". Value: "+f+"."),i&&b.push(i)}return b};var g="ah::QuerystringSerializer",h="l",i="h",j="s";b.model.QuerystringSerializer=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(!a)throw new Error("Reference to the data object cannot be NULL");if(this._data=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b}c.prototype.parse=function(){var a,b,c,i,j;if(window.DOMParser){var k=new window.DOMParser;j=k.parseFromString(this._data,"text/xml")}else j=new window.ActiveXObject("Microsoft.XMLDOM"),j.async=!1,j.loadXML(this._data);var l;l=parseInt(j.getElementsByTagName("trackingInterval")[0].childNodes[0].nodeValue,10),l&&(a=l),l=parseInt(j.getElementsByTagName("setupCheckInterval")[0].childNodes[0].nodeValue,10),l&&(b=l),l=parseInt(j.getElementsByTagName("trackExternalErrors")[0].childNodes[0].nodeValue,10),l&&(c=1==l),j.getElementsByTagName("nielsenEnabled")[0]?(l=parseInt(j.getElementsByTagName("nielsenEnabled")[0].childNodes[0].nodeValue,10),i=1==l):i=!0;var m={};return m[e]=a,m[f]=b,m[g]=c,m[h]=i,this._logger.debug(d,"#parse() > Obtained configuration settings."),m};var d="ah::SettingsParser",e="reporting_interval",f="check_status_interval",g="track_external_errors",h="nielsen_enabled";b.network.SettingsParser=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(this._trackingServer=null,this._checkStatusServer=null,this._publisher=null,this._isConfigured=!1,this._isDestroyed=!1,this._quietMode=!1,this._visitorOptedOut=!1,this._prevReportSent=null,!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._serializer=new i(b),this._installEventListeners()}var d=a.Event,e=a.URLRequestMethod,f=a.URLRequest,g=a.URLLoader,h=b.network.SettingsParser,i=b.model.QuerystringSerializer;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(j,"#destroy()"),this._uninstallEventListeners())},c.prototype._onApiConfig=function(a){var b=a.data;this._logger.debug(j,"#_onApiConfig(sb_server="+b[k]+", check_status_server="+b[l]+", publisher="+b[m]+", quiet_mode="+b[n]+", ssl="+b[o]+")"),this._trackingServer=this._updateRequestProtocol(b[k],b[o]),this._checkStatusServer=this._updateRequestProtocol(b[l],b[o]),this._publisher=b[m],this._quietMode=b[n],this._isConfigured=!0},c.prototype._onUpdateVisitorOptOut=function(a){var b=a.data;this._logger.debug(j,"#_onUpdateVisitorOptOut(visitor_opt_out="+b[q]+")"),this._visitorOptedOut=b[q]},c.prototype._onFilterReportAvailable=function(a){var b=a.data;if(!this._isConfigured)return void this._logger.warn(j,"#_onFilterReportAvailable() > Unable to send request: not configured.");var c=b[p],h=this._serializer.serializeReport(c),i=this._trackingServer+"/?"+h.serializedOutput;if(this._prevReportSent&&this._prevReportSent.eventData&&c.eventData&&this._prevReportSent.eventData.playhead==c.eventData.playhead&&this._prevReportSent.eventData.ts==c.eventData.ts&&this._prevReportSent.eventData.prevTs==c.eventData.prevTs&&this._prevReportSent.eventData.type==c.eventData.type)return void this._logger.debug(j,"#_onFilterReportAvailable() > Duplicate heartbeat report not sent for URL:\n"+i);this._prevReportSent=c;var k=new f(i,e.GET);this._logger.debug(j,"#_onFilterReportAvailable() > "+k.url);var l=this,m=function(a){o.close(),h.callback&&h.callback.call(null)},n=function(a){o.close(),l._logger.warn(j,"#_onFilterReportAvailable() > Failed to send heartbeat report."),h.callback&&h.callback.call(null)};if(!this._quietMode&&!this._visitorOptedOut){var o=new g;o.addEventListener(d.SUCCESS,m,this),o.addEventListener(d.ERROR,n,this),o.load(k)}},c.prototype._onClockCheckStatusTick=function(a){function b(a){if(a.data){var b=new h(a.data.response,i._logger),c=b.parse();c?i._channel.trigger(new d(v,c)):i._logger.warn(j,"#_onClockCheckStatusTick() > Failed to parse the config. settings.")}n.close()}function c(a){i._logger.warn(j,"#_onClockCheckStatusTick() > Failed to obtain the config. settings."),n.close()}if(!this._isConfigured)return void this._logger.warn(j,"#_onClockCheckStatusTick() > Unable to send request: not configured.");if(!this._publisher)return void this._logger.warn(j,"#_onClockCheckStatusTick() > Publisher is NULL.");var i=this,k=this._publisher.replace(/[^a-zA-Z0-9]+/,"-").toLocaleLowerCase(),l=this._checkStatusServer+k+".xml?r="+(new Date).getTime(),m=new f(l,e.GET),n=new g;n.addEventListener(d.SUCCESS,b,this),n.addEventListener(d.ERROR,c,this),this._logger.debug(j,"#_onClockCheckStatusTick() > Get new settings from: "+l),n.load(m)},c.prototype._updateRequestProtocol=function(a,b){var c=a;return 0===c.indexOf("http://")?c=c.slice(7):0===c.indexOf("https://")&&(c=c.slice(8)),b?"https://"+c:"http://"+c},c.prototype._installEventListeners=function(){this._channel.on(r,this._onApiConfig,this),this._channel.on(s,this._onUpdateVisitorOptOut,this),this._channel.on(t,this._onFilterReportAvailable,this),this._channel.on(u,this._onClockCheckStatusTick,this)},c.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)};var j="ah::Network",k="tracking_server",l="check_status_server",m="publisher",n="quiet_mode",o="ssl",p="report",q="visitor_opt_out",r="api:config",s="api:update_visitor_optout",t="filter:data_available",u="clock:check_status.tick",v="net:check_status_complete";b.network.Network=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){if(!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._isDestroyed=!1,this._isBufferingInProgress=!1,this._reportBuffer={},this._tsHistory={},this._workQueue=new i,this._installEventListeners()}function d(a){var b=[];return a&&a.forEach(function(a){a.eventData.type()==k.EVENT_TYPE_PAUSE||a.eventData.type()==k.EVENT_TYPE_STALL?(!a.filterReport||a.eventData.duration()>u)&&b.push(a):b.push(a)}),b}function e(a){var b=-1,c=-1,d=[];return a.forEach(function(a){a.eventData.type()==k.EVENT_TYPE_START?a.assetData.type()==l.TYPE_MAIN_CONTENT?b==-1?b=d.push(a)-1:(a.eventData.prevTs(-1),d[b]=a):c==-1?c=d.push(a)-1:(a.eventData.prevTs(-1),d[c]=a):d.push(a)}),d}function f(a){var b=[];return a.forEach(function(c){if(c.eventData.type()==k.EVENT_TYPE_PLAY){if(c.eventData.duration()>t)b.push(c);else if(0==c.eventData.duration()&&c.assetData.type()==l.TYPE_MAIN_CONTENT){var d=g(a);d.indexOf(c)==d.length-1&&b.push(c)}}else b.push(c)}),b}function g(a){var b=[];return a.forEach(function(a){a.eventData.type()!=k.EVENT_TYPE_PLAY&&a.eventData.type()!=k.EVENT_TYPE_BUFFER&&a.eventData.type()!=k.EVENT_TYPE_START||b.push(a)}),b}var h=a.radio.Command,i=a.radio.CommandQueue,j=a.Event,k=b.model.EventDao,l=b.model.AssetDao;c.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(w,"#destroy()"),this._uninstallEventListeners(),this.clear())},c.prototype.clear=function(){this._logger.debug(w,"#clear()"),this._workQueue.cancelAllCommands(),this._reportBuffer={},this._tsHistory={},this._isBufferingInProgress=!1},c.prototype.flush=function(){this._workQueue.addCommand(new h(this._flushBufferReport,this))},c.prototype._bufferReport=function(a){if(!this._isDestroyed){var b=a[q];if(b){var c=b.sessionData.sessionId();this._reportBuffer[c]=this._reportBuffer[c]||[],this._reportBuffer[c].push(b)}if(!this._isBufferingInProgress){this._isBufferingInProgress=!0;var d={};d[p]=!0,d[r]=1,this._channel.command(s,d)}}},c.prototype._flushBufferReport=function(){function a(a){if(a)for(var c=0;c<a.length;c++){var d=a[c],e=d.sessionData.sessionId();b._tsHistory[e]=b._tsHistory[e]||{};var f=d.eventData.type()+"."+(d.assetData.type()==l.TYPE_AD?d.assetData.adData().adId():d.assetData.videoId());b._tsHistory[e].hasOwnProperty(f)&&d.eventData.prevTs(b._tsHistory[e][f]),b._tsHistory[e][f]=d.eventData.ts()}}if(!this._isDestroyed){var b=this;for(var c in this._reportBuffer)if(this._reportBuffer.hasOwnProperty(c)){var g=f(e(d(this._reportBuffer[c])));a(g);for(var h=0;h<g.length;h++){var i=g[h],k={};k[q]=i,this._channel.trigger(new j(n,k))}}this._reportBuffer={};var m=this._channel.request(v),o=this._tsHistory[m]||{};this._tsHistory={},this._tsHistory[m]=o,this._isBufferingInProgress=!1}},c.prototype._onContextReportAvailable=function(a){var b=a.data;this._workQueue.addCommand(new h(this._bufferReport,this,[b]))},c.prototype._onClockFlushFilterTick=function(a){this.flush()},c.prototype._installEventListeners=function(){this._channel.on(m,this._onContextReportAvailable,this),this._channel.on(o,this._onClockFlushFilterTick,this)},c.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)};var m="context:report_available",n="filter:data_available",o="clock:flush_filter.tick",p="reset",q="report",r="repeat_count",s="clock:flush_filter.resume",t=250,u=250,v="session_id",w="ah::ReportFilter";b.filter.ReportFilter=c}(a.ADB.core,b),function(a,b){"use strict";function c(a,b){this._onFail={fn:a,ctx:b}}var d=a.ErrorInfo;c.prototype.validateFields=function(a,b){if(!a)return this._fail("Data cannot be null");if(b)for(var c=0;c<b.length;c++){var d=b[c];switch(d){case"videoId":if(!a.hasOwnProperty("videoId"))return this._fail("The ID for the main video must be specified.");if("string"!=typeof a.videoId)return this._fail("The ID for the main video must be a String.");if(""===a.videoId)return this._fail("The ID for the main video cannot be an empty string.");break;case"streamType":if(!a.hasOwnProperty("streamType"))return this._fail("The stream type for the main video must be specified.");if("string"!=typeof a.streamType)return this._fail("The stream type for the main video must be a String.");if(""===a.streamType)return this._fail("The stream type for the main video cannot be an empty string.");break;case"videoLength":if(!a.hasOwnProperty("videoLength"))return this._fail("The length of the main video must be specified.");if("number"!=typeof a.videoLength)return this._fail("The length of the main video must be a Number.");if(isNaN(a.videoLength))return this._fail("The length of the main video cannot be NaN.");break;case"playhead":if(!a.hasOwnProperty("playhead"))return this._fail("The playhead for the main video must be specified.");if("number"!=typeof a.playhead)return this._fail("The playhead for the main video must be a Number.");if(isNaN(a.playhead))return this._fail("The playhead for the main video cannot be NaN.");break;case"playerName":if(!a.hasOwnProperty("playerName"))return this._fail("The player name for the main video must be specified.");if("string"!=typeof a.playerName)return this._fail("The player name for the main video must be a String.");if(""===a.playerName)return this._fail("The player name for the main video cannot be an empty string.");break;case"rsid":if(!a.hasOwnProperty("rsid"))return this._fail("account (rsid) is required and has to be set in the AppMeasurement instance.");if("string"!=typeof a.rsid)return this._fail("account (rsid) of the AppMeasurement instance must be a String.");if(""===a.rsid)return this._fail("account (rsid) of the AppMeasurement instance  cannot be an empty string.");break;case"trackingServer":if(!a.hasOwnProperty("trackingServer"))return this._fail("trackingServer is required and has to be set in the AppMeasurement instance.");if("string"!=typeof a.trackingServer)return this._fail("trackingServer of the AppMeasurement instance must be a String.");if(""===a.trackingServer)return this._fail("trackingServer of the AppMeasurement instance cannot be an empty string.");break;case"podPlayerName":if(!a.hasOwnProperty("podPlayerName"))return this._fail("The player name for the ad-break must be specified.");if("string"!=typeof a.podPlayerName)return this._fail("The player name for the ad-break must be a String.");if(""===a.podPlayerName)return this._fail("The player name for the ad-break cannot be an empty string.");break;case"podPosition":if(!a.hasOwnProperty("podPosition"))return this._fail("Position (index) of the ad-break must be specified.");if("number"!=typeof a.podPosition)return this._fail("Position (index) of the ad-break must be a Number.");if(isNaN(a.podPosition))return this._fail("Position (index) of the ad-break cannot be NaN.");break;case"adId":if(!a.hasOwnProperty("adId"))return this._fail("The ad ID must be specified.");if("string"!=typeof a.adId)return this._fail("The ad ID must be a String.");if(""===a.adId)return this._fail("The ad ID cannot be an empty string.");break;case"adPosition":if(!a.hasOwnProperty("adPosition"))return this._fail("Position (index) of the ad must be specified.");if("number"!=typeof a.adPosition)return this._fail("Position (index) of the ad must be a Number.");if(isNaN(a.adPosition))return this._fail("Position (index) of the ad cannot be NaN.");break;case"chapterPosition":if(!a.hasOwnProperty("chapterPosition"))return this._fail("Position (index) of the chapter must be specified.");if("number"!=typeof a.chapterPosition)return this._fail("Position (index) of the chapter must be a Number.");if(isNaN(a.chapterPosition))return this._fail("Position (index) of the chapter cannot be NaN.");break;case"chapterOffset":if(!a.hasOwnProperty("chapterOffset"))return this._fail("Chapter start-time (offset) must be specified.");if("number"!=typeof a.chapterOffset)return this._fail("Chapter start-time (offset) must be a Number.");if(isNaN(a.chapterOffset))return this._fail("Chapter start-time (offset) cannot be NaN.");break;case"chapterLength":if(!a.hasOwnProperty("chapterLength"))return this._fail("The length of the chapter must be specified.");if("number"!=typeof a.chapterLength)return this._fail("The length of the chapter must be a Number.");if(isNaN(a.chapterLength))return this._fail("The length of the chapter cannot be NaN.");break;default:return this._fail("Unable to validate unknown parameter: "+d)}}return!0},c.prototype._fail=function(a){var b=new d("Invalid input data",a);return this._onFail.fn&&this._onFail.fn.call(this._onFail.ctx,b),!1},b.context.InputDataValidator=c}(a.ADB.va,b),function(a,b){"use strict";function c(a,b){if(!b)throw new Error("Reference to the logger object cannot be NULL");if(this._logger=b,!a)throw new Error("Reference to the context object cannot be NULL");this._context=a}var d=b.model.Report;
	c.prototype.createReportForItem=function(a){return this._logger.debug(e,"Creating report for item: "+a.eventData.type()),new d(this._context._adobeAnalyticsData,this._context._userData,this._context._aamData,this._context._serviceProviderData,this._context._sessionData,a)};var e="ah::ReportFactory";b.context.ReportFactory=c}(a.ADB.core,b),function(a,b,c,d){"use strict";function e(a,b){if(!a)throw new Error("Reference to the channel object cannot be NULL");if(this._channel=a,!b)throw new Error("Reference to the logger object cannot be NULL");this._logger=b,this._lastInBandItem=null,this._autoComputedStartupTime=0,this._reportingInterval=fa,this._assetData=null,this._streamData=null,this._qosData=null,this._sessionData=null,this._cuserData=null,this._adobeAnalyticsData=new j,this._serviceProviderData=new k,this._userData=new l,this._aamData=new m,this._isTrackingSessionActive=!1,this._isVideoComplete=!1,this._activeAssetId=null,this._isDestroyed=!1,this._doNotOverrideEventDuration=!1,this._reportFactory=new u(this,this._logger),this._inputDataValidator=new v(function(a){this._logger.error(w,a.getMessage()+" | "+a.getDetails()),this._channel.trigger(new h(y,a))},this),this._stashedChapterData=null,this._stashedAdData=null,this._trackExternalErrors=!0,this._installEventListeners()}var f=c.md5,g=c.ObjectUtils,h=a.Event,i=d.model.SessionDao,j=d.model.AdobeAnalyticsDao,k=d.model.ServiceProviderDao,l=d.model.UserDao,m=d.model.AudienceManagerDao,n=d.model.EventDao,o=d.model.AssetDao,p=d.model.StreamDao,q=d.model.QoSDao,r=d.model.AdDao,s=d.model.ChapterDao,t=d.model.TrackItem,u=d.context.ReportFactory,v=d.context.InputDataValidator;e.prototype.destroy=function(){this._isDestroyed||(this._isDestroyed=!0,this._logger.debug(w,"#destroy()"),this._uninstallEventListeners())},e.prototype._onApiAnalyticsStart=function(a){this._logger.debug(w,"#_onApiAnalyticsStart()");var b=a.data;if(this._checkCall("_onApiAnalyticsStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._userData.visitorId(b.vid),this._userData.analyticsVisitorId(b.aid),this._userData.marketingCloudVisitorId(b.mid),this._aamData.audienceManagerBlob(b.blob),this._aamData.audienceManagerLocationHint(b.loc_hint),b.customerIDs&&(this._cuserData=b.customerIDs),this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_AA_START,b.playhead,null,b._eventData[E]);c.assetData.adData(null),c.assetData.type(o.TYPE_MAIN_CONTENT),this._cuserData=null,this._sendHit(c)}},e.prototype._onApiAnalyticsAdStart=function(a){this._logger.debug(w,"#_onApiAnalyticsAdStart()");var b=a.data;if(this._checkCall("_onApiAnalyticsAdStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_AA_AD_START,b.playhead,null,b._eventData[E]);this._sendHit(c)}},e.prototype._onApiVideoLoad=function(a){var b=a.data;this._logger.debug(w,"#_onApiVideoLoad(rsid="+b.rsid+", aa_trackingServer="+b.trackingServer+")"),this._resetInternalState(),this._inputDataValidator.validateFields(b,["rsid","trackingServer"])&&(this._sessionData.sessionId(this._generateSessionId()),this._isTrackingSessionActive=!0)},e.prototype._onApiVideoUnload=function(a){return this._logger.debug(w,"#_onApiVideoUnload()"),this._isTrackingSessionActive?void(this._isTrackingSessionActive=!1):void this._logger.debug(w,"#_onApiVideoUnload() > No active tracking session.")},e.prototype._onApiVideoStart=function(a){var b=a.data;if(this._logger.debug(w,"#_onApiVideoStart(id="+b.videoId+", name="+b.videoName+", length="+b.videoLength+", type="+b.streamType+", playerName="+b.playerName+")"),this._checkCall("_onApiVideoStart")&&this._inputDataValidator.validateFields(b,["videoId","streamType","videoLength","playhead","playerName"])){this._adobeAnalyticsData.reportSuiteId(b.rsid),this._adobeAnalyticsData.trackingServer(b.trackingServer),this._adobeAnalyticsData.ssl(Number(b.useSsl)),this._serviceProviderData.ovp(b.ovp),this._serviceProviderData.sdk(b.sdk),this._serviceProviderData.channel(b.channel),this._serviceProviderData.libVersion(b.version),this._serviceProviderData.apiLevel(b.apiLvl),this._activeAssetId=b.videoId,this._serviceProviderData.playerName(b.playerName),this._assetData.videoId(this._activeAssetId),this._assetData.length(b.videoLength),this._assetData.type(o.TYPE_MAIN_CONTENT),this._assetData.publisher(b.publisher),this._assetData.name(b.videoName),this._streamData.type(b.streamType),this._updateQoSInfo(b);var c=b.metaNielsen?g.merge(b.metaVideo,b.metaNielsen):b.metaVideo,d=new t(this,n.EVENT_TYPE_START,b.playhead,c,b._eventData[E]);this._sendHit(d)}},e.prototype._onApiVideoResume=function(a){var b=a.data;if(this._logger.debug(w,"#_onApiVideoResume(id="+b.videoId+", name="+b.videoName+", length="+b.videoLength+", type="+b.streamType+", playerName="+b.playerName+")"),this._checkCall("_onApiVideoResume")&&this._inputDataValidator.validateFields(b,["videoId","streamType","videoLength","playhead","playerName"])){this._activeAssetId=b.videoId,this._assetData.videoId(this._activeAssetId),this._assetData.length(b.videoLength),this._assetData.type(o.TYPE_MAIN_CONTENT),this._assetData.name(b.videoName),this._streamData.type(b.streamType);var c=new t(this,n.EVENT_TYPE_RESUME,b.playhead,null,b._eventData[E]);this._sendHit(c)}},e.prototype._onApiVideoComplete=function(a){this._logger.debug(w,"#_onApiVideoComplete()");var b=a.data;if(this._checkCall("_onApiVideoComplete")){var c=new t(this,n.EVENT_TYPE_COMPLETE,this._assetData.length(),null,b._eventData[E]);this._sendHit(c),this._isVideoComplete=!0}},e.prototype._onApiPlay=function(a){this._logger.debug(w,"#_onApiPlay()");var b=a.data;if(this._checkCall("_onApiPlay")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_PLAY,b.playhead,null,b._eventData[E]);this._sendHit(c)}},e.prototype._onApiPause=function(a){this._logger.debug(w,"#_onApiPause()");var b=a.data;if(this._checkCall("_onApiPause")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=b.playheadStalled?n.EVENT_TYPE_STALL:n.EVENT_TYPE_PAUSE,d=new t(this,c,b.playhead,null,b._eventData[E]);b._eventData.hasOwnProperty(F)&&(d.filterReport=b._eventData[F]),this._sendHit(d)}},e.prototype._onApiBufferStart=function(a){this._logger.debug(w,"#_onApiBufferStart()");var b=a.data;if(this._checkCall("_onApiBufferStart")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_BUFFER,b.playhead,null,b._eventData[E]);this._sendHit(c)}},e.prototype._onApiSeekStart=function(a){this._logger.debug(w,"#_onApiSeekStart()"),this._checkCall("_onApiSeekStart")&&(this._stashedAdData=this._assetData.adData(),this._stashedChapterData=this._assetData.chapterData(),this._assetData.adData(null),this._assetData.type(o.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId(),this._assetData.chapterData(null))},e.prototype._onApiSeekComplete=function(a){this._logger.debug(w,"#_onApiSeekComplete()");var b=a.data;if(this._checkCall("_onApiSeekComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(b.isInAd){if(!this._inputDataValidator.validateFields(b,["adId","adPosition","podPosition","podPlayerName"]))return;var c=f(this._assetData.videoId())+"_"+b.podPosition;if(this._stashedAdData&&this._stashedAdData.podId()==c&&parseInt(this._stashedAdData.podPosition(),10)==b.adPosition)this._assetData.adData(this._stashedAdData),this._activeAssetId=this._stashedAdData.adId();else if(!this._assetData.adData()){this._activeAssetId=b.adId;var d=new r;d.adId(this._activeAssetId),d.adName(b.adName),d.adLength(b.adLength),d.podId(c),d.resolver(b.podPlayerName),d.podPosition(b.podPosition+""),d.podName(b.podName),d.podOffset(b.podSecond),d.sid(this._generateSessionId()),this._assetData.adData(d)}this._assetData.type(o.TYPE_AD)}else this._assetData.adData(null),this._assetData.type(o.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId();if(b.isInChapter){if(!this._inputDataValidator.validateFields(b,["chapterPosition","chapterLength","chapterOffset"]))return;if(this._stashedChapterData&&b.chapterPosition==this._stashedChapterData.position())this._assetData.chapterData(this._stashedChapterData);else if(!this._assetData.chapterData()){var e=new s;e.id(f(this._assetData.videoId())+"_"+b.chapterPosition),e.name(b.chapterName),e.length(b.chapterLength),e.position(b.chapterPosition),e.offset(b.chapterOffset),e.sid(this._generateSessionId()),this._assetData.chapterData(e)}}else this._assetData.chapterData(null);this._stashedAdData=null,this._stashedChapterData=null}},e.prototype._onApiAdStart=function(a){var b=a.data;if(this._logger.debug(w,"#_onApiAdStart(id="+b.adId+", player_name="+b.podPlayerName+", parent_name="+this._assetData.videoId()+", pod_pos="+b.adPosition+")"),this._checkCall("_onApiAdStart")&&this._inputDataValidator.validateFields(b,["playhead","podPosition","podPlayerName","adId","adPosition"])){this._activeAssetId=b.adId;var c=new r;c.adId(this._activeAssetId),c.adName(b.adName),c.adLength(b.adLength),c.resolver(b.podPlayerName),c.podId(f(this._assetData.videoId())+"_"+b.podPosition),c.podPosition(b.adPosition+""),c.podName(b.podName),c.podOffset(b.podSecond),c.sid(this._generateSessionId()),this._assetData.adData(c),this._assetData.type(o.TYPE_AD),this._updateQoSInfo(b);var d=g.merge(b.metaVideo,b.metaAd);d=b.metaNielsen?g.merge(d,b.metaNielsen):d;var e=new t(this,n.EVENT_TYPE_START,b.playhead,d,b._eventData[E]);this._sendHit(e)}},e.prototype._onApiAdComplete=function(a){this._logger.debug(w,"#_onApiAdComplete()");var b=a.data;if(this._checkCall("_onApiAdComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(this._assetData.type()!=o.TYPE_AD)return void this._logger.warn(w,"#_onApiAdComplete() > Ignoring the ad complete event, because we are no longer in an ad.");this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_COMPLETE,b.playhead,null,b._eventData[E]);this._sendHit(c),this._assetData.adData(null),this._assetData.type(o.TYPE_MAIN_CONTENT),this._activeAssetId=this._assetData.videoId()}},e.prototype._onApiChapterStart=function(a){var b=a.data;if(this._logger.debug(w,"#_onApiChapterStart(name="+b.chapterName+", length="+b.chapterLength+", position="+b.chapterPosition+", chapter_offset="+b.chapterOffset+")"),this._checkCall("_onApiChapterStart")&&this._inputDataValidator.validateFields(b,["playhead","chapterPosition","chapterOffset","chapterLength"])){var c=new s;c.id(f(this._assetData.videoId())+"_"+b.chapterPosition),c.name(b.chapterName),c.length(b.chapterLength),c.position(b.chapterPosition),c.offset(b.chapterOffset),c.sid(this._generateSessionId()),this._assetData.chapterData(c),this._updateQoSInfo(b);var d=g.merge(b.metaVideo,b.metaChapter),e=new t(this,n.EVENT_TYPE_CHAPTER_START,b.playhead,d,b._eventData[E]);e.assetData.adData(null),e.assetData.type(o.TYPE_MAIN_CONTENT),this._sendHit(e)}},e.prototype._onApiChapterComplete=function(a){this._logger.debug(w,"#_onApiChapterComplete()");var b=a.data;if(this._checkCall("_onApiChapterComplete")&&this._inputDataValidator.validateFields(b,["playhead"])){if(!this._assetData.chapterData())return void this._logger.warn(w,"#_onApiChapterComplete() > Ignoring the chapter complete event, because we are no longer in a chapter.");this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_CHAPTER_COMPLETE,b.playhead,null,b._eventData[E]);c.assetData.adData(null),c.assetData.type(o.TYPE_MAIN_CONTENT),this._sendHit(c),this._assetData.chapterData(null)}},e.prototype._onApiBitrateChange=function(a){this._logger.debug(w,"#_onApiBitrateChange()");var b=a.data;if(this._checkCall("_onApiBitrateChange")&&this._inputDataValidator.validateFields(b,["playhead"])){this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_BITRATE_CHANGE,b.playhead,null,b._eventData[E]);this._sendHit(c)}},e.prototype._onApiTrackError=function(a){var b=a.data;if(this._logger.debug(w,"#_onApiTrackError(source="+b._eventData.source+", err_id="+b._eventData.error_id+")"),!this._isTrackingSessionActive)return void this._logger.warn(w,"#_onApiTrackError() > No active tracking session.");if(this._trackExternalErrors||b._eventData.source===x){this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_ERROR,0,null,b._eventData[E]);c.eventData.id(b._eventData.error_id),c.eventData.source(b._eventData.source),this._sendHit(c)}},e.prototype._onApiTrackInternalError=function(a){var b=a.data;this._logger.debug(w,"#_onApiTrackInternalError(source="+b.source+", err_id="+b.error_id+")"),this._updateQoSInfo(b);var c=new t(this,n.EVENT_TYPE_ERROR,0);c.eventData.id(b.error_id),c.eventData.source(b.source),this._sendHit(c)},e.prototype._onApiQuantumEnd=function(a){this._logger.debug(w,"#_onApiQuantumEnd(interval="+this._channel.request(B)+")");var b=a.data;this._checkCall("_onApiQuantumEnd")&&this._inputDataValidator.validateFields(b,["playhead"])&&(this._lastInBandItem&&(this._lastInBandItem.eventData.playhead(b.playhead),this._updateQoSInfo(b),this._lastInBandItem.qosData.bitrate(this._qosData.bitrate()),this._lastInBandItem.qosData.fps(this._qosData.fps()),this._lastInBandItem.qosData.droppedFrames(this._qosData.droppedFrames()),this._lastInBandItem.qosData.startupTime(this._qosData.startupTime())),this._sendHit(this._lastInBandItem))},e.prototype._onNetworkCheckStatusComplete=function(a){var b=a.data;this._trackExternalErrors=b[I],this._reportingInterval=b[J],this._reportingInterval||(this._reportingInterval=fa),this._logger.debug(w,"#_onNetworkCheckStatusComplete(track_ext_err="+this._trackExternalErrors+")")},e.prototype._onResetSessionId=function(a){var b=this._generateSessionId();this._sessionData=new i,this._sessionData.sessionId(b),this._logger.debug(w,"#_resetSessionId(new sessionId="+b+")")},e.prototype._installEventListeners=function(){this._channel.on(K,this._onApiAnalyticsStart,this),this._channel.on(L,this._onApiAnalyticsAdStart,this),this._channel.on(M,this._onApiVideoLoad,this),this._channel.on(N,this._onApiVideoUnload,this),this._channel.on(O,this._onApiVideoStart,this),this._channel.on(P,this._onApiVideoComplete,this),this._channel.on(Q,this._onApiVideoResume,this),this._channel.on(R,this._onApiAdStart,this),this._channel.on(S,this._onApiAdComplete,this),this._channel.on(T,this._onApiPlay,this),this._channel.on(U,this._onApiPause,this),this._channel.on(V,this._onApiBufferStart,this),this._channel.on(W,this._onApiSeekStart,this),this._channel.on(X,this._onApiSeekComplete,this),this._channel.on(Y,this._onApiChapterStart,this),this._channel.on(Z,this._onApiChapterComplete,this),this._channel.on(aa,this._onApiBitrateChange,this),this._channel.on($,this._onApiTrackError,this),this._channel.on(_,this._onApiTrackInternalError,this),this._channel.on(ba,this._onApiQuantumEnd,this),this._channel.on(da,this._onNetworkCheckStatusComplete,this),this._channel.on(D,this._onResetSessionId,this),this._channel.reply(C,function(){return this._sessionData&&this._sessionData.sessionId()?this._sessionData.sessionId():null},this)},e.prototype._uninstallEventListeners=function(){this._channel.off(null,null,this)},e.prototype._resetInternalState=function(){this._logger.debug(w,"#_resetInternalState()"),this._isTrackingSessionActive=!1,this._isVideoComplete=!1,this._autoComputedStartupTime=0,this._streamData=new p,this._qosData=new q,this._sessionData=new i,this._assetData=new o,this._cuserData=null,this._stashedAdData=null,this._stashedChapterData=null,this._lastInBandItem=null},e.prototype._generateSessionId=function(){return""+(new Date).getTime()+Math.floor(1e9*Math.random())},e.prototype._updateQoSInfo=function(a){this._qosData.bitrate(a.bitrate||0),this._qosData.fps(a.fps||0),this._qosData.droppedFrames(a.droppedFrames||0),null==a.startupTime||isNaN(a.startupTime)?(this._qosData.startupTime(this._autoComputedStartupTime),this._qosData.isStartupTimeOverridden=!1):(this._qosData.startupTime(a.startupTime),this._qosData.isStartupTimeOverridden=!0)},e.prototype._checkCall=function(a){return this._isTrackingSessionActive?!this._isVideoComplete||(this._logger.warn(w,"#"+a+"() > The video content already completed."),!1):(this._logger.warn(w,"#"+a+"() > No active tracking session."),!1)},e.prototype._updateLastInBandItem=function(a){var b=(new Date).getTime(),c=1e3*Math.abs(a.eventData.playhead()-this._lastInBandItem.eventData.playhead()),d=Math.abs(b-this._lastInBandItem.eventData.ts());this._lastInBandItem.eventData.type()!=n.EVENT_TYPE_PAUSE&&this._lastInBandItem.eventData.type()!=n.EVENT_TYPE_STALL?(c<=d*ea||this._doNotOverrideEventDuration)&&d<=this._reportingInterval*ea*1e3?this._lastInBandItem.eventData.duration(b-this._lastInBandItem.eventData.ts()):(this._logger.warn(w,"[WARNING] Resetting duration in lastInBandItem to 0. playheadDelta:"+c+" tsDelta:"+d+" event type:"+this._lastInBandItem.eventData.type()),this._lastInBandItem.eventData.duration(0)):this._lastInBandItem.eventData.duration(b-this._lastInBandItem.eventData.ts()),this._doNotOverrideEventDuration&&(this._doNotOverrideEventDuration=!1),this._lastInBandItem.eventData.ts(b),this._lastInBandItem.eventData.playhead(a.eventData.playhead()),this._lastInBandItem.qosData.startupTime(a.qosData.startupTime()),this._lastInBandItem.qosData.isStartupTimeOverridden=a.qosData.isStartupTimeOverridden},e.prototype._sendHit=function(a){function b(a){var b=c._reportFactory.createReportForItem(a);b.qosData.isStartupTimeOverridden||b.qosData.startupTime(c._autoComputedStartupTime);var e={};e[G]=b,c._channel.trigger(new h(ca,e)),b.eventData.type()!=n.EVENT_TYPE_PLAY&&b.eventData.type()!=n.EVENT_TYPE_BUFFER&&b.eventData.type()!=n.EVENT_TYPE_START||(d={},d[H]=!0,c._channel.command(z,d))}var c=this,d={};switch(a.eventData.type()){case n.EVENT_TYPE_START:case n.EVENT_TYPE_PLAY:case n.EVENT_TYPE_PAUSE:case n.EVENT_TYPE_STALL:case n.EVENT_TYPE_BUFFER:this._lastInBandItem&&(this._updateLastInBandItem(a),this._lastInBandItem.eventData.type()==n.EVENT_TYPE_START&&this._lastInBandItem.assetData.type()==o.TYPE_MAIN_CONTENT&&(this._autoComputedStartupTime+=this._lastInBandItem.eventData.duration()),a!=this._lastInBandItem&&b(this._lastInBandItem)),b(a),this._lastInBandItem=a,d={},d[H]=!0,this._channel.command(z,d);break;case n.EVENT_TYPE_COMPLETE:this._lastInBandItem&&(a.assetData.type()==o.TYPE_AD&&(this._doNotOverrideEventDuration=!0),this._updateLastInBandItem(a),b(this._lastInBandItem)),b(a),a.assetData.type()==o.TYPE_MAIN_CONTENT?(this._lastInBandItem=null,d={},d[H]=!0,this._channel.command(A,d)):a.assetData.type()==o.TYPE_AD&&(this._lastInBandItem.assetData.adData(null),this._lastInBandItem.assetData.type(o.TYPE_MAIN_CONTENT),this._doNotOverrideEventDuration=!0);break;case n.EVENT_TYPE_CHAPTER_START:case n.EVENT_TYPE_CHAPTER_COMPLETE:this._lastInBandItem&&(this._updateLastInBandItem(a),b(this._lastInBandItem)),b(a),this._lastInBandItem&&(this._lastInBandItem.assetData.chapterData(a.eventData.type()==n.EVENT_TYPE_CHAPTER_START?new s(a.assetData.chapterData()):null),this._lastInBandItem.eventData.duration(0),b(this._lastInBandItem));break;default:b(a)}};var w="ah::Context",x="sourceErrorSDK",y="error",z="clock:reporting.resume",A="clock:reporting.pause",B="reporting_interval",C="session_id",D="reset_session_id",E="callback",F="filter_report",G="report",H="reset",I="track_external_errors",J="reporting_interval",K="api:aa_start",L="api:aa_ad_start",M="api:video_load",N="api:video_unload",O="api:video_start",P="api:video_complete",Q="api:video_resume",R="api:ad_start",S="api:ad_complete",T="api:play",U="api:pause",V="api:buffer_start",W="api:seek_start",X="api:seek_complete",Y="api:chapter_start",Z="api:chapter_complete",$="api:track_error",_="api:track_internal_error",aa="api:bitrate_change",ba="api:quantum_end",ca="context:report_available",da="net:check_status_complete",ea=1.5,fa=10;d.context.Context=e}(a.ADB.core,a.ADB.va,a.ADB.va.utils,b),function(a){"use strict";function b(a,b){this.trackingServer=a,this.publisher=b,this.ssl=!1,this.ovp=c,this.sdk=c,this.quietMode=!1,this.debugLogging=!1,this.__isPrimetime=!1,this.__psdkVersion=null}var c="unknown";a.AdobeHeartbeatPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.AdobeHeartbeatPluginDelegate=b}(b),function(a,b,c){"use strict";function d(a){d.__super__.constructor.call(this,q),this._radio=new i(this._logger),this._channel=this._radio.channel(y),this._delegate=a,this._context=new l(this._channel,this._logger),this._filter=new m(this._channel,this._logger),this._network=new n(this._channel,this._logger),this._setupDataResolver()}var e=a.Event,f=a.Trigger,g=a.plugin.BasePlugin,h=a.plugin.ParamMapping,i=a.radio.Radio,j=b.ErrorInfo,k=b.Version,l=c.context.Context,m=c.filter.ReportFilter,n=c.network.Network,o=c.clock.Clock,p=c.AdobeHeartbeatPluginConfig;a.extend(d,g),d.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof p))throw new Error("Expected config data to be instance of AdobeHeartbeatPluginConfig.");this._config=a,this._config.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure({trackingServer="+this._config.trackingServer+", publisher="+this._config.publisher+", quietMode="+this._config.quietMode+", ssl="+this._config.ssl+"})");var b=this._config.trackingServer+"/settings/",c={};c[ba]=this._config.trackingServer,c[ca]=b,c[da]=this._config.publisher,c[ea]=this._config.quietMode,c[fa]=this._config.ssl,this._channel.trigger(new e(ja,c)),this._isConfigured=!0},d.prototype.bootstrap=function(a){d.__super__.bootstrap.call(this,a),this._channel.on(z,this._onError,this),this._clock=new o(this._pluginManager,this._channel,this._logger),this._channel.command(Ea),this._channel.trigger(new e(La)),this._registerCommands(),this._registerBehaviours()},d.prototype._teardown=function(){this._logger.debug(this._logTag,"#_teardown()"),this._radio.shutdown(),this._context.destroy(),this._clock.destroy(),this._filter.destroy(),this._network.destroy()},d.prototype._canProcess=function(){return this._isConfigured?this._errorInfo?(this._logger.error(this._logTag,"_canProcess() > Plugin in ERROR state."),!1):d.__super__._canProcess.call(this):(this._logger.error(this._logTag,"_canProcess() > Plugin not configured."),!1)},d.prototype._cmdAnalyticsError=function(a){this._errorInfo||(this._errorInfo=new j("Internal error","AdobeAnalyticsPlugin is in ERROR state."),this._trigger(z,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo))},d.prototype._cmdAnalyticsStart=function(a){if(this._canProcess()){var b={};b[ga]=a.visitorOptedOut,this._channel.trigger(new e(ka,b)),this._channel.trigger(new e(ha,a))}},d.prototype._cmdAnalyticsAdStart=function(a){this._canProcess()&&this._channel.trigger(new e(ia,a))},d.prototype._cmdVideoLoad=function(a){this._errorInfo=null,this._canProcess()&&(this._isTrackingSessionActive&&this._channel.trigger(new e(ma,a)),this._isTrackingSessionActive=!1,this._isPaused=!0,this._isSeeking=!1,this._isBuffering=!1,this._isVideoIdle=!1,this._filter.clear(),this._channel.trigger(new e(la,a)),this._isTrackingSessionActive=!0)},d.prototype._cmdVideoUnload=function(a){this._errorInfo=null,this._canProcess()&&(this._channel.trigger(new e(ma,a)),this._filter.flush(),this._runReportingTimer(!1),this._runFlushFilterTimer(!1),this._runIdleTimer(!1),this._isTrackingSessionActive=!1)},d.prototype._cmdVideoStart=function(a){this._canProcess()&&this._channel.trigger(new e(na,a))},d.prototype._cmdVideoComplete=function(a){this._canProcess()&&this._channel.trigger(new e(oa,a))},d.prototype._cmdVideoResume=function(a){this._canProcess()&&this._channel.trigger(new e(pa,a))},d.prototype._cmdPlay=function(a){this._canProcess()&&(this._isPaused=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdPause=function(a){this._canProcess()&&(this._channel.trigger(new e(ta,a)),this._isPaused=!0,this._runIdleTimer(!0))},d.prototype._cmdAdStart=function(a){this._canProcess()&&(this._channel.trigger(new e(qa,a)),this._resumePlaybackIfPossible(a))},d.prototype._cmdAdComplete=function(a){this._canProcess()&&(this._channel.trigger(new e(ra,a)),a.isInAdBreak||this._resumePlaybackIfPossible(a))},d.prototype._cmdBufferStart=function(a){this._canProcess()&&(this._channel.trigger(new e(ua,a)),this._isBuffering=!0,this._runIdleTimer(!0))},d.prototype._cmdBufferComplete=function(a){this._canProcess()&&(this._isBuffering=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdSeekStart=function(a){this._canProcess()&&(this._channel.trigger(new e(va,a)),this._channel.trigger(new e(ta,a)),this._isSeeking=!0,this._runIdleTimer(!0))},d.prototype._cmdSeekComplete=function(a){this._canProcess()&&(this._channel.trigger(new e(wa,a)),this._isSeeking=!1,this._resumePlaybackIfPossible(a))},d.prototype._cmdChapterStart=function(a){this._canProcess()&&this._channel.trigger(new e(xa,a))},d.prototype._cmdChapterComplete=function(a){this._canProcess()&&this._channel.trigger(new e(ya,a))},d.prototype._cmdBitrateChange=function(a){this._canProcess()&&this._channel.trigger(new e(Ba,a))},d.prototype._cmdTrackError=function(a){this._canProcess()&&this._channel.trigger(new e(za,a))},d.prototype._cmdClockReportingTick=function(a){this._canProcess()&&this._channel.trigger(new e(Ca,a))},d.prototype._cmdIdleTick=function(a){this._canProcess()&&(this._isVideoIdle=!0,this._trigger(V),this._filter.flush(),this._runReportingTimer(!1),this._runFlushFilterTimer(!1),this._runIdleTimer(!1),this._trigger(T))},d.prototype._onError=function(a){this._errorInfo=a.data;var b={};b[_]=Da,b[aa]=this._errorInfo.getMessage()+"|"+this._errorInfo.getDetails(),this._channel.trigger(new e(Aa,b)),this._runReportingTimer(!1),this._trigger(z,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo)},d.prototype._runIdleTimer=function(a){var b={};b[$]=!0,a?this._channel.command(Ja,b):this._channel.command(Ka,b)},d.prototype._runFlushFilterTimer=function(a){var b={};b[$]=!0,a?this._channel.command(Ha,b):this._channel.command(Ia,b)},d.prototype._runReportingTimer=function(a){var b={};b[$]=!0,a?this._channel.command(Fa,b):this._channel.command(Ga,b)},d.prototype._registerCommands=function(){this._pluginManager.comply(this,"handleAnalyticsError",this._cmdAnalyticsError),this._pluginManager.comply(this,"handleAnalyticsStart",this._cmdAnalyticsStart),this._pluginManager.comply(this,"handleAnalyticsAdStart",this._cmdAnalyticsAdStart),this._pluginManager.comply(this,"handleVideoLoad",this._cmdVideoLoad),this._pluginManager.comply(this,"handleVideoUnload",this._cmdVideoUnload),this._pluginManager.comply(this,"handleVideoStart",this._cmdVideoStart),this._pluginManager.comply(this,"handleVideoComplete",this._cmdVideoComplete),this._pluginManager.comply(this,"handleVideoResume",this._cmdVideoResume),this._pluginManager.comply(this,"handlePlay",this._cmdPlay),this._pluginManager.comply(this,"handlePause",this._cmdPause),this._pluginManager.comply(this,"handleAdStart",this._cmdAdStart),this._pluginManager.comply(this,"handleAdComplete",this._cmdAdComplete),this._pluginManager.comply(this,"handleBufferStart",this._cmdBufferStart),this._pluginManager.comply(this,"handleBufferComplete",this._cmdBufferComplete),this._pluginManager.comply(this,"handleSeekStart",this._cmdSeekStart),this._pluginManager.comply(this,"handleSeekComplete",this._cmdSeekComplete),this._pluginManager.comply(this,"handleChapterStart",this._cmdChapterStart),this._pluginManager.comply(this,"handleChapterComplete",this._cmdChapterComplete),this._pluginManager.comply(this,"handleBitrateChange",this._cmdBitrateChange),this._pluginManager.comply(this,"handleTrackError",this._cmdTrackError),this._pluginManager.comply(this,"handleClockReportingTick",this._cmdClockReportingTick),this._pluginManager.comply(this,"handleIdleTick",this._cmdIdleTick)},d.prototype._registerBehaviours=function(){this._pluginManager.registerBehaviour(new f(t,C),this,"handleVideoLoad",[new h(s,"rsid","rsid"),new h(s,"tracking_server","trackingServer")]),this._pluginManager.registerBehaviour(new f(t,D),this,"handleVideoUnload"),this._pluginManager.registerBehaviour(new f(t,E),this,"handleVideoStart",[new h(t,"video.id","videoId"),new h(t,"video.name","videoName"),new h(t,"video.length","videoLength"),new h(t,"video.playhead","playhead"),new h(t,"video.playerName","playerName"),new h(t,"video.streamType","streamType"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"rsid","rsid"),new h(s,"tracking_server","trackingServer"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(s,"ssl","useSsl"),new h(u,"meta","metaNielsen"),new h(r,"publisher","publisher"),new h(r,"sdk","sdk"),new h(r,"ovp","ovp"),new h(r,"version","version"),new h(r,"api_level","apiLvl")]),this._pluginManager.registerBehaviour(new f(t,G),this,"handleVideoComplete",[new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,F),this,"handleVideoResume",[new h(t,"video.id","videoId"),new h(t,"video.name","videoName"),new h(t,"video.length","videoLength"),new h(t,"video.playhead","playhead"),new h(t,"video.playerName","playerName"),new h(t,"video.streamType","streamType")]),this._pluginManager.registerBehaviour(new f(t,H),this,"handlePlay",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,I),this,"handlePause",[new h(t,"video.playhead","playhead"),new h(t,"video.playheadStalled","playheadStalled"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,J),this,"handleAdStart",[new h(t,"video.playhead","playhead"),new h(t,"ad.id","adId"),new h(t,"ad.name","adName"),new h(t,"ad.length","adLength"),new h(t,"ad.position","adPosition"),new h(t,"pod.name","podName"),new h(t,"pod.playerName","podPlayerName"),new h(t,"pod.position","podPosition"),new h(t,"pod.startTime","podSecond"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.ad.*","metaAd"),new h(u,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(t,K),this,"handleAdComplete",[new h(t,"video.playhead","playhead"),new h(t,"ad.isInAdBreak","isInAdBreak"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,L),this,"handleBufferStart",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,M),this,"handleBufferComplete",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,N),this,"handleSeekStart",[new h(t,"video.playhead","playhead")]),this._pluginManager.registerBehaviour(new f(t,O),this,"handleSeekComplete",[new h(t,"video.playhead","playhead"),new h(t,"ad.isInAd","isInAd"),new h(t,"ad.id","adId"),new h(t,"ad.position","adPosition"),new h(t,"pod.playerName","podPlayerName"),new h(t,"pod.position","podPosition"),new h(t,"chapter.isInChapter","isInChapter"),new h(t,"chapter.position","chapterPosition"),new h(t,"chapter.name","chapterName"),new h(t,"chapter.length","chapterLength"),new h(t,"chapter.startTime","chapterOffset"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),
	this._pluginManager.registerBehaviour(new f(t,P),this,"handleChapterStart",[new h(t,"video.playhead","playhead"),new h(t,"chapter.position","chapterPosition"),new h(t,"chapter.name","chapterName"),new h(t,"chapter.length","chapterLength"),new h(t,"chapter.startTime","chapterOffset"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.chapter.*","metaChapter"),new h(u,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(t,Q),this,"handleChapterComplete",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,R),this,"handleBitrateChange",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(t,S),this,"handleTrackError"),this._pluginManager.registerBehaviour(new f(v,X),this,"handleClockReportingTick",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(v,Z),this,"handleIdleTick",[]),this._pluginManager.registerBehaviour(new f(r,V),this,"handleClockReportingTick",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(s,z),this,"handleAnalyticsError"),this._pluginManager.registerBehaviour(new f(s,A),this,"handleAnalyticsStart",[new h(s,"vid","vid"),new h(s,"aid","aid"),new h(s,"mid","mid"),new h(s,"customerIDs","customerIDs"),new h(s,"visitorOptedOut","visitorOptedOut"),new h(s,"blob","blob"),new h(s,"loc_hint","loc_hint"),new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")]),this._pluginManager.registerBehaviour(new f(s,B),this,"handleAnalyticsAdStart",[new h(t,"video.playhead","playhead"),new h(t,"qos.fps","fps"),new h(t,"qos.droppedFrames","droppedFrames"),new h(t,"qos.bitrate","bitrate"),new h(t,"qos.startupTime","startupTime")])},d.prototype._setupDataResolver=function(){var a={},b=this;a.version=function(){return k.getVersion()},a.api_level=function(){return k.getApiLevel()},a.tracking_server=function(){return b._config?b._config.trackingServer:null},a.publisher=function(){return b._config?b._config.publisher:null},a.quiet_mode=function(){return!!b._config&&b._config.quietMode},a.ovp=function(){return b._config?b._config.ovp:null},a.sdk=function(){return b._config?b._config.sdk:null},a.is_primetime=function(){return!!b._config&&b._config.__isPrimetime},a.psdk_version=function(){return b._config?b._config.__psdkVersion:null},a.session_id=function(){return b._channel.request(w)},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];c=c||{},c[e]=a.hasOwnProperty(e)?a[e].call(this):null}return c}},d.prototype._resumePlaybackIfPossible=function(a){this._errorInfo||this._isPaused||this._isSeeking||this._isBuffering||(this._isVideoIdle&&(this._isVideoIdle=!1,this._resumePlaybackFromIdle()),this._runIdleTimer(!1),this._channel.trigger(new e(sa,a)))},d.prototype._resumePlaybackFromIdle=function(){this._trigger(V),this._filter.clear(),this._channel.trigger(new e(x)),this._trigger(U),this._runReportingTimer(!0),this._runFlushFilterTimer(!0)};var q="adobe-heartbeat",r=q,s="adobe-analytics",t="player",u="nielsen",v="service.clock",w="session_id",x="reset_session_id",y="heartbeat-channel",z="error",A="aa_start",B="sc_ad_start",C="video_load",D="video_unload",E="video_start",F="video_resume",G="video_complete",H="play",I="pause",J="ad_start",K="ad_complete",L="buffer_start",M="buffer_complete",N="seek_start",O="seek_complete",P="chapter_start",Q="chapter_complete",R="bitrate_change",S="track_error",T="video_idle_start",U="video_idle_resume",V="quantum_close",W="heartbeat.reporting",X=W+".tick",Y="heartbeat.idle",Z=Y+".tick",$="reset",_="source",aa="error_id",ba="tracking_server",ca="check_status_server",da="publisher",ea="quiet_mode",fa="ssl",ga="visitor_opt_out",ha="api:aa_start",ia="api:aa_ad_start",ja="api:config",ka="api:update_visitor_optout",la="api:video_load",ma="api:video_unload",na="api:video_start",oa="api:video_complete",pa="api:video_resume",qa="api:ad_start",ra="api:ad_complete",sa="api:play",ta="api:pause",ua="api:buffer_start",va="api:seek_start",wa="api:seek_complete",xa="api:chapter_start",ya="api:chapter_complete",za="api:track_error",Aa="api:track_internal_error",Ba="api:bitrate_change",Ca="api:quantum_end",Da="sourceErrorHeartbeat",Ea="clock:check_status.resume",Fa="clock:reporting.resume",Ga="clock:reporting.pause",Ha="clock:flush_filter.resume",Ia="clock:flush_filter.pause",Ja="clock:idle.resume",Ka="clock:idle.pause",La="clock:check_status.get_settings";c.AdobeHeartbeatPlugin=d}(a.ADB.core,a.ADB.va,b),a.ADB.va.plugins.ah||(a.ADB.va.plugins.ah=b)}(this);
	
	// AdobeAnalyticsPlugin
	!function(a){if("undefined"==typeof b)var b={};!function(a,b){"use strict";function c(a,b){this._onFail={fn:a,ctx:b}}var d=a.ErrorInfo;c.prototype.validateFields=function(a,b){if(!a)return this._fail("Data cannot be null");if(b)for(var c=0;c<b.length;c++){var d=b[c];switch(d){case"videoId":if(!a.hasOwnProperty("videoId"))return this._fail("The ID for the main video must be specified.");if("string"!=typeof a.videoId)return this._fail("The ID for the main video must be a String.");if(""===a.videoId)return this._fail("The ID for the main video cannot be an empty string.");break;case"streamType":if(!a.hasOwnProperty("streamType"))return this._fail("The stream type for the main video must be specified.");if("string"!=typeof a.streamType)return this._fail("The stream type for the main video must be a String.");if(""===a.streamType)return this._fail("The stream type for the main video cannot be an empty string.");break;case"playerName":if(!a.hasOwnProperty("playerName"))return this._fail("The player name for the main video must be specified.");if("string"!=typeof a.playerName)return this._fail("The player name for the main video must be a String.");if(""===a.playerName)return this._fail("The player name for the main video cannot be an empty string.");break;case"videoLength":if(!a.hasOwnProperty("videoLength"))return this._fail("The length of the main video must be specified.");if("number"!=typeof a.videoLength)return this._fail("The length of the main video must be a Number.");if(isNaN(a.videoLength))return this._fail("The length of the main video cannot be NaN.");break;case"podPlayerName":if(!a.hasOwnProperty("podPlayerName"))return this._fail("The player name for the ad-break must be specified.");if("string"!=typeof a.podPlayerName)return this._fail("The player name for the ad-break must be a String.");if(""===a.podPlayerName)return this._fail("The player name for the ad-break cannot be an empty string.");break;case"podPosition":if(!a.hasOwnProperty("podPosition"))return this._fail("Position (index) of the ad-break must be specified.");if("number"!=typeof a.podPosition)return this._fail("Position (index) of the ad-break must be a Number.");if(isNaN(a.podPosition))return this._fail("Position (index) of the ad-break cannot be NaN.");break;case"adId":if(!a.hasOwnProperty("adId"))return this._fail("The ad ID must be specified.");if("string"!=typeof a.adId)return this._fail("The ad ID must be a String.");if(""===a.adId)return this._fail("The ad ID cannot be an empty string.");break;case"adPosition":if(!a.hasOwnProperty("adPosition"))return this._fail("Position (index) of the ad must be specified.");if("number"!=typeof a.adPosition)return this._fail("Position (index) of the ad must be a Number.");if(isNaN(a.adPosition))return this._fail("Position (index) of the ad cannot be NaN.");break;case"adLength":if(!a.hasOwnProperty("adLength"))return this._fail("The length of the ad must be specified.");if("number"!=typeof a.adLength)return this._fail("The length of the ad must be a Number.");if(isNaN(a.adLength))return this._fail("The length of the ad cannot be NaN.");break;default:return this._fail("Unable to validate unknown parameter: "+d)}}return!0},c.prototype._fail=function(a){var b=new d("Invalid input data",a);return this._onFail.fn&&this._onFail.fn.call(this._onFail.ctx,b),!1},b.InputDataValidator=c}(a.ADB.va,b),function(a){"use strict";function b(){this.channel=c,this.debugLogging=!1}var c="";a.AdobeAnalyticsPluginConfig=b}(b),function(a){"use strict";function b(){}b.prototype.onError=function(a){},a.AdobeAnalyticsPluginDelegate=b}(b),function(a,b,c,d){"use strict";function e(a,b){if(e.__super__.constructor.call(this,r),!a)throw new Error("The reference to the AppMeasurement object cannot be NULL.");this._appMeasurement=a,this._delegate=b,this._customMetaKeys=[],this._videoMetadata={},this._adMetadata={},this._chapterMetadata={},this._errorInfo=null,this._workQueue=new k(!0,w),this._inputDataValidator=new q(function(a){this._errorInfo=a,this._logger.error(this._logTag,a.getMessage()+" | "+a.getDetails());var b=this;setTimeout(function(){b._trigger(x,a),b._delegate&&b._delegate.onError(b._errorInfo)},0)},this),this._appMeasurement.isReadyToTrack(),this._setupDataResolver()}var f=a.Trigger,g=a.plugin.BasePlugin,h=a.plugin.ParamMapping,i=a.radio.Channel,j=a.radio.Command,k=a.radio.CommandQueue,l=b.ErrorInfo,m=c.md5,n=c.StringUtils,o=c.ObjectUtils,p=d.AdobeAnalyticsPluginConfig,q=d.InputDataValidator;a.extend(e,g),e.prototype.configure=function(a){if(!a)throw new Error("Reference to the configuration data cannot be NULL.");if(!(a instanceof p))throw new Error("Expected config data to be instance of AdobeAnalyticsPluginConfig.");this._config=a,this._config.debugLogging?this._logger.enable():this._logger.disable(),this._logger.debug(this._logTag,"#configure({trackingServer="+this._config.debugLogging+", channel="+this._config.channel+", ssl="+this._appMeasurement.ssl+"})")},e.prototype.bootstrap=function(a){e.__super__.bootstrap.call(this,a),this._registerCommands(),this._registerBehaviours()},e.prototype.setup=function(){this._appMeasurement.isReadyToTrack()?this._onAppMeasurementReady():this._appMeasurement.callbackWhenReadyToTrack(this,this._onAppMeasurementReady,[]),e.__super__.setup.call(this)},e.prototype.setVideoMetadata=function(a){this._videoMetadata=o.clone(a)},e.prototype.setAdMetadata=function(a){this._adMetadata=o.clone(a)},e.prototype.setChapterMetadata=function(a){this._chapterMetadata=o.clone(a)},e.prototype._canProcess=function(){return this._errorInfo?(this._logger.error(this._logTag,"#_canProcess() > In ERROR state."),!1):e.__super__._canProcess.call(this)},e.prototype._cmdVideoLoad=function(a){this._errorInfo=null},e.prototype._cmdVideoStart=function(a){this._logger.debug(this._logTag,"#_cmdVideoStart()"),this._canProcess()&&this._workQueue.addCommand(new j(this._executeOpen,this,[a]))},e.prototype._cmdAdStart=function(a){this._logger.debug(this._logTag,"#_cmdAdStart()"),this._canProcess()&&this._workQueue.addCommand(new j(this._executeOpenAd,this,[a]))},e.prototype._cmdHeartbeatPluginError=function(a){this._errorInfo||(this._errorInfo=new l("Internal error","HeartbeatPlugin is in ERROR state."),this._trigger(x,this._errorInfo),this._delegate&&this._delegate.onError(this._errorInfo))},e.prototype._resetAppMeasurementContextData=function(){delete this._appMeasurement.contextData["a.contentType"],delete this._appMeasurement.contextData["a.media.name"],delete this._appMeasurement.contextData["a.media.friendlyName"],delete this._appMeasurement.contextData["a.media.length"],delete this._appMeasurement.contextData["a.media.playerName"],delete this._appMeasurement.contextData["a.media.channel"],delete this._appMeasurement.contextData["a.media.view"],delete this._appMeasurement.contextData["a.media.ad.name"],delete this._appMeasurement.contextData["a.media.ad.friendlyName"],delete this._appMeasurement.contextData["a.media.ad.podFriendlyName"],delete this._appMeasurement.contextData["a.media.ad.length"],delete this._appMeasurement.contextData["a.media.ad.playerName"],delete this._appMeasurement.contextData["a.media.ad.pod"],delete this._appMeasurement.contextData["a.media.ad.podPosition"],delete this._appMeasurement.contextData["a.media.ad.podSecond"],delete this._appMeasurement.contextData["a.media.ad.view"];for(var a=0;a<this._customMetaKeys.length;a++){var b=this._customMetaKeys[a];delete this._appMeasurement.contextData[b]}this._customMetaKeys=[]},e.prototype._executeOpen=function(a){if(this._logger.debug(this._logTag,"#_executeOpen(id="+a.videoId+", videoName="+a.videoName+", streamType="+a.streamType+", length="+a.videoLength+", playerName="+a.playerName+", channel="+a.channel+", isPrimetime="+a.isPrimetime+", sessionId="+a.sessionId+")"),this._canProcess()&&this._inputDataValidator.validateFields(a,["videoId","streamType","videoLength","playerName"])){this._resetAppMeasurementContextData();for(var b in a.metaVideo)a.metaVideo.hasOwnProperty(b)&&(this._appMeasurement.contextData[b]=a.metaVideo[b],this._customMetaKeys.push(b));if(a.metaNielsen)for(var b in a.metaNielsen)a.metaNielsen.hasOwnProperty(b)&&(this._appMeasurement.contextData[b]=a.metaNielsen[b],this._customMetaKeys.push(b));this._appMeasurement.contextData["a.contentType"]=a.streamType,this._appMeasurement.contextData["a.media.name"]=a.videoId,this._appMeasurement.contextData["a.media.friendlyName"]=a.videoName||"",this._appMeasurement.contextData["a.media.length"]=Math.floor(a.videoLength)||"0.0",this._appMeasurement.contextData["a.media.playerName"]=a.playerName,this._appMeasurement.contextData["a.media.channel"]=a.channel||"",this._appMeasurement.contextData["a.media.view"]=!0,this._appMeasurement.contextData["a.media.vsid"]=a.sessionId,this._appMeasurement.pev3=y,this._appMeasurement.pe=a.isPrimetime?B:A,this._appMeasurement.track();var c=this;setTimeout(function(){c._trigger(E,a)},0)}},e.prototype._executeOpenAd=function(a){var b=m(a.videoId)+"_"+a.podPosition;if(this._logger.debug(this._logTag,"#_executeOpenAd(id="+a.adId+", streamType="+a.streamType+", length="+a.adLength+", podPlayerName="+a.podPlayerName+", parentId="+a.videoId+", podId="+b+", parentPodPosition="+a.adPosition+", podSecond="+a.podSecond+")"),this._canProcess()&&this._inputDataValidator.validateFields(a,["videoId","streamType","playerName","adId","adLength","podPlayerName","adPosition"])){a.podSecond=null==a.podSecond||isNaN(a.podSecond)?a.playhead:a.podSecond,this._resetAppMeasurementContextData();var c;for(c in a.metaVideo)a.metaVideo.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaVideo[c],this._customMetaKeys.push(c));for(c in a.metaAd)a.metaAd.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaAd[c],this._customMetaKeys.push(c));if(a.metaNielsen)for(var c in a.metaNielsen)a.metaNielsen.hasOwnProperty(c)&&(this._appMeasurement.contextData[c]=a.metaNielsen[c],this._customMetaKeys.push(c));this._appMeasurement.contextData["a.contentType"]=a.streamType,this._appMeasurement.contextData["a.media.name"]=a.videoId,this._appMeasurement.contextData["a.media.playerName"]=a.playerName,this._appMeasurement.contextData["a.media.channel"]=a.channel||"",this._appMeasurement.contextData["a.media.vsid"]=a.sessionId,this._appMeasurement.contextData["a.media.friendlyName"]=a.videoName||"",this._appMeasurement.contextData["a.media.length"]=Math.floor(a.videoLength)||"0.0",this._appMeasurement.contextData["a.media.ad.name"]=a.adId,this._appMeasurement.contextData["a.media.ad.friendlyName"]=a.adName||"",this._appMeasurement.contextData["a.media.ad.podFriendlyName"]=a.podName||"",this._appMeasurement.contextData["a.media.ad.length"]=Math.floor(a.adLength)||"0.0",this._appMeasurement.contextData["a.media.ad.playerName"]=a.podPlayerName,this._appMeasurement.contextData["a.media.ad.pod"]=b,this._appMeasurement.contextData["a.media.ad.podPosition"]=Math.floor(a.adPosition)||"0.0",this._appMeasurement.contextData["a.media.ad.podSecond"]=Math.floor(a.podSecond)||"0.0",this._appMeasurement.contextData["a.media.ad.view"]=!0,this._appMeasurement.pev3=z,this._appMeasurement.pe=a.isPrimetime?D:C,this._appMeasurement.track();var d=this;setTimeout(function(){d._trigger(F,a)},0)}},e.prototype._setupDataResolver=function(){var a={},b=this;a.rsid=function(){return b._appMeasurement.account},a.tracking_server=function(){return b._appMeasurement.ssl&&b._appMeasurement.trackingServerSecure?b._appMeasurement.trackingServerSecure:b._appMeasurement.trackingServer},a.ssl=function(){return b._appMeasurement.ssl},a.vid=function(){return b._appMeasurement.visitorID},a.aid=function(){return b._appMeasurement.analyticsVisitorID},a.mid=function(){return b._appMeasurement.marketingCloudVisitorID},a.blob=function(){return b._appMeasurement.audienceManagerBlob},a.loc_hint=function(){return b._appMeasurement.audienceManagerLocationHint?parseInt(b._appMeasurement.audienceManagerLocationHint):""},a.customerIDs=function(){var a=b._appMeasurement.visitor.getCustomerIDs(),c={};for(var d in a)if(a.hasOwnProperty(d)){var e=a[d];if("object"==typeof e){for(var f in e)e.hasOwnProperty(f)&&("authState"==f?c[d+".as"]=e[f]:c[d+"."+f]=e[f]);c[d+".as"]||(c[d+".as"]="0")}}return c},a.channel=function(){return b._config?b._config.channel:null},a.meta=function(a){var c=a.split(".");if(c.length<2)return null;var d=c.shift();switch(a=c.join("."),d){case"video":return a==i.WILDCARD?b._videoMetadata:b._videoMetadata[a];case"ad":return a==i.WILDCARD?b._adMetadata:b._adMetadata[a];case"chapter":return a==i.WILDCARD?b._chapterMetadata:b._chapterMetadata[a];default:return null}},a.visitorOptedOut=function(){return void 0!=b._appMeasurement.visitorOptedOut&&b._appMeasurement.visitorOptedOut},this._dataResolver=function(b){if(!b||0==b.length)return null;for(var c=null,d=0;d<b.length;d++){var e=b[d];c=c||{},n.startsWith(e,"meta.")?c[e]=a.meta(e.split("meta.")[1]):c[e]=a.hasOwnProperty(e)?a[e].call(this):null}return c}},e.prototype._registerCommands=function(){this._pluginManager.comply(this,"handleVideoLoad",this._cmdVideoLoad),this._pluginManager.comply(this,"handleVideoStart",this._cmdVideoStart),this._pluginManager.comply(this,"handleAdStart",this._cmdAdStart),this._pluginManager.comply(this,"handleHeartbeatPluginError",this._cmdHeartbeatPluginError)},e.prototype._registerBehaviours=function(){this._pluginManager.registerBehaviour(new f(u,G),this,"handleVideoLoad"),this._pluginManager.registerBehaviour(new f(u,H),this,"handleVideoStart",[new h(u,"video.id","videoId"),new h(u,"video.streamType","streamType"),new h(u,"video.name","videoName"),new h(u,"video.length","videoLength"),new h(u,"video.playerName","playerName"),new h(u,"video.streamType","streamType"),new h(v,"is_primetime","isPrimetime"),new h(v,"session_id","sessionId"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(t,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(u,I),this,"handleAdStart",[new h(u,"video.id","videoId"),new h(u,"video.streamType","streamType"),new h(u,"video.playhead","playhead"),new h(u,"video.playerName","playerName"),new h(u,"video.name","videoName"),new h(u,"video.length","videoLength"),new h(u,"ad.id","adId"),new h(u,"ad.length","adLength"),new h(u,"ad.position","adPosition"),new h(u,"ad.name","adName"),new h(u,"pod.name","podName"),new h(u,"pod.position","podPosition"),new h(u,"pod.playerName","podPlayerName"),new h(u,"pod.startTime","podSecond"),new h(v,"is_primetime","isPrimetime"),new h(v,"session_id","sessionId"),new h(s,"channel","channel"),new h(s,"meta.video.*","metaVideo"),new h(s,"meta.ad.*","metaAd"),new h(t,"meta","metaNielsen")]),this._pluginManager.registerBehaviour(new f(v,x),this,"handleHeartbeatPluginError")},e.prototype._onAppMeasurementReady=function(){this._workQueue.resume()};var r="adobe-analytics",s=r,t="nielsen",u="player",v="adobe-heartbeat",w=2e3,x="error",y="video",z="videoAd",A="ms_s",B="msp_s",C="msa_s",D="mspa_s",E="aa_start",F="sc_ad_start",G="video_load",H="video_start",I="ad_start";d.AdobeAnalyticsPlugin=e}(a.ADB.core,a.ADB.va,a.ADB.va.utils,b),function(a){"use strict";var b={SHOW:"a.media.show",SEASON:"a.media.season",EPISODE:"a.media.episode",ASSET_ID:"a.media.asset",GENRE:"a.media.genre",FIRST_AIR_DATE:"a.media.airDate",FIRST_DIGITAL_DATE:"a.media.digitalDate",RATING:"a.media.rating",ORIGINATOR:"a.media.originator",NETWORK:"a.media.network",SHOW_TYPE:"a.media.type",AD_LOAD:"a.media.adLoad",MVPD:"a.media.pass.mvpd",AUTHORIZED:"a.media.pass.auth",DAY_PART:"a.media.dayPart",FEED:"a.media.feed",STREAM_FORMAT:"a.media.format"},c={ADVERTISER:"a.media.ad.advertiser",CAMPAIGN_ID:"a.media.ad.campaign",CREATIVE_ID:"a.media.ad.creative",PLACEMENT_ID:"a.media.ad.placement",SITE_ID:"a.media.ad.site",CREATIVE_URL:"a.media.ad.creativeURL"};a.VideoMetadataKeys=b,a.AdMetadataKeys=c}(b),a.ADB.va.plugins.aa||(a.ADB.va.plugins.aa=b)}(this);
	
	// MediaHeartbeat
	!function(a){!function(a){"use strict";function b(){this.trackingServer=void 0,this.channel=void 0,this.ovp=void 0,this.appVersion=void 0,this.playerName=void 0,this.ssl=!1,this.debugLogging=!1}a.MediaHeartbeatConfig=b,a.MediaHeartbeatConfig.sharedInstance=new b}(a.ADB.va),function(a){"use strict";function b(){this.data={}}var c=a.plugins.videoplayer.VideoInfo,d=a.plugins.videoplayer.AdBreakInfo,e=a.plugins.videoplayer.AdInfo,f=a.plugins.videoplayer.ChapterInfo,g=a.plugins.videoplayer.QoSInfo;b.MEDIAINFO_KEY_NAME="a.name",b.MEDIAINFO_KEY_VIDEOID="a.videoId",b.MEDIAINFO_KEY_ADID="a.adId",b.MEDIAINFO_KEY_LENGTH="a.length",b.MEDIAINFO_KEY_PLAYHEAD="a.playhead",b.MEDIAINFO_KEY_STREAMTYPE="a.streamType",b.MEDIAINFO_KEY_POSITION="a.position",b.MEDIAINFO_KEY_STARTTIME="a.startTime",b.MEDIAINFO_KEY_BITRATE="a.bitrate",b.MEDIAINFO_KEY_FPS="a.fps",b.MEDIAINFO_KEY_DROPPEDFRAMES="a.droppedFrames",b.MEDIAINFO_KEY_STARTUPTIME="a.startupTime",b.MEDIAINFO_KEY_TIMEDMETADATA="a.timedMetadata",b.prototype.setValue=function(a,b){this.data[a]=b},b.prototype.getValue=function(a){return this.data.hasOwnProperty(a)?this.data[a]:null},b.prototype.createVideoInfo=function(){var a=new c;return a.id=null!=this.getValue(b.MEDIAINFO_KEY_VIDEOID)?this.getValue(b.MEDIAINFO_KEY_VIDEOID):"",a.name=null!=this.getValue(b.MEDIAINFO_KEY_NAME)?this.getValue(b.MEDIAINFO_KEY_NAME):"",a.length=null!=this.getValue(b.MEDIAINFO_KEY_LENGTH)?this.getValue(b.MEDIAINFO_KEY_LENGTH):0,a.playhead=null!=this.getValue(b.MEDIAINFO_KEY_PLAYHEAD)?this.getValue(b.MEDIAINFO_KEY_PLAYHEAD):0,a.streamType=null!=this.getValue(b.MEDIAINFO_KEY_STREAMTYPE)?this.getValue(b.MEDIAINFO_KEY_STREAMTYPE):"",a},b.prototype.createAdBreakInfo=function(){var a=new d;return a.name=null!=this.getValue(b.MEDIAINFO_KEY_NAME)?this.getValue(b.MEDIAINFO_KEY_NAME):"",a.position=null!=this.getValue(b.MEDIAINFO_KEY_POSITION)?this.getValue(b.MEDIAINFO_KEY_POSITION):0,a.startTime=null!=this.getValue(b.MEDIAINFO_KEY_STARTTIME)?this.getValue(b.MEDIAINFO_KEY_STARTTIME):0,a},b.prototype.createAdInfo=function(){var a=new e;return a.id=null!=this.getValue(b.MEDIAINFO_KEY_ADID)?this.getValue(b.MEDIAINFO_KEY_ADID):"",a.name=null!=this.getValue(b.MEDIAINFO_KEY_NAME)?this.getValue(b.MEDIAINFO_KEY_NAME):"",a.length=null!=this.getValue(b.MEDIAINFO_KEY_LENGTH)?this.getValue(b.MEDIAINFO_KEY_LENGTH):0,a.position=null!=this.getValue(b.MEDIAINFO_KEY_POSITION)?this.getValue(b.MEDIAINFO_KEY_POSITION):0,a},b.prototype.createChapterInfo=function(){var a=new f;return a.name=null!=this.getValue(b.MEDIAINFO_KEY_NAME)?this.getValue(b.MEDIAINFO_KEY_NAME):"",a.length=null!=this.getValue(b.MEDIAINFO_KEY_LENGTH)?this.getValue(b.MEDIAINFO_KEY_LENGTH):0,a.startTime=null!=this.getValue(b.MEDIAINFO_KEY_STARTTIME)?this.getValue(b.MEDIAINFO_KEY_STARTTIME):0,a.position=null!=this.getValue(b.MEDIAINFO_KEY_POSITION)?this.getValue(b.MEDIAINFO_KEY_POSITION):0,a},b.prototype.createQoSInfo=function(){var a=new g;return a.bitrate=null!=this.getValue(b.MEDIAINFO_KEY_BITRATE)?this.getValue(b.MEDIAINFO_KEY_BITRATE):0,a.fps=null!=this.getValue(b.MEDIAINFO_KEY_FPS)?this.getValue(b.MEDIAINFO_KEY_FPS):0,a.droppedFrames=null!=this.getValue(b.MEDIAINFO_KEY_DROPPEDFRAMES)?this.getValue(b.MEDIAINFO_KEY_DROPPEDFRAMES):0,a.startupTime=null!=this.getValue(b.MEDIAINFO_KEY_STARTUPTIME)?this.getValue(b.MEDIAINFO_KEY_STARTUPTIME):0,a},a.MediaObject=b}(a.ADB.va),function(a,b){"use strict";function c(a){c.__super__.constructor.call(this),this._heartbeat=a}function d(a){d.__super__.constructor.call(this),this._heartbeat=a}function e(a){e.__super__.constructor.call(this),this._heartbeat=a}function f(a){f.__super__.constructor.call(this),this._heartbeat=a}a.extend(c,b.plugins.aa.AdobeAnalyticsPluginDelegate),c.prototype.onError=function(a){b.MediaHeartbeat._onDelegateError.call(this._heartbeat,a)},a.extend(d,b.plugins.ah.AdobeHeartbeatPluginDelegate),d.prototype.onError=function(a){b.MediaHeartbeat._onDelegateError.call(this._heartbeat,a)},a.extend(e,b.HeartbeatDelegate),e.prototype.onError=function(a){b.MediaHeartbeat._onDelegateError.call(this._heartbeat,a)},a.extend(f,b.plugins.videoplayer.VideoPlayerPluginDelegate),f.prototype.getVideoInfo=function(){return this._heartbeat&&this._heartbeat._videoInfo?(this._heartbeat._delegate&&(this._heartbeat._videoInfo.playhead=this._heartbeat._delegate.getCurrentPlaybackTime()),this._heartbeat._videoInfo):null},f.prototype.getAdBreakInfo=function(){return this._heartbeat&&this._heartbeat._adBreakInfo?this._heartbeat._adBreakInfo:null},f.prototype.getAdInfo=function(){return this._heartbeat&&this._heartbeat._adInfo?this._heartbeat._adInfo:null},f.prototype.getChapterInfo=function(){return this._heartbeat&&this._heartbeat._chapterInfo?this._heartbeat._chapterInfo:null},f.prototype.getQoSInfo=function(){if(this._heartbeat&&this._heartbeat._delegate&&this._heartbeat._delegate.getQoSObject()){var a=this._heartbeat._delegate.getQoSObject();if(a&&"object"==typeof a&&a.setValue)return a.createQoSInfo()}return null},b._MediaAnalyticsPluginDelegate=c,b._MediaHeartbeatPluginDelegate=d,b._ADBMediaHeartbeatDelegate=e,b._MediaHeartbeatVideoPlayerPluginDelegate=f}(a.ADB.core,a.ADB.va),function(a,b){"use strict";function c(){}function d(a){d.__super__.constructor.call(this),this._heartbeat=a}var e=b.MediaHeartbeatConfig;b.plugins.nielsen&&(c.MEDIAHEARTBEAT_NIELSEN_CONTENT_METADATA="media_nielsen_content_metadata",c.MEDIAHEARTBEAT_NIELSEN_AD_METADATA="media_nielsen_ad_metadata",c.MEDIAHEARTBEAT_NIELSEN_CHANNEL_METADATA="media_nielsen_channel_metadata",e.prototype.nielsenConfigKey=void 0,e.prototype.nielsenAppInfo=void 0,a.extend(d,b.plugins.nielsen.NielsenPluginDelegate),d.prototype.getMetadataInfo=function(){if(this._heartbeat&&this._heartbeat._currentContentMediaObject){var a=this._heartbeat._currentContentMediaObject.getValue(c.MEDIAHEARTBEAT_NIELSEN_CONTENT_METADATA);if("object"==typeof a)return a}return null},d.prototype.getAdMetadataInfo=function(){if(this._heartbeat&&this._heartbeat._currentAdMediaObject){var a=this._heartbeat._currentAdMediaObject.getValue(c.MEDIAHEARTBEAT_NIELSEN_AD_METADATA);if("object"==typeof a)return a}return null},d.prototype.getChannelInfo=function(){if(this._heartbeat&&this._heartbeat._currentContentMediaObject){var a=this._heartbeat._currentContentMediaObject.getValue(c.MEDIAHEARTBEAT_NIELSEN_CHANNEL_METADATA);if("object"==typeof a)return a}return null},d.prototype.onError=function(a){this._heartbeat&&b.MediaHeartbeat._onError.call(this._heartbeat,a)},b._MediaHeartbeatNielsen=c,b._MediaHeartbeatNielsenPluginDelegate=d)}(a.ADB.core,a.ADB.va),function(b,c){"use strict";function d(){}function e(b,d,e){if(this._logger=new z,this._plugins=[],this._playerPlugin=null,this._aaPlugin=null,this._ahPlugin=null,this._nielsenPlugin=null,this._currentContentMediaObject=void 0,this._currentAdMediaObject=void 0,this._videoInfo=void 0,this._adBreakInfo=void 0,this._adInfo=void 0,this._chapterInfo=void 0,this._state={},this._delegate=b,e)this.appMeasurement=e;else{if(!a.s)return void this._logger.error($,"Valid AppMeasurement instance required for initialising MediaHeartbeat");this.appMeasurement=a.s}d&&"object"==typeof d&&void 0!=d.trackingServer?(this._config=d,c.MediaHeartbeat._debugLogging||this._config.debugLogging?this._logger.enable():this._logger.disable()):this._logger.error($,"Valid config required for initialising MediaHeartbeat")}function f(a,b){if(a==e.Event.AdBreakStart){if(this._logger.info($,"#::trackEvent(AdBreakStart)"),!t.call(this,Y))return void this._logger.error($,"API call trackEvent:AdBreakStart is unsupported in the current state.");b&&"object"==typeof b&&b.setValue?(this._adBreakInfo=b.createAdBreakInfo(),this._adBreakInfo.playerName=this._config.playerName?this._config.playerName:""):this._logger.error($,"Invalid AdBreak Info for MediaHeartbeatEvent.AdBreakStart event.")}else{if(this._logger.info($,"#::trackEvent(AdBreakComplete)"),!t.call(this,Y,!0))return void this._logger.error($,"API call trackEvent:AdBreakComplete is unsupported in the current state.");this._adBreakInfo=void 0}}function g(a,b,c){if(a==e.Event.AdStart){if(this._logger.info($,"#::trackEvent(AdStart)"),!t.call(this,X))return void this._logger.error($,"API call trackEvent:AdStart is unsupported in the current state.");if(b&&"object"==typeof b&&b.setValue){this._currentAdMediaObject=b,this._adInfo=b.createAdInfo();var d=b.getValue(e.MediaObjectKey.StandardAdMetadata);if(d&&"object"==typeof d)for(var f in d)d.hasOwnProperty(f)&&(c[f]=d[f]);this._aaPlugin&&this._aaPlugin.setAdMetadata(c),this._playerPlugin.trackAdStart(),this._state[Z]||this._state[S]||this.trackPlay()}else this._logger.error($,"Invalid Ad Info for MediaHeartbeatEvent.AdStart event.")}else if(a==e.Event.AdComplete){if(this._logger.info($,"#::trackEvent(AdComplete)"),!t.call(this,X,!0))return void this._logger.error($,"API call trackEvent:AdComplete is unsupported in the current state.");this._playerPlugin.trackAdComplete(),this._adInfo=null}else{if(this._logger.info($,"#::trackEvent(AdSkip)"),!t.call(this,X,!0))return void this._logger.error($,"API call trackEvent:AdSkip is unsupported in the current state.");this._adInfo=null}}function h(a){if(a==e.Event.SeekStart){if(this._logger.info($,"#::trackEvent(SeekStart)"),!t.call(this,V))return void this._logger.error($,"API call trackEvent:SeekStart is unsupported in the current state.");this._playerPlugin.trackSeekStart()}else{if(this._logger.info($,"#::trackEvent(SeekComplete)"),!t.call(this,V,!0))return void this._logger.error($,"API call trackEvent:SeekComplete is unsupported in the current state.");this._playerPlugin.trackSeekComplete()}}function i(a,b,c){if(a==e.Event.ChapterStart){if(this._logger.info($,"#::trackEvent(ChapterStart)"),!t.call(this,W))return void this._logger.error($,"API call trackEvent:ChapterStart is unsupported in the current state.");b&&"object"==typeof b&&b.setValue?(this._chapterInfo=b.createChapterInfo(),this._aaPlugin&&this._aaPlugin.setChapterMetadata(c),this._playerPlugin.trackChapterStart(),this._state[Z]||this._state[S]||this.trackPlay()):this._logger.error($,"Invalid Chapter Info for MediaHeartbeatEvent.ChapterStart event.")}else if(a==e.Event.ChapterComplete){if(this._logger.info($,"#::trackEvent(ChapterComplete)"),!t.call(this,W,!0))return void this._logger.error($,"API call trackEvent:ChapterComplete is unsupported in the current state.");this._chapterInfo=null,this._playerPlugin.trackChapterComplete()}else{if(this._logger.info($,"#::trackEvent(ChapterSkip)"),!t.call(this,W,!0))return void this._logger.error($,"API call trackEvent:ChapterSkip is unsupported in the current state.");this._chapterInfo=null}}function j(a){if(a==e.Event.BufferStart){if(this._logger.info($,"#::trackEvent(BufferStart)"),!t.call(this,U))return void this._logger.error($,"API call trackEvent:BufferStart is unsupported in the current state.");this._playerPlugin.trackBufferStart()}else{if(this._logger.info($,"#::trackEvent(BufferComplete)"),!t.call(this,U,!0))return void this._logger.error($,"API call trackEvent:BufferComplete is unsupported in the current state.");this._playerPlugin.trackBufferComplete()}}function k(){return this._logger.info($,"#::trackEvent(BitrateChange)"),w.call(this)?void this._playerPlugin.trackBitrateChange():void this._logger.error($,"API call trackEvent:BitrateChange is unsupported in the current state.")}function l(a){if(this._logger.info($,"#::trackEvent(TimedMetadataUpdate)"),a&&"object"==typeof a&&a.setValue){var b=a.getValue(B.MEDIAINFO_KEY_TIMEDMETADATA);this._playerPlugin&&b&&"string"==typeof b&&this._playerPlugin.trackTimedMetadata(b)}}function m(){this._aaPlugin=new I(this.appMeasurement,new K(this));var a=new J;a.channel=this._config.channel?this._config.channel:"",a.debugLogging=c.MediaHeartbeat._debugLogging||this._config.debugLogging,this._aaPlugin.configure(a),this._plugins.push(this._aaPlugin)}function n(){this._ahPlugin=new L(new N(this));var a=new M(this._config.trackingServer,this.appMeasurement.visitor.marketingCloudOrgID);a.debugLogging=c.MediaHeartbeat._debugLogging||this._config.debugLogging,a.ovp=this._config.ovp?this._config.ovp:"",a.ssl=this._config.ssl,a.sdk=this._config.appVersion?this._config.appVersion:"";var b=s.call(this);b&&b.length>0&&(a.__primetime=!0,a.__psdkVersion=b),this._ahPlugin.configure(a),this._plugins.push(this._ahPlugin)}function o(){this._playerPlugin=new F(new H(this));var a=new G;a.debugLogging=c.MediaHeartbeat._debugLogging||this._config.debugLogging,this._playerPlugin.configure(a),this._plugins.push(this._playerPlugin)}function p(){if(c.plugins.nielsen&&this._config.nielsenConfigKey&&this._config.nielsenAppInfo){this._nielsenPlugin=new c.plugins.nielsen.NielsenPlugin(new c._MediaHeartbeatNielsenPluginDelegate(this));var a=new c.plugins.nielsen.NielsenPluginConfig;a.debugLogging=c.MediaHeartbeat._debugLogging||this._config.debugLogging,a.appInfo=this._config.nielsenAppInfo,a.configKey=this._config.nielsenConfigKey,this._nielsenPlugin.configure(a),this._plugins.push(this._nielsenPlugin)}}function q(){var a=new D;a.debugLogging=c.MediaHeartbeat._debugLogging||this._config.debugLogging,this._heartbeat=new C(new E(this),this._plugins),this._heartbeat.configure(a)}function r(a){this._logger.error($,a.getMessage()+" | "+a.getDetails())}function s(){return this._currentContentMediaObject?this._currentContentMediaObject.getValue(_):null}function t(a,b){if(a!=Q&&(!this._state[Q]||this._state[T]))return!1;a===R&&u.call(this);var c=!(a===Y&&!b);if(c&&(b?!this._state[a]:this._state[a]))return!1;switch(a){case R:this._state[S]=b,this._state[Z]=!0;break;case S:this._state[R]=b;break;case Y:if(!b&&this._state[X])return!1;break;case X:if(!b&&!this._state[Y])return!1}return this._state[a]=!b,!0}function u(){this._state[V]&&this.trackEvent(e.Event.SeekComplete),this._state[U]&&this.trackEvent(e.Event.BufferComplete)}function v(a){this._state[a]=!1}function w(){return this._state[Q]}function x(){this._state={}}function y(){this._plugins=[],this._aaPlugin=null,this._ahPlugin=null,this._playerPlugin=null,this._nielsenPlugin=null,this._heartbeat&&(this._heartbeat.destroy(),this._heartbeat=null)}var z=b.Logger,A=c.plugins.videoplayer.AssetType,B=c.MediaObject,C=c.Heartbeat,D=c.HeartbeatConfig,E=c._ADBMediaHeartbeatDelegate,F=c.plugins.videoplayer.VideoPlayerPlugin,G=c.plugins.videoplayer.VideoPlayerPluginConfig,H=c._MediaHeartbeatVideoPlayerPluginDelegate,I=c.plugins.aa.AdobeAnalyticsPlugin,J=c.plugins.aa.AdobeAnalyticsPluginConfig,K=c._MediaAnalyticsPluginDelegate,L=c.plugins.ah.AdobeHeartbeatPlugin,M=c.plugins.ah.AdobeHeartbeatPluginConfig,N=c._MediaHeartbeatPluginDelegate;if(d.prototype.getCurrentPlaybackTime=function(){return null},d.prototype.getQoSObject=function(){return null},e.Event={AdBreakStart:"adBreakStart",AdBreakComplete:"adBreakComplete",AdStart:"adStart",AdComplete:"adComplete",AdSkip:"adSkip",ChapterStart:"chapterStart",ChapterComplete:"chapterComplete",ChapterSkip:"chapterSkip",SeekStart:"seekStart",SeekComplete:"seekComplete",BufferStart:"bufferStart",BufferComplete:"bufferComplete",BitrateChange:"bitrateChange",TimedMetadataUpdate:"timedMetadataUpdate"},e.StreamType={VOD:"vod",LIVE:"live",LINEAR:"linear"},e.MediaObjectKey={StandardVideoMetadata:"media_standard_content_metadata",StandardAdMetadata:"media_standard_ad_metadata",VideoResumed:"resumed"},e.VideoMetadataKeys=c.plugins.aa.VideoMetadataKeys,e.AdMetadataKeys=c.plugins.aa.AdMetadataKeys,e.version=function(){return c.Version.getVersion()},e.prototype.trackSessionStart=function(a,b){if(this._logger.info($,"#::trackSessionStart()"),!t.call(this,Q))return void this._logger.error($,"API call trackSessionStart is unsupported in the current state.");if(!a||"object"!=typeof a||!a.setValue)return v.call(this,Q),void this._logger.error($,"Invalid Media Info object");this._currentContentMediaObject=a,this._videoInfo=a.createVideoInfo(),this._videoInfo.playerName=void 0!=this._config.playerName?this._config.playerName:"";var c=a.getValue(e.MediaObjectKey.StandardVideoMetadata);if(c&&"object"==typeof c)for(var d in c)c.hasOwnProperty(d)&&(b[d]=c[d]);var f=a.getValue(e.MediaObjectKey.VideoResumed);f&&"boolean"==typeof f&&(this._videoInfo.resumed=a.getValue(e.MediaObjectKey.VideoResumed)),P.call(this),this._playerPlugin&&(this._aaPlugin&&this._aaPlugin.setVideoMetadata(b),this._playerPlugin.trackVideoLoad(),this._playerPlugin.trackSessionStart())},e.prototype.trackPlay=function(){return this._logger.info($,"#::trackPlay()"),t.call(this,R)?void this._playerPlugin.trackPlay():void this._logger.error($,"API call trackPlay is unsupported in the current state.")},e.prototype.trackPause=function(){return this._logger.info($,"#::trackPause()"),t.call(this,S)?void(this._playerPlugin&&this._playerPlugin.trackPause()):void this._logger.error($,"API call trackPause is unsupported in the current state.")},e.prototype.trackComplete=function(){return this._logger.info($,"#::trackComplete()"),t.call(this,T)?void(this._playerPlugin&&this._playerPlugin.trackComplete(function(){})):void this._logger.error($,"API call trackComplete is unsupported in the current state.")},e.prototype.trackSessionEnd=function(){return this._logger.info($,"#::trackSessionEnd()"),t.call(this,Q,!0)?(this._playerPlugin&&this._playerPlugin.trackVideoUnload(),x.call(this),void y.call(this)):(x.call(this),y.call(this),void this._logger.error($,"API call trackSessionEnd is unsupported in the current state."))},e.prototype.trackError=function(a){return this._logger.info($,"#::trackError()"),w.call(this)?void(this._playerPlugin&&this._playerPlugin.trackVideoPlayerError(a?a:"unknown_error_id")):void this._logger.error($,"API call trackError is unsupported in the current state.")},e.prototype.trackEvent=function(a,b,c){switch(a){case e.Event.AdBreakStart:case e.Event.AdBreakComplete:f.call(this,a,b);break;case e.Event.AdStart:case e.Event.AdComplete:case e.Event.AdSkip:g.call(this,a,b,c);break;case e.Event.SeekStart:case e.Event.SeekComplete:h.call(this,a);break;case e.Event.ChapterStart:case e.Event.ChapterComplete:case e.Event.ChapterSkip:i.call(this,a,b,c);break;case e.Event.BufferStart:case e.Event.BufferComplete:j.call(this,a);break;case e.Event.BitrateChange:k.call(this);break;case e.Event.TimedMetadataUpdate:l.call(this,b)}},c.plugins.nielsen){var O=c._MediaHeartbeatNielsen;e.MediaObjectKey.NielsenContentMetadata=O.MEDIAHEARTBEAT_NIELSEN_CONTENT_METADATA,e.MediaObjectKey.NielsenAdMetadata=O.MEDIAHEARTBEAT_NIELSEN_AD_METADATA,e.MediaObjectKey.NielsenChannelMetadata=O.MEDIAHEARTBEAT_NIELSEN_CHANNEL_METADATA,e.prototype.nielsenLoadMetadata=function(a){this._nielsenPlugin&&this._nielsenPlugin.loadMetadata(a)}}var P=function(){if(!this.appMeasurement||!this.appMeasurement.visitor)throw new Error("appMeasurement.visitor object cannot be NULL.");m.call(this),n.call(this),o.call(this),p.call(this),q.call(this)},Q=1,R=2,S=3,T=4,U=5,V=6,W=7,X=8,Y=9,Z=10;e.createMediaObject=function(a,b,c,d){var f=new B;f.setValue(B.MEDIAINFO_KEY_VIDEOID,b),f.setValue(B.MEDIAINFO_KEY_NAME,a),f.setValue(B.MEDIAINFO_KEY_LENGTH,c),f.setValue(B.MEDIAINFO_KEY_PLAYHEAD,0);var g=A.ASSET_TYPE_VOD;switch(d){case e.StreamType.VOD:g=A.ASSET_TYPE_VOD;break;case e.StreamType.LIVE:g=A.ASSET_TYPE_LIVE;break;case e.StreamType.LINEAR:g=A.ASSET_TYPE_LINEAR}return f.setValue(B.MEDIAINFO_KEY_STREAMTYPE,g),f},e.createAdBreakObject=function(a,b,c){var d=new B;return d.setValue(B.MEDIAINFO_KEY_NAME,a),d.setValue(B.MEDIAINFO_KEY_POSITION,b),d.setValue(B.MEDIAINFO_KEY_STARTUPTIME,c),d},e.createAdObject=function(a,b,c,d){var e=new B;return e.setValue(B.MEDIAINFO_KEY_NAME,a),e.setValue(B.MEDIAINFO_KEY_ADID,b),e.setValue(B.MEDIAINFO_KEY_POSITION,c),e.setValue(B.MEDIAINFO_KEY_LENGTH,d),e},e.createChapterObject=function(a,b,c,d){var e=new B;return e.setValue(B.MEDIAINFO_KEY_NAME,a),e.setValue(B.MEDIAINFO_KEY_POSITION,b),e.setValue(B.MEDIAINFO_KEY_LENGTH,c),e.setValue(B.MEDIAINFO_KEY_STARTTIME,d),e},e.createQoSObject=function(a,b,c,d){var e=new B;return e.setValue(B.MEDIAINFO_KEY_BITRATE,a),e.setValue(B.MEDIAINFO_KEY_FPS,c),e.setValue(B.MEDIAINFO_KEY_DROPPEDFRAMES,d),e.setValue(B.MEDIAINFO_KEY_STARTUPTIME,b),e},e.createTimedMetadataObject=function(a){var b=new B;return b.setValue(B.MEDIAINFO_KEY_TIMEDMETADATA,a),b};var $="MediaHeartbeat",_="a.__pttvsdkVersion";c.MediaHeartbeat=e,c.MediaHeartbeatDelegate=d,c.MediaHeartbeat._onDelegateError=r,c.MediaHeartbeat._debugLogging=!1}(a.ADB.core,a.ADB.va),a.ADB||(a.ADB={}),a.ADB.core||(a.ADB.core=core),a.ADB.va||(a.ADB.va=va),a.ADB.va.plugins||(a.ADB.va.plugins={})}(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _utilsUtil = __webpack_require__(201);
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	    return {
	        init: function init(bpDefinition) {
	            // copy over jQuery elements already saved in brandplay.js
	            for (i in bpDefinition) {
	                if (bpDefinition[i] instanceof $) this[i] = bpDefinition[i];
	            }
	            this.$pageWrapper.prepend("<div id='menuBG'>");
	            this.bpDefinition = bpDefinition;
	            this.$menuClose = $('#menu-close');
	            this.$menuBG = $('#menuBG').hide();
	            this.$programClose = $('#programClose');
	            this.$playlistContainer = $('.playlistContainer');
	            this.$program_menu__icons = $('.program_menu__icons');
	            // if config does not have mobileMenu property, hide chapterMenu
	            if (!bpInstance.mobileMenu) {
	                this.$program_menu__icons.addClass('no-menu');
	            }
	            this.build();
	        },
	        build: function build() {
	            // hide back arrow in app view, remove link from Medscape logo
	            if ($('body').hasClass('app')) {
	                var homeLink = $('#returnToMedscape');
	                homeLink.find('a').on('click', function () {
	                    return false;
	                });
	            }
	            this.addHandlers();
	        },
	        addHandlers: function addHandlers() {
	            var self = this,
	                menuOpenClass = 'open';
	            $(window).on('mobmenu:close', function (e) {
	                e.preventDefault();
	                if (self.$playlistContainer.hasClass(menuOpenClass)) {
	                    self.$menuBG.fadeOut(300);
	                    self.$playlistContainer.removeClass(menuOpenClass);
	                    $('body').removeClass('chapter-menu-open');
	
	                    $(window).trigger('player:play');
	                } else {
	                    self.$menuBG.fadeIn(300);
	                    self.$playlistContainer.addClass(menuOpenClass);
	                    if (self.$menuDropDown.hasClass(menuOpenClass)) {
	                        self.$menuDropDown.hide().removeClass('open');
	                    }
	                    $('body').addClass('chapter-menu-open');
	                    $(window).trigger('player:pause');
	                }
	            });
	
	            this.$chapterMenu.on('click', function () {
	                $(window).trigger('mobmenu:close');
	            });
	
	            this.$menu.on('click', function () {
	                // Fix for PPE-49675
	                self.$brandPlay.removeClass('lock-isi');
	                self.$isiContainer.removeClass('lock-isi');
	                if (self.$menuDropDown.hasClass('open')) {
	                    //re-add the native video controls when the layer is dismissed
	                    self.$video.attr('controls', 'true').removeClass('tempHideVideo');
	                    self.$menuDropDown.hide().removeClass('open');
	                    self.$menuBG.fadeOut(300);
	                    self.bpDefinition.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_close', self.bpDefinition]);
	                } else {
	                    if (self.$playlistContainer.hasClass(menuOpenClass)) {
	                        self.$playlistContainer.removeClass(menuOpenClass);
	                    }
	                    self.$menuBG.fadeIn(300);
	                    self.$menuDropDown.show().addClass('open');
	                    self.bpDefinition.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_OPEN', 'vidvbp-action_sheet', self.bpDefinition]);
	                    setTimeout(function () {
	                        //remove native video controls while the menu layer is up
	                        self.$video.removeAttr('controls');
	                    }, 500);
	                }
	            });
	
	            this.$programClose.on('click', function () {
	                self.bpDefinition.notify('TrackBind', ['pamTrack', 'CLOSE', 'vidvbp-close', self.bpDefinition]);
	
	                var metaRefURL = $('meta[name=metaref]').attr('content');
	
	                if (metaRefURL !== 'null') {
	                    if (metaRefURL.substring(0, 7) === 'http://') {
	                        window.location.href = metaRefURL;
	                    } else {
	                        window.location.href = 'http://' + metaRefURL;
	                    }
	                } else {
	                    window.location.href = 'http://www.medscape.com';
	                    // Handle click event.
	                }
	            });
	
	            this.$menuBG.add(this.$menuClose).on('click', function (e) {
	                $('body').removeClass('chapter-menu-open');
	                e.preventDefault();
	                self.$video.attr('controls', 'true').removeClass('tempHideVideo');
	                self.$menu.removeClass('menu_open');
	                self.$menuDropDown.hide().removeClass('open');
	                self.$menuBG.fadeOut(300);
	                self.$brandPlay.removeClass('lock-isi');
	                self.$isiContainer.removeClass('lock-isi');
	                if (self.$playlistContainer.hasClass(menuOpenClass)) self.$playlistContainer.removeClass(menuOpenClass);
	                if (self.$menuDropDown.hasClass(menuOpenClass)) self.$menuDropDown.removeClass(menuOpenClass);
	            });
	
	            this.$pageWrapper.on('click', function () {
	                if (!(0, _utilsUtil.isIpad)()) {
	                    self.$video.attr('controls', 'true').removeClass('tempHideVideo');
	                }
	            });
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/* Modernizr 2.7.1 (Custom Build) | MIT & BSD
	 * Build: http://modernizr.com/download/#-fontface-cssanimations-csstransforms-csstransforms3d-csstransitions-canvas-audio-video-webworkers-geolocation-inlinesvg-svg-svgclippaths-touch-shiv-mq-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-load
	 */
	;window.Modernizr=function(a,b,c){function B(a){j.cssText=a}function C(a,b){return B(m.join(a+";")+(b||""))}function D(a,b){return typeof a===b}function E(a,b){return!!~(""+a).indexOf(b)}function F(a,b){for(var d in a){var e=a[d];if(!E(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function G(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:D(f,"function")?f.bind(d||b):f}return!1}function H(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return D(b,"string")||D(b,"undefined")?F(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),G(e,b,c))}var d="2.7.1",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={svg:"http://www.w3.org/2000/svg"},r={},s={},t={},u=[],v=u.slice,w,x=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},y=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b).matches;var d;return x("@media "+b+" { #"+h+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},z={}.hasOwnProperty,A;!D(z,"undefined")&&!D(z.call,"undefined")?A=function(a,b){return z.call(a,b)}:A=function(a,b){return b in a&&D(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=v.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(v.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(v.call(arguments)))};return e}),r.canvas=function(){var a=b.createElement("canvas");return!!a.getContext&&!!a.getContext("2d")},r.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:x(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},r.geolocation=function(){return"geolocation"in navigator},r.cssanimations=function(){return H("animationName")},r.csstransforms=function(){return!!H("transform")},r.csstransforms3d=function(){var a=!!H("perspective");return a&&"webkitPerspective"in g.style&&x("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},r.csstransitions=function(){return H("transition")},r.fontface=function(){var a;return x('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a},r.video=function(){var a=b.createElement("video"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),c.h264=a.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),c.webm=a.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")}catch(d){}return c},r.audio=function(){var a=b.createElement("audio"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),c.mp3=a.canPlayType("audio/mpeg;").replace(/^no$/,""),c.wav=a.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),c.m4a=(a.canPlayType("audio/x-m4a;")||a.canPlayType("audio/aac;")).replace(/^no$/,"")}catch(d){}return c},r.webworkers=function(){return!!a.Worker},r.svg=function(){return!!b.createElementNS&&!!b.createElementNS(q.svg,"svg").createSVGRect},r.inlinesvg=function(){var a=b.createElement("div");return a.innerHTML="<svg/>",(a.firstChild&&a.firstChild.namespaceURI)==q.svg},r.svgclippaths=function(){return!!b.createElementNS&&/SVGClipPath/.test(l.call(b.createElementNS(q.svg,"clipPath")))};for(var I in r)A(r,I)&&(w=I.toLowerCase(),e[w]=r[I](),u.push((e[w]?"":"no-")+w));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)A(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},B(""),i=k=null,function(a,b){function l(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function m(){var a=s.elements;return typeof a=="string"?a.split(" "):a}function n(a){var b=j[a[h]];return b||(b={},i++,a[h]=i,j[i]=b),b}function o(a,c,d){c||(c=b);if(k)return c.createElement(a);d||(d=n(c));var g;return d.cache[a]?g=d.cache[a].cloneNode():f.test(a)?g=(d.cache[a]=d.createElem(a)).cloneNode():g=d.createElem(a),g.canHaveChildren&&!e.test(a)&&!g.tagUrn?d.frag.appendChild(g):g}function p(a,c){a||(a=b);if(k)return a.createDocumentFragment();c=c||n(a);var d=c.frag.cloneNode(),e=0,f=m(),g=f.length;for(;e<g;e++)d.createElement(f[e]);return d}function q(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return s.shivMethods?o(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+m().join().replace(/[\w\-]+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(s,b.frag)}function r(a){a||(a=b);var c=n(a);return s.shivCSS&&!g&&!c.hasCSS&&(c.hasCSS=!!l(a,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),k||q(a,c),a}var c="3.7.0",d=a.html5||{},e=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,f=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g,h="_html5shiv",i=0,j={},k;(function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",g="hidden"in a,k=a.childNodes.length==1||function(){b.createElement("a");var a=b.createDocumentFragment();return typeof a.cloneNode=="undefined"||typeof a.createDocumentFragment=="undefined"||typeof a.createElement=="undefined"}()}catch(c){g=!0,k=!0}})();var s={elements:d.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",version:c,shivCSS:d.shivCSS!==!1,supportsUnknownElements:k,shivMethods:d.shivMethods!==!1,type:"default",shivDocument:r,createElement:o,createDocumentFragment:p};a.html5=s,r(b)}(this,b),e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.mq=y,e.testProp=function(a){return F([a])},e.testAllProps=H,e.testStyles=x,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+u.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.Modernizr;
	}.call(window));

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//     Underscore.js 1.5.2
	//     http://underscorejs.org
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.5.2';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, length = obj.length; i < length; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
	      }
	    }
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results.push(iterator.call(context, value, index, list));
	    });
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !iterator.call(context, value, index, list);
	    }, context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs, first) {
	    if (_.isEmpty(attrs)) return first ? void 0 : [];
	    return _[first ? 'find' : 'filter'](obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.where(obj, attrs, true);
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity, value: -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed > result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity, value: Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Shuffle an array, using the modern version of the 
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // Sample **n** random values from an array.
	  // If **n** is not specified, returns a single random element from the array.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (arguments.length < 2 || guard) {
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, value, context) {
	      var result = {};
	      var iterator = value == null ? _.identity : lookupIterator(value);
	      each(obj, function(value, index) {
	        var key = iterator.call(context, value, index, obj);
	        behavior(result, key, value);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, key, value) {
	    (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, key, value) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, key) {
	    _.has(result, key) ? result[key]++ : result[key] = 1;
	  });
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    return (n == null) || guard ? array[0] : slice.call(array, 0, n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) {
	      return array[array.length - 1];
	    } else {
	      return slice.call(array, Math.max(array.length - n, 0));
	    }
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    each(input, function(value) {
	      if (_.isArray(value) || _.isArguments(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(_.flatten(arguments, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var length = _.max(_.pluck(arguments, "length").concat(0));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, '' + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(length);
	
	    while(idx < length) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;
	    args = slice.call(arguments, 2);
	    return bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      ctor.prototype = func.prototype;
	      var self = new ctor;
	      ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (Object(result) === result) return result;
	      return self;
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context.
	  _.partial = function(func) {
	    var args = slice.call(arguments, 1);
	    return function() {
	      return func.apply(this, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) throw new Error("bindAll must be passed function names");
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    options || (options = {});
	    var later = function() {
	      previous = options.leading === false ? 0 : new Date;
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function() {
	      var now = new Date;
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = new Date();
	      var later = function() {
	        var last = (new Date()) - timestamp;
	        if (last < wait) {
	          timeout = setTimeout(later, wait - last);
	        } else {
	          timeout = null;
	          if (!immediate) result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	      }
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = new Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = new Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] === void 0) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                             _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(Math.max(0, n));
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	}).call(this);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint camelcase: 0 */
	/* global ADB, s_pageview_id, s_md, wmdSetContext, remLinkTrackVars, addLinkTrackVars, wmdPageLink */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _heartbeat = __webpack_require__(312);
	
	var _heartbeat2 = _interopRequireDefault(_heartbeat);
	
	var _import = __webpack_require__(200);
	
	var _utilsUtil = __webpack_require__(201);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsHas_medscape_globals = __webpack_require__(317);
	
	var _mixinsHas_medscape_globals2 = _interopRequireDefault(_mixinsHas_medscape_globals);
	
	var _mixinsHas_pretty_time = __webpack_require__(242);
	
	var _mixinsHas_pretty_time2 = _interopRequireDefault(_mixinsHas_pretty_time);
	
	var _storesVideo_store = __webpack_require__(225);
	
	var _storesVideo_store2 = _interopRequireDefault(_storesVideo_store);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsBp_tracking = __webpack_require__(318);
	
	var _mixinsBp_tracking2 = _interopRequireDefault(_mixinsBp_tracking);
	
	var _storesDescriptor_store = __webpack_require__(238);
	
	var _storesDescriptor_store2 = _interopRequireDefault(_storesDescriptor_store);
	
	var _md5 = __webpack_require__(305);
	
	var _md52 = _interopRequireDefault(_md5);
	
	exports['default'] = _reflux2['default'].createStore({
	  mixins: [_mixinsHas_medscape_globals2['default'], _mixinsHas_pretty_time2['default']],
	  isFirstPlay: true,
	  isWaiting: false,
	  hasStarted: false,
	  hasEnded: false,
	  init: function init() {
	    var _this = this;
	
	    this.tracking = window.bpInstance.hasOwnProperty('tracking') ? window.bpInstance.tracking : null;
	    window.s_sact = this.tracking.sfNumber;
	    window.s_sptr = this.tracking.brandName + ' [ ' + this.tracking.brandId + ' ]';
	    window.s_sprodid = this.tracking.productId;
	    window.s_sprod = this.tracking.productName;
	    window.s_sactid = this.tracking.cp.activityId;
	    window.s_spcrtid = this.tracking.partnerCreativeID;
	    this.contextDataVars = ['contextData.a.contentType', 'contextData.a.media.name', 'contextData.a.media.playerName', 'contextData.a.media.pageName', 'contextData.a.media.friendlyName', 'contextData.a.media.length', 'contextData.a.media.channel', 'contextData.a.media.view', 'contextData.a.media.ad.name', 'contextData.a.media.ad.podFriendlyName', 'contextData.a.media.ad.length', 'contextData.a.media.ad.pod', 'contextData.a.media.ad.podPosition', 'contextData.a.media.ad.podSecond', 'contextData.a.media.ad.CPM', 'contextData.a.media.ad.view', 'contextData.a.media.extcampaign', 'contextData.wb.vpgnm', 'contextData.wb.ecd', 'contextData.wb.sptr', 'contextData.wb.sprodid', 'contextData.wb.sprod', 'contextData.wb.sactid', 'contextData.wb.sact', 'contextData.wb.asset', 'contextData.vpgnm', 'contextData.ecd', 'contextData.chn', 'contextData.rs', 'contextData.site', 'contextData.dprofsn', 'contextData.dspclty', 'contextData.regid', 'contextData.dcntry', 'contextData.vpagename'];
	    this.initMedscapeGlobals();
	    this.isCPDisabled = typeof this.cp === 'undefined' ? true : false;
	    this.isIPPDisabled = false;
	    this.$metrics.prop6 = 'video-brandplay';
	    this.mmodule = 'video-brandplay';
	    this.listenTo(_storesVideo_store2['default'], this.onVideoChange.bind(this));
	    window.trackingEnabled = true;
	    this.Bptracking = new _mixinsBp_tracking2['default']();
	    this.addHeartbeatContext();
	    this.playerEle = null;
	    this.playList = null;
	    this.playerStatus = {};
	    addLinkTrackVars('contextData.wb.spcrtid');
	    // set 3rd party tracking listener, triggered on: progress, play, pause, mute, unmute, start, fullscreen, collapse
	    (0, _jquery2['default'])(window).on('track:3rdParty', function (event, obj) {
	      if (_this.getTrackURL() !== undefined) {
	        _this.Bptracking.thirdPartyTracking(_this.getTrackURL(), obj.ev, obj.param);
	      }
	    }).on('onSetCaption', this.onSetClosedCaptioning);
	    this.isVideoRendered();
	  },
	  isVideoRendered: function isVideoRendered() {
	    if (_utilsUtil.isMobile) {
	      if (!(0, _jquery2['default'])('video')[0]) {
	        window.requestAnimationFrame(this.isVideoRendered);
	      } else {
	        this.setMobileTrackHandlers();
	      }
	    }
	    if (!_utilsUtil.isMobile && (0, _jquery2['default'])('.playlist').length > 0) {
	      window.requestAnimationFrame(this.isVideoRendered);
	    } else {
	      this.playList = (0, _jquery2['default'])('.playlist');
	    }
	  },
	  setMobileTrackHandlers: function setMobileTrackHandlers() {
	    var _this2 = this;
	
	    this.playerEle = _storesVideo_store2['default'].mediaApi._v.getMediaElement();
	    this.playerEle.addEventListener('volumechange', function () {
	      _this2.playerStatus.currentVolume = _this2.playerEle.muted ? 0 : _this2.playerEle.volume;
	      _this2.onVolumeChanged(_this2.playerStatus);
	    });
	    // listen to native player event 'change' to track closed captioning
	    this.playerEle.textTracks.addEventListener('change', function (e) {
	      var useCC = {};
	      if (e.target[0].mode) {
	        var track = e.target[0];
	        if (track.mode !== 'hidden') {
	          track.mode == 'showing' ? useCC.on = true : useCC.on = false;
	          _this2.onSetClosedCaptioning(e, useCC);
	        }
	      }
	    });
	    var prefix = 'vidvbp-ctl_';
	    var eventMap = [{ event: 'play', prop: prefix + 'play' }, { event: 'pause', prop: prefix + 'pause' }, { event: 'seeked', prop: prefix + 'scrub' }, { event: 'volumechange', eventName: true, prop: function prop() {
	        return prefix + (_this2.playerEle.muted ? 'muted' : 'unmuted');
	      } }, { event: 'webkitfullscreenchange', eventName: true, prop: function prop() {
	        return prefix + (document.webkitFullscreenElement ? 'fullscreen' : 'collapsed');
	      } }].forEach(function (obj, i, arr) {
	      _this2.playerEle.addEventListener(obj.event, _this2.mobile3rdPartyHandler.bind(null, arr[i], prefix));
	    });
	    if ((0, _utilsUtil.isMobile)()) {
	      if ((0, _utilsUtil.isIOS)()) {
	        (0, _jquery2['default'])('video.akamai-html5').on('webkitbeginfullscreen', function (e) {
	          var articleNo = _this2.getArticleNo();
	          _this2.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_bigr');
	        });
	        (0, _jquery2['default'])('video.akamai-html5').on('webkitendfullscreen', function (e) {
	          var articleNo = _this2.getArticleNo();
	          _this2.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_smalr');
	        });
	      } else {
	        (0, _jquery2['default'])('video.akamai-html5').on('webkitfullscreenchange', function (e) {
	          if (document.webkitFullscreenElement === null) {
	            var articleNo = _this2.getArticleNo();
	            _this2.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_smalr');
	          } else {
	            var articleNo = _this2.getArticleNo();
	            _this2.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_bigr');
	          }
	        });
	      }
	    }
	  },
	  mobile3rdPartyHandler: function mobile3rdPartyHandler(mobileEvent, prefix, event) {
	    // convert event name before tracking if volume or fullscreen
	    var key = mobileEvent.eventName ? mobileEvent.prop().substr(prefix.length) : mobileEvent.event;
	    var val = typeof mobileEvent.prop === 'function' ? mobileEvent.prop() : mobileEvent.prop;
	    (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: key, param: val });
	  },
	  trackingPixelRequest: function trackingPixelRequest(trackingPixel) {
	    if (trackingPixel && trackingPixel !== '') {
	      var pixelImg = document.createElement('img');
	      pixelImg.style.opacity = 0;
	      pixelImg.src = trackingPixel;
	      document.body.appendChild(pixelImg);
	    }
	  },
	  resetDurationTracking: function resetDurationTracking() {
	    var _percentages;
	
	    this.percentages = (_percentages = {}, _defineProperty(_percentages, 25, true), _defineProperty(_percentages, 50, true), _defineProperty(_percentages, 75, true), _defineProperty(_percentages, 100, true), _percentages);
	  },
	  onVideoChange: function onVideoChange(state) {
	    var event = state.video.event;
	    var handler = (0, _import.camelCase)('on_' + event);
	    if (this[handler]) {
	      this[handler](state.video);
	    }
	  },
	  onseeked: function onseeked() {},
	  onBuffering: function onBuffering() {},
	  onVideoSelected: function onVideoSelected() {
	    if (!this.isFirstPlay && this.heartbeat) {
	      if (this.analyticsPlugin) {
	        this.analyticsPlugin.setAdMetadata(null);
	        this.analyticsPlugin.setVideoMetadata(null);
	      }
	      if (this.VideoPlayerPlugin) {
	        this.VideoPlayerPlugin.trackVideoUnload();
	        this.heartbeat.destroy();
	      }
	      this.hasStarted = false;
	      this.hasEnded = false;
	    }
	    this.isFirstPlay = false;
	  },
	  onPlay: function onPlay(state) {
	    var isStart = !this.hasStarted && !this.hasEnded;
	    var articleNo = this.getArticleNo();
	    // hasStarted is set only once on the first play. Once it's true it remains that way
	    // hasEnded is reset to `false` at the beginning of every play and set to `true` onEnded.
	    //
	    // This allows us to trigger the appropriate call on the first play (e.g. replay or play)
	    // But handle video replays as well.
	    if (isStart) {
	      if ((0, _utilsUtil.isIpad)()) {
	        if (state.meta.autoplay === true && this.isFirstPlay === true) {
	          (0, _jquery2['default'])('.chapter-link-in-menu').removeClass('now_playing_color');
	          (0, _jquery2['default'])('#chapter-' + _articleNo).addClass('now_playing_color');
	        }
	      }
	      if (this.isFirstPlay) {
	        this.Bptracking.pamTrack('ARTICLE-' + _articleNo, 'vidvbp-ctl_play');
	      }
	      (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'start', param: 'vidvbp-ctl_start' });
	      this.trackingPixelRequest(state.meta.video0);
	      this.initHeartbeat();
	      this.VideoPlayerPlugin.trackVideoLoad();
	      this.cp.appname = 'ippevent';
	      this.cp.activityName = 'participation';
	      window.postCp(this.cp);
	      this.Bptracking.trackIpp('startPresentation');
	      this.isFirstPlay = false;
	      this.VideoPlayerPlugin.trackSessionStart();
	      this.addHeartbeatContext();
	      if (isStart) {
	
	        this.VideoPlayerPlugin.trackVideoLoad();
	        this.VideoPlayerPlugin.trackSessionStart();
	        this.remHeartbeatContext();
	      }
	      if (this.analyticsPlugin) {
	        this.analyticsPlugin.setVideoMetadata({
	          chn: 'test',
	          rs: s_md.prop50 || '',
	          site: 'brandplay',
	          dprofsn: s_md.prop19 || '',
	          dspclty: s_md.prop38 || '',
	          regid: s_md.prop47 || '',
	          dcntry: s_md.prop37 || '',
	          pageName: s_md.eVar1 || this.articleId,
	          extcampaign: typeof s_md.contextData['wb.ecd'] !== 'undefined' ? s_md.contextData['wb.ecd'] : '',
	          sptr: this.tracking.brandName + ' [ ' + this.tracking.brandId + ' ]',
	          sprodid: this.tracking.productId,
	          sprod: this.tracking.productName,
	          sactid: this.tracking.cp.activityId,
	          sact: 'sf' + this.tracking.sfNumber,
	          asset: this.mmodule,
	          spcrtid: this.tracking.partnerCreativeID
	        });
	      }
	      this.hasStarted = true;
	      this.hasEnded = false;
	      this.remHeartbeatContext();
	      var _articleNo = this.getArticleNo();
	      this.Bptracking.pamTrack('ARTICLE-' + _articleNo, 'vidvbp_start');
	      this.cp.appname = 'ippcontent';
	      this.cp.activityName = 'scn' + _articleNo;
	      window.postCp(this.cp);
	      this.resetDurationTracking();
	      (0, _jquery2['default'])('.chapter-link-in-menu').removeClass("now_playing_color");
	      (0, _jquery2['default'])('#chapter-' + _articleNo).addClass("now_playing_color");
	      this.resetDurationTracking();
	    }
	    this.VideoPlayerPlugin.trackPlay();
	  },
	  onStarted: function onStarted() {},
	  onProgress: function onProgress(state) {
	    var _this3 = this;
	
	    if ((0, _import.get)(this, 'playerEle.currentTime', null) !== null) {
	      (function () {
	        var trackPrefix = 'vidvbp_';
	        var percent = Math.round(_this3.playerEle.currentTime / _this3.playerEle.duration * 100);
	        var articleNo = _this3.getArticleNo();
	        if (_this3.hasStarted && !state.isEnded) {
	          [25, 50, 75].forEach(function (i) {
	            if (percent > i && _this3.percentages[i]) {
	              _this3.percentages[i] = false;
	              _this3.Bptracking.pamTrack('ARTICLE-' + articleNo, trackPrefix + (i + 'pct'), _this3);
	              if (i == 25) _this3.trackingPixelRequest(state.meta.video25);
	              if (i == 50) _this3.trackingPixelRequest(state.meta.video50);
	              if (i == 75) _this3.trackingPixelRequest(state.meta.video75);
	              (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'progress', param: trackPrefix + i + '%' });
	            }
	          });
	        }
	        if (state.hasStarted && !percent > 0) (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'progress', param: trackPrefix + 0 + '%' });
	      })();
	    }
	  },
	  onEnded: function onEnded(state) {
	    if (this.hasEnded !== true) {
	      var articleNo = this.getArticleNo();
	      this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp_100pct', this);
	      this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'allvideo_100pct');
	      (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'progress', param: 'vidvbp_100%' });
	      this.analyticsPlugin.setAdMetadata(null);
	      this.analyticsPlugin.setVideoMetadata(null);
	      this.VideoPlayerPlugin.trackComplete();
	      this.VideoPlayerPlugin.trackVideoUnload();
	      this.hasEnded = true;
	      this.resetDurationTracking();
	      this.trackingPixelRequest(state.meta.video100);
	    }
	    window.trackingEnabled = false;
	  },
	  onSettingTime: function onSettingTime() {
	    var articleNo = this.getArticleNo();
	    this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_scrb'); // desktop scrub
	    // removing 3rdParty tracking from this event, as it fires on play / start, already handled in setMobileTrackHandlers()
	  },
	  onVolumeChanged: function onVolumeChanged(state) {
	    if ((0, _utilsUtil.isIpad)() && this.prevVolume === undefined) {
	      this.prevVolume = state.currentVolume;
	      return;
	    }
	    var currentVolume = state.currentVolume;
	
	    var articleNo = this.getArticleNo();
	    if (this.prevVolume !== currentVolume) {
	      if (currentVolume === 0) {
	        this.isMuted = true;
	        this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_mute');
	        (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'mute', article: articleNo, param: 'vidvbp-ctl_mute' });
	      } else if (this.isMuted) {
	        this.isMuted = false;
	        this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_mutex');
	        (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'unmute', article: articleNo, param: 'vidvbp-ctl_mutex' });
	      } else {
	        if ((0, _utilsUtil.isIpad)()) {
	          this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_mutex');
	        }
	        this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_vol');
	      }
	    }
	    this.prevVolume = currentVolume;
	  },
	  onFullScreen: function onFullScreen() {
	    if (!this.isFullScreen) {
	      this.isFullScreen = true;
	      var articleNo = this.getArticleNo();
	      this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_bigr');
	      (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'expand', article: articleNo, param: 'vidvbp-ctl_bigr' });
	    }
	  },
	  onExitFullScreen: function onExitFullScreen() {
	    if (this.isFullScreen) {
	      this.isFullScreen = false;
	      var articleNo = this.getArticleNo();
	      this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_smalr');
	      (0, _jquery2['default'])(window).trigger('track:3rdParty', { ev: 'collapse', article: articleNo, param: 'vidvbp-ctl_smalr' });
	    }
	  },
	  onSetClosedCaptioning: function onSetClosedCaptioning(e, isSet) {
	    var captionText = isSet.on ? 'ccy' : 'ccn',
	        articleNo = this.getArticleNo();
	    this.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_' + captionText);
	  },
	  initHeartbeat: function initHeartbeat() {
	    var _this4 = this;
	
	    if (typeof _heartbeat2['default'].ADB === 'undefined' || typeof s_md === 'undefined') {
	      // eslint-disable-line
	      return;
	    }
	    // Map values to make code readable;
	    var _HBT$ADB$va = _heartbeat2['default'].ADB.va;
	    var plugins = _HBT$ADB$va.plugins;
	    var HeartbeatDelegate = _HBT$ADB$va.HeartbeatDelegate;
	    var HeartbeatConfig = _HBT$ADB$va.HeartbeatConfig;
	    var Heartbeat = _HBT$ADB$va.Heartbeat;
	    var _plugins$aa = plugins.aa;
	    var AdobeAnalyticsPluginConfig = _plugins$aa.AdobeAnalyticsPluginConfig;
	    var AdobeAnalyticsPluginDelegate = _plugins$aa.AdobeAnalyticsPluginDelegate;
	    var AdobeAnalyticsPlugin = _plugins$aa.AdobeAnalyticsPlugin;
	    var _plugins$ah = plugins.ah;
	    var AdobeHeartbeatPluginConfig = _plugins$ah.AdobeHeartbeatPluginConfig;
	    var AdobeHeartbeatPluginDelegate = _plugins$ah.AdobeHeartbeatPluginDelegate;
	    var AdobeHeartbeatPlugin = _plugins$ah.AdobeHeartbeatPlugin;
	    var _plugins$videoplayer = plugins.videoplayer;
	    var VideoPlayerPluginConfig = _plugins$videoplayer.VideoPlayerPluginConfig;
	    var VideoPlayerPluginDelegate = _plugins$videoplayer.VideoPlayerPluginDelegate;
	    var VideoPlayerPlugin = _plugins$videoplayer.VideoPlayerPlugin;
	    var VideoInfo = _plugins$videoplayer.VideoInfo;
	    var ChapterInfo = _plugins$videoplayer.ChapterInfo;
	
	    var analyticsPluginConfig = new AdobeAnalyticsPluginConfig(),
	        analyticsPluginDelegate = new AdobeAnalyticsPluginDelegate(),
	        analyticsPlugin = new AdobeAnalyticsPlugin(s_md, analyticsPluginDelegate),
	        // eslint-disable-line
	
	    heartbeatPluginConfig = new AdobeHeartbeatPluginConfig(document.location.protocol + '//webmd.hb.omtrdc.net', '16AD4362526701720A490D45@AdobeOrg'),
	        heartbeatPluginDelegate = new AdobeHeartbeatPluginDelegate(),
	        heartbeatPlugin = new AdobeHeartbeatPlugin(heartbeatPluginDelegate),
	        heartbeatConfig = new HeartbeatConfig(),
	        heartbeatDelegate = new HeartbeatDelegate(),
	        videoPlayerPluginConfig = new VideoPlayerPluginConfig(),
	        videoPlayerPluginDelegate = new VideoPlayerPluginDelegate(); // VideoStore.mediaApi._v.getMediaElement()
	    this.VideoPlayerPlugin = new VideoPlayerPlugin(videoPlayerPluginDelegate);
	
	    this.analyticsPlugin = analyticsPlugin;
	    this.videoPlayerPluginDelegate = videoPlayerPluginDelegate;
	
	    analyticsPluginConfig.channel = this.$metrics.prop47;
	    heartbeatPluginConfig.sdk = 'Heartbeats V-1.5.4';
	    heartbeatPluginConfig.ssl = document.location.protocol === 'https:';
	
	    this.addHeartbeatContext();
	    analyticsPluginConfig.debugLogging = false;
	    heartbeatPluginConfig.debugLogging = false;
	    heartbeatConfig.debugLogging = false;
	    videoPlayerPluginConfig.debugLogging = false;
	    heartbeatPluginConfig.quietMode = false;
	    var preHashValue = this.ipp.sfNum + '_ARTICLE-' + this.getArticleNo();
	    var hashValue = (0, _md52['default'])(preHashValue);
	    videoPlayerPluginDelegate.getVideoInfo = function () {
	      var info = new VideoInfo();
	      info.id = 'video_' + _this4.ipp.sfNum + '_' + _this4.getArticleNo();
	      info.name = 'video' + _this4.getArticleNo();
	      info.playerName = 'coreLibVideo-' + hashValue;
	      info.length = _storesVideo_store2['default'].getDuration();
	      info.streamType = 'vod';
	      info.playhead = _storesVideo_store2['default'].getCurrentTime() || 0;
	      info.friendlyName = 'video_' + _this4.getArticleNo();
	      return info;
	    };
	
	    videoPlayerPluginDelegate.getChapterInfo = function () {
	      var info = new ChapterInfo();
	      info.name = 'video ' + _this4.getArticleNo();
	      info.length = _storesVideo_store2['default'].getDuration();
	      info.position = _storesVideo_store2['default'].getCurrentTime();
	      info.startTime = 0;
	      return info;
	    };
	
	    // configure  plugins
	    heartbeatPlugin.configure(heartbeatPluginConfig);
	    analyticsPlugin.configure(analyticsPluginConfig);
	    this.VideoPlayerPlugin.configure(videoPlayerPluginConfig);
	    this.heartbeat = new Heartbeat(heartbeatDelegate, [this.VideoPlayerPlugin, analyticsPlugin, heartbeatPlugin]);
	    this.heartbeat.configure(heartbeatConfig);
	
	    (0, _jquery2['default'])(window).on('beforeunload', function () {
	      _this4.VideoPlayerPlugin.trackVideoUnload();
	      _this4.VideoPlayerPlugin.destroy();
	    });
	
	    // Not heartbeat, this is used to track pause and play of the video through omniture.
	    (0, _jquery2['default'])(_storesVideo_store2['default'].mediaApi._v.getMediaElement()).unbind('pause').bind('pause', function () {
	      var articleNo = _this4.getArticleNo();
	      var trackURL = '',
	          theIndex = _storesVideo_store2['default'].getIndex();
	      trackURL = _storesDescriptor_store2['default'].getVideos()[theIndex].trackingURL;
	
	      _this4.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_pause');
	    });
	    (0, _jquery2['default'])(_storesVideo_store2['default'].mediaApi._v.getMediaElement()).unbind('play').bind('play', function () {
	      var articleNo = _this4.getArticleNo();
	      _this4.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_play');
	      (0, _jquery2['default'])('.chapter-link-in-menu').removeClass("now_playing_color");
	      (0, _jquery2['default'])('#chapter-' + articleNo).addClass("now_playing_color");
	    });
	    if (_utilsUtil.isMobile) {
	      (0, _jquery2['default'])(_storesVideo_store2['default'].mediaApi._v.getMediaElement()).unbind('seeked').bind('seeked', function () {
	        var articleNo = _this4.getArticleNo();
	        _this4.Bptracking.pamTrack('ARTICLE-' + articleNo, 'vidvbp-ctl_scrb');
	      });
	    }
	  },
	  getArticleNo: function getArticleNo() {
	    /*
	     * conditional used to return 1 for programs with only 1 video
	     * */
	    return bpInstance.videos.length !== 1 ? _storesVideo_store2['default'].getIndex() + 1 : 1;
	  },
	  getTrackURL: function getTrackURL() {
	    return _storesDescriptor_store2['default'].getVideos()[_storesVideo_store2['default'].getIndex()].trackingURL;
	  },
	  addHeartbeatContext: function addHeartbeatContext() {
	    if (typeof addLinkTrackVars === 'undefined') {
	      return;
	    } else {
	      addLinkTrackVars(this.contextDataVars.toString());
	      //addLinkTrackVars('contextData.wb.spcrtid');
	      window.wmdSetContext('wb.sprod', this.tracking.productName);
	      window.wmdSetContext('wb.sactid', this.tracking.cp.activityId);
	      window.wmdSetContext('wb.sact', 'sf' + this.tracking.sfNumber);
	      window.wmdSetContext('wb.spcrtid', this.tracking.partnerCreativeID);
	    }
	  },
	  remHeartbeatContext: function remHeartbeatContext() {
	    if (typeof addLinkTrackVars === 'undefined') {
	      return;
	    } else {
	      remLinkTrackVars(this.contextDataVars.toString());
	    }
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  initMedscapeGlobals: function initMedscapeGlobals() {
	    var empty = function empty() {};
	    this.initGlobal('$userId', window.s_registered_user_id, undefined);
	    this.initGlobal('$metrics', window.s_md, {});
	    this.initGlobal('$wmdPageView', window.wmdPageview, empty);
	    this.initGlobal('$wmdTrack', window.wmdTrack, empty);
	    this.initGlobal('$wmdPageLink', window.wmdPageLink, empty);
	    this.initFromMeta('ipp');
	    this.initFromMeta('cp');
	  },
	  initGlobal: function initGlobal(name, globe, fallback) {
	    if (typeof globe !== 'undefined') {
	      this[name] = globe;
	    } else {
	      this[name] = fallback;
	    }
	  },
	  initFromMeta: function initFromMeta(name) {
	    var metaElement = document.querySelector('[data-' + name + ']');
	    delete this[name];
	    if (metaElement !== null) {
	      this[name] = JSON.parse(metaElement.getAttribute('data-' + name));
	    }
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _md5 = __webpack_require__(305);
	
	var _md52 = _interopRequireDefault(_md5);
	
	var BPTracking = function BPTracking() {
		var omniPagenameDefault = window.location.href.split("://")[1].split("?")[0].split("#")[0].replace('www.', ''),
		    pamProductName = 'brandplay',
		    omnitureEnable = true;
	
		var sfNumObj = {};
	
		if ($('meta[data-ipp]').length > 0) {
			sfNumObj = $('meta[data-ipp]').data();
		}
	
		this.omni = function (sLink, pName, obj) {
			// Omniture Ad Hoc tracking, for Internal or External-Domain destinations
			try {
				var self = this;
				if (typeof pName == 'object') {
					obj = pName;
					pName = undefined;
				}
				if (omnitureEnable) {
					if (typeof obj != 'undefined' && typeof obj == 'object') {
	
						if (typeof obj.href != 'undefined') {
							// if referring element link points to external domain, fire external Omniture function
							if (obj.href.match(/:\/\//) != null && obj.href.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain || $.trim(obj.href) == window.location.href.split('#')[0] + "#") {
								self.omniPageLink(sLink, pName);
							} else {
								// else fire internal Omniture function
								self.omniTrack(sLink, pName);
							}
						} else if (typeof obj.action != 'undefined') {
							// if referring element form action points to external domain, fire external Omniture function
							if (obj.action.match(/:\/\//) != null && obj.action.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain || $.trim(obj.action) == window.location.href.split('#')[0] + "#") {
								self.omniPageLink(sLink, pName);
							} else {
								// else fire internal Omniture function
								self.omniTrack(sLink, pName);
							}
						} else {
							self.omniPageLink(sLink, pName);
						}
					} else {
						self.omniPageLink(sLink, pName);
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.omniTrack = function (sLink, pName) {
			// Omniture Ad Hoc tracking, for In-Domain destinations
			try {
				if (omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdTrack != 'undefined') {
						if (typeof pName != 'undefined') {
							s_md.pageName = pName;
						}
						wmdTrack(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.omniPageLink = function (sLink, pName) {
			// Omniture Ad Hoc tracking, for External-Domain destinations
			try {
				if (omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdPageLink != 'undefined') {
						if (typeof pName != 'undefined') {
							s_md.pageName = pName;
						}
						wmdPageLink(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.omniPageview = function (pCount, pName) {
			// Omniture Page View function
			try {
				if (omnitureEnable) {
					if (typeof pName == 'object') {
						pName = undefined;
					}
					if (typeof wmdPageview != 'undefined') {
						if (typeof pName != 'undefined') {
							wmdPageview(pName, pCount);
						} else {
							wmdPageview("", pCount);
						}
						if (typeof pName != 'undefined') {
							s_md.pageName = omniPagenameDefault;
						}
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.pamTrack = function (assetName, moduleStrOrPvNum, element) {
			//Function to Send Track, or Bind to Elements
			try {
				//addLinkTrackVars('contextData.wb.spcrtid');
				var self = this;
				if (typeof element == 'object') {
					if (typeof moduleStrOrPvNum == 'number') {
						this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + (0, _md52["default"])(sfNumObj.ipp.sfNum + '_' + assetName) + '/', element);
					} else {
						this.omni(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + (0, _md52["default"])(sfNumObj.ipp.sfNum + '_' + assetName) + '/', element);
					}
				} else {
					if (typeof moduleStrOrPvNum == 'number') {
						this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + (0, _md52["default"])(sfNumObj.ipp.sfNum + '_' + assetName) + '/');
					} else {
						this.omni(moduleStrOrPvNum, document.domain.replace('wp.', '').replace(/www\.(.+\.com)/, '$1') + '/' + pamProductName + '/' + sfNumObj.ipp.sfNum + '/' + (0, _md52["default"])(sfNumObj.ipp.sfNum + '_' + assetName) + '/');
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.trackIpp = function (action) {
			try {
				var self = this;
				if (typeof sfNumObj.ipp.wpUrl != 'undefined' && typeof sfNumObj.ipp.parIdE != 'undefined' && typeof sfNumObj.ipp.activityId != 'undefined') {
					var preload_image = new Image(1, 1);
					if (typeof sfNumObj.ipp.tacticId != 'undefined') {
						preload_image.src = '//' + sfNumObj.ipp.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + sfNumObj.ipp.activityId + '&parId=' + sfNumObj.ipp.parIdE + '&tacticId=' + sfNumObj.ipp.tacticId;
					} else {
						preload_image.src = '//' + sfNumObj.ipp.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + sfNumObj.ipp.activityId + '&parId=' + sfNumObj.ipp.parIdE;
					}
				}
			} catch (err) {
				console.log(err);
			}
		};
	
		this.thirdPartyTracking = function (url, assetName, moduleStrOrPvNum) {
			// creates an <img> with the src attribute of a 3rd party and appends it to the bottom of the body
			url = url + '?' + assetName + '=' + moduleStrOrPvNum;
			var img = document.createElement('img');
			img.src = url;
			$(img).css({
				position: 'absolute',
				display: 'none',
				bottom: 0
			});
			$('body').append(img);
		};
	};
	
	exports["default"] = BPTracking;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _import = __webpack_require__(200);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _reflux = __webpack_require__(205);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _storesDescriptor_store = __webpack_require__(238);
	
	var _storesDescriptor_store2 = _interopRequireDefault(_storesDescriptor_store);
	
	exports['default'] = _reflux2['default'].createStore({
	  canShowBoth: false,
	  init: function init() {
	    this.listenTo(_storesDescriptor_store2['default'], 'onLoad');
	  },
	  onLoad: function onLoad(state) {
	    var videos = _import2['default'].get(state, 'descriptor.videos', []);
	    this.canShowBoth = videos.length > 1;
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/*
	 * classList.js: Cross-browser full element.classList implementation.
	 * 1.1.20150312
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: Dedicated to the public domain.
	 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
	 */
	
	/*global self, document, DOMException */
	
	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
	if ("document" in self) {
	
	  // Full polyfill for browsers with no classList support
	  // Including IE < Edge missing SVGElement.classList
	  if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
	
	    (function(view) {
	
	      "use strict";
	
	      if (!('Element' in view)) return;
	
	      var
	        classListProp = "classList",
	        protoProp = "prototype",
	        elemCtrProto = view.Element[protoProp],
	        objCtr = Object,
	        strTrim = String[protoProp].trim || function() {
	          return this.replace(/^\s+|\s+$/g, "");
	        },
	        arrIndexOf = Array[protoProp].indexOf || function(item) {
	          var
	            i = 0,
	            len = this.length;
	          for (; i < len; i++) {
	            if (i in this && this[i] === item) {
	              return i;
	            }
	          }
	          return -1;
	        }
	        // Vendors: please allow content code to instantiate DOMExceptions
	        ,
	        DOMEx = function(type, message) {
	          this.name = type;
	          this.code = DOMException[type];
	          this.message = message;
	        },
	        checkTokenAndGetIndex = function(classList, token) {
	          if (token === "") {
	            throw new DOMEx(
	              "SYNTAX_ERR", "An invalid or illegal string was specified"
	            );
	          }
	          if (/\s/.test(token)) {
	            throw new DOMEx(
	              "INVALID_CHARACTER_ERR", "String contains an invalid character"
	            );
	          }
	          return arrIndexOf.call(classList, token);
	        },
	        ClassList = function(elem) {
	          var
	            trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
	            classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
	            i = 0,
	            len = classes.length;
	          for (; i < len; i++) {
	            this.push(classes[i]);
	          }
	          this._updateClassName = function() {
	            elem.setAttribute("class", this.toString());
	          };
	        },
	        classListProto = ClassList[protoProp] = [],
	        classListGetter = function() {
	          return new ClassList(this);
	        };
	      // Most DOMException implementations don't allow calling DOMException's toString()
	      // on non-DOMExceptions. Error's toString() is sufficient here.
	      DOMEx[protoProp] = Error[protoProp];
	      classListProto.item = function(i) {
	        return this[i] || null;
	      };
	      classListProto.contains = function(token) {
	        token += "";
	        return checkTokenAndGetIndex(this, token) !== -1;
	      };
	      classListProto.add = function() {
	        var
	          tokens = arguments,
	          i = 0,
	          l = tokens.length,
	          token, updated = false;
	        do {
	          token = tokens[i] + "";
	          if (checkTokenAndGetIndex(this, token) === -1) {
	            this.push(token);
	            updated = true;
	          }
	        }
	        while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	      classListProto.remove = function() {
	        var
	          tokens = arguments,
	          i = 0,
	          l = tokens.length,
	          token, updated = false,
	          index;
	        do {
	          token = tokens[i] + "";
	          index = checkTokenAndGetIndex(this, token);
	          while (index !== -1) {
	            this.splice(index, 1);
	            updated = true;
	            index = checkTokenAndGetIndex(this, token);
	          }
	        }
	        while (++i < l);
	
	        if (updated) {
	          this._updateClassName();
	        }
	      };
	      classListProto.toggle = function(token, force) {
	        token += "";
	
	        var
	          result = this.contains(token),
	          method = result ?
	          force !== true && "remove" :
	          force !== false && "add";
	
	        if (method) {
	          this[method](token);
	        }
	
	        if (force === true || force === false) {
	          return force;
	        } else {
	          return !result;
	        }
	      };
	      classListProto.toString = function() {
	        return this.join(" ");
	      };
	
	      if (objCtr.defineProperty) {
	        var classListPropDesc = {
	          get: classListGetter,
	          enumerable: true,
	          configurable: true
	        };
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) { // IE 8 doesn't support enumerable:true
	          if (ex.number === -0x7FF5EC54) {
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	
	    }(self));
	
	  } else {
	    // There is full or partial native classList support, so just check if we need
	    // to normalize the add/remove and toggle APIs.
	
	    (function() {
	      "use strict";
	
	      var testElement = document.createElement("_");
	
	      testElement.classList.add("c1", "c2");
	
	      // Polyfill for IE 10/11 and Firefox <26, where classList.add and
	      // classList.remove exist but support only one argument at a time.
	      if (!testElement.classList.contains("c2")) {
	        var createMethod = function(method) {
	          var original = DOMTokenList.prototype[method];
	
	          DOMTokenList.prototype[method] = function(token) {
	            var i, len = arguments.length;
	
	            for (i = 0; i < len; i++) {
	              token = arguments[i];
	              original.call(this, token);
	            }
	          };
	        };
	        createMethod('add');
	        createMethod('remove');
	      }
	
	      testElement.classList.toggle("c3", false);
	
	      // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	      // support the second argument.
	      if (testElement.classList.contains("c3")) {
	        var _toggle = DOMTokenList.prototype.toggle;
	
	        DOMTokenList.prototype.toggle = function(token, force) {
	          if (1 in arguments && !this.contains(token) === !force) {
	            return force;
	          } else {
	            return _toggle.call(this, token);
	          }
	        };
	
	      }
	
	      testElement = null;
	    }());
	
	  }
	
	}


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	
	/*
	* DESCRIPTION: add device and client classname to body element.
	* REFERENCED FROM: https://gist.githubusercontent.com/devfred/2884711/raw/4bd1e4d3e72b16b570ae0244e5c9ed556fd71815/browser-detect.js
	* */
	
	'use strict';
	
	(function (undefined) {
	    var body = document.getElementsByTagName('body')[0];
	
	    /* Apple Device Webkit Browsers */
	    var isIdevice = /(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent);
	    if (isIdevice) {
	        body.className += ' iphone ipod ipad';
	    }
	    var isIphone = /(iPhone).*AppleWebKit/i.test(navigator.userAgent);
	    if (isIphone) {
	        body.className += ' iphone';
	    }
	    var isIpad = /(iPad).*AppleWebKit/i.test(navigator.userAgent);
	    if (isIpad) {
	        body.className += ' ipad';
	    }
	
	    /* Android Device Browsers */
	
	    /* Microsoft Browsers */
	
	    /* Mozilla Browsers */
	
	    var BrowserDetect = {
	        init: function init() {
	            this.browser = this.searchString(this.dataBrowser) || 'An unknown browser';
	            this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'an unknown version';
	            this.OS = this.searchString(this.dataOS) || 'an unknown OS';
	        },
	        searchString: function searchString(data) {
	            for (var i = 0; i < data.length; i++) {
	                var dataString = data[i].string;
	                var dataProp = data[i].prop;
	                this.versionSearchString = data[i].versionSearch || data[i].identity;
	                if (dataString) {
	                    if (dataString.indexOf(data[i].subString) !== -1) return data[i].identity;
	                } else if (dataProp) return data[i].identity;
	            }
	        },
	        searchVersion: function searchVersion(dataString) {
	            var index = dataString.indexOf(this.versionSearchString);
	            if (index === -1) return;
	            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
	        },
	        dataBrowser: [{
	            string: navigator.userAgent,
	            subString: 'Android',
	            identity: 'Android'
	        }, {
	            string: navigator.userAgent,
	            subString: 'Chrome',
	            identity: 'Chrome'
	        }, {
	            string: navigator.vendor,
	            subString: 'Apple',
	            identity: 'Safari',
	            versionSearch: 'Version'
	        }, {
	            string: navigator.userAgent,
	            subString: 'Firefox',
	            identity: 'Firefox'
	        }, {
	            string: navigator.userAgent,
	            subString: 'MSIE',
	            identity: 'Explorer',
	            versionSearch: 'MSIE'
	        }, {
	            string: navigator.userAgent,
	            subString: 'Trident',
	            identity: 'IE11',
	            versionSearch: 'rv'
	        }],
	        dataOS: [{
	            string: navigator.platform,
	            subString: 'Win',
	            identity: 'Windows'
	        }, {
	            string: navigator.platform,
	            subString: 'Mac',
	            identity: 'Mac'
	        }, {
	            string: navigator.userAgent,
	            subString: 'iPhone',
	            identity: 'iPhone/iPod'
	        }]
	
	    };
	    BrowserDetect.init();
	    body.className += ' ' + BrowserDetect.browser.toLowerCase();
	    // add app class
	    var isApp = window.medscape.core.isApp;
	    if (isApp) body.className += ' ' + 'app';
	})();

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  true ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// bp2.bundle.js